(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 7315:
/***/ (function(module) {

"use strict";



if (true) {
  module.exports = {
    DevTool: () => null,
  };
} else {}


/***/ }),

/***/ 32829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kZ": function() { return /* binding */ popperGenerator; }
});

// UNUSED EXPORTS: createPopper, detectOverflow

// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js
var getBoundingClientRect = __webpack_require__(1603);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js
var getWindowScroll = __webpack_require__(11349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getWindow.js
var getWindow = __webpack_require__(58402);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
var instanceOf = __webpack_require__(8792);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === (0,getWindow/* default */.Z)(node) || !(0,instanceOf/* isHTMLElement */.Re)(node)) {
    return (0,getWindowScroll/* default */.Z)(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
var getNodeName = __webpack_require__(30741);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js
var getWindowScrollBarX = __webpack_require__(84668);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js
var getDocumentElement = __webpack_require__(98112);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js
var isScrollParent = __webpack_require__(79263);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/math.js
var math = __webpack_require__(98042);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = (0,math/* round */.NM)(rect.width) / element.offsetWidth || 1;
  var scaleY = (0,math/* round */.NM)(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = (0,instanceOf/* isHTMLElement */.Re)(offsetParent);
  var offsetParentIsScaled = (0,instanceOf/* isHTMLElement */.Re)(offsetParent) && isElementScaled(offsetParent);
  var documentElement = (0,getDocumentElement/* default */.Z)(offsetParent);
  var rect = (0,getBoundingClientRect/* default */.Z)(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if ((0,getNodeName/* default */.Z)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    (0,isScrollParent/* default */.Z)(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if ((0,instanceOf/* isHTMLElement */.Re)(offsetParent)) {
      offsets = (0,getBoundingClientRect/* default */.Z)(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = (0,getWindowScrollBarX/* default */.Z)(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
var getLayoutRect = __webpack_require__(47271);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js + 1 modules
var listScrollParents = __webpack_require__(66796);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js + 1 modules
var getOffsetParent = __webpack_require__(99764);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/enums.js
var enums = __webpack_require__(71013);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return enums/* modifierPhases.reduce */.xs.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/createPopper.js














var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: (0,instanceOf/* isElement */.kK)(reference) ? (0,listScrollParents/* default */.Z)(reference) : reference.contextElement ? (0,listScrollParents/* default */.Z)(reference.contextElement) : [],
          popper: (0,listScrollParents/* default */.Z)(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (false) { var _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft, flipModifier, modifiers; }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (false) {}

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, (0,getOffsetParent/* default */.Z)(popper), state.options.strategy === 'fixed'),
          popper: (0,getLayoutRect/* default */.Z)(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (false) {}

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (false) {}

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/(/* unused pure expression or super */ null && (popperGenerator())); // eslint-disable-next-line import/no-unused-modules



/***/ }),

/***/ 40613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ contains; }
/* harmony export */ });
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8792);

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__/* .isShadowRoot */ .Zq)(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

/***/ }),

/***/ 1603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getBoundingClientRect; }
/* harmony export */ });
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8792);
/* harmony import */ var _utils_math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98042);


function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if ((0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__/* .isHTMLElement */ .Re)(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
    // Fallback to 1 in case both values are `0`

    if (offsetWidth > 0) {
      scaleX = (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_1__/* .round */ .NM)(rect.width) / offsetWidth || 1;
    }

    if (offsetHeight > 0) {
      scaleY = (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_1__/* .round */ .NM)(rect.height) / offsetHeight || 1;
    }
  }

  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}

/***/ }),

/***/ 91049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getComputedStyle; }
/* harmony export */ });
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58402);

function getComputedStyle(element) {
  return (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(element).getComputedStyle(element);
}

/***/ }),

/***/ 98112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getDocumentElement; }
/* harmony export */ });
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8792);

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return (((0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__/* .isElement */ .kK)(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

/***/ }),

/***/ 47271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getLayoutRect; }
/* harmony export */ });
/* harmony import */ var _getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1603);
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = (0,_getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

/***/ }),

/***/ 30741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getNodeName; }
/* harmony export */ });
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

/***/ }),

/***/ 99764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getOffsetParent; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getWindow.js
var getWindow = __webpack_require__(58402);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
var getNodeName = __webpack_require__(30741);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js
var getComputedStyle = __webpack_require__(91049);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
var instanceOf = __webpack_require__(8792);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf((0,getNodeName/* default */.Z)(element)) >= 0;
}
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getParentNode.js
var getParentNode = __webpack_require__(8104);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js







function getTrueOffsetParent(element) {
  if (!(0,instanceOf/* isHTMLElement */.Re)(element) || // https://github.com/popperjs/popper-core/issues/837
  (0,getComputedStyle/* default */.Z)(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  var isIE = navigator.userAgent.indexOf('Trident') !== -1;

  if (isIE && (0,instanceOf/* isHTMLElement */.Re)(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = (0,getComputedStyle/* default */.Z)(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = (0,getParentNode/* default */.Z)(element);

  if ((0,instanceOf/* isShadowRoot */.Zq)(currentNode)) {
    currentNode = currentNode.host;
  }

  while ((0,instanceOf/* isHTMLElement */.Re)(currentNode) && ['html', 'body'].indexOf((0,getNodeName/* default */.Z)(currentNode)) < 0) {
    var css = (0,getComputedStyle/* default */.Z)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = (0,getWindow/* default */.Z)(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && (0,getComputedStyle/* default */.Z)(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && ((0,getNodeName/* default */.Z)(offsetParent) === 'html' || (0,getNodeName/* default */.Z)(offsetParent) === 'body' && (0,getComputedStyle/* default */.Z)(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

/***/ }),

/***/ 8104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getParentNode; }
/* harmony export */ });
/* harmony import */ var _getNodeName_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30741);
/* harmony import */ var _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98112);
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8792);



function getParentNode(element) {
  if ((0,_getNodeName_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_1__/* .isShadowRoot */ .Zq)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0,_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(element) // fallback

  );
}

/***/ }),

/***/ 58402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getWindow; }
/* harmony export */ });
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

/***/ }),

/***/ 11349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getWindowScroll; }
/* harmony export */ });
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58402);

function getWindowScroll(node) {
  var win = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

/***/ }),

/***/ 84668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getWindowScrollBarX; }
/* harmony export */ });
/* harmony import */ var _getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1603);
/* harmony import */ var _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98112);
/* harmony import */ var _getWindowScroll_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11349);



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return (0,_getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(element)).left + (0,_getWindowScroll_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(element).scrollLeft;
}

/***/ }),

/***/ 8792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "Re": function() { return /* binding */ isHTMLElement; },
/* harmony export */   "Zq": function() { return /* binding */ isShadowRoot; }
/* harmony export */ });
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58402);


function isElement(node) {
  var OwnElement = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}



/***/ }),

/***/ 79263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isScrollParent; }
/* harmony export */ });
/* harmony import */ var _getComputedStyle_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91049);

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = (0,_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

/***/ }),

/***/ 66796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ listScrollParents; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getParentNode.js
var getParentNode = __webpack_require__(8104);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js
var isScrollParent = __webpack_require__(79263);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
var getNodeName = __webpack_require__(30741);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
var instanceOf = __webpack_require__(8792);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf((0,getNodeName/* default */.Z)(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if ((0,instanceOf/* isHTMLElement */.Re)(node) && (0,isScrollParent/* default */.Z)(node)) {
    return node;
  }

  return getScrollParent((0,getParentNode/* default */.Z)(node));
}
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getWindow.js
var getWindow = __webpack_require__(58402);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = (0,getWindow/* default */.Z)(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], (0,isScrollParent/* default */.Z)(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents((0,getParentNode/* default */.Z)(target)));
}

/***/ }),

/***/ 71013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "we": function() { return /* binding */ top; },
/* harmony export */   "I": function() { return /* binding */ bottom; },
/* harmony export */   "F2": function() { return /* binding */ right; },
/* harmony export */   "t$": function() { return /* binding */ left; },
/* harmony export */   "d7": function() { return /* binding */ auto; },
/* harmony export */   "mv": function() { return /* binding */ basePlacements; },
/* harmony export */   "BL": function() { return /* binding */ start; },
/* harmony export */   "ut": function() { return /* binding */ end; },
/* harmony export */   "zV": function() { return /* binding */ clippingParents; },
/* harmony export */   "Pj": function() { return /* binding */ viewport; },
/* harmony export */   "k5": function() { return /* binding */ popper; },
/* harmony export */   "YP": function() { return /* binding */ reference; },
/* harmony export */   "bw": function() { return /* binding */ variationPlacements; },
/* harmony export */   "Ct": function() { return /* binding */ placements; },
/* harmony export */   "xs": function() { return /* binding */ modifierPhases; }
/* harmony export */ });
/* unused harmony exports beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite */
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

/***/ }),

/***/ 40002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10338);
/* harmony import */ var _dom_utils_getLayoutRect_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47271);
/* harmony import */ var _dom_utils_contains_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40613);
/* harmony import */ var _dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99764);
/* harmony import */ var _utils_getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69655);
/* harmony import */ var _utils_within_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91150);
/* harmony import */ var _utils_mergePaddingObject_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76592);
/* harmony import */ var _utils_expandToHashMap_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6782);
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71013);









 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return (0,_utils_mergePaddingObject_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(typeof padding !== 'number' ? padding : (0,_utils_expandToHashMap_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(padding, _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .basePlacements */ .mv));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = (0,_utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(state.placement);
  var axis = (0,_utils_getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(basePlacement);
  var isVertical = [_enums_js__WEBPACK_IMPORTED_MODULE_2__/* .left */ .t$, _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .right */ .F2].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = (0,_dom_utils_getLayoutRect_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(arrowElement);
  var minProp = axis === 'y' ? _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .top */ .we : _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .left */ .t$;
  var maxProp = axis === 'y' ? _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .bottom */ .I : _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .right */ .F2;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = (0,_dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = (0,_utils_within_js__WEBPACK_IMPORTED_MODULE_7__/* .within */ .u)(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (false) {}

  if (!(0,_dom_utils_contains_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(state.elements.popper, arrowElement)) {
    if (false) {}

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});

/***/ }),

/***/ 83148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapToStyles */
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71013);
/* harmony import */ var _dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99764);
/* harmony import */ var _dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58402);
/* harmony import */ var _dom_utils_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98112);
/* harmony import */ var _dom_utils_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91049);
/* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10338);
/* harmony import */ var _utils_getVariation_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88760);
/* harmony import */ var _utils_math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98042);







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_0__/* .round */ .NM)(x * dpr) / dpr || 0,
    y: (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_0__/* .round */ .NM)(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$;
  var sideY = _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .top */ .we;
  var win = window;

  if (adaptive) {
    var offsetParent = (0,_dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === (0,_dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(popper)) {
      offsetParent = (0,_dom_utils_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(popper);

      if ((0,_dom_utils_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .top */ .we || (placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$ || placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .right */ .F2) && variation === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .end */ .ut) {
      sideY = _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .bottom */ .I;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$ || (placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .top */ .we || placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .bottom */ .I) && variation === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .end */ .ut) {
      sideX = _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .right */ .F2;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (false) { var transitionProperty; }

  var commonStyles = {
    placement: (0,_utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(state.placement),
    variation: (0,_utils_getVariation_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});

/***/ }),

/***/ 78425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58402);
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = (0,_dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});

/***/ }),

/***/ 89858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ modifiers_flip; }
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/getBasePlacement.js
var getBasePlacement = __webpack_require__(10338);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/detectOverflow.js + 4 modules
var detectOverflow = __webpack_require__(1036);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/getVariation.js
var getVariation = __webpack_require__(88760);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/enums.js
var enums = __webpack_require__(71013);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums/* placements */.Ct : _options$allowedAutoP;
  var variation = (0,getVariation/* default */.Z)(placement);
  var placements = variation ? flipVariations ? enums/* variationPlacements */.bw : enums/* variationPlacements.filter */.bw.filter(function (placement) {
    return (0,getVariation/* default */.Z)(placement) === variation;
  }) : enums/* basePlacements */.mv;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;

    if (false) {}
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = (0,detectOverflow/* default */.Z)(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[(0,getBasePlacement/* default */.Z)(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if ((0,getBasePlacement/* default */.Z)(placement) === enums/* auto */.d7) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = (0,getBasePlacement/* default */.Z)(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat((0,getBasePlacement/* default */.Z)(placement) === enums/* auto */.d7 ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = (0,getBasePlacement/* default */.Z)(placement);

    var isStartVariation = (0,getVariation/* default */.Z)(placement) === enums/* start */.BL;
    var isVertical = [enums/* top */.we, enums/* bottom */.I].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = (0,detectOverflow/* default */.Z)(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? enums/* right */.F2 : enums/* left */.t$ : isStartVariation ? enums/* bottom */.I : enums/* top */.we;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});

/***/ }),

/***/ 5445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71013);
/* harmony import */ var _utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1036);



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [_enums_js__WEBPACK_IMPORTED_MODULE_0__/* .top */ .we, _enums_js__WEBPACK_IMPORTED_MODULE_0__/* .right */ .F2, _enums_js__WEBPACK_IMPORTED_MODULE_0__/* .bottom */ .I, _enums_js__WEBPACK_IMPORTED_MODULE_0__/* .left */ .t$].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = (0,_utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = (0,_utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});

/***/ }),

/***/ 87883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export distanceAndSkiddingToXY */
/* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10338);
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71013);

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = (0,_utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(placement);
  var invertDistance = [_enums_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$, _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .top */ .we].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [_enums_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$, _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .right */ .F2].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .placements.reduce */ .Ct.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});

/***/ }),

/***/ 93809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_computeOffsets_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97297);


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = (0,_utils_computeOffsets_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});

/***/ }),

/***/ 7382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ modifiers_preventOverflow; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/enums.js
var enums = __webpack_require__(71013);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/getBasePlacement.js
var getBasePlacement = __webpack_require__(10338);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
var getMainAxisFromPlacement = __webpack_require__(69655);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/within.js
var within = __webpack_require__(91150);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
var getLayoutRect = __webpack_require__(47271);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js + 1 modules
var getOffsetParent = __webpack_require__(99764);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/detectOverflow.js + 4 modules
var detectOverflow = __webpack_require__(1036);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/getVariation.js
var getVariation = __webpack_require__(88760);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
var getFreshSideObject = __webpack_require__(97666);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/math.js
var math = __webpack_require__(98042);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = (0,detectOverflow/* default */.Z)(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = (0,getBasePlacement/* default */.Z)(state.placement);
  var variation = (0,getVariation/* default */.Z)(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = (0,getMainAxisFromPlacement/* default */.Z)(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums/* top */.we : enums/* left */.t$;
    var altSide = mainAxis === 'y' ? enums/* bottom */.I : enums/* right */.F2;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === enums/* start */.BL ? referenceRect[len] : popperRect[len];
    var maxLen = variation === enums/* start */.BL ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? (0,getLayoutRect/* default */.Z)(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0,getFreshSideObject/* default */.Z)();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = (0,within/* within */.u)(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && (0,getOffsetParent/* default */.Z)(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = (0,within/* within */.u)(tether ? (0,math/* min */.VV)(min, tetherMin) : min, offset, tether ? (0,math/* max */.Fp)(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums/* top */.we : enums/* left */.t$;

    var _altSide = mainAxis === 'x' ? enums/* bottom */.I : enums/* right */.F2;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums/* top */.we, enums/* left */.t$].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? (0,within/* withinMaxClamp */.q)(_tetherMin, _offset, _tetherMax) : (0,within/* within */.u)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});

/***/ }),

/***/ 97297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ computeOffsets; }
/* harmony export */ });
/* harmony import */ var _getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10338);
/* harmony import */ var _getVariation_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88760);
/* harmony import */ var _getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69655);
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71013);




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? (0,_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(placement) : null;
  var variation = placement ? (0,_getVariation_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .top */ .we:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .bottom */ .I:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .right */ .F2:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .left */ .t$:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? (0,_getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .start */ .BL:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .end */ .ut:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}

/***/ }),

/***/ 1036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ detectOverflow; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/enums.js
var enums = __webpack_require__(71013);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getWindow.js
var getWindow = __webpack_require__(58402);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js
var getDocumentElement = __webpack_require__(98112);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js
var getWindowScrollBarX = __webpack_require__(84668);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js



function getViewportRect(element) {
  var win = (0,getWindow/* default */.Z)(element);
  var html = (0,getDocumentElement/* default */.Z)(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + (0,getWindowScrollBarX/* default */.Z)(element),
    y: y
  };
}
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js
var getComputedStyle = __webpack_require__(91049);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js
var getWindowScroll = __webpack_require__(11349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/math.js
var math = __webpack_require__(98042);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = (0,getDocumentElement/* default */.Z)(element);
  var winScroll = (0,getWindowScroll/* default */.Z)(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = (0,math/* max */.Fp)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = (0,math/* max */.Fp)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + (0,getWindowScrollBarX/* default */.Z)(element);
  var y = -winScroll.scrollTop;

  if ((0,getComputedStyle/* default */.Z)(body || html).direction === 'rtl') {
    x += (0,math/* max */.Fp)(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js + 1 modules
var listScrollParents = __webpack_require__(66796);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js + 1 modules
var getOffsetParent = __webpack_require__(99764);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
var instanceOf = __webpack_require__(8792);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js
var getBoundingClientRect = __webpack_require__(1603);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getParentNode.js
var getParentNode = __webpack_require__(8104);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/contains.js
var contains = __webpack_require__(40613);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
var getNodeName = __webpack_require__(30741);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element) {
  var rect = (0,getBoundingClientRect/* default */.Z)(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === enums/* viewport */.Pj ? rectToClientRect(getViewportRect(element)) : (0,instanceOf/* isElement */.kK)(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect((0,getDocumentElement/* default */.Z)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = (0,listScrollParents/* default */.Z)((0,getParentNode/* default */.Z)(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf((0,getComputedStyle/* default */.Z)(element).position) >= 0;
  var clipperElement = canEscapeClipping && (0,instanceOf/* isHTMLElement */.Re)(element) ? (0,getOffsetParent/* default */.Z)(element) : element;

  if (!(0,instanceOf/* isElement */.kK)(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return (0,instanceOf/* isElement */.kK)(clippingParent) && (0,contains/* default */.Z)(clippingParent, clipperElement) && (0,getNodeName/* default */.Z)(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = (0,math/* max */.Fp)(rect.top, accRect.top);
    accRect.right = (0,math/* min */.VV)(rect.right, accRect.right);
    accRect.bottom = (0,math/* min */.VV)(rect.bottom, accRect.bottom);
    accRect.left = (0,math/* max */.Fp)(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/computeOffsets.js
var computeOffsets = __webpack_require__(97297);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/mergePaddingObject.js
var mergePaddingObject = __webpack_require__(76592);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/expandToHashMap.js
var expandToHashMap = __webpack_require__(6782);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? enums/* clippingParents */.zV : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? enums/* viewport */.Pj : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? enums/* popper */.k5 : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = (0,mergePaddingObject/* default */.Z)(typeof padding !== 'number' ? padding : (0,expandToHashMap/* default */.Z)(padding, enums/* basePlacements */.mv));
  var altContext = elementContext === enums/* popper */.k5 ? enums/* reference */.YP : enums/* popper */.k5;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect((0,instanceOf/* isElement */.kK)(element) ? element : element.contextElement || (0,getDocumentElement/* default */.Z)(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = (0,getBoundingClientRect/* default */.Z)(state.elements.reference);
  var popperOffsets = (0,computeOffsets/* default */.Z)({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === enums/* popper */.k5 ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === enums/* popper */.k5 && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [enums/* right */.F2, enums/* bottom */.I].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums/* top */.we, enums/* bottom */.I].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

/***/ }),

/***/ 6782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ expandToHashMap; }
/* harmony export */ });
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

/***/ }),

/***/ 10338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getBasePlacement; }
/* harmony export */ });

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

/***/ }),

/***/ 97666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getFreshSideObject; }
/* harmony export */ });
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

/***/ }),

/***/ 69655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getMainAxisFromPlacement; }
/* harmony export */ });
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

/***/ }),

/***/ 88760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getVariation; }
/* harmony export */ });
function getVariation(placement) {
  return placement.split('-')[1];
}

/***/ }),

/***/ 98042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fp": function() { return /* binding */ max; },
/* harmony export */   "VV": function() { return /* binding */ min; },
/* harmony export */   "NM": function() { return /* binding */ round; }
/* harmony export */ });
var max = Math.max;
var min = Math.min;
var round = Math.round;

/***/ }),

/***/ 76592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ mergePaddingObject; }
/* harmony export */ });
/* harmony import */ var _getFreshSideObject_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97666);

function mergePaddingObject(paddingObject) {
  return Object.assign({}, (0,_getFreshSideObject_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(), paddingObject);
}

/***/ }),

/***/ 91150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ within; },
/* harmony export */   "q": function() { return /* binding */ withinMaxClamp; }
/* harmony export */ });
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98042);

function within(min, value, max) {
  return (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .max */ .Fp)(min, (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .min */ .VV)(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

/***/ }),

/***/ 14786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCallbackRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);

/**
 * A convenience hook around `useState` designed to be paired with
 * the component [callback ref](https://reactjs.org/docs/refs-and-the-dom.html#callback-refs) api.
 * Callback refs are useful over `useRef()` when you need to respond to the ref being set
 * instead of lazily accessing it in an effect.
 *
 * ```ts
 * const [element, attachRef] = useCallbackRef<HTMLDivElement>()
 *
 * useEffect(() => {
 *   if (!element) return
 *
 *   const calendar = new FullCalendar.Calendar(element)
 *
 *   return () => {
 *     calendar.destroy()
 *   }
 * }, [element])
 *
 * return <div ref={attachRef} />
 * ```
 *
 * @category refs
 */

function useCallbackRef() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
}

/***/ }),

/***/ 51935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);

/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */

function useCommittedRef(value) {
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(value);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    ref.current = value;
  }, [value]);
  return ref;
}

/* harmony default export */ __webpack_exports__["Z"] = (useCommittedRef);

/***/ }),

/***/ 61255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useEventCallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _useCommittedRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51935);


function useEventCallback(fn) {
  var ref = (0,_useCommittedRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(fn);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    return ref.current && ref.current.apply(ref, arguments);
  }, [ref]);
}

/***/ }),

/***/ 88908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useEventListener; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _useEventCallback__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61255);



/**
 * Attaches an event handler outside directly to specified DOM element
 * bypassing the react synthetic event system.
 *
 * @param element The target to listen for events on
 * @param event The DOM event name
 * @param handler An event handler
 * @param capture Whether or not to listen during the capture event phase
 */
function useEventListener(eventTarget, event, listener, capture) {
  if (capture === void 0) {
    capture = false;
  }

  var handler = (0,_useEventCallback__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(listener);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
    target.addEventListener(event, handler, capture);
    return function () {
      return target.removeEventListener(event, handler, capture);
    };
  }, [eventTarget]);
}

/***/ }),

/***/ 89357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useForceUpdate; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);

/**
 * Returns a function that triggers a component update. the hook equivalent to
 * `this.forceUpdate()` in a class component. In most cases using a state value directly
 * is preferable but may be required in some advanced usages of refs for interop or
 * when direct DOM manipulation is required.
 *
 * ```ts
 * const forceUpdate = useForceUpdate();
 *
 * const updateOnClick = useCallback(() => {
 *  forceUpdate()
 * }, [forceUpdate])
 *
 * return <button type="button" onClick={updateOnClick}>Hi there</button>
 * ```
 */

function useForceUpdate() {
  // The toggling state value is designed to defeat React optimizations for skipping
  // updates when they are stricting equal to the last state value
  var _useReducer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(function (state) {
    return !state;
  }, false),
      dispatch = _useReducer[1];

  return dispatch;
}

/***/ }),

/***/ 46644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);

var isReactNative = typeof __webpack_require__.g !== 'undefined' && // @ts-ignore
__webpack_require__.g.navigator && // @ts-ignore
__webpack_require__.g.navigator.product === 'ReactNative';
var isDOM = typeof document !== 'undefined';
/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */

/* harmony default export */ __webpack_exports__["Z"] = (isDOM || isReactNative ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect);

/***/ }),

/***/ 39400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mergeRefs */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);


var toFnRef = function toFnRef(ref) {
  return !ref || typeof ref === 'function' ? ref : function (value) {
    ref.current = value;
  };
};

function mergeRefs(refA, refB) {
  var a = toFnRef(refA);
  var b = toFnRef(refB);
  return function (value) {
    if (a) a(value);
    if (b) b(value);
  };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */

function useMergedRefs(refA, refB) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return mergeRefs(refA, refB);
  }, [refA, refB]);
}

/* harmony default export */ __webpack_exports__["Z"] = (useMergedRefs);

/***/ }),

/***/ 88441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMounted; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);

/**
 * Track whether a component is current mounted. Generally less preferable than
 * properlly canceling effects so they don't run after a component is unmounted,
 * but helpful in cases where that isn't feasible, such as a `Promise` resolution.
 *
 * @returns a function that returns the current isMounted state of the component
 *
 * ```ts
 * const [data, setData] = useState(null)
 * const isMounted = useMounted()
 *
 * useEffect(() => {
 *   fetchdata().then((newData) => {
 *      if (isMounted()) {
 *        setData(newData);
 *      }
 *   })
 * })
 * ```
 */

function useMounted() {
  var mounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
  var isMounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function () {
    return mounted.current;
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    return function () {
      mounted.current = false;
    };
  }, []);
  return isMounted.current;
}

/***/ }),

/***/ 35981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePrevious; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);

/**
 * Store the last of some value. Tracked via a `Ref` only updating it
 * after the component renders.
 *
 * Helpful if you need to compare a prop value to it's previous value during render.
 *
 * ```ts
 * function Component(props) {
 *   const lastProps = usePrevious(props)
 *
 *   if (lastProps.foo !== props.foo)
 *     resetValueFromProps(props.foo)
 * }
 * ```
 *
 * @param value the value to track
 */

function usePrevious(value) {
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
}

/***/ }),

/***/ 87528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useWillUnmount; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useUpdatedRef.js

/**
 * Returns a ref that is immediately updated with the new value
 *
 * @param value The Ref value
 * @category refs
 */

function useUpdatedRef(value) {
  var valueRef = (0,react.useRef)(value);
  valueRef.current = value;
  return valueRef;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useWillUnmount.js


/**
 * Attach a callback that fires when a component unmounts
 *
 * @param fn Handler to run when the component unmounts
 * @category effects
 */

function useWillUnmount(fn) {
  var onUnmount = useUpdatedRef(fn);
  (0,react.useEffect)(function () {
    return function () {
      return onUnmount.current();
    };
  }, []);
}

/***/ }),

/***/ 50456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Anchor; }
});

// UNUSED EXPORTS: isTrivialHref

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useCallbackRef.js
var useCallbackRef = __webpack_require__(14786);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useCommittedRef.js
var esm_useCommittedRef = __webpack_require__(51935);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useEventCallback.js
var useEventCallback = __webpack_require__(61255);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useEventListener.js
var esm_useEventListener = __webpack_require__(88908);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useGlobalListener.js



/**
 * Attaches an event handler outside directly to the `document`,
 * bypassing the react synthetic event system.
 *
 * ```ts
 * useGlobalListener('keydown', (event) => {
 *  console.log(event.key)
 * })
 * ```
 *
 * @param event The DOM event name
 * @param handler An event handler
 * @param capture Whether or not to listen during the capture event phase
 */
function useGlobalListener(event, handler, capture) {
  if (capture === void 0) {
    capture = false;
  }

  var documentTarget = useCallback(function () {
    return document;
  }, []);
  return useEventListener(documentTarget, event, handler, capture);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useInterval.js


/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */

function useInterval(fn, ms, paused, runImmediately) {
  if (paused === void 0) {
    paused = false;
  }

  if (runImmediately === void 0) {
    runImmediately = false;
  }

  var handle;
  var fnRef = useCommittedRef(fn); // this ref is necessary b/c useEffect will sometimes miss a paused toggle
  // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.

  var pausedRef = useCommittedRef(paused);

  var tick = function tick() {
    if (pausedRef.current) return;
    fnRef.current();
    schedule(); // eslint-disable-line no-use-before-define
  };

  var schedule = function schedule() {
    clearTimeout(handle);
    handle = setTimeout(tick, ms);
  };

  useEffect(function () {
    if (runImmediately) {
      tick();
    } else {
      schedule();
    }

    return function () {
      return clearTimeout(handle);
    };
  }, [paused, runImmediately]);
}

/* harmony default export */ var esm_useInterval = ((/* unused pure expression or super */ null && (useInterval)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useRafInterval.js



function useRafInterval(fn, ms, paused) {
  if (paused === void 0) {
    paused = false;
  }

  var handle;
  var start = new Date().getTime();
  var fnRef = useCommittedRef(fn); // this ref is necessary b/c useEffect will sometimes miss a paused toggle
  // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.

  var pausedRef = useCommittedRef(paused);

  function loop() {
    var current = new Date().getTime();
    var delta = current - start;
    if (pausedRef.current) return;

    if (delta >= ms && fnRef.current) {
      fnRef.current();
      start = new Date().getTime();
    }

    cancelAnimationFrame(handle);
    handle = requestAnimationFrame(loop);
  }

  useEffect(function () {
    handle = requestAnimationFrame(loop);
    return function () {
      return cancelAnimationFrame(handle);
    };
  }, []);
}

/* harmony default export */ var esm_useRafInterval = ((/* unused pure expression or super */ null && (useRafInterval)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useMergeState.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



/**
 * Mimics a React class component's state model, of having a single unified
 * `state` object and an updater that merges updates into the existing state, as
 * opposed to replacing it.
 *
 * ```js
 * const [state, setState] = useMergeState({ name: 'Betsy', age: 24 })
 *
 * setState({ name: 'Johan' }) // { name: 'Johan', age: 24 }
 *
 * setState(state => ({ age: state.age + 10 })) // { name: 'Johan', age: 34 }
 * ```
 *
 * @param initialState The initial state object
 */
function useMergeState_useMergeState(initialState) {
  var _useState = useState(initialState),
      state = _useState[0],
      setState = _useState[1];

  var updater = useCallback(function (update) {
    if (update === null) return;

    if (typeof update === 'function') {
      setState(function (state) {
        var nextState = update(state);
        return nextState == null ? state : _extends({}, state, nextState);
      });
    } else {
      setState(function (state) {
        return _extends({}, state, update);
      });
    }
  }, [setState]);
  return [state, updater];
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useMergeStateFromProps.js

function useMergeStateFromProps(props, gDSFP, initialState) {
  var _useMergeState = useMergeState(initialState),
      state = _useMergeState[0],
      setState = _useMergeState[1];

  var nextState = gDSFP(props, state);
  if (nextState !== null) setState(nextState);
  return [state, setState];
}
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useMounted.js
var useMounted = __webpack_require__(88441);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/usePrevious.js
var usePrevious = __webpack_require__(35981);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useImage.js


/**
 * Fetch and load an image for programatic use such as in a `<canvas>` element.
 *
 * @param imageOrUrl The `HtmlImageElement` or image url to load
 * @param crossOrigin The `crossorigin` attribute to set
 *
 * ```ts
 * const { image, error } = useImage('/static/kittens.png')
 * const ref = useRef<HTMLCanvasElement>()
 *
 * useEffect(() => {
 *   const ctx = ref.current.getContext('2d')
 *
 *   if (image) {
 *     ctx.drawImage(image, 0, 0)
 *   }
 * }, [ref, image])
 *
 * return (
 *   <>
 *     {error && "there was a problem loading the image"}
 *     <canvas ref={ref} />
 *   </>
 * ```
 */
function useImage(imageOrUrl, crossOrigin) {
  var _useState = useState({
    image: null,
    error: null
  }),
      state = _useState[0],
      setState = _useState[1];

  useEffect(function () {
    if (!imageOrUrl) return undefined;
    var image;

    if (typeof imageOrUrl === 'string') {
      image = new Image();
      if (crossOrigin) image.crossOrigin = crossOrigin;
      image.src = imageOrUrl;
    } else {
      image = imageOrUrl;

      if (image.complete && image.naturalHeight > 0) {
        setState({
          image: image,
          error: null
        });
        return;
      }
    }

    function onLoad() {
      setState({
        image: image,
        error: null
      });
    }

    function onError(error) {
      setState({
        image: image,
        error: error
      });
    }

    image.addEventListener('load', onLoad);
    image.addEventListener('error', onError);
    return function () {
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onError);
    };
  }, [imageOrUrl, crossOrigin]);
  return state;
}
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useIsomorphicEffect.js
var useIsomorphicEffect = __webpack_require__(46644);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useResizeObserver.js


var targetMap = new WeakMap();
var resizeObserver;

function getResizeObserver() {
  // eslint-disable-next-line no-return-assign
  return resizeObserver = resizeObserver || new window.ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var handler = targetMap.get(entry.target);
      if (handler) handler(entry.contentRect);
    });
  });
}
/**
 * Efficiently observe size changes on an element. Depends on the `ResizeObserver` api,
 * and polyfills are needed in older browsers.
 *
 * ```ts
 * const [ref, attachRef] = useCallbackRef(null);
 *
 * const rect = useResizeObserver(ref);
 *
 * return (
 *  <div ref={attachRef}>
 *    {JSON.stringify(rect)}
 *  </div>
 * )
 * ```
 *
 * @param element The DOM element to observe
 */


function useResizeObserver(element) {
  var _useState = useState(null),
      rect = _useState[0],
      setRect = _useState[1];

  useEffect(function () {
    if (!element) return;
    getResizeObserver().observe(element);
    setRect(element.getBoundingClientRect());
    targetMap.set(element, function (rect) {
      setRect(rect);
    });
    return function () {
      targetMap.delete(element);
    };
  }, [element]);
  return rect;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/index.js














// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/Button.js
var Button = __webpack_require__(46028);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/Anchor.js
const _excluded = ["onKeyDown"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/anchor-has-content */




function isTrivialHref(href) {
  return !href || href.trim() === '#';
}

/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */
const Anchor = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    onKeyDown
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  const [buttonProps] = (0,Button/* useButtonProps */.FT)(Object.assign({
    tagName: 'a'
  }, props));
  const handleKeyDown = (0,useEventCallback/* default */.Z)(e => {
    buttonProps.onKeyDown(e);
    onKeyDown == null ? void 0 : onKeyDown(e);
  });

  if (isTrivialHref(props.href) && !props.role || props.role === 'button') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("a", Object.assign({
      ref: ref
    }, props, buttonProps, {
      onKeyDown: handleKeyDown
    }));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", Object.assign({
    ref: ref
  }, props, {
    onKeyDown: onKeyDown
  }));
});
Anchor.displayName = 'Anchor';
/* harmony default export */ var esm_Anchor = (Anchor);

/***/ }),

/***/ 46028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FT": function() { return /* binding */ useButtonProps; }
/* harmony export */ });
/* unused harmony export isTrivialHref */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4637);
const _excluded = ["as", "disabled"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
function useButtonProps({
  tagName,
  disabled,
  href,
  target,
  rel,
  onClick,
  tabIndex = 0,
  type
}) {
  if (!tagName) {
    if (href != null || target != null || rel != null) {
      tagName = 'a';
    } else {
      tagName = 'button';
    }
  }

  const meta = {
    tagName
  };

  if (tagName === 'button') {
    return [{
      type: type || 'button',
      disabled
    }, meta];
  }

  const handleClick = event => {
    if (disabled || tagName === 'a' && isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    onClick == null ? void 0 : onClick(event);
  };

  const handleKeyDown = event => {
    if (event.key === ' ') {
      event.preventDefault();
      handleClick(event);
    }
  };

  if (tagName === 'a') {
    // Ensure there's a href so Enter can trigger anchor button.
    href || (href = '#');

    if (disabled) {
      href = undefined;
    }
  }

  return [{
    role: 'button',
    // explicitly undefined so that it overrides the props disabled in a spread
    // e.g. <Tag {...props} {...hookProps} />
    disabled: undefined,
    tabIndex: disabled ? undefined : tabIndex,
    href,
    target: tagName === 'a' ? target : undefined,
    'aria-disabled': !disabled ? undefined : disabled,
    rel: tagName === 'a' ? rel : undefined,
    onClick: handleClick,
    onKeyDown: handleKeyDown
  }, meta];
}
const Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_ref, ref) => {
  let {
    as: asProp,
    disabled
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  const [buttonProps, {
    tagName: Component
  }] = useButtonProps(Object.assign({
    tagName: asProp,
    disabled
  }, props));
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Component, Object.assign({}, props, buttonProps, {
    ref: ref
  }));
});
Button.displayName = 'Button';
/* harmony default export */ __webpack_exports__["ZP"] = (Button);

/***/ }),

/***/ 46040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PB": function() { return /* binding */ dataAttr; },
/* harmony export */   "$F": function() { return /* binding */ dataProp; }
/* harmony export */ });
/* unused harmony exports ATTRIBUTE_PREFIX, PROPERTY_PREFIX */
const ATTRIBUTE_PREFIX = `data-rr-ui-`;
const PROPERTY_PREFIX = `rrUi`;
function dataAttr(property) {
  return `${ATTRIBUTE_PREFIX}${property}`;
}
function dataProp(property) {
  return `${PROPERTY_PREFIX}${property}`;
}

/***/ }),

/***/ 42902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Modal; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/ownerDocument.js
var ownerDocument = __webpack_require__(78342);
;// CONCATENATED MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/activeElement.js

/**
 * Returns the actively focused element safely.
 *
 * @param doc the document to check
 */

function activeElement(doc) {
  if (doc === void 0) {
    doc = (0,ownerDocument/* default */.Z)();
  }

  // Support: IE 9 only
  // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
  try {
    var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
    // document.activeElement from an <iframe>

    if (!active || !active.nodeName) return null;
    return active;
  } catch (e) {
    /* ie throws if no active element */
    return doc.body;
  }
}
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/contains.js
var contains = __webpack_require__(26712);
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/canUseDOM.js
var canUseDOM = __webpack_require__(62762);
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/listen.js
var listen = __webpack_require__(17692);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@17.0.2_react@17.0.2/node_modules/react-dom/index.js
var react_dom = __webpack_require__(87995);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useMounted.js
var useMounted = __webpack_require__(88441);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useWillUnmount.js + 1 modules
var useWillUnmount = __webpack_require__(87528);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/usePrevious.js
var usePrevious = __webpack_require__(35981);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useEventCallback.js
var useEventCallback = __webpack_require__(61255);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/ModalManager.js + 1 modules
var ModalManager = __webpack_require__(20317);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/useWaitForDOMRef.js
var useWaitForDOMRef = __webpack_require__(6854);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/useWindow.js
var useWindow = __webpack_require__(30215);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/Modal.js
const _excluded = ["show", "role", "className", "style", "children", "backdrop", "keyboard", "onBackdropClick", "onEscapeKeyDown", "transition", "backdropTransition", "autoFocus", "enforceFocus", "restoreFocus", "restoreFocusOptions", "renderDialog", "renderBackdrop", "manager", "container", "onShow", "onHide", "onExit", "onExited", "onExiting", "onEnter", "onEntering", "onEntered"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable @typescript-eslint/no-use-before-define, react/prop-types */

















let manager;

function getManager(window) {
  if (!manager) manager = new ModalManager/* default */.Z({
    ownerDocument: window == null ? void 0 : window.document
  });
  return manager;
}

function useModalManager(provided) {
  const window = (0,useWindow/* default */.Z)();
  const modalManager = provided || getManager(window);
  const modal = (0,react.useRef)({
    dialog: null,
    backdrop: null
  });
  return Object.assign(modal.current, {
    add: () => modalManager.add(modal.current),
    remove: () => modalManager.remove(modal.current),
    isTopModal: () => modalManager.isTopModal(modal.current),
    setDialogRef: (0,react.useCallback)(ref => {
      modal.current.dialog = ref;
    }, []),
    setBackdropRef: (0,react.useCallback)(ref => {
      modal.current.backdrop = ref;
    }, [])
  });
}

const Modal = /*#__PURE__*/(0,react.forwardRef)((_ref, ref) => {
  let {
    show = false,
    role = 'dialog',
    className,
    style,
    children,
    backdrop = true,
    keyboard = true,
    onBackdropClick,
    onEscapeKeyDown,
    transition,
    backdropTransition,
    autoFocus = true,
    enforceFocus = true,
    restoreFocus = true,
    restoreFocusOptions,
    renderDialog,
    renderBackdrop = props => /*#__PURE__*/(0,jsx_runtime.jsx)("div", Object.assign({}, props)),
    manager: providedManager,
    container: containerRef,
    onShow,
    onHide = () => {},
    onExit,
    onExited,
    onExiting,
    onEnter,
    onEntering,
    onEntered
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  const container = (0,useWaitForDOMRef/* default */.Z)(containerRef);
  const modal = useModalManager(providedManager);
  const isMounted = (0,useMounted/* default */.Z)();
  const prevShow = (0,usePrevious/* default */.Z)(show);
  const [exited, setExited] = (0,react.useState)(!show);
  const lastFocusRef = (0,react.useRef)(null);
  (0,react.useImperativeHandle)(ref, () => modal, [modal]);

  if (canUseDOM/* default */.Z && !prevShow && show) {
    lastFocusRef.current = activeElement();
  }

  if (!transition && !show && !exited) {
    setExited(true);
  } else if (show && exited) {
    setExited(false);
  }

  const handleShow = (0,useEventCallback/* default */.Z)(() => {
    modal.add();
    removeKeydownListenerRef.current = (0,listen/* default */.Z)(document, 'keydown', handleDocumentKeyDown);
    removeFocusListenerRef.current = (0,listen/* default */.Z)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
    // and so steals focus from it
    () => setTimeout(handleEnforceFocus), true);

    if (onShow) {
      onShow();
    } // autofocus after onShow to not trigger a focus event for previous
    // modals before this one is shown.


    if (autoFocus) {
      const currentActiveElement = activeElement(document);

      if (modal.dialog && currentActiveElement && !(0,contains/* default */.Z)(modal.dialog, currentActiveElement)) {
        lastFocusRef.current = currentActiveElement;
        modal.dialog.focus();
      }
    }
  });
  const handleHide = (0,useEventCallback/* default */.Z)(() => {
    modal.remove();
    removeKeydownListenerRef.current == null ? void 0 : removeKeydownListenerRef.current();
    removeFocusListenerRef.current == null ? void 0 : removeFocusListenerRef.current();

    if (restoreFocus) {
      var _lastFocusRef$current;

      // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
      (_lastFocusRef$current = lastFocusRef.current) == null ? void 0 : _lastFocusRef$current.focus == null ? void 0 : _lastFocusRef$current.focus(restoreFocusOptions);
      lastFocusRef.current = null;
    }
  }); // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
  // Show logic when:
  //  - show is `true` _and_ `container` has resolved

  (0,react.useEffect)(() => {
    if (!show || !container) return;
    handleShow();
  }, [show, container,
  /* should never change: */
  handleShow]); // Hide cleanup logic when:
  //  - `exited` switches to true
  //  - component unmounts;

  (0,react.useEffect)(() => {
    if (!exited) return;
    handleHide();
  }, [exited, handleHide]);
  (0,useWillUnmount/* default */.Z)(() => {
    handleHide();
  }); // --------------------------------

  const handleEnforceFocus = (0,useEventCallback/* default */.Z)(() => {
    if (!enforceFocus || !isMounted() || !modal.isTopModal()) {
      return;
    }

    const currentActiveElement = activeElement();

    if (modal.dialog && currentActiveElement && !(0,contains/* default */.Z)(modal.dialog, currentActiveElement)) {
      modal.dialog.focus();
    }
  });
  const handleBackdropClick = (0,useEventCallback/* default */.Z)(e => {
    if (e.target !== e.currentTarget) {
      return;
    }

    onBackdropClick == null ? void 0 : onBackdropClick(e);

    if (backdrop === true) {
      onHide();
    }
  });
  const handleDocumentKeyDown = (0,useEventCallback/* default */.Z)(e => {
    if (keyboard && e.keyCode === 27 && modal.isTopModal()) {
      onEscapeKeyDown == null ? void 0 : onEscapeKeyDown(e);

      if (!e.defaultPrevented) {
        onHide();
      }
    }
  });
  const removeFocusListenerRef = (0,react.useRef)();
  const removeKeydownListenerRef = (0,react.useRef)();

  const handleHidden = (...args) => {
    setExited(true);
    onExited == null ? void 0 : onExited(...args);
  };

  const Transition = transition;

  if (!container || !(show || Transition && !exited)) {
    return null;
  }

  const dialogProps = Object.assign({
    role,
    ref: modal.setDialogRef,
    // apparently only works on the dialog role element
    'aria-modal': role === 'dialog' ? true : undefined
  }, rest, {
    style,
    className,
    tabIndex: -1
  });
  let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", Object.assign({}, dialogProps, {
    children: /*#__PURE__*/react.cloneElement(children, {
      role: 'document'
    })
  }));

  if (Transition) {
    dialog = /*#__PURE__*/(0,jsx_runtime.jsx)(Transition, {
      appear: true,
      unmountOnExit: true,
      in: !!show,
      onExit: onExit,
      onExiting: onExiting,
      onExited: handleHidden,
      onEnter: onEnter,
      onEntering: onEntering,
      onEntered: onEntered,
      children: dialog
    });
  }

  let backdropElement = null;

  if (backdrop) {
    const BackdropTransition = backdropTransition;
    backdropElement = renderBackdrop({
      ref: modal.setBackdropRef,
      onClick: handleBackdropClick
    });

    if (BackdropTransition) {
      backdropElement = /*#__PURE__*/(0,jsx_runtime.jsx)(BackdropTransition, {
        appear: true,
        in: !!show,
        children: backdropElement
      });
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/react_dom.createPortal( /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [backdropElement, dialog]
    }), container)
  });
});
Modal.displayName = 'Modal';
/* harmony default export */ var esm_Modal = (Object.assign(Modal, {
  Manager: ModalManager/* default */.Z
}));

/***/ }),

/***/ 20317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_ModalManager; }
});

// UNUSED EXPORTS: OPEN_DATA_ATTRIBUTE

// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/css.js + 5 modules
var css = __webpack_require__(20968);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/DataKey.js
var DataKey = __webpack_require__(46040);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/getScrollbarWidth.js
/**
 * Get the width of the vertical window scrollbar if it's visible
 */
function getBodyScrollbarWidth(ownerDocument = document) {
  const window = ownerDocument.defaultView;
  return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/ModalManager.js



const OPEN_DATA_ATTRIBUTE = (0,DataKey/* dataAttr */.PB)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */

class ModalManager {
  constructor({
    ownerDocument,
    handleContainerOverflow = true,
    isRTL = false
  } = {}) {
    this.handleContainerOverflow = handleContainerOverflow;
    this.isRTL = isRTL;
    this.modals = [];
    this.ownerDocument = ownerDocument;
  }

  getScrollbarWidth() {
    return getBodyScrollbarWidth(this.ownerDocument);
  }

  getElement() {
    return (this.ownerDocument || document).body;
  }

  setModalAttributes(_modal) {// For overriding
  }

  removeModalAttributes(_modal) {// For overriding
  }

  setContainerStyle(containerState) {
    const style = {
      overflow: 'hidden'
    }; // we are only interested in the actual `style` here
    // because we will override it

    const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
    const container = this.getElement();
    containerState.style = {
      overflow: container.style.overflow,
      [paddingProp]: container.style[paddingProp]
    };

    if (containerState.scrollBarWidth) {
      // use computed style, here to get the real padding
      // to add our scrollbar width
      style[paddingProp] = `${parseInt((0,css/* default */.Z)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
    }

    container.setAttribute(OPEN_DATA_ATTRIBUTE, '');
    (0,css/* default */.Z)(container, style);
  }

  reset() {
    [...this.modals].forEach(m => this.remove(m));
  }

  removeContainerStyle(containerState) {
    const container = this.getElement();
    container.removeAttribute(OPEN_DATA_ATTRIBUTE);
    Object.assign(container.style, containerState.style);
  }

  add(modal) {
    let modalIdx = this.modals.indexOf(modal);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = this.modals.length;
    this.modals.push(modal);
    this.setModalAttributes(modal);

    if (modalIdx !== 0) {
      return modalIdx;
    }

    this.state = {
      scrollBarWidth: this.getScrollbarWidth(),
      style: {}
    };

    if (this.handleContainerOverflow) {
      this.setContainerStyle(this.state);
    }

    return modalIdx;
  }

  remove(modal) {
    const modalIdx = this.modals.indexOf(modal);

    if (modalIdx === -1) {
      return;
    }

    this.modals.splice(modalIdx, 1); // if that was the last modal in a container,
    // clean up the container

    if (!this.modals.length && this.handleContainerOverflow) {
      this.removeContainerStyle(this.state);
    }

    this.removeModalAttributes(modal);
  }

  isTopModal(modal) {
    return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
  }

}

/* harmony default export */ var esm_ModalManager = (ModalManager);

/***/ }),

/***/ 84418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);

const NavContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
NavContext.displayName = 'NavContext';
/* harmony default export */ __webpack_exports__["Z"] = (NavContext);

/***/ }),

/***/ 27680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useNavItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61255);
/* harmony import */ var _NavContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84418);
/* harmony import */ var _SelectableContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77519);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46028);
/* harmony import */ var _DataKey__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46040);
/* harmony import */ var _TabContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70330);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4637);
const _excluded = ["as", "active", "eventKey"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }










function useNavItem({
  key,
  onClick,
  active,
  id,
  role,
  disabled
}) {
  const parentOnSelect = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_SelectableContext__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
  const navContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_NavContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
  const tabContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_TabContext__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z);
  let isActive = active;
  const props = {
    role
  };

  if (navContext) {
    if (!role && navContext.role === 'tablist') props.role = 'tab';
    const contextControllerId = navContext.getControllerId(key != null ? key : null);
    const contextControlledId = navContext.getControlledId(key != null ? key : null); // @ts-ignore

    props[(0,_DataKey__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)('event-key')] = key;
    props.id = contextControllerId || id;
    isActive = active == null && key != null ? navContext.activeKey === key : active;
    /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */

    if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
  }

  if (props.role === 'tab') {
    if (disabled) {
      props.tabIndex = -1;
      props['aria-disabled'] = true;
    }

    if (isActive) {
      props['aria-selected'] = isActive;
    } else {
      props.tabIndex = -1;
    }
  }

  props.onClick = (0,_restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(e => {
    if (disabled) return;
    onClick == null ? void 0 : onClick(e);

    if (key == null) {
      return;
    }

    if (parentOnSelect && !e.isPropagationStopped()) {
      parentOnSelect(key, e);
    }
  });
  return [props, {
    isActive
  }];
}
const NavItem = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_ref, ref) => {
  let {
    as: Component = _Button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP,
    active,
    eventKey
  } = _ref,
      options = _objectWithoutPropertiesLoose(_ref, _excluded);

  const [props, meta] = useNavItem(Object.assign({
    key: (0,_SelectableContext__WEBPACK_IMPORTED_MODULE_3__/* .makeEventKey */ .h)(eventKey, options.href),
    active
  }, options)); // @ts-ignore

  props[(0,_DataKey__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)('active')] = meta.isActive;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, Object.assign({}, options, props, {
    ref: ref
  }));
});
NavItem.displayName = 'NavItem';
/* harmony default export */ __webpack_exports__["Z"] = (NavItem);

/***/ }),

/***/ 77519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ makeEventKey; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);

const SelectableContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
const makeEventKey = (eventKey, href = null) => {
  if (eventKey != null) return String(eventKey);
  return href || null;
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectableContext);

/***/ }),

/***/ 70330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);

const TabContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
/* harmony default export */ __webpack_exports__["Z"] = (TabContext);

/***/ }),

/***/ 96027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ mergeOptionsWithPopperConfig; }
/* harmony export */ });
/* unused harmony exports toModifierMap, toModifierArray */
function toModifierMap(modifiers) {
  const result = {};

  if (!Array.isArray(modifiers)) {
    return modifiers || result;
  } // eslint-disable-next-line no-unused-expressions


  modifiers == null ? void 0 : modifiers.forEach(m => {
    result[m.name] = m;
  });
  return result;
}
function toModifierArray(map = {}) {
  if (Array.isArray(map)) return map;
  return Object.keys(map).map(k => {
    map[k].name = k;
    return map[k];
  });
}
function mergeOptionsWithPopperConfig({
  enabled,
  enableEvents,
  placement,
  flip,
  offset,
  fixed,
  containerPadding,
  arrowElement,
  popperConfig = {}
}) {
  var _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;

  const modifiers = toModifierMap(popperConfig.modifiers);
  return Object.assign({}, popperConfig, {
    placement,
    enabled,
    strategy: fixed ? 'fixed' : popperConfig.strategy,
    modifiers: toModifierArray(Object.assign({}, modifiers, {
      eventListeners: {
        enabled: enableEvents
      },
      preventOverflow: Object.assign({}, modifiers.preventOverflow, {
        options: containerPadding ? Object.assign({
          padding: containerPadding
        }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
      }),
      offset: {
        options: Object.assign({
          offset
        }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
      },
      arrow: Object.assign({}, modifiers.arrow, {
        enabled: !!arrowElement,
        options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
          element: arrowElement
        })
      }),
      flip: Object.assign({
        enabled: !!flip
      }, modifiers.flip)
    }))
  });
}

/***/ }),

/***/ 41071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ getRefTarget; }
/* harmony export */ });
/* harmony import */ var dom_helpers_contains__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26712);
/* harmony import */ var dom_helpers_listen__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17692);
/* harmony import */ var dom_helpers_ownerDocument__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78342);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61255);
/* harmony import */ var warning__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91190);
/* harmony import */ var warning__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(warning__WEBPACK_IMPORTED_MODULE_3__);







const noop = () => {};

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

const getRefTarget = ref => ref && ('current' in ref ? ref.current : ref);
const InitialTriggerEvents = {
  click: 'mousedown',
  mouseup: 'mousedown',
  pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */

function useClickOutside(ref, onClickOutside = noop, {
  disabled,
  clickTrigger = 'click'
} = {}) {
  const preventMouseClickOutsideRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
  const waitingForTrigger = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
  const handleMouseCapture = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(e => {
    const currentTarget = getRefTarget(ref);
    warning__WEBPACK_IMPORTED_MODULE_3___default()(!!currentTarget, 'ClickOutside captured a close event but does not have a ref to compare it to. ' + 'useClickOutside(), should be passed a ref that resolves to a DOM node');
    preventMouseClickOutsideRef.current = !currentTarget || isModifiedEvent(e) || !isLeftClickEvent(e) || !!(0,dom_helpers_contains__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(currentTarget, e.target) || waitingForTrigger.current;
    waitingForTrigger.current = false;
  }, [ref]);
  const handleInitialMouse = (0,_restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(e => {
    const currentTarget = getRefTarget(ref);

    if (currentTarget && (0,dom_helpers_contains__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(currentTarget, e.target)) {
      waitingForTrigger.current = true;
    }
  });
  const handleMouse = (0,_restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(e => {
    if (!preventMouseClickOutsideRef.current) {
      onClickOutside(e);
    }
  });
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (disabled || ref == null) return undefined;
    const doc = (0,dom_helpers_ownerDocument__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(getRefTarget(ref)); // Store the current event to avoid triggering handlers immediately
    // https://github.com/facebook/react/issues/20074

    let currentEvent = (doc.defaultView || window).event;
    let removeInitialTriggerListener = null;

    if (InitialTriggerEvents[clickTrigger]) {
      removeInitialTriggerListener = (0,dom_helpers_listen__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(doc, InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
    } // Use capture for this listener so it fires before React's listener, to
    // avoid false positives in the contains() check below if the target DOM
    // element is removed in the React mouse callback.


    const removeMouseCaptureListener = (0,dom_helpers_listen__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(doc, clickTrigger, handleMouseCapture, true);
    const removeMouseListener = (0,dom_helpers_listen__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(doc, clickTrigger, e => {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }

      handleMouse(e);
    });
    let mobileSafariHackListeners = [];

    if ('ontouchstart' in doc.documentElement) {
      mobileSafariHackListeners = [].slice.call(doc.body.children).map(el => (0,dom_helpers_listen__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(el, 'mousemove', noop));
    }

    return () => {
      removeInitialTriggerListener == null ? void 0 : removeInitialTriggerListener();
      removeMouseCaptureListener();
      removeMouseListener();
      mobileSafariHackListeners.forEach(remove => remove());
    };
  }, [ref, disabled, clickTrigger, handleMouseCapture, handleInitialMouse, handleMouse]);
}

/* harmony default export */ __webpack_exports__["Z"] = (useClickOutside);

/***/ }),

/***/ 39279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_usePopper; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
;// CONCATENATED MODULE: ./node_modules/.pnpm/dequal@2.0.2/node_modules/dequal/dist/index.mjs
var has = Object.prototype.hasOwnProperty;

function find(iter, tar, key) {
	for (key of iter.keys()) {
		if (dequal(key, tar)) return key;
	}
}

function dequal(foo, bar) {
	var ctor, len, tmp;
	if (foo === bar) return true;

	if (foo && bar && (ctor=foo.constructor) === bar.constructor) {
		if (ctor === Date) return foo.getTime() === bar.getTime();
		if (ctor === RegExp) return foo.toString() === bar.toString();

		if (ctor === Array) {
			if ((len=foo.length) === bar.length) {
				while (len-- && dequal(foo[len], bar[len]));
			}
			return len === -1;
		}

		if (ctor === Set) {
			if (foo.size !== bar.size) {
				return false;
			}
			for (len of foo) {
				tmp = len;
				if (tmp && typeof tmp === 'object') {
					tmp = find(bar, tmp);
					if (!tmp) return false;
				}
				if (!bar.has(tmp)) return false;
			}
			return true;
		}

		if (ctor === Map) {
			if (foo.size !== bar.size) {
				return false;
			}
			for (len of foo) {
				tmp = len[0];
				if (tmp && typeof tmp === 'object') {
					tmp = find(bar, tmp);
					if (!tmp) return false;
				}
				if (!dequal(len[1], bar.get(tmp))) {
					return false;
				}
			}
			return true;
		}

		if (ctor === ArrayBuffer) {
			foo = new Uint8Array(foo);
			bar = new Uint8Array(bar);
		} else if (ctor === DataView) {
			if ((len=foo.byteLength) === bar.byteLength) {
				while (len-- && foo.getInt8(len) === bar.getInt8(len));
			}
			return len === -1;
		}

		if (ArrayBuffer.isView(foo)) {
			if ((len=foo.byteLength) === bar.byteLength) {
				while (len-- && foo[len] === bar[len]);
			}
			return len === -1;
		}

		if (!ctor || typeof foo === 'object') {
			len = 0;
			for (ctor in foo) {
				if (has.call(foo, ctor) && ++len && !has.call(bar, ctor)) return false;
				if (!(ctor in bar) || !dequal(foo[ctor], bar[ctor])) return false;
			}
			return Object.keys(bar).length === len;
		}
	}

	return foo !== foo && bar !== bar;
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useMounted.js
var useMounted = __webpack_require__(88441);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useSafeState.js



function useSafeState(state) {
  var isMounted = (0,useMounted/* default */.Z)();
  return [state[0], (0,react.useCallback)(function (nextState) {
    if (!isMounted()) return;
    return state[1](nextState);
  }, [isMounted, state[1]])];
}

/* harmony default export */ var esm_useSafeState = (useSafeState);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/modifiers/arrow.js
var arrow = __webpack_require__(40002);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/modifiers/computeStyles.js
var computeStyles = __webpack_require__(83148);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/modifiers/eventListeners.js
var eventListeners = __webpack_require__(78425);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/modifiers/flip.js + 3 modules
var flip = __webpack_require__(89858);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/modifiers/hide.js
var hide = __webpack_require__(5445);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/modifiers/offset.js
var offset = __webpack_require__(87883);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/modifiers/popperOffsets.js
var popperOffsets = __webpack_require__(93809);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/modifiers/preventOverflow.js + 1 modules
var preventOverflow = __webpack_require__(7382);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/createPopper.js + 6 modules
var createPopper = __webpack_require__(32829);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/popper.js









 // For the common JS build we will turn this file into a bundle with no imports.
// This is b/c the Popper lib is all esm files, and would break in a common js only environment

const popper_createPopper = (0,createPopper/* popperGenerator */.kZ)({
  defaultModifiers: [hide/* default */.Z, popperOffsets/* default */.Z, computeStyles/* default */.Z, eventListeners/* default */.Z, offset/* default */.Z, flip/* default */.Z, preventOverflow/* default */.Z, arrow/* default */.Z]
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/usePopper.js
const _excluded = ["enabled", "placement", "strategy", "modifiers"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





const disabledApplyStylesModifier = {
  name: 'applyStyles',
  enabled: false,
  phase: 'afterWrite',
  fn: () => undefined
}; // until docjs supports type exports...

const ariaDescribedByModifier = {
  name: 'ariaDescribedBy',
  enabled: true,
  phase: 'afterWrite',
  effect: ({
    state
  }) => () => {
    const {
      reference,
      popper
    } = state.elements;

    if ('removeAttribute' in reference) {
      const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter(id => id.trim() !== popper.id);
      if (!ids.length) reference.removeAttribute('aria-describedby');else reference.setAttribute('aria-describedby', ids.join(','));
    }
  },
  fn: ({
    state
  }) => {
    var _popper$getAttribute;

    const {
      popper,
      reference
    } = state.elements;
    const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();

    if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
      const ids = reference.getAttribute('aria-describedby');

      if (ids && ids.split(',').indexOf(popper.id) !== -1) {
        return;
      }

      reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
    }
  }
};
const EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */

function usePopper(referenceElement, popperElement, _ref = {}) {
  let {
    enabled = true,
    placement = 'bottom',
    strategy = 'absolute',
    modifiers = EMPTY_MODIFIERS
  } = _ref,
      config = _objectWithoutPropertiesLoose(_ref, _excluded);

  const prevModifiers = (0,react.useRef)(modifiers);
  const popperInstanceRef = (0,react.useRef)();
  const update = (0,react.useCallback)(() => {
    var _popperInstanceRef$cu;

    (_popperInstanceRef$cu = popperInstanceRef.current) == null ? void 0 : _popperInstanceRef$cu.update();
  }, []);
  const forceUpdate = (0,react.useCallback)(() => {
    var _popperInstanceRef$cu2;

    (_popperInstanceRef$cu2 = popperInstanceRef.current) == null ? void 0 : _popperInstanceRef$cu2.forceUpdate();
  }, []);
  const [popperState, setState] = esm_useSafeState((0,react.useState)({
    placement,
    update,
    forceUpdate,
    attributes: {},
    styles: {
      popper: {},
      arrow: {}
    }
  }));
  const updateModifier = (0,react.useMemo)(() => ({
    name: 'updateStateModifier',
    enabled: true,
    phase: 'write',
    requires: ['computeStyles'],
    fn: ({
      state
    }) => {
      const styles = {};
      const attributes = {};
      Object.keys(state.elements).forEach(element => {
        styles[element] = state.styles[element];
        attributes[element] = state.attributes[element];
      });
      setState({
        state,
        styles,
        attributes,
        update,
        forceUpdate,
        placement: state.placement
      });
    }
  }), [update, forceUpdate, setState]);
  const nextModifiers = (0,react.useMemo)(() => {
    if (!dequal(prevModifiers.current, modifiers)) {
      prevModifiers.current = modifiers;
    }

    return prevModifiers.current;
  }, [modifiers]);
  (0,react.useEffect)(() => {
    if (!popperInstanceRef.current || !enabled) return;
    popperInstanceRef.current.setOptions({
      placement,
      strategy,
      modifiers: [...nextModifiers, updateModifier, disabledApplyStylesModifier]
    });
  }, [strategy, placement, updateModifier, enabled, nextModifiers]);
  (0,react.useEffect)(() => {
    if (!enabled || referenceElement == null || popperElement == null) {
      return undefined;
    }

    popperInstanceRef.current = popper_createPopper(referenceElement, popperElement, Object.assign({}, config, {
      placement,
      strategy,
      modifiers: [...nextModifiers, ariaDescribedByModifier, updateModifier]
    }));
    return () => {
      if (popperInstanceRef.current != null) {
        popperInstanceRef.current.destroy();
        popperInstanceRef.current = undefined;
        setState(s => Object.assign({}, s, {
          attributes: {},
          styles: {
            popper: {}
          }
        }));
      }
    }; // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, referenceElement, popperElement]);
  return popperState;
}

/* harmony default export */ var esm_usePopper = (usePopper);

/***/ }),

/***/ 6854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWaitForDOMRef; }
/* harmony export */ });
/* unused harmony export resolveContainerRef */
/* harmony import */ var dom_helpers_ownerDocument__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78342);
/* harmony import */ var dom_helpers_canUseDOM__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62762);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _useWindow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30215);




const resolveContainerRef = (ref, document) => {
  var _ref;

  if (!dom_helpers_canUseDOM__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z) return null;
  if (ref == null) return (document || (0,dom_helpers_ownerDocument__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)()).body;
  if (typeof ref === 'function') ref = ref();
  if (ref && 'current' in ref) ref = ref.current;
  if ((_ref = ref) != null && _ref.nodeType) return ref || null;
  return null;
};
function useWaitForDOMRef(ref, onResolved) {
  const window = (0,_useWindow__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const [resolvedRef, setRef] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(() => resolveContainerRef(ref, window == null ? void 0 : window.document));

  if (!resolvedRef) {
    const earlyRef = resolveContainerRef(ref);
    if (earlyRef) setRef(earlyRef);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (onResolved && resolvedRef) {
      onResolved(resolvedRef);
    }
  }, [onResolved, resolvedRef]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    const nextRef = resolveContainerRef(ref);

    if (nextRef !== resolvedRef) {
      setRef(nextRef);
    }
  }, [ref, resolvedRef]);
  return resolvedRef;
}

/***/ }),

/***/ 30215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWindow; }
/* harmony export */ });
/* unused harmony export WindowProvider */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var dom_helpers_canUseDOM__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62762);


const Context = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(dom_helpers_canUseDOM__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z ? window : undefined);
const WindowProvider = Context.Provider;
/**
 * The document "window" placed in React context. Helpful for determining
 * SSR context, or when rendering into an iframe.
 *
 * @returns the current window
 */

function useWindow() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Context);
}

/***/ }),

/***/ 39949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dr": function() { return /* binding */ eventFromException; },
  "aB": function() { return /* binding */ eventFromMessage; },
  "ME": function() { return /* binding */ eventFromUnknownInput; },
  "GJ": function() { return /* binding */ exceptionFromError; }
});

// UNUSED EXPORTS: eventFromError, eventFromPlainObject, eventFromString, parseStackFrames

// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@1.14.1/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(65949);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+types@6.19.7/node_modules/@sentry/types/esm/severity.js
var severity = __webpack_require__(13359);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(83106);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(96702);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/normalize.js + 1 modules
var normalize = __webpack_require__(74526);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/stacktrace.js
var esm_stacktrace = __webpack_require__(42389);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(70133);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(1774);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/stack-parsers.js

// global reference to slice
var UNKNOWN_FUNCTION = '?';
var OPERA10_PRIORITY = 10;
var OPERA11_PRIORITY = 20;
var CHROME_PRIORITY = 30;
var WINJS_PRIORITY = 40;
var GECKO_PRIORITY = 50;
function createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true,
    };
    if (lineno !== undefined) {
        frame.lineno = lineno;
    }
    if (colno !== undefined) {
        frame.colno = colno;
    }
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var chrome = function (line) {
    var parts = chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0,tslib_es6/* __read */.CR)(extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var chromeStackParser = [CHROME_PRIORITY, chrome];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var gecko = function (line) {
    var _a;
    var parts = geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || UNKNOWN_FUNCTION;
        _a = (0,tslib_es6/* __read */.CR)(extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var geckoStackParser = [GECKO_PRIORITY, gecko];
var winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var winjs = function (line) {
    var parts = winjsRegex.exec(line);
    return parts
        ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
        : undefined;
};
var winjsStackParser = [WINJS_PRIORITY, winjs];
var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var opera10 = function (line) {
    var parts = opera10Regex.exec(line);
    return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var opera10StackParser = [OPERA10_PRIORITY, opera10];
var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var opera11 = function (line) {
    var parts = opera11Regex.exec(line);
    return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var opera11StackParser = [OPERA11_PRIORITY, opera11];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
var extractSafariExtensionDetails = function (func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension
        ? [
            func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
            isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename,
        ]
        : [func, filename];
};
//# sourceMappingURL=stack-parsers.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/eventbuilder.js




/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */
function exceptionFromError(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = parseStackFrames(ex);
    var exception = {
        type: ex && ex.name,
        value: extractMessage(ex),
    };
    if (frames.length) {
        exception.stacktrace = { frames: frames };
    }
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
/**
 * @hidden
 */
function eventFromPlainObject(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0,is/* isEvent */.cO)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0,object/* extractExceptionKeysForMessage */.zf)(exception),
                },
            ],
        },
        extra: {
            __serialized__: (0,normalize/* normalizeToSize */.Qy)(exception),
        },
    };
    if (syntheticException) {
        var frames_1 = parseStackFrames(syntheticException);
        if (frames_1.length) {
            event.stacktrace = { frames: frames_1 };
        }
    }
    return event;
}
/**
 * @hidden
 */
function eventFromError(ex) {
    return {
        exception: {
            values: [exceptionFromError(ex)],
        },
    };
}
/** Parses stack frames from an error */
function parseStackFrames(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = getPopSize(ex);
    try {
        return (0,esm_stacktrace/* createStackParser */.pE)(opera10StackParser, opera11StackParser, chromeStackParser, winjsStackParser, geckoStackParser)(stacktrace, popSize);
    }
    catch (e) {
        // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;
function getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') {
            return ex.framesToPop;
        }
        if (reactMinifiedRegexp.test(ex.message)) {
            return 1;
        }
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return 'No error message';
    }
    if (message.error && typeof message.error.message === 'string') {
        return message.error.message;
    }
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(exception, hint, attachStacktrace) {
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromUnknownInput(exception, syntheticException, attachStacktrace);
    (0,misc/* addExceptionMechanism */.EG)(event); // defaults to { type: 'generic', handled: true }
    event.level = severity/* Severity.Error */.z.Error;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(message, level, hint, attachStacktrace) {
    if (level === void 0) { level = severity/* Severity.Info */.z.Info; }
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromString(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}
/**
 * @hidden
 */
function eventFromUnknownInput(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0,is/* isErrorEvent */.VW)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return eventFromError(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0,is/* isDOMError */.TX)(exception) || (0,is/* isDOMException */.fm)(exception)) {
        var domException = exception;
        if ('stack' in exception) {
            event = eventFromError(exception);
        }
        else {
            var name_1 = domException.name || ((0,is/* isDOMError */.TX)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = eventFromString(message, syntheticException, attachStacktrace);
            (0,misc/* addExceptionTypeValue */.Db)(event, message);
        }
        if ('code' in domException) {
            event.tags = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event.tags), { 'DOMException.code': "" + domException.code });
        }
        return event;
    }
    if ((0,is/* isError */.VZ)(exception)) {
        // we have a real Error object, do nothing
        return eventFromError(exception);
    }
    if ((0,is/* isPlainObject */.PO)(exception) || (0,is/* isEvent */.cO)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = eventFromPlainObject(objectException, syntheticException, isUnhandledRejection);
        (0,misc/* addExceptionMechanism */.EG)(event, {
            synthetic: true,
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(exception, syntheticException, attachStacktrace);
    (0,misc/* addExceptionTypeValue */.Db)(event, "" + exception, undefined);
    (0,misc/* addExceptionMechanism */.EG)(event, {
        synthetic: true,
    });
    return event;
}
/**
 * @hidden
 */
function eventFromString(input, syntheticException, attachStacktrace) {
    var event = {
        message: input,
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = parseStackFrames(syntheticException);
        if (frames_2.length) {
            event.stacktrace = { frames: frames_2 };
        }
    }
    return event;
}
//# sourceMappingURL=eventbuilder.js.map

/***/ }),

/***/ 85524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ IS_DEBUG_BUILD; }
/* harmony export */ });
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
//# sourceMappingURL=flags.js.map

/***/ }),

/***/ 88621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wz": function() { return /* binding */ shouldIgnoreOnError; },
/* harmony export */   "re": function() { return /* binding */ wrap; },
/* harmony export */   "BS": function() { return /* binding */ injectReportDialog; }
/* harmony export */ });
/* unused harmony export ignoreNextOnError */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65949);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22164);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88961);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66149);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96702);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70133);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43888);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85524);




var global = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
var ignoreOnError = 0;
/**
 * @hidden
 */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) { options = {}; }
    if (typeof fn !== 'function') {
        return fn;
    }
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            return wrapper;
        }
        // We don't wanna wrap it twice
        if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getOriginalFunction */ .HK)(fn)) {
            return fn;
        }
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function () {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') {
                before.apply(this, arguments);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        }
        catch (ex) {
            ignoreNextOnError();
            (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .withScope */ .$e)(function (scope) {
                scope.addEventProcessor(function (event) {
                    if (options.mechanism) {
                        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionTypeValue */ .Db)(event, undefined, undefined);
                        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionMechanism */ .EG)(event, options.mechanism);
                    }
                    event.extra = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)({}, event.extra), { arguments: args });
                    return event;
                });
                (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .captureException */ .Tb)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    }
    catch (_oO) { } // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .markFunctionWrapped */ .$Q)(sentryWrapped, fn);
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, 'name', {
                get: function () {
                    return fn.name;
                },
            });
        }
        // eslint-disable-next-line no-empty
    }
    catch (_oO) { }
    return sentryWrapped;
}
/**
 * Injects the Report Dialog script
 * @hidden
 */
function injectReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!global.document) {
        return;
    }
    if (!options.eventId) {
        _flags__WEBPACK_IMPORTED_MODULE_5__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.error */ .kg.error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        _flags__WEBPACK_IMPORTED_MODULE_5__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.error */ .kg.error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = global.document.createElement('script');
    script.async = true;
    script.src = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_7__/* .getReportDialogEndpoint */ .hR)(options.dsn, options);
    if (options.onLoad) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        script.onload = options.onLoad;
    }
    var injectionPoint = global.document.head || global.document.body;
    if (injectionPoint) {
        injectionPoint.appendChild(script);
    }
}
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 69195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@1.14.1/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(65949);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+hub@6.19.7/node_modules/@sentry/hub/esm/hub.js + 2 modules
var hub = __webpack_require__(25976);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+types@6.19.7/node_modules/@sentry/types/esm/severity.js
var severity = __webpack_require__(13359);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/enums.js
var SeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical'];
//# sourceMappingURL=enums.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/severity.js


function isSupportedSeverity(level) {
    return SeverityLevels.indexOf(level) !== -1;
}
/**
 * Converts a string-based level into a {@link Severity}.
 *
 * @param level string representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
    if (level === 'warn')
        return severity/* Severity.Warning */.z.Warning;
    if (isSupportedSeverity(level)) {
        return level;
    }
    return severity/* Severity.Log */.z.Log;
}
//# sourceMappingURL=severity.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(70133);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(71588);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(42880);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(80973);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/global.js
var esm_global = __webpack_require__(66149);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/integrations/breadcrumbs.js

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable max-lines */



/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
var Breadcrumbs = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this._options = (0,tslib_es6/* __assign */.pi)({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */
    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
        if (!this._options.sentry) {
            return;
        }
        (0,hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0,misc/* getEventDescription */.jH)(event),
        }, {
            event: event,
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        if (this._options.console) {
            (0,instrument/* addInstrumentationHandler */.o)('console', _consoleBreadcrumb);
        }
        if (this._options.dom) {
            (0,instrument/* addInstrumentationHandler */.o)('dom', _domBreadcrumb(this._options.dom));
        }
        if (this._options.xhr) {
            (0,instrument/* addInstrumentationHandler */.o)('xhr', _xhrBreadcrumb);
        }
        if (this._options.fetch) {
            (0,instrument/* addInstrumentationHandler */.o)('fetch', _fetchBreadcrumb);
        }
        if (this._options.history) {
            (0,instrument/* addInstrumentationHandler */.o)('history', _historyBreadcrumb);
        }
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}());

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') {
            keyAttrs = [keyAttrs];
        }
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target
                ? (0,browser/* htmlTreeAsString */.R)(handlerData.event.target, keyAttrs)
                : (0,browser/* htmlTreeAsString */.R)(handlerData.event, keyAttrs);
        }
        catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) {
            return;
        }
        (0,hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target,
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global,
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console',
        },
        level: severityFromString(handlerData.level),
        message: (0,string/* safeJoin */.nK)(handlerData.args, ' '),
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0,string/* safeJoin */.nK)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        }
        else {
            // Don't capture a breadcrumb for passed assertions
            return;
        }
    }
    (0,hub/* getCurrentHub */.Gd)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level,
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) {
            return;
        }
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0,hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code,
            },
            type: 'http',
        }, {
            xhr: handlerData.xhr,
            input: body,
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) {
        return;
    }
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
        // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
    }
    if (handlerData.error) {
        (0,hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: 'fetch',
            data: handlerData.fetchData,
            level: severity/* Severity.Error */.z.Error,
            type: 'http',
        }, {
            data: handlerData.error,
            input: handlerData.args,
        });
    }
    else {
        (0,hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: 'fetch',
            data: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, handlerData.fetchData), { status_code: handlerData.response.status }),
            type: 'http',
        }, {
            input: handlerData.args,
            response: handlerData.response,
        });
    }
}
/**
 * Creates breadcrumbs from history API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _historyBreadcrumb(handlerData) {
    var global = (0,esm_global/* getGlobalObject */.R)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0,misc/* parseUrl */.en)(global.location.href);
    var parsedFrom = (0,misc/* parseUrl */.en)(from);
    var parsedTo = (0,misc/* parseUrl */.en)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) {
        parsedFrom = parsedLoc;
    }
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
        to = parsedTo.relative;
    }
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
        from = parsedFrom.relative;
    }
    (0,hub/* getCurrentHub */.Gd)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to,
        },
    });
}
//# sourceMappingURL=breadcrumbs.js.map

/***/ }),

/***/ 22277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Dedupe; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43888);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85524);


/** Deduplication filter */
var Dedupe = /** @class */ (function () {
    function Dedupe() {
        /**
         * @inheritDoc
         */
        this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */
    Dedupe.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if (_shouldDropEvent(currentEvent, self._previousEvent)) {
                        _flags__WEBPACK_IMPORTED_MODULE_0__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                }
                catch (_oO) {
                    return (self._previousEvent = currentEvent);
                }
                return (self._previousEvent = currentEvent);
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */
    Dedupe.id = 'Dedupe';
    return Dedupe;
}());

/** JSDoc */
function _shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) {
        return false;
    }
    if (_isSameMessageEvent(currentEvent, previousEvent)) {
        return true;
    }
    if (_isSameExceptionEvent(currentEvent, previousEvent)) {
        return true;
    }
    return false;
}
/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) {
        return false;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
        return false;
    }
    if (currentMessage !== previousMessage) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = _getExceptionFromEvent(previousEvent);
    var currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) {
        return false;
    }
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = _getFramesFromEvent(currentEvent);
    var previousFrames = _getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) {
        return true;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
        return false;
    }
    currentFrames = currentFrames;
    previousFrames = previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) {
        return false;
    }
    // Otherwise, compare the two
    for (var i = 0; i < previousFrames.length; i++) {
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename ||
            frameA.lineno !== frameB.lineno ||
            frameA.colno !== frameB.colno ||
            frameA.function !== frameB.function) {
            return false;
        }
    }
    return true;
}
/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) {
        return true;
    }
    // If only one event has a fingerprint, but not the other one, they are not the same
    if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
        return false;
    }
    currentFingerprint = currentFingerprint;
    previousFingerprint = previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    }
    catch (_oO) {
        return false;
    }
}
/** JSDoc */
function _getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */
function _getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) {
        try {
            // @ts-ignore Object could be undefined
            return exception.values[0].stacktrace.frames;
        }
        catch (_oO) {
            return undefined;
        }
    }
    else if (event.stacktrace) {
        return event.stacktrace.frames;
    }
    return undefined;
}
//# sourceMappingURL=dedupe.js.map

/***/ }),

/***/ 99441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ GlobalHandlers; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65949);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25976);
/* harmony import */ var _sentry_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13359);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71588);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83106);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42880);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43888);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70133);
/* harmony import */ var _eventbuilder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39949);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85524);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88621);

/* eslint-disable @typescript-eslint/no-unsafe-member-access */






/** Global handlers */
var GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */
        this._installFunc = {
            onerror: _installGlobalOnErrorHandler,
            onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
        };
        this._options = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for (var key in options) {
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());

/** JSDoc */
function _installGlobalOnErrorHandler() {
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .addInstrumentationHandler */ .o)('error', 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (data) {
        var _a = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__read */ .CR)(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration(GlobalHandlers)) {
            return;
        }
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if ((0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .shouldIgnoreOnError */ .Wz)() || (error && error.__sentry_own_request__)) {
            return;
        }
        var event = error === undefined && (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD)(msg)
            ? _eventFromIncompleteOnError(msg, url, line, column)
            : _enhanceEventWithInitialFrame((0,_eventbuilder__WEBPACK_IMPORTED_MODULE_4__/* .eventFromUnknownInput */ .ME)(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = _sentry_types__WEBPACK_IMPORTED_MODULE_5__/* .Severity.Error */ .z.Error;
        addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .addInstrumentationHandler */ .o)('unhandledrejection', 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (e) {
        var _a = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__read */ .CR)(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration(GlobalHandlers)) {
            return;
        }
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) {
                error = e.reason;
            }
            // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
            // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
            // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
            // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
            // https://github.com/getsentry/sentry-javascript/issues/2380
            else if ('detail' in e && 'reason' in e.detail) {
                error = e.detail.reason;
            }
        }
        catch (_oO) {
            // no-empty
        }
        if ((0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .shouldIgnoreOnError */ .Wz)() || (error && error.__sentry_own_request__)) {
            return true;
        }
        var event = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .isPrimitive */ .pt)(error)
            ? _eventFromRejectionWithPrimitive(error)
            : (0,_eventbuilder__WEBPACK_IMPORTED_MODULE_4__/* .eventFromUnknownInput */ .ME)(error, undefined, attachStacktrace, true);
        event.level = _sentry_types__WEBPACK_IMPORTED_MODULE_5__/* .Severity.Error */ .z.Error;
        addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason),
                },
            ],
        },
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .isErrorEvent */ .VW)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message,
                },
            ],
        },
    };
    return _enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = (event.exception = event.exception || {});
    // event.exception.values
    var ev = (e.values = e.values || []);
    // event.exception.values[0]
    var ev0 = (ev[0] = ev[0] || {});
    // event.exception.values[0].stacktrace
    var ev0s = (ev0.stacktrace = ev0.stacktrace || {});
    // event.exception.values[0].stacktrace.frames
    var ev0sf = (ev0s.frames = ev0s.frames || []);
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD)(url) && url.length > 0 ? url : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .getLocationHref */ .l)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) {
        ev0sf.push({
            colno: colno,
            filename: filename,
            function: '?',
            in_app: true,
            lineno: lineno,
        });
    }
    return event;
}
function globalHandlerLog(type) {
    _flags__WEBPACK_IMPORTED_MODULE_7__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .logger.log */ .kg.log("Global Handler attached: " + type);
}
function addMechanismAndCapture(hub, error, event, type) {
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .addExceptionMechanism */ .EG)(event, {
        handled: false,
        type: type,
    });
    hub.captureEvent(event, {
        originalException: error,
    });
}
function getHubAndAttachStacktrace() {
    var hub = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_10__/* .getCurrentHub */ .Gd)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [hub, attachStacktrace];
}
//# sourceMappingURL=globalhandlers.js.map

/***/ }),

/***/ 23016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iP": function() { return /* binding */ LinkedErrors; }
/* harmony export */ });
/* unused harmony exports _handler, _walkErrorTree */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65949);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14752);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25976);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83106);
/* harmony import */ var _eventbuilder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39949);




var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var LinkedErrors = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .addGlobalEventProcessor */ .c)(function (event, hint) {
            var self = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)().getIntegration(LinkedErrors);
            return self ? _handler(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}());

/**
 * @inheritDoc
 */
function _handler(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isInstanceOf */ .V9)(hint.originalException, Error)) {
        return event;
    }
    var linkedErrors = _walkErrorTree(limit, hint.originalException, key);
    event.exception.values = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__spread */ .fl)(linkedErrors, event.exception.values);
    return event;
}
/**
 * JSDOC
 */
function _walkErrorTree(limit, error, key, stack) {
    if (stack === void 0) { stack = []; }
    if (!(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isInstanceOf */ .V9)(error[key], Error) || stack.length + 1 >= limit) {
        return stack;
    }
    var exception = (0,_eventbuilder__WEBPACK_IMPORTED_MODULE_4__/* .exceptionFromError */ .GJ)(error[key]);
    return _walkErrorTree(limit, error[key], key, (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__spread */ .fl)([exception], stack));
}
//# sourceMappingURL=linkederrors.js.map

/***/ }),

/***/ 95234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ TryCatch; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65949);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66149);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96702);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42389);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88621);



var DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload',
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */
var TryCatch = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function TryCatch(options) {
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
        this._options = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        var global = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)();
        if (this._options.setTimeout) {
            (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(global, 'setTimeout', _wrapTimeFunction);
        }
        if (this._options.setInterval) {
            (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(global, 'setInterval', _wrapTimeFunction);
        }
        if (this._options.requestAnimationFrame) {
            (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(global, 'requestAnimationFrame', _wrapRAF);
        }
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
            (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
        }
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
            eventTarget.forEach(_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}());

/** JSDoc */
function _wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var originalCallback = args[0];
        args[0] = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .wrap */ .re)(originalCallback, {
            mechanism: {
                data: { function: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(original) },
                handled: true,
                type: 'instrument',
            },
        });
        return original.apply(this, args);
    };
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .wrap */ .re)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(original),
                    },
                    handled: true,
                    type: 'instrument',
                },
            }),
        ]);
    };
}
/** JSDoc */
function _wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
        xmlHttpRequestProps.forEach(function (prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(xhr, prop, function (original) {
                    var wrapOptions = {
                        mechanism: {
                            data: {
                                function: prop,
                                handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(original),
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    };
                    // If Instrument integration has been called before TryCatch, get the name of original function
                    var originalFunction = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .getOriginalFunction */ .HK)(original);
                    if (originalFunction) {
                        wrapOptions.mechanism.data.handler = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(originalFunction);
                    }
                    // Otherwise wrap directly
                    return (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .wrap */ .re)(original, wrapOptions);
                });
            }
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */
function _wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
        return;
    }
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(proto, 'addEventListener', function (original) {
        return function (eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') {
                    fn.handleEvent = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .wrap */ .re)(fn.handleEvent.bind(fn), {
                        mechanism: {
                            data: {
                                function: 'handleEvent',
                                handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(fn),
                                target: target,
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    });
                }
            }
            catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .wrap */ .re)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(fn),
                            target: target,
                        },
                        handled: true,
                        type: 'instrument',
                    },
                }),
                options,
            ]);
        };
    });
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(proto, 'removeEventListener', function (originalRemoveEventListener) {
        return function (eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */
            var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) {
                    originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            }
            catch (e) {
                // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}
//# sourceMappingURL=trycatch.js.map

/***/ }),

/***/ 28942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ UserAgent; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65949);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14752);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25976);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66149);



var global = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
/** UserAgent */
var UserAgent = /** @class */ (function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .addGlobalEventProcessor */ .c)(function (event) {
            if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentHub */ .Gd)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!global.navigator && !global.location && !global.document) {
                    return event;
                }
                // grab as much info as exists and add it to the event
                var url = (event.request && event.request.url) || (global.location && global.location.href);
                var referrer = (global.document || {}).referrer;
                var userAgent = (global.navigator || {}).userAgent;
                var headers = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, (event.request && event.request.headers)), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
                var request = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, (url && { url: url })), { headers: headers });
                return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, event), { request: request });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}());

//# sourceMappingURL=useragent.js.map

/***/ }),

/***/ 55652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yl": function() { return /* binding */ flush; },
  "S1": function() { return /* binding */ init; }
});

// UNUSED EXPORTS: close, defaultIntegrations, forceLoad, lastEventId, onLoad, showReportDialog, wrap

// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+hub@6.19.7/node_modules/@sentry/hub/esm/hub.js + 2 modules
var esm_hub = __webpack_require__(25976);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(43888);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+core@6.19.7/node_modules/@sentry/core/esm/flags.js
var flags = __webpack_require__(18015);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+core@6.19.7/node_modules/@sentry/core/esm/sdk.js



/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(clientClass, options) {
    if (options.debug === true) {
        if (flags/* IS_DEBUG_BUILD */.h) {
            esm_logger/* logger.enable */.kg.enable();
        }
        else {
            // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        }
    }
    var hub = (0,esm_hub/* getCurrentHub */.Gd)();
    var scope = hub.getScope();
    if (scope) {
        scope.update(options.initialScope);
    }
    var client = new clientClass(options);
    hub.bindClient(client);
}
//# sourceMappingURL=sdk.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+core@6.19.7/node_modules/@sentry/core/esm/integrations/inboundfilters.js
var inboundfilters = __webpack_require__(99946);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+core@6.19.7/node_modules/@sentry/core/esm/integrations/functiontostring.js
var functiontostring = __webpack_require__(70156);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/global.js
var global = __webpack_require__(66149);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(1774);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(71588);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@1.14.1/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(65949);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+core@6.19.7/node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(89324);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+hub@6.19.7/node_modules/@sentry/hub/esm/scope.js
var esm_scope = __webpack_require__(14752);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/dsn.js
var dsn = __webpack_require__(13897);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(70133);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(83106);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(29939);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/normalize.js + 1 modules
var normalize = __webpack_require__(74526);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(80973);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/error.js + 1 modules
var error = __webpack_require__(11683);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(96702);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+core@6.19.7/node_modules/@sentry/core/esm/integration.js




var installedIntegrations = [];
/**
 * @private
 */
function filterDuplicates(integrations) {
    return integrations.reduce(function (acc, integrations) {
        if (acc.every(function (accIntegration) { return integrations.name !== accIntegration.name; })) {
            acc.push(integrations);
        }
        return acc;
    }, []);
}
/** Gets integration to install */
function getIntegrationsToSetup(options) {
    var defaultIntegrations = (options.defaultIntegrations && (0,tslib_es6/* __spread */.fl)(options.defaultIntegrations)) || [];
    var userIntegrations = options.integrations;
    var integrations = (0,tslib_es6/* __spread */.fl)(filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) {
        // Filter out integrations that are also included in user options
        integrations = (0,tslib_es6/* __spread */.fl)(integrations.filter(function (integrations) {
            return userIntegrations.every(function (userIntegration) { return userIntegration.name !== integrations.name; });
        }), filterDuplicates(userIntegrations));
    }
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [integrations];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function (i) { return i.name; });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
        integrations.push.apply(integrations, (0,tslib_es6/* __spread */.fl)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    }
    return integrations;
}
/** Setup given integration */
function setupIntegration(integration) {
    if (installedIntegrations.indexOf(integration.name) !== -1) {
        return;
    }
    integration.setupOnce(esm_scope/* addGlobalEventProcessor */.c, esm_hub/* getCurrentHub */.Gd);
    installedIntegrations.push(integration.name);
    flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log("Integration installed: " + integration.name);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(options) {
    var integrations = {};
    getIntegrationsToSetup(options).forEach(function (integration) {
        integrations[integration.name] = integration;
        setupIntegration(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0,object/* addNonEnumerableProperty */.xp)(integrations, 'initialized', true);
    return integrations;
}
//# sourceMappingURL=integration.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+core@6.19.7/node_modules/@sentry/core/esm/baseclient.js

/* eslint-disable max-lines */




var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */
var BaseClient = /** @class */ (function () {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */
    function BaseClient(backendClass, options) {
        /** Array of used integrations. */
        this._integrations = {};
        /** Number of calls being processed */
        this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) {
            this._dsn = (0,dsn/* makeDsn */.v)(options.dsn);
        }
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function (exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
            flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend()
            .eventFromException(exception, hint)
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0,is/* isPrimitive */.pt)(message)
            ? this._getBackend().eventFromMessage(String(message), level, hint)
            : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureEvent = function (event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
            flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureSession = function (session) {
        if (!this._isEnabled()) {
            flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.warn */.kg.warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) {
            flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.warn */.kg.warn('Discarded session because of missing or non-string release');
        }
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({ init: false });
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getDsn = function () {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getOptions = function () {
        return this._options;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getTransport = function () {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.flush = function (timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function (clientFinished) {
            return _this.getTransport()
                .close(timeout)
                .then(function (transportFlushed) { return clientFinished && transportFlushed; });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.close = function (timeout) {
        var _this = this;
        return this.flush(timeout).then(function (result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */
    BaseClient.prototype.setupIntegrations = function () {
        if (this._isEnabled() && !this._integrations.initialized) {
            this._integrations = setupIntegrations(this._options);
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegration = function (integration) {
        try {
            return this._integrations[integration.id] || null;
        }
        catch (_oO) {
            flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.warn */.kg.warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */
    BaseClient.prototype._updateSessionFromEvent = function (session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for (var exceptions_1 = (0,tslib_es6/* __values */.XA)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()) {
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);
        if (shouldUpdateAndSend) {
            session.update((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (crashed && { status: 'crashed' })), { errors: session.errors || Number(errored || crashed) }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */
    BaseClient.prototype._sendSession = function (session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */
    BaseClient.prototype._isClientDoneProcessing = function (timeout) {
        var _this = this;
        return new syncpromise/* SyncPromise */.cW(function (resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function () {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                }
                else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */
    BaseClient.prototype._getBackend = function () {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */
    BaseClient.prototype._isEnabled = function () {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */
    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event), { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)()), timestamp: event.timestamp || (0,time/* dateTimestampInSeconds */.yW)() });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) {
            finalScope = esm_scope/* Scope.clone */.s.clone(finalScope).update(hint.captureContext);
        }
        // We prepare the result here with a resolved Event.
        var result = (0,syncpromise/* resolvedSyncPromise */.WD)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) {
            // In case we have a hub we reassign it.
            result = finalScope.applyToEvent(prepared, hint);
        }
        return result.then(function (evt) {
            if (evt) {
                // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
                // it is only attached as extra data to the event if the event somehow skips being normalized
                evt.sdkProcessingMetadata = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, evt.sdkProcessingMetadata), { normalizeDepth: (0,normalize/* normalize */.Fv)(normalizeDepth) + " (" + typeof normalizeDepth + ")" });
            }
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
                return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            }
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */
    BaseClient.prototype._normalizeEvent = function (event, depth, maxBreadth) {
        if (!event) {
            return null;
        }
        var normalized = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event), (event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function (b) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, b), (b.data && {
                data: (0,normalize/* normalize */.Fv)(b.data, depth, maxBreadth),
            }))); }),
        })), (event.user && {
            user: (0,normalize/* normalize */.Fv)(event.user, depth, maxBreadth),
        })), (event.contexts && {
            contexts: (0,normalize/* normalize */.Fv)(event.contexts, depth, maxBreadth),
        })), (event.extra && {
            extra: (0,normalize/* normalize */.Fv)(event.extra, depth, maxBreadth),
        }));
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            normalized.contexts.trace = event.contexts.trace;
        }
        normalized.sdkProcessingMetadata = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, normalized.sdkProcessingMetadata), { baseClientNormalized: true });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */
    BaseClient.prototype._applyClientOptions = function (event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) {
            event.environment = 'environment' in options ? environment : 'production';
        }
        if (event.release === undefined && release !== undefined) {
            event.release = release;
        }
        if (event.dist === undefined && dist !== undefined) {
            event.dist = dist;
        }
        if (event.message) {
            event.message = (0,string/* truncate */.$G)(event.message, maxValueLength);
        }
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) {
            exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
        }
        var request = event.request;
        if (request && request.url) {
            request.url = (0,string/* truncate */.$G)(request.url, maxValueLength);
        }
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */
    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0,tslib_es6/* __spread */.fl)((event.sdk.integrations || []), integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */
    BaseClient.prototype._sendEvent = function (event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */
    BaseClient.prototype._captureEvent = function (event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function (finalEvent) {
            return finalEvent.event_id;
        }, function (reason) {
            flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.error */.kg.error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */
    BaseClient.prototype._processEvent = function (event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) {
                transport.recordLostEvent(outcome, category);
            }
        }
        if (!this._isEnabled()) {
            return (0,syncpromise/* rejectedSyncPromise */.$2)(new error/* SentryError */.b('SDK not enabled, will not capture event.'));
        }
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0,syncpromise/* rejectedSyncPromise */.$2)(new error/* SentryError */.b("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint)
            .then(function (prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new error/* SentryError */.b('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) {
                return prepared;
            }
            var beforeSendResult = beforeSend(prepared, hint);
            return _ensureBeforeSendRv(beforeSendResult);
        })
            .then(function (processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new error/* SentryError */.b('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) {
                _this._updateSessionFromEvent(session, processedEvent);
            }
            _this._sendEvent(processedEvent);
            return processedEvent;
        })
            .then(null, function (reason) {
            if (reason instanceof error/* SentryError */.b) {
                throw reason;
            }
            _this.captureException(reason, {
                data: {
                    __sentry__: true,
                },
                originalException: reason,
            });
            throw new error/* SentryError */.b("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */
    BaseClient.prototype._process = function (promise) {
        var _this = this;
        this._numProcessing += 1;
        void promise.then(function (value) {
            _this._numProcessing -= 1;
            return value;
        }, function (reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}());

/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */
function _ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0,is/* isThenable */.J8)(rv)) {
        return rv.then(function (event) {
            if (!((0,is/* isPlainObject */.PO)(event) || event === null)) {
                throw new error/* SentryError */.b(nullErr);
            }
            return event;
        }, function (e) {
            throw new error/* SentryError */.b("beforeSend rejected with " + e);
        });
    }
    else if (!((0,is/* isPlainObject */.PO)(rv) || rv === null)) {
        throw new error/* SentryError */.b(nullErr);
    }
    return rv;
}
//# sourceMappingURL=baseclient.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+core@6.19.7/node_modules/@sentry/core/esm/api.js
var esm_api = __webpack_require__(88961);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/envelope.js


/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items) {
    if (items === void 0) { items = []; }
    return [headers, items];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
    var _a = __read(envelope, 2), headers = _a[0], items = _a[1];
    return [headers, __spread(items, [newItem])];
}
/**
 * Get the type of the envelope. Grabs the type from the first envelope item.
 */
function getEnvelopeType(envelope) {
    var _a = (0,tslib_es6/* __read */.CR)(envelope, 2), _b = (0,tslib_es6/* __read */.CR)(_a[1], 1), _c = (0,tslib_es6/* __read */.CR)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
/**
 * Serializes an envelope into a string.
 */
function serializeEnvelope(envelope) {
    var _a = (0,tslib_es6/* __read */.CR)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function (acc, item) {
        var _a = (0,tslib_es6/* __read */.CR)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0,is/* isPrimitive */.pt)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}
//# sourceMappingURL=envelope.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+core@6.19.7/node_modules/@sentry/core/esm/request.js



/** Extract sdk info from from the API metadata */
function getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) {
        return;
    }
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return { name: name, version: version };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) {
        return event;
    }
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0,tslib_es6/* __spread */.fl)((event.sdk.integrations || []), (sdkInfo.integrations || []));
    event.sdk.packages = (0,tslib_es6/* __spread */.fl)((event.sdk.packages || []), (sdkInfo.packages || []));
    return event;
}
/** Creates an envelope from a Session */
function createSessionEnvelope(session, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: (0,dsn/* dsnToString */.R)(api.dsn) }));
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [{ type: type }, session];
    var envelope = createEnvelope(envelopeHeaders, [envelopeItem]);
    return [envelope, type];
}
/** Creates a SentryRequest from a Session. */
function sessionToSentryRequest(session, api) {
    var _a = (0,tslib_es6/* __read */.CR)(createSessionEnvelope(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: serializeEnvelope(envelope),
        type: type,
        url: (0,esm_api/* getEnvelopeEndpointWithUrlEncodedAuth */.Ut)(api.dsn, api.tunnel),
    };
}
/**
 * Create an Envelope from an event. Note that this is duplicated from below,
 * but on purpose as this will be refactored in v7.
 */
function createEventEnvelope(event, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ event_id: event.event_id, sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: (0,dsn/* dsnToString */.R)(api.dsn) }));
    var eventItem = [
        {
            type: eventType,
            sample_rates: [{ id: samplingMethod, rate: sampleRate }],
        },
        event,
    ];
    return createEnvelope(envelopeHeaders, [eventItem]);
}
/** Creates a SentryRequest from an event. */
function eventToSentryRequest(event, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    }
    catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0,normalize/* normalize */.Fv)(event));
        }
        catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: { message: innerErr.message, stack: innerErr.stack },
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope
            ? (0,esm_api/* getEnvelopeEndpointWithUrlEncodedAuth */.Ut)(api.dsn, api.tunnel)
            : (0,esm_api/* getStoreEndpointWithUrlEncodedAuth */.qi)(api.dsn),
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ event_id: event.event_id, sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: (0,dsn/* dsnToString */.R)(api.dsn) }));
        var eventItem = [
            {
                type: eventType,
                sample_rates: [{ id: samplingMethod, rate: sampleRate }],
            },
            req.body,
        ];
        var envelope = createEnvelope(envelopeHeaders, [eventItem]);
        req.body = serializeEnvelope(envelope);
    }
    return req;
}
//# sourceMappingURL=request.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+core@6.19.7/node_modules/@sentry/core/esm/transports/noop.js

/** Noop transport */
var NoopTransport = /** @class */ (function () {
    function NoopTransport() {
    }
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.sendEvent = function (_) {
        return (0,syncpromise/* resolvedSyncPromise */.WD)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped',
        });
    };
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.close = function (_) {
        return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    };
    return NoopTransport;
}());

//# sourceMappingURL=noop.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+core@6.19.7/node_modules/@sentry/core/esm/basebackend.js






/**
 * This is the base implemention of a Backend.
 * @hidden
 */
var BaseBackend = /** @class */ (function () {
    /** Creates a new backend instance. */
    function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) {
            flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.warn */.kg.warn('No DSN provided, backend will not do anything.');
        }
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
        throw new error/* SentryError */.b('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
        throw new error/* SentryError */.b('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendEvent = function (event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport &&
            this._options.dsn &&
            this._options._experiments &&
            this._options._experiments.newTransport) {
            var api = (0,esm_api/* initAPIDetails */.hd)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = createEventEnvelope(event, api);
            void this._newTransport.send(env).then(null, function (reason) {
                flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.error */.kg.error('Error while sending event:', reason);
            });
        }
        else {
            void this._transport.sendEvent(event).then(null, function (reason) {
                flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.error */.kg.error('Error while sending event:', reason);
            });
        }
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendSession = function (session) {
        if (!this._transport.sendSession) {
            flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.warn */.kg.warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport &&
            this._options.dsn &&
            this._options._experiments &&
            this._options._experiments.newTransport) {
            var api = (0,esm_api/* initAPIDetails */.hd)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0,tslib_es6/* __read */.CR)(createSessionEnvelope(session, api), 1), env = _a[0];
            void this._newTransport.send(env).then(null, function (reason) {
                flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.error */.kg.error('Error while sending session:', reason);
            });
        }
        else {
            void this._transport.sendSession(session).then(null, function (reason) {
                flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.error */.kg.error('Error while sending session:', reason);
            });
        }
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.getTransport = function () {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */
    BaseBackend.prototype._setupTransport = function () {
        return new NoopTransport();
    };
    return BaseBackend;
}());

//# sourceMappingURL=basebackend.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+types@6.19.7/node_modules/@sentry/types/esm/severity.js
var severity = __webpack_require__(13359);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(47961);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/eventbuilder.js + 1 modules
var eventbuilder = __webpack_require__(39949);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/promisebuffer.js


/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */
    function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */
    function add(taskProducer) {
        if (!isReady()) {
            return (0,syncpromise/* rejectedSyncPromise */.$2)(new error/* SentryError */.b('Not adding Promise due to buffer limit reached.'));
        }
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) {
            buffer.push(task);
        }
        void task
            .then(function () { return remove(task); })
            // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
            // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
            // have promises, so TS has to polyfill when down-compiling.)
            .then(null, function () {
            return remove(task).then(null, function () {
                // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */
    function drain(timeout) {
        return new syncpromise/* SyncPromise */.cW(function (resolve, reject) {
            var counter = buffer.length;
            if (!counter) {
                return resolve(true);
            }
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function () {
                if (timeout && timeout > 0) {
                    resolve(false);
                }
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function (item) {
                void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(function () {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain,
    };
}
//# sourceMappingURL=promisebuffer.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/ratelimit.js

var DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now) {
    if (now === void 0) { now = Date.now(); }
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) {
        return headerDelay * 1000;
    }
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) {
        return headerDate - now;
    }
    return DEFAULT_RETRY_AFTER;
}
/**
 * Gets the time that given category is disabled until for rate limiting
 */
function disabledUntil(limits, category) {
    return limits[category] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, category, now) {
    if (now === void 0) { now = Date.now(); }
    return disabledUntil(limits, category) > now;
}
/**
 * Update ratelimits from incoming headers.
 * Returns true if headers contains a non-empty rate limiting header.
 */
function updateRateLimits(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) { now = Date.now(); }
    var updatedRateLimits = (0,tslib_es6/* __assign */.pi)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) {
        try {
            /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */
            for (var _c = (0,tslib_es6/* __values */.XA)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()) {
                var limit = _d.value;
                var parameters = limit.split(':', 2);
                var headerDelay = parseInt(parameters[0], 10);
                var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
                if (!parameters[1]) {
                    updatedRateLimits.all = now + delay;
                }
                else {
                    try {
                        for (var _e = (e_2 = void 0, (0,tslib_es6/* __values */.XA)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var category = _f.value;
                            updatedRateLimits[category] = now + delay;
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    else if (retryAfterHeader) {
        updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
    }
    return updatedRateLimits;
}
//# sourceMappingURL=ratelimit.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/status.js
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */
function eventStatusFromHttpCode(code) {
    if (code >= 200 && code < 300) {
        return 'success';
    }
    if (code === 429) {
        return 'rate_limit';
    }
    if (code >= 400 && code < 500) {
        return 'invalid';
    }
    if (code >= 500) {
        return 'failed';
    }
    return 'unknown';
}
//# sourceMappingURL=status.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+core@6.19.7/node_modules/@sentry/core/esm/transports/base.js

var ERROR_TRANSPORT_CATEGORY = 'error';
var TRANSACTION_TRANSPORT_CATEGORY = 'transaction';
var ATTACHMENT_TRANSPORT_CATEGORY = 'attachment';
var SESSION_TRANSPORT_CATEGORY = 'session';
var DEFAULT_TRANSPORT_BUFFER_SIZE = 30;
/**
 * Creates a `NewTransport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(options, makeRequest, buffer) {
    if (buffer === void 0) { buffer = makePromiseBuffer(options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE); }
    var rateLimits = {};
    var flush = function (timeout) { return buffer.drain(timeout); };
    function send(envelope) {
        var envCategory = getEnvelopeType(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: serializeEnvelope(envelope),
        };
        // Don't add to buffer if transport is already rate-limited
        if (isRateLimited(rateLimits, category)) {
            return (0,syncpromise/* rejectedSyncPromise */.$2)({
                status: 'rate_limit',
                reason: getRateLimitReason(rateLimits, category),
            });
        }
        var requestTask = function () {
            return makeRequest(request).then(function (_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = eventStatusFromHttpCode(statusCode);
                if (headers) {
                    rateLimits = updateRateLimits(rateLimits, headers);
                }
                if (status === 'success') {
                    return (0,syncpromise/* resolvedSyncPromise */.WD)({ status: status, reason: reason });
                }
                return (0,syncpromise/* rejectedSyncPromise */.$2)({
                    status: status,
                    reason: reason ||
                        body ||
                        (status === 'rate_limit' ? getRateLimitReason(rateLimits, category) : 'Unknown transport error'),
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush,
    };
}
function getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date(disabledUntil(rateLimits, category)).toISOString();
}
//# sourceMappingURL=base.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/async.js
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function forget(promise) {
    void promise.then(null, function (e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}
//# sourceMappingURL=async.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/flags.js
var esm_flags = __webpack_require__(85524);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/transports/utils.js


var utils_global = (0,global/* getGlobalObject */.R)();
var cachedFetchImpl;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
    if (cachedFetchImpl) {
        return cachedFetchImpl;
    }
    /* eslint-disable @typescript-eslint/unbound-method */
    // Fast path to avoid DOM I/O
    if ((0,supports/* isNativeFetch */.Du)(utils_global.fetch)) {
        return (cachedFetchImpl = utils_global.fetch.bind(utils_global));
    }
    var document = utils_global.document;
    var fetchImpl = utils_global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') {
        try {
            var sandbox = document.createElement('iframe');
            sandbox.hidden = true;
            document.head.appendChild(sandbox);
            var contentWindow = sandbox.contentWindow;
            if (contentWindow && contentWindow.fetch) {
                fetchImpl = contentWindow.fetch;
            }
            document.head.removeChild(sandbox);
        }
        catch (e) {
            esm_flags/* IS_DEBUG_BUILD */.h &&
                esm_logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
        }
    }
    return (cachedFetchImpl = fetchImpl.bind(utils_global));
    /* eslint-enable @typescript-eslint/unbound-method */
}
/**
 * Sends sdk client report using sendBeacon or fetch as a fallback if available
 *
 * @param url report endpoint
 * @param body report payload
 */
function sendReport(url, body) {
    var isRealNavigator = Object.prototype.toString.call(utils_global && utils_global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof utils_global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = utils_global.navigator.sendBeacon.bind(utils_global.navigator);
        return sendBeacon(url, body);
    }
    if ((0,supports/* supportsFetch */.Ak)()) {
        var fetch_1 = getNativeFetchImplementation();
        return forget(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true,
        }));
    }
}
//# sourceMappingURL=utils.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/transports/new-fetch.js



/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeNewFetchTransport(options, nativeFetch) {
    if (nativeFetch === void 0) { nativeFetch = getNativeFetchImplementation(); }
    function makeRequest(request) {
        var requestOptions = (0,tslib_es6/* __assign */.pi)({ body: request.body, method: 'POST', referrerPolicy: 'origin' }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function (response) {
            return response.text().then(function (body) { return ({
                body: body,
                headers: {
                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                    'retry-after': response.headers.get('Retry-After'),
                },
                reason: response.statusText,
                statusCode: response.status,
            }); });
        });
    }
    return createTransport({ bufferSize: options.bufferSize }, makeRequest);
}
//# sourceMappingURL=new-fetch.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/clientreport.js


/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        { type: 'client_report' },
        {
            timestamp: timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
            discarded_events: discarded_events,
        },
    ];
    return createEnvelope(dsn ? { dsn: dsn } : {}, [clientReportItem]);
}
//# sourceMappingURL=clientreport.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/transports/base.js





function requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var base_global = (0,global/* getGlobalObject */.R)();
/** Base Transport class implementation */
var BaseTransport = /** @class */ (function () {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */
        this._buffer = makePromiseBuffer(30);
        /** Locks transport after receiving rate limits in a response */
        this._rateLimits = {};
        this._outcomes = {};
        this._api = (0,esm_api/* initAPIDetails */.hd)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0,esm_api/* getStoreEndpointWithUrlEncodedAuth */.qi)(this._api.dsn);
        if (this.options.sendClientReports && base_global.document) {
            base_global.document.addEventListener('visibilitychange', function () {
                if (base_global.document.visibilityState === 'hidden') {
                    _this._flushOutcomes();
                }
            });
        }
    }
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendEvent = function (event) {
        return this._sendRequest(eventToSentryRequest(event, this._api), event);
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendSession = function (session) {
        return this._sendRequest(sessionToSentryRequest(session, this._api), session);
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.close = function (timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.recordLostEvent = function (reason, category) {
        var _a;
        if (!this.options.sendClientReports) {
            return;
        }
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = requestTypeToCategory(category) + ":" + reason;
        esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], (_a !== null && _a !== void 0 ? _a : 0)) + 1;
    };
    /**
     * Send outcomes as an envelope
     */
    BaseTransport.prototype._flushOutcomes = function () {
        if (!this.options.sendClientReports) {
            return;
        }
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log('No outcomes to flush');
            return;
        }
        esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0,esm_api/* getEnvelopeEndpointWithUrlEncodedAuth */.Ut)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function (key) {
            var _a = (0,tslib_es6/* __read */.CR)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key],
            };
            // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = createClientReportEnvelope(discardedEvents, this._api.tunnel && (0,dsn/* dsnToString */.R)(this._api.dsn));
        try {
            sendReport(url, serializeEnvelope(envelope));
        }
        catch (e) {
            esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.error */.kg.error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */
    BaseTransport.prototype._handleResponse = function (_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = eventStatusFromHttpCode(response.status);
        this._rateLimits = updateRateLimits(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) {
            esm_flags/* IS_DEBUG_BUILD */.h &&
                // eslint-disable-next-line deprecation/deprecation
                esm_logger/* logger.warn */.kg.warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        }
        if (status === 'success') {
            resolve({ status: status });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */
    BaseTransport.prototype._disabledUntil = function (requestType) {
        var category = requestTypeToCategory(requestType);
        return new Date(disabledUntil(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */
    BaseTransport.prototype._isRateLimited = function (requestType) {
        var category = requestTypeToCategory(requestType);
        return isRateLimited(this._rateLimits, category);
    };
    return BaseTransport;
}());

//# sourceMappingURL=base.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/transports/fetch.js




/** `fetch` based transport */
var FetchTransport = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) { fetchImpl = getNativeFetchImplementation(); }
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    FetchTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: ((0,supports/* supportsReferrerPolicy */.hv)() ? 'origin' : ''),
        };
        if (this.options.fetchParameters !== undefined) {
            Object.assign(options, this.options.fetchParameters);
        }
        if (this.options.headers !== undefined) {
            options.headers = this.options.headers;
        }
        return this._buffer
            .add(function () {
            return new syncpromise/* SyncPromise */.cW(function (resolve, reject) {
                void _this._fetch(sentryRequest.url, options)
                    .then(function (response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After'),
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject,
                    });
                })
                    .catch(reject);
            });
        })
            .then(undefined, function (reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof error/* SentryError */.b) {
                _this.recordLostEvent('queue_overflow', sentryRequest.type);
            }
            else {
                _this.recordLostEvent('network_error', sentryRequest.type);
            }
            throw reason;
        });
    };
    return FetchTransport;
}(BaseTransport));

//# sourceMappingURL=fetch.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/transports/new-xhr.js


/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
var XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeNewXHRTransport(options) {
    function makeRequest(request) {
        return new syncpromise/* SyncPromise */.cW(function (resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (xhr.readyState === XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After'),
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status,
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for (var header in options.headers) {
                if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
                    xhr.setRequestHeader(header, options.headers[header]);
                }
            }
            xhr.send(request.body);
        });
    }
    return createTransport({ bufferSize: options.bufferSize }, makeRequest);
}
//# sourceMappingURL=new-xhr.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/transports/xhr.js



/** `XHR` based transport */
var XHRTransport = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    XHRTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        return this._buffer
            .add(function () {
            return new syncpromise/* SyncPromise */.cW(function (resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function () {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After'),
                        };
                        _this._handleResponse({ requestType: sentryRequest.type, response: request, headers: headers, resolve: resolve, reject: reject });
                    }
                };
                request.open('POST', sentryRequest.url);
                for (var header in _this.options.headers) {
                    if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) {
                        request.setRequestHeader(header, _this.options.headers[header]);
                    }
                }
                request.send(sentryRequest.body);
            });
        })
            .then(undefined, function (reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof error/* SentryError */.b) {
                _this.recordLostEvent('queue_overflow', sentryRequest.type);
            }
            else {
                _this.recordLostEvent('network_error', sentryRequest.type);
            }
            throw reason;
        });
    };
    return XHRTransport;
}(BaseTransport));

//# sourceMappingURL=xhr.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/backend.js






/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */
var BrowserBackend = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromException = function (exception, hint) {
        return (0,eventbuilder/* eventFromException */.dr)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
        if (level === void 0) { level = severity/* Severity.Info */.z.Info; }
        return (0,eventbuilder/* eventFromMessage */.aB)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype._setupTransport = function () {
        if (!this._options.dsn) {
            // We return the noop transport here in case there is no Dsn.
            return _super.prototype._setupTransport.call(this);
        }
        var transportOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._options.transportOptions), { dsn: this._options.dsn, tunnel: this._options.tunnel, sendClientReports: this._options.sendClientReports, _metadata: this._options._metadata });
        var api = (0,esm_api/* initAPIDetails */.hd)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0,esm_api/* getEnvelopeEndpointWithUrlEncodedAuth */.Ut)(api.dsn, api.tunnel);
        if (this._options.transport) {
            return new this._options.transport(transportOptions);
        }
        if ((0,supports/* supportsFetch */.Ak)()) {
            var requestOptions = (0,tslib_es6/* __assign */.pi)({}, transportOptions.fetchParameters);
            this._newTransport = makeNewFetchTransport({ requestOptions: requestOptions, url: url });
            return new FetchTransport(transportOptions);
        }
        this._newTransport = makeNewXHRTransport({
            url: url,
            headers: transportOptions.headers,
        });
        return new XHRTransport(transportOptions);
    };
    return BrowserBackend;
}(BaseBackend));

//# sourceMappingURL=backend.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(88621);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/integrations/breadcrumbs.js + 2 modules
var breadcrumbs = __webpack_require__(69195);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/client.js







/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var BrowserClient = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */
    function BrowserClient(options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: version/* SDK_VERSION */.J,
                },
            ],
            version: version/* SDK_VERSION */.J,
        };
        _this = _super.call(this, BrowserBackend, options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */
    BrowserClient.prototype.showReportDialog = function (options) {
        if (options === void 0) { options = {}; }
        // doesn't work without a document (React Native)
        var document = (0,global/* getGlobalObject */.R)().document;
        if (!document) {
            return;
        }
        if (!this._isEnabled()) {
            esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.error */.kg.error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0,helpers/* injectReportDialog */.BS)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { dsn: options.dsn || this.getDsn() }));
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._sendEvent = function (event) {
        var integration = this.getIntegration(breadcrumbs/* Breadcrumbs */.O);
        if (integration) {
            integration.addSentryBreadcrumb(event);
        }
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}(BaseClient));

//# sourceMappingURL=client.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/integrations/trycatch.js
var trycatch = __webpack_require__(95234);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/integrations/globalhandlers.js
var globalhandlers = __webpack_require__(99441);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/integrations/linkederrors.js
var linkederrors = __webpack_require__(23016);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/integrations/dedupe.js
var dedupe = __webpack_require__(22277);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/integrations/useragent.js
var useragent = __webpack_require__(28942);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/sdk.js







var defaultIntegrations = [
    new inboundfilters/* InboundFilters */.QD(),
    new functiontostring/* FunctionToString */.c(),
    new trycatch/* TryCatch */.p(),
    new breadcrumbs/* Breadcrumbs */.O(),
    new globalhandlers/* GlobalHandlers */.d(),
    new linkederrors/* LinkedErrors */.iP(),
    new dedupe/* Dedupe */.I(),
    new useragent/* UserAgent */.Z(),
];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options) {
    if (options === void 0) { options = {}; }
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = defaultIntegrations;
    }
    if (options.release === undefined) {
        var window_1 = (0,global/* getGlobalObject */.R)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
            options.release = window_1.SENTRY_RELEASE.id;
        }
    }
    if (options.autoSessionTracking === undefined) {
        options.autoSessionTracking = true;
    }
    if (options.sendClientReports === undefined) {
        options.sendClientReports = true;
    }
    initAndBind(BrowserClient, options);
    if (options.autoSessionTracking) {
        startSessionTracking();
    }
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options) {
    if (options === void 0) { options = {}; }
    var hub = getCurrentHub();
    var scope = hub.getScope();
    if (scope) {
        options.user = __assign(__assign({}, scope.getUser()), options.user);
    }
    if (!options.eventId) {
        options.eventId = hub.lastEventId();
    }
    var client = hub.getClient();
    if (client) {
        client.showReportDialog(options);
    }
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
    return getCurrentHub().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
    // Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
    callback();
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function flush(timeout) {
    var client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
    if (client) {
        return client.flush(timeout);
    }
    esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.warn */.kg.warn('Cannot flush events. No client defined.');
    return (0,syncpromise/* resolvedSyncPromise */.WD)(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function sdk_close(timeout) {
    var client = getCurrentHub().getClient();
    if (client) {
        return client.close(timeout);
    }
    IS_DEBUG_BUILD && logger.warn('Cannot flush events and disable SDK. No client defined.');
    return resolvedSyncPromise(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrap(fn) {
    return internalWrap(fn)();
}
function startSessionOnHub(hub) {
    hub.startSession({ ignoreDuration: true });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
    var window = (0,global/* getGlobalObject */.R)();
    var document = window.document;
    if (typeof document === 'undefined') {
        esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.warn */.kg.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = (0,esm_hub/* getCurrentHub */.Gd)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) {
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0,instrument/* addInstrumentationHandler */.o)('history', function (_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) {
            startSessionOnHub((0,esm_hub/* getCurrentHub */.Gd)());
        }
    });
}
//# sourceMappingURL=sdk.js.map

/***/ }),

/***/ 88961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hd": function() { return /* binding */ initAPIDetails; },
/* harmony export */   "qi": function() { return /* binding */ getStoreEndpointWithUrlEncodedAuth; },
/* harmony export */   "Ut": function() { return /* binding */ getEnvelopeEndpointWithUrlEncodedAuth; },
/* harmony export */   "hR": function() { return /* binding */ getReportDialogEndpoint; }
/* harmony export */ });
/* unused harmony exports API, getRequestHeaders */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13897);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96702);

var SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/
var API = /** @class */ (function () {
    /** Create a new instance of API */
    function API(dsn, metadata, tunnel) {
        if (metadata === void 0) { metadata = {}; }
        this.dsn = dsn;
        this._dsnObject = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .makeDsn */ .v)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */
    API.prototype.getDsn = function () {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */
    API.prototype.forceEnvelope = function () {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */
    API.prototype.getBaseApiEndpoint = function () {
        return getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */
    API.prototype.getStoreEndpoint = function () {
        return getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
        return getStoreEndpointWithUrlEncodedAuth(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function () {
        return getEnvelopeEndpointWithUrlEncodedAuth(this._dsnObject, this._tunnel);
    };
    return API;
}());

/** Initializes API Details */
function initAPIDetails(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .makeDsn */ .v)(dsn),
        tunnel: tunnel,
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn, target) {
    return "" + getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn) {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .urlEncode */ ._j)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: SENTRY_API_VERSION,
    });
}
/** Returns the store endpoint URL. */
function getStoreEndpoint(dsn) {
    return _getIngestEndpoint(dsn, 'store');
}
/**
 * Returns the store endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getStoreEndpointWithUrlEncodedAuth(dsn) {
    return getStoreEndpoint(dsn) + "?" + _encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */
function _getEnvelopeEndpoint(dsn) {
    return _getIngestEndpoint(dsn, 'envelope');
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel) {
    return tunnel ? tunnel : _getEnvelopeEndpoint(dsn) + "?" + _encodedAuth(dsn);
}
/**
 * Returns an object that can be used in request headers.
 * This is needed for node and the old /store endpoint in sentry
 */
function getRequestHeaders(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) {
        header.push("sentry_secret=" + dsn.pass);
    }
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', '),
    };
}
/** Returns the url to the report dialog endpoint. */
function getReportDialogEndpoint(dsnLike, dialogOptions) {
    var dsn = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .makeDsn */ .v)(dsnLike);
    var endpoint = getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dsnToString */ .R)(dsn);
    for (var key in dialogOptions) {
        if (key === 'dsn') {
            continue;
        }
        if (key === 'user') {
            if (!dialogOptions.user) {
                continue;
            }
            if (dialogOptions.user.name) {
                encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            }
            if (dialogOptions.user.email) {
                encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
            }
        }
        else {
            encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
        }
    }
    return endpoint + "?" + encodedOptions;
}
//# sourceMappingURL=api.js.map

/***/ }),

/***/ 18015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ IS_DEBUG_BUILD; }
/* harmony export */ });
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
//# sourceMappingURL=flags.js.map

/***/ }),

/***/ 70156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ FunctionToString; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96702);

var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */ (function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getOriginalFunction */ .HK)(this) || this;
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}());

//# sourceMappingURL=functiontostring.js.map

/***/ }),

/***/ 99946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QD": function() { return /* binding */ InboundFilters; }
/* harmony export */ });
/* unused harmony exports _mergeOptions, _shouldDropEvent */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65949);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43888);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70133);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80973);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18015);



// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */ (function () {
    function InboundFilters(_options) {
        if (_options === void 0) { _options = {}; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = _mergeOptions(self_1._options, clientOptions);
                    return _shouldDropEvent(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}());

/** JSDoc */
function _mergeOptions(internalOptions, clientOptions) {
    if (internalOptions === void 0) { internalOptions = {}; }
    if (clientOptions === void 0) { clientOptions = {}; }
    return {
        allowUrls: (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)((internalOptions.whitelistUrls || []), (internalOptions.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
        denyUrls: (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)((internalOptions.blacklistUrls || []), (internalOptions.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
        ignoreErrors: (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)((internalOptions.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
    };
}
/** JSDoc */
function _shouldDropEvent(event, options) {
    if (options.ignoreInternal && _isSentryError(event)) {
        _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEventDescription */ .jH)(event));
        return true;
    }
    if (_isIgnoredError(event, options.ignoreErrors)) {
        _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEventDescription */ .jH)(event));
        return true;
    }
    if (_isDeniedUrl(event, options.denyUrls)) {
        _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEventDescription */ .jH)(event) + ".\nUrl: " + _getEventFilterUrl(event));
        return true;
    }
    if (!_isAllowedUrl(event, options.allowUrls)) {
        _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEventDescription */ .jH)(event) + ".\nUrl: " + _getEventFilterUrl(event));
        return true;
    }
    return false;
}
function _isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) {
        return false;
    }
    return _getPossibleEventMessages(event).some(function (message) {
        return ignoreErrors.some(function (pattern) { return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .isMatchingPattern */ .zC)(message, pattern); });
    });
}
function _isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) {
        return false;
    }
    var url = _getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function (pattern) { return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .isMatchingPattern */ .zC)(url, pattern); });
}
function _isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) {
        return true;
    }
    var url = _getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function (pattern) { return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .isMatchingPattern */ .zC)(url, pattern); });
}
function _getPossibleEventMessages(event) {
    if (event.message) {
        return [event.message];
    }
    if (event.exception) {
        try {
            var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
            return ["" + value, type + ": " + value];
        }
        catch (oO) {
            _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .kg.error("Cannot extract message for event " + (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEventDescription */ .jH)(event));
            return [];
        }
    }
    return [];
}
function _isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    }
    catch (e) {
        // ignore
    }
    return false;
}
function _getLastValidUrl(frames) {
    if (frames === void 0) { frames = []; }
    for (var i = frames.length - 1; i >= 0; i--) {
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
            return frame.filename || null;
        }
    }
    return null;
}
function _getEventFilterUrl(event) {
    try {
        if (event.stacktrace) {
            return _getLastValidUrl(event.stacktrace.frames);
        }
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        }
        catch (e) {
            // ignore
        }
        return frames_1 ? _getLastValidUrl(frames_1) : null;
    }
    catch (oO) {
        _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .kg.error("Cannot extract url for event " + (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .getEventDescription */ .jH)(event));
        return null;
    }
}
//# sourceMappingURL=inboundfilters.js.map

/***/ }),

/***/ 89324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SDK_VERSION; }
/* harmony export */ });
var SDK_VERSION = '6.19.7';
//# sourceMappingURL=version.js.map

/***/ }),

/***/ 25976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xb": function() { return /* binding */ Hub; },
  "Gd": function() { return /* binding */ getCurrentHub; },
  "cu": function() { return /* binding */ getMainCarrier; }
});

// UNUSED EXPORTS: API_VERSION, getActiveDomain, getHubFromCarrier, makeMain, setHubOnCarrier

// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@1.14.1/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(65949);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(70133);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(29939);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(43888);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/global.js
var esm_global = __webpack_require__(66149);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(12648);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+hub@6.19.7/node_modules/@sentry/hub/esm/flags.js
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var flags_IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
//# sourceMappingURL=flags.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+hub@6.19.7/node_modules/@sentry/hub/esm/scope.js
var esm_scope = __webpack_require__(14752);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(96702);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+hub@6.19.7/node_modules/@sentry/hub/esm/session.js

/**
 * @inheritdoc
 */
var Session = /** @class */ (function () {
    function Session(context) {
        this.errors = 0;
        this.sid = (0,misc/* uuid4 */.DM)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0,time/* timestampInSeconds */.ph)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) {
            this.update(context);
        }
    }
    /** JSDoc */
    // eslint-disable-next-line complexity
    Session.prototype.update = function (context) {
        if (context === void 0) { context = {}; }
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) {
                this.ipAddress = context.user.ip_address;
            }
            if (!this.did && !context.did) {
                this.did = context.user.id || context.user.email || context.user.username;
            }
        }
        this.timestamp = context.timestamp || (0,time/* timestampInSeconds */.ph)();
        if (context.ignoreDuration) {
            this.ignoreDuration = context.ignoreDuration;
        }
        if (context.sid) {
            // Good enough uuid validation. — Kamil
            this.sid = context.sid.length === 32 ? context.sid : (0,misc/* uuid4 */.DM)();
        }
        if (context.init !== undefined) {
            this.init = context.init;
        }
        if (!this.did && context.did) {
            this.did = "" + context.did;
        }
        if (typeof context.started === 'number') {
            this.started = context.started;
        }
        if (this.ignoreDuration) {
            this.duration = undefined;
        }
        else if (typeof context.duration === 'number') {
            this.duration = context.duration;
        }
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) {
            this.release = context.release;
        }
        if (context.environment) {
            this.environment = context.environment;
        }
        if (!this.ipAddress && context.ipAddress) {
            this.ipAddress = context.ipAddress;
        }
        if (!this.userAgent && context.userAgent) {
            this.userAgent = context.userAgent;
        }
        if (typeof context.errors === 'number') {
            this.errors = context.errors;
        }
        if (context.status) {
            this.status = context.status;
        }
    };
    /** JSDoc */
    Session.prototype.close = function (status) {
        if (status) {
            this.update({ status: status });
        }
        else if (this.status === 'ok') {
            this.update({ status: 'exited' });
        }
        else {
            this.update();
        }
    };
    /** JSDoc */
    Session.prototype.toJSON = function () {
        return (0,object/* dropUndefinedKeys */.Jr)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent,
            },
        });
    };
    return Session;
}());

//# sourceMappingURL=session.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+hub@6.19.7/node_modules/@sentry/hub/esm/hub.js





/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */
var Hub = /** @class */ (function () {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */
    function Hub(client, scope, _version) {
        if (scope === void 0) { scope = new esm_scope/* Scope */.s(); }
        if (_version === void 0) { _version = API_VERSION; }
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */
        this._stack = [{}];
        this.getStackTop().scope = scope;
        if (client) {
            this.bindClient(client);
        }
    }
    /**
     * @inheritDoc
     */
    Hub.prototype.isOlderThan = function (version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.bindClient = function (client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) {
            client.setupIntegrations();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.pushScope = function () {
        // We want to clone the content of prev scope
        var scope = esm_scope/* Scope.clone */.s.clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope,
        });
        return scope;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.popScope = function () {
        if (this.getStack().length <= 1)
            return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.withScope = function (callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        }
        finally {
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getClient = function () {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */
    Hub.prototype.getScope = function () {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */
    Hub.prototype.getStack = function () {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */
    Hub.prototype.getStackTop = function () {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function (exception, hint) {
        var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)());
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureException', exception, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureMessage = function (message, level, hint) {
        var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)());
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureMessage', message, level, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureEvent = function (event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)();
        if (event.type !== 'transaction') {
            this._lastEventId = eventId;
        }
        this._invokeClient('captureEvent', event, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, hint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.lastEventId = function () {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client)
            return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0)
            return;
        var timestamp = (0,time/* dateTimestampInSeconds */.yW)();
        var mergedBreadcrumb = (0,tslib_es6/* __assign */.pi)({ timestamp: timestamp }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb
            ? (0,esm_logger/* consoleSandbox */.Cf)(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
            : mergedBreadcrumb;
        if (finalBreadcrumb === null)
            return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setUser = function (user) {
        var scope = this.getScope();
        if (scope)
            scope.setUser(user);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTags = function (tags) {
        var scope = this.getScope();
        if (scope)
            scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtras = function (extras) {
        var scope = this.getScope();
        if (scope)
            scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTag = function (key, value) {
        var scope = this.getScope();
        if (scope)
            scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtra = function (key, extra) {
        var scope = this.getScope();
        if (scope)
            scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function (name, context) {
        var scope = this.getScope();
        if (scope)
            scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.configureScope = function (callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) {
            callback(scope);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.run = function (callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        }
        finally {
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getIntegration = function (integration) {
        var client = this.getClient();
        if (!client)
            return null;
        try {
            return client.getIntegration(integration);
        }
        catch (_oO) {
            flags_IS_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSpan = function (context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startTransaction = function (context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.traceHeaders = function () {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureSession = function (endSession) {
        if (endSession === void 0) { endSession = false; }
        // both send the update and pull the session from the scope
        if (endSession) {
            return this.endSession();
        }
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.endSession = function () {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) {
            session.close();
        }
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) {
            scope.setSession();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSession = function (context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0,esm_global/* getGlobalObject */.R)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new Session((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ release: release,
            environment: environment }, (scope && { user: scope.getUser() })), (userAgent && { userAgent: userAgent })), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') {
                currentSession.update({ status: 'exited' });
            }
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */
    Hub.prototype._sendSessionUpdate = function () {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope)
            return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) {
                client.captureSession(session);
            }
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function (method) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            (_a = client)[method].apply(_a, (0,tslib_es6/* __spread */.fl)(args, [scope]));
        }
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */
    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function (method) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
            return sentry.extensions[method].apply(this, args);
        }
        flags_IS_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}());

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
    var carrier = (0,esm_global/* getGlobalObject */.R)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined,
    };
    return carrier;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0,node/* isNodeEnv */.KV)()) {
        return getHubFromActiveDomain(registry);
    }
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * Returns the active domain, if one exists
 * @deprecated No longer used; remove in v7
 * @returns The domain, or undefined if there is no active domain
 */
// eslint-disable-next-line deprecation/deprecation
function getActiveDomain() {
    IS_DEBUG_BUILD && logger.warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = getMainCarrier().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
    try {
        var sentry = getMainCarrier().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) {
            return getHubFromCarrier(registry);
        }
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, esm_scope/* Scope.clone */.s.clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    }
    catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
    return (0,esm_global/* getGlobalSingleton */.Y)('hub', function () { return new Hub(); }, carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
    if (!carrier)
        return false;
    var __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
    __SENTRY__.hub = hub;
    return true;
}
//# sourceMappingURL=hub.js.map

/***/ }),

/***/ 14752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ Scope; },
/* harmony export */   "c": function() { return /* binding */ addGlobalEventProcessor; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65949);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83106);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29939);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1774);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66149);


/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var Scope = /** @class */ (function () {
    function Scope() {
        /** Flag if notifying is happening. */
        this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this._eventProcessors = [];
        /** Array of breadcrumbs. */
        this._breadcrumbs = [];
        /** User */
        this._user = {};
        /** Tags */
        this._tags = {};
        /** Extra */
        this._extra = {};
        /** Contexts */
        this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */
        this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)(scope._breadcrumbs);
            newScope._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, scope._tags);
            newScope._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, scope._extra);
            newScope._contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    Scope.prototype.addScopeListener = function (callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addEventProcessor = function (callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setUser = function (user) {
        this._user = user || {};
        if (this._session) {
            this._session.update({ user: user });
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getUser = function () {
        return this._user;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getRequestSession = function () {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setRequestSession = function (requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTags = function (tags) {
        this._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtras = function (extras) {
        this._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setLevel = function (level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTransactionName = function (name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */
    Scope.prototype.setTransaction = function (name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setContext = function (key, context) {
        var _a;
        if (context === null) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._contexts[key];
        }
        else {
            this._contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSpan = function (span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSpan = function () {
        return this._span;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getTransaction = function () {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSession = function (session) {
        if (!session) {
            delete this._session;
        }
        else {
            this._session = session;
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSession = function () {
        return this._session;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.update = function (captureContext) {
        if (!captureContext) {
            return this;
        }
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), captureContext._tags);
            this._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), captureContext._extra);
            this._contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) {
                this._user = captureContext._user;
            }
            if (captureContext._level) {
                this._level = captureContext._level;
            }
            if (captureContext._fingerprint) {
                this._fingerprint = captureContext._fingerprint;
            }
            if (captureContext._requestSession) {
                this._requestSession = captureContext._requestSession;
            }
        }
        else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext = captureContext;
            this._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), captureContext.tags);
            this._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), captureContext.extra);
            this._contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) {
                this._user = captureContext.user;
            }
            if (captureContext.level) {
                this._level = captureContext.level;
            }
            if (captureContext.fingerprint) {
                this._fingerprint = captureContext.fingerprint;
            }
            if (captureContext.requestSession) {
                this._requestSession = captureContext.requestSession;
            }
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clear = function () {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, MAX_BREADCRUMBS) : MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) {
            return this;
        }
        var mergedBreadcrumb = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({ timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)() }, breadcrumb);
        this._breadcrumbs = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clearBreadcrumbs = function () {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */
    Scope.prototype.applyToEvent = function (event, hint) {
        if (this._extra && Object.keys(this._extra).length) {
            event.extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), event.extra);
        }
        if (this._tags && Object.keys(this._tags).length) {
            event.tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), event.tags);
        }
        if (this._user && Object.keys(this._user).length) {
            event.user = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._user), event.user);
        }
        if (this._contexts && Object.keys(this._contexts).length) {
            event.contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._contexts), event.contexts);
        }
        if (this._level) {
            event.level = this._level;
        }
        if (this._transactionName) {
            event.transaction = this._transactionName;
        }
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({ trace: this._span.getTraceContext() }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) {
                event.tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({ transaction: transactionName }, event.tags);
            }
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)((event.breadcrumbs || []), this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)(getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */
    Scope.prototype.setSDKProcessingMetadata = function (newData) {
        this._sdkProcessingMetadata = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
        var _this = this;
        if (index === void 0) { index = 0; }
        return new _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .SyncPromise */ .cW(function (resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') {
                resolve(event);
            }
            else {
                var result = processor((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, event), hint);
                if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isThenable */ .J8)(result)) {
                    void result
                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
                        .then(null, reject);
                }
                else {
                    void _this._notifyEventProcessors(processors, result, hint, index + 1)
                        .then(resolve)
                        .then(null, reject);
                }
            }
        });
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype._notifyScopeListeners = function () {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function (callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype._applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint
            ? Array.isArray(event.fingerprint)
                ? event.fingerprint
                : [event.fingerprint]
            : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) {
            event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    return Scope;
}());

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getGlobalSingleton */ .Y)('globalEventProcessors', function () { return []; });
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}
//# sourceMappingURL=scope.js.map

/***/ }),

/***/ 22164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "e": function() { return /* binding */ configureScope; },
/* harmony export */   "$e": function() { return /* binding */ withScope; }
/* harmony export */ });
/* unused harmony exports captureMessage, captureEvent, addBreadcrumb, setContext, setExtras, setTags, setExtra, setTag, setUser, _callOnClient, startTransaction */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65949);
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25976);


/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
    if (hub && hub[method]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return hub[method].apply(hub, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spread */ .fl)(args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException,
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
    return callOnHub('captureMessage', message, level, __assign({ originalException: message, syntheticException: syntheticException }, context));
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event) {
    return callOnHub('captureEvent', event);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
    callOnHub('configureScope', callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
    callOnHub('addBreadcrumb', breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
    callOnHub('setContext', name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
    callOnHub('setExtras', extras);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
    callOnHub('setTags', tags);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
    callOnHub('setExtra', key, extra);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
    callOnHub('setTag', key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
    callOnHub('setUser', user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 * @hidden
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _callOnClient(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    callOnHub.apply(void 0, __spread(['_invokeClient', method], args));
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(context, customSamplingContext) {
    return callOnHub('startTransaction', __assign({}, context), customSamplingContext);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 90201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ FINISH_REASON_TAG; },
/* harmony export */   "x": function() { return /* binding */ IDLE_TRANSACTION_FINISH_REASONS; }
/* harmony export */ });
// Store finish reasons in tuple to save on bundle size
// Readonly type should enforce that this is not mutated.
var FINISH_REASON_TAG = 'finishReason';
var IDLE_TRANSACTION_FINISH_REASONS = ['heartbeatFailed', 'idleTimeout', 'documentHidden'];
//# sourceMappingURL=constants.js.map

/***/ }),

/***/ 66513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ IS_DEBUG_BUILD; }
/* harmony export */ });
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
//# sourceMappingURL=flags.js.map

/***/ }),

/***/ 27280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ro": function() { return /* binding */ addExtensionMethods; },
  "lb": function() { return /* binding */ startIdleTransaction; }
});

// UNUSED EXPORTS: _addTracingExtensions

// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@1.14.1/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(65949);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+hub@6.19.7/node_modules/@sentry/hub/esm/hub.js + 2 modules
var hub = __webpack_require__(25976);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(43888);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(83106);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(12648);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(71588);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/flags.js
var flags = __webpack_require__(66513);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(49743);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/errors.js



/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
    (0,instrument/* addInstrumentationHandler */.o)('error', errorCallback);
    (0,instrument/* addInstrumentationHandler */.o)('unhandledrejection', errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
    var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
    if (activeTransaction) {
        var status_1 = 'internal_error';
        flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log("[Tracing] Transaction: " + status_1 + " -> Global error occured");
        activeTransaction.setStatus(status_1);
    }
}
//# sourceMappingURL=errors.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(9774);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/transaction.js
var esm_transaction = __webpack_require__(4247);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/hubextensions.js
/* module decorator */ module = __webpack_require__.hmd(module);








/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
    var scope = this.getScope();
    if (scope) {
        var span = scope.getSpan();
        if (span) {
            return {
                'sentry-trace': span.toTraceparent(),
            };
        }
    }
    return {};
}
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */
function sample(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0,utils/* hasTracingEnabled */.zu)(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    if (transaction.sampled !== undefined) {
        transaction.setMetadata({
            transactionSampling: { method: 'explicitly_set' },
        });
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    var sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setMetadata({
            transactionSampling: {
                method: 'client_sampler',
                // cast to number in case it's a boolean
                rate: Number(sampleRate),
            },
        });
    }
    else if (samplingContext.parentSampled !== undefined) {
        sampleRate = samplingContext.parentSampled;
        transaction.setMetadata({
            transactionSampling: { method: 'inheritance' },
        });
    }
    else {
        sampleRate = options.tracesSampleRate;
        transaction.setMetadata({
            transactionSampling: {
                method: 'client_rate',
                // cast to number in case it's a boolean
                rate: Number(sampleRate),
            },
        });
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!isValidSampleRate(sampleRate)) {
        flags/* IS_DEBUG_BUILD */.h && logger/* logger.warn */.kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        flags/* IS_DEBUG_BUILD */.h &&
            logger/* logger.log */.kg.log("[Tracing] Discarding transaction because " + (typeof options.tracesSampler === 'function'
                ? 'tracesSampler returned 0 or false'
                : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'));
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        flags/* IS_DEBUG_BUILD */.h &&
            logger/* logger.log */.kg.log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = " + Number(sampleRate) + ")");
        return transaction;
    }
    flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log("[Tracing] starting " + transaction.op + " transaction - " + transaction.name);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0,is/* isNaN */.i2)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        flags/* IS_DEBUG_BUILD */.h &&
            logger/* logger.warn */.kg.warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got " + JSON.stringify(rate) + " of type " + JSON.stringify(typeof rate) + ".");
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        flags/* IS_DEBUG_BUILD */.h &&
            logger/* logger.warn */.kg.warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got " + rate + ".");
        return false;
    }
    return true;
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(transactionContext, customSamplingContext) {
    var client = this.getClient();
    var options = (client && client.getOptions()) || {};
    var transaction = new esm_transaction/* Transaction */.Y(transactionContext, this);
    transaction = sample(transaction, options, (0,tslib_es6/* __assign */.pi)({ parentSampled: transactionContext.parentSampled, transactionContext: transactionContext }, customSamplingContext));
    if (transaction.sampled) {
        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    }
    return transaction;
}
/**
 * Create new idle transaction.
 */
function startIdleTransaction(hub, transactionContext, idleTimeout, onScope, customSamplingContext) {
    var client = hub.getClient();
    var options = (client && client.getOptions()) || {};
    var transaction = new idletransaction/* IdleTransaction */.io(transactionContext, hub, idleTimeout, onScope);
    transaction = sample(transaction, options, (0,tslib_es6/* __assign */.pi)({ parentSampled: transactionContext.parentSampled, transactionContext: transactionContext }, customSamplingContext));
    if (transaction.sampled) {
        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    }
    return transaction;
}
/**
 * @private
 */
function _addTracingExtensions() {
    var carrier = (0,hub/* getMainCarrier */.cu)();
    if (!carrier.__SENTRY__) {
        return;
    }
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) {
        carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
    }
    if (!carrier.__SENTRY__.extensions.traceHeaders) {
        carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
    }
}
/**
 * @private
 */
function _autoloadDatabaseIntegrations() {
    var carrier = (0,hub/* getMainCarrier */.cu)();
    if (!carrier.__SENTRY__) {
        return;
    }
    var packageToIntegrationMapping = {
        mongodb: function () {
            var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo');
            return new integration.Mongo();
        },
        mongoose: function () {
            var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo');
            return new integration.Mongo({ mongoose: true });
        },
        mysql: function () {
            var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mysql');
            return new integration.Mysql();
        },
        pg: function () {
            var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/postgres');
            return new integration.Postgres();
        },
    };
    var mappedPackages = Object.keys(packageToIntegrationMapping)
        .filter(function (moduleName) { return !!(0,node/* loadModule */.$y)(moduleName); })
        .map(function (pkg) {
        try {
            return packageToIntegrationMapping[pkg]();
        }
        catch (e) {
            return undefined;
        }
    })
        .filter(function (p) { return p; });
    if (mappedPackages.length > 0) {
        carrier.__SENTRY__.integrations = (0,tslib_es6/* __spread */.fl)((carrier.__SENTRY__.integrations || []), mappedPackages);
    }
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */
function addExtensionMethods() {
    _addTracingExtensions();
    // Detect and automatically load specified integrations.
    if ((0,node/* isNodeEnv */.KV)()) {
        _autoloadDatabaseIntegrations();
    }
    // If an error happens globally, we should make sure transaction status is set to error.
    registerErrorInstrumentation();
}
//# sourceMappingURL=hubextensions.js.map

/***/ }),

/***/ 9774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nT": function() { return /* binding */ DEFAULT_IDLE_TIMEOUT; },
/* harmony export */   "io": function() { return /* binding */ IdleTransaction; }
/* harmony export */ });
/* unused harmony exports HEARTBEAT_INTERVAL, IdleTransactionSpanRecorder */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65949);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29939);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43888);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90201);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66513);
/* harmony import */ var _span__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43573);
/* harmony import */ var _transaction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4247);






var DEFAULT_IDLE_TIMEOUT = 1000;
var HEARTBEAT_INTERVAL = 5000;
/**
 * @inheritDoc
 */
var IdleTransactionSpanRecorder = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(IdleTransactionSpanRecorder, _super);
    function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
        if (transactionSpanId === void 0) { transactionSpanId = ''; }
        var _this = _super.call(this, maxlen) || this;
        _this._pushActivity = _pushActivity;
        _this._popActivity = _popActivity;
        _this.transactionSpanId = transactionSpanId;
        return _this;
    }
    /**
     * @inheritDoc
     */
    IdleTransactionSpanRecorder.prototype.add = function (span) {
        var _this = this;
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanId !== this.transactionSpanId) {
            // We patch span.finish() to pop an activity after setting an endTimestamp.
            span.finish = function (endTimestamp) {
                span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
                _this._popActivity(span.spanId);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if (span.endTimestamp === undefined) {
                this._pushActivity(span.spanId);
            }
        }
        _super.prototype.add.call(this, span);
    };
    return IdleTransactionSpanRecorder;
}(_span__WEBPACK_IMPORTED_MODULE_2__/* .SpanRecorder */ .gB));

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
var IdleTransaction = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(IdleTransaction, _super);
    function IdleTransaction(transactionContext, _idleHub, 
    /**
     * The time to wait in ms until the idle transaction will be finished.
     * @default 1000
     */
    _idleTimeout, 
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope) {
        if (_idleTimeout === void 0) { _idleTimeout = DEFAULT_IDLE_TIMEOUT; }
        if (_onScope === void 0) { _onScope = false; }
        var _this = _super.call(this, transactionContext, _idleHub) || this;
        _this._idleHub = _idleHub;
        _this._idleTimeout = _idleTimeout;
        _this._onScope = _onScope;
        // Activities store a list of active spans
        _this.activities = {};
        // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
        _this._heartbeatCounter = 0;
        // We should not use heartbeat if we finished a transaction
        _this._finished = false;
        _this._beforeFinishCallbacks = [];
        if (_idleHub && _onScope) {
            // There should only be one active transaction on the scope
            clearActiveTransaction(_idleHub);
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log("Setting idle transaction on scope. Span ID: " + _this.spanId);
            _idleHub.configureScope(function (scope) { return scope.setSpan(_this); });
        }
        _this._initTimeout = setTimeout(function () {
            if (!_this._finished) {
                _this.finish();
            }
        }, _this._idleTimeout);
        return _this;
    }
    /** {@inheritDoc} */
    IdleTransaction.prototype.finish = function (endTimestamp) {
        var e_1, _a;
        var _this = this;
        if (endTimestamp === void 0) { endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)(); }
        this._finished = true;
        this.activities = {};
        if (this.spanRecorder) {
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h &&
                _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);
            try {
                for (var _b = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__values */ .XA)(this._beforeFinishCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var callback = _c.value;
                    callback(this, endTimestamp);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            this.spanRecorder.spans = this.spanRecorder.spans.filter(function (span) {
                // If we are dealing with the transaction itself, we just return it
                if (span.spanId === _this.spanId) {
                    return true;
                }
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!span.endTimestamp) {
                    span.endTimestamp = endTimestamp;
                    span.setStatus('cancelled');
                    _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h &&
                        _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                var keepSpan = span.startTimestamp < endTimestamp;
                if (!keepSpan) {
                    _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h &&
                        _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] discarding Span since it happened after Transaction was finished', JSON.stringify(span, undefined, 2));
                }
                return keepSpan;
            });
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] flushing IdleTransaction');
        }
        else {
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] No active IdleTransaction');
        }
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            clearActiveTransaction(this._idleHub);
        }
        return _super.prototype.finish.call(this, endTimestamp);
    };
    /**
     * Register a callback function that gets excecuted before the transaction finishes.
     * Useful for cleanup or if you want to add any additional spans based on current context.
     *
     * This is exposed because users have no other way of running something before an idle transaction
     * finishes.
     */
    IdleTransaction.prototype.registerBeforeFinishCallback = function (callback) {
        this._beforeFinishCallbacks.push(callback);
    };
    /**
     * @inheritDoc
     */
    IdleTransaction.prototype.initSpanRecorder = function (maxlen) {
        var _this = this;
        if (!this.spanRecorder) {
            var pushActivity = function (id) {
                if (_this._finished) {
                    return;
                }
                _this._pushActivity(id);
            };
            var popActivity = function (id) {
                if (_this._finished) {
                    return;
                }
                _this._popActivity(id);
            };
            this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('Starting heartbeat');
            this._pingHeartbeat();
        }
        this.spanRecorder.add(this);
    };
    /**
     * Start tracking a specific activity.
     * @param spanId The span id that represents the activity
     */
    IdleTransaction.prototype._pushActivity = function (spanId) {
        if (this._initTimeout) {
            clearTimeout(this._initTimeout);
            this._initTimeout = undefined;
        }
        _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log("[Tracing] pushActivity: " + spanId);
        this.activities[spanId] = true;
        _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
    };
    /**
     * Remove an activity from usage
     * @param spanId The span id that represents the activity
     */
    IdleTransaction.prototype._popActivity = function (spanId) {
        var _this = this;
        if (this.activities[spanId]) {
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log("[Tracing] popActivity " + spanId);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            var timeout = this._idleTimeout;
            // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampWithMs is in seconds, timeout is in ms
            var end_1 = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)() + timeout / 1000;
            setTimeout(function () {
                if (!_this._finished) {
                    _this.setTag(_constants__WEBPACK_IMPORTED_MODULE_5__/* .FINISH_REASON_TAG */ .d, _constants__WEBPACK_IMPORTED_MODULE_5__/* .IDLE_TRANSACTION_FINISH_REASONS[1] */ .x[1]);
                    _this.finish(end_1);
                }
            }, timeout);
        }
    };
    /**
     * Checks when entries of this.activities are not changing for 3 beats.
     * If this occurs we finish the transaction.
     */
    IdleTransaction.prototype._beat = function () {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) {
            return;
        }
        var heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) {
            this._heartbeatCounter += 1;
        }
        else {
            this._heartbeatCounter = 1;
        }
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] Transaction finished because of no change for 3 heart beats');
            this.setStatus('deadline_exceeded');
            this.setTag(_constants__WEBPACK_IMPORTED_MODULE_5__/* .FINISH_REASON_TAG */ .d, _constants__WEBPACK_IMPORTED_MODULE_5__/* .IDLE_TRANSACTION_FINISH_REASONS[0] */ .x[0]);
            this.finish();
        }
        else {
            this._pingHeartbeat();
        }
    };
    /**
     * Pings the heartbeat
     */
    IdleTransaction.prototype._pingHeartbeat = function () {
        var _this = this;
        _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log("pinging Heartbeat -> current counter: " + this._heartbeatCounter);
        setTimeout(function () {
            _this._beat();
        }, HEARTBEAT_INTERVAL);
    };
    return IdleTransaction;
}(_transaction__WEBPACK_IMPORTED_MODULE_6__/* .Transaction */ .Y));

/**
 * Reset transaction on scope to `undefined`
 */
function clearActiveTransaction(hub) {
    if (hub) {
        var scope = hub.getScope();
        if (scope) {
            var transaction = scope.getTransaction();
            if (transaction) {
                scope.setSpan(undefined);
            }
        }
    }
}
//# sourceMappingURL=idletransaction.js.map

/***/ }),

/***/ 43573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gB": function() { return /* binding */ SpanRecorder; },
/* harmony export */   "Dr": function() { return /* binding */ Span; }
/* harmony export */ });
/* unused harmony export spanStatusfromHttpCode */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65949);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70133);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29939);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96702);


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
var SpanRecorder = /** @class */ (function () {
    function SpanRecorder(maxlen) {
        if (maxlen === void 0) { maxlen = 1000; }
        this.spans = [];
        this._maxlen = maxlen;
    }
    /**
     * This is just so that we don't run out of memory while recording a lot
     * of spans. At some point we just stop and flush out the start of the
     * trace tree (i.e.the first n spans with the smallest
     * start_timestamp).
     */
    SpanRecorder.prototype.add = function (span) {
        if (this.spans.length > this._maxlen) {
            span.spanRecorder = undefined;
        }
        else {
            this.spans.push(span);
        }
    };
    return SpanRecorder;
}());

/**
 * Span contains all data about a span
 */
var Span = /** @class */ (function () {
    /**
     * You should never call the constructor manually, always use `Sentry.startTransaction()`
     * or call `startChild()` on an existing span.
     * @internal
     * @hideconstructor
     * @hidden
     */
    function Span(spanContext) {
        /**
         * @inheritDoc
         */
        this.traceId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)();
        /**
         * @inheritDoc
         */
        this.spanId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)().substring(16);
        /**
         * Timestamp in seconds when the span was created.
         */
        this.startTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
        /**
         * @inheritDoc
         */
        this.tags = {};
        /**
         * @inheritDoc
         */
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.data = {};
        if (!spanContext) {
            return this;
        }
        if (spanContext.traceId) {
            this.traceId = spanContext.traceId;
        }
        if (spanContext.spanId) {
            this.spanId = spanContext.spanId;
        }
        if (spanContext.parentSpanId) {
            this.parentSpanId = spanContext.parentSpanId;
        }
        // We want to include booleans as well here
        if ('sampled' in spanContext) {
            this.sampled = spanContext.sampled;
        }
        if (spanContext.op) {
            this.op = spanContext.op;
        }
        if (spanContext.description) {
            this.description = spanContext.description;
        }
        if (spanContext.data) {
            this.data = spanContext.data;
        }
        if (spanContext.tags) {
            this.tags = spanContext.tags;
        }
        if (spanContext.status) {
            this.status = spanContext.status;
        }
        if (spanContext.startTimestamp) {
            this.startTimestamp = spanContext.startTimestamp;
        }
        if (spanContext.endTimestamp) {
            this.endTimestamp = spanContext.endTimestamp;
        }
    }
    /**
     * @inheritDoc
     * @deprecated
     */
    Span.prototype.child = function (spanContext) {
        return this.startChild(spanContext);
    };
    /**
     * @inheritDoc
     */
    Span.prototype.startChild = function (spanContext) {
        var childSpan = new Span((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, spanContext), { parentSpanId: this.spanId, sampled: this.sampled, traceId: this.traceId }));
        childSpan.spanRecorder = this.spanRecorder;
        if (childSpan.spanRecorder) {
            childSpan.spanRecorder.add(childSpan);
        }
        childSpan.transaction = this.transaction;
        return childSpan;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setTag = function (key, value) {
        var _a;
        this.tags = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, this.tags), (_a = {}, _a[key] = value, _a));
        return this;
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Span.prototype.setData = function (key, value) {
        var _a;
        this.data = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, this.data), (_a = {}, _a[key] = value, _a));
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setStatus = function (value) {
        this.status = value;
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setHttpStatus = function (httpStatus) {
        this.setTag('http.status_code', String(httpStatus));
        var spanStatus = spanStatusfromHttpCode(httpStatus);
        if (spanStatus !== 'unknown_error') {
            this.setStatus(spanStatus);
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.isSuccess = function () {
        return this.status === 'ok';
    };
    /**
     * @inheritDoc
     */
    Span.prototype.finish = function (endTimestamp) {
        this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toTraceparent = function () {
        var sampledString = '';
        if (this.sampled !== undefined) {
            sampledString = this.sampled ? '-1' : '-0';
        }
        return this.traceId + "-" + this.spanId + sampledString;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toContext = function () {
        return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
            data: this.data,
            description: this.description,
            endTimestamp: this.endTimestamp,
            op: this.op,
            parentSpanId: this.parentSpanId,
            sampled: this.sampled,
            spanId: this.spanId,
            startTimestamp: this.startTimestamp,
            status: this.status,
            tags: this.tags,
            traceId: this.traceId,
        });
    };
    /**
     * @inheritDoc
     */
    Span.prototype.updateWithContext = function (spanContext) {
        var _a, _b, _c, _d, _e;
        this.data = (_a = spanContext.data, (_a !== null && _a !== void 0 ? _a : {}));
        this.description = spanContext.description;
        this.endTimestamp = spanContext.endTimestamp;
        this.op = spanContext.op;
        this.parentSpanId = spanContext.parentSpanId;
        this.sampled = spanContext.sampled;
        this.spanId = (_b = spanContext.spanId, (_b !== null && _b !== void 0 ? _b : this.spanId));
        this.startTimestamp = (_c = spanContext.startTimestamp, (_c !== null && _c !== void 0 ? _c : this.startTimestamp));
        this.status = spanContext.status;
        this.tags = (_d = spanContext.tags, (_d !== null && _d !== void 0 ? _d : {}));
        this.traceId = (_e = spanContext.traceId, (_e !== null && _e !== void 0 ? _e : this.traceId));
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.getTraceContext = function () {
        return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            trace_id: this.traceId,
        });
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toJSON = function () {
        return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            start_timestamp: this.startTimestamp,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this.endTimestamp,
            trace_id: this.traceId,
        });
    };
    return Span;
}());

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) {
        return 'ok';
    }
    if (httpStatus >= 400 && httpStatus < 500) {
        switch (httpStatus) {
            case 401:
                return 'unauthenticated';
            case 403:
                return 'permission_denied';
            case 404:
                return 'not_found';
            case 409:
                return 'already_exists';
            case 413:
                return 'failed_precondition';
            case 429:
                return 'resource_exhausted';
            default:
                return 'invalid_argument';
        }
    }
    if (httpStatus >= 500 && httpStatus < 600) {
        switch (httpStatus) {
            case 501:
                return 'unimplemented';
            case 503:
                return 'unavailable';
            case 504:
                return 'deadline_exceeded';
            default:
                return 'internal_error';
        }
    }
    return 'unknown_error';
}
//# sourceMappingURL=span.js.map

/***/ }),

/***/ 4247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Transaction; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65949);
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25976);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83106);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43888);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96702);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66513);
/* harmony import */ var _span__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43573);





/** JSDoc */
var Transaction = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(Transaction, _super);
    /**
     * This constructor should never be called manually. Those instrumenting tracing should use
     * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
     * @internal
     * @hideconstructor
     * @hidden
     */
    function Transaction(transactionContext, hub) {
        var _this = _super.call(this, transactionContext) || this;
        _this._measurements = {};
        /**
         * The reference to the current hub.
         */
        _this._hub = (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();
        if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isInstanceOf */ .V9)(hub, _sentry_hub__WEBPACK_IMPORTED_MODULE_1__/* .Hub */ .Xb)) {
            _this._hub = hub;
        }
        _this.name = transactionContext.name || '';
        _this.metadata = transactionContext.metadata || {};
        _this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        _this.transaction = _this;
        return _this;
    }
    /**
     * JSDoc
     */
    Transaction.prototype.setName = function (name) {
        this.name = name;
    };
    /**
     * Attaches SpanRecorder to the span itself
     * @param maxlen maximum number of spans that can be recorded
     */
    Transaction.prototype.initSpanRecorder = function (maxlen) {
        if (maxlen === void 0) { maxlen = 1000; }
        if (!this.spanRecorder) {
            this.spanRecorder = new _span__WEBPACK_IMPORTED_MODULE_3__/* .SpanRecorder */ .gB(maxlen);
        }
        this.spanRecorder.add(this);
    };
    /**
     * Set observed measurements for this transaction.
     * @hidden
     */
    Transaction.prototype.setMeasurements = function (measurements) {
        this._measurements = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, measurements);
    };
    /**
     * Set metadata for this transaction.
     * @hidden
     */
    Transaction.prototype.setMetadata = function (newMetadata) {
        this.metadata = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this.metadata), newMetadata);
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.finish = function (endTimestamp) {
        var _this = this;
        // This transaction is already finished, so we should not flush it again.
        if (this.endTimestamp !== undefined) {
            return undefined;
        }
        if (!this.name) {
            _flags__WEBPACK_IMPORTED_MODULE_4__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.warn */ .kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this.name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        _super.prototype.finish.call(this, endTimestamp);
        if (this.sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            _flags__WEBPACK_IMPORTED_MODULE_4__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.log */ .kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            var client = this._hub.getClient();
            var transport = client && client.getTransport && client.getTransport();
            if (transport && transport.recordLostEvent) {
                transport.recordLostEvent('sample_rate', 'transaction');
            }
            return undefined;
        }
        var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function (s) { return s !== _this && s.endTimestamp; }) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            this.endTimestamp = finishedSpans.reduce(function (prev, current) {
                if (prev.endTimestamp && current.endTimestamp) {
                    return prev.endTimestamp > current.endTimestamp ? prev : current;
                }
                return prev;
            }).endTimestamp;
        }
        var transaction = {
            contexts: {
                trace: this.getTraceContext(),
            },
            spans: finishedSpans,
            start_timestamp: this.startTimestamp,
            tags: this.tags,
            timestamp: this.endTimestamp,
            transaction: this.name,
            type: 'transaction',
            sdkProcessingMetadata: this.metadata,
        };
        var hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            _flags__WEBPACK_IMPORTED_MODULE_4__/* .IS_DEBUG_BUILD */ .h &&
                _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.log */ .kg.log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        _flags__WEBPACK_IMPORTED_MODULE_4__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.log */ .kg.log("[Tracing] Finishing " + this.op + " transaction: " + this.name + ".");
        return this._hub.captureEvent(transaction);
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.toContext = function () {
        var spanContext = _super.prototype.toContext.call(this);
        return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .dropUndefinedKeys */ .Jr)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, spanContext), { name: this.name, trimEnd: this._trimEnd }));
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.updateWithContext = function (transactionContext) {
        var _a;
        _super.prototype.updateWithContext.call(this, transactionContext);
        this.name = (_a = transactionContext.name, (_a !== null && _a !== void 0 ? _a : ''));
        this._trimEnd = transactionContext.trimEnd;
        return this;
    };
    return Transaction;
}(_span__WEBPACK_IMPORTED_MODULE_3__/* .Span */ .Dr));

//# sourceMappingURL=transaction.js.map

/***/ }),

/***/ 49743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "zu": function() { return /* binding */ hasTracingEnabled; },
/* harmony export */   "x1": function() { return /* binding */ getActiveTransaction; },
/* harmony export */   "XL": function() { return /* binding */ msToSec; },
/* harmony export */   "WB": function() { return /* binding */ secToMs; }
/* harmony export */ });
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25976);

/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * TODO(v7): Reorganize these exports
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 */

/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(maybeOptions) {
    var client = (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
    var options = maybeOptions || (client && client.getOptions());
    return !!options && ('tracesSampleRate' in options || 'tracesSampler' in options);
}
/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
    var hub = maybeHub || (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
    var scope = hub.getScope();
    return scope && scope.getTransaction();
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
    return time / 1000;
}
/**
 * Converts from seconds to milliseconds
 * @param time time in seconds
 */
function secToMs(time) {
    return time * 1000;
}
// so it can be used in manual instrumentation without necessitating a hard dependency on @sentry/utils

//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 13359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Severity; }
/* harmony export */ });
/* unused harmony export SeverityLevels */
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
// TODO: in v7, these can disappear, because they now also exist in `@sentry/utils`. (Having them there rather than here
// is nice because then it enforces the idea that only types are exported from `@sentry/types`.)
var SeverityLevels = (/* unused pure expression or super */ null && (['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical']));
//# sourceMappingURL=severity.js.map

/***/ }),

/***/ 30621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ isDebugBuild; },
/* harmony export */   "n": function() { return /* binding */ isBrowserBundle; }
/* harmony export */ });
/**
 * This module mostly exists for optimizations in the build process
 * through rollup and terser.  We define some global constants which
 * are normally undefined.  However terser overrides these with global
 * definitions which can be evaluated by the static analyzer when
 * creating a bundle.
 *
 * In turn the `isDebugBuild` and `isBrowserBundle` functions are pure
 * and can help us remove unused code from the bundles.
 */
/**
 * Figures out if we're building with debug functionality.
 *
 * @returns true if this is a debug build
 */
function isDebugBuild() {
    return typeof __SENTRY_NO_DEBUG__ !== 'undefined' && !__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
//# sourceMappingURL=env.js.map

/***/ }),

/***/ 9875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getGlobalObject; }
/* harmony export */ });
/* harmony import */ var _node__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58179);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
    return ((0,_node__WEBPACK_IMPORTED_MODULE_0__/* .isNodeEnv */ .KV)()
        ? __webpack_require__.g
        : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
            ? window // eslint-disable-line no-restricted-globals
            : typeof self !== 'undefined'
                ? self
                : fallbackGlobalObject);
}
//# sourceMappingURL=global.js.map

/***/ }),

/***/ 58179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KV": function() { return /* binding */ isNodeEnv; },
/* harmony export */   "l$": function() { return /* binding */ dynamicRequire; }
/* harmony export */ });
/* unused harmony export loadModule */
/* harmony import */ var _env__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30621);
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(14224);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return (!(0,_env__WEBPACK_IMPORTED_MODULE_0__/* .isBrowserBundle */ .n)() &&
        Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]');
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    }
    catch (e) {
        // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    }
    catch (e) {
        // no-empty
    }
    return mod;
}
//# sourceMappingURL=node.js.map

/***/ }),

/***/ 93182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; }
/* harmony export */ });
/* unused harmony exports timestampWithMs, usingPerformanceAPI, _browserPerformanceTimeOriginMode, browserPerformanceTimeOrigin */
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9875);
/* harmony import */ var _node__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58179);
/* module decorator */ module = __webpack_require__.hmd(module);


/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
var dateTimestampSource = {
    nowSeconds: function () { return Date.now() / 1000; },
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
    var performance = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)().performance;
    if (!performance || !performance.now) {
        return undefined;
    }
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function () { return performance.now(); },
        timeOrigin: timeOrigin,
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
    try {
        var perfHooks = (0,_node__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks');
        return perfHooks.performance;
    }
    catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */
var platformPerformance = (0,_node__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
    };
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
// Re-exported with an old name for backwards-compatibility.
var timestampWithMs = (/* unused pure expression or super */ null && (timestampInSeconds));
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
var usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
var _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
var browserPerformanceTimeOrigin = (function () {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600 * 1000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin
        ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
        : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        }
        else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
})();
//# sourceMappingURL=time.js.map

/***/ }),

/***/ 42880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "l": function() { return /* binding */ getLocationHref; }
/* harmony export */ });
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66149);
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83106);


/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
                break;
            }
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length
        ? keyAttrs.filter(function (keyAttr) { return elem.getAttribute(keyAttr); }).map(function (keyAttr) { return [keyAttr, elem.getAttribute(keyAttr)]; })
        : null;
    if (keyAttrPairs && keyAttrPairs.length) {
        keyAttrPairs.forEach(function (keyAttrPair) {
            out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
        });
    }
    else {
        if (elem.id) {
            out.push("#" + elem.id);
        }
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(className)) {
            classes = className.split(/\s+/);
            for (i = 0; i < classes.length; i++) {
                out.push("." + classes[i]);
            }
        }
    }
    var allowedAttrs = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < allowedAttrs.length; i++) {
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */
function getLocationHref() {
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)();
    try {
        return global.document.location.href;
    }
    catch (oO) {
        return '';
    }
}
//# sourceMappingURL=browser.js.map

/***/ }),

/***/ 13897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ dsnToString; },
/* harmony export */   "v": function() { return /* binding */ makeDsn; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65949);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11683);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49934);



/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsnToString(dsn, withPassword) {
    if (withPassword === void 0) { withPassword = false; }
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return (protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') +
        ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
}
function dsnFromString(str) {
    var match = DSN_REGEX.exec(str);
    if (!match) {
        throw new _error__WEBPACK_IMPORTED_MODULE_0__/* .SentryError */ .b("Invalid Sentry Dsn: " + str);
    }
    var _a = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__read */ .CR)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) {
            projectId = projectMatch[0];
        }
    }
    return dsnFromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, publicKey: publicKey });
}
function dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) {
        components.publicKey = components.user;
    }
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId,
    };
}
function validateDsn(dsn) {
    if (!_flags__WEBPACK_IMPORTED_MODULE_2__/* .IS_DEBUG_BUILD */ .h) {
        return;
    }
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
    requiredComponents.forEach(function (component) {
        if (!dsn[component]) {
            throw new _error__WEBPACK_IMPORTED_MODULE_0__/* .SentryError */ .b("Invalid Sentry Dsn: " + component + " missing");
        }
    });
    if (!projectId.match(/^\d+$/)) {
        throw new _error__WEBPACK_IMPORTED_MODULE_0__/* .SentryError */ .b("Invalid Sentry Dsn: Invalid projectId " + projectId);
    }
    if (!isValidProtocol(protocol)) {
        throw new _error__WEBPACK_IMPORTED_MODULE_0__/* .SentryError */ .b("Invalid Sentry Dsn: Invalid protocol " + protocol);
    }
    if (port && isNaN(parseInt(port, 10))) {
        throw new _error__WEBPACK_IMPORTED_MODULE_0__/* .SentryError */ .b("Invalid Sentry Dsn: Invalid port " + port);
    }
    return true;
}
/** The Sentry Dsn, identifying a Sentry instance and project. */
function makeDsn(from) {
    var components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
    validateDsn(components);
    return components;
}
//# sourceMappingURL=dsn.js.map

/***/ }),

/***/ 11683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ SentryError; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@1.14.1/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(65949);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/polyfill.js
var setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function mixinProperties(obj, proto) {
    for (var prop in proto) {
        if (!Object.prototype.hasOwnProperty.call(obj, prop)) {
            // @ts-ignore typescript complains about indexing so we remove
            obj[prop] = proto[prop];
        }
    }
    return obj;
}
//# sourceMappingURL=polyfill.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/error.js


/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error));

//# sourceMappingURL=error.js.map

/***/ }),

/***/ 49934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ IS_DEBUG_BUILD; }
/* harmony export */ });
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
//# sourceMappingURL=flags.js.map

/***/ }),

/***/ 66149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "Y": function() { return /* binding */ getGlobalSingleton; }
/* harmony export */ });
/* harmony import */ var _node__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12648);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
    return ((0,_node__WEBPACK_IMPORTED_MODULE_0__/* .isNodeEnv */ .KV)()
        ? __webpack_require__.g
        : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
            ? window // eslint-disable-line no-restricted-globals
            : typeof self !== 'undefined'
                ? self
                : fallbackGlobalObject);
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `getGlobalObject`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
    var global = (obj || getGlobalObject());
    var __SENTRY__ = (global.__SENTRY__ = global.__SENTRY__ || {});
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}
//# sourceMappingURL=global.js.map

/***/ }),

/***/ 71588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ addInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65949);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49934);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66149);
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83106);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43888);
/* harmony import */ var _object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96702);
/* harmony import */ var _stacktrace__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42389);
/* harmony import */ var _supports__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47961);








var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */
var handlers = {};
var instrumented = {};
/** Instruments given API */
function instrument(type) {
    if (instrumented[type]) {
        return;
    }
    instrumented[type] = true;
    switch (type) {
        case 'console':
            instrumentConsole();
            break;
        case 'dom':
            instrumentDOM();
            break;
        case 'xhr':
            instrumentXHR();
            break;
        case 'fetch':
            instrumentFetch();
            break;
        case 'history':
            instrumentHistory();
            break;
        case 'error':
            instrumentError();
            break;
        case 'unhandledrejection':
            instrumentUnhandledRejection();
            break;
        default:
            _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h && _logger__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn('unknown instrumentation type:', type);
            return;
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(callback);
    instrument(type);
}
/** JSDoc */
function triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !handlers[type]) {
        return;
    }
    try {
        for (var _b = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__values */ .XA)(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
            var handler = _c.value;
            try {
                handler(data);
            }
            catch (e) {
                _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h &&
                    _logger__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .kg.error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0,_stacktrace__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(handler) + "\nError:", e);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/** JSDoc */
function instrumentConsole() {
    if (!('console' in global)) {
        return;
    }
    _logger__WEBPACK_IMPORTED_MODULE_2__/* .CONSOLE_LEVELS.forEach */ .RU.forEach(function (level) {
        if (!(level in global.console)) {
            return;
        }
        (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(global.console, level, function (originalConsoleMethod) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                triggerHandlers('console', { args: args, level: level });
                // this fails for some browsers. :(
                if (originalConsoleMethod) {
                    originalConsoleMethod.apply(global.console, args);
                }
            };
        });
    });
}
/** JSDoc */
function instrumentFetch() {
    if (!(0,_supports__WEBPACK_IMPORTED_MODULE_6__/* .supportsNativeFetch */ .t$)()) {
        return;
    }
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(global, 'fetch', function (originalFetch) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var handlerData = {
                args: args,
                fetchData: {
                    method: getFetchMethod(args),
                    url: getFetchUrl(args),
                },
                startTimestamp: Date.now(),
            };
            triggerHandlers('fetch', (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply(global, args).then(function (response) {
                triggerHandlers('fetch', (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, handlerData), { endTimestamp: Date.now(), response: response }));
                return response;
            }, function (error) {
                triggerHandlers('fetch', (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, handlerData), { endTimestamp: Date.now(), error: error }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if ('Request' in global && (0,_is__WEBPACK_IMPORTED_MODULE_7__/* .isInstanceOf */ .V9)(fetchArgs[0], Request) && fetchArgs[0].method) {
        return String(fetchArgs[0].method).toUpperCase();
    }
    if (fetchArgs[1] && fetchArgs[1].method) {
        return String(fetchArgs[1].method).toUpperCase();
    }
    return 'GET';
}
/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if (typeof fetchArgs[0] === 'string') {
        return fetchArgs[0];
    }
    if ('Request' in global && (0,_is__WEBPACK_IMPORTED_MODULE_7__/* .isInstanceOf */ .V9)(fetchArgs[0], Request)) {
        return fetchArgs[0].url;
    }
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */
/** JSDoc */
function instrumentXHR() {
    if (!('XMLHttpRequest' in global)) {
        return;
    }
    var xhrproto = XMLHttpRequest.prototype;
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(xhrproto, 'open', function (originalOpen) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = (xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0,_is__WEBPACK_IMPORTED_MODULE_7__/* .isString */ .HD)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
            });
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0,_is__WEBPACK_IMPORTED_MODULE_7__/* .isString */ .HD)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
                xhr.__sentry_own_request__ = true;
            }
            var onreadystatechangeHandler = function () {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    }
                    catch (e) {
                        /* do nothing */
                    }
                    triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr,
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(xhr, 'onreadystatechange', function (original) {
                    return function () {
                        var readyStateArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            readyStateArgs[_i] = arguments[_i];
                        }
                        onreadystatechangeHandler();
                        return original.apply(xhr, readyStateArgs);
                    };
                });
            }
            else {
                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            }
            return originalOpen.apply(xhr, args);
        };
    });
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(xhrproto, 'send', function (originalSend) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.__sentry_xhr__ && args[0] !== undefined) {
                this.__sentry_xhr__.body = args[0];
            }
            triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this,
            });
            return originalSend.apply(this, args);
        };
    });
}
var lastHref;
/** JSDoc */
function instrumentHistory() {
    if (!(0,_supports__WEBPACK_IMPORTED_MODULE_6__/* .supportsHistory */ .Bf)()) {
        return;
    }
    var oldOnPopState = global.onpopstate;
    global.onpopstate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var to = global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        triggerHandlers('history', {
            from: from,
            to: to,
        });
        if (oldOnPopState) {
            // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
            // https://github.com/getsentry/sentry-javascript/issues/3344
            // https://github.com/bugsnag/bugsnag-js/issues/469
            try {
                return oldOnPopState.apply(this, args);
            }
            catch (_oO) {
                // no-empty
            }
        }
    };
    /** @hidden */
    function historyReplacementFunction(originalHistoryFunction) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                triggerHandlers('history', {
                    from: from,
                    to: to,
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(global.history, 'pushState', historyReplacementFunction);
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(global.history, 'replaceState', historyReplacementFunction);
}
var debounceDuration = 1000;
var debounceTimerID;
var lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) {
        return true;
    }
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) {
        return true;
    }
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) {
            return true;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') {
        return false;
    }
    try {
        var target = event.target;
        if (!target || !target.tagName) {
            return true;
        }
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
            return false;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) { globalListener = false; }
    return function (event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || lastCapturedEvent === event) {
            return;
        }
        // We always want to skip _some_ events.
        if (shouldSkipDOMEvent(event)) {
            return;
        }
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if (debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout(debounceTimerID);
        debounceTimerID = global.setTimeout(function () {
            debounceTimerID = undefined;
        }, debounceDuration);
    };
}
/** JSDoc */
function instrumentDOM() {
    if (!('document' in global)) {
        return;
    }
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
    global.document.addEventListener('click', globalDOMEventHandler, false);
    global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    ['EventTarget', 'Node'].forEach(function (target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = global[target] && global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(proto, 'addEventListener', function (originalAddEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_1 = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
                        var handlerForType = (handlers_1[type] = handlers_1[type] || { refCount: 0 });
                        if (!handlerForType.handler) {
                            var handler = makeDOMEventHandler(triggerDOMHandler);
                            handlerForType.handler = handler;
                            originalAddEventListener.call(this, type, handler, options);
                        }
                        handlerForType.refCount += 1;
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(proto, 'removeEventListener', function (originalRemoveEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers_2[type];
                        if (handlerForType) {
                            handlerForType.refCount -= 1;
                            // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                            if (handlerForType.refCount <= 0) {
                                originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                                handlerForType.handler = undefined;
                                delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                            }
                            // If there are no longer any custom handlers of any type on this element, cleanup everything.
                            if (Object.keys(handlers_2).length === 0) {
                                delete el.__sentry_instrumentation_handlers__;
                            }
                        }
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
    _oldOnErrorHandler = global.onerror;
    global.onerror = function (msg, url, line, column, error) {
        triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url,
        });
        if (_oldOnErrorHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnErrorHandler.apply(this, arguments);
        }
        return false;
    };
}
var _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = global.onunhandledrejection;
    global.onunhandledrejection = function (e) {
        triggerHandlers('unhandledrejection', e);
        if (_oldOnUnhandledRejectionHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        }
        return true;
    };
}
//# sourceMappingURL=instrument.js.map

/***/ }),

/***/ 83106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; }
/* harmony export */ });
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable-next-line @typescript-eslint/unbound-method
var objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (objectToString.call(wat)) {
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
function isBuiltin(wat, ty) {
    return objectToString.call(wat) === "[object " + ty + "]";
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return isBuiltin(wat, 'String');
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    }
    catch (_e) {
        return false;
    }
}
//# sourceMappingURL=is.js.map

/***/ }),

/***/ 43888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65949);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49934);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66149);



// TODO: Implement different loggers for different environments
var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
var CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
    if (!('console' in global)) {
        return callback();
    }
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    CONSOLE_LEVELS.forEach(function (level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    }
    finally {
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function (level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function makeLogger() {
    var enabled = false;
    var logger = {
        enable: function () {
            enabled = true;
        },
        disable: function () {
            enabled = false;
        },
    };
    if (_flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h) {
        CONSOLE_LEVELS.forEach(function (name) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            logger[name] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (enabled) {
                    consoleSandbox(function () {
                        var _a;
                        (_a = global.console)[name].apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__spread */ .fl)([PREFIX + "[" + name + "]:"], args));
                    });
                }
            };
        });
    }
    else {
        CONSOLE_LEVELS.forEach(function (name) {
            logger[name] = function () { return undefined; };
        });
    }
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var logger;
if (_flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h) {
    logger = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .Y)('logger', makeLogger);
}
else {
    logger = makeLogger();
}

//# sourceMappingURL=logger.js.map

/***/ }),

/***/ 70133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "en": function() { return /* binding */ parseUrl; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "rt": function() { return /* binding */ stripUrlQueryAndFragment; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; }
/* harmony export */ });
/* unused harmony exports parseSemver, addContextToFrame */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65949);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66149);
/* harmony import */ var _object__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96702);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-bitwise
        var r = (Math.random() * 16) | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
function getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    var message = event.message, eventId = event.event_id;
    if (message) {
        return message;
    }
    var firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) {
            return firstException.type + ": " + firstException.value;
        }
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
    var exception = (event.exception = event.exception || {});
    var values = (exception.values = exception.values || []);
    var firstException = (values[0] = values[0] || {});
    if (!firstException.value) {
        firstException.value = value || '';
    }
    if (!firstException.type) {
        firstException.type = type || 'Error';
    }
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
    var firstException = getFirstException(event);
    if (!firstException) {
        return;
    }
    var defaultMechanism = { type: 'generic', handled: true };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, (currentMechanism && currentMechanism.data)), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4],
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) { linesOfContext = 5; }
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines
        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
        .map(function (line) { return snipLine(line, 0); });
    frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines
        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
        .map(function (line) { return snipLine(line, 0); });
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) {
        return true;
    }
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0,_object__WEBPACK_IMPORTED_MODULE_2__/* .addNonEnumerableProperty */ .xp)(exception, '__sentry_captured__', true);
    }
    catch (err) {
        // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
//# sourceMappingURL=misc.js.map

/***/ }),

/***/ 12648:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l$": function() { return /* binding */ dynamicRequire; },
  "KV": function() { return /* binding */ isNodeEnv; },
  "$y": function() { return /* binding */ loadModule; }
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/env.js
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */
/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
//# sourceMappingURL=env.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/node.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(14224);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return (!isBrowserBundle() &&
        Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]');
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    }
    catch (e) {
        // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    }
    catch (e) {
        // no-empty
    }
    return mod;
}
//# sourceMappingURL=node.js.map

/***/ }),

/***/ 74526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fv": function() { return /* binding */ normalize; },
  "Qy": function() { return /* binding */ normalizeToSize; }
});

// UNUSED EXPORTS: walk

// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@1.14.1/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(65949);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(83106);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Helper to decycle json objects
 */
function memoBuilder() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) {
                return true;
            }
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (var i = 0; i < inner.length; i++) {
            var value = inner[i];
            if (value === obj) {
                return true;
            }
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) {
            inner.delete(obj);
        }
        else {
            for (var i = 0; i < inner.length; i++) {
                if (inner[i] === obj) {
                    inner.splice(i, 1);
                    break;
                }
            }
        }
    }
    return [memoize, unmemoize];
}
//# sourceMappingURL=memo.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(96702);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(42389);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output..
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
function normalize(input, depth, maxProperties) {
    if (depth === void 0) { depth = +Infinity; }
    if (maxProperties === void 0) { maxProperties = +Infinity; }
    try {
        // since we're at the outermost level, there is no key
        return visit('', input, depth, maxProperties);
    }
    catch (err) {
        return { ERROR: "**non-serializable** (" + err + ")" };
    }
}
/** JSDoc */
function normalizeToSize(object, 
// Default Node.js REPL depth
depth, 
// 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) { depth = 3; }
    if (maxSize === void 0) { maxSize = 100 * 1024; }
    var normalized = normalize(object, depth);
    if (jsonSize(normalized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(key, value, depth, maxProperties, memo) {
    if (depth === void 0) { depth = +Infinity; }
    if (maxProperties === void 0) { maxProperties = +Infinity; }
    if (memo === void 0) { memo = memoBuilder(); }
    var _a = (0,tslib_es6/* __read */.CR)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
        try {
            return valueWithToJSON.toJSON();
        }
        catch (err) {
            // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
        }
    }
    // Get the simple cases out of the way first
    if (value === null || (['number', 'boolean', 'string'].includes(typeof value) && !(0,is/* isNaN */.i2)(value))) {
        return value;
    }
    var stringified = stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) {
        return stringified;
    }
    // We're also done if we've reached the max depth
    if (depth === 0) {
        // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
        return stringified.replace('object ', '');
    }
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) {
        return '[Circular ~]';
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = (Array.isArray(value) ? [] : {});
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = ((0,is/* isError */.VZ)(value) || (0,is/* isEvent */.cO)(value) ? (0,object/* convertToPlainObject */.Sh)(value) : value);
    for (var visitKey in visitable) {
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
            continue;
        }
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = visit(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
// TODO remove this in v7 (this means the method will no longer be exported, under any name)

/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(key, 
// this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) {
            return '[Domain]';
        }
        if (key === 'domainEmitter') {
            return '[DomainEmitter]';
        }
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
            return '[Global]';
        }
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) {
            return '[Window]';
        }
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) {
            return '[Document]';
        }
        // React's SyntheticEvent thingy
        if ((0,is/* isSyntheticEvent */.Cy)(value)) {
            return '[SyntheticEvent]';
        }
        if (typeof value === 'number' && value !== value) {
            return '[NaN]';
        }
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) {
            return '[undefined]';
        }
        if (typeof value === 'function') {
            return "[Function: " + (0,stacktrace/* getFunctionName */.$P)(value) + "]";
        }
        if (typeof value === 'symbol') {
            return "[" + String(value) + "]";
        }
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') {
            return "[BigInt: " + String(value) + "]";
        }
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    }
    catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */
function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
//# sourceMappingURL=normalize.js.map

/***/ }),

/***/ 96702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65949);
/* harmony import */ var _browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42880);
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83106);
/* harmony import */ var _string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80973);




/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') {
        try {
            markFunctionWrapped(wrapped, original);
        }
        catch (_Oo) {
            // This can throw if multiple fill happens on a global object like XMLHttpRequest
            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true,
    });
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
/**
 * Transforms any object into an object literal with all its attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 */
function convertToPlainObject(value) {
    var newObj = value;
    if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isError */ .VZ)(value)) {
        newObj = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ message: value.message, name: value.name, stack: value.stack }, getOwnProperties(value));
    }
    else if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isEvent */ .cO)(value)) {
        var event_1 = value;
        newObj = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ type: event_1.type, target: serializeEventTarget(event_1.target), currentTarget: serializeEventTarget(event_1.currentTarget) }, getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
            newObj.detail = event_1.detail;
        }
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
    try {
        return (0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isElement */ .kK)(target) ? (0,_browser__WEBPACK_IMPORTED_MODULE_2__/* .htmlTreeAsString */ .R)(target) : Object.prototype.toString.call(target);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
    var extractedProps = {};
    for (var property in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, property)) {
            extractedProps[property] = obj[property];
        }
    }
    return extractedProps;
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) { maxLength = 40; }
    var keys = Object.keys(convertToPlainObject(exception));
    keys.sort();
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return (0,_string__WEBPACK_IMPORTED_MODULE_3__/* .truncate */ .$G)(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return (0,_string__WEBPACK_IMPORTED_MODULE_3__/* .truncate */ .$G)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return the new object with removed keys that value was `undefined`.
 * Works recursively on objects and arrays.
 */
function dropUndefinedKeys(val) {
    var e_1, _a;
    if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .PO)(val)) {
        var rv = {};
        try {
            for (var _b = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__values */ .XA)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (typeof val[key] !== 'undefined') {
                    rv[key] = dropUndefinedKeys(val[key]);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return rv;
    }
    if (Array.isArray(val)) {
        return val.map(dropUndefinedKeys);
    }
    return val;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
    var objectified;
    switch (true) {
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case isPrimitive(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
//# sourceMappingURL=object.js.map

/***/ }),

/***/ 42389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "pE": function() { return /* binding */ createStackParser; },
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; }
/* harmony export */ });
/* unused harmony export stripSentryFramesAndReverse */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65949);

var STACKTRACE_LIMIT = 50;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser() {
    var parsers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parsers[_i] = arguments[_i];
    }
    var sortedParsers = parsers.sort(function (a, b) { return a[0] - b[0]; }).map(function (p) { return p[1]; });
    return function (stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) { skipFirst = 0; }
        var frames = [];
        try {
            for (var _c = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__values */ .XA)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var line = _d.value;
                try {
                    for (var sortedParsers_1 = (e_2 = void 0, (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__values */ .XA)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()) {
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return stripSentryFramesAndReverse(frames);
    };
}
/**
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
    if (!stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack
        .slice(0, STACKTRACE_LIMIT)
        .map(function (frame) { return ((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, frame), { filename: frame.filename || localStack[0].filename, function: frame.function || '?' })); })
        .reverse();
}
var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') {
            return defaultFunctionName;
        }
        return fn.name || defaultFunctionName;
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
//# sourceMappingURL=stacktrace.js.map

/***/ }),

/***/ 80973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; },
/* harmony export */   "zC": function() { return /* binding */ isMatchingPattern; }
/* harmony export */ });
/* unused harmony exports snipLine, escapeStringForRegex */
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83106);

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    if (typeof str !== 'string' || max === 0) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) {
        return newLine;
    }
    if (colno > lineLength) {
        // eslint-disable-next-line no-param-reassign
        colno = lineLength;
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) {
        end = lineLength;
    }
    if (end === lineLength) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} " + newLine;
    }
    if (end < lineLength) {
        newLine += ' {snip}';
    }
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
    if (!(0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
        return false;
    }
    if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
        return pattern.test(value);
    }
    if (typeof pattern === 'string') {
        return value.indexOf(pattern) !== -1;
    }
    return false;
}
/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */
function escapeStringForRegex(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
//# sourceMappingURL=string.js.map

/***/ }),

/***/ 47961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": function() { return /* binding */ supportsFetch; },
/* harmony export */   "Du": function() { return /* binding */ isNativeFetch; },
/* harmony export */   "t$": function() { return /* binding */ supportsNativeFetch; },
/* harmony export */   "hv": function() { return /* binding */ supportsReferrerPolicy; },
/* harmony export */   "Bf": function() { return /* binding */ supportsHistory; }
/* harmony export */ });
/* unused harmony exports supportsErrorEvent, supportsDOMError, supportsDOMException, supportsReportingObserver */
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49934);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66149);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43888);



/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
    try {
        new ErrorEvent('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
    try {
        new DOMException('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)())) {
        return false;
    }
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(global.fetch)) {
        return true;
    }
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') {
        try {
            var sandbox = doc.createElement('iframe');
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // eslint-disable-next-line @typescript-eslint/unbound-method
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        }
        catch (err) {
            _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h &&
                _logger__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
        }
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
    return 'ReportingObserver' in getGlobalObject();
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        new Request('_', {
            referrerPolicy: 'origin',
        });
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
//# sourceMappingURL=supports.js.map

/***/ }),

/***/ 1774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83106);
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/typedef */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
    return new SyncPromise(function (resolve) {
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
    return new SyncPromise(function (_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
var SyncPromise = /** @class */ (function () {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */;
        this._handlers = [];
        /** JSDoc */
        this._resolve = function (value) {
            _this._setResult(1 /* RESOLVED */, value);
        };
        /** JSDoc */
        this._reject = function (reason) {
            _this._setResult(2 /* REJECTED */, reason);
        };
        /** JSDoc */
        this._setResult = function (state, value) {
            if (_this._state !== 0 /* PENDING */) {
                return;
            }
            if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
                void value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */
        this._executeHandlers = function () {
            if (_this._state === 0 /* PENDING */) {
                return;
            }
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function (handler) {
                if (handler[0]) {
                    return;
                }
                if (_this._state === 1 /* RESOLVED */) {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    handler[1](_this._value);
                }
                if (_this._state === 2 /* REJECTED */) {
                    handler[2](_this._value);
                }
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        }
        catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */
    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            _this._handlers.push([
                false,
                function (result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                    }
                    else {
                        try {
                            resolve(onfulfilled(result));
                        }
                        catch (e) {
                            reject(e);
                        }
                    }
                },
                function (reason) {
                    if (!onrejected) {
                        reject(reason);
                    }
                    else {
                        try {
                            resolve(onrejected(reason));
                        }
                        catch (e) {
                            reject(e);
                        }
                    }
                },
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */
    SyncPromise.prototype.catch = function (onrejected) {
        return this.then(function (val) { return val; }, onrejected);
    };
    /** JSDoc */
    SyncPromise.prototype.finally = function (onfinally) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function (value) {
                isRejected = false;
                val = value;
                if (onfinally) {
                    onfinally();
                }
            }, function (reason) {
                isRejected = true;
                val = reason;
                if (onfinally) {
                    onfinally();
                }
            }).then(function () {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}());

//# sourceMappingURL=syncpromise.js.map

/***/ }),

/***/ 29939:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "_I": function() { return /* binding */ timestampWithMs; },
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; }
/* harmony export */ });
/* unused harmony exports usingPerformanceAPI, _browserPerformanceTimeOriginMode */
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66149);
/* harmony import */ var _node__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12648);
/* module decorator */ module = __webpack_require__.hmd(module);


/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
var dateTimestampSource = {
    nowSeconds: function () { return Date.now() / 1000; },
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
    var performance = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)().performance;
    if (!performance || !performance.now) {
        return undefined;
    }
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function () { return performance.now(); },
        timeOrigin: timeOrigin,
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
    try {
        var perfHooks = (0,_node__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks');
        return perfHooks.performance;
    }
    catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */
var platformPerformance = (0,_node__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
    };
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
// Re-exported with an old name for backwards-compatibility.
var timestampWithMs = timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
var usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
var _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
var browserPerformanceTimeOrigin = (function () {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600 * 1000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin
        ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
        : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        }
        else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
})();
//# sourceMappingURL=time.js.map

/***/ }),

/***/ 58121:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var _global = (typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"H1Ozn6sBXt3Rs8uQMPC9a"};

/***/ }),

/***/ 10299:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(32790);

/***/ }),

/***/ 72334:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62070);
var settle = __webpack_require__(79669);
var cookies = __webpack_require__(40626);
var buildURL = __webpack_require__(55795);
var buildFullPath = __webpack_require__(98325);
var parseHeaders = __webpack_require__(66244);
var isURLSameOrigin = __webpack_require__(91307);
var createError = __webpack_require__(16171);
var defaults = __webpack_require__(39045);
var Cancel = __webpack_require__(26426);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || defaults.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new Cancel('canceled') : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 32790:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62070);
var bind = __webpack_require__(16908);
var Axios = __webpack_require__(18388);
var mergeConfig = __webpack_require__(2534);
var defaults = __webpack_require__(39045);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(26426);
axios.CancelToken = __webpack_require__(50343);
axios.isCancel = __webpack_require__(4376);
axios.VERSION = (__webpack_require__(16215).version);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(32682);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(32710);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 26426:
/***/ (function(module) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 50343:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(26426);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 4376:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 18388:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62070);
var buildURL = __webpack_require__(55795);
var InterceptorManager = __webpack_require__(91816);
var dispatchRequest = __webpack_require__(36838);
var mergeConfig = __webpack_require__(2534);
var validator = __webpack_require__(56015);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 91816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62070);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 98325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(44108);
var combineURLs = __webpack_require__(21050);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 16171:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(31938);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ 36838:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62070);
var transformData = __webpack_require__(75339);
var isCancel = __webpack_require__(4376);
var defaults = __webpack_require__(39045);
var Cancel = __webpack_require__(26426);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel('canceled');
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 31938:
/***/ (function(module) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};


/***/ }),

/***/ 2534:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62070);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 79669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(16171);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 75339:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62070);
var defaults = __webpack_require__(39045);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 39045:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);


var utils = __webpack_require__(62070);
var normalizeHeaderName = __webpack_require__(17567);
var enhanceError = __webpack_require__(31938);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(72334);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(72334);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 16215:
/***/ (function(module) {

module.exports = {
  "version": "0.24.0"
};

/***/ }),

/***/ 16908:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 55795:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62070);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 21050:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 40626:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62070);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 44108:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 32710:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ 91307:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62070);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 17567:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62070);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 66244:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62070);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 32682:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 56015:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(16215).version);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 62070:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(16908);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ 19803:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 37820:
/***/ (function(module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(14224);
/* eslint-env browser */

/**
 * This is the web browser implementation of `debug()`.
 */

exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (() => {
	let warned = false;

	return () => {
		if (!warned) {
			warned = true;
			console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
		}
	};
})();

/**
 * Colors.
 */

exports.colors = [
	'#0000CC',
	'#0000FF',
	'#0033CC',
	'#0033FF',
	'#0066CC',
	'#0066FF',
	'#0099CC',
	'#0099FF',
	'#00CC00',
	'#00CC33',
	'#00CC66',
	'#00CC99',
	'#00CCCC',
	'#00CCFF',
	'#3300CC',
	'#3300FF',
	'#3333CC',
	'#3333FF',
	'#3366CC',
	'#3366FF',
	'#3399CC',
	'#3399FF',
	'#33CC00',
	'#33CC33',
	'#33CC66',
	'#33CC99',
	'#33CCCC',
	'#33CCFF',
	'#6600CC',
	'#6600FF',
	'#6633CC',
	'#6633FF',
	'#66CC00',
	'#66CC33',
	'#9900CC',
	'#9900FF',
	'#9933CC',
	'#9933FF',
	'#99CC00',
	'#99CC33',
	'#CC0000',
	'#CC0033',
	'#CC0066',
	'#CC0099',
	'#CC00CC',
	'#CC00FF',
	'#CC3300',
	'#CC3333',
	'#CC3366',
	'#CC3399',
	'#CC33CC',
	'#CC33FF',
	'#CC6600',
	'#CC6633',
	'#CC9900',
	'#CC9933',
	'#CCCC00',
	'#CCCC33',
	'#FF0000',
	'#FF0033',
	'#FF0066',
	'#FF0099',
	'#FF00CC',
	'#FF00FF',
	'#FF3300',
	'#FF3333',
	'#FF3366',
	'#FF3399',
	'#FF33CC',
	'#FF33FF',
	'#FF6600',
	'#FF6633',
	'#FF9900',
	'#FF9933',
	'#FFCC00',
	'#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

// eslint-disable-next-line complexity
function useColors() {
	// NB: In an Electron preload script, document will be defined but not fully
	// initialized. Since we know we're in Chrome, we'll just detect this case
	// explicitly
	if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
		return true;
	}

	// Internet Explorer and Edge do not support colors.
	if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
		return false;
	}

	// Is webkit? http://stackoverflow.com/a/16459606/376773
	// document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
		// Is firebug? http://stackoverflow.com/a/398120/376773
		(typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
		// Is firefox >= v31?
		// https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
		// Double check webkit in userAgent just in case we are in a worker
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
	args[0] = (this.useColors ? '%c' : '') +
		this.namespace +
		(this.useColors ? ' %c' : ' ') +
		args[0] +
		(this.useColors ? '%c ' : ' ') +
		'+' + module.exports.humanize(this.diff);

	if (!this.useColors) {
		return;
	}

	const c = 'color: ' + this.color;
	args.splice(1, 0, c, 'color: inherit');

	// The final "%c" is somewhat tricky, because there could be other
	// arguments passed either before or after the %c, so we need to
	// figure out the correct index to insert the CSS into
	let index = 0;
	let lastC = 0;
	args[0].replace(/%[a-zA-Z%]/g, match => {
		if (match === '%%') {
			return;
		}
		index++;
		if (match === '%c') {
			// We only are interested in the *last* %c
			// (the user may have provided their own)
			lastC = index;
		}
	});

	args.splice(lastC, 0, c);
}

/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */
exports.log = console.debug || console.log || (() => {});

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */
function save(namespaces) {
	try {
		if (namespaces) {
			exports.storage.setItem('debug', namespaces);
		} else {
			exports.storage.removeItem('debug');
		}
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */
function load() {
	let r;
	try {
		r = exports.storage.getItem('debug');
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}

	// If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	if (!r && typeof process !== 'undefined' && 'env' in process) {
		r = process.env.DEBUG;
	}

	return r;
}

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
	try {
		// TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
		// The Browser also has localStorage in the global context.
		return localStorage;
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

module.exports = __webpack_require__(18455)(exports);

const {formatters} = module.exports;

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
	try {
		return JSON.stringify(v);
	} catch (error) {
		return '[UnexpectedJSONParseError]: ' + error.message;
	}
};


/***/ }),

/***/ 18455:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */

function setup(env) {
	createDebug.debug = createDebug;
	createDebug.default = createDebug;
	createDebug.coerce = coerce;
	createDebug.disable = disable;
	createDebug.enable = enable;
	createDebug.enabled = enabled;
	createDebug.humanize = __webpack_require__(54610);
	createDebug.destroy = destroy;

	Object.keys(env).forEach(key => {
		createDebug[key] = env[key];
	});

	/**
	* The currently active debug mode names, and names to skip.
	*/

	createDebug.names = [];
	createDebug.skips = [];

	/**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/
	createDebug.formatters = {};

	/**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/
	function selectColor(namespace) {
		let hash = 0;

		for (let i = 0; i < namespace.length; i++) {
			hash = ((hash << 5) - hash) + namespace.charCodeAt(i);
			hash |= 0; // Convert to 32bit integer
		}

		return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
	}
	createDebug.selectColor = selectColor;

	/**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/
	function createDebug(namespace) {
		let prevTime;
		let enableOverride = null;
		let namespacesCache;
		let enabledCache;

		function debug(...args) {
			// Disabled?
			if (!debug.enabled) {
				return;
			}

			const self = debug;

			// Set `diff` timestamp
			const curr = Number(new Date());
			const ms = curr - (prevTime || curr);
			self.diff = ms;
			self.prev = prevTime;
			self.curr = curr;
			prevTime = curr;

			args[0] = createDebug.coerce(args[0]);

			if (typeof args[0] !== 'string') {
				// Anything else let's inspect with %O
				args.unshift('%O');
			}

			// Apply any `formatters` transformations
			let index = 0;
			args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
				// If we encounter an escaped % then don't increase the array index
				if (match === '%%') {
					return '%';
				}
				index++;
				const formatter = createDebug.formatters[format];
				if (typeof formatter === 'function') {
					const val = args[index];
					match = formatter.call(self, val);

					// Now we need to remove `args[index]` since it's inlined in the `format`
					args.splice(index, 1);
					index--;
				}
				return match;
			});

			// Apply env-specific formatting (colors, etc.)
			createDebug.formatArgs.call(self, args);

			const logFn = self.log || createDebug.log;
			logFn.apply(self, args);
		}

		debug.namespace = namespace;
		debug.useColors = createDebug.useColors();
		debug.color = createDebug.selectColor(namespace);
		debug.extend = extend;
		debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.

		Object.defineProperty(debug, 'enabled', {
			enumerable: true,
			configurable: false,
			get: () => {
				if (enableOverride !== null) {
					return enableOverride;
				}
				if (namespacesCache !== createDebug.namespaces) {
					namespacesCache = createDebug.namespaces;
					enabledCache = createDebug.enabled(namespace);
				}

				return enabledCache;
			},
			set: v => {
				enableOverride = v;
			}
		});

		// Env-specific initialization logic for debug instances
		if (typeof createDebug.init === 'function') {
			createDebug.init(debug);
		}

		return debug;
	}

	function extend(namespace, delimiter) {
		const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
		newDebug.log = this.log;
		return newDebug;
	}

	/**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/
	function enable(namespaces) {
		createDebug.save(namespaces);
		createDebug.namespaces = namespaces;

		createDebug.names = [];
		createDebug.skips = [];

		let i;
		const split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
		const len = split.length;

		for (i = 0; i < len; i++) {
			if (!split[i]) {
				// ignore empty strings
				continue;
			}

			namespaces = split[i].replace(/\*/g, '.*?');

			if (namespaces[0] === '-') {
				createDebug.skips.push(new RegExp('^' + namespaces.slice(1) + '$'));
			} else {
				createDebug.names.push(new RegExp('^' + namespaces + '$'));
			}
		}
	}

	/**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/
	function disable() {
		const namespaces = [
			...createDebug.names.map(toNamespace),
			...createDebug.skips.map(toNamespace).map(namespace => '-' + namespace)
		].join(',');
		createDebug.enable('');
		return namespaces;
	}

	/**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/
	function enabled(name) {
		if (name[name.length - 1] === '*') {
			return true;
		}

		let i;
		let len;

		for (i = 0, len = createDebug.skips.length; i < len; i++) {
			if (createDebug.skips[i].test(name)) {
				return false;
			}
		}

		for (i = 0, len = createDebug.names.length; i < len; i++) {
			if (createDebug.names[i].test(name)) {
				return true;
			}
		}

		return false;
	}

	/**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/
	function toNamespace(regexp) {
		return regexp.toString()
			.substring(2, regexp.toString().length - 2)
			.replace(/\.\*\?$/, '*');
	}

	/**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/
	function coerce(val) {
		if (val instanceof Error) {
			return val.stack || val.message;
		}
		return val;
	}

	/**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/
	function destroy() {
		console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
	}

	createDebug.enable(createDebug.load());

	return createDebug;
}

module.exports = setup;


/***/ }),

/***/ 22853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports optionsSupported, onceSupported */
/* harmony import */ var _canUseDOM__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62762);
/* eslint-disable no-return-assign */

var optionsSupported = false;
var onceSupported = false;

try {
  var options = {
    get passive() {
      return optionsSupported = true;
    },

    get once() {
      // eslint-disable-next-line no-multi-assign
      return onceSupported = optionsSupported = true;
    }

  };

  if (_canUseDOM__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z) {
    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, true);
  }
} catch (e) {
  /* */
}

/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function addEventListener(node, eventName, handler, options) {
  if (options && typeof options !== 'boolean' && !onceSupported) {
    var once = options.once,
        capture = options.capture;
    var wrappedHandler = handler;

    if (!onceSupported && once) {
      wrappedHandler = handler.__once || function onceHandler(event) {
        this.removeEventListener(eventName, onceHandler, capture);
        handler.call(this, event);
      };

      handler.__once = wrappedHandler;
    }

    node.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
  }

  node.addEventListener(eventName, handler, options);
}

/* harmony default export */ __webpack_exports__["ZP"] = (addEventListener);

/***/ }),

/***/ 62762:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = (!!(typeof window !== 'undefined' && window.document && window.document.createElement));

/***/ }),

/***/ 26712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ contains; }
/* harmony export */ });
/* eslint-disable no-bitwise, no-cond-assign */

/**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */
function contains(context, node) {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  if (context.contains) return context.contains(node);
  if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

/***/ }),

/***/ 20968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ css; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/ownerDocument.js
var ownerDocument = __webpack_require__(78342);
;// CONCATENATED MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/ownerWindow.js

/**
 * Returns the owner window of a given element.
 * 
 * @param node the element
 */

function ownerWindow(node) {
  var doc = (0,ownerDocument/* default */.Z)(node);
  return doc && doc.defaultView || window;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/getComputedStyle.js

/**
 * Returns one or all computed style properties of an element.
 * 
 * @param node the element
 * @param psuedoElement the style property
 */

function getComputedStyle(node, psuedoElement) {
  return ownerWindow(node).getComputedStyle(node, psuedoElement);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/hyphenate.js
var rUpper = /([A-Z])/g;
function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/hyphenateStyle.js
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */

var msPattern = /^ms-/;
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/isTransform.js
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function isTransform(value) {
  return !!(value && supportedTransforms.test(value));
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/css.js




function style(node, property) {
  var css = '';
  var transforms = '';

  if (typeof property === 'string') {
    return node.style.getPropertyValue(hyphenateStyleName(property)) || getComputedStyle(node).getPropertyValue(hyphenateStyleName(property));
  }

  Object.keys(property).forEach(function (key) {
    var value = property[key];

    if (!value && value !== 0) {
      node.style.removeProperty(hyphenateStyleName(key));
    } else if (isTransform(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += hyphenateStyleName(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += "transform: " + transforms + ";";
  }

  node.style.cssText += ";" + css;
}

/* harmony default export */ var css = (style);

/***/ }),

/***/ 99523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ hasClass; }
/* harmony export */ });
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/***/ }),

/***/ 17692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _addEventListener__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22853);
/* harmony import */ var _removeEventListener__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97877);



function listen(node, eventName, handler, options) {
  (0,_addEventListener__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(node, eventName, handler, options);
  return function () {
    (0,_removeEventListener__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(node, eventName, handler, options);
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (listen);

/***/ }),

/***/ 78342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerDocument; }
/* harmony export */ });
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

/***/ }),

/***/ 83465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ qsa; }
/* harmony export */ });
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
/**
 * Runs `querySelectorAll` on a given element.
 * 
 * @param element the element
 * @param selector the selector
 */

function qsa(element, selector) {
  return toArray(element.querySelectorAll(selector));
}

/***/ }),

/***/ 97877:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function removeEventListener(node, eventName, handler, options) {
  var capture = options && typeof options !== 'boolean' ? options.capture : options;
  node.removeEventListener(eventName, handler, capture);

  if (handler.__once) {
    node.removeEventListener(eventName, handler.__once, capture);
  }
}

/* harmony default export */ __webpack_exports__["Z"] = (removeEventListener);

/***/ }),

/***/ 4498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ transitionEnd; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/css.js + 5 modules
var css = __webpack_require__(20968);
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/listen.js
var listen = __webpack_require__(17692);
;// CONCATENATED MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/triggerEvent.js
/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */
function triggerEvent(node, eventName, bubbles, cancelable) {
  if (bubbles === void 0) {
    bubbles = false;
  }

  if (cancelable === void 0) {
    cancelable = true;
  }

  if (node) {
    var event = document.createEvent('HTMLEvents');
    event.initEvent(eventName, bubbles, cancelable);
    node.dispatchEvent(event);
  }
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/transitionEnd.js




function parseDuration(node) {
  var str = (0,css/* default */.Z)(node, 'transitionDuration') || '';
  var mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

function emulateTransitionEnd(element, duration, padding) {
  if (padding === void 0) {
    padding = 5;
  }

  var called = false;
  var handle = setTimeout(function () {
    if (!called) triggerEvent(element, 'transitionend', true);
  }, duration + padding);
  var remove = (0,listen/* default */.Z)(element, 'transitionend', function () {
    called = true;
  }, {
    once: true
  });
  return function () {
    clearTimeout(handle);
    remove();
  };
}

function transitionEnd(element, handler, duration, padding) {
  if (duration == null) duration = parseDuration(element) || 0;
  var removeEmulate = emulateTransitionEnd(element, duration, padding);
  var remove = (0,listen/* default */.Z)(element, 'transitionend', handler);
  return function () {
    removeEmulate();
    remove();
  };
}

/***/ }),

/***/ 3341:
/***/ (function(module) {

"use strict";


// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 72535:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(56237);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 53670:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {}

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),

/***/ 98499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "It": function() { return /* binding */ useImmerAtom; }
});

// UNUSED EXPORTS: atomWithImmer, withImmer

;// CONCATENATED MODULE: ./node_modules/.pnpm/immer@9.0.12/node_modules/immer/dist/immer.esm.js
function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if(false){ var i, o; }throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return"'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return!!n&&!!n[Q]}function t(n){return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var r=Object.getPrototypeOf(n);if(null===r)return!0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!n.constructor[L]||s(n)||v(n))}function e(t){return r(t)||n(23,t),t[Q].t}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n)})):n.forEach((function(t,e){return r(e,t,n)}))}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?(n.delete(r),n.add(t)):n[r]=t}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)?n:(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0),n)}function h(){n(2)}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function m(n,r){tn[n]||(tn[n]=r)}function _(){return true||0,U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r)}function O(n){g(n),n.p.forEach(S),n.p=null}function g(n){n===U&&(U=n.l)}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.O=!0}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.g||b("ES5").S(e,r,o),o?(i[Q].P&&(O(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),O(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o;i(3===e.i?new Set(o):o,(function(r,i){return A(n,e,o,r,i,t)})),x(n,o,!1),t&&n.u&&b("Patches").R(e,t,n.u,n.s)}return e.o}function A(e,i,o,a,c,s){if( false&&0,r(c)){var v=M(e,c,s&&i&&3!==i.i&&!u(i.D,a)?s.concat(a):void 0);if(f(o,a,v),!r(v))return;e.m=!1}if(t(c)&&!y(c)){if(!e.h.F&&e._<1)return;M(e,c),i&&i.A.l||x(e,c)}}function x(n,r,t){void 0===t&&(t=!1),n.h.F&&n.m&&d(r,t)}function z(n,r){var t=n[Q];return(t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t)}}function k(n){n.P||(n.P=!0,n.l&&k(n.l))}function E(n){n.o||(n.o=l(n.t))}function R(n,r,t){var e=s(r)?b("MapSet").N(r,t):v(r)?b("MapSet").T(r,t):n.g?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,D:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return(t?t.A:_()).p.push(e),e}function D(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=F(r,c),u.I=!1}else e=F(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t))})),3===c?new Set(e):e}(e)}function F(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function N(){function t(n,r){var t=s[n];return t?t.enumerable=r:s[n]=t={configurable:!0,enumerable:r,get:function(){var r=this[Q];return false&&0,en.get(r,n)},set:function(r){var t=this[Q]; false&&0,en.set(t,n,r)}},t}function e(n){for(var r=n.length-1;r>=0;r--){var t=n[r][Q];if(!t.P)switch(t.i){case 5:a(t)&&k(t);break;case 4:o(t)&&k(t)}}}function o(n){for(var r=n.t,t=n.k,e=nn(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=r[o];if(void 0===a&&!u(r,o))return!0;var f=t[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return!0}}var v=!!r[Q];return e.length!==nn(r).length+(v?0:1)}function a(n){var r=n.k;if(r.length!==n.t.length)return!0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return!0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return!0;return!1}function f(r){r.O&&n(3,JSON.stringify(p(r)))}var s={};m("ES5",{J:function(n,r){var e=Array.isArray(n),i=function(n,r){if(n){for(var e=Array(r.length),i=0;i<r.length;i++)Object.defineProperty(e,""+i,t(i,!0));return e}var o=rn(r);delete o[Q];for(var u=nn(o),a=0;a<u.length;a++){var f=u[a];o[f]=t(f,n||!!o[f].enumerable)}return Object.create(Object.getPrototypeOf(r),o)}(e,n),o={i:e?5:4,A:r?r.A:_(),P:!1,I:!1,D:{},l:r,t:n,k:i,o:null,O:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,t,o){o?r(t)&&t[Q].A===n&&e(n.p):(n.u&&function n(r){if(r&&"object"==typeof r){var t=r[Q];if(t){var e=t.t,o=t.k,f=t.D,c=t.i;if(4===c)i(o,(function(r){r!==Q&&(void 0!==e[r]||u(e,r)?f[r]||n(o[r]):(f[r]=!0,k(t)))})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,k(t))}));else if(5===c){if(a(t)&&(k(t),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)o.hasOwnProperty(l)||(f[l]=!0),void 0===f[l]&&n(o[l])}}}}(n.p[0]),e(n.p))},K:function(n){return 4===n.i?o(n):a(n)}})}function T(){function e(n){if(!t(n))return n;if(Array.isArray(n))return n.map(e);if(s(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],e(n[1])]})));if(v(n))return new Set(Array.from(n).map(e));var r=Object.create(Object.getPrototypeOf(n));for(var i in n)r[i]=e(n[i]);return u(n,L)&&(r[L]=n[L]),r}function f(n){return r(n)?e(n):n}var c="add";m("Patches",{$:function(r,t){return t.forEach((function(t){for(var i=t.path,u=t.op,f=r,s=0;s<i.length-1;s++){var v=o(f),p=""+i[s];0!==v&&1!==v||"__proto__"!==p&&"constructor"!==p||n(24),"function"==typeof f&&"prototype"===p&&n(24),"object"!=typeof(f=a(f,p))&&n(15,i.join("/"))}var l=o(f),d=e(t.value),h=i[i.length-1];switch(u){case"replace":switch(l){case 2:return f.set(h,d);case 3:n(16);default:return f[h]=d}case c:switch(l){case 1:return"-"===h?f.push(d):f.splice(h,0,d);case 2:return f.set(h,d);case 3:return f.add(d);default:return f[h]=d}case"remove":switch(l){case 1:return f.splice(h,1);case 2:return f.delete(h);case 3:return f.delete(t.value);default:return delete f[h]}default:n(17,u)}})),r},R:function(n,r,t,e){switch(n.i){case 0:case 4:case 2:return function(n,r,t,e){var o=n.t,s=n.o;i(n.D,(function(n,i){var v=a(o,n),p=a(s,n),l=i?u(o,n)?"replace":c:"remove";if(v!==p||"replace"!==l){var d=r.concat(n);t.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),e.push(l===c?{op:"remove",path:d}:"remove"===l?{op:c,path:d,value:f(v)}:{op:"replace",path:d,value:f(v)})}}))}(n,r,t,e);case 5:case 1:return function(n,r,t,e){var i=n.t,o=n.D,u=n.o;if(u.length<i.length){var a=[u,i];i=a[0],u=a[1];var s=[e,t];t=s[0],e=s[1]}for(var v=0;v<i.length;v++)if(o[v]&&u[v]!==i[v]){var p=r.concat([v]);t.push({op:"replace",path:p,value:f(u[v])}),e.push({op:"replace",path:p,value:f(i[v])})}for(var l=i.length;l<u.length;l++){var d=r.concat([l]);t.push({op:c,path:d,value:f(u[l])})}i.length<u.length&&e.push({op:"replace",path:r.concat(["length"]),value:i.length})}(n,r,t,e);case 3:return function(n,r,t,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=r.concat([u]);t.push({op:"remove",path:i,value:n}),e.unshift({op:c,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=r.concat([u]);t.push({op:c,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,r,t,e)}},M:function(n,r,t,e){t.push({op:"replace",path:[],value:r===H?void 0:r}),e.push({op:"replace",path:[],value:n})}})}function C(){function r(n,r){function t(){this.constructor=n}a(n,r),n.prototype=(t.prototype=r.prototype,new t)}function e(n){n.o||(n.D=new Map,n.o=new Map(n.t))}function o(n){n.o||(n.o=new Set,n.t.forEach((function(r){if(t(r)){var e=R(n.A.h,r,n);n.p.set(r,e),n.o.add(e)}else n.o.add(r)})))}function u(r){r.O&&n(3,JSON.stringify(p(r)))}var a=function(n,r){return(a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,r){n.__proto__=r}||function(n,r){for(var t in r)r.hasOwnProperty(t)&&(n[t]=r[t])})(n,r)},f=function(){function n(n,r){return this[Q]={i:2,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,D:void 0,t:n,k:this,C:!1,O:!1},this}r(n,Map);var o=n.prototype;return Object.defineProperty(o,"size",{get:function(){return p(this[Q]).size}}),o.has=function(n){return p(this[Q]).has(n)},o.set=function(n,r){var t=this[Q];return u(t),p(t).has(n)&&p(t).get(n)===r||(e(t),k(t),t.D.set(n,!0),t.o.set(n,r),t.D.set(n,!0)),this},o.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),e(r),k(r),r.t.has(n)?r.D.set(n,!1):r.D.delete(n),r.o.delete(n),!0},o.clear=function(){var n=this[Q];u(n),p(n).size&&(e(n),k(n),n.D=new Map,i(n.t,(function(r){n.D.set(r,!1)})),n.o.clear())},o.forEach=function(n,r){var t=this;p(this[Q]).forEach((function(e,i){n.call(r,t.get(i),i,t)}))},o.get=function(n){var r=this[Q];u(r);var i=p(r).get(n);if(r.I||!t(i))return i;if(i!==r.t.get(n))return i;var o=R(r.A.h,i,r);return e(r),r.o.set(n,o),o},o.keys=function(){return p(this[Q]).keys()},o.values=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.values()},n.next=function(){var n=t.next();return n.done?n:{done:!1,value:r.get(n.value)}},n},o.entries=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.entries()},n.next=function(){var n=t.next();if(n.done)return n;var e=r.get(n.value);return{done:!1,value:[n.value,e]}},n},o[V]=function(){return this.entries()},n}(),c=function(){function n(n,r){return this[Q]={i:3,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,O:!1,C:!1},this}r(n,Set);var t=n.prototype;return Object.defineProperty(t,"size",{get:function(){return p(this[Q]).size}}),t.has=function(n){var r=this[Q];return u(r),r.o?!!r.o.has(n)||!(!r.p.has(n)||!r.o.has(r.p.get(n))):r.t.has(n)},t.add=function(n){var r=this[Q];return u(r),this.has(n)||(o(r),k(r),r.o.add(n)),this},t.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),o(r),k(r),r.o.delete(n)||!!r.p.has(n)&&r.o.delete(r.p.get(n))},t.clear=function(){var n=this[Q];u(n),p(n).size&&(o(n),k(n),n.o.clear())},t.values=function(){var n=this[Q];return u(n),o(n),n.o.values()},t.entries=function(){var n=this[Q];return u(n),o(n),n.o.entries()},t.keys=function(){return this.values()},t[V]=function(){return this.values()},t.forEach=function(n,r){for(var t=this.values(),e=t.next();!e.done;)n.call(r,e.value,e.value,this),e=t.next()},n}();m("MapSet",{N:function(n,r){return new f(n,r)},T:function(n,r){return new c(n,r)}})}function J(){N(),C(),T()}function K(n){return n}function $(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",V="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return"produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return"'current' expects a draft, got: "+n},23:function(n){return"'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t)})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=R(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.D[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return!0;E(n),k(n)}return n.o[r]===t&&"number"!=typeof t&&(void 0!==t||r in n.o)||(n.o[r]=t,n.D[r]=!0,!0)},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.D[r]=!1,E(n),k(n)):delete n.D[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)}})),on.deleteProperty=function(r,t){return false&&0,on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return false&&0,en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.g=B,this.F=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return(t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=R(e,r,void 0),v=!0;try{f=i(s),v=!1}finally{v?O(c):g(c)}return"undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw O(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.F&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l)}return f}n(21,r)},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r}));return"undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return[n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze)}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=D(e));var i=w(this),o=R(this,e,void 0);return o[Q].C=!0,g(i),o},i.finishDraft=function(r,t){var e=r&&r[Q]; false&&(0);var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.F=n},i.setUseProxies=function(r){r&&!B&&n(20),this.g=r},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,immer_esm_fn=an.produce,cn=an.produceWithPatches.bind(an),sn=an.setAutoFreeze.bind(an),vn=an.setUseProxies.bind(an),pn=an.applyPatches.bind(an),ln=an.createDraft.bind(an),dn=an.finishDraft.bind(an);/* harmony default export */ var immer_esm = ((/* unused pure expression or super */ null && (immer_esm_fn)));
//# sourceMappingURL=immer.esm.js.map

// EXTERNAL MODULE: ./node_modules/.pnpm/jotai@1.6.1_zrsyqg6kfmuxkmxyjtbkl6ldiu/node_modules/jotai/esm/index.js
var esm = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
;// CONCATENATED MODULE: ./node_modules/.pnpm/jotai@1.6.1_zrsyqg6kfmuxkmxyjtbkl6ldiu/node_modules/jotai/esm/immer.js




function atomWithImmer(initialValue) {
  const anAtom = atom(initialValue, (get, set, fn) => set(anAtom, produce(get(anAtom), typeof fn === "function" ? fn : () => fn)));
  return anAtom;
}

function useImmerAtom(anAtom, scope) {
  const [state, setState] = (0,esm/* useAtom */.KO)(anAtom, scope);
  const setStateWithImmer = (0,react.useCallback)((fn) => setState(immer_esm_fn((draft) => fn(draft))), [setState]);
  return [state, setStateWithImmer];
}

const getWeakCacheItem = (cache, deps) => {
  do {
    const [dep, ...rest] = deps;
    const entry = cache.get(dep);
    if (!entry) {
      return;
    }
    if (!rest.length) {
      return entry[1];
    }
    cache = entry[0];
    deps = rest;
  } while (deps.length);
};
const setWeakCacheItem = (cache, deps, item) => {
  do {
    const [dep, ...rest] = deps;
    let entry = cache.get(dep);
    if (!entry) {
      entry = [ new WeakMap()];
      cache.set(dep, entry);
    }
    if (!rest.length) {
      entry[1] = item;
      return;
    }
    cache = entry[0];
    deps = rest;
  } while (deps.length);
};
const createMemoizeAtom = () => {
  const cache = /* @__PURE__ */ new WeakMap();
  const memoizeAtom = (createAtom, deps) => {
    const cachedAtom = getWeakCacheItem(cache, deps);
    if (cachedAtom) {
      return cachedAtom;
    }
    const createdAtom = createAtom();
    setWeakCacheItem(cache, deps, createdAtom);
    return createdAtom;
  };
  return memoizeAtom;
};

const memoizeAtom = createMemoizeAtom();
function withImmer(anAtom) {
  return memoizeAtom(() => {
    const derivedAtom = atom((get) => get(anAtom), (get, set, fn) => set(anAtom, produce(get(anAtom), typeof fn === "function" ? fn : () => fn)));
    return derivedAtom;
  }, [anAtom]);
}




/***/ }),

/***/ 7997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aQ": function() { return /* binding */ getScopeContext; },
/* harmony export */   "cn": function() { return /* binding */ atom; },
/* harmony export */   "KO": function() { return /* binding */ useAtom; }
/* harmony export */ });
/* unused harmony exports Provider, unstable_createStore, useAtomValue, useSetAtom */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* provided dependency */ var process = __webpack_require__(14224);


const SUSPENSE_PROMISE = Symbol();
const isSuspensePromise = (promise) => !!promise[SUSPENSE_PROMISE];
const isSuspensePromiseAlreadyCancelled = (suspensePromise) => !suspensePromise[SUSPENSE_PROMISE].c;
const cancelSuspensePromise = (suspensePromise) => {
  var _a, _b;
  (_b = (_a = suspensePromise[SUSPENSE_PROMISE]).c) == null ? void 0 : _b.call(_a);
};
const isEqualSuspensePromise = (oldSuspensePromise, newSuspensePromise) => {
  const oldOriginalPromise = oldSuspensePromise[SUSPENSE_PROMISE].o;
  const newOriginalPromise = newSuspensePromise[SUSPENSE_PROMISE].o;
  return oldOriginalPromise === newOriginalPromise || oldSuspensePromise === newOriginalPromise || isSuspensePromise(oldOriginalPromise) && isEqualSuspensePromise(oldOriginalPromise, newSuspensePromise);
};
const createSuspensePromise = (promise) => {
  const objectToAttach = {
    o: promise,
    c: null
  };
  const suspensePromise = new Promise((resolve) => {
    objectToAttach.c = () => {
      objectToAttach.c = null;
      resolve();
    };
    promise.then(objectToAttach.c, objectToAttach.c);
  });
  suspensePromise[SUSPENSE_PROMISE] = objectToAttach;
  return suspensePromise;
};

var __defProp$1 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
const hasInitialValue = (atom) => "init" in atom;
const READ_ATOM = "r";
const WRITE_ATOM = "w";
const COMMIT_ATOM = "c";
const SUBSCRIBE_ATOM = "s";
const RESTORE_ATOMS = "h";
const DEV_SUBSCRIBE_STATE = "n";
const DEV_GET_MOUNTED_ATOMS = "l";
const DEV_GET_ATOM_STATE = "a";
const DEV_GET_MOUNTED = "m";
const createStore = (initialValues) => {
  const committedAtomStateMap = /* @__PURE__ */ new WeakMap();
  const mountedMap = /* @__PURE__ */ new WeakMap();
  const pendingMap = /* @__PURE__ */ new Map();
  let stateListeners;
  let mountedAtoms;
  if (true) {
    stateListeners = /* @__PURE__ */ new Set();
    mountedAtoms = /* @__PURE__ */ new Set();
  }
  if (initialValues) {
    for (const [atom, value] of initialValues) {
      const atomState = { v: value, r: 0, d: /* @__PURE__ */ new Map() };
      if (true) {
        Object.freeze(atomState);
        if (!hasInitialValue(atom)) {
          console.warn("Found initial value for derived atom which can cause unexpected behavior", atom);
        }
      }
      committedAtomStateMap.set(atom, atomState);
    }
  }
  const suspensePromiseCacheMap = /* @__PURE__ */ new WeakMap();
  const addSuspensePromiseToCache = (version, atom, suspensePromise) => {
    let cache = suspensePromiseCacheMap.get(atom);
    if (!cache) {
      cache = /* @__PURE__ */ new Map();
      suspensePromiseCacheMap.set(atom, cache);
    }
    suspensePromise.then(() => {
      if (cache.get(version) === suspensePromise) {
        cache.delete(version);
        if (!cache.size) {
          suspensePromiseCacheMap.delete(atom);
        }
      }
    });
    cache.set(version, suspensePromise);
  };
  const cancelAllSuspensePromiseInCache = (atom) => {
    const versionSet = /* @__PURE__ */ new Set();
    const cache = suspensePromiseCacheMap.get(atom);
    if (cache) {
      suspensePromiseCacheMap.delete(atom);
      cache.forEach((suspensePromise, version) => {
        cancelSuspensePromise(suspensePromise);
        versionSet.add(version);
      });
    }
    return versionSet;
  };
  const versionedAtomStateMapMap = /* @__PURE__ */ new WeakMap();
  const getVersionedAtomStateMap = (version) => {
    let versionedAtomStateMap = versionedAtomStateMapMap.get(version);
    if (!versionedAtomStateMap) {
      versionedAtomStateMap = /* @__PURE__ */ new Map();
      versionedAtomStateMapMap.set(version, versionedAtomStateMap);
    }
    return versionedAtomStateMap;
  };
  const getAtomState = (version, atom) => {
    if (version) {
      const versionedAtomStateMap = getVersionedAtomStateMap(version);
      let atomState = versionedAtomStateMap.get(atom);
      if (!atomState) {
        atomState = getAtomState(version.p, atom);
        if (atomState) {
          if ("p" in atomState) {
            atomState.p.then(() => versionedAtomStateMap.delete(atom));
          }
          versionedAtomStateMap.set(atom, atomState);
        }
      }
      return atomState;
    }
    return committedAtomStateMap.get(atom);
  };
  const setAtomState = (version, atom, atomState) => {
    if (true) {
      Object.freeze(atomState);
    }
    if (version) {
      const versionedAtomStateMap = getVersionedAtomStateMap(version);
      versionedAtomStateMap.set(atom, atomState);
    } else {
      const prevAtomState = committedAtomStateMap.get(atom);
      committedAtomStateMap.set(atom, atomState);
      if (!pendingMap.has(atom)) {
        pendingMap.set(atom, prevAtomState);
      }
    }
  };
  const createReadDependencies = (version, prevReadDependencies = /* @__PURE__ */ new Map(), dependencies) => {
    if (!dependencies) {
      return prevReadDependencies;
    }
    const readDependencies = /* @__PURE__ */ new Map();
    let changed = false;
    dependencies.forEach((atom) => {
      var _a;
      const revision = ((_a = getAtomState(version, atom)) == null ? void 0 : _a.r) || 0;
      readDependencies.set(atom, revision);
      if (prevReadDependencies.get(atom) !== revision) {
        changed = true;
      }
    });
    if (prevReadDependencies.size === readDependencies.size && !changed) {
      return prevReadDependencies;
    }
    return readDependencies;
  };
  const setAtomValue = (version, atom, value, dependencies, suspensePromise) => {
    const atomState = getAtomState(version, atom);
    if (atomState) {
      if (suspensePromise && (!("p" in atomState) || !isEqualSuspensePromise(atomState.p, suspensePromise))) {
        return atomState;
      }
      if ("p" in atomState) {
        cancelSuspensePromise(atomState.p);
      }
    }
    const nextAtomState = {
      v: value,
      r: (atomState == null ? void 0 : atomState.r) || 0,
      d: createReadDependencies(version, atomState == null ? void 0 : atomState.d, dependencies)
    };
    if (!atomState || !("v" in atomState) || !Object.is(atomState.v, value)) {
      ++nextAtomState.r;
      if (nextAtomState.d.has(atom)) {
        nextAtomState.d = new Map(nextAtomState.d).set(atom, nextAtomState.r);
      }
    } else if (nextAtomState.d !== atomState.d && (nextAtomState.d.size !== atomState.d.size || !Array.from(nextAtomState.d.keys()).every((a) => atomState.d.has(a)))) {
      Promise.resolve().then(() => {
        flushPending(version);
      });
    }
    setAtomState(version, atom, nextAtomState);
    return nextAtomState;
  };
  const setAtomReadError = (version, atom, error, dependencies, suspensePromise) => {
    const atomState = getAtomState(version, atom);
    if (atomState) {
      if (suspensePromise && (!("p" in atomState) || !isEqualSuspensePromise(atomState.p, suspensePromise))) {
        return atomState;
      }
      if ("p" in atomState) {
        cancelSuspensePromise(atomState.p);
      }
    }
    const nextAtomState = {
      e: error,
      r: (atomState == null ? void 0 : atomState.r) || 0,
      d: createReadDependencies(version, atomState == null ? void 0 : atomState.d, dependencies)
    };
    setAtomState(version, atom, nextAtomState);
    return nextAtomState;
  };
  const setAtomSuspensePromise = (version, atom, suspensePromise, dependencies) => {
    const atomState = getAtomState(version, atom);
    if (atomState && "p" in atomState) {
      if (isEqualSuspensePromise(atomState.p, suspensePromise)) {
        return atomState;
      }
      cancelSuspensePromise(atomState.p);
    }
    addSuspensePromiseToCache(version, atom, suspensePromise);
    const nextAtomState = {
      p: suspensePromise,
      r: (atomState == null ? void 0 : atomState.r) || 0,
      d: createReadDependencies(version, atomState == null ? void 0 : atomState.d, dependencies)
    };
    setAtomState(version, atom, nextAtomState);
    return nextAtomState;
  };
  const setAtomPromiseOrValue = (version, atom, promiseOrValue, dependencies) => {
    if (promiseOrValue instanceof Promise) {
      const suspensePromise = createSuspensePromise(promiseOrValue.then((value) => {
        setAtomValue(version, atom, value, dependencies, suspensePromise);
        flushPending(version);
      }).catch((e) => {
        if (e instanceof Promise) {
          if (isSuspensePromise(e)) {
            return e.then(() => {
              readAtomState(version, atom, true);
            });
          }
          return e;
        }
        setAtomReadError(version, atom, e, dependencies, suspensePromise);
        flushPending(version);
      }));
      return setAtomSuspensePromise(version, atom, suspensePromise, dependencies);
    }
    return setAtomValue(version, atom, promiseOrValue, dependencies);
  };
  const setAtomInvalidated = (version, atom) => {
    const atomState = getAtomState(version, atom);
    if (atomState) {
      const nextAtomState = __spreadProps$1(__spreadValues$1({}, atomState), {
        i: atomState.r
      });
      setAtomState(version, atom, nextAtomState);
    } else if (true) {
      console.warn("[Bug] could not invalidate non existing atom", atom);
    }
  };
  const readAtomState = (version, atom, force) => {
    if (!force) {
      const atomState = getAtomState(version, atom);
      if (atomState) {
        if (atomState.r !== atomState.i && "p" in atomState && !isSuspensePromiseAlreadyCancelled(atomState.p)) {
          return atomState;
        }
        atomState.d.forEach((_, a) => {
          if (a !== atom) {
            if (!mountedMap.has(a)) {
              readAtomState(version, a);
            } else {
              const aState = getAtomState(version, a);
              if (aState && aState.r === aState.i) {
                readAtomState(version, a);
              }
            }
          }
        });
        if (Array.from(atomState.d).every(([a, r]) => {
          const aState = getAtomState(version, a);
          return aState && "v" in aState && aState.r === r;
        })) {
          return atomState;
        }
      }
    }
    const dependencies = /* @__PURE__ */ new Set();
    try {
      const promiseOrValue = atom.read((a) => {
        dependencies.add(a);
        const aState = a === atom ? getAtomState(version, a) : readAtomState(version, a);
        if (aState) {
          if ("e" in aState) {
            throw aState.e;
          }
          if ("p" in aState) {
            throw aState.p;
          }
          return aState.v;
        }
        if (hasInitialValue(a)) {
          return a.init;
        }
        throw new Error("no atom init");
      });
      return setAtomPromiseOrValue(version, atom, promiseOrValue, dependencies);
    } catch (errorOrPromise) {
      if (errorOrPromise instanceof Promise) {
        const suspensePromise = createSuspensePromise(errorOrPromise);
        return setAtomSuspensePromise(version, atom, suspensePromise, dependencies);
      }
      return setAtomReadError(version, atom, errorOrPromise, dependencies);
    }
  };
  const readAtom = (readingAtom, version) => {
    const atomState = readAtomState(version, readingAtom);
    return atomState;
  };
  const addAtom = (addingAtom) => {
    let mounted = mountedMap.get(addingAtom);
    if (!mounted) {
      mounted = mountAtom(addingAtom);
    }
    return mounted;
  };
  const canUnmountAtom = (atom, mounted) => !mounted.l.size && (!mounted.t.size || mounted.t.size === 1 && mounted.t.has(atom));
  const delAtom = (deletingAtom) => {
    const mounted = mountedMap.get(deletingAtom);
    if (mounted && canUnmountAtom(deletingAtom, mounted)) {
      unmountAtom(deletingAtom);
    }
  };
  const invalidateDependents = (version, atom) => {
    const mounted = mountedMap.get(atom);
    mounted == null ? void 0 : mounted.t.forEach((dependent) => {
      if (dependent !== atom) {
        setAtomInvalidated(version, dependent);
        invalidateDependents(version, dependent);
      }
    });
  };
  const writeAtomState = (version, atom, update) => {
    let isSync = true;
    const writeGetter = (a, options) => {
      const aState = readAtomState(version, a);
      if ("e" in aState) {
        throw aState.e;
      }
      if ("p" in aState) {
        if (options == null ? void 0 : options.unstable_promise) {
          return aState.p.then(() => writeGetter(a, options));
        }
        if (true) {
          console.info("Reading pending atom state in write operation. We throw a promise for now.", a);
        }
        throw aState.p;
      }
      if ("v" in aState) {
        return aState.v;
      }
      if (true) {
        console.warn("[Bug] no value found while reading atom in write operation. This is probably a bug.", a);
      }
      throw new Error("no value found");
    };
    const setter = (a, v) => {
      let promiseOrVoid2;
      if (a === atom) {
        if (!hasInitialValue(a)) {
          throw new Error("atom not writable");
        }
        const versionSet = cancelAllSuspensePromiseInCache(a);
        versionSet.forEach((cancelledVersion) => {
          if (cancelledVersion !== version) {
            setAtomPromiseOrValue(cancelledVersion, a, v);
          }
        });
        setAtomPromiseOrValue(version, a, v);
        invalidateDependents(version, a);
      } else {
        promiseOrVoid2 = writeAtomState(version, a, v);
      }
      if (!isSync) {
        flushPending(version);
      }
      return promiseOrVoid2;
    };
    const promiseOrVoid = atom.write(writeGetter, setter, update);
    isSync = false;
    version = void 0;
    return promiseOrVoid;
  };
  const writeAtom = (writingAtom, update, version) => {
    const promiseOrVoid = writeAtomState(version, writingAtom, update);
    flushPending(version);
    return promiseOrVoid;
  };
  const isActuallyWritableAtom = (atom) => !!atom.write;
  const mountAtom = (atom, initialDependent) => {
    const mounted = {
      t: new Set(initialDependent && [initialDependent]),
      l: /* @__PURE__ */ new Set()
    };
    mountedMap.set(atom, mounted);
    if (true) {
      mountedAtoms.add(atom);
    }
    const atomState = readAtomState(void 0, atom);
    atomState.d.forEach((_, a) => {
      const aMounted = mountedMap.get(a);
      if (aMounted) {
        aMounted.t.add(atom);
      } else {
        if (a !== atom) {
          mountAtom(a, atom);
        }
      }
    });
    if (isActuallyWritableAtom(atom) && atom.onMount) {
      const setAtom = (update) => writeAtom(atom, update);
      const onUnmount = atom.onMount(setAtom);
      if (onUnmount) {
        mounted.u = onUnmount;
      }
    }
    return mounted;
  };
  const unmountAtom = (atom) => {
    var _a;
    const onUnmount = (_a = mountedMap.get(atom)) == null ? void 0 : _a.u;
    if (onUnmount) {
      onUnmount();
    }
    mountedMap.delete(atom);
    if (true) {
      mountedAtoms.delete(atom);
    }
    const atomState = getAtomState(void 0, atom);
    if (atomState) {
      atomState.d.forEach((_, a) => {
        if (a !== atom) {
          const mounted = mountedMap.get(a);
          if (mounted) {
            mounted.t.delete(atom);
            if (canUnmountAtom(a, mounted)) {
              unmountAtom(a);
            }
          }
        }
      });
    } else if (true) {
      console.warn("[Bug] could not find atom state to unmount", atom);
    }
  };
  const mountDependencies = (atom, atomState, prevReadDependencies) => {
    const dependencies = new Set(atomState.d.keys());
    prevReadDependencies == null ? void 0 : prevReadDependencies.forEach((_, a) => {
      if (dependencies.has(a)) {
        dependencies.delete(a);
        return;
      }
      const mounted = mountedMap.get(a);
      if (mounted) {
        mounted.t.delete(atom);
        if (canUnmountAtom(a, mounted)) {
          unmountAtom(a);
        }
      }
    });
    dependencies.forEach((a) => {
      const mounted = mountedMap.get(a);
      if (mounted) {
        mounted.t.add(atom);
      } else if (mountedMap.has(atom)) {
        mountAtom(a, atom);
      }
    });
  };
  const flushPending = (version) => {
    if (version) {
      const versionedAtomStateMap = getVersionedAtomStateMap(version);
      versionedAtomStateMap.forEach((atomState, atom) => {
        if (atomState !== committedAtomStateMap.get(atom)) {
          const mounted = mountedMap.get(atom);
          mounted == null ? void 0 : mounted.l.forEach((listener) => listener(version));
        }
      });
      return;
    }
    while (pendingMap.size) {
      const pending = Array.from(pendingMap);
      pendingMap.clear();
      pending.forEach(([atom, prevAtomState]) => {
        const atomState = getAtomState(void 0, atom);
        if (atomState && atomState.d !== (prevAtomState == null ? void 0 : prevAtomState.d)) {
          mountDependencies(atom, atomState, prevAtomState == null ? void 0 : prevAtomState.d);
        }
        const mounted = mountedMap.get(atom);
        mounted == null ? void 0 : mounted.l.forEach((listener) => listener());
      });
    }
    if (true) {
      stateListeners.forEach((l) => l());
    }
  };
  const commitVersionedAtomStateMap = (version) => {
    const versionedAtomStateMap = getVersionedAtomStateMap(version);
    versionedAtomStateMap.forEach((atomState, atom) => {
      const prevAtomState = committedAtomStateMap.get(atom);
      if (atomState.r > ((prevAtomState == null ? void 0 : prevAtomState.r) || 0) || "v" in atomState && atomState.r === (prevAtomState == null ? void 0 : prevAtomState.r) && atomState.d !== (prevAtomState == null ? void 0 : prevAtomState.d)) {
        committedAtomStateMap.set(atom, atomState);
        if (atomState.d !== (prevAtomState == null ? void 0 : prevAtomState.d)) {
          mountDependencies(atom, atomState, prevAtomState == null ? void 0 : prevAtomState.d);
        }
      }
    });
  };
  const commitAtom = (_atom, version) => {
    if (version) {
      commitVersionedAtomStateMap(version);
    }
    flushPending(void 0);
  };
  const subscribeAtom = (atom, callback) => {
    const mounted = addAtom(atom);
    const listeners = mounted.l;
    listeners.add(callback);
    return () => {
      listeners.delete(callback);
      delAtom(atom);
    };
  };
  const restoreAtoms = (values, version) => {
    for (const [atom, value] of values) {
      if (hasInitialValue(atom)) {
        setAtomPromiseOrValue(version, atom, value);
        invalidateDependents(version, atom);
      }
    }
    flushPending(version);
  };
  if (true) {
    return {
      [READ_ATOM]: readAtom,
      [WRITE_ATOM]: writeAtom,
      [COMMIT_ATOM]: commitAtom,
      [SUBSCRIBE_ATOM]: subscribeAtom,
      [RESTORE_ATOMS]: restoreAtoms,
      [DEV_SUBSCRIBE_STATE]: (l) => {
        stateListeners.add(l);
        return () => {
          stateListeners.delete(l);
        };
      },
      [DEV_GET_MOUNTED_ATOMS]: () => mountedAtoms.values(),
      [DEV_GET_ATOM_STATE]: (a) => committedAtomStateMap.get(a),
      [DEV_GET_MOUNTED]: (a) => mountedMap.get(a)
    };
  }
  return {
    [READ_ATOM]: readAtom,
    [WRITE_ATOM]: writeAtom,
    [COMMIT_ATOM]: commitAtom,
    [SUBSCRIBE_ATOM]: subscribeAtom,
    [RESTORE_ATOMS]: restoreAtoms
  };
};
const createStoreForExport = (initialValues) => {
  const store = createStore(initialValues);
  const get = (atom) => {
    const atomState = store[READ_ATOM](atom);
    if ("e" in atomState) {
      throw atomState.e;
    }
    if ("p" in atomState) {
      return void 0;
    }
    return atomState.v;
  };
  const asyncGet = (atom) => new Promise((resolve, reject) => {
    const atomState = store[READ_ATOM](atom);
    if ("e" in atomState) {
      reject(atomState.e);
    } else if ("p" in atomState) {
      resolve(atomState.p.then(() => asyncGet(atom)));
    } else {
      resolve(atomState.v);
    }
  });
  const set = (atom, update) => store[WRITE_ATOM](atom, update);
  const sub = (atom, callback) => store[SUBSCRIBE_ATOM](atom, callback);
  return {
    get,
    asyncGet,
    set,
    sub,
    SECRET_INTERNAL_store: store
  };
};

const createScopeContainer = (initialValues, unstable_createStore) => {
  const store = unstable_createStore ? unstable_createStore(initialValues).SECRET_INTERNAL_store : createStore(initialValues);
  return { s: store };
};
const ScopeContextMap = /* @__PURE__ */ new Map();
const getScopeContext = (scope) => {
  if (!ScopeContextMap.has(scope)) {
    ScopeContextMap.set(scope, (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(createScopeContainer()));
  }
  return ScopeContextMap.get(scope);
};

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const Provider = ({
  children,
  initialValues,
  scope,
  unstable_createStore,
  unstable_enableVersionedWrite
}) => {
  const [version, setVersion] = useState();
  useEffect(() => {
    if (version) {
      scopeContainerRef.current.s[COMMIT_ATOM](null, version);
      delete version.p;
    }
  }, [version]);
  const scopeContainerRef = useRef();
  if (!scopeContainerRef.current) {
    scopeContainerRef.current = createScopeContainer(initialValues, unstable_createStore);
    if (unstable_enableVersionedWrite) {
      scopeContainerRef.current.w = (write) => {
        setVersion((parentVersion) => {
          const nextVersion = parentVersion ? { p: parentVersion } : {};
          write(nextVersion);
          return nextVersion;
        });
      };
    }
  }
  if ( true && (typeof process !== "object" || "production" !== "test")) {
    useDebugState(scopeContainerRef.current);
  }
  const ScopeContainerContext = getScopeContext(scope);
  return createElement(ScopeContainerContext.Provider, {
    value: scopeContainerRef.current
  }, children);
};
const atomToPrintable = (atom) => atom.debugLabel || atom.toString();
const stateToPrintable = ([store, atoms]) => Object.fromEntries(atoms.flatMap((atom) => {
  var _a, _b;
  const mounted = (_a = store[DEV_GET_MOUNTED]) == null ? void 0 : _a.call(store, atom);
  if (!mounted) {
    return [];
  }
  const dependents = mounted.t;
  const atomState = ((_b = store[DEV_GET_ATOM_STATE]) == null ? void 0 : _b.call(store, atom)) || {};
  return [
    [
      atomToPrintable(atom),
      __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, "e" in atomState && { error: atomState.e }), "p" in atomState && { promise: atomState.p }), "v" in atomState && { value: atomState.v }), {
        dependents: Array.from(dependents).map(atomToPrintable)
      })
    ]
  ];
}));
const useDebugState = (scopeContainer) => {
  const { s: store } = scopeContainer;
  const [atoms, setAtoms] = useState([]);
  useEffect(() => {
    var _a;
    const callback = () => {
      var _a2;
      setAtoms(Array.from(((_a2 = store[DEV_GET_MOUNTED_ATOMS]) == null ? void 0 : _a2.call(store)) || []));
    };
    const unsubscribe = (_a = store[DEV_SUBSCRIBE_STATE]) == null ? void 0 : _a.call(store, callback);
    callback();
    return unsubscribe;
  }, [store]);
  useDebugValue([store, atoms], stateToPrintable);
};

let keyCount = 0;
function atom(read, write) {
  const key = `atom${++keyCount}`;
  const config = {
    toString: () => key
  };
  if (typeof read === "function") {
    config.read = read;
  } else {
    config.init = read;
    config.read = (get) => get(config);
    config.write = (get, set, update) => set(config, typeof update === "function" ? update(get(config)) : update);
  }
  if (write) {
    config.write = write;
  }
  return config;
}

function useAtomValue(atom, scope) {
  const ScopeContext = getScopeContext(scope);
  const { s: store } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ScopeContext);
  const getAtomValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((version2) => {
    const atomState = store[READ_ATOM](atom, version2);
    if ("e" in atomState) {
      throw atomState.e;
    }
    if ("p" in atomState) {
      throw atomState.p;
    }
    if ("v" in atomState) {
      return atomState.v;
    }
    throw new Error("no atom value");
  }, [store, atom]);
  const [[version, value, atomFromUseReducer], rerenderIfChanged] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)((0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((prev, nextVersion) => {
    const nextValue = getAtomValue(nextVersion);
    if (Object.is(prev[1], nextValue) && prev[2] === atom) {
      return prev;
    }
    return [nextVersion, nextValue, atom];
  }, [getAtomValue, atom]), void 0, () => {
    const initialVersion = void 0;
    const initialValue = getAtomValue(initialVersion);
    return [initialVersion, initialValue, atom];
  });
  if (atomFromUseReducer !== atom) {
    rerenderIfChanged(void 0);
  }
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const unsubscribe = store[SUBSCRIBE_ATOM](atom, rerenderIfChanged);
    rerenderIfChanged(void 0);
    return unsubscribe;
  }, [store, atom]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    store[COMMIT_ATOM](atom, version);
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useDebugValue)(value);
  return value;
}

function useSetAtom(atom, scope) {
  const ScopeContext = getScopeContext(scope);
  const { s: store, w: versionedWrite } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ScopeContext);
  const setAtom = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((update) => {
    if (!("write" in atom) && typeof process === "object" && "production" !== "production") {}
    const write = (version) => store[WRITE_ATOM](atom, update, version);
    return versionedWrite ? versionedWrite(write) : write();
  }, [store, versionedWrite, atom]);
  return setAtom;
}

function useAtom(atom, scope) {
  if ("scope" in atom) {
    console.warn("atom.scope is deprecated. Please do useAtom(atom, scope) instead.");
    scope = atom.scope;
  }
  return [
    useAtomValue(atom, scope),
    useSetAtom(atom, scope)
  ];
}




/***/ }),

/***/ 86763:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ }),

/***/ 87269:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 88987:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(71519),
    hashDelete = __webpack_require__(82999),
    hashGet = __webpack_require__(76111),
    hashHas = __webpack_require__(50506),
    hashSet = __webpack_require__(80845);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 175:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(2173),
    listCacheDelete = __webpack_require__(33752),
    listCacheGet = __webpack_require__(10548),
    listCacheHas = __webpack_require__(63410),
    listCacheSet = __webpack_require__(3564);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 35922:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 9440:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(7140),
    mapCacheDelete = __webpack_require__(56504),
    mapCacheGet = __webpack_require__(88833),
    mapCacheHas = __webpack_require__(80953),
    mapCacheSet = __webpack_require__(70724);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 6795:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 81956:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 78188:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(9440),
    setCacheAdd = __webpack_require__(96659),
    setCacheHas = __webpack_require__(97230);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 5929:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(175),
    stackClear = __webpack_require__(40551),
    stackDelete = __webpack_require__(4090),
    stackGet = __webpack_require__(47694),
    stackHas = __webpack_require__(86220),
    stackSet = __webpack_require__(68958);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 74396:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(29165);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 92210:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(29165);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 69477:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 48969:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 79809:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(39739),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isBuffer = __webpack_require__(61563),
    isIndex = __webpack_require__(91010),
    isTypedArray = __webpack_require__(73806);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 75697:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 28486:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 30695:
/***/ (function(module) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),

/***/ 84330:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 74202:
/***/ (function(module) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ 81034:
/***/ (function(module) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),

/***/ 62718:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(42448);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 30404:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(34082);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 91030:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(29);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 61343:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(91030),
    keys = __webpack_require__(50579);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 97499:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(60399),
    toKey = __webpack_require__(77817);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 38084:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(28486),
    isArray = __webpack_require__(24669);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 80732:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(74396),
    getRawTag = __webpack_require__(31239),
    objectToString = __webpack_require__(57058);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 45435:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),

/***/ 71664:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 84742:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(80732),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 6620:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(83977),
    isObjectLike = __webpack_require__(55073);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 83977:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(5929),
    equalArrays = __webpack_require__(22684),
    equalByTag = __webpack_require__(7456),
    equalObjects = __webpack_require__(18120),
    getTag = __webpack_require__(81887),
    isArray = __webpack_require__(24669),
    isBuffer = __webpack_require__(61563),
    isTypedArray = __webpack_require__(73806);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 27122:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(5929),
    baseIsEqual = __webpack_require__(6620);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 58939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(92042),
    isMasked = __webpack_require__(90654),
    isObject = __webpack_require__(56813),
    toSource = __webpack_require__(51059);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 22882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(80732),
    isLength = __webpack_require__(17216),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 5673:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(3772),
    baseMatchesProperty = __webpack_require__(30493),
    identity = __webpack_require__(48148),
    isArray = __webpack_require__(24669),
    property = __webpack_require__(51798);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 87473:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(92963),
    nativeKeys = __webpack_require__(14457);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 3772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(27122),
    getMatchData = __webpack_require__(67487),
    matchesStrictComparable = __webpack_require__(78857);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 30493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(6620),
    get = __webpack_require__(65439),
    hasIn = __webpack_require__(28281),
    isKey = __webpack_require__(2610),
    isStrictComparable = __webpack_require__(92769),
    matchesStrictComparable = __webpack_require__(78857),
    toKey = __webpack_require__(77817);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 17498:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 71000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97499);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 243:
/***/ (function(module) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),

/***/ 43846:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 39739:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 73150:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(74396),
    arrayMap = __webpack_require__(75697),
    isArray = __webpack_require__(24669),
    isSymbol = __webpack_require__(16764);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 58792:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 29880:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 60399:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(24669),
    isKey = __webpack_require__(2610),
    stringToPath = __webpack_require__(77057),
    toString = __webpack_require__(8389);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 20167:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(43846);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),

/***/ 36633:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(29165);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 29:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 23684:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castSlice = __webpack_require__(20167),
    hasUnicode = __webpack_require__(30080),
    stringToArray = __webpack_require__(30078),
    toString = __webpack_require__(8389);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),

/***/ 51471:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayReduce = __webpack_require__(30695),
    deburr = __webpack_require__(26357),
    words = __webpack_require__(71055);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),

/***/ 92523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(243);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),

/***/ 34082:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(47758);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 22684:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(78188),
    arraySome = __webpack_require__(84330),
    cacheHas = __webpack_require__(29880);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 7456:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(74396),
    Uint8Array = __webpack_require__(92210),
    eq = __webpack_require__(42448),
    equalArrays = __webpack_require__(22684),
    mapToArray = __webpack_require__(7523),
    setToArray = __webpack_require__(79967);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 18120:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(69698);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 96476:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 69698:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(38084),
    getSymbols = __webpack_require__(97482),
    keys = __webpack_require__(50579);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 67707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(3880);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 67487:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(92769),
    keys = __webpack_require__(50579);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 47758:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(58939),
    getValue = __webpack_require__(9149);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 31239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(74396);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 97482:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(48969),
    stubArray = __webpack_require__(68036);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 81887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(87269),
    Map = __webpack_require__(35922),
    Promise = __webpack_require__(6795),
    Set = __webpack_require__(81956),
    WeakMap = __webpack_require__(69477),
    baseGetTag = __webpack_require__(80732),
    toSource = __webpack_require__(51059);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 9149:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 18554:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(60399),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isIndex = __webpack_require__(91010),
    isLength = __webpack_require__(17216),
    toKey = __webpack_require__(77817);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 30080:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),

/***/ 37854:
/***/ (function(module) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),

/***/ 71519:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(37722);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 82999:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 76111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(37722);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 50506:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(37722);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 80845:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(37722);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 91010:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 2610:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(24669),
    isSymbol = __webpack_require__(16764);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 3880:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 90654:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(36633);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 92963:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 92769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(56813);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 2173:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 33752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(62718);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 10548:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(62718);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 63410:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(62718);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 3564:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(62718);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 7140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(88987),
    ListCache = __webpack_require__(175),
    Map = __webpack_require__(35922);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 56504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(67707);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 88833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(67707);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 80953:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(67707);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 70724:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(67707);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 7523:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 78857:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 45171:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(34736);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 37722:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(47758);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 14457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(75542);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 8478:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(96476);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 57058:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 75542:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 29165:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(96476);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 96659:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 97230:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 79967:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 40551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(175);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 4090:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 47694:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 86220:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 68958:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(175),
    Map = __webpack_require__(35922),
    MapCache = __webpack_require__(9440);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 30078:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiToArray = __webpack_require__(74202),
    hasUnicode = __webpack_require__(30080),
    unicodeToArray = __webpack_require__(95611);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),

/***/ 77057:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(45171);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 77817:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(16764);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 51059:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 95611:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),

/***/ 24155:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),

/***/ 47638:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var capitalize = __webpack_require__(68437),
    createCompounder = __webpack_require__(51471);

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

module.exports = camelCase;


/***/ }),

/***/ 68437:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(8389),
    upperFirst = __webpack_require__(42950);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),

/***/ 26357:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var deburrLetter = __webpack_require__(92523),
    toString = __webpack_require__(8389);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),

/***/ 42448:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 65439:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97499);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 56611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHas = __webpack_require__(45435),
    hasPath = __webpack_require__(18554);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),

/***/ 28281:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(71664),
    hasPath = __webpack_require__(18554);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 48148:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 30353:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(84742),
    isObjectLike = __webpack_require__(55073);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 24669:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 47428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(92042),
    isLength = __webpack_require__(17216);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 61563:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(29165),
    stubFalse = __webpack_require__(84193);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 92042:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(80732),
    isObject = __webpack_require__(56813);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 17216:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 56813:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 55073:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 16764:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(80732),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 73806:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(22882),
    baseUnary = __webpack_require__(58792),
    nodeUtil = __webpack_require__(8478);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 50579:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(79809),
    baseKeys = __webpack_require__(87473),
    isArrayLike = __webpack_require__(47428);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 48347:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(30404),
    baseForOwn = __webpack_require__(61343),
    baseIteratee = __webpack_require__(5673);

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),

/***/ 65632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(30404),
    baseForOwn = __webpack_require__(61343),
    baseIteratee = __webpack_require__(5673);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),

/***/ 34736:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(9440);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 51798:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(17498),
    basePropertyDeep = __webpack_require__(71000),
    isKey = __webpack_require__(2610),
    toKey = __webpack_require__(77817);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 69113:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCompounder = __webpack_require__(51471);

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

module.exports = snakeCase;


/***/ }),

/***/ 68036:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 84193:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 8389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(73150);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 42950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(23684);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),

/***/ 71055:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiWords = __webpack_require__(81034),
    hasUnicodeWord = __webpack_require__(37854),
    toString = __webpack_require__(8389),
    unicodeWords = __webpack_require__(24155);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),

/***/ 54610:
/***/ (function(module) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}


/***/ }),

/***/ 71958:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(52669);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93305:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
__webpack_unused_export__ = ({
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(59496));
var _router = __webpack_require__(46625);
var _router1 = __webpack_require__(29463);
var _useIntersection = __webpack_require__(79542);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    router.prefetch(href, as, options).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === 'A';
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    // replace state instead of push if prop is present
    router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
    });
}
function Link(props) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var p = props.prefetch !== false;
    var router = (0, _router1).useRouter();
    var ref2 = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, props.href, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: props.as ? (0, _router).resolveHref(router, props.as) : resolvedAs || resolvedHref
        };
    }, [
        router,
        props.href,
        props.as
    ]), href = ref2.href, as = ref2.as;
    var children = props.children, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale;
    if (typeof children === 'string') {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (false) {} else {
        child = _react.default.Children.only(children);
    }
    var childRef = child && typeof child === 'object' && child.ref;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: '200px'
    }), 2), setIntersectionRef = ref1[0], isVisible = ref1[1];
    var setRef = _react.default.useCallback(function(el) {
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === 'function') childRef(el);
            else if (typeof childRef === 'object') {
                childRef.current = el;
            }
        }
    }, [
        childRef,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
        var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (child.props && typeof child.props.onClick === 'function') {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale);
            }
        }
    };
    childProps.onMouseEnter = function(e) {
        if (child.props && typeof child.props.onMouseEnter === 'function') {
            child.props.onMouseEnter(e);
        }
        if ((0, _router).isLocalURL(href)) {
            prefetch(router, href, as, {
                priority: true
            });
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (props.passHref || child.type === 'a' && !('href' in child.props)) {
        var curLocale1 = typeof locale !== 'undefined' ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _router).getDomainLocale(as, curLocale1, router && router.locales, router && router.domainLocales);
        childProps.href = localeDomain || (0, _router).addBasePath((0, _router).addLocale(as, curLocale1, router && router.defaultLocale));
    }
    return(/*#__PURE__*/ _react.default.cloneElement(child, childProps));
}
var _default = Link;
exports["default"] = _default; //# sourceMappingURL=link.js.map


/***/ }),

/***/ 79542:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(59496);
var _requestIdleCallback = __webpack_require__(32960);
var hasIntersectionObserver = typeof IntersectionObserver !== 'undefined';
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var unobserve = (0, _react).useRef();
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(rootRef ? rootRef.current : null), 2), root = ref1[0], setRoot = ref1[1];
    var setRef = (0, _react).useCallback(function(el) {
        if (unobserve.current) {
            unobserve.current();
            unobserve.current = undefined;
        }
        if (isDisabled || visible) return;
        if (el && el.tagName) {
            unobserve.current = observe(el, function(isVisible) {
                return isVisible && setVisible(isVisible);
            }, {
                root: root,
                rootMargin: rootMargin
            });
        }
    }, [
        isDisabled,
        root,
        rootMargin,
        visible
    ]);
    (0, _react).useEffect(function() {
        if (!hasIntersectionObserver) {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        visible
    ]);
    (0, _react).useEffect(function() {
        if (rootRef) setRoot(rootRef.current);
    }, [
        rootRef
    ]);
    return [
        setRef,
        visible
    ];
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ''
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
    } else {
        instance = observers.get(id);
        idList.push(id);
    }
    if (instance) {
        return instance;
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    observers.set(id, instance = {
        id: id,
        observer: observer,
        elements: elements
    });
    return instance;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 8925:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// NAMESPACE OBJECT: ./node_modules/.pnpm/@sentry+core@6.19.7/node_modules/@sentry/core/esm/integrations/index.js
var integrations_namespaceObject = {};
__webpack_require__.r(integrations_namespaceObject);
__webpack_require__.d(integrations_namespaceObject, {
  "FunctionToString": function() { return functiontostring/* FunctionToString */.c; },
  "InboundFilters": function() { return inboundfilters/* InboundFilters */.QD; }
});

// NAMESPACE OBJECT: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/integrations/index.js
var esm_integrations_namespaceObject = {};
__webpack_require__.r(esm_integrations_namespaceObject);
__webpack_require__.d(esm_integrations_namespaceObject, {
  "Breadcrumbs": function() { return breadcrumbs/* Breadcrumbs */.O; },
  "Dedupe": function() { return dedupe/* Dedupe */.I; },
  "GlobalHandlers": function() { return globalhandlers/* GlobalHandlers */.d; },
  "LinkedErrors": function() { return linkederrors/* LinkedErrors */.iP; },
  "TryCatch": function() { return trycatch/* TryCatch */.p; },
  "UserAgent": function() { return useragent/* UserAgent */.Z; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@1.14.1/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(65949);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+core@6.19.7/node_modules/@sentry/core/esm/integrations/functiontostring.js
var functiontostring = __webpack_require__(70156);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+core@6.19.7/node_modules/@sentry/core/esm/integrations/inboundfilters.js
var inboundfilters = __webpack_require__(99946);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+core@6.19.7/node_modules/@sentry/core/esm/integrations/index.js


//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/global.js
var global = __webpack_require__(66149);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/integrations/globalhandlers.js
var globalhandlers = __webpack_require__(99441);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/integrations/trycatch.js
var trycatch = __webpack_require__(95234);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/integrations/breadcrumbs.js + 2 modules
var breadcrumbs = __webpack_require__(69195);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/integrations/linkederrors.js
var linkederrors = __webpack_require__(23016);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/integrations/useragent.js
var useragent = __webpack_require__(28942);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/integrations/dedupe.js
var dedupe = __webpack_require__(22277);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/integrations/index.js






//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/index.js






var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var _window = (0,global/* getGlobalObject */.R)();
if (_window.Sentry && _window.Sentry.Integrations) {
    windowIntegrations = _window.Sentry.Integrations;
}
var INTEGRATIONS = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, windowIntegrations), integrations_namespaceObject), esm_integrations_namespaceObject);

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+core@6.19.7/node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(89324);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+browser@6.19.7/node_modules/@sentry/browser/esm/sdk.js + 21 modules
var sdk = __webpack_require__(55652);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+react@6.19.7_react@17.0.2/node_modules/@sentry/react/esm/sdk.js

/**
 * Inits the React SDK
 */
function init(options) {
    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
        name: 'sentry.javascript.react',
        packages: [
            {
                name: 'npm:@sentry/react',
                version: version/* SDK_VERSION */.J,
            },
        ],
        version: version/* SDK_VERSION */.J,
    };
    (0,sdk/* init */.S1)(options);
}
//# sourceMappingURL=sdk.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+minimal@6.19.7/node_modules/@sentry/minimal/esm/index.js
var esm = __webpack_require__(22164);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(27280);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(43888);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/flags.js
var flags = __webpack_require__(66513);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(9774);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(49743);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/tracing.js
var TRACEPARENT_REGEXP = new RegExp('^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$');
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
    var matches = traceparent.match(TRACEPARENT_REGEXP);
    if (matches) {
        var parentSampled = void 0;
        if (matches[3] === '1') {
            parentSampled = true;
        }
        else if (matches[3] === '0') {
            parentSampled = false;
        }
        return {
            traceId: matches[1],
            parentSampled: parentSampled,
            parentSpanId: matches[2],
        };
    }
    return undefined;
}
//# sourceMappingURL=tracing.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/constants.js
var constants = __webpack_require__(90201);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/browser/backgroundtab.js




var backgroundtab_global = (0,global/* getGlobalObject */.R)();
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
    if (backgroundtab_global && backgroundtab_global.document) {
        backgroundtab_global.document.addEventListener('visibilitychange', function () {
            var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
            if (backgroundtab_global.document.hidden && activeTransaction) {
                var statusType = 'cancelled';
                flags/* IS_DEBUG_BUILD */.h &&
                    logger/* logger.log */.kg.log("[Tracing] Transaction: " + statusType + " -> since tab moved to the background, op: " + activeTransaction.op);
                // We should not set status if it is already set, this prevent important statuses like
                // error or data loss from being overwritten on transaction.
                if (!activeTransaction.status) {
                    activeTransaction.setStatus(statusType);
                }
                activeTransaction.setTag('visibilitychange', 'document.hidden');
                activeTransaction.setTag(constants/* FINISH_REASON_TAG */.d, constants/* IDLE_TRANSACTION_FINISH_REASONS.2 */.x[2]);
                activeTransaction.finish();
            }
        });
    }
    else {
        flags/* IS_DEBUG_BUILD */.h && logger/* logger.warn */.kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
    }
}
//# sourceMappingURL=backgroundtab.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(12648);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(29939);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(42880);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/browser/web-vitals/lib/bindReporter.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var bindReporter = function (callback, metric, reportAllChanges) {
    var prevValue;
    return function (forceReport) {
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                metric.delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (metric.delta || prevValue === undefined) {
                    prevValue = metric.value;
                    callback(metric);
                }
            }
        }
    };
};
//# sourceMappingURL=bindReporter.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
var generateUniqueID = function () {
    return "v2-" + Date.now() + "-" + (Math.floor(Math.random() * (9e12 - 1)) + 1e12);
};
//# sourceMappingURL=generateUniqueID.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/browser/web-vitals/lib/initMetric.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var initMetric = function (name, value) {
    return {
        name: name,
        value: (value !== null && value !== void 0 ? value : -1),
        delta: 0,
        entries: [],
        id: generateUniqueID(),
    };
};
//# sourceMappingURL=initMetric.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/browser/web-vitals/lib/observe.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
var observe = function (type, callback) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            // More extensive feature detect needed for Firefox due to:
            // https://github.com/GoogleChrome/web-vitals/issues/142
            if (type === 'first-input' && !('PerformanceEventTiming' in self)) {
                return;
            }
            var po = new PerformanceObserver(function (l) { return l.getEntries().map(callback); });
            po.observe({ type: type, buffered: true });
            return po;
        }
    }
    catch (e) {
        // Do nothing.
    }
    return;
};
//# sourceMappingURL=observe.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/browser/web-vitals/lib/onHidden.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var onHidden = function (cb, once) {
    var onHiddenOrPageHide = function (event) {
        if (event.type === 'pagehide' || (0,global/* getGlobalObject */.R)().document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener('visibilitychange', onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener('pagehide', onHiddenOrPageHide, true);
};
//# sourceMappingURL=onHidden.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/browser/web-vitals/getCLS.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var getCLS = function (onReport, reportAllChanges) {
    var metric = initMetric('CLS', 0);
    var report;
    var sessionValue = 0;
    var sessionEntries = [];
    var entryHandler = function (entry) {
        // Only count layout shifts without recent user input.
        // TODO: Figure out why entry can be undefined
        if (entry && !entry.hadRecentInput) {
            var firstSessionEntry = sessionEntries[0];
            var lastSessionEntry = sessionEntries[sessionEntries.length - 1];
            // If the entry occurred less than 1 second after the previous entry and
            // less than 5 seconds after the first entry in the session, include the
            // entry in the current session. Otherwise, start a new session.
            if (sessionValue &&
                sessionEntries.length !== 0 &&
                entry.startTime - lastSessionEntry.startTime < 1000 &&
                entry.startTime - firstSessionEntry.startTime < 5000) {
                sessionValue += entry.value;
                sessionEntries.push(entry);
            }
            else {
                sessionValue = entry.value;
                sessionEntries = [entry];
            }
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                if (report) {
                    report();
                }
            }
        }
    };
    var po = observe('layout-shift', entryHandler);
    if (po) {
        report = bindReporter(onReport, metric, reportAllChanges);
        onHidden(function () {
            po.takeRecords().map(entryHandler);
            report(true);
        });
    }
};
//# sourceMappingURL=getCLS.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var firstHiddenTime = -1;
var initHiddenTime = function () {
    return (0,global/* getGlobalObject */.R)().document.visibilityState === 'hidden' ? 0 : Infinity;
};
var trackChanges = function () {
    // Update the time if/when the document becomes hidden.
    onHidden(function (_a) {
        var timeStamp = _a.timeStamp;
        firstHiddenTime = timeStamp;
    }, true);
};
var getVisibilityWatcher = function () {
    if (firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        firstHiddenTime = initHiddenTime();
        trackChanges();
    }
    return {
        get firstHiddenTime() {
            return firstHiddenTime;
        },
    };
};
//# sourceMappingURL=getVisibilityWatcher.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/browser/web-vitals/getFID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var getFID = function (onReport, reportAllChanges) {
    var visibilityWatcher = getVisibilityWatcher();
    var metric = initMetric('FID');
    var report;
    var entryHandler = function (entry) {
        // Only report if the page wasn't hidden prior to the first input.
        if (report && entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    var po = observe('first-input', entryHandler);
    if (po) {
        report = bindReporter(onReport, metric, reportAllChanges);
        onHidden(function () {
            po.takeRecords().map(entryHandler);
            po.disconnect();
        }, true);
    }
};
//# sourceMappingURL=getFID.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/browser/web-vitals/getLCP.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var reportedMetricIDs = {};
var getLCP = function (onReport, reportAllChanges) {
    var visibilityWatcher = getVisibilityWatcher();
    var metric = initMetric('LCP');
    var report;
    var entryHandler = function (entry) {
        // The startTime attribute returns the value of the renderTime if it is not 0,
        // and the value of the loadTime otherwise.
        var value = entry.startTime;
        // If the page was hidden prior to paint time of the entry,
        // ignore it and mark the metric as final, otherwise add the entry.
        if (value < visibilityWatcher.firstHiddenTime) {
            metric.value = value;
            metric.entries.push(entry);
        }
        if (report) {
            report();
        }
    };
    var po = observe('largest-contentful-paint', entryHandler);
    if (po) {
        report = bindReporter(onReport, metric, reportAllChanges);
        var stopListening_1 = function () {
            if (!reportedMetricIDs[metric.id]) {
                po.takeRecords().map(entryHandler);
                po.disconnect();
                reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        ['keydown', 'click'].forEach(function (type) {
            addEventListener(type, stopListening_1, { once: true, capture: true });
        });
        onHidden(stopListening_1, true);
    }
};
//# sourceMappingURL=getLCP.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/browser/metrics.js








var metrics_global = (0,global/* getGlobalObject */.R)();
/** Class tracking metrics  */
var MetricsInstrumentation = /** @class */ (function () {
    function MetricsInstrumentation(_reportAllChanges) {
        if (_reportAllChanges === void 0) { _reportAllChanges = false; }
        this._reportAllChanges = _reportAllChanges;
        this._measurements = {};
        this._performanceCursor = 0;
        if (!(0,node/* isNodeEnv */.KV)() && metrics_global && metrics_global.performance && metrics_global.document) {
            if (metrics_global.performance.mark) {
                metrics_global.performance.mark('sentry-tracing-init');
            }
            this._trackCLS();
            this._trackLCP();
            this._trackFID();
        }
    }
    /** Add performance related spans to a transaction */
    MetricsInstrumentation.prototype.addPerformanceEntries = function (transaction) {
        var _this = this;
        if (!metrics_global || !metrics_global.performance || !metrics_global.performance.getEntries || !time/* browserPerformanceTimeOrigin */.Z1) {
            // Gatekeeper if performance API not available
            return;
        }
        flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log('[Tracing] Adding & adjusting spans using Performance API');
        var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);
        var responseStartTimestamp;
        var requestStartTimestamp;
        metrics_global.performance
            .getEntries()
            .slice(this._performanceCursor)
            .forEach(function (entry) {
            var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
            var duration = (0,utils/* msToSec */.XL)(entry.duration);
            if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
                return;
            }
            switch (entry.entryType) {
                case 'navigation': {
                    addNavigationSpans(transaction, entry, timeOrigin);
                    responseStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart);
                    requestStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart);
                    break;
                }
                case 'mark':
                case 'paint':
                case 'measure': {
                    var startTimestamp = addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    var firstHidden = getVisibilityWatcher();
                    // Only report if the page wasn't hidden prior to the web vital.
                    var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log('[Measurements] Adding FP');
                        _this._measurements['fp'] = { value: entry.startTime };
                        _this._measurements['mark.fp'] = { value: startTimestamp };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log('[Measurements] Adding FCP');
                        _this._measurements['fcp'] = { value: entry.startTime };
                        _this._measurements['mark.fcp'] = { value: startTimestamp };
                    }
                    break;
                }
                case 'resource': {
                    var resourceName = entry.name.replace(metrics_global.location.origin, '');
                    addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
                    break;
                }
                default:
                // Ignore other entry types.
            }
        });
        this._performanceCursor = Math.max(performance.getEntries().length - 1, 0);
        this._trackNavigator(transaction);
        // Measurements are only available for pageload transactions
        if (transaction.op === 'pageload') {
            // normalize applicable web vital values to be relative to transaction.startTimestamp
            var timeOrigin_1 = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);
            // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
            // start of the response in milliseconds
            if (typeof responseStartTimestamp === 'number') {
                flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log('[Measurements] Adding TTFB');
                this._measurements['ttfb'] = { value: (responseStartTimestamp - transaction.startTimestamp) * 1000 };
                if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
                    // Capture the time spent making the request and receiving the first byte of the response.
                    // This is the time between the start of the request and the start of the response in milliseconds.
                    this._measurements['ttfb.requestTime'] = { value: (responseStartTimestamp - requestStartTimestamp) * 1000 };
                }
            }
            ['fcp', 'fp', 'lcp'].forEach(function (name) {
                if (!_this._measurements[name] || timeOrigin_1 >= transaction.startTimestamp) {
                    return;
                }
                // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
                // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
                // to be adjusted to be relative to transaction.startTimestamp.
                var oldValue = _this._measurements[name].value;
                var measurementTimestamp = timeOrigin_1 + (0,utils/* msToSec */.XL)(oldValue);
                // normalizedValue should be in milliseconds
                var normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
                var delta = normalizedValue - oldValue;
                flags/* IS_DEBUG_BUILD */.h &&
                    logger/* logger.log */.kg.log("[Measurements] Normalized " + name + " from " + oldValue + " to " + normalizedValue + " (" + delta + ")");
                _this._measurements[name].value = normalizedValue;
            });
            if (this._measurements['mark.fid'] && this._measurements['fid']) {
                // create span for FID
                _startChild(transaction, {
                    description: 'first input delay',
                    endTimestamp: this._measurements['mark.fid'].value + (0,utils/* msToSec */.XL)(this._measurements['fid'].value),
                    op: 'web.vitals',
                    startTimestamp: this._measurements['mark.fid'].value,
                });
            }
            // If FCP is not recorded we should not record the cls value
            // according to the new definition of CLS.
            if (!('fcp' in this._measurements)) {
                delete this._measurements.cls;
            }
            transaction.setMeasurements(this._measurements);
            tagMetricInfo(transaction, this._lcpEntry, this._clsEntry);
            transaction.setTag('sentry_reportAllChanges', this._reportAllChanges);
        }
    };
    /**
     * Capture the information of the user agent.
     */
    MetricsInstrumentation.prototype._trackNavigator = function (transaction) {
        var navigator = metrics_global.navigator;
        if (!navigator) {
            return;
        }
        // track network connectivity
        var connection = navigator.connection;
        if (connection) {
            if (connection.effectiveType) {
                transaction.setTag('effectiveConnectionType', connection.effectiveType);
            }
            if (connection.type) {
                transaction.setTag('connectionType', connection.type);
            }
            if (isMeasurementValue(connection.rtt)) {
                this._measurements['connection.rtt'] = { value: connection.rtt };
            }
            if (isMeasurementValue(connection.downlink)) {
                this._measurements['connection.downlink'] = { value: connection.downlink };
            }
        }
        if (isMeasurementValue(navigator.deviceMemory)) {
            transaction.setTag('deviceMemory', String(navigator.deviceMemory));
        }
        if (isMeasurementValue(navigator.hardwareConcurrency)) {
            transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
        }
    };
    /** Starts tracking the Cumulative Layout Shift on the current page. */
    MetricsInstrumentation.prototype._trackCLS = function () {
        var _this = this;
        // See:
        // https://web.dev/evolving-cls/
        // https://web.dev/cls-web-tooling/
        getCLS(function (metric) {
            var entry = metric.entries.pop();
            if (!entry) {
                return;
            }
            flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log('[Measurements] Adding CLS');
            _this._measurements['cls'] = { value: metric.value };
            _this._clsEntry = entry;
        });
    };
    /** Starts tracking the Largest Contentful Paint on the current page. */
    MetricsInstrumentation.prototype._trackLCP = function () {
        var _this = this;
        getLCP(function (metric) {
            var entry = metric.entries.pop();
            if (!entry) {
                return;
            }
            var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);
            var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
            flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log('[Measurements] Adding LCP');
            _this._measurements['lcp'] = { value: metric.value };
            _this._measurements['mark.lcp'] = { value: timeOrigin + startTime };
            _this._lcpEntry = entry;
        }, this._reportAllChanges);
    };
    /** Starts tracking the First Input Delay on the current page. */
    MetricsInstrumentation.prototype._trackFID = function () {
        var _this = this;
        getFID(function (metric) {
            var entry = metric.entries.pop();
            if (!entry) {
                return;
            }
            var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);
            var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
            flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log('[Measurements] Adding FID');
            _this._measurements['fid'] = { value: metric.value };
            _this._measurements['mark.fid'] = { value: timeOrigin + startTime };
        });
    };
    return MetricsInstrumentation;
}());

/** Instrument navigation entries */
function addNavigationSpans(transaction, entry, timeOrigin) {
    ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(function (event) {
        addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    addRequest(transaction, entry, timeOrigin);
}
/** Create measure related spans */
function addMeasureSpans(transaction, entry, startTime, duration, timeOrigin) {
    var measureStartTimestamp = timeOrigin + startTime;
    var measureEndTimestamp = measureStartTimestamp + duration;
    _startChild(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        startTimestamp: measureStartTimestamp,
    });
    return measureStartTimestamp;
}
/** Create resource-related spans */
function addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
        return;
    }
    var data = {};
    if ('transferSize' in entry) {
        data['Transfer Size'] = entry.transferSize;
    }
    if ('encodedBodySize' in entry) {
        data['Encoded Body Size'] = entry.encodedBodySize;
    }
    if ('decodedBodySize' in entry) {
        data['Decoded Body Size'] = entry.decodedBodySize;
    }
    var startTimestamp = timeOrigin + startTime;
    var endTimestamp = startTimestamp + duration;
    _startChild(transaction, {
        description: resourceName,
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? "resource." + entry.initiatorType : 'resource',
        startTimestamp: startTimestamp,
        data: data,
    });
}
/** Create performance navigation related spans */
function addPerformanceNavigationTiming(transaction, entry, event, timeOrigin, description, eventEnd) {
    var end = eventEnd ? entry[eventEnd] : entry[event + "End"];
    var start = entry[event + "Start"];
    if (!start || !end) {
        return;
    }
    _startChild(transaction, {
        op: 'browser',
        description: (description !== null && description !== void 0 ? description : event),
        startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(start),
        endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(end),
    });
}
/** Create request and response related spans */
function addRequest(transaction, entry, timeOrigin) {
    _startChild(transaction, {
        op: 'browser',
        description: 'request',
        startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart),
        endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd),
    });
    _startChild(transaction, {
        op: 'browser',
        description: 'response',
        startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart),
        endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd),
    });
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, _a) {
    var startTimestamp = _a.startTimestamp, ctx = (0,tslib_es6/* __rest */._T)(_a, ["startTimestamp"]);
    if (startTimestamp && transaction.startTimestamp > startTimestamp) {
        transaction.startTimestamp = startTimestamp;
    }
    return transaction.startChild((0,tslib_es6/* __assign */.pi)({ startTimestamp: startTimestamp }, ctx));
}
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
    return typeof value === 'number' && isFinite(value);
}
/** Add LCP / CLS data to transaction to allow debugging */
function tagMetricInfo(transaction, lcpEntry, clsEntry) {
    if (lcpEntry) {
        flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if (lcpEntry.element) {
            transaction.setTag('lcp.element', (0,browser/* htmlTreeAsString */.R)(lcpEntry.element));
        }
        if (lcpEntry.id) {
            transaction.setTag('lcp.id', lcpEntry.id);
        }
        if (lcpEntry.url) {
            // Trim URL to the first 200 characters.
            transaction.setTag('lcp.url', lcpEntry.url.trim().slice(0, 200));
        }
        transaction.setTag('lcp.size', lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if (clsEntry && clsEntry.sources) {
        flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log('[Measurements] Adding CLS Data');
        clsEntry.sources.forEach(function (source, index) {
            return transaction.setTag("cls.source." + (index + 1), (0,browser/* htmlTreeAsString */.R)(source.node));
        });
    }
}
//# sourceMappingURL=metrics.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(80973);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(71588);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(83106);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/browser/request.js



var DEFAULT_TRACING_ORIGINS = ['localhost', /^\//];
var defaultRequestInstrumentationOptions = {
    traceFetch: true,
    traceXHR: true,
    tracingOrigins: DEFAULT_TRACING_ORIGINS,
};
/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    var _a = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, defaultRequestInstrumentationOptions), _options), traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
    // We should cache url -> decision so that we don't have to compute
    // regexp everytime we create a request.
    var urlMap = {};
    var defaultShouldCreateSpan = function (url) {
        if (urlMap[url]) {
            return urlMap[url];
        }
        var origins = tracingOrigins;
        urlMap[url] =
            origins.some(function (origin) { return (0,string/* isMatchingPattern */.zC)(url, origin); }) &&
                !(0,string/* isMatchingPattern */.zC)(url, 'sentry_key');
        return urlMap[url];
    };
    // We want that our users don't have to re-implement shouldCreateSpanForRequest themselves
    // That's why we filter out already unwanted Spans from tracingOrigins
    var shouldCreateSpan = defaultShouldCreateSpan;
    if (typeof shouldCreateSpanForRequest === 'function') {
        shouldCreateSpan = function (url) {
            return defaultShouldCreateSpan(url) && shouldCreateSpanForRequest(url);
        };
    }
    var spans = {};
    if (traceFetch) {
        (0,instrument/* addInstrumentationHandler */.o)('fetch', function (handlerData) {
            fetchCallback(handlerData, shouldCreateSpan, spans);
        });
    }
    if (traceXHR) {
        (0,instrument/* addInstrumentationHandler */.o)('xhr', function (handlerData) {
            xhrCallback(handlerData, shouldCreateSpan, spans);
        });
    }
}
/**
 * Create and track fetch request spans
 */
function fetchCallback(handlerData, shouldCreateSpan, spans) {
    if (!(0,utils/* hasTracingEnabled */.zu)() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
        return;
    }
    if (handlerData.endTimestamp) {
        var spanId = handlerData.fetchData.__span;
        if (!spanId)
            return;
        var span = spans[spanId];
        if (span) {
            if (handlerData.response) {
                // TODO (kmclb) remove this once types PR goes through
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                span.setHttpStatus(handlerData.response.status);
            }
            else if (handlerData.error) {
                span.setStatus('internal_error');
            }
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, handlerData.fetchData), { type: 'fetch' }),
            description: handlerData.fetchData.method + " " + handlerData.fetchData.url,
            op: 'http.client',
        });
        handlerData.fetchData.__span = span.spanId;
        spans[span.spanId] = span;
        var request = (handlerData.args[0] = handlerData.args[0]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var options = (handlerData.args[1] = handlerData.args[1] || {});
        var headers = options.headers;
        if ((0,is/* isInstanceOf */.V9)(request, Request)) {
            headers = request.headers;
        }
        if (headers) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (typeof headers.append === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                headers.append('sentry-trace', span.toTraceparent());
            }
            else if (Array.isArray(headers)) {
                headers = (0,tslib_es6/* __spread */.fl)(headers, [['sentry-trace', span.toTraceparent()]]);
            }
            else {
                headers = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, headers), { 'sentry-trace': span.toTraceparent() });
            }
        }
        else {
            headers = { 'sentry-trace': span.toTraceparent() };
        }
        options.headers = headers;
    }
}
/**
 * Create and track xhr request spans
 */
function xhrCallback(handlerData, shouldCreateSpan, spans) {
    if (!(0,utils/* hasTracingEnabled */.zu)() ||
        (handlerData.xhr && handlerData.xhr.__sentry_own_request__) ||
        !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))) {
        return;
    }
    var xhr = handlerData.xhr.__sentry_xhr__;
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp) {
        var spanId = handlerData.xhr.__sentry_xhr_span_id__;
        if (!spanId)
            return;
        var span = spans[spanId];
        if (span) {
            span.setHttpStatus(xhr.status_code);
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    // if not, create a new span to track it
    var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, xhr.data), { type: 'xhr', method: xhr.method, url: xhr.url }),
            description: xhr.method + " " + xhr.url,
            op: 'http.client',
        });
        handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
        spans[handlerData.xhr.__sentry_xhr_span_id__] = span;
        if (handlerData.xhr.setRequestHeader) {
            try {
                handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());
            }
            catch (_) {
                // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
            }
        }
    }
}
//# sourceMappingURL=request.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/browser/router.js


var router_global = (0,global/* getGlobalObject */.R)();
/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(customStartTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
    if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
    if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
    if (!router_global || !router_global.location) {
        flags/* IS_DEBUG_BUILD */.h && logger/* logger.warn */.kg.warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    var startingUrl = router_global.location.href;
    var activeTransaction;
    if (startTransactionOnPageLoad) {
        activeTransaction = customStartTransaction({ name: router_global.location.pathname, op: 'pageload' });
    }
    if (startTransactionOnLocationChange) {
        (0,instrument/* addInstrumentationHandler */.o)('history', function (_a) {
            var to = _a.to, from = _a.from;
            /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */
            if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                startingUrl = undefined;
                return;
            }
            if (from !== to) {
                startingUrl = undefined;
                if (activeTransaction) {
                    flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log("[Tracing] Finishing current transaction with op: " + activeTransaction.op);
                    // If there's an open transaction on the scope, we need to finish it before creating an new one.
                    activeTransaction.finish();
                }
                activeTransaction = customStartTransaction({ name: router_global.location.pathname, op: 'navigation' });
            }
        });
    }
}
//# sourceMappingURL=router.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/browser/browsertracing.js










var DEFAULT_MAX_TRANSACTION_DURATION_SECONDS = 600;
var DEFAULT_BROWSER_TRACING_OPTIONS = (0,tslib_es6/* __assign */.pi)({ idleTimeout: idletransaction/* DEFAULT_IDLE_TIMEOUT */.nT, markBackgroundTransactions: true, maxTransactionDuration: DEFAULT_MAX_TRANSACTION_DURATION_SECONDS, routingInstrumentation: instrumentRoutingWithDefaults, startTransactionOnLocationChange: true, startTransactionOnPageLoad: true }, defaultRequestInstrumentationOptions);
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
var BrowserTracing = /** @class */ (function () {
    function BrowserTracing(_options) {
        /**
         * @inheritDoc
         */
        this.name = BrowserTracing.id;
        /** Store configured idle timeout so that it can be added as a tag to transactions */
        this._configuredIdleTimeout = undefined;
        var tracingOrigins = defaultRequestInstrumentationOptions.tracingOrigins;
        // NOTE: Logger doesn't work in constructors, as it's initialized after integrations instances
        if (_options) {
            this._configuredIdleTimeout = _options.idleTimeout;
            if (_options.tracingOrigins && Array.isArray(_options.tracingOrigins) && _options.tracingOrigins.length !== 0) {
                tracingOrigins = _options.tracingOrigins;
            }
            else {
                flags/* IS_DEBUG_BUILD */.h && (this._emitOptionsWarning = true);
            }
        }
        this.options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, DEFAULT_BROWSER_TRACING_OPTIONS), _options), { tracingOrigins: tracingOrigins });
        var _metricOptions = this.options._metricOptions;
        this._metrics = new MetricsInstrumentation(_metricOptions && _metricOptions._reportAllChanges);
    }
    /**
     * @inheritDoc
     */
    BrowserTracing.prototype.setupOnce = function (_, getCurrentHub) {
        var _this = this;
        this._getCurrentHub = getCurrentHub;
        if (this._emitOptionsWarning) {
            flags/* IS_DEBUG_BUILD */.h &&
                logger/* logger.warn */.kg.warn('[Tracing] You need to define `tracingOrigins` in the options. Set an array of urls or patterns to trace.');
            flags/* IS_DEBUG_BUILD */.h &&
                logger/* logger.warn */.kg.warn("[Tracing] We added a reasonable default for you: " + defaultRequestInstrumentationOptions.tracingOrigins);
        }
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.options, instrumentRouting = _a.routingInstrumentation, startTransactionOnLocationChange = _a.startTransactionOnLocationChange, startTransactionOnPageLoad = _a.startTransactionOnPageLoad, markBackgroundTransactions = _a.markBackgroundTransactions, traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
        instrumentRouting(function (context) { return _this._createRouteTransaction(context); }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) {
            registerBackgroundTabDetection();
        }
        instrumentOutgoingRequests({ traceFetch: traceFetch, traceXHR: traceXHR, tracingOrigins: tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest });
    };
    /** Create routing idle transaction. */
    BrowserTracing.prototype._createRouteTransaction = function (context) {
        var _this = this;
        if (!this._getCurrentHub) {
            flags/* IS_DEBUG_BUILD */.h &&
                logger/* logger.warn */.kg.warn("[Tracing] Did not create " + context.op + " transaction because _getCurrentHub is invalid.");
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.options, beforeNavigate = _a.beforeNavigate, idleTimeout = _a.idleTimeout, maxTransactionDuration = _a.maxTransactionDuration;
        var parentContextFromHeader = context.op === 'pageload' ? getHeaderContext() : undefined;
        var expandedContext = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), parentContextFromHeader), { trimEnd: true });
        var modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        var finalContext = modifiedContext === undefined ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, expandedContext), { sampled: false }) : modifiedContext;
        if (finalContext.sampled === false) {
            flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log("[Tracing] Will not send " + finalContext.op + " transaction because of beforeNavigate.");
        }
        flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log("[Tracing] Starting " + finalContext.op + " transaction on scope");
        var hub = this._getCurrentHub();
        var location = (0,global/* getGlobalObject */.R)().location;
        var idleTransaction = (0,hubextensions/* startIdleTransaction */.lb)(hub, finalContext, idleTimeout, true, { location: location });
        idleTransaction.registerBeforeFinishCallback(function (transaction, endTimestamp) {
            _this._metrics.addPerformanceEntries(transaction);
            adjustTransactionDuration((0,utils/* secToMs */.WB)(maxTransactionDuration), transaction, endTimestamp);
        });
        idleTransaction.setTag('idleTimeout', this._configuredIdleTimeout);
        return idleTransaction;
    };
    /**
     * @inheritDoc
     */
    BrowserTracing.id = 'BrowserTracing';
    return BrowserTracing;
}());

/**
 * Gets transaction context from a sentry-trace meta.
 *
 * @returns Transaction context data from the header or undefined if there's no header or the header is malformed
 */
function getHeaderContext() {
    var header = getMetaContent('sentry-trace');
    if (header) {
        return extractTraceparentData(header);
    }
    return undefined;
}
/** Returns the value of a meta tag */
function getMetaContent(metaName) {
    var el = (0,global/* getGlobalObject */.R)().document.querySelector("meta[name=" + metaName + "]");
    return el ? el.getAttribute('content') : null;
}
/** Adjusts transaction value based on max transaction duration */
function adjustTransactionDuration(maxDuration, transaction, endTimestamp) {
    var diff = endTimestamp - transaction.startTimestamp;
    var isOutdatedTransaction = endTimestamp && (diff > maxDuration || diff < 0);
    if (isOutdatedTransaction) {
        transaction.setStatus('deadline_exceeded');
        transaction.setTag('maxTransactionDurationExceeded', 'true');
    }
}
//# sourceMappingURL=browsertracing.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+tracing@6.19.7/node_modules/@sentry/tracing/esm/index.js



// This is already exported as part of `Integrations` above (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
//
// Previously we expected users to import tracing integrations like
//
// import { Integrations } from '@sentry/tracing';
// const instance = new Integrations.BrowserTracing();
//
// This makes the integrations unable to be treeshaken though. To address this, we now have
// this individual export. We now expect users to consume BrowserTracing like so:
//
// import { BrowserTracing } from '@sentry/tracing';
// const instance = new BrowserTracing();
//
// For an example of of the new usage of BrowserTracing, see @sentry/nextjs index.client.ts


// eslint-disable-next-line deprecation/deprecation





// We are patching the global object with our hub extension methods
(0,hubextensions/* addExtensionMethods */.ro)();


//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(70133);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.19.7/node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(96702);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_n6febsnk4nq7zxsovmf65ymnxm/node_modules/next/router.js
var router = __webpack_require__(63359);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+nextjs@6.19.7_wtdfae2u2aes77du6lgsc7ufqe/node_modules/@sentry/nextjs/esm/performance/client.js
/* eslint-disable @typescript-eslint/no-explicit-any */



var client_global = (0,global/* getGlobalObject */.R)();
var DEFAULT_TAGS = {
    'routing.instrumentation': 'next-router',
};
var activeTransaction = undefined;
var prevTransactionName = undefined;
var startTransaction = undefined;
/**
 * Creates routing instrumention for Next Router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function nextRouterInstrumentation(startTransactionCb, startTransactionOnPageLoad, startTransactionOnLocationChange) {
    if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
    if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
    startTransaction = startTransactionCb;
    router["default"].ready(function () {
        // We can only start the pageload transaction when we have access to the parameterized
        // route name. Setting the transaction name after the transaction is started could lead
        // to possible race conditions with the router, so this approach was taken.
        if (startTransactionOnPageLoad) {
            prevTransactionName = router["default"].route !== null ? (0,misc/* stripUrlQueryAndFragment */.rt)(router["default"].route) : client_global.location.pathname;
            activeTransaction = startTransactionCb({
                name: prevTransactionName,
                op: 'pageload',
                tags: DEFAULT_TAGS,
            });
        }
        // Spans that aren't attached to any transaction are lost; so if transactions aren't
        // created (besides potentially the onpageload transaction), no need to wrap the router.
        if (!startTransactionOnLocationChange)
            return;
        // `withRouter` uses `useRouter` underneath:
        // https://github.com/vercel/next.js/blob/de42719619ae69fbd88e445100f15701f6e1e100/packages/next/client/with-router.tsx#L21
        // Router events also use the router:
        // https://github.com/vercel/next.js/blob/de42719619ae69fbd88e445100f15701f6e1e100/packages/next/client/router.ts#L92
        // `Router.changeState` handles the router state changes, so it may be enough to only wrap it
        // (instead of wrapping all of the Router's functions).
        var routerPrototype = Object.getPrototypeOf(router["default"].router);
        (0,object/* fill */.hl)(routerPrototype, 'changeState', changeStateWrapper);
    });
}
/**
 * Wraps Router.changeState()
 * https://github.com/vercel/next.js/blob/da97a18dafc7799e63aa7985adc95f213c2bf5f3/packages/next/next-server/lib/router/router.ts#L1204
 * Start a navigation transaction every time the router changes state.
 */
function changeStateWrapper(originalChangeStateWrapper) {
    var wrapper = function (method, 
    // The parameterized url, ex. posts/[id]/[comment]
    url, 
    // The actual url, ex. posts/85/my-comment
    as, options) {
        // At the moment there are no additional arguments (meaning the rest parameter is empty).
        // This is meant to protect from future additions to Next.js API, especially since this is an
        // internal API.
        var args = [];
        for (
        // At the moment there are no additional arguments (meaning the rest parameter is empty).
        // This is meant to protect from future additions to Next.js API, especially since this is an
        // internal API.
        var _i = 4; 
        // At the moment there are no additional arguments (meaning the rest parameter is empty).
        // This is meant to protect from future additions to Next.js API, especially since this is an
        // internal API.
        _i < arguments.length; 
        // At the moment there are no additional arguments (meaning the rest parameter is empty).
        // This is meant to protect from future additions to Next.js API, especially since this is an
        // internal API.
        _i++) {
            // At the moment there are no additional arguments (meaning the rest parameter is empty).
            // This is meant to protect from future additions to Next.js API, especially since this is an
            // internal API.
            args[_i - 4] = arguments[_i];
        }
        var newTransactionName = (0,misc/* stripUrlQueryAndFragment */.rt)(url);
        // do not start a transaction if it's from the same page
        if (startTransaction !== undefined && prevTransactionName !== newTransactionName) {
            if (activeTransaction) {
                activeTransaction.finish();
            }
            var tags = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, DEFAULT_TAGS), { method: method }), options);
            if (prevTransactionName) {
                tags.from = prevTransactionName;
            }
            prevTransactionName = newTransactionName;
            activeTransaction = startTransaction({
                name: prevTransactionName,
                op: 'navigation',
                tags: tags,
            });
        }
        return originalChangeStateWrapper.call.apply(originalChangeStateWrapper, (0,tslib_es6/* __spread */.fl)([this, method, url, as, options], args));
    };
    return wrapper;
}
//# sourceMappingURL=client.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+nextjs@6.19.7_wtdfae2u2aes77du6lgsc7ufqe/node_modules/@sentry/nextjs/esm/utils/metadata.js

var PACKAGE_NAME_PREFIX = 'npm:@sentry/';
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 * @param options sdk options object that gets mutated
 * @param names list of package names
 */
function buildMetadata(options, names) {
    options._metadata = options._metadata || {};
    options._metadata.sdk =
        options._metadata.sdk ||
            {
                name: 'sentry.javascript.nextjs',
                packages: names.map(function (name) { return ({
                    name: "" + PACKAGE_NAME_PREFIX + name,
                    version: version/* SDK_VERSION */.J,
                }); }),
                version: version/* SDK_VERSION */.J,
            };
}
//# sourceMappingURL=metadata.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+nextjs@6.19.7_wtdfae2u2aes77du6lgsc7ufqe/node_modules/@sentry/nextjs/esm/utils/userIntegrations.js

/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setNestedKey(obj, keyPath, value) {
    // Ex. foo.bar.zoop will extract foo and bar.zoop
    var match = keyPath.match(/([a-z]+)\.(.*)/i);
    if (match === null) {
        obj[keyPath] = value;
    }
    else {
        setNestedKey(obj[match[1]], match[2], value);
    }
}
/**
 * Retrieves the patched integrations with the provided integration.
 *
 * The integration must be present in the final user integrations, and they are compared
 * by integration name. If the user has defined one, there's nothing to patch; if not,
 * the provided integration is added.
 *
 * @param integration The integration to patch, if necessary.
 * @param userIntegrations Integrations defined by the user.
 * @param options options to update for a particular integration
 * @returns Final integrations, patched if necessary.
 */
function addIntegration(integration, userIntegrations, options) {
    if (options === void 0) { options = {}; }
    if (Array.isArray(userIntegrations)) {
        return addIntegrationToArray(integration, userIntegrations, options);
    }
    else {
        return addIntegrationToFunction(integration, userIntegrations, options);
    }
}
function addIntegrationToArray(integration, userIntegrations, options) {
    var includesName = false;
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var x = 0; x < userIntegrations.length; x++) {
        if (userIntegrations[x].name === integration.name) {
            includesName = true;
        }
        var op = options[userIntegrations[x].name];
        if (op) {
            setNestedKey(userIntegrations[x], op.keyPath, op.value);
        }
    }
    if (includesName) {
        return userIntegrations;
    }
    return (0,tslib_es6/* __spread */.fl)(userIntegrations, [integration]);
}
function addIntegrationToFunction(integration, userIntegrationsFunc, options) {
    var wrapper = function (defaultIntegrations) {
        var userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);
        return addIntegrationToArray(integration, userFinalIntegrations, options);
    };
    return wrapper;
}
//# sourceMappingURL=userIntegrations.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+nextjs@6.19.7_wtdfae2u2aes77du6lgsc7ufqe/node_modules/@sentry/nextjs/esm/index.client.js








var Integrations = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, INTEGRATIONS), { BrowserTracing: BrowserTracing });
// This is already exported as part of `Integrations` above (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
//
// Previously we expected users to import `BrowserTracing` like this:
//
// import { Integrations } from '@sentry/nextjs';
// const instance = new Integrations.BrowserTracing();
//
// This makes the integrations unable to be treeshaken though. To address this, we now have
// this individual export. We now expect users to consume BrowserTracing like so:
//
// import { BrowserTracing } from '@sentry/nextjs';
// const instance = new BrowserTracing();

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function index_client_init(options) {
    buildMetadata(options, ['nextjs', 'react']);
    options.environment = options.environment || "production";
    // Only add BrowserTracing if a tracesSampleRate or tracesSampler is set
    var integrations = options.tracesSampleRate === undefined && options.tracesSampler === undefined
        ? options.integrations
        : createClientIntegrations(options.integrations);
    init((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { integrations: integrations }));
    (0,esm/* configureScope */.e)(function (scope) {
        scope.setTag('runtime', 'browser');
        scope.addEventProcessor(function (event) { return (event.type === 'transaction' && event.transaction === '/404' ? null : event); });
    });
}
var defaultBrowserTracingIntegration = new BrowserTracing({
    tracingOrigins: (0,tslib_es6/* __spread */.fl)(defaultRequestInstrumentationOptions.tracingOrigins, [/^(api\/)/]),
    routingInstrumentation: nextRouterInstrumentation,
});
function createClientIntegrations(integrations) {
    if (integrations) {
        return addIntegration(defaultBrowserTracingIntegration, integrations, {
            BrowserTracing: { keyPath: 'options.routingInstrumentation', value: nextRouterInstrumentation },
        });
    }
    else {
        return [defaultBrowserTracingIntegration];
    }
}
//# sourceMappingURL=index.client.js.map
;// CONCATENATED MODULE: ./sentry.client.config.js
/* provided dependency */ var process = __webpack_require__(14224);
// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

var SENTRY_DSN = process.env.SENTRY_DSN || "https://d8d9a3df635d4c6d8c03f32a62495264@o1091335.ingest.sentry.io/6167164";
var getFloat = function(getter) {
    var str = getter();
    if (str) {
        if (typeof str !== 'string') {
            throw new Error('getter must return a string');
        }
        return parseFloat(str);
    }
    return str;
};
index_client_init({
    dsn: SENTRY_DSN,
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: getFloat(function() {
        return process.env.NEXT_PUBLIC_SENTRY_SAMPLE_RATE;
    }) || 1,
    environment: "production" || 0,
    showReportDialog: process.env.NEXT_PUBLIC_SENTRY_REPORT_DIALOG === 'enabled' || false
});


/***/ }),

/***/ 7462:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var GenderType;
(function(GenderType) {
    GenderType["NEUTRAL"] = 'nonSpecific';
    GenderType["MALE"] = 'male';
    GenderType["FEMALE"] = 'female';
})(GenderType || (GenderType = {}));
/* harmony default export */ __webpack_exports__["Z"] = (GenderType);


/***/ }),

/***/ 75594:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var ItemType;
(function(ItemType) {
    ItemType["Question"] = 'question';
    ItemType["Condition"] = 'condition';
    ItemType["Instructions"] = 'instructions';
    ItemType["TimeScale"] = 'timeScale';
    ItemType["ResponseScale"] = 'responseScale';
    ItemType["SymptomScale"] = 'symptomScale';
})(ItemType || (ItemType = {}));
/* harmony default export */ __webpack_exports__["Z"] = (ItemType);


/***/ }),

/***/ 35247:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var QuestionnaireKind;
(function(QuestionnaireKind) {
    QuestionnaireKind[QuestionnaireKind["OFFICIAL"] = 0] = "OFFICIAL";
    QuestionnaireKind[QuestionnaireKind["CUSTOM"] = 1] = "CUSTOM";
})(QuestionnaireKind || (QuestionnaireKind = {}));
/* harmony default export */ __webpack_exports__["Z"] = (QuestionnaireKind);


/***/ }),

/***/ 96439:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var QuestionnaireState;
(function(QuestionnaireState) {
    QuestionnaireState["WAITING_FOR_APPROVAL"] = 'waitingForApproval';
    QuestionnaireState["PUBLISHED"] = 'published';
    QuestionnaireState["DRAFT"] = 'draft';
})(QuestionnaireState || (QuestionnaireState = {}));
/* harmony default export */ __webpack_exports__["Z"] = (QuestionnaireState);


/***/ }),

/***/ 49676:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var QuestionnaireType;
(function(QuestionnaireType) {
    QuestionnaireType["CORE"] = 'core';
    QuestionnaireType["MODULE"] = 'module';
    QuestionnaireType["STANDALONE"] = 'standalone';
    QuestionnaireType["PREVIOUS"] = 'previous';
    QuestionnaireType["CAT"] = 'cat';
    QuestionnaireType["CAT_SHORT"] = 'catshort';
    QuestionnaireType["ITEM_LIST"] = 'itemlist';
    QuestionnaireType["SHORT_FORM"] = 'shortform';
})(QuestionnaireType || (QuestionnaireType = {}));
/* harmony default export */ __webpack_exports__["Z"] = (QuestionnaireType);


/***/ }),

/***/ 70359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _errors_ErrorBoundary; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_n6febsnk4nq7zxsovmf65ymnxm/node_modules/next/link.js
var next_link = __webpack_require__(70462);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(28440);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(44858);
// EXTERNAL MODULE: ./src/components/_errors/500/500.module.scss
var _500_module = __webpack_require__(94493);
var _500_module_default = /*#__PURE__*/__webpack_require__.n(_500_module);
;// CONCATENATED MODULE: ./src/components/_errors/500/index.tsx




function Error500() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: (_500_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    children: "Something went wrong"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "lead",
                    children: "Please try again later."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "/",
                        children: "Back home"
                    })
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@1.14.1/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(65949);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.18.2/node_modules/@sentry/utils/esm/global.js
var esm_global = __webpack_require__(9875);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.18.2/node_modules/@sentry/utils/esm/misc.js




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = (0,esm_global/* getGlobalObject */.R)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-bitwise
        var r = (Math.random() * 16) | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
function getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    var message = event.message, eventId = event.event_id;
    if (message) {
        return message;
    }
    var firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) {
            return firstException.type + ": " + firstException.value;
        }
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
    var exception = (event.exception = event.exception || {});
    var values = (exception.values = exception.values || []);
    var firstException = (values[0] = values[0] || {});
    if (!firstException.value) {
        firstException.value = value || '';
    }
    if (!firstException.type) {
        firstException.type = type || 'Error';
    }
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function misc_addExceptionMechanism(event, newMechanism) {
    var firstException = getFirstException(event);
    if (!firstException) {
        return;
    }
    var defaultMechanism = { type: 'generic', handled: true };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (currentMechanism && currentMechanism.data)), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4],
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) { linesOfContext = 5; }
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines
        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
        .map(function (line) { return snipLine(line, 0); });
    frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines
        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
        .map(function (line) { return snipLine(line, 0); });
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) {
        return true;
    }
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        addNonEnumerableProperty(exception, '__sentry_captured__', true);
    }
    catch (err) {
        // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
//# sourceMappingURL=misc.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.18.2/node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(93182);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.18.2/node_modules/@sentry/utils/esm/logger.js


// TODO: Implement different loggers for different environments
var global = (0,esm_global/* getGlobalObject */.R)();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
/**
 * Temporarily unwrap `console.log` and friends in order to perform the given callback using the original methods.
 * Restores wrapping after the callback completes.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
    var global = (0,esm_global/* getGlobalObject */.R)();
    var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
    if (!('console' in global)) {
        return callback();
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    levels.forEach(function (level) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (level in global.console && originalConsole[level].__sentry_original__) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalConsole[level].__sentry_original__;
        }
    });
    // Perform callback manipulations
    var result = callback();
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(function (level) {
        originalConsole[level] = wrappedLevels[level];
    });
    return result;
}
/** JSDoc */
var Logger = /** @class */ (function () {
    /** JSDoc */
    function Logger() {
        this._enabled = false;
    }
    /** JSDoc */
    Logger.prototype.disable = function () {
        this._enabled = false;
    };
    /** JSDoc */
    Logger.prototype.enable = function () {
        this._enabled = true;
    };
    /** JSDoc */
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        consoleSandbox(function () {
            var _a;
            (_a = global.console).log.apply(_a, (0,tslib_es6/* __spread */.fl)([PREFIX + "[Log]:"], args));
        });
    };
    /** JSDoc */
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        consoleSandbox(function () {
            var _a;
            (_a = global.console).warn.apply(_a, (0,tslib_es6/* __spread */.fl)([PREFIX + "[Warn]:"], args));
        });
    };
    /** JSDoc */
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        consoleSandbox(function () {
            var _a;
            (_a = global.console).error.apply(_a, (0,tslib_es6/* __spread */.fl)([PREFIX + "[Error]:"], args));
        });
    };
    return Logger;
}());
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
global.__SENTRY__ = global.__SENTRY__ || {};
var logger_logger = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());

//# sourceMappingURL=logger.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.18.2/node_modules/@sentry/utils/esm/node.js
var node = __webpack_require__(58179);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.18.2/node_modules/@sentry/utils/esm/is.js
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable-next-line @typescript-eslint/unbound-method
var objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (objectToString.call(wat)) {
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
function isBuiltin(wat, ty) {
    return objectToString.call(wat) === "[object " + ty + "]";
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return isBuiltin(wat, 'String');
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function is_isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    }
    catch (_e) {
        return false;
    }
}
//# sourceMappingURL=is.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.18.2/node_modules/@sentry/utils/esm/syncpromise.js
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/typedef */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function syncpromise_resolvedSyncPromise(value) {
    return new SyncPromise(function (resolve) {
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
    return new SyncPromise(function (_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
var SyncPromise = /** @class */ (function () {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */;
        this._handlers = [];
        /** JSDoc */
        this._resolve = function (value) {
            _this._setResult(1 /* RESOLVED */, value);
        };
        /** JSDoc */
        this._reject = function (reason) {
            _this._setResult(2 /* REJECTED */, reason);
        };
        /** JSDoc */
        this._setResult = function (state, value) {
            if (_this._state !== 0 /* PENDING */) {
                return;
            }
            if (isThenable(value)) {
                void value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */
        this._executeHandlers = function () {
            if (_this._state === 0 /* PENDING */) {
                return;
            }
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function (handler) {
                if (handler[0]) {
                    return;
                }
                if (_this._state === 1 /* RESOLVED */) {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    handler[1](_this._value);
                }
                if (_this._state === 2 /* REJECTED */) {
                    handler[2](_this._value);
                }
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        }
        catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */
    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            _this._handlers.push([
                false,
                function (result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                    }
                    else {
                        try {
                            resolve(onfulfilled(result));
                        }
                        catch (e) {
                            reject(e);
                        }
                    }
                },
                function (reason) {
                    if (!onrejected) {
                        reject(reason);
                    }
                    else {
                        try {
                            resolve(onrejected(reason));
                        }
                        catch (e) {
                            reject(e);
                        }
                    }
                },
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */
    SyncPromise.prototype.catch = function (onrejected) {
        return this.then(function (val) { return val; }, onrejected);
    };
    /** JSDoc */
    SyncPromise.prototype.finally = function (onfinally) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function (value) {
                isRejected = false;
                val = value;
                if (onfinally) {
                    onfinally();
                }
            }, function (reason) {
                isRejected = true;
                val = reason;
                if (onfinally) {
                    onfinally();
                }
            }).then(function () {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}());

//# sourceMappingURL=syncpromise.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+hub@6.18.2/node_modules/@sentry/hub/esm/scope.js


/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var Scope = /** @class */ (function () {
    function Scope() {
        /** Flag if notifying is happening. */
        this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this._eventProcessors = [];
        /** Array of breadcrumbs. */
        this._breadcrumbs = [];
        /** User */
        this._user = {};
        /** Tags */
        this._tags = {};
        /** Extra */
        this._extra = {};
        /** Contexts */
        this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */
        this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0,tslib_es6/* __spread */.fl)(scope._breadcrumbs);
            newScope._tags = (0,tslib_es6/* __assign */.pi)({}, scope._tags);
            newScope._extra = (0,tslib_es6/* __assign */.pi)({}, scope._extra);
            newScope._contexts = (0,tslib_es6/* __assign */.pi)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0,tslib_es6/* __spread */.fl)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    Scope.prototype.addScopeListener = function (callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addEventProcessor = function (callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setUser = function (user) {
        this._user = user || {};
        if (this._session) {
            this._session.update({ user: user });
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getUser = function () {
        return this._user;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getRequestSession = function () {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setRequestSession = function (requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTags = function (tags) {
        this._tags = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this._tags = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtras = function (extras) {
        this._extra = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this._extra = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setLevel = function (level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTransactionName = function (name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */
    Scope.prototype.setTransaction = function (name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setContext = function (key, context) {
        var _a;
        if (context === null) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._contexts[key];
        }
        else {
            this._contexts = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSpan = function (span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSpan = function () {
        return this._span;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getTransaction = function () {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSession = function (session) {
        if (!session) {
            delete this._session;
        }
        else {
            this._session = session;
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSession = function () {
        return this._session;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.update = function (captureContext) {
        if (!captureContext) {
            return this;
        }
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._tags), captureContext._tags);
            this._extra = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._extra), captureContext._extra);
            this._contexts = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) {
                this._user = captureContext._user;
            }
            if (captureContext._level) {
                this._level = captureContext._level;
            }
            if (captureContext._fingerprint) {
                this._fingerprint = captureContext._fingerprint;
            }
            if (captureContext._requestSession) {
                this._requestSession = captureContext._requestSession;
            }
        }
        else if (isPlainObject(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext = captureContext;
            this._tags = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._tags), captureContext.tags);
            this._extra = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._extra), captureContext.extra);
            this._contexts = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) {
                this._user = captureContext.user;
            }
            if (captureContext.level) {
                this._level = captureContext.level;
            }
            if (captureContext.fingerprint) {
                this._fingerprint = captureContext.fingerprint;
            }
            if (captureContext.requestSession) {
                this._requestSession = captureContext.requestSession;
            }
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clear = function () {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, MAX_BREADCRUMBS) : MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) {
            return this;
        }
        var mergedBreadcrumb = (0,tslib_es6/* __assign */.pi)({ timestamp: (0,time/* dateTimestampInSeconds */.yW)() }, breadcrumb);
        this._breadcrumbs = (0,tslib_es6/* __spread */.fl)(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clearBreadcrumbs = function () {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */
    Scope.prototype.applyToEvent = function (event, hint) {
        if (this._extra && Object.keys(this._extra).length) {
            event.extra = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._extra), event.extra);
        }
        if (this._tags && Object.keys(this._tags).length) {
            event.tags = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._tags), event.tags);
        }
        if (this._user && Object.keys(this._user).length) {
            event.user = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._user), event.user);
        }
        if (this._contexts && Object.keys(this._contexts).length) {
            event.contexts = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._contexts), event.contexts);
        }
        if (this._level) {
            event.level = this._level;
        }
        if (this._transactionName) {
            event.transaction = this._transactionName;
        }
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0,tslib_es6/* __assign */.pi)({ trace: this._span.getTraceContext() }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) {
                event.tags = (0,tslib_es6/* __assign */.pi)({ transaction: transactionName }, event.tags);
            }
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0,tslib_es6/* __spread */.fl)((event.breadcrumbs || []), this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0,tslib_es6/* __spread */.fl)(getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */
    Scope.prototype.setSDKProcessingMetadata = function (newData) {
        this._sdkProcessingMetadata = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
        var _this = this;
        if (index === void 0) { index = 0; }
        return new SyncPromise(function (resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') {
                resolve(event);
            }
            else {
                var result = processor((0,tslib_es6/* __assign */.pi)({}, event), hint);
                if (isThenable(result)) {
                    void result
                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
                        .then(null, reject);
                }
                else {
                    void _this._notifyEventProcessors(processors, result, hint, index + 1)
                        .then(resolve)
                        .then(null, reject);
                }
            }
        });
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype._notifyScopeListeners = function () {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function (callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype._applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint
            ? Array.isArray(event.fingerprint)
                ? event.fingerprint
                : [event.fingerprint]
            : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) {
            event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    return Scope;
}());

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
    /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access  */
    var global = (0,esm_global/* getGlobalObject */.R)();
    global.__SENTRY__ = global.__SENTRY__ || {};
    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
    return global.__SENTRY__.globalEventProcessors;
    /* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}
//# sourceMappingURL=scope.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.18.2/node_modules/@sentry/utils/esm/browser.js


/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
                break;
            }
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length
        ? keyAttrs.filter(function (keyAttr) { return elem.getAttribute(keyAttr); }).map(function (keyAttr) { return [keyAttr, elem.getAttribute(keyAttr)]; })
        : null;
    if (keyAttrPairs && keyAttrPairs.length) {
        keyAttrPairs.forEach(function (keyAttrPair) {
            out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
        });
    }
    else {
        if (elem.id) {
            out.push("#" + elem.id);
        }
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && isString(className)) {
            classes = className.split(/\s+/);
            for (i = 0; i < classes.length; i++) {
                out.push("." + classes[i]);
            }
        }
    }
    var allowedAttrs = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < allowedAttrs.length; i++) {
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */
function getLocationHref() {
    var global = (0,esm_global/* getGlobalObject */.R)();
    try {
        return global.document.location.href;
    }
    catch (oO) {
        return '';
    }
}
//# sourceMappingURL=browser.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.18.2/node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Helper to decycle json objects
 */
function memoBuilder() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) {
                return true;
            }
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (var i = 0; i < inner.length; i++) {
            var value = inner[i];
            if (value === obj) {
                return true;
            }
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) {
            inner.delete(obj);
        }
        else {
            for (var i = 0; i < inner.length; i++) {
                if (inner[i] === obj) {
                    inner.splice(i, 1);
                    break;
                }
            }
        }
    }
    return [memoize, unmemoize];
}
//# sourceMappingURL=memo.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.18.2/node_modules/@sentry/utils/esm/stacktrace.js

var STACKTRACE_LIMIT = 50;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser() {
    var parsers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parsers[_i] = arguments[_i];
    }
    var sortedParsers = parsers.sort(function (a, b) { return a[0] - b[0]; }).map(function (p) { return p[1]; });
    return function (stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) { skipFirst = 0; }
        var frames = [];
        try {
            for (var _c = (0,tslib_es6/* __values */.XA)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var line = _d.value;
                try {
                    for (var sortedParsers_1 = (e_2 = void 0, (0,tslib_es6/* __values */.XA)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()) {
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return stripSentryFramesAndReverse(frames);
    };
}
/**
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
    if (!stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack
        .slice(0, STACKTRACE_LIMIT)
        .map(function (frame) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, frame), { filename: frame.filename || localStack[0].filename, function: frame.function || '?' })); })
        .reverse();
}
var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') {
            return defaultFunctionName;
        }
        return fn.name || defaultFunctionName;
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
//# sourceMappingURL=stacktrace.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.18.2/node_modules/@sentry/utils/esm/string.js

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    if (typeof str !== 'string' || max === 0) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function string_snipLine(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) {
        return newLine;
    }
    if (colno > lineLength) {
        // eslint-disable-next-line no-param-reassign
        colno = lineLength;
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) {
        end = lineLength;
    }
    if (end === lineLength) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} " + newLine;
    }
    if (end < lineLength) {
        newLine += ' {snip}';
    }
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
    if (!isString(value)) {
        return false;
    }
    if (isRegExp(pattern)) {
        return pattern.test(value);
    }
    if (typeof pattern === 'string') {
        return value.indexOf(pattern) !== -1;
    }
    return false;
}
/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */
function escapeStringForRegex(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
//# sourceMappingURL=string.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.18.2/node_modules/@sentry/utils/esm/object.js






/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') {
        try {
            markFunctionWrapped(wrapped, original);
        }
        catch (_Oo) {
            // This can throw if multiple fill happens on a global object like XMLHttpRequest
            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function object_addNonEnumerableProperty(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true,
    });
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    object_addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
/**
 * Transforms any object into an object literal with all its attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 */
function getWalkSource(value) {
    if (isError(value)) {
        var error = value;
        var err = {
            message: error.message,
            name: error.name,
            stack: error.stack,
        };
        for (var i in error) {
            if (Object.prototype.hasOwnProperty.call(error, i)) {
                err[i] = error[i];
            }
        }
        return err;
    }
    if (isEvent(value)) {
        var event_1 = value;
        var source = {};
        // Accessing event attributes can throw (see https://github.com/getsentry/sentry-javascript/issues/768 and
        // https://github.com/getsentry/sentry-javascript/issues/838), but accessing `type` hasn't been wrapped in a
        // try-catch in at least two years and no one's complained, so that's likely not an issue anymore
        source.type = event_1.type;
        try {
            source.target = isElement(event_1.target)
                ? htmlTreeAsString(event_1.target)
                : Object.prototype.toString.call(event_1.target);
        }
        catch (_oO) {
            source.target = '<unknown>';
        }
        try {
            source.currentTarget = isElement(event_1.currentTarget)
                ? htmlTreeAsString(event_1.currentTarget)
                : Object.prototype.toString.call(event_1.currentTarget);
        }
        catch (_oO) {
            source.currentTarget = '<unknown>';
        }
        if (typeof CustomEvent !== 'undefined' && isInstanceOf(value, CustomEvent)) {
            source.detail = event_1.detail;
        }
        for (var attr in event_1) {
            if (Object.prototype.hasOwnProperty.call(event_1, attr)) {
                source[attr] = event_1[attr];
            }
        }
        return source;
    }
    return value;
}
/** Calculates bytes size of input string */
function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/** JSDoc */
function normalizeToSize(object, 
// Default Node.js REPL depth
depth, 
// 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) { depth = 3; }
    if (maxSize === void 0) { maxSize = 100 * 1024; }
    var serialized = normalize(object, depth);
    if (jsonSize(serialized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return serialized;
}
/**
 * Transform any non-primitive, BigInt, or Symbol-type value into a string. Acts as a no-op on strings, numbers,
 * booleans, null, and undefined.
 *
 * @param value The value to stringify
 * @returns For non-primitive, BigInt, and Symbol-type values, a string denoting the value's type, type and value, or
 *  type and `description` property, respectively. For non-BigInt, non-Symbol primitives, returns the original value,
 *  unchanged.
 */
function serializeValue(value) {
    // Node.js REPL notation
    if (typeof value === 'string') {
        return value;
    }
    var type = Object.prototype.toString.call(value);
    if (type === '[object Object]') {
        return '[Object]';
    }
    if (type === '[object Array]') {
        return '[Array]';
    }
    // `makeSerializable` provides a string representation of certain non-serializable values. For all others, it's a
    // pass-through.
    var serializable = makeSerializable(value);
    return is_isPrimitive(serializable) ? serializable : type;
}
/**
 * makeSerializable()
 *
 * Takes unserializable input and make it serializer-friendly.
 *
 * Handles globals, functions, `undefined`, `NaN`, and other non-serializable values.
 */
function makeSerializable(value, key) {
    if (key === 'domain' && value && typeof value === 'object' && value._events) {
        return '[Domain]';
    }
    if (key === 'domainEmitter') {
        return '[DomainEmitter]';
    }
    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
        return '[Global]';
    }
    // It's safe to use `window` and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.
    // eslint-disable-next-line no-restricted-globals
    if (typeof window !== 'undefined' && value === window) {
        return '[Window]';
    }
    // eslint-disable-next-line no-restricted-globals
    if (typeof document !== 'undefined' && value === document) {
        return '[Document]';
    }
    // React's SyntheticEvent thingy
    if (isSyntheticEvent(value)) {
        return '[SyntheticEvent]';
    }
    if (typeof value === 'number' && value !== value) {
        return '[NaN]';
    }
    if (value === void 0) {
        return '[undefined]';
    }
    if (typeof value === 'function') {
        return "[Function: " + getFunctionName(value) + "]";
    }
    // symbols and bigints are considered primitives by TS, but aren't natively JSON-serilaizable
    if (typeof value === 'symbol') {
        return "[" + String(value) + "]";
    }
    if (typeof value === 'bigint') {
        return "[BigInt: " + String(value) + "]";
    }
    return value;
}
/**
 * Walks an object to perform a normalization on it
 *
 * @param key of object that's walked in current iteration
 * @param value object to be walked
 * @param depth Optional number indicating how deep should walking be performed
 * @param memo Optional Memo class handling decycling
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function walk(key, value, depth, memo) {
    if (depth === void 0) { depth = +Infinity; }
    if (memo === void 0) { memo = memoBuilder(); }
    var _a = (0,tslib_es6/* __read */.CR)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If we reach the maximum depth, serialize whatever is left
    if (depth === 0) {
        return serializeValue(value);
    }
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // If value implements `toJSON` method, call it and return early
    if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
        return value.toJSON();
    }
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    // `makeSerializable` provides a string representation of certain non-serializable values. For all others, it's a
    // pass-through. If what comes back is a primitive (either because it's been stringified or because it was primitive
    // all along), we're done.
    var serializable = makeSerializable(value, key);
    if (is_isPrimitive(serializable)) {
        return serializable;
    }
    // Create source that we will use for the next iteration. It will either be an objectified error object (`Error` type
    // with extracted key:value pairs) or the input itself.
    var source = getWalkSource(value);
    // Create an accumulator that will act as a parent for all future itterations of that branch
    var acc = Array.isArray(value) ? [] : {};
    // If we already walked that branch, bail out, as it's circular reference
    if (memoize(value)) {
        return '[Circular ~]';
    }
    // Walk all keys of the source
    for (var innerKey in source) {
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
            continue;
        }
        // Recursively walk through all the child nodes
        var innerValue = source[innerKey];
        acc[innerKey] = walk(innerKey, innerValue, depth - 1, memo);
    }
    // Once walked through all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return acc;
}
/**
 * normalize()
 *
 * - Creates a copy to prevent original input mutation
 * - Skip non-enumerablers
 * - Calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
 * - Translates known global objects/Classes to a string representations
 * - Takes care of Error objects serialization
 * - Optionally limit depth of final output
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function normalize(input, depth) {
    try {
        // since we're at the outermost level, there is no key
        return walk('', input, depth);
    }
    catch (_oO) {
        return '**non-serializable**';
    }
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) { maxLength = 40; }
    var keys = Object.keys(getWalkSource(exception));
    keys.sort();
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return truncate(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return truncate(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return the new object with removed keys that value was `undefined`.
 * Works recursively on objects and arrays.
 */
function dropUndefinedKeys(val) {
    var e_1, _a;
    if (isPlainObject(val)) {
        var obj = val;
        var rv = {};
        try {
            for (var _b = (0,tslib_es6/* __values */.XA)(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (typeof obj[key] !== 'undefined') {
                    rv[key] = dropUndefinedKeys(obj[key]);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return rv;
    }
    if (Array.isArray(val)) {
        return val.map(dropUndefinedKeys);
    }
    return val;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
    var objectified;
    switch (true) {
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case isPrimitive(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
//# sourceMappingURL=object.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+hub@6.18.2/node_modules/@sentry/hub/esm/session.js

/**
 * @inheritdoc
 */
var Session = /** @class */ (function () {
    function Session(context) {
        this.errors = 0;
        this.sid = uuid4();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0,time/* timestampInSeconds */.ph)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) {
            this.update(context);
        }
    }
    /** JSDoc */
    // eslint-disable-next-line complexity
    Session.prototype.update = function (context) {
        if (context === void 0) { context = {}; }
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) {
                this.ipAddress = context.user.ip_address;
            }
            if (!this.did && !context.did) {
                this.did = context.user.id || context.user.email || context.user.username;
            }
        }
        this.timestamp = context.timestamp || (0,time/* timestampInSeconds */.ph)();
        if (context.ignoreDuration) {
            this.ignoreDuration = context.ignoreDuration;
        }
        if (context.sid) {
            // Good enough uuid validation. — Kamil
            this.sid = context.sid.length === 32 ? context.sid : uuid4();
        }
        if (context.init !== undefined) {
            this.init = context.init;
        }
        if (!this.did && context.did) {
            this.did = "" + context.did;
        }
        if (typeof context.started === 'number') {
            this.started = context.started;
        }
        if (this.ignoreDuration) {
            this.duration = undefined;
        }
        else if (typeof context.duration === 'number') {
            this.duration = context.duration;
        }
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) {
            this.release = context.release;
        }
        if (context.environment) {
            this.environment = context.environment;
        }
        if (!this.ipAddress && context.ipAddress) {
            this.ipAddress = context.ipAddress;
        }
        if (!this.userAgent && context.userAgent) {
            this.userAgent = context.userAgent;
        }
        if (typeof context.errors === 'number') {
            this.errors = context.errors;
        }
        if (context.status) {
            this.status = context.status;
        }
    };
    /** JSDoc */
    Session.prototype.close = function (status) {
        if (status) {
            this.update({ status: status });
        }
        else if (this.status === 'ok') {
            this.update({ status: 'exited' });
        }
        else {
            this.update();
        }
    };
    /** JSDoc */
    Session.prototype.toJSON = function () {
        return dropUndefinedKeys({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent,
            },
        });
    };
    return Session;
}());

//# sourceMappingURL=session.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+hub@6.18.2/node_modules/@sentry/hub/esm/hub.js




/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */
var Hub = /** @class */ (function () {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */
    function Hub(client, scope, _version) {
        if (scope === void 0) { scope = new Scope(); }
        if (_version === void 0) { _version = API_VERSION; }
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */
        this._stack = [{}];
        this.getStackTop().scope = scope;
        if (client) {
            this.bindClient(client);
        }
    }
    /**
     * @inheritDoc
     */
    Hub.prototype.isOlderThan = function (version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.bindClient = function (client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) {
            client.setupIntegrations();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.pushScope = function () {
        // We want to clone the content of prev scope
        var scope = Scope.clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope,
        });
        return scope;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.popScope = function () {
        if (this.getStack().length <= 1)
            return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.withScope = function (callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        }
        finally {
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getClient = function () {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */
    Hub.prototype.getScope = function () {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */
    Hub.prototype.getStack = function () {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */
    Hub.prototype.getStackTop = function () {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function (exception, hint) {
        var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : uuid4());
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureException', exception, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureMessage = function (message, level, hint) {
        var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : uuid4());
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureMessage', message, level, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureEvent = function (event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : uuid4();
        if (event.type !== 'transaction') {
            this._lastEventId = eventId;
        }
        this._invokeClient('captureEvent', event, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, hint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.lastEventId = function () {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client)
            return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0)
            return;
        var timestamp = (0,time/* dateTimestampInSeconds */.yW)();
        var mergedBreadcrumb = (0,tslib_es6/* __assign */.pi)({ timestamp: timestamp }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb
            ? consoleSandbox(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
            : mergedBreadcrumb;
        if (finalBreadcrumb === null)
            return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setUser = function (user) {
        var scope = this.getScope();
        if (scope)
            scope.setUser(user);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTags = function (tags) {
        var scope = this.getScope();
        if (scope)
            scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtras = function (extras) {
        var scope = this.getScope();
        if (scope)
            scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTag = function (key, value) {
        var scope = this.getScope();
        if (scope)
            scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtra = function (key, extra) {
        var scope = this.getScope();
        if (scope)
            scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function (name, context) {
        var scope = this.getScope();
        if (scope)
            scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.configureScope = function (callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) {
            callback(scope);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.run = function (callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        }
        finally {
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getIntegration = function (integration) {
        var client = this.getClient();
        if (!client)
            return null;
        try {
            return client.getIntegration(integration);
        }
        catch (_oO) {
            logger_logger.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSpan = function (context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startTransaction = function (context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.traceHeaders = function () {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureSession = function (endSession) {
        if (endSession === void 0) { endSession = false; }
        // both send the update and pull the session from the scope
        if (endSession) {
            return this.endSession();
        }
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.endSession = function () {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) {
            session.close();
        }
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) {
            scope.setSession();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSession = function (context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0,esm_global/* getGlobalObject */.R)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new Session((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ release: release,
            environment: environment }, (scope && { user: scope.getUser() })), (userAgent && { userAgent: userAgent })), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') {
                currentSession.update({ status: 'exited' });
            }
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */
    Hub.prototype._sendSessionUpdate = function () {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope)
            return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) {
                client.captureSession(session);
            }
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function (method) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            (_a = client)[method].apply(_a, (0,tslib_es6/* __spread */.fl)(args, [scope]));
        }
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */
    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function (method) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
            return sentry.extensions[method].apply(this, args);
        }
        logger_logger.warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}());

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
    var carrier = (0,esm_global/* getGlobalObject */.R)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined,
    };
    return carrier;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function hub_getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0,node/* isNodeEnv */.KV)()) {
        return getHubFromActiveDomain(registry);
    }
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * Returns the active domain, if one exists
 * @deprecated No longer used; remove in v7
 * @returns The domain, or undefined if there is no active domain
 */
// eslint-disable-next-line deprecation/deprecation
function getActiveDomain() {
    logger.warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = getMainCarrier().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
    try {
        var sentry = getMainCarrier().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) {
            return getHubFromCarrier(registry);
        }
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, Scope.clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    }
    catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub)
        return carrier.__SENTRY__.hub;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = new Hub();
    return carrier.__SENTRY__.hub;
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
    if (!carrier)
        return false;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = hub;
    return true;
}
//# sourceMappingURL=hub.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+minimal@6.18.2/node_modules/@sentry/minimal/esm/index.js


/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = hub_getCurrentHub();
    if (hub && hub[method]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return hub[method].apply(hub, (0,tslib_es6/* __spread */.fl)(args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
    var syntheticException;
    try {
        throw new Error('Sentry syntheticException');
    }
    catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException,
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(message, captureContext) {
    var syntheticException;
    try {
        throw new Error(message);
    }
    catch (exception) {
        syntheticException = exception;
    }
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
    return callOnHub('captureMessage', message, level, __assign({ originalException: message, syntheticException: syntheticException }, context));
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event) {
    return callOnHub('captureEvent', event);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
    callOnHub('configureScope', callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
    callOnHub('addBreadcrumb', breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
    callOnHub('setContext', name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
    callOnHub('setExtras', extras);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
    callOnHub('setTags', tags);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
    callOnHub('setExtra', key, extra);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
    callOnHub('setTag', key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
    callOnHub('setUser', user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 * @hidden
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _callOnClient(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    callOnHub.apply(void 0, __spread(['_invokeClient', method], args));
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(context, customSamplingContext) {
    return callOnHub('startTransaction', __assign({}, context), customSamplingContext);
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+utils@6.18.2/node_modules/@sentry/utils/esm/env.js
var env = __webpack_require__(30621);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+core@6.18.2/node_modules/@sentry/core/esm/integrations/inboundfilters.js



// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */ (function () {
    function InboundFilters(_options) {
        if (_options === void 0) { _options = {}; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function () {
        addGlobalEventProcessor(function (event) {
            var hub = hub_getCurrentHub();
            if (!hub) {
                return event;
            }
            var self = hub.getIntegration(InboundFilters);
            if (self) {
                var client = hub.getClient();
                var clientOptions = client ? client.getOptions() : {};
                // This checks prevents most of the occurrences of the bug linked below:
                // https://github.com/getsentry/sentry-javascript/issues/2622
                // The bug is caused by multiple SDK instances, where one is minified and one is using non-mangled code.
                // Unfortunatelly we cannot fix it reliably (thus reserved property in rollup's terser config),
                // as we cannot force people using multiple instances in their apps to sync SDK versions.
                var options = typeof self._mergeOptions === 'function' ? self._mergeOptions(clientOptions) : {};
                if (typeof self._shouldDropEvent !== 'function') {
                    return event;
                }
                return self._shouldDropEvent(event, options) ? null : event;
            }
            return event;
        });
    };
    /** JSDoc */
    InboundFilters.prototype._shouldDropEvent = function (event, options) {
        if (this._isSentryError(event, options)) {
            if ((0,env/* isDebugBuild */.c)()) {
                logger_logger.warn("Event dropped due to being internal Sentry Error.\nEvent: " + getEventDescription(event));
            }
            return true;
        }
        if (this._isIgnoredError(event, options)) {
            if ((0,env/* isDebugBuild */.c)()) {
                logger_logger.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + getEventDescription(event));
            }
            return true;
        }
        if (this._isDeniedUrl(event, options)) {
            if ((0,env/* isDebugBuild */.c)()) {
                logger_logger.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            }
            return true;
        }
        if (!this._isAllowedUrl(event, options)) {
            if ((0,env/* isDebugBuild */.c)()) {
                logger_logger.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            }
            return true;
        }
        return false;
    };
    /** JSDoc */
    InboundFilters.prototype._isSentryError = function (event, options) {
        if (!options.ignoreInternal) {
            return false;
        }
        try {
            // @ts-ignore can't be a sentry error if undefined
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return event.exception.values[0].type === 'SentryError';
        }
        catch (e) {
            // ignore
        }
        return false;
    };
    /** JSDoc */
    InboundFilters.prototype._isIgnoredError = function (event, options) {
        if (!options.ignoreErrors || !options.ignoreErrors.length) {
            return false;
        }
        return this._getPossibleEventMessages(event).some(function (message) {
            // Not sure why TypeScript complains here...
            return options.ignoreErrors.some(function (pattern) { return isMatchingPattern(message, pattern); });
        });
    };
    /** JSDoc */
    InboundFilters.prototype._isDeniedUrl = function (event, options) {
        // TODO: Use Glob instead?
        if (!options.denyUrls || !options.denyUrls.length) {
            return false;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? false : options.denyUrls.some(function (pattern) { return isMatchingPattern(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._isAllowedUrl = function (event, options) {
        // TODO: Use Glob instead?
        if (!options.allowUrls || !options.allowUrls.length) {
            return true;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? true : options.allowUrls.some(function (pattern) { return isMatchingPattern(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._mergeOptions = function (clientOptions) {
        if (clientOptions === void 0) { clientOptions = {}; }
        return {
            allowUrls: (0,tslib_es6/* __spread */.fl)((this._options.whitelistUrls || []), (this._options.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
            denyUrls: (0,tslib_es6/* __spread */.fl)((this._options.blacklistUrls || []), (this._options.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
            ignoreErrors: (0,tslib_es6/* __spread */.fl)((this._options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
        };
    };
    /** JSDoc */
    InboundFilters.prototype._getPossibleEventMessages = function (event) {
        if (event.message) {
            return [event.message];
        }
        if (event.exception) {
            try {
                var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
                return ["" + value, type + ": " + value];
            }
            catch (oO) {
                if ((0,env/* isDebugBuild */.c)()) {
                    logger_logger.error("Cannot extract message for event " + getEventDescription(event));
                }
                return [];
            }
        }
        return [];
    };
    /** JSDoc */
    InboundFilters.prototype._getLastValidUrl = function (frames) {
        if (frames === void 0) { frames = []; }
        for (var i = frames.length - 1; i >= 0; i--) {
            var frame = frames[i];
            if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
                return frame.filename || null;
            }
        }
        return null;
    };
    /** JSDoc */
    InboundFilters.prototype._getEventFilterUrl = function (event) {
        try {
            if (event.stacktrace) {
                return this._getLastValidUrl(event.stacktrace.frames);
            }
            var frames_1;
            try {
                // @ts-ignore we only care about frames if the whole thing here is defined
                frames_1 = event.exception.values[0].stacktrace.frames;
            }
            catch (e) {
                // ignore
            }
            return frames_1 ? this._getLastValidUrl(frames_1) : null;
        }
        catch (oO) {
            if ((0,env/* isDebugBuild */.c)()) {
                logger_logger.error("Cannot extract url for event " + getEventDescription(event));
            }
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}());

//# sourceMappingURL=inboundfilters.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+core@6.18.2/node_modules/@sentry/core/esm/integrations/functiontostring.js

var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */ (function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = getOriginalFunction(this) || this;
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}());

//# sourceMappingURL=functiontostring.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.18.2/node_modules/@sentry/browser/esm/helpers.js



var helpers_global = (0,esm_global/* getGlobalObject */.R)();
var ignoreOnError = 0;
/**
 * @hidden
 */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) { options = {}; }
    if (typeof fn !== 'function') {
        return fn;
    }
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            return wrapper;
        }
        // We don't wanna wrap it twice
        if (getOriginalFunction(fn)) {
            return fn;
        }
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function () {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') {
                before.apply(this, arguments);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        }
        catch (ex) {
            ignoreNextOnError();
            withScope(function (scope) {
                scope.addEventProcessor(function (event) {
                    if (options.mechanism) {
                        addExceptionTypeValue(event, undefined, undefined);
                        misc_addExceptionMechanism(event, options.mechanism);
                    }
                    event.extra = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event.extra), { arguments: args });
                    return event;
                });
                captureException(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    }
    catch (_oO) { } // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    markFunctionWrapped(sentryWrapped, fn);
    object_addNonEnumerableProperty(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, 'name', {
                get: function () {
                    return fn.name;
                },
            });
        }
        // eslint-disable-next-line no-empty
    }
    catch (_oO) { }
    return sentryWrapped;
}
/**
 * Injects the Report Dialog script
 * @hidden
 */
function injectReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!helpers_global.document) {
        return;
    }
    if (!options.eventId) {
        if (isDebugBuild()) {
            logger.error('Missing eventId option in showReportDialog call');
        }
        return;
    }
    if (!options.dsn) {
        if (isDebugBuild()) {
            logger.error('Missing dsn option in showReportDialog call');
        }
        return;
    }
    var script = helpers_global.document.createElement('script');
    script.async = true;
    script.src = getReportDialogEndpoint(options.dsn, options);
    if (options.onLoad) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        script.onload = options.onLoad;
    }
    var injectionPoint = helpers_global.document.head || helpers_global.document.body;
    if (injectionPoint) {
        injectionPoint.appendChild(script);
    }
}
//# sourceMappingURL=helpers.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.18.2/node_modules/@sentry/browser/esm/integrations/trycatch.js



var DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload',
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */
var TryCatch = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function TryCatch(options) {
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
        this._options = (0,tslib_es6/* __assign */.pi)({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        var global = (0,esm_global/* getGlobalObject */.R)();
        if (this._options.setTimeout) {
            fill(global, 'setTimeout', _wrapTimeFunction);
        }
        if (this._options.setInterval) {
            fill(global, 'setInterval', _wrapTimeFunction);
        }
        if (this._options.requestAnimationFrame) {
            fill(global, 'requestAnimationFrame', _wrapRAF);
        }
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
            fill(XMLHttpRequest.prototype, 'send', _wrapXHR);
        }
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
            eventTarget.forEach(_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}());

/** JSDoc */
function _wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var originalCallback = args[0];
        args[0] = wrap(originalCallback, {
            mechanism: {
                data: { function: getFunctionName(original) },
                handled: true,
                type: 'instrument',
            },
        });
        return original.apply(this, args);
    };
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.call(this, wrap(callback, {
            mechanism: {
                data: {
                    function: 'requestAnimationFrame',
                    handler: getFunctionName(original),
                },
                handled: true,
                type: 'instrument',
            },
        }));
    };
}
/** JSDoc */
function _wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
        xmlHttpRequestProps.forEach(function (prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                fill(xhr, prop, function (original) {
                    var wrapOptions = {
                        mechanism: {
                            data: {
                                function: prop,
                                handler: getFunctionName(original),
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    };
                    // If Instrument integration has been called before TryCatch, get the name of original function
                    var originalFunction = getOriginalFunction(original);
                    if (originalFunction) {
                        wrapOptions.mechanism.data.handler = getFunctionName(originalFunction);
                    }
                    // Otherwise wrap directly
                    return wrap(original, wrapOptions);
                });
            }
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */
function _wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0,esm_global/* getGlobalObject */.R)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
        return;
    }
    fill(proto, 'addEventListener', function (original) {
        return function (eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') {
                    fn.handleEvent = wrap(fn.handleEvent.bind(fn), {
                        mechanism: {
                            data: {
                                function: 'handleEvent',
                                handler: getFunctionName(fn),
                                target: target,
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    });
                }
            }
            catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.call(this, eventName, 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            wrap(fn, {
                mechanism: {
                    data: {
                        function: 'addEventListener',
                        handler: getFunctionName(fn),
                        target: target,
                    },
                    handled: true,
                    type: 'instrument',
                },
            }), options);
        };
    });
    fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
        return function (eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */
            var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) {
                    originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            }
            catch (e) {
                // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}
//# sourceMappingURL=trycatch.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+types@6.18.2/node_modules/@sentry/types/esm/severity.js
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */
var severity_Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(severity_Severity || (severity_Severity = {}));
// TODO: in v7, these can disappear, because they now also exist in `@sentry/utils`. (Having them there rather than here
// is nice because then it enforces the idea that only types are exported from `@sentry/types`.)
var SeverityLevels = (/* unused pure expression or super */ null && (['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical']));
//# sourceMappingURL=severity.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.18.2/node_modules/@sentry/utils/esm/supports.js



/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
    try {
        new ErrorEvent('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
    try {
        new DOMException('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in (0,esm_global/* getGlobalObject */.R)())) {
        return false;
    }
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var global = (0,esm_global/* getGlobalObject */.R)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(global.fetch)) {
        return true;
    }
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') {
        try {
            var sandbox = doc.createElement('iframe');
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // eslint-disable-next-line @typescript-eslint/unbound-method
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        }
        catch (err) {
            if ((0,env/* isDebugBuild */.c)()) {
                logger_logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
            }
        }
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
    return 'ReportingObserver' in getGlobalObject();
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        new Request('_', {
            referrerPolicy: 'origin',
        });
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0,esm_global/* getGlobalObject */.R)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
//# sourceMappingURL=supports.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.18.2/node_modules/@sentry/utils/esm/instrument.js








var instrument_global = (0,esm_global/* getGlobalObject */.R)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */
var handlers = {};
var instrumented = {};
/** Instruments given API */
function instrument(type) {
    if (instrumented[type]) {
        return;
    }
    instrumented[type] = true;
    switch (type) {
        case 'console':
            instrumentConsole();
            break;
        case 'dom':
            instrumentDOM();
            break;
        case 'xhr':
            instrumentXHR();
            break;
        case 'fetch':
            instrumentFetch();
            break;
        case 'history':
            instrumentHistory();
            break;
        case 'error':
            instrumentError();
            break;
        case 'unhandledrejection':
            instrumentUnhandledRejection();
            break;
        default:
            logger_logger.warn('unknown instrumentation type:', type);
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function instrument_addInstrumentationHandler(type, callback) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(callback);
    instrument(type);
}
/** JSDoc */
function triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !handlers[type]) {
        return;
    }
    try {
        for (var _b = (0,tslib_es6/* __values */.XA)(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
            var handler = _c.value;
            try {
                handler(data);
            }
            catch (e) {
                if ((0,env/* isDebugBuild */.c)()) {
                    logger_logger.error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + getFunctionName(handler) + "\nError:", e);
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/** JSDoc */
function instrumentConsole() {
    if (!('console' in instrument_global)) {
        return;
    }
    ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
        if (!(level in instrument_global.console)) {
            return;
        }
        fill(instrument_global.console, level, function (originalConsoleMethod) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                triggerHandlers('console', { args: args, level: level });
                // this fails for some browsers. :(
                if (originalConsoleMethod) {
                    originalConsoleMethod.apply(instrument_global.console, args);
                }
            };
        });
    });
}
/** JSDoc */
function instrumentFetch() {
    if (!supportsNativeFetch()) {
        return;
    }
    fill(instrument_global, 'fetch', function (originalFetch) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var handlerData = {
                args: args,
                fetchData: {
                    method: getFetchMethod(args),
                    url: getFetchUrl(args),
                },
                startTimestamp: Date.now(),
            };
            triggerHandlers('fetch', (0,tslib_es6/* __assign */.pi)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply(instrument_global, args).then(function (response) {
                triggerHandlers('fetch', (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, handlerData), { endTimestamp: Date.now(), response: response }));
                return response;
            }, function (error) {
                triggerHandlers('fetch', (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, handlerData), { endTimestamp: Date.now(), error: error }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if ('Request' in instrument_global && isInstanceOf(fetchArgs[0], Request) && fetchArgs[0].method) {
        return String(fetchArgs[0].method).toUpperCase();
    }
    if (fetchArgs[1] && fetchArgs[1].method) {
        return String(fetchArgs[1].method).toUpperCase();
    }
    return 'GET';
}
/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if (typeof fetchArgs[0] === 'string') {
        return fetchArgs[0];
    }
    if ('Request' in instrument_global && isInstanceOf(fetchArgs[0], Request)) {
        return fetchArgs[0].url;
    }
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */
/** JSDoc */
function instrumentXHR() {
    if (!('XMLHttpRequest' in instrument_global)) {
        return;
    }
    var xhrproto = XMLHttpRequest.prototype;
    fill(xhrproto, 'open', function (originalOpen) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = (xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: isString(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
            });
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (isString(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
                xhr.__sentry_own_request__ = true;
            }
            var onreadystatechangeHandler = function () {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    }
                    catch (e) {
                        /* do nothing */
                    }
                    triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr,
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                fill(xhr, 'onreadystatechange', function (original) {
                    return function () {
                        var readyStateArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            readyStateArgs[_i] = arguments[_i];
                        }
                        onreadystatechangeHandler();
                        return original.apply(xhr, readyStateArgs);
                    };
                });
            }
            else {
                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            }
            return originalOpen.apply(xhr, args);
        };
    });
    fill(xhrproto, 'send', function (originalSend) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.__sentry_xhr__ && args[0] !== undefined) {
                this.__sentry_xhr__.body = args[0];
            }
            triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this,
            });
            return originalSend.apply(this, args);
        };
    });
}
var lastHref;
/** JSDoc */
function instrumentHistory() {
    if (!supportsHistory()) {
        return;
    }
    var oldOnPopState = instrument_global.onpopstate;
    instrument_global.onpopstate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var to = instrument_global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        triggerHandlers('history', {
            from: from,
            to: to,
        });
        if (oldOnPopState) {
            // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
            // https://github.com/getsentry/sentry-javascript/issues/3344
            // https://github.com/bugsnag/bugsnag-js/issues/469
            try {
                return oldOnPopState.apply(this, args);
            }
            catch (_oO) {
                // no-empty
            }
        }
    };
    /** @hidden */
    function historyReplacementFunction(originalHistoryFunction) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                triggerHandlers('history', {
                    from: from,
                    to: to,
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    fill(instrument_global.history, 'pushState', historyReplacementFunction);
    fill(instrument_global.history, 'replaceState', historyReplacementFunction);
}
var debounceDuration = 1000;
var debounceTimerID;
var lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) {
        return true;
    }
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) {
        return true;
    }
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) {
            return true;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') {
        return false;
    }
    try {
        var target = event.target;
        if (!target || !target.tagName) {
            return true;
        }
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
            return false;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) { globalListener = false; }
    return function (event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || lastCapturedEvent === event) {
            return;
        }
        // We always want to skip _some_ events.
        if (shouldSkipDOMEvent(event)) {
            return;
        }
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if (debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout(debounceTimerID);
        debounceTimerID = instrument_global.setTimeout(function () {
            debounceTimerID = undefined;
        }, debounceDuration);
    };
}
/** JSDoc */
function instrumentDOM() {
    if (!('document' in instrument_global)) {
        return;
    }
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
    instrument_global.document.addEventListener('click', globalDOMEventHandler, false);
    instrument_global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    ['EventTarget', 'Node'].forEach(function (target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = instrument_global[target] && instrument_global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        fill(proto, 'addEventListener', function (originalAddEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_1 = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
                        var handlerForType = (handlers_1[type] = handlers_1[type] || { refCount: 0 });
                        if (!handlerForType.handler) {
                            var handler = makeDOMEventHandler(triggerDOMHandler);
                            handlerForType.handler = handler;
                            originalAddEventListener.call(this, type, handler, options);
                        }
                        handlerForType.refCount += 1;
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers_2[type];
                        if (handlerForType) {
                            handlerForType.refCount -= 1;
                            // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                            if (handlerForType.refCount <= 0) {
                                originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                                handlerForType.handler = undefined;
                                delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                            }
                            // If there are no longer any custom handlers of any type on this element, cleanup everything.
                            if (Object.keys(handlers_2).length === 0) {
                                delete el.__sentry_instrumentation_handlers__;
                            }
                        }
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
    _oldOnErrorHandler = instrument_global.onerror;
    instrument_global.onerror = function (msg, url, line, column, error) {
        triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url,
        });
        if (_oldOnErrorHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnErrorHandler.apply(this, arguments);
        }
        return false;
    };
}
var _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = instrument_global.onunhandledrejection;
    instrument_global.onunhandledrejection = function (e) {
        triggerHandlers('unhandledrejection', e);
        if (_oldOnUnhandledRejectionHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        }
        return true;
    };
}
//# sourceMappingURL=instrument.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.18.2/node_modules/@sentry/utils/esm/enums.js
var enums_SeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical'];
//# sourceMappingURL=enums.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+utils@6.18.2/node_modules/@sentry/utils/esm/severity.js


function isSupportedSeverity(level) {
    return enums_SeverityLevels.indexOf(level) !== -1;
}
/**
 * Converts a string-based level into a {@link Severity}.
 *
 * @param level string representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
    if (level === 'warn')
        return severity_Severity.Warning;
    if (isSupportedSeverity(level)) {
        return level;
    }
    return severity_Severity.Log;
}
//# sourceMappingURL=severity.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.18.2/node_modules/@sentry/browser/esm/integrations/breadcrumbs.js

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable max-lines */



/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
var Breadcrumbs = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this._options = (0,tslib_es6/* __assign */.pi)({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */
    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
        if (!this._options.sentry) {
            return;
        }
        hub_getCurrentHub().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: getEventDescription(event),
        }, {
            event: event,
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        if (this._options.console) {
            instrument_addInstrumentationHandler('console', _consoleBreadcrumb);
        }
        if (this._options.dom) {
            instrument_addInstrumentationHandler('dom', _domBreadcrumb(this._options.dom));
        }
        if (this._options.xhr) {
            instrument_addInstrumentationHandler('xhr', _xhrBreadcrumb);
        }
        if (this._options.fetch) {
            instrument_addInstrumentationHandler('fetch', _fetchBreadcrumb);
        }
        if (this._options.history) {
            instrument_addInstrumentationHandler('history', _historyBreadcrumb);
        }
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}());

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') {
            keyAttrs = [keyAttrs];
        }
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target
                ? htmlTreeAsString(handlerData.event.target, keyAttrs)
                : htmlTreeAsString(handlerData.event, keyAttrs);
        }
        catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) {
            return;
        }
        hub_getCurrentHub().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target,
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global,
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console',
        },
        level: severityFromString(handlerData.level),
        message: safeJoin(handlerData.args, ' '),
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + (safeJoin(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        }
        else {
            // Don't capture a breadcrumb for passed assertions
            return;
        }
    }
    hub_getCurrentHub().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level,
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) {
            return;
        }
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        hub_getCurrentHub().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code,
            },
            type: 'http',
        }, {
            xhr: handlerData.xhr,
            input: body,
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) {
        return;
    }
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
        // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
    }
    if (handlerData.error) {
        hub_getCurrentHub().addBreadcrumb({
            category: 'fetch',
            data: handlerData.fetchData,
            level: severity_Severity.Error,
            type: 'http',
        }, {
            data: handlerData.error,
            input: handlerData.args,
        });
    }
    else {
        hub_getCurrentHub().addBreadcrumb({
            category: 'fetch',
            data: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, handlerData.fetchData), { status_code: handlerData.response.status }),
            type: 'http',
        }, {
            input: handlerData.args,
            response: handlerData.response,
        });
    }
}
/**
 * Creates breadcrumbs from history API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _historyBreadcrumb(handlerData) {
    var global = (0,esm_global/* getGlobalObject */.R)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = parseUrl(global.location.href);
    var parsedFrom = parseUrl(from);
    var parsedTo = parseUrl(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) {
        parsedFrom = parsedLoc;
    }
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
        to = parsedTo.relative;
    }
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
        from = parsedFrom.relative;
    }
    hub_getCurrentHub().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to,
        },
    });
}
//# sourceMappingURL=breadcrumbs.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.18.2/node_modules/@sentry/browser/esm/stack-parsers.js

// global reference to slice
var UNKNOWN_FUNCTION = '?';
var OPERA10_PRIORITY = 10;
var OPERA11_PRIORITY = 20;
var CHROME_PRIORITY = 30;
var WINJS_PRIORITY = 40;
var GECKO_PRIORITY = 50;
function createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true,
    };
    if (lineno !== undefined) {
        frame.lineno = lineno;
    }
    if (colno !== undefined) {
        frame.colno = colno;
    }
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var chrome = function (line) {
    var parts = chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0,tslib_es6/* __read */.CR)(extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var chromeStackParser = [CHROME_PRIORITY, chrome];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var gecko = function (line) {
    var _a;
    var parts = geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || UNKNOWN_FUNCTION;
        _a = (0,tslib_es6/* __read */.CR)(extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var geckoStackParser = [GECKO_PRIORITY, gecko];
var winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var winjs = function (line) {
    var parts = winjsRegex.exec(line);
    return parts
        ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
        : undefined;
};
var winjsStackParser = [WINJS_PRIORITY, winjs];
var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var opera10 = function (line) {
    var parts = opera10Regex.exec(line);
    return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var opera10StackParser = [OPERA10_PRIORITY, opera10];
var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var opera11 = function (line) {
    var parts = opera11Regex.exec(line);
    return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var opera11StackParser = [OPERA11_PRIORITY, opera11];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
var extractSafariExtensionDetails = function (func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension
        ? [
            func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
            isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename,
        ]
        : [func, filename];
};
//# sourceMappingURL=stack-parsers.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.18.2/node_modules/@sentry/browser/esm/eventbuilder.js




/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */
function exceptionFromError(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = parseStackFrames(ex);
    var exception = {
        type: ex && ex.name,
        value: extractMessage(ex),
    };
    if (frames.length) {
        exception.stacktrace = { frames: frames };
    }
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
/**
 * @hidden
 */
function eventFromPlainObject(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: isEvent(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + extractExceptionKeysForMessage(exception),
                },
            ],
        },
        extra: {
            __serialized__: normalizeToSize(exception),
        },
    };
    if (syntheticException) {
        var frames_1 = parseStackFrames(syntheticException);
        if (frames_1.length) {
            event.stacktrace = { frames: frames_1 };
        }
    }
    return event;
}
/**
 * @hidden
 */
function eventFromError(ex) {
    return {
        exception: {
            values: [exceptionFromError(ex)],
        },
    };
}
/** Parses stack frames from an error */
function parseStackFrames(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = getPopSize(ex);
    try {
        return createStackParser(opera10StackParser, opera11StackParser, chromeStackParser, winjsStackParser, geckoStackParser)(stacktrace, popSize);
    }
    catch (e) {
        // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;
function getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') {
            return ex.framesToPop;
        }
        if (reactMinifiedRegexp.test(ex.message)) {
            return 1;
        }
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return 'No error message';
    }
    if (message.error && typeof message.error.message === 'string') {
        return message.error.message;
    }
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(exception, hint, attachStacktrace) {
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromUnknownInput(exception, syntheticException, attachStacktrace);
    addExceptionMechanism(event); // defaults to { type: 'generic', handled: true }
    event.level = Severity.Error;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return resolvedSyncPromise(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(message, level, hint, attachStacktrace) {
    if (level === void 0) { level = Severity.Info; }
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromString(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return resolvedSyncPromise(event);
}
/**
 * @hidden
 */
function eventFromUnknownInput(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if (isErrorEvent(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return eventFromError(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if (isDOMError(exception) || isDOMException(exception)) {
        var domException = exception;
        if ('stack' in exception) {
            event = eventFromError(exception);
        }
        else {
            var name_1 = domException.name || (isDOMError(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = eventFromString(message, syntheticException, attachStacktrace);
            addExceptionTypeValue(event, message);
        }
        if ('code' in domException) {
            event.tags = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event.tags), { 'DOMException.code': "" + domException.code });
        }
        return event;
    }
    if (isError(exception)) {
        // we have a real Error object, do nothing
        return eventFromError(exception);
    }
    if (isPlainObject(exception) || isEvent(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = eventFromPlainObject(objectException, syntheticException, isUnhandledRejection);
        misc_addExceptionMechanism(event, {
            synthetic: true,
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(exception, syntheticException, attachStacktrace);
    addExceptionTypeValue(event, "" + exception, undefined);
    misc_addExceptionMechanism(event, {
        synthetic: true,
    });
    return event;
}
/**
 * @hidden
 */
function eventFromString(input, syntheticException, attachStacktrace) {
    var event = {
        message: input,
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = parseStackFrames(syntheticException);
        if (frames_2.length) {
            event.stacktrace = { frames: frames_2 };
        }
    }
    return event;
}
//# sourceMappingURL=eventbuilder.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.18.2/node_modules/@sentry/browser/esm/integrations/globalhandlers.js

/* eslint-disable @typescript-eslint/no-unsafe-member-access */





/** Global handlers */
var GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */
        this._installFunc = {
            onerror: _installGlobalOnErrorHandler,
            onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
        };
        this._options = (0,tslib_es6/* __assign */.pi)({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for (var key in options) {
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());

/** JSDoc */
function _installGlobalOnErrorHandler() {
    instrument_addInstrumentationHandler('error', 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (data) {
        var _a = (0,tslib_es6/* __read */.CR)(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration(GlobalHandlers)) {
            return;
        }
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
            return;
        }
        var event = error === undefined && isString(msg)
            ? _eventFromIncompleteOnError(msg, url, line, column)
            : _enhanceEventWithInitialFrame(eventFromUnknownInput(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = severity_Severity.Error;
        addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
    instrument_addInstrumentationHandler('unhandledrejection', 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (e) {
        var _a = (0,tslib_es6/* __read */.CR)(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration(GlobalHandlers)) {
            return;
        }
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) {
                error = e.reason;
            }
            // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
            // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
            // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
            // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
            // https://github.com/getsentry/sentry-javascript/issues/2380
            else if ('detail' in e && 'reason' in e.detail) {
                error = e.detail.reason;
            }
        }
        catch (_oO) {
            // no-empty
        }
        if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
            return true;
        }
        var event = is_isPrimitive(error)
            ? _eventFromRejectionWithPrimitive(error)
            : eventFromUnknownInput(error, undefined, attachStacktrace, true);
        event.level = severity_Severity.Error;
        addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason),
                },
            ],
        },
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = isErrorEvent(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message,
                },
            ],
        },
    };
    return _enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = (event.exception = event.exception || {});
    // event.exception.values
    var ev = (e.values = e.values || []);
    // event.exception.values[0]
    var ev0 = (ev[0] = ev[0] || {});
    // event.exception.values[0].stacktrace
    var ev0s = (ev0.stacktrace = ev0.stacktrace || {});
    // event.exception.values[0].stacktrace.frames
    var ev0sf = (ev0s.frames = ev0s.frames || []);
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = isString(url) && url.length > 0 ? url : getLocationHref();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) {
        ev0sf.push({
            colno: colno,
            filename: filename,
            function: '?',
            in_app: true,
            lineno: lineno,
        });
    }
    return event;
}
function globalHandlerLog(type) {
    if ((0,env/* isDebugBuild */.c)()) {
        logger_logger.log("Global Handler attached: " + type);
    }
}
function addMechanismAndCapture(hub, error, event, type) {
    misc_addExceptionMechanism(event, {
        handled: false,
        type: type,
    });
    hub.captureEvent(event, {
        originalException: error,
    });
}
function getHubAndAttachStacktrace() {
    var hub = hub_getCurrentHub();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [hub, attachStacktrace];
}
//# sourceMappingURL=globalhandlers.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.18.2/node_modules/@sentry/browser/esm/integrations/linkederrors.js




var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var LinkedErrors = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        addGlobalEventProcessor(function (event, hint) {
            var self = hub_getCurrentHub().getIntegration(LinkedErrors);
            return self ? _handler(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}());

/**
 * @inheritDoc
 */
function _handler(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !isInstanceOf(hint.originalException, Error)) {
        return event;
    }
    var linkedErrors = _walkErrorTree(limit, hint.originalException, key);
    event.exception.values = (0,tslib_es6/* __spread */.fl)(linkedErrors, event.exception.values);
    return event;
}
/**
 * JSDOC
 */
function _walkErrorTree(limit, error, key, stack) {
    if (stack === void 0) { stack = []; }
    if (!isInstanceOf(error[key], Error) || stack.length + 1 >= limit) {
        return stack;
    }
    var exception = exceptionFromError(error[key]);
    return _walkErrorTree(limit, error[key], key, (0,tslib_es6/* __spread */.fl)([exception], stack));
}
//# sourceMappingURL=linkederrors.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.18.2/node_modules/@sentry/browser/esm/integrations/dedupe.js

/** Deduplication filter */
var Dedupe = /** @class */ (function () {
    function Dedupe() {
        /**
         * @inheritDoc
         */
        this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */
    Dedupe.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if (_shouldDropEvent(currentEvent, self._previousEvent)) {
                        logger_logger.warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                }
                catch (_oO) {
                    return (self._previousEvent = currentEvent);
                }
                return (self._previousEvent = currentEvent);
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */
    Dedupe.id = 'Dedupe';
    return Dedupe;
}());

/** JSDoc */
function _shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) {
        return false;
    }
    if (_isSameMessageEvent(currentEvent, previousEvent)) {
        return true;
    }
    if (_isSameExceptionEvent(currentEvent, previousEvent)) {
        return true;
    }
    return false;
}
/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) {
        return false;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
        return false;
    }
    if (currentMessage !== previousMessage) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = _getExceptionFromEvent(previousEvent);
    var currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) {
        return false;
    }
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = _getFramesFromEvent(currentEvent);
    var previousFrames = _getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) {
        return true;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
        return false;
    }
    currentFrames = currentFrames;
    previousFrames = previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) {
        return false;
    }
    // Otherwise, compare the two
    for (var i = 0; i < previousFrames.length; i++) {
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename ||
            frameA.lineno !== frameB.lineno ||
            frameA.colno !== frameB.colno ||
            frameA.function !== frameB.function) {
            return false;
        }
    }
    return true;
}
/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) {
        return true;
    }
    // If only one event has a fingerprint, but not the other one, they are not the same
    if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
        return false;
    }
    currentFingerprint = currentFingerprint;
    previousFingerprint = previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    }
    catch (_oO) {
        return false;
    }
}
/** JSDoc */
function _getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */
function _getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) {
        try {
            // @ts-ignore Object could be undefined
            return exception.values[0].stacktrace.frames;
        }
        catch (_oO) {
            return undefined;
        }
    }
    else if (event.stacktrace) {
        return event.stacktrace.frames;
    }
    return undefined;
}
//# sourceMappingURL=dedupe.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.18.2/node_modules/@sentry/browser/esm/integrations/useragent.js



var useragent_global = (0,esm_global/* getGlobalObject */.R)();
/** UserAgent */
var UserAgent = /** @class */ (function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        addGlobalEventProcessor(function (event) {
            if (hub_getCurrentHub().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!useragent_global.navigator && !useragent_global.location && !useragent_global.document) {
                    return event;
                }
                // grab as much info as exists and add it to the event
                var url = (event.request && event.request.url) || (useragent_global.location && useragent_global.location.href);
                var referrer = (useragent_global.document || {}).referrer;
                var userAgent = (useragent_global.navigator || {}).userAgent;
                var headers = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (event.request && event.request.headers)), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
                var request = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (url && { url: url })), { headers: headers });
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event), { request: request });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}());

//# sourceMappingURL=useragent.js.map
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+browser@6.18.2/node_modules/@sentry/browser/esm/sdk.js






var defaultIntegrations = [
    new InboundFilters(),
    new FunctionToString(),
    new TryCatch(),
    new Breadcrumbs(),
    new GlobalHandlers(),
    new LinkedErrors(),
    new Dedupe(),
    new UserAgent(),
];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options) {
    if (options === void 0) { options = {}; }
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = defaultIntegrations;
    }
    if (options.release === undefined) {
        var window_1 = getGlobalObject();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
            options.release = window_1.SENTRY_RELEASE.id;
        }
    }
    if (options.autoSessionTracking === undefined) {
        options.autoSessionTracking = true;
    }
    if (options.sendClientReports === undefined) {
        options.sendClientReports = true;
    }
    initAndBind(BrowserClient, options);
    if (options.autoSessionTracking) {
        startSessionTracking();
    }
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options) {
    if (options === void 0) { options = {}; }
    var hub = hub_getCurrentHub();
    var scope = hub.getScope();
    if (scope) {
        options.user = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, scope.getUser()), options.user);
    }
    if (!options.eventId) {
        options.eventId = hub.lastEventId();
    }
    var client = hub.getClient();
    if (client) {
        client.showReportDialog(options);
    }
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
    return getCurrentHub().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
    // Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
    callback();
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function flush(timeout) {
    var client = getCurrentHub().getClient();
    if (client) {
        return client.flush(timeout);
    }
    if (isDebugBuild()) {
        logger.warn('Cannot flush events. No client defined.');
    }
    return resolvedSyncPromise(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function sdk_close(timeout) {
    var client = getCurrentHub().getClient();
    if (client) {
        return client.close(timeout);
    }
    if (isDebugBuild()) {
        logger.warn('Cannot flush events and disable SDK. No client defined.');
    }
    return resolvedSyncPromise(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function sdk_wrap(fn) {
    return internalWrap(fn)();
}
function startSessionOnHub(hub) {
    hub.startSession({ ignoreDuration: true });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
    var window = getGlobalObject();
    var document = window.document;
    if (typeof document === 'undefined') {
        if (isDebugBuild()) {
            logger.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        }
        return;
    }
    var hub = getCurrentHub();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) {
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    addInstrumentationHandler('history', function (_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) {
            startSessionOnHub(getCurrentHub());
        }
    });
}
//# sourceMappingURL=sdk.js.map
// EXTERNAL MODULE: ./node_modules/.pnpm/hoist-non-react-statics@3.3.2/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(72535);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@sentry+react@6.18.2_react@17.0.2/node_modules/@sentry/react/esm/errorboundary.js





function isAtLeastReact17(version) {
    var major = version.match(/^([^.]+)/);
    return major !== null && parseInt(major[0]) >= 17;
}
var UNKNOWN_COMPONENT = 'unknown';
var INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null,
};
/**
 * A ErrorBoundary component that logs errors to Sentry. Requires React >= 16.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */
var ErrorBoundary = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = INITIAL_STATE;
        _this.resetErrorBoundary = function () {
            var onReset = _this.props.onReset;
            var _a = _this.state, error = _a.error, componentStack = _a.componentStack, eventId = _a.eventId;
            if (onReset) {
                onReset(error, componentStack, eventId);
            }
            _this.setState(INITIAL_STATE);
        };
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, _a) {
        var _this = this;
        var componentStack = _a.componentStack;
        var _b = this.props, beforeCapture = _b.beforeCapture, onError = _b.onError, showDialog = _b.showDialog, dialogOptions = _b.dialogOptions;
        withScope(function (scope) {
            // If on React version >= 17, create stack trace from componentStack param and links
            // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
            // Linking errors requires the `LinkedErrors` integration be enabled.
            if (isAtLeastReact17(react.version)) {
                var errorBoundaryError = new Error(error.message);
                errorBoundaryError.name = "React ErrorBoundary " + errorBoundaryError.name;
                errorBoundaryError.stack = componentStack;
                // Using the `LinkedErrors` integration to link the errors together.
                error.cause = errorBoundaryError;
            }
            if (beforeCapture) {
                beforeCapture(scope, error, componentStack);
            }
            var eventId = captureException(error, { contexts: { react: { componentStack: componentStack } } });
            if (onError) {
                onError(error, componentStack, eventId);
            }
            if (showDialog) {
                showReportDialog((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, dialogOptions), { eventId: eventId }));
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            _this.setState({ error: error, componentStack: componentStack, eventId: eventId });
        });
    };
    ErrorBoundary.prototype.componentDidMount = function () {
        var onMount = this.props.onMount;
        if (onMount) {
            onMount();
        }
    };
    ErrorBoundary.prototype.componentWillUnmount = function () {
        var _a = this.state, error = _a.error, componentStack = _a.componentStack, eventId = _a.eventId;
        var onUnmount = this.props.onUnmount;
        if (onUnmount) {
            onUnmount(error, componentStack, eventId);
        }
    };
    ErrorBoundary.prototype.render = function () {
        var _a = this.props, fallback = _a.fallback, children = _a.children;
        var _b = this.state, error = _b.error, componentStack = _b.componentStack, eventId = _b.eventId;
        if (error) {
            var element = undefined;
            if (typeof fallback === 'function') {
                element = fallback({ error: error, componentStack: componentStack, resetError: this.resetErrorBoundary, eventId: eventId });
            }
            else {
                element = fallback;
            }
            if (react.isValidElement(element)) {
                return element;
            }
            if (fallback) {
                logger_logger.warn('fallback did not produce a valid ReactElement');
            }
            // Fail gracefully if no fallback provided or is not valid
            return null;
        }
        if (typeof children === 'function') {
            return children();
        }
        return children;
    };
    return ErrorBoundary;
}(react.Component));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withErrorBoundary(WrappedComponent, errorBoundaryOptions) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;
    var Wrapped = function (props) { return (React.createElement(ErrorBoundary, __assign({}, errorBoundaryOptions),
        React.createElement(WrappedComponent, __assign({}, props)))); };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    Wrapped.displayName = "errorBoundary(" + componentDisplayName + ")";
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    hoistNonReactStatics(Wrapped, WrappedComponent);
    return Wrapped;
}

//# sourceMappingURL=errorboundary.js.map
;// CONCATENATED MODULE: ./src/components/_errors/ErrorBoundary/index.tsx



var ErrorBoundary_ErrorBoundary = function(param) {
    var children = param.children;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary, {
        fallback: Error500,
        showDialog: true,
        children: children
    }));
};
/* harmony default export */ var _errors_ErrorBoundary = (ErrorBoundary_ErrorBoundary);


/***/ }),

/***/ 50509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28268);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44858);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42359);
/* harmony import */ var _field_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23076);
/* harmony import */ var _field_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_field_module_scss__WEBPACK_IMPORTED_MODULE_3__);



var Field = function(param) {
    var children = param.children, id = param.id, label = param.label, feedback = param.feedback;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Group */ .Z.Group, {
        as: react_bootstrap__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
        controlId: id,
        className: (_field_module_scss__WEBPACK_IMPORTED_MODULE_3___default().formGroup),
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Label */ .Z.Label, {
                column: true,
                md: "4",
                className: "".concat((_field_module_scss__WEBPACK_IMPORTED_MODULE_3___default().formInputFieldLabel), " fw-bold d-flex px-3"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_field_module_scss__WEBPACK_IMPORTED_MODULE_3___default().labelText),
                    children: label
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                md: label ? 8 : 12,
                className: (_field_module_scss__WEBPACK_IMPORTED_MODULE_3___default().input),
                children: [
                    children,
                    feedback && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Control.Feedback */ .Z.Control.Feedback, {
                        type: "invalid",
                        children: feedback === null || feedback === void 0 ? void 0 : feedback.message
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Field);


/***/ }),

/***/ 68642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var react_quill_dist_quill_snow_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2853);
/* harmony import */ var react_quill_dist_quill_snow_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_quill_dist_quill_snow_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _richTextEditor_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59586);
/* harmony import */ var _richTextEditor_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_richTextEditor_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_content_loader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16629);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90300);






function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ReactQuill = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.lazy(function() {
    return Promise.all(/* import() */[__webpack_require__.e(774), __webpack_require__.e(991), __webpack_require__.e(392)]).then(__webpack_require__.t.bind(__webpack_require__, 46454, 23));
});
var MemoizedReactQuill = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(ReactQuill, function(prev, next) {
    return prev && prev.placeholder === next.placeholder;
});
var getModules = function(param) {
    var isToolbarEnabled = param.isToolbarEnabled, isEnterKeyAllowed = param.isEnterKeyAllowed;
    return {
        toolbar: isToolbarEnabled ? [
            [
                {
                    header: 1
                },
                {
                    header: 2
                },
                {
                    header: [
                        1,
                        2,
                        false
                    ]
                }
            ],
            [
                'bold',
                'italic',
                'underline'
            ],
            [
                {
                    list: 'ordered'
                },
                {
                    list: 'bullet'
                }
            ],
            [
                'link',
                'clean'
            ], 
        ] : false,
        keyboard: isEnterKeyAllowed ? undefined : {
            bindings: {
                enter: {
                    key: 13,
                    handler: function() {}
                },
                shift_enter: {
                    key: 13,
                    shiftKey: true,
                    handler: function() {}
                }
            }
        }
    };
};
function RichTextEditor(_param) {
    var onChange = function onChange(text) {
        setValue(name, text, {});
    };
    var _isToolbarEnabled = _param.isToolbarEnabled, isToolbarEnabled = _isToolbarEnabled === void 0 ? true : _isToolbarEnabled, _isEnterKeyAllowed = _param.isEnterKeyAllowed, isEnterKeyAllowed = _isEnterKeyAllowed === void 0 ? true : _isEnterKeyAllowed, inputAreaClassName = _param.inputAreaClassName, wrapperClassName = _param.wrapperClassName, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? '' : _placeholder, style = _param.style, props = _objectWithoutProperties(_param, [
        "isToolbarEnabled",
        "isEnterKeyAllowed",
        "inputAreaClassName",
        "wrapperClassName",
        "placeholder",
        "style"
    ]);
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useController */ .bc)(props), _field = ref.field, name = _field.name, value = _field.value, invalid = ref.fieldState.invalid;
    var setValue = props.setValue;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_4__/* .Code */ .EK, {}),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MemoizedReactQuill, {
            theme: "snow",
            modules: getModules({
                isToolbarEnabled: isToolbarEnabled,
                isEnterKeyAllowed: isEnterKeyAllowed
            }),
            className: invalid ? "form-control is-invalid ".concat(wrapperClassName || (_richTextEditor_module_scss__WEBPACK_IMPORTED_MODULE_5___default().wrapper)) : wrapperClassName || (_richTextEditor_module_scss__WEBPACK_IMPORTED_MODULE_5___default().wrapper),
            placeholder: placeholder,
            onChange: onChange,
            value: value,
            style: style,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: inputAreaClassName || (_richTextEditor_module_scss__WEBPACK_IMPORTED_MODULE_5___default().inputArea)
            })
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (RichTextEditor);


/***/ }),

/***/ 27824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var hooks_useCountries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18205);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2103);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function FormCountrySelect(props) {
    var countries = (0,hooks_useCountries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().countries;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props, {
        isHidingEmptyOptions: true,
        items: countries === null || countries === void 0 ? void 0 : countries.map(function(param) {
            var code = param.code, name = param.name;
            return {
                label: name,
                value: code
            };
        })
    })));
}
/* harmony default export */ __webpack_exports__["Z"] = (FormCountrySelect);


/***/ }),

/***/ 96156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2103);
/* harmony import */ var _types_Gender__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7462);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function FormGenderSelect(props) {
    var types = [
        {
            label: 'Neutral',
            value: _types_Gender__WEBPACK_IMPORTED_MODULE_2__/* ["default"].NEUTRAL */ .Z.NEUTRAL
        },
        {
            label: 'Male specific',
            value: _types_Gender__WEBPACK_IMPORTED_MODULE_2__/* ["default"].MALE */ .Z.MALE
        },
        {
            label: 'Female specific',
            value: _types_Gender__WEBPACK_IMPORTED_MODULE_2__/* ["default"].FEMALE */ .Z.FEMALE
        }, 
    ];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({}, props, {
        items: types,
        isHidingEmptyOptions: true
    })));
}
/* harmony default export */ __webpack_exports__["Z"] = (FormGenderSelect);


/***/ }),

/***/ 58758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2103);
/* harmony import */ var hooks_useQuestionnaireTypes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82060);



function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function QuestionnaireTypeSelect(_param) {
    var kind = _param.kind, _isForQuestionnaireModules = _param.isForQuestionnaireModules, isForQuestionnaireModules = _isForQuestionnaireModules === void 0 ? false : _isForQuestionnaireModules, props = _objectWithoutProperties(_param, [
        "kind",
        "isForQuestionnaireModules"
    ]);
    var questionnaireTypesByKind = (0,hooks_useQuestionnaireTypes__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(isForQuestionnaireModules).questionnaireTypesByKind;
    var types = _toConsumableArray(questionnaireTypesByKind[kind].map(function(t) {
        return {
            value: t.type,
            label: isForQuestionnaireModules ? t.labelPlural : t.labelSingular
        };
    }));
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({}, props, {
        isHidingEmptyOptions: true,
        items: types
    })));
}
/* harmony default export */ __webpack_exports__["Z"] = (QuestionnaireTypeSelect);


/***/ }),

/***/ 2103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28268);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90300);
/* harmony import */ var _sharedSelect_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62001);
/* harmony import */ var _sharedSelect_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_sharedSelect_module_scss__WEBPACK_IMPORTED_MODULE_2__);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function FormSelect(props) {
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_1__/* .useController */ .bc)(props), field = ref.field, invalid = ref.fieldState.invalid;
    var label = props.label, _isHidingEmptyOptions = props.isHidingEmptyOptions, isHidingEmptyOptions = _isHidingEmptyOptions === void 0 ? false : _isHidingEmptyOptions, items = props.items, _disabled = props.disabled, disabled = _disabled === void 0 ? false : _disabled;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: isHidingEmptyOptions ? (_sharedSelect_module_scss__WEBPACK_IMPORTED_MODULE_2___default().hideEmpty) : undefined,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Select */ .Z.Select, _objectSpread({
            "aria-label": label
        }, field, {
            value: field.value,
            isInvalid: invalid,
            disabled: disabled,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                    value: "",
                    children: label
                }),
                items && items.map(function(item) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                        value: item.value,
                        children: item.label
                    }, item.value);
                })
            ]
        }))
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (FormSelect);


/***/ }),

/***/ 83931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _form_Typeahead; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/index.js + 87 modules
var es = __webpack_require__(3078);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
;// CONCATENATED MODULE: ./src/components/_form/Typeahead/ReactBootstrapTypeaheadWrapper/index.tsx



function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ReactBootstrapTypeaheadWrapper = /*
 as Typeahead is not well typed we need that wrapper to avoid spread that issue in your code
 */ /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(ReactBootstrapTypeaheadWrapper, Component1);
    var _super = _createSuper(ReactBootstrapTypeaheadWrapper);
    function ReactBootstrapTypeaheadWrapper() {
        _classCallCheck(this, ReactBootstrapTypeaheadWrapper);
        return _super.apply(this, arguments);
    }
    _createClass(ReactBootstrapTypeaheadWrapper, [
        {
            key: "render",
            value: function render() {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Typeahead */.pY, _objectSpread({}, this.props)));
            }
        }
    ]);
    return ReactBootstrapTypeaheadWrapper;
}(react.Component);
/* harmony default export */ var Typeahead_ReactBootstrapTypeaheadWrapper = (ReactBootstrapTypeaheadWrapper);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.28.0_react@17.0.2/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(90300);
// EXTERNAL MODULE: ./src/components/_form/Typeahead/typeahead.module.scss
var typeahead_module = __webpack_require__(17124);
var typeahead_module_default = /*#__PURE__*/__webpack_require__.n(typeahead_module);
;// CONCATENATED MODULE: ./src/components/_form/Typeahead/index.tsx




function Typeahead_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Typeahead_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Typeahead_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Typeahead(_param) {
    var setValue = _param.setValue, _isWithApiCall = _param.isWithApiCall, isWithApiCall = _isWithApiCall === void 0 ? false : _isWithApiCall, name = _param.name, callbackOnChange = _param.callbackOnChange, props = _objectWithoutProperties(_param, [
        "setValue",
        "isWithApiCall",
        "name",
        "callbackOnChange"
    ]);
    var field = (0,index_esm/* useController */.bc)(Typeahead_objectSpread({
        name: name
    }, props)).field;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Typeahead_ReactBootstrapTypeaheadWrapper, Typeahead_objectSpread({
        className: "".concat((typeahead_module_default()).selectContainer, "  ").concat(isWithApiCall ? (typeahead_module_default()).selectContainerWithApiCall : '')
    }, props, field, {
        onChange: function(options) {
            var opts = props.multiple ? options : options[0];
            setValue(name, opts, {});
            if (callbackOnChange) {
                callbackOnChange();
            }
        }
    })));
}
/* harmony default export */ var _form_Typeahead = (Typeahead);


/***/ }),

/***/ 69001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95601);
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4637);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59496);
/* harmony import */ var hooks_useApi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7920);
/* harmony import */ var _typeaheadWithApiCall_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1993);
/* harmony import */ var _typeaheadWithApiCall_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_typeaheadWithApiCall_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var components_form_Typeahead__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83931);
/* harmony import */ var hooks_useDebounce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18656);
/* harmony import */ var react_content_loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16629);








function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function TypeaheadWithApiCall(_param) {
    var name = _param.name, _error = _param.error, error = _error === void 0 ? '' : _error, _defaultSelected = _param.defaultSelected, defaultSelected = _defaultSelected === void 0 ? [] : _defaultSelected, infoText = _param.infoText, _allowNew = _param.allowNew, allowNew = _allowNew === void 0 ? false : _allowNew, apiConfig = _param.apiConfig, categoriesType = _param.categoriesType, props = _objectWithoutProperties(_param, [
        "name",
        "error",
        "defaultSelected",
        "infoText",
        "allowNew",
        "apiConfig",
        "categoriesType"
    ]);
    var api = (0,hooks_useApi__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), values = ref[0], setValues = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''), query1 = ref1[0], setQuery = ref1[1];
    var debounce = (0,hooks_useDebounce__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(query1);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var request = function() {
        var _ref = _asyncToGenerator(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var url, maxResults, params, queryParams, result, filteredResult;
            return _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        url = param.url, maxResults = param.maxResults, params = param.params;
                        queryParams = new URLSearchParams(_objectSpread({
                            q: query1
                        }, params)).toString();
                        ;
                        if (!categoriesType) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 6;
                        return api.get("".concat(url, "?type=").concat(categoriesType, "&").concat(queryParams));
                    case 6:
                        result = _ctx.sent;
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.next = 11;
                        return api.get("".concat(url, "?").concat(queryParams));
                    case 11:
                        result = _ctx.sent;
                    case 12:
                        filteredResult = result === null || result === void 0 ? void 0 : result.data.slice(0, maxResults);
                        return _ctx.abrupt("return", _objectSpread({}, result, {
                            data: filteredResult
                        }));
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function request(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchData = function() {
        var _ref = _asyncToGenerator(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(query) {
            var results, mappedValues;
            return _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsLoading(true);
                        if (!(query.trim().length === 0)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.next = 5;
                        return Promise.all([].concat(apiConfig).map(request));
                    case 5:
                        results = _ctx.sent;
                        mappedValues = (results === null || results === void 0 ? void 0 : results.flatMap(function(r) {
                            return r.data;
                        })) || [];
                        setValues(mappedValues);
                        setIsLoading(false);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchData(query) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        fetchData(query1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        debounce
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_form_Typeahead__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread({
                name: name,
                minLength: 1,
                id: name,
                options: values,
                onInputChange: setQuery,
                isInvalid: !!error,
                emptyLabel: isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_6__/* .BulletList */ .DY, {
                    height: 250
                }) : null,
                defaultSelected: defaultSelected,
                allowNew: allowNew,
                isWithApiCall: true
            }, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                className: (_typeaheadWithApiCall_module_scss__WEBPACK_IMPORTED_MODULE_7___default().helpInfoText),
                children: infoText
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                className: (_typeaheadWithApiCall_module_scss__WEBPACK_IMPORTED_MODULE_7___default().fieldError),
                children: [
                    " ",
                    error
                ]
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (TypeaheadWithApiCall);


/***/ }),

/***/ 31500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bo": function() { return /* binding */ emailRequiredSchema; },
/* harmony export */   "Js": function() { return /* binding */ passwordSchema; },
/* harmony export */   "EV": function() { return /* binding */ passwordRequiredSchema; },
/* harmony export */   "eN": function() { return /* binding */ passwordOptionalSchema; }
/* harmony export */ });
/* unused harmony export emailSchema */
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55423);
/* harmony import */ var functions_validation_getIsRequiredText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42590);


var emailSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().label('Email').email();
var emailRequiredSchema = emailSchema.required();
var passwordSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().min(8);
var passwordRequiredSchema = passwordSchema.required((0,functions_validation_getIsRequiredText__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('Password'));
var passwordOptionalSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().test('len', 'password must be at least 8 characters', function(val) {
    if (val === undefined) {
        return true;
    }
    return val.length === 0 || val.length >= 8;
});


/***/ }),

/***/ 72552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55423);
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94213);
/* harmony import */ var _ModalHeader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90846);
/* harmony import */ var _formModal_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20974);
/* harmony import */ var _formModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_formModal_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _FormModalInner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72139);
/* harmony import */ var hooks_useFormModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97901);







(0,yup__WEBPACK_IMPORTED_MODULE_1__/* .setLocale */ .i_)({
    mixed: {
        // eslint-disable-next-line no-template-curly-in-string
        required: '${path} is required'
    }
});
function FormModal(param) {
    var toggle = param.toggle, isShowing = param.isShowing, children = param.children, onSubmit = param.onSubmit, initialValues = param.initialValues, submitButtonText = param.submitButtonText, validationSchema = param.validationSchema, cancelButtonText = param.cancelButtonText, title = param.title, _onComplete = param.onComplete, onComplete = _onComplete === void 0 ? function() {} : _onComplete, customSize = param.customSize, _isResetAfterSubmit = param.isResetAfterSubmit, isResetAfterSubmit = _isResetAfterSubmit === void 0 ? false : _isResetAfterSubmit, isReducible = param.isReducible, onCancelClickCallback = param.onCancelClickCallback, isReduced = param.isReduced, toggleReduce = param.toggleReduce, buttonInsteadCancelText = param.buttonInsteadCancelText, buttonInsteadCancelCallback = param.buttonInsteadCancelCallback;
    var ref = (0,hooks_useFormModal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        onComplete: onComplete,
        onSubmit: onSubmit,
        validationSchema: validationSchema,
        initialValues: initialValues,
        toggle: toggle,
        isResetAfterSubmit: isResetAfterSubmit,
        onCancelClickCallback: onCancelClickCallback
    }), onCancelClick = ref.onCancelClick, form = ref.form;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !isReduced && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                isShowing: isShowing,
                size: "lg",
                dialogClassName: customSize ? (_formModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().customSize) : '',
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ModalHeader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        title: title,
                        hide: onCancelClick,
                        isReducible: isReducible,
                        toggleReduce: toggleReduce
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormModalInner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        form: form,
                        onCancelClick: onCancelClick,
                        submitButtonText: submitButtonText,
                        cancelButtonText: cancelButtonText,
                        buttonInsteadCancelText: buttonInsteadCancelText,
                        buttonInsteadCancelCallback: buttonInsteadCancelCallback,
                        children: children
                    })
                ]
            }),
            isReduced && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ModalHeader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                title: title,
                hide: onCancelClick,
                isReducible: isReducible,
                isReduced: isReduced,
                toggleReduce: toggleReduce
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (FormModal);


/***/ }),

/***/ 72139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var elements_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77732);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55423);
/* harmony import */ var elements_Warning__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34155);
/* harmony import */ var elements_ButtonWithLoader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49788);
/* harmony import */ var _ModalBody__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63769);
/* harmony import */ var _ModalFooter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47550);
/* harmony import */ var _hookform_devtools__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7315);
/* harmony import */ var _hookform_devtools__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_hookform_devtools__WEBPACK_IMPORTED_MODULE_7__);
/* provided dependency */ var process = __webpack_require__(14224);








(0,yup__WEBPACK_IMPORTED_MODULE_2__/* .setLocale */ .i_)({
    mixed: {
        // eslint-disable-next-line no-template-curly-in-string
        required: '${path} is required'
    }
});
function FormModalInner(param) {
    var form = param.form, onCancelClick = param.onCancelClick, children = param.children, submitButtonText = param.submitButtonText, cancelButtonText = param.cancelButtonText, buttonInsteadCancelText = param.buttonInsteadCancelText, buttonInsteadCancelCallback = param.buttonInsteadCancelCallback;
    var handleSubmit = form.handleSubmit, warningMessage = form.warningMessage, isLoading = form.isLoading, control = form.control;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ModalBody__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "p-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(elements_Warning__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            show: !!warningMessage,
                            text: warningMessage
                        }),
                        children(form)
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ModalFooter__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(elements_ButtonWithLoader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        isLoading: isLoading,
                        onClick: handleSubmit,
                        children: submitButtonText
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(elements_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "button",
                        onClick: buttonInsteadCancelCallback ? buttonInsteadCancelCallback : onCancelClick,
                        variant: "outline-primary",
                        disabled: isLoading,
                        children: cancelButtonText || buttonInsteadCancelText || 'Cancel'
                    })
                ]
            }),
            process.env.NEXT_PUBLIC_HOOK_FORM_DEVTOOL === 'enabled' && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hookform_devtools__WEBPACK_IMPORTED_MODULE_7__.DevTool, {
                control: control
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (FormModalInner);


/***/ }),

/***/ 29089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var components_modal_ModalHeader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90846);
/* harmony import */ var components_modal_ModalBody__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63769);
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94213);




var MessageBox = function(param) {
    var title = param.title, isShowing = param.isShowing, toggle = param.toggle, onComplete = param.onComplete, children = param.children;
    var onClose = function() {
        setTimeout(function() {
            onComplete(false);
        }, 300);
        toggle();
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isShowing: isShowing,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_ModalHeader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    title: title,
                    hide: onClose
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_ModalBody__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: children
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (MessageBox);


/***/ }),

/***/ 94213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84745);
/* harmony import */ var _modal_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55133);
/* harmony import */ var _modal_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_modal_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Modal = function(param) {
    var isShowing = param.isShowing, children = param.children, size = param.size, dialogClassName = param.dialogClassName;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        show: isShowing,
        size: size,
        dialogClassName: "".concat((_modal_module_scss__WEBPACK_IMPORTED_MODULE_2___default().modalDefault), "  ").concat(dialogClassName || ''),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Modal);


/***/ }),

/***/ 63769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84745);


var ModalBody = function(param) {
    var children = param.children;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Body */ .Z.Body, {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalBody);


/***/ }),

/***/ 47550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84745);


var ModalFooter = function(param) {
    var children = param.children;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Footer */ .Z.Footer, {
        className: "border-0",
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalFooter);


/***/ }),

/***/ 90846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84745);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46863);
/* harmony import */ var _modalHeader_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10680);
/* harmony import */ var _modalHeader_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_modalHeader_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var ModalHeader = function(param) {
    var children = param.children, title = param.title, hide = param.hide, isReducible = param.isReducible, toggleReduce = param.toggleReduce, isReduced = param.isReduced;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Header */ .Z.Header, {
        className: "".concat((_modalHeader_module_scss__WEBPACK_IMPORTED_MODULE_2___default().header), " ").concat(isReduced && (_modalHeader_module_scss__WEBPACK_IMPORTED_MODULE_2___default().headerReduced)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Title */ .Z.Title, {
                className: (_modalHeader_module_scss__WEBPACK_IMPORTED_MODULE_2___default().modalTitle),
                children: title
            }),
            isReducible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                type: "button",
                className: (_modalHeader_module_scss__WEBPACK_IMPORTED_MODULE_2___default().leftButton),
                "aria-label": "Close",
                onClick: toggleReduce,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    "aria-hidden": "true",
                    children: isReduced ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "bi bi-arrow-up-left-square"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "bi bi-arrow-down-right-square"
                    })
                })
            }),
            !isReduced && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                type: "button",
                className: (_modalHeader_module_scss__WEBPACK_IMPORTED_MODULE_2___default().button),
                "aria-label": "Close",
                onClick: hide,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "bi bi-x-square"
                    })
                })
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalHeader);


/***/ }),

/***/ 95560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95601);
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4637);
/* harmony import */ var hooks_useAlerts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96308);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86628);
/* harmony import */ var hooks_useCreateQuestionnaire__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14149);
/* harmony import */ var functions_string_stripHtmlFromString__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31620);
/* harmony import */ var functions_object_normalizeTypeaheadArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22948);







function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CreateCustomQuestionnaireFormModal = function(param) {
    var isShowing = param.isShowing, toggle = param.toggle, addQuestionToQuestionnaire = param.addQuestionToQuestionnaire;
    var addSuccessAlert = (0,hooks_useAlerts__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().addSuccessAlert;
    var createQuestionnaire = (0,hooks_useCreateQuestionnaire__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().createQuestionnaire;
    var onSubmit = function() {
        var _ref = _asyncToGenerator(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(formData) {
            var description, chemical, fixedDescription, fixedChemical, result, ref, ref1;
            return _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        description = formData.description, chemical = formData.chemical;
                        fixedDescription = (0,functions_string_stripHtmlFromString__WEBPACK_IMPORTED_MODULE_5__/* .stripHtmlFromStringIfEmpty */ .Y)(description);
                        fixedChemical = (0,functions_object_normalizeTypeaheadArray__WEBPACK_IMPORTED_MODULE_6__/* .normalizeTypeaheadField */ .m)(chemical);
                        _ctx.next = 5;
                        return createQuestionnaire(_objectSpread({}, formData, {
                            isCustom: true,
                            description: fixedDescription,
                            chemical: fixedChemical
                        }));
                    case 5:
                        result = _ctx.sent;
                        if (!(typeof addQuestionToQuestionnaire === 'function')) {
                            _ctx.next = 10;
                            break;
                        }
                        ;
                        _ctx.next = 10;
                        return addQuestionToQuestionnaire(result === null || result === void 0 ? void 0 : result.id, (result === null || result === void 0 ? void 0 : (ref = result.questionnaireItems) === null || ref === void 0 ? void 0 : ref.length) ? result.questionsStartPosition + (result === null || result === void 0 ? void 0 : (ref1 = result.questionnaireItems) === null || ref1 === void 0 ? void 0 : ref1.length) : result.questionsStartPosition);
                    case 10:
                        addSuccessAlert('Questionnaire created!');
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(formData) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(___WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isShowing: isShowing,
        toggle: toggle,
        title: "Add Questionnaire",
        onSubmit: onSubmit,
        canShowDraftMessage: true,
        isResetAfterSubmit: true
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CreateCustomQuestionnaireFormModal);


/***/ }),

/***/ 86628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _questionnaires_CustomQuestionnaireFormModal; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./src/components/_form/Field/index.tsx
var Field = __webpack_require__(50509);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Form.js + 15 modules
var Form = __webpack_require__(28268);
// EXTERNAL MODULE: ./src/components/_modal/FormModal/index.tsx
var FormModal = __webpack_require__(72552);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(55423);
// EXTERNAL MODULE: ./src/functions/validation/getIsRequiredText.ts
var getIsRequiredText = __webpack_require__(42590);
// EXTERNAL MODULE: ./src/_types/api/questionnaires/QuestionnaireType.ts
var QuestionnaireType = __webpack_require__(49676);
// EXTERNAL MODULE: ./src/_types/Gender.ts
var Gender = __webpack_require__(7462);
;// CONCATENATED MODULE: ./src/components/_questionnaires/CustomQuestionnaireFormModal/schema.ts




var schema = es/* object */.Ry().shape({
    name: es/* string */.Z_().required((0,getIsRequiredText/* default */.Z)('Name')),
    type: es/* mixed */.nK().oneOf(Object.values(QuestionnaireType/* default */.Z)).required((0,getIsRequiredText/* default */.Z)('Type')),
    gender: es/* string */.Z_().required((0,getIsRequiredText/* default */.Z)('Gender')),
    chemical: es/* mixed */.nK(),
    questionsStartPosition: es/* number */.Rx().typeError('First question must only contain digits').min(1, 'First question must be greater than or equal to 1.').max(1000, 'First question must be lower than or equal to 1000.').required((0,getIsRequiredText/* default */.Z)('First question')),
    description: es/* string */.Z_()
});
var schema_initialValues = {
    name: '',
    type: QuestionnaireType/* default.ITEM_LIST */.Z.ITEM_LIST,
    gender: Gender/* default.NEUTRAL */.Z.NEUTRAL,
    chemical: null,
    questionsStartPosition: 1,
    description: ''
};

// EXTERNAL MODULE: ./src/components/_form/Select/GenderSelect/index.tsx
var GenderSelect = __webpack_require__(96156);
// EXTERNAL MODULE: ./src/components/_questionnaires/CustomQuestionnaireFormModal/createQuestionnaire.module.scss
var createQuestionnaire_module = __webpack_require__(49758);
var createQuestionnaire_module_default = /*#__PURE__*/__webpack_require__.n(createQuestionnaire_module);
// EXTERNAL MODULE: ./src/components/_form/RichTextEditor/index.tsx
var RichTextEditor = __webpack_require__(68642);
// EXTERNAL MODULE: ./src/components/_form/Select/QuestionnaireTypeSelect/index.tsx
var QuestionnaireTypeSelect = __webpack_require__(58758);
// EXTERNAL MODULE: ./src/_types/api/questionnaires/QuestionnaireKind.ts
var QuestionnaireKind = __webpack_require__(35247);
// EXTERNAL MODULE: ./src/components/_form/Select/index.tsx
var Select = __webpack_require__(2103);
// EXTERNAL MODULE: ./src/_types/api/questionnaires/QuestionnaireState.ts
var QuestionnaireState = __webpack_require__(96439);
;// CONCATENATED MODULE: ./src/components/_form/Select/QuestionnaireStateSelect/index.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function QuestionnaireStateSelect(props) {
    var types = [
        {
            label: 'Draft',
            value: QuestionnaireState/* default.DRAFT */.Z.DRAFT
        },
        {
            label: 'Waiting for approval',
            value: QuestionnaireState/* default.WAITING_FOR_APPROVAL */.Z.WAITING_FOR_APPROVAL
        },
        {
            label: 'Published',
            value: QuestionnaireState/* default.PUBLISHED */.Z.PUBLISHED
        }, 
    ];
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, _objectSpread({}, props, {
        items: types,
        isHidingEmptyOptions: true
    })));
}
/* harmony default export */ var Select_QuestionnaireStateSelect = (QuestionnaireStateSelect);

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_n6febsnk4nq7zxsovmf65ymnxm/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(95601);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(88349);
// EXTERNAL MODULE: ./src/hooks/useApi.ts
var useApi = __webpack_require__(7920);
// EXTERNAL MODULE: ./src/consts/paths/api/authors/index.ts
var authors = __webpack_require__(74781);
;// CONCATENATED MODULE: ./src/hooks/useQuestionnaireAuthors/index.tsx




function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var useQuestionnaireAuthors = function() {
    var api = (0,useApi/* default */.Z)();
    var authorsQueryKey = 'authors';
    var ref = (0,react_query_es.useQuery)(authorsQueryKey, _asyncToGenerator(runtime_default().mark(function _callee() {
        var result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get(authors/* default */.Z);
                case 2:
                    result = _ctx.sent;
                    return _ctx.abrupt("return", result === null || result === void 0 ? void 0 : result.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))), questionnaireAuthors = ref.data, error = ref.error, isLoading = ref.isLoading;
    return {
        questionnaireAuthors: questionnaireAuthors,
        error: error,
        isLoading: isLoading
    };
};
/* harmony default export */ var hooks_useQuestionnaireAuthors = (useQuestionnaireAuthors);

;// CONCATENATED MODULE: ./src/components/_form/Select/QuestionnaireAuthorSelect/index.tsx



function QuestionnaireAuthorSelect_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function QuestionnaireAuthorSelect_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            QuestionnaireAuthorSelect_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function QuestionnaireAuthorSelect(props) {
    var questionnaireAuthors = hooks_useQuestionnaireAuthors().questionnaireAuthors;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, QuestionnaireAuthorSelect_objectSpread({}, props, {
        items: questionnaireAuthors === null || questionnaireAuthors === void 0 ? void 0 : questionnaireAuthors.map(function(param) {
            var id = param.id, name = param.name;
            return {
                label: name,
                value: id
            };
        }),
        isHidingEmptyOptions: true
    })));
}
/* harmony default export */ var Select_QuestionnaireAuthorSelect = (QuestionnaireAuthorSelect);

// EXTERNAL MODULE: ./src/components/_form/TypeaheadWithApiCall/index.tsx
var TypeaheadWithApiCall = __webpack_require__(69001);
// EXTERNAL MODULE: ./src/consts/paths/api/questionnaires/questionnairesPath.ts
var questionnairesPath = __webpack_require__(61680);
;// CONCATENATED MODULE: ./src/components/_questionnaires/CustomQuestionnaireFormModal/index.tsx














function CustomQuestionnaireFormModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CustomQuestionnaireFormModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CustomQuestionnaireFormModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CustomQuestionnaireFormModal = function(param1) {
    var title = param1.title, _submitButtonText = param1.submitButtonText, submitButtonText = _submitButtonText === void 0 ? 'Save' : _submitButtonText, initialValues = param1.initialValues, isShowing = param1.isShowing, toggle = param1.toggle, onSubmit = param1.onSubmit, _canAskState = param1.canAskState, canAskState = _canAskState === void 0 ? false : _canAskState, _canAskAuthor = param1.canAskAuthor, canAskAuthor = _canAskAuthor === void 0 ? false : _canAskAuthor, _canShowDraftMessage = param1.canShowDraftMessage, canShowDraftMessage = _canShowDraftMessage === void 0 ? false : _canShowDraftMessage, _isResetAfterSubmit = param1.isResetAfterSubmit, isResetAfterSubmit = _isResetAfterSubmit === void 0 ? false : _isResetAfterSubmit, _canChangeStatus = param1.canChangeStatus, canChangeStatus = _canChangeStatus === void 0 ? false : _canChangeStatus;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal/* default */.Z, {
        title: title,
        toggle: toggle,
        isShowing: isShowing,
        validationSchema: schema,
        submitButtonText: submitButtonText,
        initialValues: initialValues || schema_initialValues,
        onSubmit: onSubmit,
        onComplete: function() {
            return toggle();
        },
        customSize: true,
        isResetAfterSubmit: isResetAfterSubmit,
        children: function(param) {
            var register = param.register, control = param.control, errors = param.formState.errors, setValue = param.setValue;
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    canShowDraftMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (createQuestionnaire_module_default()).infoTextWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "Your questionnaire will be saved as a draft."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "If you wish to export this questionnaire for use, you will first need to submit it for approval. Once a content manager approves it, it will be visible to the entire community and everyone will be able to export it for use."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "name",
                        id: "name",
                        feedback: errors.name,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, CustomQuestionnaireFormModal_objectSpread({
                            isInvalid: !!errors.name,
                            placeholder: "e. g. Breast Module"
                        }, register('name')))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "type",
                        id: "type",
                        feedback: errors.type,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionnaireTypeSelect/* default */.Z, {
                            kind: QuestionnaireKind/* default.CUSTOM */.Z.CUSTOM,
                            control: control,
                            name: "type",
                            label: ""
                        })
                    }),
                    canAskState && /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "status",
                        id: "state",
                        feedback: errors.state,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_QuestionnaireStateSelect, {
                            control: control,
                            name: "state",
                            label: "",
                            disabled: !canChangeStatus
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "gender",
                        id: "gender",
                        feedback: errors.gender,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GenderSelect/* default */.Z, {
                            control: control,
                            name: "gender",
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "molecule",
                        id: "chemical",
                        feedback: undefined,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeaheadWithApiCall/* default */.Z, {
                            name: "chemical",
                            control: control,
                            setValue: setValue,
                            minLength: 1,
                            isInvalid: !!errors.chemical,
                            infoText: "",
                            allowNew: true,
                            multiple: false,
                            defaultSelected: [
                                (initialValues === null || initialValues === void 0 ? void 0 : initialValues.chemical) || ''
                            ],
                            placeholder: "Name of the molecule tested",
                            error: (ref = errors.chemical) === null || ref === void 0 ? void 0 : ref.message,
                            apiConfig: {
                                url: "".concat(questionnairesPath/* default */.ZP, "/chemicals/search")
                            }
                        })
                    }),
                    canAskAuthor && /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "author",
                        id: "author",
                        feedback: errors.author,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_QuestionnaireAuthorSelect, {
                            control: control,
                            name: "author",
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Field/* default */.Z, {
                        label: "First question",
                        id: "questionsStartPosition",
                        feedback: errors.questionsStartPosition,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, CustomQuestionnaireFormModal_objectSpread({
                                isInvalid: !!errors.questionsStartPosition,
                                placeholder: "1",
                                defaultValue: 1,
                                min: 1,
                                type: "number"
                            }, register('questionsStartPosition'))),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (createQuestionnaire_module_default()).helpInfoText,
                                children: "The numbering of questions starts from this number."
                            })
                        ]
                    }, "questionsStartPosition"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "description",
                        id: "description",
                        feedback: errors.description,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextEditor/* default */.Z, {
                            control: control,
                            setValue: setValue,
                            name: "description",
                            placeholder: "any other information worth mentioning..."
                        })
                    }, "description")
                ]
            });
        }
    }));
};
/* harmony default export */ var _questionnaires_CustomQuestionnaireFormModal = (CustomQuestionnaireFormModal);


/***/ }),

/***/ 83569:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var apiBaseUrl = "https://itemlibrary-api.eortc.org/api" || 0;
/* harmony default export */ __webpack_exports__["Z"] = (apiBaseUrl);


/***/ }),

/***/ 40332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pb": function() { return /* binding */ KEYWORDS; },
/* harmony export */   "aA": function() { return /* binding */ CATEGORIES; },
/* harmony export */   "gJ": function() { return /* binding */ ICDCODES; },
/* harmony export */   "zH": function() { return /* binding */ CTCAE_CATEGORIES; }
/* harmony export */ });
var KEYWORDS = 'keywords';
var CATEGORIES = 'categories';
var ICDCODES = 'icdCodes';
var CTCAE_CATEGORIES = 'ctcaeCategories';


/***/ }),

/***/ 58065:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var forgotPasswordPath = '/auth/forget-password';
/* harmony default export */ __webpack_exports__["Z"] = (forgotPasswordPath);


/***/ }),

/***/ 77480:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var requestAccessPath = '/auth/register';
/* harmony default export */ __webpack_exports__["Z"] = (requestAccessPath);


/***/ }),

/***/ 93194:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var tokenPath = '/auth/token';
/* harmony default export */ __webpack_exports__["Z"] = (tokenPath);


/***/ }),

/***/ 68337:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var updatePasswordPath = '/auth/change-password';
/* harmony default export */ __webpack_exports__["Z"] = (updatePasswordPath);


/***/ }),

/***/ 89944:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var usersPath = '/users';
/* harmony default export */ __webpack_exports__["Z"] = (usersPath);


/***/ }),

/***/ 74781:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var authorsPath = '/authors';
/* harmony default export */ __webpack_exports__["Z"] = (authorsPath);


/***/ }),

/***/ 62019:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var itemsCategoriesPath = '/items/categories';
/* harmony default export */ __webpack_exports__["Z"] = (itemsCategoriesPath);


/***/ }),

/***/ 41999:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var itemsPath = '/items';
/* harmony default export */ __webpack_exports__["Z"] = (itemsPath);


/***/ }),

/***/ 12580:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var recommendedWordingPath = '/recommended-wordings';
/* harmony default export */ __webpack_exports__["Z"] = (recommendedWordingPath);


/***/ }),

/***/ 53917:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var itemsSearchPath = '/items/search';
/* harmony default export */ __webpack_exports__["Z"] = (itemsSearchPath);


/***/ }),

/***/ 94890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ languagesPath; }
/* harmony export */ });
var languagesPath = '/languages';


/***/ }),

/***/ 85944:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var bulkAddQuestionnaireItemsPath = '/questionnaire-items/bulk-add';
/* harmony default export */ __webpack_exports__["Z"] = (bulkAddQuestionnaireItemsPath);


/***/ }),

/***/ 96616:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var questionnaireSummariesPath = '/questionnaire-summaries';
/* harmony default export */ __webpack_exports__["Z"] = (questionnaireSummariesPath);


/***/ }),

/***/ 30829:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var questionnaireItemsPath = '/questionnaire-items';
/* harmony default export */ __webpack_exports__["Z"] = (questionnaireItemsPath);


/***/ }),

/***/ 61680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qn": function() { return /* binding */ downloadCsvPath; },
/* harmony export */   "ac": function() { return /* binding */ downloadTranslationsPath; },
/* harmony export */   "ID": function() { return /* binding */ submitForApprovalPath; },
/* harmony export */   "uX": function() { return /* binding */ cancelSubmitForApprovalPath; },
/* harmony export */   "GF": function() { return /* binding */ publishQuestionnairePath; },
/* harmony export */   "yd": function() { return /* binding */ rejectQuestionnairePath; }
/* harmony export */ });
var questionnairesPath = '/questionnaires';
/* harmony default export */ __webpack_exports__["ZP"] = (questionnairesPath);
var downloadCsvPath = '/download-csv';
var downloadTranslationsPath = '/download-translations';
var submitForApprovalPath = '/submit-for-approval';
var cancelSubmitForApprovalPath = '/cancel-submit-for-approval';
var publishQuestionnairePath = '/publish';
var rejectQuestionnairePath = '/reject';


/***/ }),

/***/ 21987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zf": function() { return /* binding */ questionnaireLibraryPath; },
/* harmony export */   "PM": function() { return /* binding */ requestActionPath; },
/* harmony export */   "_k": function() { return /* binding */ getRequestsPath; },
/* harmony export */   "aI": function() { return /* binding */ questionnaireLibraryModulesPath; }
/* harmony export */ });
/* unused harmony export modulesPath */
var requestsPath = '/requests';
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (requestsPath)));
var questionnaireLibraryPath = '/questionnaire-library';
var requestActionPath = "".concat(questionnaireLibraryPath, "/process/requests");
var getRequestsPath = questionnaireLibraryPath + requestsPath;
var modulesPath = '/modules';
var questionnaireLibraryModulesPath = questionnaireLibraryPath + modulesPath;


/***/ }),

/***/ 91070:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var usagePath = '/usage';
/* harmony default export */ __webpack_exports__["Z"] = (usagePath);


/***/ }),

/***/ 88549:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var forgotPasswordPath = '/auth/current-user';
/* harmony default export */ __webpack_exports__["Z"] = (forgotPasswordPath);


/***/ }),

/***/ 37109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iA": function() { return /* binding */ questionnairesBaseQueryKey; },
/* harmony export */   "Fl": function() { return /* binding */ itemsBaseQueryKey; },
/* harmony export */   "Rq": function() { return /* binding */ usageBaseQueryKey; },
/* harmony export */   "G3": function() { return /* binding */ searchBaseQueryKey; },
/* harmony export */   "zl": function() { return /* binding */ requestsBaseQueryKey; },
/* harmony export */   "kC": function() { return /* binding */ questionnaireLibraryModuleKey; },
/* harmony export */   "KR": function() { return /* binding */ questionnaireLibraryModulesKey; }
/* harmony export */ });
var questionnairesBaseQueryKey = 'questionnaires';
var itemsBaseQueryKey = 'items';
var usageBaseQueryKey = 'usage';
var searchBaseQueryKey = 'search';
var requestsBaseQueryKey = 'requests';
var questionnaireLibraryModuleKey = 'questionnairesLibraryModule';
var questionnaireLibraryModulesKey = 'questionnairesLibraryModules';


/***/ }),

/***/ 77732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46863);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50050);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_2__);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Button = function(props) {
    var children = props.children, className = props.className;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({}, props, {
        type: "button",
        className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().customButton), " ").concat(className || '').trim(),
        children: children
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 49788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var elements_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77732);
/* harmony import */ var _buttonWithLoader_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80570);
/* harmony import */ var _buttonWithLoader_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_buttonWithLoader_module_scss__WEBPACK_IMPORTED_MODULE_2__);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ButtonWithLoader = function(_param) /*#__PURE__*/ {
    var isLoading = _param.isLoading, onClick = _param.onClick, children = _param.children, props = _objectWithoutProperties(_param, [
        "isLoading",
        "onClick",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "d-flex align-items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(elements_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({
            type: "button",
            onClick: onClick,
            className: "d-inline-block",
            disabled: isLoading
        }, props, {
            children: isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_buttonWithLoader_module_scss__WEBPACK_IMPORTED_MODULE_2___default().loader)
            }) : children
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonWithLoader);


/***/ }),

/***/ 53046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TooltipWrapper_TooltipWrapper; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/contains.js
var contains = __webpack_require__(26712);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useMounted.js
var useMounted = __webpack_require__(88441);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useWillUnmount.js + 1 modules
var useWillUnmount = __webpack_require__(87528);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useTimeout.js



/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */

var MAX_DELAY_MS = Math.pow(2, 31) - 1;

function setChainedTimeout(handleRef, fn, timeoutAtMs) {
  var delayMs = timeoutAtMs - Date.now();
  handleRef.current = delayMs <= MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(function () {
    return setChainedTimeout(handleRef, fn, timeoutAtMs);
  }, MAX_DELAY_MS);
}
/**
 * Returns a controller object for setting a timeout that is properly cleaned up
 * once the component unmounts. New timeouts cancel and replace existing ones.
 *
 *
 *
 * ```tsx
 * const { set, clear } = useTimeout();
 * const [hello, showHello] = useState(false);
 * //Display hello after 5 seconds
 * set(() => showHello(true), 5000);
 * return (
 *   <div className="App">
 *     {hello ? <h3>Hello</h3> : null}
 *   </div>
 * );
 * ```
 */


function useTimeout() {
  var isMounted = (0,useMounted/* default */.Z)(); // types are confused between node and web here IDK

  var handleRef = (0,react.useRef)();
  (0,useWillUnmount/* default */.Z)(function () {
    return clearTimeout(handleRef.current);
  });
  return (0,react.useMemo)(function () {
    var clear = function clear() {
      return clearTimeout(handleRef.current);
    };

    function set(fn, delayMs) {
      if (delayMs === void 0) {
        delayMs = 0;
      }

      if (!isMounted()) return;
      clear();

      if (delayMs <= MAX_DELAY_MS) {
        // For simplicity, if the timeout is short, just set a normal timeout.
        handleRef.current = setTimeout(fn, delayMs);
      } else {
        setChainedTimeout(handleRef, fn, Date.now() + delayMs);
      }
    }

    return {
      set: set,
      clear: clear
    };
  }, []);
}
// EXTERNAL MODULE: ./node_modules/.pnpm/warning@4.0.3/node_modules/warning/warning.js
var warning = __webpack_require__(91190);
// EXTERNAL MODULE: ./node_modules/.pnpm/uncontrollable@7.2.1_react@17.0.2/node_modules/uncontrollable/lib/esm/index.js + 4 modules
var esm = __webpack_require__(22084);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useMergedRefs.js
var useMergedRefs = __webpack_require__(39400);
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(19803);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@17.0.2_react@17.0.2/node_modules/react-dom/index.js
var react_dom = __webpack_require__(87995);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useCallbackRef.js
var useCallbackRef = __webpack_require__(14786);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/usePopper.js + 3 modules
var usePopper = __webpack_require__(39279);
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/listen.js
var listen = __webpack_require__(17692);
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/ownerDocument.js
var ownerDocument = __webpack_require__(78342);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useEventCallback.js
var useEventCallback = __webpack_require__(61255);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/useClickOutside.js
var useClickOutside = __webpack_require__(41071);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/useRootClose.js





const escapeKeyCode = 27;

const noop = () => {};

/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */
function useRootClose(ref, onRootClose, {
  disabled,
  clickTrigger
} = {}) {
  const onClose = onRootClose || noop;
  (0,useClickOutside/* default */.Z)(ref, onClose, {
    disabled,
    clickTrigger
  });
  const handleKeyUp = (0,useEventCallback/* default */.Z)(e => {
    if (e.keyCode === escapeKeyCode) {
      onClose(e);
    }
  });
  (0,react.useEffect)(() => {
    if (disabled || ref == null) return undefined;
    const doc = (0,ownerDocument/* default */.Z)((0,useClickOutside/* getRefTarget */.f)(ref)); // Store the current event to avoid triggering handlers immediately
    // https://github.com/facebook/react/issues/20074

    let currentEvent = (doc.defaultView || window).event;
    const removeKeyupListener = (0,listen/* default */.Z)(doc, 'keyup', e => {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }

      handleKeyUp(e);
    });
    return () => {
      removeKeyupListener();
    };
  }, [ref, disabled, handleKeyUp]);
}

/* harmony default export */ var esm_useRootClose = (useRootClose);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/useWaitForDOMRef.js
var useWaitForDOMRef = __webpack_require__(6854);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/mergeOptionsWithPopperConfig.js
var mergeOptionsWithPopperConfig = __webpack_require__(96027);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/Overlay.js











/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */
const Overlay = /*#__PURE__*/react.forwardRef((props, outerRef) => {
  const {
    flip,
    offset,
    placement,
    containerPadding,
    popperConfig = {},
    transition: Transition
  } = props;
  const [rootElement, attachRef] = (0,useCallbackRef/* default */.Z)();
  const [arrowElement, attachArrowRef] = (0,useCallbackRef/* default */.Z)();
  const mergedRef = (0,useMergedRefs/* default */.Z)(attachRef, outerRef);
  const container = (0,useWaitForDOMRef/* default */.Z)(props.container);
  const target = (0,useWaitForDOMRef/* default */.Z)(props.target);
  const [exited, setExited] = (0,react.useState)(!props.show);
  const popper = (0,usePopper/* default */.Z)(target, rootElement, (0,mergeOptionsWithPopperConfig/* default */.ZP)({
    placement,
    enableEvents: !!props.show,
    containerPadding: containerPadding || 5,
    flip,
    offset,
    arrowElement,
    popperConfig
  }));

  if (props.show) {
    if (exited) setExited(false);
  } else if (!props.transition && !exited) {
    setExited(true);
  }

  const handleHidden = (...args) => {
    setExited(true);

    if (props.onExited) {
      props.onExited(...args);
    }
  }; // Don't un-render the overlay while it's transitioning out.


  const mountOverlay = props.show || Transition && !exited;
  esm_useRootClose(rootElement, props.onHide, {
    disabled: !props.rootClose || props.rootCloseDisabled,
    clickTrigger: props.rootCloseEvent
  });

  if (!mountOverlay) {
    // Don't bother showing anything if we don't have to.
    return null;
  }

  let child = props.children(Object.assign({}, popper.attributes.popper, {
    style: popper.styles.popper,
    ref: mergedRef
  }), {
    popper,
    placement,
    show: !!props.show,
    arrowProps: Object.assign({}, popper.attributes.arrow, {
      style: popper.styles.arrow,
      ref: attachArrowRef
    })
  });

  if (Transition) {
    const {
      onExit,
      onExiting,
      onEnter,
      onEntering,
      onEntered
    } = props;
    child = /*#__PURE__*/(0,jsx_runtime.jsx)(Transition, {
      in: props.show,
      appear: true,
      onExit: onExit,
      onExiting: onExiting,
      onExited: handleHidden,
      onEnter: onEnter,
      onEntering: onEntering,
      onEntered: onEntered,
      children: child
    });
  }

  return container ? /*#__PURE__*/react_dom.createPortal(child, container) : null;
});
Overlay.displayName = 'Overlay';
/* harmony default export */ var esm_Overlay = (Overlay);
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/hasClass.js
var hasClass = __webpack_require__(99523);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(97902);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(91385);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/PopoverHeader.js

/* harmony default export */ var PopoverHeader = ((0,createWithBsPrefix/* default */.Z)('popover-header'));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/PopoverBody.js

/* harmony default export */ var PopoverBody = ((0,createWithBsPrefix/* default */.Z)('popover-body'));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/helpers.js

class BsPrefixComponent extends react.Component {} // Need to use this instead of typeof Component to get proper type checking.

function getOverlayDirection(placement, isRTL) {
  let bsDirection = placement;

  if (placement === 'left') {
    bsDirection = isRTL ? 'end' : 'start';
  } else if (placement === 'right') {
    bsDirection = isRTL ? 'start' : 'end';
  }

  return bsDirection;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Popover.js








const defaultProps = {
  placement: 'right'
};
const Popover = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  placement,
  className,
  style,
  children,
  body,
  arrowProps,
  popper: _,
  show: _1,
  ...props
}, ref) => {
  const decoratedBsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'popover');
  const isRTL = (0,ThemeProvider/* useIsRTL */.SC)();
  const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
  const bsDirection = getOverlayDirection(primaryPlacement, isRTL);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    role: "tooltip",
    style: style,
    "x-placement": primaryPlacement,
    className: classnames_default()(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
    ...props,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "popover-arrow",
      ...arrowProps
    }), body ? /*#__PURE__*/(0,jsx_runtime.jsx)(PopoverBody, {
      children: children
    }) : children]
  });
});
Popover.defaultProps = defaultProps;
/* harmony default export */ var esm_Popover = (Object.assign(Popover, {
  Header: PopoverHeader,
  Body: PopoverBody,
  // Default popover offset.
  // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
  POPPER_OFFSET: [0, 8]
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/useOverlayOffset.js



 // This is meant for internal use.
// This applies a custom offset to the overlay if it's a popover.

function useOverlayOffset(customOffset) {
  const overlayRef = (0,react.useRef)(null);
  const popoverClass = (0,ThemeProvider/* useBootstrapPrefix */.vE)(undefined, 'popover');
  const offset = (0,react.useMemo)(() => ({
    name: 'offset',
    options: {
      offset: () => {
        if (overlayRef.current && (0,hasClass/* default */.Z)(overlayRef.current, popoverClass)) {
          return customOffset || esm_Popover.POPPER_OFFSET;
        }

        return customOffset || [0, 0];
      }
    }
  }), [customOffset, popoverClass]);
  return [overlayRef, [offset]];
}
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Fade.js
var Fade = __webpack_require__(94542);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/safeFindDOMNode.js
var safeFindDOMNode = __webpack_require__(92201);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Overlay.js









const Overlay_defaultProps = {
  transition: Fade/* default */.Z,
  rootClose: false,
  show: false,
  placement: 'top'
};

function wrapRefs(props, arrowProps) {
  const {
    ref
  } = props;
  const {
    ref: aRef
  } = arrowProps;

  props.ref = ref.__wrapped || (ref.__wrapped = r => ref((0,safeFindDOMNode/* default */.Z)(r)));

  arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = r => aRef((0,safeFindDOMNode/* default */.Z)(r)));
}

const Overlay_Overlay = /*#__PURE__*/react.forwardRef(({
  children: overlay,
  transition,
  popperConfig = {},
  ...outerProps
}, outerRef) => {
  const popperRef = (0,react.useRef)({});
  const [ref, modifiers] = useOverlayOffset(outerProps.offset);
  const mergedRef = (0,useMergedRefs/* default */.Z)(outerRef, ref);
  const actualTransition = transition === true ? Fade/* default */.Z : transition || undefined;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Overlay, { ...outerProps,
    ref: mergedRef,
    popperConfig: { ...popperConfig,
      modifiers: modifiers.concat(popperConfig.modifiers || [])
    },
    transition: actualTransition,
    children: (overlayProps, {
      arrowProps,
      popper: popperObj,
      show
    }) => {
      var _popperObj$state, _popperObj$state$modi;

      wrapRefs(overlayProps, arrowProps); // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop

      const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
      const popper = Object.assign(popperRef.current, {
        state: popperObj == null ? void 0 : popperObj.state,
        scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
        placement: updatedPlacement,
        outOfBoundaries: (popperObj == null ? void 0 : (_popperObj$state = popperObj.state) == null ? void 0 : (_popperObj$state$modi = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state$modi.isReferenceHidden) || false
      });
      if (typeof overlay === 'function') return overlay({ ...overlayProps,
        placement: updatedPlacement,
        show,
        ...(!transition && show && {
          className: 'show'
        }),
        popper,
        arrowProps
      });
      return /*#__PURE__*/react.cloneElement(overlay, { ...overlayProps,
        placement: updatedPlacement,
        arrowProps,
        popper,
        className: classnames_default()(overlay.props.className, !transition && show && 'show'),
        style: { ...overlay.props.style,
          ...overlayProps.style
        }
      });
    }
  });
});
Overlay_Overlay.displayName = 'Overlay';
Overlay_Overlay.defaultProps = Overlay_defaultProps;
/* harmony default export */ var react_bootstrap_esm_Overlay = (Overlay_Overlay);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/OverlayTrigger.js













function normalizeDelay(delay) {
  return delay && typeof delay === 'object' ? delay : {
    show: delay,
    hide: delay
  };
} // Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.


function handleMouseOverOut( // eslint-disable-next-line @typescript-eslint/no-shadow
handler, args, relatedNative) {
  const [e] = args;
  const target = e.currentTarget;
  const related = e.relatedTarget || e.nativeEvent[relatedNative];

  if ((!related || related !== target) && !(0,contains/* default */.Z)(target, related)) {
    handler(...args);
  }
}

const OverlayTrigger_defaultProps = {
  defaultShow: false,
  trigger: ['hover', 'focus']
};

function OverlayTrigger({
  trigger,
  overlay,
  children,
  popperConfig = {},
  show: propsShow,
  defaultShow = false,
  onToggle,
  delay: propsDelay,
  placement,
  flip = placement && placement.indexOf('auto') !== -1,
  ...props
}) {
  const triggerNodeRef = (0,react.useRef)(null);
  const mergedRef = (0,useMergedRefs/* default */.Z)(triggerNodeRef, children.ref);
  const timeout = useTimeout();
  const hoverStateRef = (0,react.useRef)('');
  const [show, setShow] = (0,esm/* useUncontrolledProp */.$c)(propsShow, defaultShow, onToggle);
  const delay = normalizeDelay(propsDelay);
  const {
    onFocus,
    onBlur,
    onClick
  } = typeof children !== 'function' ? react.Children.only(children).props : {};

  const attachRef = r => {
    mergedRef((0,safeFindDOMNode/* default */.Z)(r));
  };

  const handleShow = (0,react.useCallback)(() => {
    timeout.clear();
    hoverStateRef.current = 'show';

    if (!delay.show) {
      setShow(true);
      return;
    }

    timeout.set(() => {
      if (hoverStateRef.current === 'show') setShow(true);
    }, delay.show);
  }, [delay.show, setShow, timeout]);
  const handleHide = (0,react.useCallback)(() => {
    timeout.clear();
    hoverStateRef.current = 'hide';

    if (!delay.hide) {
      setShow(false);
      return;
    }

    timeout.set(() => {
      if (hoverStateRef.current === 'hide') setShow(false);
    }, delay.hide);
  }, [delay.hide, setShow, timeout]);
  const handleFocus = (0,react.useCallback)((...args) => {
    handleShow();
    onFocus == null ? void 0 : onFocus(...args);
  }, [handleShow, onFocus]);
  const handleBlur = (0,react.useCallback)((...args) => {
    handleHide();
    onBlur == null ? void 0 : onBlur(...args);
  }, [handleHide, onBlur]);
  const handleClick = (0,react.useCallback)((...args) => {
    setShow(!show);
    onClick == null ? void 0 : onClick(...args);
  }, [onClick, setShow, show]);
  const handleMouseOver = (0,react.useCallback)((...args) => {
    handleMouseOverOut(handleShow, args, 'fromElement');
  }, [handleShow]);
  const handleMouseOut = (0,react.useCallback)((...args) => {
    handleMouseOverOut(handleHide, args, 'toElement');
  }, [handleHide]);
  const triggers = trigger == null ? [] : [].concat(trigger);
  const triggerProps = {
    ref: attachRef
  };

  if (triggers.indexOf('click') !== -1) {
    triggerProps.onClick = handleClick;
  }

  if (triggers.indexOf('focus') !== -1) {
    triggerProps.onFocus = handleFocus;
    triggerProps.onBlur = handleBlur;
  }

  if (triggers.indexOf('hover') !== -1) {
     false ? 0 : void 0;
    triggerProps.onMouseOver = handleMouseOver;
    triggerProps.onMouseOut = handleMouseOut;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [typeof children === 'function' ? children(triggerProps) : /*#__PURE__*/(0,react.cloneElement)(children, triggerProps), /*#__PURE__*/(0,jsx_runtime.jsx)(react_bootstrap_esm_Overlay, { ...props,
      show: show,
      onHide: handleHide,
      flip: flip,
      placement: placement,
      popperConfig: popperConfig,
      target: triggerNodeRef.current,
      children: overlay
    })]
  });
}

OverlayTrigger.defaultProps = OverlayTrigger_defaultProps;
/* harmony default export */ var esm_OverlayTrigger = (OverlayTrigger);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Tooltip.js






const Tooltip_defaultProps = {
  placement: 'right'
};
const Tooltip = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  placement,
  className,
  style,
  children,
  arrowProps,
  popper: _,
  show: _2,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'tooltip');
  const isRTL = (0,ThemeProvider/* useIsRTL */.SC)();
  const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
  const bsDirection = getOverlayDirection(primaryPlacement, isRTL);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    style: style,
    role: "tooltip",
    "x-placement": primaryPlacement,
    className: classnames_default()(className, bsPrefix, `bs-tooltip-${bsDirection}`),
    ...props,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "tooltip-arrow",
      ...arrowProps
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: `${bsPrefix}-inner`,
      children: children
    })]
  });
});
Tooltip.defaultProps = Tooltip_defaultProps;
Tooltip.displayName = 'Tooltip';
/* harmony default export */ var esm_Tooltip = (Tooltip);
;// CONCATENATED MODULE: ./src/elements/TooltipWrapper/TooltipWrapper.tsx


var TooltipWrapper = function(param) {
    var placement = param.placement, text = param.text, children = param.children, tooltipId = param.tooltipId;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(esm_OverlayTrigger, {
        placement: placement,
        overlay: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Tooltip, {
            id: tooltipId,
            children: text
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "d-inline-block",
            children: children
        })
    });
};
/* harmony default export */ var TooltipWrapper_TooltipWrapper = (TooltipWrapper);


/***/ }),

/***/ 34155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44925);
/* harmony import */ var _login_info_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96485);
/* harmony import */ var _login_info_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_login_info_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Warning = function(param) {
    var show = param.show, text = param.text;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        variant: "danger",
        className: show ? (_login_info_module_scss__WEBPACK_IMPORTED_MODULE_2___default().alert) : 'd-none',
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_login_info_module_scss__WEBPACK_IMPORTED_MODULE_2___default().alertIcon)
            }),
            text
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Warning);


/***/ }),

/***/ 42711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tryGetApiError; }
});

;// CONCATENATED MODULE: ./src/functions/axios/tryCastAxiosError.ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
/* harmony default export */ function tryCastAxiosError(candidate) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if ((candidate === null || candidate === void 0 ? void 0 : candidate.isAxiosError) === true) {
        return candidate;
    }
    throw candidate;
};

;// CONCATENATED MODULE: ./src/functions/api/tryGetApiError.ts

// eslint-disable-next-line @typescript-eslint/no-explicit-any
/* harmony default export */ function tryGetApiError(candidate) {
    var ref;
    var axiosError = tryCastAxiosError(candidate);
    return (ref = axiosError.response) === null || ref === void 0 ? void 0 : ref.data;
};


/***/ }),

/***/ 22948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ normalizeTypeaheadArray; },
/* harmony export */   "m": function() { return /* binding */ normalizeTypeaheadField; }
/* harmony export */ });
var normalizeTypeaheadArray = function(array) {
    return array.map(function(item) {
        return normalizeTypeaheadField(item);
    });
};
var normalizeTypeaheadField = function(value) {
    if (typeof value !== 'string' && (value === null || value === void 0 ? void 0 : value.customOption)) {
        return value.label;
    }
    return value;
};


/***/ }),

/***/ 31620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ stripHtmlFromStringIfEmpty; }
/* harmony export */ });
var stripHtmlFromStringIfEmpty = function(html) {
    var ref;
    var div = document.createElement('div');
    div.innerHTML = html;
    // If there is no text pass empty string
    return ((ref = div.textContent) === null || ref === void 0 ? void 0 : ref.trim()) ? html : '';
};


/***/ }),

/***/ 42590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(value) {
    return "".concat(value, " is required");
};


/***/ }),

/***/ 96308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useAlerts; }
});

// UNUSED EXPORTS: alertsAtom

// EXTERNAL MODULE: ./node_modules/.pnpm/jotai@1.6.1_zrsyqg6kfmuxkmxyjtbkl6ldiu/node_modules/jotai/esm/index.js
var esm = __webpack_require__(7997);
;// CONCATENATED MODULE: ./src/_types/appState/AlertType.ts
var AlertType;
(function(AlertType) {
    AlertType["Success"] = 'success';
    AlertType["Error"] = 'danger';
    AlertType["Warning"] = 'warning';
    AlertType["Info"] = 'info';
})(AlertType || (AlertType = {}));

// EXTERNAL MODULE: ./node_modules/.pnpm/jotai@1.6.1_zrsyqg6kfmuxkmxyjtbkl6ldiu/node_modules/jotai/esm/immer.js + 1 modules
var immer = __webpack_require__(98499);
;// CONCATENATED MODULE: ./src/hooks/useAlerts/index.ts



function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var alertsAtom = (0,esm/* atom */.cn)([]);
function useAlerts() {
    var ref = _slicedToArray((0,immer/* useImmerAtom */.It)(alertsAtom), 2), alerts1 = ref[0], setAlerts = ref[1];
    var addAlert = function(message, type) {
        var isAutomaticallyDismissed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        setAlerts(function(alerts) {
            var trimmedMessage = message.trim();
            // get alert if already existing
            var alreadyExistingAlert = alerts.find(function(alert) {
                return alert.message === trimmedMessage && alert.type === type;
            });
            if (alreadyExistingAlert) {
                alreadyExistingAlert.count += 1;
            } else {
                alerts.push({
                    message: trimmedMessage,
                    type: type,
                    count: 1,
                    id: type + trimmedMessage,
                    isAutomaticallyDismissed: isAutomaticallyDismissed
                });
            }
        });
    };
    var removeAlert = function(alert) {
        setAlerts(function(alerts) {
            return alerts = alerts.filter(function(a) {
                return a.message !== alert.message || a.type !== alert.type;
            });
        });
    };
    return {
        alerts: alerts1,
        addInfoAlert: function(message) {
            return addAlert(message, AlertType.Info);
        },
        addWarningAlert: function(message) {
            return addAlert(message, AlertType.Warning, false);
        },
        addErrorAlert: function(message) {
            return addAlert(message, AlertType.Error, false);
        },
        addUnexpectedServerErrorAlert: function() {
            return addAlert('An unexpected internal server occurred. Please try again later.', AlertType.Error, false);
        },
        addSuccessAlert: function(message) {
            return addAlert(message, AlertType.Success);
        },
        removeAlert: removeAlert
    };
};


/***/ }),

/***/ 7920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10299);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var consts_api_apiBaseUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83569);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _useUserSession__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39955);




var useApi = function() {
    var ref1 = (0,_useUserSession__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), accessToken = ref1.accessToken, invalidateAccessToken = ref1.invalidateAccessToken;
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var headers = accessToken ? {
            Authorization: "Bearer ".concat(accessToken)
        } : {};
        var client = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
            baseURL: consts_api_apiBaseUrl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
            headers: headers
        });
        client.interceptors.response.use(undefined, function(error) {
            var ref;
            if (((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === 401) {
                invalidateAccessToken();
            }
            return Promise.reject(error);
        });
        return client;
    }, [
        accessToken,
        invalidateAccessToken
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useApi);


/***/ }),

/***/ 18205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95601);
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var useCountries = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), countries = ref[0], setCountries = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        void _asyncToGenerator(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.t0 = setCountries;
                        _ctx.next = 3;
                        return __webpack_require__.e(/* import() */ 479).then(__webpack_require__.t.bind(__webpack_require__, 69479, 19));
                    case 3:
                        _ctx.t1 = _ctx.sent.default;
                        (0, _ctx.t0)(_ctx.t1);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, []);
    var getCountryName = function(code) {
        var result = countries === null || countries === void 0 ? void 0 : countries.filter(function(item) {
            return item.code === code;
        });
        if (result) {
            return result[0].name;
        }
        return '';
    };
    return {
        countries: countries,
        getCountryName: getCountryName
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCountries);


/***/ }),

/***/ 14149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95601);
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var consts_paths_api_questionnaires_questionnairesPath__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61680);
/* harmony import */ var _useCurrentUser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36271);
/* harmony import */ var _useInvalidateQuestionnaires__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23632);
/* harmony import */ var _useApi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7920);





function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var useCreateQuestionnaire = function() {
    var api = (0,_useApi__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var currentUser = (0,_useCurrentUser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().currentUser;
    var invalidateQuestionnaires = (0,_useInvalidateQuestionnaires__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return {
        createQuestionnaire: (function() {
            var _ref = _asyncToGenerator(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(formData) {
                var ref, _invalidate, invalidate, data, ref1, createdQuestionnaire, _args = arguments;
                return _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ref = _args.length > 1 && _args[1] !== void 0 ? _args[1] : {}, _invalidate = ref.invalidate, invalidate = _invalidate === void 0 ? true : _invalidate;
                            data = _objectSpread({}, formData, {
                                author: currentUser.id,
                                languages: [
                                    {
                                        code: 'en',
                                        name: 'English'
                                    }
                                ],
                                state: 'draft'
                            });
                            _ctx.next = 4;
                            return api.post(consts_paths_api_questionnaires_questionnairesPath__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, data);
                        case 4:
                            ref1 = _ctx.sent;
                            createdQuestionnaire = ref1.data;
                            if (!invalidate) {
                                _ctx.next = 9;
                                break;
                            }
                            _ctx.next = 9;
                            return invalidateQuestionnaires();
                        case 9:
                            return _ctx.abrupt("return", createdQuestionnaire);
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(formData) {
                return _ref.apply(this, arguments);
            };
        })()
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCreateQuestionnaire);


/***/ }),

/***/ 36271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCurrentUser; }
/* harmony export */ });
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95601);
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88349);
/* harmony import */ var consts_paths_api_users_current_user__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88549);
/* harmony import */ var _useApi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7920);
/* harmony import */ var hooks_useUserSession__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39955);
/* harmony import */ var consts_paths_api_auth_updatePassword__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68337);






function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useCurrentUser() {
    var api = (0,_useApi__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQueryClient)();
    var currentUserKey = 'current-user';
    var isAuthenticated = (0,hooks_useUserSession__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isAuthenticated;
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)(currentUserKey, _asyncToGenerator(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get(consts_paths_api_users_current_user__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        enabled: isAuthenticated
    }), currentUser = ref.data;
    var updateCurrentUser = function() {
        var _ref = _asyncToGenerator(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(user) {
            return _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return api.put("".concat(consts_paths_api_users_current_user__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, "/").concat(user.id), user);
                    case 2:
                        queryClient.invalidateQueries(currentUserKey);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function updateCurrentUser(user) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref1 = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useMutation)(function() {
        var _ref = _asyncToGenerator(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
            return _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return api.post(consts_paths_api_auth_updatePassword__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, data);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }()), isPasswordUpdated = ref1.isSuccess, updatePassword = ref1.mutate, resetSuccess = ref1.reset;
    return {
        currentUser: currentUser,
        updateCurrentUser: updateCurrentUser,
        isPasswordUpdated: isPasswordUpdated,
        updatePassword: updatePassword,
        resetSuccess: resetSuccess
    };
};


/***/ }),

/***/ 42010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ useCurrentUserPermissions; }
});

// UNUSED EXPORTS: canAccessPage, mergePermissions

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_n6febsnk4nq7zxsovmf65ymnxm/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(95601);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/hooks/useCurrentUser/index.tsx
var useCurrentUser = __webpack_require__(36271);
;// CONCATENATED MODULE: ./src/functions/object/omitFalsyFields.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function omitFalsyFields(obj) {
    return _toConsumableArray(Object.keys(obj)).reduce(function(ret, key) {
        var newRet = _objectSpread({}, ret);
        if (obj[key]) {
            if (obj[key] === true) {
                newRet[key] = true;
            } else if (obj[key] !== false) {
                newRet[key] = omitFalsyFields(obj[key]);
            }
        }
        return newRet;
    }, {});
}
/* harmony default export */ var object_omitFalsyFields = (omitFalsyFields);

// EXTERNAL MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/index.js + 235 modules
var es = __webpack_require__(62058);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(88349);
;// CONCATENATED MODULE: ./src/hooks/useCurrentUserPermissions/index.tsx





function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useCurrentUserPermissions_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useCurrentUserPermissions_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useCurrentUserPermissions_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function canAccessPage(pagePath, permissions) {
    //  basic impl : if the user has access permission on base path, we consider he can access it.
    // for example if the user wants to access /users/entry/2 and has users.canAccess:true -> ok
    var basePath = pagePath.split('/')[1] || '/';
    return permissions[basePath] && permissions[basePath].canAccess;
}
function mergePermissions(userRoles, permissionsByRole, defaultPermissions) {
    return userRoles.reduce(function(result, roleId) {
        var rolePermissions = permissionsByRole[roleId];
        if (rolePermissions) {
            return (0,es/* mergeDeepRight */.BPw)(result, object_omitFalsyFields(rolePermissions));
        }
        return result;
    }, defaultPermissions);
}
function useCurrentUserPermissions() {
    var currentUser = (0,useCurrentUser/* default */.Z)().currentUser;
    var currentUserRoles = currentUser === null || currentUser === void 0 ? void 0 : currentUser.roles;
    var ref = (0,react_query_es.useQuery)('current-user-currentUserPermissions', _asyncToGenerator(runtime_default().mark(function _callee() {
        var permissionsByRole;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return __webpack_require__.e(/* import() */ 463).then(__webpack_require__.t.bind(__webpack_require__, 87463, 19));
                case 2:
                    permissionsByRole = _ctx.sent.default;
                    return _ctx.abrupt("return", mergePermissions(currentUserRoles, permissionsByRole, permissionsByRole.default));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        enabled: !!currentUser
    }), currentUserPermissions = ref.data;
    return useCurrentUserPermissions_objectSpread({}, currentUserPermissions, {
        currentUserPermissions: currentUserPermissions,
        arePermissionsLoaded: !!currentUserPermissions,
        canAccessPage: function(pagePath) {
            return !!currentUserPermissions && canAccessPage(pagePath, currentUserPermissions);
        },
        currentUser: currentUser
    });
};


/***/ }),

/***/ 18656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);

function useDebounce(value, delay) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var timer = setTimeout(function() {
            return setDebouncedValue(value);
        }, delay || 500);
        return function() {
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
/* harmony default export */ __webpack_exports__["Z"] = (useDebounce);


/***/ }),

/***/ 74766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UseForm; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_n6febsnk4nq7zxsovmf65ymnxm/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(95601);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.28.0_react@17.0.2/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(90300);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@hookform+resolvers@2.8.8_react-hook-form@7.28.0/node_modules/@hookform/resolvers/dist/resolvers.module.js
var e=function(i,e,t){if(i&&"reportValidity"in i){var f=(0,index_esm/* get */.U2)(t,e);i.setCustomValidity(f&&f.message||""),i.reportValidity()}},resolvers_module_t=function(r,i){var t=function(t){var f=i.fields[t];f&&f.ref&&"reportValidity"in f.ref?e(f.ref,t,r):f.refs&&f.refs.forEach(function(i){return e(i,t,r)})};for(var f in i.fields)t(f)},f=function(e,f){f.shouldUseNativeValidation&&resolvers_module_t(e,f);var o={};for(var a in e){var n=(0,index_esm/* get */.U2)(f.fields,a);(0,index_esm/* set */.t8)(o,a,Object.assign(e[a],{ref:n&&n.ref}))}return o};
//# sourceMappingURL=resolvers.module.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@hookform+resolvers@2.8.8_react-hook-form@7.28.0/node_modules/@hookform/resolvers/yup/dist/yup.module.js
var o=function(o,n,a){return void 0===n&&(n={}),void 0===a&&(a={}),function(s,i,c){try{return Promise.resolve(function(t,r){try{var u=(n.context&&"development"==="production"&&0,Promise.resolve(o["sync"===a.mode?"validateSync":"validate"](s,Object.assign({abortEarly:!1},n,{context:i}))).then(function(t){return c.shouldUseNativeValidation&&resolvers_module_t({},c),{values:t,errors:{}}}))}catch(e){return r(e)}return u&&u.then?u.then(void 0,r):u}(0,function(e){if(!e.inner)throw e;return{values:{},errors:f((o=e,n=!c.shouldUseNativeValidation&&"all"===c.criteriaMode,(o.inner||[]).reduce(function(e,t){if(e[t.path]||(e[t.path]={message:t.message,type:t.type}),n){var o=e[t.path].types,a=o&&o[t.type];e[t.path]=(0,index_esm/* appendErrors */.KN)(t.path,n,e,t.type,a?[].concat(a,t.message):t.message)}return e},{})),c)};var o,n}))}catch(e){return Promise.reject(e)}}};
//# sourceMappingURL=yup.module.js.map

;// CONCATENATED MODULE: ./src/hooks/useIsMounted.ts

function useIsMounted() {
    var isMounted = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    return (0,react.useCallback)(function() {
        return isMounted.current;
    }, []);
}
/* harmony default export */ var hooks_useIsMounted = (useIsMounted);

;// CONCATENATED MODULE: ./src/elements/ButtonWithLoader/useButtonWithLoader.ts

var useButtonWithLoader = function() {
    var ref = (0,react.useState)(false), isLoading = ref[0], setIsLoading = ref[1];
    return {
        isLoading: isLoading,
        setIsLoading: setIsLoading
    };
};
/* harmony default export */ var ButtonWithLoader_useButtonWithLoader = (useButtonWithLoader);

// EXTERNAL MODULE: ./src/hooks/useUnexpectedError.ts
var useUnexpectedError = __webpack_require__(97808);
// EXTERNAL MODULE: ./src/functions/api/tryGetApiError.ts + 1 modules
var tryGetApiError = __webpack_require__(42711);
;// CONCATENATED MODULE: ./src/hooks/useForm.tsx








function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function UseForm(_param) {
    var schema = _param.schema, onSubmit = _param.onSubmit, formProps = _objectWithoutProperties(_param, [
        "schema",
        "onSubmit"
    ]);
    var isMounted = hooks_useIsMounted();
    var ref = ButtonWithLoader_useButtonWithLoader(), isLoading = ref.isLoading, setIsLoading = ref.setIsLoading;
    var ref1 = (0,react.useState)(''), warningMessage = ref1[0], setWarningMessage = ref1[1];
    var setUnexpectedError = (0,useUnexpectedError/* default */.Z)().setUnexpectedError;
    var form = (0,index_esm/* useForm */.cI)(_objectSpread({
        resolver: o(schema)
    }, formProps));
    var onSubmitProxy = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(data) {
            var apiError;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setIsLoading(true);
                        setWarningMessage('');
                        _ctx.next = 5;
                        return onSubmit(data);
                    case 5:
                        if (isMounted()) {
                            setIsLoading(false);
                        }
                        _ctx.next = 13;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        apiError = (0,tryGetApiError/* default */.Z)(_ctx.t0);
                        if (apiError && apiError.error_description) {
                            setWarningMessage(apiError.error_description);
                        } else {
                            // Server reply not managed
                            setUnexpectedError(_ctx.t0, {
                                isUserAlreadyAlerted: true
                            });
                            setWarningMessage('Something went wrong, please try again.');
                        }
                        setIsLoading(false);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function onSubmitProxy(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var reset = function(data) {
        setWarningMessage('');
        form.reset(data);
    };
    return _objectSpread({}, form, {
        isLoading: isLoading,
        warningMessage: warningMessage,
        handleSubmit: form.handleSubmit(onSubmitProxy),
        setWarningMessage: setWarningMessage,
        reset: reset
    });
};


/***/ }),

/***/ 97901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95601);
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var hooks_useForm__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74766);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useFormModal(param) {
    var onComplete = param.onComplete, onSubmit = param.onSubmit, validationSchema = param.validationSchema, initialValues = param.initialValues, toggle = param.toggle, isResetAfterSubmit = param.isResetAfterSubmit, onCancelClickCallback = param.onCancelClickCallback;
    var onSubmitProxy = function() {
        var _ref = _asyncToGenerator(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
            return _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return onSubmit(data);
                    case 2:
                        onComplete(data);
                        reset(isResetAfterSubmit ? undefined : data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmitProxy(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var form = (0,hooks_useForm__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        schema: validationSchema,
        onSubmit: onSubmitProxy,
        defaultValues: initialValues
    });
    var reset = form.reset, setWarningMessage = form.setWarningMessage;
    var onCancelClick = function() {
        onCancelClickCallback && onCancelClickCallback();
        toggle();
        reset();
        setWarningMessage('');
    };
    return {
        reset: reset,
        onCancelClick: onCancelClick,
        form: form
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useFormModal);


/***/ }),

/***/ 23632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useInvalidateQuestionnaires; }
/* harmony export */ });
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95601);
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88349);
/* harmony import */ var consts_sharedQueryKeys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37109);



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useInvalidateQuestionnaires() {
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQueryClient)();
    return _asyncToGenerator(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return queryClient.invalidateQueries({
                        predicate: function(query) {
                            return typeof query.queryKey[0] === 'string' && query.queryKey[0] === consts_sharedQueryKeys__WEBPACK_IMPORTED_MODULE_2__/* .questionnairesBaseQueryKey */ .iA;
                        }
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};


/***/ }),

/***/ 5330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);

var useModal = function() {
    var toggle = function toggle() {
        setIsShowing(!isShowing);
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isShowing = ref[0], setIsShowing = ref[1];
    return [
        isShowing,
        toggle
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (useModal);


/***/ }),

/***/ 82060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vQ": function() { return /* binding */ useQuestionnaireType; }
/* harmony export */ });
/* unused harmony export questionnairesTypes */
/* harmony import */ var _types_api_questionnaires_QuestionnaireKind__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35247);
/* harmony import */ var _types_api_questionnaires_QuestionnaireType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49676);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var questionnairesTypes = [
    {
        labelPlural: 'Item lists',
        labelSingular: 'Item list',
        type: _types_api_questionnaires_QuestionnaireType__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ITEM_LIST */ .Z.ITEM_LIST,
        isOfficial: false,
        isCustom: true
    },
    {
        labelPlural: 'Core questionnaires',
        labelSingular: 'Core questionnaire',
        type: _types_api_questionnaires_QuestionnaireType__WEBPACK_IMPORTED_MODULE_1__/* ["default"].CORE */ .Z.CORE,
        isOfficial: true,
        isCustom: false
    },
    {
        labelPlural: 'Modules',
        labelSingular: 'Module',
        type: _types_api_questionnaires_QuestionnaireType__WEBPACK_IMPORTED_MODULE_1__/* ["default"].MODULE */ .Z.MODULE,
        isOfficial: true,
        isCustom: true
    },
    {
        labelPlural: 'Standalone questionnaires',
        labelSingular: 'Standalone questionnaire',
        type: _types_api_questionnaires_QuestionnaireType__WEBPACK_IMPORTED_MODULE_1__/* ["default"].STANDALONE */ .Z.STANDALONE,
        isOfficial: true,
        isCustom: true
    },
    {
        labelPlural: 'Previous versions (questionnaires)',
        labelSingular: 'Previous versions (questionnaires)',
        type: _types_api_questionnaires_QuestionnaireType__WEBPACK_IMPORTED_MODULE_1__/* ["default"].PREVIOUS */ .Z.PREVIOUS,
        isOfficial: true,
        isCustom: false
    },
    {
        labelPlural: 'CAT',
        labelSingular: 'CAT',
        type: _types_api_questionnaires_QuestionnaireType__WEBPACK_IMPORTED_MODULE_1__/* ["default"].CAT */ .Z.CAT,
        isOfficial: true,
        isCustom: true
    },
    {
        labelPlural: 'CAT short forms',
        labelSingular: 'CAT short forms',
        type: _types_api_questionnaires_QuestionnaireType__WEBPACK_IMPORTED_MODULE_1__/* ["default"].CAT_SHORT */ .Z.CAT_SHORT,
        isOfficial: true,
        isCustom: false
    },
    {
        labelPlural: 'Short forms',
        labelSingular: 'Short form',
        type: _types_api_questionnaires_QuestionnaireType__WEBPACK_IMPORTED_MODULE_1__/* ["default"].SHORT_FORM */ .Z.SHORT_FORM,
        isOfficial: true,
        isCustom: false
    }, 
];
var officialQuestionnaireTypes = questionnairesTypes.filter(function(t) {
    return t.isOfficial;
});
var customQuestionnaireTypes = questionnairesTypes.filter(function(t) {
    return t.isCustom;
});
// Hard coded values
var questionnaireModulesTypes = [
    questionnairesTypes[1],
    questionnairesTypes[2],
    questionnairesTypes[3]
];
var useQuestionnaireTypes = function(isForQuestionnaireModules) {
    if (isForQuestionnaireModules) {
        var _obj;
        return {
            questionnaireTypesByKind: (_obj = {}, _defineProperty(_obj, _types_api_questionnaires_QuestionnaireKind__WEBPACK_IMPORTED_MODULE_0__/* ["default"].OFFICIAL */ .Z.OFFICIAL, questionnaireModulesTypes), _defineProperty(_obj, _types_api_questionnaires_QuestionnaireKind__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CUSTOM */ .Z.CUSTOM, questionnaireModulesTypes), _obj)
        };
    }
    var _obj1;
    return {
        questionnaireTypesByKind: (_obj1 = {}, _defineProperty(_obj1, _types_api_questionnaires_QuestionnaireKind__WEBPACK_IMPORTED_MODULE_0__/* ["default"].OFFICIAL */ .Z.OFFICIAL, officialQuestionnaireTypes), _defineProperty(_obj1, _types_api_questionnaires_QuestionnaireKind__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CUSTOM */ .Z.CUSTOM, customQuestionnaireTypes), _obj1)
    };
};
/* harmony default export */ __webpack_exports__["ZP"] = (useQuestionnaireTypes);
var useQuestionnaireType = function(type) {
    return type ? questionnairesTypes.find(function(qt) {
        return qt.type === type;
    }) : null;
};


/***/ }),

/***/ 97808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useUnexpectedError; }
/* harmony export */ });
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22164);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7997);
/* harmony import */ var hooks_useAlerts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96308);



function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var unexpectedErrorAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)(undefined);
function useUnexpectedError() {
    var addUnexpectedServerErrorAlert = (0,hooks_useAlerts__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)().addUnexpectedServerErrorAlert;
    var ref = _slicedToArray((0,jotai__WEBPACK_IMPORTED_MODULE_1__/* .useAtom */ .KO)(unexpectedErrorAtom, 'unexpectedError'), 2), lastError = ref[0], setUnexpectedError = ref[1];
    return {
        hasUnexpectedError: !!lastError,
        setUnexpectedError: function(newError) {
            var isUserAlreadyAlerted = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).isUserAlreadyAlerted;
            if (newError !== lastError) {
                setUnexpectedError(newError);
                _sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__/* .captureException */ .Tb(newError);
                if (!isUserAlreadyAlerted) {
                    addUnexpectedServerErrorAlert();
                }
            }
        }
    };
};


/***/ }),

/***/ 39955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useUserSession; }
});

// UNUSED EXPORTS: sessionAtom

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_n6febsnk4nq7zxsovmf65ymnxm/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(95601);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./node_modules/.pnpm/js-cookie@3.0.1/node_modules/js-cookie/dist/js.cookie.mjs
/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function js_cookie_assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (key, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = js_cookie_assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      key + '=' + converter.write(value, key) + stringifiedAttributes)
  }

  function get (key) {
    if (typeof document === 'undefined' || (arguments.length && !key)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (key, attributes) {
        set(
          key,
          '',
          js_cookie_assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, js_cookie_assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(js_cookie_assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */

/* harmony default export */ var js_cookie = (api);

;// CONCATENATED MODULE: ./src/consts/auth/accessTokenCookieName.ts
/* provided dependency */ var process = __webpack_require__(14224);
var accessTokenCookieName = process.env.NEXT_PUBLIC_COOKIES_TOKEN_NAME || 'token';
/* harmony default export */ var auth_accessTokenCookieName = (accessTokenCookieName);

// EXTERNAL MODULE: ./node_modules/.pnpm/jotai@1.6.1_zrsyqg6kfmuxkmxyjtbkl6ldiu/node_modules/jotai/esm/index.js
var esm = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/.pnpm/jotai@1.6.1_zrsyqg6kfmuxkmxyjtbkl6ldiu/node_modules/jotai/esm/immer.js + 1 modules
var immer = __webpack_require__(98499);
// EXTERNAL MODULE: ./node_modules/.pnpm/axios@0.24.0/node_modules/axios/index.js
var axios = __webpack_require__(10299);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/consts/api/apiBaseUrl.ts
var apiBaseUrl = __webpack_require__(83569);
// EXTERNAL MODULE: ./src/consts/paths/api/auth/token.ts
var token = __webpack_require__(93194);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/index.js
var es = __webpack_require__(88349);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_n6febsnk4nq7zxsovmf65ymnxm/node_modules/next/router.js
var next_router = __webpack_require__(63359);
;// CONCATENATED MODULE: ./src/hooks/useUserSession/index.ts










function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var apiUrl = "".concat(apiBaseUrl/* default */.Z).concat(token/* default */.Z);
var accessTokenFromCookie = js_cookie.get(auth_accessTokenCookieName);
var sessionAtom = (0,esm/* atom */.cn)({
    accessToken: accessTokenFromCookie,
    isAuthenticated: !!accessTokenFromCookie,
    isUnauthorized: false
});
function getAccessToken(username, password) {
    return _getAccessToken.apply(this, arguments);
}
function _getAccessToken() {
    _getAccessToken = _asyncToGenerator(runtime_default().mark(function _callee(username, password) {
        var bodyFormData, response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    bodyFormData = new URLSearchParams({
                        username: username,
                        password: password,
                        grant_type: 'password'
                    });
                    _ctx.next = 3;
                    return axios_default()({
                        method: 'post',
                        url: apiUrl,
                        data: bodyFormData.toString(),
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    });
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data.access_token);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getAccessToken.apply(this, arguments);
}
function removeAccessToken(userSession) {
    js_cookie.remove(auth_accessTokenCookieName);
    userSession.accessToken = null;
    userSession.isAuthenticated = false;
}
function useUserSession() {
    var ref = _slicedToArray((0,immer/* useImmerAtom */.It)(sessionAtom), 2), ref1 = ref[0], isAuthenticated = ref1.isAuthenticated, accessToken1 = ref1.accessToken, isUnauthorized = ref1.isUnauthorized, setUserSession = ref[1];
    var router = (0,next_router.useRouter)();
    var queryClient = (0,es.useQueryClient)();
    var logOn = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(username, password) {
            var accessToken;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getAccessToken(username, password);
                    case 2:
                        accessToken = _ctx.sent;
                        js_cookie.set(auth_accessTokenCookieName, accessToken);
                        setUserSession(function(userSession) {
                            userSession.isUnauthorized = false;
                            userSession.accessToken = accessToken;
                            userSession.isAuthenticated = true;
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function logOn(username, password) {
            return _ref.apply(this, arguments);
        };
    }();
    var logOut = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return router.replace('/', undefined, {
                            shallow: true
                        });
                    case 2:
                        setUserSession(function(userSession) {
                            removeAccessToken(userSession);
                        });
                        // clear react-query caches
                        queryClient.clear();
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function logOut() {
            return _ref.apply(this, arguments);
        };
    }();
    var invalidateAccessToken = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setUserSession(function(userSession) {
                            removeAccessToken(userSession);
                        });
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function invalidateAccessToken() {
            return _ref.apply(this, arguments);
        };
    }();
    var setIsAuthenticated = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(value) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setUserSession(function(userSession) {
                            userSession.isAuthenticated = value;
                        });
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function setIsAuthenticated(value) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        isAuthenticated: isAuthenticated,
        accessToken: accessToken1,
        isUnauthorized: isUnauthorized,
        logOn: logOn,
        logOut: logOut,
        invalidateAccessToken: invalidateAccessToken,
        setIsAuthenticated: setIsAuthenticated
    };
}
/* harmony default export */ var hooks_useUserSession = (useUserSession);


/***/ }),

/***/ 59116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50163);
/* harmony import */ var _footer_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73534);
/* harmony import */ var _footer_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_footer_module_scss__WEBPACK_IMPORTED_MODULE_1__);



var FooterBase = function(param) {
    var children = param.children;
    var items = [
        {
            link: 'https://www.eortc.org/',
            text: 'EORTC website',
            id: 0
        },
        {
            link: 'https://qol.eortc.org',
            text: 'EORTC Quality of Life Group',
            id: 1
        },
        {
            link: 'mailto:itemlibrary@eortc.org',
            text: 'Contact us',
            id: 2
        }, 
    ];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
        className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_1___default().footer),
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_1___default().navbar),
                children: items.map(function(item) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Item */ .Z.Item, {
                        className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_1___default().navitem),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Link */ .Z.Link, {
                            href: item.link,
                            children: item.text
                        })
                    }, item.id);
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FooterBase);


/***/ }),

/***/ 53787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Header_HeaderBase; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(28440);
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(19803);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/SelectableContext.js
var SelectableContext = __webpack_require__(77519);
// EXTERNAL MODULE: ./node_modules/.pnpm/uncontrollable@7.2.1_react@17.0.2/node_modules/uncontrollable/lib/esm/index.js + 4 modules
var esm = __webpack_require__(22084);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(91385);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(97902);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/NavbarBrand.js




const NavbarBrand = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  as,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'navbar-brand');
  const Component = as || (props.href ? 'a' : 'span');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, { ...props,
    ref: ref,
    className: classnames_default()(className, bsPrefix)
  });
});
NavbarBrand.displayName = 'NavbarBrand';
/* harmony default export */ var esm_NavbarBrand = (NavbarBrand);
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/css.js + 5 modules
var css = __webpack_require__(20968);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-transition-group@4.4.2_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-transition-group/esm/Transition.js + 2 modules
var Transition = __webpack_require__(72983);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/transitionEndListener.js
var transitionEndListener = __webpack_require__(72605);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/createChainedFunction.js
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction(...funcs) {
  return funcs.filter(f => f != null).reduce((acc, f) => {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) return f;
    return function chainedFunction(...args) {
      // @ts-ignore
      acc.apply(this, args); // @ts-ignore

      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ var esm_createChainedFunction = (createChainedFunction);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/triggerBrowserReflow.js
var triggerBrowserReflow = __webpack_require__(81194);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/TransitionWrapper.js
var TransitionWrapper = __webpack_require__(52309);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Collapse.js









const MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

function getDefaultDimensionValue(dimension, elem) {
  const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
  const value = elem[offset];
  const margins = MARGINS[dimension];
  return value + // @ts-ignore
  parseInt((0,css/* default */.Z)(elem, margins[0]), 10) + // @ts-ignore
  parseInt((0,css/* default */.Z)(elem, margins[1]), 10);
}

const collapseStyles = {
  [Transition/* EXITED */.Wj]: 'collapse',
  [Transition/* EXITING */.Ix]: 'collapsing',
  [Transition/* ENTERING */.d0]: 'collapsing',
  [Transition/* ENTERED */.cn]: 'collapse show'
};
const defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  getDimensionValue: getDefaultDimensionValue
};
const Collapse = /*#__PURE__*/react.forwardRef(({
  onEnter,
  onEntering,
  onEntered,
  onExit,
  onExiting,
  className,
  children,
  dimension = 'height',
  getDimensionValue = getDefaultDimensionValue,
  ...props
}, ref) => {
  /* Compute dimension */
  const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
  /* -- Expanding -- */

  const handleEnter = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = '0';
  }, onEnter), [computedDimension, onEnter]);
  const handleEntering = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
    elem.style[computedDimension] = `${elem[scroll]}px`;
  }, onEntering), [computedDimension, onEntering]);
  const handleEntered = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = null;
  }, onEntered), [computedDimension, onEntered]);
  /* -- Collapsing -- */

  const handleExit = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
    (0,triggerBrowserReflow/* default */.Z)(elem);
  }, onExit), [onExit, getDimensionValue, computedDimension]);
  const handleExiting = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = null;
  }, onExiting), [computedDimension, onExiting]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionWrapper/* default */.Z, {
    ref: ref,
    addEndListener: transitionEndListener/* default */.Z,
    ...props,
    "aria-expanded": props.role ? props.in : null,
    onEnter: handleEnter,
    onEntering: handleEntering,
    onEntered: handleEntered,
    onExit: handleExit,
    onExiting: handleExiting,
    childRef: children.ref,
    children: (state, innerProps) => /*#__PURE__*/react.cloneElement(children, { ...innerProps,
      className: classnames_default()(className, children.props.className, collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
    })
  });
}); // @ts-ignore

// @ts-ignore
Collapse.defaultProps = defaultProps;
/* harmony default export */ var esm_Collapse = (Collapse);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/NavbarContext.js
var NavbarContext = __webpack_require__(46674);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/NavbarCollapse.js






const NavbarCollapse = /*#__PURE__*/react.forwardRef(({
  children,
  bsPrefix,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'navbar-collapse');
  const context = (0,react.useContext)(NavbarContext/* default */.Z);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Collapse, {
    in: !!(context && context.expanded),
    ...props,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      ref: ref,
      className: bsPrefix,
      children: children
    })
  });
});
NavbarCollapse.displayName = 'NavbarCollapse';
/* harmony default export */ var esm_NavbarCollapse = (NavbarCollapse);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useEventCallback.js
var useEventCallback = __webpack_require__(61255);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/NavbarToggle.js







const NavbarToggle_defaultProps = {
  label: 'Toggle navigation'
};
const NavbarToggle = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  children,
  label,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'button',
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'navbar-toggler');
  const {
    onToggle,
    expanded
  } = (0,react.useContext)(NavbarContext/* default */.Z) || {};
  const handleClick = (0,useEventCallback/* default */.Z)(e => {
    if (onClick) onClick(e);
    if (onToggle) onToggle();
  });

  if (Component === 'button') {
    props.type = 'button';
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, { ...props,
    ref: ref,
    onClick: handleClick,
    "aria-label": label,
    className: classnames_default()(className, bsPrefix, !expanded && 'collapsed'),
    children: children || /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: `${bsPrefix}-icon`
    })
  });
});
NavbarToggle.displayName = 'NavbarToggle';
NavbarToggle.defaultProps = NavbarToggle_defaultProps;
/* harmony default export */ var esm_NavbarToggle = (NavbarToggle);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/Modal.js + 1 modules
var Modal = __webpack_require__(42902);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Fade.js
var Fade = __webpack_require__(94542);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/OffcanvasBody.js

/* harmony default export */ var OffcanvasBody = ((0,createWithBsPrefix/* default */.Z)('offcanvas-body'));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/OffcanvasToggling.js







const OffcanvasToggling_defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
const transitionStyles = {
  [Transition/* ENTERING */.d0]: 'show',
  [Transition/* ENTERED */.cn]: 'show'
};
const OffcanvasToggling = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  children,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'offcanvas');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionWrapper/* default */.Z, {
    ref: ref,
    addEndListener: transitionEndListener/* default */.Z,
    ...props,
    childRef: children.ref,
    children: (status, innerProps) => /*#__PURE__*/react.cloneElement(children, { ...innerProps,
      className: classnames_default()(className, children.props.className, (status === Transition/* ENTERING */.d0 || status === Transition/* EXITING */.Ix) && `${bsPrefix}-toggling`, transitionStyles[status])
    })
  });
});
OffcanvasToggling.defaultProps = OffcanvasToggling_defaultProps;
OffcanvasToggling.displayName = 'OffcanvasToggling';
/* harmony default export */ var esm_OffcanvasToggling = (OffcanvasToggling);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/ModalContext.js
var ModalContext = __webpack_require__(1445);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/AbstractModalHeader.js
var AbstractModalHeader = __webpack_require__(76557);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/OffcanvasHeader.js





const OffcanvasHeader_defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};
const OffcanvasHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'offcanvas-header');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AbstractModalHeader/* default */.Z, {
    ref: ref,
    ...props,
    className: classnames_default()(className, bsPrefix)
  });
});
OffcanvasHeader.displayName = 'OffcanvasHeader';
OffcanvasHeader.defaultProps = OffcanvasHeader_defaultProps;
/* harmony default export */ var esm_OffcanvasHeader = (OffcanvasHeader);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/divWithClassName.js
var divWithClassName = __webpack_require__(57024);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/OffcanvasTitle.js


const DivStyledAsH5 = (0,divWithClassName/* default */.Z)('h5');
/* harmony default export */ var OffcanvasTitle = ((0,createWithBsPrefix/* default */.Z)('offcanvas-title', {
  Component: DivStyledAsH5
}));
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/BootstrapModalManager.js + 2 modules
var BootstrapModalManager = __webpack_require__(25047);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Offcanvas.js















const Offcanvas_defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  scroll: false,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  placement: 'start'
};

function DialogTransition(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_OffcanvasToggling, { ...props
  });
}

function BackdropTransition(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Fade/* default */.Z, { ...props
  });
}

const Offcanvas = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  children,
  'aria-labelledby': ariaLabelledby,
  placement,

  /* BaseModal props */
  show,
  backdrop,
  keyboard,
  scroll,
  onEscapeKeyDown,
  onShow,
  onHide,
  container,
  autoFocus,
  enforceFocus,
  restoreFocus,
  restoreFocusOptions,
  onEntered,
  onExit,
  onExiting,
  onEnter,
  onEntering,
  onExited,
  backdropClassName,
  manager: propsManager,
  ...props
}, ref) => {
  const modalManager = (0,react.useRef)();
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'offcanvas');
  const {
    onToggle
  } = (0,react.useContext)(NavbarContext/* default */.Z) || {};
  const handleHide = (0,useEventCallback/* default */.Z)(() => {
    onToggle == null ? void 0 : onToggle();
    onHide == null ? void 0 : onHide();
  });
  const modalContext = (0,react.useMemo)(() => ({
    onHide: handleHide
  }), [handleHide]);

  function getModalManager() {
    if (propsManager) return propsManager;

    if (scroll) {
      // Have to use a different modal manager since the shared
      // one handles overflow.
      if (!modalManager.current) modalManager.current = new BootstrapModalManager/* default */.Z({
        handleContainerOverflow: false
      });
      return modalManager.current;
    }

    return (0,BootstrapModalManager/* getSharedManager */.t)();
  }

  const handleEnter = (node, ...args) => {
    if (node) node.style.visibility = 'visible';
    onEnter == null ? void 0 : onEnter(node, ...args);
  };

  const handleExited = (node, ...args) => {
    if (node) node.style.visibility = '';
    onExited == null ? void 0 : onExited(...args);
  };

  const renderBackdrop = (0,react.useCallback)(backdropProps => /*#__PURE__*/(0,jsx_runtime.jsx)("div", { ...backdropProps,
    className: classnames_default()(`${bsPrefix}-backdrop`, backdropClassName)
  }), [backdropClassName, bsPrefix]);

  const renderDialog = dialogProps => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    role: "dialog",
    ...dialogProps,
    ...props,
    className: classnames_default()(className, bsPrefix, `${bsPrefix}-${placement}`),
    "aria-labelledby": ariaLabelledby,
    children: children
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ModalContext/* default.Provider */.Z.Provider, {
    value: modalContext,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      show: show,
      ref: ref,
      backdrop: backdrop,
      container: container,
      keyboard: keyboard,
      autoFocus: autoFocus,
      enforceFocus: enforceFocus && !scroll,
      restoreFocus: restoreFocus,
      restoreFocusOptions: restoreFocusOptions,
      onEscapeKeyDown: onEscapeKeyDown,
      onShow: onShow,
      onHide: handleHide,
      onEnter: handleEnter,
      onEntering: onEntering,
      onEntered: onEntered,
      onExit: onExit,
      onExiting: onExiting,
      onExited: handleExited,
      manager: getModalManager(),
      transition: DialogTransition,
      backdropTransition: BackdropTransition,
      renderBackdrop: renderBackdrop,
      renderDialog: renderDialog
    })
  });
});
Offcanvas.displayName = 'Offcanvas';
Offcanvas.defaultProps = Offcanvas_defaultProps;
/* harmony default export */ var esm_Offcanvas = (Object.assign(Offcanvas, {
  Body: OffcanvasBody,
  Header: esm_OffcanvasHeader,
  Title: OffcanvasTitle
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/NavbarOffcanvas.js





const NavbarOffcanvas = /*#__PURE__*/react.forwardRef((props, ref) => {
  const context = (0,react.useContext)(NavbarContext/* default */.Z);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Offcanvas, {
    ref: ref,
    show: !!(context != null && context.expanded),
    ...props
  });
});
NavbarOffcanvas.displayName = 'NavbarOffcanvas';
/* harmony default export */ var esm_NavbarOffcanvas = (NavbarOffcanvas);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Navbar.js













const NavbarText = (0,createWithBsPrefix/* default */.Z)('navbar-text', {
  Component: 'span'
});
const Navbar_defaultProps = {
  expand: true,
  variant: 'light',
  collapseOnSelect: false
};
const Navbar = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    bsPrefix: initialBsPrefix,
    expand,
    variant,
    bg,
    fixed,
    sticky,
    className,
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'nav',
    expanded,
    onToggle,
    onSelect,
    collapseOnSelect,
    ...controlledProps
  } = (0,esm/* useUncontrolled */.Ch)(props, {
    expanded: 'onToggle'
  });
  const bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(initialBsPrefix, 'navbar');
  const handleCollapse = (0,react.useCallback)((...args) => {
    onSelect == null ? void 0 : onSelect(...args);

    if (collapseOnSelect && expanded) {
      onToggle == null ? void 0 : onToggle(false);
    }
  }, [onSelect, collapseOnSelect, expanded, onToggle]); // will result in some false positives but that seems better
  // than false negatives. strict `undefined` check allows explicit
  // "nulling" of the role if the user really doesn't want one

  if (controlledProps.role === undefined && Component !== 'nav') {
    controlledProps.role = 'navigation';
  }

  let expandClass = `${bsPrefix}-expand`;
  if (typeof expand === 'string') expandClass = `${expandClass}-${expand}`;
  const navbarContext = (0,react.useMemo)(() => ({
    onToggle: () => onToggle == null ? void 0 : onToggle(!expanded),
    bsPrefix,
    expanded: !!expanded
  }), [bsPrefix, expanded, onToggle]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(NavbarContext/* default.Provider */.Z.Provider, {
    value: navbarContext,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(SelectableContext/* default.Provider */.Z.Provider, {
      value: handleCollapse,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
        ref: ref,
        ...controlledProps,
        className: classnames_default()(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
      })
    })
  });
});
Navbar.defaultProps = Navbar_defaultProps;
Navbar.displayName = 'Navbar';
/* harmony default export */ var esm_Navbar = (Object.assign(Navbar, {
  Brand: esm_NavbarBrand,
  Collapse: esm_NavbarCollapse,
  Offcanvas: esm_NavbarOffcanvas,
  Text: NavbarText,
  Toggle: esm_NavbarToggle
}));
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_n6febsnk4nq7zxsovmf65ymnxm/node_modules/next/link.js
var next_link = __webpack_require__(70462);
// EXTERNAL MODULE: ./src/layout/Header/HeaderBase/HeaderBase.module.scss
var HeaderBase_module = __webpack_require__(99283);
var HeaderBase_module_default = /*#__PURE__*/__webpack_require__.n(HeaderBase_module);
;// CONCATENATED MODULE: ./src/layout/Header/HeaderBase/logo.png
/* harmony default export */ var logo = ({"src":"/_next/static/media/logo.6e669d32.png","height":28,"width":116,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAQAAADPnVVmAAAALElEQVR42mP4t+9f1T//f17/cv5l/Ev858jw78a/Wf98/7n+S/oX/s/jnw0AixYWad1Q1oMAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/layout/Header/HeaderBase/index.tsx






function HeaderBase(param) {
    var children = param.children;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Navbar, {
        expand: "lg",
        variant: "light",
        bg: "light",
        className: (HeaderBase_module_default()).example,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: "/",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Navbar.Brand, {
                        className: (HeaderBase_module_default()).logoWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: logo.src,
                                alt: "EORTC logo",
                                width: "116px",
                                height: "28px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (HeaderBase_module_default()).title,
                                children: "Item Library"
                            })
                        ]
                    })
                }),
                children
            ]
        })
    }));
}
/* harmony default export */ var Header_HeaderBase = (HeaderBase);


/***/ }),

/***/ 20298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout_LoggedOutLayout; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./src/layout/Header/HeaderBase/index.tsx + 13 modules
var HeaderBase = __webpack_require__(53787);
;// CONCATENATED MODULE: ./src/layout/Header/LoggedOutHeader/index.tsx


var LoggedOutHeader = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(HeaderBase/* default */.Z, {});
};
/* harmony default export */ var Header_LoggedOutHeader = (LoggedOutHeader);

// EXTERNAL MODULE: ./src/layout/Footer/Base/index.tsx
var Base = __webpack_require__(59116);
// EXTERNAL MODULE: ./src/components/_errors/ErrorBoundary/index.tsx + 32 modules
var ErrorBoundary = __webpack_require__(70359);
;// CONCATENATED MODULE: ./src/layout/Layout/LoggedOutLayout/index.tsx




var LoggedOutLayout = function(param) {
    var children = param.children;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_LoggedOutHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Base/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var Layout_LoggedOutLayout = (LoggedOutLayout);


/***/ }),

/***/ 65599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* binding */ worker; }
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/msw@0.35.0/node_modules/msw/lib/esm/fetch-deps.js
/* provided dependency */ var process = __webpack_require__(14224);
var statuses = {
	"100": "Continue",
	"101": "Switching Protocols",
	"102": "Processing",
	"103": "Early Hints",
	"200": "OK",
	"201": "Created",
	"202": "Accepted",
	"203": "Non-Authoritative Information",
	"204": "No Content",
	"205": "Reset Content",
	"206": "Partial Content",
	"207": "Multi-Status",
	"208": "Already Reported",
	"226": "IM Used",
	"300": "Multiple Choices",
	"301": "Moved Permanently",
	"302": "Found",
	"303": "See Other",
	"304": "Not Modified",
	"305": "Use Proxy",
	"307": "Temporary Redirect",
	"308": "Permanent Redirect",
	"400": "Bad Request",
	"401": "Unauthorized",
	"402": "Payment Required",
	"403": "Forbidden",
	"404": "Not Found",
	"405": "Method Not Allowed",
	"406": "Not Acceptable",
	"407": "Proxy Authentication Required",
	"408": "Request Timeout",
	"409": "Conflict",
	"410": "Gone",
	"411": "Length Required",
	"412": "Precondition Failed",
	"413": "Payload Too Large",
	"414": "URI Too Long",
	"415": "Unsupported Media Type",
	"416": "Range Not Satisfiable",
	"417": "Expectation Failed",
	"418": "I'm a Teapot",
	"421": "Misdirected Request",
	"422": "Unprocessable Entity",
	"423": "Locked",
	"424": "Failed Dependency",
	"425": "Too Early",
	"426": "Upgrade Required",
	"428": "Precondition Required",
	"429": "Too Many Requests",
	"431": "Request Header Fields Too Large",
	"451": "Unavailable For Legal Reasons",
	"500": "Internal Server Error",
	"501": "Not Implemented",
	"502": "Bad Gateway",
	"503": "Service Unavailable",
	"504": "Gateway Timeout",
	"505": "HTTP Version Not Supported",
	"506": "Variant Also Negotiates",
	"507": "Insufficient Storage",
	"508": "Loop Detected",
	"509": "Bandwidth Limit Exceeded",
	"510": "Not Extended",
	"511": "Network Authentication Required"
};

/**
 * Sets a response status code and text.
 * @example
 * res(ctx.status(301))
 * res(ctx.status(400, 'Custom status text'))
 * @see {@link https://mswjs.io/docs/api/context/status `ctx.status()`}
 */
const fetch_deps_status = (statusCode, statusText) => {
    return (res) => {
        res.status = statusCode;
        res.statusText =
            statusText || statuses[String(statusCode)];
        return res;
    };
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

var lib$1 = {};

var Headers = {};

var normalizeHeaderName$1 = {};

Object.defineProperty(normalizeHeaderName$1, "__esModule", { value: true });
normalizeHeaderName$1.normalizeHeaderName = void 0;
var HEADERS_INVALID_CHARACTERS = /[^a-z0-9\-#$%&'*+.^_`|~]/i;
function normalizeHeaderName(name) {
    if (typeof name !== 'string') {
        name = String(name);
    }
    if (HEADERS_INVALID_CHARACTERS.test(name) || name.trim() === '') {
        throw new TypeError('Invalid character in header field name');
    }
    return name.toLowerCase();
}
normalizeHeaderName$1.normalizeHeaderName = normalizeHeaderName;

var normalizeHeaderValue$1 = {};

Object.defineProperty(normalizeHeaderValue$1, "__esModule", { value: true });
normalizeHeaderValue$1.normalizeHeaderValue = void 0;
function normalizeHeaderValue(value) {
    if (typeof value !== 'string') {
        value = String(value);
    }
    return value;
}
normalizeHeaderValue$1.normalizeHeaderValue = normalizeHeaderValue;

var __generator = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read$3 = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (commonjsGlobal && commonjsGlobal.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(Headers, "__esModule", { value: true });
var normalizeHeaderName_1 = normalizeHeaderName$1;
var normalizeHeaderValue_1 = normalizeHeaderValue$1;
var HeadersPolyfill = /** @class */ (function () {
    function HeadersPolyfill(init) {
        var _this = this;
        // Normalized header {"name":"a, b"} storage.
        this._headers = {};
        // Keeps the mapping between the raw header name
        // and the normalized header name to ease the lookup.
        this._names = new Map();
        /**
         * @note Cannot check if the `init` is an instance of the `Headers`
         * because that class is only defined in the browser.
         */
        if (['Headers', 'HeadersPolyfill'].includes(init === null || init === void 0 ? void 0 : init.constructor.name) ||
            init instanceof HeadersPolyfill) {
            var initialHeaders = init;
            initialHeaders.forEach(function (value, name) {
                _this.append(name, value);
            }, this);
        }
        else if (Array.isArray(init)) {
            init.forEach(function (_a) {
                var _b = __read$3(_a, 2), name = _b[0], value = _b[1];
                _this.append(name, Array.isArray(value) ? value.join(', ') : value);
            });
        }
        else if (init) {
            Object.getOwnPropertyNames(init).forEach(function (name) {
                var value = init[name];
                _this.append(name, Array.isArray(value) ? value.join(', ') : value);
            });
        }
    }
    HeadersPolyfill.prototype[Symbol.iterator] = function () {
        return this.entries();
    };
    HeadersPolyfill.prototype.keys = function () {
        var _a, _b, name_1, e_1_1;
        var e_1, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 5, 6, 7]);
                    _a = __values(Object.keys(this._headers)), _b = _a.next();
                    _d.label = 1;
                case 1:
                    if (!!_b.done) return [3 /*break*/, 4];
                    name_1 = _b.value;
                    return [4 /*yield*/, name_1];
                case 2:
                    _d.sent();
                    _d.label = 3;
                case 3:
                    _b = _a.next();
                    return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 7];
                case 5:
                    e_1_1 = _d.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 7];
                case 6:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    };
    HeadersPolyfill.prototype.values = function () {
        var _a, _b, value, e_2_1;
        var e_2, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 5, 6, 7]);
                    _a = __values(Object.values(this._headers)), _b = _a.next();
                    _d.label = 1;
                case 1:
                    if (!!_b.done) return [3 /*break*/, 4];
                    value = _b.value;
                    return [4 /*yield*/, value];
                case 2:
                    _d.sent();
                    _d.label = 3;
                case 3:
                    _b = _a.next();
                    return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 7];
                case 5:
                    e_2_1 = _d.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 7];
                case 6:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    };
    HeadersPolyfill.prototype.entries = function () {
        var _a, _b, name_2, e_3_1;
        var e_3, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 5, 6, 7]);
                    _a = __values(Object.keys(this._headers)), _b = _a.next();
                    _d.label = 1;
                case 1:
                    if (!!_b.done) return [3 /*break*/, 4];
                    name_2 = _b.value;
                    return [4 /*yield*/, [name_2, this.get(name_2)]];
                case 2:
                    _d.sent();
                    _d.label = 3;
                case 3:
                    _b = _a.next();
                    return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 7];
                case 5:
                    e_3_1 = _d.sent();
                    e_3 = { error: e_3_1 };
                    return [3 /*break*/, 7];
                case 6:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_3) throw e_3.error; }
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    };
    /**
     * Returns a `ByteString` sequence of all the values of a header with a given name.
     */
    HeadersPolyfill.prototype.get = function (name) {
        return this._headers[normalizeHeaderName_1.normalizeHeaderName(name)] || null;
    };
    /**
     * Sets a new value for an existing header inside a `Headers` object, or adds the header if it does not already exist.
     */
    HeadersPolyfill.prototype.set = function (name, value) {
        var normalizedName = normalizeHeaderName_1.normalizeHeaderName(name);
        this._headers[normalizedName] = normalizeHeaderValue_1.normalizeHeaderValue(value);
        this._names.set(normalizedName, name);
    };
    /**
     * Appends a new value onto an existing header inside a `Headers` object, or adds the header if it does not already exist.
     */
    HeadersPolyfill.prototype.append = function (name, value) {
        var resolvedValue = this.has(name) ? this.get(name) + ", " + value : value;
        this.set(name, resolvedValue);
    };
    /**
     * Deletes a header from the `Headers` object.
     */
    HeadersPolyfill.prototype.delete = function (name) {
        if (!this.has(name)) {
            return this;
        }
        var normalizedName = normalizeHeaderName_1.normalizeHeaderName(name);
        delete this._headers[normalizedName];
        this._names.delete(normalizedName);
        return this;
    };
    /**
     * Returns the object of all the normalized headers.
     */
    HeadersPolyfill.prototype.all = function () {
        return this._headers;
    };
    /**
     * Returns the object of all the raw headers.
     */
    HeadersPolyfill.prototype.raw = function () {
        var _this = this;
        return Object.entries(this._headers).reduce(function (headers, _a) {
            var _b = __read$3(_a, 2), name = _b[0], value = _b[1];
            headers[_this._names.get(name)] = value;
            return headers;
        }, {});
    };
    /**
     * Returns a boolean stating whether a `Headers` object contains a certain header.
     */
    HeadersPolyfill.prototype.has = function (name) {
        return this._headers.hasOwnProperty(normalizeHeaderName_1.normalizeHeaderName(name));
    };
    /**
     * Traverses the `Headers` object,
     * calling the given callback for each header.
     */
    HeadersPolyfill.prototype.forEach = function (callback, thisArg) {
        for (var name_3 in this._headers) {
            if (this._headers.hasOwnProperty(name_3)) {
                callback.call(thisArg, this._headers[name_3], name_3, this);
            }
        }
    };
    return HeadersPolyfill;
}());
Headers.default = HeadersPolyfill;

var headersToString$1 = {};

var headersToList$1 = {};

Object.defineProperty(headersToList$1, "__esModule", { value: true });
headersToList$1.headersToList = void 0;
function headersToList(headers) {
    var headersList = [];
    headers.forEach(function (value, name) {
        var resolvedValue = value.includes(',')
            ? value.split(',').map(function (value) { return value.trim(); })
            : value;
        headersList.push([name, resolvedValue]);
    });
    return headersList;
}
headersToList$1.headersToList = headersToList;

var __read$2 = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(headersToString$1, "__esModule", { value: true });
headersToString$1.headersToString = void 0;
var headersToList_1 = headersToList$1;
/**
 * Converts a given `Headers` instance to its string representation.
 */
function headersToString(headers) {
    var list = headersToList_1.headersToList(headers);
    var lines = list.map(function (_a) {
        var _b = __read$2(_a, 2), name = _b[0], value = _b[1];
        var values = [].concat(value);
        return name + ": " + values.join(', ');
    });
    return lines.join('\r\n');
}
headersToString$1.headersToString = headersToString;

var headersToObject$1 = {};

Object.defineProperty(headersToObject$1, "__esModule", { value: true });
headersToObject$1.headersToObject = void 0;
// List of headers that cannot have multiple values,
// while potentially having a comma in their single value.
var singleValueHeaders = ['user-agent'];
/**
 * Converts a given `Headers` instance into a plain object.
 * Respects headers with multiple values.
 */
function headersToObject(headers) {
    var headersObject = {};
    headers.forEach(function (value, name) {
        var isMultiValue = !singleValueHeaders.includes(name.toLowerCase()) && value.includes(',');
        headersObject[name] = isMultiValue
            ? value.split(',').map(function (s) { return s.trim(); })
            : value;
    });
    return headersObject;
}
headersToObject$1.headersToObject = headersToObject;

var stringToHeaders$1 = {};

Object.defineProperty(stringToHeaders$1, "__esModule", { value: true });
stringToHeaders$1.stringToHeaders = void 0;
var Headers_1$2 = Headers;
/**
 * Converts a string representation of headers (i.e. from XMLHttpRequest)
 * to a new `Headers` instance.
 */
function stringToHeaders(str) {
    var lines = str.trim().split(/[\r\n]+/);
    return lines.reduce(function (headers, line) {
        var parts = line.split(': ');
        var name = parts.shift();
        var value = parts.join(': ');
        headers.append(name, value);
        return headers;
    }, new Headers_1$2.default());
}
stringToHeaders$1.stringToHeaders = stringToHeaders;

var listToHeaders$1 = {};

var __read$1 = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(listToHeaders$1, "__esModule", { value: true });
listToHeaders$1.listToHeaders = void 0;
var Headers_1$1 = Headers;
function listToHeaders(list) {
    var headers = new Headers_1$1.default();
    list.forEach(function (_a) {
        var _b = __read$1(_a, 2), name = _b[0], value = _b[1];
        var values = [].concat(value);
        values.forEach(function (value) {
            headers.append(name, value);
        });
    });
    return headers;
}
listToHeaders$1.listToHeaders = listToHeaders;

var objectToHeaders$1 = {};

var reduceHeadersObject$1 = {};

Object.defineProperty(reduceHeadersObject$1, "__esModule", { value: true });
reduceHeadersObject$1.reduceHeadersObject = void 0;
/**
 * Reduces given headers object instnace.
 */
function reduceHeadersObject(headers, reducer, initialState) {
    return Object.keys(headers).reduce(function (nextHeaders, name) {
        return reducer(nextHeaders, name, headers[name]);
    }, initialState);
}
reduceHeadersObject$1.reduceHeadersObject = reduceHeadersObject;

Object.defineProperty(objectToHeaders$1, "__esModule", { value: true });
objectToHeaders$1.objectToHeaders = void 0;
var Headers_1 = Headers;
var reduceHeadersObject_1$1 = reduceHeadersObject$1;
/**
 * Converts a given headers object to a new `Headers` instance.
 */
function objectToHeaders(headersObject) {
    return reduceHeadersObject_1$1.reduceHeadersObject(headersObject, function (headers, name, value) {
        var values = [].concat(value).filter(Boolean);
        values.forEach(function (value) {
            headers.append(name, value);
        });
        return headers;
    }, new Headers_1.default());
}
objectToHeaders$1.objectToHeaders = objectToHeaders;

var flattenHeadersList$1 = {};

var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(flattenHeadersList$1, "__esModule", { value: true });
flattenHeadersList$1.flattenHeadersList = void 0;
function flattenHeadersList(list) {
    return list.map(function (_a) {
        var _b = __read(_a, 2), name = _b[0], values = _b[1];
        return [name, [].concat(values).join('; ')];
    });
}
flattenHeadersList$1.flattenHeadersList = flattenHeadersList;

var flattenHeadersObject$1 = {};

Object.defineProperty(flattenHeadersObject$1, "__esModule", { value: true });
flattenHeadersObject$1.flattenHeadersObject = void 0;
var reduceHeadersObject_1 = reduceHeadersObject$1;
function flattenHeadersObject(headersObject) {
    return reduceHeadersObject_1.reduceHeadersObject(headersObject, function (headers, name, value) {
        headers[name] = [].concat(value).join('; ');
        return headers;
    }, {});
}
flattenHeadersObject$1.flattenHeadersObject = flattenHeadersObject;

(function (exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenHeadersObject = exports.flattenHeadersList = exports.reduceHeadersObject = exports.objectToHeaders = exports.listToHeaders = exports.stringToHeaders = exports.headersToObject = exports.headersToList = exports.headersToString = exports.Headers = void 0;
var Headers_1 = Headers;
Object.defineProperty(exports, "Headers", { enumerable: true, get: function () { return Headers_1.default; } });
var headersToString_1 = headersToString$1;
Object.defineProperty(exports, "headersToString", { enumerable: true, get: function () { return headersToString_1.headersToString; } });
var headersToList_1 = headersToList$1;
Object.defineProperty(exports, "headersToList", { enumerable: true, get: function () { return headersToList_1.headersToList; } });
var headersToObject_1 = headersToObject$1;
Object.defineProperty(exports, "headersToObject", { enumerable: true, get: function () { return headersToObject_1.headersToObject; } });
var stringToHeaders_1 = stringToHeaders$1;
Object.defineProperty(exports, "stringToHeaders", { enumerable: true, get: function () { return stringToHeaders_1.stringToHeaders; } });
var listToHeaders_1 = listToHeaders$1;
Object.defineProperty(exports, "listToHeaders", { enumerable: true, get: function () { return listToHeaders_1.listToHeaders; } });
var objectToHeaders_1 = objectToHeaders$1;
Object.defineProperty(exports, "objectToHeaders", { enumerable: true, get: function () { return objectToHeaders_1.objectToHeaders; } });
var reduceHeadersObject_1 = reduceHeadersObject$1;
Object.defineProperty(exports, "reduceHeadersObject", { enumerable: true, get: function () { return reduceHeadersObject_1.reduceHeadersObject; } });
var flattenHeadersList_1 = flattenHeadersList$1;
Object.defineProperty(exports, "flattenHeadersList", { enumerable: true, get: function () { return flattenHeadersList_1.flattenHeadersList; } });
var flattenHeadersObject_1 = flattenHeadersObject$1;
Object.defineProperty(exports, "flattenHeadersObject", { enumerable: true, get: function () { return flattenHeadersObject_1.flattenHeadersObject; } });
}(lib$1));

/**
 * Sets one or multiple response headers.
 * @example
 * ctx.set('Content-Type', 'text/plain')
 * ctx.set({
 *   'Accept': 'application/javascript',
 *   'Content-Type': "text/plain"
 * })
 * @see {@link https://mswjs.io/docs/api/context/set `ctx.set()`}
 */
function set(...args) {
    return (res) => {
        const [name, value] = args;
        if (typeof name === 'string') {
            res.headers.append(name, value);
        }
        else {
            const headers = lib$1.objectToHeaders(name);
            headers.forEach((value, name) => {
                res.headers.append(name, value);
            });
        }
        return res;
    };
}

/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */

/**
 * Module exports.
 * @public
 */

var parse_1 = parse;
var serialize_1 = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {};
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim();
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}

/**
 * Sets a given cookie on the mocked response.
 * @example res(ctx.cookie('name', 'value'))
 */
const cookie = (name, value, options) => {
    return (res) => {
        const serializedCookie = serialize_1(name, value, options);
        res.headers.set('Set-Cookie', serializedCookie);
        if (typeof document !== 'undefined') {
            document.cookie = serializedCookie;
        }
        return res;
    };
};

/**
 * Parses a given string into a JSON.
 * Does not throw an exception on an invalid JSON string.
 */
function jsonParse(str) {
    try {
        return JSON.parse(str);
    }
    catch (error) {
        return undefined;
    }
}

/**
 * Sets the given value as the JSON body of the response.
 * Appends a `Content-Type: application/json` header on the
 * mocked response.
 * @example
 * res(ctx.json('Some string'))
 * res(ctx.json({ key: 'value' }))
 * res(ctx.json([1, '2', false, { ok: true }]))
 * @see {@link https://mswjs.io/docs/api/context/json `ctx.json()`}
 */
const json = (body) => {
    return (res) => {
        res.headers.set('Content-Type', 'application/json');
        res.body = JSON.stringify(body);
        return res;
    };
};

var lib = {exports: {}};

(function (module, exports) {
(function (global, factory) {
  factory(exports) ;
}(commonjsGlobal, (function (exports) {
  /**
   * Determines if the current process is a Node.js process.
   */
  function isNodeProcess() {
      if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
          return true;
      }
      return !!(typeof process !== 'undefined' &&
          process.versions &&
          process.versions.node);
  }

  exports.isNodeProcess = isNodeProcess;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
}(lib, lib.exports));

const SET_TIMEOUT_MAX_ALLOWED_INT = 2147483647;
const MIN_SERVER_RESPONSE_TIME = 100;
const MAX_SERVER_RESPONSE_TIME = 400;
const NODE_SERVER_RESPONSE_TIME = 5;
const getRandomServerResponseTime = () => {
    if (lib.exports.isNodeProcess()) {
        return NODE_SERVER_RESPONSE_TIME;
    }
    return Math.floor(Math.random() * (MAX_SERVER_RESPONSE_TIME - MIN_SERVER_RESPONSE_TIME) +
        MIN_SERVER_RESPONSE_TIME);
};
/**
 * Delays the response by the given duration (ms).
 * @example
 * res(ctx.delay(1200)) // delay response by 1200ms
 * res(ctx.delay()) // emulate realistic server response time
 * res(ctx.delay('infinite')) // delay response infinitely
 * @see {@link https://mswjs.io/docs/api/context/delay `ctx.delay()`}
 */
const delay = (durationOrMode) => {
    return (res) => {
        let delayTime;
        if (typeof durationOrMode === 'string') {
            switch (durationOrMode) {
                case 'infinite': {
                    // Using `Infinity` as a delay value executes the response timeout immediately.
                    // Instead, use the maximum allowed integer for `setTimeout`.
                    delayTime = SET_TIMEOUT_MAX_ALLOWED_INT;
                    break;
                }
                case 'real': {
                    delayTime = getRandomServerResponseTime();
                    break;
                }
                default: {
                    throw new Error(`Failed to delay a response: unknown delay mode "${durationOrMode}". Please make sure you provide one of the supported modes ("real", "infinite") or a number to "ctx.delay".`);
                }
            }
        }
        else if (typeof durationOrMode === 'undefined') {
            // Use random realistic server response time when no explicit delay duration was provided.
            delayTime = getRandomServerResponseTime();
        }
        else {
            // Guard against passing values like `Infinity` or `Number.MAX_VALUE`
            // as the response delay duration. They don't produce the result you may expect.
            if (durationOrMode > SET_TIMEOUT_MAX_ALLOWED_INT) {
                throw new Error(`Failed to delay a response: provided delay duration (${durationOrMode}) exceeds the maximum allowed duration for "setTimeout" (${SET_TIMEOUT_MAX_ALLOWED_INT}). This will cause the response to be returned immediately. Please use a number within the allowed range to delay the response by exact duration, or consider the "infinite" delay mode to delay the response indefinitely.`);
            }
            delayTime = durationOrMode;
        }
        res.delay = delayTime;
        return res;
    };
};

const useFetch = lib.exports.isNodeProcess() ? __webpack_require__(16444) : window.fetch;
const augmentRequestInit = (requestInit) => {
    const headers = new lib$1.Headers(requestInit.headers);
    headers.set('x-msw-bypass', 'true');
    return Object.assign(Object.assign({}, requestInit), { headers: headers.all() });
};
const createFetchRequestParameters = (input) => {
    const { body, method } = input;
    const requestParameters = Object.assign(Object.assign({}, input), { body: undefined });
    if (['GET', 'HEAD'].includes(method)) {
        return requestParameters;
    }
    requestParameters.body =
        typeof body === 'object' ? JSON.stringify(body) : body;
    return requestParameters;
};
/**
 * Performs a bypassed request inside a request handler.
 * @example
 * const originalResponse = await ctx.fetch(req)
 * @see {@link https://mswjs.io/docs/api/context/fetch `ctx.fetch()`}
 */
const fetch = (input, requestInit = {}) => {
    if (typeof input === 'string') {
        return useFetch(input, augmentRequestInit(requestInit));
    }
    const requestParameters = createFetchRequestParameters(input);
    const derivedRequestInit = augmentRequestInit(requestParameters);
    return useFetch(input.url.href, derivedRequestInit);
};



;// CONCATENATED MODULE: ./node_modules/.pnpm/msw@0.35.0/node_modules/msw/lib/esm/RequestHandler-deps.js


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

var RequestHandler_deps_lib = {};

var invariant$1 = {};

var format$1 = {};

Object.defineProperty(format$1, "__esModule", { value: true });
format$1.format = void 0;
var POSITIONALS_EXP = /(%?)(%([sdjo]))/g;
function serializePositional(positional, flag) {
    switch (flag) {
        // Strings.
        case 's':
            return positional;
        // Digits.
        case 'd':
        case 'i':
            return Number(positional);
        // JSON.
        case 'j':
            return JSON.stringify(positional);
        // Objects.
        case 'o': {
            // Preserve stings to prevent extra quotes around them.
            if (typeof positional === 'string') {
                return positional;
            }
            var json = JSON.stringify(positional);
            // If the positional isn't serializable, return it as-is.
            if (json === '{}' || json === '[]' || /^\[object .+?\]$/.test(json)) {
                return positional;
            }
            return json;
        }
    }
}
function format(message) {
    var positionals = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positionals[_i - 1] = arguments[_i];
    }
    if (positionals.length === 0) {
        return message;
    }
    var positionalIndex = 0;
    var formattedMessage = message.replace(POSITIONALS_EXP, function (match, isEscaped, _, flag) {
        var positional = positionals[positionalIndex];
        var value = serializePositional(positional, flag);
        if (!isEscaped) {
            positionalIndex++;
            return value;
        }
        return match;
    });
    // Append unresolved positionals to string as-is.
    if (positionalIndex < positionals.length) {
        formattedMessage += " " + positionals.slice(positionalIndex).join(' ');
    }
    formattedMessage = formattedMessage.replace(/%{2,2}/g, '%');
    return formattedMessage;
}
format$1.format = format;

var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (commonjsGlobal && commonjsGlobal.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(invariant$1, "__esModule", { value: true });
invariant$1.invariant = invariant$1.InvariantError = void 0;
var format_1 = format$1;
var STACK_FRAMES_TO_IGNORE = 2;
var InvariantError = /** @class */ (function (_super) {
    __extends(InvariantError, _super);
    function InvariantError(message) {
        var positionals = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            positionals[_i - 1] = arguments[_i];
        }
        var _this = _super.call(this, message) || this;
        _this.name = 'Invariant Violation';
        _this.message = format_1.format.apply(void 0, __spreadArray([message], positionals));
        if (_this.stack) {
            var prevStack = _this.stack;
            _this.stack = prevStack
                .split('\n')
                .slice(STACK_FRAMES_TO_IGNORE)
                .join('\n');
        }
        return _this;
    }
    return InvariantError;
}(Error));
invariant$1.InvariantError = InvariantError;
function invariant(predicate, message) {
    var positionals = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        positionals[_i - 2] = arguments[_i];
    }
    if (!predicate) {
        throw new (InvariantError.bind.apply(InvariantError, __spreadArray([void 0, message], positionals)))();
    }
}
invariant$1.invariant = invariant;

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(invariant$1, exports);
__exportStar(format$1, exports);
}(RequestHandler_deps_lib));

const LIBRARY_PREFIX = '[MSW]';
/**
 * Formats a given message by appending the library's prefix string.
 */
function formatMessage(message, ...positionals) {
    const interpolatedMessage = RequestHandler_deps_lib.format(message, ...positionals);
    return `${LIBRARY_PREFIX} ${interpolatedMessage}`;
}
/**
 * Prints a library-specific warning.
 */
function warn(message, ...positionals) {
    console.warn(formatMessage(message, ...positionals));
}
/**
 * Prints a library-specific error.
 */
function error(message, ...positionals) {
    console.error(formatMessage(message, ...positionals));
}
const devUtils = {
    formatMessage,
    warn,
    error,
};

class NetworkError extends Error {
    constructor(message) {
        super(message);
        this.name = 'NetworkError';
    }
}

function parseContentHeaders(headersString) {
    var _a, _b;
    const headers = lib$1.stringToHeaders(headersString);
    const contentType = headers.get('content-type') || 'text/plain';
    const disposition = headers.get('content-disposition');
    if (!disposition) {
        throw new Error('"Content-Disposition" header is required.');
    }
    const directives = disposition.split(';').reduce((acc, chunk) => {
        const [name, ...rest] = chunk.trim().split('=');
        acc[name] = rest.join('=');
        return acc;
    }, {});
    const name = (_a = directives.name) === null || _a === void 0 ? void 0 : _a.slice(1, -1);
    const filename = (_b = directives.filename) === null || _b === void 0 ? void 0 : _b.slice(1, -1);
    return {
        name,
        filename,
        contentType,
    };
}
/**
 * Parses a given string as a multipart/form-data.
 * Does not throw an exception on an invalid multipart string.
 */
function parseMultipartData(data, headers) {
    const contentType = headers === null || headers === void 0 ? void 0 : headers.get('content-type');
    if (!contentType) {
        return undefined;
    }
    const [, ...directives] = contentType.split(/; */);
    const boundary = directives
        .filter((d) => d.startsWith('boundary='))
        .map((s) => s.replace(/^boundary=/, ''))[0];
    if (!boundary) {
        return undefined;
    }
    const boundaryRegExp = new RegExp(`--+${boundary}`);
    const fields = data
        .split(boundaryRegExp)
        .filter((chunk) => chunk.startsWith('\r\n') && chunk.endsWith('\r\n'))
        .map((chunk) => chunk.trimStart().replace(/\r\n$/, ''));
    if (!fields.length) {
        return undefined;
    }
    const parsedBody = {};
    try {
        for (const field of fields) {
            const [contentHeaders, ...rest] = field.split('\r\n\r\n');
            const contentBody = rest.join('\r\n\r\n');
            const { contentType, filename, name } = parseContentHeaders(contentHeaders);
            const value = filename === undefined
                ? contentBody
                : new File([contentBody], filename, { type: contentType });
            const parsedValue = parsedBody[name];
            if (parsedValue === undefined) {
                parsedBody[name] = value;
            }
            else if (Array.isArray(parsedValue)) {
                parsedBody[name] = [...parsedValue, value];
            }
            else {
                parsedBody[name] = [parsedValue, value];
            }
        }
        return parsedBody;
    }
    catch (error) {
        return undefined;
    }
}

/**
 * Parses a given request/response body based on the `Content-Type` header.
 */
function parseBody(body, headers) {
    // Return whatever falsey body value is given.
    if (!body) {
        return body;
    }
    const contentType = headers === null || headers === void 0 ? void 0 : headers.get('content-type');
    // If the body has a Multipart Content-Type
    // parse it into an object.
    const hasMultipartContent = contentType === null || contentType === void 0 ? void 0 : contentType.startsWith('multipart/form-data');
    if (hasMultipartContent && typeof body !== 'object') {
        return parseMultipartData(body, headers) || body;
    }
    // If the intercepted request's body has a JSON Content-Type
    // parse it into an object.
    const hasJsonContent = contentType === null || contentType === void 0 ? void 0 : contentType.includes('json');
    if (hasJsonContent && typeof body !== 'object') {
        return jsonParse(body) || body;
    }
    // Otherwise leave as-is.
    return body;
}

/**
 * Returns a relative URL if the given request URL is relative to the current origin.
 * Otherwise returns an absolute URL.
 */
const getPublicUrlFromRequest = (request) => {
    return request.referrer.startsWith(request.url.origin)
        ? request.url.pathname
        : new URL(request.url.pathname, `${request.url.protocol}//${request.url.host}`).href;
};

var StatusCodeColor;
(function (StatusCodeColor) {
    StatusCodeColor["Success"] = "#69AB32";
    StatusCodeColor["Warning"] = "#F0BB4B";
    StatusCodeColor["Danger"] = "#E95F5D";
})(StatusCodeColor || (StatusCodeColor = {}));
/**
 * Returns a HEX color for a given response status code number.
 */
function getStatusCodeColor(status) {
    if (status < 300) {
        return StatusCodeColor.Success;
    }
    if (status < 400) {
        return StatusCodeColor.Warning;
    }
    return StatusCodeColor.Danger;
}

/**
 * Returns a timestamp string in a "HH:MM:SS" format.
 */
function getTimestamp() {
    const now = new Date();
    return [now.getHours(), now.getMinutes(), now.getSeconds()]
        .map(String)
        .map((chunk) => chunk.slice(0, 2))
        .map((chunk) => chunk.padStart(2, '0'))
        .join(':');
}

/**
 * Formats a mocked request for introspection in browser's console.
 */
function prepareRequest(request) {
    return Object.assign(Object.assign({}, request), { headers: request.headers.all() });
}

/**
 * Formats a mocked response for introspection in the browser's console.
 */
function prepareResponse(res) {
    const responseHeaders = lib$1.objectToHeaders(res.headers);
    return Object.assign(Object.assign({}, res), { 
        // Parse a response JSON body for preview in the logs
        body: parseBody(res.body, responseHeaders) });
}

/**
 * Converts a string path to a Regular Expression.
 * Transforms path parameters into named RegExp groups.
 */
const pathToRegExp = (path) => {
    const pattern = path
        // Escape literal dots
        .replace(/\./g, '\\.')
        // Escape literal slashes
        .replace(/\//g, '/')
        // Escape literal question marks
        .replace(/\?/g, '\\?')
        // Ignore trailing slashes
        .replace(/\/+$/, '')
        // Replace wildcard with any zero-to-any character sequence
        .replace(/\*+/g, '.*')
        // Replace parameters with named capturing groups
        .replace(/:([^\d|^\/][a-zA-Z0-9_]*(?=(?:\/|\\.)|$))/g, (_, paramName) => `(?<${paramName}>[^\/]+?)`)
        // Allow optional trailing slash
        .concat('(\\/|$)');
    return new RegExp(pattern, 'gi');
};

/**
 * Matches a given url against a path.
 */
const match = (path, url) => {
    const expression = path instanceof RegExp ? path : pathToRegExp(path);
    const match = expression.exec(url) || false;
    // Matches in strict mode: match string should equal to input (url)
    // Otherwise loose matches will be considered truthy:
    // match('/messages/:id', '/messages/123/users') // true
    const matches = path instanceof RegExp ? !!match : !!match && match[0] === match.input;
    return {
        matches,
        params: match && matches ? match.groups || null : null,
    };
};

var getCleanUrl$1 = {};

Object.defineProperty(getCleanUrl$1, "__esModule", { value: true });
var getCleanUrl_2 = getCleanUrl$1.getCleanUrl = void 0;
/**
 * Removes query parameters and hashes from a given URL.
 */
function getCleanUrl(url, isAbsolute) {
    if (isAbsolute === void 0) { isAbsolute = true; }
    return [isAbsolute && url.origin, url.pathname].filter(Boolean).join('');
}
getCleanUrl_2 = getCleanUrl$1.getCleanUrl = getCleanUrl;

const REDUNDANT_CHARACTERS_EXP = /[\?|#].*$/g;
function getSearchParams(path) {
    return new URL(`/${path}`, 'http://localhost').searchParams;
}
/**
 * Removes query parameters and hashes from a given URL string.
 */
function cleanUrl(path) {
    return path.replace(REDUNDANT_CHARACTERS_EXP, '');
}

/**
 * Returns an absolute URL based on the given path.
 */
function getAbsoluteUrl(path, baseUrl) {
    // Ignore absolute URLs.
    if (!path.startsWith('/')) {
        return path;
    }
    // Resolve a relative request URL against a given custom "baseUrl"
    // or the current location (in the case of browser/browser-like environments).
    const origin = baseUrl || (typeof location !== 'undefined' && location.origin);
    return origin
        ? // Encode and decode the path to preserve escaped characters.
            decodeURI(new URL(encodeURI(path), origin).href)
        : path;
}

/**
 * Normalizes a given request handler path:
 * - Preserves RegExp.
 * - Removes query parameters and hashes.
 * - Rebases relative URLs against the "baseUrl" or the current location.
 * - Preserves relative URLs in Node.js, unless specified otherwise.
 */
function normalizePath(path, baseUrl) {
    // RegExp paths do not need normalization.
    if (path instanceof RegExp) {
        return path;
    }
    const maybeAbsoluteUrl = getAbsoluteUrl(path, baseUrl);
    return cleanUrl(maybeAbsoluteUrl);
}

/**
 * Returns the result of matching given request URL against a mask.
 */
function matchRequestUrl(url, path, baseUrl) {
    const normalizedPath = normalizePath(path, baseUrl);
    return match(normalizedPath, getCleanUrl_2(url));
}

/**
 * Composes a given list of functions into a new function that
 * executes from right to left.
 */
function compose(...fns) {
    return (...args) => {
        return fns.reduceRight((leftFn, rightFn) => {
            return leftFn instanceof Promise
                ? Promise.resolve(leftFn).then(rightFn)
                : rightFn(leftFn);
        }, args[0]);
    };
}

const defaultResponse = {
    status: 200,
    statusText: 'OK',
    body: null,
    delay: 0,
    once: false,
};
const defaultResponseTransformers = [];
function createResponseComposition(responseOverrides, defaultTransformers = defaultResponseTransformers) {
    return (...transformers) => __awaiter(this, void 0, void 0, function* () {
        const initialResponse = Object.assign({}, defaultResponse, {
            headers: new lib$1.Headers({
                'x-powered-by': 'msw',
            }),
        }, responseOverrides);
        const resolvedTransformers = [
            ...defaultTransformers,
            ...transformers,
        ].filter(Boolean);
        const resolvedResponse = resolvedTransformers.length > 0
            ? compose(...resolvedTransformers)(initialResponse)
            : initialResponse;
        return resolvedResponse;
    });
}
const response = Object.assign(createResponseComposition(), {
    once: createResponseComposition({ once: true }),
    networkError(message) {
        throw new NetworkError(message);
    },
});

/**
 * Return the stack trace frame of a function's invocation.
 */
function getCallFrame() {
    // In <IE11, new Error may return an undefined stack
    const stack = (new Error().stack || '');
    const frames = stack.split('\n');
    // Get the first frame that doesn't reference the library's internal trace.
    // Assume that frame is the invocation frame.
    const ignoreFrameRegExp = /(node_modules)?[\/\\]lib[\/\\](umd|esm|iief|cjs)[\/\\]|^[^\/\\]*$/;
    const declarationFrame = frames.slice(1).find((frame) => {
        return !ignoreFrameRegExp.test(frame);
    });
    if (!declarationFrame) {
        return;
    }
    // Extract file reference from the stack frame.
    const declarationPath = declarationFrame
        .replace(/\s*at [^()]*\(([^)]+)\)/, '$1')
        .replace(/^@/, '');
    return declarationPath;
}

/**
 * Determines if the given function is an iterator.
 */
function isIterable(fn) {
    if (!fn) {
        return false;
    }
    return typeof fn[Symbol.iterator] == 'function';
}

const defaultContext = {
    status: fetch_deps_status,
    set: set,
    delay: delay,
    fetch: fetch,
};
class RequestHandler {
    constructor(options) {
        this.shouldSkip = false;
        this.ctx = options.ctx || defaultContext;
        this.resolver = options.resolver;
        const callFrame = getCallFrame();
        this.info = Object.assign(Object.assign({}, options.info), { callFrame });
    }
    /**
     * Parse the captured request to extract additional information from it.
     * Parsed result is then exposed to other methods of this request handler.
     */
    parse(_request, _resolutionContext) {
        return null;
    }
    /**
     * Test if this handler matches the given request.
     */
    test(request, resolutionContext) {
        return this.predicate(request, this.parse(request, resolutionContext), resolutionContext);
    }
    /**
     * Derive the publicly exposed request (`req`) instance of the response resolver
     * from the captured request and its parsed result.
     */
    getPublicRequest(request, _parsedResult) {
        return request;
    }
    markAsSkipped(shouldSkip = true) {
        this.shouldSkip = shouldSkip;
    }
    /**
     * Execute this request handler and produce a mocked response
     * using the given resolver function.
     */
    run(request, resolutionContext) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.shouldSkip) {
                return null;
            }
            const parsedResult = this.parse(request, resolutionContext);
            const shouldIntercept = this.predicate(request, parsedResult, resolutionContext);
            if (!shouldIntercept) {
                return null;
            }
            const publicRequest = this.getPublicRequest(request, parsedResult);
            // Create a response extraction wrapper around the resolver
            // since it can be both an async function and a generator.
            const executeResolver = this.wrapResolver(this.resolver);
            const mockedResponse = yield executeResolver(publicRequest, response, this.ctx);
            return this.createExecutionResult(parsedResult, publicRequest, mockedResponse);
        });
    }
    wrapResolver(resolver) {
        return (req, res, ctx) => __awaiter(this, void 0, void 0, function* () {
            const result = this.resolverGenerator || (yield resolver(req, res, ctx));
            if (isIterable(result)) {
                const { value, done } = result[Symbol.iterator]().next();
                const nextResponse = yield value;
                // If the generator is done and there is no next value,
                // return the previous generator's value.
                if (!nextResponse && done) {
                    return this.resolverGeneratorResult;
                }
                if (!this.resolverGenerator) {
                    this.resolverGenerator = result;
                }
                this.resolverGeneratorResult = nextResponse;
                return nextResponse;
            }
            return result;
        });
    }
    createExecutionResult(parsedResult, request, response) {
        return {
            handler: this,
            parsedResult: parsedResult || null,
            request,
            response: response || null,
        };
    }
}



;// CONCATENATED MODULE: ./node_modules/.pnpm/msw@0.35.0/node_modules/msw/lib/esm/xml-deps.js
/**
 * Sets a raw response body. Does not append any `Content-Type` headers.
 * @example
 * res(ctx.body('Successful response'))
 * res(ctx.body(JSON.stringify({ key: 'value' })))
 * @see {@link https://mswjs.io/docs/api/context/body `ctx.body()`}
 */
const body = (value) => {
    return (res) => {
        res.body = value;
        return res;
    };
};

/**
 * Sets a textual response body. Appends a `Content-Type: text/plain`
 * header on the mocked response.
 * @example res(ctx.text('Successful response'))
 * @see {@link https://mswjs.io/docs/api/context/text `ctx.text()`}
 */
const xml_deps_text = (body) => {
    return (res) => {
        res.headers.set('Content-Type', 'text/plain');
        res.body = body;
        return res;
    };
};

/**
 * Sets an XML response body. Appends a `Content-Type: text/xml` header
 * on the mocked response.
 * @example
 * res(ctx.xml('<node key="value">Content</node>'))
 * @see {@link https://mswjs.io/docs/api/context/xml `ctx.xml()`}
 */
const xml = (body) => {
    return (res) => {
        res.headers.set('Content-Type', 'text/xml');
        res.body = body;
        return res;
    };
};



;// CONCATENATED MODULE: ./node_modules/.pnpm/msw@0.35.0/node_modules/msw/lib/esm/rest-deps.js




/**
 * Performs a case-insensitive comparison of two given strings.
 */
function isStringEqual(actual, expected) {
    return actual.toLowerCase() === expected.toLowerCase();
}

var RESTMethods;
(function (RESTMethods) {
    RESTMethods["HEAD"] = "HEAD";
    RESTMethods["GET"] = "GET";
    RESTMethods["POST"] = "POST";
    RESTMethods["PUT"] = "PUT";
    RESTMethods["PATCH"] = "PATCH";
    RESTMethods["OPTIONS"] = "OPTIONS";
    RESTMethods["DELETE"] = "DELETE";
})(RESTMethods || (RESTMethods = {}));
const restContext = {
    set: set,
    status: fetch_deps_status,
    cookie: cookie,
    body: body,
    text: xml_deps_text,
    json: json,
    xml: xml,
    delay: delay,
    fetch: fetch,
};
/**
 * Request handler for REST API requests.
 * Provides request matching based on method and URL.
 */
class RestHandler extends RequestHandler {
    constructor(method, path, resolver) {
        super({
            info: {
                header: `${method} ${path}`,
                path,
                method,
            },
            ctx: restContext,
            resolver,
        });
        this.checkRedundantQueryParameters();
    }
    checkRedundantQueryParameters() {
        const { method, path } = this.info;
        if (path instanceof RegExp) {
            return;
        }
        const url = cleanUrl(path);
        // Bypass request handler URLs that have no redundant characters.
        if (url === path) {
            return;
        }
        const searchParams = getSearchParams(path);
        const queryParams = [];
        searchParams.forEach((_, paramName) => {
            queryParams.push(paramName);
        });
        devUtils.warn(`\
Found a redundant usage of query parameters in the request handler URL for "${method} ${path}". Please match against a path instead, and access query parameters in the response resolver function:

rest.${method.toLowerCase()}("${url}", (req, res, ctx) => {
  const query = req.url.searchParams
${queryParams
            .map((paramName) => `\
  const ${paramName} = query.get("${paramName}")`)
            .join('\n')}
})\
      `);
    }
    parse(request, resolutionContext) {
        return matchRequestUrl(request.url, this.info.path, resolutionContext === null || resolutionContext === void 0 ? void 0 : resolutionContext.baseUrl);
    }
    getPublicRequest(request, parsedResult) {
        return Object.assign(Object.assign({}, request), { params: parsedResult.params || {} });
    }
    predicate(request, parsedResult) {
        return (isStringEqual(this.info.method, request.method) && parsedResult.matches);
    }
    log(request, response) {
        const publicUrl = getPublicUrlFromRequest(request);
        const loggedRequest = prepareRequest(request);
        const loggedResponse = prepareResponse(response);
        const statusColor = getStatusCodeColor(response.status);
        console.groupCollapsed(devUtils.formatMessage('%s %s %s (%c%s%c)'), getTimestamp(), request.method, publicUrl, `color:${statusColor}`, `${response.status} ${response.statusText}`, 'color:inherit');
        console.log('Request', loggedRequest);
        console.log('Handler:', {
            mask: this.info.path,
            resolver: this.resolver,
        });
        console.log('Response', loggedResponse);
        console.groupEnd();
    }
}

function createRestHandler(method) {
    return (path, resolver) => {
        return new RestHandler(method, path, resolver);
    };
}
const rest = {
    head: createRestHandler(RESTMethods.HEAD),
    get: createRestHandler(RESTMethods.GET),
    post: createRestHandler(RESTMethods.POST),
    put: createRestHandler(RESTMethods.PUT),
    delete: createRestHandler(RESTMethods.DELETE),
    patch: createRestHandler(RESTMethods.PATCH),
    options: createRestHandler(RESTMethods.OPTIONS),
};



;// CONCATENATED MODULE: ./node_modules/.pnpm/msw@0.35.0/node_modules/msw/lib/esm/errors-deps.js


/**
 * Determines if the given value is an object.
 */
function isObject(value) {
    return value != null && typeof value === 'object' && !Array.isArray(value);
}

/**
 * Deeply merges two given objects with the right one
 * having a priority during property assignment.
 */
function mergeRight(left, right) {
    return Object.entries(right).reduce((result, [key, rightValue]) => {
        const leftValue = result[key];
        if (Array.isArray(leftValue) && Array.isArray(rightValue)) {
            result[key] = leftValue.concat(rightValue);
            return result;
        }
        if (isObject(leftValue) && isObject(rightValue)) {
            result[key] = mergeRight(leftValue, rightValue);
            return result;
        }
        result[key] = rightValue;
        return result;
    }, Object.assign({}, left));
}

/**
 * Sets a given payload as a GraphQL response body.
 * @example
 * res(ctx.data({ user: { firstName: 'John' }}))
 * @see {@link https://mswjs.io/docs/api/context/data `ctx.data()`}
 */
const data = (payload) => {
    return (res) => {
        const prevBody = jsonParse(res.body) || {};
        const nextBody = mergeRight(prevBody, { data: payload });
        return json(nextBody)(res);
    };
};

/**
 * Sets a given list of GraphQL errors on the mocked response.
 * @example res(ctx.errors([{ message: 'Unauthorized' }]))
 * @see {@link https://mswjs.io/docs/api/context/errors}
 */
const errors = (errorsList) => {
    return (res) => {
        if (errorsList == null) {
            return res;
        }
        const prevBody = jsonParse(res.body) || {};
        const nextBody = mergeRight(prevBody, { errors: errorsList });
        return json(nextBody)(res);
    };
};



;// CONCATENATED MODULE: ./node_modules/.pnpm/msw@0.35.0/node_modules/msw/lib/esm/graphql-deps.js




function _typeof$3(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return _typeof$3(value) == 'object' && value !== null;
}

// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator

var SYMBOL_TO_STRING_TAG = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match;

  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }

  return {
    line: line,
    column: column
  };
}

/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printLocation(location) {
  return printSourceLocation(location.source, getLocation(location.source, location.start));
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  var firstLineColumnOffset = source.locationOffset.column - 1;
  var body = whitespace(firstLineColumnOffset) + source.body;
  var lineIndex = sourceLocation.line - 1;
  var lineOffset = source.locationOffset.line - 1;
  var lineNum = sourceLocation.line + lineOffset;
  var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  var columnNum = sourceLocation.column + columnOffset;
  var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
  var lines = body.split(/\r\n|[\n\r]/g);
  var locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    var subLineIndex = Math.floor(columnNum / 80);
    var subLineColumnNum = columnNum % 80;
    var subLines = [];

    for (var i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return locationStr + printPrefixedLines([["".concat(lineNum), subLines[0]]].concat(subLines.slice(1, subLineIndex + 1).map(function (subLine) {
      return ['', subLine];
    }), [[' ', whitespace(subLineColumnNum - 1) + '^'], ['', subLines[subLineIndex + 1]]]));
  }

  return locationStr + printPrefixedLines([// Lines specified like this: ["prefix", "string"],
  ["".concat(lineNum - 1), lines[lineIndex - 1]], ["".concat(lineNum), locationLine], ['', whitespace(columnNum - 1) + '^'], ["".concat(lineNum + 1), lines[lineIndex + 1]]]);
}

function printPrefixedLines(lines) {
  var existingLines = lines.filter(function (_ref) {
    _ref[0];
        var line = _ref[1];
    return line !== undefined;
  });
  var padLen = Math.max.apply(Math, existingLines.map(function (_ref2) {
    var prefix = _ref2[0];
    return prefix.length;
  }));
  return existingLines.map(function (_ref3) {
    var prefix = _ref3[0],
        line = _ref3[1];
    return leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
  }).join('\n');
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function leftPad(len, str) {
  return whitespace(len - str.length) + str;
}

function _typeof$2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof$2(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

var GraphQLError = /*#__PURE__*/function (_Error) {
  _inherits(GraphQLError, _Error);

  var _super = _createSuper(GraphQLError);

  /**
   * A message describing the Error for debugging purposes.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   *
   * Note: should be treated as readonly, despite invariant usage.
   */

  /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */
  function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
    var _locations2, _source2, _positions2, _extensions2;

    var _this;

    _classCallCheck(this, GraphQLError);

    _this = _super.call(this, message); // Compute list of blame nodes.

    var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [nodes] : undefined; // Compute locations in the source for the given nodes/positions.


    var _source = source;

    if (!_source && _nodes) {
      var _nodes$0$loc;

      _source = (_nodes$0$loc = _nodes[0].loc) === null || _nodes$0$loc === void 0 ? void 0 : _nodes$0$loc.source;
    }

    var _positions = positions;

    if (!_positions && _nodes) {
      _positions = _nodes.reduce(function (list, node) {
        if (node.loc) {
          list.push(node.loc.start);
        }

        return list;
      }, []);
    }

    if (_positions && _positions.length === 0) {
      _positions = undefined;
    }

    var _locations;

    if (positions && source) {
      _locations = positions.map(function (pos) {
        return getLocation(source, pos);
      });
    } else if (_nodes) {
      _locations = _nodes.reduce(function (list, node) {
        if (node.loc) {
          list.push(getLocation(node.loc.source, node.loc.start));
        }

        return list;
      }, []);
    }

    var _extensions = extensions;

    if (_extensions == null && originalError != null) {
      var originalExtensions = originalError.extensions;

      if (isObjectLike(originalExtensions)) {
        _extensions = originalExtensions;
      }
    }

    Object.defineProperties(_assertThisInitialized(_this), {
      name: {
        value: 'GraphQLError'
      },
      message: {
        value: message,
        // By being enumerable, JSON.stringify will include `message` in the
        // resulting output. This ensures that the simplest possible GraphQL
        // service adheres to the spec.
        enumerable: true,
        writable: true
      },
      locations: {
        // Coercing falsy values to undefined ensures they will not be included
        // in JSON.stringify() when not provided.
        value: (_locations2 = _locations) !== null && _locations2 !== void 0 ? _locations2 : undefined,
        // By being enumerable, JSON.stringify will include `locations` in the
        // resulting output. This ensures that the simplest possible GraphQL
        // service adheres to the spec.
        enumerable: _locations != null
      },
      path: {
        // Coercing falsy values to undefined ensures they will not be included
        // in JSON.stringify() when not provided.
        value: path !== null && path !== void 0 ? path : undefined,
        // By being enumerable, JSON.stringify will include `path` in the
        // resulting output. This ensures that the simplest possible GraphQL
        // service adheres to the spec.
        enumerable: path != null
      },
      nodes: {
        value: _nodes !== null && _nodes !== void 0 ? _nodes : undefined
      },
      source: {
        value: (_source2 = _source) !== null && _source2 !== void 0 ? _source2 : undefined
      },
      positions: {
        value: (_positions2 = _positions) !== null && _positions2 !== void 0 ? _positions2 : undefined
      },
      originalError: {
        value: originalError
      },
      extensions: {
        // Coercing falsy values to undefined ensures they will not be included
        // in JSON.stringify() when not provided.
        value: (_extensions2 = _extensions) !== null && _extensions2 !== void 0 ? _extensions2 : undefined,
        // By being enumerable, JSON.stringify will include `path` in the
        // resulting output. This ensures that the simplest possible GraphQL
        // service adheres to the spec.
        enumerable: _extensions != null
      }
    }); // Include (non-enumerable) stack trace.

    if (originalError !== null && originalError !== void 0 && originalError.stack) {
      Object.defineProperty(_assertThisInitialized(_this), 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true
      });
      return _possibleConstructorReturn(_this);
    } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')


    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), GraphQLError);
    } else {
      Object.defineProperty(_assertThisInitialized(_this), 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true
      });
    }

    return _this;
  }

  _createClass$1(GraphQLError, [{
    key: "toString",
    value: function toString() {
      return printError(this);
    } // FIXME: workaround to not break chai comparisons, should be remove in v16
    // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet

  }, {
    key: SYMBOL_TO_STRING_TAG,
    get: function get() {
      return 'Object';
    }
  }]);

  return GraphQLError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */

function printError(error) {
  var output = error.message;

  if (error.nodes) {
    for (var _i2 = 0, _error$nodes2 = error.nodes; _i2 < _error$nodes2.length; _i2++) {
      var node = _error$nodes2[_i2];

      if (node.loc) {
        output += '\n\n' + printLocation(node.loc);
      }
    }
  } else if (error.source && error.locations) {
    for (var _i4 = 0, _error$locations2 = error.locations; _i4 < _error$locations2.length; _i4++) {
      var location = _error$locations2[_i4];
      output += '\n\n' + printSourceLocation(error.source, location);
    }
  }

  return output;
}

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError("Syntax Error: ".concat(description), undefined, source, [position]);
}

/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',
  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',
  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',
  // Values
  VARIABLE: 'Variable',
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',
  // Directives
  DIRECTIVE: 'Directive',
  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',
  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition',
  // Type System Extensions
  SCHEMA_EXTENSION: 'SchemaExtension',
  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */

function graphql_deps_invariant(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message != null ? message : 'Unexpected invariant triggered.');
  }
}

// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;

/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */

function defineInspect(classObject) {
  var fn = classObject.prototype.toJSON;
  typeof fn === 'function' || graphql_deps_invariant(0);
  classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')

  if (nodejsCustomInspectSymbol) {
    classObject.prototype[nodejsCustomInspectSymbol] = fn;
  }
}

/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
var Location = /*#__PURE__*/function () {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  function Location(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  var _proto = Location.prototype;

  _proto.toJSON = function toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  };

  return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

defineInspect(Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

var Token = /*#__PURE__*/function () {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  function Token(kind, start, end, line, column, prev, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = prev;
    this.next = null;
  }

  var _proto2 = Token.prototype;

  _proto2.toJSON = function toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  };

  return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

defineInspect(Token);
/**
 * The list of all possible AST node types.
 */

/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */

function _typeof$1(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }
var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (_typeof$1(value)) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? "[function ".concat(value.name, "]") : '[function]';

    case 'object':
      if (value === null) {
        return 'null';
      }

      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (previouslySeenValues.indexOf(value) !== -1) {
    return '[Circular]';
  }

  var seenValues = [].concat(previouslySeenValues, [value]);
  var customInspectFn = getCustomFn(value);

  if (customInspectFn !== undefined) {
    var customValue = customInspectFn.call(value); // check for infinite recursion

    if (customValue !== value) {
      return typeof customValue === 'string' ? customValue : formatValue(customValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function formatObject(object, seenValues) {
  var keys = Object.keys(object);

  if (keys.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  var properties = keys.map(function (key) {
    var value = formatValue(object[key], seenValues);
    return key + ': ' + value;
  });
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  var len = Math.min(MAX_ARRAY_LENGTH, array.length);
  var remaining = array.length - len;
  var items = [];

  for (var i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push("... ".concat(remaining, " more items"));
  }

  return '[' + items.join(', ') + ']';
}

function getCustomFn(object) {
  var customInspectFn = object[String(nodejsCustomInspectSymbol)];

  if (typeof customInspectFn === 'function') {
    return customInspectFn;
  }

  if (typeof object.inspect === 'function') {
    return object.inspect;
  }
}

function getObjectTag(object) {
  var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    var name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}

function devAssert(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message);
  }
}

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */

// See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
var instanceOf = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
  if (value instanceof constructor) {
    return true;
  }

  if (_typeof(value) === 'object' && value !== null) {
    var _value$constructor;

    var className = constructor.prototype[Symbol.toStringTag];
    var valueClassName = // We still need to support constructor's name to detect conflicts with older versions of this library.
    Symbol.toStringTag in value ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;

    if (className === valueClassName) {
      var stringifiedValue = inspect(value);
      throw new Error("Cannot use ".concat(className, " \"").concat(stringifiedValue, "\" from another module or realm.\n\nEnsure that there is only one instance of \"graphql\" in the node_modules\ndirectory. If different versions of \"graphql\" are the dependencies of other\nrelied on modules, use \"resolutions\" to ensure only one version is installed.\n\nhttps://yarnpkg.com/en/docs/selective-version-resolutions\n\nDuplicate \"graphql\" modules cannot be used at the same time since different\nversions may have different capabilities and behavior. The data from one\nversion used in the function from another could produce confusing and\nspurious results."));
    }
  }

  return false;
};

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
var Source = /*#__PURE__*/function () {
  function Source(body) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
    var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      line: 1,
      column: 1
    };
    typeof body === 'string' || devAssert(0, "Body must be a string. Received: ".concat(inspect(body), "."));
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 || devAssert(0, 'line in locationOffset is 1-indexed and must be positive.');
    this.locationOffset.column > 0 || devAssert(0, 'column in locationOffset is 1-indexed and must be positive.');
  } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet


  _createClass(Source, [{
    key: SYMBOL_TO_STRING_TAG,
    get: function get() {
      return 'Source';
    }
  }]);

  return Source;
}();
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

// eslint-disable-next-line no-redeclare
function isSource(source) {
  return instanceOf(source, Source);
}

/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */
function dedentBlockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.

  var commonIndent = getBlockStringIndentation(rawString);

  if (commonIndent !== 0) {
    for (var i = 1; i < lines.length; i++) {
      lines[i] = lines[i].slice(commonIndent);
    }
  } // Remove leading and trailing blank lines.


  var startLine = 0;

  while (startLine < lines.length && isBlank(lines[startLine])) {
    ++startLine;
  }

  var endLine = lines.length;

  while (endLine > startLine && isBlank(lines[endLine - 1])) {
    --endLine;
  } // Return a string of the lines joined with U+000A.


  return lines.slice(startLine, endLine).join('\n');
}

function isBlank(str) {
  for (var i = 0; i < str.length; ++i) {
    if (str[i] !== ' ' && str[i] !== '\t') {
      return false;
    }
  }

  return true;
}
/**
 * @internal
 */


function getBlockStringIndentation(value) {
  var _commonIndent;

  var isFirstLine = true;
  var isEmptyLine = true;
  var indent = 0;
  var commonIndent = null;

  for (var i = 0; i < value.length; ++i) {
    switch (value.charCodeAt(i)) {
      case 13:
        //  \r
        if (value.charCodeAt(i + 1) === 10) {
          ++i; // skip \r\n as one symbol
        }

      // falls through

      case 10:
        //  \n
        isFirstLine = false;
        isEmptyLine = true;
        indent = 0;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        ++indent;
        break;

      default:
        if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) {
          commonIndent = indent;
        }

        isEmptyLine = false;
    }
  }

  return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}

/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

var Lexer = /*#__PURE__*/function () {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  function Lexer(source) {
    var startOfFileToken = new Token(TokenKind.SOF, 0, 0, 0, 0, null);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */


  var _proto = Lexer.prototype;

  _proto.advance = function advance() {
    this.lastToken = this.token;
    var token = this.token = this.lookahead();
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  ;

  _proto.lookahead = function lookahead() {
    var token = this.token;

    if (token.kind !== TokenKind.EOF) {
      do {
        var _token$next;

        // Note: next is only mutable during parsing, so we cast to allow this.
        token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = readToken(this, token);
      } while (token.kind === TokenKind.COMMENT);
    }

    return token;
  };

  return Lexer;
}();
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return kind === TokenKind.BANG || kind === TokenKind.DOLLAR || kind === TokenKind.AMP || kind === TokenKind.PAREN_L || kind === TokenKind.PAREN_R || kind === TokenKind.SPREAD || kind === TokenKind.COLON || kind === TokenKind.EQUALS || kind === TokenKind.AT || kind === TokenKind.BRACKET_L || kind === TokenKind.BRACKET_R || kind === TokenKind.BRACE_L || kind === TokenKind.PIPE || kind === TokenKind.BRACE_R;
}

function printCharCode(code) {
  return (// NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"")
  );
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */


function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;
  var pos = prev.end;

  while (pos < bodyLength) {
    var code = body.charCodeAt(pos);
    var _line = lexer.line;

    var _col = 1 + pos - lexer.lineStart; // SourceCharacter


    switch (code) {
      case 0xfeff: // <BOM>

      case 9: //   \t

      case 32: //  <space>

      case 44:
        //  ,
        ++pos;
        continue;

      case 10:
        //  \n
        ++pos;
        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 13:
        //  \r
        if (body.charCodeAt(pos + 1) === 10) {
          pos += 2;
        } else {
          ++pos;
        }

        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 33:
        //  !
        return new Token(TokenKind.BANG, pos, pos + 1, _line, _col, prev);

      case 35:
        //  #
        return readComment(source, pos, _line, _col, prev);

      case 36:
        //  $
        return new Token(TokenKind.DOLLAR, pos, pos + 1, _line, _col, prev);

      case 38:
        //  &
        return new Token(TokenKind.AMP, pos, pos + 1, _line, _col, prev);

      case 40:
        //  (
        return new Token(TokenKind.PAREN_L, pos, pos + 1, _line, _col, prev);

      case 41:
        //  )
        return new Token(TokenKind.PAREN_R, pos, pos + 1, _line, _col, prev);

      case 46:
        //  .
        if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) {
          return new Token(TokenKind.SPREAD, pos, pos + 3, _line, _col, prev);
        }

        break;

      case 58:
        //  :
        return new Token(TokenKind.COLON, pos, pos + 1, _line, _col, prev);

      case 61:
        //  =
        return new Token(TokenKind.EQUALS, pos, pos + 1, _line, _col, prev);

      case 64:
        //  @
        return new Token(TokenKind.AT, pos, pos + 1, _line, _col, prev);

      case 91:
        //  [
        return new Token(TokenKind.BRACKET_L, pos, pos + 1, _line, _col, prev);

      case 93:
        //  ]
        return new Token(TokenKind.BRACKET_R, pos, pos + 1, _line, _col, prev);

      case 123:
        // {
        return new Token(TokenKind.BRACE_L, pos, pos + 1, _line, _col, prev);

      case 124:
        // |
        return new Token(TokenKind.PIPE, pos, pos + 1, _line, _col, prev);

      case 125:
        // }
        return new Token(TokenKind.BRACE_R, pos, pos + 1, _line, _col, prev);

      case 34:
        //  "
        if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) {
          return readBlockString(source, pos, _line, _col, prev, lexer);
        }

        return readString(source, pos, _line, _col, prev);

      case 45: //  -

      case 48: //  0

      case 49: //  1

      case 50: //  2

      case 51: //  3

      case 52: //  4

      case 53: //  5

      case 54: //  6

      case 55: //  7

      case 56: //  8

      case 57:
        //  9
        return readNumber(source, pos, code, _line, _col, prev);

      case 65: //  A

      case 66: //  B

      case 67: //  C

      case 68: //  D

      case 69: //  E

      case 70: //  F

      case 71: //  G

      case 72: //  H

      case 73: //  I

      case 74: //  J

      case 75: //  K

      case 76: //  L

      case 77: //  M

      case 78: //  N

      case 79: //  O

      case 80: //  P

      case 81: //  Q

      case 82: //  R

      case 83: //  S

      case 84: //  T

      case 85: //  U

      case 86: //  V

      case 87: //  W

      case 88: //  X

      case 89: //  Y

      case 90: //  Z

      case 95: //  _

      case 97: //  a

      case 98: //  b

      case 99: //  c

      case 100: // d

      case 101: // e

      case 102: // f

      case 103: // g

      case 104: // h

      case 105: // i

      case 106: // j

      case 107: // k

      case 108: // l

      case 109: // m

      case 110: // n

      case 111: // o

      case 112: // p

      case 113: // q

      case 114: // r

      case 115: // s

      case 116: // t

      case 117: // u

      case 118: // v

      case 119: // w

      case 120: // x

      case 121: // y

      case 122:
        // z
        return readName(source, pos, _line, _col, prev);
    }

    throw syntaxError(source, pos, unexpectedCharacterMessage(code));
  }

  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;
  return new Token(TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */


function unexpectedCharacterMessage(code) {
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
  }

  if (code === 39) {
    // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
  }

  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */


function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code;
  var position = start;

  do {
    code = body.charCodeAt(++position);
  } while (!isNaN(code) && ( // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new Token(TokenKind.COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */


function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = body.charCodeAt(++position);
  }

  if (code === 48) {
    // 0
    code = body.charCodeAt(++position);

    if (code >= 48 && code <= 57) {
      throw syntaxError(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    }
  } else {
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 46) {
    // .
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;
    code = body.charCodeAt(++position);

    if (code === 43 || code === 45) {
      // + -
      code = body.charCodeAt(++position);
    }

    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart


  if (code === 46 || isNameStart(code)) {
    throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
  }

  return new Token(isFloat ? TokenKind.FLOAT : TokenKind.INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */


function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;

  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = body.charCodeAt(++position);
    } while (code >= 48 && code <= 57); // 0 - 9


    return position;
  }

  throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */


function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += body.slice(chunkStart, position);
      return new Token(TokenKind.STRING, start, position + 1, line, col, prev, value);
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    ++position;

    if (code === 92) {
      // \
      value += body.slice(chunkStart, position - 1);
      code = body.charCodeAt(position);

      switch (code) {
        case 34:
          value += '"';
          break;

        case 47:
          value += '/';
          break;

        case 92:
          value += '\\';
          break;

        case 98:
          value += '\b';
          break;

        case 102:
          value += '\f';
          break;

        case 110:
          value += '\n';
          break;

        case 114:
          value += '\r';
          break;

        case 116:
          value += '\t';
          break;

        case 117:
          {
            // uXXXX
            var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));

            if (charCode < 0) {
              var invalidSequence = body.slice(position + 1, position + 5);
              throw syntaxError(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
            }

            value += String.fromCharCode(charCode);
            position += 4;
            break;
          }

        default:
          throw syntaxError(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
      }

      ++position;
      chunkStart = position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */


function readBlockString(source, start, line, col, prev, lexer) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position))) {
    // Closing Triple-Quote (""")
    if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
      rawValue += body.slice(chunkStart, position);
      return new Token(TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, dedentBlockStringValue(rawValue));
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else if ( // Escape Triple-Quote (\""")
    code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
      rawValue += body.slice(chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */


function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */


function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */


function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;

  while (position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }

  return new Token(TokenKind.NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z


function isNameStart(code) {
  return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function graphql_deps_parse(source, options) {
  var parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

var Parser = /*#__PURE__*/function () {
  function Parser(source, options) {
    var sourceObj = isSource(source) ? source : new Source(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
  }
  /**
   * Converts a name lex token into a name parse node.
   */


  var _proto = Parser.prototype;

  _proto.parseName = function parseName() {
    var token = this.expectToken(TokenKind.NAME);
    return {
      kind: Kind.NAME,
      value: token.value,
      loc: this.loc(token)
    };
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */
  ;

  _proto.parseDocument = function parseDocument() {
    var start = this._lexer.token;
    return {
      kind: Kind.DOCUMENT,
      definitions: this.many(TokenKind.SOF, this.parseDefinition, TokenKind.EOF),
      loc: this.loc(start)
    };
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */
  ;

  _proto.parseDefinition = function parseDefinition() {
    if (this.peek(TokenKind.NAME)) {
      switch (this._lexer.token.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'schema':
        case 'scalar':
        case 'type':
        case 'interface':
        case 'union':
        case 'enum':
        case 'input':
        case 'directive':
          return this.parseTypeSystemDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    } else if (this.peek(TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } else if (this.peekDescription()) {
      return this.parseTypeSystemDefinition();
    }

    throw this.unexpected();
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  ;

  _proto.parseOperationDefinition = function parseOperationDefinition() {
    var start = this._lexer.token;

    if (this.peek(TokenKind.BRACE_L)) {
      return {
        kind: Kind.OPERATION_DEFINITION,
        operation: 'query',
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    var operation = this.parseOperationType();
    var name;

    if (this.peek(TokenKind.NAME)) {
      name = this.parseName();
    }

    return {
      kind: Kind.OPERATION_DEFINITION,
      operation: operation,
      name: name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * OperationType : one of query mutation subscription
   */
  ;

  _proto.parseOperationType = function parseOperationType() {
    var operationToken = this.expectToken(TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return 'query';

      case 'mutation':
        return 'mutation';

      case 'subscription':
        return 'subscription';
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  ;

  _proto.parseVariableDefinitions = function parseVariableDefinitions() {
    return this.optionalMany(TokenKind.PAREN_L, this.parseVariableDefinition, TokenKind.PAREN_R);
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseVariableDefinition = function parseVariableDefinition() {
    var start = this._lexer.token;
    return {
      kind: Kind.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(TokenKind.EQUALS) ? this.parseValueLiteral(true) : undefined,
      directives: this.parseDirectives(true),
      loc: this.loc(start)
    };
  }
  /**
   * Variable : $ Name
   */
  ;

  _proto.parseVariable = function parseVariable() {
    var start = this._lexer.token;
    this.expectToken(TokenKind.DOLLAR);
    return {
      kind: Kind.VARIABLE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  }
  /**
   * SelectionSet : { Selection+ }
   */
  ;

  _proto.parseSelectionSet = function parseSelectionSet() {
    var start = this._lexer.token;
    return {
      kind: Kind.SELECTION_SET,
      selections: this.many(TokenKind.BRACE_L, this.parseSelection, TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  ;

  _proto.parseSelection = function parseSelection() {
    return this.peek(TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  ;

  _proto.parseField = function parseField() {
    var start = this._lexer.token;
    var nameOrAlias = this.parseName();
    var alias;
    var name;

    if (this.expectOptionalToken(TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return {
      kind: Kind.FIELD,
      alias: alias,
      name: name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(TokenKind.BRACE_L) ? this.parseSelectionSet() : undefined,
      loc: this.loc(start)
    };
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  ;

  _proto.parseArguments = function parseArguments(isConst) {
    var item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(TokenKind.PAREN_L, item, TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseArgument = function parseArgument() {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return {
      kind: Kind.ARGUMENT,
      name: name,
      value: this.parseValueLiteral(false),
      loc: this.loc(start)
    };
  };

  _proto.parseConstArgument = function parseConstArgument() {
    var start = this._lexer.token;
    return {
      kind: Kind.ARGUMENT,
      name: this.parseName(),
      value: (this.expectToken(TokenKind.COLON), this.parseValueLiteral(true)),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  ;

  _proto.parseFragment = function parseFragment() {
    var start = this._lexer.token;
    this.expectToken(TokenKind.SPREAD);
    var hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(TokenKind.NAME)) {
      return {
        kind: Kind.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
        loc: this.loc(start)
      };
    }

    return {
      kind: Kind.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  ;

  _proto.parseFragmentDefinition = function parseFragmentDefinition() {
    var _this$_options;

    var start = this._lexer.token;
    this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) {
      return {
        kind: Kind.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    return {
      kind: Kind.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentName : Name but not `on`
   */
  ;

  _proto.parseFragmentName = function parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  ;

  _proto.parseValueLiteral = function parseValueLiteral(isConst) {
    var token = this._lexer.token;

    switch (token.kind) {
      case TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case TokenKind.INT:
        this._lexer.advance();

        return {
          kind: Kind.INT,
          value: token.value,
          loc: this.loc(token)
        };

      case TokenKind.FLOAT:
        this._lexer.advance();

        return {
          kind: Kind.FLOAT,
          value: token.value,
          loc: this.loc(token)
        };

      case TokenKind.STRING:
      case TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case TokenKind.NAME:
        this._lexer.advance();

        switch (token.value) {
          case 'true':
            return {
              kind: Kind.BOOLEAN,
              value: true,
              loc: this.loc(token)
            };

          case 'false':
            return {
              kind: Kind.BOOLEAN,
              value: false,
              loc: this.loc(token)
            };

          case 'null':
            return {
              kind: Kind.NULL,
              loc: this.loc(token)
            };

          default:
            return {
              kind: Kind.ENUM,
              value: token.value,
              loc: this.loc(token)
            };
        }

      case TokenKind.DOLLAR:
        if (!isConst) {
          return this.parseVariable();
        }

        break;
    }

    throw this.unexpected();
  };

  _proto.parseStringLiteral = function parseStringLiteral() {
    var token = this._lexer.token;

    this._lexer.advance();

    return {
      kind: Kind.STRING,
      value: token.value,
      block: token.kind === TokenKind.BLOCK_STRING,
      loc: this.loc(token)
    };
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  ;

  _proto.parseList = function parseList(isConst) {
    var _this = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this.parseValueLiteral(isConst);
    };

    return {
      kind: Kind.LIST,
      values: this.any(TokenKind.BRACKET_L, item, TokenKind.BRACKET_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */
  ;

  _proto.parseObject = function parseObject(isConst) {
    var _this2 = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this2.parseObjectField(isConst);
    };

    return {
      kind: Kind.OBJECT,
      fields: this.any(TokenKind.BRACE_L, item, TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseObjectField = function parseObjectField(isConst) {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return {
      kind: Kind.OBJECT_FIELD,
      name: name,
      value: this.parseValueLiteral(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */
  ;

  _proto.parseDirectives = function parseDirectives(isConst) {
    var directives = [];

    while (this.peek(TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }
  /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */
  ;

  _proto.parseDirective = function parseDirective(isConst) {
    var start = this._lexer.token;
    this.expectToken(TokenKind.AT);
    return {
      kind: Kind.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  ;

  _proto.parseTypeReference = function parseTypeReference() {
    var start = this._lexer.token;
    var type;

    if (this.expectOptionalToken(TokenKind.BRACKET_L)) {
      type = this.parseTypeReference();
      this.expectToken(TokenKind.BRACKET_R);
      type = {
        kind: Kind.LIST_TYPE,
        type: type,
        loc: this.loc(start)
      };
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(TokenKind.BANG)) {
      return {
        kind: Kind.NON_NULL_TYPE,
        type: type,
        loc: this.loc(start)
      };
    }

    return type;
  }
  /**
   * NamedType : Name
   */
  ;

  _proto.parseNamedType = function parseNamedType() {
    var start = this._lexer.token;
    return {
      kind: Kind.NAMED_TYPE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Type Definition section.

  /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
    // Many definitions begin with a description and require a lookahead.
    var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;

    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }
    }

    throw this.unexpected(keywordToken);
  };

  _proto.peekDescription = function peekDescription() {
    return this.peek(TokenKind.STRING) || this.peek(TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  ;

  _proto.parseDescription = function parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */
  ;

  _proto.parseSchemaDefinition = function parseSchemaDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.many(TokenKind.BRACE_L, this.parseOperationTypeDefinition, TokenKind.BRACE_R);
    return {
      kind: Kind.SCHEMA_DEFINITION,
      description: description,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  ;

  _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
    var start = this._lexer.token;
    var operation = this.parseOperationType();
    this.expectToken(TokenKind.COLON);
    var type = this.parseNamedType();
    return {
      kind: Kind.OPERATION_TYPE_DEFINITION,
      operation: operation,
      type: type,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  ;

  _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: Kind.SCALAR_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: Kind.OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  ;

  _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
    var _this$_options2;

    if (!this.expectOptionalKeyword('implements')) {
      return [];
    }

    if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
      var types = []; // Optional leading ampersand

      this.expectOptionalToken(TokenKind.AMP);

      do {
        types.push(this.parseNamedType());
      } while (this.expectOptionalToken(TokenKind.AMP) || this.peek(TokenKind.NAME));

      return types;
    }

    return this.delimitedMany(TokenKind.AMP, this.parseNamedType);
  }
  /**
   * FieldsDefinition : { FieldDefinition+ }
   */
  ;

  _proto.parseFieldsDefinition = function parseFieldsDefinition() {
    var _this$_options3;

    // Legacy support for the SDL?
    if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek(TokenKind.BRACE_L) && this._lexer.lookahead().kind === TokenKind.BRACE_R) {
      this._lexer.advance();

      this._lexer.advance();

      return [];
    }

    return this.optionalMany(TokenKind.BRACE_L, this.parseFieldDefinition, TokenKind.BRACE_R);
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  ;

  _proto.parseFieldDefinition = function parseFieldDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    this.expectToken(TokenKind.COLON);
    var type = this.parseTypeReference();
    var directives = this.parseDirectives(true);
    return {
      kind: Kind.FIELD_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      type: type,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  ;

  _proto.parseArgumentDefs = function parseArgumentDefs() {
    return this.optionalMany(TokenKind.PAREN_L, this.parseInputValueDef, TokenKind.PAREN_R);
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseInputValueDef = function parseInputValueDef() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    this.expectToken(TokenKind.COLON);
    var type = this.parseTypeReference();
    var defaultValue;

    if (this.expectOptionalToken(TokenKind.EQUALS)) {
      defaultValue = this.parseValueLiteral(true);
    }

    var directives = this.parseDirectives(true);
    return {
      kind: Kind.INPUT_VALUE_DEFINITION,
      description: description,
      name: name,
      type: type,
      defaultValue: defaultValue,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: Kind.INTERFACE_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  ;

  _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();
    return {
      kind: Kind.UNION_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  ;

  _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
    return this.expectOptionalToken(TokenKind.EQUALS) ? this.delimitedMany(TokenKind.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  ;

  _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();
    return {
      kind: Kind.ENUM_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */
  ;

  _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
    return this.optionalMany(TokenKind.BRACE_L, this.parseEnumValueDefinition, TokenKind.BRACE_R);
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */
  ;

  _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: Kind.ENUM_VALUE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  ;

  _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();
    return {
      kind: Kind.INPUT_OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */
  ;

  _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
    return this.optionalMany(TokenKind.BRACE_L, this.parseInputValueDef, TokenKind.BRACE_R);
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
    var keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */
  ;

  _proto.parseSchemaExtension = function parseSchemaExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.optionalMany(TokenKind.BRACE_L, this.parseOperationTypeDefinition, TokenKind.BRACE_R);

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.SCHEMA_EXTENSION,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  ;

  _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.SCALAR_TYPE_EXTENSION,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  ;

  _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.OBJECT_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  ;

  _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.INTERFACE_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  ;

  _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.UNION_TYPE_EXTENSION,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  ;

  _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.ENUM_TYPE_EXTENSION,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  ;

  _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.INPUT_OBJECT_TYPE_EXTENSION,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */
  ;

  _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(TokenKind.AT);
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    var repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    var locations = this.parseDirectiveLocations();
    return {
      kind: Kind.DIRECTIVE_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      repeatable: repeatable,
      locations: locations,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  ;

  _proto.parseDirectiveLocations = function parseDirectiveLocations() {
    return this.delimitedMany(TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  ;

  _proto.parseDirectiveLocation = function parseDirectiveLocation() {
    var start = this._lexer.token;
    var name = this.parseName();

    if (DirectiveLocation[name.value] !== undefined) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */
  ;

  _proto.loc = function loc(startToken) {
    var _this$_options4;

    if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) {
      return new Location(startToken, this._lexer.lastToken, this._lexer.source);
    }
  }
  /**
   * Determines if the next token is of a given kind
   */
  ;

  _proto.peek = function peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectToken = function expectToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    throw syntaxError(this._lexer.source, token.start, "Expected ".concat(getTokenKindDesc(kind), ", found ").concat(getTokenDesc(token), "."));
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */
  ;

  _proto.expectOptionalToken = function expectOptionalToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    return undefined;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectKeyword = function expectKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === TokenKind.NAME && token.value === value) {
      this._lexer.advance();
    } else {
      throw syntaxError(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat(getTokenDesc(token), "."));
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  ;

  _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === TokenKind.NAME && token.value === value) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  ;

  _proto.unexpected = function unexpected(atToken) {
    var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token), "."));
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.any = function any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      var nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.many = function many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  ;

  _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  };

  return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  var value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */


function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? "\"".concat(kind, "\"") : kind;
}

function parseDocumentNode(node) {
    var _a;
    const operationDef = node.definitions.find((def) => {
        return def.kind === 'OperationDefinition';
    });
    return {
        operationType: operationDef === null || operationDef === void 0 ? void 0 : operationDef.operation,
        operationName: (_a = operationDef === null || operationDef === void 0 ? void 0 : operationDef.name) === null || _a === void 0 ? void 0 : _a.value,
    };
}
function parseQuery(query) {
    try {
        const ast = graphql_deps_parse(query);
        return parseDocumentNode(ast);
    }
    catch (error) {
        return error;
    }
}
function extractMultipartVariables(variables, map, files) {
    const operations = { variables };
    for (const [key, pathArray] of Object.entries(map)) {
        if (!(key in files)) {
            throw new Error(`Given files do not have a key '${key}' .`);
        }
        for (const dotPath of pathArray) {
            const [lastPath, ...reversedPaths] = dotPath.split('.').reverse();
            const paths = reversedPaths.reverse();
            let target = operations;
            for (const path of paths) {
                if (!(path in target)) {
                    throw new Error(`Property '${paths}' is not in operations.`);
                }
                target = target[path];
            }
            target[lastPath] = files[key];
        }
    }
    return operations.variables;
}
function getGraphQLInput(request) {
    var _a, _b;
    switch (request.method) {
        case 'GET': {
            const query = request.url.searchParams.get('query');
            const variables = request.url.searchParams.get('variables') || '';
            return {
                query,
                variables: jsonParse(variables),
            };
        }
        case 'POST': {
            if ((_a = request.body) === null || _a === void 0 ? void 0 : _a.query) {
                const { query, variables } = request.body;
                return {
                    query,
                    variables,
                };
            }
            // Handle multipart body operations.
            if ((_b = request.body) === null || _b === void 0 ? void 0 : _b.operations) {
                const _c = request.body, { operations, map } = _c, files = __rest(_c, ["operations", "map"]);
                const parsedOperations = jsonParse(operations) || {};
                if (!parsedOperations.query) {
                    return null;
                }
                const parsedMap = jsonParse(map || '') || {};
                const variables = parsedOperations.variables
                    ? extractMultipartVariables(parsedOperations.variables, parsedMap, files)
                    : {};
                return {
                    query: parsedOperations.query,
                    variables,
                };
            }
        }
        default:
            return null;
    }
}
/**
 * Determines if a given request can be considered a GraphQL request.
 * Does not parse the query and does not guarantee its validity.
 */
function parseGraphQLRequest(request) {
    const input = getGraphQLInput(request);
    if (!input || !input.query) {
        return undefined;
    }
    const { query, variables } = input;
    const parsedResult = parseQuery(query);
    if (parsedResult instanceof Error) {
        const requestPublicUrl = getPublicUrlFromRequest(request);
        throw new Error(devUtils.formatMessage('Failed to intercept a GraphQL request to "%s %s": cannot parse query. See the error message from the parser below.\n\n%s', request.method, requestPublicUrl, parsedResult.message));
    }
    return {
        operationType: parsedResult.operationType,
        operationName: parsedResult.operationName,
        variables,
    };
}

function tryCatch(fn, onException) {
    try {
        const result = fn();
        return result;
    }
    catch (error) {
        onException === null || onException === void 0 ? void 0 : onException(error);
    }
}

const graphqlContext = {
    set: set,
    status: fetch_deps_status,
    delay: delay,
    fetch: fetch,
    data: data,
    errors: errors,
    cookie: cookie,
};
function isDocumentNode(value) {
    if (value == null) {
        return false;
    }
    return typeof value === 'object' && 'kind' in value && 'definitions' in value;
}
class GraphQLHandler extends RequestHandler {
    constructor(operationType, operationName, endpoint, resolver) {
        let resolvedOperationName = operationName;
        if (isDocumentNode(operationName)) {
            const parsedNode = parseDocumentNode(operationName);
            if (parsedNode.operationType !== operationType) {
                throw new Error(`Failed to create a GraphQL handler: provided a DocumentNode with a mismatched operation type (expected "${operationType}", but got "${parsedNode.operationType}").`);
            }
            if (!parsedNode.operationName) {
                throw new Error(`Failed to create a GraphQL handler: provided a DocumentNode with no operation name.`);
            }
            resolvedOperationName = parsedNode.operationName;
        }
        const header = operationType === 'all'
            ? `${operationType} (origin: ${endpoint.toString()})`
            : `${operationType} ${resolvedOperationName} (origin: ${endpoint.toString()})`;
        super({
            info: {
                header,
                operationType,
                operationName: resolvedOperationName,
            },
            ctx: graphqlContext,
            resolver,
        });
        this.endpoint = endpoint;
    }
    parse(request) {
        return tryCatch(() => parseGraphQLRequest(request), (error) => console.error(error.message));
    }
    getPublicRequest(request, parsedResult) {
        return Object.assign(Object.assign({}, request), { variables: (parsedResult === null || parsedResult === void 0 ? void 0 : parsedResult.variables) || {} });
    }
    predicate(request, parsedResult) {
        if (!parsedResult) {
            return false;
        }
        if (!parsedResult.operationName) {
            const publicUrl = getPublicUrlFromRequest(request);
            devUtils.warn(`\
Failed to intercept a GraphQL request at "${request.method} ${publicUrl}": unnamed GraphQL operations are not supported.

Consider naming this operation or using "graphql.operation" request handler to intercept GraphQL requests regardless of their operation name/type. Read more: https://mswjs.io/docs/api/graphql/operation\
      `);
            return false;
        }
        const hasMatchingUrl = matchRequestUrl(request.url, this.endpoint);
        const hasMatchingOperationType = this.info.operationType === 'all' ||
            parsedResult.operationType === this.info.operationType;
        const hasMatchingOperationName = this.info.operationName instanceof RegExp
            ? this.info.operationName.test(parsedResult.operationName)
            : parsedResult.operationName === this.info.operationName;
        return (hasMatchingUrl.matches &&
            hasMatchingOperationType &&
            hasMatchingOperationName);
    }
    log(request, response, handler, parsedRequest) {
        const loggedRequest = prepareRequest(request);
        const loggedResponse = prepareResponse(response);
        const statusColor = getStatusCodeColor(response.status);
        console.groupCollapsed(devUtils.formatMessage('%s %s (%c%s%c)'), getTimestamp(), `${parsedRequest === null || parsedRequest === void 0 ? void 0 : parsedRequest.operationType} ${parsedRequest === null || parsedRequest === void 0 ? void 0 : parsedRequest.operationName}`, `color:${statusColor}`, `${response.status} ${response.statusText}`, 'color:inherit');
        console.log('Request:', loggedRequest);
        console.log('Handler:', this);
        console.log('Response:', loggedResponse);
        console.groupEnd();
    }
}

function createScopedGraphQLHandler(operationType, url) {
    return (operationName, resolver) => {
        return new GraphQLHandler(operationType, operationName, url, resolver);
    };
}
function createGraphQLOperationHandler(url) {
    return (resolver) => {
        return new GraphQLHandler('all', new RegExp('.*'), url, resolver);
    };
}
const standardGraphQLHandlers = {
    /**
     * Captures any GraphQL operation, regardless of its name, under the current scope.
     * @example
     * graphql.operation((req, res, ctx) => {
     *   return res(ctx.data({ name: 'John' }))
     * })
     * @see {@link https://mswjs.io/docs/api/graphql/operation `graphql.operation()`}
     */
    operation: createGraphQLOperationHandler('*'),
    /**
     * Captures a GraphQL query by a given name.
     * @example
     * graphql.query('GetUser', (req, res, ctx) => {
     *   return res(ctx.data({ user: { name: 'John' } }))
     * })
     * @see {@link https://mswjs.io/docs/api/graphql/query `graphql.query()`}
     */
    query: createScopedGraphQLHandler('query', '*'),
    /**
     * Captures a GraphQL mutation by a given name.
     * @example
     * graphql.mutation('SavePost', (req, res, ctx) => {
     *   return res(ctx.data({ post: { id: 'abc-123' } }))
     * })
     * @see {@link https://mswjs.io/docs/api/graphql/mutation `graphql.mutation()`}
     */
    mutation: createScopedGraphQLHandler('mutation', '*'),
};
function createGraphQLLink(url) {
    return {
        operation: createGraphQLOperationHandler(url),
        query: createScopedGraphQLHandler('query', url),
        mutation: createScopedGraphQLHandler('mutation', url),
    };
}
const graphql = Object.assign(Object.assign({}, standardGraphQLHandlers), { link: createGraphQLLink });



// EXTERNAL MODULE: ./node_modules/.pnpm/debug@4.3.4/node_modules/debug/src/browser.js
var browser = __webpack_require__(37820);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./node_modules/.pnpm/msw@0.35.0/node_modules/msw/lib/esm/index.js
/* provided dependency */ var esm_process = __webpack_require__(14224);












var lib$3 = {};

var StrictEventEmitter$1 = {};

var events = {exports: {}};

var R = typeof Reflect === 'object' ? Reflect : null;
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  };

var ReflectOwnKeys;
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys;
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
};

function EventEmitter() {
  EventEmitter.init.call(this);
}
events.exports = EventEmitter;
events.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}

var __extends$1 = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (commonjsGlobal && commonjsGlobal.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
StrictEventEmitter$1.__esModule = true;
StrictEventEmitter$1.StrictEventEmitter = void 0;
var events_1 = events.exports;
var StrictEventEmitter = /** @class */ (function (_super) {
    __extends$1(StrictEventEmitter, _super);
    function StrictEventEmitter() {
        return _super.call(this) || this;
    }
    StrictEventEmitter.prototype.on = function (event, listener) {
        return _super.prototype.on.call(this, event.toString(), listener);
    };
    StrictEventEmitter.prototype.once = function (event, listener) {
        return _super.prototype.on.call(this, event.toString(), listener);
    };
    StrictEventEmitter.prototype.off = function (event, listener) {
        return _super.prototype.off.call(this, event.toString(), listener);
    };
    StrictEventEmitter.prototype.emit = function (event) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        return _super.prototype.emit.apply(this, __spreadArrays([event.toString()], data));
    };
    StrictEventEmitter.prototype.addListener = function (event, listener) {
        return _super.prototype.addListener.call(this, event.toString(), listener);
    };
    StrictEventEmitter.prototype.removeListener = function (event, listener) {
        return _super.prototype.removeListener.call(this, event.toString(), listener);
    };
    return StrictEventEmitter;
}(events_1.EventEmitter));
StrictEventEmitter$1.StrictEventEmitter = StrictEventEmitter;

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.StrictEventEmitter = void 0;
var StrictEventEmitter_1 = StrictEventEmitter$1;
__createBinding(exports, StrictEventEmitter_1, "StrictEventEmitter");
}(lib$3));

var lib$2 = {};

var until$1 = {};

Object.defineProperty(until$1, "__esModule", { value: true });
/**
 * Gracefully handles a given Promise factory.
 * @example
 * cosnt [error, data] = await until(() => asyncAction())
 */
until$1.until = async (promise) => {
    try {
        const data = await promise().catch((error) => {
            throw error;
        });
        return [null, data];
    }
    catch (error) {
        return [error, null];
    }
};

Object.defineProperty(lib$2, "__esModule", { value: true });
var until_1$1 = until$1;
var until = lib$2.until = until_1$1.until;

/**
 * Attempts to resolve a Service Worker instance from a given registration,
 * regardless of its state (active, installing, waiting).
 */
const getWorkerByRegistration = (registration, absoluteWorkerUrl, findWorker) => {
    const allStates = [
        registration.active,
        registration.installing,
        registration.waiting,
    ];
    const existingStates = allStates.filter(Boolean);
    const mockWorker = existingStates.find((worker) => {
        return findWorker(worker.scriptURL, absoluteWorkerUrl);
    });
    return mockWorker || null;
};

/**
 * Returns an absolute Service Worker URL based on the given
 * relative URL (known during the registration).
 */
function getAbsoluteWorkerUrl(relativeUrl) {
    return new URL(relativeUrl, location.origin).href;
}

/**
 * Returns an active Service Worker instance.
 * When not found, registers a new Service Worker.
 */
const getWorkerInstance = (url, options = {}, findWorker) => __awaiter(void 0, void 0, void 0, function* () {
    // Resolve the absolute Service Worker URL.
    const absoluteWorkerUrl = getAbsoluteWorkerUrl(url);
    const mockRegistrations = yield navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => registrations.filter((registration) => getWorkerByRegistration(registration, absoluteWorkerUrl, findWorker)));
    if (!navigator.serviceWorker.controller && mockRegistrations.length > 0) {
        // Reload the page when it has associated workers, but no active controller.
        // The absence of a controller can mean either:
        // - page has no Service Worker associated with it
        // - page has been hard-reloaded and its workers won't be used until the next reload.
        // Since we've checked that there are registrations associated with this page,
        // at this point we are sure it's hard reload that falls into this clause.
        location.reload();
    }
    const [existingRegistration] = mockRegistrations;
    if (existingRegistration) {
        // When the Service Worker is registered, update it and return the reference.
        return existingRegistration.update().then(() => {
            return [
                getWorkerByRegistration(existingRegistration, absoluteWorkerUrl, findWorker),
                existingRegistration,
            ];
        });
    }
    // When the Service Worker wasn't found, register it anew and return the reference.
    const [error, instance] = yield until(() => __awaiter(void 0, void 0, void 0, function* () {
        const registration = yield navigator.serviceWorker.register(url, options);
        return [
            // Compare existing worker registration by its worker URL,
            // to prevent irrelevant workers to resolve here (such as Codesandbox worker).
            getWorkerByRegistration(registration, absoluteWorkerUrl, findWorker),
            registration,
        ];
    }));
    // Handle Service Worker registration errors.
    if (error) {
        const isWorkerMissing = error.message.includes('(404)');
        // Produce a custom error message when given a non-existing Service Worker url.
        // Suggest developers to check their setup.
        if (isWorkerMissing) {
            const scopeUrl = new URL((options === null || options === void 0 ? void 0 : options.scope) || '/', location.href);
            throw new Error(devUtils.formatMessage(`\
Failed to register a Service Worker for scope ('${scopeUrl.href}') with script ('${absoluteWorkerUrl}'): Service Worker script does not exist at the given path.

Did you forget to run "npx msw init <PUBLIC_DIR>"?

Learn more about creating the Service Worker script: https://mswjs.io/docs/cli/init`));
        }
        // Fallback error message for any other registration errors.
        throw new Error(devUtils.formatMessage('Failed to register the Service Worker:\n\n%s', error.message));
    }
    return instance;
});

/**
 * Prints a worker activation message in the browser's console.
 */
function printStartMessage(args = {}) {
    if (args.quiet) {
        return;
    }
    const message = args.message || 'Mocking enabled.';
    console.groupCollapsed(`%c${devUtils.formatMessage(message)}`, 'color:orangered;font-weight:bold;');
    console.log('%cDocumentation: %chttps://mswjs.io/docs', 'font-weight:bold', 'font-weight:normal');
    console.log('Found an issue? https://github.com/mswjs/msw/issues');
    console.groupEnd();
}

/**
 * Signals the worker to enable the interception of requests.
 */
function enableMocking(context, options) {
    return __awaiter(this, void 0, void 0, function* () {
        context.workerChannel.send('MOCK_ACTIVATE');
        return context.events.once('MOCKING_ENABLED').then(() => {
            printStartMessage({ quiet: options.quiet });
        });
    });
}

/**
 * Creates a communication channel between the client
 * and the Service Worker associated with the given event.
 */
const createBroadcastChannel = (event) => {
    const port = event.ports[0];
    return {
        /**
         * Sends a text message to the connected Service Worker.
         */
        send(message) {
            if (port) {
                port.postMessage(message);
            }
        },
    };
};

var esm_lib$1 = {};

var CookieStore = {};

var setCookie = {exports: {}};

var defaultParseOptions = {
  decodeValues: true,
  map: false,
  silent: false,
};

function isNonEmptyString(str) {
  return typeof str === "string" && !!str.trim();
}

function parseString(setCookieValue, options) {
  var parts = setCookieValue.split(";").filter(isNonEmptyString);
  var nameValue = parts.shift().split("=");
  var name = nameValue.shift();
  var value = nameValue.join("="); // everything after the first =, joined by a "=" if there was more than one part

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  try {
    value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
  } catch (e) {
    console.error(
      "set-cookie-parser encountered an error while decoding a cookie with value '" +
        value +
        "'. Set options.decodeValues to false to disable this feature.",
      e
    );
  }

  var cookie = {
    name: name, // grab everything before the first =
    value: value,
  };

  parts.forEach(function (part) {
    var sides = part.split("=");
    var key = sides.shift().trimLeft().toLowerCase();
    var value = sides.join("=");
    if (key === "expires") {
      cookie.expires = new Date(value);
    } else if (key === "max-age") {
      cookie.maxAge = parseInt(value, 10);
    } else if (key === "secure") {
      cookie.secure = true;
    } else if (key === "httponly") {
      cookie.httpOnly = true;
    } else if (key === "samesite") {
      cookie.sameSite = value;
    } else {
      cookie[key] = value;
    }
  });

  return cookie;
}

function parse$1(input, options) {
  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!input) {
    if (!options.map) {
      return [];
    } else {
      return {};
    }
  }

  if (input.headers && input.headers["set-cookie"]) {
    // fast-path for node.js (which automatically normalizes header names to lower-case
    input = input.headers["set-cookie"];
  } else if (input.headers) {
    // slow-path for other environments - see #25
    var sch =
      input.headers[
        Object.keys(input.headers).find(function (key) {
          return key.toLowerCase() === "set-cookie";
        })
      ];
    // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
    if (!sch && input.headers.cookie && !options.silent) {
      console.warn(
        "Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning."
      );
    }
    input = sch;
  }
  if (!Array.isArray(input)) {
    input = [input];
  }

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!options.map) {
    return input.filter(isNonEmptyString).map(function (str) {
      return parseString(str, options);
    });
  } else {
    var cookies = {};
    return input.filter(isNonEmptyString).reduce(function (cookies, str) {
      var cookie = parseString(str, options);
      cookies[cookie.name] = cookie;
      return cookies;
    }, cookies);
  }
}

/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/
function splitCookiesString(cookiesString) {
  if (Array.isArray(cookiesString)) {
    return cookiesString;
  }
  if (typeof cookiesString !== "string") {
    return [];
  }

  var cookiesStrings = [];
  var pos = 0;
  var start;
  var ch;
  var lastComma;
  var nextStart;
  var cookiesSeparatorFound;

  function skipWhitespace() {
    while (pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos))) {
      pos += 1;
    }
    return pos < cookiesString.length;
  }

  function notSpecialChar() {
    ch = cookiesString.charAt(pos);

    return ch !== "=" && ch !== ";" && ch !== ",";
  }

  while (pos < cookiesString.length) {
    start = pos;
    cookiesSeparatorFound = false;

    while (skipWhitespace()) {
      ch = cookiesString.charAt(pos);
      if (ch === ",") {
        // ',' is a cookie separator if we have later first '=', not ';' or ','
        lastComma = pos;
        pos += 1;

        skipWhitespace();
        nextStart = pos;

        while (pos < cookiesString.length && notSpecialChar()) {
          pos += 1;
        }

        // currently special character
        if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
          // we found cookies separator
          cookiesSeparatorFound = true;
          // pos is inside the next cookie, so back up and return it.
          pos = nextStart;
          cookiesStrings.push(cookiesString.substring(start, lastComma));
          start = pos;
        } else {
          // in param ',' or param separator ';',
          // we continue from that comma
          pos = lastComma + 1;
        }
      } else {
        pos += 1;
      }
    }

    if (!cookiesSeparatorFound || pos >= cookiesString.length) {
      cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
  }

  return cookiesStrings;
}

setCookie.exports = parse$1;
setCookie.exports.parse = parse$1;
setCookie.exports.parseString = parseString;
setCookie.exports.splitCookiesString = splitCookiesString;

(function (exports) {
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERSISTENCY_KEY = void 0;
const set_cookie_parser_1 = setCookie.exports;
exports.PERSISTENCY_KEY = 'MSW_COOKIE_STORE';
const SUPPORTS_LOCAL_STORAGE = typeof localStorage !== 'undefined';
class CookieStore {
    constructor() {
        this.store = new Map();
    }
    /**
     * Sets the given request cookies into the store.
     * Respects the `request.credentials` policy.
     */
    add(request, response) {
        if (request.credentials === 'omit') {
            return;
        }
        const requestUrl = new URL(request.url);
        const responseCookies = response.headers.get('set-cookie');
        if (!responseCookies) {
            return;
        }
        const now = Date.now();
        const parsedResponseCookies = set_cookie_parser_1.parse(responseCookies).map((_a) => {
            var { maxAge } = _a, cookie = __rest(_a, ["maxAge"]);
            return (Object.assign(Object.assign({}, cookie), { expires: maxAge === undefined ? cookie.expires : new Date(now + maxAge * 1000), maxAge }));
        });
        const prevCookies = this.store.get(requestUrl.origin) || new Map();
        parsedResponseCookies.forEach((cookie) => {
            this.store.set(requestUrl.origin, prevCookies.set(cookie.name, cookie));
        });
    }
    /**
     * Returns cookies relevant to the given request
     * and its `request.credentials` policy.
     */
    get(request) {
        this.deleteExpiredCookies();
        const requestUrl = new URL(request.url);
        const originCookies = this.store.get(requestUrl.origin) || new Map();
        switch (request.credentials) {
            case 'include': {
                const documentCookies = set_cookie_parser_1.parse(document.cookie);
                documentCookies.forEach((cookie) => {
                    originCookies.set(cookie.name, cookie);
                });
                return originCookies;
            }
            case 'same-origin': {
                return originCookies;
            }
            default:
                return new Map();
        }
    }
    /**
     * Returns a collection of all stored cookies.
     */
    getAll() {
        this.deleteExpiredCookies();
        return this.store;
    }
    /**
     * Deletes all cookies associated with the given request.
     */
    deleteAll(request) {
        const requestUrl = new URL(request.url);
        this.store.delete(requestUrl.origin);
    }
    /**
     * Clears the entire cookie store.
     */
    clear() {
        this.store.clear();
    }
    /**
     * Hydrates the virtual cookie store from the `localStorage` if defined.
     */
    hydrate() {
        if (!SUPPORTS_LOCAL_STORAGE) {
            return;
        }
        const persistedCookies = localStorage.getItem(exports.PERSISTENCY_KEY);
        if (persistedCookies) {
            try {
                const parsedCookies = JSON.parse(persistedCookies);
                parsedCookies.forEach(([origin, cookies]) => {
                    this.store.set(origin, new Map(cookies.map((_a) => {
                        var [token, _b] = _a, { expires } = _b, cookie = __rest(_b, ["expires"]);
                        return [
                            token,
                            expires === undefined
                                ? cookie
                                : Object.assign(Object.assign({}, cookie), { expires: new Date(expires) }),
                        ];
                    })));
                });
            }
            catch (error) {
                console.warn(`
[virtual-cookie] Failed to parse a stored cookie from the localStorage (key "${exports.PERSISTENCY_KEY}").

Stored value:
${localStorage.getItem(exports.PERSISTENCY_KEY)}

Thrown exception:
${error}

Invalid value has been removed from localStorage to prevent subsequent failed parsing attempts.`);
                localStorage.removeItem(exports.PERSISTENCY_KEY);
            }
        }
    }
    /**
     * Persists the current virtual cookies into the `localStorage` if defined,
     * so they are available on the next page load.
     */
    persist() {
        if (!SUPPORTS_LOCAL_STORAGE) {
            return;
        }
        const serializedCookies = Array.from(this.store.entries()).map(([origin, cookies]) => {
            return [origin, Array.from(cookies.entries())];
        });
        localStorage.setItem(exports.PERSISTENCY_KEY, JSON.stringify(serializedCookies));
    }
    deleteExpiredCookies() {
        const now = Date.now();
        this.store.forEach((originCookies, origin) => {
            originCookies.forEach(({ expires, name }) => {
                if (expires !== undefined && expires.getTime() <= now) {
                    originCookies.delete(name);
                }
            });
            if (originCookies.size === 0) {
                this.store.delete(origin);
            }
        });
    }
}
exports.default = new CookieStore();
}(CookieStore));

(function (exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERSISTENCY_KEY = exports.store = void 0;
var CookieStore_1 = CookieStore;
Object.defineProperty(exports, "store", { enumerable: true, get: function () { return __importDefault(CookieStore_1).default; } });
Object.defineProperty(exports, "PERSISTENCY_KEY", { enumerable: true, get: function () { return CookieStore_1.PERSISTENCY_KEY; } });
}(esm_lib$1));

function getAllCookies() {
    return parse_1(document.cookie);
}
/**
 * Returns relevant document cookies based on the request `credentials` option.
 */
function getRequestCookies(request) {
    /**
     * @note No cookies persist on the document in Node.js: no document.
     */
    if (typeof location === 'undefined') {
        return {};
    }
    switch (request.credentials) {
        case 'same-origin': {
            // Return document cookies only when requested a resource
            // from the same origin as the current document.
            return location.origin === request.url.origin ? getAllCookies() : {};
        }
        case 'include': {
            // Return all document cookies.
            return getAllCookies();
        }
        default: {
            return {};
        }
    }
}

function setRequestCookies(request) {
    var _a;
    esm_lib$1.store.hydrate();
    request.cookies = Object.assign(Object.assign({}, getRequestCookies(request)), Array.from((_a = esm_lib$1.store.get(Object.assign(Object.assign({}, request), { url: request.url.toString() }))) === null || _a === void 0 ? void 0 : _a.entries()).reduce((cookies, [name, { value }]) => Object.assign(cookies, { [name]: value }), {}));
    request.headers.set('cookie', Object.entries(request.cookies)
        .map(([name, value]) => `${name}=${value}`)
        .join('; '));
}

/**
 * Ensures that an empty GET request body is always represented as `undefined`.
 */
function pruneGetRequestBody(request) {
    if (request.method &&
        isStringEqual(request.method, 'GET') &&
        request.body === '') {
        return undefined;
    }
    return request.body;
}

/**
 * Converts a given request received from the Service Worker
 * into a `MockedRequest` instance.
 */
function parseWorkerRequest(rawRequest) {
    const request = {
        id: rawRequest.id,
        cache: rawRequest.cache,
        credentials: rawRequest.credentials,
        method: rawRequest.method,
        url: new URL(rawRequest.url),
        referrer: rawRequest.referrer,
        referrerPolicy: rawRequest.referrerPolicy,
        redirect: rawRequest.redirect,
        mode: rawRequest.mode,
        params: {},
        cookies: {},
        integrity: rawRequest.integrity,
        keepalive: rawRequest.keepalive,
        destination: rawRequest.destination,
        body: pruneGetRequestBody(rawRequest),
        bodyUsed: rawRequest.bodyUsed,
        headers: new lib$1.Headers(rawRequest.headers),
    };
    // Set document cookies on the request.
    setRequestCookies(request);
    // Parse the request's body based on the "Content-Type" header.
    request.body = parseBody(request.body, request.headers);
    return request;
}

/**
 * Returns a mocked response for a given request using following request handlers.
 */
const getResponse = (request, handlers, resolutionContext) => __awaiter(void 0, void 0, void 0, function* () {
    const relevantHandlers = handlers.filter((handler) => {
        return handler.test(request, resolutionContext);
    });
    if (relevantHandlers.length === 0) {
        return {
            handler: undefined,
            response: undefined,
        };
    }
    const result = yield relevantHandlers.reduce((executionResult, handler) => __awaiter(void 0, void 0, void 0, function* () {
        const previousResults = yield executionResult;
        if (!!(previousResults === null || previousResults === void 0 ? void 0 : previousResults.response)) {
            return executionResult;
        }
        const result = yield handler.run(request, resolutionContext);
        if (result === null || result.handler.shouldSkip) {
            return null;
        }
        if (!result.response) {
            return {
                request: result.request,
                handler: result.handler,
                response: undefined,
                parsedResult: result.parsedResult,
            };
        }
        if (result.response.once) {
            handler.markAsSkipped(true);
        }
        return result;
    }), Promise.resolve(null));
    // Although reducing a list of relevant request handlers, it's possible
    // that in the end there will be no handler associted with the request
    // (i.e. if relevant handlers are fall-through).
    if (!result) {
        return {
            handler: undefined,
            response: undefined,
        };
    }
    return {
        handler: result.handler,
        publicRequest: result.request,
        parsedRequest: result.parsedResult,
        response: result.response,
    };
});

var jsLevenshtein = (function()
{
  function _min(d0, d1, d2, bx, ay)
  {
    return d0 < d1 || d2 < d1
        ? d0 > d2
            ? d2 + 1
            : d0 + 1
        : bx === ay
            ? d1
            : d1 + 1;
  }

  return function(a, b)
  {
    if (a === b) {
      return 0;
    }

    if (a.length > b.length) {
      var tmp = a;
      a = b;
      b = tmp;
    }

    var la = a.length;
    var lb = b.length;

    while (la > 0 && (a.charCodeAt(la - 1) === b.charCodeAt(lb - 1))) {
      la--;
      lb--;
    }

    var offset = 0;

    while (offset < la && (a.charCodeAt(offset) === b.charCodeAt(offset))) {
      offset++;
    }

    la -= offset;
    lb -= offset;

    if (la === 0 || lb < 3) {
      return lb;
    }

    var x = 0;
    var y;
    var d0;
    var d1;
    var d2;
    var d3;
    var dd;
    var dy;
    var ay;
    var bx0;
    var bx1;
    var bx2;
    var bx3;

    var vector = [];

    for (y = 0; y < la; y++) {
      vector.push(y + 1);
      vector.push(a.charCodeAt(offset + y));
    }

    var len = vector.length - 1;

    for (; x < lb - 3;) {
      bx0 = b.charCodeAt(offset + (d0 = x));
      bx1 = b.charCodeAt(offset + (d1 = x + 1));
      bx2 = b.charCodeAt(offset + (d2 = x + 2));
      bx3 = b.charCodeAt(offset + (d3 = x + 3));
      dd = (x += 4);
      for (y = 0; y < len; y += 2) {
        dy = vector[y];
        ay = vector[y + 1];
        d0 = _min(dy, d0, d1, bx0, ay);
        d1 = _min(d0, d1, d2, bx1, ay);
        d2 = _min(d1, d2, d3, bx2, ay);
        dd = _min(d2, d3, dd, bx3, ay);
        vector[y] = dd;
        d3 = d2;
        d2 = d1;
        d1 = d0;
        d0 = dy;
      }
    }

    for (; x < lb;) {
      bx0 = b.charCodeAt(offset + (d0 = x));
      dd = ++x;
      for (y = 0; y < len; y += 2) {
        dy = vector[y];
        vector[y] = dd = _min(dy, d0, dd, bx0, vector[y + 1]);
        d0 = dy;
      }
    }

    return dd;
  };
})();

const MAX_MATCH_SCORE = 3;
const MAX_SUGGESTION_COUNT = 4;
const TYPE_MATCH_DELTA = 0.5;
function groupHandlersByType(handlers) {
    return handlers.reduce((groups, handler) => {
        if (handler instanceof RestHandler) {
            groups.rest.push(handler);
        }
        if (handler instanceof GraphQLHandler) {
            groups.graphql.push(handler);
        }
        return groups;
    }, {
        rest: [],
        graphql: [],
    });
}
function getScoreForRestHandler() {
    return (request, handler) => {
        const { path, method } = handler.info;
        if (path instanceof RegExp) {
            return Infinity;
        }
        const hasSameMethod = isStringEqual(request.method, method);
        // Always treat a handler with the same method as a more similar one.
        const methodScoreDelta = hasSameMethod ? TYPE_MATCH_DELTA : 0;
        const requestPublicUrl = getPublicUrlFromRequest(request);
        const score = jsLevenshtein(requestPublicUrl, path);
        return score - methodScoreDelta;
    };
}
function getScoreForGraphQLHandler(parsedQuery) {
    return (_, handler) => {
        if (typeof parsedQuery.operationName === 'undefined') {
            return Infinity;
        }
        const { operationType, operationName } = handler.info;
        const hasSameOperationType = parsedQuery.operationType === operationType;
        // Always treat a handler with the same operation type as a more similar one.
        const operationTypeScoreDelta = hasSameOperationType ? TYPE_MATCH_DELTA : 0;
        const score = jsLevenshtein(parsedQuery.operationName, operationName);
        return score - operationTypeScoreDelta;
    };
}
function getSuggestedHandler(request, handlers, getScore) {
    const suggestedHandlers = handlers
        .reduce((acc, handler) => {
        const score = getScore(request, handler);
        return acc.concat([[score, handler]]);
    }, [])
        .sort(([leftScore], [rightScore]) => {
        return leftScore - rightScore;
    })
        .filter(([score]) => {
        return score <= MAX_MATCH_SCORE;
    })
        .slice(0, MAX_SUGGESTION_COUNT)
        .map(([, handler]) => handler);
    return suggestedHandlers;
}
function getSuggestedHandlersMessage(handlers) {
    if (handlers.length > 1) {
        return `\
Did you mean to request one of the following resources instead?

${handlers.map((handler) => `  • ${handler.info.header}`).join('\n')}`;
    }
    return `Did you mean to request "${handlers[0].info.header}" instead?`;
}
function onUnhandledRequest(request, handlers, strategy = 'warn') {
    if (typeof strategy === 'function') {
        strategy(request);
        return;
    }
    /**
     * @note Ignore exceptions during GraphQL request parsing because at this point
     * we cannot assume the unhandled request is a valid GraphQL request.
     * If the GraphQL parsing fails, just don't treat it as a GraphQL request.
     */
    const parsedGraphQLQuery = tryCatch(() => parseGraphQLRequest(request));
    const handlerGroups = groupHandlersByType(handlers);
    const relevantHandlers = parsedGraphQLQuery
        ? handlerGroups.graphql
        : handlerGroups.rest;
    const suggestedHandlers = getSuggestedHandler(request, relevantHandlers, parsedGraphQLQuery
        ? getScoreForGraphQLHandler(parsedGraphQLQuery)
        : getScoreForRestHandler());
    const handlerSuggestion = suggestedHandlers.length > 0
        ? getSuggestedHandlersMessage(suggestedHandlers)
        : '';
    const publicUrl = getPublicUrlFromRequest(request);
    const requestHeader = parsedGraphQLQuery
        ? `${parsedGraphQLQuery.operationType} ${parsedGraphQLQuery.operationName} (${request.method} ${publicUrl})`
        : `${request.method} ${publicUrl}`;
    const messageTemplate = [
        `captured a request without a matching request handler:`,
        `  \u2022 ${requestHeader}`,
        handlerSuggestion,
        `\
If you still wish to intercept this unhandled request, please create a request handler for it.
Read more: https://mswjs.io/docs/getting-started/mocks\
`,
    ].filter(Boolean);
    const message = messageTemplate.join('\n\n');
    switch (strategy) {
        case 'error': {
            // Print a developer-friendly error.
            devUtils.error('Error: %s', message);
            // Throw an exception to halt request processing and not perform the original request.
            throw new Error('Cannot bypass a request when using the "error" strategy for the "onUnhandledRequest" option.');
        }
        case 'warn': {
            devUtils.warn('Warning: %s', message);
            break;
        }
        case 'bypass':
            break;
        default:
            throw new Error(devUtils.formatMessage('Failed to react to an unhandled request: unknown strategy "%s". Please provide one of the supported strategies ("bypass", "warn", "error") or a custom callback function as the value of the "onUnhandledRequest" option.', strategy));
    }
}

function readResponseCookies(request, response) {
    esm_lib$1.store.add(Object.assign(Object.assign({}, request), { url: request.url.toString() }), response);
    esm_lib$1.store.persist();
}

function handleRequest(request, handlers, options, emitter, handleRequestOptions) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        emitter.emit('request:start', request);
        // Perform bypassed requests (i.e. issued via "ctx.fetch") as-is.
        if (request.headers.get('x-msw-bypass')) {
            emitter.emit('request:end', request);
            (_a = handleRequestOptions === null || handleRequestOptions === void 0 ? void 0 : handleRequestOptions.onBypassResponse) === null || _a === void 0 ? void 0 : _a.call(handleRequestOptions, request);
            return;
        }
        // Resolve a mocked response from the list of request handlers.
        const lookupResult = yield getResponse(request, handlers, handleRequestOptions === null || handleRequestOptions === void 0 ? void 0 : handleRequestOptions.resolutionContext);
        const { handler, response } = lookupResult;
        // When there's no handler for the request, consider it unhandled.
        // Allow the developer to react to such cases.
        if (!handler) {
            onUnhandledRequest(request, handlers, options.onUnhandledRequest);
            emitter.emit('request:unhandled', request);
            emitter.emit('request:end', request);
            (_b = handleRequestOptions === null || handleRequestOptions === void 0 ? void 0 : handleRequestOptions.onBypassResponse) === null || _b === void 0 ? void 0 : _b.call(handleRequestOptions, request);
            return;
        }
        // When the handled request returned no mocked response, warn the developer,
        // as it may be an oversight on their part. Perform the request as-is.
        if (!response) {
            devUtils.warn('Expected a mocking resolver function to return a mocked response Object, but got: %s. Original response is going to be used instead.', response);
            emitter.emit('request:end', request);
            (_c = handleRequestOptions === null || handleRequestOptions === void 0 ? void 0 : handleRequestOptions.onBypassResponse) === null || _c === void 0 ? void 0 : _c.call(handleRequestOptions, request);
            return;
        }
        // Store all the received response cookies in the virtual cookie store.
        readResponseCookies(request, response);
        emitter.emit('request:match', request);
        return new Promise((resolve) => {
            var _a, _b, _c;
            const requiredLookupResult = lookupResult;
            const transformedResponse = ((_a = handleRequestOptions === null || handleRequestOptions === void 0 ? void 0 : handleRequestOptions.transformResponse) === null || _a === void 0 ? void 0 : _a.call(handleRequestOptions, response)) ||
                response;
            (_b = handleRequestOptions === null || handleRequestOptions === void 0 ? void 0 : handleRequestOptions.onMockedResponse) === null || _b === void 0 ? void 0 : _b.call(handleRequestOptions, transformedResponse, requiredLookupResult);
            setTimeout(() => {
                var _a;
                (_a = handleRequestOptions === null || handleRequestOptions === void 0 ? void 0 : handleRequestOptions.onMockedResponseSent) === null || _a === void 0 ? void 0 : _a.call(handleRequestOptions, transformedResponse, requiredLookupResult);
                emitter.emit('request:end', request);
                resolve(transformedResponse);
            }, (_c = response.delay) !== null && _c !== void 0 ? _c : 0);
        });
    });
}

const createRequestListener = (context, options) => {
    return (event, message) => __awaiter(void 0, void 0, void 0, function* () {
        const channel = createBroadcastChannel(event);
        try {
            const request = parseWorkerRequest(message.payload);
            yield handleRequest(request, context.requestHandlers, options, context.emitter, {
                transformResponse(response) {
                    return Object.assign(Object.assign({}, response), { headers: response.headers.all() });
                },
                onBypassResponse() {
                    return channel.send({
                        type: 'MOCK_NOT_FOUND',
                    });
                },
                onMockedResponse(response) {
                    channel.send({
                        type: 'MOCK_SUCCESS',
                        payload: response,
                    });
                },
                onMockedResponseSent(response, { handler, publicRequest, parsedRequest }) {
                    if (!options.quiet) {
                        handler.log(publicRequest, response, handler, parsedRequest);
                    }
                },
            });
        }
        catch (error) {
            if (error instanceof NetworkError) {
                // Treat emulated network error differently,
                // as it is an intended exception in a request handler.
                return channel.send({
                    type: 'NETWORK_ERROR',
                    payload: {
                        name: error.name,
                        message: error.message,
                    },
                });
            }
            // Treat all the other exceptions in a request handler
            // as unintended, alerting that there is a problem needs fixing.
            channel.send({
                type: 'INTERNAL_ERROR',
                payload: {
                    status: 500,
                    body: JSON.stringify({
                        errorType: error.constructor.name,
                        message: error.message,
                        location: error.stack,
                    }),
                },
            });
        }
    });
};

function requestIntegrityCheck(context, serviceWorker) {
    return __awaiter(this, void 0, void 0, function* () {
        // Signal Service Worker to report back its integrity
        context.workerChannel.send('INTEGRITY_CHECK_REQUEST');
        const { payload: actualChecksum } = yield context.events.once('INTEGRITY_CHECK_RESPONSE');
        // Compare the response from the Service Worker and the
        // global variable set by Rollup during the build.
        if (actualChecksum !== "f0a916b13c8acc2b526a03a6d26df85f") {
            throw new Error(`Currently active Service Worker (${actualChecksum}) is behind the latest published one (${"f0a916b13c8acc2b526a03a6d26df85f"}).`);
        }
        return serviceWorker;
    });
}

/**
 * Intercepts and defers any requests on the page
 * until the Service Worker instance is ready.
 * Must only be used in a browser.
 */
function deferNetworkRequestsUntil(predicatePromise) {
    // Defer any `XMLHttpRequest` requests until the Service Worker is ready.
    const originalXhrSend = window.XMLHttpRequest.prototype.send;
    window.XMLHttpRequest.prototype.send = function (...args) {
        // Keep this function synchronous to comply with `XMLHttpRequest.prototype.send`,
        // because that method is always synchronous.
        until(() => predicatePromise).then(() => {
            window.XMLHttpRequest.prototype.send = originalXhrSend;
            this.send(...args);
        });
    };
    // Defer any `fetch` requests until the Service Worker is ready.
    const originalFetch = window.fetch;
    window.fetch = (...args) => __awaiter(this, void 0, void 0, function* () {
        yield until(() => predicatePromise);
        window.fetch = originalFetch;
        return window.fetch(...args);
    });
}

function createResponseListener(context) {
    return (_, message) => {
        var _a;
        const { payload: responseJson } = message;
        /**
         * CORS requests with `mode: "no-cors"` result in "opaque" responses.
         * That kind of responses cannot be manipulated in JavaScript due
         * to the security considerations.
         * @see https://fetch.spec.whatwg.org/#concept-filtered-response-opaque
         * @see https://github.com/mswjs/msw/issues/529
         */
        if ((_a = responseJson.type) === null || _a === void 0 ? void 0 : _a.includes('opaque')) {
            return;
        }
        const response = new Response(responseJson.body || null, responseJson);
        const isMockedResponse = response.headers.get('x-powered-by') === 'msw';
        if (isMockedResponse) {
            context.emitter.emit('response:mocked', response, responseJson.requestId);
        }
        else {
            context.emitter.emit('response:bypass', response, responseJson.requestId);
        }
    };
}

function validateWorkerScope(registration, options) {
    if (!(options === null || options === void 0 ? void 0 : options.quiet) && !location.href.startsWith(registration.scope)) {
        devUtils.warn(`\
Cannot intercept requests on this page because it's outside of the worker's scope ("${registration.scope}"). If you wish to mock API requests on this page, you must resolve this scope issue.

- (Recommended) Register the worker at the root level ("/") of your application.
- Set the "Service-Worker-Allowed" response header to allow out-of-scope workers.\
`);
    }
}

const createStartHandler = (context) => {
    return function start(options, customOptions) {
        const startWorkerInstance = () => __awaiter(this, void 0, void 0, function* () {
            // Remove all previously existing event listeners.
            // This way none of the listeners persists between Fast refresh
            // of the application's code.
            context.events.removeAllListeners();
            // Handle requests signaled by the worker.
            context.workerChannel.on('REQUEST', createRequestListener(context, options));
            context.workerChannel.on('RESPONSE', createResponseListener(context));
            const instance = yield getWorkerInstance(options.serviceWorker.url, options.serviceWorker.options, options.findWorker);
            const [worker, registration] = instance;
            if (!worker) {
                const missingWorkerMessage = (customOptions === null || customOptions === void 0 ? void 0 : customOptions.findWorker)
                    ? devUtils.formatMessage(`Failed to locate the Service Worker registration using a custom "findWorker" predicate.

Please ensure that the custom predicate properly locates the Service Worker registration at "%s".
More details: https://mswjs.io/docs/api/setup-worker/start#findworker
`, options.serviceWorker.url)
                    : devUtils.formatMessage(`Failed to locate the Service Worker registration.

This most likely means that the worker script URL "%s" cannot resolve against the actual public hostname (%s). This may happen if your application runs behind a proxy, or has a dynamic hostname.

Please consider using a custom "serviceWorker.url" option to point to the actual worker script location, or a custom "findWorker" option to resolve the Service Worker registration manually. More details: https://mswjs.io/docs/api/setup-worker/start`, options.serviceWorker.url, location.host);
                throw new Error(missingWorkerMessage);
            }
            context.worker = worker;
            context.registration = registration;
            context.events.addListener(window, 'beforeunload', () => {
                if (worker.state !== 'redundant') {
                    // Notify the Service Worker that this client has closed.
                    // Internally, it's similar to disabling the mocking, only
                    // client close event has a handler that self-terminates
                    // the Service Worker when there are no open clients.
                    context.workerChannel.send('CLIENT_CLOSED');
                }
                // Make sure we're always clearing the interval - there are reports that not doing this can
                // cause memory leaks in headless browser environments.
                window.clearInterval(context.keepAliveInterval);
            });
            // Check if the active Service Worker is the latest published one
            const [integrityError] = yield until(() => requestIntegrityCheck(context, worker));
            if (integrityError) {
                devUtils.error(`\
Detected outdated Service Worker: ${integrityError.message}

The mocking is still enabled, but it's highly recommended that you update your Service Worker by running:

$ npx msw init <PUBLIC_DIR>

This is necessary to ensure that the Service Worker is in sync with the library to guarantee its stability.
If this message still persists after updating, please report an issue: https://github.com/open-draft/msw/issues\
      `);
            }
            yield enableMocking(context, options).catch((err) => {
                throw new Error(`Failed to enable mocking: ${err === null || err === void 0 ? void 0 : err.message}`);
            });
            context.keepAliveInterval = window.setInterval(() => context.workerChannel.send('KEEPALIVE_REQUEST'), 5000);
            // Warn the user when loading the page that lies outside
            // of the worker's scope.
            validateWorkerScope(registration, context.startOptions);
            return registration;
        });
        const workerRegistration = startWorkerInstance();
        // Defer any network requests until the Service Worker instance is ready.
        // This prevents a race condition between the Service Worker registration
        // and application's runtime requests (i.e. requests on mount).
        if (options.waitUntilReady) {
            deferNetworkRequestsUntil(workerRegistration);
        }
        return workerRegistration;
    };
};

function printStopMessage(args = {}) {
    if (args.quiet) {
        return;
    }
    console.log(`%c${devUtils.formatMessage('Mocking disabled.')}`, 'color:orangered;font-weight:bold;');
}

const createStop = (context) => {
    return function stop() {
        var _a;
        /**
         * Signal the Service Worker to disable mocking for this client.
         * Use this an an explicit way to stop the mocking, while preserving
         * the worker-client relation. Does not affect the worker's lifecycle.
         */
        context.workerChannel.send('MOCK_DEACTIVATE');
        window.clearInterval(context.keepAliveInterval);
        printStopMessage({ quiet: (_a = context.startOptions) === null || _a === void 0 ? void 0 : _a.quiet });
    };
};

function use(currentHandlers, ...handlers) {
    currentHandlers.unshift(...handlers);
}
function restoreHandlers(handlers) {
    handlers.forEach((handler) => {
        handler.markAsSkipped(false);
    });
}
function resetHandlers(initialHandlers, ...nextHandlers) {
    return nextHandlers.length > 0 ? [...nextHandlers] : [...initialHandlers];
}

const DEFAULT_START_OPTIONS = {
    serviceWorker: {
        url: '/mockServiceWorker.js',
        options: null,
    },
    quiet: false,
    waitUntilReady: true,
    onUnhandledRequest: 'warn',
    findWorker(scriptURL, mockServiceWorkerUrl) {
        return scriptURL === mockServiceWorkerUrl;
    },
};
/**
 * Returns resolved worker start options, merging the default options
 * with the given custom options.
 */
function resolveStartOptions(initialOptions) {
    return mergeRight(DEFAULT_START_OPTIONS, initialOptions || {});
}
function prepareStartHandler(handler, context) {
    return (initialOptions) => {
        context.startOptions = resolveStartOptions(initialOptions);
        return handler(context.startOptions, initialOptions || {});
    };
}

var esm_lib = {};

var createInterceptor$1 = {};

Object.defineProperty(createInterceptor$1, "__esModule", { value: true });
createInterceptor$1.createInterceptor = void 0;
var strict_event_emitter_1$1 = lib$3;
function createInterceptor(options) {
    var observer = new strict_event_emitter_1$1.StrictEventEmitter();
    var cleanupFns = [];
    return {
        apply: function () {
            cleanupFns = options.modules.map(function (interceptor) {
                return interceptor(observer, options.resolver);
            });
        },
        on: function (event, listener) {
            observer.addListener(event, listener);
        },
        restore: function () {
            observer.removeAllListeners();
            if (cleanupFns.length === 0) {
                throw new Error("Failed to restore patched modules: no patches found. Did you forget to run \".apply()\"?");
            }
            cleanupFns.forEach(function (restore) { return restore(); });
        },
    };
}
createInterceptor$1.createInterceptor = createInterceptor;

var remote = {};

var toIsoResponse$1 = {};

Object.defineProperty(toIsoResponse$1, "__esModule", { value: true });
toIsoResponse$1.toIsoResponse = void 0;
var headers_utils_1$3 = lib$1;
/**
 * Converts a given mocked response object into an isomorphic response.
 */
function toIsoResponse(response) {
    return {
        status: response.status || 200,
        statusText: response.statusText || 'OK',
        headers: headers_utils_1$3.objectToHeaders(response.headers || {}),
        body: response.body,
    };
}
toIsoResponse$1.toIsoResponse = toIsoResponse;

var __assign$1 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
var __awaiter$2 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator$2 = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var esm_read$1 = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(remote, "__esModule", { value: true });
remote.createRemoteResolver = remote.createRemoteInterceptor = void 0;
var headers_utils_1$2 = lib$1;
var outvariant_1 = RequestHandler_deps_lib;
var strict_event_emitter_1 = lib$3;
var createInterceptor_1 = createInterceptor$1;
var toIsoResponse_1$2 = toIsoResponse$1;
function requestReviver(key, value) {
    switch (key) {
        case 'url':
            return new URL(value);
        case 'headers':
            return new headers_utils_1$2.Headers(value);
        default:
            return value;
    }
}
/**
 * Creates a remote request interceptor that delegates
 * the mocked response resolution to the parent process.
 * The parent process must establish a remote resolver
 * by calling `createRemoteResolver` function.
 */
function createRemoteInterceptor(options) {
    outvariant_1.invariant(esm_process.connected, "Failed to create a remote interceptor: the current process (%s) does not have a parent. Please make sure you're spawning this process as a child process in order to use remote request interception.", esm_process.pid);
    if (typeof esm_process.send === 'undefined') {
        throw new Error("Failed to create a remote interceptor: the current process (" + esm_process.pid + ") does not have the IPC enabled. Please make sure you're spawning this process with the \"ipc\" stdio value set:\n\nspawn('node', ['module.js'], { stdio: ['ipc'] })");
    }
    var handleParentMessage;
    var interceptor = createInterceptor_1.createInterceptor(__assign$1(__assign$1({}, options), { resolver: function (request) {
            var _a;
            var serializedRequest = JSON.stringify(request);
            (_a = esm_process.send) === null || _a === void 0 ? void 0 : _a.call(esm_process, "request:" + serializedRequest);
            return new Promise(function (resolve) {
                handleParentMessage = function (message) {
                    if (typeof message !== 'string') {
                        return;
                    }
                    if (message.startsWith("response:" + request.id)) {
                        var _a = esm_read$1(message.match(/^response:.+?:(.+)$/) || [], 2), responseString = _a[1];
                        if (!responseString) {
                            return resolve();
                        }
                        var mockedResponse = JSON.parse(responseString);
                        return resolve(mockedResponse);
                    }
                };
                esm_process.addListener('message', handleParentMessage);
            });
        } }));
    return __assign$1(__assign$1({}, interceptor), { restore: function () {
            interceptor.restore();
            esm_process.removeListener('message', handleParentMessage);
        } });
}
remote.createRemoteInterceptor = createRemoteInterceptor;
/**
 * Creates a response resolver function attached to the given `ChildProcess`.
 * The child process must establish a remote interceptor by calling `createRemoteInterceptor` function.
 */
function createRemoteResolver(options) {
    var _this = this;
    var observer = new strict_event_emitter_1.StrictEventEmitter();
    var handleChildMessage = function (message) { return __awaiter$2(_this, void 0, void 0, function () {
        var _a, requestString, isoRequest_1, mockedResponse_1, serializedResponse;
        return __generator$2(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (typeof message !== 'string') {
                        return [2 /*return*/];
                    }
                    if (!message.startsWith('request:')) return [3 /*break*/, 2];
                    _a = esm_read$1(message.match(/^request:(.+)$/) || [], 2), requestString = _a[1];
                    if (!requestString) {
                        return [2 /*return*/];
                    }
                    isoRequest_1 = JSON.parse(requestString, requestReviver);
                    observer.emit('request', isoRequest_1);
                    return [4 /*yield*/, options.resolver(isoRequest_1, undefined)
                        // Send the mocked response to the child process.
                    ];
                case 1:
                    mockedResponse_1 = _b.sent();
                    serializedResponse = JSON.stringify(mockedResponse_1);
                    options.process.send("response:" + isoRequest_1.id + ":" + serializedResponse, function (error) {
                        if (error) {
                            return;
                        }
                        if (mockedResponse_1) {
                            // Emit an optimisting "response" event at this point,
                            // not to rely on the back-and-forth signaling for the sake of the event.
                            observer.emit('response', isoRequest_1, toIsoResponse_1$2.toIsoResponse(mockedResponse_1));
                        }
                    });
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var cleanup = function () {
        options.process.removeListener('message', handleChildMessage);
    };
    options.process.addListener('message', handleChildMessage);
    options.process.addListener('disconnect', cleanup);
    options.process.addListener('error', cleanup);
    options.process.addListener('exit', cleanup);
    return {
        on: function (event, listener) {
            observer.addListener(event, listener);
        },
    };
}
remote.createRemoteResolver = createRemoteResolver;

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCleanUrl = void 0;
__exportStar(createInterceptor$1, exports);
__exportStar(remote, exports);
/* Utils */
var getCleanUrl_1 = getCleanUrl$1;
Object.defineProperty(exports, "getCleanUrl", { enumerable: true, get: function () { return getCleanUrl_1.getCleanUrl; } });

}(esm_lib));

var esm_fetch = {};

var uuid = {};

Object.defineProperty(uuid, "__esModule", { value: true });
uuid.uuidv4 = void 0;
function uuidv4$1() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        var v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
uuid.uuidv4 = uuidv4$1;

var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter$1 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator$1 = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(esm_fetch, "__esModule", { value: true });
var interceptFetch_1 = esm_fetch.interceptFetch = void 0;
var headers_utils_1$1 = lib$1;
var toIsoResponse_1$1 = toIsoResponse$1;
var uuid_1$1 = uuid;
var debug$1 = browser_default()('fetch');
var interceptFetch = function (observer, resolver) {
    var pureFetch = window.fetch;
    debug$1('replacing "window.fetch"...');
    window.fetch = function (input, init) { return __awaiter$1(void 0, void 0, void 0, function () {
        var ref, url, method, isoRequest, response, isomorphicResponse;
        var _a;
        return __generator$1(this, function (_b) {
            switch (_b.label) {
                case 0:
                    ref = new Request(input, init);
                    url = typeof input === 'string' ? input : input.url;
                    method = (init === null || init === void 0 ? void 0 : init.method) || 'GET';
                    debug$1('[%s] %s', method, url);
                    _a = {
                        id: uuid_1$1.uuidv4(),
                        url: new URL(url, location.origin),
                        method: method,
                        headers: new headers_utils_1$1.Headers((init === null || init === void 0 ? void 0 : init.headers) || {})
                    };
                    return [4 /*yield*/, ref.text()];
                case 1:
                    isoRequest = (_a.body = _b.sent(),
                        _a);
                    debug$1('isomorphic request', isoRequest);
                    observer.emit('request', isoRequest);
                    debug$1('awaiting for the mocked response...');
                    return [4 /*yield*/, resolver(isoRequest, ref)];
                case 2:
                    response = _b.sent();
                    debug$1('mocked response', response);
                    if (response) {
                        isomorphicResponse = toIsoResponse_1$1.toIsoResponse(response);
                        debug$1('derived isomorphic response', isomorphicResponse);
                        observer.emit('response', isoRequest, isomorphicResponse);
                        return [2 /*return*/, new Response(response.body, __assign(__assign({}, isomorphicResponse), { 
                                // `Response.headers` cannot be instantiated with the `Headers` polyfill.
                                // Apparently, it halts if the `Headers` class contains unknown properties
                                // (i.e. the internal `Headers.map`).
                                headers: headers_utils_1$1.flattenHeadersObject(response.headers || {}) }))];
                    }
                    debug$1('no mocked response found, bypassing...');
                    return [2 /*return*/, pureFetch(input, init).then(function (response) { return __awaiter$1(void 0, void 0, void 0, function () {
                            var _a, _b, _c;
                            return __generator$1(this, function (_d) {
                                switch (_d.label) {
                                    case 0:
                                        debug$1('original fetch performed', response);
                                        _b = (_a = observer).emit;
                                        _c = ['response',
                                            isoRequest];
                                        return [4 /*yield*/, normalizeFetchResponse(response)];
                                    case 1:
                                        _b.apply(_a, _c.concat([_d.sent()]));
                                        return [2 /*return*/, response];
                                }
                            });
                        }); })];
            }
        });
    }); };
    return function () {
        debug$1('restoring modules...');
        window.fetch = pureFetch;
    };
};
interceptFetch_1 = esm_fetch.interceptFetch = interceptFetch;
function normalizeFetchResponse(response) {
    return __awaiter$1(this, void 0, void 0, function () {
        var _a;
        return __generator$1(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = {
                        status: response.status,
                        statusText: response.statusText,
                        headers: headers_utils_1$1.objectToHeaders(headers_utils_1$1.headersToObject(response.headers))
                    };
                    return [4 /*yield*/, response.text()];
                case 1: return [2 /*return*/, (_a.body = _b.sent(),
                        _a)];
            }
        });
    });
}

var XMLHttpRequest = {};

var XMLHttpRequestOverride = {};

var domParser = {};

var conventions$2 = {};

/**
 * "Shallow freezes" an object to render it immutable.
 * Uses `Object.freeze` if available,
 * otherwise the immutability is only in the type.
 *
 * Is used to create "enum like" objects.
 *
 * @template T
 * @param {T} object the object to freeze
 * @param {Pick<ObjectConstructor, 'freeze'> = Object} oc `Object` by default,
 * 				allows to inject custom object constructor for tests
 * @returns {Readonly<T>}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
 */
function freeze(object, oc) {
	if (oc === undefined) {
		oc = Object;
	}
	return oc && typeof oc.freeze === 'function' ? oc.freeze(object) : object
}

/**
 * All mime types that are allowed as input to `DOMParser.parseFromString`
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#Argument02 MDN
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#domparsersupportedtype WHATWG HTML Spec
 * @see DOMParser.prototype.parseFromString
 */
var MIME_TYPE = freeze({
	/**
	 * `text/html`, the only mime type that triggers treating an XML document as HTML.
	 *
	 * @see DOMParser.SupportedType.isHTML
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
	 */
	HTML: 'text/html',

	/**
	 * Helper method to check a mime type if it indicates an HTML document
	 *
	 * @param {string} [value]
	 * @returns {boolean}
	 *
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */
	isHTML: function (value) {
		return value === MIME_TYPE.HTML
	},

	/**
	 * `application/xml`, the standard mime type for XML documents.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
	 * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */
	XML_APPLICATION: 'application/xml',

	/**
	 * `text/html`, an alias for `application/xml`.
	 *
	 * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
	 * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */
	XML_TEXT: 'text/xml',

	/**
	 * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
	 * but is parsed as an XML document.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
	 * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
	 */
	XML_XHTML_APPLICATION: 'application/xhtml+xml',

	/**
	 * `image/svg+xml`,
	 *
	 * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
	 * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
	 * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
	 */
	XML_SVG_IMAGE: 'image/svg+xml',
});

/**
 * Namespaces that are used in this code base.
 *
 * @see http://www.w3.org/TR/REC-xml-names
 */
var NAMESPACE$3 = freeze({
	/**
	 * The XHTML namespace.
	 *
	 * @see http://www.w3.org/1999/xhtml
	 */
	HTML: 'http://www.w3.org/1999/xhtml',

	/**
	 * Checks if `uri` equals `NAMESPACE.HTML`.
	 *
	 * @param {string} [uri]
	 *
	 * @see NAMESPACE.HTML
	 */
	isHTML: function (uri) {
		return uri === NAMESPACE$3.HTML
	},

	/**
	 * The SVG namespace.
	 *
	 * @see http://www.w3.org/2000/svg
	 */
	SVG: 'http://www.w3.org/2000/svg',

	/**
	 * The `xml:` namespace.
	 *
	 * @see http://www.w3.org/XML/1998/namespace
	 */
	XML: 'http://www.w3.org/XML/1998/namespace',

	/**
	 * The `xmlns:` namespace
	 *
	 * @see https://www.w3.org/2000/xmlns/
	 */
	XMLNS: 'http://www.w3.org/2000/xmlns/',
});

conventions$2.freeze = freeze;
conventions$2.MIME_TYPE = MIME_TYPE;
conventions$2.NAMESPACE = NAMESPACE$3;

var entities$1 = {};

(function (exports) {
var freeze = conventions$2.freeze;

/**
 * The entities that are predefined in every XML document.
 *
 * @see https://www.w3.org/TR/2006/REC-xml11-20060816/#sec-predefined-ent W3C XML 1.1
 * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-predefined-ent W3C XML 1.0
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Predefined_entities_in_XML Wikipedia
 */
exports.XML_ENTITIES = freeze({amp:'&', apos:"'", gt:'>', lt:'<', quot:'"'});

/**
 * A map of currently 241 entities that are detected in an HTML document.
 * They contain all entries from `XML_ENTITIES`.
 *
 * @see XML_ENTITIES
 * @see DOMParser.parseFromString
 * @see DOMImplementation.prototype.createHTMLDocument
 * @see https://html.spec.whatwg.org/#named-character-references WHATWG HTML(5) Spec
 * @see https://www.w3.org/TR/xml-entity-names/ W3C XML Entity Names
 * @see https://www.w3.org/TR/html4/sgml/entities.html W3C HTML4/SGML
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Character_entity_references_in_HTML Wikipedia (HTML)
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Entities_representing_special_characters_in_XHTML Wikpedia (XHTML)
 */
exports.HTML_ENTITIES = freeze({
       lt: '<',
       gt: '>',
       amp: '&',
       quot: '"',
       apos: "'",
       Agrave: "À",
       Aacute: "Á",
       Acirc: "Â",
       Atilde: "Ã",
       Auml: "Ä",
       Aring: "Å",
       AElig: "Æ",
       Ccedil: "Ç",
       Egrave: "È",
       Eacute: "É",
       Ecirc: "Ê",
       Euml: "Ë",
       Igrave: "Ì",
       Iacute: "Í",
       Icirc: "Î",
       Iuml: "Ï",
       ETH: "Ð",
       Ntilde: "Ñ",
       Ograve: "Ò",
       Oacute: "Ó",
       Ocirc: "Ô",
       Otilde: "Õ",
       Ouml: "Ö",
       Oslash: "Ø",
       Ugrave: "Ù",
       Uacute: "Ú",
       Ucirc: "Û",
       Uuml: "Ü",
       Yacute: "Ý",
       THORN: "Þ",
       szlig: "ß",
       agrave: "à",
       aacute: "á",
       acirc: "â",
       atilde: "ã",
       auml: "ä",
       aring: "å",
       aelig: "æ",
       ccedil: "ç",
       egrave: "è",
       eacute: "é",
       ecirc: "ê",
       euml: "ë",
       igrave: "ì",
       iacute: "í",
       icirc: "î",
       iuml: "ï",
       eth: "ð",
       ntilde: "ñ",
       ograve: "ò",
       oacute: "ó",
       ocirc: "ô",
       otilde: "õ",
       ouml: "ö",
       oslash: "ø",
       ugrave: "ù",
       uacute: "ú",
       ucirc: "û",
       uuml: "ü",
       yacute: "ý",
       thorn: "þ",
       yuml: "ÿ",
       nbsp: "\u00a0",
       iexcl: "¡",
       cent: "¢",
       pound: "£",
       curren: "¤",
       yen: "¥",
       brvbar: "¦",
       sect: "§",
       uml: "¨",
       copy: "©",
       ordf: "ª",
       laquo: "«",
       not: "¬",
       shy: "­­",
       reg: "®",
       macr: "¯",
       deg: "°",
       plusmn: "±",
       sup2: "²",
       sup3: "³",
       acute: "´",
       micro: "µ",
       para: "¶",
       middot: "·",
       cedil: "¸",
       sup1: "¹",
       ordm: "º",
       raquo: "»",
       frac14: "¼",
       frac12: "½",
       frac34: "¾",
       iquest: "¿",
       times: "×",
       divide: "÷",
       forall: "∀",
       part: "∂",
       exist: "∃",
       empty: "∅",
       nabla: "∇",
       isin: "∈",
       notin: "∉",
       ni: "∋",
       prod: "∏",
       sum: "∑",
       minus: "−",
       lowast: "∗",
       radic: "√",
       prop: "∝",
       infin: "∞",
       ang: "∠",
       and: "∧",
       or: "∨",
       cap: "∩",
       cup: "∪",
       'int': "∫",
       there4: "∴",
       sim: "∼",
       cong: "≅",
       asymp: "≈",
       ne: "≠",
       equiv: "≡",
       le: "≤",
       ge: "≥",
       sub: "⊂",
       sup: "⊃",
       nsub: "⊄",
       sube: "⊆",
       supe: "⊇",
       oplus: "⊕",
       otimes: "⊗",
       perp: "⊥",
       sdot: "⋅",
       Alpha: "Α",
       Beta: "Β",
       Gamma: "Γ",
       Delta: "Δ",
       Epsilon: "Ε",
       Zeta: "Ζ",
       Eta: "Η",
       Theta: "Θ",
       Iota: "Ι",
       Kappa: "Κ",
       Lambda: "Λ",
       Mu: "Μ",
       Nu: "Ν",
       Xi: "Ξ",
       Omicron: "Ο",
       Pi: "Π",
       Rho: "Ρ",
       Sigma: "Σ",
       Tau: "Τ",
       Upsilon: "Υ",
       Phi: "Φ",
       Chi: "Χ",
       Psi: "Ψ",
       Omega: "Ω",
       alpha: "α",
       beta: "β",
       gamma: "γ",
       delta: "δ",
       epsilon: "ε",
       zeta: "ζ",
       eta: "η",
       theta: "θ",
       iota: "ι",
       kappa: "κ",
       lambda: "λ",
       mu: "μ",
       nu: "ν",
       xi: "ξ",
       omicron: "ο",
       pi: "π",
       rho: "ρ",
       sigmaf: "ς",
       sigma: "σ",
       tau: "τ",
       upsilon: "υ",
       phi: "φ",
       chi: "χ",
       psi: "ψ",
       omega: "ω",
       thetasym: "ϑ",
       upsih: "ϒ",
       piv: "ϖ",
       OElig: "Œ",
       oelig: "œ",
       Scaron: "Š",
       scaron: "š",
       Yuml: "Ÿ",
       fnof: "ƒ",
       circ: "ˆ",
       tilde: "˜",
       ensp: " ",
       emsp: " ",
       thinsp: " ",
       zwnj: "‌",
       zwj: "‍",
       lrm: "‎",
       rlm: "‏",
       ndash: "–",
       mdash: "—",
       lsquo: "‘",
       rsquo: "’",
       sbquo: "‚",
       ldquo: "“",
       rdquo: "”",
       bdquo: "„",
       dagger: "†",
       Dagger: "‡",
       bull: "•",
       hellip: "…",
       permil: "‰",
       prime: "′",
       Prime: "″",
       lsaquo: "‹",
       rsaquo: "›",
       oline: "‾",
       euro: "€",
       trade: "™",
       larr: "←",
       uarr: "↑",
       rarr: "→",
       darr: "↓",
       harr: "↔",
       crarr: "↵",
       lceil: "⌈",
       rceil: "⌉",
       lfloor: "⌊",
       rfloor: "⌋",
       loz: "◊",
       spades: "♠",
       clubs: "♣",
       hearts: "♥",
       diams: "♦"
});

/**
 * @deprecated use `HTML_ENTITIES` instead
 * @see HTML_ENTITIES
 */
exports.entityMap = exports.HTML_ENTITIES;
}(entities$1));

var sax$1 = {};

var NAMESPACE$2 = conventions$2.NAMESPACE;

//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
//[5]   	Name	   ::=   	NameStartChar (NameChar)*
var nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;//\u10000-\uEFFFF
var nameChar = new RegExp("[\\-\\.0-9"+nameStartChar.source.slice(1,-1)+"\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
var tagNamePattern = new RegExp('^'+nameStartChar.source+nameChar.source+'*(?:\:'+nameStartChar.source+nameChar.source+'*)?$');
//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')

//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
var S_TAG = 0;//tag name offerring
var S_ATTR = 1;//attr name offerring 
var S_ATTR_SPACE=2;//attr name end and space offer
var S_EQ = 3;//=space?
var S_ATTR_NOQUOT_VALUE = 4;//attr value(no quot value only)
var S_ATTR_END = 5;//attr value end and no space(quot end)
var S_TAG_SPACE = 6;//(attr value end || tag end ) && (space offer)
var S_TAG_CLOSE = 7;//closed el<el />

/**
 * Creates an error that will not be caught by XMLReader aka the SAX parser.
 *
 * @param {string} message
 * @param {any?} locator Optional, can provide details about the location in the source
 * @constructor
 */
function ParseError$1(message, locator) {
	this.message = message;
	this.locator = locator;
	if(Error.captureStackTrace) Error.captureStackTrace(this, ParseError$1);
}
ParseError$1.prototype = new Error();
ParseError$1.prototype.name = ParseError$1.name;

function XMLReader$1(){
	
}

XMLReader$1.prototype = {
	parse:function(source,defaultNSMap,entityMap){
		var domBuilder = this.domBuilder;
		domBuilder.startDocument();
		_copy(defaultNSMap ,defaultNSMap = {});
		esm_parse(source,defaultNSMap,entityMap,
				domBuilder,this.errorHandler);
		domBuilder.endDocument();
	}
};
function esm_parse(source,defaultNSMapCopy,entityMap,domBuilder,errorHandler){
	function fixedFromCharCode(code) {
		// String.prototype.fromCharCode does not supports
		// > 2 bytes unicode chars directly
		if (code > 0xffff) {
			code -= 0x10000;
			var surrogate1 = 0xd800 + (code >> 10)
				, surrogate2 = 0xdc00 + (code & 0x3ff);

			return String.fromCharCode(surrogate1, surrogate2);
		} else {
			return String.fromCharCode(code);
		}
	}
	function entityReplacer(a){
		var k = a.slice(1,-1);
		if(k in entityMap){
			return entityMap[k]; 
		}else if(k.charAt(0) === '#'){
			return fixedFromCharCode(parseInt(k.substr(1).replace('x','0x')))
		}else {
			errorHandler.error('entity not found:'+a);
			return a;
		}
	}
	function appendText(end){//has some bugs
		if(end>start){
			var xt = source.substring(start,end).replace(/&#?\w+;/g,entityReplacer);
			locator&&position(start);
			domBuilder.characters(xt,0,end-start);
			start = end;
		}
	}
	function position(p,m){
		while(p>=lineEnd && (m = linePattern.exec(source))){
			lineStart = m.index;
			lineEnd = lineStart + m[0].length;
			locator.lineNumber++;
			//console.log('line++:',locator,startPos,endPos)
		}
		locator.columnNumber = p-lineStart+1;
	}
	var lineStart = 0;
	var lineEnd = 0;
	var linePattern = /.*(?:\r\n?|\n)|.*$/g;
	var locator = domBuilder.locator;
	
	var parseStack = [{currentNSMap:defaultNSMapCopy}];
	var closeMap = {};
	var start = 0;
	while(true){
		try{
			var tagStart = source.indexOf('<',start);
			if(tagStart<0){
				if(!source.substr(start).match(/^\s*$/)){
					var doc = domBuilder.doc;
	    			var text = doc.createTextNode(source.substr(start));
	    			doc.appendChild(text);
	    			domBuilder.currentElement = text;
				}
				return;
			}
			if(tagStart>start){
				appendText(tagStart);
			}
			switch(source.charAt(tagStart+1)){
			case '/':
				var end = source.indexOf('>',tagStart+3);
				var tagName = source.substring(tagStart + 2, end).replace(/[ \t\n\r]+$/g, '');
				var config = parseStack.pop();
				if(end<0){
					
	        		tagName = source.substring(tagStart+2).replace(/[\s<].*/,'');
	        		errorHandler.error("end tag name: "+tagName+' is not complete:'+config.tagName);
	        		end = tagStart+1+tagName.length;
	        	}else if(tagName.match(/\s</)){
	        		tagName = tagName.replace(/[\s<].*/,'');
	        		errorHandler.error("end tag name: "+tagName+' maybe not complete');
	        		end = tagStart+1+tagName.length;
				}
				var localNSMap = config.localNSMap;
				var endMatch = config.tagName == tagName;
				var endIgnoreCaseMach = endMatch || config.tagName&&config.tagName.toLowerCase() == tagName.toLowerCase();
		        if(endIgnoreCaseMach){
		        	domBuilder.endElement(config.uri,config.localName,tagName);
					if(localNSMap){
						for(var prefix in localNSMap){
							domBuilder.endPrefixMapping(prefix) ;
						}
					}
					if(!endMatch){
		            	errorHandler.fatalError("end tag name: "+tagName+' is not match the current start tagName:'+config.tagName ); // No known test case
					}
		        }else {
		        	parseStack.push(config);
		        }
				
				end++;
				break;
				// end elment
			case '?':// <?...?>
				locator&&position(tagStart);
				end = parseInstruction(source,tagStart,domBuilder);
				break;
			case '!':// <!doctype,<![CDATA,<!--
				locator&&position(tagStart);
				end = parseDCC(source,tagStart,domBuilder,errorHandler);
				break;
			default:
				locator&&position(tagStart);
				var el = new ElementAttributes();
				var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
				//elStartEnd
				var end = parseElementStartPart(source,tagStart,el,currentNSMap,entityReplacer,errorHandler);
				var len = el.length;
				
				
				if(!el.closed && fixSelfClosed(source,end,el.tagName,closeMap)){
					el.closed = true;
					if(!entityMap.nbsp){
						errorHandler.warning('unclosed xml attribute');
					}
				}
				if(locator && len){
					var locator2 = copyLocator(locator,{});
					//try{//attribute position fixed
					for(var i = 0;i<len;i++){
						var a = el[i];
						position(a.offset);
						a.locator = copyLocator(locator,{});
					}
					domBuilder.locator = locator2;
					if(appendElement$1(el,domBuilder,currentNSMap)){
						parseStack.push(el);
					}
					domBuilder.locator = locator;
				}else {
					if(appendElement$1(el,domBuilder,currentNSMap)){
						parseStack.push(el);
					}
				}

				if (NAMESPACE$2.isHTML(el.uri) && !el.closed) {
					end = parseHtmlSpecialContent(source,end,el.tagName,entityReplacer,domBuilder);
				} else {
					end++;
				}
			}
		}catch(e){
			if (e instanceof ParseError$1) {
				throw e;
			}
			errorHandler.error('element parse error: '+e);
			end = -1;
		}
		if(end>start){
			start = end;
		}else {
			//TODO: 这里有可能sax回退，有位置错误风险
			appendText(Math.max(tagStart,start)+1);
		}
	}
}
function copyLocator(f,t){
	t.lineNumber = f.lineNumber;
	t.columnNumber = f.columnNumber;
	return t;
}

/**
 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
 */
function parseElementStartPart(source,start,el,currentNSMap,entityReplacer,errorHandler){

	/**
	 * @param {string} qname
	 * @param {string} value
	 * @param {number} startIndex
	 */
	function addAttribute(qname, value, startIndex) {
		if (qname in el.attributeNames) errorHandler.fatalError('Attribute ' + qname + ' redefined');
		el.addValue(qname, value, startIndex);
	}
	var attrName;
	var value;
	var p = ++start;
	var s = S_TAG;//status
	while(true){
		var c = source.charAt(p);
		switch(c){
		case '=':
			if(s === S_ATTR){//attrName
				attrName = source.slice(start,p);
				s = S_EQ;
			}else if(s === S_ATTR_SPACE){
				s = S_EQ;
			}else {
				//fatalError: equal must after attrName or space after attrName
				throw new Error('attribute equal must after attrName'); // No known test case
			}
			break;
		case '\'':
		case '"':
			if(s === S_EQ || s === S_ATTR //|| s == S_ATTR_SPACE
				){//equal
				if(s === S_ATTR){
					errorHandler.warning('attribute value must after "="');
					attrName = source.slice(start,p);
				}
				start = p+1;
				p = source.indexOf(c,start);
				if(p>0){
					value = source.slice(start,p).replace(/&#?\w+;/g,entityReplacer);
					addAttribute(attrName, value, start-1);
					s = S_ATTR_END;
				}else {
					//fatalError: no end quot match
					throw new Error('attribute value no end \''+c+'\' match');
				}
			}else if(s == S_ATTR_NOQUOT_VALUE){
				value = source.slice(start,p).replace(/&#?\w+;/g,entityReplacer);
				//console.log(attrName,value,start,p)
				addAttribute(attrName, value, start);
				//console.dir(el)
				errorHandler.warning('attribute "'+attrName+'" missed start quot('+c+')!!');
				start = p+1;
				s = S_ATTR_END;
			}else {
				//fatalError: no equal before
				throw new Error('attribute value must after "="'); // No known test case
			}
			break;
		case '/':
			switch(s){
			case S_TAG:
				el.setTagName(source.slice(start,p));
			case S_ATTR_END:
			case S_TAG_SPACE:
			case S_TAG_CLOSE:
				s =S_TAG_CLOSE;
				el.closed = true;
			case S_ATTR_NOQUOT_VALUE:
			case S_ATTR:
			case S_ATTR_SPACE:
				break;
			//case S_EQ:
			default:
				throw new Error("attribute invalid close char('/')") // No known test case
			}
			break;
		case ''://end document
			errorHandler.error('unexpected end of input');
			if(s == S_TAG){
				el.setTagName(source.slice(start,p));
			}
			return p;
		case '>':
			switch(s){
			case S_TAG:
				el.setTagName(source.slice(start,p));
			case S_ATTR_END:
			case S_TAG_SPACE:
			case S_TAG_CLOSE:
				break;//normal
			case S_ATTR_NOQUOT_VALUE://Compatible state
			case S_ATTR:
				value = source.slice(start,p);
				if(value.slice(-1) === '/'){
					el.closed  = true;
					value = value.slice(0,-1);
				}
			case S_ATTR_SPACE:
				if(s === S_ATTR_SPACE){
					value = attrName;
				}
				if(s == S_ATTR_NOQUOT_VALUE){
					errorHandler.warning('attribute "'+value+'" missed quot(")!');
					addAttribute(attrName, value.replace(/&#?\w+;/g,entityReplacer), start);
				}else {
					if(!NAMESPACE$2.isHTML(currentNSMap['']) || !value.match(/^(?:disabled|checked|selected)$/i)){
						errorHandler.warning('attribute "'+value+'" missed value!! "'+value+'" instead!!');
					}
					addAttribute(value, value, start);
				}
				break;
			case S_EQ:
				throw new Error('attribute value missed!!');
			}
//			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
			return p;
		/*xml space '\x20' | #x9 | #xD | #xA; */
		case '\u0080':
			c = ' ';
		default:
			if(c<= ' '){//space
				switch(s){
				case S_TAG:
					el.setTagName(source.slice(start,p));//tagName
					s = S_TAG_SPACE;
					break;
				case S_ATTR:
					attrName = source.slice(start,p);
					s = S_ATTR_SPACE;
					break;
				case S_ATTR_NOQUOT_VALUE:
					var value = source.slice(start,p).replace(/&#?\w+;/g,entityReplacer);
					errorHandler.warning('attribute "'+value+'" missed quot(")!!');
					addAttribute(attrName, value, start);
				case S_ATTR_END:
					s = S_TAG_SPACE;
					break;
				//case S_TAG_SPACE:
				//case S_EQ:
				//case S_ATTR_SPACE:
				//	void();break;
				//case S_TAG_CLOSE:
					//ignore warning
				}
			}else {//not space
//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
				switch(s){
				//case S_TAG:void();break;
				//case S_ATTR:void();break;
				//case S_ATTR_NOQUOT_VALUE:void();break;
				case S_ATTR_SPACE:
					el.tagName;
					if (!NAMESPACE$2.isHTML(currentNSMap['']) || !attrName.match(/^(?:disabled|checked|selected)$/i)) {
						errorHandler.warning('attribute "'+attrName+'" missed value!! "'+attrName+'" instead2!!');
					}
					addAttribute(attrName, attrName, start);
					start = p;
					s = S_ATTR;
					break;
				case S_ATTR_END:
					errorHandler.warning('attribute space is required"'+attrName+'"!!');
				case S_TAG_SPACE:
					s = S_ATTR;
					start = p;
					break;
				case S_EQ:
					s = S_ATTR_NOQUOT_VALUE;
					start = p;
					break;
				case S_TAG_CLOSE:
					throw new Error("elements closed character '/' and '>' must be connected to");
				}
			}
		}//end outer switch
		//console.log('p++',p)
		p++;
	}
}
/**
 * @return true if has new namespace define
 */
function appendElement$1(el,domBuilder,currentNSMap){
	var tagName = el.tagName;
	var localNSMap = null;
	//var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
	var i = el.length;
	while(i--){
		var a = el[i];
		var qName = a.qName;
		var value = a.value;
		var nsp = qName.indexOf(':');
		if(nsp>0){
			var prefix = a.prefix = qName.slice(0,nsp);
			var localName = qName.slice(nsp+1);
			var nsPrefix = prefix === 'xmlns' && localName;
		}else {
			localName = qName;
			prefix = null;
			nsPrefix = qName === 'xmlns' && '';
		}
		//can not set prefix,because prefix !== ''
		a.localName = localName ;
		//prefix == null for no ns prefix attribute 
		if(nsPrefix !== false){//hack!!
			if(localNSMap == null){
				localNSMap = {};
				//console.log(currentNSMap,0)
				_copy(currentNSMap,currentNSMap={});
				//console.log(currentNSMap,1)
			}
			currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
			a.uri = NAMESPACE$2.XMLNS;
			domBuilder.startPrefixMapping(nsPrefix, value); 
		}
	}
	var i = el.length;
	while(i--){
		a = el[i];
		var prefix = a.prefix;
		if(prefix){//no prefix attribute has no namespace
			if(prefix === 'xml'){
				a.uri = NAMESPACE$2.XML;
			}if(prefix !== 'xmlns'){
				a.uri = currentNSMap[prefix || ''];
				
				//{console.log('###'+a.qName,domBuilder.locator.systemId+'',currentNSMap,a.uri)}
			}
		}
	}
	var nsp = tagName.indexOf(':');
	if(nsp>0){
		prefix = el.prefix = tagName.slice(0,nsp);
		localName = el.localName = tagName.slice(nsp+1);
	}else {
		prefix = null;//important!!
		localName = el.localName = tagName;
	}
	//no prefix element has default namespace
	var ns = el.uri = currentNSMap[prefix || ''];
	domBuilder.startElement(ns,localName,tagName,el);
	//endPrefixMapping and startPrefixMapping have not any help for dom builder
	//localNSMap = null
	if(el.closed){
		domBuilder.endElement(ns,localName,tagName);
		if(localNSMap){
			for(prefix in localNSMap){
				domBuilder.endPrefixMapping(prefix); 
			}
		}
	}else {
		el.currentNSMap = currentNSMap;
		el.localNSMap = localNSMap;
		//parseStack.push(el);
		return true;
	}
}
function parseHtmlSpecialContent(source,elStartEnd,tagName,entityReplacer,domBuilder){
	if(/^(?:script|textarea)$/i.test(tagName)){
		var elEndStart =  source.indexOf('</'+tagName+'>',elStartEnd);
		var text = source.substring(elStartEnd+1,elEndStart);
		if(/[&<]/.test(text)){
			if(/^script$/i.test(tagName)){
				//if(!/\]\]>/.test(text)){
					//lexHandler.startCDATA();
					domBuilder.characters(text,0,text.length);
					//lexHandler.endCDATA();
					return elEndStart;
				//}
			}//}else{//text area
				text = text.replace(/&#?\w+;/g,entityReplacer);
				domBuilder.characters(text,0,text.length);
				return elEndStart;
			//}
			
		}
	}
	return elStartEnd+1;
}
function fixSelfClosed(source,elStartEnd,tagName,closeMap){
	//if(tagName in closeMap){
	var pos = closeMap[tagName];
	if(pos == null){
		//console.log(tagName)
		pos =  source.lastIndexOf('</'+tagName+'>');
		if(pos<elStartEnd){//忘记闭合
			pos = source.lastIndexOf('</'+tagName);
		}
		closeMap[tagName] =pos;
	}
	return pos<elStartEnd;
	//} 
}
function _copy(source,target){
	for(var n in source){target[n] = source[n];}
}
function parseDCC(source,start,domBuilder,errorHandler){//sure start with '<!'
	var next= source.charAt(start+2);
	switch(next){
	case '-':
		if(source.charAt(start + 3) === '-'){
			var end = source.indexOf('-->',start+4);
			//append comment source.substring(4,end)//<!--
			if(end>start){
				domBuilder.comment(source,start+4,end-start-4);
				return end+3;
			}else {
				errorHandler.error("Unclosed comment");
				return -1;
			}
		}else {
			//error
			return -1;
		}
	default:
		if(source.substr(start+3,6) == 'CDATA['){
			var end = source.indexOf(']]>',start+9);
			domBuilder.startCDATA();
			domBuilder.characters(source,start+9,end-start-9);
			domBuilder.endCDATA(); 
			return end+3;
		}
		//<!DOCTYPE
		//startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId) 
		var matchs = split(source,start);
		var len = matchs.length;
		if(len>1 && /!doctype/i.test(matchs[0][0])){
			var name = matchs[1][0];
			var pubid = false;
			var sysid = false;
			if(len>3){
				if(/^public$/i.test(matchs[2][0])){
					pubid = matchs[3][0];
					sysid = len>4 && matchs[4][0];
				}else if(/^system$/i.test(matchs[2][0])){
					sysid = matchs[3][0];
				}
			}
			var lastMatch = matchs[len-1];
			domBuilder.startDTD(name, pubid, sysid);
			domBuilder.endDTD();
			
			return lastMatch.index+lastMatch[0].length
		}
	}
	return -1;
}



function parseInstruction(source,start,domBuilder){
	var end = source.indexOf('?>',start);
	if(end){
		var match = source.substring(start,end).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
		if(match){
			match[0].length;
			domBuilder.processingInstruction(match[1], match[2]) ;
			return end+2;
		}else {//error
			return -1;
		}
	}
	return -1;
}

function ElementAttributes(){
	this.attributeNames = {};
}
ElementAttributes.prototype = {
	setTagName:function(tagName){
		if(!tagNamePattern.test(tagName)){
			throw new Error('invalid tagName:'+tagName)
		}
		this.tagName = tagName;
	},
	addValue:function(qName, value, offset) {
		if(!tagNamePattern.test(qName)){
			throw new Error('invalid attribute:'+qName)
		}
		this.attributeNames[qName] = this.length;
		this[this.length++] = {qName:qName,value:value,offset:offset};
	},
	length:0,
	getLocalName:function(i){return this[i].localName},
	getLocator:function(i){return this[i].locator},
	getQName:function(i){return this[i].qName},
	getURI:function(i){return this[i].uri},
	getValue:function(i){return this[i].value}
//	,getIndex:function(uri, localName)){
//		if(localName){
//			
//		}else{
//			var qName = uri
//		}
//	},
//	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
//	getType:function(uri,localName){}
//	getType:function(i){},
};



function split(source,start){
	var match;
	var buf = [];
	var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
	reg.lastIndex = start;
	reg.exec(source);//skip <
	while(match = reg.exec(source)){
		buf.push(match);
		if(match[1])return buf;
	}
}

sax$1.XMLReader = XMLReader$1;
sax$1.ParseError = ParseError$1;

var dom = {};

var conventions$1 = conventions$2;

var NAMESPACE$1 = conventions$1.NAMESPACE;

/**
 * A prerequisite for `[].filter`, to drop elements that are empty
 * @param {string} input
 * @returns {boolean}
 */
function notEmptyString (input) {
	return input !== ''
}
/**
 * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
 * @see https://infra.spec.whatwg.org/#ascii-whitespace
 *
 * @param {string} input
 * @returns {string[]} (can be empty)
 */
function splitOnASCIIWhitespace(input) {
	// U+0009 TAB, U+000A LF, U+000C FF, U+000D CR, U+0020 SPACE
	return input ? input.split(/[\t\n\f\r ]+/).filter(notEmptyString) : []
}

/**
 * Adds element as a key to current if it is not already present.
 *
 * @param {Record<string, boolean | undefined>} current
 * @param {string} element
 * @returns {Record<string, boolean | undefined>}
 */
function orderedSetReducer (current, element) {
	if (!current.hasOwnProperty(element)) {
		current[element] = true;
	}
	return current;
}

/**
 * @see https://infra.spec.whatwg.org/#ordered-set
 * @param {string} input
 * @returns {string[]}
 */
function toOrderedSet(input) {
	if (!input) return [];
	var list = splitOnASCIIWhitespace(input);
	return Object.keys(list.reduce(orderedSetReducer, {}))
}

/**
 * Uses `list.indexOf` to implement something like `Array.prototype.includes`,
 * which we can not rely on being available.
 *
 * @param {any[]} list
 * @returns {function(any): boolean}
 */
function arrayIncludes (list) {
	return function(element) {
		return list && list.indexOf(element) !== -1;
	}
}

function copy(src,dest){
	for(var p in src){
		dest[p] = src[p];
	}
}

/**
^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
 */
function _extends(Class,Super){
	var pt = Class.prototype;
	if(!(pt instanceof Super)){
		function t(){}		t.prototype = Super.prototype;
		t = new t();
		copy(pt,t);
		Class.prototype = pt = t;
	}
	if(pt.constructor != Class){
		if(typeof Class != 'function'){
			console.error("unknow Class:"+Class);
		}
		pt.constructor = Class;
	}
}

// Node Types
var NodeType = {};
var ELEMENT_NODE                = NodeType.ELEMENT_NODE                = 1;
var ATTRIBUTE_NODE              = NodeType.ATTRIBUTE_NODE              = 2;
var TEXT_NODE                   = NodeType.TEXT_NODE                   = 3;
var CDATA_SECTION_NODE          = NodeType.CDATA_SECTION_NODE          = 4;
var ENTITY_REFERENCE_NODE       = NodeType.ENTITY_REFERENCE_NODE       = 5;
var ENTITY_NODE                 = NodeType.ENTITY_NODE                 = 6;
var PROCESSING_INSTRUCTION_NODE = NodeType.PROCESSING_INSTRUCTION_NODE = 7;
var COMMENT_NODE                = NodeType.COMMENT_NODE                = 8;
var DOCUMENT_NODE               = NodeType.DOCUMENT_NODE               = 9;
var DOCUMENT_TYPE_NODE          = NodeType.DOCUMENT_TYPE_NODE          = 10;
var DOCUMENT_FRAGMENT_NODE      = NodeType.DOCUMENT_FRAGMENT_NODE      = 11;
var NOTATION_NODE               = NodeType.NOTATION_NODE               = 12;

// ExceptionCode
var ExceptionCode = {};
var ExceptionMessage = {};
ExceptionCode.INDEX_SIZE_ERR              = ((ExceptionMessage[1]="Index size error"),1);
ExceptionCode.DOMSTRING_SIZE_ERR          = ((ExceptionMessage[2]="DOMString size error"),2);
var HIERARCHY_REQUEST_ERR       = ExceptionCode.HIERARCHY_REQUEST_ERR       = ((ExceptionMessage[3]="Hierarchy request error"),3);
ExceptionCode.WRONG_DOCUMENT_ERR          = ((ExceptionMessage[4]="Wrong document"),4);
ExceptionCode.INVALID_CHARACTER_ERR       = ((ExceptionMessage[5]="Invalid character"),5);
ExceptionCode.NO_DATA_ALLOWED_ERR         = ((ExceptionMessage[6]="No data allowed"),6);
ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = ((ExceptionMessage[7]="No modification allowed"),7);
var NOT_FOUND_ERR               = ExceptionCode.NOT_FOUND_ERR               = ((ExceptionMessage[8]="Not found"),8);
ExceptionCode.NOT_SUPPORTED_ERR           = ((ExceptionMessage[9]="Not supported"),9);
var INUSE_ATTRIBUTE_ERR         = ExceptionCode.INUSE_ATTRIBUTE_ERR         = ((ExceptionMessage[10]="Attribute in use"),10);
//level2
ExceptionCode.INVALID_STATE_ERR        	= ((ExceptionMessage[11]="Invalid state"),11);
ExceptionCode.SYNTAX_ERR               	= ((ExceptionMessage[12]="Syntax error"),12);
ExceptionCode.INVALID_MODIFICATION_ERR 	= ((ExceptionMessage[13]="Invalid modification"),13);
ExceptionCode.NAMESPACE_ERR           	= ((ExceptionMessage[14]="Invalid namespace"),14);
ExceptionCode.INVALID_ACCESS_ERR      	= ((ExceptionMessage[15]="Invalid access"),15);

/**
 * DOM Level 2
 * Object DOMException
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
 */
function DOMException(code, message) {
	if(message instanceof Error){
		var error = message;
	}else {
		error = this;
		Error.call(this, ExceptionMessage[code]);
		this.message = ExceptionMessage[code];
		if(Error.captureStackTrace) Error.captureStackTrace(this, DOMException);
	}
	error.code = code;
	if(message) this.message = this.message + ": " + message;
	return error;
}DOMException.prototype = Error.prototype;
copy(ExceptionCode,DOMException);

/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
 * The items in the NodeList are accessible via an integral index, starting from 0.
 */
function NodeList() {
}NodeList.prototype = {
	/**
	 * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
	 * @standard level1
	 */
	length:0, 
	/**
	 * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
	 * @standard level1
	 * @param index  unsigned long 
	 *   Index into the collection.
	 * @return Node
	 * 	The node at the indexth position in the NodeList, or null if that is not a valid index. 
	 */
	item: function(index) {
		return this[index] || null;
	},
	toString:function(isHTML,nodeFilter){
		for(var buf = [], i = 0;i<this.length;i++){
			serializeToString(this[i],buf,isHTML,nodeFilter);
		}
		return buf.join('');
	}
};

function LiveNodeList(node,refresh){
	this._node = node;
	this._refresh = refresh;
	_updateLiveList(this);
}
function _updateLiveList(list){
	var inc = list._node._inc || list._node.ownerDocument._inc;
	if(list._inc != inc){
		var ls = list._refresh(list._node);
		//console.log(ls.length)
		__set__(list,'length',ls.length);
		copy(ls,list);
		list._inc = inc;
	}
}
LiveNodeList.prototype.item = function(i){
	_updateLiveList(this);
	return this[i];
};

_extends(LiveNodeList,NodeList);

/**
 * Objects implementing the NamedNodeMap interface are used
 * to represent collections of nodes that can be accessed by name.
 * Note that NamedNodeMap does not inherit from NodeList;
 * NamedNodeMaps are not maintained in any particular order.
 * Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index,
 * but this is simply to allow convenient enumeration of the contents of a NamedNodeMap,
 * and does not imply that the DOM specifies an order to these Nodes.
 * NamedNodeMap objects in the DOM are live.
 * used for attributes or DocumentType entities 
 */
function NamedNodeMap() {
}
function _findNodeIndex(list,node){
	var i = list.length;
	while(i--){
		if(list[i] === node){return i}
	}
}

function _addNamedNode(el,list,newAttr,oldAttr){
	if(oldAttr){
		list[_findNodeIndex(list,oldAttr)] = newAttr;
	}else {
		list[list.length++] = newAttr;
	}
	if(el){
		newAttr.ownerElement = el;
		var doc = el.ownerDocument;
		if(doc){
			oldAttr && _onRemoveAttribute(doc,el,oldAttr);
			_onAddAttribute(doc,el,newAttr);
		}
	}
}
function _removeNamedNode(el,list,attr){
	//console.log('remove attr:'+attr)
	var i = _findNodeIndex(list,attr);
	if(i>=0){
		var lastIndex = list.length-1;
		while(i<lastIndex){
			list[i] = list[++i];
		}
		list.length = lastIndex;
		if(el){
			var doc = el.ownerDocument;
			if(doc){
				_onRemoveAttribute(doc,el,attr);
				attr.ownerElement = null;
			}
		}
	}else {
		throw DOMException(NOT_FOUND_ERR,new Error(el.tagName+'@'+attr))
	}
}
NamedNodeMap.prototype = {
	length:0,
	item:NodeList.prototype.item,
	getNamedItem: function(key) {
//		if(key.indexOf(':')>0 || key == 'xmlns'){
//			return null;
//		}
		//console.log()
		var i = this.length;
		while(i--){
			var attr = this[i];
			//console.log(attr.nodeName,key)
			if(attr.nodeName == key){
				return attr;
			}
		}
	},
	setNamedItem: function(attr) {
		var el = attr.ownerElement;
		if(el && el!=this._ownerElement){
			throw new DOMException(INUSE_ATTRIBUTE_ERR);
		}
		var oldAttr = this.getNamedItem(attr.nodeName);
		_addNamedNode(this._ownerElement,this,attr,oldAttr);
		return oldAttr;
	},
	/* returns Node */
	setNamedItemNS: function(attr) {// raises: WRONG_DOCUMENT_ERR,NO_MODIFICATION_ALLOWED_ERR,INUSE_ATTRIBUTE_ERR
		var el = attr.ownerElement, oldAttr;
		if(el && el!=this._ownerElement){
			throw new DOMException(INUSE_ATTRIBUTE_ERR);
		}
		oldAttr = this.getNamedItemNS(attr.namespaceURI,attr.localName);
		_addNamedNode(this._ownerElement,this,attr,oldAttr);
		return oldAttr;
	},

	/* returns Node */
	removeNamedItem: function(key) {
		var attr = this.getNamedItem(key);
		_removeNamedNode(this._ownerElement,this,attr);
		return attr;
		
		
	},// raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR
	
	//for level2
	removeNamedItemNS:function(namespaceURI,localName){
		var attr = this.getNamedItemNS(namespaceURI,localName);
		_removeNamedNode(this._ownerElement,this,attr);
		return attr;
	},
	getNamedItemNS: function(namespaceURI, localName) {
		var i = this.length;
		while(i--){
			var node = this[i];
			if(node.localName == localName && node.namespaceURI == namespaceURI){
				return node;
			}
		}
		return null;
	}
};

/**
 * The DOMImplementation interface represents an object providing methods
 * which are not dependent on any particular document.
 * Such an object is returned by the `Document.implementation` property.
 *
 * __The individual methods describe the differences compared to the specs.__
 *
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation MDN
 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490 DOM Level 1 Core (Initial)
 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#ID-102161490 DOM Level 2 Core
 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-102161490 DOM Level 3 Core
 * @see https://dom.spec.whatwg.org/#domimplementation DOM Living Standard
 */
function DOMImplementation$1() {
}

DOMImplementation$1.prototype = {
	/**
	 * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
	 * The different implementations fairly diverged in what kind of features were reported.
	 * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
	 *
	 * @deprecated It is deprecated and modern browsers return true in all cases.
	 *
	 * @param {string} feature
	 * @param {string} [version]
	 * @returns {boolean} always true
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
	 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
	 */
	hasFeature: function(feature, version) {
			return true;
	},
	/**
	 * Creates an XML Document object of the specified type with its document element.
	 *
	 * __It behaves slightly different from the description in the living standard__:
	 * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
	 * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * @param {string|null} namespaceURI
	 * @param {string} qualifiedName
	 * @param {DocumentType=null} doctype
	 * @returns {Document}
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */
	createDocument: function(namespaceURI,  qualifiedName, doctype){
		var doc = new Document();
		doc.implementation = this;
		doc.childNodes = new NodeList();
		doc.doctype = doctype || null;
		if (doctype){
			doc.appendChild(doctype);
		}
		if (qualifiedName){
			var root = doc.createElementNS(namespaceURI, qualifiedName);
			doc.appendChild(root);
		}
		return doc;
	},
	/**
	 * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
	 *
	 * __This behavior is slightly different from the in the specs__:
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * @param {string} qualifiedName
	 * @param {string} [publicId]
	 * @param {string} [systemId]
	 * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
	 * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */
	createDocumentType: function(qualifiedName, publicId, systemId){
		var node = new DocumentType();
		node.name = qualifiedName;
		node.nodeName = qualifiedName;
		node.publicId = publicId || '';
		node.systemId = systemId || '';

		return node;
	}
};


/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
 */

function Node() {
}
Node.prototype = {
	firstChild : null,
	lastChild : null,
	previousSibling : null,
	nextSibling : null,
	attributes : null,
	parentNode : null,
	childNodes : null,
	ownerDocument : null,
	nodeValue : null,
	namespaceURI : null,
	prefix : null,
	localName : null,
	// Modified in DOM Level 2:
	insertBefore:function(newChild, refChild){//raises 
		return _insertBefore(this,newChild,refChild);
	},
	replaceChild:function(newChild, oldChild){//raises 
		this.insertBefore(newChild,oldChild);
		if(oldChild){
			this.removeChild(oldChild);
		}
	},
	removeChild:function(oldChild){
		return _removeChild(this,oldChild);
	},
	appendChild:function(newChild){
		return this.insertBefore(newChild,null);
	},
	hasChildNodes:function(){
		return this.firstChild != null;
	},
	cloneNode:function(deep){
		return cloneNode(this.ownerDocument||this,this,deep);
	},
	// Modified in DOM Level 2:
	normalize:function(){
		var child = this.firstChild;
		while(child){
			var next = child.nextSibling;
			if(next && next.nodeType == TEXT_NODE && child.nodeType == TEXT_NODE){
				this.removeChild(next);
				child.appendData(next.data);
			}else {
				child.normalize();
				child = next;
			}
		}
	},
  	// Introduced in DOM Level 2:
	isSupported:function(feature, version){
		return this.ownerDocument.implementation.hasFeature(feature,version);
	},
    // Introduced in DOM Level 2:
    hasAttributes:function(){
    	return this.attributes.length>0;
    },
    lookupPrefix:function(namespaceURI){
    	var el = this;
    	while(el){
    		var map = el._nsMap;
    		//console.dir(map)
    		if(map){
    			for(var n in map){
    				if(map[n] == namespaceURI){
    					return n;
    				}
    			}
    		}
    		el = el.nodeType == ATTRIBUTE_NODE?el.ownerDocument : el.parentNode;
    	}
    	return null;
    },
    // Introduced in DOM Level 3:
    lookupNamespaceURI:function(prefix){
    	var el = this;
    	while(el){
    		var map = el._nsMap;
    		//console.dir(map)
    		if(map){
    			if(prefix in map){
    				return map[prefix] ;
    			}
    		}
    		el = el.nodeType == ATTRIBUTE_NODE?el.ownerDocument : el.parentNode;
    	}
    	return null;
    },
    // Introduced in DOM Level 3:
    isDefaultNamespace:function(namespaceURI){
    	var prefix = this.lookupPrefix(namespaceURI);
    	return prefix == null;
    }
};


function _xmlEncoder(c){
	return c == '<' && '&lt;' ||
         c == '>' && '&gt;' ||
         c == '&' && '&amp;' ||
         c == '"' && '&quot;' ||
         '&#'+c.charCodeAt()+';'
}


copy(NodeType,Node);
copy(NodeType,Node.prototype);

/**
 * @param callback return true for continue,false for break
 * @return boolean true: break visit;
 */
function _visitNode(node,callback){
	if(callback(node)){
		return true;
	}
	if(node = node.firstChild){
		do{
			if(_visitNode(node,callback)){return true}
        }while(node=node.nextSibling)
    }
}



function Document(){
}

function _onAddAttribute(doc,el,newAttr){
	doc && doc._inc++;
	var ns = newAttr.namespaceURI ;
	if(ns === NAMESPACE$1.XMLNS){
		//update namespace
		el._nsMap[newAttr.prefix?newAttr.localName:''] = newAttr.value;
	}
}

function _onRemoveAttribute(doc,el,newAttr,remove){
	doc && doc._inc++;
	var ns = newAttr.namespaceURI ;
	if(ns === NAMESPACE$1.XMLNS){
		//update namespace
		delete el._nsMap[newAttr.prefix?newAttr.localName:''];
	}
}

function _onUpdateChild(doc,el,newChild){
	if(doc && doc._inc){
		doc._inc++;
		//update childNodes
		var cs = el.childNodes;
		if(newChild){
			cs[cs.length++] = newChild;
		}else {
			//console.log(1)
			var child = el.firstChild;
			var i = 0;
			while(child){
				cs[i++] = child;
				child =child.nextSibling;
			}
			cs.length = i;
		}
	}
}

/**
 * attributes;
 * children;
 * 
 * writeable properties:
 * nodeValue,Attr:value,CharacterData:data
 * prefix
 */
function _removeChild(parentNode,child){
	var previous = child.previousSibling;
	var next = child.nextSibling;
	if(previous){
		previous.nextSibling = next;
	}else {
		parentNode.firstChild = next;
	}
	if(next){
		next.previousSibling = previous;
	}else {
		parentNode.lastChild = previous;
	}
	_onUpdateChild(parentNode.ownerDocument,parentNode);
	return child;
}
/**
 * preformance key(refChild == null)
 */
function _insertBefore(parentNode,newChild,nextChild){
	var cp = newChild.parentNode;
	if(cp){
		cp.removeChild(newChild);//remove and update
	}
	if(newChild.nodeType === DOCUMENT_FRAGMENT_NODE){
		var newFirst = newChild.firstChild;
		if (newFirst == null) {
			return newChild;
		}
		var newLast = newChild.lastChild;
	}else {
		newFirst = newLast = newChild;
	}
	var pre = nextChild ? nextChild.previousSibling : parentNode.lastChild;

	newFirst.previousSibling = pre;
	newLast.nextSibling = nextChild;
	
	
	if(pre){
		pre.nextSibling = newFirst;
	}else {
		parentNode.firstChild = newFirst;
	}
	if(nextChild == null){
		parentNode.lastChild = newLast;
	}else {
		nextChild.previousSibling = newLast;
	}
	do{
		newFirst.parentNode = parentNode;
	}while(newFirst !== newLast && (newFirst= newFirst.nextSibling))
	_onUpdateChild(parentNode.ownerDocument||parentNode,parentNode);
	//console.log(parentNode.lastChild.nextSibling == null)
	if (newChild.nodeType == DOCUMENT_FRAGMENT_NODE) {
		newChild.firstChild = newChild.lastChild = null;
	}
	return newChild;
}
function _appendSingleChild(parentNode,newChild){
	var cp = newChild.parentNode;
	if(cp){
		var pre = parentNode.lastChild;
		cp.removeChild(newChild);//remove and update
		var pre = parentNode.lastChild;
	}
	var pre = parentNode.lastChild;
	newChild.parentNode = parentNode;
	newChild.previousSibling = pre;
	newChild.nextSibling = null;
	if(pre){
		pre.nextSibling = newChild;
	}else {
		parentNode.firstChild = newChild;
	}
	parentNode.lastChild = newChild;
	_onUpdateChild(parentNode.ownerDocument,parentNode,newChild);
	return newChild;
	//console.log("__aa",parentNode.lastChild.nextSibling == null)
}
Document.prototype = {
	//implementation : null,
	nodeName :  '#document',
	nodeType :  DOCUMENT_NODE,
	doctype :  null,
	documentElement :  null,
	_inc : 1,

	insertBefore :  function(newChild, refChild){//raises
		if(newChild.nodeType == DOCUMENT_FRAGMENT_NODE){
			var child = newChild.firstChild;
			while(child){
				var next = child.nextSibling;
				this.insertBefore(child,refChild);
				child = next;
			}
			return newChild;
		}
		if(this.documentElement == null && newChild.nodeType == ELEMENT_NODE){
			this.documentElement = newChild;
		}

		return _insertBefore(this,newChild,refChild),(newChild.ownerDocument = this),newChild;
	},
	removeChild :  function(oldChild){
		if(this.documentElement == oldChild){
			this.documentElement = null;
		}
		return _removeChild(this,oldChild);
	},
	// Introduced in DOM Level 2:
	importNode : function(importedNode,deep){
		return importNode(this,importedNode,deep);
	},
	// Introduced in DOM Level 2:
	getElementById :	function(id){
		var rtv = null;
		_visitNode(this.documentElement,function(node){
			if(node.nodeType == ELEMENT_NODE){
				if(node.getAttribute('id') == id){
					rtv = node;
					return true;
				}
			}
		});
		return rtv;
	},

	/**
	 * The `getElementsByClassName` method of `Document` interface returns an array-like object
	 * of all child elements which have **all** of the given class name(s).
	 *
	 * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
	 *
	 *
	 * Warning: This is a live LiveNodeList.
	 * Changes in the DOM will reflect in the array as the changes occur.
	 * If an element selected by this array no longer qualifies for the selector,
	 * it will automatically be removed. Be aware of this for iteration purposes.
	 *
	 * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
	 * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
	 */
	getElementsByClassName: function(classNames) {
		var classNamesSet = toOrderedSet(classNames);
		return new LiveNodeList(this, function(base) {
			var ls = [];
			if (classNamesSet.length > 0) {
				_visitNode(base.documentElement, function(node) {
					if(node !== base && node.nodeType === ELEMENT_NODE) {
						var nodeClassNames = node.getAttribute('class');
						// can be null if the attribute does not exist
						if (nodeClassNames) {
							// before splitting and iterating just compare them for the most common case
							var matches = classNames === nodeClassNames;
							if (!matches) {
								var nodeClassNamesSet = toOrderedSet(nodeClassNames);
								matches = classNamesSet.every(arrayIncludes(nodeClassNamesSet));
							}
							if(matches) {
								ls.push(node);
							}
						}
					}
				});
			}
			return ls;
		});
	},

	//document factory method:
	createElement :	function(tagName){
		var node = new Element();
		node.ownerDocument = this;
		node.nodeName = tagName;
		node.tagName = tagName;
		node.localName = tagName;
		node.childNodes = new NodeList();
		var attrs	= node.attributes = new NamedNodeMap();
		attrs._ownerElement = node;
		return node;
	},
	createDocumentFragment :	function(){
		var node = new DocumentFragment();
		node.ownerDocument = this;
		node.childNodes = new NodeList();
		return node;
	},
	createTextNode :	function(data){
		var node = new Text();
		node.ownerDocument = this;
		node.appendData(data);
		return node;
	},
	createComment :	function(data){
		var node = new Comment();
		node.ownerDocument = this;
		node.appendData(data);
		return node;
	},
	createCDATASection :	function(data){
		var node = new CDATASection();
		node.ownerDocument = this;
		node.appendData(data);
		return node;
	},
	createProcessingInstruction :	function(target,data){
		var node = new ProcessingInstruction();
		node.ownerDocument = this;
		node.tagName = node.target = target;
		node.nodeValue= node.data = data;
		return node;
	},
	createAttribute :	function(name){
		var node = new Attr();
		node.ownerDocument	= this;
		node.name = name;
		node.nodeName	= name;
		node.localName = name;
		node.specified = true;
		return node;
	},
	createEntityReference :	function(name){
		var node = new EntityReference();
		node.ownerDocument	= this;
		node.nodeName	= name;
		return node;
	},
	// Introduced in DOM Level 2:
	createElementNS :	function(namespaceURI,qualifiedName){
		var node = new Element();
		var pl = qualifiedName.split(':');
		var attrs	= node.attributes = new NamedNodeMap();
		node.childNodes = new NodeList();
		node.ownerDocument = this;
		node.nodeName = qualifiedName;
		node.tagName = qualifiedName;
		node.namespaceURI = namespaceURI;
		if(pl.length == 2){
			node.prefix = pl[0];
			node.localName = pl[1];
		}else {
			//el.prefix = null;
			node.localName = qualifiedName;
		}
		attrs._ownerElement = node;
		return node;
	},
	// Introduced in DOM Level 2:
	createAttributeNS :	function(namespaceURI,qualifiedName){
		var node = new Attr();
		var pl = qualifiedName.split(':');
		node.ownerDocument = this;
		node.nodeName = qualifiedName;
		node.name = qualifiedName;
		node.namespaceURI = namespaceURI;
		node.specified = true;
		if(pl.length == 2){
			node.prefix = pl[0];
			node.localName = pl[1];
		}else {
			//el.prefix = null;
			node.localName = qualifiedName;
		}
		return node;
	}
};
_extends(Document,Node);


function Element() {
	this._nsMap = {};
}Element.prototype = {
	nodeType : ELEMENT_NODE,
	hasAttribute : function(name){
		return this.getAttributeNode(name)!=null;
	},
	getAttribute : function(name){
		var attr = this.getAttributeNode(name);
		return attr && attr.value || '';
	},
	getAttributeNode : function(name){
		return this.attributes.getNamedItem(name);
	},
	setAttribute : function(name, value){
		var attr = this.ownerDocument.createAttribute(name);
		attr.value = attr.nodeValue = "" + value;
		this.setAttributeNode(attr);
	},
	removeAttribute : function(name){
		var attr = this.getAttributeNode(name);
		attr && this.removeAttributeNode(attr);
	},
	
	//four real opeartion method
	appendChild:function(newChild){
		if(newChild.nodeType === DOCUMENT_FRAGMENT_NODE){
			return this.insertBefore(newChild,null);
		}else {
			return _appendSingleChild(this,newChild);
		}
	},
	setAttributeNode : function(newAttr){
		return this.attributes.setNamedItem(newAttr);
	},
	setAttributeNodeNS : function(newAttr){
		return this.attributes.setNamedItemNS(newAttr);
	},
	removeAttributeNode : function(oldAttr){
		//console.log(this == oldAttr.ownerElement)
		return this.attributes.removeNamedItem(oldAttr.nodeName);
	},
	//get real attribute name,and remove it by removeAttributeNode
	removeAttributeNS : function(namespaceURI, localName){
		var old = this.getAttributeNodeNS(namespaceURI, localName);
		old && this.removeAttributeNode(old);
	},
	
	hasAttributeNS : function(namespaceURI, localName){
		return this.getAttributeNodeNS(namespaceURI, localName)!=null;
	},
	getAttributeNS : function(namespaceURI, localName){
		var attr = this.getAttributeNodeNS(namespaceURI, localName);
		return attr && attr.value || '';
	},
	setAttributeNS : function(namespaceURI, qualifiedName, value){
		var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
		attr.value = attr.nodeValue = "" + value;
		this.setAttributeNode(attr);
	},
	getAttributeNodeNS : function(namespaceURI, localName){
		return this.attributes.getNamedItemNS(namespaceURI, localName);
	},
	
	getElementsByTagName : function(tagName){
		return new LiveNodeList(this,function(base){
			var ls = [];
			_visitNode(base,function(node){
				if(node !== base && node.nodeType == ELEMENT_NODE && (tagName === '*' || node.tagName == tagName)){
					ls.push(node);
				}
			});
			return ls;
		});
	},
	getElementsByTagNameNS : function(namespaceURI, localName){
		return new LiveNodeList(this,function(base){
			var ls = [];
			_visitNode(base,function(node){
				if(node !== base && node.nodeType === ELEMENT_NODE && (namespaceURI === '*' || node.namespaceURI === namespaceURI) && (localName === '*' || node.localName == localName)){
					ls.push(node);
				}
			});
			return ls;
			
		});
	}
};
Document.prototype.getElementsByTagName = Element.prototype.getElementsByTagName;
Document.prototype.getElementsByTagNameNS = Element.prototype.getElementsByTagNameNS;


_extends(Element,Node);
function Attr() {
}Attr.prototype.nodeType = ATTRIBUTE_NODE;
_extends(Attr,Node);


function CharacterData() {
}CharacterData.prototype = {
	data : '',
	substringData : function(offset, count) {
		return this.data.substring(offset, offset+count);
	},
	appendData: function(text) {
		text = this.data+text;
		this.nodeValue = this.data = text;
		this.length = text.length;
	},
	insertData: function(offset,text) {
		this.replaceData(offset,0,text);
	
	},
	appendChild:function(newChild){
		throw new Error(ExceptionMessage[HIERARCHY_REQUEST_ERR])
	},
	deleteData: function(offset, count) {
		this.replaceData(offset,count,"");
	},
	replaceData: function(offset, count, text) {
		var start = this.data.substring(0,offset);
		var end = this.data.substring(offset+count);
		text = start + text + end;
		this.nodeValue = this.data = text;
		this.length = text.length;
	}
};
_extends(CharacterData,Node);
function Text() {
}Text.prototype = {
	nodeName : "#text",
	nodeType : TEXT_NODE,
	splitText : function(offset) {
		var text = this.data;
		var newText = text.substring(offset);
		text = text.substring(0, offset);
		this.data = this.nodeValue = text;
		this.length = text.length;
		var newNode = this.ownerDocument.createTextNode(newText);
		if(this.parentNode){
			this.parentNode.insertBefore(newNode, this.nextSibling);
		}
		return newNode;
	}
};
_extends(Text,CharacterData);
function Comment() {
}Comment.prototype = {
	nodeName : "#comment",
	nodeType : COMMENT_NODE
};
_extends(Comment,CharacterData);

function CDATASection() {
}CDATASection.prototype = {
	nodeName : "#cdata-section",
	nodeType : CDATA_SECTION_NODE
};
_extends(CDATASection,CharacterData);


function DocumentType() {
}DocumentType.prototype.nodeType = DOCUMENT_TYPE_NODE;
_extends(DocumentType,Node);

function Notation() {
}Notation.prototype.nodeType = NOTATION_NODE;
_extends(Notation,Node);

function Entity() {
}Entity.prototype.nodeType = ENTITY_NODE;
_extends(Entity,Node);

function EntityReference() {
}EntityReference.prototype.nodeType = ENTITY_REFERENCE_NODE;
_extends(EntityReference,Node);

function DocumentFragment() {
}DocumentFragment.prototype.nodeName =	"#document-fragment";
DocumentFragment.prototype.nodeType =	DOCUMENT_FRAGMENT_NODE;
_extends(DocumentFragment,Node);


function ProcessingInstruction() {
}
ProcessingInstruction.prototype.nodeType = PROCESSING_INSTRUCTION_NODE;
_extends(ProcessingInstruction,Node);
function XMLSerializer(){}
XMLSerializer.prototype.serializeToString = function(node,isHtml,nodeFilter){
	return nodeSerializeToString.call(node,isHtml,nodeFilter);
};
Node.prototype.toString = nodeSerializeToString;
function nodeSerializeToString(isHtml,nodeFilter){
	var buf = [];
	var refNode = this.nodeType == 9 && this.documentElement || this;
	var prefix = refNode.prefix;
	var uri = refNode.namespaceURI;
	
	if(uri && prefix == null){
		//console.log(prefix)
		var prefix = refNode.lookupPrefix(uri);
		if(prefix == null){
			//isHTML = true;
			var visibleNamespaces=[
			{namespace:uri,prefix:null}
			//{namespace:uri,prefix:''}
			];
		}
	}
	serializeToString(this,buf,isHtml,nodeFilter,visibleNamespaces);
	//console.log('###',this.nodeType,uri,prefix,buf.join(''))
	return buf.join('');
}

function needNamespaceDefine(node, isHTML, visibleNamespaces) {
	var prefix = node.prefix || '';
	var uri = node.namespaceURI;
	// According to [Namespaces in XML 1.0](https://www.w3.org/TR/REC-xml-names/#ns-using) ,
	// and more specifically https://www.w3.org/TR/REC-xml-names/#nsc-NoPrefixUndecl :
	// > In a namespace declaration for a prefix [...], the attribute value MUST NOT be empty.
	// in a similar manner [Namespaces in XML 1.1](https://www.w3.org/TR/xml-names11/#ns-using)
	// and more specifically https://www.w3.org/TR/xml-names11/#nsc-NSDeclared :
	// > [...] Furthermore, the attribute value [...] must not be an empty string.
	// so serializing empty namespace value like xmlns:ds="" would produce an invalid XML document.
	if (!uri) {
		return false;
	}
	if (prefix === "xml" && uri === NAMESPACE$1.XML || uri === NAMESPACE$1.XMLNS) {
		return false;
	}
	
	var i = visibleNamespaces.length; 
	while (i--) {
		var ns = visibleNamespaces[i];
		// get namespace prefix
		if (ns.prefix === prefix) {
			return ns.namespace !== uri;
		}
	}
	return true;
}
/**
 * Well-formed constraint: No < in Attribute Values
 * The replacement text of any entity referred to directly or indirectly in an attribute value must not contain a <.
 * @see https://www.w3.org/TR/xml/#CleanAttrVals
 * @see https://www.w3.org/TR/xml/#NT-AttValue
 */
function addSerializedAttribute(buf, qualifiedName, value) {
	buf.push(' ', qualifiedName, '="', value.replace(/[<&"]/g,_xmlEncoder), '"');
}

function serializeToString(node,buf,isHTML,nodeFilter,visibleNamespaces){
	if (!visibleNamespaces) {
		visibleNamespaces = [];
	}

	if(nodeFilter){
		node = nodeFilter(node);
		if(node){
			if(typeof node == 'string'){
				buf.push(node);
				return;
			}
		}else {
			return;
		}
		//buf.sort.apply(attrs, attributeSorter);
	}

	switch(node.nodeType){
	case ELEMENT_NODE:
		var attrs = node.attributes;
		var len = attrs.length;
		var child = node.firstChild;
		var nodeName = node.tagName;
		
		isHTML = NAMESPACE$1.isHTML(node.namespaceURI) || isHTML;

		var prefixedNodeName = nodeName;
		if (!isHTML && !node.prefix && node.namespaceURI) {
			var defaultNS;
			for (var ai = 0; ai < attrs.length; ai++) {
				if (attrs.item(ai).name === 'xmlns') {
					defaultNS = attrs.item(ai).value;
					break
				}
			}
			if (defaultNS !== node.namespaceURI) {
				for (var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--) {
					var namespace = visibleNamespaces[nsi];
					if (namespace.namespace === node.namespaceURI) {
						if (namespace.prefix) {
							prefixedNodeName = namespace.prefix + ':' + nodeName;
						}
						break
					}
				}
			}
		}

		buf.push('<', prefixedNodeName);

		for(var i=0;i<len;i++){
			// add namespaces for attributes
			var attr = attrs.item(i);
			if (attr.prefix == 'xmlns') {
				visibleNamespaces.push({ prefix: attr.localName, namespace: attr.value });
			}else if(attr.nodeName == 'xmlns'){
				visibleNamespaces.push({ prefix: '', namespace: attr.value });
			}
		}

		for(var i=0;i<len;i++){
			var attr = attrs.item(i);
			if (needNamespaceDefine(attr,isHTML, visibleNamespaces)) {
				var prefix = attr.prefix||'';
				var uri = attr.namespaceURI;
				addSerializedAttribute(buf, prefix ? 'xmlns:' + prefix : "xmlns", uri);
				visibleNamespaces.push({ prefix: prefix, namespace:uri });
			}
			serializeToString(attr,buf,isHTML,nodeFilter,visibleNamespaces);
		}

		// add namespace for current node		
		if (nodeName === prefixedNodeName && needNamespaceDefine(node, isHTML, visibleNamespaces)) {
			var prefix = node.prefix||'';
			var uri = node.namespaceURI;
			addSerializedAttribute(buf, prefix ? 'xmlns:' + prefix : "xmlns", uri);
			visibleNamespaces.push({ prefix: prefix, namespace:uri });
		}
		
		if(child || isHTML && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)){
			buf.push('>');
			//if is cdata child node
			if(isHTML && /^script$/i.test(nodeName)){
				while(child){
					if(child.data){
						buf.push(child.data);
					}else {
						serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
					}
					child = child.nextSibling;
				}
			}else
			{
				while(child){
					serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
					child = child.nextSibling;
				}
			}
			buf.push('</',prefixedNodeName,'>');
		}else {
			buf.push('/>');
		}
		// remove added visible namespaces
		//visibleNamespaces.length = startVisibleNamespaces;
		return;
	case DOCUMENT_NODE:
	case DOCUMENT_FRAGMENT_NODE:
		var child = node.firstChild;
		while(child){
			serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
			child = child.nextSibling;
		}
		return;
	case ATTRIBUTE_NODE:
		return addSerializedAttribute(buf, node.name, node.value);
	case TEXT_NODE:
		/**
		 * The ampersand character (&) and the left angle bracket (<) must not appear in their literal form,
		 * except when used as markup delimiters, or within a comment, a processing instruction, or a CDATA section.
		 * If they are needed elsewhere, they must be escaped using either numeric character references or the strings
		 * `&amp;` and `&lt;` respectively.
		 * The right angle bracket (>) may be represented using the string " &gt; ", and must, for compatibility,
		 * be escaped using either `&gt;` or a character reference when it appears in the string `]]>` in content,
		 * when that string is not marking the end of a CDATA section.
		 *
		 * In the content of elements, character data is any string of characters
		 * which does not contain the start-delimiter of any markup
		 * and does not include the CDATA-section-close delimiter, `]]>`.
		 *
		 * @see https://www.w3.org/TR/xml/#NT-CharData
		 */
		return buf.push(node.data
			.replace(/[<&]/g,_xmlEncoder)
			.replace(/]]>/g, ']]&gt;')
		);
	case CDATA_SECTION_NODE:
		return buf.push( '<![CDATA[',node.data,']]>');
	case COMMENT_NODE:
		return buf.push( "<!--",node.data,"-->");
	case DOCUMENT_TYPE_NODE:
		var pubid = node.publicId;
		var sysid = node.systemId;
		buf.push('<!DOCTYPE ',node.name);
		if(pubid){
			buf.push(' PUBLIC ', pubid);
			if (sysid && sysid!='.') {
				buf.push(' ', sysid);
			}
			buf.push('>');
		}else if(sysid && sysid!='.'){
			buf.push(' SYSTEM ', sysid, '>');
		}else {
			var sub = node.internalSubset;
			if(sub){
				buf.push(" [",sub,"]");
			}
			buf.push(">");
		}
		return;
	case PROCESSING_INSTRUCTION_NODE:
		return buf.push( "<?",node.target," ",node.data,"?>");
	case ENTITY_REFERENCE_NODE:
		return buf.push( '&',node.nodeName,';');
	//case ENTITY_NODE:
	//case NOTATION_NODE:
	default:
		buf.push('??',node.nodeName);
	}
}
function importNode(doc,node,deep){
	var node2;
	switch (node.nodeType) {
	case ELEMENT_NODE:
		node2 = node.cloneNode(false);
		node2.ownerDocument = doc;
		//var attrs = node2.attributes;
		//var len = attrs.length;
		//for(var i=0;i<len;i++){
			//node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
		//}
	case DOCUMENT_FRAGMENT_NODE:
		break;
	case ATTRIBUTE_NODE:
		deep = true;
		break;
	//case ENTITY_REFERENCE_NODE:
	//case PROCESSING_INSTRUCTION_NODE:
	////case TEXT_NODE:
	//case CDATA_SECTION_NODE:
	//case COMMENT_NODE:
	//	deep = false;
	//	break;
	//case DOCUMENT_NODE:
	//case DOCUMENT_TYPE_NODE:
	//cannot be imported.
	//case ENTITY_NODE:
	//case NOTATION_NODE：
	//can not hit in level3
	//default:throw e;
	}
	if(!node2){
		node2 = node.cloneNode(false);//false
	}
	node2.ownerDocument = doc;
	node2.parentNode = null;
	if(deep){
		var child = node.firstChild;
		while(child){
			node2.appendChild(importNode(doc,child,deep));
			child = child.nextSibling;
		}
	}
	return node2;
}
//
//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
function cloneNode(doc,node,deep){
	var node2 = new node.constructor();
	for(var n in node){
		var v = node[n];
		if(typeof v != 'object' ){
			if(v != node2[n]){
				node2[n] = v;
			}
		}
	}
	if(node.childNodes){
		node2.childNodes = new NodeList();
	}
	node2.ownerDocument = doc;
	switch (node2.nodeType) {
	case ELEMENT_NODE:
		var attrs	= node.attributes;
		var attrs2	= node2.attributes = new NamedNodeMap();
		var len = attrs.length;
		attrs2._ownerElement = node2;
		for(var i=0;i<len;i++){
			node2.setAttributeNode(cloneNode(doc,attrs.item(i),true));
		}
		break;	case ATTRIBUTE_NODE:
		deep = true;
	}
	if(deep){
		var child = node.firstChild;
		while(child){
			node2.appendChild(cloneNode(doc,child,deep));
			child = child.nextSibling;
		}
	}
	return node2;
}

function __set__(object,key,value){
	object[key] = value;
}
//do dynamic
try{
	if(Object.defineProperty){
		Object.defineProperty(LiveNodeList.prototype,'length',{
			get:function(){
				_updateLiveList(this);
				return this.$$length;
			}
		});

		Object.defineProperty(Node.prototype,'textContent',{
			get:function(){
				return getTextContent(this);
			},

			set:function(data){
				switch(this.nodeType){
				case ELEMENT_NODE:
				case DOCUMENT_FRAGMENT_NODE:
					while(this.firstChild){
						this.removeChild(this.firstChild);
					}
					if(data || String(data)){
						this.appendChild(this.ownerDocument.createTextNode(data));
					}
					break;

				default:
					this.data = data;
					this.value = data;
					this.nodeValue = data;
				}
			}
		});
		
		function getTextContent(node){
			switch(node.nodeType){
			case ELEMENT_NODE:
			case DOCUMENT_FRAGMENT_NODE:
				var buf = [];
				node = node.firstChild;
				while(node){
					if(node.nodeType!==7 && node.nodeType !==8){
						buf.push(getTextContent(node));
					}
					node = node.nextSibling;
				}
				return buf.join('');
			default:
				return node.nodeValue;
			}
		}

		__set__ = function(object,key,value){
			//console.log(value)
			object['$$'+key] = value;
		};
	}
}catch(e){//ie8
}

//if(typeof require == 'function'){
	dom.DocumentType = DocumentType;
	dom.DOMException = DOMException;
	dom.DOMImplementation = DOMImplementation$1;
	dom.Element = Element;
	dom.Node = Node;
	dom.NodeList = NodeList;
	dom.XMLSerializer = XMLSerializer;

var conventions = conventions$2;
var entities = entities$1;

var NAMESPACE = conventions.NAMESPACE;

function DOMParser(options){
	this.options = options ||{locator:{}};
}

DOMParser.prototype.parseFromString = function(source,mimeType){
	var options = this.options;
	var sax =  new XMLReader();
	var domBuilder = options.domBuilder || new DOMHandler();//contentHandler and LexicalHandler
	var errorHandler = options.errorHandler;
	var locator = options.locator;
	var defaultNSMap = options.xmlns||{};
	var isHTML = /\/x?html?$/.test(mimeType);//mimeType.toLowerCase().indexOf('html') > -1;
  	var entityMap = isHTML ? entities.HTML_ENTITIES : entities.XML_ENTITIES;
	if(locator){
		domBuilder.setDocumentLocator(locator);
	}

	sax.errorHandler = buildErrorHandler(errorHandler,domBuilder,locator);
	sax.domBuilder = options.domBuilder || domBuilder;
	if(isHTML){
		defaultNSMap[''] = NAMESPACE.HTML;
	}
	defaultNSMap.xml = defaultNSMap.xml || NAMESPACE.XML;
	if(source && typeof source === 'string'){
		sax.parse(source,defaultNSMap,entityMap);
	}else {
		sax.errorHandler.error("invalid doc source");
	}
	return domBuilder.doc;
};
function buildErrorHandler(errorImpl,domBuilder,locator){
	if(!errorImpl){
		if(domBuilder instanceof DOMHandler){
			return domBuilder;
		}
		errorImpl = domBuilder ;
	}
	var errorHandler = {};
	var isCallback = errorImpl instanceof Function;
	locator = locator||{};
	function build(key){
		var fn = errorImpl[key];
		if(!fn && isCallback){
			fn = errorImpl.length == 2?function(msg){errorImpl(key,msg);}:errorImpl;
		}
		errorHandler[key] = fn && function(msg){
			fn('[xmldom '+key+']\t'+msg+_locator(locator));
		}||function(){};
	}
	build('warning');
	build('error');
	build('fatalError');
	return errorHandler;
}

//console.log('#\n\n\n\n\n\n\n####')
/**
 * +ContentHandler+ErrorHandler
 * +LexicalHandler+EntityResolver2
 * -DeclHandler-DTDHandler
 *
 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
 */
function DOMHandler() {
    this.cdata = false;
}
function position(locator,node){
	node.lineNumber = locator.lineNumber;
	node.columnNumber = locator.columnNumber;
}
/**
 * @see org.xml.sax.ContentHandler#startDocument
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
 */
DOMHandler.prototype = {
	startDocument : function() {
    	this.doc = new DOMImplementation().createDocument(null, null, null);
    	if (this.locator) {
        	this.doc.documentURI = this.locator.systemId;
    	}
	},
	startElement:function(namespaceURI, localName, qName, attrs) {
		var doc = this.doc;
	    var el = doc.createElementNS(namespaceURI, qName||localName);
	    var len = attrs.length;
	    appendElement(this, el);
	    this.currentElement = el;

		this.locator && position(this.locator,el);
	    for (var i = 0 ; i < len; i++) {
	        var namespaceURI = attrs.getURI(i);
	        var value = attrs.getValue(i);
	        var qName = attrs.getQName(i);
			var attr = doc.createAttributeNS(namespaceURI, qName);
			this.locator &&position(attrs.getLocator(i),attr);
			attr.value = attr.nodeValue = value;
			el.setAttributeNode(attr);
	    }
	},
	endElement:function(namespaceURI, localName, qName) {
		var current = this.currentElement;
		current.tagName;
		this.currentElement = current.parentNode;
	},
	startPrefixMapping:function(prefix, uri) {
	},
	endPrefixMapping:function(prefix) {
	},
	processingInstruction:function(target, data) {
	    var ins = this.doc.createProcessingInstruction(target, data);
	    this.locator && position(this.locator,ins);
	    appendElement(this, ins);
	},
	ignorableWhitespace:function(ch, start, length) {
	},
	characters:function(chars, start, length) {
		chars = _toString.apply(this,arguments);
		//console.log(chars)
		if(chars){
			if (this.cdata) {
				var charNode = this.doc.createCDATASection(chars);
			} else {
				var charNode = this.doc.createTextNode(chars);
			}
			if(this.currentElement){
				this.currentElement.appendChild(charNode);
			}else if(/^\s*$/.test(chars)){
				this.doc.appendChild(charNode);
				//process xml
			}
			this.locator && position(this.locator,charNode);
		}
	},
	skippedEntity:function(name) {
	},
	endDocument:function() {
		this.doc.normalize();
	},
	setDocumentLocator:function (locator) {
	    if(this.locator = locator){// && !('lineNumber' in locator)){
	    	locator.lineNumber = 0;
	    }
	},
	//LexicalHandler
	comment:function(chars, start, length) {
		chars = _toString.apply(this,arguments);
	    var comm = this.doc.createComment(chars);
	    this.locator && position(this.locator,comm);
	    appendElement(this, comm);
	},

	startCDATA:function() {
	    //used in characters() methods
	    this.cdata = true;
	},
	endCDATA:function() {
	    this.cdata = false;
	},

	startDTD:function(name, publicId, systemId) {
		var impl = this.doc.implementation;
	    if (impl && impl.createDocumentType) {
	        var dt = impl.createDocumentType(name, publicId, systemId);
	        this.locator && position(this.locator,dt);
	        appendElement(this, dt);
	    }
	},
	/**
	 * @see org.xml.sax.ErrorHandler
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
	 */
	warning:function(error) {
		console.warn('[xmldom warning]\t'+error,_locator(this.locator));
	},
	error:function(error) {
		console.error('[xmldom error]\t'+error,_locator(this.locator));
	},
	fatalError:function(error) {
		throw new ParseError(error, this.locator);
	}
};
function _locator(l){
	if(l){
		return '\n@'+(l.systemId ||'')+'#[line:'+l.lineNumber+',col:'+l.columnNumber+']'
	}
}
function _toString(chars,start,length){
	if(typeof chars == 'string'){
		return chars.substr(start,length)
	}else {//java sax connect width xmldom on rhino(what about: "? && !(chars instanceof String)")
		if(chars.length >= start+length || start){
			return new java.lang.String(chars,start,length)+'';
		}
		return chars;
	}
}

/*
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
 * used method of org.xml.sax.ext.LexicalHandler:
 *  #comment(chars, start, length)
 *  #startCDATA()
 *  #endCDATA()
 *  #startDTD(name, publicId, systemId)
 *
 *
 * IGNORED method of org.xml.sax.ext.LexicalHandler:
 *  #endDTD()
 *  #startEntity(name)
 *  #endEntity(name)
 *
 *
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
 * IGNORED method of org.xml.sax.ext.DeclHandler
 * 	#attributeDecl(eName, aName, type, mode, value)
 *  #elementDecl(name, model)
 *  #externalEntityDecl(name, publicId, systemId)
 *  #internalEntityDecl(name, value)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
 * IGNORED method of org.xml.sax.EntityResolver2
 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
 *  #resolveEntity(publicId, systemId)
 *  #getExternalSubset(name, baseURI)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
 * IGNORED method of org.xml.sax.DTDHandler
 *  #notationDecl(name, publicId, systemId) {};
 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
 */
"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g,function(key){
	DOMHandler.prototype[key] = function(){return null};
});

/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */
function appendElement (hander,node) {
    if (!hander.currentElement) {
        hander.doc.appendChild(node);
    } else {
        hander.currentElement.appendChild(node);
    }
}//appendChild and setAttributeNS are preformance key

//if(typeof require == 'function'){
var sax = sax$1;
var XMLReader = sax.XMLReader;
var ParseError = sax.ParseError;
var DOMImplementation = domParser.DOMImplementation = dom.DOMImplementation;
domParser.XMLSerializer = dom.XMLSerializer ;
domParser.DOMParser = DOMParser;
domParser.__DOMHandler = DOMHandler;

var parseJson$1 = {};

Object.defineProperty(parseJson$1, "__esModule", { value: true });
parseJson$1.parseJson = void 0;
/**
 * Parses a given string into JSON.
 * Gracefully handles invalid JSON by returning `null`.
 */
function parseJson(data) {
    try {
        var json = JSON.parse(data);
        return json;
    }
    catch (_) {
        return null;
    }
}
parseJson$1.parseJson = parseJson;

var bufferFrom$1 = {};

Object.defineProperty(bufferFrom$1, "__esModule", { value: true });
bufferFrom$1.bufferFrom = void 0;
/**
 * Convert a given string into a `Uint8Array`.
 * We don't use `TextEncoder` because it's unavailable in some environments.
 */
function bufferFrom(init) {
    var encodedString = encodeURIComponent(init);
    var binaryString = encodedString.replace(/%([0-9A-F]{2})/g, function (_, char) {
        return String.fromCharCode(('0x' + char));
    });
    var buffer = new Uint8Array(binaryString.length);
    Array.prototype.forEach.call(binaryString, function (char, index) {
        buffer[index] = char.charCodeAt(0);
    });
    return buffer;
}
bufferFrom$1.bufferFrom = bufferFrom;

var createEvent$1 = {};

var EventPolyfill$1 = {};

Object.defineProperty(EventPolyfill$1, "__esModule", { value: true });
EventPolyfill$1.EventPolyfill = void 0;
var EventPolyfill = /** @class */ (function () {
    function EventPolyfill(type, options) {
        this.AT_TARGET = 0;
        this.BUBBLING_PHASE = 0;
        this.CAPTURING_PHASE = 0;
        this.NONE = 0;
        this.type = '';
        this.srcElement = null;
        this.currentTarget = null;
        this.eventPhase = 0;
        this.isTrusted = true;
        this.composed = false;
        this.cancelable = true;
        this.defaultPrevented = false;
        this.bubbles = true;
        this.lengthComputable = true;
        this.loaded = 0;
        this.total = 0;
        this.cancelBubble = false;
        this.returnValue = true;
        this.type = type;
        this.target = (options === null || options === void 0 ? void 0 : options.target) || null;
        this.currentTarget = (options === null || options === void 0 ? void 0 : options.currentTarget) || null;
        this.timeStamp = Date.now();
    }
    EventPolyfill.prototype.composedPath = function () {
        return [];
    };
    EventPolyfill.prototype.initEvent = function (type, bubbles, cancelable) {
        this.type = type;
        this.bubbles = !!bubbles;
        this.cancelable = !!cancelable;
    };
    EventPolyfill.prototype.preventDefault = function () {
        this.defaultPrevented = true;
    };
    EventPolyfill.prototype.stopPropagation = function () { };
    EventPolyfill.prototype.stopImmediatePropagation = function () { };
    return EventPolyfill;
}());
EventPolyfill$1.EventPolyfill = EventPolyfill;

var ProgressEventPolyfill$1 = {};

var esm_extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(ProgressEventPolyfill$1, "__esModule", { value: true });
ProgressEventPolyfill$1.ProgressEventPolyfill = void 0;
var EventPolyfill_1$1 = EventPolyfill$1;
var ProgressEventPolyfill = /** @class */ (function (_super) {
    esm_extends(ProgressEventPolyfill, _super);
    function ProgressEventPolyfill(type, init) {
        var _this = _super.call(this, type) || this;
        _this.lengthComputable = (init === null || init === void 0 ? void 0 : init.lengthComputable) || false;
        _this.composed = (init === null || init === void 0 ? void 0 : init.composed) || false;
        _this.loaded = (init === null || init === void 0 ? void 0 : init.loaded) || 0;
        _this.total = (init === null || init === void 0 ? void 0 : init.total) || 0;
        return _this;
    }
    return ProgressEventPolyfill;
}(EventPolyfill_1$1.EventPolyfill));
ProgressEventPolyfill$1.ProgressEventPolyfill = ProgressEventPolyfill;

Object.defineProperty(createEvent$1, "__esModule", { value: true });
createEvent$1.createEvent = void 0;
var EventPolyfill_1 = EventPolyfill$1;
var ProgressEventPolyfill_1 = ProgressEventPolyfill$1;
var SUPPORTS_PROGRESS_EVENT = typeof ProgressEvent !== 'undefined';
function createEvent(target, type, init) {
    var progressEvents = [
        'error',
        'progress',
        'loadstart',
        'loadend',
        'load',
        'timeout',
        'abort',
    ];
    /**
     * `ProgressEvent` is not supported in React Native.
     * @see https://github.com/mswjs/interceptors/issues/40
     */
    var ProgressEventClass = SUPPORTS_PROGRESS_EVENT
        ? ProgressEvent
        : ProgressEventPolyfill_1.ProgressEventPolyfill;
    var event = progressEvents.includes(type)
        ? new ProgressEventClass(type, {
            lengthComputable: true,
            loaded: (init === null || init === void 0 ? void 0 : init.loaded) || 0,
            total: (init === null || init === void 0 ? void 0 : init.total) || 0,
        })
        : new EventPolyfill_1.EventPolyfill(type, {
            target: target,
            currentTarget: target,
        });
    return event;
}
createEvent$1.createEvent = createEvent;

var esm_awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var esm_generator = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var esm_values = (commonjsGlobal && commonjsGlobal.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var esm_read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(XMLHttpRequestOverride, "__esModule", { value: true });
XMLHttpRequestOverride.createXMLHttpRequestOverride = void 0;
/**
 * XMLHttpRequest override class.
 * Inspired by https://github.com/marvinhagemeister/xhr-mocklet.
 */
var until_1 = lib$2;
var headers_utils_1 = lib$1;
var xmldom_1 = domParser;
var parseJson_1 = parseJson$1;
var toIsoResponse_1 = toIsoResponse$1;
var uuid_1 = uuid;
var bufferFrom_1 = bufferFrom$1;
var createEvent_1 = createEvent$1;
var createDebug = (browser_default());
var createXMLHttpRequestOverride = function (options) {
    var _a;
    var pureXMLHttpRequest = options.pureXMLHttpRequest, observer = options.observer, resolver = options.resolver;
    var debug = createDebug('XHR');
    return _a = /** @class */ (function () {
            function XMLHttpRequestOverride() {
                // Collection of events modified by `addEventListener`/`removeEventListener` calls.
                this._events = [];
                this.UNSENT = 0;
                this.OPENED = 1;
                this.HEADERS_RECEIVED = 2;
                this.LOADING = 3;
                this.DONE = 4;
                this.onreadystatechange = null;
                /* Events */
                this.onabort = null;
                this.onerror = null;
                this.onload = null;
                this.onloadend = null;
                this.onloadstart = null;
                this.onprogress = null;
                this.ontimeout = null;
                this.url = '';
                this.method = 'GET';
                this.readyState = this.UNSENT;
                this.withCredentials = false;
                this.status = 200;
                this.statusText = 'OK';
                this.data = '';
                this.response = '';
                this.responseType = 'text';
                this.responseText = '';
                this.responseXML = null;
                this.responseURL = '';
                this.upload = null;
                this.timeout = 0;
                this._requestHeaders = new headers_utils_1.Headers();
                this._responseHeaders = new headers_utils_1.Headers();
            }
            XMLHttpRequestOverride.prototype.setReadyState = function (nextState) {
                if (nextState === this.readyState) {
                    return;
                }
                debug('readyState change %d -> %d', this.readyState, nextState);
                this.readyState = nextState;
                if (nextState !== this.UNSENT) {
                    debug('triggerring readystate change...');
                    this.trigger('readystatechange');
                }
            };
            /**
             * Triggers both direct callback and attached event listeners
             * for the given event.
             */
            XMLHttpRequestOverride.prototype.trigger = function (eventName, options) {
                var e_1, _a;
                debug('trigger "%s" (%d)', eventName, this.readyState);
                debug('resolve listener for event "%s"', eventName);
                // @ts-expect-error XMLHttpRequest class has no index signature.
                var callback = this["on" + eventName];
                callback === null || callback === void 0 ? void 0 : callback.call(this, createEvent_1.createEvent(this, eventName, options));
                try {
                    for (var _b = esm_values(this._events), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var event_1 = _c.value;
                        if (event_1.name === eventName) {
                            debug('calling mock event listener "%s" (%d)', eventName, this.readyState);
                            event_1.listener.call(this, createEvent_1.createEvent(this, eventName, options));
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return this;
            };
            XMLHttpRequestOverride.prototype.reset = function () {
                debug('reset');
                this.setReadyState(this.UNSENT);
                this.status = 200;
                this.statusText = 'OK';
                this.data = '';
                this.response = null;
                this.responseText = null;
                this.responseXML = null;
                this._requestHeaders = new headers_utils_1.Headers();
                this._responseHeaders = new headers_utils_1.Headers();
            };
            XMLHttpRequestOverride.prototype.open = function (method, url, async, user, password) {
                if (async === void 0) { async = true; }
                return esm_awaiter(this, void 0, void 0, function () {
                    return esm_generator(this, function (_a) {
                        debug = createDebug("XHR " + method + " " + url);
                        debug('open', { method: method, url: url, async: async, user: user, password: password });
                        this.reset();
                        this.setReadyState(this.OPENED);
                        if (typeof url === 'undefined') {
                            this.url = method;
                            this.method = 'GET';
                        }
                        else {
                            this.url = url;
                            this.method = method;
                            this.async = async;
                            this.user = user;
                            this.password = password;
                        }
                        return [2 /*return*/];
                    });
                });
            };
            XMLHttpRequestOverride.prototype.send = function (data) {
                var _this = this;
                debug('send %s %s', this.method, this.url);
                this.data = data || '';
                var url;
                try {
                    url = new URL(this.url);
                }
                catch (error) {
                    // Assume a relative URL, if construction of a new `URL` instance fails.
                    // Since `XMLHttpRequest` always executed in a DOM-like environment,
                    // resolve the relative request URL against the current window location.
                    url = new URL(this.url, window.location.href);
                }
                debug('request headers', this._requestHeaders);
                // Create an intercepted request instance exposed to the request intercepting middleware.
                var isoRequest = {
                    id: uuid_1.uuidv4(),
                    url: url,
                    method: this.method,
                    body: this.data,
                    headers: this._requestHeaders,
                };
                observer.emit('request', isoRequest);
                debug('awaiting mocked response...');
                Promise.resolve(until_1.until(function () { return esm_awaiter(_this, void 0, void 0, function () { return esm_generator(this, function (_a) {
                    return [2 /*return*/, resolver(isoRequest, this)];
                }); }); })).then(function (_a) {
                    var _b;
                    var _c = esm_read(_a, 2), middlewareException = _c[0], mockedResponse = _c[1];
                    // When the request middleware throws an exception, error the request.
                    // This cancels the request and is similar to a network error.
                    if (middlewareException) {
                        debug('middleware function threw an exception!', middlewareException);
                        // No way to propagate the actual error message.
                        _this.trigger('error');
                        _this.abort();
                        return;
                    }
                    // Return a mocked response, if provided in the middleware.
                    if (mockedResponse) {
                        debug('received mocked response', mockedResponse);
                        // Trigger a loadstart event to indicate the initialization of the fetch.
                        _this.trigger('loadstart');
                        _this.status = mockedResponse.status || 200;
                        _this.statusText = mockedResponse.statusText || 'OK';
                        _this._responseHeaders = mockedResponse.headers
                            ? headers_utils_1.objectToHeaders(mockedResponse.headers)
                            : new headers_utils_1.Headers();
                        debug('set response status', _this.status, _this.statusText);
                        debug('set response headers', _this._responseHeaders);
                        // Mark that response headers has been received
                        // and trigger a ready state event to reflect received headers
                        // in a custom `onreadystatechange` callback.
                        _this.setReadyState(_this.HEADERS_RECEIVED);
                        debug('response type', _this.responseType);
                        _this.response = _this.getResponseBody(mockedResponse.body);
                        _this.responseText = mockedResponse.body || '';
                        _this.responseXML = _this.getResponseXML();
                        debug('set response body', _this.response);
                        if (mockedResponse.body && _this.response) {
                            _this.setReadyState(_this.LOADING);
                            // Presense of the mocked response implies a response body (not null).
                            // Presense of the coerced `this.response` implies the mocked body is valid.
                            var bodyBuffer = bufferFrom_1.bufferFrom(mockedResponse.body);
                            // Trigger a progress event based on the mocked response body.
                            _this.trigger('progress', {
                                loaded: bodyBuffer.length,
                                total: bodyBuffer.length,
                            });
                        }
                        /**
                         * Explicitly mark the request as done so its response never hangs.
                         * @see https://github.com/mswjs/interceptors/issues/13
                         */
                        _this.setReadyState(_this.DONE);
                        // Trigger a load event to indicate the fetch has succeeded.
                        _this.trigger('load');
                        // Trigger a loadend event to indicate the fetch has completed.
                        _this.trigger('loadend');
                        observer.emit('response', isoRequest, toIsoResponse_1.toIsoResponse(mockedResponse));
                    }
                    else {
                        debug('no mocked response received!');
                        // Perform an original request, when the request middleware returned no mocked response.
                        var originalRequest_1 = new pureXMLHttpRequest();
                        debug('opening an original request %s %s', _this.method, _this.url);
                        originalRequest_1.open(_this.method, _this.url, (_b = _this.async) !== null && _b !== void 0 ? _b : true, _this.user, _this.password);
                        // Reflect a successful state of the original request
                        // on the patched instance.
                        originalRequest_1.addEventListener('load', function () {
                            debug('original "onload"');
                            _this.status = originalRequest_1.status;
                            _this.statusText = originalRequest_1.statusText;
                            _this.responseURL = originalRequest_1.responseURL;
                            _this.responseType = originalRequest_1.responseType;
                            _this.response = originalRequest_1.response;
                            _this.responseText = originalRequest_1.responseText;
                            _this.responseXML = originalRequest_1.responseXML;
                            debug('set mock request readyState to DONE');
                            // Explicitly mark the mocked request instance as done
                            // so the response never hangs.
                            /**
                             * @note `readystatechange` listener is called TWICE
                             * in the case of unhandled request.
                             */
                            _this.setReadyState(_this.DONE);
                            debug('received original response', _this.status, _this.statusText);
                            debug('original response body:', _this.response);
                            var responseHeaders = originalRequest_1.getAllResponseHeaders();
                            debug('original response headers:\n', responseHeaders);
                            _this._responseHeaders = headers_utils_1.stringToHeaders(responseHeaders);
                            debug('original response headers (normalized)', _this._responseHeaders);
                            debug('original response finished');
                            observer.emit('response', isoRequest, {
                                status: originalRequest_1.status,
                                statusText: originalRequest_1.statusText,
                                headers: _this._responseHeaders,
                                body: originalRequest_1.response,
                            });
                        });
                        // Assign callbacks and event listeners from the intercepted XHR instance
                        // to the original XHR instance.
                        _this.propagateCallbacks(originalRequest_1);
                        _this.propagateListeners(originalRequest_1);
                        _this.propagateHeaders(originalRequest_1, _this._requestHeaders);
                        if (_this.async) {
                            originalRequest_1.timeout = _this.timeout;
                        }
                        debug('send', _this.data);
                        originalRequest_1.send(_this.data);
                    }
                });
            };
            XMLHttpRequestOverride.prototype.abort = function () {
                debug('abort');
                if (this.readyState > this.UNSENT && this.readyState < this.DONE) {
                    this.setReadyState(this.UNSENT);
                    this.trigger('abort');
                }
            };
            XMLHttpRequestOverride.prototype.dispatchEvent = function () {
                return false;
            };
            XMLHttpRequestOverride.prototype.setRequestHeader = function (name, value) {
                debug('set request header "%s" to "%s"', name, value);
                this._requestHeaders.append(name, value);
            };
            XMLHttpRequestOverride.prototype.getResponseHeader = function (name) {
                debug('get response header "%s"', name);
                if (this.readyState < this.HEADERS_RECEIVED) {
                    debug('cannot return a header: headers not received (state: %s)', this.readyState);
                    return null;
                }
                var headerValue = this._responseHeaders.get(name);
                debug('resolved response header "%s" to "%s"', name, headerValue, this._responseHeaders);
                return headerValue;
            };
            XMLHttpRequestOverride.prototype.getAllResponseHeaders = function () {
                debug('get all response headers');
                if (this.readyState < this.HEADERS_RECEIVED) {
                    debug('cannot return headers: headers not received (state: %s)', this.readyState);
                    return '';
                }
                return headers_utils_1.headersToString(this._responseHeaders);
            };
            XMLHttpRequestOverride.prototype.addEventListener = function (name, listener) {
                debug('addEventListener', name, listener);
                this._events.push({
                    name: name,
                    listener: listener,
                });
            };
            XMLHttpRequestOverride.prototype.removeEventListener = function (name, listener) {
                debug('removeEventListener', name, listener);
                this._events = this._events.filter(function (storedEvent) {
                    return storedEvent.name !== name && storedEvent.listener !== listener;
                });
            };
            XMLHttpRequestOverride.prototype.overrideMimeType = function () { };
            /**
             * Resolves the response based on the `responseType` value.
             */
            XMLHttpRequestOverride.prototype.getResponseBody = function (body) {
                // Handle an improperly set "null" value of the mocked response body.
                var textBody = body !== null && body !== void 0 ? body : '';
                debug('coerced response body to', textBody);
                switch (this.responseType) {
                    case 'json': {
                        debug('resolving response body as JSON');
                        return parseJson_1.parseJson(textBody);
                    }
                    case 'blob': {
                        var blobType = this.getResponseHeader('content-type') || 'text/plain';
                        debug('resolving response body as Blob', { type: blobType });
                        return new Blob([textBody], {
                            type: blobType,
                        });
                    }
                    case 'arraybuffer': {
                        debug('resolving response body as ArrayBuffer');
                        var arrayBuffer = bufferFrom_1.bufferFrom(textBody);
                        return arrayBuffer;
                    }
                    default:
                        return textBody;
                }
            };
            XMLHttpRequestOverride.prototype.getResponseXML = function () {
                var contentType = this.getResponseHeader('Content-Type');
                if (contentType === 'application/xml' || contentType === 'text/xml') {
                    return new xmldom_1.DOMParser().parseFromString(this.responseText, contentType);
                }
                return null;
            };
            /**
             * Propagates mock XMLHttpRequest instance callbacks
             * to the given XMLHttpRequest instance.
             */
            XMLHttpRequestOverride.prototype.propagateCallbacks = function (request) {
                request.onabort = this.abort;
                request.onerror = this.onerror;
                request.ontimeout = this.ontimeout;
                request.onload = this.onload;
                request.onloadstart = this.onloadstart;
                request.onloadend = this.onloadend;
                request.onprogress = this.onprogress;
                request.onreadystatechange = this.onreadystatechange;
            };
            /**
             * Propagates the mock XMLHttpRequest instance listeners
             * to the given XMLHttpRequest instance.
             */
            XMLHttpRequestOverride.prototype.propagateListeners = function (request) {
                debug('propagating request listeners (%d) to the original request', this._events.length, this._events);
                this._events.forEach(function (_a) {
                    var name = _a.name, listener = _a.listener;
                    request.addEventListener(name, listener);
                });
            };
            XMLHttpRequestOverride.prototype.propagateHeaders = function (request, headers) {
                debug('propagating request headers to the original request', headers);
                // Preserve the request headers casing.
                Object.entries(headers.raw()).forEach(function (_a) {
                    var _b = esm_read(_a, 2), name = _b[0], value = _b[1];
                    debug('setting "%s" (%s) header on the original request', name, value);
                    request.setRequestHeader(name, value);
                });
            };
            return XMLHttpRequestOverride;
        }()),
        /* Request state */
        _a.UNSENT = 0,
        _a.OPENED = 1,
        _a.HEADERS_RECEIVED = 2,
        _a.LOADING = 3,
        _a.DONE = 4,
        _a;
};
XMLHttpRequestOverride.createXMLHttpRequestOverride = createXMLHttpRequestOverride;

Object.defineProperty(XMLHttpRequest, "__esModule", { value: true });
var interceptXMLHttpRequest_1 = XMLHttpRequest.interceptXMLHttpRequest = void 0;
var XMLHttpRequestOverride_1 = XMLHttpRequestOverride;
var debug = browser_default()('XHR');
var pureXMLHttpRequest = 
// Although executed in node, certain processes emulate the DOM-like environment
// (i.e. `js-dom` in Jest). The `window` object would be avilable in such environments.
typeof window === 'undefined' ? undefined : window.XMLHttpRequest;
/**
 * Intercepts requests issued via `XMLHttpRequest`.
 */
var interceptXMLHttpRequest = function (observer, resolver) {
    if (pureXMLHttpRequest) {
        debug('patching "XMLHttpRequest" module...');
        var XMLHttpRequestOverride = XMLHttpRequestOverride_1.createXMLHttpRequestOverride({
            pureXMLHttpRequest: pureXMLHttpRequest,
            observer: observer,
            resolver: resolver,
        });
        window.XMLHttpRequest = XMLHttpRequestOverride;
    }
    return function () {
        if (pureXMLHttpRequest) {
            debug('restoring modules...');
            window.XMLHttpRequest = pureXMLHttpRequest;
        }
    };
};
interceptXMLHttpRequest_1 = XMLHttpRequest.interceptXMLHttpRequest = interceptXMLHttpRequest;

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

/**
 * Converts a given isomorphic request to a `MockedRequest` instance.
 */
function parseIsomorphicRequest(request) {
    const requestId = uuidv4();
    request.headers.set('x-msw-request-id', requestId);
    const mockedRequest = {
        id: requestId,
        url: request.url,
        method: request.method,
        body: parseBody(request.body, request.headers),
        headers: request.headers,
        cookies: {},
        redirect: 'manual',
        referrer: '',
        keepalive: false,
        cache: 'default',
        mode: 'cors',
        referrerPolicy: 'no-referrer',
        integrity: '',
        destination: 'document',
        bodyUsed: false,
        credentials: 'same-origin',
    };
    // Set mocked request cookies from the `cookie` header of the original request.
    // No need to take `credentials` into account, because in Node.js requests are intercepted
    // _after_ they happen. Request issuer should have already taken care of sending relevant cookies.
    // Unlike browser, where interception is on the worker level, _before_ the request happens.
    const requestCookiesString = request.headers.get('cookie');
    // Attach all the cookies from the virtual cookie store.
    setRequestCookies(mockedRequest);
    const requestCookies = requestCookiesString
        ? parse_1(requestCookiesString)
        : {};
    // Merge both direct request cookies and the cookies inherited
    // from other same-origin requests in the cookie store.
    mockedRequest.cookies = Object.assign(Object.assign({}, mockedRequest.cookies), requestCookies);
    return mockedRequest;
}

function createFallbackRequestListener(context, options) {
    const interceptor = esm_lib.createInterceptor({
        modules: [interceptFetch_1, interceptXMLHttpRequest_1],
        resolver(request) {
            return __awaiter(this, void 0, void 0, function* () {
                const mockedRequest = parseIsomorphicRequest(request);
                return handleRequest(mockedRequest, context.requestHandlers, options, context.emitter, {
                    transformResponse(response) {
                        return {
                            status: response.status,
                            statusText: response.statusText,
                            headers: response.headers.all(),
                            body: response.body,
                        };
                    },
                    onMockedResponseSent(response, { handler, publicRequest, parsedRequest }) {
                        if (!options.quiet) {
                            handler.log(publicRequest, response, handler, parsedRequest);
                        }
                    },
                });
            });
        },
    });
    interceptor.apply();
    return interceptor;
}

function createFallbackStart(context) {
    return function start(options) {
        return __awaiter(this, void 0, void 0, function* () {
            context.fallbackInterceptor = createFallbackRequestListener(context, options);
            printStartMessage({
                message: 'Mocking enabled (fallback mode).',
                quiet: options.quiet,
            });
            return undefined;
        });
    };
}

function createFallbackStop(context) {
    return function stop() {
        var _a, _b;
        (_a = context.fallbackInterceptor) === null || _a === void 0 ? void 0 : _a.restore();
        printStopMessage({ quiet: (_b = context.startOptions) === null || _b === void 0 ? void 0 : _b.quiet });
    };
}

/**
 * Pipes all emitted events from one emitter to another.
 */
function pipeEvents(source, destination) {
    const rawEmit = source.emit;
    // @ts-ignore
    if (rawEmit._isPiped) {
        return;
    }
    source.emit = function (event, ...data) {
        destination.emit(event, ...data);
        return rawEmit.call(this, event, ...data);
    };
    // @ts-ignore
    source.emit._isPiped = true;
}

// Declare the list of event handlers on the module's scope
// so it persists between Fash refreshes of the application's code.
let listeners = [];
/**
 * Creates a new mock Service Worker registration
 * with the given request handlers.
 * @param {RequestHandler[]} requestHandlers List of request handlers
 * @see {@link https://mswjs.io/docs/api/setup-worker `setupWorker`}
 */
function setupWorker(...requestHandlers) {
    requestHandlers.forEach((handler) => {
        if (Array.isArray(handler))
            throw new Error(devUtils.formatMessage('Failed to call "setupWorker" given an Array of request handlers (setupWorker([a, b])), expected to receive each handler individually: setupWorker(a, b).'));
    });
    // Error when attempting to run this function in a Node.js environment.
    if (lib.exports.isNodeProcess()) {
        throw new Error(devUtils.formatMessage('Failed to execute `setupWorker` in a non-browser environment. Consider using `setupServer` for Node.js environment instead.'));
    }
    const emitter = new lib$3.StrictEventEmitter();
    const publicEmitter = new lib$3.StrictEventEmitter();
    pipeEvents(emitter, publicEmitter);
    const context = {
        startOptions: undefined,
        worker: null,
        registration: null,
        requestHandlers: [...requestHandlers],
        emitter,
        workerChannel: {
            on(eventType, callback) {
                context.events.addListener(navigator.serviceWorker, 'message', (event) => {
                    // Avoid messages broadcasted from unrelated workers.
                    if (event.source !== context.worker) {
                        return;
                    }
                    const message = jsonParse(event.data);
                    if (!message) {
                        return;
                    }
                    if (message.type === eventType) {
                        callback(event, message);
                    }
                });
            },
            send(type) {
                var _a;
                (_a = context.worker) === null || _a === void 0 ? void 0 : _a.postMessage(type);
            },
        },
        events: {
            addListener(target, eventType, callback) {
                target.addEventListener(eventType, callback);
                listeners.push({ eventType, target, callback });
                return () => {
                    target.removeEventListener(eventType, callback);
                };
            },
            removeAllListeners() {
                for (const { target, eventType, callback } of listeners) {
                    target.removeEventListener(eventType, callback);
                }
                listeners = [];
            },
            once(eventType) {
                const bindings = [];
                return new Promise((resolve, reject) => {
                    const handleIncomingMessage = (event) => {
                        try {
                            const message = JSON.parse(event.data);
                            if (message.type === eventType) {
                                resolve(message);
                            }
                        }
                        catch (error) {
                            reject(error);
                        }
                    };
                    bindings.push(context.events.addListener(navigator.serviceWorker, 'message', handleIncomingMessage), context.events.addListener(navigator.serviceWorker, 'messageerror', reject));
                }).finally(() => {
                    bindings.forEach((unbind) => unbind());
                });
            },
        },
        useFallbackMode: !('serviceWorker' in navigator) || location.protocol === 'file:',
    };
    const startHandler = context.useFallbackMode
        ? createFallbackStart(context)
        : createStartHandler(context);
    const stopHandler = context.useFallbackMode
        ? createFallbackStop(context)
        : createStop(context);
    return {
        start: prepareStartHandler(startHandler, context),
        stop() {
            context.events.removeAllListeners();
            context.emitter.removeAllListeners();
            publicEmitter.removeAllListeners();
            stopHandler();
        },
        use(...handlers) {
            use(context.requestHandlers, ...handlers);
        },
        restoreHandlers() {
            restoreHandlers(context.requestHandlers);
        },
        resetHandlers(...nextHandlers) {
            context.requestHandlers = resetHandlers(requestHandlers, ...nextHandlers);
        },
        printHandlers() {
            context.requestHandlers.forEach((handler) => {
                const { header, callFrame } = handler.info;
                const pragma = handler.info.hasOwnProperty('operationType')
                    ? '[graphql]'
                    : '[rest]';
                console.groupCollapsed(`${pragma} ${header}`);
                if (callFrame) {
                    console.log(`Declaration: ${callFrame}`);
                }
                console.log('Handler:', handler);
                if (handler instanceof RestHandler) {
                    console.log('Match:', `https://mswjs.io/repl?path=${handler.info.path}`);
                }
                console.groupEnd();
            });
        },
        events: {
            on(...args) {
                return publicEmitter.on(...args);
            },
            removeListener(...args) {
                return publicEmitter.removeListener(...args);
            },
            removeAllListeners(...args) {
                return publicEmitter.removeAllListeners(...args);
            },
        },
    };
}



// EXTERNAL MODULE: ./src/consts/paths/api/auth/token.ts
var token = __webpack_require__(93194);
;// CONCATENATED MODULE: ./src/mocks/resolvePath.ts
function resolvePath(subPath) {
    return "".concat("https://itemlibrary-api.eortc.org/api").concat(subPath);
};

;// CONCATENATED MODULE: ./src/mocks/login/happyPath.ts



/* harmony default export */ function happyPath() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 0 : _delay;
    return [
        rest.post(resolvePath(token/* default */.Z), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({
                access_token: 'mocked_access_token'
            }));
        }), 
    ];
};

// EXTERNAL MODULE: ./src/consts/paths/api/auth/forgotPassword.ts
var forgotPassword = __webpack_require__(58065);
;// CONCATENATED MODULE: ./src/mocks/forgotPassword/happyPath.ts



/* harmony default export */ function forgotPassword_happyPath() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 0 : _delay;
    return [
        rest.post(resolvePath(forgotPassword/* default */.Z), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({
                respose: 'All good'
            }));
        }), 
    ];
};

// EXTERNAL MODULE: ./src/consts/paths/api/auth/requestAccess.ts
var requestAccess = __webpack_require__(77480);
;// CONCATENATED MODULE: ./src/mocks/requestAccess/happyPath.ts



/* harmony default export */ function requestAccess_happyPath() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 0 : _delay;
    return [
        rest.post(resolvePath(requestAccess/* default */.Z), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({
                id: 72,
                roles: [
                    'viewTranslations',
                    'viewContent',
                    'manageOwnCustom'
                ]
            }));
        }), 
    ];
};

// EXTERNAL MODULE: ./src/consts/paths/api/users/current-user.ts
var current_user = __webpack_require__(88549);
;// CONCATENATED MODULE: ./src/mocks/users/current-user/happyPath.ts



/* harmony default export */ function current_user_happyPath() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 0 : _delay;
    return [
        rest.get(resolvePath(current_user/* default */.Z), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({
                id: 1,
                email: 'me@emakina.com',
                userName: 'me',
                profile: 'industrial',
                name: 'me',
                status: 'string',
                country: 'US',
                organisation: 'EMAKINA',
                motivation: 'this app rocks',
                roles: [
                    'manageUsers',
                    'manageOwnCustom',
                    'manageContent',
                    'manageQuestionnaireRequests'
                ],
                questionnaires: [
                    0
                ]
            }));
        }), 
    ];
};

// EXTERNAL MODULE: ./src/consts/paths/api/auth/users/users.ts
var users = __webpack_require__(89944);
;// CONCATENATED MODULE: ./src/mocks/users/getUsers/happyPath.ts



/* harmony default export */ function getUsers_happyPath() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 0 : _delay;
    return [
        rest.get(resolvePath(users/* default */.Z), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json([
                {
                    id: 0,
                    email: 'Test@gladiator.com',
                    userName: 'test',
                    profile: 'Test emperor',
                    name: 'Test aurelius',
                    status: 'suspended',
                    country: 'IT',
                    organisation: 'Government',
                    motivation: 'You have power over your mind - not outside events. Realize this, and you will find strength.'
                },
                {
                    id: 1,
                    email: 'maximus@gladiator.com',
                    userName: 'Maximus',
                    profile: 'administrator',
                    name: 'Maximus Decimus Meridius',
                    status: 'approved',
                    country: 'ES',
                    organisation: 'Army',
                    motivation: ' revenge against Commodus'
                },
                {
                    id: 2,
                    email: 'Marcus@gladiator.com',
                    userName: 'Marc',
                    profile: 'True emperor',
                    name: 'marcus aurelius',
                    status: 'pending',
                    country: 'IT',
                    organisation: 'Government',
                    motivation: 'You have power over your mind - not outside events. Realize this, and you will find strength.'
                },
                {
                    id: 3,
                    email: 'Commodus@gladiator.com',
                    userName: 'Commodus',
                    profile: 'administrator',
                    name: 'Commodus',
                    status: 'suspended',
                    country: 'IT',
                    organisation: 'Throne',
                    motivation: 'Not good..'
                },
                {
                    id: 4,
                    email: 'Jake@gladiator.com',
                    userName: 'Jake',
                    profile: 'Jake',
                    name: 'Jake',
                    status: 'pending',
                    country: 'IT',
                    organisation: 'Frontend',
                    motivation: 'You have power over your mind - not outside events. Realize this, and you will find strength.'
                }, 
            ]));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/users/addUser/happyPath.ts



/* harmony default export */ function addUser_happyPath() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 0 : _delay;
    return [
        rest.post(resolvePath(users/* default */.Z), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({
                id: 78,
                roles: [
                    'viewTranslations',
                    'viewContent',
                    'manageOwnCustom'
                ]
            }));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/users/editUser/happyPath.ts



/* harmony default export */ function editUser_happyPath() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 0 : _delay;
    return [
        rest.put(resolvePath("".concat(users/* default */.Z, "/*")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({
                roles: [
                    'viewTranslations',
                    'viewContent',
                    'manageOwnCustom'
                ],
                questionnaires: [],
                id: 80,
                email: 'z.obradovic@emakina.rs',
                userName: 'z.obradovic@emakina.rs',
                profile: 'academic',
                name: 'Zoc',
                status: 'pending',
                country: 'AO',
                organisation: 'Emk',
                motivation: 'Testing e'
            }));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/users/deleteUser/index.ts



/* harmony default export */ function deleteUser() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 0 : _delay;
    return [
        rest["delete"](resolvePath("".concat(users/* default */.Z, "/*")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({}));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/users/editAccount/index.ts



/* harmony default export */ function editAccount() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 0 : _delay;
    return [
        rest.put(resolvePath("".concat(current_user/* default */.Z, "/*")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({
                roles: [
                    'viewTranslations',
                    'viewContent',
                    'manageContent',
                    'manageOwnCustom',
                    'manageUsers',
                    'manageQuestionnaireRequests',
                    'downloadQuestionnaire', 
                ],
                questionnaires: [],
                id: 73,
                email: 'test@test.com',
                userName: 'test@stest.com',
                profile: 'administrator',
                name: 'Z test (admin).',
                status: 'approved',
                country: 'RS',
                organisation: 'Emakina',
                motivation: 'I want to kick-off backbone.js and refactor the SPA in React.'
            }));
        }), 
    ];
};

// EXTERNAL MODULE: ./src/consts/paths/api/auth/updatePassword.ts
var updatePassword = __webpack_require__(68337);
;// CONCATENATED MODULE: ./src/mocks/users/changePassword/index.ts



/* harmony default export */ function changePassword() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 0 : _delay;
    return [
        rest.post(resolvePath(updatePassword/* default */.Z), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({}));
        }), 
    ];
};

// EXTERNAL MODULE: ./src/consts/paths/api/questionnaires/getSummaries/index.ts
var getSummaries = __webpack_require__(96616);
;// CONCATENATED MODULE: ./src/mocks/questionnaires/getSummaries/questionnaires.json
var questionnaires_namespaceObject = JSON.parse('[{"rank":null,"id":23,"name":"Chronic Lymphocytic Leukaemia","code":"CLL16","type":"previous","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-CLL16 Chronic Lymphocytic Leukaemia module</h3><p>The QLQ-CLL16 was a module used in conjunction with the QLQ-C30. It was replaced with the QLQ-CLL17 questionnaire.</p><p><u><br /></u></p><p><u>Scale structure</u><br /></p><ul><li>Disease and treatment effects 31-38</li><li>Fatigue 39, 40</li><li>Infection 35-46</li></ul><p>    Single items</p><ul><li>Social problems 41</li><li>Future health 42</li></ul>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":16,"languages":[{"code":"sq","name":"Albanian"},{"code":"ar_EG","name":"Arabic (Egypt)"},{"code":"bs","name":"Bosnian"},{"code":"bg","name":"Bulgarian"},{"code":"hr","name":"Croatian"},{"code":"cs","name":"Czech"},{"code":"lang454","name":"Malay (Singapore)"},{"code":"lang457","name":"Arabic (Israel)"},{"code":"uk","name":"Ukrainian"},{"code":"ur_PK","name":"Urdu (Pakistan)"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"},{"code":"es_VE","name":"Spanish (Venezuela)"},{"code":"sv","name":"Swedish"},{"code":"ta","name":"Tamil"},{"code":"te","name":"Telugu"},{"code":"th","name":"Thai"},{"code":"tr","name":"Turkish"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"es_PE","name":"Spanish (Peru)"},{"code":"es_PR","name":"Spanish (Puerto Rico)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"es_US","name":"Spanish (United States)"},{"code":"es_UY","name":"Spanish (Uruguay)"},{"code":"ru","name":"Russian"},{"code":"sr","name":"Serbian"},{"code":"sk","name":"Slovak"},{"code":"sl","name":"Slovenian"},{"code":"es_AR","name":"Spanish (Argentina)"},{"code":"es_CO","name":"Spanish (Colombia)"},{"code":"ml","name":"Malayalam"},{"code":"mr","name":"Marathi"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"ro","name":"Romanian"},{"code":"it","name":"Italian"},{"code":"kn","name":"Kannada"},{"code":"ko","name":"Korean"},{"code":"lv","name":"Latvian"},{"code":"lt","name":"Lithuanian"},{"code":"mk","name":"Macedonian"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"gu","name":"Gujarati"},{"code":"he","name":"Hebrew"},{"code":"hi","name":"Hindi"},{"code":"hu","name":"Hungarian"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"et","name":"Estonian"},{"code":"fi","name":"Finnish"},{"code":"fr_CA","name":"French (Canada)"}],"createDate":"2016-03-01T15:32:37.137","updateDate":"2016-05-24T14:09:31.437"},{"rank":null,"id":46,"name":"Palliative care","code":"C-PAL","type":"core","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-C15-PAL Core questionnaire for palliative care</h3><p>The abbreviated 15-item version of the EORTC QLQ-C30 (version 3.0) developed for palliative care.</p><p><br /></p><h4><u>Development</u></h4><p>Groenvold M, Petersen MA, Aaronson NK, et al. for the EORTC Quality of Life Group. The development of the EORTC QLQ-C15-PAL: A shortened questionnaire for cancer patients in palliative care. Eur J Cancer 42 (1): 55-64, 2006.</p><p><br /></p><p></p><ul></ul><p></p><h4><u>Scale structure</u></h4><p></p><p></p><ul></ul><p></p><ul><li>Physical functioning 1-3</li><li>Emotional functioning 13, 14<br /></li><li>Dyspnea 4</li><li>Pain 5, 12</li><li>Insomnia 6</li><li>Fatigue 7, 11</li><li>Appetite loss 8</li><li>Nausea 9</li><li>Constipation 10</li><li>Quality of life 15</li></ul>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":15,"languages":[{"code":"af","name":"Afrikaans"},{"code":"ar","name":"Arabic"},{"code":"bs","name":"Bosnian"},{"code":"bg","name":"Bulgarian"},{"code":"hr","name":"Croatian"},{"code":"cs","name":"Czech"},{"code":"lang436","name":"Chinese Cantonese (Hong Kong)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"},{"code":"sk","name":"Slovak"},{"code":"sl","name":"Slovenian"},{"code":"es_AR","name":"Spanish (Argentina)"},{"code":"es_CL","name":"Spanish (Chile)"},{"code":"es_CO","name":"Spanish (Colombia)"},{"code":"es_CR","name":"Spanish (Costa Rica)"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"ro","name":"Romanian"},{"code":"ru","name":"Russian"},{"code":"sr","name":"Serbian"},{"code":"el","name":"Greek"},{"code":"he","name":"Hebrew"},{"code":"hu","name":"Hungarian"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"ko","name":"Korean"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"fi","name":"Finnish"},{"code":"fr_CA","name":"French (Canada)"},{"code":"de","name":"German"}],"createDate":"2016-03-04T11:54:28.283","updateDate":"2016-05-04T09:25:35.113"},{"rank":null,"id":29,"name":"Oesophagael","code":"OES","type":"module","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-OES18 Oesophageal cancer module</h3><p>The QLQ-OES18 Oesophageal cancer module is meant for use among patients with oesophageal cancer undergoing any single or combination of treatments including: oesophagectomy, chemoradiation, endoscopic palliation or palliative chemotherapy and/or radiotherapy. This module is to be used with the EORTC QLQ-C30 core questionnaire.</p><p>The OES18 module is fully validated. </p><p><u><br /></u></p><p><u>Development</u><br /></p><p>Blazeby JM, Conroy T, Hammerlid E, et al. Clinical and Psychometric Validation of an EORTC Questionnaire Module, the EORTC QLQ-OES18, to Assess Quality of Life in Patients with Oesophageal Cancer. Eur J Cancer 39:1384-1394, 2003. </p><p>Blazeby JM, Alderson D, Winstone K, Steyn R, Hammerlid E, Arraras J, Farndon JR. Development of an EORTC questionnaire module to be used in quality of life assessment for patients with oesophageal cancer. The EORTC Quality of Life Study Group. Eur J Cancer. 1996 Oct;32A(11):1912-7. </p><p>Lagergren P, Fayers P, Conroy T, Stein HJ, Sezer O, Hardwick R, Hammerlid E, Bottomley A, Van Cutsem E, Blazeby JM; European Organisation for Research Treatment of Cancer Gastrointestinal and Quality of Life Groups. Clinical and psychometric validation of a questionnaire module, the EORTC QLQ-OG25, to assess health-related quality of life in patients with cancer of the oesophagus, the oesophago-gastric junction and the stomach. Eur J Cancer. 2007 Sep;43(14):2066-73. Epub 2007 Aug 15</p><p> </p><p><u>Scale structure</u></p><p>Symptom scales</p><ul><li>Eating 36-39</li><li>Reflux 44, 45</li><li>Pain 46-48</li><li>Trouble swallowing saliva 34</li><li>Choked when swallowing 35</li><li>Dry mouth 40</li><li>Trouble with taste 41</li><li>Trouble with coughing 42</li><li>Trouble talking 43</li></ul><p></p><p>Functional scales</p><ul><li>Dysphagia 31-33</li></ul><p><u><br /></u></p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":19,"languages":[{"code":"af","name":"Afrikaans"},{"code":"cs","name":"Czech"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"lang457","name":"Arabic (Israel)"},{"code":"lang439","name":"Chinese Mandarin (Singapore)"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang444","name":"Xhosa"},{"code":"lang449","name":"Sotho"},{"code":"lang452","name":"Norwegian"},{"code":"es_US","name":"Spanish (United States)"},{"code":"sv","name":"Swedish"},{"code":"tr","name":"Turkish"},{"code":"uk","name":"Ukrainian"},{"code":"lang436","name":"Chinese Cantonese (Hong Kong)"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"si","name":"Sinhala"},{"code":"es_AR","name":"Spanish (Argentina)"},{"code":"es_CO","name":"Spanish (Colombia)"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"es_PE","name":"Spanish (Peru)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"ml","name":"Malayalam"},{"code":"fa","name":"Persian"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"ru","name":"Russian"},{"code":"hi","name":"Hindi"},{"code":"hu","name":"Hungarian"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"ko","name":"Korean"},{"code":"lv","name":"Latvian"},{"code":"en","name":"English"},{"code":"et","name":"Estonian"},{"code":"fi","name":"Finnish"},{"code":"fr_CA","name":"French (Canada)"},{"code":"de","name":"German"}],"createDate":"2016-03-02T13:41:34.337","updateDate":"2016-09-06T13:57:50.627"},{"rank":null,"id":1000273,"name":"Test again","code":null,"type":"cat","state":"published","phase":null,"gender":"female","chemical":"Test kwa again","description":"test","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":63,"email":"kwa@emakina.com","name":"Kéren"},"questionsStartPosition":3,"numQuestions":1,"languages":[{"code":"nl_BE","name":"Dutch (Belgium)"},{"code":"en","name":"English"},{"code":"fr_BE","name":"French (Belgium)"}],"createDate":"2019-04-19T10:16:23.85","updateDate":"2019-04-23T11:17:48.887"},{"rank":null,"id":1000141,"name":"test chemical","code":"","type":"module","state":"draft","phase":null,"gender":"nonSpecific","chemical":"lolipop","description":"","additionalInfo":"","contact":"","isCustom":true,"author":{"id":3,"email":"dagmara.kulis@eortc.be","name":"Dagmara Kulis"},"questionsStartPosition":null,"numQuestions":0,"languages":[{"code":"en","name":"English"}],"createDate":"2017-03-29T13:43:24.88","updateDate":"2017-03-29T16:37:07.463"},{"rank":null,"id":1000233,"name":"copy of Prostate","code":null,"type":"module","state":"draft","phase":null,"gender":"male","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":27,"email":"csi@emakina.com","name":"Cédric Simon"},"questionsStartPosition":null,"numQuestions":25,"languages":[{"code":"en","name":"English"}],"createDate":"2017-04-28T16:29:39.497","updateDate":"2017-04-28T16:29:39.497"},{"rank":null,"id":1000267,"name":"Test Julien 2809","code":null,"type":"module","state":"published","phase":null,"gender":"nonSpecific","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":20,"email":"big.brother@world.com","name":"Big Brother"},"questionsStartPosition":null,"numQuestions":2,"languages":[{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"fr_BE","name":"French (Belgium)"}],"createDate":"2018-09-28T15:26:40.39","updateDate":"2018-09-28T15:28:25.86"},{"rank":null,"id":9,"name":"Head & Neck","code":"H&N35","type":"previous","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-H&amp;N35 Head and Neck cancer module</h3><p>The QLQ-H&amp;N35 was a fully validated module used in conjunction with the QLQ-C30. It has been replaced with the QLQ-H&amp;N43.</p><p><br /></p><h4><u>Development</u></h4><p>Bjordal K, De Graeff A, Fayers PM, et al. on behalf of the EORTC Quality of Life Group. A 12 country field study of the EORTC QLQ-C30 (version 3.0) and the head and neck cancer specific module (EORTC QLQ-H&amp;N35) in head &amp; neck patients. Eur. J. Cancer 36: 1796-1807, 2000.<br /></p><p>Bjordal K, Hammerlid E, Ahlner-Elmqvist M, et al. for the EORTC Quality of Life Group. Quality of life in head and neck cancer patients: Validation of the European organization for research and treatment of cancer quality of life questionnaire-H&amp;N35. J. Clin. Oncol. 17: 1008-1019, 1999.<br /></p><p>Bjordal K, Kaasa S, Ahlner M, et al. Development of a head and neck cancer-specific module for use with the EORTC core quality of life questionnaire (EORTC QLQ-C30). Quality of Life Research 2: 72, 1993.</p><p>Singer S, Arraras JI, Chie WC, Fisher SE, Galalae R, Hammerlid E, Nicolatou-Galitis O, Schmalz C, Verdonck-de Leeuw I, Gamper E, Keszte J, Hofmeister D. Performance of the EORTC questionnaire for the assessment of quality of life in head and neck cancer patients EORTC QLQ-H&amp;N35: a methodological review. Qual Life Res. 2013 Oct;22(8):1927-41. doi: 10.1007/s11136-012-0325-1<br /></p><p><br /></p><h4><u>Scale structure</u></h4><p>Symptom scales and/or items:</p><ul><li>Pain 31-34</li><li>Swallowing 35-38</li><li>Senses problems 43, 44</li><li>Speech problems 46, 53, 54</li><li>Trouble with social eating 49-52</li><li>Trouble with social contact 48, 55-58</li><li>Less sexuality 59, 60</li><li>Teeth 39</li><li>Opening mouth 40</li><li>Dry mouth 41</li><li>Sticky saliva 42</li><li>Coughing 45</li><li>Felt ill 47</li><li>Pain killers 61</li><li>Nutritional supplements 62</li><li>Feeding tube 63</li><li>Weight loss 64</li><li>Weight gain 65</li></ul><p></p><p></p><h4><br /></h4><h4><u>Other publications on the questionnaire</u><br /></h4><p></p><p>Arrarás Urdaniz JI, Arias de la Vega F, Manterola Burgaleta\\nA, García RV, Martínez Aguillo M, Salgado Pascual E, Martínez López E. Quality\\nof life in patients with locally advanced head and neck cancer treated with\\nchemoradiotherapy. Comparison of two protocols using the EORTC questionnaires\\n(QLQ-C30, H&amp;N35). Clin Transl Oncol. 2005;7(9):398-403<br /></p><p>Sherman AC, Simonton S, Adams DC, Vural E, Owens B, Hanna E.\\nAssessing quality of life in patients with head and neck cancer:\\ncross-validation of the European Organization for Research and Treatment of\\nCancer (EORTC) Quality of Life Head and Neck module (QLQ-H&amp;N35). Arch\\nOtolaryngol Head Neck Surg. 2000 Apr; 126(4):459-67.<br /></p><p>Singer S, Wollbrück D, Wulke C, Dietz A, Klemm E, Oeken J,\\nMeister EF, Gudziol H, Bindewald J, Schwarz R. Validation of the EORTC QLQ-C30\\nand EORTC QLQ-H&amp;N35 in patients with laryngeal cancer after surgery. Head\\nNeck. 2008 Oct 28; [Epub ahead of print]</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":35,"languages":[{"code":"af","name":"Afrikaans"},{"code":"ar_EG","name":"Arabic (Egypt)"},{"code":"ar_TN","name":"Arabic (Tunisia)"},{"code":"bn","name":"Bengali"},{"code":"lang454","name":"Malay (Singapore)"},{"code":"lang455","name":"Pangasinan"},{"code":"lang457","name":"Arabic (Israel)"},{"code":"lang448","name":"Tagalog"},{"code":"lang449","name":"Sotho"},{"code":"lang450","name":"Russian (Georgia)"},{"code":"lang452","name":"Norwegian"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang443","name":"Iloko"},{"code":"lang444","name":"Xhosa"},{"code":"lang447","name":"Tamil (Malaysia)"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"lang438","name":"Chinese Mandarin (Malaysia)"},{"code":"lang439","name":"Chinese Mandarin (Singapore)"},{"code":"uk","name":"Ukrainian"},{"code":"vi","name":"Vietnamese"},{"code":"zu","name":"Zulu"},{"code":"lang435","name":"Cebuano"},{"code":"lang436","name":"Chinese Cantonese (Hong Kong)"},{"code":"ta_IN","name":"Tamil (India)"},{"code":"te","name":"Telugu"},{"code":"th","name":"Thai"},{"code":"tr","name":"Turkish"},{"code":"es_PE","name":"Spanish (Peru)"},{"code":"es_PR","name":"Spanish (Puerto Rico)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"es_US","name":"Spanish (United States)"},{"code":"sv","name":"Swedish"},{"code":"sl","name":"Slovenian"},{"code":"es_AR","name":"Spanish (Argentina)"},{"code":"es_CL","name":"Spanish (Chile)"},{"code":"es_CO","name":"Spanish (Colombia)"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"sr","name":"Serbian"},{"code":"sr_Cyrl","name":"Serbian (Cyrillic)"},{"code":"si","name":"Sinhala"},{"code":"sk","name":"Slovak"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"pa","name":"Punjabi"},{"code":"ro","name":"Romanian"},{"code":"ru","name":"Russian"},{"code":"fa","name":"Persian"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"lv","name":"Latvian"},{"code":"lt","name":"Lithuanian"},{"code":"ms_MY","name":"Malay (Malaysia)"},{"code":"ml","name":"Malayalam"},{"code":"ja","name":"Japanese"},{"code":"kn","name":"Kannada"},{"code":"ko","name":"Korean"},{"code":"hu","name":"Hungarian"},{"code":"it","name":"Italian"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"gu","name":"Gujarati"},{"code":"he","name":"Hebrew"},{"code":"fi","name":"Finnish"},{"code":"fr_CA","name":"French (Canada)"},{"code":"ka","name":"Georgian"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"et","name":"Estonian"},{"code":"bg","name":"Bulgarian"},{"code":"hr","name":"Croatian"},{"code":"cs","name":"Czech"},{"code":"da","name":"Danish"}],"createDate":"2016-02-19T13:08:51.587","updateDate":"2016-09-15T14:37:46"},{"rank":null,"id":15,"name":"Brain","code":"BN","type":"module","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-BN20 Brian module</h3><p>The QLQ-BN20 Brain module is meant for use among brain\\ncancer patients varying in disease stage and treatment modality (i.e. surgery,\\nchemotherapy, radiotherapy, etc.). This module is to be used with the EORTC QLQ-C30 core questionnaire.<br /></p><p>The BN20 module is fully\\nvalidated. </p><p><u><br /></u></p><p><u>Development</u><br /></p>\\n\\n<p>Taphoorn MJ, Claassens\\nL, Aaronson NK, Coens C, Mauer M, Osoba D, Stupp R, Mirimanoff RO, van den Bent\\nMJ, Bottomley A; on behalf of the EORTC Quality of Life Group, and Brain\\nCancer, NCIC and Radiotherapy Groups. An international validation study of the\\nEORTC brain cancer module (EORTC QLQ-BN20) for assessing health-related quality\\nof life and symptoms in brain cancer patients. European Journal of Cancer. 2010\\nApr;46(6):1033-40. doi: 10.1016/j.ejca.2010.01.012.</p>\\n\\n<p> </p>\\n\\n<p><u>Scale structure</u></p>\\n\\n<p>Symptom scales / items</p>\\n\\n\\n\\n\\n\\n\\n\\n\\n\\n\\n\\n\\n\\n\\n\\n\\n\\n\\n\\n\\n\\n<ul><li>Future uncertainty 31-33, 35</li><li>Visual disorder 36-38</li><li>Motor dysfunction 40, 45, 49</li><li>Communication deficit 41-43</li><li>Headaches 34</li><li>Seizures 39</li><li>Drowsiness 44</li><li>Itchy skin 47</li><li>Hair loss 46</li><li>Weakness of legs 48</li><li>Bladder control 50</li></ul>\\n\\n<p> </p>\\n\\n<p><u>How to obtain the questionnaire</u></p>\\n\\n<p>The EORTC has two\\npolicies for the use of the QLQ-C30 and associated modules.</p>\\n\\n<p><b>Commercial users</b>(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p>\\n\\n<p>What is classed as<b> ‘academic’\\nresearch</b>(2) – for educational institutions, hospitals, etc - No fee:\\nquestionnaires can be downloaded from the EORTC website</p>\\n\\n<p> </p>\\n\\n<p>(1) If an\\norganization, institution or company is being provided with or providing funds,\\nsponsorship or a grant for their research, and should any of these gain\\nfinancially or use the measures for commercial purposes, then a fee is\\nchargeable. </p>\\n\\n<p>(2) The only time a\\nfee is not chargeable is if the study is purely for academic use and there is\\nno financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":44,"languages":[{"code":"af","name":"Afrikaans"},{"code":"ar","name":"Arabic"},{"code":"lang454","name":"Malay (Singapore)"},{"code":"lang456","name":"Russian (Israel)"},{"code":"lang449","name":"Sotho"},{"code":"lang452","name":"Norwegian"},{"code":"lang441","name":"French (Europe)"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"lang439","name":"Chinese Mandarin (Singapore)"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang436","name":"Chinese Cantonese (Hong Kong)"},{"code":"sv","name":"Swedish"},{"code":"tr","name":"Turkish"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"ru_RU","name":"Russian (Russia)"},{"code":"sk","name":"Slovak"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"ro","name":"Romanian"},{"code":"fa","name":"Persian"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"lt","name":"Lithuanian"},{"code":"mk","name":"Macedonian"},{"code":"ja","name":"Japanese"},{"code":"kk","name":"Kazakh"},{"code":"ko","name":"Korean"},{"code":"he","name":"Hebrew"},{"code":"hu","name":"Hungarian"},{"code":"id","name":"Indonesian"},{"code":"it","name":"Italian"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"et","name":"Estonian"},{"code":"fi","name":"Finnish"},{"code":"fr_CA","name":"French (Canada)"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"bg","name":"Bulgarian"},{"code":"cs","name":"Czech"}],"createDate":"2016-03-01T08:45:58.617","updateDate":"2016-06-30T15:25:57.397"},{"rank":null,"id":1000124,"name":"Test questionnaire v3.3","code":"IL3.3","type":"module","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":"<p>Description of Test questionnaire v3.3</p><p><strong></strong><br></p>","additionalInfo":"<p>Additional Info of Test questionnaire v3.3<br /></p>","contact":"alexis.debontridder@gmail.com","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":2,"languages":[{"code":"en","name":"English"},{"code":"fr_BE","name":"French (Belgium)"}],"createDate":"2017-03-28T10:26:48.777","updateDate":"2017-03-28T10:26:48.777"},{"rank":null,"id":1000110,"name":"richard create","code":"","type":"module","state":"draft","phase":null,"gender":"nonSpecific","chemical":"","description":"","additionalInfo":"","contact":"","isCustom":true,"author":{"id":36,"email":"clb@emakina.com","name":"Clémence Braun"},"questionsStartPosition":null,"numQuestions":0,"languages":[{"code":"en","name":"English"}],"createDate":"2017-03-23T09:19:19.717","updateDate":"2017-03-29T16:36:43.563"},{"rank":null,"id":1000090,"name":"Appetite","code":"AP","type":"cat","state":null,"phase":4,"gender":"nonSpecific","chemical":null,"description":"","additionalInfo":"<p><br /></p>","contact":"adb@emakina.com","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":2,"languages":[{"code":"af","name":"Afrikaans"},{"code":"en","name":"English"}],"createDate":"2017-03-15T15:39:10.227","updateDate":"2017-03-15T15:50:32.967"},{"rank":null,"id":1000144,"name":"TEST CHRISTOPHE","code":"BRUI","type":"standalone","state":null,"phase":4,"gender":"female","chemical":null,"description":"etst","additionalInfo":"<p>testttt</p>","contact":"dagmara@eortc.be","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":1,"languages":[{"code":"en","name":"English"}],"createDate":"2017-03-30T15:28:02.577","updateDate":"2017-03-30T15:28:02.577"},{"rank":null,"id":32,"name":"Colorectal","code":"CR29","type":"module","state":null,"phase":5,"gender":"male","chemical":null,"description":"<p>The QLQ-CR29&nbsp;Colorectal Cancer module is meant for use among colorectal cancer patients&nbsp;varying in disease stage and treatment modality (i.e. radiotherapy or chemoradiation,&nbsp;ultra-low anterior resection, minimal access surgery and new chemotherapy&nbsp;regimens).&nbsp;This module is to be used with the EORTC QLQ-C30 core questionnaire.</p><p>The&nbsp;CR29&nbsp;module is fully validated.&nbsp;</p><div><br></div>","additionalInfo":"<p><u>Development</u><br /></p><p>Whistance RN, Conroy T, Chie W, et al. Clinical and Psychometric Validation of the EORTC QLQ-CR29 Questionnaire Module to Assess Health-Related Quality of Life in Patients with Colorectal Cancer. Eur J Cancer 45:3017-3026, 2009.</p><p> </p><p><u>Scale structure</u></p><p>Functional Scales</p><ul><li>Body image 45 - 47</li><li>Anxiety 43</li><li>Weight 44</li><li>Sexual interest 62</li></ul><p>Symptom scales</p><ul><li>Urinary frequency 31, 32</li><li>Blood and mucus in stool 38, 39</li><li>Stool frequency 52, 53, 59, 60</li><li>Urinary incontinence 33</li><li>Dysuria 34</li><li>Abdominal pain 35</li><li>Buttock pain 36</li><li>Bloating 37</li><li>Dry mouth 40</li><li>Hair loss 41</li><li>Taste 42</li><li>Flatulence 49, 56</li><li>Faecal incontinence 50, 57</li><li>Sore skin 51, 58</li><li>Embarrassment 54, 61</li><li>Stoma care problems 55</li><li>Impotence 63</li><li>Dyspareunia 64</li></ul><p><br /></p><p><u>How to obtain the questionnaire</u><br /></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":34,"languages":[{"code":"af","name":"Afrikaans"},{"code":"ar_SA","name":"Arabic (Saudi Arabia)"},{"code":"cs","name":"Czech"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"lang449","name":"Sotho"},{"code":"lang452","name":"Norwegian"},{"code":"lang454","name":"Malay (Singapore)"},{"code":"lang436","name":"Chinese Cantonese (Hong Kong)"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"lang439","name":"Chinese Mandarin (Singapore)"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang444","name":"Xhosa"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"es_US","name":"Spanish (United States)"},{"code":"sv","name":"Swedish"},{"code":"th","name":"Thai"},{"code":"tr","name":"Turkish"},{"code":"zu","name":"Zulu"},{"code":"ru","name":"Russian"},{"code":"sk","name":"Slovak"},{"code":"sl","name":"Slovenian"},{"code":"es_CO","name":"Spanish (Colombia)"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"ml","name":"Malayalam"},{"code":"fa","name":"Persian"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"ro","name":"Romanian"},{"code":"he","name":"Hebrew"},{"code":"hu","name":"Hungarian"},{"code":"is","name":"Icelandic"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"ko","name":"Korean"},{"code":"nl_BE","name":"Dutch (Belgium)"},{"code":"en","name":"English"},{"code":"fi","name":"Finnish"},{"code":"fr_CA","name":"French (Canada)"},{"code":"de","name":"German"}],"createDate":"2016-03-02T15:23:31.007","updateDate":"2017-03-31T13:14:45.5"},{"rank":null,"id":1000276,"name":"Test JTH","code":"JTH","type":"module","state":"draft","phase":5,"gender":"nonSpecific","chemical":null,"description":"","additionalInfo":"<p><br /></p>","contact":"jth@emakina.com","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":0,"languages":[{"code":"nl","name":"Dutch"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"en","name":"English"}],"createDate":"2019-09-05T14:05:01.137","updateDate":"2019-09-05T14:05:01.137"},{"rank":null,"id":1000230,"name":"copy of Cholangiocarcinoma & Gall Bladder","code":null,"type":"module","state":"waitingForApproval","phase":null,"gender":"nonSpecific","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":27,"email":"csi@emakina.com","name":"Cédric Simon"},"questionsStartPosition":null,"numQuestions":26,"languages":[{"code":"en","name":"English"}],"createDate":"2017-04-26T15:00:05.527","updateDate":"2017-05-05T18:21:38.857"},{"rank":null,"id":1000236,"name":"copy of Breast ","code":null,"type":"module","state":"draft","phase":null,"gender":"female","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":37,"email":"ykh@emakina.com","name":"Younes Kh\'Leeh"},"questionsStartPosition":null,"numQuestions":24,"languages":[{"code":"en","name":"English"}],"createDate":"2017-05-02T12:24:52.01","updateDate":"2017-05-02T12:24:52.01"},{"rank":null,"id":1000284,"name":"Demo","code":"VB","type":"standalone","state":"draft","phase":5,"gender":"nonSpecific","chemical":null,"description":"<h4>vvsdcsdvssd</h4><p>sdsdf</p><p><b>qdf</b></p><p>sdfsd</p>","additionalInfo":"<p>xcvxcvxcvxcvxcv</p>","contact":"adb@emakina.com","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":0,"languages":[{"code":"en","name":"English"}],"createDate":"2021-11-17T14:24:54.24","updateDate":"2021-11-17T14:24:54.24"},{"rank":null,"id":26,"name":"Chronic Myeloid Leukaemia","code":"CML","type":"module","state":null,"phase":3,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-<b>CML24 </b><b>Chronic Myeloid Leukaemia</b> module</h3><p>The CML24 module has completed phase III. </p><p>This module is to be used with the EORTC QLQ-C30 core questionnaire.<br /></p><p><br /></p><p><u>Scales</u></p><p>Multi-item scales<br /></p><ul><li>Symptom burden 31-44</li><li>Impact on worry/mood 33-48</li><li>Impact on daily life 47-51<br /></li><li>Satisfaction with care and information 52, 53</li></ul><p>Single-item scales</p><ul><li>Body image problems 49</li><li>Satisfaction with social life 54</li></ul><p><u><br /></u></p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":24,"languages":[{"code":"ar_IQ","name":"Arabic (Iraq)"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"fi","name":"Finnish"},{"code":"de","name":"German"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"el","name":"Greek"},{"code":"hu","name":"Hungarian"},{"code":"it","name":"Italian"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"es_ES","name":"Spanish (Spain)"}],"createDate":"2016-03-02T11:27:15.41","updateDate":"2016-05-17T11:47:24.137"},{"rank":null,"id":12,"name":"Stomach","code":"STO","type":"module","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-STO22 Gastric cancer module</h3><p>The QLQ-STO22 Gastric cancer module is meant for use among patients with gastric cancer varying in disease stage and treatment modality (i.e. surgery, chemotherapy, radiotherapy, etc.).This module is to be used with the EORTC QLQ-C30 core questionnaire.</p><p>The STO22 module is fully validated. </p><p><br /><u>Development</u><br /></p><p>Blazeby JM, Conroy T, Bottomley A, et al. Clinical and Psychometric Validation of a Questionnaire Module, the EORTC QLQ-STO22, to Assess Quality of Life in Patients with Gastric Cancer. Eur J Cancer 40:2260-2268, 2004.</p><p> </p><p><u>Scale structure</u></p><ul><li>Dysphagia 31-33</li><li>Pain 34-37</li><li>Reflux symptoms 38-40</li><li>Eating restrictions 41-43, 46</li><li>Anxiety 47, 48, 50</li></ul><p></p><p>Single items</p><ul><li>Having a dry mouth 44</li><li>Taste 45</li><li>Body image 49</li><li>Hair loss 52</li></ul><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":22,"languages":[{"code":"af","name":"Afrikaans"},{"code":"ar","name":"Arabic"},{"code":"bn","name":"Bengali"},{"code":"bg","name":"Bulgarian"},{"code":"hr","name":"Croatian"},{"code":"cs","name":"Czech"},{"code":"lang449","name":"Sotho"},{"code":"lang452","name":"Norwegian"},{"code":"lang454","name":"Malay (Singapore)"},{"code":"lang438","name":"Chinese Mandarin (Malaysia)"},{"code":"lang439","name":"Chinese Mandarin (Singapore)"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang444","name":"Xhosa"},{"code":"lang448","name":"Tagalog"},{"code":"uk","name":"Ukrainian"},{"code":"ur","name":"Urdu"},{"code":"zu","name":"Zulu"},{"code":"lang435","name":"Cebuano"},{"code":"lang436","name":"Chinese Cantonese (Hong Kong)"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"es_US","name":"Spanish (United States)"},{"code":"sv","name":"Swedish"},{"code":"ta","name":"Tamil"},{"code":"te","name":"Telugu"},{"code":"th","name":"Thai"},{"code":"tr","name":"Turkish"},{"code":"es_GT","name":"Spanish (Guatemala)"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"es_PA","name":"Spanish (Panama)"},{"code":"es_PE","name":"Spanish (Peru)"},{"code":"es_PR","name":"Spanish (Puerto Rico)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"ro","name":"Romanian"},{"code":"ru","name":"Russian"},{"code":"es_AR","name":"Spanish (Argentina)"},{"code":"es_CL","name":"Spanish (Chile)"},{"code":"es_CO","name":"Spanish (Colombia)"},{"code":"mk","name":"Macedonian"},{"code":"ms_MY","name":"Malay (Malaysia)"},{"code":"ml","name":"Malayalam"},{"code":"mr","name":"Marathi"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"kn","name":"Kannada"},{"code":"ko","name":"Korean"},{"code":"lv","name":"Latvian"},{"code":"lt","name":"Lithuanian"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"gu","name":"Gujarati"},{"code":"he","name":"Hebrew"},{"code":"hi","name":"Hindi"},{"code":"hu","name":"Hungarian"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"et","name":"Estonian"},{"code":"fi","name":"Finnish"},{"code":"fr_CA","name":"French (Canada)"}],"createDate":"2016-02-29T12:07:23.47","updateDate":"2016-04-13T15:16:13.373"},{"rank":null,"id":1000244,"name":"Test ","code":"BRTEST","type":"module","state":"draft","phase":5,"gender":"nonSpecific","chemical":null,"description":"<p>test clb</p>","additionalInfo":"<p>test clb</p>","contact":"tesst@gmail.com","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":3,"languages":[{"code":"en","name":"English"},{"code":"lang441","name":"French (Europe)"}],"createDate":"2017-05-02T15:29:50.693","updateDate":"2019-04-29T14:45:39.65"},{"rank":null,"id":35,"name":"Multiple Myeloma","code":"MY","type":"module","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-MY20 Multiple Myeloma</h3><p>The QLQ-MY20 Multiple Myeloma module is meant for use among multiple myeloma cancer patients varying\\nin disease stage and treatment modality (i.e. surgery, chemotherapy,\\nradiotherapy and hormonal treatment). This module is to be used with the EORTC QLQ C30 core questionnaire.<br /></p><p>The MY20 module is fully validated. </p><p><u><br /></u></p><p><u>Development</u><br /></p><p>Cocks K, Cohen D, Wisløff F, et al. An International Field Study of the Reliability and\\nValidity of a Disease-Specific Questionnaire Module (the QMQ-MY20) in Assessing\\nthe Quality of Life of Patients with Multiple Myeloma. <i>Eur J Cancer</i> 43:1670-1678, 2007.</p><p> </p><p><u>Scale structure</u></p><p>Functional scales / items</p><ul><li>Future perspective 48-50</li><li>Body image 47</li></ul><p>Symptom scales</p><ul><li>Disease symptoms 31-36</li><li>Side effects of treatment 37-46</li></ul><p><br /></p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules. </p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":20,"languages":[{"code":"af","name":"Afrikaans"},{"code":"ar_EG","name":"Arabic (Egypt)"},{"code":"ar_LB","name":"Arabic (Lebanon)"},{"code":"bn","name":"Bengali"},{"code":"bg","name":"Bulgarian"},{"code":"hr","name":"Croatian"},{"code":"lang452","name":"Norwegian"},{"code":"lang454","name":"Malay (Singapore)"},{"code":"lang457","name":"Arabic (Israel)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang444","name":"Xhosa"},{"code":"lang447","name":"Tamil (Malaysia)"},{"code":"lang449","name":"Sotho"},{"code":"lang450","name":"Russian (Georgia)"},{"code":"lang451","name":"Russian (Belarus)"},{"code":"zu","name":"Zulu"},{"code":"lang436","name":"Chinese Cantonese (Hong Kong)"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"lang438","name":"Chinese Mandarin (Malaysia)"},{"code":"lang439","name":"Chinese Mandarin (Singapore)"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"ta_IN","name":"Tamil (India)"},{"code":"te","name":"Telugu"},{"code":"th","name":"Thai"},{"code":"tr","name":"Turkish"},{"code":"uk","name":"Ukrainian"},{"code":"ur_IN","name":"Urdu (India)"},{"code":"es_CO","name":"Spanish (Colombia)"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"es_PR","name":"Spanish (Puerto Rico)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"es_US","name":"Spanish (United States)"},{"code":"sv","name":"Swedish"},{"code":"ro","name":"Romanian"},{"code":"ru","name":"Russian"},{"code":"sr","name":"Serbian"},{"code":"sk","name":"Slovak"},{"code":"es_AR","name":"Spanish (Argentina)"},{"code":"es_CL","name":"Spanish (Chile)"},{"code":"ms_MY","name":"Malay (Malaysia)"},{"code":"ml","name":"Malayalam"},{"code":"mr","name":"Marathi"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"hu","name":"Hungarian"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"kn","name":"Kannada"},{"code":"ko","name":"Korean"},{"code":"lt","name":"Lithuanian"},{"code":"ka","name":"Georgian"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"gu","name":"Gujarati"},{"code":"he","name":"Hebrew"},{"code":"hi","name":"Hindi"},{"code":"cs","name":"Czech"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"fi","name":"Finnish"},{"code":"fr_CA","name":"French (Canada)"}],"createDate":"2016-03-03T12:50:21.047","updateDate":"2016-04-13T14:37:31.087"},{"rank":null,"id":1000250,"name":"copy of Bone Metastases","code":null,"type":"module","state":"draft","phase":null,"gender":"nonSpecific","chemical":"8.N-Methyl-3,4-methylenedioxyamphetamine Hydrochloride","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":2,"email":"mca@emakina.com","name":"Mathieu Callewaert"},"questionsStartPosition":null,"numQuestions":23,"languages":[{"code":"en","name":"English"}],"createDate":"2017-05-03T16:47:57.1","updateDate":"2017-05-03T17:10:28.967"},{"rank":null,"id":43,"name":"Head & Neck","code":"H&N","type":"module","state":null,"phase":4,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-H&amp;N43 Head and neck cancer module</h3><p>The H&amp;N43 is an update of the QLQ-H&amp;N35 questionnaire.</p><p>The module is currently undergoing Phase IV.</p><p>It is to be used with the QLQ-C30.</p><p><br /></p><h4><u>Development</u></h4><p>Singer S., Arraras J., Chie W.C., Fisher S., Galalae R., Hammerlid E., Nicolatou-Galitis O., Schmalz C., Verdonck-de Leeuw I.M., Gamper E., Keszte J., &amp; Hofmeister D. (2013) Performance of the EORTC questionnaire for the assessment of quality of life in head and neck cancer patients EORTC QLQ-H&amp;N35. A methodological review. Quality of Life Research 22, 1927-1941.</p><p>Singer S., Arraras J., Baumann I., Boehm A., Chie W.C., Galalae R., Langendijk J.A., Guntinas-Lichius O., Hammerlid E., Pinto M., Nicolatou-Galitis O., Schmalz C., Sen M., Sherman A.C., Spiegel K., Verdonck-de Leeuw I.M., Yarom N., Zotti P., Hofmeister D., &amp; on behalf of the EORTC Quality of Life and the EORTC Head and Neck Cancer Groups (2013) Quality of life in head and neck cancer patients receiving multimodal or targeted therapy - Update of the EORTC QLQ-H&amp;N35, Phase I. Head and Neck 35, 1331-1338.</p><p>Singer S, Araújo C, Arraras JI, Baumann I, Boehm A, Brokstad Herlofson B, Castro Silva J, Chie WC, Fisher S, Guntinas-Lichius O, Hammerlid E, Elisa Irarrázaval M, Jensen Hjermstad M, Jensen K, Kiyota N, Licitra L, Nicolatou-Galitis O, Pinto M, Santos M, Schmalz C, Sherman AC, Tomaszewska IM, Verdonck de Leeuw I, Yarom N, Zotti P, Hofmeister D; on behalf of the EORTC Quality of Life and the EORTC Head and Neck Cancer Groups. (2014) Measuring quality of life in patients with head and neck cancer: Update of the EORTC QLQ-H&amp;N Module, Phase III. Head Neck. 2014 May 15. doi: 10.1002/hed.23762.</p><p><br /></p><h4><u>Scale structure</u></h4><p>Symptom scales and/or items:</p><ul><li>Fear of progression 69-70</li><li>Body image 48-50</li><li>Senses problems 44-45</li><li>Dry mouth and sticky saliva 42-43 <br /></li><li>Pain in the mouth 31-34</li><li>Sexuality 60-61</li><li>Problems with shoulder 62-63<br /></li><li>Skin problems 65-67</li><li>Social eating 51-54</li><li>Speech 47, 55-58</li><li>Swallowing 35-38</li><li>Problems with teeth 39-40, 73 </li></ul><p>Single item scales </p><ul><li>Coughing 46</li><li>Lymphoedema 64</li><li>Neurological problems 72</li><li>Trismus 41</li><li>Social contact 59</li><li>Weight loss 68</li><li>Problems with wound healing 71<br /></li></ul><p><br /></p><p></p><p></p><p><u>How to obtain the questionnaire</u><br /></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p></p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party. </p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":43,"languages":[{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"he","name":"Hebrew"},{"code":"lang452","name":"Norwegian"},{"code":"es_CL","name":"Spanish (Chile)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"sv","name":"Swedish"},{"code":"uk","name":"Ukrainian"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"fa","name":"Persian"},{"code":"pl","name":"Polish"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"sr","name":"Serbian"}],"createDate":"2016-03-03T15:54:43.573","updateDate":"2016-06-16T11:51:55.103"},{"rank":null,"id":1000264,"name":"ttrtrtrt","code":null,"type":"module","state":"draft","phase":null,"gender":"nonSpecific","chemical":"8.N-Methyl-3,4-methylenedioxyamphetamine Hydrochloride","description":"<h3><img style=\\"width: 540px;\\" src=\\"data:image/jpeg;base64,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\\" data-filename=\\"cables_za.jpg\\">jjhjhj</h3><p><br></p><p><br></p>","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":1,"email":"adb@emakina.com","name":"Alexis Debontridder"},"questionsStartPosition":null,"numQuestions":1,"languages":[{"code":"en","name":"English"}],"createDate":"2017-06-01T14:46:18.297","updateDate":"2017-06-01T14:46:18.297"},{"rank":null,"id":49,"name":"Spiritual Wellbeing","code":"SWB","type":"standalone","state":null,"phase":4,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<p>The QLQ-SWB32 Spiritual Wellbeing questionnaire has been developed to assess spiritual wellbeing in people with advanced cancer receiving palliative (but not necessarily terminal) care. </p><p>The SWB32 questionnaire is a stand-alone measure.</p><p>The SWB32 module is currently under phase IV.</p><p><u><br /></u></p><p><u>How to obtain the questionnaire</u><br /></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.  </p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":32,"languages":[{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"de","name":"German"},{"code":"is","name":"Icelandic"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"fa","name":"Persian"},{"code":"es_CL","name":"Spanish (Chile)"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"}],"createDate":"2016-03-04T15:46:43.767","updateDate":"2016-04-13T14:18:52.2"},{"rank":null,"id":1000279,"name":"Cancer test","code":null,"type":"itemlist","state":"draft","phase":null,"gender":"nonSpecific","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":69,"email":"yno@emakina.com","name":"Yasmina"},"questionsStartPosition":1,"numQuestions":1,"languages":[{"code":"en","name":"English"}],"createDate":"2021-05-04T11:17:35.143","updateDate":"2021-05-04T11:17:35.143"},{"rank":null,"id":1000285,"name":"copy of Bladder 2021","code":null,"type":"itemlist","state":"published","phase":null,"gender":"nonSpecific","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":1,"email":"adb@emakina.com","name":"Alexis Debontridder"},"questionsStartPosition":1,"numQuestions":35,"languages":[{"code":"en","name":"English"}],"createDate":"2021-11-17T14:44:24.477","updateDate":"2021-11-17T14:45:48.947"},{"rank":null,"id":21,"name":"Opthalmic","code":"OPT","type":"module","state":null,"phase":3,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-OPT30 Ophthalmic cancer module</h3><p>The QLQ-OPT30 Ophthalmic cancer module is intended for patients with uveal melanoma treated with methods such as transpupillary thermotherapy, plaque radiotherapy, proton beam radiotherapy, local resection, and enucleation. </p><p>This module is to be used with the EORTC QLQ-C30 core questionnaire.</p><p>The OPT30 module is fully validated. </p><p><u><br /></u></p><p><u>Scale structure</u></p><ul><li>Ocular irritation 31-36</li><li>Vision impairment 37-40</li><li>Headaches 41</li><li>Worry about recurrent disease 42-45</li><li>Problems driving 46-47</li><li>Problems with appearance 48-49</li><li>Functional problems due to vision impairment 50-55</li><li>Problems with reading 56</li><li>Functional problems in the treated eye 57-60<br /></li></ul><p> </p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":30,"languages":[{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"fi","name":"Finnish"},{"code":"de","name":"German"},{"code":"pl","name":"Polish"},{"code":"sv","name":"Swedish"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"}],"createDate":"2016-03-01T14:37:57.14","updateDate":"2016-05-17T14:35:06.523"},{"rank":null,"id":27,"name":"Oesophago-Gastric","code":"OG","type":"module","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-OG25 Oesophago-gastric cancer module</h3><p>The QLQ-OG25 oesophago-gastric\\ncancer module is meant for use among patients with cancer of the oesophagus,\\nthe oesophago-gastric junction and the stomach varying in disease stage and\\ntreatment modality (i.e. surgery, chemotherapy, radiotherapy, etc.). </p><p>This module is to be used with the EORTC QLQ-C30 core questionnaire.<br /></p><p>The OG25 module is fully validated. </p><p><u><br /></u></p><p><u>Development</u><br /></p><p>Lagergren P, Fayers P, Conroy T, et al. Clinical and Psychometric Validation of a\\nQuestionnaire Module, the EORTC QLQ-OG25, to Assess Health-Related Quality of Life\\nin Patients with Cancer of the Oesophagus, the Oesophago-Gastric Junction and\\nthe Stomach. <i>Eur J Cancer</i>\\n43:2066-2073, 2007.</p><p> </p><p><u>Scale structure</u></p><p>Functional scales\\t\\t\\t\\t</p><ul><li>Body image\\t49</li></ul><p>Symptom scales\\t\\t\\t\\t<br /></p><ul><li>Dysphagia 31 – 33</li><li>Eating 34 – 37</li><li>Reflux 38, 39</li><li>Odynophagia 40, 41</li><li>Pain and discomfort 42, 43</li><li>Anxiety 44, 45</li><li>Eating with others 46</li><li>Dry mouth 47</li><li>Trouble with taste 48</li><li>Trouble swallowing saliva 50</li><li>Choked when swallowing 51</li><li>Trouble with coughing 52</li><li>Trouble talking\\t53</li><li>Weight loss 54</li><li>Hair loss 55</li></ul><div><br /></div><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":25,"languages":[{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"de","name":"German"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"sv","name":"Swedish"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"},{"code":"ko","name":"Korean"},{"code":"ml","name":"Malayalam"},{"code":"fa","name":"Persian"},{"code":"pl","name":"Polish"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"es_MX","name":"Spanish (Mexico)"}],"createDate":"2016-03-02T12:57:24.123","updateDate":"2016-05-24T13:08:02.623"},{"rank":null,"id":1000265,"name":"test add item ykh","code":null,"type":"module","state":"draft","phase":null,"gender":"nonSpecific","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":2,"email":"mca@emakina.com","name":"Mathieu Callewaert"},"questionsStartPosition":null,"numQuestions":2,"languages":[{"code":"en","name":"English"}],"createDate":"2017-06-20T14:11:03.997","updateDate":"2017-06-20T14:11:03.997"},{"rank":null,"id":1000271,"name":"Test Module","code":"TEST","type":"catshort","state":"draft","phase":5,"gender":"nonSpecific","chemical":null,"description":"<p>This is a test&nbsp;&nbsp;&nbsp;&nbsp;</p>","additionalInfo":"<p>Test</p>","contact":"kwa@emakina.com","isCustom":false,"author":null,"questionsStartPosition":3,"numQuestions":3,"languages":[{"code":"en","name":"English"}],"createDate":"2019-04-19T09:50:45.21","updateDate":"2019-04-19T10:00:44.433"},{"rank":null,"id":38,"name":"Endometrial","code":"EN","type":"module","state":null,"phase":5,"gender":"female","chemical":null,"description":"<p><br></p><h3>QLQ-EN24 Endometrial cancer module</h3><p><br></p><p>The&nbsp;QLQ-EN24&nbsp;Endometrial Cancer&nbsp;module&nbsp;is designed for patients with all stages of endometrial cancer treated with pelvic surgery, chemotherapy, radiotherapy or concomitant radio/chemotherapy. </p><p><br></p><p>This module is to&nbsp;be used with the EORTC QLQ-C30 core questionnaire.<br></p><p><br></p><p>The&nbsp;EN24&nbsp;module is fully validated.&nbsp;</p><p><br></p>","additionalInfo":"<h3><br /></h3><p><br /><u>Development</u><br /></p><p>Greimel E,\\nNordin A, Lanceley A, et al. Psychometric validation of the European Organisation\\nfor Research and Treatment of Cancer Quality of Life Questionnaire-Endometrial\\nCancer Module (EORTC QLQ-EN24) Eur. J Cancer (2010),\\ndoi:10.1016/j.ejca.2010.08.014</p><p> </p><p><u>Scale structure</u></p><p>Functional scales</p><ul><li>Sexual interest 49</li><li>Sexual activity 50</li><li>Sexual enjoyment 54</li></ul><p></p><p>Symptom scales</p><ul><li>Lymphoedema 31-32</li><li>Urological symptoms 34-37</li><li>Gastrointestinal symptoms 38-42</li><li>Poor body image 47-48</li><li>Sexual/vaginal problems 51-53</li><li>Pain in back and pelvis 33</li><li>Tingling/numbness 43</li><li>Muscular pain 44</li><li>Hair loss 45</li><li>Taste change 46</li></ul><p><br /></p><p></p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party. </p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":24,"languages":[{"code":"hr","name":"Croatian"},{"code":"cs","name":"Czech"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"de","name":"German"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"},{"code":"it","name":"Italian"},{"code":"pl","name":"Polish"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"es_US","name":"Spanish (United States)"},{"code":"sv","name":"Swedish"}],"createDate":"2016-03-03T13:50:42.18","updateDate":"2017-03-28T13:42:07.617"},{"rank":null,"id":1000245,"name":"test","code":"BR1","type":"module","state":"draft","phase":5,"gender":"nonSpecific","chemical":null,"description":"<a href=\\"http://www.emakina.com\\" target=\\"_blank\\">TEST</a>","additionalInfo":"<p><br /></p>","contact":"test@gmail.com","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":0,"languages":[{"code":"en","name":"English"}],"createDate":"2017-05-02T15:31:02.317","updateDate":"2017-05-02T15:31:02.317"},{"rank":null,"id":44,"name":"Hepatocellular carcinoma","code":"HCC","type":"module","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-HCC18 Hepatocellular carcinoma</h3><p>The QLQ-HCC18 Hepatocellular carcinoma (primary liver cancer) module is meant for use among for patients with hepatocellular carcinoma. This module is to be used with the EORTC QLQ-C30 core questionnaire.<br /></p><p>The HCC18 module is fully validated. </p><p><u><br /></u></p><p><u>Development</u><br /></p><p>Wei-Chu Chie, Jane M. Blazeby, Chin-Fu Hsiao, Herng-Chia Chiu, Ronnie T. Poon, Naoko Mikoshiba, Gillian Al-Kadhimi, Nigel Heaton, Jozer Calara, Peter Collins, Katharine Caddick, Anna Costantini, Valerie Vilgrain, Ludovic Trinquart, and Chieh Chiang; On behalf of the EORTC Quality of Life Group. International Cross-Cultural Field Validation of an European Organization for Research and Treatment of Cancer Questionnaire Module for Patients With Primary Liver Cancer, the European Organization for Research and Treatment of Cancer Quality-of-Life Questionnaire HCC18. HEPATOLOGY, Vol. 55, No. 4, 2012</p><p> </p><p><u>Scale structure</u></p><ul><li>Fatigue scale 45-47</li><li>Body image scale 33, 35</li><li>Jaundice scale 36, 37</li><li>Nutrition scale 31, 32, 42-44</li><li>Pain scale 38, 39</li><li>Fever\\nscale 40, 41</li></ul><p>Single items</p><ul><li>Abdominal swelling 34</li><li>Sex life 48</li></ul><p><u><br /></u></p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":20,"languages":[{"code":"af","name":"Afrikaans"},{"code":"sq_AL","name":"Albanian (Albania)"},{"code":"hr","name":"Croatian"},{"code":"cs","name":"Czech"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"lang447","name":"Tamil (Malaysia)"},{"code":"lang448","name":"Tagalog"},{"code":"lang449","name":"Sotho"},{"code":"lang452","name":"Norwegian"},{"code":"lang454","name":"Malay (Singapore)"},{"code":"lang457","name":"Arabic (Israel)"},{"code":"lang438","name":"Chinese Mandarin (Malaysia)"},{"code":"lang439","name":"Chinese Mandarin (Singapore)"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang444","name":"Xhosa"},{"code":"lang446","name":"Tamil (Singapore)"},{"code":"tr","name":"Turkish"},{"code":"vi","name":"Vietnamese"},{"code":"zu","name":"Zulu"},{"code":"lang435","name":"Cebuano"},{"code":"lang436","name":"Chinese Cantonese (Hong Kong)"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"es_PR","name":"Spanish (Puerto Rico)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"es_US","name":"Spanish (United States)"},{"code":"sv","name":"Swedish"},{"code":"th","name":"Thai"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"ro","name":"Romanian"},{"code":"ru","name":"Russian"},{"code":"es_AR","name":"Spanish (Argentina)"},{"code":"es_CL","name":"Spanish (Chile)"},{"code":"es_CO","name":"Spanish (Colombia)"},{"code":"ko","name":"Korean"},{"code":"lv","name":"Latvian"},{"code":"lt","name":"Lithuanian"},{"code":"ms_MY","name":"Malay (Malaysia)"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"el","name":"Greek"},{"code":"he","name":"Hebrew"},{"code":"hi","name":"Hindi"},{"code":"hu","name":"Hungarian"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"en","name":"English"},{"code":"et","name":"Estonian"},{"code":"fi","name":"Finnish"},{"code":"fr_CA","name":"French (Canada)"},{"code":"de","name":"German"}],"createDate":"2016-03-04T09:29:25.83","updateDate":"2016-04-13T15:13:43.527"},{"rank":null,"id":1000153,"name":"other questionnaire","code":null,"type":"module","state":"published","phase":null,"gender":"nonSpecific","chemical":"test","description":"<a href=\\"test \\">test&nbsp;</a>","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":37,"email":"ykh@emakina.com","name":"Younes Kh\'Leeh"},"questionsStartPosition":null,"numQuestions":1,"languages":[{"code":"en","name":"English"}],"createDate":"2017-03-31T15:23:07.3","updateDate":"2017-04-21T15:33:28.63"},{"rank":null,"id":1000259,"name":"copy of Brice de nice","code":null,"type":"module","state":"draft","phase":null,"gender":"male","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":27,"email":"csi@emakina.com","name":"Cédric Simon"},"questionsStartPosition":null,"numQuestions":10,"languages":[{"code":"en","name":"English"}],"createDate":"2017-05-04T14:25:33.42","updateDate":"2017-05-04T14:25:33.42"},{"rank":null,"id":1,"name":"Prostate","code":"PR","type":"module","state":null,"phase":5,"gender":"male","chemical":null,"description":"<p>The QLQ-PR25&nbsp;Prostate cancer&nbsp;module is a questionnaire module&nbsp;meant for use among patients with prostate cancer varying in disease stage and treatment modality (i.e. surgery, chemotherapy, radiotherapy, etc.).This module is to&nbsp;be used with the EORTC QLQ-C30 core questionnaire.<br></p><p>The&nbsp;PR25&nbsp;module is fully validated.&nbsp;</p>","additionalInfo":"<h3><u>Development</u><br /></h3><p>van Andel G, Bottomley A, Fosså SD, et al. An International Field Study of the EORTC QLQ-PR25: a\\nQuestionnaire for Assessing the Health-Related Quality of Life of Patients with\\nProstate Cancer. <i>Eur J Cancer</i>\\n44:2418-2424, 2008.</p><p> </p><p><u>Scale structure</u></p><p>Functional scales</p><ul><li>Sexual activity 50, 51</li><li>Sexual functioning 52-55</li></ul><p>Symptom scales</p><ul><li>Urinary symptoms 31-37, 39</li><li>Bowel symptoms 40-43</li><li>Hormonal treatment-related symptoms 44-49</li><li>Incontinence aid 38</li></ul><div> <br /></div><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":26,"languages":[{"code":"af","name":"Afrikaans"},{"code":"bn","name":"Bengali"},{"code":"bg","name":"Bulgarian"},{"code":"ca","name":"Catalan"},{"code":"hr","name":"Croatian"},{"code":"cs","name":"Czech"},{"code":"lang457","name":"Arabic (Israel)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang444","name":"Xhosa"},{"code":"lang448","name":"Tagalog"},{"code":"lang449","name":"Sotho"},{"code":"lang452","name":"Norwegian"},{"code":"lang454","name":"Malay (Singapore)"},{"code":"zu","name":"Zulu"},{"code":"lang436","name":"Chinese Cantonese (Hong Kong)"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"lang438","name":"Chinese Mandarin (Malaysia)"},{"code":"lang439","name":"Chinese Mandarin (Singapore)"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"es_US","name":"Spanish (United States)"},{"code":"sv","name":"Swedish"},{"code":"th","name":"Thai"},{"code":"tr","name":"Turkish"},{"code":"uk","name":"Ukrainian"},{"code":"vi","name":"Vietnamese"},{"code":"es_AR","name":"Spanish (Argentina)"},{"code":"es_CL","name":"Spanish (Chile)"},{"code":"es_CO","name":"Spanish (Colombia)"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"es_PE","name":"Spanish (Peru)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"ro","name":"Romanian"},{"code":"ru","name":"Russian"},{"code":"sr","name":"Serbian"},{"code":"sk","name":"Slovak"},{"code":"ja","name":"Japanese"},{"code":"ko","name":"Korean"},{"code":"lv","name":"Latvian"},{"code":"lt","name":"Lithuanian"},{"code":"ms_MY","name":"Malay (Malaysia)"},{"code":"pl","name":"Polish"},{"code":"el","name":"Greek"},{"code":"he","name":"Hebrew"},{"code":"hi","name":"Hindi"},{"code":"hu","name":"Hungarian"},{"code":"id","name":"Indonesian"},{"code":"it","name":"Italian"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"et","name":"Estonian"},{"code":"fr_CA","name":"French (Canada)"},{"code":"de","name":"German"}],"createDate":"2016-02-02T11:37:44.567","updateDate":"2017-03-31T16:48:18.517"},{"rank":null,"id":50,"name":"Physical Functioning","code":"PF","type":"cat","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":"","additionalInfo":"","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":5,"languages":[{"code":"en","name":"English"}],"createDate":"2016-12-15T14:31:47.91","updateDate":"2017-03-15T15:51:30.217"},{"rank":null,"id":24,"name":"Chronic Lymphocytic Leukaemia","code":"CLL","type":"module","state":null,"phase":3,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3><b>QLQ-CLL17 Chronic Lymphocytic Leukaemia module</b></h3><p>The CLL17 module has completed phase III. </p><p>This module is to be used with the EORTC QLQ-C30 core questionnaire.</p><p><br /></p><p><u>Scales</u></p><ul><li>Symptom burden 31-36</li><li>Physical condition / fatigue 37-40</li><li>Worries/fears health and functioning 41-45 and if applicable 46, 47</li></ul><p><br /></p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":17,"languages":[{"code":"ar_IQ","name":"Arabic (Iraq)"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"de","name":"German"},{"code":"it","name":"Italian"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"lang441","name":"French (Europe)"}],"createDate":"2016-03-02T10:14:52.47","updateDate":"2016-05-17T11:43:39.177"},{"rank":null,"id":47,"name":"In-Patient Satisfaction","code":"IN–PATSAT","type":"standalone","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-IN-PATSAT32 In-Patient Satisfaction questionnaire</h3><p>The QLQ-IN-PATSAT32 In-Patient Satisfaction questionnaire is designed to measure patients’ appraisal of hospital doctors and nurses, as well as aspects of care organisation and services. It addresses technical competence, information provision, interpersonal skills, availability, waiting time, access, comfort and overall care perception. The IN-PATSAT32 is a stand-alone questionnaire enabling the assessment of the contribution of patient satisfaction with oncology-relevant aspects of care by comparison with treatment, psychosocial intervention, or health care services across countries from various socio-cultural backgrounds.<br /></p><p>The IN-PATSAT32 questionnaire is fully validated. </p><p><u><br /></u></p><p><u>Development</u><br /></p><p>A. Brédart, A. Bottomley, J.M. Blazeby, T. Conroy, C. Coens, S. D\\u0001Haese, Wei-Chu Chie, E. Hammerlid, J.I. Arraras, F. Efficace, C. Rodary, S. Schraub, M. Costantini, A. Costantini, F. Joly, O. Sezer, D. Razavi, M. Mehlitz, M. Bielska-Lasota, N.K. Aaronson, On behalf of the European Organisation for Research and Treatment of Cancer Quality of Life Group and Quality of Life Unit. An international prospective study of the EORTC cancer in-patient satisfaction with care measure (EORTC IN-PATSAT32). European Journal of Cancer 41 (2005) 2120–2131</p><p> </p><p><u>Scale structure</u></p><p>Doctors</p><ul><li>Interpersonal skills 34-36</li><li>Technical skills 31-33</li><li>Information provision 37-39</li><li>Availability 40, 41</li></ul><p> Nurses</p><ul><li>Interpersonal skills 45-47</li><li>Technical skills 42-44</li><li>Information provision 48-50</li><li>Availability 51, 52</li></ul><p><br /></p><ul><li>Other hospital personnel kindness and helpfulness, and information giving 54-56</li><li>Waiting time (performing medical tests/treatment, receiving medical tests results) 57, 58</li><li>Access 59, 50</li></ul><p>Single item scale<br /></p><ul><li>Exchange of information 53</li><li>Comfort/cleanness 61</li><li>General satisfaction 62</li></ul><p><br /></p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":33,"languages":[{"code":"ar","name":"Arabic"},{"code":"hr","name":"Croatian"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"fi","name":"Finnish"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"si","name":"Sinhala"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"sv","name":"Swedish"},{"code":"tr","name":"Turkish"},{"code":"de","name":"German"},{"code":"is","name":"Icelandic"},{"code":"it","name":"Italian"},{"code":"mt","name":"Maltese"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"}],"createDate":"2016-03-04T12:12:09.187","updateDate":"2016-09-20T14:57:33.533"},{"rank":null,"id":18,"name":"Breast Reconstruction","code":"BRR","type":"module","state":null,"phase":4,"gender":"female","chemical":null,"description":null,"additionalInfo":"<h3><u>Development</u></h3><p>Thomson HJ, Winters ZE, Brandberg Y, Didier F, Blazeby JM, Mills J. The early development phases of a European Organisation for Research and Treatment of Cancer (EORTC) module to assess patient reported outcomes (PROs) in women undergoing breast reconstruction. European Journal of Cancer, 2013; 49:1018-1026.</p><p>Winters ZE, Balta V, Thomson HJ, Bradberg Y, Oberguggenberger A, Sinove Y, Unukovych D, Nava M, Sandelin K and Johansson H on behalf of the European Organisation for Research and Treatment of Cancer (EORTC) Quality of Life Group. Phase III development of the European Organisation for Research and Treatment of Cancer Quality of Life Questionnaire module for women undergoing breast reconstruction, 2014; 101(4): 371–382.</p><p><br /></p><p><u>Scale</u><br /></p><p>Body image</p><ul><li>Sexuality 57-60</li></ul><p>Symptom scale / items</p><ul><li>Treatment side effects   54-55</li><li>Donor site symptoms (1)   74-76</li></ul><p>Satisfaction scales / items</p><ul><li>Breast cosmetic   61-66</li><li>Nipple cosmetic (2)   67-68</li><li>Satisfaction with surgery (3)   69-71</li></ul><p>Stand alone / items</p><ul><li>Well-fitting bra   56</li><li>Loss of nipple (4)   72</li><li>Preserve / reconstruct nipple (5)   73</li><li>Satisfaction with Donor scars (1)   77</li></ul><p>(1) If flap\\nprocedure<br /></p><p>(2) If nipple\\npreserved</p><p>(3) If breast\\nreconstructed</p><p>(4) If nipple\\nlost and not reconstructed</p><p>\\n\\n\\n\\n\\n\\n\\n\\n\\n\\n\\n\\n</p><p>(5) If nipple\\npreserved /reconstructed</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":54,"numQuestions":25,"languages":[{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"it","name":"Italian"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"lang441","name":"French (Europe)"}],"createDate":"2016-03-01T11:46:43.7","updateDate":"2017-03-15T14:13:07.46"},{"rank":null,"id":30,"name":"Non-Muscle Invasive Bladder Cancer","code":"NMIBC","type":"module","state":null,"phase":3,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-NMIBC24 Non-Muscle Invasive Bladder Cancer module</h3><p>The QLQ-NMIBC24 Non-Muscle Invasive Bladder Cancer module is meant for use among patients with superficial bladder cancer. This module is to be used with the EORTC QLQ-C30 core questionnaire.<br /></p><p>The NMIBC24 has completed phase III. </p><p> </p><p><u>Scale structure</u></p><ul><li>Urinary symptoms 31, 37</li><li>Malaise 38, 39</li><li>Future worries 41, 44</li><li>Bloating and flatulence 45, 46</li><li>Sexual function 47, 48</li><li>Male sexual problems 49, 50</li></ul><p></p><p>Single items</p><ul><li>Intravesical treatment issues 40<br /></li><li>Sexual intimacy 51</li><li>Risk of contaminating partner 52</li><li>Sexual enjoyment 53</li><li>Female sexual problems 54</li></ul><p> </p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":24,"languages":[{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"hu","name":"Hungarian"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"},{"code":"ru","name":"Russian"},{"code":"sk","name":"Slovak"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"es_US","name":"Spanish (United States)"},{"code":"sv","name":"Swedish"},{"code":"tr","name":"Turkish"},{"code":"it","name":"Italian"},{"code":"ko","name":"Korean"},{"code":"fa","name":"Persian"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"pt_PT","name":"Portuguese (Portugal)"}],"createDate":"2016-03-02T13:58:12.403","updateDate":"2016-04-13T14:53:06.913"},{"rank":null,"id":1000142,"name":"MDMA","code":null,"type":"standalone","state":"published","phase":null,"gender":"nonSpecific","chemical":"8.N-Methyl-3,4-methylenedioxyamphetamine Hydrochloride","description":"<p>MDMA is an N-substituted amphetamine analog. It is a widely abused drug classified as a hallucinogen and causes marked, long-lasting changes in brain serotonergic systems. It is commonly referred to as MDMA or ecstasy.</p><p>Clinical trials are now testing the therapeutic potential of MDMA for post-traumatic stress disorder (PTSD) and anxiety associated with terminal cancer. MDMA is one of the four most widely used illicit drugs in the U.S.<br></p>","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":2,"email":"mca@emakina.com","name":"Mathieu Callewaert"},"questionsStartPosition":null,"numQuestions":4,"languages":[{"code":"af","name":"Afrikaans"},{"code":"da","name":"Danish"},{"code":"en","name":"English"}],"createDate":"2017-03-30T09:28:02.88","updateDate":"2017-04-21T12:09:03.797"},{"rank":null,"id":1000182,"name":"test bug","code":"TE23","type":"module","state":"draft","phase":5,"gender":"nonSpecific","chemical":null,"description":"efzfzfe","additionalInfo":"<p>zefzfzfz<br /></p>","contact":"mll@emakina.com","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":1,"languages":[{"code":"en","name":"English"}],"createDate":"2017-04-24T15:30:04.99","updateDate":"2017-04-24T15:30:04.99"},{"rank":null,"id":1000282,"name":"copy of Cervix","code":null,"type":"itemlist","state":"draft","phase":null,"gender":"female","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":1,"email":"adb@emakina.com","name":"Alexis Debontridder"},"questionsStartPosition":1,"numQuestions":24,"languages":[{"code":"en","name":"English"}],"createDate":"2021-06-04T11:18:40.377","updateDate":"2021-06-04T11:18:40.377"},{"rank":null,"id":1000268,"name":"test julien","code":null,"type":"module","state":"draft","phase":null,"gender":"nonSpecific","chemical":"test julien","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":55,"email":"jth@emakina.com","name":"Julien Theys"},"questionsStartPosition":10,"numQuestions":8,"languages":[{"code":"en","name":"English"}],"createDate":"2019-01-16T14:26:43.627","updateDate":"2019-04-23T13:40:40.053"},{"rank":null,"id":10,"name":"Cholangiocarcinoma & Gall Bladder","code":"BIL","type":"module","state":null,"phase":4,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-BIL21 Cholangiocarcinoma &amp; Gall Bladder module</h3><p>The QLQ-BIL21 Cholangiocarcinoma &amp; Gall Bladder module is a questionnaire to assess cholangiocarcinoma and gallbladder cancer symptoms (including jaundice, eating, tiredness, pain and anxiety) and side effects of treatment. This module is to be used with the EORTC QLQ-C30 core questionnaire.<br /></p><p>The BIL21 module is currently under phase IV. <br /></p><p><u><br /></u></p><p><u>Scale structure</u></p><p>Symptom scales</p><ul><li>Eating 31-34</li><li>Jaundice 35-37</li><li>Tiredness 38-40</li><li>Pain 41-44</li><li>Anxiety 45,-48</li></ul><p><br /></p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":21,"languages":[{"code":"bn","name":"Bengali"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"de","name":"German"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"ko","name":"Korean"},{"code":"es_CL","name":"Spanish (Chile)"},{"code":"lang437","name":"Chinese Mandarin (China)"}],"createDate":"2016-02-26T09:00:41.947","updateDate":"2016-05-17T11:40:13.08"},{"rank":null,"id":1000242,"name":"demo sprint 8","code":null,"type":"module","state":"draft","phase":null,"gender":"nonSpecific","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":37,"email":"ykh@emakina.com","name":"Younes Kh\'Leeh"},"questionsStartPosition":null,"numQuestions":1,"languages":[{"code":"en","name":"English"}],"createDate":"2017-05-02T14:12:25.673","updateDate":"2017-05-02T14:12:25.673"},{"rank":null,"id":1000262,"name":"test demo 9","code":null,"type":"module","state":"draft","phase":null,"gender":"nonSpecific","chemical":"test","description":"test","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":1,"email":"adb@emakina.com","name":"Alexis Debontridder"},"questionsStartPosition":null,"numQuestions":5,"languages":[{"code":"en","name":"English"}],"createDate":"2017-05-08T10:12:43.52","updateDate":"2017-05-08T10:12:43.52"},{"rank":null,"id":41,"name":"Hodgkin\'s Lymphoma","code":"HL","type":"module","state":null,"phase":3,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-HL27 Hodgkin’s Lymphoma module</h3><p>The HL27 module has completed phase III. </p><p>The module is to be used with the EORTC QLQ-C30 core questionnaire.<br /></p><p><br /></p><p><u>Scales</u></p><ul><li>Symptom burden 31-36</li><li>Physical condition/ Fatigue 37-40</li><li>Emotional impact 41-46<br /></li><li>Worries/fears health and functioning 47-54 and if applicable 55-57</li></ul><p><br /></p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":27,"languages":[{"code":"ar_IQ","name":"Arabic (Iraq)"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"de","name":"German"},{"code":"it","name":"Italian"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"lang441","name":"French (Europe)"}],"createDate":"2016-03-03T14:49:08.46","updateDate":"2016-04-13T14:32:31.313"},{"rank":null,"id":1000156,"name":"test cm","code":null,"type":"module","state":"published","phase":null,"gender":"nonSpecific","chemical":"test","description":"<p>&nbsp; &nbsp; test<br></p>","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":37,"email":"ykh@emakina.com","name":"Younes Kh\'Leeh"},"questionsStartPosition":null,"numQuestions":0,"languages":[{"code":"en","name":"English"}],"createDate":"2017-03-31T16:00:10.673","updateDate":"2017-04-21T18:25:00.423"},{"rank":null,"id":4,"name":"Core","code":"C","type":"core","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-C30 Core questionnaire v. 3.0</h3><p>The QLQ-C30 is the core questionnaire that covers the most common problems and symptoms, and measures overall health status and quality of life of cancer patients.</p><h4><u>Development</u></h4><p>Aaronson NK, Ahmedzai S, Bullinger M, et al. for the EORTC Study Group on Quality of Life. The EORTC Core Quality of Life Questionnaire: Interim results of an international field study. In: Effect of Cancer on Quality of Life (D. Osoba, ed.), CRC Press Inc., Boca Raton, 1991, pp. 185-203.</p><p>Bjordal K, Kaasa S. Psychometric validation of the EORTC core quality of life questionnaire, 30 item version and a diagnosis specific module for head and neck cancer patients. Acta Oncol. 31: 311-321, 1992.</p><p>Aaronson NK, Ahmedzai S, Bergman B, et al., for the European Organization for Research and Treatment of Cancer QLQ-C30: A Quality-of-Life Instrument for Use in International Clinical Trials in Oncology. JNCI 85: 365-376, 1993.</p><p><br /></p><h4><u>Scale structure</u></h4><p>Functioning scales:</p><ul><li>Physical 1-5</li><li>Role 6, 7</li><li>Cognitive 20, 25</li><li>Emotional 21-24</li><li>Social 26, 27</li><li>Global quality of life 29, 30</li></ul><p>Symptom scales and/or items:</p><ul><li>Fatigue 10, 12, 18</li><li>Nausea and vomiting 14, 15</li><li>Pain 9, 19</li><li>Dyspnea 8</li><li>Sleep disturbance 11</li><li>Appetite loss 13</li><li>Constipation 16</li><li>Diarrhea 17</li><li>Financial impact 28</li></ul><p></p><p></p><h4><br /></h4><h4><u>How to obtain the questionnaire</u></h4><p>The EORTC has two policies for the use of the QLQ-C30 and\\nassociated modules.</p><p></p>\\n\\n<p><b>Commercial users</b>(1) - Royalty\\nfee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p>\\n\\n<p>What is classed as<b> ‘academic’\\nresearch</b>(2) – for educational institutions, hospitals, etc - No fee:\\nquestionnaires can be downloaded from the EORTC website</p>\\n\\n<p> </p>\\n\\n<p>(1) If an organization, institution or company is being\\nprovided with or providing funds, sponsorship or a grant for their research,\\nand should any of these gain financially or use the measures for commercial\\npurposes, then a fee is chargeable.  </p>\\n\\n<p>(2) The only time a fee is not chargeable is if the study is\\npurely for academic use and there is no financial gain by any party.  </p><p><br /></p><h4><u>Other publications on the questionnaire</u></h4><p>Giesinger JM, Kieffer JM, Fayers PM, Groenvold M, Petersen MA, Scott NW, Sprangers MA, Velikova G, Aaronson NK; EORTC Quality of Life Group. Replication and validation of higher order models demonstrated that a summary score for the EORTC QLQ-C30 is robust. J Clin Epidemiol. 2016 Jan; 69:79-88.</p><p>Scott NW, Etta JA, Aaronson NK, Bottomley A, Fayers PM, Groenvold M, Koller M, Kuliś D, Marais D, Petersen MA, Sprangers MA. An evaluation of the response category translations of the EORTC QLQ-C30 questionnaire. Qual Life Res. 2012 Oct 2, PMID: 23054491.</p><p>Gundy CM, Fayers PM, Groenvold M, Petersen MA, Scott NW, Sprangers MA, Velikova G, Aaronson NK. Comparing higher order models for the EORTC QLQ-C30. Qual Life Res. 2012 Nov;21(9):1607-17. doi: 10.1007/s11136-011-0082-6. Epub 2011  Dec 21. PubMed PMID: 22187352; PubMed Central PMCID: PMC3472059.</p><p>Scott NW, Fayers PM, Aaronson NK, Bottomley A, de Graeff A, Groenvold M, Gundy C, Koller M, Petersen MA, Sprangers MAG on beholf of the EORTC Quality of Life Group and the Quality of Life Cross-Cultural Meta-Analysis Group. Differential item functioning (DIF) in the EORTC QLQ-C30: a comparison of baseline, on-treatment and off-treatment data. Qual Life Res. 2009 Feb 27.</p><p>Scott NW, Fayers PM, Aaronson NK, Bottomley A, de Graeff A, Groenvold M, Koller M, Petersen MA, Sprangers MA; on behalf of the EORTC and the Quality of Life Cross-Cultural Meta-Analysis Group. The use of differential item functioning analyses to identify cultural differences in responses to the EORTC QLQ-C30. Qual Life Res 16: 115-129, 2007.<br /></p><p>Scott NW, Fayers PM, Bottomley A et al. on behalf of the EORTC Quality of Life Cross-Cultural Meta-Analysis Group. Comparing translations of the EORTC QLQ-C30 using differential item functioning analyses. Qual Life Res 15 (6): 1103-1115, 2006.<br /></p><p>Bjorner JB, Petersen MA, Groenvold M et al. for the EORTC Quality of Life Group. Use of item response theory to develop a shortened version of the EORTC QLQ-C30 emotional function scale. Quality of Life Research 13: 1683-1697, 2004.</p><p>Fayers P, Bottomley A on behalf of the EORTC Quality of Life Group and of the Quality of Life Unit. Quality of life research within the EORTC - the EORTC QLQ-C30. Eur. J. Cancer 38 (Suppl. 4): S125-S133, 2002.<br /></p><p>Kaasa S, Bjordal K, Aaronson NK, et al. and the EORTC Study Group on Quality of Life. The EORTC Core Quality of Life Questionnaire (QLQ-C30): Validity and reliability when analyzed with patients treated with palliative radiotherapy. Eur. J. Cancer 31A: 2260-2263, 1995.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":30,"languages":[{"code":"af","name":"Afrikaans"},{"code":"sq","name":"Albanian"},{"code":"am","name":"Amharic"},{"code":"ar","name":"Arabic"},{"code":"bn","name":"Bengali"},{"code":"bs","name":"Bosnian"},{"code":"lang454","name":"Malay (Singapore)"},{"code":"lang455","name":"Pangasinan"},{"code":"lang448","name":"Tagalog"},{"code":"lang449","name":"Sotho"},{"code":"lang450","name":"Russian (Georgia)"},{"code":"lang451","name":"Russian (Belarus)"},{"code":"lang452","name":"Norwegian"},{"code":"lang453","name":"Kiswahili"},{"code":"lang442","name":"Greenlandic"},{"code":"lang443","name":"Iloko"},{"code":"lang444","name":"Xhosa"},{"code":"lang445","name":"Tswana"},{"code":"lang446","name":"Tamil (Singapore)"},{"code":"lang447","name":"Tamil (Malaysia)"},{"code":"lang436","name":"Chinese Cantonese (Hong Kong)"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"lang438","name":"Chinese Mandarin (Malaysia)"},{"code":"lang439","name":"Chinese Mandarin (Singapore)"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"ur_IN","name":"Urdu (India)"},{"code":"ur_PK","name":"Urdu (Pakistan)"},{"code":"vi","name":"Vietnamese"},{"code":"yo","name":"Yoruba"},{"code":"zu","name":"Zulu"},{"code":"lang435","name":"Cebuano"},{"code":"ta_IN","name":"Tamil (India)"},{"code":"ta_LK","name":"Tamil (Sri Lanka)"},{"code":"te","name":"Telugu"},{"code":"th","name":"Thai"},{"code":"tr","name":"Turkish"},{"code":"uk","name":"Ukrainian"},{"code":"es_PR","name":"Spanish (Puerto Rico)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"es_US","name":"Spanish (United States)"},{"code":"es_UY","name":"Spanish (Uruguay)"},{"code":"es_VE","name":"Spanish (Venezuela)"},{"code":"sv","name":"Swedish"},{"code":"es_CR","name":"Spanish (Costa Rica)"},{"code":"es_EC","name":"Spanish (Ecuador)"},{"code":"es_GT","name":"Spanish (Guatemala)"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"es_PA","name":"Spanish (Panama)"},{"code":"es_PE","name":"Spanish (Peru)"},{"code":"sk","name":"Slovak"},{"code":"sl","name":"Slovenian"},{"code":"es","name":"Spanish"},{"code":"es_AR","name":"Spanish (Argentina)"},{"code":"es_CL","name":"Spanish (Chile)"},{"code":"es_CO","name":"Spanish (Colombia)"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"pa","name":"Punjabi"},{"code":"ro","name":"Romanian"},{"code":"ru","name":"Russian"},{"code":"sr","name":"Serbian"},{"code":"sr_Cyrl","name":"Serbian (Cyrillic)"},{"code":"ms_MY","name":"Malay (Malaysia)"},{"code":"ml","name":"Malayalam"},{"code":"mt","name":"Maltese"},{"code":"fa","name":"Persian"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"kk","name":"Kazakh"},{"code":"km","name":"Khmer"},{"code":"ko","name":"Korean"},{"code":"lv","name":"Latvian"},{"code":"lt","name":"Lithuanian"},{"code":"mk","name":"Macedonian"},{"code":"hu","name":"Hungarian"},{"code":"is","name":"Icelandic"},{"code":"id","name":"Indonesian"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"kn","name":"Kannada"},{"code":"ka","name":"Georgian"},{"code":"de","name":"German"},{"code":"de_CH","name":"German (Switzerland)"},{"code":"el","name":"Greek"},{"code":"gu","name":"Gujarati"},{"code":"he","name":"Hebrew"},{"code":"en","name":"English"},{"code":"et","name":"Estonian"},{"code":"fi","name":"Finnish"},{"code":"fr_BE","name":"French (Belgium)"},{"code":"fr_CA","name":"French (Canada)"},{"code":"lg","name":"Ganda"},{"code":"bg","name":"Bulgarian"},{"code":"ca","name":"Catalan"},{"code":"hr","name":"Croatian"},{"code":"cs","name":"Czech"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"}],"createDate":"2016-02-10T11:37:40.957","updateDate":"2016-05-04T09:15:24.817"},{"rank":null,"id":19,"name":"Ovarian","code":"OV","type":"module","state":null,"phase":5,"gender":"female","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-OV28 Ovarian cancer module</h3><p>The QLQ-OV28 Ovarian\\ncancer module is meant for use among ovarian cancer patients varying in disease\\nstage and treatment modality (i.e. surgery, chemotherapy, radiotherapy, etc.). This module is to be used with the EORTC QLQ-C30 core questionnaire.<br /></p><p>The OV28 module is fully validated. </p><p><u><br /></u></p><p><u>Development</u><br /></p><p>Greimel E,\\nBottomley A, Cull A, et al. on behalf of the EORTC Quality of Life Group and\\nthe Quality of Life Unit. An International Field Study of the Reliability and Validity\\nof a Disease-Specific Questionnaire Module (the QLQ-OV28) in Assessing the Quality\\nof Life of Patients with Ovarian Cancer. <i>Eur\\nJ Cancer</i> 39:1402-1408, 2003.</p><p> </p><p><u>Scale structure</u></p><p>Functional scales\\t\\t\\t\\t</p><ul><li>Body image 50-51</li><li>Sexuality 55-58</li><li>Attitude to disease/treatment 52-54</li></ul><p>Symptom scales / items\\t\\t\\t\\t<br /></p><ul><li>Abdominal/GI symptoms 31-37</li><li>Peripheral neuropathy 41-43</li><li>Hormonal/menopausal symptoms 48, 49</li><li>Other chemotherapy side-effects 40, 44-47</li><li>Hair loss 38, 39</li></ul><div><br /></div><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":28,"languages":[{"code":"af","name":"Afrikaans"},{"code":"bg","name":"Bulgarian"},{"code":"hr","name":"Croatian"},{"code":"cs","name":"Czech"},{"code":"da","name":"Danish"},{"code":"lang452","name":"Norwegian"},{"code":"lang454","name":"Malay (Singapore)"},{"code":"lang457","name":"Arabic (Israel)"},{"code":"lang439","name":"Chinese Mandarin (Singapore)"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang446","name":"Tamil (Singapore)"},{"code":"lang447","name":"Tamil (Malaysia)"},{"code":"sv","name":"Swedish"},{"code":"tr","name":"Turkish"},{"code":"uk","name":"Ukrainian"},{"code":"zu","name":"Zulu"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"lang438","name":"Chinese Mandarin (Malaysia)"},{"code":"sl","name":"Slovenian"},{"code":"es_AR","name":"Spanish (Argentina)"},{"code":"es_CL","name":"Spanish (Chile)"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"es_US","name":"Spanish (United States)"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"ro","name":"Romanian"},{"code":"ru","name":"Russian"},{"code":"sr","name":"Serbian"},{"code":"sk","name":"Slovak"},{"code":"ja","name":"Japanese"},{"code":"ko","name":"Korean"},{"code":"lv","name":"Latvian"},{"code":"lt","name":"Lithuanian"},{"code":"ms_MY","name":"Malay (Malaysia)"},{"code":"pl","name":"Polish"},{"code":"fr_CA","name":"French (Canada)"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"he","name":"Hebrew"},{"code":"hu","name":"Hungarian"},{"code":"it","name":"Italian"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"et","name":"Estonian"},{"code":"fi","name":"Finnish"}],"createDate":"2016-03-01T12:44:39.483","updateDate":"2016-04-13T15:10:30.2"},{"rank":null,"id":1000177,"name":"asking for publish","code":null,"type":"module","state":"published","phase":null,"gender":"nonSpecific","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":37,"email":"ykh@emakina.com","name":"Younes Kh\'Leeh"},"questionsStartPosition":null,"numQuestions":2,"languages":[{"code":"af","name":"Afrikaans"},{"code":"lang441","name":"French (Europe)"},{"code":"en","name":"English"},{"code":"eo","name":"Esperanto"}],"createDate":"2017-04-21T18:45:53.697","updateDate":"2017-04-21T18:46:39.67"},{"rank":null,"id":1000277,"name":"Alexis Debontridder 2021","code":null,"type":"standalone","state":"draft","phase":null,"gender":"male","chemical":"Spike","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":1,"email":"adb@emakina.com","name":"Alexis Debontridder"},"questionsStartPosition":1,"numQuestions":5,"languages":[{"code":"en","name":"English"}],"createDate":"2021-04-07T16:34:58.533","updateDate":"2021-04-07T16:34:58.533"},{"rank":null,"id":1000283,"name":"Test IL","code":null,"type":"standalone","state":"published","phase":null,"gender":"nonSpecific","chemical":"testMolecule","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":56,"email":"dks@emakina.com","name":"Derrick Sanya"},"questionsStartPosition":1,"numQuestions":1,"languages":[{"code":"en","name":"English"}],"createDate":"2021-06-14T13:32:44.127","updateDate":"2021-06-14T13:34:03.187"},{"rank":null,"id":1000231,"name":"copy of Breast ","code":null,"type":"module","state":"draft","phase":null,"gender":"female","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":27,"email":"csi@emakina.com","name":"Cédric Simon"},"questionsStartPosition":null,"numQuestions":25,"languages":[{"code":"en","name":"English"}],"createDate":"2017-04-28T15:01:13.433","updateDate":"2017-04-28T15:01:13.433"},{"rank":null,"id":25,"name":"Oral Health","code":"OH","type":"module","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-OH15 Oral Health module</h3><p>The QLQ-OH15 Oral Health module is designed for the assessment of oral health and quality of life in cancer patients. This module is to be used with the EORTC QLQ-C30 core questionnaire.</p><p>The OH15 module is fully validated. </p><p><u><br /></u></p><p><u>Development</u><br /></p><p>M. Hjermstad, M. Bergenmar, K. Bjordal, S. Fisher, D. Hofmeister, S. Montel, O. Nicolatou-Galitis, M. Pinto, J. Raber-Durlacher, S. Singer, I. Tomaszewska, K. Tomaszewski, I. Verdonck-de Leeuw, N. Yarom, J. Winstanley, B. Herlofson: <em>International field testing of the reliability, validity and psychometric properties of an EORTC quality of life module for dental and oral health; the EORTC QLQ-OH15</em>. Supportive Care in Cancer, 23 (1), Suppl 1: 15-05-P, page S181, doi 10.1007/s00520-015-2712-y.<br /></p><p> </p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":15,"languages":[{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"de","name":"German"},{"code":"he","name":"Hebrew"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"si","name":"Sinhala"},{"code":"sv","name":"Swedish"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"}],"createDate":"2016-03-02T10:37:31.733","updateDate":"2016-04-13T14:55:51.3"},{"rank":null,"id":36,"name":"Liver Metastasis Colorectal","code":"LMC","type":"module","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-LMC21 Colorectal liver cancer module</h3><p>The QLQ-LMC21 Colorectal liver cancer module is meant for use among patients with colorectal liver metastases varying in disease stage and treatment modality (i.e. surgery, chemotherapy, radiotherapy, etc.). This module is to be used with the EORTC QLQ-C30 core questionnaire.<br /></p><p>The LMC21 module is fully validated. </p><p><u><br /></u></p><p><u>Development</u><br /></p><p>Blazeby JM, Fayers P, Conroy T, et al. Validation of the EORTC QLQ-LCM21 Questionnaire for Assessment of Patient-Reported Outcomes During Treatment of Colorectal Liver Metastases. Br J Surg 96:291-298, 2009.</p><p>Kavadas V, Blazeby JM, et al. Development of an EORTC disease-specific quality of life questionnaire for use in patients with liver metastases from colorectal cancer. Eur J Cancer. 2003 Jun;39(9):1259-63.</p><p> </p><p><u>Scale structure</u></p><p>Symptom scales </p><ul><li>Nutritional problems 31, 32</li><li>Fatigue 37, 43, 44</li><li>Pain 39, 40, 42</li><li>Emotional problems 47-50</li><li>Weight loss 33</li><li>Taste 34</li><li>Dry mouth 35</li><li>Sore mouth/tongue 36</li><li>Peripheral neuropathy 38</li><li>Jaundice 41</li><li>Contact with friends 45</li><li>Talking about feelings 46</li><li>Sex life 51</li></ul><p> <br /></p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":21,"languages":[{"code":"cs","name":"Czech"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"de","name":"German"},{"code":"it","name":"Italian"},{"code":"pl","name":"Polish"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"}],"createDate":"2016-03-03T13:09:43.37","updateDate":"2016-04-13T14:35:34.36"},{"rank":null,"id":1000243,"name":"copy of Prostate","code":null,"type":"module","state":"published","phase":null,"gender":"male","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":37,"email":"ykh@emakina.com","name":"Younes Kh\'Leeh"},"questionsStartPosition":null,"numQuestions":26,"languages":[{"code":"af","name":"Afrikaans"},{"code":"en","name":"English"},{"code":"lang441","name":"French (Europe)"},{"code":"lang460","name":"Adb"}],"createDate":"2017-05-02T14:13:54.127","updateDate":"2017-05-02T14:18:31.747"},{"rank":null,"id":13,"name":"Bladder","code":"BLM","type":"module","state":null,"phase":3,"gender":"nonSpecific","chemical":null,"description":"<h3 style=\\"font-family: Titillium, sans-serif; color: rgb(0, 0, 0);\\">QLQ-BLM30 Bladder module</h3><p>The QLQ-BLM30 Bladder module is a questionnaire to assess patient-reported outcomes in muscle-invasive bladder cancer. This module is to be used with the EORTC QLQ-C30 core questionnaire.<br></p><p>The BLM30 module has completed phase III.</p>","additionalInfo":"<h4><u>Scale structure</u></h4><p><b>Please note: This is a hypothesised scale structure. It has not undergone factor analysis</b><br /></p><ul><li>Urinary symptom 31-37</li><li>Urostomy problem 38-43</li><li>Single catheter use problem 44</li><li>Future perspective 45-47</li><li>Abdominal bloating and flatulence 48-49</li><li>Body image 50-52</li><li>Sexual functioning 53-60</li></ul>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":35,"languages":[{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"de","name":"German"},{"code":"hu","name":"Hungarian"},{"code":"it","name":"Italian"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"sv","name":"Swedish"},{"code":"tr","name":"Turkish"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"},{"code":"ko","name":"Korean"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"ru","name":"Russian"},{"code":"sk","name":"Slovak"}],"createDate":"2016-02-29T12:51:28.113","updateDate":"2017-04-24T15:25:27.917"},{"rank":null,"id":42,"name":"Neuroendocrine Carcinoid","code":"GI.NET","type":"module","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-GI.NET21 Gastrointestinal neuroendocrine tumours</h3><p>The QLQ-GI.NET21 Gastrointestinal neuroendocrine tumours module is intended for use among patients with G.I.-related neuroendocrine tumours, who vary in disease stage and treatments. This module is to be used with the EORTC QLQ-C30 core questionnaire.</p><p>The GI.NET21 module is fully validated. </p><p> <br /></p><p><u>Scale structure</u></p><ul><li>Endocrine scale 31, 32, 33</li><li>G.I. scale 34, 35, 36, 37,38</li><li>Treatment scale 39, 40, 46</li><li>Social function scale 42, 44, 49</li><li>Disease related worries scale 41, 43, 47</li>\\n</ul><p>Single items</p><ul><li>Muscle /bone pain symptom 48</li><li>Sexual function 51</li><li>Information/communication function 50</li><li>Body Image 45       </li></ul><p><u><br /></u></p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules. </p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":21,"languages":[{"code":"af","name":"Afrikaans"},{"code":"bg","name":"Bulgarian"},{"code":"hr","name":"Croatian"},{"code":"cs","name":"Czech"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"es_US","name":"Spanish (United States)"},{"code":"sv","name":"Swedish"},{"code":"te","name":"Telugu"},{"code":"tr","name":"Turkish"},{"code":"uk","name":"Ukrainian"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"ro","name":"Romanian"},{"code":"ru","name":"Russian"},{"code":"sr","name":"Serbian"},{"code":"sk","name":"Slovak"},{"code":"hu","name":"Hungarian"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"lv","name":"Latvian"},{"code":"mr","name":"Marathi"},{"code":"pl","name":"Polish"},{"code":"en","name":"English"},{"code":"et","name":"Estonian"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"he","name":"Hebrew"},{"code":"hi","name":"Hindi"}],"createDate":"2016-03-03T15:17:29.27","updateDate":"2016-04-13T14:41:34.683"},{"rank":null,"id":5,"name":"Breast ","code":"BR","type":"module","state":null,"phase":5,"gender":"female","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-BR23 Breast cancer module</h3><p>The module is fully validated. It is to be used with the QLQ-C30.</p><p><br /></p><h4><u>Development</u></h4><p>Sprangers MAG, Groenvold M, Arraras JI, et al. The European Organisation for Research and Treatment of Cancer: Breast Cancer Specific Quality of Life Questionnaire Module: First results from a three-country field study. J. Clin. Oncol. 14: 2756-2768, 1996.</p><p><br /></p><h4><u>Scale structure</u></h4><p>Functional scales:</p><ul><li>Body image 39-42</li><li>Sexual functioning 44, 45</li><li>Sexual enjoyment 46</li><li>Future perspective 43</li></ul><p>Symptom scales and/or items:</p><ul><li>Systemic therapy side effects 31-34, 36-38</li><li>Breast symptoms 50-53</li><li>Arm symptoms 47-49</li><li>Upset by hair loss 35</li></ul><p><br /></p><h4><u>Other publications on the questionnaire</u></h4><p>Arraras JI, Manterola A, Domínguez MA, Arias F,\\nVillafranca E, Romero P, Martínez E, Illarramendi JJ, Salgado E. Impact of\\nradiotherapy on the quality of life of elderly patients with localized breast\\ncancer. A prospective study. Clin Transl Oncol (2008) 10:498-504</p><p>Soares Oliveira I, da Cunha Menezes Costa L, Ribeiro\\nCabral Fagundes F, Maria Nunes Cabral C. Evaluation of cross-cultural\\nadaptation and measurement properties of breast cancer-specific quality-of-life\\nquestionnaires: a systematic review. 2015 Quality of Life Research, Volume 24,\\nIssue 5 , pp 1179-1195</p><h4></h4>","contact":"adb@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":27,"languages":[{"code":"af","name":"Afrikaans"},{"code":"am","name":"Amharic"},{"code":"ar","name":"Arabic"},{"code":"bn","name":"Bengali"},{"code":"bs","name":"Bosnian"},{"code":"bg","name":"Bulgarian"},{"code":"lang451","name":"Russian (Belarus)"},{"code":"lang452","name":"Norwegian"},{"code":"lang454","name":"Malay (Singapore)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang444","name":"Xhosa"},{"code":"lang446","name":"Tamil (Singapore)"},{"code":"lang447","name":"Tamil (Malaysia)"},{"code":"lang448","name":"Tagalog"},{"code":"lang449","name":"Sotho"},{"code":"lang435","name":"Cebuano"},{"code":"lang436","name":"Chinese Cantonese (Hong Kong)"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"lang438","name":"Chinese Mandarin (Malaysia)"},{"code":"lang439","name":"Chinese Mandarin (Singapore)"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"tr","name":"Turkish"},{"code":"uk","name":"Ukrainian"},{"code":"ur_IN","name":"Urdu (India)"},{"code":"vi","name":"Vietnamese"},{"code":"yo","name":"Yoruba"},{"code":"zu","name":"Zulu"},{"code":"es_UY","name":"Spanish (Uruguay)"},{"code":"sv","name":"Swedish"},{"code":"ta_IN","name":"Tamil (India)"},{"code":"ta_LK","name":"Tamil (Sri Lanka)"},{"code":"te","name":"Telugu"},{"code":"th","name":"Thai"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"es_PA","name":"Spanish (Panama)"},{"code":"es_PE","name":"Spanish (Peru)"},{"code":"es_PR","name":"Spanish (Puerto Rico)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"es_US","name":"Spanish (United States)"},{"code":"es_AR","name":"Spanish (Argentina)"},{"code":"es_CL","name":"Spanish (Chile)"},{"code":"es_CO","name":"Spanish (Colombia)"},{"code":"es_CR","name":"Spanish (Costa Rica)"},{"code":"es_EC","name":"Spanish (Ecuador)"},{"code":"es_GT","name":"Spanish (Guatemala)"},{"code":"ro","name":"Romanian"},{"code":"ru","name":"Russian"},{"code":"sr","name":"Serbian"},{"code":"si","name":"Sinhala"},{"code":"sk","name":"Slovak"},{"code":"sl","name":"Slovenian"},{"code":"mt","name":"Maltese"},{"code":"fa","name":"Persian"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"pa","name":"Punjabi"},{"code":"ko","name":"Korean"},{"code":"lv","name":"Latvian"},{"code":"lt","name":"Lithuanian"},{"code":"mk","name":"Macedonian"},{"code":"ms_MY","name":"Malay (Malaysia)"},{"code":"ml","name":"Malayalam"},{"code":"he","name":"Hebrew"},{"code":"hi","name":"Hindi"},{"code":"hu","name":"Hungarian"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"kn","name":"Kannada"},{"code":"fi","name":"Finnish"},{"code":"fr_CA","name":"French (Canada)"},{"code":"ka","name":"Georgian"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"gu","name":"Gujarati"},{"code":"hr","name":"Croatian"},{"code":"cs","name":"Czech"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"et","name":"Estonian"}],"createDate":"2016-02-10T12:48:34.083","updateDate":"2017-03-15T09:38:02.037"},{"rank":null,"id":1000263,"name":"copy of Bone Metastases","code":null,"type":"module","state":"draft","phase":null,"gender":"nonSpecific","chemical":"test","description":"test demo 9","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":1,"email":"adb@emakina.com","name":"Alexis Debontridder"},"questionsStartPosition":null,"numQuestions":23,"languages":[{"code":"en","name":"English"}],"createDate":"2017-05-08T10:27:13.887","updateDate":"2017-05-08T10:27:13.887"},{"rank":null,"id":1000280,"name":"copy of Cachexia","code":null,"type":"itemlist","state":"draft","phase":null,"gender":"nonSpecific","chemical":"","description":"xwcxwcwxwxc","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":1,"email":"adb@emakina.com","name":"Alexis Debontridder"},"questionsStartPosition":1,"numQuestions":25,"languages":[{"code":"en","name":"English"}],"createDate":"2021-05-28T16:37:49.067","updateDate":"2021-05-28T16:37:49.067"},{"rank":null,"id":1000274,"name":"test kwa","code":"KWA","type":"cat","state":"draft","phase":5,"gender":"nonSpecific","chemical":null,"description":"test kwa","additionalInfo":"<p>test</p>","contact":"kwa@emakina.com","isCustom":false,"author":null,"questionsStartPosition":2,"numQuestions":4,"languages":[{"code":"en","name":"English"},{"code":"fr_BE","name":"French (Belgium)"}],"createDate":"2019-04-19T10:18:12.657","updateDate":"2019-09-16T11:23:56.163"},{"rank":null,"id":1000180,"name":"Demo sprint 7","code":null,"type":"module","state":"published","phase":null,"gender":"nonSpecific","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":37,"email":"ykh@emakina.com","name":"Younes Kh\'Leeh"},"questionsStartPosition":null,"numQuestions":2,"languages":[{"code":"af","name":"Afrikaans"},{"code":"en","name":"English"}],"createDate":"2017-04-24T13:41:35.12","updateDate":"2017-05-03T12:51:48.497"},{"rank":null,"id":1000240,"name":"copy of Prostate","code":null,"type":"module","state":"draft","phase":null,"gender":"male","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":1,"email":"adb@emakina.com","name":"Alexis Debontridder"},"questionsStartPosition":null,"numQuestions":28,"languages":[{"code":"en","name":"English"}],"createDate":"2017-05-02T13:20:42.713","updateDate":"2017-05-02T13:20:42.713"},{"rank":null,"id":22,"name":"Chemo-Induced Peripheral Neuropathy","code":"CIPN","type":"module","state":null,"phase":4,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-CIPN20 Chemo-Induced Peripheral Neuropathy module</h3><p>The QLQ-CIPN20 Chemo-Induced Peripheral Neuropathy module is a questionnaire to elicit patients\' experience of symptoms and functional limitations related to CIPN. This module is to be used with the EORTC QLQ-C30 core questionnaire.<br /></p><p>The CIPN20 module is currently under phase IV. <br /></p><p><u><br /></u></p><p><u>Scale structure</u></p><ul><li>Sensory scale 31-36, 39, 40, 48</li><li>Motor scale 37, 38, 41-45, 49</li><li>Autonomic scale 46, 47, 50</li></ul><p><br /></p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":20,"languages":[{"code":"ar_MA","name":"Arabic (Morocco)"},{"code":"cs","name":"Czech"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"fi","name":"Finnish"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"},{"code":"lang457","name":"Arabic (Israel)"},{"code":"es_US","name":"Spanish (United States)"},{"code":"sv","name":"Swedish"},{"code":"th","name":"Thai"},{"code":"tr","name":"Turkish"},{"code":"uk","name":"Ukrainian"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"ru","name":"Russian"},{"code":"sk","name":"Slovak"},{"code":"sl","name":"Slovenian"},{"code":"es_AR","name":"Spanish (Argentina)"},{"code":"es_CL","name":"Spanish (Chile)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"ja","name":"Japanese"},{"code":"ko","name":"Korean"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"ro","name":"Romanian"},{"code":"fr_CA","name":"French (Canada)"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"he","name":"Hebrew"},{"code":"hu","name":"Hungarian"},{"code":"it","name":"Italian"}],"createDate":"2016-03-01T14:54:53.52","updateDate":"2016-05-17T11:37:56.7"},{"rank":null,"id":1000174,"name":"ADB Official No State","code":"ADB45","type":"module","state":"draft","phase":5,"gender":"nonSpecific","chemical":null,"description":"","additionalInfo":"<p><br /></p>","contact":"adb@emakina.com","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":4,"languages":[{"code":"sq","name":"Albanian"},{"code":"en","name":"English"},{"code":"fr","name":"French"},{"code":"lang441","name":"French (Europe)"},{"code":"lang461","name":"Jth"},{"code":"lang462","name":"Test"}],"createDate":"2017-04-21T16:42:12.37","updateDate":"2017-04-21T16:42:12.37"},{"rank":null,"id":33,"name":"Non-Hodgkin\'s Lymphoma - Low Grade","code":"NHL-LG","type":"module","state":null,"phase":3,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-NHL-LG Non-Hodgkin\'s Lymphoma - Low Grade module</h3><p>The NHL-LG module has completed phase III. </p><p>This module is to be used with the EORTC QLQ-C30 core questionnaire.<br /></p><p><br /></p><p><u>Scales</u></p><ul><li>Symptom burden 31-34</li><li>Physical condition/ Fatigue 35-38</li><li>Emotional impact 39-42<br /></li><li>Worries/fears health and functioning 43-48 and if applicable 49, 50</li></ul><p><br /></p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":20,"languages":[{"code":"ar_IQ","name":"Arabic (Iraq)"},{"code":"da","name":"Danish"},{"code":"lang441","name":"French (Europe)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"it","name":"Italian"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"de","name":"German"}],"createDate":"2016-03-02T15:31:30.21","updateDate":"2016-04-13T14:52:30.47"},{"rank":null,"id":39,"name":"Information","code":"INFO","type":"module","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-INFO25 Information module</h3><p>The QLQ-INFO25 Information module is meant for use among cancer patients in different disease sites and stages, and in any moment of the treatment and follow-up periods. </p><p>This module is to be used with the EORTC QLQ-C30 core questionnaire.</p><p>The INFO25 module is fully validated. </p><p><u><br /></u></p><p><u>Development</u><br /></p><p>Arraras JI, Greimel E, Sezer O et al. An international validation study of the EORTC QLQ-INFO25 questionnaire: An instrument to assess the information given to cancer patients. Eur J Cancer 2010; 46: 2726 –2738.</p><p><br /></p><p><u>Scale structure</u></p><ul><li>Information about the disease 31 – 34</li><li>Information about medical tests 35 - 37</li><li>Information about treatments 38 - 43</li><li>Information about other services 44 - 47</li></ul><p>Single-item Scales<br /></p><ul><li>Information about different places of care 48</li><li>Information about things you can do to help yourself 49</li><li>Written information 50</li><li>Information on CD tape / video 51</li><li>Satisfaction with the information received 52</li><li>Wish to receive more information 53</li><li>Wish you have received less information 54</li><li>Overall the information has been helpful 55</li></ul><p> </p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":25,"languages":[{"code":"ar_LB","name":"Arabic (Lebanon)"},{"code":"hr","name":"Croatian"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"sv","name":"Swedish"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"en","name":"English"},{"code":"fr_CA","name":"French (Canada)"},{"code":"de","name":"German"}],"createDate":"2016-03-03T13:51:42.99","updateDate":"2016-05-17T13:58:25.48"},{"rank":null,"id":16,"name":"Proctitis","code":"PRT","type":"module","state":null,"phase":4,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-PRT23 Radiation Proctitis module</h3><p>The QLQ-PRT23 Radiation Proctitis module is intended to assess bowel complications associated with pelvic irradiation for cancers located in the pelvic region. It is likely that the instrument will be suitable for use with non-radiation induced proctitis also.. This module is to be used with the EORTC QLQ-C30 core questionnaire.</p><p>The PRT23 is undergoing Phase IV validation.</p><p> </p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":24,"languages":[{"code":"en","name":"English"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"ru","name":"Russian"}],"createDate":"2016-03-01T08:50:53.843","updateDate":"2016-04-13T15:15:12.047"},{"rank":null,"id":1000266,"name":"test n","code":null,"type":"module","state":"draft","phase":null,"gender":"nonSpecific","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":37,"email":"ykh@emakina.com","name":"Younes Kh\'Leeh"},"questionsStartPosition":null,"numQuestions":0,"languages":[{"code":"en","name":"English"}],"createDate":"2017-06-20T14:16:54.233","updateDate":"2017-06-20T14:16:54.233"},{"rank":null,"id":45,"name":"High Dose Chemotherapy","code":"HDC","type":"module","state":null,"phase":3,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-HDC29 High-Dose Chemotherapy module</h3><p>The QLQ-HDC29 High-Dose Chemotherapy module is intended for cancer patients undergoing high-dose myeloablative treatment with haematological stem cell transplantation (allogeneic / autologous bone marrow transplantation or peripheral stem cell transplantation). It is targeted for the peri-transplant period, the time during treatment (usually in hospital) and up to 6 months after the treatment. </p><p>This module is to be used with the EORTC QLQ-C30 core questionnaire.<br /></p><p>The HDC29 module has completed phase III. </p><p><u><br /></u></p><p><u>Development</u><br /></p><p>Velikova G, Weis J, Hjermstad MJ, Kopp M, Morris P, Watson M, Sezer O; EORTC Quality of Life Group. The EORTC QLQ-HDC29: A supplementary module assessing the quality of life during and after high-dose chemotherapy and stem cell transplantation. Eur J Cancer. 2007, 43: 87-94<br /></p><p> </p><p><u>Scale structure</u></p><ul><li>Gastro-intestinal side effects 31-35</li><li>Worries / Anxiety 38, 43, 46, 53, 57</li><li>Inpatient issues 44, 45, 47</li><li>Body image 37, 34</li><li>Impact on family 48-51</li><li>Sexuality 58, 59</li></ul><p>Single-item</p><ul><li>Skin problems 36<br /></li><li>Fever 39</li><li>Urine frequency 40</li><li>Aches in bones 41</li><li>Finish things 42</li><li>Spiritual 52</li><li>Fertility 55</li><li>Regular drugs 56</li></ul><p><br /></p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":29,"languages":[{"code":"ar_AE","name":"Arabic (United Arab Emirates)"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"fr_CA","name":"French (Canada)"},{"code":"de","name":"German"},{"code":"it","name":"Italian"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"},{"code":"ja","name":"Japanese"},{"code":"ko","name":"Korean"},{"code":"ru","name":"Russian"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"es_US","name":"Spanish (United States)"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"}],"createDate":"2016-03-04T10:22:37.59","updateDate":"2016-05-17T13:50:39.883"},{"rank":null,"id":1000260,"name":"copy of Brice de nice 3","code":null,"type":"module","state":"draft","phase":null,"gender":"male","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":2,"email":"mca@emakina.com","name":"Mathieu Callewaert"},"questionsStartPosition":null,"numQuestions":6,"languages":[{"code":"en","name":"English"}],"createDate":"2017-05-04T14:30:34.423","updateDate":"2017-05-04T14:30:34.423"},{"rank":null,"id":2,"name":"Elderly","code":"ELD","type":"module","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<p></p><p>The QLQ-ELD14 Elderly Cancer Patients module is designed to address potential deficiencies of the QLQ system for cancer patients who are elderly. This module is to be used with the EORTC QLQ-C30 core questionnaire.</p><p>The ELD14 module is fully validated.</p><p><b> </b></p><p><u>Scale structure</u></p><ul><li>Mobility 31,\\n33, 34</li><li>Worries about others 36, 37</li><li>Worries 38, 39, 40</li><li>Maintaining purpose 41, 42</li><li>Burden of illness 43, 44</li><li>Joint stiffness 32</li><li>Family support 35</li></ul><p><br /></p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact cheryl.whittaker@eortc.be</p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable.</p><p></p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":14,"languages":[{"code":"bg","name":"Bulgarian"},{"code":"hr","name":"Croatian"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"es_CL","name":"Spanish (Chile)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"sv","name":"Swedish"},{"code":"tr","name":"Turkish"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"it","name":"Italian"},{"code":"ko","name":"Korean"},{"code":"lt","name":"Lithuanian"},{"code":"pl","name":"Polish"}],"createDate":"2016-02-02T11:57:27.787","updateDate":"2016-04-13T14:27:51.697"},{"rank":null,"id":1000160,"name":"Demo sprint 5","code":null,"type":"standalone","state":"draft","phase":null,"gender":"nonSpecific","chemical":"Acetylsalicyic Acid","description":"New questionnaire from other questionnaire","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":36,"email":"clb@emakina.com","name":"Clémence Braun"},"questionsStartPosition":null,"numQuestions":1,"languages":[{"code":"en","name":"English"}],"createDate":"2017-04-03T13:42:30.257","updateDate":"2017-04-03T13:44:34.48"},{"rank":null,"id":48,"name":"Lung","code":"LC","type":"module","state":null,"phase":3,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3><b>QLQ-LC29 Lung cancer module</b></h3><p>This module is to be used with the EORTC QLQ-C30 core questionnaire.</p><p>The LC29 module has completed phase III. </p><p> <br /></p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":29,"languages":[{"code":"en","name":"English"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"he","name":"Hebrew"},{"code":"it","name":"Italian"},{"code":"pl","name":"Polish"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang452","name":"Norwegian"}],"createDate":"2016-03-04T14:49:34.8","updateDate":"2016-04-13T14:36:42.333"},{"rank":null,"id":17,"name":"Pancreatic","code":"PAN","type":"module","state":null,"phase":3,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3> QLQ-PAN26 Pancreatic cancer module</h3><p>The QLQ-PAN26 Pancreatic cancer module is intended for patients at all disease stages undergoing surgical resection, palliative surgical intervention, endoscopic palliation or palliative chemotherapy. This module is to be used with the EORTC QLQ-C30 core questionnaire.<br /></p><p>The PAN26 module has completed Phase III.</p><p> <br /></p><p><u>Scale structure</u></p><ul><li>Pancreatic pain 31, 33-35</li><li>Digestive symptoms 36, 37</li><li>Altered bowel habit 46, 47</li><li>Hepatic 44, 45</li><li>Body image 48, 49</li><li>Satisfaction with health care 53, 54</li><li>Sexuality 55, 56</li></ul><p> </p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":26,"languages":[{"code":"bg","name":"Bulgarian"},{"code":"cs","name":"Czech"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"fr_CA","name":"French (Canada)"},{"code":"lang436","name":"Chinese Cantonese (Hong Kong)"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"},{"code":"lang457","name":"Arabic (Israel)"},{"code":"sk","name":"Slovak"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"es_US","name":"Spanish (United States)"},{"code":"sv","name":"Swedish"},{"code":"tr","name":"Turkish"},{"code":"uk","name":"Ukrainian"},{"code":"ko","name":"Korean"},{"code":"lt","name":"Lithuanian"},{"code":"fa","name":"Persian"},{"code":"pl","name":"Polish"},{"code":"ro","name":"Romanian"},{"code":"ru","name":"Russian"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"he","name":"Hebrew"},{"code":"hu","name":"Hungarian"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"}],"createDate":"2016-03-01T11:37:01.703","updateDate":"2016-04-13T15:11:39.843"},{"rank":null,"id":31,"name":"Non-Hodgkin\'s Lymphoma - High Grade","code":"NHL-HG","type":"module","state":null,"phase":4,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-NHL-HG Non-Hodgkin\'s Lymphoma - High Grade module</h3><p>The NHL-HG module has completed phase III. </p><p>This module is to be used with the EORTC QLQ-C30 core questionnaire.<br /></p><p><br /></p><p><u>Scales</u></p><ul><li>Symptom burden 31-37</li><li>Neuropathy 38, 39<br /></li><li>Physical condition/ Fatigue 40-44</li><li>Emotional impact 45-48<br /></li><li>Worries/fears health and functioning 49-56 and if applicable 57-59</li></ul><p><br /></p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":29,"languages":[{"code":"ar_IQ","name":"Arabic (Iraq)"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"de","name":"German"},{"code":"it","name":"Italian"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"lang441","name":"French (Europe)"}],"createDate":"2016-03-02T14:36:21.93","updateDate":"2016-04-13T14:41:57.99"},{"rank":null,"id":1000275,"name":"Test CLE","code":null,"type":"cat","state":"published","phase":null,"gender":"nonSpecific","chemical":"Molecule Name","description":"This is a test for a CAT.&nbsp;","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":62,"email":"cle@emakina.com","name":"Christophe Leemans"},"questionsStartPosition":1,"numQuestions":0,"languages":[{"code":"en","name":"English"}],"createDate":"2019-04-24T16:08:21.05","updateDate":"2019-04-24T17:47:31.867"},{"rank":null,"id":1000083,"name":"Test Module","code":"CLB","type":"module","state":null,"phase":5,"gender":"female","chemical":null,"description":null,"additionalInfo":"<h3>test</h3>","contact":"dagmara@eortc.be","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":0,"languages":[{"code":"en","name":"English"}],"createDate":"2017-03-03T10:05:31.943","updateDate":"2017-03-03T10:05:31.943"},{"rank":null,"id":1000281,"name":" bcbxvcbbb","code":null,"type":"itemlist","state":"draft","phase":null,"gender":"nonSpecific","chemical":"vbxcbx","description":"cvbxcb","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":71,"email":"alexis.debontridder+1@gmail.com","name":"adb (academic)"},"questionsStartPosition":1,"numQuestions":2,"languages":[{"code":"en","name":"English"}],"createDate":"2021-05-31T16:29:29.393","updateDate":"2021-05-31T16:29:29.393"},{"rank":null,"id":1000175,"name":"CSI waiting for approval on creation","code":null,"type":"module","state":"published","phase":null,"gender":"nonSpecific","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":27,"email":"csi@emakina.com","name":"Cédric Simon"},"questionsStartPosition":null,"numQuestions":3,"languages":[{"code":"en","name":"English"}],"createDate":"2017-04-21T16:48:24.233","updateDate":"2021-11-17T14:39:08.88"},{"rank":null,"id":34,"name":"Cervix","code":"CX","type":"module","state":null,"phase":5,"gender":"female","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-CX24 Cervix module</h3><p>The QLQ-CX24 Cervical Cancer module is meant for use among cervical cancer patients varying in disease stage and treatment modality (i.e. surgery, chemotherapy, radiotherapy, etc.). This module is to be used with the EORTC QLQ-C30 core questionnaire.<br /></p><p>The CX24 module is fully validated. </p><p><br /><u>Development</u><br /></p><p>Greimel ER, Kuljanic Vlasic K, Waldenstrom AC, et al. The European Organization for Research and Treatment of Cancer (EORTC) Quality-of-Life Questionnaire Cervical Cancer Module: EORTC QLQ-CX24. Cancer 14:1812-1822, 2006.</p><p> </p><p><u>Scale structure</u></p><p>Functional scales</p><ul><li>Body image 45-47</li><li>Sexual activity 49</li><li>Sexual enjoyment 54</li><li>Sexual/vaginal functioning 50-53</li></ul><p>Symptom scales</p><ul><li>Symptom experience 31-37, 39, 41, 43</li><li>Lymphoedema 38</li><li>Peripheral neuropathy 40</li><li>Menopausal symptoms 44</li><li>Sexual worry 48</li></ul><p> </p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party. </p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":24,"languages":[{"code":"af","name":"Afrikaans"},{"code":"af_ZA","name":"Afrikaans (South Africa)"},{"code":"ar_DZ","name":"Arabic (Algeria)"},{"code":"bn","name":"Bengali"},{"code":"hr","name":"Croatian"},{"code":"lang448","name":"Tagalog"},{"code":"lang452","name":"Norwegian"},{"code":"lang455","name":"Pangasinan"},{"code":"lang441","name":"French (Europe)"},{"code":"lang443","name":"Iloko"},{"code":"lang444","name":"Xhosa"},{"code":"lang445","name":"Tswana"},{"code":"sv","name":"Swedish"},{"code":"tr","name":"Turkish"},{"code":"zu","name":"Zulu"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"si","name":"Sinhala"},{"code":"es_CL","name":"Spanish (Chile)"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"ko","name":"Korean"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"de","name":"German"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"cs","name":"Czech"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"}],"createDate":"2016-03-03T12:37:12.717","updateDate":"2016-05-17T11:31:18.48"},{"rank":null,"id":40,"name":"Fatigue","code":"FA","type":"module","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-FA12 Cancer-related fatigue module</h3><p>The QLQ-FA12 Cancer-related fatigue module has been developed for use in all diagnoses, stages of the disease and treatment settings. It is measuring cancer related fatigue based on a multidimensional approach including physical, emotional and cognitive aspects of fatigue.</p><p>The module has been fully validated.</p><p> </p><p><u>Scale structure</u></p><ul><li>Physical fatigue 1-5</li><li>Emotional fatigue 6-8</li><li>Cognitive fatigue 9-10</li></ul><p>Single items</p><ul><li>Interference with daily life 11</li><li>Social sequelae 12</li></ul><p><br /></p><p></p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":12,"languages":[{"code":"ar_IQ","name":"Arabic (Iraq)"},{"code":"lang452","name":"Norwegian"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"sv","name":"Swedish"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"de","name":"German"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"}],"createDate":"2016-03-03T14:26:42.923","updateDate":"2017-01-03T09:52:37.993"},{"rank":null,"id":11,"name":"Testicular","code":"TC","type":"module","state":null,"phase":4,"gender":"male","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-TC26 Testicular cancer module</h3><p>The QLQ-TC26 Testicular cancer module is a questionnaire module for the assessment of quality of life in patients with testicular cancer. This module is to be used with the EORTC QLQ-C30 core questionnaire.</p><p>The TC26 module is currently under phase IV.</p><p><br /></p><p><u>Scale structure</u></p><p>Symptom scale</p><ul><li>Treatment side effects 31-38<br /></li><li>Job problems 43-44</li><li>Family problems 45</li><li>Infertility 46</li><li>Body image problems 48</li><li>Sexual problems 52-53</li></ul><p><br /></p><p>Functioning scale<br /></p><ul><li>Satisfaction with care 39-40</li><li>Future perspective 31-32</li><li>Communication 47, 51</li><li>Sexual activity 49-50</li><li>Sexual enjoyment 54-55</li><li>Satisfaction with testicular implant 56</li></ul><div><br /></div><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":26,"languages":[{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"de","name":"German"},{"code":"it","name":"Italian"},{"code":"sk","name":"Slovak"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"sv","name":"Swedish"},{"code":"lang452","name":"Norwegian"}],"createDate":"2016-02-29T09:24:18.393","updateDate":"2016-04-13T15:16:43.14"},{"rank":null,"id":1000169,"name":"demo sprint 6","code":null,"type":"module","state":"draft","phase":null,"gender":"nonSpecific","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":11,"email":"rwa@emakina.com","name":"Richardinov Popovskaïa W."},"questionsStartPosition":null,"numQuestions":5,"languages":[{"code":"en","name":"English"}],"createDate":"2017-04-18T14:14:03.613","updateDate":"2017-04-24T11:39:35.443"},{"rank":null,"id":1000249,"name":"blaaa","code":null,"type":"module","state":"waitingForApproval","phase":null,"gender":"nonSpecific","chemical":"dfdsfsd","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":2,"email":"mca@emakina.com","name":"Mathieu Callewaert"},"questionsStartPosition":null,"numQuestions":13,"languages":[{"code":"en","name":"English"}],"createDate":"2017-05-03T16:46:24.497","updateDate":"2017-05-05T16:38:24.97"},{"rank":null,"id":1000261,"name":"BB custom test","code":null,"type":"module","state":"draft","phase":null,"gender":"nonSpecific","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":20,"email":"big.brother@world.com","name":"Big Brother"},"questionsStartPosition":null,"numQuestions":1,"languages":[{"code":"en","name":"English"}],"createDate":"2017-05-05T18:37:16.32","updateDate":"2017-05-05T18:41:30.65"},{"rank":null,"id":1000092,"name":"Brice","code":"BLB","type":"cat","state":null,"phase":4,"gender":"male","chemical":null,"description":"<h3>What\'s new pussy CAT</h3><h3><img src=\\"data:image/jpeg;base64,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\\" data-filename=\\"blb.jpg\\" style=\\"color: inherit; font-family: inherit; width: 98px;\\"></h3><p></p><p><span style=\\"color: rgba(0, 0, 0, 0.870588); font-family: Roboto, RobotoDraft, Helvetica, Arial, sans-serif; font-size: 13px;\\">In the french speaking part of Belgium everyone knows that Brice Le Blévennec is a complete nerd. For about 9 years he hosted CyberCafe, a cult radio and TV show about technologies ranging from the Internet to video games, from electronic gadgets to music, from geek art to hollywood blockbusters...</span></p><br style=\\"-webkit-tap-highlight-color: transparent; color: rgba(0, 0, 0, 0.870588); font-family: Roboto, RobotoDraft, Helvetica, Arial, sans-serif; font-size: 13px;\\"><p><span style=\\"color: rgba(0, 0, 0, 0.870588); font-family: Roboto, RobotoDraft, Helvetica, Arial, sans-serif; font-size: 13px;\\">That was long ago. Now Brice is a respected business men and a serial internet entrepreneur. He is President and Chief Creative Officer at Emakina.com, belgium largest Full Service Interactive Agency (listed on Alternext since July 2006). He is also the co-founder and Chief Visionary Officer of ContactOffice, a Messenging and Collaboration ASP service. Since 2007 he is the co-founder and Chief Visionary Officer of Tunz.com, the first mobile e-wallet. In 2010 he co-founded Zingle, a Social Dating company.&nbsp;</span></p><p></p>","additionalInfo":"","contact":"blb@emakina.com","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":10,"languages":[{"code":"eu","name":"Basque"},{"code":"en","name":"English"}],"createDate":"2017-03-15T15:54:36.687","updateDate":"2017-03-15T16:06:19.393"},{"rank":null,"id":20,"name":"Cachexia","code":"CAX","type":"module","state":null,"phase":3,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-CAX24 Cachexia module</h3><p>The QLQ-CAX24 Cachexia module is a questionnaire to measure quality of life in people who have cancer cachexia. This module is to be used with the EORTC QLQ-C30 core questionnaire.<br /></p><p>The CAX24 module has completed phase III. <br /></p><p><br /></p><p><u>Scale</u><br /></p><ul><li>Food aversion 31-35</li><li>Eating &amp; weight loss worry 36-38</li><li>Eating difficulties 39-41</li><li>Loss of control 42-47</li><li>Physical decline 48-50</li><li>Single items 51-54</li></ul><p><br /></p><p><u>How to obtain the questionnaire</u></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":24,"languages":[{"code":"sq","name":"Albanian"},{"code":"en","name":"English"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"it","name":"Italian"},{"code":"pl","name":"Polish"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"sv","name":"Swedish"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"},{"code":"lang463","name":"Mca"}],"createDate":"2016-03-01T13:44:00.45","updateDate":"2016-05-17T11:22:31.997"},{"rank":null,"id":1000238,"name":"copy of Bone Metastases","code":null,"type":"module","state":"draft","phase":null,"gender":"nonSpecific","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":37,"email":"ykh@emakina.com","name":"Younes Kh\'Leeh"},"questionsStartPosition":null,"numQuestions":24,"languages":[{"code":"en","name":"English"}],"createDate":"2017-05-02T12:53:09.92","updateDate":"2017-05-02T12:53:09.92"},{"rank":null,"id":28,"name":"Communication","code":"COMU","type":"module","state":null,"phase":4,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3><b>QLQ-COMU26 Communication module</b></h3><p>The COMU26 module is currently in phase IV. </p><p>The module is to be used with the EORTC QLQ-C30 core questionnaire.<br /></p><p><u><br /></u></p><p><u>How to obtain the questionnaire</u><br /></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.  </p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":30,"numQuestions":26,"languages":[{"code":"hr","name":"Croatian"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"it","name":"Italian"},{"code":"pl","name":"Polish"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"}],"createDate":"2016-03-02T13:18:22.983","updateDate":"2017-03-10T17:01:25.887"},{"rank":null,"id":1000278,"name":"Testing questionnaires","code":null,"type":"itemlist","state":"draft","phase":null,"gender":"nonSpecific","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":69,"email":"yno@emakina.com","name":"Yasmina"},"questionsStartPosition":1,"numQuestions":1,"languages":[{"code":"en","name":"English"}],"createDate":"2021-05-03T17:43:52.217","updateDate":"2021-05-03T17:43:52.217"},{"rank":null,"id":1000086,"name":"My Core","code":"ADB","type":"core","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>Additional Info</h3><h4>Additional Info</h4><p>Additional Info</p><hr /><p><br /></p><hr /><p>Additional Info<br /><br /><br /></p>","contact":"adb@emakina.com","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":0,"languages":[{"code":"en","name":"English"}],"createDate":"2017-03-10T17:35:22.497","updateDate":"2017-03-10T17:54:28.23"},{"rank":null,"id":1000232,"name":"copy of Prostate","code":null,"type":"module","state":"waitingForApproval","phase":null,"gender":"male","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":2,"email":"mca@emakina.com","name":"Mathieu Callewaert"},"questionsStartPosition":null,"numQuestions":25,"languages":[{"code":"en","name":"English"}],"createDate":"2017-04-28T16:04:47.463","updateDate":"2017-06-06T15:42:06.657"},{"rank":null,"id":1000152,"name":"Julie JTR","code":null,"type":"module","state":"published","phase":null,"gender":"nonSpecific","chemical":"hge","description":"testest","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":37,"email":"ykh@emakina.com","name":"Younes Kh\'Leeh"},"questionsStartPosition":null,"numQuestions":2,"languages":[{"code":"ca","name":"Catalan"},{"code":"en","name":"English"},{"code":"fr_CA","name":"French (Canada)"},{"code":"lang441","name":"French (Europe)"}],"createDate":"2017-03-31T15:22:19.36","updateDate":"2017-04-21T17:11:47.47"},{"rank":null,"id":1000272,"name":"Test Item","code":null,"type":"cat","state":"draft","phase":null,"gender":"nonSpecific","chemical":"Test kwa","description":"this is a test","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":63,"email":"kwa@emakina.com","name":"Kéren"},"questionsStartPosition":3,"numQuestions":5,"languages":[{"code":"en","name":"English"}],"createDate":"2019-04-19T10:02:09.183","updateDate":"2019-04-19T10:15:35.24"},{"rank":null,"id":14,"name":"Bone Metastases","code":"BM","type":"module","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-BM22 Bone Metastases module</h3><p>The QLQ-BM22 Bone Metastases module is a questionnaire to\\nassess the health-related quality of life (QOL) in patients with bone\\nmetastases (BM).This module is to be used with the EORTC QLQ-C30 core questionnaire.<br /></p><p>The BM22 module is fully validated. </p><p><br /><u>Development</u><br /></p>\\n\\n<p>Chow, E, Nguyen J,\\nTseng ZL, Ling-Ming H, Ming-Feng H, Fairchild A, Alysa Vassiliou Vassilios A,\\nJesus-Garcia R, Alm El-Din Mohamed A., Aswin Forges K, Chie F, Wei-Chu W,\\nBottomley A; On behalf of the European Organisation for Research Treatment of\\nCancer; Quality of Life Group. International Field Testing of the Reliability\\nand Validity of the EORTC QLQ-BM22 Module to Assess Health-Related Quality of\\nLife in Patients With Bone Metastases; Cancer, 2012 Mar 1;118(5):1457-65. doi:\\n10.1002/cncr.26410</p>\\n\\n<p> </p>\\n\\n<p><u>Scale structure</u></p>\\n\\n<p>Symptom scales / items</p>\\n\\n<ul>\\n <li>Painful sites 31-35</li>\\n <li>Pain characteristics 36-38</li>\\n</ul>\\n\\n<p>Functional scales</p>\\n\\n<ul>\\n <li>Functional interference 39-46</li>\\n <li>Psychosocial aspects 47-52</li>\\n</ul>\\n\\n<p> </p>\\n\\n<p><u>How to obtain the questionnaire</u></p>\\n\\n<p>The EORTC has two\\npolicies for the use of the QLQ-C30 and associated modules.</p>\\n\\n<p><b>Commercial users</b>(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p>\\n\\n<p>What is classed as<b> ‘academic’\\nresearch</b>(2) – for educational institutions, hospitals, etc - No fee:\\nquestionnaires can be downloaded from the EORTC website</p>\\n\\n<p> </p>\\n\\n<p>(1) If an\\norganization, institution or company is being provided with or providing funds,\\nsponsorship or a grant for their research, and should any of these gain\\nfinancially or use the measures for commercial purposes, then a fee is\\nchargeable. </p>\\n\\n<p>(2) The only time a\\nfee is not chargeable is if the study is purely for academic use and there is\\nno financial gain by any party.  </p>\\n\\n<p> </p>\\n\\n<p><u>Other publications on the questionnaire</u></p>\\n\\n<p>Chow E, Nguyen J,\\nZhang L, Tseng L-M, Hou M-F, Fairchild A, Vassiliou V, Reynaldo J-G, Alm El-Din\\nM A, Kumar A, Forges F, Chie W-C, Bottomley A. International Field Testing of\\nthe Reliability and Validity of the EORTC QLQ-BM22 Module to Assess Health-Related\\nQuality of Life in Patients With Bone Metastases. 2011, Wiley Online Library.</p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":23,"languages":[{"code":"ar","name":"Arabic"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"fr_CA","name":"French (Canada)"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"th","name":"Thai"},{"code":"lang436","name":"Chinese Cantonese (Hong Kong)"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"es_AR","name":"Spanish (Argentina)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"es_US","name":"Spanish (United States)"},{"code":"sv","name":"Swedish"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"ko","name":"Korean"},{"code":"ml","name":"Malayalam"},{"code":"fa","name":"Persian"},{"code":"pl","name":"Polish"}],"createDate":"2016-02-29T15:14:51.83","updateDate":"2016-06-29T11:55:48.423"},{"rank":null,"id":37,"name":"Lung","code":"LC13","type":"previous","state":null,"phase":5,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3> QLQ-LC13 Lung cancer module</h3><p>The QLQ-LC13 was a fully validated module used in conjunction with the QLQ-C30 questionnaire. It was replaced with the QLQ-LC29.</p><p><u><br /></u></p><p><u>Development</u><br /></p><p>Bergman B et al.\\nThe EORTC QLQ-LC13: a Modular Supplement to the EORTC Core Quality of Life\\nQuestionnaire (QLQ-C30) for Use in Lung Cancer Clinical Trials.  <i>Eur J\\nCancer</i> 30A:635-642, 1994.</p><p> </p><p><u>Scale structure</u></p><p>Symptom scales / items</p><ul><li>Dyspnoea 33-35</li><li>Coughing 31<br /></li><li>Haemoptysis 32</li><li>Sore mouth 36</li><li>Dysphagia 37</li><li>Peripheral neuropathy 38</li><li>Alopecia 39</li><li>Pain in chest 40</li><li>Pain in arm or shoulder 41</li><li>Pain in other parts 42</li><li>Pain medication 43</li></ul><p><br /></p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":13,"languages":[{"code":"af","name":"Afrikaans"},{"code":"ar","name":"Arabic"},{"code":"bn","name":"Bengali"},{"code":"bs","name":"Bosnian"},{"code":"bg","name":"Bulgarian"},{"code":"hr","name":"Croatian"},{"code":"lang446","name":"Tamil (Singapore)"},{"code":"lang447","name":"Tamil (Malaysia)"},{"code":"lang448","name":"Tagalog"},{"code":"lang449","name":"Sotho"},{"code":"lang452","name":"Norwegian"},{"code":"lang454","name":"Malay (Singapore)"},{"code":"lang438","name":"Chinese Mandarin (Malaysia)"},{"code":"lang439","name":"Chinese Mandarin (Singapore)"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"lang443","name":"Iloko"},{"code":"lang444","name":"Xhosa"},{"code":"ur_PK","name":"Urdu (Pakistan)"},{"code":"vi","name":"Vietnamese"},{"code":"zu","name":"Zulu"},{"code":"lang435","name":"Cebuano"},{"code":"lang436","name":"Chinese Cantonese (Hong Kong)"},{"code":"lang437","name":"Chinese Mandarin (China)"},{"code":"sv","name":"Swedish"},{"code":"ta_IN","name":"Tamil (India)"},{"code":"te","name":"Telugu"},{"code":"th","name":"Thai"},{"code":"tr","name":"Turkish"},{"code":"uk","name":"Ukrainian"},{"code":"es_CO","name":"Spanish (Colombia)"},{"code":"es_MX","name":"Spanish (Mexico)"},{"code":"es_PE","name":"Spanish (Peru)"},{"code":"es_PR","name":"Spanish (Puerto Rico)"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"es_US","name":"Spanish (United States)"},{"code":"sr","name":"Serbian"},{"code":"si","name":"Sinhala"},{"code":"sk","name":"Slovak"},{"code":"sl","name":"Slovenian"},{"code":"es_AR","name":"Spanish (Argentina)"},{"code":"es_CL","name":"Spanish (Chile)"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"pa","name":"Punjabi"},{"code":"ro","name":"Romanian"},{"code":"ru","name":"Russian"},{"code":"lv","name":"Latvian"},{"code":"lt","name":"Lithuanian"},{"code":"ms_MY","name":"Malay (Malaysia)"},{"code":"ml","name":"Malayalam"},{"code":"mr","name":"Marathi"},{"code":"fa","name":"Persian"},{"code":"hu","name":"Hungarian"},{"code":"id","name":"Indonesian"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"kn","name":"Kannada"},{"code":"ko","name":"Korean"},{"code":"fr_CA","name":"French (Canada)"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"gu","name":"Gujarati"},{"code":"he","name":"Hebrew"},{"code":"hi","name":"Hindi"},{"code":"cs","name":"Czech"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"et","name":"Estonian"},{"code":"fi","name":"Finnish"}],"createDate":"2016-03-03T13:30:53.053","updateDate":"2016-06-22T15:09:46.233"},{"rank":null,"id":8,"name":"Sexual Health","code":"SHQ-C","type":"standalone","state":null,"phase":3,"gender":"nonSpecific","chemical":null,"description":null,"additionalInfo":"<h3>QLQ-SHQ-C22 Sexual Health questionnaire</h3><p>The SHQ-C22 questionnaire has completed phase III.</p><p>It is a stand-alone questionnaire.<br /></p><p><u><br /></u></p><p><u>How to obtain the questionnaire</u><br /></p><p>The EORTC has two policies for the use of the QLQ-C30 and associated modules.</p><p>Commercial users(1) - Royalty fee: please contact <a href=\\"mailto:cheryl.whittaker@eortc.be\\">cheryl.whittaker@eortc.be</a></p><p>What is classed as ‘academic’ research(2) – for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website</p><p> </p><p>(1) If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable. </p><p>(2) The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.  </p>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":22,"languages":[{"code":"hr","name":"Croatian"},{"code":"da","name":"Danish"},{"code":"nl","name":"Dutch"},{"code":"en","name":"English"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"lang452","name":"Norwegian"},{"code":"it","name":"Italian"},{"code":"pl","name":"Polish"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"sv","name":"Swedish"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"}],"createDate":"2016-02-18T09:33:14.167","updateDate":"2016-06-02T13:01:58.507"},{"rank":null,"id":1000258,"name":"copy of Brice","code":null,"type":"module","state":"draft","phase":null,"gender":"male","chemical":"","description":"","additionalInfo":null,"contact":null,"isCustom":true,"author":{"id":1,"email":"adb@emakina.com","name":"Alexis Debontridder"},"questionsStartPosition":null,"numQuestions":12,"languages":[{"code":"en","name":"English"}],"createDate":"2017-05-04T14:23:37.76","updateDate":"2017-05-04T14:23:37.76"}]');
;// CONCATENATED MODULE: ./src/mocks/questionnaires/getSummaries/index.ts




/* harmony default export */ function questionnaires_getSummaries() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.get(resolvePath(getSummaries/* default */.Z), function(req, res, ctx) {
            var kind = req.url.searchParams.get('kind');
            return res(ctx.delay(delay), ctx.status(200), ctx.json(questionnaires_namespaceObject.filter(function(q) {
                return kind === null || !!parseInt(kind) === q.isCustom;
            })));
        }), 
    ];
};

// EXTERNAL MODULE: ./src/consts/paths/api/items/getCategories/index.ts
var getCategories = __webpack_require__(62019);
;// CONCATENATED MODULE: ./src/mocks/items/categories/index.tsx



/* harmony default export */ function categories() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 0 : _delay;
    return [
        rest.get(resolvePath(getCategories/* default */.Z), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), // XXL data
            ctx.json([
                {
                    categoryId: 1,
                    categoryName: 'Activities of Daily Living',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 10,
                            code: 'Q7',
                            description: 'RF08 limit work daily activities',
                            categoryId: 1
                        },
                        {
                            itemId: 67,
                            code: 'Q53',
                            description: 'urinary problems daily activities',
                            categoryId: 1
                        },
                        {
                            itemId: 68,
                            code: 'Q54',
                            description: 'bowel problems daily activities',
                            categoryId: 1
                        },
                        {
                            itemId: 266,
                            code: 'Q206',
                            description: 'modify daily activities',
                            categoryId: 1
                        },
                        {
                            itemId: 369,
                            code: 'Q298',
                            description: 'worry change daily life',
                            categoryId: 1
                        },
                        {
                            itemId: 371,
                            code: 'Q300',
                            description: 'problem usual activities weight loss',
                            categoryId: 1
                        },
                        {
                            itemId: 412,
                            code: 'Q339',
                            description: 'activities limited vision',
                            categoryId: 1
                        },
                        {
                            itemId: 420,
                            code: 'Q346',
                            description: 'problem driving daylight',
                            categoryId: 1
                        },
                        {
                            itemId: 421,
                            code: 'Q347',
                            description: 'problem driving dark ',
                            categoryId: 1
                        },
                        {
                            itemId: 458,
                            code: 'Q381',
                            description: 'problem carry usual activities tired',
                            categoryId: 1
                        },
                        {
                            itemId: 616,
                            code: 'Q520',
                            description: 'tired interference daily activities',
                            categoryId: 1
                        },
                        {
                            itemId: 658,
                            code: 'Q555',
                            description: 'drug intake interference daily life',
                            categoryId: 1
                        },
                        {
                            itemId: 707,
                            code: 'Q594',
                            description: 'scar pain daily activities',
                            categoryId: 1
                        },
                        {
                            itemId: 800,
                            code: 'Q675',
                            description: 'RF04 need help work daily activity',
                            categoryId: 1
                        }, 
                    ]
                },
                {
                    categoryId: 2,
                    categoryName: 'Basic ADL',
                    parentId: 1,
                    parentCategoryName: 'Activities of Daily Living',
                    items: [
                        {
                            itemId: 18,
                            code: 'Q9',
                            description: 'PF05 help with daily living',
                            categoryId: 2
                        },
                        {
                            itemId: 753,
                            code: 'Q628',
                            description: 'PF03 need help footcare',
                            categoryId: 2
                        },
                        {
                            itemId: 755,
                            code: 'Q630',
                            description: 'PF06 help grooming',
                            categoryId: 2
                        },
                        {
                            itemId: 759,
                            code: 'Q634',
                            description: 'PF10',
                            categoryId: 2
                        },
                        {
                            itemId: 762,
                            code: 'Q637',
                            description: 'PF14 need help put on shirt',
                            categoryId: 2
                        },
                        {
                            itemId: 767,
                            code: 'Q642',
                            description: 'PF21 need help wash face hands',
                            categoryId: 2
                        },
                        {
                            itemId: 772,
                            code: 'Q647',
                            description: 'PF27 need help undress',
                            categoryId: 2
                        },
                        {
                            itemId: 774,
                            code: 'Q649',
                            description: 'PF28 need help eat',
                            categoryId: 2
                        },
                        {
                            itemId: 872,
                            code: 'Q746',
                            description: 'FA32 exhausted dress',
                            categoryId: 2
                        },
                        {
                            itemId: 874,
                            code: 'Q748',
                            description: 'FA34 exhausted shower',
                            categoryId: 2
                        },
                        {
                            itemId: 918,
                            code: 'Q792',
                            description: 'DY01 short breath wash',
                            categoryId: 2
                        },
                        {
                            itemId: 932,
                            code: 'Q806',
                            description: 'DY16 short breath dress',
                            categoryId: 2
                        },
                        {
                            itemId: 1098,
                            code: 'Q857',
                            description: 'clean oneself',
                            categoryId: 2
                        }, 
                    ]
                },
                {
                    categoryId: 3,
                    categoryName: 'Instrumental ADL',
                    parentId: 1,
                    parentCategoryName: 'Activities of Daily Living',
                    items: [
                        {
                            itemId: 49,
                            code: 'Q37',
                            description: 'help with chores',
                            categoryId: 3
                        },
                        {
                            itemId: 629,
                            code: 'Q529',
                            description: 'limited travel',
                            categoryId: 3
                        },
                        {
                            itemId: 797,
                            code: 'Q672',
                            description: 'RF01 limit household tasks',
                            categoryId: 3
                        },
                        {
                            itemId: 798,
                            code: 'Q673',
                            description: 'RF02 limit light housework',
                            categoryId: 3
                        },
                        {
                            itemId: 802,
                            code: 'Q677',
                            description: 'RF06 limit repairs maintenance',
                            categoryId: 3
                        },
                        {
                            itemId: 803,
                            code: 'Q678',
                            description: 'RF07 limit finances',
                            categoryId: 3
                        },
                        {
                            itemId: 804,
                            code: 'Q679',
                            description: 'RF09 limit heavy household',
                            categoryId: 3
                        },
                        {
                            itemId: 859,
                            code: 'Q733',
                            description: 'FA12 shopping exhausting',
                            categoryId: 3
                        }, 
                    ]
                },
                {
                    categoryId: 4,
                    categoryName: 'Body Image',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 1,
                            code: 'Q1',
                            description: 'less masculine',
                            categoryId: 4
                        },
                        {
                            itemId: 130,
                            code: 'Q95',
                            description: 'problem appearance',
                            categoryId: 4
                        },
                        {
                            itemId: 148,
                            code: 'Q109',
                            description: 'less feminine',
                            categoryId: 4
                        },
                        {
                            itemId: 169,
                            code: 'Q128',
                            description: 'physically less attractive',
                            categoryId: 4
                        },
                        {
                            itemId: 170,
                            code: 'Q129',
                            description: 'problems look naked',
                            categoryId: 4
                        },
                        {
                            itemId: 171,
                            code: 'Q130',
                            description: 'dissatisfied body',
                            categoryId: 4
                        },
                        {
                            itemId: 248,
                            code: 'Q189',
                            description: 'less feminine/masculine ',
                            categoryId: 4
                        },
                        {
                            itemId: 323,
                            code: 'Q260',
                            description: 'feel less sexually attractive',
                            categoryId: 4
                        },
                        {
                            itemId: 327,
                            code: 'Q264',
                            description: 'satisfied size breast',
                            categoryId: 4
                        },
                        {
                            itemId: 328,
                            code: 'Q265',
                            description: 'satisfied shape breast',
                            categoryId: 4
                        },
                        {
                            itemId: 329,
                            code: 'Q266',
                            description: 'satisfied skin appearance breast',
                            categoryId: 4
                        },
                        {
                            itemId: 330,
                            code: 'Q267',
                            description: 'satisfied symmetry breasts',
                            categoryId: 4
                        },
                        {
                            itemId: 331,
                            code: 'Q268',
                            description: 'satisfied cleavage',
                            categoryId: 4
                        },
                        {
                            itemId: 333,
                            code: 'Q270',
                            description: 'satisfied appearance nipple',
                            categoryId: 4
                        },
                        {
                            itemId: 335,
                            code: 'Q272',
                            description: 'satisfied scars appearance breast',
                            categoryId: 4
                        },
                        {
                            itemId: 337,
                            code: 'Q274',
                            description: 'satisfied breast reconstruction result ',
                            categoryId: 4
                        },
                        {
                            itemId: 341,
                            code: 'Q278',
                            description: 'satisfied scars appearance',
                            categoryId: 4
                        },
                        {
                            itemId: 342,
                            code: 'Q279',
                            description: 'problem loss of nipple',
                            categoryId: 4
                        },
                        {
                            itemId: 367,
                            code: 'Q296',
                            description: 'worry appearance',
                            categoryId: 4
                        },
                        {
                            itemId: 398,
                            code: 'Q325',
                            description: 'dissatisfied cosmetic surgery',
                            categoryId: 4
                        },
                        {
                            itemId: 501,
                            code: 'Q415',
                            description: 'lack confidence body',
                            categoryId: 4
                        },
                        {
                            itemId: 613,
                            code: 'Q517',
                            description: 'lack self confidence',
                            categoryId: 4
                        },
                        {
                            itemId: 643,
                            code: 'Q543',
                            description: 'worry appearance abdomen',
                            categoryId: 4
                        },
                        {
                            itemId: 789,
                            code: 'Q664',
                            description: 'EF14 lose interest appearance',
                            categoryId: 4
                        },
                        {
                            itemId: 1227,
                            code: 'Q915',
                            description: 'satisfied cosmetic result surgery',
                            categoryId: 4
                        }, 
                    ]
                },
                {
                    categoryId: 5,
                    categoryName: 'Bones, Muscles, & Joints',
                    parentId: null,
                    parentCategoryName: null,
                    items: []
                },
                {
                    categoryId: 6,
                    categoryName: 'Muscle weakness',
                    parentId: 5,
                    parentCategoryName: 'Bones, Muscles, & Joints',
                    items: [
                        {
                            itemId: 405,
                            code: 'Q332',
                            description: 'problem open weak hands',
                            categoryId: 6
                        },
                        {
                            itemId: 408,
                            code: 'Q335',
                            description: 'problem stairs chair weak legs',
                            categoryId: 6
                        },
                        {
                            itemId: 411,
                            code: 'Q338',
                            description: 'problem use pedals',
                            categoryId: 6
                        },
                        {
                            itemId: 429,
                            code: 'Q355',
                            description: ' muscle weakness',
                            categoryId: 6
                        }, 
                    ]
                },
                {
                    categoryId: 7,
                    categoryName: 'Myalgia',
                    parentId: 5,
                    parentCategoryName: 'Bones, Muscles, & Joints',
                    items: [
                        {
                            itemId: 392,
                            code: 'Q321',
                            description: 'cramps hands',
                            categoryId: 7
                        },
                        {
                            itemId: 393,
                            code: 'Q322',
                            description: 'cramps feet',
                            categoryId: 7
                        },
                        {
                            itemId: 456,
                            code: 'Q379',
                            description: 'muscle cramps',
                            categoryId: 7
                        }, 
                    ]
                },
                {
                    categoryId: 8,
                    categoryName: 'Bowel',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 68,
                            code: 'Q54',
                            description: 'bowel problems daily activities',
                            categoryId: 8
                        },
                        {
                            itemId: 287,
                            code: 'Q227',
                            description: 'pain cramp rectum',
                            categoryId: 8
                        },
                        {
                            itemId: 288,
                            code: 'Q228',
                            description: 'pain discomfort anus',
                            categoryId: 8
                        },
                        {
                            itemId: 292,
                            code: 'Q232',
                            description: 'unable empty bowels',
                            categoryId: 8
                        },
                        {
                            itemId: 294,
                            code: 'Q234',
                            description: 'wear incontinence aid',
                            categoryId: 8
                        },
                        {
                            itemId: 295,
                            code: 'Q235',
                            description: 'restricted types food bowel problems',
                            categoryId: 8
                        },
                        {
                            itemId: 296,
                            code: 'Q236',
                            description: 'worry bowel problem',
                            categoryId: 8
                        },
                        {
                            itemId: 297,
                            code: 'Q237',
                            description: 'embarrassed bowel problem',
                            categoryId: 8
                        },
                        {
                            itemId: 300,
                            code: 'Q240',
                            description: 'unhappy rest life bowel habit',
                            categoryId: 8
                        },
                        {
                            itemId: 306,
                            code: 'Q244',
                            description: 'assistance manage bowel problem',
                            categoryId: 8
                        },
                        {
                            itemId: 317,
                            code: 'Q254',
                            description: 'frequent bowel movements',
                            categoryId: 8
                        },
                        {
                            itemId: 318,
                            code: 'Q255',
                            description: 'urge bowel movement',
                            categoryId: 8
                        },
                        {
                            itemId: 353,
                            code: 'Q282',
                            description: 'change bowel habit',
                            categoryId: 8
                        },
                        {
                            itemId: 517,
                            code: 'Q431',
                            description: 'pain buttock anal area rectum',
                            categoryId: 8
                        },
                        {
                            itemId: 519,
                            code: 'Q433',
                            description: 'stool mucus',
                            categoryId: 8
                        },
                        {
                            itemId: 524,
                            code: 'Q435',
                            description: 'stoma bag',
                            categoryId: 8
                        },
                        {
                            itemId: 527,
                            code: 'Q437',
                            description: 'stoma leak stools',
                            categoryId: 8
                        },
                        {
                            itemId: 529,
                            code: 'Q439',
                            description: 'stoma frequent change day',
                            categoryId: 8
                        },
                        {
                            itemId: 535,
                            code: 'Q445',
                            description: 'sore skin anal area',
                            categoryId: 8
                        },
                        {
                            itemId: 536,
                            code: 'Q446',
                            description: 'bowel movement frequent day',
                            categoryId: 8
                        },
                        {
                            itemId: 538,
                            code: 'Q448',
                            description: 'embarrassed bowel movement',
                            categoryId: 8
                        },
                        {
                            itemId: 584,
                            code: 'Q490',
                            description: 'hurry toilet stools urge',
                            categoryId: 8
                        },
                        {
                            itemId: 1236,
                            code: 'Q924',
                            description: 'change bowel movements',
                            categoryId: 8
                        },
                        {
                            itemId: 1296,
                            code: 'Q957',
                            description: 'loose fatty stools',
                            categoryId: 8
                        },
                        {
                            itemId: 1297,
                            code: 'Q958',
                            description: 'dark red black stools',
                            categoryId: 8
                        }, 
                    ]
                },
                {
                    categoryId: 9,
                    categoryName: 'Blood in stools',
                    parentId: 8,
                    parentCategoryName: 'Bowel',
                    items: [
                        {
                            itemId: 70,
                            code: 'Q55',
                            description: 'blood in stools',
                            categoryId: 9
                        },
                        {
                            itemId: 289,
                            code: 'Q229',
                            description: 'bright blood stools',
                            categoryId: 9
                        },
                        {
                            itemId: 290,
                            code: 'Q230',
                            description: 'dark blood clots stools',
                            categoryId: 9
                        }, 
                    ]
                },
                {
                    categoryId: 10,
                    categoryName: 'Constipation',
                    parentId: 8,
                    parentCategoryName: 'Bowel',
                    items: [
                        {
                            itemId: 30,
                            code: 'Q19',
                            description: 'CO09 constipation',
                            categoryId: 10
                        },
                        {
                            itemId: 949,
                            code: 'Q823',
                            description: 'CO01 need BM cannot',
                            categoryId: 10
                        },
                        {
                            itemId: 950,
                            code: 'Q824',
                            description: 'CO02 hard stools',
                            categoryId: 10
                        },
                        {
                            itemId: 951,
                            code: 'Q825',
                            description: 'CO03 too hard stools',
                            categoryId: 10
                        },
                        {
                            itemId: 953,
                            code: 'Q827',
                            description: 'CO05 strain 10 min BM',
                            categoryId: 10
                        },
                        {
                            itemId: 954,
                            code: 'Q828',
                            description: 'CO06 press pass stool',
                            categoryId: 10
                        },
                        {
                            itemId: 955,
                            code: 'Q829',
                            description: 'CO07 not finish BM',
                            categoryId: 10
                        },
                        {
                            itemId: 956,
                            code: 'Q830',
                            description: 'CO08 finger pass stool',
                            categoryId: 10
                        },
                        {
                            itemId: 957,
                            code: 'Q831',
                            description: 'CO10 unwell',
                            categoryId: 10
                        }, 
                    ]
                },
                {
                    categoryId: 11,
                    categoryName: 'Diarrhea',
                    parentId: 8,
                    parentCategoryName: 'Bowel',
                    items: [
                        {
                            itemId: 31,
                            code: 'Q20',
                            description: 'DI12 diarrhea',
                            categoryId: 11
                        },
                        {
                            itemId: 291,
                            code: 'Q231',
                            description: 'unable wait bowel movement',
                            categoryId: 11
                        },
                        {
                            itemId: 293,
                            code: 'Q233',
                            description: 'passing water open bowels',
                            categoryId: 11
                        },
                        {
                            itemId: 302,
                            code: 'Q242',
                            description: 'medication diarrhoea',
                            categoryId: 11
                        },
                        {
                            itemId: 304,
                            code: 'Q243',
                            description: 'highest number bowel movement',
                            categoryId: 11
                        },
                        {
                            itemId: 958,
                            code: 'Q832',
                            description: 'DI01 wear pad',
                            categoryId: 11
                        },
                        {
                            itemId: 959,
                            code: 'Q833',
                            description: 'DI02 3 BM liquid stools',
                            categoryId: 11
                        },
                        {
                            itemId: 960,
                            code: 'Q834',
                            description: 'DI03 severe toilet several times',
                            categoryId: 11
                        },
                        {
                            itemId: 961,
                            code: 'Q835',
                            description: 'DI04 leakage liquid stools',
                            categoryId: 11
                        },
                        {
                            itemId: 962,
                            code: 'Q836',
                            description: 'DI05 sever DI reach toilet',
                            categoryId: 11
                        },
                        {
                            itemId: 964,
                            code: 'Q838',
                            description: 'DI07 distress DI',
                            categoryId: 11
                        },
                        {
                            itemId: 965,
                            code: 'Q839',
                            description: 'DI08 liquid watery stools',
                            categoryId: 11
                        },
                        {
                            itemId: 966,
                            code: 'Q840',
                            description: 'DI09 discomfort DI',
                            categoryId: 11
                        },
                        {
                            itemId: 967,
                            code: 'Q841',
                            description: 'DI10 worry far toilet DI',
                            categoryId: 11
                        }, 
                    ]
                },
                {
                    categoryId: 12,
                    categoryName: 'Fecal incontinence',
                    parentId: 8,
                    parentCategoryName: 'Bowel',
                    items: [
                        {
                            itemId: 110,
                            code: 'Q86',
                            description: 'worry incontinent',
                            categoryId: 12
                        },
                        {
                            itemId: 276,
                            code: 'Q216',
                            description: 'release liquid stools',
                            categoryId: 12
                        },
                        {
                            itemId: 534,
                            code: 'Q444',
                            description: 'leakage stools back passage',
                            categoryId: 12
                        },
                        {
                            itemId: 541,
                            code: 'Q451',
                            description: 'problem control bowels',
                            categoryId: 12
                        },
                        {
                            itemId: 586,
                            code: 'Q492',
                            description: 'leak stools',
                            categoryId: 12
                        },
                        {
                            itemId: 1093,
                            code: 'Q852',
                            description: 'leak stools mucus anus',
                            categoryId: 12
                        }, 
                    ]
                },
                {
                    categoryId: 13,
                    categoryName: 'Flatulence/gas',
                    parentId: 8,
                    parentCategoryName: 'Bowel',
                    items: []
                },
                {
                    categoryId: 14,
                    categoryName: 'Breast',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 177,
                            code: 'Q134',
                            description: 'pain area affected breast',
                            categoryId: 14
                        },
                        {
                            itemId: 178,
                            code: 'Q135',
                            description: 'swollen area affected breast',
                            categoryId: 14
                        },
                        {
                            itemId: 180,
                            code: 'Q137',
                            description: 'skin problems area affected breast',
                            categoryId: 14
                        },
                        {
                            itemId: 321,
                            code: 'Q258',
                            description: 'problem fullness arm',
                            categoryId: 14
                        },
                        {
                            itemId: 325,
                            code: 'Q262',
                            description: 'breast role sexuality',
                            categoryId: 14
                        },
                        {
                            itemId: 326,
                            code: 'Q263',
                            description: 'problem loss sensations breast',
                            categoryId: 14
                        }, 
                    ]
                },
                {
                    categoryId: 15,
                    categoryName: 'Breast reconstruction',
                    parentId: 14,
                    parentCategoryName: 'Breast',
                    items: [
                        {
                            itemId: 327,
                            code: 'Q264',
                            description: 'satisfied size breast',
                            categoryId: 15
                        },
                        {
                            itemId: 328,
                            code: 'Q265',
                            description: 'satisfied shape breast',
                            categoryId: 15
                        },
                        {
                            itemId: 329,
                            code: 'Q266',
                            description: 'satisfied skin appearance breast',
                            categoryId: 15
                        },
                        {
                            itemId: 330,
                            code: 'Q267',
                            description: 'satisfied symmetry breasts',
                            categoryId: 15
                        },
                        {
                            itemId: 331,
                            code: 'Q268',
                            description: 'satisfied cleavage',
                            categoryId: 15
                        },
                        {
                            itemId: 332,
                            code: 'Q269',
                            description: 'satisfied softness breast',
                            categoryId: 15
                        },
                        {
                            itemId: 333,
                            code: 'Q270',
                            description: 'satisfied appearance nipple',
                            categoryId: 15
                        },
                        {
                            itemId: 335,
                            code: 'Q272',
                            description: 'satisfied scars appearance breast',
                            categoryId: 15
                        },
                        {
                            itemId: 337,
                            code: 'Q274',
                            description: 'satisfied breast reconstruction result ',
                            categoryId: 15
                        },
                        {
                            itemId: 338,
                            code: 'Q275',
                            description: 'coming to terms breast reconstruction',
                            categoryId: 15
                        },
                        {
                            itemId: 339,
                            code: 'Q276',
                            description: 'tightness breast',
                            categoryId: 15
                        },
                        {
                            itemId: 340,
                            code: 'Q277',
                            description: 'numb breast',
                            categoryId: 15
                        },
                        {
                            itemId: 341,
                            code: 'Q278',
                            description: 'satisfied scars appearance',
                            categoryId: 15
                        },
                        {
                            itemId: 342,
                            code: 'Q279',
                            description: 'problem loss of nipple',
                            categoryId: 15
                        },
                        {
                            itemId: 343,
                            code: 'Q280',
                            description: 'coming to terms nipple preservation/reconstruction',
                            categoryId: 15
                        }, 
                    ]
                },
                {
                    categoryId: 16,
                    categoryName: 'Cardiovascular',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 510,
                            code: 'Q424',
                            description: 'worry damage heart blood vessels',
                            categoryId: 16
                        },
                        {
                            itemId: 608,
                            code: 'Q512',
                            description: 'vulnerable veins',
                            categoryId: 16
                        },
                        {
                            itemId: 626,
                            code: 'Q526',
                            description: 'problem repeated injections',
                            categoryId: 16
                        },
                        {
                            itemId: 654,
                            code: 'Q551',
                            description: 'worry blood recover',
                            categoryId: 16
                        },
                        {
                            itemId: 1244,
                            code: 'Q932',
                            description: 'palpitations',
                            categoryId: 16
                        },
                        {
                            itemId: 1262,
                            code: 'Q947',
                            description: 'rapid heartbeat',
                            categoryId: 16
                        }, 
                    ]
                },
                {
                    categoryId: 17,
                    categoryName: 'Cognitive Functioning',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 612,
                            code: 'Q516',
                            description: 'problem think clearly',
                            categoryId: 17
                        },
                        {
                            itemId: 614,
                            code: 'Q518',
                            description: 'feel confused',
                            categoryId: 17
                        },
                        {
                            itemId: 615,
                            code: 'Q519',
                            description: 'problem finish things',
                            categoryId: 17
                        },
                        {
                            itemId: 830,
                            code: 'Q705',
                            description: 'CF28 problems gather thoughts',
                            categoryId: 17
                        }, 
                    ]
                },
                {
                    categoryId: 18,
                    categoryName: 'Concentration',
                    parentId: 17,
                    parentCategoryName: 'Cognitive Functioning',
                    items: [
                        {
                            itemId: 34,
                            code: 'Q23',
                            description: 'CF11 problems concentrate',
                            categoryId: 18
                        },
                        {
                            itemId: 806,
                            code: 'Q681',
                            description: 'CF02 distracted thoughts',
                            categoryId: 18
                        },
                        {
                            itemId: 815,
                            code: 'Q690',
                            description: 'CF12 distracted read',
                            categoryId: 18
                        },
                        {
                            itemId: 816,
                            code: 'Q691',
                            description: 'CF14 problems concentrate interested',
                            categoryId: 18
                        },
                        {
                            itemId: 824,
                            code: 'Q699',
                            description: 'CF22 distracted task finish',
                            categoryId: 18
                        },
                        {
                            itemId: 828,
                            code: 'Q703',
                            description: 'CF26 problems focus important',
                            categoryId: 18
                        },
                        {
                            itemId: 836,
                            code: 'Q711',
                            description: 'CF34 problems focus task',
                            categoryId: 18
                        }, 
                    ]
                },
                {
                    categoryId: 19,
                    categoryName: 'Memory',
                    parentId: 17,
                    parentCategoryName: 'Cognitive Functioning',
                    items: [
                        {
                            itemId: 39,
                            code: 'Q28',
                            description: ' CF13 problems remember',
                            categoryId: 19
                        },
                        {
                            itemId: 807,
                            code: 'Q682',
                            description: 'CF03 problems remember date',
                            categoryId: 19
                        },
                        {
                            itemId: 808,
                            code: 'Q683',
                            description: 'CF04 problems remember told',
                            categoryId: 19
                        },
                        {
                            itemId: 809,
                            code: 'Q684',
                            description: 'CF05 problems remember say talk',
                            categoryId: 19
                        },
                        {
                            itemId: 810,
                            code: 'Q685',
                            description: 'CF06 problems remember happen',
                            categoryId: 19
                        },
                        {
                            itemId: 811,
                            code: 'Q686',
                            description: 'CF07 walk forget',
                            categoryId: 19
                        },
                        {
                            itemId: 812,
                            code: 'Q687',
                            description: 'CF08 problems remember names',
                            categoryId: 19
                        },
                        {
                            itemId: 813,
                            code: 'Q688',
                            description: 'CF09 problems remember goal distracted',
                            categoryId: 19
                        },
                        {
                            itemId: 814,
                            code: 'Q689',
                            description: 'CF10 problems remember do interrupt',
                            categoryId: 19
                        },
                        {
                            itemId: 817,
                            code: 'Q692',
                            description: 'CF15 forgetful',
                            categoryId: 19
                        },
                        {
                            itemId: 819,
                            code: 'Q694',
                            description: 'CF17 problems recognise',
                            categoryId: 19
                        },
                        {
                            itemId: 820,
                            code: 'Q695',
                            description: 'CF18 problems remember told',
                            categoryId: 19
                        },
                        {
                            itemId: 822,
                            code: 'Q697',
                            description: 'CF20 problems remember new information',
                            categoryId: 19
                        },
                        {
                            itemId: 823,
                            code: 'Q698',
                            description: 'CF21 problems remember take things',
                            categoryId: 19
                        },
                        {
                            itemId: 825,
                            code: 'Q700',
                            description: 'CF23 problems remember already done',
                            categoryId: 19
                        },
                        {
                            itemId: 826,
                            code: 'Q701',
                            description: 'CF24 problems remember said',
                            categoryId: 19
                        },
                        {
                            itemId: 827,
                            code: 'Q702',
                            description: 'CF25 problems remember message',
                            categoryId: 19
                        },
                        {
                            itemId: 829,
                            code: 'Q704',
                            description: 'CF27 problems remember think',
                            categoryId: 19
                        },
                        {
                            itemId: 831,
                            code: 'Q706',
                            description: 'CF29 problems remember plans',
                            categoryId: 19
                        },
                        {
                            itemId: 832,
                            code: 'Q707',
                            description: 'CF30 problems remember weekday',
                            categoryId: 19
                        },
                        {
                            itemId: 833,
                            code: 'Q708',
                            description: 'CF31 problems remember text',
                            categoryId: 19
                        },
                        {
                            itemId: 834,
                            code: 'Q709',
                            description: 'CF32 problems remember did',
                            categoryId: 19
                        },
                        {
                            itemId: 835,
                            code: 'Q710',
                            description: 'CF33 forget routine',
                            categoryId: 19
                        }, 
                    ]
                },
                {
                    categoryId: 20,
                    categoryName: 'Multi-tasking',
                    parentId: 17,
                    parentCategoryName: 'Cognitive Functioning',
                    items: [
                        {
                            itemId: 805,
                            code: 'Q680',
                            description: 'CF01 problems two tasks simultaneous',
                            categoryId: 20
                        }, 
                    ]
                },
                {
                    categoryId: 21,
                    categoryName: 'Communication',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 50,
                            code: 'Q38',
                            description: 'able to talk with family about illness',
                            categoryId: 21
                        },
                        {
                            itemId: 128,
                            code: 'Q93',
                            description: 'communication HCP sexual issues',
                            categoryId: 21
                        },
                        {
                            itemId: 133,
                            code: 'Q98',
                            description: 'communication sexual issues partner',
                            categoryId: 21
                        },
                        {
                            itemId: 144,
                            code: 'Q106',
                            description: 'problem talking to others',
                            categoryId: 21
                        },
                        {
                            itemId: 202,
                            code: 'Q156',
                            description: 'talk disease partner',
                            categoryId: 21
                        },
                        {
                            itemId: 203,
                            code: 'Q157',
                            description: 'talk sexuality partner',
                            categoryId: 21
                        },
                        {
                            itemId: 298,
                            code: 'Q238',
                            description: 'problem communicate thoughts',
                            categoryId: 21
                        },
                        {
                            itemId: 479,
                            code: 'Q394',
                            description: 'opportunity express emotions',
                            categoryId: 21
                        },
                        {
                            itemId: 556,
                            code: 'Q465',
                            description: 'problem talk feelings family friends',
                            categoryId: 21
                        },
                        {
                            itemId: 721,
                            code: 'Q603',
                            description: 'someone talk feelings',
                            categoryId: 21
                        }, 
                    ]
                },
                {
                    categoryId: 22,
                    categoryName: 'Dermatological',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 332,
                            code: 'Q269',
                            description: 'satisfied softness breast',
                            categoryId: 22
                        },
                        {
                            itemId: 608,
                            code: 'Q512',
                            description: 'vulnerable veins',
                            categoryId: 22
                        },
                        {
                            itemId: 626,
                            code: 'Q526',
                            description: 'problem repeated injections',
                            categoryId: 22
                        },
                        {
                            itemId: 637,
                            code: 'Q537',
                            description: 'skin colour changes',
                            categoryId: 22
                        },
                        {
                            itemId: 638,
                            code: 'Q538',
                            description: 'problem wound heal',
                            categoryId: 22
                        },
                        {
                            itemId: 704,
                            code: 'Q591',
                            description: 'area wound oversensitive',
                            categoryId: 22
                        },
                        {
                            itemId: 1147,
                            code: 'Q891',
                            description: 'tear split skin genital area',
                            categoryId: 22
                        },
                        {
                            itemId: 1153,
                            code: 'Q897',
                            description: 'tight skin genital area',
                            categoryId: 22
                        },
                        {
                            itemId: 1157,
                            code: 'Q901',
                            description: 'tight skin legs',
                            categoryId: 22
                        },
                        {
                            itemId: 1219,
                            code: 'Q907',
                            description: 'reddening hands feet',
                            categoryId: 22
                        },
                        {
                            itemId: 1238,
                            code: 'Q926',
                            description: 'broken nails',
                            categoryId: 22
                        },
                        {
                            itemId: 1239,
                            code: 'Q927',
                            description: 'hair colour change',
                            categoryId: 22
                        },
                        {
                            itemId: 1240,
                            code: 'Q928',
                            description: 'hair texture change',
                            categoryId: 22
                        },
                        {
                            itemId: 1251,
                            code: 'Q939',
                            description: 'skin sensitive sun',
                            categoryId: 22
                        }, 
                    ]
                },
                {
                    categoryId: 23,
                    categoryName: 'Bruising',
                    parentId: 22,
                    parentCategoryName: 'Dermatological',
                    items: [
                        {
                            itemId: 422,
                            code: 'Q348',
                            description: 'bruising',
                            categoryId: 23
                        },
                        {
                            itemId: 1252,
                            code: 'Q940',
                            description: 'bruise easily',
                            categoryId: 23
                        }, 
                    ]
                },
                {
                    categoryId: 24,
                    categoryName: 'Dry/itchy skin',
                    parentId: 22,
                    parentCategoryName: 'Dermatological',
                    items: [
                        {
                            itemId: 180,
                            code: 'Q137',
                            description: 'skin problems area affected breast',
                            categoryId: 24
                        },
                        {
                            itemId: 186,
                            code: 'Q142',
                            description: 'skin problems',
                            categoryId: 24
                        },
                        {
                            itemId: 197,
                            code: 'Q151',
                            description: 'itching',
                            categoryId: 24
                        },
                        {
                            itemId: 308,
                            code: 'Q245',
                            description: 'problem itchy skin',
                            categoryId: 24
                        },
                        {
                            itemId: 636,
                            code: 'Q536',
                            description: 'rash',
                            categoryId: 24
                        },
                        {
                            itemId: 1096,
                            code: 'Q855',
                            description: 'itchy irritated skin treated',
                            categoryId: 24
                        },
                        {
                            itemId: 1145,
                            code: 'Q889',
                            description: 'itchy irritated skin genital area',
                            categoryId: 24
                        },
                        {
                            itemId: 1248,
                            code: 'Q936',
                            description: 'dry flaking cracked skin',
                            categoryId: 24
                        }, 
                    ]
                },
                {
                    categoryId: 25,
                    categoryName: 'Hair loss',
                    parentId: 22,
                    parentCategoryName: 'Dermatological',
                    items: [
                        {
                            itemId: 155,
                            code: 'Q116',
                            description: 'lost hair',
                            categoryId: 25
                        },
                        {
                            itemId: 166,
                            code: 'Q125',
                            description: 'upset loss hair',
                            categoryId: 25
                        },
                        {
                            itemId: 647,
                            code: 'Q547',
                            description: 'upset treatment affect hair',
                            categoryId: 25
                        },
                        {
                            itemId: 701,
                            code: 'Q588',
                            description: 'thin lifeless hair',
                            categoryId: 25
                        }, 
                    ]
                },
                {
                    categoryId: 26,
                    categoryName: 'Jaundice',
                    parentId: 22,
                    parentCategoryName: 'Dermatological',
                    items: [
                        {
                            itemId: 196,
                            code: 'Q150',
                            description: 'jaundice ',
                            categoryId: 26
                        },
                        {
                            itemId: 199,
                            code: 'Q153',
                            description: 'worry jaundice',
                            categoryId: 26
                        },
                        {
                            itemId: 316,
                            code: 'Q253',
                            description: 'yellow skin',
                            categoryId: 26
                        }, 
                    ]
                },
                {
                    categoryId: 27,
                    categoryName: 'Redness/flushing',
                    parentId: 22,
                    parentCategoryName: 'Dermatological',
                    items: [
                        {
                            itemId: 619,
                            code: 'Q523',
                            description: 'look flushed red',
                            categoryId: 27
                        }, 
                    ]
                },
                {
                    categoryId: 28,
                    categoryName: 'Sore skin',
                    parentId: 22,
                    parentCategoryName: 'Dermatological',
                    items: [
                        {
                            itemId: 528,
                            code: 'Q438',
                            description: 'stoma sore skin',
                            categoryId: 28
                        },
                        {
                            itemId: 535,
                            code: 'Q445',
                            description: 'sore skin anal area',
                            categoryId: 28
                        },
                        {
                            itemId: 1146,
                            code: 'Q890',
                            description: 'sore skin genital area',
                            categoryId: 28
                        },
                        {
                            itemId: 1155,
                            code: 'Q899',
                            description: 'sore skin groin',
                            categoryId: 28
                        }, 
                    ]
                },
                {
                    categoryId: 29,
                    categoryName: 'Splitting finger/toenails',
                    parentId: 22,
                    parentCategoryName: 'Dermatological',
                    items: [
                        {
                            itemId: 699,
                            code: 'Q586',
                            description: 'split nails',
                            categoryId: 29
                        }, 
                    ]
                },
                {
                    categoryId: 30,
                    categoryName: 'Disease/Treatment Burden',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 51,
                            code: 'Q39',
                            description: 'worry family coping',
                            categoryId: 30
                        },
                        {
                            itemId: 58,
                            code: 'Q46',
                            description: 'burden disease patient',
                            categoryId: 30
                        },
                        {
                            itemId: 59,
                            code: 'Q47',
                            description: 'burden treatment patient',
                            categoryId: 30
                        },
                        {
                            itemId: 62,
                            code: 'Q50',
                            description: 'go out close to toilet',
                            categoryId: 30
                        },
                        {
                            itemId: 242,
                            code: 'Q183',
                            description: 'dependent others urostomy care ',
                            categoryId: 30
                        },
                        {
                            itemId: 269,
                            code: 'Q209',
                            description: 'worry become dependent',
                            categoryId: 30
                        },
                        {
                            itemId: 306,
                            code: 'Q244',
                            description: 'assistance manage bowel problem',
                            categoryId: 30
                        },
                        {
                            itemId: 338,
                            code: 'Q275',
                            description: 'coming to terms breast reconstruction',
                            categoryId: 30
                        },
                        {
                            itemId: 365,
                            code: 'Q294',
                            description: 'worry burden other people',
                            categoryId: 30
                        },
                        {
                            itemId: 370,
                            code: 'Q299',
                            description: 'worry become more dependent',
                            categoryId: 30
                        },
                        {
                            itemId: 462,
                            code: 'Q384',
                            description: 'need social support therapy disease',
                            categoryId: 30
                        },
                        {
                            itemId: 504,
                            code: 'Q418',
                            description: 'problem accept limitations',
                            categoryId: 30
                        },
                        {
                            itemId: 558,
                            code: 'Q467',
                            description: 'disease treatment sex life',
                            categoryId: 30
                        },
                        {
                            itemId: 627,
                            code: 'Q527',
                            description: 'distress disease treatment close people',
                            categoryId: 30
                        },
                        {
                            itemId: 652,
                            code: 'Q549',
                            description: 'problem cope hospital',
                            categoryId: 30
                        },
                        {
                            itemId: 658,
                            code: 'Q555',
                            description: 'drug intake interference daily life',
                            categoryId: 30
                        },
                        {
                            itemId: 659,
                            code: 'Q556',
                            description: 'watch closely new symptoms',
                            categoryId: 30
                        },
                        {
                            itemId: 713,
                            code: 'Q595',
                            description: 'able deal with problems',
                            categoryId: 30
                        },
                        {
                            itemId: 715,
                            code: 'Q597',
                            description: 'find things enjoy',
                            categoryId: 30
                        },
                        {
                            itemId: 729,
                            code: 'Q611',
                            description: 'wonder anything done',
                            categoryId: 30
                        },
                        {
                            itemId: 730,
                            code: 'Q612',
                            description: 'felt unfair ill',
                            categoryId: 30
                        },
                        {
                            itemId: 739,
                            code: 'Q621',
                            description: 'feelings life changed less well',
                            categoryId: 30
                        },
                        {
                            itemId: 740,
                            code: 'Q622',
                            description: ' feelings life changed last weeks',
                            categoryId: 30
                        },
                        {
                            itemId: 1264,
                            code: 'Q949',
                            description: 'worry hormone tablets body scan',
                            categoryId: 30
                        },
                        {
                            itemId: 1265,
                            code: 'Q950',
                            description: 'worry drugs life',
                            categoryId: 30
                        },
                        {
                            itemId: 1268,
                            code: 'Q953',
                            description: 'worry close cope',
                            categoryId: 30
                        }, 
                    ]
                },
                {
                    categoryId: 31,
                    categoryName: 'Treatment side effects',
                    parentId: 30,
                    parentCategoryName: 'Disease/Treatment Burden',
                    items: [
                        {
                            itemId: 123,
                            code: 'Q88',
                            description: 'treatment sex life',
                            categoryId: 31
                        },
                        {
                            itemId: 220,
                            code: 'Q168',
                            description: 'problem side effects ',
                            categoryId: 31
                        },
                        {
                            itemId: 621,
                            code: 'Q525',
                            description: 'side effects treatment',
                            categoryId: 31
                        }, 
                    ]
                },
                {
                    categoryId: 32,
                    categoryName: 'Dyspnea',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 22,
                            code: 'Q11',
                            description: 'DY06 short of breath',
                            categoryId: 32
                        },
                        {
                            itemId: 431,
                            code: 'Q357',
                            description: ' short breath exertion',
                            categoryId: 32
                        },
                        {
                            itemId: 562,
                            code: 'Q471',
                            description: 'short breath rest',
                            categoryId: 32
                        },
                        {
                            itemId: 564,
                            code: 'Q473',
                            description: 'short breath walk',
                            categoryId: 32
                        },
                        {
                            itemId: 565,
                            code: 'Q474',
                            description: 'short breath stairs',
                            categoryId: 32
                        },
                        {
                            itemId: 918,
                            code: 'Q792',
                            description: 'DY01 short breath wash',
                            categoryId: 32
                        },
                        {
                            itemId: 919,
                            code: 'Q793',
                            description: 'DY02 short breath rest',
                            categoryId: 32
                        },
                        {
                            itemId: 920,
                            code: 'Q794',
                            description: 'DY03 problem breath sweat',
                            categoryId: 32
                        },
                        {
                            itemId: 921,
                            code: 'Q795',
                            description: 'DY04 gasp air',
                            categoryId: 32
                        },
                        {
                            itemId: 922,
                            code: 'Q796',
                            description: 'DY05 feel stop breathe',
                            categoryId: 32
                        },
                        {
                            itemId: 924,
                            code: 'Q798',
                            description: 'DY08 not enough air',
                            categoryId: 32
                        },
                        {
                            itemId: 926,
                            code: 'Q800',
                            description: 'DY10 short breath bend',
                            categoryId: 32
                        },
                        {
                            itemId: 927,
                            code: 'Q801',
                            description: 'DY11 short breath minimal effort',
                            categoryId: 32
                        },
                        {
                            itemId: 928,
                            code: 'Q802',
                            description: 'DY12 suffocate',
                            categoryId: 32
                        },
                        {
                            itemId: 929,
                            code: 'Q803',
                            description: 'DY13 short breath moderate activity',
                            categoryId: 32
                        },
                        {
                            itemId: 930,
                            code: 'Q804',
                            description: 'DY14 severe short breath',
                            categoryId: 32
                        },
                        {
                            itemId: 931,
                            code: 'Q805',
                            description: 'DY15 rapid breathing',
                            categoryId: 32
                        },
                        {
                            itemId: 932,
                            code: 'Q806',
                            description: 'DY16 short breath dress',
                            categoryId: 32
                        },
                        {
                            itemId: 933,
                            code: 'Q807',
                            description: 'DY17 short breath walk 100 m',
                            categoryId: 32
                        },
                        {
                            itemId: 934,
                            code: 'Q808',
                            description: 'DY18 short breath talk',
                            categoryId: 32
                        },
                        {
                            itemId: 935,
                            code: 'Q809',
                            description: 'DY19 stop breath walk',
                            categoryId: 32
                        },
                        {
                            itemId: 936,
                            code: 'Q810',
                            description: 'DY20 very severe short breath',
                            categoryId: 32
                        },
                        {
                            itemId: 937,
                            code: 'Q811',
                            description: 'DY21 short breath walk',
                            categoryId: 32
                        },
                        {
                            itemId: 938,
                            code: 'Q812',
                            description: 'DY22 problems breathe in',
                            categoryId: 32
                        },
                        {
                            itemId: 939,
                            code: 'Q813',
                            description: 'DY23 short breath walk level ground',
                            categoryId: 32
                        },
                        {
                            itemId: 940,
                            code: 'Q814',
                            description: 'DY24 problems breathe out',
                            categoryId: 32
                        },
                        {
                            itemId: 941,
                            code: 'Q815',
                            description: 'DY25 short breath walk up flight stairs',
                            categoryId: 32
                        },
                        {
                            itemId: 942,
                            code: 'Q816',
                            description: 'DY26 short breath stand up chair',
                            categoryId: 32
                        },
                        {
                            itemId: 943,
                            code: 'Q817',
                            description: 'DY27 short breath walk less 100 m',
                            categoryId: 32
                        },
                        {
                            itemId: 944,
                            code: 'Q818',
                            description: 'DY28 cannot breathe',
                            categoryId: 32
                        },
                        {
                            itemId: 945,
                            code: 'Q819',
                            description: 'DY29 short breath lie down',
                            categoryId: 32
                        },
                        {
                            itemId: 946,
                            code: 'Q820',
                            description: 'DY30 short breath go up few steps',
                            categoryId: 32
                        },
                        {
                            itemId: 947,
                            code: 'Q821',
                            description: 'DY31 short breath walk around home',
                            categoryId: 32
                        },
                        {
                            itemId: 948,
                            code: 'Q822',
                            description: 'DY32 out breath',
                            categoryId: 32
                        }, 
                    ]
                },
                {
                    categoryId: 33,
                    categoryName: 'Eating/Appetite Loss',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 76,
                            code: 'Q61',
                            description: 'problem drinking liquids',
                            categoryId: 33
                        },
                        {
                            itemId: 77,
                            code: 'Q62',
                            description: 'problem eating liquidised food',
                            categoryId: 33
                        },
                        {
                            itemId: 79,
                            code: 'Q64',
                            description: 'problem eating solid food',
                            categoryId: 33
                        },
                        {
                            itemId: 131,
                            code: 'Q96',
                            description: 'problem eating',
                            categoryId: 33
                        },
                        {
                            itemId: 132,
                            code: 'Q97',
                            description: 'problem eating with family',
                            categoryId: 33
                        },
                        {
                            itemId: 138,
                            code: 'Q103',
                            description: 'problem enjoying meals',
                            categoryId: 33
                        },
                        {
                            itemId: 160,
                            code: 'Q121',
                            description: 'nutritional supplements ',
                            categoryId: 33
                        },
                        {
                            itemId: 161,
                            code: 'Q122',
                            description: 'feeding tube',
                            categoryId: 33
                        },
                        {
                            itemId: 218,
                            code: 'Q166',
                            description: 'discomfort eating',
                            categoryId: 33
                        },
                        {
                            itemId: 234,
                            code: 'Q175',
                            description: 'long time finish meal',
                            categoryId: 33
                        },
                        {
                            itemId: 352,
                            code: 'Q281',
                            description: 'unpleasant food texture',
                            categoryId: 33
                        },
                        {
                            itemId: 358,
                            code: 'Q287',
                            description: 'worry not eat enough',
                            categoryId: 33
                        },
                        {
                            itemId: 361,
                            code: 'Q290',
                            description: 'unable to eat',
                            categoryId: 33
                        },
                        {
                            itemId: 372,
                            code: 'Q301',
                            description: 'FA29 tired eat',
                            categoryId: 33
                        },
                        {
                            itemId: 474,
                            code: 'Q389',
                            description: 'eat solid food',
                            categoryId: 33
                        },
                        {
                            itemId: 476,
                            code: 'Q391',
                            description: 'eat liquidised soft food',
                            categoryId: 33
                        },
                        {
                            itemId: 477,
                            code: 'Q392',
                            description: 'drink liquids',
                            categoryId: 33
                        },
                        {
                            itemId: 639,
                            code: 'Q539',
                            description: 'problem chew',
                            categoryId: 33
                        },
                        {
                            itemId: 645,
                            code: 'Q545',
                            description: 'worry enough nourishment',
                            categoryId: 33
                        },
                        {
                            itemId: 892,
                            code: 'Q766',
                            description: 'NV06 nausea eat less',
                            categoryId: 33
                        },
                        {
                            itemId: 900,
                            code: 'Q774',
                            description: 'NV14 nausea interfere appetite',
                            categoryId: 33
                        },
                        {
                            itemId: 902,
                            code: 'Q776',
                            description: 'NV16 nausea unable eat',
                            categoryId: 33
                        },
                        {
                            itemId: 904,
                            code: 'Q778',
                            description: 'NV18 nausea less fluid',
                            categoryId: 33
                        },
                        {
                            itemId: 905,
                            code: 'Q779',
                            description: 'NV19 nausea unable eat stomach',
                            categoryId: 33
                        },
                        {
                            itemId: 1141,
                            code: 'Q885',
                            description: 'problem swallowing liquid',
                            categoryId: 33
                        },
                        {
                            itemId: 1142,
                            code: 'Q886',
                            description: 'problem swallow solid food',
                            categoryId: 33
                        },
                        {
                            itemId: 1143,
                            code: 'Q887',
                            description: 'problem pureed food',
                            categoryId: 33
                        },
                        {
                            itemId: 1237,
                            code: 'Q925',
                            description: 'restricted types food',
                            categoryId: 33
                        }, 
                    ]
                },
                {
                    categoryId: 34,
                    categoryName: 'Altered taste/smell',
                    parentId: 33,
                    parentCategoryName: 'Eating/Appetite Loss',
                    items: []
                },
                {
                    categoryId: 35,
                    categoryName: 'Appetite loss',
                    parentId: 33,
                    parentCategoryName: 'Eating/Appetite Loss',
                    items: [
                        {
                            itemId: 27,
                            code: 'Q16',
                            description: 'AP04 appetite loss',
                            categoryId: 35
                        },
                        {
                            itemId: 355,
                            code: 'Q284',
                            description: 'too much put off',
                            categoryId: 35
                        },
                        {
                            itemId: 363,
                            code: 'Q292',
                            description: 'pressure others eat more',
                            categoryId: 35
                        },
                        {
                            itemId: 374,
                            code: 'Q303',
                            description: 'AP02 force eat',
                            categoryId: 35
                        },
                        {
                            itemId: 906,
                            code: 'Q780',
                            description: 'AP01 severe lack appetite',
                            categoryId: 35
                        },
                        {
                            itemId: 907,
                            code: 'Q781',
                            description: 'AP03 encouragement eat',
                            categoryId: 35
                        },
                        {
                            itemId: 908,
                            code: 'Q782',
                            description: 'AP05 problem enjoy food',
                            categoryId: 35
                        },
                        {
                            itemId: 909,
                            code: 'Q783',
                            description: 'AP06 lack interest eat',
                            categoryId: 35
                        },
                        {
                            itemId: 910,
                            code: 'Q784',
                            description: 'AP07 food repulsive',
                            categoryId: 35
                        }, 
                    ]
                },
                {
                    categoryId: 36,
                    categoryName: 'Early satiety',
                    parentId: 33,
                    parentCategoryName: 'Eating/Appetite Loss',
                    items: [
                        {
                            itemId: 181,
                            code: 'Q138',
                            description: 'full up too quickly ',
                            categoryId: 36
                        }, 
                    ]
                },
                {
                    categoryId: 37,
                    categoryName: 'Eating restrictions',
                    parentId: 33,
                    parentCategoryName: 'Eating/Appetite Loss',
                    items: [
                        {
                            itemId: 195,
                            code: 'Q149',
                            description: 'limited types of food',
                            categoryId: 37
                        },
                        {
                            itemId: 295,
                            code: 'Q235',
                            description: 'restricted types food bowel problems',
                            categoryId: 37
                        },
                        {
                            itemId: 313,
                            code: 'Q250',
                            description: 'limited amounts of food',
                            categoryId: 37
                        }, 
                    ]
                },
                {
                    categoryId: 38,
                    categoryName: 'Edema',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 83,
                            code: 'Q68',
                            description: 'swelling legs ankles',
                            categoryId: 38
                        },
                        {
                            itemId: 175,
                            code: 'Q132',
                            description: 'swollen arm hand',
                            categoryId: 38
                        },
                        {
                            itemId: 178,
                            code: 'Q135',
                            description: 'swollen area affected breast',
                            categoryId: 38
                        },
                        {
                            itemId: 321,
                            code: 'Q258',
                            description: 'problem fullness arm',
                            categoryId: 38
                        },
                        {
                            itemId: 336,
                            code: 'Q273',
                            description: 'problems clothes tight',
                            categoryId: 38
                        },
                        {
                            itemId: 454,
                            code: 'Q377',
                            description: 'swelling certain body parts',
                            categoryId: 38
                        },
                        {
                            itemId: 545,
                            code: 'Q454',
                            description: 'swelling legs',
                            categoryId: 38
                        },
                        {
                            itemId: 579,
                            code: 'Q485',
                            description: 'heavy legs',
                            categoryId: 38
                        },
                        {
                            itemId: 635,
                            code: 'Q535',
                            description: 'neck swelling ',
                            categoryId: 38
                        },
                        {
                            itemId: 642,
                            code: 'Q542',
                            description: 'abdomen swelling',
                            categoryId: 38
                        },
                        {
                            itemId: 1152,
                            code: 'Q896',
                            description: 'swelling genital area',
                            categoryId: 38
                        },
                        {
                            itemId: 1154,
                            code: 'Q898',
                            description: 'swelling groin',
                            categoryId: 38
                        },
                        {
                            itemId: 1228,
                            code: 'Q916',
                            description: 'swelling body',
                            categoryId: 38
                        },
                        {
                            itemId: 1229,
                            code: 'Q917',
                            description: 'swelling face eyes',
                            categoryId: 38
                        }, 
                    ]
                },
                {
                    categoryId: 39,
                    categoryName: 'Emotional Functioning',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 56,
                            code: 'Q44',
                            description: 'positive outlook',
                            categoryId: 39
                        },
                        {
                            itemId: 166,
                            code: 'Q125',
                            description: 'upset loss hair',
                            categoryId: 39
                        },
                        {
                            itemId: 217,
                            code: 'Q165',
                            description: 'enjoying yourself',
                            categoryId: 39
                        },
                        {
                            itemId: 237,
                            code: 'Q178',
                            description: 'think illness',
                            categoryId: 39
                        },
                        {
                            itemId: 271,
                            code: 'Q211',
                            description: 'feel positive health',
                            categoryId: 39
                        },
                        {
                            itemId: 479,
                            code: 'Q394',
                            description: 'opportunity express emotions',
                            categoryId: 39
                        },
                        {
                            itemId: 503,
                            code: 'Q417',
                            description: 'patient HCP listen emotions',
                            categoryId: 39
                        },
                        {
                            itemId: 505,
                            code: 'Q419',
                            description: 'HCP help manage emotions',
                            categoryId: 39
                        },
                        {
                            itemId: 518,
                            code: 'Q432',
                            description: 'restless agitated',
                            categoryId: 39
                        },
                        {
                            itemId: 556,
                            code: 'Q465',
                            description: 'problem talk feelings family friends',
                            categoryId: 39
                        },
                        {
                            itemId: 609,
                            code: 'Q513',
                            description: 'feeling discouraged',
                            categoryId: 39
                        },
                        {
                            itemId: 613,
                            code: 'Q517',
                            description: 'lack self confidence',
                            categoryId: 39
                        },
                        {
                            itemId: 647,
                            code: 'Q547',
                            description: 'upset treatment affect hair',
                            categoryId: 39
                        },
                        {
                            itemId: 653,
                            code: 'Q550',
                            description: 'problem isolation hospital',
                            categoryId: 39
                        },
                        {
                            itemId: 716,
                            code: 'Q598',
                            description: 'forgive things done',
                            categoryId: 39
                        },
                        {
                            itemId: 717,
                            code: 'Q599',
                            description: 'troubled',
                            categoryId: 39
                        },
                        {
                            itemId: 718,
                            code: 'Q600',
                            description: 'lonely',
                            categoryId: 39
                        },
                        {
                            itemId: 720,
                            code: 'Q602',
                            description: 'love close people',
                            categoryId: 39
                        },
                        {
                            itemId: 721,
                            code: 'Q603',
                            description: 'someone talk feelings',
                            categoryId: 39
                        },
                        {
                            itemId: 725,
                            code: 'Q607',
                            description: 'life fulfil',
                            categoryId: 39
                        },
                        {
                            itemId: 726,
                            code: 'Q608',
                            description: 'life worthwhile',
                            categoryId: 39
                        },
                        {
                            itemId: 780,
                            code: 'Q655',
                            description: 'EF05 vulnerable',
                            categoryId: 39
                        },
                        {
                            itemId: 783,
                            code: 'Q658',
                            description: 'EF08 discouraged',
                            categoryId: 39
                        },
                        {
                            itemId: 792,
                            code: 'Q667',
                            description: 'EF20 desperate',
                            categoryId: 39
                        },
                        {
                            itemId: 793,
                            code: 'Q668',
                            description: 'EF21 fear lost control',
                            categoryId: 39
                        },
                        {
                            itemId: 891,
                            code: 'Q765',
                            description: 'NV05 nausea interfere enjoy life',
                            categoryId: 39
                        },
                        {
                            itemId: 1271,
                            code: 'Q956',
                            description: 'support family friends',
                            categoryId: 39
                        }, 
                    ]
                },
                {
                    categoryId: 40,
                    categoryName: 'Anger',
                    parentId: 39,
                    parentCategoryName: 'Emotional Functioning',
                    items: [
                        {
                            itemId: 37,
                            code: 'Q26',
                            description: 'EF17 irritable',
                            categoryId: 40
                        },
                        {
                            itemId: 781,
                            code: 'Q656',
                            description: 'EF06 frustrated',
                            categoryId: 40
                        }, 
                    ]
                },
                {
                    categoryId: 41,
                    categoryName: 'Anxiety',
                    parentId: 39,
                    parentCategoryName: 'Emotional Functioning',
                    items: [
                        {
                            itemId: 36,
                            code: 'Q25',
                            description: 'EF19 worry',
                            categoryId: 41
                        },
                        {
                            itemId: 245,
                            code: 'Q186',
                            description: 'worry results',
                            categoryId: 41
                        },
                        {
                            itemId: 246,
                            code: 'Q187',
                            description: 'worry future treatments',
                            categoryId: 41
                        },
                        {
                            itemId: 296,
                            code: 'Q236',
                            description: 'worry bowel problem',
                            categoryId: 41
                        },
                        {
                            itemId: 656,
                            code: 'Q553',
                            description: 'need keep fears concerns family friends',
                            categoryId: 41
                        },
                        {
                            itemId: 728,
                            code: 'Q610',
                            description: 'worries concerns future',
                            categoryId: 41
                        },
                        {
                            itemId: 778,
                            code: 'Q653',
                            description: 'EF03 panic',
                            categoryId: 41
                        }, 
                    ]
                },
                {
                    categoryId: 42,
                    categoryName: 'Depression',
                    parentId: 39,
                    parentCategoryName: 'Emotional Functioning',
                    items: [
                        {
                            itemId: 38,
                            code: 'Q27',
                            description: 'EF16 depressed',
                            categoryId: 42
                        },
                        {
                            itemId: 782,
                            code: 'Q657',
                            description: 'EF07 worthless',
                            categoryId: 42
                        },
                        {
                            itemId: 785,
                            code: 'Q660',
                            description: 'EF10 nothing cheer up',
                            categoryId: 42
                        },
                        {
                            itemId: 787,
                            code: 'Q662',
                            description: 'EF12 pleasure gone',
                            categoryId: 42
                        },
                        {
                            itemId: 789,
                            code: 'Q664',
                            description: 'EF14 lose interest appearance',
                            categoryId: 42
                        },
                        {
                            itemId: 790,
                            code: 'Q665',
                            description: 'EF15 miserable',
                            categoryId: 42
                        },
                        {
                            itemId: 791,
                            code: 'Q666',
                            description: 'EF18 useless',
                            categoryId: 42
                        },
                        {
                            itemId: 794,
                            code: 'Q669',
                            description: 'EF22 sad',
                            categoryId: 42
                        },
                        {
                            itemId: 795,
                            code: 'Q670',
                            description: 'EF23 give up',
                            categoryId: 42
                        },
                        {
                            itemId: 796,
                            code: 'Q671',
                            description: 'EF24 nothing look forward',
                            categoryId: 42
                        }, 
                    ]
                },
                {
                    categoryId: 43,
                    categoryName: 'Distress',
                    parentId: 39,
                    parentCategoryName: 'Emotional Functioning',
                    items: [
                        {
                            itemId: 897,
                            code: 'Q771',
                            description: 'NV11 nausea distress',
                            categoryId: 43
                        },
                        {
                            itemId: 964,
                            code: 'Q838',
                            description: 'DI07 distress DI',
                            categoryId: 43
                        },
                        {
                            itemId: 1267,
                            code: 'Q952',
                            description: 'upsetting close distressed result disease treatment',
                            categoryId: 43
                        }, 
                    ]
                },
                {
                    categoryId: 44,
                    categoryName: 'Embarrassment',
                    parentId: 39,
                    parentCategoryName: 'Emotional Functioning',
                    items: [
                        {
                            itemId: 241,
                            code: 'Q182',
                            description: 'embarrassed urostomy',
                            categoryId: 44
                        },
                        {
                            itemId: 297,
                            code: 'Q237',
                            description: 'embarrassed bowel problem',
                            categoryId: 44
                        },
                        {
                            itemId: 531,
                            code: 'Q441',
                            description: 'embarrassed stoma',
                            categoryId: 44
                        },
                        {
                            itemId: 538,
                            code: 'Q448',
                            description: 'embarrassed bowel movement',
                            categoryId: 44
                        }, 
                    ]
                },
                {
                    categoryId: 45,
                    categoryName: 'Fear',
                    parentId: 39,
                    parentCategoryName: 'Emotional Functioning',
                    items: [
                        {
                            itemId: 786,
                            code: 'Q661',
                            description: 'EF11 afraid',
                            categoryId: 45
                        }, 
                    ]
                },
                {
                    categoryId: 46,
                    categoryName: 'Helplessness',
                    parentId: 39,
                    parentCategoryName: 'Emotional Functioning',
                    items: [
                        {
                            itemId: 611,
                            code: 'Q515',
                            description: 'feeling helpless',
                            categoryId: 46
                        },
                        {
                            itemId: 777,
                            code: 'Q652',
                            description: 'EF02 helpless',
                            categoryId: 46
                        }, 
                    ]
                },
                {
                    categoryId: 47,
                    categoryName: 'Mood swings',
                    parentId: 39,
                    parentCategoryName: 'Emotional Functioning',
                    items: [
                        {
                            itemId: 457,
                            code: 'Q380',
                            description: 'mood changes',
                            categoryId: 47
                        },
                        {
                            itemId: 784,
                            code: 'Q659',
                            description: 'EF09 outbursts',
                            categoryId: 47
                        }, 
                    ]
                },
                {
                    categoryId: 48,
                    categoryName: 'Stress',
                    parentId: 39,
                    parentCategoryName: 'Emotional Functioning',
                    items: [
                        {
                            itemId: 35,
                            code: 'Q24',
                            description: 'EF01 tense',
                            categoryId: 48
                        },
                        {
                            itemId: 216,
                            code: 'Q164',
                            description: 'stress',
                            categoryId: 48
                        },
                        {
                            itemId: 788,
                            code: 'Q663',
                            description: 'EF13 problems relax',
                            categoryId: 48
                        }, 
                    ]
                },
                {
                    categoryId: 49,
                    categoryName: 'Family Life',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 40,
                            code: 'Q29',
                            description: 'SF10 PC/MT interference family life',
                            categoryId: 49
                        },
                        {
                            itemId: 50,
                            code: 'Q38',
                            description: 'able to talk with family about illness',
                            categoryId: 49
                        },
                        {
                            itemId: 51,
                            code: 'Q39',
                            description: 'worry family coping',
                            categoryId: 49
                        },
                        {
                            itemId: 132,
                            code: 'Q97',
                            description: 'problem eating with family',
                            categoryId: 49
                        },
                        {
                            itemId: 198,
                            code: 'Q152',
                            description: 'worry disruption family life',
                            categoryId: 49
                        },
                        {
                            itemId: 219,
                            code: 'Q167',
                            description: 'worry family future',
                            categoryId: 49
                        },
                        {
                            itemId: 462,
                            code: 'Q384',
                            description: 'need social support therapy disease',
                            categoryId: 49
                        },
                        {
                            itemId: 588,
                            code: 'Q494',
                            description: 'effects treatment social family life',
                            categoryId: 49
                        },
                        {
                            itemId: 627,
                            code: 'Q527',
                            description: 'distress disease treatment close people',
                            categoryId: 49
                        },
                        {
                            itemId: 656,
                            code: 'Q553',
                            description: 'need keep fears concerns family friends',
                            categoryId: 49
                        },
                        {
                            itemId: 719,
                            code: 'Q601',
                            description: 'share thoughts life people close',
                            categoryId: 49
                        },
                        {
                            itemId: 720,
                            code: 'Q602',
                            description: 'love close people',
                            categoryId: 49
                        },
                        {
                            itemId: 896,
                            code: 'Q770',
                            description: 'NV10 nausea interfere family life',
                            categoryId: 49
                        },
                        {
                            itemId: 1130,
                            code: 'Q877',
                            description: 'family involved care',
                            categoryId: 49
                        },
                        {
                            itemId: 1267,
                            code: 'Q952',
                            description: 'upsetting close distressed result disease treatment',
                            categoryId: 49
                        },
                        {
                            itemId: 1268,
                            code: 'Q953',
                            description: 'worry close cope',
                            categoryId: 49
                        },
                        {
                            itemId: 1271,
                            code: 'Q956',
                            description: 'support family friends',
                            categoryId: 49
                        }, 
                    ]
                },
                {
                    categoryId: 50,
                    categoryName: 'Fatigue',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 24,
                            code: 'Q13',
                            description: 'FA27 need rest',
                            categoryId: 50
                        },
                        {
                            itemId: 26,
                            code: 'Q15',
                            description: 'FA22 weak',
                            categoryId: 50
                        },
                        {
                            itemId: 32,
                            code: 'Q21',
                            description: 'FA17 tired',
                            categoryId: 50
                        },
                        {
                            itemId: 122,
                            code: 'Q87',
                            description: 'fatigue sex life',
                            categoryId: 50
                        },
                        {
                            itemId: 205,
                            code: 'Q158',
                            description: 'FA06 slowed down',
                            categoryId: 50
                        },
                        {
                            itemId: 206,
                            code: 'Q159',
                            description: 'FA19 lack energy',
                            categoryId: 50
                        },
                        {
                            itemId: 315,
                            code: 'Q252',
                            description: 'FA15 weak arms legs',
                            categoryId: 50
                        },
                        {
                            itemId: 372,
                            code: 'Q301',
                            description: 'FA29 tired eat',
                            categoryId: 50
                        },
                        {
                            itemId: 424,
                            code: 'Q350',
                            description: 'lethargic',
                            categoryId: 50
                        },
                        {
                            itemId: 433,
                            code: 'Q359',
                            description: 'sudden tiredness',
                            categoryId: 50
                        },
                        {
                            itemId: 458,
                            code: 'Q381',
                            description: 'problem carry usual activities tired',
                            categoryId: 50
                        },
                        {
                            itemId: 597,
                            code: 'Q502',
                            description: 'FA16 exhausted',
                            categoryId: 50
                        },
                        {
                            itemId: 598,
                            code: 'Q503',
                            description: 'sleepy daytime',
                            categoryId: 50
                        },
                        {
                            itemId: 607,
                            code: 'Q511',
                            description: 'problem get things started',
                            categoryId: 50
                        },
                        {
                            itemId: 616,
                            code: 'Q520',
                            description: 'tired interference daily activities',
                            categoryId: 50
                        },
                        {
                            itemId: 617,
                            code: 'Q521',
                            description: 'tired not understood close people',
                            categoryId: 50
                        },
                        {
                            itemId: 848,
                            code: 'Q723',
                            description: 'FA01 tired eyes open day',
                            categoryId: 50
                        },
                        {
                            itemId: 851,
                            code: 'Q726',
                            description: 'FA04 weak things',
                            categoryId: 50
                        },
                        {
                            itemId: 853,
                            code: 'Q727',
                            description: 'FA05 lack energy things',
                            categoryId: 50
                        },
                        {
                            itemId: 855,
                            code: 'Q729',
                            description: 'FA08 drained',
                            categoryId: 50
                        },
                        {
                            itemId: 856,
                            code: 'Q730',
                            description: 'FA09 exhausted move body',
                            categoryId: 50
                        },
                        {
                            itemId: 857,
                            code: 'Q731',
                            description: 'FA10 problems start tired',
                            categoryId: 50
                        },
                        {
                            itemId: 858,
                            code: 'Q732',
                            description: 'FA11 tired simple',
                            categoryId: 50
                        },
                        {
                            itemId: 859,
                            code: 'Q733',
                            description: 'FA12 shopping exhausting',
                            categoryId: 50
                        },
                        {
                            itemId: 860,
                            code: 'Q734',
                            description: 'FA13 physically exhausted',
                            categoryId: 50
                        },
                        {
                            itemId: 861,
                            code: 'Q735',
                            description: 'FA14 leisure exhausting',
                            categoryId: 50
                        },
                        {
                            itemId: 862,
                            code: 'Q736',
                            description: 'FA18 sleep long day',
                            categoryId: 50
                        },
                        {
                            itemId: 863,
                            code: 'Q737',
                            description: 'FA20 easily tired',
                            categoryId: 50
                        },
                        {
                            itemId: 864,
                            code: 'Q738',
                            description: 'FA21 problems sit tired',
                            categoryId: 50
                        },
                        {
                            itemId: 865,
                            code: 'Q739',
                            description: 'FA23 worn out',
                            categoryId: 50
                        },
                        {
                            itemId: 866,
                            code: 'Q740',
                            description: 'FA24 long lack energy',
                            categoryId: 50
                        },
                        {
                            itemId: 867,
                            code: 'Q741',
                            description: 'FA25 problems finish tired',
                            categoryId: 50
                        },
                        {
                            itemId: 868,
                            code: 'Q742',
                            description: 'FA26 tired stairs',
                            categoryId: 50
                        },
                        {
                            itemId: 869,
                            code: 'Q743',
                            description: 'FA28 need long rest',
                            categoryId: 50
                        },
                        {
                            itemId: 871,
                            code: 'Q745',
                            description: 'FA31 extreme need rest',
                            categoryId: 50
                        },
                        {
                            itemId: 872,
                            code: 'Q746',
                            description: 'FA32 exhausted dress',
                            categoryId: 50
                        },
                        {
                            itemId: 873,
                            code: 'Q747',
                            description: 'FA33 tired long activity',
                            categoryId: 50
                        },
                        {
                            itemId: 874,
                            code: 'Q748',
                            description: 'FA34 exhausted shower',
                            categoryId: 50
                        },
                        {
                            itemId: 1257,
                            code: 'Q942',
                            description: 'mentally exhausted',
                            categoryId: 50
                        }, 
                    ]
                },
                {
                    categoryId: 51,
                    categoryName: 'Financial Impact',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 42,
                            code: 'Q31',
                            description: 'FI01 financial difficulties',
                            categoryId: 51
                        },
                        {
                            itemId: 970,
                            code: 'Q844',
                            description: 'FI02 extra expenses difficult pay',
                            categoryId: 51
                        },
                        {
                            itemId: 971,
                            code: 'Q845',
                            description: 'FI03 extra expenses',
                            categoryId: 51
                        },
                        {
                            itemId: 972,
                            code: 'Q846',
                            description: 'FI04 lack money basic',
                            categoryId: 51
                        },
                        {
                            itemId: 973,
                            code: 'Q847',
                            description: 'FI05 debt',
                            categoryId: 51
                        },
                        {
                            itemId: 974,
                            code: 'Q848',
                            description: 'FI06 change life finances',
                            categoryId: 51
                        },
                        {
                            itemId: 975,
                            code: 'Q849',
                            description: 'FI07 less money',
                            categoryId: 51
                        },
                        {
                            itemId: 976,
                            code: 'Q850',
                            description: 'FI08 problems pay regular expenses',
                            categoryId: 51
                        },
                        {
                            itemId: 977,
                            code: 'Q851',
                            description: 'FI09 borrow sell',
                            categoryId: 51
                        }, 
                    ]
                },
                {
                    categoryId: 52,
                    categoryName: 'Fine Motor Skills',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 400,
                            code: 'Q327',
                            description: 'problem pouring',
                            categoryId: 52
                        },
                        {
                            itemId: 402,
                            code: 'Q329',
                            description: 'problem hold pen',
                            categoryId: 52
                        },
                        {
                            itemId: 403,
                            code: 'Q330',
                            description: 'problem small objects fingers',
                            categoryId: 52
                        },
                        {
                            itemId: 405,
                            code: 'Q332',
                            description: 'problem open weak hands',
                            categoryId: 52
                        }, 
                    ]
                },
                {
                    categoryId: 53,
                    categoryName: 'Future Outlook',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 52,
                            code: 'Q40',
                            description: 'worry future important people',
                            categoryId: 53
                        },
                        {
                            itemId: 53,
                            code: 'Q41',
                            description: 'worry health in future',
                            categoryId: 53
                        },
                        {
                            itemId: 54,
                            code: 'Q42',
                            description: 'uncertain about future',
                            categoryId: 53
                        },
                        {
                            itemId: 55,
                            code: 'Q43',
                            description: 'worry end of life',
                            categoryId: 53
                        },
                        {
                            itemId: 56,
                            code: 'Q44',
                            description: 'positive outlook',
                            categoryId: 53
                        },
                        {
                            itemId: 219,
                            code: 'Q167',
                            description: 'worry family future',
                            categoryId: 53
                        },
                        {
                            itemId: 245,
                            code: 'Q186',
                            description: 'worry results',
                            categoryId: 53
                        },
                        {
                            itemId: 246,
                            code: 'Q187',
                            description: 'worry future treatments',
                            categoryId: 53
                        },
                        {
                            itemId: 268,
                            code: 'Q208',
                            description: 'worry mobility loss',
                            categoryId: 53
                        },
                        {
                            itemId: 269,
                            code: 'Q209',
                            description: 'worry become dependent',
                            categoryId: 53
                        },
                        {
                            itemId: 271,
                            code: 'Q211',
                            description: 'feel positive health',
                            categoryId: 53
                        },
                        {
                            itemId: 278,
                            code: 'Q218',
                            description: 'worse outlook future',
                            categoryId: 53
                        },
                        {
                            itemId: 300,
                            code: 'Q240',
                            description: 'unhappy rest life bowel habit',
                            categoryId: 53
                        },
                        {
                            itemId: 359,
                            code: 'Q288',
                            description: 'worry weight loss continues',
                            categoryId: 53
                        },
                        {
                            itemId: 370,
                            code: 'Q299',
                            description: 'worry become more dependent',
                            categoryId: 53
                        },
                        {
                            itemId: 443,
                            code: 'Q368',
                            description: 'worry treatment future health problem',
                            categoryId: 53
                        },
                        {
                            itemId: 445,
                            code: 'Q370',
                            description: 'worry continue work education',
                            categoryId: 53
                        },
                        {
                            itemId: 506,
                            code: 'Q420',
                            description: 'worry chronically ill',
                            categoryId: 53
                        },
                        {
                            itemId: 551,
                            code: 'Q460',
                            description: 'worried dying',
                            categoryId: 53
                        },
                        {
                            itemId: 654,
                            code: 'Q551',
                            description: 'worry blood recover',
                            categoryId: 53
                        },
                        {
                            itemId: 727,
                            code: 'Q609',
                            description: 'plan future',
                            categoryId: 53
                        },
                        {
                            itemId: 728,
                            code: 'Q610',
                            description: 'worries concerns future',
                            categoryId: 53
                        },
                        {
                            itemId: 729,
                            code: 'Q611',
                            description: 'wonder anything done',
                            categoryId: 53
                        },
                        {
                            itemId: 796,
                            code: 'Q671',
                            description: 'EF24 nothing look forward',
                            categoryId: 53
                        },
                        {
                            itemId: 1264,
                            code: 'Q949',
                            description: 'worry hormone tablets body scan',
                            categoryId: 53
                        },
                        {
                            itemId: 1265,
                            code: 'Q950',
                            description: 'worry drugs life',
                            categoryId: 53
                        }, 
                    ]
                },
                {
                    categoryId: 54,
                    categoryName: 'Disease progression',
                    parentId: 53,
                    parentCategoryName: 'Future Outlook',
                    items: [
                        {
                            itemId: 396,
                            code: 'Q323',
                            description: 'worry lose eye',
                            categoryId: 54
                        },
                        {
                            itemId: 659,
                            code: 'Q556',
                            description: 'watch closely new symptoms',
                            categoryId: 54
                        },
                        {
                            itemId: 700,
                            code: 'Q587',
                            description: 'afraid tumor progression',
                            categoryId: 54
                        }, 
                    ]
                },
                {
                    categoryId: 55,
                    categoryName: 'Disease recurrence',
                    parentId: 53,
                    parentCategoryName: 'Future Outlook',
                    items: [
                        {
                            itemId: 391,
                            code: 'Q320',
                            description: 'worry tumor other areas',
                            categoryId: 55
                        },
                        {
                            itemId: 419,
                            code: 'Q345',
                            description: 'worry tumor recur treated eye',
                            categoryId: 55
                        },
                        {
                            itemId: 438,
                            code: 'Q364',
                            description: 'worry recurrence disease',
                            categoryId: 55
                        },
                        {
                            itemId: 441,
                            code: 'Q366',
                            description: 'worry another type cancer',
                            categoryId: 55
                        }, 
                    ]
                },
                {
                    categoryId: 56,
                    categoryName: 'Hopefulness',
                    parentId: 53,
                    parentCategoryName: 'Future Outlook',
                    items: []
                },
                {
                    categoryId: 57,
                    categoryName: 'General Gastrointestinal',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 71,
                            code: 'Q56',
                            description: 'bloated feeling abdomen',
                            categoryId: 57
                        },
                        {
                            itemId: 274,
                            code: 'Q214',
                            description: 'gurgling noise abdomen',
                            categoryId: 57
                        },
                        {
                            itemId: 314,
                            code: 'Q251',
                            description: 'indigestion',
                            categoryId: 57
                        },
                        {
                            itemId: 336,
                            code: 'Q273',
                            description: 'problems clothes tight',
                            categoryId: 57
                        },
                        {
                            itemId: 642,
                            code: 'Q542',
                            description: 'abdomen swelling',
                            categoryId: 57
                        },
                        {
                            itemId: 643,
                            code: 'Q543',
                            description: 'worry appearance abdomen',
                            categoryId: 57
                        },
                        {
                            itemId: 1298,
                            code: 'Q959',
                            description: 'pain upper abdomen',
                            categoryId: 57
                        }, 
                    ]
                },
                {
                    categoryId: 58,
                    categoryName: 'Abdominal pain/cramps',
                    parentId: 57,
                    parentCategoryName: 'General Gastrointestinal',
                    items: [
                        {
                            itemId: 228,
                            code: 'Q170',
                            description: 'discomfort stomach area',
                            categoryId: 58
                        },
                        {
                            itemId: 286,
                            code: 'Q226',
                            description: 'abdominal cramp',
                            categoryId: 58
                        },
                        {
                            itemId: 516,
                            code: 'Q430',
                            description: 'pain abdomen',
                            categoryId: 58
                        },
                        {
                            itemId: 540,
                            code: 'Q450',
                            description: 'cramps abdomen',
                            categoryId: 58
                        },
                        {
                            itemId: 620,
                            code: 'Q524',
                            description: 'abdominal discomfort',
                            categoryId: 58
                        },
                        {
                            itemId: 966,
                            code: 'Q840',
                            description: 'DI09 discomfort DI',
                            categoryId: 58
                        }, 
                    ]
                },
                {
                    categoryId: 59,
                    categoryName: 'Acid reflux',
                    parentId: 57,
                    parentCategoryName: 'General Gastrointestinal',
                    items: [
                        {
                            itemId: 184,
                            code: 'Q140',
                            description: 'acid reflux',
                            categoryId: 59
                        },
                        {
                            itemId: 229,
                            code: 'Q171',
                            description: 'problem acid bile mouth',
                            categoryId: 59
                        },
                        {
                            itemId: 230,
                            code: 'Q172',
                            description: 'acid indigestion heartburn',
                            categoryId: 59
                        }, 
                    ]
                },
                {
                    categoryId: 60,
                    categoryName: 'Belching',
                    parentId: 57,
                    parentCategoryName: 'General Gastrointestinal',
                    items: [
                        {
                            itemId: 231,
                            code: 'Q173',
                            description: 'problem belching',
                            categoryId: 60
                        }, 
                    ]
                },
                {
                    categoryId: 61,
                    categoryName: 'Flatulence/gas',
                    parentId: 57,
                    parentCategoryName: 'General Gastrointestinal',
                    items: []
                },
                {
                    categoryId: 62,
                    categoryName: 'General Physical Health',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 273,
                            code: 'Q213',
                            description: 'setbacks condition',
                            categoryId: 62
                        },
                        {
                            itemId: 452,
                            code: 'Q375',
                            description: 'worry changes weight',
                            categoryId: 62
                        },
                        {
                            itemId: 521,
                            code: 'Q434',
                            description: 'worry weight',
                            categoryId: 62
                        },
                        {
                            itemId: 1245,
                            code: 'Q933',
                            description: 'nose bleed',
                            categoryId: 62
                        },
                        {
                            itemId: 1247,
                            code: 'Q935',
                            description: 'faint',
                            categoryId: 62
                        },
                        {
                            itemId: 1299,
                            code: 'Q960',
                            description: 'loss consciousness',
                            categoryId: 62
                        },
                        {
                            itemId: 1300,
                            code: 'Q961',
                            description: 'feel faint',
                            categoryId: 62
                        }, 
                    ]
                },
                {
                    categoryId: 63,
                    categoryName: 'Allergic reactions',
                    parentId: 62,
                    parentCategoryName: 'General Physical Health',
                    items: [
                        {
                            itemId: 697,
                            code: 'Q584',
                            description: 'allergic reactions',
                            categoryId: 63
                        }, 
                    ]
                },
                {
                    categoryId: 64,
                    categoryName: 'Fever',
                    parentId: 62,
                    parentCategoryName: 'General Physical Health',
                    items: [
                        {
                            itemId: 423,
                            code: 'Q349',
                            description: 'temperature go up down',
                            categoryId: 64
                        },
                        {
                            itemId: 485,
                            code: 'Q400',
                            description: 'fevers',
                            categoryId: 64
                        },
                        {
                            itemId: 644,
                            code: 'Q544',
                            description: 'chills',
                            categoryId: 64
                        },
                        {
                            itemId: 651,
                            code: 'Q548',
                            description: 'fevers chills',
                            categoryId: 64
                        }, 
                    ]
                },
                {
                    categoryId: 65,
                    categoryName: 'Global health',
                    parentId: 62,
                    parentCategoryName: 'General Physical Health',
                    items: [
                        {
                            itemId: 43,
                            code: 'Q32',
                            description: 'global health status',
                            categoryId: 65
                        }, 
                    ]
                },
                {
                    categoryId: 66,
                    categoryName: 'Hot flushes',
                    parentId: 62,
                    parentCategoryName: 'General Physical Health',
                    items: [
                        {
                            itemId: 78,
                            code: 'Q63',
                            description: 'hot flushes',
                            categoryId: 66
                        },
                        {
                            itemId: 560,
                            code: 'Q469',
                            description: 'hot flush sweats',
                            categoryId: 66
                        }, 
                    ]
                },
                {
                    categoryId: 67,
                    categoryName: 'Infections',
                    parentId: 62,
                    parentCategoryName: 'General Physical Health',
                    items: [
                        {
                            itemId: 426,
                            code: 'Q352',
                            description: 'problem other infections',
                            categoryId: 67
                        },
                        {
                            itemId: 427,
                            code: 'Q353',
                            description: 'need antibiotics courses',
                            categoryId: 67
                        },
                        {
                            itemId: 428,
                            code: 'Q354',
                            description: 'worry get infection ',
                            categoryId: 67
                        },
                        {
                            itemId: 1253,
                            code: 'Q941',
                            description: 'infections',
                            categoryId: 67
                        }, 
                    ]
                },
                {
                    categoryId: 68,
                    categoryName: 'Malaise',
                    parentId: 62,
                    parentCategoryName: 'General Physical Health',
                    items: [
                        {
                            itemId: 129,
                            code: 'Q94',
                            description: 'felt ill',
                            categoryId: 68
                        },
                        {
                            itemId: 167,
                            code: 'Q126',
                            description: 'feel ill unwell',
                            categoryId: 68
                        },
                        {
                            itemId: 957,
                            code: 'Q831',
                            description: 'CO10 unwell',
                            categoryId: 68
                        }, 
                    ]
                },
                {
                    categoryId: 69,
                    categoryName: 'Perspiration',
                    parentId: 62,
                    parentCategoryName: 'General Physical Health',
                    items: [
                        {
                            itemId: 366,
                            code: 'Q295',
                            description: 'night sweats',
                            categoryId: 69
                        },
                        {
                            itemId: 453,
                            code: 'Q376',
                            description: 'sweat excessively',
                            categoryId: 69
                        },
                        {
                            itemId: 920,
                            code: 'Q794',
                            description: 'DY03 problem breath sweat',
                            categoryId: 69
                        }, 
                    ]
                },
                {
                    categoryId: 70,
                    categoryName: 'Weakness',
                    parentId: 62,
                    parentCategoryName: 'General Physical Health',
                    items: [
                        {
                            itemId: 26,
                            code: 'Q15',
                            description: 'FA22 weak',
                            categoryId: 70
                        },
                        {
                            itemId: 315,
                            code: 'Q252',
                            description: 'FA15 weak arms legs',
                            categoryId: 70
                        }, 
                    ]
                },
                {
                    categoryId: 71,
                    categoryName: 'Weight gain',
                    parentId: 62,
                    parentCategoryName: 'General Physical Health',
                    items: [
                        {
                            itemId: 87,
                            code: 'Q71',
                            description: 'problem weight gain',
                            categoryId: 71
                        },
                        {
                            itemId: 163,
                            code: 'Q124',
                            description: 'weight gain',
                            categoryId: 71
                        }, 
                    ]
                },
                {
                    categoryId: 72,
                    categoryName: 'Weight loss',
                    parentId: 62,
                    parentCategoryName: 'General Physical Health',
                    items: [
                        {
                            itemId: 6,
                            code: 'Q3',
                            description: 'weight loss problem',
                            categoryId: 72
                        },
                        {
                            itemId: 162,
                            code: 'Q123',
                            description: 'weight loss',
                            categoryId: 72
                        },
                        {
                            itemId: 239,
                            code: 'Q180',
                            description: 'worry weight too low',
                            categoryId: 72
                        },
                        {
                            itemId: 240,
                            code: 'Q181',
                            description: 'worry weight loss',
                            categoryId: 72
                        },
                        {
                            itemId: 359,
                            code: 'Q288',
                            description: 'worry weight loss continues',
                            categoryId: 72
                        },
                        {
                            itemId: 368,
                            code: 'Q297',
                            description: 'feel weight loss control',
                            categoryId: 72
                        },
                        {
                            itemId: 371,
                            code: 'Q300',
                            description: 'problem usual activities weight loss',
                            categoryId: 72
                        },
                        {
                            itemId: 375,
                            code: 'Q304',
                            description: 'adequate information weight loss',
                            categoryId: 72
                        },
                        {
                            itemId: 552,
                            code: 'Q461',
                            description: 'worried lose weight',
                            categoryId: 72
                        },
                        {
                            itemId: 645,
                            code: 'Q545',
                            description: 'worry enough nourishment',
                            categoryId: 72
                        }, 
                    ]
                },
                {
                    categoryId: 73,
                    categoryName: 'General QOL',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 44,
                            code: 'Q33',
                            description: 'global quality of life',
                            categoryId: 73
                        }, 
                    ]
                },
                {
                    categoryId: 74,
                    categoryName: 'General Respiratory',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 944,
                            code: 'Q818',
                            description: 'DY28 cannot breathe',
                            categoryId: 74
                        }, 
                    ]
                },
                {
                    categoryId: 75,
                    categoryName: 'Chest infections',
                    parentId: 74,
                    parentCategoryName: 'General Respiratory',
                    items: [
                        {
                            itemId: 425,
                            code: 'Q351',
                            description: 'problem chest infections',
                            categoryId: 75
                        }, 
                    ]
                },
                {
                    categoryId: 76,
                    categoryName: 'Chest pain',
                    parentId: 74,
                    parentCategoryName: 'General Respiratory',
                    items: []
                },
                {
                    categoryId: 77,
                    categoryName: 'Coughing',
                    parentId: 74,
                    parentCategoryName: 'General Respiratory',
                    items: [
                        {
                            itemId: 125,
                            code: 'Q90',
                            description: 'coughing',
                            categoryId: 77
                        },
                        {
                            itemId: 480,
                            code: 'Q395',
                            description: 'problem coughing',
                            categoryId: 77
                        },
                        {
                            itemId: 497,
                            code: 'Q411',
                            description: 'dry cough',
                            categoryId: 77
                        }, 
                    ]
                },
                {
                    categoryId: 78,
                    categoryName: 'Coughing up blood',
                    parentId: 74,
                    parentCategoryName: 'General Respiratory',
                    items: [
                        {
                            itemId: 561,
                            code: 'Q470',
                            description: 'cough blood',
                            categoryId: 78
                        }, 
                    ]
                },
                {
                    categoryId: 79,
                    categoryName: 'Medical Devices',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 448,
                            code: 'Q372',
                            description: 'dentures',
                            categoryId: 79
                        },
                        {
                            itemId: 450,
                            code: 'Q373',
                            description: 'problem ill fitting dentures',
                            categoryId: 79
                        }, 
                    ]
                },
                {
                    categoryId: 80,
                    categoryName: 'Drainage tubes/bags',
                    parentId: 79,
                    parentCategoryName: 'Medical Devices',
                    items: [
                        {
                            itemId: 221,
                            code: 'Q169',
                            description: 'problem drainage tubes/bags',
                            categoryId: 80
                        }, 
                    ]
                },
                {
                    categoryId: 81,
                    categoryName: 'Feeding tube',
                    parentId: 79,
                    parentCategoryName: 'Medical Devices',
                    items: [
                        {
                            itemId: 161,
                            code: 'Q122',
                            description: 'feeding tube',
                            categoryId: 81
                        }, 
                    ]
                },
                {
                    categoryId: 82,
                    categoryName: 'Pads',
                    parentId: 79,
                    parentCategoryName: 'Medical Devices',
                    items: [
                        {
                            itemId: 66,
                            code: 'Q52',
                            description: 'problem incontinence aid',
                            categoryId: 82
                        },
                        {
                            itemId: 294,
                            code: 'Q234',
                            description: 'wear incontinence aid',
                            categoryId: 82
                        },
                        {
                            itemId: 958,
                            code: 'Q832',
                            description: 'DI01 wear pad',
                            categoryId: 82
                        }, 
                    ]
                },
                {
                    categoryId: 83,
                    categoryName: 'Stoma bag',
                    parentId: 79,
                    parentCategoryName: 'Medical Devices',
                    items: [
                        {
                            itemId: 524,
                            code: 'Q435',
                            description: 'stoma bag',
                            categoryId: 83
                        },
                        {
                            itemId: 527,
                            code: 'Q437',
                            description: 'stoma leak stools',
                            categoryId: 83
                        },
                        {
                            itemId: 528,
                            code: 'Q438',
                            description: 'stoma sore skin',
                            categoryId: 83
                        },
                        {
                            itemId: 529,
                            code: 'Q439',
                            description: 'stoma frequent change day',
                            categoryId: 83
                        },
                        {
                            itemId: 531,
                            code: 'Q441',
                            description: 'embarrassed stoma',
                            categoryId: 83
                        },
                        {
                            itemId: 532,
                            code: 'Q442',
                            description: 'problem care stoma',
                            categoryId: 83
                        }, 
                    ]
                },
                {
                    categoryId: 84,
                    categoryName: 'Testicular implant',
                    parentId: 79,
                    parentCategoryName: 'Medical Devices',
                    items: [
                        {
                            itemId: 209,
                            code: 'Q161',
                            description: 'satisfied testicular implant',
                            categoryId: 84
                        }, 
                    ]
                },
                {
                    categoryId: 85,
                    categoryName: 'Urinary stoma',
                    parentId: 79,
                    parentCategoryName: 'Medical Devices',
                    items: [
                        {
                            itemId: 235,
                            code: 'Q176',
                            description: 'urine bag leak',
                            categoryId: 85
                        },
                        {
                            itemId: 236,
                            code: 'Q177',
                            description: 'problem care urostomy',
                            categoryId: 85
                        },
                        {
                            itemId: 238,
                            code: 'Q179',
                            description: 'skin irritarion urostomy',
                            categoryId: 85
                        },
                        {
                            itemId: 241,
                            code: 'Q182',
                            description: 'embarrassed urostomy',
                            categoryId: 85
                        },
                        {
                            itemId: 242,
                            code: 'Q183',
                            description: 'dependent others urostomy care ',
                            categoryId: 85
                        },
                        {
                            itemId: 243,
                            code: 'Q184',
                            description: 'urostomy bag changes',
                            categoryId: 85
                        },
                        {
                            itemId: 244,
                            code: 'Q185',
                            description: 'problem self-catheterization',
                            categoryId: 85
                        },
                        {
                            itemId: 1159,
                            code: 'Q903',
                            description: 'urine catheter stoma bag',
                            categoryId: 85
                        }, 
                    ]
                },
                {
                    categoryId: 86,
                    categoryName: 'Nausea/Vomiting',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 889,
                            code: 'Q763',
                            description: 'NV03 nausea interfere daily activities',
                            categoryId: 86
                        },
                        {
                            itemId: 890,
                            code: 'Q764',
                            description: 'NV04 severe nausea',
                            categoryId: 86
                        },
                        {
                            itemId: 891,
                            code: 'Q765',
                            description: 'NV05 nausea interfere enjoy life',
                            categoryId: 86
                        },
                        {
                            itemId: 892,
                            code: 'Q766',
                            description: 'NV06 nausea eat less',
                            categoryId: 86
                        },
                        {
                            itemId: 893,
                            code: 'Q767',
                            description: 'NV07 problem nausea',
                            categoryId: 86
                        },
                        {
                            itemId: 894,
                            code: 'Q768',
                            description: 'NV08 nausea interfere physical activity',
                            categoryId: 86
                        },
                        {
                            itemId: 895,
                            code: 'Q769',
                            description: 'NV09 nausea unbearable',
                            categoryId: 86
                        },
                        {
                            itemId: 896,
                            code: 'Q770',
                            description: 'NV10 nausea interfere family life',
                            categoryId: 86
                        },
                        {
                            itemId: 897,
                            code: 'Q771',
                            description: 'NV11 nausea distress',
                            categoryId: 86
                        },
                        {
                            itemId: 899,
                            code: 'Q773',
                            description: 'NV13 nausea interfere leisure',
                            categoryId: 86
                        },
                        {
                            itemId: 900,
                            code: 'Q774',
                            description: 'NV14 nausea interfere appetite',
                            categoryId: 86
                        },
                        {
                            itemId: 901,
                            code: 'Q775',
                            description: 'NV15 nausea day night',
                            categoryId: 86
                        },
                        {
                            itemId: 902,
                            code: 'Q776',
                            description: 'NV16 nausea unable eat',
                            categoryId: 86
                        },
                        {
                            itemId: 904,
                            code: 'Q778',
                            description: 'NV18 nausea less fluid',
                            categoryId: 86
                        },
                        {
                            itemId: 905,
                            code: 'Q779',
                            description: 'NV19 nausea unable eat stomach',
                            categoryId: 86
                        }, 
                    ]
                },
                {
                    categoryId: 87,
                    categoryName: 'Nausea',
                    parentId: 86,
                    parentCategoryName: 'Nausea/Vomiting',
                    items: [
                        {
                            itemId: 28,
                            code: 'Q17',
                            description: 'NV01 nausea',
                            categoryId: 87
                        }, 
                    ]
                },
                {
                    categoryId: 88,
                    categoryName: 'Vomiting',
                    parentId: 86,
                    parentCategoryName: 'Nausea/Vomiting',
                    items: [
                        {
                            itemId: 29,
                            code: 'Q18',
                            description: 'NV02 vomit',
                            categoryId: 88
                        }, 
                    ]
                },
                {
                    categoryId: 89,
                    categoryName: 'Oral',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 72,
                            code: 'Q57',
                            description: 'mouth pain',
                            categoryId: 89
                        },
                        {
                            itemId: 73,
                            code: 'Q58',
                            description: 'jaw pain',
                            categoryId: 89
                        },
                        {
                            itemId: 74,
                            code: 'Q59',
                            description: 'sore mouth',
                            categoryId: 89
                        },
                        {
                            itemId: 81,
                            code: 'Q66',
                            description: 'choked when swallowing',
                            categoryId: 89
                        },
                        {
                            itemId: 82,
                            code: 'Q67',
                            description: 'problem teeth',
                            categoryId: 89
                        },
                        {
                            itemId: 85,
                            code: 'Q69',
                            description: 'problem open mouth',
                            categoryId: 89
                        },
                        {
                            itemId: 89,
                            code: 'Q73',
                            description: 'sticky saliva',
                            categoryId: 89
                        },
                        {
                            itemId: 218,
                            code: 'Q166',
                            description: 'discomfort eating',
                            categoryId: 89
                        },
                        {
                            itemId: 229,
                            code: 'Q171',
                            description: 'problem acid bile mouth',
                            categoryId: 89
                        },
                        {
                            itemId: 442,
                            code: 'Q367',
                            description: 'information dental mouth problems',
                            categoryId: 89
                        },
                        {
                            itemId: 447,
                            code: 'Q371',
                            description: 'satisfied amount information dental mouth problems',
                            categoryId: 89
                        },
                        {
                            itemId: 448,
                            code: 'Q372',
                            description: 'dentures',
                            categoryId: 89
                        },
                        {
                            itemId: 450,
                            code: 'Q373',
                            description: 'problem ill fitting dentures',
                            categoryId: 89
                        },
                        {
                            itemId: 631,
                            code: 'Q531',
                            description: 'problem teeth loss',
                            categoryId: 89
                        },
                        {
                            itemId: 639,
                            code: 'Q539',
                            description: 'problem chew',
                            categoryId: 89
                        },
                        {
                            itemId: 1217,
                            code: 'Q905',
                            description: 'reddening mouth',
                            categoryId: 89
                        },
                        {
                            itemId: 1263,
                            code: 'Q948',
                            description: 'knot throat',
                            categoryId: 89
                        },
                        {
                            itemId: 1266,
                            code: 'Q951',
                            description: 'tingling numbness mouth',
                            categoryId: 89
                        }, 
                    ]
                },
                {
                    categoryId: 90,
                    categoryName: 'Bleeding gums',
                    parentId: 89,
                    parentCategoryName: 'Oral',
                    items: [
                        {
                            itemId: 435,
                            code: 'Q361',
                            description: 'problem bleeding gums',
                            categoryId: 90
                        },
                        {
                            itemId: 1242,
                            code: 'Q930',
                            description: 'bleeding gums',
                            categoryId: 90
                        }, 
                    ]
                },
                {
                    categoryId: 91,
                    categoryName: 'Dry mouth',
                    parentId: 89,
                    parentCategoryName: 'Oral',
                    items: [
                        {
                            itemId: 86,
                            code: 'Q70',
                            description: 'dry mouth',
                            categoryId: 91
                        }, 
                    ]
                },
                {
                    categoryId: 92,
                    categoryName: 'Dysphagia',
                    parentId: 89,
                    parentCategoryName: 'Oral',
                    items: [
                        {
                            itemId: 76,
                            code: 'Q61',
                            description: 'problem drinking liquids',
                            categoryId: 92
                        },
                        {
                            itemId: 77,
                            code: 'Q62',
                            description: 'problem eating liquidised food',
                            categoryId: 92
                        },
                        {
                            itemId: 79,
                            code: 'Q64',
                            description: 'problem eating solid food',
                            categoryId: 92
                        },
                        {
                            itemId: 362,
                            code: 'Q291',
                            description: 'problem swallowing',
                            categoryId: 92
                        },
                        {
                            itemId: 461,
                            code: 'Q383',
                            description: 'problem swallow saliva',
                            categoryId: 92
                        },
                        {
                            itemId: 1141,
                            code: 'Q885',
                            description: 'problem swallowing liquid',
                            categoryId: 92
                        },
                        {
                            itemId: 1142,
                            code: 'Q886',
                            description: 'problem swallow solid food',
                            categoryId: 92
                        },
                        {
                            itemId: 1143,
                            code: 'Q887',
                            description: 'problem pureed food',
                            categoryId: 92
                        }, 
                    ]
                },
                {
                    categoryId: 93,
                    categoryName: 'Feeling thirsty',
                    parentId: 89,
                    parentCategoryName: 'Oral',
                    items: [
                        {
                            itemId: 549,
                            code: 'Q458',
                            description: 'thirsty',
                            categoryId: 93
                        }, 
                    ]
                },
                {
                    categoryId: 94,
                    categoryName: 'Hoarseness',
                    parentId: 89,
                    parentCategoryName: 'Oral',
                    items: [
                        {
                            itemId: 126,
                            code: 'Q91',
                            description: 'hoarseness',
                            categoryId: 94
                        },
                        {
                            itemId: 632,
                            code: 'Q532',
                            description: 'problem hoarse',
                            categoryId: 94
                        },
                        {
                            itemId: 1259,
                            code: 'Q944',
                            description: 'voice sound result disease treatment',
                            categoryId: 94
                        },
                        {
                            itemId: 1260,
                            code: 'Q945',
                            description: 'tired voice',
                            categoryId: 94
                        }, 
                    ]
                },
                {
                    categoryId: 95,
                    categoryName: 'Lip/mouth sores',
                    parentId: 89,
                    parentCategoryName: 'Oral',
                    items: [
                        {
                            itemId: 436,
                            code: 'Q362',
                            description: 'lip sores',
                            categoryId: 95
                        },
                        {
                            itemId: 437,
                            code: 'Q363',
                            description: 'sores corners mouth',
                            categoryId: 95
                        }, 
                    ]
                },
                {
                    categoryId: 96,
                    categoryName: 'Throat pain',
                    parentId: 89,
                    parentCategoryName: 'Oral',
                    items: []
                },
                {
                    categoryId: 97,
                    categoryName: 'Pain',
                    parentId: null,
                    parentCategoryName: null,
                    items: []
                },
                {
                    categoryId: 98,
                    categoryName: 'Generalized',
                    parentId: 97,
                    parentCategoryName: 'Pain',
                    items: [
                        {
                            itemId: 23,
                            code: 'Q12',
                            description: 'PA16 pain',
                            categoryId: 98
                        }, 
                    ]
                },
                {
                    categoryId: 99,
                    categoryName: 'Headaches',
                    parentId: 97,
                    parentCategoryName: 'Pain',
                    items: [
                        {
                            itemId: 168,
                            code: 'Q127',
                            description: 'headaches',
                            categoryId: 99
                        }, 
                    ]
                },
                {
                    categoryId: 100,
                    categoryName: 'Localized',
                    parentId: 97,
                    parentCategoryName: 'Pain',
                    items: [
                        {
                            itemId: 72,
                            code: 'Q57',
                            description: 'mouth pain',
                            categoryId: 100
                        },
                        {
                            itemId: 73,
                            code: 'Q58',
                            description: 'jaw pain',
                            categoryId: 100
                        },
                        {
                            itemId: 74,
                            code: 'Q59',
                            description: 'sore mouth',
                            categoryId: 100
                        },
                        {
                            itemId: 174,
                            code: 'Q131',
                            description: 'pain arm shoulder',
                            categoryId: 100
                        },
                        {
                            itemId: 177,
                            code: 'Q134',
                            description: 'pain area affected breast',
                            categoryId: 100
                        },
                        {
                            itemId: 212,
                            code: 'Q163',
                            description: 'pain back',
                            categoryId: 100
                        },
                        {
                            itemId: 233,
                            code: 'Q174',
                            description: 'pain burning feeling urinate',
                            categoryId: 100
                        },
                        {
                            itemId: 250,
                            code: 'Q191',
                            description: 'pain in back',
                            categoryId: 100
                        },
                        {
                            itemId: 251,
                            code: 'Q192',
                            description: 'pain in legs/hips',
                            categoryId: 100
                        },
                        {
                            itemId: 252,
                            code: 'Q193',
                            description: 'pain in arms/shoulders',
                            categoryId: 100
                        },
                        {
                            itemId: 253,
                            code: 'Q194',
                            description: 'pain in chest/ribs',
                            categoryId: 100
                        },
                        {
                            itemId: 254,
                            code: 'Q195',
                            description: 'pain in buttocks',
                            categoryId: 100
                        },
                        {
                            itemId: 286,
                            code: 'Q226',
                            description: 'abdominal cramp',
                            categoryId: 100
                        },
                        {
                            itemId: 287,
                            code: 'Q227',
                            description: 'pain cramp rectum',
                            categoryId: 100
                        },
                        {
                            itemId: 288,
                            code: 'Q228',
                            description: 'pain discomfort anus',
                            categoryId: 100
                        },
                        {
                            itemId: 377,
                            code: 'Q306',
                            description: 'pain soreness discomfort treated eye',
                            categoryId: 100
                        },
                        {
                            itemId: 392,
                            code: 'Q321',
                            description: 'cramps hands',
                            categoryId: 100
                        },
                        {
                            itemId: 393,
                            code: 'Q322',
                            description: 'cramps feet',
                            categoryId: 100
                        },
                        {
                            itemId: 516,
                            code: 'Q430',
                            description: 'pain abdomen',
                            categoryId: 100
                        },
                        {
                            itemId: 517,
                            code: 'Q431',
                            description: 'pain buttock anal area rectum',
                            categoryId: 100
                        },
                        {
                            itemId: 547,
                            code: 'Q456',
                            description: 'pain lower back',
                            categoryId: 100
                        },
                        {
                            itemId: 703,
                            code: 'Q590',
                            description: 'pain area surgery',
                            categoryId: 100
                        },
                        {
                            itemId: 1258,
                            code: 'Q943',
                            description: 'discomfort neck',
                            categoryId: 100
                        }, 
                    ]
                },
                {
                    categoryId: 101,
                    categoryName: 'Physical Functioning',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 17,
                            code: 'Q8',
                            description: 'PF13 need stay bed chair ',
                            categoryId: 101
                        },
                        {
                            itemId: 18,
                            code: 'Q9',
                            description: 'PF05 help with daily living',
                            categoryId: 101
                        },
                        {
                            itemId: 193,
                            code: 'Q148',
                            description: 'physically limited disease treatment',
                            categoryId: 101
                        },
                        {
                            itemId: 200,
                            code: 'Q154',
                            description: 'less active',
                            categoryId: 101
                        },
                        {
                            itemId: 312,
                            code: 'Q249',
                            description: 'uncomfortable position',
                            categoryId: 101
                        },
                        {
                            itemId: 431,
                            code: 'Q357',
                            description: ' short breath exertion',
                            categoryId: 101
                        },
                        {
                            itemId: 629,
                            code: 'Q529',
                            description: 'limited travel',
                            categoryId: 101
                        },
                        {
                            itemId: 702,
                            code: 'Q589',
                            description: 'decrease physical capabilities',
                            categoryId: 101
                        },
                        {
                            itemId: 705,
                            code: 'Q592',
                            description: 'restricted performance surgery',
                            categoryId: 101
                        },
                        {
                            itemId: 706,
                            code: 'Q593',
                            description: 'problem use arm shoulder operation',
                            categoryId: 101
                        },
                        {
                            itemId: 753,
                            code: 'Q628',
                            description: 'PF03 need help footcare',
                            categoryId: 101
                        },
                        {
                            itemId: 755,
                            code: 'Q630',
                            description: 'PF06 help grooming',
                            categoryId: 101
                        },
                        {
                            itemId: 759,
                            code: 'Q634',
                            description: 'PF10',
                            categoryId: 101
                        },
                        {
                            itemId: 762,
                            code: 'Q637',
                            description: 'PF14 need help put on shirt',
                            categoryId: 101
                        },
                        {
                            itemId: 767,
                            code: 'Q642',
                            description: 'PF21 need help wash face hands',
                            categoryId: 101
                        },
                        {
                            itemId: 772,
                            code: 'Q647',
                            description: 'PF27 need help undress',
                            categoryId: 101
                        },
                        {
                            itemId: 774,
                            code: 'Q649',
                            description: 'PF28 need help eat',
                            categoryId: 101
                        },
                        {
                            itemId: 851,
                            code: 'Q726',
                            description: 'FA04 weak things',
                            categoryId: 101
                        }, 
                    ]
                },
                {
                    categoryId: 102,
                    categoryName: 'Bending',
                    parentId: 101,
                    parentCategoryName: 'Physical Functioning',
                    items: [
                        {
                            itemId: 764,
                            code: 'Q639',
                            description: 'PF17 problems bend pick',
                            categoryId: 102
                        },
                        {
                            itemId: 926,
                            code: 'Q800',
                            description: 'DY10 short breath bend',
                            categoryId: 102
                        }, 
                    ]
                },
                {
                    categoryId: 103,
                    categoryName: 'Climbing stairs',
                    parentId: 101,
                    parentCategoryName: 'Physical Functioning',
                    items: [
                        {
                            itemId: 46,
                            code: 'Q34',
                            description: 'problems steps or stairs',
                            categoryId: 103
                        },
                        {
                            itemId: 408,
                            code: 'Q335',
                            description: 'problem stairs chair weak legs',
                            categoryId: 103
                        },
                        {
                            itemId: 565,
                            code: 'Q474',
                            description: 'short breath stairs',
                            categoryId: 103
                        },
                        {
                            itemId: 754,
                            code: 'Q629',
                            description: 'PF04 problems walk up stairs',
                            categoryId: 103
                        },
                        {
                            itemId: 868,
                            code: 'Q742',
                            description: 'FA26 tired stairs',
                            categoryId: 103
                        },
                        {
                            itemId: 941,
                            code: 'Q815',
                            description: 'DY25 short breath walk up flight stairs',
                            categoryId: 103
                        },
                        {
                            itemId: 946,
                            code: 'Q820',
                            description: 'DY30 short breath go up few steps',
                            categoryId: 103
                        }, 
                    ]
                },
                {
                    categoryId: 104,
                    categoryName: 'Coordination',
                    parentId: 101,
                    parentCategoryName: 'Physical Functioning',
                    items: [
                        {
                            itemId: 301,
                            code: 'Q241',
                            description: 'problem coordination',
                            categoryId: 104
                        }, 
                    ]
                },
                {
                    categoryId: 105,
                    categoryName: 'Lifting/carrying',
                    parentId: 101,
                    parentCategoryName: 'Physical Functioning',
                    items: [
                        {
                            itemId: 7,
                            code: 'Q4',
                            description: 'PF15 problems carry bags',
                            categoryId: 105
                        },
                        {
                            itemId: 751,
                            code: 'Q626',
                            description: 'PF01 problems lift cup glass mouth',
                            categoryId: 105
                        },
                        {
                            itemId: 757,
                            code: 'Q632',
                            description: 'PF08 problems lift 10 kg',
                            categoryId: 105
                        },
                        {
                            itemId: 766,
                            code: 'Q641',
                            description: 'PF20 problems carry bag upstairs',
                            categoryId: 105
                        },
                        {
                            itemId: 770,
                            code: 'Q645',
                            description: 'PF25 problems carry 5 kg',
                            categoryId: 105
                        },
                        {
                            itemId: 773,
                            code: 'Q648',
                            description: 'PF28 problems carry both hands upstairs',
                            categoryId: 105
                        },
                        {
                            itemId: 775,
                            code: 'Q650',
                            description: 'PF30 problems lift pot',
                            categoryId: 105
                        }, 
                    ]
                },
                {
                    categoryId: 106,
                    categoryName: 'Mobility',
                    parentId: 101,
                    parentCategoryName: 'Physical Functioning',
                    items: [
                        {
                            itemId: 48,
                            code: 'Q36',
                            description: 'unsteady on feet',
                            categoryId: 106
                        },
                        {
                            itemId: 176,
                            code: 'Q133',
                            description: 'problem move arm',
                            categoryId: 106
                        },
                        {
                            itemId: 268,
                            code: 'Q208',
                            description: 'worry mobility loss',
                            categoryId: 106
                        },
                        {
                            itemId: 397,
                            code: 'Q324',
                            description: 'problem standing walking feeling ground',
                            categoryId: 106
                        },
                        {
                            itemId: 404,
                            code: 'Q331',
                            description: 'problem steps pavements',
                            categoryId: 106
                        },
                        {
                            itemId: 407,
                            code: 'Q334',
                            description: 'problem walking downstairs uneven ground',
                            categoryId: 106
                        }, 
                    ]
                },
                {
                    categoryId: 107,
                    categoryName: 'Reaching/grasping',
                    parentId: 101,
                    parentCategoryName: 'Physical Functioning',
                    items: [
                        {
                            itemId: 763,
                            code: 'Q638',
                            description: 'PF16 problems reach object above head',
                            categoryId: 107
                        }, 
                    ]
                },
                {
                    categoryId: 108,
                    categoryName: 'Running',
                    parentId: 10,
                    parentCategoryName: 'Constipation',
                    items: [
                        {
                            itemId: 765,
                            code: 'Q640',
                            description: 'PF18 problems run fast',
                            categoryId: 108
                        },
                        {
                            itemId: 768,
                            code: 'Q643',
                            description: 'PF22 problems run 100 m',
                            categoryId: 108
                        },
                        {
                            itemId: 776,
                            code: 'Q651',
                            description: 'PF31 problems run short',
                            categoryId: 108
                        }, 
                    ]
                },
                {
                    categoryId: 109,
                    categoryName: 'Sitting',
                    parentId: 101,
                    parentCategoryName: 'Physical Functioning',
                    items: [
                        {
                            itemId: 864,
                            code: 'Q738',
                            description: 'FA21 problems sit tired',
                            categoryId: 109
                        },
                        {
                            itemId: 1150,
                            code: 'Q894',
                            description: 'problem sit genital area',
                            categoryId: 109
                        }, 
                    ]
                },
                {
                    categoryId: 110,
                    categoryName: 'Standing',
                    parentId: 101,
                    parentCategoryName: 'Physical Functioning',
                    items: [
                        {
                            itemId: 409,
                            code: 'Q336',
                            description: 'dizzy stan up sitting lying position',
                            categoryId: 110
                        },
                        {
                            itemId: 942,
                            code: 'Q816',
                            description: 'DY26 short breath stand up chair',
                            categoryId: 110
                        }, 
                    ]
                },
                {
                    categoryId: 111,
                    categoryName: 'Walking',
                    parentId: 101,
                    parentCategoryName: 'Physical Functioning',
                    items: [
                        {
                            itemId: 8,
                            code: 'Q5',
                            description: 'PF24 problems long walk',
                            categoryId: 111
                        },
                        {
                            itemId: 9,
                            code: 'Q6',
                            description: 'PF19 problems short walk',
                            categoryId: 111
                        },
                        {
                            itemId: 564,
                            code: 'Q473',
                            description: 'short breath walk',
                            categoryId: 111
                        },
                        {
                            itemId: 752,
                            code: 'Q627',
                            description: 'PF02 problems walk 100 m',
                            categoryId: 111
                        },
                        {
                            itemId: 756,
                            code: 'Q631',
                            description: 'PF07 problems walk 30 min',
                            categoryId: 111
                        },
                        {
                            itemId: 758,
                            code: 'Q633',
                            description: 'PF09 problems hike 3 km uneven',
                            categoryId: 111
                        },
                        {
                            itemId: 760,
                            code: 'Q635',
                            description: 'PF11 problems walking outdoors flat',
                            categoryId: 111
                        },
                        {
                            itemId: 761,
                            code: 'Q636',
                            description: 'PF12 problems steps',
                            categoryId: 111
                        },
                        {
                            itemId: 769,
                            code: 'Q644',
                            description: 'PF23 problems walk carry back',
                            categoryId: 111
                        },
                        {
                            itemId: 771,
                            code: 'Q646',
                            description: 'PF26',
                            categoryId: 111
                        },
                        {
                            itemId: 873,
                            code: 'Q747',
                            description: 'FA33 tired long activity',
                            categoryId: 111
                        },
                        {
                            itemId: 894,
                            code: 'Q768',
                            description: 'NV08 nausea interfere physical activity',
                            categoryId: 111
                        },
                        {
                            itemId: 929,
                            code: 'Q803',
                            description: 'DY13 short breath moderate activity',
                            categoryId: 111
                        },
                        {
                            itemId: 933,
                            code: 'Q807',
                            description: 'DY17 short breath walk 100 m',
                            categoryId: 111
                        },
                        {
                            itemId: 935,
                            code: 'Q809',
                            description: 'DY19 stop breath walk',
                            categoryId: 111
                        },
                        {
                            itemId: 937,
                            code: 'Q811',
                            description: 'DY21 short breath walk',
                            categoryId: 111
                        },
                        {
                            itemId: 939,
                            code: 'Q813',
                            description: 'DY23 short breath walk level ground',
                            categoryId: 111
                        },
                        {
                            itemId: 943,
                            code: 'Q817',
                            description: 'DY27 short breath walk less 100 m',
                            categoryId: 111
                        },
                        {
                            itemId: 947,
                            code: 'Q821',
                            description: 'DY31 short breath walk around home',
                            categoryId: 111
                        }, 
                    ]
                },
                {
                    categoryId: 112,
                    categoryName: 'Recreation/Leisure',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 57,
                            code: 'Q45',
                            description: 'motivated continue hobbies',
                            categoryId: 112
                        },
                        {
                            itemId: 861,
                            code: 'Q735',
                            description: 'FA14 leisure exhausting',
                            categoryId: 112
                        },
                        {
                            itemId: 899,
                            code: 'Q773',
                            description: 'NV13 nausea interfere leisure',
                            categoryId: 112
                        }, 
                    ]
                },
                {
                    categoryId: 113,
                    categoryName: 'Reproductive',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 209,
                            code: 'Q161',
                            description: 'satisfied testicular implant',
                            categoryId: 113
                        },
                        {
                            itemId: 559,
                            code: 'Q468',
                            description: 'abnormal bleed vagina',
                            categoryId: 113
                        },
                        {
                            itemId: 1145,
                            code: 'Q889',
                            description: 'itchy irritated skin genital area',
                            categoryId: 113
                        },
                        {
                            itemId: 1146,
                            code: 'Q890',
                            description: 'sore skin genital area',
                            categoryId: 113
                        },
                        {
                            itemId: 1147,
                            code: 'Q891',
                            description: 'tear split skin genital area',
                            categoryId: 113
                        },
                        {
                            itemId: 1149,
                            code: 'Q893',
                            description: 'problem scar genital area',
                            categoryId: 113
                        },
                        {
                            itemId: 1150,
                            code: 'Q894',
                            description: 'problem sit genital area',
                            categoryId: 113
                        },
                        {
                            itemId: 1152,
                            code: 'Q896',
                            description: 'swelling genital area',
                            categoryId: 113
                        },
                        {
                            itemId: 1153,
                            code: 'Q897',
                            description: 'tight skin genital area',
                            categoryId: 113
                        },
                        {
                            itemId: 1154,
                            code: 'Q898',
                            description: 'swelling groin',
                            categoryId: 113
                        },
                        {
                            itemId: 1155,
                            code: 'Q899',
                            description: 'sore skin groin',
                            categoryId: 113
                        }, 
                    ]
                },
                {
                    categoryId: 114,
                    categoryName: 'Getting/maintaining erection',
                    parentId: 113,
                    parentCategoryName: 'Reproductive',
                    items: [
                        {
                            itemId: 94,
                            code: 'Q77',
                            description: 'problem erection',
                            categoryId: 114
                        },
                        {
                            itemId: 145,
                            code: 'Q107',
                            description: 'confident about erection',
                            categoryId: 114
                        }, 
                    ]
                },
                {
                    categoryId: 115,
                    categoryName: 'Ejaculation',
                    parentId: 113,
                    parentCategoryName: 'Reproductive',
                    items: [
                        {
                            itemId: 95,
                            code: 'Q78',
                            description: 'problem ejaculation',
                            categoryId: 115
                        }, 
                    ]
                },
                {
                    categoryId: 116,
                    categoryName: 'Fertility',
                    parentId: 113,
                    parentCategoryName: 'Reproductive',
                    items: [
                        {
                            itemId: 201,
                            code: 'Q155',
                            description: 'worry fertility',
                            categoryId: 116
                        }, 
                    ]
                },
                {
                    categoryId: 117,
                    categoryName: 'Vaginal discharge',
                    parentId: 113,
                    parentCategoryName: 'Reproductive',
                    items: [
                        {
                            itemId: 557,
                            code: 'Q466',
                            description: 'vaginal discharge',
                            categoryId: 117
                        },
                        {
                            itemId: 1151,
                            code: 'Q895',
                            description: 'discharge vagina genital area',
                            categoryId: 117
                        }, 
                    ]
                },
                {
                    categoryId: 118,
                    categoryName: 'Vaginal discomfort',
                    parentId: 113,
                    parentCategoryName: 'Reproductive',
                    items: [
                        {
                            itemId: 1225,
                            code: 'Q913',
                            description: 'discomfort vagina',
                            categoryId: 118
                        },
                        {
                            itemId: 1226,
                            code: 'Q914',
                            description: 'pain vagina sex',
                            categoryId: 118
                        }, 
                    ]
                },
                {
                    categoryId: 119,
                    categoryName: 'Vaginal dryness',
                    parentId: 113,
                    parentCategoryName: 'Reproductive',
                    items: [
                        {
                            itemId: 563,
                            code: 'Q472',
                            description: 'vagina dry sex',
                            categoryId: 119
                        },
                        {
                            itemId: 1224,
                            code: 'Q912',
                            description: 'dry vagina',
                            categoryId: 119
                        }, 
                    ]
                },
                {
                    categoryId: 120,
                    categoryName: 'Vaginal tightness',
                    parentId: 113,
                    parentCategoryName: 'Reproductive',
                    items: [
                        {
                            itemId: 567,
                            code: 'Q476',
                            description: 'vagina short ',
                            categoryId: 120
                        },
                        {
                            itemId: 569,
                            code: 'Q477',
                            description: 'vagina tight',
                            categoryId: 120
                        },
                        {
                            itemId: 591,
                            code: 'Q497',
                            description: 'vagina short tight',
                            categoryId: 120
                        },
                        {
                            itemId: 1100,
                            code: 'Q858',
                            description: 'vagina narrow tight',
                            categoryId: 120
                        },
                        {
                            itemId: 1148,
                            code: 'Q892',
                            description: 'narrow tight vaginal entrance',
                            categoryId: 120
                        },
                        {
                            itemId: 1160,
                            code: 'Q904',
                            description: 'narrow tight vagina sex',
                            categoryId: 120
                        }, 
                    ]
                },
                {
                    categoryId: 121,
                    categoryName: 'Role Functioning\xa0',
                    parentId: null,
                    parentCategoryName: null,
                    items: []
                },
                {
                    categoryId: 122,
                    categoryName: 'Household tasks',
                    parentId: 121,
                    parentCategoryName: 'Role Functioning\xa0',
                    items: [
                        {
                            itemId: 797,
                            code: 'Q672',
                            description: 'RF01 limit household tasks',
                            categoryId: 122
                        },
                        {
                            itemId: 798,
                            code: 'Q673',
                            description: 'RF02 limit light housework',
                            categoryId: 122
                        },
                        {
                            itemId: 802,
                            code: 'Q677',
                            description: 'RF06 limit repairs maintenance',
                            categoryId: 122
                        },
                        {
                            itemId: 803,
                            code: 'Q678',
                            description: 'RF07 limit finances',
                            categoryId: 122
                        },
                        {
                            itemId: 804,
                            code: 'Q679',
                            description: 'RF09 limit heavy household',
                            categoryId: 122
                        }, 
                    ]
                },
                {
                    categoryId: 123,
                    categoryName: 'Work/school',
                    parentId: 121,
                    parentCategoryName: 'Role Functioning\xa0',
                    items: [
                        {
                            itemId: 10,
                            code: 'Q7',
                            description: 'RF08 limit work daily activities',
                            categoryId: 123
                        },
                        {
                            itemId: 192,
                            code: 'Q147',
                            description: 'problem job education',
                            categoryId: 123
                        },
                        {
                            itemId: 444,
                            code: 'Q369',
                            description: 'problem work/study',
                            categoryId: 123
                        },
                        {
                            itemId: 445,
                            code: 'Q370',
                            description: 'worry continue work education',
                            categoryId: 123
                        },
                        {
                            itemId: 800,
                            code: 'Q675',
                            description: 'RF04 need help work daily activity',
                            categoryId: 123
                        },
                        {
                            itemId: 889,
                            code: 'Q763',
                            description: 'NV03 nausea interfere daily activities',
                            categoryId: 123
                        }, 
                    ]
                },
                {
                    categoryId: 124,
                    categoryName: 'Satisfaction with Care – Health Care Setting',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 189,
                            code: 'Q145',
                            description: 'satisfied medical care',
                            categoryId: 124
                        },
                        {
                            itemId: 688,
                            code: 'Q579',
                            description: 'waiting time results __tests__',
                            categoryId: 124
                        },
                        {
                            itemId: 689,
                            code: 'Q580',
                            description: 'speed medical __tests__ treatments',
                            categoryId: 124
                        },
                        {
                            itemId: 690,
                            code: 'Q581',
                            description: 'ease access',
                            categoryId: 124
                        },
                        {
                            itemId: 691,
                            code: 'Q582',
                            description: 'ease find departments',
                            categoryId: 124
                        },
                        {
                            itemId: 692,
                            code: 'Q583',
                            description: 'environment building',
                            categoryId: 124
                        },
                        {
                            itemId: 1122,
                            code: 'Q869',
                            description: 'ease recognise roles HCPs',
                            categoryId: 124
                        },
                        {
                            itemId: 1128,
                            code: 'Q875',
                            description: 'wait time test treatment',
                            categoryId: 124
                        },
                        {
                            itemId: 1129,
                            code: 'Q876',
                            description: 'privacy examine treat',
                            categoryId: 124
                        },
                        {
                            itemId: 1130,
                            code: 'Q877',
                            description: 'family involved care',
                            categoryId: 124
                        },
                        {
                            itemId: 1134,
                            code: 'Q878',
                            description: 'see same HCPs outpatient',
                            categoryId: 124
                        },
                        {
                            itemId: 1135,
                            code: 'Q879',
                            description: 'arrange appointment',
                            categoryId: 124
                        },
                        {
                            itemId: 1136,
                            code: 'Q880',
                            description: 'waiting time obtain appointment',
                            categoryId: 124
                        }, 
                    ]
                },
                {
                    categoryId: 125,
                    categoryName: 'Satisfaction with Care – Information and Communication',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 190,
                            code: 'Q146',
                            description: 'satisfied information disease treatment',
                            categoryId: 125
                        },
                        {
                            itemId: 375,
                            code: 'Q304',
                            description: 'adequate information weight loss',
                            categoryId: 125
                        },
                        {
                            itemId: 442,
                            code: 'Q367',
                            description: 'information dental mouth problems',
                            categoryId: 125
                        },
                        {
                            itemId: 447,
                            code: 'Q371',
                            description: 'satisfied amount information dental mouth problems',
                            categoryId: 125
                        },
                        {
                            itemId: 465,
                            code: 'Q387',
                            description: 'satisfied received information',
                            categoryId: 125
                        },
                        {
                            itemId: 475,
                            code: 'Q390',
                            description: 'opportunities talk professionals',
                            categoryId: 125
                        },
                        {
                            itemId: 478,
                            code: 'Q393',
                            description: 'free ask questions',
                            categoryId: 125
                        },
                        {
                            itemId: 486,
                            code: 'Q401',
                            description: 'patient HCP time talk',
                            categoryId: 125
                        },
                        {
                            itemId: 494,
                            code: 'Q409',
                            description: 'patient HCP language',
                            categoryId: 125
                        },
                        {
                            itemId: 495,
                            code: 'Q410',
                            description: 'patient HCP answer openly',
                            categoryId: 125
                        },
                        {
                            itemId: 503,
                            code: 'Q417',
                            description: 'patient HCP listen emotions',
                            categoryId: 125
                        },
                        {
                            itemId: 507,
                            code: 'Q421',
                            description: 'HCP account preferences information',
                            categoryId: 125
                        },
                        {
                            itemId: 508,
                            code: 'Q422',
                            description: 'patient HCP check information',
                            categoryId: 125
                        },
                        {
                            itemId: 509,
                            code: 'Q423',
                            description: 'HCP check understand information',
                            categoryId: 125
                        },
                        {
                            itemId: 511,
                            code: 'Q425',
                            description: 'HCP explain again',
                            categoryId: 125
                        },
                        {
                            itemId: 512,
                            code: 'Q426',
                            description: 'HCP answer difficult questions',
                            categoryId: 125
                        },
                        {
                            itemId: 513,
                            code: 'Q427',
                            description: 'HCP explain treatment aims',
                            categoryId: 125
                        },
                        {
                            itemId: 514,
                            code: 'Q428',
                            description: 'HCP privacy',
                            categoryId: 125
                        },
                        {
                            itemId: 515,
                            code: 'Q429',
                            description: 'satisfied HCP communication',
                            categoryId: 125
                        },
                        {
                            itemId: 573,
                            code: 'Q479',
                            description: 'diagnosis',
                            categoryId: 125
                        },
                        {
                            itemId: 574,
                            code: 'Q480',
                            description: 'extent disease',
                            categoryId: 125
                        },
                        {
                            itemId: 575,
                            code: 'Q481',
                            description: 'possible causes',
                            categoryId: 125
                        },
                        {
                            itemId: 576,
                            code: 'Q482',
                            description: 'disease control',
                            categoryId: 125
                        },
                        {
                            itemId: 577,
                            code: 'Q483',
                            description: 'purpose __tests__',
                            categoryId: 125
                        },
                        {
                            itemId: 578,
                            code: 'Q484',
                            description: 'procedures __tests__',
                            categoryId: 125
                        },
                        {
                            itemId: 580,
                            code: 'Q486',
                            description: 'results medical __tests__',
                            categoryId: 125
                        },
                        {
                            itemId: 582,
                            code: 'Q488',
                            description: 'medical treatment',
                            categoryId: 125
                        },
                        {
                            itemId: 583,
                            code: 'Q489',
                            description: 'benefit treatment',
                            categoryId: 125
                        },
                        {
                            itemId: 585,
                            code: 'Q491',
                            description: 'side effects',
                            categoryId: 125
                        },
                        {
                            itemId: 587,
                            code: 'Q493',
                            description: 'expected effects symptoms',
                            categoryId: 125
                        },
                        {
                            itemId: 588,
                            code: 'Q494',
                            description: 'effects treatment social family life',
                            categoryId: 125
                        },
                        {
                            itemId: 589,
                            code: 'Q495',
                            description: 'effects treatment sexual activity',
                            categoryId: 125
                        },
                        {
                            itemId: 590,
                            code: 'Q496',
                            description: 'help outside hospital',
                            categoryId: 125
                        },
                        {
                            itemId: 592,
                            code: 'Q498',
                            description: 'rehabilitation',
                            categoryId: 125
                        },
                        {
                            itemId: 593,
                            code: 'Q499',
                            description: 'aspects managing home',
                            categoryId: 125
                        },
                        {
                            itemId: 594,
                            code: 'Q500',
                            description: 'psychological support',
                            categoryId: 125
                        },
                        {
                            itemId: 595,
                            code: 'Q501',
                            description: 'places care',
                            categoryId: 125
                        },
                        {
                            itemId: 599,
                            code: 'Q504',
                            description: 'help get well',
                            categoryId: 125
                        },
                        {
                            itemId: 600,
                            code: 'Q505',
                            description: 'written information',
                            categoryId: 125
                        },
                        {
                            itemId: 601,
                            code: 'Q506',
                            description: 'information cd tape video',
                            categoryId: 125
                        },
                        {
                            itemId: 602,
                            code: 'Q507',
                            description: 'satisfied amount information',
                            categoryId: 125
                        },
                        {
                            itemId: 603,
                            code: 'Q508',
                            description: 'wish more information',
                            categoryId: 125
                        },
                        {
                            itemId: 605,
                            code: 'Q509',
                            description: 'wish less information',
                            categoryId: 125
                        },
                        {
                            itemId: 606,
                            code: 'Q510',
                            description: 'information helpful',
                            categoryId: 125
                        },
                        {
                            itemId: 630,
                            code: 'Q530',
                            description: 'problem adequate information',
                            categoryId: 125
                        },
                        {
                            itemId: 672,
                            code: 'Q563',
                            description: 'information illness',
                            categoryId: 125
                        },
                        {
                            itemId: 673,
                            code: 'Q564',
                            description: 'information medical test',
                            categoryId: 125
                        },
                        {
                            itemId: 674,
                            code: 'Q565',
                            description: 'information treatment',
                            categoryId: 125
                        },
                        {
                            itemId: 681,
                            code: 'Q572',
                            description: 'information care',
                            categoryId: 125
                        },
                        {
                            itemId: 684,
                            code: 'Q575',
                            description: 'exchange information caregivers',
                            categoryId: 125
                        },
                        {
                            itemId: 686,
                            code: 'Q577',
                            description: 'information admission hospital',
                            categoryId: 125
                        },
                        {
                            itemId: 687,
                            code: 'Q578',
                            description: 'information discharge hospital',
                            categoryId: 125
                        },
                        {
                            itemId: 1112,
                            code: 'Q863',
                            description: 'information __tests__ treatment',
                            categoryId: 125
                        },
                        {
                            itemId: 1118,
                            code: 'Q866',
                            description: 'information care treatment',
                            categoryId: 125
                        },
                        {
                            itemId: 1124,
                            code: 'Q871',
                            description: 'information care services community',
                            categoryId: 125
                        },
                        {
                            itemId: 1125,
                            code: 'Q872',
                            description: 'information schedule test',
                            categoryId: 125
                        },
                        {
                            itemId: 1126,
                            code: 'Q873',
                            description: 'information support service',
                            categoryId: 125
                        },
                        {
                            itemId: 1127,
                            code: 'Q874',
                            description: 'information improve prevent',
                            categoryId: 125
                        },
                        {
                            itemId: 1137,
                            code: 'Q881',
                            description: 'communicate hospital home',
                            categoryId: 125
                        },
                        {
                            itemId: 1138,
                            code: 'Q882',
                            description: 'information should do after hospital',
                            categoryId: 125
                        },
                        {
                            itemId: 1139,
                            code: 'Q883',
                            description: 'information contact hospital',
                            categoryId: 125
                        }, 
                    ]
                },
                {
                    categoryId: 126,
                    categoryName: 'Satisfaction with Care – Quality of Care from HCPs',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 320,
                            code: 'Q257',
                            description: 'adequate support HCP',
                            categoryId: 126
                        },
                        {
                            itemId: 464,
                            code: 'Q386',
                            description: 'satisfied received care',
                            categoryId: 126
                        },
                        {
                            itemId: 483,
                            code: 'Q398',
                            description: 'patient HCP understanding disease',
                            categoryId: 126
                        },
                        {
                            itemId: 484,
                            code: 'Q399',
                            description: 'patient HCP mutual trust ',
                            categoryId: 126
                        },
                        {
                            itemId: 487,
                            code: 'Q402',
                            description: 'patient HCP approach equal',
                            categoryId: 126
                        },
                        {
                            itemId: 488,
                            code: 'Q403',
                            description: 'HCP sincere',
                            categoryId: 126
                        },
                        {
                            itemId: 491,
                            code: 'Q406',
                            description: 'patient HCP easy talk openly',
                            categoryId: 126
                        },
                        {
                            itemId: 492,
                            code: 'Q407',
                            description: 'patient HCP respect',
                            categoryId: 126
                        },
                        {
                            itemId: 493,
                            code: 'Q408',
                            description: 'problem HCP seriously',
                            categoryId: 126
                        },
                        {
                            itemId: 498,
                            code: 'Q412',
                            description: 'patient HCP look conversation',
                            categoryId: 126
                        },
                        {
                            itemId: 499,
                            code: 'Q413',
                            description: 'HCP calm voice',
                            categoryId: 126
                        },
                        {
                            itemId: 500,
                            code: 'Q414',
                            description: 'patient HCP understand situation',
                            categoryId: 126
                        },
                        {
                            itemId: 505,
                            code: 'Q419',
                            description: 'HCP help manage emotions',
                            categoryId: 126
                        },
                        {
                            itemId: 655,
                            code: 'Q552',
                            description: 'satisfied prepare treatment',
                            categoryId: 126
                        },
                        {
                            itemId: 666,
                            code: 'Q557',
                            description: 'knowledge experience illness',
                            categoryId: 126
                        },
                        {
                            itemId: 667,
                            code: 'Q558',
                            description: 'treatment follow-up',
                            categoryId: 126
                        },
                        {
                            itemId: 668,
                            code: 'Q559',
                            description: 'attention physical problems',
                            categoryId: 126
                        },
                        {
                            itemId: 669,
                            code: 'Q560',
                            description: 'willingness listen concerns',
                            categoryId: 126
                        },
                        {
                            itemId: 670,
                            code: 'Q561',
                            description: 'interest personally',
                            categoryId: 126
                        },
                        {
                            itemId: 671,
                            code: 'Q562',
                            description: 'comfort support',
                            categoryId: 126
                        },
                        {
                            itemId: 675,
                            code: 'Q566',
                            description: 'frequency visits consultations',
                            categoryId: 126
                        },
                        {
                            itemId: 676,
                            code: 'Q567',
                            description: 'time visits consultations',
                            categoryId: 126
                        },
                        {
                            itemId: 677,
                            code: 'Q568',
                            description: 'physical examinations',
                            categoryId: 126
                        },
                        {
                            itemId: 678,
                            code: 'Q569',
                            description: 'handle care',
                            categoryId: 126
                        },
                        {
                            itemId: 679,
                            code: 'Q570',
                            description: 'attention physical comfort',
                            categoryId: 126
                        },
                        {
                            itemId: 680,
                            code: 'Q571',
                            description: 'human qualities',
                            categoryId: 126
                        },
                        {
                            itemId: 682,
                            code: 'Q573',
                            description: 'prompt buzzer calls',
                            categoryId: 126
                        },
                        {
                            itemId: 683,
                            code: 'Q574',
                            description: 'time devoted',
                            categoryId: 126
                        },
                        {
                            itemId: 685,
                            code: 'Q576',
                            description: 'kind helpful technical reception laboratory',
                            categoryId: 126
                        },
                        {
                            itemId: 1109,
                            code: 'Q860',
                            description: 'aware care treatment',
                            categoryId: 126
                        },
                        {
                            itemId: 1110,
                            code: 'Q861',
                            description: 'attention physical symptoms',
                            categoryId: 126
                        },
                        {
                            itemId: 1111,
                            code: 'Q862',
                            description: 'thorough treating physical symptoms',
                            categoryId: 126
                        },
                        {
                            itemId: 1113,
                            code: 'Q864',
                            description: 'attention opinion choice',
                            categoryId: 126
                        },
                        {
                            itemId: 1114,
                            code: 'Q865',
                            description: 'interest person',
                            categoryId: 126
                        },
                        {
                            itemId: 1119,
                            code: 'Q867',
                            description: 'advice manage symptoms',
                            categoryId: 126
                        },
                        {
                            itemId: 1120,
                            code: 'Q868',
                            description: 'prompt answer requests',
                            categoryId: 126
                        },
                        {
                            itemId: 1123,
                            code: 'Q870',
                            description: 'HCPs work team',
                            categoryId: 126
                        },
                        {
                            itemId: 1140,
                            code: 'Q884',
                            description: 'provision follow up after treatment',
                            categoryId: 126
                        },
                        {
                            itemId: 1269,
                            code: 'Q954',
                            description: 'support doctors',
                            categoryId: 126
                        },
                        {
                            itemId: 1270,
                            code: 'Q955',
                            description: 'support HCPs',
                            categoryId: 126
                        }, 
                    ]
                },
                {
                    categoryId: 127,
                    categoryName: 'Sensory/Neurological\xa0',
                    parentId: null,
                    parentCategoryName: null,
                    items: []
                },
                {
                    categoryId: 128,
                    categoryName: 'Altered taste/smell',
                    parentId: 127,
                    parentCategoryName: 'Sensory/Neurological\xa0',
                    items: []
                },
                {
                    categoryId: 129,
                    categoryName: 'Dizziness',
                    parentId: 127,
                    parentCategoryName: 'Sensory/Neurological\xa0',
                    items: [
                        {
                            itemId: 48,
                            code: 'Q36',
                            description: 'unsteady on feet',
                            categoryId: 129
                        },
                        {
                            itemId: 409,
                            code: 'Q336',
                            description: 'dizzy stan up sitting lying position',
                            categoryId: 129
                        },
                        {
                            itemId: 698,
                            code: 'Q585',
                            description: 'dizzy',
                            categoryId: 129
                        }, 
                    ]
                },
                {
                    categoryId: 130,
                    categoryName: 'Neuropathy',
                    parentId: 127,
                    parentCategoryName: 'Sensory/Neurological\xa0',
                    items: [
                        {
                            itemId: 185,
                            code: 'Q141',
                            description: 'tingling numbness fingers toes',
                            categoryId: 130
                        },
                        {
                            itemId: 311,
                            code: 'Q248',
                            description: 'numb tingling arm shoulder',
                            categoryId: 130
                        },
                        {
                            itemId: 356,
                            code: 'Q285',
                            description: 'tingling hands feet',
                            categoryId: 130
                        },
                        {
                            itemId: 380,
                            code: 'Q309',
                            description: 'tingling fingers hands',
                            categoryId: 130
                        },
                        {
                            itemId: 383,
                            code: 'Q312',
                            description: 'tingling toes feet',
                            categoryId: 130
                        },
                        {
                            itemId: 386,
                            code: 'Q315',
                            description: 'numb fingers/hands',
                            categoryId: 130
                        },
                        {
                            itemId: 397,
                            code: 'Q324',
                            description: 'problem standing walking feeling ground',
                            categoryId: 130
                        },
                        {
                            itemId: 399,
                            code: 'Q326',
                            description: 'problem distinguish hot cold water',
                            categoryId: 130
                        },
                        {
                            itemId: 411,
                            code: 'Q338',
                            description: 'problem use pedals',
                            categoryId: 130
                        },
                        {
                            itemId: 553,
                            code: 'Q462',
                            description: 'tingling numb hands feet',
                            categoryId: 130
                        },
                        {
                            itemId: 1220,
                            code: 'Q908',
                            description: 'tingling fingers toes',
                            categoryId: 130
                        },
                        {
                            itemId: 1266,
                            code: 'Q951',
                            description: 'tingling numbness mouth',
                            categoryId: 130
                        }, 
                    ]
                },
                {
                    categoryId: 131,
                    categoryName: 'Numbness',
                    parentId: 127,
                    parentCategoryName: 'Sensory/Neurological\xa0',
                    items: [
                        {
                            itemId: 340,
                            code: 'Q277',
                            description: 'numb breast',
                            categoryId: 131
                        },
                        {
                            itemId: 357,
                            code: 'Q286',
                            description: 'numb fingers toes',
                            categoryId: 131
                        },
                        {
                            itemId: 387,
                            code: 'Q316',
                            description: 'numb toes/feet',
                            categoryId: 131
                        }, 
                    ]
                },
                {
                    categoryId: 132,
                    categoryName: 'Seizures',
                    parentId: 127,
                    parentCategoryName: 'Sensory/Neurological\xa0',
                    items: [
                        {
                            itemId: 282,
                            code: 'Q222',
                            description: 'seizures',
                            categoryId: 132
                        }, 
                    ]
                },
                {
                    categoryId: 133,
                    categoryName: 'Sexual',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 88,
                            code: 'Q72',
                            description: 'interest in sex',
                            categoryId: 133
                        },
                        {
                            itemId: 90,
                            code: 'Q74',
                            description: 'sexually active',
                            categoryId: 133
                        },
                        {
                            itemId: 94,
                            code: 'Q77',
                            description: 'problem erection',
                            categoryId: 133
                        },
                        {
                            itemId: 95,
                            code: 'Q78',
                            description: 'problem ejaculation',
                            categoryId: 133
                        },
                        {
                            itemId: 96,
                            code: 'Q79',
                            description: 'uncomfortable sexually intimate',
                            categoryId: 133
                        },
                        {
                            itemId: 105,
                            code: 'Q81',
                            description: 'importance active sex life',
                            categoryId: 133
                        },
                        {
                            itemId: 106,
                            code: 'Q82',
                            description: 'decreased libido',
                            categoryId: 133
                        },
                        {
                            itemId: 107,
                            code: 'Q83',
                            description: 'satisfaction sexual desire',
                            categoryId: 133
                        },
                        {
                            itemId: 108,
                            code: 'Q84',
                            description: 'sexual activity enjoyable',
                            categoryId: 133
                        },
                        {
                            itemId: 109,
                            code: 'Q85',
                            description: 'satisfaction reach orgasm',
                            categoryId: 133
                        },
                        {
                            itemId: 122,
                            code: 'Q87',
                            description: 'fatigue sex life',
                            categoryId: 133
                        },
                        {
                            itemId: 123,
                            code: 'Q88',
                            description: 'treatment sex life',
                            categoryId: 133
                        },
                        {
                            itemId: 128,
                            code: 'Q93',
                            description: 'communication HCP sexual issues',
                            categoryId: 133
                        },
                        {
                            itemId: 133,
                            code: 'Q98',
                            description: 'communication sexual issues partner',
                            categoryId: 133
                        },
                        {
                            itemId: 135,
                            code: 'Q100',
                            description: 'satisfied level intimacy',
                            categoryId: 133
                        },
                        {
                            itemId: 137,
                            code: 'Q102',
                            description: 'insecure satisfy partner',
                            categoryId: 133
                        },
                        {
                            itemId: 139,
                            code: 'Q104',
                            description: 'satisfied sex life',
                            categoryId: 133
                        },
                        {
                            itemId: 140,
                            code: 'Q105',
                            description: 'extent sexual enjoyment',
                            categoryId: 133
                        },
                        {
                            itemId: 145,
                            code: 'Q107',
                            description: 'confident about erection',
                            categoryId: 133
                        },
                        {
                            itemId: 157,
                            code: 'Q118',
                            description: 'less interest sex',
                            categoryId: 133
                        },
                        {
                            itemId: 158,
                            code: 'Q119',
                            description: 'less sexual enjoyment',
                            categoryId: 133
                        },
                        {
                            itemId: 207,
                            code: 'Q160',
                            description: 'satisfied sexual relationship',
                            categoryId: 133
                        },
                        {
                            itemId: 249,
                            code: 'Q190',
                            description: 'worry contaminate bladder treatment',
                            categoryId: 133
                        },
                        {
                            itemId: 323,
                            code: 'Q260',
                            description: 'feel less sexually attractive',
                            categoryId: 133
                        },
                        {
                            itemId: 324,
                            code: 'Q261',
                            description: 'uncomfortable intimate situations',
                            categoryId: 133
                        },
                        {
                            itemId: 325,
                            code: 'Q262',
                            description: 'breast role sexuality',
                            categoryId: 133
                        },
                        {
                            itemId: 326,
                            code: 'Q263',
                            description: 'problem loss sensations breast',
                            categoryId: 133
                        },
                        {
                            itemId: 558,
                            code: 'Q467',
                            description: 'disease treatment sex life',
                            categoryId: 133
                        },
                        {
                            itemId: 563,
                            code: 'Q472',
                            description: 'vagina dry sex',
                            categoryId: 133
                        },
                        {
                            itemId: 589,
                            code: 'Q495',
                            description: 'effects treatment sexual activity',
                            categoryId: 133
                        },
                        {
                            itemId: 1160,
                            code: 'Q904',
                            description: 'narrow tight vagina sex',
                            categoryId: 133
                        },
                        {
                            itemId: 1226,
                            code: 'Q914',
                            description: 'pain vagina sex',
                            categoryId: 133
                        }, 
                    ]
                },
                {
                    categoryId: 134,
                    categoryName: 'Sleep\xa0',
                    parentId: null,
                    parentCategoryName: null,
                    items: []
                },
                {
                    categoryId: 135,
                    categoryName: 'Daytime sleepiness',
                    parentId: 134,
                    parentCategoryName: 'Sleep\xa0',
                    items: [
                        {
                            itemId: 598,
                            code: 'Q503',
                            description: 'sleepy daytime',
                            categoryId: 135
                        },
                        {
                            itemId: 646,
                            code: 'Q546',
                            description: 'need sleep day',
                            categoryId: 135
                        },
                        {
                            itemId: 848,
                            code: 'Q723',
                            description: 'FA01 tired eyes open day',
                            categoryId: 135
                        },
                        {
                            itemId: 862,
                            code: 'Q736',
                            description: 'FA18 sleep long day',
                            categoryId: 135
                        }, 
                    ]
                },
                {
                    categoryId: 136,
                    categoryName: 'Insomnia',
                    parentId: 134,
                    parentCategoryName: 'Sleep\xa0',
                    items: [
                        {
                            itemId: 25,
                            code: 'Q14',
                            description: 'SL05 problem sleeping',
                            categoryId: 136
                        },
                        {
                            itemId: 912,
                            code: 'Q786',
                            description: 'SL02 wake up night',
                            categoryId: 136
                        },
                        {
                            itemId: 913,
                            code: 'Q787',
                            description: 'SL03 wake up early',
                            categoryId: 136
                        },
                        {
                            itemId: 914,
                            code: 'Q788',
                            description: 'SL04 problem stay asleep',
                            categoryId: 136
                        },
                        {
                            itemId: 915,
                            code: 'Q789',
                            description: 'SL06 problem good night sleep',
                            categoryId: 136
                        },
                        {
                            itemId: 916,
                            code: 'Q790',
                            description: 'SL07 wake up long period night',
                            categoryId: 136
                        }, 
                    ]
                },
                {
                    categoryId: 137,
                    categoryName: 'Sleep disturbance\xa0',
                    parentId: 134,
                    parentCategoryName: 'Sleep\xa0',
                    items: []
                },
                {
                    categoryId: 138,
                    categoryName: 'Social Functioning\xa0',
                    parentId: null,
                    parentCategoryName: null,
                    items: []
                },
                {
                    categoryId: 139,
                    categoryName: 'Speech',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 126,
                            code: 'Q91',
                            description: 'hoarseness',
                            categoryId: 139
                        },
                        {
                            itemId: 144,
                            code: 'Q106',
                            description: 'problem talking to others',
                            categoryId: 139
                        },
                        {
                            itemId: 149,
                            code: 'Q110',
                            description: 'problem talking phone',
                            categoryId: 139
                        },
                        {
                            itemId: 298,
                            code: 'Q238',
                            description: 'problem communicate thoughts',
                            categoryId: 139
                        },
                        {
                            itemId: 463,
                            code: 'Q385',
                            description: 'problem talking',
                            categoryId: 139
                        },
                        {
                            itemId: 632,
                            code: 'Q532',
                            description: 'problem hoarse',
                            categoryId: 139
                        },
                        {
                            itemId: 633,
                            code: 'Q533',
                            description: 'problem talk noisy environment',
                            categoryId: 139
                        },
                        {
                            itemId: 640,
                            code: 'Q540',
                            description: 'problem speak clearly',
                            categoryId: 139
                        },
                        {
                            itemId: 934,
                            code: 'Q808',
                            description: 'DY18 short breath talk',
                            categoryId: 139
                        },
                        {
                            itemId: 1259,
                            code: 'Q944',
                            description: 'voice sound result disease treatment',
                            categoryId: 139
                        },
                        {
                            itemId: 1260,
                            code: 'Q945',
                            description: 'tired voice',
                            categoryId: 139
                        }, 
                    ]
                },
                {
                    categoryId: 140,
                    categoryName: 'Spirituality',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 657,
                            code: 'Q554',
                            description: 'experience distinguish important things life',
                            categoryId: 140
                        },
                        {
                            itemId: 713,
                            code: 'Q595',
                            description: 'able deal with problems',
                            categoryId: 140
                        },
                        {
                            itemId: 714,
                            code: 'Q596',
                            description: 'peace myself',
                            categoryId: 140
                        },
                        {
                            itemId: 716,
                            code: 'Q598',
                            description: 'forgive things done',
                            categoryId: 140
                        },
                        {
                            itemId: 719,
                            code: 'Q601',
                            description: 'share thoughts life people close',
                            categoryId: 140
                        },
                        {
                            itemId: 725,
                            code: 'Q607',
                            description: 'life fulfil',
                            categoryId: 140
                        },
                        {
                            itemId: 726,
                            code: 'Q608',
                            description: 'life worthwhile',
                            categoryId: 140
                        },
                        {
                            itemId: 730,
                            code: 'Q612',
                            description: 'felt unfair ill',
                            categoryId: 140
                        },
                        {
                            itemId: 731,
                            code: 'Q613',
                            description: 'time quietness prayer meditation',
                            categoryId: 140
                        },
                        {
                            itemId: 732,
                            code: 'Q614',
                            description: 'important others pray for me',
                            categoryId: 140
                        },
                        {
                            itemId: 733,
                            code: 'Q615',
                            description: 'believe god',
                            categoryId: 140
                        },
                        {
                            itemId: 734,
                            code: 'Q616',
                            description: 'always believed god',
                            categoryId: 140
                        },
                        {
                            itemId: 735,
                            code: 'Q617',
                            description: 'beliefs changed less well',
                            categoryId: 140
                        },
                        {
                            itemId: 736,
                            code: 'Q618',
                            description: 'beliefs changed last weeks',
                            categoryId: 140
                        },
                        {
                            itemId: 737,
                            code: 'Q619',
                            description: 'connected god',
                            categoryId: 140
                        },
                        {
                            itemId: 738,
                            code: 'Q620',
                            description: 'feel will live words, deeds, influence others',
                            categoryId: 140
                        },
                        {
                            itemId: 739,
                            code: 'Q621',
                            description: 'feelings life changed less well',
                            categoryId: 140
                        },
                        {
                            itemId: 740,
                            code: 'Q622',
                            description: ' feelings life changed last weeks',
                            categoryId: 140
                        },
                        {
                            itemId: 741,
                            code: 'Q623',
                            description: 'life after death',
                            categoryId: 140
                        },
                        {
                            itemId: 742,
                            code: 'Q624',
                            description: 'spiritual wellbeing',
                            categoryId: 140
                        },
                        {
                            itemId: 743,
                            code: 'Q625',
                            description: 'global spiritual wellbeing',
                            categoryId: 140
                        }, 
                    ]
                },
                {
                    categoryId: 141,
                    categoryName: 'Surgery',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 398,
                            code: 'Q325',
                            description: 'dissatisfied cosmetic surgery',
                            categoryId: 141
                        },
                        {
                            itemId: 704,
                            code: 'Q591',
                            description: 'area wound oversensitive',
                            categoryId: 141
                        },
                        {
                            itemId: 705,
                            code: 'Q592',
                            description: 'restricted performance surgery',
                            categoryId: 141
                        },
                        {
                            itemId: 706,
                            code: 'Q593',
                            description: 'problem use arm shoulder operation',
                            categoryId: 141
                        },
                        {
                            itemId: 707,
                            code: 'Q594',
                            description: 'scar pain daily activities',
                            categoryId: 141
                        },
                        {
                            itemId: 1227,
                            code: 'Q915',
                            description: 'satisfied cosmetic result surgery',
                            categoryId: 141
                        }, 
                    ]
                },
                {
                    categoryId: 142,
                    categoryName: 'Urinary',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 67,
                            code: 'Q53',
                            description: 'urinary problems daily activities',
                            categoryId: 142
                        },
                        {
                            itemId: 236,
                            code: 'Q177',
                            description: 'problem care urostomy',
                            categoryId: 142
                        },
                        {
                            itemId: 238,
                            code: 'Q179',
                            description: 'skin irritarion urostomy',
                            categoryId: 142
                        },
                        {
                            itemId: 243,
                            code: 'Q184',
                            description: 'urostomy bag changes',
                            categoryId: 142
                        },
                        {
                            itemId: 244,
                            code: 'Q185',
                            description: 'problem self-catheterization',
                            categoryId: 142
                        },
                        {
                            itemId: 249,
                            code: 'Q190',
                            description: 'worry contaminate bladder treatment',
                            categoryId: 142
                        },
                        {
                            itemId: 490,
                            code: 'Q405',
                            description: 'worry repeated bladder treatment',
                            categoryId: 142
                        },
                        {
                            itemId: 1159,
                            code: 'Q903',
                            description: 'urine catheter stoma bag',
                            categoryId: 142
                        }, 
                    ]
                },
                {
                    categoryId: 143,
                    categoryName: 'Painful urination',
                    parentId: 142,
                    parentCategoryName: 'Urinary',
                    items: [
                        {
                            itemId: 233,
                            code: 'Q174',
                            description: 'pain burning feeling urinate',
                            categoryId: 143
                        }, 
                    ]
                },
                {
                    categoryId: 144,
                    categoryName: 'Urinary frequency',
                    parentId: 142,
                    parentCategoryName: 'Urinary',
                    items: [
                        {
                            itemId: 4,
                            code: 'Q2',
                            description: 'frequent urination day',
                            categoryId: 144
                        },
                        {
                            itemId: 364,
                            code: 'Q293',
                            description: 'urinate frequently',
                            categoryId: 144
                        },
                        {
                            itemId: 1097,
                            code: 'Q856',
                            description: 'frequent urination',
                            categoryId: 144
                        }, 
                    ]
                },
                {
                    categoryId: 145,
                    categoryName: 'Urinary incontinence',
                    parentId: 142,
                    parentCategoryName: 'Urinary',
                    items: [
                        {
                            itemId: 66,
                            code: 'Q52',
                            description: 'problem incontinence aid',
                            categoryId: 145
                        },
                        {
                            itemId: 110,
                            code: 'Q86',
                            description: 'worry incontinent',
                            categoryId: 145
                        },
                        {
                            itemId: 235,
                            code: 'Q176',
                            description: 'urine bag leak',
                            categoryId: 145
                        },
                        {
                            itemId: 310,
                            code: 'Q247',
                            description: 'problem controlling bladder',
                            categoryId: 145
                        },
                        {
                            itemId: 543,
                            code: 'Q452',
                            description: 'leak urine',
                            categoryId: 145
                        }, 
                    ]
                },
                {
                    categoryId: 146,
                    categoryName: 'Urinary retention',
                    parentId: 142,
                    parentCategoryName: 'Urinary',
                    items: [
                        {
                            itemId: 544,
                            code: 'Q453',
                            description: 'problem empty bladder',
                            categoryId: 146
                        }, 
                    ]
                },
                {
                    categoryId: 147,
                    categoryName: 'Urinary urgency',
                    parentId: 142,
                    parentCategoryName: 'Urinary',
                    items: [
                        {
                            itemId: 60,
                            code: 'Q48',
                            description: 'hurry to toilet',
                            categoryId: 147
                        }, 
                    ]
                },
                {
                    categoryId: 148,
                    categoryName: 'Visual',
                    parentId: null,
                    parentCategoryName: null,
                    items: [
                        {
                            itemId: 154,
                            code: 'Q115',
                            description: 'eyes painful irritated watery',
                            categoryId: 148
                        },
                        {
                            itemId: 280,
                            code: 'Q220',
                            description: 'blurred vision',
                            categoryId: 148
                        },
                        {
                            itemId: 281,
                            code: 'Q221',
                            description: 'problems reading vision',
                            categoryId: 148
                        },
                        {
                            itemId: 376,
                            code: 'Q305',
                            description: 'grittiness treated eye',
                            categoryId: 148
                        },
                        {
                            itemId: 377,
                            code: 'Q306',
                            description: 'pain soreness discomfort treated eye',
                            categoryId: 148
                        },
                        {
                            itemId: 378,
                            code: 'Q307',
                            description: 'itching treated eye',
                            categoryId: 148
                        },
                        {
                            itemId: 379,
                            code: 'Q308',
                            description: 'problem watering treated eye',
                            categoryId: 148
                        },
                        {
                            itemId: 381,
                            code: 'Q310',
                            description: 'problem discharge treated eye',
                            categoryId: 148
                        },
                        {
                            itemId: 382,
                            code: 'Q311',
                            description: 'dryness treated eye',
                            categoryId: 148
                        },
                        {
                            itemId: 384,
                            code: 'Q313',
                            description: 'problem defects side vision',
                            categoryId: 148
                        },
                        {
                            itemId: 396,
                            code: 'Q323',
                            description: 'worry lose eye',
                            categoryId: 148
                        },
                        {
                            itemId: 400,
                            code: 'Q327',
                            description: 'problem pouring',
                            categoryId: 148
                        },
                        {
                            itemId: 401,
                            code: 'Q328',
                            description: 'problem walk crowd',
                            categoryId: 148
                        },
                        {
                            itemId: 404,
                            code: 'Q331',
                            description: 'problem steps pavements',
                            categoryId: 148
                        },
                        {
                            itemId: 407,
                            code: 'Q334',
                            description: 'problem walking downstairs uneven ground',
                            categoryId: 148
                        },
                        {
                            itemId: 412,
                            code: 'Q339',
                            description: 'activities limited vision',
                            categoryId: 148
                        },
                        {
                            itemId: 414,
                            code: 'Q340',
                            description: 'distorted treated eye',
                            categoryId: 148
                        },
                        {
                            itemId: 417,
                            code: 'Q343',
                            description: 'bright light uncomfortable',
                            categoryId: 148
                        },
                        {
                            itemId: 418,
                            code: 'Q344',
                            description: 'vision interfere treated eye',
                            categoryId: 148
                        },
                        {
                            itemId: 419,
                            code: 'Q345',
                            description: 'worry tumor recur treated eye',
                            categoryId: 148
                        },
                        {
                            itemId: 420,
                            code: 'Q346',
                            description: 'problem driving daylight',
                            categoryId: 148
                        },
                        {
                            itemId: 421,
                            code: 'Q347',
                            description: 'problem driving dark ',
                            categoryId: 148
                        },
                        {
                            itemId: 455,
                            code: 'Q378',
                            description: 'problem eyes',
                            categoryId: 148
                        },
                        {
                            itemId: 550,
                            code: 'Q459',
                            description: 'burning sore eyes',
                            categoryId: 148
                        },
                        {
                            itemId: 1230,
                            code: 'Q918',
                            description: 'watery eyes',
                            categoryId: 148
                        },
                        {
                            itemId: 1231,
                            code: 'Q919',
                            description: 'dry eyes',
                            categoryId: 148
                        },
                        {
                            itemId: 1232,
                            code: 'Q920',
                            description: 'red eyes',
                            categoryId: 148
                        },
                        {
                            itemId: 1233,
                            code: 'Q921',
                            description: 'itchy eyes',
                            categoryId: 148
                        },
                        {
                            itemId: 1234,
                            code: 'Q922',
                            description: 'burning eyes',
                            categoryId: 148
                        }, 
                    ]
                },
                {
                    categoryId: 149,
                    categoryName: 'Depth perception',
                    parentId: 148,
                    parentCategoryName: 'Visual',
                    items: [
                        {
                            itemId: 410,
                            code: 'Q337',
                            description: 'problem judge distance',
                            categoryId: 149
                        }, 
                    ]
                },
                {
                    categoryId: 150,
                    categoryName: 'Double vision',
                    parentId: 148,
                    parentCategoryName: 'Visual',
                    items: [
                        {
                            itemId: 279,
                            code: 'Q219',
                            description: 'double vision',
                            categoryId: 150
                        },
                        {
                            itemId: 385,
                            code: 'Q314',
                            description: 'problem double vision straight',
                            categoryId: 150
                        },
                        {
                            itemId: 388,
                            code: 'Q317',
                            description: 'problem double vision sideways',
                            categoryId: 150
                        }, 
                    ]
                },
                {
                    categoryId: 151,
                    categoryName: 'Face recognition',
                    parentId: 148,
                    parentCategoryName: 'Visual',
                    items: [
                        {
                            itemId: 819,
                            code: 'Q694',
                            description: 'CF17 problems recognise',
                            categoryId: 151
                        }, 
                    ]
                },
                {
                    categoryId: 152,
                    categoryName: 'Floaters and flashers',
                    parentId: 148,
                    parentCategoryName: 'Visual',
                    items: [
                        {
                            itemId: 415,
                            code: 'Q341',
                            description: 'flash balls light treated eye',
                            categoryId: 152
                        },
                        {
                            itemId: 416,
                            code: 'Q342',
                            description: 'floaters treated eye',
                            categoryId: 152
                        }, 
                    ]
                }, 
            ]));
        }), 
    ];
};

// EXTERNAL MODULE: ./src/consts/paths/api/questionnaires/questionnairesPath.ts
var questionnairesPath = __webpack_require__(61680);
;// CONCATENATED MODULE: ./src/mocks/questionnaires/createCustomQuestionnaire/index.ts



/* harmony default export */ function createCustomQuestionnaire() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 0 : _delay;
    return [
        rest.post(resolvePath(questionnairesPath/* default */.ZP), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({
                name: 'sadsad',
                code: null,
                type: 'itemlist',
                state: 'draft',
                phase: null,
                gender: 'female',
                chemical: 'asdsad',
                description: 'asdsad',
                additionalInfo: null,
                contact: null,
                isCustom: true,
                author: 73,
                questionsStartPosition: 1,
                languages: [
                    {
                        code: 'en',
                        name: 'English'
                    }
                ],
                id: 1000288,
                createDate: '2022-02-09T12:36:19.7441355+00:00',
                updateDate: '2022-02-09T12:36:19.7441355+00:00'
            }));
        }), 
    ];
};

// EXTERNAL MODULE: ./src/consts/paths/api/items/getItems/index.ts
var getItems = __webpack_require__(41999);
;// CONCATENATED MODULE: ./src/mocks/items/getItem/item.json
var item_namespaceObject = JSON.parse('{"code":"IN4","codePrefix":"IN","type":"instructions","description":"next page","direction":null,"underlyingIssue":"","additionalInfo":"<h4>Recommended wording:</h4><p>Please continue to the next page</p>","recommendedWordings":[{"item":15,"language":"en","wording":"Please go on to next page","id":60,"createDate":"2016-02-10T15:21:39.353","updateDate":"2016-06-28T11:49:50.107"}],"categories":[],"keywords":["page"],"icdCodes":[],"questionnaireItems":[{"questionnaire":4,"item":15,"position":4,"wording":"Please go on to the next page","comment":null,"id":19,"createDate":"2016-02-10T15:21:39.353","updateDate":"2016-06-28T11:49:50.107"},{"questionnaire":8,"item":15,"position":6,"wording":"Please go on to the next page","comment":null,"id":158,"createDate":"2016-02-25T12:38:47.16","updateDate":"2016-02-25T12:38:47.16"},{"questionnaire":5,"item":15,"position":1,"wording":"Please go on to the next page","comment":null,"id":214,"createDate":"2016-02-25T15:13:45.887","updateDate":"2022-03-03T07:59:54.307"},{"questionnaire":11,"item":15,"position":4,"wording":"Please go on to the next page","comment":null,"id":256,"createDate":"2016-02-29T11:55:37.603","updateDate":"2016-02-29T11:55:37.603"},{"questionnaire":13,"item":15,"position":3,"wording":"Please go on to the next page","comment":null,"id":308,"createDate":"2016-02-29T13:07:06.693","updateDate":"2022-03-25T14:21:05.593"},{"questionnaire":16,"item":15,"position":4,"wording":"Please go on to the next page","comment":null,"id":431,"createDate":"2016-03-01T10:50:12.397","updateDate":"2016-03-01T10:50:12.397"},{"questionnaire":17,"item":15,"position":4,"wording":"Please go on to the next page","comment":null,"id":474,"createDate":"2016-03-01T12:19:22.777","updateDate":"2016-03-01T12:19:22.777"},{"questionnaire":18,"item":15,"position":5,"wording":"Please go on to the next page","comment":null,"id":520,"createDate":"2016-03-01T13:27:36.077","updateDate":"2022-03-01T10:18:31.393"},{"questionnaire":20,"item":15,"position":4,"wording":"Please continue to the next page","comment":null,"id":532,"createDate":"2016-03-01T13:46:03.667","updateDate":"2016-08-23T12:47:56"},{"questionnaire":19,"item":15,"position":3,"wording":"Please go on to next page","comment":null,"id":563,"createDate":"2016-03-01T14:29:29.013","updateDate":"2016-03-01T14:29:29.013"},{"questionnaire":22,"item":15,"position":4,"wording":"Please go on to the next page","comment":null,"id":616,"createDate":"2016-03-01T15:08:32.693","updateDate":"2016-03-01T15:08:32.693"},{"questionnaire":21,"item":15,"position":4,"wording":"Please go to the next page","comment":null,"id":629,"createDate":"2016-03-01T15:23:49.337","updateDate":"2016-03-01T15:23:49.337"},{"questionnaire":26,"item":15,"position":4,"wording":"Please go on to the next page","comment":null,"id":722,"createDate":"2016-03-02T11:28:15.177","updateDate":"2016-09-19T11:24:49.593"},{"questionnaire":27,"item":15,"position":4,"wording":"Please go on to the next page","comment":null,"id":771,"createDate":"2016-03-02T13:09:32.907","updateDate":"2016-03-02T13:09:32.907"},{"questionnaire":28,"item":15,"position":9,"wording":"Please go on to the next page","comment":null,"id":798,"createDate":"2016-03-02T13:43:31.717","updateDate":"2016-08-12T11:30:20.783"},{"questionnaire":30,"item":15,"position":4,"wording":"Please go on to the next page","comment":null,"id":852,"createDate":"2016-03-02T14:23:22.057","updateDate":"2016-03-02T14:23:22.057"},{"questionnaire":31,"item":15,"position":4,"wording":"Please go on to next page","comment":null,"id":901,"createDate":"2016-03-02T15:02:33.177","updateDate":"2016-08-25T12:03:37.643"},{"questionnaire":32,"item":15,"position":4,"wording":"Please go on to next page","comment":null,"id":931,"createDate":"2016-03-02T15:25:44.843","updateDate":"2016-08-11T12:46:48.02"},{"questionnaire":33,"item":15,"position":4,"wording":"Please go on to next page","comment":null,"id":959,"createDate":"2016-03-02T15:36:46.51","updateDate":"2016-08-25T12:59:28.243"},{"questionnaire":35,"item":15,"position":4,"wording":"Please turn to next page","comment":null,"id":1033,"createDate":"2016-03-03T13:04:39.827","updateDate":"2016-08-19T12:07:56.673"},{"questionnaire":34,"item":15,"position":1,"wording":"Please go on to the next page","comment":null,"id":1080,"createDate":"2016-03-03T13:31:26.143","updateDate":"2016-07-08T11:41:00.3"},{"questionnaire":38,"item":15,"position":3,"wording":"Please go on to the next page","comment":null,"id":1145,"createDate":"2016-03-03T14:14:53.533","updateDate":"2016-08-12T14:19:11.99"},{"questionnaire":39,"item":15,"position":1,"wording":"Please go to the next page","comment":null,"id":1158,"createDate":"2016-03-03T14:23:33.813","updateDate":"2016-06-16T15:20:28.08"},{"questionnaire":41,"item":15,"position":4,"wording":"Please go to next page","comment":null,"id":1205,"createDate":"2016-03-03T15:05:50.627","updateDate":"2016-08-18T15:39:37.453"},{"questionnaire":43,"item":15,"position":4,"wording":"Please go on to the next page","comment":null,"id":1261,"createDate":"2016-03-03T15:55:55.13","updateDate":"2016-09-05T08:27:30.83"},{"questionnaire":45,"item":15,"position":4,"wording":"Please go on to the next page","comment":null,"id":1335,"createDate":"2016-03-04T10:34:21.237","updateDate":"2016-08-18T13:27:30.513"},{"questionnaire":48,"item":15,"position":4,"wording":"Please go on to the next page","comment":null,"id":1461,"createDate":"2016-03-04T15:18:06.95","updateDate":"2016-08-19T11:35:26.063"},{"questionnaire":49,"item":15,"position":4,"wording":"Please go to the next page","comment":null,"id":1480,"createDate":"2016-03-07T09:40:43.243","updateDate":"2016-06-16T15:09:17.227"},{"questionnaire":46,"item":15,"position":9,"wording":"Please go to the next page","comment":null,"id":1527,"createDate":"2016-06-23T10:51:49.873","updateDate":"2016-06-23T11:03:00.71"},{"questionnaire":1,"item":15,"position":4,"wording":"Please go to the next page","comment":null,"id":1532,"createDate":"2016-09-12T10:28:16.91","updateDate":"2016-09-12T10:28:16.91"},{"questionnaire":47,"item":15,"position":5,"wording":"Please go to the next page","comment":null,"id":1537,"createDate":"2016-09-14T09:32:54","updateDate":"2016-09-14T09:32:54"},{"questionnaire":9,"item":15,"position":4,"wording":"Please go to the next page","comment":null,"id":1539,"createDate":"2016-09-15T12:44:14.927","updateDate":"2016-09-15T12:44:14.927"},{"questionnaire":1000287,"item":15,"position":1,"wording":"Please continue to the next page","comment":null,"id":9422,"createDate":"2022-04-29T06:10:34.717","updateDate":"2022-04-29T06:10:34.717"},{"questionnaire":1000284,"item":15,"position":1,"wording":"Please go on to the next page","comment":null,"id":9423,"createDate":"2022-04-29T09:45:19.74","updateDate":"2022-04-29T09:45:19.74"}],"similarItems":[{"id":173,"code":"CS6","name":"only if sexually active","type":"condition","wording":"Answer the following two questions only if you were sexually active:"},{"id":227,"code":"CS11","name":"if catheter, during the past week","type":"condition","wording":"PLEASE ANSWER QUESTION 44 ONLY IF YOU HAVE USED A CATHETER DURING THE PAST WEEK"},{"id":1713,"code":"CS6","name":"only if sexually active","type":"condition","wording":"Answer this question only if you have been sexually active:"},{"id":522,"code":"CS24","name":"if stoma bag","type":"condition","wording":"Answer these questions ONLY IF YOU HAVE A STOMA BAG, if not please continue below:"},{"id":346,"code":"CS13","name":"if nipple preserved","type":"condition","wording":"Answer these two questions ONLY IF your nipple has been PRESERVED."},{"id":523,"code":"CS25","name":"if no stoma bag","type":"condition","wording":"Answer these questions ONLY IF YOU DO NOT HAVE A STOMA BAG:"},{"id":395,"code":"CS20","name":"if you are a man","type":"condition","wording":"Please answer the following question only if you are a man"}],"associatedItems":[{"id":153,"code":"Q115","name":"food drink taste different","type":"question","wording":"Have food and drink tasted different from usual?"}],"id":15,"createDate":"2016-02-10T15:21:39.32","updateDate":"2017-02-09T16:21:44.803"}');
;// CONCATENATED MODULE: ./src/mocks/items/getItem/index.tsx




/* harmony default export */ function getItem() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 0 : _delay;
    return [
        rest.get(resolvePath("".concat(getItems/* default */.Z, "/*")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json(item_namespaceObject));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/questionnaires/get/questionnaire.json
var questionnaire_namespaceObject = JSON.parse('{"id":13,"name":"Bladder","code":"BLM","type":"module","state":null,"phase":3,"gender":"nonSpecific","chemical":null,"description":"<h3 style=\\"font-family: Titillium, sans-serif; color: rgb(0, 0, 0);\\">QLQ-BLM30 Bladder module</h3><p>The QLQ-BLM30 Bladder module is a questionnaire to assess patient-reported outcomes in muscle-invasive bladder cancer. This module is to be used with the EORTC QLQ-C30 core questionnaire.<br></p><p>The BLM30 module has completed phase III.</p>","additionalInfo":"<h4><u>Scale structure</u></h4><p><b>Please note: This is a hypothesised scale structure. It has not undergone factor analysis</b><br /></p><ul><li>Urinary symptom 31-37</li><li>Urostomy problem 38-43</li><li>Single catheter use problem 44</li><li>Future perspective 45-47</li><li>Abdominal bloating and flatulence 48-49</li><li>Body image 50-52</li><li>Sexual functioning 53-60</li></ul>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"updateDate":"2017-03-10T17:10:42.057","questionnaireItems":[{"item":{"code":"TS1","codePrefix":"TS","type":"timeScale","description":"past week","direction":null,"underlyingIssue":"","additionalInfo":"","recommendedWordings":[],"categories":null,"id":2,"createDate":"2016-02-02T11:56:24.837","updateDate":"2017-03-10T17:10:10.763"},"questionnaire":13,"position":1,"wording":"During the past week:","comment":null,"relatedQuestions":[310,832,320,321,322,323,325,326,331,339,340,341,342,343,344,345,347,348,350,351,352],"id":296,"createDate":"2016-02-29T12:52:53.277","updateDate":"2016-06-27T12:07:31.917"},{"item":{"code":"RS1","codePrefix":"RS","type":"responseScale","description":"4-point Likert scale","direction":null,"underlyingIssue":"","additionalInfo":"","recommendedWordings":[],"categories":null,"id":3,"createDate":"2016-02-02T11:57:02.403","updateDate":"2017-03-10T17:10:42.057"},"questionnaire":13,"position":1,"wording":"Not at all, A little, Quite a bit, Very much","comment":null,"relatedQuestions":[310,832,320,321,322,323,325,326,331,339,340,341,342,343,344,345,347,348,350,351,352,353,354,355,357,358,865,359,360],"id":295,"createDate":"2016-02-29T12:51:53.683","updateDate":"2016-05-17T11:07:10.363"},{"item":{"code":"TS2","codePrefix":"TS","type":"timeScale","description":"last 4 weeks","direction":null,"underlyingIssue":"","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":5,"createDate":"2016-02-10T11:28:03.23","updateDate":"2016-03-04T14:26:11.287"},"questionnaire":13,"position":2,"wording":"During the past four weeks:","comment":null,"relatedQuestions":[353,354,355,357,358,865,359,360],"id":297,"createDate":"2016-02-29T12:53:07.833","updateDate":"2016-05-17T11:08:01.847"},{"item":{"code":"IN4","codePrefix":"IN","type":"instructions","description":"next page","direction":null,"underlyingIssue":"","additionalInfo":"<h4>Recommended wording:</h4><p>Please continue to the next page</p>","recommendedWordings":[],"categories":null,"id":15,"createDate":"2016-02-10T15:21:39.32","updateDate":"2017-02-09T16:21:44.803"},"questionnaire":13,"position":4,"wording":"Please go on to the next page","comment":null,"relatedQuestions":[],"id":308,"createDate":"2016-02-29T13:07:06.693","updateDate":"2016-02-29T13:07:06.693"},{"item":{"code":"Q12","codePrefix":"Q","type":"question","description":"PA pain","direction":"negative","underlyingIssue":"experiencing pain","additionalInfo":"","recommendedWordings":[],"categories":null,"id":23,"createDate":"2016-02-17T15:31:21.943","updateDate":"2016-06-02T14:12:12.98"},"questionnaire":13,"position":33,"wording":"Have you had pain?","comment":null,"id":7688,"createDate":"2017-04-24T15:31:55.363","updateDate":"2017-04-24T15:31:55.363"},{"item":{"code":"Q41","codePrefix":"Q","type":"question","description":"worry health in future","direction":"negative","underlyingIssue":"worrying about health in the future","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you worried about your health in the future?</p>","recommendedWordings":[{"item":53,"language":"en","wording":"Were you worried about your health in the future?","id":22,"createDate":"2016-02-18T11:46:37.84","updateDate":"2017-04-07T12:51:49.61"},{"item":53,"language":"ko","wording":"chin chan choun","id":24,"createDate":"2016-02-18T11:46:37.84","updateDate":"2017-04-07T12:43:52.95"}],"categories":null,"id":53,"createDate":"2016-02-18T11:46:37.807","updateDate":"2016-06-02T15:16:24.48"},"questionnaire":13,"position":13,"wording":"Were you worried about your health in the future?","comment":null,"id":343,"createDate":"2016-02-29T14:09:07.933","updateDate":"2016-05-17T11:04:37.37"},{"item":{"code":"Q48","codePrefix":"Q","type":"question","description":"hurry to toilet","direction":"negative","underlyingIssue":"having to hurry to get to the toilet when feeling the urge to pass urine","additionalInfo":"","recommendedWordings":[],"categories":null,"id":60,"createDate":"2016-02-18T13:13:22.243","updateDate":"2016-06-24T11:27:14.913"},"questionnaire":13,"position":28,"wording":"When you felt the urge to pass urine, did you have to hurry to get to the toilet?\\n","comment":null,"id":832,"createDate":"2016-03-02T14:01:00.89","updateDate":"2016-03-02T14:01:12.933"},{"item":{"code":"Q49","codePrefix":"Q","type":"question","description":"enough sleep urinate","direction":"negative","underlyingIssue":"experiencing problems with getting enough sleep because of having to get up frequently at night to urinate","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems getting enough sleep, because you needed to get up frequently at night to urinate?</p>","recommendedWordings":[],"categories":null,"id":61,"createDate":"2016-02-18T13:15:36.77","updateDate":"2016-06-28T11:28:55.257"},"questionnaire":13,"position":1,"wording":"Was it difficult for you to get enough sleep, because you needed to get up frequently at night to urinate?","comment":null,"id":320,"createDate":"2016-02-29T13:19:03.557","updateDate":"2022-02-21T12:08:17.993"},{"item":{"code":"Q50","codePrefix":"Q","type":"question","description":"go out close to toilet","direction":"negative","underlyingIssue":"having problems getting out of the house because of having to be close to the toilet","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems going out of the house, because you needed to be close to a toilet?</p>","recommendedWordings":[],"categories":null,"id":62,"createDate":"2016-02-18T13:17:11.963","updateDate":"2016-06-28T11:38:20.46"},"questionnaire":13,"position":3,"wording":"Have you had difficulty going out of the house, because you needed to be close to a toilet?","comment":null,"id":321,"createDate":"2016-02-29T13:19:41.263","updateDate":"2017-03-09T17:07:31.923"},{"item":{"code":"Q57","codePrefix":"Q","type":"question","description":"bloated feeling abdomen","direction":"negative","underlyingIssue":"having a bloated feeling in the abdomen","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had a bloated feeling in your abdomen?</p>","recommendedWordings":[],"categories":null,"id":71,"createDate":"2016-02-18T14:21:19.85","updateDate":"2016-06-03T13:27:26.473"},"questionnaire":13,"position":16,"wording":"Have you had a bloated feeling in your abdomen?","comment":null,"id":347,"createDate":"2016-02-29T14:25:26.717","updateDate":"2016-05-17T11:05:03.407"},{"item":{"code":"Q73","codePrefix":"Q","type":"question","description":"interest in sex","direction":"positive","underlyingIssue":"being interested in sex","additionalInfo":"<p><u>Recommended wording: </u></p><p>Have you been interested in sex?</p>","recommendedWordings":[{"item":88,"language":"en","wording":"sdqfsqdfsdf","id":36,"createDate":"2017-04-21T12:19:18.913","updateDate":"2017-04-21T12:19:18.913"}],"categories":null,"id":88,"createDate":"2016-02-19T14:52:37.923","updateDate":"2017-03-16T19:27:29.457"},"questionnaire":13,"position":21,"wording":"To what extent were you interested in sex?","comment":null,"id":353,"createDate":"2016-02-29T14:55:01.58","updateDate":"2016-05-17T11:05:41.397"},{"item":{"code":"Q73","codePrefix":"Q","type":"question","description":"interest in sex","direction":"positive","underlyingIssue":"being interested in sex","additionalInfo":"<p><u>Recommended wording: </u></p><p>Have you been interested in sex?</p>","recommendedWordings":[{"item":88,"language":"en","wording":"sdqfsqdfsdf","id":36,"createDate":"2017-04-21T12:19:18.913","updateDate":"2017-04-21T12:19:18.913"}],"categories":null,"id":88,"createDate":"2016-02-19T14:52:37.923","updateDate":"2017-03-16T19:27:29.457"},"questionnaire":13,"position":34,"wording":"interest in sex","comment":null,"id":8957,"createDate":"2018-04-23T14:58:22.293","updateDate":"2018-04-23T14:58:22.293"},{"item":{"code":"Q75","codePrefix":"Q","type":"question","description":"sexually active","direction":"positive","underlyingIssue":"being sexually active","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been sexually active (with or without intercourse)?</p>","recommendedWordings":[],"categories":null,"id":90,"createDate":"2016-02-19T14:54:21.903","updateDate":"2016-06-28T15:28:23.093"},"questionnaire":13,"position":22,"wording":"To what extent were you sexually active? (with or without intercourse)","comment":null,"id":354,"createDate":"2016-02-29T14:55:15.95","updateDate":"2016-02-29T14:55:15.95"},{"item":{"code":"Q78","codePrefix":"Q","type":"question","description":"problem erection","direction":"negative","underlyingIssue":"experiencing problems achieving or maintaining an erection","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems getting or maintaining an erection?</p>","recommendedWordings":[],"categories":null,"id":94,"createDate":"2016-02-19T15:13:33.663","updateDate":"2016-06-03T15:26:34.96"},"questionnaire":13,"position":23,"wording":"Did you have difficulty getting or maintaining an erection?","comment":null,"id":355,"createDate":"2016-02-29T14:55:36.73","updateDate":"2016-05-17T11:05:48.417"},{"item":{"code":"Q79","codePrefix":"Q","type":"question","description":"problem ejaculation","direction":"negative","underlyingIssue":"experiencing problems with ejaculation","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with ejaculation (e.g., dry ejaculation)?</p>","recommendedWordings":[],"categories":null,"id":95,"createDate":"2016-02-19T15:14:39.98","updateDate":"2016-06-03T15:27:31.247"},"questionnaire":13,"position":24,"wording":"Did you have ejaculation problems (e.g. dry ejaculation)?","comment":null,"id":357,"createDate":"2016-02-29T14:57:59.13","updateDate":"2016-05-17T11:05:53.157"},{"item":{"code":"Q80","codePrefix":"Q","type":"question","description":"uncomfortable sexually intimate","direction":"negative","underlyingIssue":"feeling uncomfortable about being sexually intimate","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":96,"createDate":"2016-02-19T15:15:52.93","updateDate":"2016-04-05T12:56:58.12"},"questionnaire":13,"position":25,"wording":"Have you felt uncomfortable about being sexually intimate?","comment":null,"id":358,"createDate":"2016-02-29T14:59:19.163","updateDate":"2016-05-17T11:05:56.747"},{"item":{"code":"Q81","codePrefix":"Q","type":"question","description":"frequent urination night","direction":"negative","underlyingIssue":"having to urinate frequently at night","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had to urinate frequently during the night?</p>","recommendedWordings":[{"item":104,"language":"en","wording":"blabla","id":26,"createDate":"2017-04-07T13:47:37.253","updateDate":"2017-04-07T13:47:37.253"},{"item":104,"language":"lang441","wording":"blabla fr","id":47,"createDate":"2019-09-05T13:42:18.497","updateDate":"2019-09-05T13:42:59.797"}],"categories":null,"id":104,"createDate":"2016-02-25T09:53:52.523","updateDate":"2016-06-28T12:59:34.023"},"questionnaire":13,"position":2,"wording":"Have you had to urinate frequently at night?","comment":null,"id":310,"createDate":"2016-02-29T13:07:42.713","updateDate":"2017-03-28T12:29:24.19"},{"item":{"code":"Q85","codePrefix":"Q","type":"question","description":"sexual activity enjoyable","direction":"positive","underlyingIssue":"finding sexual activity enjoyable","additionalInfo":"<p><u>Recommended wording:</u></p><p>Has sexual activity been enjoyable for you?</p>","recommendedWordings":[],"categories":null,"id":108,"createDate":"2016-02-25T11:09:58.413","updateDate":"2016-06-03T15:32:27.373"},"questionnaire":13,"position":26,"wording":"To what extent was sex enjoyable for you?","comment":null,"id":359,"createDate":"2016-02-29T14:59:46.883","updateDate":"2016-02-29T14:59:46.883"},{"item":{"code":"IN13","codePrefix":"IN","type":"instructions","description":"patients report","direction":null,"underlyingIssue":"","additionalInfo":"<h4>Recommended wording:</h4><p>Patients sometimes report that they have the following symptoms or problems.</p>","recommendedWordings":[],"categories":null,"id":119,"createDate":"2016-02-25T11:26:11.347","updateDate":"2017-02-09T16:27:47.297"},"questionnaire":13,"position":1,"wording":"Patients sometimes report that they have the following symptoms or problems.","comment":null,"relatedQuestions":[],"id":298,"createDate":"2016-02-29T12:53:31.093","updateDate":"2017-04-27T10:50:46.573"},{"item":{"code":"IN14","codePrefix":"IN","type":"instructions","description":"indicate extent past week","direction":null,"underlyingIssue":"","additionalInfo":"<h4>Recommended wording:</h4><p>Please indicate the extent to which you have experienced these symptoms or problems during the past week.</p>","recommendedWordings":[],"categories":null,"id":120,"createDate":"2016-02-25T11:26:34.903","updateDate":"2017-02-09T16:29:10.167"},"questionnaire":13,"position":2,"wording":"Please indicate the extent to which you have experienced these symptoms or problems during the past week.","comment":null,"relatedQuestions":[],"id":299,"createDate":"2016-02-29T12:53:43.713","updateDate":"2016-02-29T13:06:55.74"},{"item":{"code":"IN15","codePrefix":"IN","type":"instructions","description":"answer circling","direction":null,"underlyingIssue":"","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":121,"createDate":"2016-02-25T11:27:05.34","updateDate":"2016-02-25T11:27:05.34"},"questionnaire":13,"position":3,"wording":"Please answer by circling the number that best applies to you.","comment":null,"relatedQuestions":[],"id":300,"createDate":"2016-02-29T12:53:55.29","updateDate":"2016-02-29T12:53:55.29"},{"item":{"code":"CS1","codePrefix":"CS","type":"condition","description":"men only","direction":null,"underlyingIssue":"","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":141,"createDate":"2016-02-25T12:43:56.207","updateDate":"2016-02-25T12:43:56.207"},"questionnaire":13,"position":5,"wording":"For men only:","comment":null,"relatedQuestions":[355,357],"id":356,"createDate":"2016-02-29T14:55:58.57","updateDate":"2017-04-27T10:48:11.227"},{"item":{"code":"CS3","codePrefix":"CS","type":"condition","description":"sexually active 4 weeks","direction":null,"underlyingIssue":"","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":143,"createDate":"2016-02-25T12:45:23.6","updateDate":"2016-02-25T12:45:23.6"},"questionnaire":13,"position":1,"wording":"Please answer the following 4 questions only if you have been sexually active during the past 4 weeks:","comment":null,"relatedQuestions":[358,865,359,360],"id":304,"createDate":"2016-02-29T12:56:50.517","updateDate":"2017-03-14T16:45:24.097"},{"item":{"code":"CS4","codePrefix":"CS","type":"condition","description":"women only","direction":null,"underlyingIssue":"","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":146,"createDate":"2016-02-25T12:48:18.827","updateDate":"2016-02-25T12:48:18.827"},"questionnaire":13,"position":6,"wording":"For women only:","comment":null,"relatedQuestions":[360],"id":361,"createDate":"2016-02-29T15:00:47.803","updateDate":"2017-04-27T10:47:04.037"},{"item":{"code":"Q109","codePrefix":"Q","type":"question","description":"dry vagina","direction":"negative","underlyingIssue":"having a dry vagina during sexual activity","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had a dry vagina during sexual activity?</p>","recommendedWordings":[],"categories":null,"id":147,"createDate":"2016-02-25T12:49:03.053","updateDate":"2016-06-28T11:49:23.197"},"questionnaire":13,"position":27,"wording":"Did you have a dry vagina or other problems during intercourse?\\n","comment":null,"id":360,"createDate":"2016-02-29T15:00:17.337","updateDate":"2016-02-29T15:00:29.287"},{"item":{"code":"Q129","codePrefix":"Q","type":"question","description":"physically less attractive","direction":"negative","underlyingIssue":"feeling physically less attractive as a result of the disease or treatment","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt less physically attractive as a results of your disease or treatment?</p>","recommendedWordings":[],"categories":null,"id":169,"createDate":"2016-02-25T14:45:44.48","updateDate":"2017-03-31T16:57:43.893"},"questionnaire":13,"position":18,"wording":"Have you felt physically less attractive as a result of your illness or treatment?","comment":null,"id":350,"createDate":"2016-02-29T14:49:03.14","updateDate":"2016-05-17T11:05:21.583"},{"item":{"code":"Q131","codePrefix":"Q","type":"question","description":"dissatisfied body","direction":"negative","underlyingIssue":"feeling dissatisfied with one\'s body","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt dissatisfied with your body as a result of your disease or treatment?</p>","recommendedWordings":[],"categories":null,"id":171,"createDate":"2016-02-25T14:48:00.75","updateDate":"2016-06-28T15:02:11.843"},"questionnaire":13,"position":19,"wording":"Have you been dissatisfied with your body?","comment":null,"id":351,"createDate":"2016-02-29T14:49:15.123","updateDate":"2016-05-17T11:05:25.577"},{"item":{"code":"CS9","codePrefix":"CS","type":"condition","description":"if no urostomy","direction":null,"underlyingIssue":"","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":225,"createDate":"2016-02-29T12:59:21.06","updateDate":"2016-02-29T12:59:47.253"},"questionnaire":13,"position":2,"wording":"PLEASE ANSWER QUESTIONS 31 - 37 ONLY IF YOU DO NOT HAVE A UROSTOMY","comment":null,"relatedQuestions":[310,321,320,322,323,832],"id":305,"createDate":"2016-02-29T12:59:21.093","updateDate":"2017-03-14T16:44:50.54"},{"item":{"code":"CS10","codePrefix":"CS","type":"condition","description":"if urostomy","direction":null,"underlyingIssue":"","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":226,"createDate":"2016-02-29T13:04:51.073","updateDate":"2016-02-29T13:04:51.073"},"questionnaire":13,"position":3,"wording":"PLEASE ANSWER QUESTIONS 38 - 43 ONLY IF YOU HAVE A UROSTOMY","comment":null,"relatedQuestions":[325,326,331,339,340,341],"id":306,"createDate":"2016-02-29T13:04:51.093","updateDate":"2016-05-17T11:06:56.137"},{"item":{"code":"CS11","codePrefix":"CS","type":"condition","description":"if catheter, during the past week","direction":null,"underlyingIssue":"","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":227,"createDate":"2016-02-29T13:05:39.733","updateDate":"2016-02-29T13:05:39.733"},"questionnaire":13,"position":4,"wording":"PLEASE ANSWER QUESTION 44 ONLY IF YOU HAVE USED A CATHETER DURING THE PAST WEEK","comment":null,"relatedQuestions":[342],"id":307,"createDate":"2016-02-29T13:05:39.767","updateDate":"2016-06-27T12:07:40.017"},{"item":{"code":"Q176","codePrefix":"Q","type":"question","description":"pain burning feeling urinate","direction":"negative","underlyingIssue":"having pain/burning feeling when urinating","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had pain or a burning feeling when urinating?</p>","recommendedWordings":[],"categories":null,"id":233,"createDate":"2016-02-29T13:27:04.957","updateDate":"2016-06-24T11:25:17.737"},"questionnaire":13,"position":5,"wording":"Have you had pain or a burning feeling when urinating?","comment":null,"id":323,"createDate":"2016-02-29T13:27:05.007","updateDate":"2016-05-17T11:02:53.173"},{"item":{"code":"Q178","codePrefix":"Q","type":"question","description":"urine bag leak","direction":"negative","underlyingIssue":"urostomy bag leaking","additionalInfo":"","recommendedWordings":[],"categories":null,"id":235,"createDate":"2016-02-29T13:32:56.5","updateDate":"2016-06-07T09:38:58.763"},"questionnaire":13,"position":6,"wording":"Has urine leaked from your urostomy bag?","comment":null,"id":325,"createDate":"2016-02-29T13:32:56.517","updateDate":"2016-05-17T11:03:34.563"},{"item":{"code":"Q179","codePrefix":"Q","type":"question","description":"problem care urostomy","direction":"negative","underlyingIssue":"experiencing problems caring for the urostomy","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems with caring for your urostomy?</p>","recommendedWordings":[],"categories":null,"id":236,"createDate":"2016-02-29T13:34:00.01","updateDate":"2016-06-28T11:38:53.75"},"questionnaire":13,"position":7,"wording":"Did you have problems with caring for your urostomy?","comment":null,"id":326,"createDate":"2016-02-29T13:34:00.043","updateDate":"2016-05-17T11:03:45.56"},{"item":{"code":"Q181","codePrefix":"Q","type":"question","description":"skin irritarion urostomy","direction":"negative","underlyingIssue":"having irritated skin around the urostomy","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has your skin been irritated around the urostomy?</p>","recommendedWordings":[],"categories":null,"id":238,"createDate":"2016-02-29T13:36:49.683","updateDate":"2016-06-28T11:39:36.513"},"questionnaire":13,"position":8,"wording":"Was your skin around the urostomy irritated?","comment":null,"id":331,"createDate":"2016-02-29T13:36:49.717","updateDate":"2016-05-17T11:03:53.783"},{"item":{"code":"Q184","codePrefix":"Q","type":"question","description":"embarrassed urostomy","direction":"negative","underlyingIssue":"being embarrassed because of the urostomy","additionalInfo":"","recommendedWordings":[],"categories":null,"id":241,"createDate":"2016-02-29T13:53:55.313","updateDate":"2016-06-07T09:47:21.983"},"questionnaire":13,"position":9,"wording":"Have you felt embarrassed because of your urostomy?","comment":null,"id":339,"createDate":"2016-02-29T13:53:55.347","updateDate":"2016-05-17T11:04:06.543"},{"item":{"code":"Q185","codePrefix":"Q","type":"question","description":"dependent others urostomy care ","direction":"negative","underlyingIssue":"depending on others for urostomy care ","additionalInfo":"","recommendedWordings":[],"categories":null,"id":242,"createDate":"2016-02-29T13:56:41.443","updateDate":"2016-06-07T09:47:46.12"},"questionnaire":13,"position":10,"wording":"Have you been dependent on others for caring  for your urostomy?","comment":null,"id":340,"createDate":"2016-02-29T13:56:41.477","updateDate":"2016-05-17T11:04:16.53"},{"item":{"code":"Q186","codePrefix":"Q","type":"question","description":"urostomy bag changes","direction":"negative","underlyingIssue":"having to frequently change the urostomy bag","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had to frequently change the urostomy bag?</p>","recommendedWordings":[],"categories":null,"id":243,"createDate":"2016-02-29T13:58:05.547","updateDate":"2016-06-07T09:51:28.89"},"questionnaire":13,"position":11,"wording":"Did you frequently have to change the urostomy bag?","comment":null,"id":341,"createDate":"2016-02-29T13:58:05.58","updateDate":"2016-05-17T11:04:21.63"},{"item":{"code":"Q187","codePrefix":"Q","type":"question","description":"problem self-catheterization","direction":"negative","underlyingIssue":"experiencing problems with self-catheterization","additionalInfo":"","recommendedWordings":[],"categories":null,"id":244,"createDate":"2016-02-29T14:08:26.763","updateDate":"2016-06-03T13:50:22.313"},"questionnaire":13,"position":12,"wording":"Have you had problems with self-catheterization? (inserting a tube in the bladder to pass urine)","comment":null,"id":342,"createDate":"2016-02-29T14:08:26.797","updateDate":"2016-05-17T11:04:26.95"},{"item":{"code":"Q188","codePrefix":"Q","type":"question","description":"worry results","direction":"negative","underlyingIssue":"worrying about results of examinations and tests","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about the results of examinations and tests?</p>","recommendedWordings":[],"categories":null,"id":245,"createDate":"2016-02-29T14:12:13.267","updateDate":"2016-06-28T14:35:55.75"},"questionnaire":13,"position":14,"wording":"Did you worry about the results of examinations and tests?","comment":null,"id":344,"createDate":"2016-02-29T14:12:13.287","updateDate":"2016-05-17T11:04:46.903"},{"item":{"code":"Q189","codePrefix":"Q","type":"question","description":"worry future treatments","direction":"negative","underlyingIssue":"worrying about possible future treatments","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about possible future treatments?</p>","recommendedWordings":[],"categories":null,"id":246,"createDate":"2016-02-29T14:15:34.67","updateDate":"2016-06-07T09:55:42.347"},"questionnaire":13,"position":15,"wording":"Did you worry about possible future treatments?","comment":null,"id":345,"createDate":"2016-02-29T14:15:34.72","updateDate":"2016-05-17T11:04:53.783"},{"item":{"code":"Q190","codePrefix":"Q","type":"question","description":"flatulence","direction":"negative","underlyingIssue":"having flatulence/gas","additionalInfo":"","recommendedWordings":[],"categories":null,"id":247,"createDate":"2016-02-29T14:38:38.54","updateDate":"2016-06-07T09:56:12.987"},"questionnaire":13,"position":17,"wording":"Have you had flatulence or gas?","comment":null,"id":348,"createDate":"2016-02-29T14:38:38.57","updateDate":"2016-05-17T11:05:15.497"},{"item":{"code":"Q191","codePrefix":"Q","type":"question","description":"less feminine/masculine ","direction":"negative","underlyingIssue":"feeling less feminine/masculine","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt less masculine/feminine as a result of your disease or treatment?</p>","recommendedWordings":[],"categories":null,"id":248,"createDate":"2016-02-29T14:54:06.867","updateDate":"2017-02-16T12:18:13.02"},"questionnaire":13,"position":20,"wording":"Have you felt less feminine/masculine as a result of your illness or treatment?","comment":null,"id":352,"createDate":"2016-02-29T14:54:06.9","updateDate":"2016-05-17T11:05:31.427"},{"item":{"code":"Q192","codePrefix":"Q","type":"question","description":"worry contaminate bladder treatment","direction":"negative","underlyingIssue":"worrying about possible contamination of the partner during sexual contact with the bladder treatment","additionalInfo":"","recommendedWordings":[],"categories":null,"id":249,"createDate":"2016-02-29T15:04:22.763","updateDate":"2016-06-07T10:06:07.217"},"questionnaire":13,"position":29,"wording":"Have you worried that you may contaminate your partner during sexual contact with the \\tbladder treatment you have been receiving?","comment":null,"id":865,"createDate":"2016-03-02T14:26:14.053","updateDate":"2016-05-17T11:06:01.457"},{"item":{"code":"Q230","codePrefix":"Q","type":"question","description":"pain discomfort anus","direction":"negative","underlyingIssue":"experiencing pain/discomfort around the anus","additionalInfo":"","recommendedWordings":[],"categories":null,"id":288,"createDate":"2016-03-01T10:32:28.247","updateDate":"2016-06-07T12:51:28.573"},"questionnaire":13,"position":35,"wording":"Have you had pain /discomfort around your anal opening (back passsssssage)?","comment":null,"id":9016,"createDate":"2021-04-08T12:59:01.397","updateDate":"2021-04-08T12:59:01.397"},{"item":{"code":"Q454","codePrefix":"Q","type":"question","description":"leak urine","direction":"negative","underlyingIssue":"having leaking of urine","additionalInfo":"","recommendedWordings":[],"categories":null,"id":543,"createDate":"2016-03-03T12:48:03.337","updateDate":"2016-06-15T11:36:48.437"},"questionnaire":13,"position":4,"wording":"Have you had any unintentional release (leakage) of urine?","comment":null,"id":322,"createDate":"2016-02-29T13:19:52.51","updateDate":"2017-03-09T17:07:30.97"},{"item":{"code":"Q640","codePrefix":"Q","type":"question","description":"Test Keyword Autocompletion","direction":"negative","underlyingIssue":"stress","additionalInfo":"<h3>any other information worth mentioning...</h3>","recommendedWordings":[],"categories":null,"id":1000979,"createDate":"2017-03-09T15:34:14.613","updateDate":"2017-03-09T16:21:55.633"},"questionnaire":13,"position":30,"wording":"Test Keyword Autocompletion Wording","comment":null,"id":7463,"createDate":"2017-03-09T15:34:14.59","updateDate":"2017-03-14T17:01:11.273"},{"item":{"code":"Q641","codePrefix":"Q","type":"question","description":"Test Code for Item","direction":"negative","underlyingIssue":"stress","additionalInfo":"Additonal Test Info","recommendedWordings":[],"categories":null,"id":1000980,"createDate":"2017-03-09T15:48:17.557","updateDate":"2017-03-10T15:52:59.383"},"questionnaire":13,"position":31,"wording":"Test Code for Item Wording","comment":null,"id":7464,"createDate":"2017-03-09T15:48:17.573","updateDate":"2017-03-14T17:01:07.233"},{"item":{"code":"SS3","codePrefix":"SS","type":"symptomScale","description":"Test Symptom Scale","direction":null,"underlyingIssue":"","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":1000985,"createDate":"2017-03-14T16:40:34.207","updateDate":"2017-03-14T16:40:34.207"},"questionnaire":13,"position":1,"wording":"Test Wording Symptom Scale","comment":null,"relatedQuestions":[321,320,322,323,325,326,331,339],"id":7469,"createDate":"2017-03-14T16:40:34.123","updateDate":"2017-03-14T16:56:21.813"},{"item":{"code":"Q649","codePrefix":"Q","type":"question","description":"test bug 379","direction":"positive","underlyingIssue":"rd","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":1000996,"createDate":"2017-04-24T15:24:55.31","updateDate":"2017-04-24T15:24:55.31"},"questionnaire":13,"position":32,"wording":"test","comment":null,"id":7684,"createDate":"2017-04-24T15:24:55.373","updateDate":"2017-04-24T15:24:55.373"}],"languages":[{"code":"en","name":"English"},{"code":"sv","name":"Swedish"}]}');
;// CONCATENATED MODULE: ./src/mocks/questionnaires/get/index.tsx




/* harmony default export */ function get() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.get(resolvePath("".concat(questionnairesPath/* default */.ZP, "/*/details/en")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json(questionnaire_namespaceObject));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/questionnaires/publish/index.ts




/* harmony default export */ function publish() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.put(resolvePath("".concat(questionnairesPath/* default */.ZP, "/*/publish")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json(questionnaires_namespaceObject));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/questionnaires/delete/index.tsx



/* harmony default export */ function questionnaires_delete() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest["delete"](resolvePath("".concat(questionnairesPath/* default */.ZP, "/*")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({}));
        }), 
    ];
};

// EXTERNAL MODULE: ./src/consts/paths/api/questionnaires/questionnaireItemsPath.ts
var questionnaireItemsPath = __webpack_require__(30829);
;// CONCATENATED MODULE: ./src/mocks/questionnaires/updateQuestionnaireItem/index.ts



/* harmony default export */ function updateQuestionnaireItem() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.put(resolvePath("".concat(questionnaireItemsPath/* default */.Z, "/*")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({
                questionnaire: 18,
                item: 311,
                position: 2,
                wording: 'Have you had numbness or tingling in your arm or shoulder?',
                comment: null,
                relatedQuestions: [],
                id: 458,
                createDate: '2016-03-01T11:52:04.853',
                updateDate: '2022-03-11T09:30:34.8381178+00:00'
            }));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/questionnaires/deleteQuestionnaireItem/index.tsx



/* harmony default export */ function deleteQuestionnaireItem() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest["delete"](resolvePath("".concat(questionnaireItemsPath/* default */.Z, "/*")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({}));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/questionnaires/editQuestionnaireItem/index.ts



/* harmony default export */ function editQuestionnaireItem() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.put(resolvePath("".concat(questionnaireItemsPath/* default */.Z, "/*")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({
                name: 'sadsad',
                code: null,
                type: 'itemlist',
                state: 'draft',
                phase: null,
                gender: 'female',
                chemical: 'asdsad',
                description: 'asdsad',
                additionalInfo: null,
                contact: null,
                isCustom: true,
                author: 73,
                questionsStartPosition: 1,
                languages: [
                    {
                        code: 'en',
                        name: 'English'
                    }
                ],
                id: 1000288,
                createDate: '2022-02-09T12:36:19.7441355+00:00',
                updateDate: '2022-02-09T12:36:19.7441355+00:00'
            }));
        }), 
    ];
};

// EXTERNAL MODULE: ./src/consts/paths/api/items/search/searchScalePath.ts
var searchScalePath = __webpack_require__(53917);
;// CONCATENATED MODULE: ./src/mocks/items/search/timeScales/timeScales.json
var timeScales_namespaceObject = JSON.parse('[{"rank":null,"id":2,"code":"TS1","type":"timeScale","description":"past week","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"During the past week:","recommendedWording":null,"questionnaires":[1,2,4,5,9,11,1000265,1000275,1000280,1000282,1000287,1000249,1000250,1000258,1000260,1000263,44,45,46,48,49,1000243,37,38,40,41,42,43,31,32,33,34,35,36,24,25,26,27,29,30,18,19,20,21,22,23,12,13,14,15,16,17],"categories":[],"createDate":"2016-02-02T11:56:24.837","updateDate":"2017-03-10T17:10:10.763"},{"rank":null,"id":5,"code":"TS2","type":"timeScale","description":"last 4 weeks","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"During the past 4 weeks:","recommendedWording":null,"questionnaires":[1,8,19,23,24,30,1000282,42,44,45,46,1000265,1000277,31,32,33,34,36,41],"categories":[],"createDate":"2016-02-10T11:28:03.23","updateDate":"2016-03-04T14:26:11.287"},{"rank":null,"id":255,"code":"TS3","type":"timeScale","description":"pain during the past week","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"During the past week have you had pain in any of the following parts of your body?","recommendedWording":null,"questionnaires":[14,1000142,1000243,1000262,1000263],"categories":[],"createDate":"2016-02-29T15:27:58.143","updateDate":"2016-02-29T15:27:58.143"},{"rank":null,"id":345,"code":"TS4","type":"timeScale","description":"past week satisfaction","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"During the past week,  how SATISFIED have you been with:","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:26:19.26","updateDate":"2016-03-01T13:26:54.027"},{"rank":null,"id":440,"code":"TS5","type":"timeScale","description":"course current illness treatment","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"In the course of your current illness or its treatment,\\nnot only the past week:","recommendedWording":null,"questionnaires":[25,1000277],"categories":[],"createDate":"2016-03-02T11:04:56.533","updateDate":"2016-03-02T11:04:56.533"},{"rank":null,"id":572,"code":"TS6","type":"timeScale","description":"current disease treatment information","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"During your current disease or treatment, how much information have you received on:","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T13:52:34.487","updateDate":"2016-03-03T13:52:34.487"},{"rank":null,"id":746,"code":"TS7","type":"timeScale","description":"past week satisfied ","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"During the past week, how satisfied have you been with:","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-07-08T10:33:51.8","updateDate":"2016-07-08T10:33:51.8"},{"rank":null,"id":750,"code":"TS8","type":"timeScale","description":"generally","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"More generally:","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-09-14T14:13:20.237","updateDate":"2016-09-14T14:13:20.237"},{"rank":null,"id":1000967,"code":"TS9","type":"timeScale","description":"test scale","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"test wording","recommendedWording":null,"questionnaires":[1000083],"categories":[],"createDate":"2017-03-03T10:07:52.833","updateDate":"2017-03-03T10:07:52.833"},{"rank":null,"id":1001006,"code":"TS10","type":"timeScale","description":"demo item code timescale","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"demo item code timescale","recommendedWording":null,"questionnaires":[5],"categories":[],"createDate":"2017-05-02T14:10:30.903","updateDate":"2017-05-02T14:10:30.903"}]');
// EXTERNAL MODULE: ./src/_types/api/items/ItemType.ts
var ItemType = __webpack_require__(75594);
;// CONCATENATED MODULE: ./src/mocks/items/search/timeScales/index.ts





/* harmony default export */ function timeScales() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 0 : _delay;
    return [
        rest.get(resolvePath(searchScalePath/* default */.Z), function(req, res, ctx) {
            var type = req.url.searchParams.get('type');
            if (type !== ItemType/* default.TimeScale */.Z.TimeScale) {
                return;
            }
            return res(ctx.delay(delay), ctx.status(200), ctx.json(timeScales_namespaceObject));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/items/search/responseScales/responseScales.json
var responseScales_namespaceObject = JSON.parse('[{"rank":null,"id":3,"code":"RS1","type":"responseScale","description":"4-point Likert scale","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Not at all, A little, Quite a bit, Very much","recommendedWording":null,"questionnaires":[1,2,4,5,8,9,1000265,1000277,1000280,1000282,1000287,1000250,1000258,1000260,1000261,1000262,1000263,45,46,48,49,1000090,1000249,39,40,41,42,43,44,33,34,35,36,37,38,27,28,29,30,31,32,21,22,23,24,25,26,15,16,17,18,19,20,10,11,12,13,14],"categories":[],"createDate":"2016-02-02T11:57:02.403","updateDate":"2017-03-10T17:10:42.057"},{"rank":null,"id":19,"code":"RS2","type":"responseScale","description":"7-point scale C30","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Very poor, Excellent","recommendedWording":null,"questionnaires":[4,46,1000175,1000230,1000231,1000243,1000274,1000275],"categories":[],"createDate":"2016-02-10T15:30:57.343","updateDate":"2016-02-18T09:12:24.183"},{"rank":null,"id":164,"code":"RS3","type":"responseScale","description":"binary","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Yes, No","recommendedWording":null,"questionnaires":[9,16,25,32,37,39,1000283,1000298,1000092,1000175,1000240,1000258,1000259,1000260],"categories":[],"createDate":"2016-02-25T14:10:16.883","updateDate":"2016-02-25T14:10:16.883"},{"rank":null,"id":496,"code":"RS4","type":"responseScale","description":"4-point Likert scale + N/A","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"N/A, Not at all, A little, Quite a bit, Very much","recommendedWording":null,"questionnaires":[28,42,1000142,1000232],"categories":[],"createDate":"2016-03-02T14:40:28.043","updateDate":"2016-03-02T14:40:56.983"},{"rank":null,"id":661,"code":"RS5","type":"responseScale","description":"5-point satisfaction scale","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Poor, Fair, Good, Very good, Excellent","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T12:27:13.783","updateDate":"2016-03-04T14:26:25.327"},{"rank":null,"id":708,"code":"RS6","type":"responseScale","description":"0-7 point scale","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Don\'t know/ Can\'t answer, Very poor, Excellent","recommendedWording":null,"questionnaires":[49,1000240],"categories":[],"createDate":"2016-03-07T09:42:10.433","updateDate":"2016-03-07T09:42:10.433"},{"rank":null,"id":748,"code":"RS7","type":"responseScale","description":"category HCPs","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Doctor(s), Nurse(s), Psychologist(s), Radiotherapy technician(s), Other (please specify: _____________)","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-08-12T11:40:29.123","updateDate":"2016-08-12T11:40:29.123"},{"rank":null,"id":749,"code":"RS8","type":"responseScale","description":"communication time","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"During the period of diagnosis, treatment, follow up","recommendedWording":null,"questionnaires":[28,1000250],"categories":[],"createDate":"2016-08-12T11:42:04.473","updateDate":"2016-08-12T11:42:04.473"}]');
;// CONCATENATED MODULE: ./src/mocks/items/search/responseScales/index.ts





/* harmony default export */ function responseScales() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.get(resolvePath(searchScalePath/* default */.Z), function(req, res, ctx) {
            var type = req.url.searchParams.get('type');
            if (type !== ItemType/* default.ResponseScale */.Z.ResponseScale) {
                return;
            }
            return res(ctx.delay(delay), ctx.status(200), ctx.json(responseScales_namespaceObject));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/questionnaires/addQuestionnaireItem/index.ts



/* harmony default export */ function addQuestionnaireItem() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.post(resolvePath("".concat(questionnaireItemsPath/* default */.Z)), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({
                comment: null,
                createDate: '2022-03-21T15:12:43.6665031+00:00',
                id: 9141,
                item: 748,
                position: 26,
                questionnaire: 1000243,
                relatedQuestions: [],
                updateDate: '2022-03-21T15:12:43.6665031+00:00',
                wording: 'Doctor(s), Nurse(s), Psychologist(s), Radiotherapy technician(s), Other (please specify: _____________)'
            }));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/questionnaires/downloadCsv/index.ts



/* harmony default export */ function downloadCsv() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.get(resolvePath("".concat(questionnairesPath/* default */.ZP, "/*").concat(questionnairesPath/* downloadCsvPath */.qn)), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.text('Questionnaire,ItemId,Type,Position,Code,Wording,Translation,RelatedQuestions ADB - Official #1,616,Question,1,Q522,Did tiredness interfere with your daily activities?,, ADB - Official #1,7,Question,2,Q4,"Do you have any trouble doing strenuous activities, like carrying a heavy shopping bag or a suitcase ? ",,'));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/items/updateItem/index.ts




/* harmony default export */ function updateItem() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.put(resolvePath("".concat(getItems/* default */.Z, "/*")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json(item_namespaceObject));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/items/search/items.json
var items_namespaceObject = JSON.parse('[{"rank":null,"id":1,"code":"Q1","type":"question","description":"less masculine","direction":"negative","underlyingIssue":"feeling less like a man","additionalInfo":"","preferredWording":"Have you felt less masculine as a result of your disease or treatment?","recommendedWording":null,"questionnaires":[1,8,11,1000092,1000232,1000233,1000278,1000298,1000240,1000243,1000258,1000259,1000265,1000277],"categories":[],"createDate":"2016-02-02T11:40:49.9","updateDate":"2016-04-18T08:50:01.14"},{"rank":null,"id":2,"code":"TS1","type":"timeScale","description":"past week","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"During the past week:","recommendedWording":null,"questionnaires":[1,2,4,5,9,11,1000265,1000275,1000280,1000282,1000287,1000249,1000250,1000258,1000260,1000263,44,45,46,48,49,1000243,37,38,40,41,42,43,31,32,33,34,35,36,24,25,26,27,29,30,18,19,20,21,22,23,12,13,14,15,16,17],"categories":[],"createDate":"2016-02-02T11:56:24.837","updateDate":"2017-03-10T17:10:10.763"},{"rank":null,"id":3,"code":"RS1","type":"responseScale","description":"4-point Likert scale","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Not at all, A little, Quite a bit, Very much","recommendedWording":null,"questionnaires":[1,2,4,5,8,9,1000280,1000282,1000287,1000261,1000262,1000263,1000265,1000277,1000249,1000250,1000258,1000260,45,46,48,49,1000090,1000177,39,40,41,42,43,44,33,34,35,36,37,38,27,28,29,30,31,32,21,22,23,24,25,26,15,16,17,18,19,20,10,11,12,13,14],"categories":[],"createDate":"2016-02-02T11:57:02.403","updateDate":"2017-03-10T17:10:42.057"},{"rank":null,"id":4,"code":"Q2","type":"question","description":"frequent urination day","direction":"negative","underlyingIssue":"havint to urinate frequently during the day","additionalInfo":"<p><u>Recommended wording: </u></p><p>Have you had to urinate frequently during the day?</p>","preferredWording":"Did you urinate frequently during the day?","recommendedWording":"Did you urinate frequently during the day?","questionnaires":[1,5,30,32,1000090,1000152,1000249,1000277,1000153,1000232,1000233,1000240,1000243],"categories":[],"createDate":"2016-02-10T11:25:09.97","updateDate":"2017-04-03T16:48:25.917"},{"rank":null,"id":5,"code":"TS2","type":"timeScale","description":"last 4 weeks","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"During the past 4 weeks:","recommendedWording":null,"questionnaires":[1,8,19,23,24,1000282,1000177,1000265,1000277,41,42,44,45,46,30,31,32,33,34,36],"categories":[],"createDate":"2016-02-10T11:28:03.23","updateDate":"2016-03-04T14:26:11.287"},{"rank":null,"id":6,"code":"Q3","type":"question","description":"weight loss problem","direction":"negative","underlyingIssue":"having a problem with losing too much weight","additionalInfo":null,"preferredWording":"Has weight loss been a problem for you?","recommendedWording":null,"questionnaires":[1,42,1000271,1000298,1000249,1000258,1000259,1000232,1000233,1000240,1000243,48,1000092],"categories":[],"createDate":"2016-02-10T11:31:26.9","updateDate":"2016-02-19T14:25:59.537"},{"rank":null,"id":7,"code":"Q4","type":"question","description":"PF carry bags","direction":"negative","underlyingIssue":"experiencing problems carrying heavy items","additionalInfo":null,"preferredWording":"Do you have any trouble doing strenuous activities, like carrying a heavy shopping bag or a suitcase?","recommendedWording":null,"questionnaires":[4,13,1000272,1000273,1000274,1000279],"categories":[],"createDate":"2016-02-10T11:39:32.283","updateDate":"2016-04-04T15:04:07.07"},{"rank":null,"id":8,"code":"Q5","type":"question","description":"PF long walk","direction":"negative","underlyingIssue":"experiencing problems taking a long walk","additionalInfo":null,"preferredWording":"Do you have any trouble taking a long walk?","recommendedWording":null,"questionnaires":[4,1000260],"categories":[],"createDate":"2016-02-10T12:23:09.207","updateDate":"2016-04-04T15:04:49.753"},{"rank":null,"id":9,"code":"Q6","type":"question","description":"PF short walk","direction":"negative","underlyingIssue":"experiencing problems taking a short walk","additionalInfo":null,"preferredWording":"Do you have any trouble taking a short walk outside of the house?","recommendedWording":null,"questionnaires":[4,5,1000260,1000261,1000264,1000274,1000090,46],"categories":[],"createDate":"2016-02-10T12:29:26.073","updateDate":"2016-04-04T15:05:06.587"},{"rank":null,"id":10,"code":"Q7","type":"question","description":"RF work daily activities","direction":"negative","underlyingIssue":"feeling limited in working or doing daily activities","additionalInfo":"","preferredWording":"Were you limited in doing either your work or other daily activities?","recommendedWording":null,"questionnaires":[4,1000230],"categories":[],"createDate":"2016-02-10T12:59:07.657","updateDate":"2016-06-02T14:08:44.76"},{"rank":null,"id":11,"code":"IN1","type":"instructions","description":"initials","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please fill in your initials:","recommendedWording":null,"questionnaires":[4,46,1000090,1000243,1000265,1000277,1000297],"categories":[],"createDate":"2016-02-10T13:04:57.33","updateDate":"2016-02-10T13:04:57.33"},{"rank":null,"id":12,"code":"IN2","type":"instructions","description":"birthdate","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Your birthdate (Day, Month, Year):","recommendedWording":null,"questionnaires":[4,46,1000265],"categories":[],"createDate":"2016-02-10T15:12:17.837","updateDate":"2016-02-18T09:10:33.543"},{"rank":null,"id":13,"code":"IN3","type":"instructions","description":"today\'s date","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Today\'s date (Day, Month, Year): \\t","recommendedWording":null,"questionnaires":[4,46],"categories":[],"createDate":"2016-02-10T15:13:54.793","updateDate":"2016-02-18T09:11:08.13"},{"rank":null,"id":15,"code":"IN4","type":"instructions","description":"next page","direction":null,"underlyingIssue":"","additionalInfo":"<h4>Recommended wording:</h4><p>Please continue to the next page</p>","preferredWording":"Please go to the next page","recommendedWording":null,"questionnaires":[1,4,5,48,49,43,45,46,47,34,35,38,39,41,28,30,31,32,33,21,22,26,27,16,17,18,19,20,8,9,11,13],"categories":[],"createDate":"2016-02-10T15:21:39.32","updateDate":"2017-02-09T16:21:44.803"},{"rank":null,"id":16,"code":"IN5","type":"instructions","description":"last questions C30","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"For the following question please circle the number between 1 and 7 that best applies to you","recommendedWording":null,"questionnaires":[4,46],"categories":[],"createDate":"2016-02-10T15:22:43.847","updateDate":"2016-02-18T09:11:36.977"},{"rank":null,"id":17,"code":"Q8","type":"question","description":"PF bed or chair ","direction":"negative","underlyingIssue":"having to stay in bed or chair during the day","additionalInfo":null,"preferredWording":"Do you need to stay in bed or a chair during the day?","recommendedWording":null,"questionnaires":[4,46,1000230],"categories":[],"createDate":"2016-02-10T15:25:53.66","updateDate":"2016-04-04T15:06:19.117"},{"rank":null,"id":18,"code":"Q9","type":"question","description":"PF help with daily living","direction":"negative","underlyingIssue":"requiring help with basic daily activities","additionalInfo":"","preferredWording":"Do you need help with eating, dressing, washing yourself or using the toilet?","recommendedWording":null,"questionnaires":[4,46,50,1000180,1000230],"categories":[],"createDate":"2016-02-10T15:30:12.49","updateDate":"2016-06-02T14:09:26.803"},{"rank":null,"id":19,"code":"RS2","type":"responseScale","description":"7-point scale C30","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Very poor, Excellent","recommendedWording":null,"questionnaires":[4,46,1000175,1000177,1000230,1000231,1000243,1000274,1000275],"categories":[],"createDate":"2016-02-10T15:30:57.343","updateDate":"2016-02-18T09:12:24.183"},{"rank":null,"id":21,"code":"Q10","type":"question","description":"RF limited hobbies","direction":"negative","underlyingIssue":"feeling limited in pursuing hobbies or leisure activities","additionalInfo":null,"preferredWording":"Were you limited in pursuing your hobbies or other leisure time activities?","recommendedWording":null,"questionnaires":[4,1000230],"categories":[],"createDate":"2016-02-10T15:53:15.727","updateDate":"2016-04-04T15:07:55.577"},{"rank":null,"id":22,"code":"Q11","type":"question","description":"DY short of breath","direction":"negative","underlyingIssue":"feeling short of breath","additionalInfo":"","preferredWording":"Were you short of breath?","recommendedWording":null,"questionnaires":[4,46,1000142,1000268,1000297],"categories":[],"createDate":"2016-02-17T15:30:47.37","updateDate":"2016-06-02T14:10:01.843"},{"rank":null,"id":23,"code":"Q12","type":"question","description":"PA pain","direction":"negative","underlyingIssue":"experiencing pain","additionalInfo":"","preferredWording":"Have you had pain?","recommendedWording":null,"questionnaires":[4,13,14,18,46,1000169,1000182,1000238,1000250,1000263],"categories":[],"createDate":"2016-02-17T15:31:21.943","updateDate":"2016-06-02T14:12:12.98"},{"rank":null,"id":24,"code":"Q13","type":"question","description":"FA need to rest","direction":"negative","underlyingIssue":"feeling the need to rest","additionalInfo":null,"preferredWording":"Did you need to rest?","recommendedWording":null,"questionnaires":[4],"categories":[],"createDate":"2016-02-17T15:32:17.387","updateDate":"2016-04-04T15:09:48.95"},{"rank":null,"id":25,"code":"Q14","type":"question","description":"SL problem sleeping","direction":"negative","underlyingIssue":"experiencing problems sleeping","additionalInfo":null,"preferredWording":"Have you had trouble sleeping?","recommendedWording":null,"questionnaires":[4,46,1000177,1000287],"categories":[],"createDate":"2016-02-17T15:41:48.197","updateDate":"2016-04-04T15:10:21.087"},{"rank":null,"id":26,"code":"Q15","type":"question","description":"FA weak","direction":"negative","underlyingIssue":"feeling weak","additionalInfo":null,"preferredWording":"Have you felt weak?","recommendedWording":null,"questionnaires":[4,46],"categories":[],"createDate":"2016-02-17T15:43:45.95","updateDate":"2016-04-04T15:10:47.237"},{"rank":null,"id":27,"code":"Q16","type":"question","description":"AP appetite loss","direction":"negative","underlyingIssue":"experiencing appetite loss","additionalInfo":"","preferredWording":"Have you lacked appetite?","recommendedWording":null,"questionnaires":[4,46],"categories":[],"createDate":"2016-02-17T15:47:58.603","updateDate":"2016-06-02T14:13:09.58"},{"rank":null,"id":28,"code":"Q17","type":"question","description":"NV nausea","direction":"negative","underlyingIssue":"feeling nauseated","additionalInfo":"","preferredWording":"Have you felt nauseated?","recommendedWording":null,"questionnaires":[4,46],"categories":[],"createDate":"2016-02-17T15:48:32.033","updateDate":"2016-06-02T14:13:26.647"},{"rank":null,"id":29,"code":"Q18","type":"question","description":"NV vomiting","direction":"negative","underlyingIssue":"vomiting","additionalInfo":"","preferredWording":"Have you vomited?","recommendedWording":null,"questionnaires":[4,1000298],"categories":[],"createDate":"2016-02-17T15:48:52.393","updateDate":"2016-06-02T14:13:52.667"},{"rank":null,"id":30,"code":"Q19","type":"question","description":"CO constipation","direction":"negative","underlyingIssue":"experiencing constipation","additionalInfo":"","preferredWording":"Have you been constipated?","recommendedWording":null,"questionnaires":[4,46],"categories":[],"createDate":"2016-02-17T15:49:14.91","updateDate":"2016-06-02T14:14:49.673"},{"rank":null,"id":31,"code":"Q20","type":"question","description":"DI diarrhea","direction":"negative","underlyingIssue":"experiencing diarrhea","additionalInfo":"","preferredWording":"Have you had diarrhea?","recommendedWording":null,"questionnaires":[4],"categories":[],"createDate":"2016-02-17T15:49:53.79","updateDate":"2016-06-02T14:15:07.317"},{"rank":null,"id":32,"code":"Q21","type":"question","description":"FA tired","direction":"negative","underlyingIssue":"feeling tired","additionalInfo":null,"preferredWording":"Were you tired?","recommendedWording":null,"questionnaires":[4,46],"categories":[],"createDate":"2016-02-17T15:50:18.033","updateDate":"2016-04-04T15:17:14.857"},{"rank":null,"id":33,"code":"Q22","type":"question","description":"PA pain interfering daily activities","direction":"negative","underlyingIssue":"experiencing pain that interferes with daily activities","additionalInfo":"","preferredWording":"Did pain interfere with your daily activities?","recommendedWording":null,"questionnaires":[4,46,1000169],"categories":[],"createDate":"2016-02-17T15:51:06.623","updateDate":"2016-06-02T14:35:10.91"},{"rank":null,"id":34,"code":"Q23","type":"question","description":"CF concentration problems","direction":"negative","underlyingIssue":"experiencing problems concentrating on things","additionalInfo":"","preferredWording":"Have you had difficulty in concentrating on things, like reading a newspaper or watching television?\\n","recommendedWording":null,"questionnaires":[4],"categories":[],"createDate":"2016-02-17T15:51:57.463","updateDate":"2016-06-02T14:36:23.11"},{"rank":null,"id":35,"code":"Q24","type":"question","description":"EF tense","direction":"negative","underlyingIssue":"feeling tense","additionalInfo":"","preferredWording":"Did you feel tense?","recommendedWording":null,"questionnaires":[4,46],"categories":[],"createDate":"2016-02-17T15:53:12.153","updateDate":"2016-06-02T14:36:47.65"},{"rank":null,"id":36,"code":"Q25","type":"question","description":"EF worry","direction":"negative","underlyingIssue":"worrying","additionalInfo":null,"preferredWording":"Did you worry?","recommendedWording":null,"questionnaires":[4],"categories":[],"createDate":"2016-02-17T15:57:25.7","updateDate":"2016-04-04T15:28:00.427"},{"rank":null,"id":37,"code":"Q26","type":"question","description":"EF irritable","direction":"negative","underlyingIssue":"feeling irritable","additionalInfo":null,"preferredWording":"Did you feel irritable?","recommendedWording":null,"questionnaires":[4],"categories":[],"createDate":"2016-02-17T15:57:47.793","updateDate":"2016-04-04T15:28:33.89"},{"rank":null,"id":38,"code":"Q27","type":"question","description":"EF depressed","direction":"negative","underlyingIssue":"feeling depressed","additionalInfo":null,"preferredWording":"Did you feel depressed?","recommendedWording":null,"questionnaires":[4,46],"categories":[],"createDate":"2016-02-17T15:58:08","updateDate":"2016-04-04T15:41:10.353"},{"rank":null,"id":39,"code":"Q28","type":"question","description":" CF problem remembering","direction":"negative","underlyingIssue":" experiencing problems remembering things","additionalInfo":"","preferredWording":"Have you had difficulty remembering things?","recommendedWording":null,"questionnaires":[4],"categories":[],"createDate":"2016-02-17T15:58:39.66","updateDate":"2016-06-02T14:38:46.493"},{"rank":null,"id":40,"code":"Q29","type":"question","description":"SF interference family life","direction":"negative","underlyingIssue":"feeling that physical condition or treatment interfere with family life","additionalInfo":null,"preferredWording":"Has your physical condition or medical treatment interfered with your family life?","recommendedWording":null,"questionnaires":[4,1000271,1000272],"categories":[],"createDate":"2016-02-17T15:59:01.503","updateDate":"2016-04-04T15:43:26.877"},{"rank":null,"id":41,"code":"Q30","type":"question","description":"SF interference social activities","direction":"negative","underlyingIssue":"feeling that physical condition or treatment interfere with social activities","additionalInfo":null,"preferredWording":"Has your physical condition or medical treatment interfered with your social activities?\\n","recommendedWording":null,"questionnaires":[4],"categories":[],"createDate":"2016-02-17T15:59:23.643","updateDate":"2016-04-04T15:44:05.49"},{"rank":null,"id":42,"code":"Q31","type":"question","description":"FI financial difficulties","direction":"negative","underlyingIssue":"physical condition or treatment causing financial difficulties","additionalInfo":"","preferredWording":"Has your physical condition or medical treatment caused you financial difficulties?\\n","recommendedWording":null,"questionnaires":[4],"categories":[],"createDate":"2016-02-17T15:59:43.397","updateDate":"2016-06-02T14:39:57.943"},{"rank":null,"id":43,"code":"Q32","type":"question","description":"global health status","direction":"positive","underlyingIssue":"global health status","additionalInfo":null,"preferredWording":"How would you rate your overall health during the past week?","recommendedWording":null,"questionnaires":[4,1000174,1000180,1000300,1000301],"categories":[],"createDate":"2016-02-17T15:59:57.47","updateDate":"2016-04-04T15:45:28.08"},{"rank":null,"id":44,"code":"Q33","type":"question","description":"global quality of life","direction":"positive","underlyingIssue":"global quality of life","additionalInfo":"","preferredWording":"How would you rate your overall quality of life during the past week?","recommendedWording":null,"questionnaires":[4,46],"categories":[],"createDate":"2016-02-17T16:00:16.16","updateDate":"2016-06-02T14:40:33.717"},{"rank":null,"id":46,"code":"Q34","type":"question","description":"problems steps or stairs","direction":"negative","underlyingIssue":"experiencing problems climbing steps or stairs","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with steps or stairs?</p>","preferredWording":"Have you had difficulty with steps or stairs?","recommendedWording":null,"questionnaires":[2],"categories":[],"createDate":"2016-02-18T11:32:53.94","updateDate":"2016-06-28T14:13:05.223"},{"rank":null,"id":47,"code":"Q35","type":"question","description":"problems joints","direction":"negative","underlyingIssue":"experiencing problems with joints","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems with your joints (e.g. stiffness, pain)?</p>","preferredWording":"Have you had trouble with your joints (e.g. stiffness, pain)?","recommendedWording":null,"questionnaires":[2],"categories":[],"createDate":"2016-02-18T11:34:08.337","updateDate":"2016-09-08T10:15:59.73"},{"rank":null,"id":48,"code":"Q36","type":"question","description":"unsteady on feet","direction":"negative","underlyingIssue":"feeling unsteady on one\'s feet","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt unsteady on your feet?</p>","preferredWording":"Did you feel unsteady on your feet?","recommendedWording":null,"questionnaires":[2,15],"categories":[],"createDate":"2016-02-18T11:34:53.423","updateDate":"2016-06-28T12:19:18.037"},{"rank":null,"id":49,"code":"Q37","type":"question","description":"help with chores","direction":"negative","underlyingIssue":"needing help with household chores","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you needed help with household chores such as cleaning or shopping?</p>","preferredWording":"Did you need help with household chores such as cleaning or shopping?\\n","recommendedWording":null,"questionnaires":[2],"categories":[],"createDate":"2016-02-18T11:38:01.16","updateDate":"2016-06-28T14:14:24.227"},{"rank":null,"id":50,"code":"Q38","type":"question","description":"able to talk with family about illness","direction":"positive","underlyingIssue":"feeling able to talk with one\'s family about the illness","additionalInfo":"","preferredWording":"Have you felt able to talk to your family about your illness?","recommendedWording":null,"questionnaires":[2],"categories":[],"createDate":"2016-02-18T11:43:32.47","updateDate":"2016-06-02T14:57:33.303"},{"rank":null,"id":51,"code":"Q39","type":"question","description":"worry family coping","direction":"negative","underlyingIssue":"worrying about one\'s family coping with the illness and treatment","additionalInfo":"","preferredWording":"Have you worried about your family coping with your illness and treatment?","recommendedWording":null,"questionnaires":[2],"categories":[],"createDate":"2016-02-18T11:44:53.063","updateDate":"2016-06-02T15:00:26.78"},{"rank":null,"id":52,"code":"Q40","type":"question","description":"worry future important people","direction":"negative","underlyingIssue":"worrying about the future of the important people","additionalInfo":"","preferredWording":"I have worried about the future of people who are important to me","recommendedWording":null,"questionnaires":[2,49,1000142,1000160,1000250,1000260],"categories":[],"createDate":"2016-02-18T11:45:47.09","updateDate":"2016-06-02T15:13:01.563"},{"rank":null,"id":53,"code":"Q41","type":"question","description":"worry health in future","direction":"negative","underlyingIssue":"worrying about health in the future","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you worried about your health in the future?</p>","preferredWording":"Have you worried about your health in the future?","recommendedWording":"Were you worried about your health in the future?","questionnaires":[2,5,10,12,13,14,1000263,48,1000230,1000231,1000236,1000238,1000250,36,41,42,43,45,27,30,31,32,33,35,17,19,21,23,24,26],"categories":[],"createDate":"2016-02-18T11:46:37.807","updateDate":"2016-06-02T15:16:24.48"},{"rank":null,"id":54,"code":"Q42","type":"question","description":"uncertain about future","direction":"negative","underlyingIssue":"feeling uncertain about one\'s future","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt uncertain about the future?</p>","preferredWording":"Did you feel uncertain about the future?","recommendedWording":"Did you feel uncertain about the future? Reco by ADB","questionnaires":[2,11,15,1000242,1000244],"categories":[],"createDate":"2016-02-18T11:47:16.217","updateDate":"2016-06-28T11:59:24.763"},{"rank":null,"id":55,"code":"Q43","type":"question","description":"worry end of life","direction":"negative","underlyingIssue":"worrying about what might happen towards the end of one\'s life","additionalInfo":"","preferredWording":"Have you worried about what might happen towards the end of your life?","recommendedWording":null,"questionnaires":[2],"categories":[],"createDate":"2016-02-18T11:48:10.833","updateDate":"2016-06-02T15:17:37.333"},{"rank":null,"id":56,"code":"Q44","type":"question","description":"positive outlook","direction":"positive","underlyingIssue":"having a positive outlook on life","additionalInfo":null,"preferredWording":"Have you had a positive outlook on life in the last week?","recommendedWording":null,"questionnaires":[2],"categories":[],"createDate":"2016-02-18T11:50:08.163","updateDate":"2016-02-18T11:50:08.163"},{"rank":null,"id":57,"code":"Q45","type":"question","description":"motivated continue hobbies","direction":"positive","underlyingIssue":"feeling motivated to continue with normal hobbies and activities","additionalInfo":"","preferredWording":"Have you felt motivated to continue with your normal hobbies and activities?","recommendedWording":null,"questionnaires":[2],"categories":[],"createDate":"2016-02-18T11:51:08.117","updateDate":"2016-06-03T13:24:57.16"},{"rank":null,"id":58,"code":"Q46","type":"question","description":"burden disease patient","direction":"negative","underlyingIssue":"disease being a burden to the patient","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has your disease been a burden to you?</p>","preferredWording":"How much has your disease been a burden to you?","recommendedWording":null,"questionnaires":[2,19],"categories":[],"createDate":"2016-02-18T11:51:46.23","updateDate":"2016-06-28T15:38:54.527"},{"rank":null,"id":59,"code":"Q47","type":"question","description":"burden treatment patient","direction":"negative","underlyingIssue":"treatment being a burden to the patient","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has your treatment been a burden to you?</p>","preferredWording":"How much has your treatment been a burden to you?","recommendedWording":null,"questionnaires":[2,19,26],"categories":[],"createDate":"2016-02-18T11:52:22.983","updateDate":"2016-06-28T15:38:25.647"},{"rank":null,"id":60,"code":"Q48","type":"question","description":"hurry to toilet","direction":"negative","underlyingIssue":"having to hurry to get to the toilet when feeling the urge to pass urine","additionalInfo":"","preferredWording":"When you felt the urge to pass urine, did you have to hurry to get to the toilet?","recommendedWording":null,"questionnaires":[1,13,30,38,1000243,1000232,1000233,1000240],"categories":[],"createDate":"2016-02-18T13:13:22.243","updateDate":"2016-06-24T11:27:14.913"},{"rank":null,"id":61,"code":"Q49","type":"question","description":"enough sleep urinate","direction":"negative","underlyingIssue":"experiencing problems with getting enough sleep because of having to get up frequently at night to urinate","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems getting enough sleep, because you needed to get up frequently at night to urinate?</p>","preferredWording":"Was it difficult for you to get enough sleep, because you needed to get up frequently at night to urinate?","recommendedWording":null,"questionnaires":[1,13,30,1000232,1000233,1000240,1000243],"categories":[],"createDate":"2016-02-18T13:15:36.77","updateDate":"2016-06-28T11:28:55.257"},{"rank":null,"id":62,"code":"Q50","type":"question","description":"go out close to toilet","direction":"negative","underlyingIssue":"having problems getting out of the house because of having to be close to the toilet","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems going out of the house, because you needed to be close to a toilet?</p>","preferredWording":"Have you had difficulty going out of the house, because you needed to be close to a toilet?","recommendedWording":null,"questionnaires":[1,13,16,30,1000232,1000233,1000240,1000243,1000250],"categories":[],"createDate":"2016-02-18T13:17:11.963","updateDate":"2016-06-28T11:38:20.46"},{"rank":null,"id":64,"code":"Q51","type":"question","description":"pain at urination","direction":"negative","underlyingIssue":"having pain when urinating","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had pain when urinating?</p>","preferredWording":"Did you have pain when you urinated?","recommendedWording":null,"questionnaires":[1,32,1000232,1000233,1000240,1000243],"categories":[],"createDate":"2016-02-18T13:19:23.663","updateDate":"2017-03-31T12:56:15.74"},{"rank":null,"id":66,"code":"Q52","type":"question","description":"problem incontinence aid","direction":"negative","underlyingIssue":"having problems wearing an incontinence aid","additionalInfo":"","preferredWording":"Has wearing an incontinence aid been a problem for you?","recommendedWording":null,"questionnaires":[1,1000092,1000232,1000233,1000240,1000243,1000258,1000259,1000260,1000298],"categories":[],"createDate":"2016-02-18T13:24:56.33","updateDate":"2016-06-03T13:47:05.153"},{"rank":null,"id":67,"code":"Q53","type":"question","description":"urinary problems daily activities","direction":"negative","underlyingIssue":"urinary problems limiting daily activities","additionalInfo":"","preferredWording":"Have your daily activities been limited by your urinary problems?","recommendedWording":null,"questionnaires":[1,1000232,1000233,1000240,1000243],"categories":[],"createDate":"2016-02-18T13:26:44.863","updateDate":"2016-06-02T15:55:20.387"},{"rank":null,"id":68,"code":"Q54","type":"question","description":"bowel problems daily activities","direction":"negative","underlyingIssue":"bowel problems limiting daily activities","additionalInfo":"","preferredWording":"Have your daily activities been limited by your bowel problems?","recommendedWording":null,"questionnaires":[1,16,1000232,1000233,1000240,1000243],"categories":[],"createDate":"2016-02-18T13:27:54.583","updateDate":"2016-06-03T13:25:31.763"},{"rank":null,"id":69,"code":"Q55","type":"question","description":"leaking stools","direction":"negative","underlyingIssue":"unintentionally releasing/leaking stools","additionalInfo":"","preferredWording":"Have you had any unintentional release (leakage) of stools?","recommendedWording":null,"questionnaires":[1,1000232,1000233,1000240,1000243],"categories":[],"createDate":"2016-02-18T13:30:27.61","updateDate":"2016-06-03T13:25:56.21"},{"rank":null,"id":70,"code":"Q56","type":"question","description":"blood in stools","direction":"negative","underlyingIssue":"having blood in stools","additionalInfo":"","preferredWording":"Have you had blood in your stools (motions)?","recommendedWording":null,"questionnaires":[1,32,1000232,1000233,1000240,1000243,1000282,34],"categories":[],"createDate":"2016-02-18T13:47:22.553","updateDate":"2016-06-03T13:26:12.137"},{"rank":null,"id":71,"code":"Q57","type":"question","description":"bloated feeling abdomen","direction":"negative","underlyingIssue":"having a bloated feeling in the abdomen","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had a bloated feeling in your abdomen?</p>","preferredWording":"Have you had a bloated feeling in your abdomen?","recommendedWording":null,"questionnaires":[1,10,12,13,16,17,1000258,1000230,1000232,1000233,1000240,1000243,19,30,32,38,42],"categories":[],"createDate":"2016-02-18T14:21:19.85","updateDate":"2016-06-03T13:27:26.473"},{"rank":null,"id":72,"code":"Q58","type":"question","description":"mouth pain","direction":"negative","underlyingIssue":"having pain in the mouth","additionalInfo":null,"preferredWording":"Have you had pain in your mouth?","recommendedWording":null,"questionnaires":[9,43],"categories":[],"createDate":"2016-02-19T13:12:29.993","updateDate":"2016-04-05T12:21:10.783"},{"rank":null,"id":73,"code":"Q59","type":"question","description":"jaw pain","direction":"negative","underlyingIssue":"having pain in the jaw","additionalInfo":"","preferredWording":"Have you had pain in your jaw?","recommendedWording":null,"questionnaires":[9,43],"categories":[],"createDate":"2016-02-19T13:18:57.607","updateDate":"2016-06-24T08:37:11.007"},{"rank":null,"id":74,"code":"Q60","type":"question","description":"sore mouth","direction":"negative","underlyingIssue":"having a sore mouth","additionalInfo":"","preferredWording":"Have you had soreness in your mouth?","recommendedWording":null,"questionnaires":[9,25,43,45],"categories":[],"createDate":"2016-02-19T13:25:26.273","updateDate":"2016-06-28T14:34:53.52"},{"rank":null,"id":75,"code":"Q61","type":"question","description":"throat pain","direction":"negative","underlyingIssue":"having pain in the throat","additionalInfo":null,"preferredWording":"Have you had pain in your throat?","recommendedWording":null,"questionnaires":[9,43],"categories":[],"createDate":"2016-02-19T13:30:20.6","updateDate":"2016-04-05T12:24:47.153"},{"rank":null,"id":76,"code":"Q62","type":"question","description":"problem swallowing liquid","direction":"negative","underlyingIssue":"experiencing problems swallowing liquids","additionalInfo":"","preferredWording":"Have you had problems drinking liquids?","recommendedWording":null,"questionnaires":[9,12,20,27,43,1000280],"categories":[],"createDate":"2016-02-19T13:34:04.86","updateDate":"2016-06-03T13:46:22.86"},{"rank":null,"id":77,"code":"Q63","type":"question","description":"problem swallowing pureed food","direction":"negative","underlyingIssue":"experiencing problems swallowing pureed food","additionalInfo":null,"preferredWording":"Have you had problems swallowing pureed food?","recommendedWording":"Have you had problems eating liquidised or soft foods?","questionnaires":[9,12,27,43],"categories":[],"createDate":"2016-02-19T13:44:41.08","updateDate":"2016-04-05T12:25:13.817"},{"rank":null,"id":78,"code":"Q64","type":"question","description":"hot flushes","direction":"negative","underlyingIssue":"experiencing hot flushes","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had hot flushes?</p>","preferredWording":"Did you have hot flushes?","recommendedWording":null,"questionnaires":[1,5,19,42,1000231,1000249,1000232,1000233,1000236,1000240,1000243],"categories":[],"createDate":"2016-02-19T13:53:43.123","updateDate":"2016-06-28T12:21:41.437"},{"rank":null,"id":79,"code":"Q65","type":"question","description":"problem eating solid food","direction":"negative","underlyingIssue":"experiencing problems eating solid food","additionalInfo":null,"preferredWording":"Have you had problems swallowing solid food?","recommendedWording":null,"questionnaires":[9,12,25,27,43],"categories":[],"createDate":"2016-02-19T13:55:54.107","updateDate":"2016-04-05T12:26:11.117"},{"rank":null,"id":80,"code":"Q66","type":"question","description":"sore/enlarged nipples/breasts","direction":"negative","underlyingIssue":"having sore or enlarged nipples or breasts","additionalInfo":null,"preferredWording":"Have you had sore or enlarged nipples or breasts?","recommendedWording":null,"questionnaires":[1,1000232,1000233,1000240,1000243,1000268],"categories":[],"createDate":"2016-02-19T13:56:08.897","updateDate":"2016-02-19T13:56:50.833"},{"rank":null,"id":81,"code":"Q67","type":"question","description":"choked when swallowing","direction":"negative","underlyingIssue":"choked when swallowing","additionalInfo":null,"preferredWording":"Have you choked when swallowing?","recommendedWording":null,"questionnaires":[9,27,29,43],"categories":[],"createDate":"2016-02-19T13:59:55.543","updateDate":"2016-02-19T14:00:14.14"},{"rank":null,"id":82,"code":"Q68","type":"question","description":"problem teeth","direction":"negative","underlyingIssue":"experiencing problems with teeth","additionalInfo":"","preferredWording":"Have you had problems with your teeth?","recommendedWording":null,"questionnaires":[9,25,43],"categories":[],"createDate":"2016-02-19T14:23:06.74","updateDate":"2016-06-03T13:47:13.967"},{"rank":null,"id":83,"code":"Q69","type":"question","description":"swelling legs ankles","direction":"negative","underlyingIssue":"having swelling in legs or ankles","additionalInfo":"","preferredWording":"Have you had swelling in your legs or ankles?","recommendedWording":null,"questionnaires":[1,1000232,1000233,1000240,1000243],"categories":[],"createDate":"2016-02-19T14:24:10.39","updateDate":"2016-06-03T15:05:32.457"},{"rank":null,"id":85,"code":"Q70","type":"question","description":"problem open mouth","direction":"negative","underlyingIssue":"experiencing problems opening the mouth wide","additionalInfo":"","preferredWording":"Have you had problems opening your mouth wide?","recommendedWording":null,"questionnaires":[9,43],"categories":[],"createDate":"2016-02-19T14:31:26.57","updateDate":"2016-06-03T15:06:23.207"},{"rank":null,"id":86,"code":"Q71","type":"question","description":"dry mouth","direction":"negative","underlyingIssue":"having a dry mouth","additionalInfo":"<p><u>Recommended wording:\\n</u><br /></p><p>Have you had a dry mouth?</p>","preferredWording":"Have you had a dry mouth?","recommendedWording":"Did you have a dry mouth?","questionnaires":[5,9,12,17,20,23,45,1000175,1000231,1000236,1000249,1000280,32,33,35,36,43,24,25,26,27,29,31],"categories":[],"createDate":"2016-02-19T14:33:24.743","updateDate":"2017-04-06T09:48:15.853"},{"rank":null,"id":87,"code":"Q72","type":"question","description":"problem weight gain","direction":"negative","underlyingIssue":"experiencing problems with weight gain","additionalInfo":"","preferredWording":"Has weight gain been a problem for you?","recommendedWording":null,"questionnaires":[1,42,1000232,1000233,1000240,1000243],"categories":[],"createDate":"2016-02-19T14:33:39.673","updateDate":"2016-06-03T15:08:04.563"},{"rank":null,"id":88,"code":"Q73","type":"question","description":"interest in sex","direction":"positive","underlyingIssue":"being interested in sex","additionalInfo":"<p><u>Recommended wording: </u></p><p>Have you been interested in sex?</p>","preferredWording":"To what extent were you interested in sex?","recommendedWording":"sdqfsqdfsdf","questionnaires":[1,5,11,13,19,1000240,1000243,1000258,1000259,1000298,1000231,1000232,1000233,1000236,30,32,38,1000092],"categories":[],"createDate":"2016-02-19T14:52:37.923","updateDate":"2017-03-16T19:27:29.457"},{"rank":null,"id":89,"code":"Q74","type":"question","description":"sticky saliva","direction":"negative","underlyingIssue":"having sticky saliva","additionalInfo":"","preferredWording":"Have you had sticky saliva?","recommendedWording":null,"questionnaires":[9,25,43],"categories":[],"createDate":"2016-02-19T14:53:50.577","updateDate":"2016-06-03T15:08:58.883"},{"rank":null,"id":90,"code":"Q75","type":"question","description":"sexually active","direction":"positive","underlyingIssue":"being sexually active","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been sexually active (with or without intercourse)?</p>","preferredWording":"To what extent were you sexually active?","recommendedWording":null,"questionnaires":[1,5,8,11,13,19,1000287,1000298,1000299,1000300,1000301,1000240,1000243,1000258,1000259,1000265,1000282,1000174,1000231,1000232,1000233,1000236,1000238,30,34,38,1000092],"categories":[],"createDate":"2016-02-19T14:54:21.903","updateDate":"2016-06-28T15:28:23.093"},{"rank":null,"id":92,"code":"Q76","type":"question","description":"problem smell","direction":"negative","underlyingIssue":"experiencing problems with the sense of smell","additionalInfo":"","preferredWording":"Have you had problems with your sense of smell?","recommendedWording":null,"questionnaires":[9,43],"categories":[],"createDate":"2016-02-19T14:58:05.35","updateDate":"2016-06-03T15:24:56.473"},{"rank":null,"id":93,"code":"Q77","type":"question","description":"problem taste","direction":"negative","underlyingIssue":"experiencing problems with the sense of taste","additionalInfo":"","preferredWording":"Have you had problems with your sense of taste?","recommendedWording":null,"questionnaires":[9,10,27,31,43,44,1000230,32,33,36,41],"categories":[],"createDate":"2016-02-19T15:07:07.55","updateDate":"2016-06-03T15:25:20.233"},{"rank":null,"id":94,"code":"Q78","type":"question","description":"problem erection","direction":"negative","underlyingIssue":"experiencing problems achieving or maintaining an erection","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems getting or maintaining an erection?</p>","preferredWording":"Did you have difficulty getting or maintaining an erection?","recommendedWording":null,"questionnaires":[1,11,13,22,30,32,1000232,1000233,1000240,1000243],"categories":[],"createDate":"2016-02-19T15:13:33.663","updateDate":"2016-06-03T15:26:34.96"},{"rank":null,"id":95,"code":"Q79","type":"question","description":"problem ejaculation","direction":"negative","underlyingIssue":"experiencing problems with ejaculation","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with ejaculation (e.g., dry ejaculation)?</p>","preferredWording":"Did you have ejaculation problems (e.g. dry ejaculation)?","recommendedWording":null,"questionnaires":[1,11,13,30,1000092,1000260,1000298,1000232,1000233,1000240,1000243,1000258,1000259],"categories":[],"createDate":"2016-02-19T15:14:39.98","updateDate":"2016-06-03T15:27:31.247"},{"rank":null,"id":96,"code":"Q80","type":"question","description":"uncomfortable sexually intimate","direction":"negative","underlyingIssue":"feeling uncomfortable about being sexually intimate","additionalInfo":null,"preferredWording":"Have you felt uncomfortable about being sexually intimate?","recommendedWording":null,"questionnaires":[1,13,30,1000243,1000258,1000259,1000260,1000298,1000092,1000232,1000233,1000240],"categories":[],"createDate":"2016-02-19T15:15:52.93","updateDate":"2016-04-05T12:56:58.12"},{"rank":null,"id":104,"code":"Q81","type":"question","description":"frequent urination night","direction":"negative","underlyingIssue":"having to urinate frequently at night","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had to urinate frequently during the night?</p>","preferredWording":"blabla","recommendedWording":"blabla","questionnaires":[1,13,30,32,1000174,1000232,1000301,1000233,1000240,1000243,1000262,1000280,1000300],"categories":[],"createDate":"2016-02-25T09:53:52.523","updateDate":"2016-06-28T12:59:34.023"},{"rank":null,"id":105,"code":"Q82","type":"question","description":"importance active sex life","direction":"none","underlyingIssue":"importance of having an active sex life","additionalInfo":null,"preferredWording":"How important to you is an active sex life?","recommendedWording":null,"questionnaires":[8,1000092,1000258,1000259,1000298],"categories":[],"createDate":"2016-02-25T10:41:23.86","updateDate":"2016-04-05T14:08:22.357"},{"rank":null,"id":106,"code":"Q83","type":"question","description":"decreased libido","direction":"negative","underlyingIssue":"having decreased level of sexual desire","additionalInfo":"","preferredWording":"Have you had decreased libido?","recommendedWording":null,"questionnaires":[8],"categories":[],"createDate":"2016-02-25T10:43:40.303","updateDate":"2016-06-03T15:31:05.52"},{"rank":null,"id":107,"code":"Q84","type":"question","description":"satisfaction sexual desire","direction":"positive","underlyingIssue":"being satisfied with the level of sexual desire","additionalInfo":"","preferredWording":"Have you been satisfied with your level of sexual desire?","recommendedWording":null,"questionnaires":[8,1000092,1000230,1000258,1000259,1000298],"categories":[],"createDate":"2016-02-25T10:51:49.4","updateDate":"2016-06-03T15:31:36.97"},{"rank":null,"id":108,"code":"Q85","type":"question","description":"sexual activity enjoyable","direction":"positive","underlyingIssue":"finding sexual activity enjoyable","additionalInfo":"<p><u>Recommended wording:</u></p><p>Has sexual activity been enjoyable for you?</p>","preferredWording":"Was sexual activity enjoyable for you?","recommendedWording":null,"questionnaires":[1,5,8,11,13,1000232,1000233,1000236,1000240,1000243,1000282,19,30,34,38,1000231],"categories":[],"createDate":"2016-02-25T11:09:58.413","updateDate":"2016-06-03T15:32:27.373"},{"rank":null,"id":109,"code":"Q86","type":"question","description":"satisfaction reach orgasm","direction":"positive","underlyingIssue":"being satisfied with the ability to reach an orgasm","additionalInfo":"","preferredWording":"Have you been satisfied with your ability to reach an orgasm?","recommendedWording":null,"questionnaires":[8],"categories":[],"createDate":"2016-02-25T11:15:48.68","updateDate":"2016-06-03T15:33:03.63"},{"rank":null,"id":110,"code":"Q87","type":"question","description":"worry incontinent","direction":"negative","underlyingIssue":"worrying about being incontinent during foreplay or intercourse","additionalInfo":"","preferredWording":"Have you been worried about being incontinent (urine/stool)?","recommendedWording":null,"questionnaires":[8],"categories":[],"createDate":"2016-02-25T11:17:10.38","updateDate":"2016-06-03T15:37:26.483"},{"rank":null,"id":112,"code":"IN6","type":"instructions","description":"changes sexual health","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Patients sometimes report changes in their sexual health after treatment.","recommendedWording":null,"questionnaires":[8],"categories":[],"createDate":"2016-02-25T11:21:48.163","updateDate":"2016-02-25T11:21:48.163"},{"rank":null,"id":113,"code":"IN7","type":"instructions","description":"respond all circling","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please respond to all of the statements yourself by circling the number that best applies to you.","recommendedWording":null,"questionnaires":[8,49],"categories":[],"createDate":"2016-02-25T11:22:11.94","updateDate":"2016-02-25T11:22:11.94"},{"rank":null,"id":114,"code":"IN8","type":"instructions","description":"no right wrong","direction":null,"underlyingIssue":"","additionalInfo":"<h4>Recommended wording:</h4><p>There are no right or wrong answers.</p>","preferredWording":"There are no right or wrong answers.","recommendedWording":null,"questionnaires":[4,8,28,39,46,47,49],"categories":[],"createDate":"2016-02-25T11:22:28.07","updateDate":"2017-02-09T16:22:48.237"},{"rank":null,"id":115,"code":"IN9","type":"instructions","description":"information confidential","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"The information that you provide will remain strictly confidential.","recommendedWording":null,"questionnaires":[4,8,28,39,46,47,49],"categories":[],"createDate":"2016-02-25T11:22:43.11","updateDate":"2016-02-25T11:22:43.11"},{"rank":null,"id":116,"code":"IN10","type":"instructions","description":"try to respond","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please try to respond to as many questions as possible.","recommendedWording":null,"questionnaires":[8],"categories":[],"createDate":"2016-02-25T11:22:57.337","updateDate":"2016-02-25T11:22:57.337"},{"rank":null,"id":117,"code":"IN11","type":"instructions","description":"interested you and your health","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"We are interested in some things about you and your health.","recommendedWording":null,"questionnaires":[4,46],"categories":[],"createDate":"2016-02-25T11:23:44.403","updateDate":"2016-02-25T11:23:44.403"},{"rank":null,"id":118,"code":"IN12","type":"instructions","description":"answer all questions circling","direction":null,"underlyingIssue":"","additionalInfo":"<h4>Recommended wording:</h4><p>Please answer all of the questions yourself by circling the number that best applies to you.</p>","preferredWording":"Please answer ALL the questions yourself by circling the number that best applies to you.","recommendedWording":null,"questionnaires":[4,24,28,39,46,47],"categories":[],"createDate":"2016-02-25T11:24:28.24","updateDate":"2017-02-09T16:26:19.903"},{"rank":null,"id":119,"code":"IN13","type":"instructions","description":"patients report","direction":null,"underlyingIssue":"","additionalInfo":"<h4>Recommended wording:</h4><p>Patients sometimes report that they have the following symptoms or problems.</p>","preferredWording":"Patients sometimes report that they have the following symptoms or problems.","recommendedWording":null,"questionnaires":[1,2,5,9,10,11,43,44,45,48,36,37,38,40,41,42,30,31,32,33,34,35,24,25,26,27,29,18,19,20,21,22,23,12,13,14,15,16,17],"categories":[],"createDate":"2016-02-25T11:26:11.347","updateDate":"2017-02-09T16:27:47.297"},{"rank":null,"id":120,"code":"IN14","type":"instructions","description":"indicate extent past week","direction":null,"underlyingIssue":"","additionalInfo":"<h4>Recommended wording:</h4><p>Please indicate the extent to which you have experienced these symptoms or problems during the past week.</p>","preferredWording":"Please indicate the extent to which you have experienced these symptoms or problems during the past week.","recommendedWording":null,"questionnaires":[1,2,5,9,10,11,44,45,48,37,38,40,41,42,43,31,32,33,34,35,36,25,26,27,29,30,19,20,21,22,23,24,12,14,15,16,17,18],"categories":[],"createDate":"2016-02-25T11:26:34.903","updateDate":"2017-02-09T16:29:10.167"},{"rank":null,"id":121,"code":"IN15","type":"instructions","description":"answer circling","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please answer by circling the number that best applies to you.","recommendedWording":null,"questionnaires":[1,2,9,10,11,48,41,42,43,44,45,34,35,36,37,40,27,29,30,31,32,33,20,21,22,23,25,26,12,13,14,16,17,18],"categories":[],"createDate":"2016-02-25T11:27:05.34","updateDate":"2016-02-25T11:27:05.34"},{"rank":null,"id":122,"code":"Q88","type":"question","description":"fatigue sex life","direction":"negative","underlyingIssue":"fatigue/lack of energy affecting sex life","additionalInfo":null,"preferredWording":"Has fatigue or a lack of energy affected your sex life?","recommendedWording":null,"questionnaires":[8],"categories":[],"createDate":"2016-02-25T11:39:27.71","updateDate":"2016-04-05T14:18:29.8"},{"rank":null,"id":123,"code":"Q89","type":"question","description":"treatment sex life","direction":"negative","underlyingIssue":"treatment affecting sex life","additionalInfo":"","preferredWording":"Has the treatment affected your sexual activity?","recommendedWording":null,"questionnaires":[8],"categories":[],"createDate":"2016-02-25T11:40:18.753","updateDate":"2016-06-03T15:33:56.36"},{"rank":null,"id":124,"code":"Q90","type":"question","description":"pain sexual activity","direction":"negative","underlyingIssue":"feeling pain during or after sexual activity","additionalInfo":null,"preferredWording":"Have you felt pain during/after sexual activity?","recommendedWording":null,"questionnaires":[8],"categories":[],"createDate":"2016-02-25T11:47:02.92","updateDate":"2016-02-25T11:47:02.92"},{"rank":null,"id":125,"code":"Q91","type":"question","description":"coughing","direction":"negative","underlyingIssue":"coughing","additionalInfo":null,"preferredWording":"Have you coughed?","recommendedWording":null,"questionnaires":[9,27,37,48],"categories":[],"createDate":"2016-02-25T11:48:41.343","updateDate":"2016-04-05T14:30:35.523"},{"rank":null,"id":126,"code":"Q92","type":"question","description":"hoarseness","direction":"negative","underlyingIssue":"been hoarse","additionalInfo":null,"preferredWording":"Have you been hoarse?","recommendedWording":null,"questionnaires":[9],"categories":[],"createDate":"2016-02-25T11:54:51.64","updateDate":"2016-04-05T14:31:31.727"},{"rank":null,"id":127,"code":"Q93","type":"question","description":"worry pain sexual activity","direction":"negative","underlyingIssue":"worrying that sex will be painful","additionalInfo":"","preferredWording":"Have you worried that sex would be painful?","recommendedWording":null,"questionnaires":[8,1000282,34],"categories":[],"createDate":"2016-02-25T12:03:24.133","updateDate":"2016-06-03T15:34:52.083"},{"rank":null,"id":128,"code":"Q94","type":"question","description":"communication HCP sexual issues","direction":"none","underlyingIssue":"having communication with health care professionals about sexual issues","additionalInfo":"","preferredWording":"Have you had communication with health professionals about sexual issues?","recommendedWording":null,"questionnaires":[8],"categories":[],"createDate":"2016-02-25T12:06:38.22","updateDate":"2016-06-03T15:37:49.383"},{"rank":null,"id":129,"code":"Q95","type":"question","description":"felt ill","direction":"negative","underlyingIssue":"feeling ill","additionalInfo":null,"preferredWording":"Have you felt ill test?","recommendedWording":null,"questionnaires":[9,35,1000175],"categories":[],"createDate":"2016-02-25T12:06:50.657","updateDate":"2016-04-05T14:48:26.963"},{"rank":null,"id":130,"code":"Q96","type":"question","description":"problem appearance","direction":"negative","underlyingIssue":"experiencing problems with appearance","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with your appearance?</p>","preferredWording":"Have you had problems with your appearance?","recommendedWording":null,"questionnaires":[9,21,43],"categories":[],"createDate":"2016-02-25T12:19:55.007","updateDate":"2016-06-03T15:38:21.037"},{"rank":null,"id":131,"code":"Q97","type":"question","description":"problem eating","direction":"negative","underlyingIssue":"experiencing problems eating","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems eating?</p>","preferredWording":"Have you had trouble with eating?","recommendedWording":"rec","questionnaires":[9,10,27,29,36,42,43,1000230],"categories":[],"createDate":"2016-02-25T12:22:16.317","updateDate":"2016-06-03T13:46:52.05"},{"rank":null,"id":132,"code":"Q98","type":"question","description":"problem eating with family","direction":"negative","underlyingIssue":"experiencing problems eating in front of family","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems eating in front of your family?</p>","preferredWording":"Have you had problems eating in front of your family?","recommendedWording":null,"questionnaires":[9,43],"categories":[],"createDate":"2016-02-25T12:30:24.647","updateDate":"2016-06-03T15:39:05.22"},{"rank":null,"id":133,"code":"Q99","type":"question","description":"communication sexual issues partner","direction":"positive","underlyingIssue":"being satisfied with the communication about sexual issues with the partner","additionalInfo":"","preferredWording":"Have you been satisfied with the communication about sexual issues between yourself and your partner?","recommendedWording":null,"questionnaires":[8],"categories":[],"createDate":"2016-02-25T12:32:26.143","updateDate":"2016-06-06T12:10:52.223"},{"rank":null,"id":134,"code":"Q100","type":"question","description":"worry pain sexual contact","direction":"negative","underlyingIssue":"worrying that partner may cause pain during sexual contact","additionalInfo":"","preferredWording":"Have you been worried that your partner may cause you pain during sexual contact?\\n","recommendedWording":null,"questionnaires":[8],"categories":[],"createDate":"2016-02-25T12:33:25.833","updateDate":"2016-06-06T12:12:08.213"},{"rank":null,"id":135,"code":"Q101","type":"question","description":"satisfied level intimacy","direction":"positive","underlyingIssue":"being satisfied with level of affection or intimacy","additionalInfo":"","preferredWording":"Have you been satisfied with your level of intimacy?","recommendedWording":null,"questionnaires":[8],"categories":[],"createDate":"2016-02-25T12:36:32.26","updateDate":"2016-06-06T12:16:13.343"},{"rank":null,"id":136,"code":"Q102","type":"question","description":"problem eating with others","direction":"negative","underlyingIssue":"experiencing problems eating in front of other people","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems eating in front of other people?</p>","preferredWording":"Have you had problems eating in front of other people?","recommendedWording":null,"questionnaires":[9,12,27,29,43],"categories":[],"createDate":"2016-02-25T12:37:21.743","updateDate":"2016-06-28T15:30:57.757"},{"rank":null,"id":137,"code":"Q103","type":"question","description":"insecure satisfy partner","direction":"negative","underlyingIssue":"feeling insecure about the ability to satisfy the partner","additionalInfo":"","preferredWording":"Have you felt insecure regarding your ability to satisfy your partner?","recommendedWording":null,"questionnaires":[8],"categories":[],"createDate":"2016-02-25T12:38:28.907","updateDate":"2016-06-06T12:15:17.167"},{"rank":null,"id":138,"code":"Q104","type":"question","description":"problem enjoying meals","direction":"negative","underlyingIssue":"experiencing problems enjoying meals","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems enjoying your meals?</p>","preferredWording":"Have you had problems enjoying your meals?","recommendedWording":null,"questionnaires":[9,12,27,29,43],"categories":[],"createDate":"2016-02-25T12:41:11.697","updateDate":"2016-06-06T12:15:49.193"},{"rank":null,"id":139,"code":"Q105","type":"question","description":"satisfied sex life","direction":"positive","underlyingIssue":"being satisfied with the sex life","additionalInfo":"","preferredWording":"Have you been satisfied with your sex life?","recommendedWording":null,"questionnaires":[8],"categories":[],"createDate":"2016-02-25T12:41:13.367","updateDate":"2016-06-06T12:16:33.11"},{"rank":null,"id":140,"code":"Q106","type":"question","description":"extent sexual enjoyment","direction":"positive","underlyingIssue":"feeling sexual enjoyment","additionalInfo":"","preferredWording":"To what extent did you feel sexual enjoyment?","recommendedWording":null,"questionnaires":[8],"categories":[],"createDate":"2016-02-25T12:42:06.737","updateDate":"2016-06-06T12:24:09.157"},{"rank":null,"id":141,"code":"CS1","type":"condition","description":"men only","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"For men only:","recommendedWording":null,"questionnaires":[8,13,30,32,1000250,1000265],"categories":[],"createDate":"2016-02-25T12:43:56.207","updateDate":"2016-02-25T12:43:56.207"},{"rank":null,"id":142,"code":"CS2","type":"condition","description":"incontinence aid","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer this question only if you wear an incontinence aid:","recommendedWording":null,"questionnaires":[1,1000265],"categories":[],"createDate":"2016-02-25T12:44:48.7","updateDate":"2016-02-25T12:44:48.7"},{"rank":null,"id":143,"code":"CS3","type":"condition","description":"sexually active 4 weeks","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer these questions only if you have been sexually active during the past 4 weeks:","recommendedWording":null,"questionnaires":[1,13,30,34,38,1000092],"categories":[],"createDate":"2016-02-25T12:45:23.6","updateDate":"2016-02-25T12:45:23.6"},{"rank":null,"id":144,"code":"Q107","type":"question","description":"problem talking to others","direction":"negative","underlyingIssue":"experiencing problems talking to other people","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems talking to other people?</p>","preferredWording":"Have you had problems talking to other people?","recommendedWording":null,"questionnaires":[9,43],"categories":[],"createDate":"2016-02-25T12:45:30.777","updateDate":"2016-06-06T12:24:48.44"},{"rank":null,"id":145,"code":"Q108","type":"question","description":"confident about erection","direction":"positive","underlyingIssue":"being confident about obtaining an erection and maintaining it","additionalInfo":"","preferredWording":"Were you confident about obtaining and maintaining an erection when you had sex?\\n","recommendedWording":null,"questionnaires":[8],"categories":[],"createDate":"2016-02-25T12:47:38.233","updateDate":"2016-06-06T12:34:00.823"},{"rank":null,"id":146,"code":"CS4","type":"condition","description":"women only","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"For women only:","recommendedWording":null,"questionnaires":[8,13,30,32],"categories":[],"createDate":"2016-02-25T12:48:18.827","updateDate":"2016-02-25T12:48:18.827"},{"rank":null,"id":147,"code":"Q109","type":"question","description":"dry vagina","direction":"negative","underlyingIssue":"having a dry vagina during sexual activity","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had a dry vagina during sexual activity?</p>","preferredWording":"Did you have a dry vagina or other problems during intercourse?\\n","recommendedWording":null,"questionnaires":[8,13,19,30],"categories":[],"createDate":"2016-02-25T12:49:03.053","updateDate":"2016-06-28T11:49:23.197"},{"rank":null,"id":148,"code":"Q110","type":"question","description":"less feminine","direction":"negative","underlyingIssue":"feeling less feminine","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt less feminine as a result of your disease or treatment?</p>","preferredWording":"Have you felt less feminine as a result of your disease or treatment?","recommendedWording":null,"questionnaires":[5,8,34,38,1000231,1000236,1000249,1000282],"categories":[],"createDate":"2016-02-25T12:49:56.283","updateDate":"2016-06-06T12:35:58.87"},{"rank":null,"id":149,"code":"Q111","type":"question","description":"problem talking phone","direction":"negative","underlyingIssue":"experiencing problems talking on the telephone","additionalInfo":"<p>Recommended wording:</p><p>Have you had problems talking on the telephone?</p>","preferredWording":"Have you had problems talking on the telephone?","recommendedWording":null,"questionnaires":[9,43],"categories":[],"createDate":"2016-02-25T12:57:03.24","updateDate":"2016-06-06T12:36:42.413"},{"rank":null,"id":150,"code":"Q112","type":"question","description":"problem social contact family","direction":"negative","underlyingIssue":"experiencing problems having social contact with family","additionalInfo":"","preferredWording":"Have you had trouble having social contact with your family?","recommendedWording":null,"questionnaires":[9],"categories":[],"createDate":"2016-02-25T13:01:31.18","updateDate":"2016-06-06T12:37:05.89"},{"rank":null,"id":151,"code":"Q113","type":"question","description":"problem social contact friends","direction":"negative","underlyingIssue":"experiencing problems having social contact with friends","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems having social contact with friends?</p>","preferredWording":"Have you had trouble having social contact with friends?","recommendedWording":null,"questionnaires":[9,36],"categories":[],"createDate":"2016-02-25T13:02:10.59","updateDate":"2016-06-28T15:07:21.043"},{"rank":null,"id":152,"code":"Q114","type":"question","description":"problem going out","direction":"negative","underlyingIssue":"experiencing problems going out in public","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems going out in public?</p>","preferredWording":"Have you had problems going out in public?","recommendedWording":null,"questionnaires":[9,43],"categories":[],"createDate":"2016-02-25T13:04:36.563","updateDate":"2016-06-06T12:38:45.39"},{"rank":null,"id":153,"code":"Q115","type":"question","description":"food drink taste different","direction":"negative","underlyingIssue":"food and drink tasting different than usual","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have food and drink tasted different from usual?</p>","preferredWording":"Have food and drink tasted different from usual?","recommendedWording":"Did food and drink taste different from usual?","questionnaires":[5,12,17,19,20,25,1000280,29,38,45,1000231,1000236],"categories":[],"createDate":"2016-02-25T13:13:34.8","updateDate":"2016-06-06T12:38:17.98"},{"rank":null,"id":154,"code":"Q116","type":"question","description":"eyes painful irritated watery","direction":"negative","underlyingIssue":"eyes feeling painful, irritated or watery","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have your eyes been painful, irritated or watery?</p>","preferredWording":"Were your eyes painful, irritated or watery?","recommendedWording":null,"questionnaires":[5,1000231,1000236,1000249],"categories":[],"createDate":"2016-02-25T13:14:40.307","updateDate":"2016-06-28T12:21:03.263"},{"rank":null,"id":155,"code":"Q117","type":"question","description":"lost hair","direction":"negative","underlyingIssue":"losing hair","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you lost any hair?</p>","preferredWording":"Have you had hair loss? edit","recommendedWording":"Have you had hair loss? edit","questionnaires":[5,11,12,19,26,32,1000268,35,37,38,48,1000231,1000236],"categories":[],"createDate":"2016-02-25T13:15:21.21","updateDate":"2017-03-17T16:34:31.63"},{"rank":null,"id":156,"code":"Q118","type":"question","description":"problem physical contact family friends","direction":"negative","underlyingIssue":"experiencing problems having physical contact with family or friends","additionalInfo":"","preferredWording":"Have you had trouble having physical contact with family or friends?","recommendedWording":null,"questionnaires":[9],"categories":[],"createDate":"2016-02-25T13:32:37.263","updateDate":"2016-06-06T12:39:57.98"},{"rank":null,"id":157,"code":"Q119","type":"question","description":"less interest sex","direction":"negative","underlyingIssue":"having less interest in sex","additionalInfo":"","preferredWording":"Have you felt less interest in sex?","recommendedWording":null,"questionnaires":[9,17,43,45],"categories":[],"createDate":"2016-02-25T13:37:35.967","updateDate":"2016-06-06T13:05:14.27"},{"rank":null,"id":158,"code":"Q120","type":"question","description":"less sexual enjoyment","direction":"negative","underlyingIssue":"experiencing less sexual enjoyment","additionalInfo":"","preferredWording":"Have you felt less sexual enjoyment?","recommendedWording":null,"questionnaires":[9,17,43,45],"categories":[],"createDate":"2016-02-25T13:39:03.237","updateDate":"2016-06-06T13:05:48.717"},{"rank":null,"id":159,"code":"Q121","type":"question","description":"painkillers","direction":"negative","underlyingIssue":"using painkillers","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you used any painkillers?</p>","preferredWording":"Did you take any medicine for pain?","recommendedWording":null,"questionnaires":[9,37,1000169,1000262],"categories":[],"createDate":"2016-02-25T13:42:38.743","updateDate":"2016-06-06T13:17:54.42"},{"rank":null,"id":160,"code":"Q122","type":"question","description":"nutritional supplements ","direction":"none","underlyingIssue":"using nutritional supplements (excluding vitamins)","additionalInfo":"","preferredWording":"Have you taken any nutritional supplements (excluding vitamins)?","recommendedWording":null,"questionnaires":[9],"categories":[],"createDate":"2016-02-25T13:59:04.297","updateDate":"2016-06-06T13:18:11.817"},{"rank":null,"id":161,"code":"Q123","type":"question","description":"feeding tube","direction":"none","underlyingIssue":"using a feeding tube","additionalInfo":"","preferredWording":"Have you used a feeding tube?","recommendedWording":null,"questionnaires":[9],"categories":[],"createDate":"2016-02-25T14:01:22.347","updateDate":"2016-06-06T13:18:22.453"},{"rank":null,"id":162,"code":"Q124","type":"question","description":"weight loss","direction":"negative","underlyingIssue":"losing weight ","additionalInfo":null,"preferredWording":"Have you lost weight?","recommendedWording":null,"questionnaires":[9,23],"categories":[],"createDate":"2016-02-25T14:02:34.013","updateDate":"2016-04-06T15:04:54.133"},{"rank":null,"id":163,"code":"Q125","type":"question","description":"weight gain","direction":"none","underlyingIssue":"gaining weight ","additionalInfo":"","preferredWording":"Have you gained weight?","recommendedWording":null,"questionnaires":[9],"categories":[],"createDate":"2016-02-25T14:04:48.07","updateDate":"2016-05-23T11:53:25.763"},{"rank":null,"id":164,"code":"RS3","type":"responseScale","description":"binary","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Yes, No","recommendedWording":null,"questionnaires":[9,16,25,32,1000298,1000177,1000240,1000258,1000259,1000260,1000283,37,39,1000092,1000175],"categories":[],"createDate":"2016-02-25T14:10:16.883","updateDate":"2016-02-25T14:10:16.883"},{"rank":null,"id":165,"code":"CS5","type":"condition","description":"if hair loss","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Answer this question only if you lost any hair:","recommendedWording":null,"questionnaires":[5,12,19,27,35],"categories":[],"createDate":"2016-02-25T14:40:37.583","updateDate":"2017-03-10T17:08:53.307"},{"rank":null,"id":166,"code":"Q126","type":"question","description":"upset loss hair","direction":"negative","underlyingIssue":"being upset by hair loss","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been upset by the loss of your hair?</p>","preferredWording":"Were you upset by the loss of your hair?","recommendedWording":null,"questionnaires":[5,12,15,19,27,35,1000231,1000236],"categories":[],"createDate":"2016-02-25T14:41:43.81","updateDate":"2016-06-28T12:21:22.497"},{"rank":null,"id":167,"code":"Q127","type":"question","description":"feel ill unwell","direction":"negative","underlyingIssue":"feeling ill or unwell","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt ill or unwell?</p>","preferredWording":"Did you feel ill or unwell?","recommendedWording":null,"questionnaires":[5,23,24,30,31,1000231,1000236],"categories":[],"createDate":"2016-02-25T14:43:17.63","updateDate":"2016-06-06T13:29:18.143"},{"rank":null,"id":168,"code":"Q128","type":"question","description":"headaches","direction":"negative","underlyingIssue":"having headaches","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had headaches?</p>","preferredWording":"Did you have headaches?","recommendedWording":null,"questionnaires":[5,15,21,26,1000231,1000236,1000249],"categories":[],"createDate":"2016-02-25T14:44:17.443","updateDate":"2016-06-06T13:30:23.137"},{"rank":null,"id":169,"code":"Q129","type":"question","description":"physically less attractive","direction":"negative","underlyingIssue":"feeling physically less attractive as a result of the disease or treatment","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt less physically attractive as a results of your disease or treatment?</p>","preferredWording":"Have you felt physically less attractive as a result of your disease or treatment?","recommendedWording":null,"questionnaires":[5,12,13,17,19,43,45,1000231,1000236,1000282,27,32,34,35,38],"categories":[],"createDate":"2016-02-25T14:45:44.48","updateDate":"2017-03-31T16:57:43.893"},{"rank":null,"id":170,"code":"Q130","type":"question","description":"problems look naked","direction":"negative","underlyingIssue":"experiencing problems looking at oneself naked","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems looking at yourself naked?</p>","preferredWording":"Did you find it difficult to look at yourself naked?","recommendedWording":null,"questionnaires":[5,1000231,1000236],"categories":[],"createDate":"2016-02-25T14:47:00.423","updateDate":"2016-09-08T10:18:51.85"},{"rank":null,"id":171,"code":"Q131","type":"question","description":"dissatisfied body","direction":"negative","underlyingIssue":"feeling dissatisfied with one\'s body","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt dissatisfied with your body as a result of your disease or treatment?</p>","preferredWording":"Have you been dissatisfied with your body?","recommendedWording":null,"questionnaires":[5,13,17,19,26,1000282,32,34,43,1000231,1000236],"categories":[],"createDate":"2016-02-25T14:48:00.75","updateDate":"2016-06-28T15:02:11.843"},{"rank":null,"id":173,"code":"CS6","type":"condition","description":"only if sexually active","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer the following two questions only if you were sexually active:","recommendedWording":null,"questionnaires":[5,19],"categories":[],"createDate":"2016-02-25T15:13:09.363","updateDate":"2016-02-25T15:13:09.363"},{"rank":null,"id":174,"code":"Q132","type":"question","description":"pain arm shoulder","direction":"negative","underlyingIssue":"having pain in an arm or shoulder","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had pain in your arm or shoulder?</p>","preferredWording":"Did you have any pain in your arm or shoulder?","recommendedWording":null,"questionnaires":[5,35,37,48,1000231,1000236],"categories":[],"createDate":"2016-02-25T15:24:43.723","updateDate":"2016-06-06T13:41:43.8"},{"rank":null,"id":175,"code":"Q133","type":"question","description":"swollen arm hand","direction":"negative","underlyingIssue":"having a swollen arm or hand","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had a swollen arm or hand?</p>","preferredWording":"Did you have a swollen arm or hand?","recommendedWording":null,"questionnaires":[5,1000231,1000236],"categories":[],"createDate":"2016-02-25T15:38:42.43","updateDate":"2016-06-06T13:48:48.57"},{"rank":null,"id":176,"code":"Q134","type":"question","description":"problem move arm","direction":"negative","underlyingIssue":"experiencing problems raising an arm or moving it sideways","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems raising your arm or moving it sideways?</p>","preferredWording":"Was it difficult to raise your arm or to move it sideways?","recommendedWording":null,"questionnaires":[5,43,1000231,1000236],"categories":[],"createDate":"2016-02-25T15:39:51.01","updateDate":"2016-06-06T13:49:51.427"},{"rank":null,"id":177,"code":"Q135","type":"question","description":"pain area affected breast","direction":"negative","underlyingIssue":"having pain in the area of the affected breast","additionalInfo":"","preferredWording":"Have you had any pain in the area of your affected breast?","recommendedWording":null,"questionnaires":[5,1000231,1000236],"categories":[],"createDate":"2016-02-25T15:40:59.34","updateDate":"2016-06-06T13:50:32.457"},{"rank":null,"id":178,"code":"Q136","type":"question","description":"swollen area affected breast","direction":"negative","underlyingIssue":"having swelling in the area of the affected breast","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has the area of your affected breast been swollen?</p>","preferredWording":"Was the area of your affected breast swollen?","recommendedWording":null,"questionnaires":[5,1000231,1000236],"categories":[],"createDate":"2016-02-25T15:41:40.383","updateDate":"2016-06-06T13:52:21.003"},{"rank":null,"id":179,"code":"Q137","type":"question","description":"oversensitive area affected breast","direction":"negative","underlyingIssue":"the area of the affected breast being oversensitive","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has the area of your affected breast been oversensitive?</p>","preferredWording":"Was the area of your affected breast oversensitive?","recommendedWording":null,"questionnaires":[5,1000231,1000236],"categories":[],"createDate":"2016-02-25T15:42:45.907","updateDate":"2016-06-06T13:53:55.747"},{"rank":null,"id":180,"code":"Q138","type":"question","description":"skin problems area affected breast","direction":"negative","underlyingIssue":"having skin problems on or in the area of the affected breast","additionalInfo":"","preferredWording":"Have you had skin problems on or in the area of your affected breast (e.g., itchy, dry, flaky)?","recommendedWording":null,"questionnaires":[5,1000231,1000236,1000268],"categories":[],"createDate":"2016-02-25T15:43:46.89","updateDate":"2016-06-06T13:54:20.52"},{"rank":null,"id":181,"code":"Q139","type":"question","description":"full up too quickly ","direction":"negative","underlyingIssue":"feeling full up too quickly after beginning to eat","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt full up too quickly after beginning to eat?</p>","preferredWording":"Have you felt full up too quickly after beginning to eat?","recommendedWording":null,"questionnaires":[1000280,1000230,44,36,29,20,27,19,10,12],"categories":[],"createDate":"2016-02-26T09:10:17.28","updateDate":"2017-02-15T15:30:32.667"},{"rank":null,"id":182,"code":"Q140","type":"question","description":"problem sense taste smell","direction":"negative","underlyingIssue":"experiencing problems with the sense of taste or smell","additionalInfo":"","preferredWording":"Have you had problems with your sense of taste or smell?","recommendedWording":null,"questionnaires":[11],"categories":[],"createDate":"2016-02-29T09:41:28.797","updateDate":"2016-06-06T14:32:02.263"},{"rank":null,"id":184,"code":"Q141","type":"question","description":"acid reflux","direction":"negative","underlyingIssue":"experiencing acid reflux","additionalInfo":null,"preferredWording":"Have you had acid reflux?","recommendedWording":null,"questionnaires":[11],"categories":[],"createDate":"2016-02-29T10:38:26.83","updateDate":"2016-03-08T12:49:11.22"},{"rank":null,"id":185,"code":"Q142","type":"question","description":"tingling numbness fingers toes","direction":"negative","underlyingIssue":"experiencing tingling or numbness in fingers or toes","additionalInfo":"","preferredWording":"Have you had tingling or numbness in your fingers or toes?","recommendedWording":null,"questionnaires":[11],"categories":[],"createDate":"2016-02-29T10:39:27.47","updateDate":"2016-06-06T14:35:25.6"},{"rank":null,"id":186,"code":"Q143","type":"question","description":"skin problems","direction":"negative","underlyingIssue":"experiencing skin problems (e.g. itchiness, dryness)","additionalInfo":"","preferredWording":"Have you had skin problems (e.g. itchy, dry)?","recommendedWording":null,"questionnaires":[11,19,23,26,48,43,45],"categories":[],"createDate":"2016-02-29T10:50:15.143","updateDate":"2016-06-06T14:42:15.83"},{"rank":null,"id":187,"code":"Q144","type":"question","description":"pale cold fingers toes","direction":"negative","underlyingIssue":"having pale or cold fingers or toes","additionalInfo":"","preferredWording":"Have you had pale/cold fingers or toes?","recommendedWording":null,"questionnaires":[11],"categories":[],"createDate":"2016-02-29T10:51:24.02","updateDate":"2016-06-06T14:46:51.633"},{"rank":null,"id":188,"code":"Q145","type":"question","description":"problem hearing","direction":"negative","underlyingIssue":"experiencing problems with hearing","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with hearing?</p>","preferredWording":"Did you have difficulty hearing?","recommendedWording":null,"questionnaires":[11,19,22],"categories":[],"createDate":"2016-02-29T10:56:06.81","updateDate":"2016-06-06T14:48:05.517"},{"rank":null,"id":189,"code":"Q146","type":"question","description":"satisfied medical care","direction":"positive","underlyingIssue":"being satisfied with the received medical care","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been satisfied with the medical care you received?</p>","preferredWording":"How would you rate the care received during your hospital stay?\\n","recommendedWording":null,"questionnaires":[11,47],"categories":[],"createDate":"2016-02-29T11:01:50.947","updateDate":"2016-06-28T15:47:07.983"},{"rank":null,"id":190,"code":"Q147","type":"question","description":"satisfied information disease treatment","direction":"positive","underlyingIssue":"being satisfied with the received information about disease and treatment","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been satisfied with the information you received about your disease and treatment?</p>","preferredWording":"Has the information given about your physical condition and treatment been adequate?","recommendedWording":null,"questionnaires":[11,17],"categories":[],"createDate":"2016-02-29T11:02:42.177","updateDate":"2016-06-28T15:47:39.45"},{"rank":null,"id":192,"code":"Q148","type":"question","description":"problem job education","direction":"negative","underlyingIssue":"experiencing problems with job or education because of having cancer or undergoing treatment","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems with your job or your education as a result of your disease or treatment?</p>","preferredWording":"Have you had any problems with your job or your education because of your disease or treatment?","recommendedWording":null,"questionnaires":[11],"categories":[],"createDate":"2016-02-29T11:04:59.01","updateDate":"2016-06-28T15:48:31.257"},{"rank":null,"id":193,"code":"Q149","type":"question","description":"physically limited disease treatment","direction":"negative","underlyingIssue":"being physically limited as a result of disease or treatment","additionalInfo":"","preferredWording":"Have you been physically limited as a result of your disease or treatment?","recommendedWording":null,"questionnaires":[11],"categories":[],"createDate":"2016-02-29T11:06:28.65","updateDate":"2016-06-06T14:59:14.763"},{"rank":null,"id":195,"code":"Q150","type":"question","description":"limited types of food","direction":"negative","underlyingIssue":"being limited in types of food as result of the disease or treatment","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you been limited in the types of food you can eat because of your disease or treatment?</p>","preferredWording":"Were you restricted in the types of food you can eat as a result of your disease or treatment?","recommendedWording":null,"questionnaires":[10,17,1000230],"categories":[],"createDate":"2016-02-29T11:28:52.86","updateDate":"2016-06-28T15:41:01.753"},{"rank":null,"id":196,"code":"Q151","type":"question","description":"jaundice ","direction":"negative","underlyingIssue":"having yellow skin or eyes (jaundice )","additionalInfo":"","preferredWording":"Have your skin or eyes been yellow (jaundiced)?","recommendedWording":"blazblou","questionnaires":[10,36,1000230],"categories":[],"createDate":"2016-02-29T11:37:32.783","updateDate":"2017-03-16T14:05:33.313"},{"rank":null,"id":197,"code":"Q152","type":"question","description":"itching","direction":"negative","underlyingIssue":"experiencing itching","additionalInfo":"","preferredWording":"Have you had itching?","recommendedWording":null,"questionnaires":[10,17,44,1000230],"categories":[],"createDate":"2016-02-29T11:42:07.523","updateDate":"2016-06-06T15:00:36.603"},{"rank":null,"id":198,"code":"Q153","type":"question","description":"worry disruption family life","direction":"negative","underlyingIssue":"worrying about disruption of family life","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about disruption of your family life?</p>","preferredWording":"Were you concerned about disruption of family life?","recommendedWording":null,"questionnaires":[11,15,42,45],"categories":[],"createDate":"2016-02-29T11:48:31.533","updateDate":"2016-06-28T12:07:54.757"},{"rank":null,"id":199,"code":"Q154","type":"question","description":"worry jaundice","direction":"negative","underlyingIssue":"worrying about having jaundiced skin or eyes","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been worried about your skin or eyes being yellow (jaundiced)?</p>","preferredWording":"Have you been worried about your skin being yellow?","recommendedWording":null,"questionnaires":[10,44,1000230],"categories":[],"createDate":"2016-02-29T11:49:08.117","updateDate":"2016-06-28T14:31:09.577"},{"rank":null,"id":200,"code":"Q155","type":"question","description":"less active","direction":"negative","underlyingIssue":"being less active than one wants to be","additionalInfo":"","preferredWording":"Have you been less active than you would like to be?","recommendedWording":null,"questionnaires":[10,36,44,1000230],"categories":[],"createDate":"2016-02-29T11:51:41.22","updateDate":"2016-06-06T15:10:37.893"},{"rank":null,"id":201,"code":"Q156","type":"question","description":"worry fertility","direction":"negative","underlyingIssue":"worrying about the ability to have children","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about your ability to have children?</p>","preferredWording":"Have  you been concerned about your ability to have children?","recommendedWording":null,"questionnaires":[11,31,41,45],"categories":[],"createDate":"2016-02-29T11:54:14.28","updateDate":"2016-06-28T14:43:10.05"},{"rank":null,"id":202,"code":"Q157","type":"question","description":"talk disease partner","direction":"positive","underlyingIssue":"feeling able to talk about disease with the partner/closest person","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been able to talk about your disease with your partner or the person who is closest to you?</p>","preferredWording":"Can you talk about your disease with your partner or the person who is closest to you?","recommendedWording":null,"questionnaires":[11],"categories":[],"createDate":"2016-02-29T11:55:28.147","updateDate":"2016-06-28T15:49:19.54"},{"rank":null,"id":203,"code":"Q158","type":"question","description":"talk sexuality partner","direction":"positive","underlyingIssue":"feeling able to talk about sexuality with the partner/closest person","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been able to talk about sexuality with your partner or the person who is closest to you?</p>","preferredWording":"Can you talk about sexuality with your partner or the person who is closest to you?","recommendedWording":null,"questionnaires":[11],"categories":[],"createDate":"2016-02-29T11:57:48.74","updateDate":"2016-06-28T15:50:15.673"},{"rank":null,"id":204,"code":"CS7","type":"condition","description":"next sexual activity","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Next questions only in the case of sexual activity:","recommendedWording":null,"questionnaires":[11],"categories":[],"createDate":"2016-02-29T11:58:39.113","updateDate":"2016-02-29T11:58:39.113"},{"rank":null,"id":205,"code":"Q159","type":"question","description":"feel slowed down","direction":"negative","underlyingIssue":"feeling slowed down","additionalInfo":"","preferredWording":"Have you felt \\"slowed down”?","recommendedWording":null,"questionnaires":[10,23,36,40,1000230],"categories":[],"createDate":"2016-02-29T11:58:51.58","updateDate":"2017-02-16T11:15:08.977"},{"rank":null,"id":206,"code":"Q160","type":"question","description":"lack energy","direction":"negative","underlyingIssue":"lacking energy","additionalInfo":"","preferredWording":"Have you felt lacking in energy?","recommendedWording":null,"questionnaires":[10,24,31,33,36,40,41,1000230],"categories":[],"createDate":"2016-02-29T11:59:58.43","updateDate":"2016-06-06T15:18:49.48"},{"rank":null,"id":207,"code":"Q161","type":"question","description":"satisfied sexual relationship","direction":"positive","underlyingIssue":"being satisfied with the sexual relationship with the partner","additionalInfo":"","preferredWording":"Has the sexual relationship with your partner been satisfying?","recommendedWording":null,"questionnaires":[11],"categories":[],"createDate":"2016-02-29T12:00:31.69","updateDate":"2016-06-06T15:19:27.653"},{"rank":null,"id":208,"code":"CS8","type":"condition","description":"testicular implant","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer this question only if you have a testicular implant:","recommendedWording":null,"questionnaires":[11,1000092],"categories":[],"createDate":"2016-02-29T12:00:49.177","updateDate":"2016-02-29T12:00:49.177"},{"rank":null,"id":209,"code":"Q162","type":"question","description":"satisfied testicular implant","direction":"positive","underlyingIssue":"being satisfied with the testicular implant","additionalInfo":"","preferredWording":"Are you satisfied with your testicular implant?","recommendedWording":null,"questionnaires":[11,1000092,1000258,1000259,1000268,1000298],"categories":[],"createDate":"2016-02-29T12:01:25.777","updateDate":"2016-06-06T15:19:56.033"},{"rank":null,"id":210,"code":"Q163","type":"question","description":"pain night","direction":"negative","underlyingIssue":"experiencing pain at night","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had pain during the night?</p>","preferredWording":"Did you have pain during the night?","recommendedWording":null,"questionnaires":[10,17,1000230],"categories":[],"createDate":"2016-02-29T12:01:54.31","updateDate":"2016-06-28T12:43:50.357"},{"rank":null,"id":211,"code":"Q164","type":"question","description":"pain stomach area","direction":"negative","underlyingIssue":"having pain in the stomach area","additionalInfo":"","preferredWording":"Have you had pain in your stomach area?","recommendedWording":null,"questionnaires":[10,11,12,27,36,1000230],"categories":[],"createDate":"2016-02-29T12:04:17.21","updateDate":"2016-06-06T15:20:33.457"},{"rank":null,"id":212,"code":"Q165","type":"question","description":"pain back","direction":"negative","underlyingIssue":"having pain in one\'s back","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had pain in your back?</p>","preferredWording":"Have you had pain in your back?","recommendedWording":null,"questionnaires":[10,17,35,36,1000230],"categories":[],"createDate":"2016-02-29T12:07:37.24","updateDate":"2016-06-06T15:21:22.397"},{"rank":null,"id":216,"code":"Q166","type":"question","description":"stress","direction":"negative","underlyingIssue":"feeling stressed","additionalInfo":"","preferredWording":"Have you felt stressed?","recommendedWording":null,"questionnaires":[10,1000230,36],"categories":[],"createDate":"2016-02-29T12:28:13.527","updateDate":"2016-06-06T15:21:40.337"},{"rank":null,"id":217,"code":"Q167","type":"question","description":"enjoying yourself","direction":"negative","underlyingIssue":"feeling less able to enjoy oneself","additionalInfo":"","preferredWording":"Have you felt less able to enjoy yourself?","recommendedWording":null,"questionnaires":[10,36,1000230],"categories":[],"createDate":"2016-02-29T12:31:06.163","updateDate":"2016-06-06T15:22:59.727"},{"rank":null,"id":218,"code":"Q168","type":"question","description":"discomfort eating","direction":"negative","underlyingIssue":"experiencing discomfort when eating","additionalInfo":"","preferredWording":"Have you had discomfort when eating?","recommendedWording":null,"questionnaires":[12,27],"categories":[],"createDate":"2016-02-29T12:35:04.557","updateDate":"2016-06-06T15:23:41.147"},{"rank":null,"id":219,"code":"Q169","type":"question","description":"worry family future","direction":"negative","underlyingIssue":"worrying about the family in the future","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you been worried about your family in the future?</p>","preferredWording":"Were you worried about your family in the future?","recommendedWording":null,"questionnaires":[10,36,1000230],"categories":[],"createDate":"2016-02-29T12:35:30.08","updateDate":"2016-06-06T15:24:34.88"},{"rank":null,"id":220,"code":"Q170","type":"question","description":"problem side effects ","direction":"negative","underlyingIssue":"experiencing problems with side effects ","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with side effects from your treatment?</p>","preferredWording":"To what extent have you been troubled with side-effects from your treatment?","recommendedWording":null,"questionnaires":[10,17,1000230],"categories":[],"createDate":"2016-02-29T12:36:35.477","updateDate":"2016-06-06T15:47:44.9"},{"rank":null,"id":221,"code":"Q171","type":"question","description":"problem drainage tubes/bags","direction":"negative","underlyingIssue":"experiencing problems with drainage tubes/bags","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with drainage tubes/bags?</p>","preferredWording":"Have you had difficulties with drainage tubes/ bags?","recommendedWording":null,"questionnaires":[10,1000230],"categories":[],"createDate":"2016-02-29T12:40:28.83","updateDate":"2016-06-06T15:48:26.947"},{"rank":null,"id":225,"code":"CS9","type":"condition","description":"if no urostomy","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"PLEASE ANSWER QUESTIONS 31 - 37 ONLY IF YOU DO NOT HAVE A UROSTOMyy","recommendedWording":null,"questionnaires":[13],"categories":[],"createDate":"2016-02-29T12:59:21.06","updateDate":"2016-02-29T12:59:47.253"},{"rank":null,"id":226,"code":"CS10","type":"condition","description":"if urostomy","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"PLEASE ANSWER QUESTIONS 38 - 43 ONLY IF YOU HAVE A UROSTOMY","recommendedWording":null,"questionnaires":[13],"categories":[],"createDate":"2016-02-29T13:04:51.073","updateDate":"2016-02-29T13:04:51.073"},{"rank":null,"id":227,"code":"CS11","type":"condition","description":"if catheter, during the past week","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"PLEASE ANSWER QUESTION 44 ONLY IF YOU HAVE USED A CATHETER DURING THE PAST WEEK","recommendedWording":null,"questionnaires":[13],"categories":[],"createDate":"2016-02-29T13:05:39.733","updateDate":"2016-02-29T13:05:39.733"},{"rank":null,"id":228,"code":"Q172","type":"question","description":"discomfort stomach area","direction":"negative","underlyingIssue":"experiencing discomfort in the stomach area","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had discomfort in your stomach area?</p>","preferredWording":"Have you had discomfort in your stomach area?","recommendedWording":null,"questionnaires":[12,17,23,27,36],"categories":[],"createDate":"2016-02-29T13:13:47.813","updateDate":"2016-06-06T15:49:45.057"},{"rank":null,"id":229,"code":"Q173","type":"question","description":"problem acid bile mouth","direction":"negative","underlyingIssue":"experiencing problems with acid or bile coming into the mouth","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with acid or bile coming into your mouth?</p>","preferredWording":"Have you had trouble with acid or bile coming into your mouth?","recommendedWording":null,"questionnaires":[12,27,29],"categories":[],"createDate":"2016-02-29T13:15:54.63","updateDate":"2016-06-06T15:50:34.2"},{"rank":null,"id":230,"code":"Q174","type":"question","description":"acid indigestion heartburn","direction":"negative","underlyingIssue":"experiencing acid indigestion or heartburn","additionalInfo":null,"preferredWording":"Have you had acid indigestion or heartburn?","recommendedWording":null,"questionnaires":[12,19,20,26,27,29,35,42,1000280],"categories":[],"createDate":"2016-02-29T13:16:32.57","updateDate":"2016-03-08T12:48:17.883"},{"rank":null,"id":231,"code":"Q175","type":"question","description":"problem belching","direction":"negative","underlyingIssue":"experiencing problems with belching","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems with belching?</p>","preferredWording":"Have you had trouble with belching?","recommendedWording":null,"questionnaires":[12],"categories":[],"createDate":"2016-02-29T13:17:20.98","updateDate":"2016-06-28T15:46:08.483"},{"rank":null,"id":233,"code":"Q176","type":"question","description":"pain burning feeling urinate","direction":"negative","underlyingIssue":"having pain/burning feeling when urinating","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had pain or a burning feeling when urinating?</p>","preferredWording":"Have you had pain or a burning feeling when passing water/urinating?","recommendedWording":null,"questionnaires":[13,30,34,38,1000282],"categories":[],"createDate":"2016-02-29T13:27:04.957","updateDate":"2016-06-24T11:25:17.737"},{"rank":null,"id":234,"code":"Q177","type":"question","description":"long time finish meal","direction":"negative","underlyingIssue":"taking long time to finish one\'s meal","additionalInfo":"","preferredWording":"Has it taken you a long time to complete your meals?","recommendedWording":null,"questionnaires":[12,27],"categories":[],"createDate":"2016-02-29T13:32:49.667","updateDate":"2016-06-06T15:52:31.673"},{"rank":null,"id":235,"code":"Q178","type":"question","description":"urine bag leak","direction":"negative","underlyingIssue":"urostomy bag leaking","additionalInfo":"","preferredWording":"Has urine leaked from your urostomy bag??","recommendedWording":null,"questionnaires":[13],"categories":[],"createDate":"2016-02-29T13:32:56.5","updateDate":"2016-06-07T09:38:58.763"},{"rank":null,"id":236,"code":"Q179","type":"question","description":"problem care urostomy","direction":"negative","underlyingIssue":"experiencing problems caring for the urostomy","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems with caring for your urostomy?</p>","preferredWording":"Did you have problems with caring for your urostomy?","recommendedWording":null,"questionnaires":[13],"categories":[],"createDate":"2016-02-29T13:34:00.01","updateDate":"2016-06-28T11:38:53.75"},{"rank":null,"id":237,"code":"Q180","type":"question","description":"think illness","direction":"negative","underlyingIssue":"thinking about the illness","additionalInfo":"","preferredWording":"Have you been thinking about your illness?","recommendedWording":null,"questionnaires":[12,27,35],"categories":[],"createDate":"2016-02-29T13:36:10.103","updateDate":"2016-06-07T09:40:28.647"},{"rank":null,"id":238,"code":"Q181","type":"question","description":"skin irritarion urostomy","direction":"negative","underlyingIssue":"having irritated skin around the urostomy","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has your skin been irritated around the urostomy?</p>","preferredWording":"Was your skin around the urostomy irritated?","recommendedWording":null,"questionnaires":[13],"categories":[],"createDate":"2016-02-29T13:36:49.683","updateDate":"2016-06-28T11:39:36.513"},{"rank":null,"id":239,"code":"Q182","type":"question","description":"worry weight too low","direction":"negative","underlyingIssue":"worrying about the weight being too low","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you worried that your weight is too low?</p>","preferredWording":"Have you worried about your weight being too low?","recommendedWording":null,"questionnaires":[12,17,27,43,44,45],"categories":[],"createDate":"2016-02-29T13:36:57.64","updateDate":"2016-06-07T09:46:04.297"},{"rank":null,"id":240,"code":"Q183","type":"question","description":"worry weight loss","direction":"negative","underlyingIssue":"worrying about losing weight","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about your weight loss?</p>","preferredWording":"Have you worried about your weight loss?","recommendedWording":null,"questionnaires":[10,20,1000230,1000280],"categories":[],"createDate":"2016-02-29T13:44:58.433","updateDate":"2016-06-07T09:46:43.413"},{"rank":null,"id":241,"code":"Q184","type":"question","description":"embarrassed urostomy","direction":"negative","underlyingIssue":"being embarrassed because of the urostomy","additionalInfo":"","preferredWording":"Have you felt embarrassed because of your urostomy?","recommendedWording":null,"questionnaires":[13],"categories":[],"createDate":"2016-02-29T13:53:55.313","updateDate":"2016-06-07T09:47:21.983"},{"rank":null,"id":242,"code":"Q185","type":"question","description":"dependent others urostomy care ","direction":"negative","underlyingIssue":"depending on others for urostomy care ","additionalInfo":"","preferredWording":"Have you been dependent on others for caring  for your urostomy?","recommendedWording":null,"questionnaires":[13],"categories":[],"createDate":"2016-02-29T13:56:41.443","updateDate":"2016-06-07T09:47:46.12"},{"rank":null,"id":243,"code":"Q186","type":"question","description":"urostomy bag changes","direction":"negative","underlyingIssue":"having to frequently change the urostomy bag","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had to frequently change the urostomy bag?</p>","preferredWording":"Did you frequently have to change the urostomy bag?","recommendedWording":null,"questionnaires":[13],"categories":[],"createDate":"2016-02-29T13:58:05.547","updateDate":"2016-06-07T09:51:28.89"},{"rank":null,"id":244,"code":"Q187","type":"question","description":"problem self-catheterization","direction":"negative","underlyingIssue":"experiencing problems with self-catheterization","additionalInfo":"","preferredWording":"Have you had problems with self-catheterization? (inserting a tube in the bladder to pass urine)","recommendedWording":null,"questionnaires":[13],"categories":[],"createDate":"2016-02-29T14:08:26.763","updateDate":"2016-06-03T13:50:22.313"},{"rank":null,"id":245,"code":"Q188","type":"question","description":"worry results","direction":"negative","underlyingIssue":"worrying about results of examinations and tests","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about the results of examinations and tests?</p>","preferredWording":"Did you worry about the results of examinations and tests?","recommendedWording":null,"questionnaires":[13,30,42,43,45,1000274],"categories":[],"createDate":"2016-02-29T14:12:13.267","updateDate":"2016-06-28T14:35:55.75"},{"rank":null,"id":246,"code":"Q189","type":"question","description":"worry future treatments","direction":"negative","underlyingIssue":"worrying about possible future treatments","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about possible future treatments?</p>","preferredWording":"Did you worry about possible future treatments?","recommendedWording":null,"questionnaires":[13,30],"categories":[],"createDate":"2016-02-29T14:15:34.67","updateDate":"2016-06-07T09:55:42.347"},{"rank":null,"id":247,"code":"Q190","type":"question","description":"flatulence","direction":"negative","underlyingIssue":"having flatulence/gas","additionalInfo":"","preferredWording":"Have you had flatulence or gas?","recommendedWording":null,"questionnaires":[13,30],"categories":[],"createDate":"2016-02-29T14:38:38.54","updateDate":"2016-06-07T09:56:12.987"},{"rank":null,"id":248,"code":"Q191","type":"question","description":"less feminine/masculine ","direction":"negative","underlyingIssue":"feeling less feminine/masculine","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt less masculine/feminine as a result of your disease or treatment?</p>","preferredWording":"Have you been feeling less feminine/masculine as a result of your disease or treatment?","recommendedWording":null,"questionnaires":[13,32],"categories":[],"createDate":"2016-02-29T14:54:06.867","updateDate":"2017-02-16T12:18:13.02"},{"rank":null,"id":249,"code":"Q192","type":"question","description":"worry contaminate bladder treatment","direction":"negative","underlyingIssue":"worrying about possible contamination of the partner during sexual contact with the bladder treatment","additionalInfo":"","preferredWording":"Have you worried that you may contaminate your partner during sexual contact with the \\tbladder treatment you have been receiving?","recommendedWording":null,"questionnaires":[13,30],"categories":[],"createDate":"2016-02-29T15:04:22.763","updateDate":"2016-06-07T10:06:07.217"},{"rank":null,"id":250,"code":"Q193","type":"question","description":"pain in back","direction":"negative","underlyingIssue":"having pain in the back","additionalInfo":"","preferredWording":"in your back ass?","recommendedWording":"in your back adb?","questionnaires":[14,1000142,1000238,1000250,1000262,1000263],"categories":[],"createDate":"2016-02-29T15:21:38.457","updateDate":"2017-03-16T16:50:18.023"},{"rank":null,"id":251,"code":"Q194","type":"question","description":"pain in legs/hips","direction":"negative","underlyingIssue":"having pain in the legs/hips","additionalInfo":"","preferredWording":"in your leg(s) or hip(s)?","recommendedWording":null,"questionnaires":[14,1000238,1000249,1000250,1000263],"categories":[],"createDate":"2016-02-29T15:22:54.26","updateDate":"2017-03-17T12:19:11.617"},{"rank":null,"id":252,"code":"Q195","type":"question","description":"pain in arms/shoulders","direction":"negative","underlyingIssue":"having pain in the arms/shoulders","additionalInfo":"","preferredWording":"in your arm(s) or shoulder(s)?","recommendedWording":null,"questionnaires":[1000263,1000238,1000250],"categories":[],"createDate":"2016-02-29T15:24:23.51","updateDate":"2017-03-16T16:49:48.18"},{"rank":null,"id":253,"code":"Q196","type":"question","description":"pain in chest/ribs","direction":"negative","underlyingIssue":"having pain in the chest/ribs","additionalInfo":"","preferredWording":"in your chest or rib(s)?","recommendedWording":null,"questionnaires":[14,1000238,1000250,1000263],"categories":[],"createDate":"2016-02-29T15:25:10.407","updateDate":"2016-06-07T10:07:40.647"},{"rank":null,"id":254,"code":"Q197","type":"question","description":"pain in buttocks","direction":"negative","underlyingIssue":"having pain in the buttocks","additionalInfo":"","preferredWording":"in your buttock(s)?","recommendedWording":null,"questionnaires":[14,1000238,1000250,1000263],"categories":[],"createDate":"2016-02-29T15:26:05.477","updateDate":"2016-06-07T10:08:08.243"},{"rank":null,"id":255,"code":"TS3","type":"timeScale","description":"pain during the past week","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"During the past week have you had pain in any of the following parts of your body?","recommendedWording":null,"questionnaires":[14,1000262,1000263,1000243,1000142,1000177],"categories":[],"createDate":"2016-02-29T15:27:58.143","updateDate":"2016-02-29T15:27:58.143"},{"rank":null,"id":256,"code":"Q198","type":"question","description":"constant pain","direction":"negative","underlyingIssue":"having constant pain","additionalInfo":"","preferredWording":"Have you had constant pain?","recommendedWording":null,"questionnaires":[14,1000238,1000250,1000263],"categories":[],"createDate":"2016-02-29T15:29:40.53","updateDate":"2016-06-07T10:10:27.167"},{"rank":null,"id":257,"code":"Q199","type":"question","description":"intermittent pain","direction":"negative","underlyingIssue":"having intermittent pain","additionalInfo":"","preferredWording":"Have you had intermittent pain?","recommendedWording":null,"questionnaires":[1000238,1000250,1000263],"categories":[],"createDate":"2016-02-29T15:30:09.22","updateDate":"2016-06-07T10:10:59.163"},{"rank":null,"id":258,"code":"Q200","type":"question","description":"pain not relieved by medication","direction":"negative","underlyingIssue":"having pain that cannot be relieved by pain medications","additionalInfo":"","preferredWording":"Have you had pain not relieved by pain medications?","recommendedWording":null,"questionnaires":[14,1000169,1000238,1000250,1000262,1000263],"categories":[],"createDate":"2016-02-29T15:37:55.07","updateDate":"2016-06-07T10:11:54.22"},{"rank":null,"id":259,"code":"Q201","type":"question","description":"pain while lying down","direction":"negative","underlyingIssue":"having pain while lying down","additionalInfo":"","preferredWording":"Have you had pain while lying down?","recommendedWording":null,"questionnaires":[14,1000169,1000238,1000250,1000263],"categories":[],"createDate":"2016-02-29T15:43:29.81","updateDate":"2016-06-07T10:12:36.323"},{"rank":null,"id":260,"code":"Q202","type":"question","description":"pain while sitting","direction":"negative","underlyingIssue":"having pain while sitting","additionalInfo":"","preferredWording":"Have you had pain while sitting?","recommendedWording":null,"questionnaires":[1000238,1000250,1000263],"categories":[],"createDate":"2016-02-29T15:43:55.007","updateDate":"2016-06-07T10:13:06.387"},{"rank":null,"id":261,"code":"Q203","type":"question","description":"pain when trying to stand up","direction":"negative","underlyingIssue":"having pain when trying to stand up","additionalInfo":"","preferredWording":"Have you had pain when trying to stand up?","recommendedWording":null,"questionnaires":[14,1000238,1000250,1000263],"categories":[],"createDate":"2016-02-29T15:44:31.34","updateDate":"2017-03-09T19:22:54.833"},{"rank":null,"id":262,"code":"Q204","type":"question","description":"pain walking","direction":"negative","underlyingIssue":"having pain while walking","additionalInfo":"","preferredWording":"Have you had pain while walking?","recommendedWording":null,"questionnaires":[14,1000238,1000250,1000263],"categories":[],"createDate":"2016-02-29T15:45:02.947","updateDate":"2016-06-28T10:48:01.347"},{"rank":null,"id":263,"code":"Q205","type":"question","description":"pain with bending or climbing stairs","direction":"negative","underlyingIssue":"having pain with bending or climbing stairs","additionalInfo":"","preferredWording":"Have you had pain with activities such as bending or climbing stairs?","recommendedWording":null,"questionnaires":[14,1000238,1000250,1000263],"categories":[],"createDate":"2016-02-29T15:45:52.807","updateDate":"2016-06-07T10:19:40.86"},{"rank":null,"id":264,"code":"Q206","type":"question","description":"pain with strenuous activity","direction":"negative","underlyingIssue":"having pain with strenuous activity","additionalInfo":"","preferredWording":"Have you had pain with strenuous activity (e.g. exercise, lifting)?","recommendedWording":null,"questionnaires":[14,1000238,1000250,1000263],"categories":[],"createDate":"2016-02-29T15:46:44.867","updateDate":"2016-06-07T10:32:29.327"},{"rank":null,"id":265,"code":"Q207","type":"question","description":"pain interfere sleeping","direction":"negative","underlyingIssue":"pain interfering with sleeping at night","additionalInfo":"","preferredWording":"Has pain interfered with your sleeping at night?","recommendedWording":null,"questionnaires":[14,1000238,1000250,1000263],"categories":[],"createDate":"2016-02-29T15:52:18.36","updateDate":"2016-06-07T10:35:11.667"},{"rank":null,"id":266,"code":"Q208","type":"question","description":"modify daily activities","direction":"negative","underlyingIssue":"having to modify one\'s daily activities due to the illness","additionalInfo":"","preferredWording":"Have you had to modify your daily activities because of your illness?","recommendedWording":null,"questionnaires":[14,1000238,1000250,1000263],"categories":[],"createDate":"2016-02-29T16:00:49.827","updateDate":"2016-06-07T10:36:09.2"},{"rank":null,"id":267,"code":"Q209","type":"question","description":"isolation feeling","direction":"negative","underlyingIssue":"feeling isolated from family and friends","additionalInfo":"","preferredWording":"Have you felt isolated from those close to you (e.g. family, friends)?","recommendedWording":null,"questionnaires":[14,45,1000238,1000250,1000263],"categories":[],"createDate":"2016-02-29T16:05:26.86","updateDate":"2017-03-09T16:19:27.463"},{"rank":null,"id":268,"code":"Q210","type":"question","description":"worry mobility loss","direction":"negative","underlyingIssue":"worrying about loss of mobility due to the illness","additionalInfo":"","preferredWording":"Have you worried about loss of mobility because of your illness?","recommendedWording":null,"questionnaires":[14,1000238,1000250,1000263],"categories":[],"createDate":"2016-03-01T08:18:46.213","updateDate":"2016-06-07T10:40:38.777"},{"rank":null,"id":269,"code":"Q211","type":"question","description":"worry become dependent","direction":"negative","underlyingIssue":"worrying about becoming dependent on others","additionalInfo":"","preferredWording":"Have you worried about becoming dependent on others because of your illness?","recommendedWording":null,"questionnaires":[14,24,31,33,41,1000238,1000250,1000263],"categories":[],"createDate":"2016-03-01T08:26:08.477","updateDate":"2016-06-07T10:41:36.7"},{"rank":null,"id":270,"code":"Q212","type":"question","description":"hope pain better","direction":"positive","underlyingIssue":"feeling hopeful about the pain getting better","additionalInfo":"","preferredWording":"Have you felt hopeful your pain will get better?","recommendedWording":null,"questionnaires":[14,1000238,1000250,1000263],"categories":[],"createDate":"2016-03-01T08:32:33.763","updateDate":"2016-06-07T10:45:10.367"},{"rank":null,"id":271,"code":"Q213","type":"question","description":"feel positive health","direction":"positive","underlyingIssue":"feeling positive about one\'s health","additionalInfo":"","preferredWording":"Have you felt positive about your health?","recommendedWording":null,"questionnaires":[14,1000238,1000250,1000263],"categories":[],"createDate":"2016-03-01T08:33:40.847","updateDate":"2016-06-07T12:02:11.703"},{"rank":null,"id":272,"code":"Q214","type":"question","description":"problem pass wind gas flatulence","direction":"negative","underlyingIssue":"experiencing problems with passing wind/gas/flatulence","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems passing wind/gas/flatulence?</p>","preferredWording":"Have you had a problem with passing wind/gas/flatulence?","recommendedWording":null,"questionnaires":[16,17,19,38,42],"categories":[],"createDate":"2016-03-01T08:53:34.837","updateDate":"2016-06-07T12:03:25.227"},{"rank":null,"id":273,"code":"Q215","type":"question","description":"setbacks condition","direction":"negative","underlyingIssue":"feeling setbacks in one\'s condition","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt you had setbacks in your physical condition?</p>","preferredWording":"Did you feel you had setbacks in your condition?","recommendedWording":null,"questionnaires":[15,31],"categories":[],"createDate":"2016-03-01T08:56:41.187","updateDate":"2016-06-28T12:07:12.103"},{"rank":null,"id":274,"code":"Q216","type":"question","description":"gurgling noise abdomen","direction":"negative","underlyingIssue":"experiencing excessive gurgling noises from the abdomen","additionalInfo":"","preferredWording":"Have you had excessive gurgling noise from your abdomen?","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T09:04:53.84","updateDate":"2016-06-07T12:05:12.557"},{"rank":null,"id":275,"code":"Q217","type":"question","description":"release wind mucous","direction":"negative","underlyingIssue":"unintentionally releasing/leaking wind or mucous","additionalInfo":"","preferredWording":"Have you had any unintentional release (leakage) of wind or mucous?","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T09:08:03.45","updateDate":"2016-06-07T12:05:47.957"},{"rank":null,"id":276,"code":"Q218","type":"question","description":"release liquid stools","direction":"negative","underlyingIssue":"unintentionally releasing/leaking liquid stoold","additionalInfo":"","preferredWording":"Have you had any unintentional release (leakage) of liquid stools?","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T09:11:41.81","updateDate":"2016-06-07T12:11:23.35"},{"rank":null,"id":277,"code":"Q219","type":"question","description":"get up bowel movement","direction":"negative","underlyingIssue":"having to get up at night to open bowels","additionalInfo":"","preferredWording":"Have you needed to get up at night to open your bowels?","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T09:17:03.48","updateDate":"2016-06-07T12:29:11.313"},{"rank":null,"id":278,"code":"Q220","type":"question","description":"worse outlook future","direction":"negative","underlyingIssue":"worsening of one\'s outlook on the future","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has your outlook on the future worsened?</p>","preferredWording":"Did your outlook on the future worsen?","recommendedWording":null,"questionnaires":[15],"categories":[],"createDate":"2016-03-01T09:20:37.83","updateDate":"2016-06-28T12:08:26.347"},{"rank":null,"id":279,"code":"Q221","type":"question","description":"double vision","direction":"negative","underlyingIssue":"having double vision","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had double vision?</p>","preferredWording":"Did you have double vision?","recommendedWording":null,"questionnaires":[15],"categories":[],"createDate":"2016-03-01T09:41:00.653","updateDate":"2016-06-28T12:08:44.163"},{"rank":null,"id":280,"code":"Q222","type":"question","description":"blurred vision","direction":"negative","underlyingIssue":"having blurred vision","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had blurred vision?</p>","preferredWording":"Was your vision blurred?","recommendedWording":null,"questionnaires":[15,22],"categories":[],"createDate":"2016-03-01T09:43:00.34","updateDate":"2016-06-28T12:09:14.74"},{"rank":null,"id":281,"code":"Q223","type":"question","description":"problems reading vision","direction":"negative","underlyingIssue":"experiencing problems with reading because of vision","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with reading because of your vision?</p>","preferredWording":"Did you have difficulty reading because of your vision?","recommendedWording":null,"questionnaires":[15,21],"categories":[],"createDate":"2016-03-01T09:45:02.76","updateDate":"2016-06-07T12:33:56.787"},{"rank":null,"id":282,"code":"Q224","type":"question","description":"seizures","direction":"negative","underlyingIssue":"having seizures","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had seizures?</p>","preferredWording":"Did you have seizures?","recommendedWording":null,"questionnaires":[15],"categories":[],"createDate":"2016-03-01T09:51:16.987","updateDate":"2016-06-07T12:34:24.26"},{"rank":null,"id":283,"code":"Q225","type":"question","description":"weakness one side","direction":"negative","underlyingIssue":"having weakness on one side of the body","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had weakness on one side of your body?</p>","preferredWording":"Did you have weakness on one side of your body?","recommendedWording":null,"questionnaires":[15],"categories":[],"createDate":"2016-03-01T10:09:00.48","updateDate":"2016-06-28T12:09:52.943"},{"rank":null,"id":284,"code":"Q226","type":"question","description":"problem finding words","direction":"negative","underlyingIssue":"experiencing problems finding the right words to express oneself","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems finding the right words to express yourself?</p>","preferredWording":"Have you had trouble finding the right words to express yourself?","recommendedWording":null,"questionnaires":[15],"categories":[],"createDate":"2016-03-01T10:19:25.703","updateDate":"2016-06-07T12:35:36.537"},{"rank":null,"id":285,"code":"Q227","type":"question","description":"problem speaking","direction":"negative","underlyingIssue":"experiencing problems speaking","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems speaking?</p>","preferredWording":"Did you have difficulty speaking?","recommendedWording":null,"questionnaires":[15,48],"categories":[],"createDate":"2016-03-01T10:23:16.843","updateDate":"2016-06-03T13:48:20.083"},{"rank":null,"id":286,"code":"Q228","type":"question","description":"abdominal cramp","direction":"negative","underlyingIssue":"experiencing abdominal pain/cramping unrelated to bowel movement","additionalInfo":"","preferredWording":"Have you had abdominal pain or cramping not related to a bowel movement?","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T10:29:58.557","updateDate":"2016-06-07T12:50:55.47"},{"rank":null,"id":287,"code":"Q229","type":"question","description":"pain cramp rectum","direction":"negative","underlyingIssue":"experiencing pain/cramping in the rectum","additionalInfo":"","preferredWording":"Have you had pain or cramping in your rectum (deep inside the back passage)?","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T10:30:43.283","updateDate":"2016-06-07T12:51:07.497"},{"rank":null,"id":288,"code":"Q230","type":"question","description":"pain discomfort anus","direction":"negative","underlyingIssue":"experiencing pain/discomfort around the anus","additionalInfo":"","preferredWording":"Have you had pain /discomfort around your anal opening (back passsssssage)?","recommendedWording":null,"questionnaires":[13,16],"categories":[],"createDate":"2016-03-01T10:32:28.247","updateDate":"2016-06-07T12:51:28.573"},{"rank":null,"id":289,"code":"Q231","type":"question","description":"bright blood stools","direction":"negative","underlyingIssue":"having bright blood in the stools","additionalInfo":"","preferredWording":"Have you had bright blood in your stools?","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T10:33:14.22","updateDate":"2016-06-07T12:53:19.807"},{"rank":null,"id":290,"code":"Q232","type":"question","description":"dark blood clots stools","direction":"negative","underlyingIssue":"having dark blood clots in the stools","additionalInfo":"","preferredWording":"Have you had dark blood clots in your stools?","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T10:34:02.3","updateDate":"2016-06-07T12:53:07.247"},{"rank":null,"id":291,"code":"Q233","type":"question","description":"unable wait bowel movement","direction":"negative","underlyingIssue":"being unable to wait for 15 minutes before bowel movement","additionalInfo":"","preferredWording":"Have you been unable to wait 15 minutes to open your bowels?","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T10:34:59.26","updateDate":"2016-06-07T13:00:18.21"},{"rank":null,"id":292,"code":"Q234","type":"question","description":"unable empty bowels","direction":"negative","underlyingIssue":"feeling unable to completely empty the bowels","additionalInfo":"","preferredWording":"Have you had the feeling of being unable to completely empty your bowels?","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T10:40:32.19","updateDate":"2016-06-07T13:00:42.72"},{"rank":null,"id":293,"code":"Q235","type":"question","description":"passing water open bowels","direction":"negative","underlyingIssue":"passing water causing bowel movement","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has passing water caused your bowel to act immediately?</p>","preferredWording":"Does passing water cause your bowels to act immediately?","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T10:41:49.01","updateDate":"2016-06-28T15:43:25.983"},{"rank":null,"id":294,"code":"Q236","type":"question","description":"wear incontinence aid","direction":"negative","underlyingIssue":"having to wear incontinence aid because of the bowel problems","additionalInfo":null,"preferredWording":"Have you had to wear a pad because of your bowel problems?","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T10:42:38.417","updateDate":"2016-03-01T10:42:38.417"},{"rank":null,"id":295,"code":"Q237","type":"question","description":"restricted types food bowel problems","direction":"negative","underlyingIssue":"having to restrict the types of food one can eat because of bowel problems","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has your treatment restricted you in the types of food you could eat due to your bowel problems?</p>","preferredWording":"Did your treatment restrict the types of food you can eat due to your bowel problems?","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T11:07:40.973","updateDate":"2016-06-28T15:44:41.383"},{"rank":null,"id":296,"code":"Q238","type":"question","description":"worry bowel problem","direction":"negative","underlyingIssue":"worrying about one\'s bowel problem","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about your bowel problem?</p>","preferredWording":"Did you worry about your bowel problem?","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T11:08:18.477","updateDate":"2016-06-07T13:06:44.34"},{"rank":null,"id":297,"code":"Q239","type":"question","description":"embarrassed bowel problem","direction":"negative","underlyingIssue":"feeling embarrassed by one\'s bowel problem","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt embarrassed by your bowel problem?</p>","preferredWording":"Did you feel embarrassed by your bowel problem?","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T11:09:11.563","updateDate":"2016-06-07T13:07:20.813"},{"rank":null,"id":298,"code":"Q240","type":"question","description":"problem communicate thoughts","direction":"negative","underlyingIssue":"experiencing problems communicating one\'s thoughts","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems communicating your thoughts?</p>","preferredWording":"Did you have trouble communicating your thoughts?","recommendedWording":null,"questionnaires":[15],"categories":[],"createDate":"2016-03-01T11:26:03.967","updateDate":"2016-06-07T13:13:25.897"},{"rank":null,"id":299,"code":"Q241","type":"question","description":"drowsy daytime","direction":"negative","underlyingIssue":"feeling drowsy during the daytime","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt drowsy during the daytime?</p>","preferredWording":"Did you feel drowsy during the daytime?","recommendedWording":null,"questionnaires":[15],"categories":[],"createDate":"2016-03-01T11:27:36.383","updateDate":"2016-06-07T13:13:50.67"},{"rank":null,"id":300,"code":"Q242","type":"question","description":"unhappy rest life bowel habit","direction":"negative","underlyingIssue":"feeling unhappy with the current bowel habit staying so for the rest of life","additionalInfo":"","preferredWording":"How unhappy would you feel if you lived the rest of your life with your bowel habit as it is now?","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T11:27:38.177","updateDate":"2016-06-07T13:20:56.813"},{"rank":null,"id":301,"code":"Q243","type":"question","description":"problem coordination","direction":"negative","underlyingIssue":"experiencing problems with coordination","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems with your coordination?</p>","preferredWording":"Did you have trouble with your coordination?","recommendedWording":null,"questionnaires":[15],"categories":[],"createDate":"2016-03-01T11:29:00.813","updateDate":"2016-06-07T13:31:12.313"},{"rank":null,"id":302,"code":"Q244","type":"question","description":"medication diarrhoea","direction":"none","underlyingIssue":"need to take medication to control diarrhoea","additionalInfo":"","preferredWording":"Have you needed to take medication to control diarrhoea?","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T11:29:16.697","updateDate":"2016-06-07T13:31:49.803"},{"rank":null,"id":304,"code":"Q245","type":"question","description":"highest number bowel movement","direction":"none","underlyingIssue":"highest number of bowel movements in 24 h","additionalInfo":"","preferredWording":"What was the highest number of times you had to open your bowels in any 24 hour period?","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T11:30:18.91","updateDate":"2016-06-07T13:35:08.037"},{"rank":null,"id":305,"code":"IN16","type":"instructions","description":"number in box","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please indicate number in box","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T11:30:37.1","updateDate":"2016-03-01T11:30:37.1"},{"rank":null,"id":306,"code":"Q246","type":"question","description":"assistance manage bowel problem","direction":"none","underlyingIssue":"wishing more assistance to manage one\'s bowel problem","additionalInfo":"","preferredWording":"Would you like more assistance to manage your bowel problem?\\n","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T11:32:07.6","updateDate":"2016-06-07T13:35:40.44"},{"rank":null,"id":307,"code":"CS12","type":"condition","description":"optional","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"(optional question)","recommendedWording":null,"questionnaires":[16],"categories":[],"createDate":"2016-03-01T11:32:19.97","updateDate":"2016-03-01T11:32:19.97"},{"rank":null,"id":308,"code":"Q247","type":"question","description":"problem itchy skin","direction":"negative","underlyingIssue":"experiencing problems with itchy skin","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with itching of your skin?</p>","preferredWording":"Did itching of your skin bother you?","recommendedWording":null,"questionnaires":[15],"categories":[],"createDate":"2016-03-01T11:34:24.933","updateDate":"2016-06-03T13:52:41.343"},{"rank":null,"id":309,"code":"Q248","type":"question","description":"weakness both legs","direction":"negative","underlyingIssue":"feeling weakness of both legs","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had weakness of both legs?</p>","preferredWording":"Did you have weakness of both legs?","recommendedWording":null,"questionnaires":[15],"categories":[],"createDate":"2016-03-01T11:36:57.13","updateDate":"2016-06-28T12:11:14.487"},{"rank":null,"id":310,"code":"Q249","type":"question","description":"problem controlling bladder","direction":"negative","underlyingIssue":"experiencing problems controlling one\'s bladder","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems controlling your bladder?</p>","preferredWording":"Did you have trouble controlling your bladder?","recommendedWording":null,"questionnaires":[15],"categories":[],"createDate":"2016-03-01T11:39:30.313","updateDate":"2016-06-07T13:49:36.02"},{"rank":null,"id":311,"code":"Q250","type":"question","description":"numb tingling arm shoulder","direction":"negative","underlyingIssue":"having numbness/tingling in the arm/shoulder","additionalInfo":"","preferredWording":"Have you had numbness or tingling in your arm or shoulder?","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T11:52:04.807","updateDate":"2016-06-14T12:16:02.503"},{"rank":null,"id":312,"code":"Q251","type":"question","description":"uncomfortable position","direction":"negative","underlyingIssue":"finding some positions uncomfortable","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you found it uncomfortable in certain position (e.g. lying down)?</p>","preferredWording":"Did you find it uncomfortable in certain positions (e.g. lying down)?","recommendedWording":null,"questionnaires":[17],"categories":[],"createDate":"2016-03-01T12:10:30.437","updateDate":"2016-06-28T15:39:43.483"},{"rank":null,"id":313,"code":"Q252","type":"question","description":"limited amounts of food","direction":"negative","underlyingIssue":"being limited in the amounts of food as a result of disease or treatment","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been limited in the amount of food you could eat as a result of your disease or treatment?</p>","preferredWording":"Were you restricted in the amounts of food you could eat as a result of your disease or treatment?","recommendedWording":null,"questionnaires":[17],"categories":[],"createDate":"2016-03-01T12:12:10.5","updateDate":"2016-06-28T15:40:40.817"},{"rank":null,"id":314,"code":"Q253","type":"question","description":"indigestion","direction":"negative","underlyingIssue":"experiencing indigestion","additionalInfo":null,"preferredWording":"Have you had indigestion?","recommendedWording":null,"questionnaires":[17],"categories":[],"createDate":"2016-03-01T12:13:51.263","updateDate":"2016-03-01T12:13:51.263"},{"rank":null,"id":315,"code":"Q254","type":"question","description":"weak arms legs","direction":"negative","underlyingIssue":"feeling weak in arms and legs","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt weak in your arms and legs?</p>","preferredWording":"Have you felt weak in your arms and legs?","recommendedWording":null,"questionnaires":[17,19],"categories":[],"createDate":"2016-03-01T12:15:26.44","updateDate":"2016-06-28T15:41:39.773"},{"rank":null,"id":316,"code":"Q255","type":"question","description":"yellow skin","direction":"negative","underlyingIssue":"skin being yellow (jaundiced)","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has your skin been yellow?</p>","preferredWording":"To what extent was your skin yellow?","recommendedWording":null,"questionnaires":[17],"categories":[],"createDate":"2016-03-01T12:16:38.423","updateDate":"2016-06-28T15:42:05.907"},{"rank":null,"id":317,"code":"Q256","type":"question","description":"frequent bowel movements","direction":"negative","underlyingIssue":"having frequent bowel movements","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had frequent bowel movements?</p>","preferredWording":"Did you have frequent bowel movements?","recommendedWording":null,"questionnaires":[17],"categories":[],"createDate":"2016-03-01T12:17:43.85","updateDate":"2016-06-07T14:33:51.723"},{"rank":null,"id":318,"code":"Q257","type":"question","description":"urge bowel movement","direction":"negative","underlyingIssue":"feeling the urge to move bowels quickly","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt the urge to move your bowels quickly?</p>","preferredWording":"Did you feel the urge to move your bowels quickly?","recommendedWording":null,"questionnaires":[17],"categories":[],"createDate":"2016-03-01T12:18:56.253","updateDate":"2016-06-07T14:33:09.163"},{"rank":null,"id":319,"code":"Q258","type":"question","description":"limited planning activites","direction":"negative","underlyingIssue":"being limited in planning activities in advance","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you been limited in planning activities in advance (e.g. meeting friends)?</p>","preferredWording":"Were you limited in planning activities, for example meeting friends, in advance?","recommendedWording":null,"questionnaires":[17,23],"categories":[],"createDate":"2016-03-01T12:21:29.78","updateDate":"2016-06-07T14:40:39.723"},{"rank":null,"id":320,"code":"Q259","type":"question","description":"adequate support HCP","direction":"positive","underlyingIssue":"receiving enough support from the medical staff","additionalInfo":null,"preferredWording":"Have you received adequate support from your health care professionals?","recommendedWording":null,"questionnaires":[17],"categories":[],"createDate":"2016-03-01T12:22:30.56","updateDate":"2016-03-01T12:22:30.56"},{"rank":null,"id":321,"code":"Q260","type":"question","description":"problem fullness arm","direction":"negative","underlyingIssue":"experiencing a problem with fullness under the arm","additionalInfo":"","preferredWording":"Have you had a problem with fullness under your arm?","recommendedWording":null,"questionnaires":[18,1000260],"categories":[],"createDate":"2016-03-01T12:22:38.563","updateDate":"2016-06-07T14:43:22.06"},{"rank":null,"id":322,"code":"Q261","type":"question","description":" problem find bra","direction":"negative","underlyingIssue":" experiencing problems finding a well-fitting bra","additionalInfo":"","preferredWording":"Have you had problems finding a well-fitting bra?","recommendedWording":null,"questionnaires":[18,1000287],"categories":[],"createDate":"2016-03-01T12:24:19.78","updateDate":"2017-03-10T15:21:58.45"},{"rank":null,"id":323,"code":"Q262","type":"question","description":"feel less sexually attractive","direction":"negative","underlyingIssue":"feeling less sexually attractive","additionalInfo":"","preferredWording":"Have you been feeling less sexually attractive as a result of your disease or treatment?","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T12:26:21.09","updateDate":"2017-03-10T15:20:08.827"},{"rank":null,"id":324,"code":"Q263","type":"question","description":"uncomfortable intimate situations","direction":"negative","underlyingIssue":"feeling uncomfortable in intimate situations","additionalInfo":"","preferredWording":"Have you felt uncomfortable in intimate situations","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T12:28:19.403","updateDate":"2016-06-07T14:46:22.497"},{"rank":null,"id":325,"code":"Q264","type":"question","description":"breast role sexuality","direction":"negative","underlyingIssue":"the role the breast in sexuality being affected by the disease/treatment","additionalInfo":"","preferredWording":"Has the role of your breast in your sexuality been affected by your disease or treatment?\\n","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T12:30:47.5","updateDate":"2016-06-07T14:50:16.957"},{"rank":null,"id":326,"code":"Q265","type":"question","description":"problem loss sensations breast","direction":"negative","underlyingIssue":"experiencing problems with the loss of pleasurable sensations of the breast","additionalInfo":"","preferredWording":"Has any loss of pleasurable sensations of your breast been a problem to you?\\n","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T12:37:16.27","updateDate":"2016-06-07T14:51:00.933"},{"rank":null,"id":327,"code":"Q266","type":"question","description":"satisfied size breast","direction":"positive","underlyingIssue":"being satisfied with the size of the breast","additionalInfo":"","preferredWording":"The size of your affected breast?","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T12:39:37.813","updateDate":"2016-06-07T14:52:35.847"},{"rank":null,"id":328,"code":"Q267","type":"question","description":"satisfied shape breast","direction":"positive","underlyingIssue":"being satisfied with the shape of the breast","additionalInfo":"","preferredWording":"The shape of your affected breast?","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T12:40:20.7","updateDate":"2016-06-07T14:52:20.34"},{"rank":null,"id":329,"code":"Q268","type":"question","description":"satisfied skin appearance breast","direction":"positive","underlyingIssue":"being satisfied with the skin appearance of the breast","additionalInfo":"","preferredWording":"The appearance of the skin of your affected breast?","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T12:47:32.943","updateDate":"2016-06-07T14:55:38.327"},{"rank":null,"id":330,"code":"Q269","type":"question","description":"satisfied symmetry breasts","direction":"positive","underlyingIssue":"being satisfied with the symmetry of the breasts","additionalInfo":"","preferredWording":"The symmetry of your breasts?","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T12:48:25.22","updateDate":"2016-06-07T14:55:28.937"},{"rank":null,"id":331,"code":"Q270","type":"question","description":"satisfied cleavage","direction":"positive","underlyingIssue":"being satisfied with the cleavage","additionalInfo":"","preferredWording":"Your cleavage?","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T12:50:32.35","updateDate":"2016-06-07T14:56:12.837"},{"rank":null,"id":332,"code":"Q271","type":"question","description":"satisfied softness breast","direction":"positive","underlyingIssue":"being satisfied with the softness of the breast","additionalInfo":"","preferredWording":"The softness of your affected breast?","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T12:51:20.243","updateDate":"2016-06-07T14:59:46.047"},{"rank":null,"id":333,"code":"Q272","type":"question","description":"satisfied appearance nipple","direction":"positive","underlyingIssue":"being satisfied with the appearance of the nipple","additionalInfo":"","preferredWording":"The appearance of your affected nipple?","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T12:53:22.82","updateDate":"2016-06-07T15:03:57.06"},{"rank":null,"id":334,"code":"Q273","type":"question","description":"satisfied sensation nipple","direction":"positive","underlyingIssue":"being satisfied with the sensation of the nipple","additionalInfo":"","preferredWording":"The sensation in your affected nipple?","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T12:54:09.073","updateDate":"2016-06-07T15:04:49.51"},{"rank":null,"id":335,"code":"Q274","type":"question","description":"satisfied scars appearance breast","direction":"positive","underlyingIssue":"being satisfied with the scars appearance on the breast","additionalInfo":"","preferredWording":"How satisfied have you been with the appearance of any scars on your affected breast?","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T12:58:08.763","updateDate":"2016-06-07T15:10:30.737"},{"rank":null,"id":336,"code":"Q275","type":"question","description":"problems clothes tight","direction":"negative","underlyingIssue":"experiencing problems with clothes feeling too tight","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems with your clothes feeling too tight?</p>","preferredWording":"Did you have problems with your clothes feeling too tight?","recommendedWording":null,"questionnaires":[19,1000267],"categories":[],"createDate":"2016-03-01T13:02:19.993","updateDate":"2016-06-28T15:34:51.107"},{"rank":null,"id":337,"code":"Q276","type":"question","description":"satisfied breast reconstruction result ","direction":"positive","underlyingIssue":"being satisfied with the breast reconstruction result ","additionalInfo":"","preferredWording":"Overall, how satisfied have you been with the result of your breast reconstruction?\\n","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:05:24.61","updateDate":"2016-06-07T15:11:12.33"},{"rank":null,"id":338,"code":"Q277","type":"question","description":"coming to terms breast reconstruction","direction":"positive","underlyingIssue":"coming to terms with the disease or treatment thanks to breast reconstruction","additionalInfo":null,"preferredWording":"Has the reconstruction of your breast helped you come to terms with your disease or treatment?","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:08:44.72","updateDate":"2016-03-04T14:17:21.133"},{"rank":null,"id":339,"code":"Q278","type":"question","description":"tightness breast","direction":"negative","underlyingIssue":"having tightness in the breast","additionalInfo":"","preferredWording":"Have you had tightness?","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:14:52.83","updateDate":"2016-06-07T15:18:54.557"},{"rank":null,"id":340,"code":"Q279","type":"question","description":"numb breast","direction":"negative","underlyingIssue":"having numbness in the breast","additionalInfo":"","preferredWording":"Have you had any numbness?","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:15:14.173","updateDate":"2016-06-14T12:16:10.85"},{"rank":null,"id":341,"code":"Q280","type":"question","description":"satisfied scars appearance","direction":"positive","underlyingIssue":"being satisfied with the appearance of the scars","additionalInfo":"","preferredWording":"Have you been satisfied with the appearance of the scars?","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:16:30.07","updateDate":"2016-06-07T15:27:08.017"},{"rank":null,"id":342,"code":"Q281","type":"question","description":"problem loss of nipple","direction":"negative","underlyingIssue":"experiencing problems with the loss of the nipple","additionalInfo":"","preferredWording":"Has the loss of your nipple been a problem to you?","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:17:40.15","updateDate":"2016-06-07T15:27:54.66"},{"rank":null,"id":343,"code":"Q282","type":"question","description":"coming to terms nipple preservation/reconstruction","direction":"positive","underlyingIssue":"coming to terms with the disease/treatment thanks to the nipple preservation/reconstruction","additionalInfo":"","preferredWording":"Has the preservation or reconstruction of your nipple helped you come to terms with the disease or treatment?\\n","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:20:16.473","updateDate":"2016-06-07T15:28:42.897"},{"rank":null,"id":344,"code":"IN17","type":"instructions","description":"affected breast","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"The term ‘affected’ refers to the breast, which has been, or is about to be, reconstructed. sadsad","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:24:57.263","updateDate":"2016-03-01T13:24:57.263"},{"rank":null,"id":345,"code":"TS4","type":"timeScale","description":"past week satisfaction","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"During the past week,  how SATISFIED have you been with:","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:26:19.26","updateDate":"2016-03-01T13:26:54.027"},{"rank":null,"id":346,"code":"CS13","type":"condition","description":"if nipple preserved","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer these two questions ONLY IF your nipple has been PRESERVED.","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:29:30.24","updateDate":"2016-03-01T13:29:30.24"},{"rank":null,"id":347,"code":"CS14","type":"condition","description":"breast reconstruction overall","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer these questions in relation to your breast reconstruction overall.","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:30:05.95","updateDate":"2016-03-01T13:30:05.95"},{"rank":null,"id":348,"code":"CS15","type":"condition","description":"if flap procedure","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer these questions ONLY IF YOU HAVE HAD A FLAP PROCEDURE (skin/muscle is taken from your back, tummy or buttock to reconstruct your breast).\\n\\n","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:31:46.753","updateDate":"2016-03-01T13:31:46.753"},{"rank":null,"id":349,"code":"CS16","type":"condition","description":"area where the skin/muscle was taken from","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please answer the following regarding the area where the skin/muscle was taken from:","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:33:05.103","updateDate":"2016-03-01T13:33:05.103"},{"rank":null,"id":350,"code":"CS17","type":"condition","description":"If loss of nipple without nipple reconstruction","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer this question ONLY IF you have LOST your nipple and NOT had a nipple reconstruction.","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:34:38.837","updateDate":"2016-03-01T13:34:38.837"},{"rank":null,"id":351,"code":"CS18","type":"condition","description":"If nipple preserving or reconstructing surgery","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer this question ONLY IF you HAVE had nipple preserving or reconstructing surgery.","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:35:51.74","updateDate":"2016-03-01T13:35:51.74"},{"rank":null,"id":352,"code":"Q283","type":"question","description":"unpleasant food texture","direction":"negative","underlyingIssue":"finding the food texture unpleasany","additionalInfo":"","preferredWording":"Have you found the texture of food unpleasant?","recommendedWording":null,"questionnaires":[20,1000280],"categories":[],"createDate":"2016-03-01T13:59:48.547","updateDate":"2016-06-07T15:30:05.767"},{"rank":null,"id":353,"code":"Q284","type":"question","description":"change bowel habit","direction":"negative","underlyingIssue":"experiencing changes in bowel habit as a result of disease or treatment","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has your bowel habit changed as a result of your disease or treatment?</p>","preferredWording":"Did you experience any change in bowel habit as a result of your disease or treatment?","recommendedWording":null,"questionnaires":[19],"categories":[],"createDate":"2016-03-01T14:00:42.26","updateDate":"2016-06-28T15:36:19.183"},{"rank":null,"id":354,"code":"Q285","type":"question","description":"smell food put off","direction":"negative","underlyingIssue":"being put off eating by the smell of the food","additionalInfo":"","preferredWording":"Have you been put off eating by the smell of food?","recommendedWording":null,"questionnaires":[20,1000280],"categories":[],"createDate":"2016-03-01T14:04:02.773","updateDate":"2016-06-07T15:32:49.497"},{"rank":null,"id":355,"code":"Q286","type":"question","description":"too much put off","direction":"negative","underlyingIssue":"being put off eating by having too much on the plate","additionalInfo":"","preferredWording":"Have you been put off eating by having too much food on your plate?","recommendedWording":null,"questionnaires":[20,1000280],"categories":[],"createDate":"2016-03-01T14:06:54.35","updateDate":"2016-06-07T15:33:39.557"},{"rank":null,"id":356,"code":"Q287","type":"question","description":"tingling hands feet","direction":"negative","underlyingIssue":"feeling tingling in hands or feet","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had tingling in your hands or feet?</p>","preferredWording":"Have you had tingling hands or feet?","recommendedWording":null,"questionnaires":[19,31,35,36,37,48],"categories":[],"createDate":"2016-03-01T14:08:02.65","updateDate":"2016-06-07T15:34:07.67"},{"rank":null,"id":357,"code":"Q288","type":"question","description":"numb fingers toes","direction":"negative","underlyingIssue":"feeling numbness in fingers or toes","additionalInfo":"","preferredWording":"Have you had numbness in your fingers or toes?","recommendedWording":null,"questionnaires":[19,31],"categories":[],"createDate":"2016-03-01T14:08:41.197","updateDate":"2016-06-14T12:16:21.957"},{"rank":null,"id":358,"code":"Q289","type":"question","description":"worry not eat enough","direction":"negative","underlyingIssue":"worrying about not eating enough","additionalInfo":"","preferredWording":"Have you worried that you do not eat enough?","recommendedWording":null,"questionnaires":[20,1000280],"categories":[],"createDate":"2016-03-01T14:12:00.34","updateDate":"2016-06-07T15:35:07.95"},{"rank":null,"id":359,"code":"Q290","type":"question","description":"worry weight loss continues","direction":"negative","underlyingIssue":"worrying about what might happen if the weight loss continues","additionalInfo":"","preferredWording":"Have you worried about what will happen if you continue to lose weight?","recommendedWording":null,"questionnaires":[20,1000280],"categories":[],"createDate":"2016-03-01T14:16:28.06","updateDate":"2016-06-07T15:35:53.19"},{"rank":null,"id":360,"code":"Q291","type":"question","description":"aches pains muscles joints","direction":"negative","underlyingIssue":"having pains/aches in muscles or joints","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had aches or pains in your muscles or joints?</p>","preferredWording":"Have you had aches or pains in your muscles or joints?","recommendedWording":null,"questionnaires":[19,24,26,31,33,38,41],"categories":[],"createDate":"2016-03-01T14:23:39.107","updateDate":"2016-06-07T15:36:28.073"},{"rank":null,"id":361,"code":"Q292","type":"question","description":"unable to eat","direction":"negative","underlyingIssue":"being unable to eat despite wanting to","additionalInfo":null,"preferredWording":"Have you been unable to eat despite wanting to?","recommendedWording":null,"questionnaires":[20,1000280],"categories":[],"createDate":"2016-03-01T14:23:59.497","updateDate":"2016-03-04T14:19:08.867"},{"rank":null,"id":362,"code":"Q293","type":"question","description":"problem swallowing","direction":"negative","underlyingIssue":"experiencing problems swallowing","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems swallowing?</p>","preferredWording":"Have you had problems swallowing?","recommendedWording":null,"questionnaires":[20,37,45,48,1000280],"categories":[],"createDate":"2016-03-01T14:25:11.757","updateDate":"2016-06-03T14:48:27.973"},{"rank":null,"id":363,"code":"Q294","type":"question","description":"pressure others eat more","direction":"negative","underlyingIssue":"feeling pressured by other people to eat more","additionalInfo":"","preferredWording":"Have you felt pressured by other people to eat more?","recommendedWording":null,"questionnaires":[20,1000280],"categories":[],"createDate":"2016-03-01T14:26:49.887","updateDate":"2016-06-07T15:40:21.177"},{"rank":null,"id":364,"code":"Q295","type":"question","description":"urinate frequently","direction":"negative","underlyingIssue":"urinating frequently","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had to urinate frequently?</p>","preferredWording":"Did you pass water/urine frequently?","recommendedWording":null,"questionnaires":[19,26,34,38,45,1000282],"categories":[],"createDate":"2016-03-01T14:27:00.4","updateDate":"2016-06-28T12:38:25.633"},{"rank":null,"id":365,"code":"Q296","type":"question","description":"worry burden other people","direction":"negative","underlyingIssue":"worrying about being a burden to other people","additionalInfo":"","preferredWording":"Have you worried that you are a burden to other people?","recommendedWording":null,"questionnaires":[20,1000280],"categories":[],"createDate":"2016-03-01T14:28:07.873","updateDate":"2016-06-07T15:41:41.52"},{"rank":null,"id":366,"code":"Q297","type":"question","description":"night sweats","direction":"negative","underlyingIssue":"experiencing excessive sweating at night","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had night sweats?</p>","preferredWording":"Did you have night sweats?","recommendedWording":null,"questionnaires":[19,23,24,42],"categories":[],"createDate":"2016-03-01T14:29:14.707","updateDate":"2016-06-28T15:11:00.51"},{"rank":null,"id":367,"code":"Q298","type":"question","description":"worry appearance","direction":"negative","underlyingIssue":"worrying about the appearance","additionalInfo":"","preferredWording":"Have you worried about your appearance?","recommendedWording":null,"questionnaires":[20,1000280],"categories":[],"createDate":"2016-03-01T14:35:03.02","updateDate":"2016-06-08T10:58:00.82"},{"rank":null,"id":368,"code":"Q299","type":"question","description":"feel weight loss control","direction":"negative","underlyingIssue":"feeling out of control about the weight loss","additionalInfo":"","preferredWording":"Have you felt your weight loss was out of control?","recommendedWording":null,"questionnaires":[20,1000280],"categories":[],"createDate":"2016-03-01T14:36:03.193","updateDate":"2016-06-08T11:09:31.953"},{"rank":null,"id":369,"code":"Q300","type":"question","description":"worry change daily life","direction":"negative","underlyingIssue":"worrying about changes in one\'s daily life","additionalInfo":"","preferredWording":"Have you worried about changes in your daily life?","recommendedWording":null,"questionnaires":[20,1000280],"categories":[],"createDate":"2016-03-01T14:39:17.077","updateDate":"2016-06-08T11:11:14.09"},{"rank":null,"id":370,"code":"Q301","type":"question","description":"worry become more dependent","direction":"negative","underlyingIssue":"worrying about becoming more dependent on others","additionalInfo":"","preferredWording":"Have you worried about becoming more dependent on others?","recommendedWording":null,"questionnaires":[20,1000280],"categories":[],"createDate":"2016-03-01T14:40:05.127","updateDate":"2016-06-08T11:12:38.91"},{"rank":null,"id":371,"code":"Q302","type":"question","description":"problem usual activities weight loss","direction":"negative","underlyingIssue":"experiencing problems doing usual activities due to the weight loss","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems doing your usual activities because of your weight?<br /></p>","preferredWording":"Have you had difficulty doing your usual activities because of your weight loss?","recommendedWording":null,"questionnaires":[20,1000280],"categories":[],"createDate":"2016-03-01T14:42:18.933","updateDate":"2016-06-28T12:36:10.613"},{"rank":null,"id":372,"code":"Q303","type":"question","description":"too tired eat","direction":"negative","underlyingIssue":"being too tired to eat","additionalInfo":"","preferredWording":"Have you been too tired to eat?","recommendedWording":null,"questionnaires":[20,1000280],"categories":[],"createDate":"2016-03-01T14:43:04.44","updateDate":"2016-06-08T11:19:29.047"},{"rank":null,"id":373,"code":"Q304","type":"question","description":"too much pain eat","direction":"negative","underlyingIssue":"being in too much pain to eat","additionalInfo":"","preferredWording":"Have you been in too much pain to eat?","recommendedWording":null,"questionnaires":[20,1000280],"categories":[],"createDate":"2016-03-01T14:43:50.743","updateDate":"2016-06-08T11:19:19.563"},{"rank":null,"id":374,"code":"Q305","type":"question","description":"force eat","direction":"negative","underlyingIssue":"forcing yourself to eat","additionalInfo":"","preferredWording":"Have you forced yourself to eat?","recommendedWording":null,"questionnaires":[20,1000280],"categories":[],"createDate":"2016-03-01T14:45:19.57","updateDate":"2016-06-08T11:33:01.537"},{"rank":null,"id":375,"code":"Q306","type":"question","description":"adequate information weight loss","direction":"positive","underlyingIssue":"receiving adequate information about weight loss","additionalInfo":"","preferredWording":"Has the information you have been given about your weight loss been adequate?","recommendedWording":null,"questionnaires":[20,1000280],"categories":[],"createDate":"2016-03-01T14:52:12.177","updateDate":"2016-06-09T13:59:00.353"},{"rank":null,"id":376,"code":"Q307","type":"question","description":"grittiness treated eye","direction":"negative","underlyingIssue":"feeling of grittiness or a foreign body in the treated eye","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had the sensation of grittiness or the feeling of a foreign body in the treated eye?</p>","preferredWording":"Did you have the sensation of grittiness or the feeling of a foreign body in the treated eye?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T14:53:42.207","updateDate":"2016-06-09T14:01:48.697"},{"rank":null,"id":377,"code":"Q308","type":"question","description":"pain soreness discomfort treated eye","direction":"negative","underlyingIssue":"feeling pain, soreness or discomfort in or around the treated eye","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt pain, soreness or discomfort in or around the treated eye?</p>","preferredWording":"Did you feel any pain, soreness or discomfort in or around the treated eye?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T14:54:39.93","updateDate":"2016-06-28T15:31:51.98"},{"rank":null,"id":378,"code":"Q309","type":"question","description":"itching treated eye","direction":"negative","underlyingIssue":"feeling itchiness in the treated eye","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had itching in the treated eye?</p>","preferredWording":"Did you have any itching in your treated eye?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T14:55:57.527","updateDate":"2016-06-28T15:32:02.027"},{"rank":null,"id":379,"code":"Q310","type":"question","description":"problem watering treated eye","direction":"negative","underlyingIssue":"experiencing problems with watering in the treated eye","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with watering in the treated eye?</p>","preferredWording":"Did watering in the treated eye trouble you?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T14:57:11.287","updateDate":"2016-06-09T14:10:49.943"},{"rank":null,"id":380,"code":"Q311","type":"question","description":"tingling fingers hands","direction":"negative","underlyingIssue":"experiencing tingling in fingers or hands","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had tingling in your fingers or hands?</p>","preferredWording":"Did you have tingling fingers or hands?","recommendedWording":null,"questionnaires":[22,1000142],"categories":[],"createDate":"2016-03-01T14:58:28.23","updateDate":"2017-03-09T16:54:03.713"},{"rank":null,"id":381,"code":"Q312","type":"question","description":"problem discharge treated eye","direction":"negative","underlyingIssue":"experiencing problems with discharge from the treated eye","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with discharge from your treated eye?</p>","preferredWording":"Were you troubled by any discharge from your treated eye?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T14:58:52.177","updateDate":"2016-06-09T14:13:41.33"},{"rank":null,"id":382,"code":"Q313","type":"question","description":"dryness treated eye","direction":"negative","underlyingIssue":"having dryness in the treated eye","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had dryness in your treated eye?</p>","preferredWording":"Did you suffer from dryness in your treated eye?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T14:59:31.317","updateDate":"2016-06-09T14:14:25.183"},{"rank":null,"id":383,"code":"Q314","type":"question","description":"tingling toes feet","direction":"negative","underlyingIssue":"experiencing tingling in toes or feet","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had tingling in your toes or feet?</p>","preferredWording":"Did you have tingling toes or feet?","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2016-03-01T15:00:08.213","updateDate":"2016-06-09T14:14:59.77"},{"rank":null,"id":384,"code":"Q315","type":"question","description":"problem defects side vision","direction":"negative","underlyingIssue":"experiencing problems with defects in the side vision","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with any defects in your side vision?</p>","preferredWording":"Were you troubled by any defects in your side vision?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T15:00:09.6","updateDate":"2016-06-09T14:16:15.18"},{"rank":null,"id":385,"code":"Q316","type":"question","description":"problem double vision straight","direction":"negative","underlyingIssue":"experiencing problems with double vision when looking straight ahead","additionalInfo":"<p><u>Recommended wording</u>:</p><p>Have you had problems with double vision when looking straight ahead?</p>","preferredWording":"Were you troubled by double vision when looking straight ahead?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T15:00:58.15","updateDate":"2016-06-10T09:54:51.13"},{"rank":null,"id":386,"code":"Q317","type":"question","description":"numb fingers/hands","direction":"negative","underlyingIssue":"experiencing numbness in fingers or hands","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had numbness in your fingers or hands?</p>","preferredWording":"Did you have numbness in your fingers or hands?","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2016-03-01T15:01:10.88","updateDate":"2016-06-09T14:18:30.11"},{"rank":null,"id":387,"code":"Q318","type":"question","description":"numb toes/feet","direction":"negative","underlyingIssue":"experiencing numbness in toes or feet","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had numbness in your toes or feet?</p>","preferredWording":"Did you have numbness in your toes or feet?","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2016-03-01T15:03:29.553","updateDate":"2016-06-09T14:19:26.083"},{"rank":null,"id":388,"code":"Q319","type":"question","description":"problem double vision sideways","direction":"negative","underlyingIssue":"experiencing problems with double vision when looking sideways","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with double vision when looking sideways?</p>","preferredWording":"Were you troubled by double vision when looking side-ways?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T15:05:11.66","updateDate":"2016-06-09T14:25:49.06"},{"rank":null,"id":389,"code":"Q320","type":"question","description":"shooting/burning pain fingers/hands","direction":"negative","underlyingIssue":"having shooting or burning pain in fingers or hands","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had shooting or burning pain in your fingers or hands?</p>","preferredWording":"Did you have shooting or burning pain in your fingers or hands?","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2016-03-01T15:05:51.893","updateDate":"2016-06-09T14:36:56.467"},{"rank":null,"id":390,"code":"Q321","type":"question","description":"shooting/burning pain toes/feet","direction":"negative","underlyingIssue":"having shooting or burning pain in toes or feet","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had shooting or burning pain in your toes or feet?</p>","preferredWording":"Did you have shooting or burning pain in your toes or feet?","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2016-03-01T15:06:46.123","updateDate":"2016-06-09T14:38:41.503"},{"rank":null,"id":391,"code":"Q322","type":"question","description":"worry tumor other areas","direction":"negative","underlyingIssue":"worrying about possible recurrence in other areas of the body","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you worried about a tumor recurring in other parts of the body?</p>","preferredWording":"Were you worried about a tumour recurring in other areas of the body?","recommendedWording":null,"questionnaires":[21,42],"categories":[],"createDate":"2016-03-01T15:07:00.91","updateDate":"2016-06-10T09:27:14.373"},{"rank":null,"id":392,"code":"Q323","type":"question","description":"cramps hands","direction":"negative","underlyingIssue":"having cramps in hands","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had cramps in your hands?</p>","preferredWording":"Did you have cramps in your hands?","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2016-03-01T15:07:15.543","updateDate":"2016-06-10T09:42:37.78"},{"rank":null,"id":393,"code":"Q324","type":"question","description":"cramps feet","direction":"negative","underlyingIssue":"having cramps in feet","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had cramps in your feet?</p>","preferredWording":"Did you have cramps in your feet?","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2016-03-01T15:07:41.457","updateDate":"2016-06-10T09:42:28.36"},{"rank":null,"id":394,"code":"CS19","type":"condition","description":"if you drive a car","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please answer the following question only if you drive a car","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2016-03-01T15:09:01.847","updateDate":"2016-03-01T15:09:01.847"},{"rank":null,"id":395,"code":"CS20","type":"condition","description":"if you are a man","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please answer the following question only if you are a man","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2016-03-01T15:09:35.95","updateDate":"2016-03-01T15:09:35.95"},{"rank":null,"id":396,"code":"Q325","type":"question","description":"worry lose eye","direction":"negative","underlyingIssue":"worrying about losing the eye","additionalInfo":"","preferredWording":"Were you worried about losing the eye?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T15:10:44.577","updateDate":"2016-06-10T09:43:08.45"},{"rank":null,"id":397,"code":"Q326","type":"question","description":"problem standing walking feeling ground","direction":"negative","underlyingIssue":"experiencing problems standing or walking because of difficulty feeling the ground under the feet","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems standing or walking because of difficulty feeling the ground under your feet?</p>","preferredWording":"Did you have problems standing or walking because of difficulty feeling the ground under your feet?\\n","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2016-03-01T15:12:09.663","updateDate":"2016-06-03T14:53:57.57"},{"rank":null,"id":398,"code":"Q327","type":"question","description":"dissatisfied cosmetic surgery","direction":"negative","underlyingIssue":"being dissatisfied with the cosmetic result of the surgery","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been dissatisfied with the cosmetic result of the surgery?</p>","preferredWording":"Were you dissatisfied with the cosmetic result of the surgery?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T15:13:48.803","updateDate":"2016-06-10T09:46:11.023"},{"rank":null,"id":399,"code":"Q328","type":"question","description":"problem distinguish hot cold water","direction":"negative","underlyingIssue":"experiencing problems distinguishing between hot and cold water","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems distinguishing between hot and cold water?</p>","preferredWording":"Did you have difficulty distinguishing between hot and cold water? \\n","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2016-03-01T15:14:07.417","updateDate":"2016-06-10T09:47:10.54"},{"rank":null,"id":400,"code":"Q329","type":"question","description":"problem pouring","direction":"negative","underlyingIssue":"experiencing problems pouring liquids","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems pouring (e.g., tea or coffee)?</p>","preferredWording":"Did you have difficulty pouring (e.g., tea or coffee)?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T15:15:33.83","updateDate":"2016-06-03T14:45:13.833"},{"rank":null,"id":401,"code":"Q330","type":"question","description":"problem walk crowd","direction":"negative","underlyingIssue":"experiencing problems walking in crowded areas","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems walking in crowded areas?</p>","preferredWording":"Did you have difficulty seeing to walk in crowded areas?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T15:18:44.64","updateDate":"2016-06-10T09:54:22.113"},{"rank":null,"id":402,"code":"Q331","type":"question","description":"problem hold pen","direction":"negative","underlyingIssue":"experiencing problems holding a pen, making writing difficult","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems holding a pen, which made writing difficult?</p>","preferredWording":"Did you have a problem holding a pen, which made writing difficult?\\n","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2016-03-01T15:21:15.857","updateDate":"2016-06-10T09:53:26.607"},{"rank":null,"id":403,"code":"Q332","type":"question","description":"problem small objects fingers","direction":"negative","underlyingIssue":"experiencing problems manipulating small objects with fingers","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems manipulating small objects with your fingers (e.g., fastening small buttons)?</p>","preferredWording":"Did you have difficulty manipulating small objects with your fingers (for example, fastening small buttons)?\\n","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2016-03-01T15:22:40.613","updateDate":"2016-06-10T09:58:45.853"},{"rank":null,"id":404,"code":"Q333","type":"question","description":"problem steps pavements","direction":"negative","underlyingIssue":"experiencing problems with steps or pavements","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with steps or pavements?</p>","preferredWording":"Did you have any difficulty with steps or pavements?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T15:23:33.67","updateDate":"2016-06-03T14:32:23.29"},{"rank":null,"id":405,"code":"Q334","type":"question","description":"problem open weak hands","direction":"negative","underlyingIssue":"experiencing problems opening a jar/bottle due to weakness in hands","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems with opening a jar or bottle because of weakness in your hands?</p>","preferredWording":"Did you have difficulty opening a jar or bottle because of weakness in your hands? \\n","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2016-03-01T15:23:52.453","updateDate":"2016-06-10T10:00:15.027"},{"rank":null,"id":406,"code":"Q335","type":"question","description":"problem walk feet drop","direction":"negative","underlyingIssue":"experiencing problems walking due to feet dropping downwards","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems walking because of your feet dropping downwards?</p>","preferredWording":"Did you have difficulty walking because your feet dropped downwards?\\n","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2016-03-01T15:25:00.88","updateDate":"2016-06-10T10:03:06.087"},{"rank":null,"id":407,"code":"Q336","type":"question","description":"problem walking downstairs uneven ground","direction":"negative","underlyingIssue":"experiencing problems walking down the stairs or on uneven ground","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems walking down the stairs or on uneven ground?</p>","preferredWording":"Did you have any difficulty walking downstairs or on uneven ground?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T15:26:48.087","updateDate":"2016-06-10T10:03:37.647"},{"rank":null,"id":408,"code":"Q337","type":"question","description":"problem stairs chair weak legs","direction":"negative","underlyingIssue":"experiencing problems climbing stairs/getting up out of a chair due to weakness in legs","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems climbing stairs or getting up out of a chair because of weakness in your legs?</p>","preferredWording":"Did you have difficulty climbing stairs or getting up out of a chair because of weakness in your legs?\\n","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2016-03-01T15:27:32.44","updateDate":"2016-06-10T10:04:43.043"},{"rank":null,"id":409,"code":"Q338","type":"question","description":"dizzy stan up sitting lying position","direction":"negative","underlyingIssue":"feeling dizzy when standing up from a sitting or lying position","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been dizzy when standing up from a sitting or lying position?</p>","preferredWording":"Were you dizzy when standing up from a sitting or lying position? \\n","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2016-03-01T15:28:50.567","updateDate":"2016-06-10T12:00:44.933"},{"rank":null,"id":410,"code":"Q339","type":"question","description":"problem judge distance","direction":"negative","underlyingIssue":"experiencing problems judging distance","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems judging distance?</p>","preferredWording":"Did you have difficulty judging distances?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T15:29:32.673","updateDate":"2016-06-10T12:38:25.743"},{"rank":null,"id":411,"code":"Q340","type":"question","description":"problem use pedals","direction":"negative","underlyingIssue":"experiencing problems using the pedals","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems using the pedals?</p>","preferredWording":"Did you have difficulty using the pedals?","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2016-03-01T15:30:21.86","updateDate":"2016-06-10T12:39:41.653"},{"rank":null,"id":412,"code":"Q341","type":"question","description":"activities limited vision","direction":"negative","underlyingIssue":"vision limiting one\'s activities","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have your activities been limited because of your vision?</p>","preferredWording":"Were your activities limited in any way because of your vision?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T15:30:34.137","updateDate":"2016-06-10T13:48:51.73"},{"rank":null,"id":413,"code":"CS21","type":"condition","description":"if applicable","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"If applicable:","recommendedWording":null,"questionnaires":[21,24,31,33,41],"categories":[],"createDate":"2016-03-01T15:31:24.14","updateDate":"2016-03-01T15:31:24.14"},{"rank":null,"id":414,"code":"Q342","type":"question","description":"distorted treated eye","direction":"negative","underlyingIssue":"things appearing distorted out of the treated eye","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have things appeared distorted out of the treated eye?</p>","preferredWording":"Did things appear distorted out of your treated eye?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T15:32:17.133","updateDate":"2016-06-10T14:14:02.17"},{"rank":null,"id":415,"code":"Q343","type":"question","description":"flash balls light treated eye","direction":"negative","underlyingIssue":"seeing flashes/balls of light with the treated eye","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you seen flashes or balls of light with the treated eye?</p>","preferredWording":"Did you see flashes or balls of light with your treated eye?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T15:32:59.507","updateDate":"2016-06-10T14:14:12.373"},{"rank":null,"id":416,"code":"Q344","type":"question","description":"floaters treated eye","direction":"negative","underlyingIssue":"seeing floaters with the treated eye","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you seen floaters with the treated eye?</p>","preferredWording":"Did you see floaters with your treated eye?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T15:33:31.283","updateDate":"2016-06-10T14:13:40.05"},{"rank":null,"id":417,"code":"Q345","type":"question","description":"bright light uncomfortable","direction":"negative","underlyingIssue":"treated eye feeling uncomfortable in bright light","additionalInfo":"<p><u>Recommended wording:</u></p><p>Has you eye felt uncomfortable in bright light?</p>","preferredWording":"Did your eye feel uncomfortable in bright light?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T15:34:16.493","updateDate":"2016-06-10T14:21:45.85"},{"rank":null,"id":418,"code":"Q346","type":"question","description":"vision interfere treated eye","direction":"negative","underlyingIssue":"vision of the treated eye interfering with the other eye","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has the vision of the treated eye interfered with the other eye?</p>","preferredWording":"Did the vision of the treated eye interfere with the other eye?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T15:35:04.683","updateDate":"2016-06-10T14:22:26.94"},{"rank":null,"id":419,"code":"Q347","type":"question","description":"worry tumor recur treated eye","direction":"negative","underlyingIssue":"worrying about tumour recurring in the treated eye","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about tumor recurring in the treated eye?</p>","preferredWording":"Were you worried about the tumour recurring in the treated eye?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T15:36:36.43","updateDate":"2016-06-10T14:23:54.663"},{"rank":null,"id":420,"code":"Q348","type":"question","description":"problem driving daylight","direction":"negative","underlyingIssue":"experiencing problems driving in daylight because of the vision impairment","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems driving in daylight because of your vision?</p>","preferredWording":"Did you have difficulty driving in daylight because of your vision?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T15:37:22.687","updateDate":"2016-06-10T14:14:50.627"},{"rank":null,"id":421,"code":"Q349","type":"question","description":"problem driving dark ","direction":"negative","underlyingIssue":"experiencing problems driving in the dark because of the vision impairment","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems driving in the dark because of your vision?</p>","preferredWording":"Did you have difficulty driving in the dark because of your vision?","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2016-03-01T15:38:00.143","updateDate":"2016-06-10T14:14:57.647"},{"rank":null,"id":422,"code":"Q350","type":"question","description":"bruising","direction":"negative","underlyingIssue":"bruising","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you bruised?</p>","preferredWording":"Did you bruise?","recommendedWording":null,"questionnaires":[23],"categories":[],"createDate":"2016-03-01T15:38:46.773","updateDate":"2016-06-10T14:27:20.497"},{"rank":null,"id":423,"code":"Q351","type":"question","description":"temperature go up down","direction":"negative","underlyingIssue":"temperature going up and down","additionalInfo":"","preferredWording":"Has your temperature been going up and down?","recommendedWording":null,"questionnaires":[23],"categories":[],"createDate":"2016-03-01T15:40:45.12","updateDate":"2016-06-10T14:27:58.013"},{"rank":null,"id":424,"code":"Q352","type":"question","description":"lethargic","direction":"negative","underlyingIssue":"feeling lethargic","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt lethargic?</p>","preferredWording":"Did you feel lethargic?","recommendedWording":null,"questionnaires":[23],"categories":[],"createDate":"2016-03-01T15:53:23.2","updateDate":"2016-06-10T14:28:41.493"},{"rank":null,"id":425,"code":"Q353","type":"question","description":"problem chest infections","direction":"negative","underlyingIssue":"experiencing problems with chest infections","additionalInfo":"","preferredWording":"Have you had trouble with chest infections?","recommendedWording":null,"questionnaires":[23],"categories":[],"createDate":"2016-03-01T15:55:13.327","updateDate":"2016-06-10T14:36:16.56"},{"rank":null,"id":426,"code":"Q354","type":"question","description":"problem other infections","direction":"negative","underlyingIssue":"experiencing problems with other infections","additionalInfo":"","preferredWording":"Have you had trouble with other infections?\\n","recommendedWording":null,"questionnaires":[23],"categories":[],"createDate":"2016-03-01T15:57:14.603","updateDate":"2016-06-10T14:36:07.73"},{"rank":null,"id":427,"code":"Q355","type":"question","description":"need antibiotics courses","direction":"negative","underlyingIssue":"needing repeated courses of antibiotics","additionalInfo":"","preferredWording":"Have you needed repeated courses of antibiotics?","recommendedWording":null,"questionnaires":[23],"categories":[],"createDate":"2016-03-01T15:58:06.367","updateDate":"2016-06-10T14:37:23.017"},{"rank":null,"id":428,"code":"Q356","type":"question","description":"worry get infection ","direction":"negative","underlyingIssue":"worrying about getting an infection","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about getting an infection?</p>","preferredWording":"Have you worried about picking up an infection?","recommendedWording":null,"questionnaires":[23,26,31,33,41],"categories":[],"createDate":"2016-03-01T15:58:45.26","updateDate":"2016-06-10T14:38:36.277"},{"rank":null,"id":429,"code":"Q357","type":"question","description":" muscle weakness","direction":"negative","underlyingIssue":"having muscle weakness","additionalInfo":"","preferredWording":"Have you had muscle weakness?","recommendedWording":null,"questionnaires":[24,31,33,41],"categories":[],"createDate":"2016-03-02T10:19:42.077","updateDate":"2016-06-09T11:50:45.873"},{"rank":null,"id":430,"code":"Q358","type":"question","description":"aches pain bones","direction":"negative","underlyingIssue":"having aches or pain in the bones","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had aches or pain in your bones?</p>","preferredWording":"Have you had aches or pain in your bones?","recommendedWording":null,"questionnaires":[24,31,35,41,45],"categories":[],"createDate":"2016-03-02T10:21:00.423","updateDate":"2016-06-10T14:50:44.073"},{"rank":null,"id":431,"code":"Q359","type":"question","description":" short breath exertion","direction":"negative","underlyingIssue":"having shortness of breath on exertion","additionalInfo":"","preferredWording":"Have you had shortness of breath on exertion?","recommendedWording":null,"questionnaires":[24,31,33,41,1000244,1000283],"categories":[],"createDate":"2016-03-02T10:26:29.097","updateDate":"2016-06-10T14:52:17.49"},{"rank":null,"id":432,"code":"Q360","type":"question","description":"drowsy","direction":"negative","underlyingIssue":"feeling drowsy","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt drowsy?</p>","preferredWording":"Have you felt drowsy?","recommendedWording":"Did you feel drowsy?","questionnaires":[24,26,1000175,1000272,31,33,35,41],"categories":[],"createDate":"2016-03-02T10:31:30.53","updateDate":"2016-06-10T14:53:19.563"},{"rank":null,"id":433,"code":"Q361","type":"question","description":"sudden tiredness","direction":"negative","underlyingIssue":"having sudden tiredness","additionalInfo":"","preferredWording":"Have you had sudden tiredness?","recommendedWording":null,"questionnaires":[24,31,33,41],"categories":[],"createDate":"2016-03-02T10:33:42.62","updateDate":"2016-06-10T14:54:02.853"},{"rank":null,"id":434,"code":"Q362","type":"question","description":"pain gums","direction":"negative","underlyingIssue":"having pain in gums","additionalInfo":"","preferredWording":"Have you had pain in your gums?","recommendedWording":null,"questionnaires":[25],"categories":[],"createDate":"2016-03-02T10:43:56.397","updateDate":"2016-06-10T14:54:17.533"},{"rank":null,"id":435,"code":"Q363","type":"question","description":"problem bleeding gums","direction":"negative","underlyingIssue":"experiencing problems with bleeding gums","additionalInfo":"","preferredWording":"Have you had problems with bleeding gums?","recommendedWording":null,"questionnaires":[25],"categories":[],"createDate":"2016-03-02T10:44:38.69","updateDate":"2016-06-10T14:55:17.66"},{"rank":null,"id":436,"code":"Q364","type":"question","description":"lip sores","direction":"negative","underlyingIssue":"having lip sores","additionalInfo":"","preferredWording":"Have you had lip sores?","recommendedWording":null,"questionnaires":[25],"categories":[],"createDate":"2016-03-02T10:45:11.917","updateDate":"2016-06-10T14:57:34.663"},{"rank":null,"id":437,"code":"Q365","type":"question","description":"sores corners mouth","direction":"negative","underlyingIssue":"having sores in the corners of the mouth","additionalInfo":"","preferredWording":"Have you had sores in the corners of your mouth?","recommendedWording":null,"questionnaires":[25],"categories":[],"createDate":"2016-03-02T10:48:52.027","updateDate":"2016-06-10T14:57:25.567"},{"rank":null,"id":438,"code":"Q366","type":"question","description":"worry recurrence disease","direction":"negative","underlyingIssue":"worrying about recurrence of the disease","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about recurrence of your disease?</p>","preferredWording":"Have you worried about recurrence of your disease?","recommendedWording":null,"questionnaires":[11,24,31,33,41],"categories":[],"createDate":"2016-03-02T10:49:57.177","updateDate":"2016-06-10T14:58:20.263"},{"rank":null,"id":439,"code":"Q367","type":"question","description":"mouth sensitive food drink","direction":"negative","underlyingIssue":"mouth being sensitive to food and drink","additionalInfo":"","preferredWording":"Has your mouth been sensitive to food and drink?","recommendedWording":null,"questionnaires":[25],"categories":[],"createDate":"2016-03-02T11:03:35.973","updateDate":"2016-06-10T15:01:42.99"},{"rank":null,"id":440,"code":"TS5","type":"timeScale","description":"course current illness treatment","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"In the course of your current illness or its treatment,\\nnot only the past week:","recommendedWording":null,"questionnaires":[25,1000277],"categories":[],"createDate":"2016-03-02T11:04:56.533","updateDate":"2016-03-02T11:04:56.533"},{"rank":null,"id":441,"code":"Q368","type":"question","description":"worry another type cancer","direction":"negative","underlyingIssue":"worrying about getting another type of cancer","additionalInfo":"","preferredWording":"Have you worried about getting another type of cancer?","recommendedWording":null,"questionnaires":[24,31,33,41],"categories":[],"createDate":"2016-03-02T11:05:23.35","updateDate":"2016-06-10T15:02:23.083"},{"rank":null,"id":442,"code":"Q369","type":"question","description":"information dental mouth problems","direction":"none","underlyingIssue":"receiving information about possible dental or mouth problems","additionalInfo":"","preferredWording":"Have you received any information about possible dental or mouth problems?","recommendedWording":null,"questionnaires":[25],"categories":[],"createDate":"2016-03-02T11:11:17.517","updateDate":"2016-06-10T15:05:26.017"},{"rank":null,"id":443,"code":"Q370","type":"question","description":"worry treatment future health problem","direction":"negative","underlyingIssue":"worrying about the treatment causing future health problems","additionalInfo":"","preferredWording":"Have you worried about your treatment causing future health problems?\\n","recommendedWording":null,"questionnaires":[24,31,33,41],"categories":[],"createDate":"2016-03-02T11:20:04.567","updateDate":"2016-06-10T15:06:13.91"},{"rank":null,"id":444,"code":"Q371","type":"question","description":"problem work/study","direction":"negative","underlyingIssue":"experiencing problems at work or place of study due to the disease","additionalInfo":"","preferredWording":"Have you had problems at your work or place of study due to the disease?\\n","recommendedWording":null,"questionnaires":[24,31,33,41],"categories":[],"createDate":"2016-03-02T11:21:57.703","updateDate":"2016-06-10T15:06:58.683"},{"rank":null,"id":445,"code":"Q372","type":"question","description":"worry continue work education","direction":"negative","underlyingIssue":"worrying about not being able to continue working or education","additionalInfo":"","preferredWording":"Have you worried about not being able\\tto continue working or your education?\\n","recommendedWording":null,"questionnaires":[24,31,33,41],"categories":[],"createDate":"2016-03-02T11:23:40.34","updateDate":"2016-06-10T15:08:13.207"},{"rank":null,"id":446,"code":"CS22","type":"condition","description":"only if received information","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer question 45 only if you have received information:","recommendedWording":null,"questionnaires":[25],"categories":[],"createDate":"2016-03-02T11:27:50.4","updateDate":"2016-03-02T11:27:50.4"},{"rank":null,"id":447,"code":"Q373","type":"question","description":"satisfied amount information dental mouth problems","direction":"positive","underlyingIssue":"being satisfied with the amount of information about possible dental or mouth problems","additionalInfo":"","preferredWording":"Have you been satisfied with the amount of information you received about possible dental or mouth problems?","recommendedWording":null,"questionnaires":[25],"categories":[],"createDate":"2016-03-02T11:28:39.497","updateDate":"2016-06-10T15:08:56.03"},{"rank":null,"id":448,"code":"Q374","type":"question","description":"dentures","direction":"none","underlyingIssue":"wearing dentures","additionalInfo":null,"preferredWording":"Have you worn dentures?","recommendedWording":null,"questionnaires":[25],"categories":[],"createDate":"2016-03-02T11:29:12.757","updateDate":"2016-03-02T11:29:12.757"},{"rank":null,"id":449,"code":"CS23","type":"condition","description":"only if used dentures","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer question 43 only if you used dentures:","recommendedWording":null,"questionnaires":[25],"categories":[],"createDate":"2016-03-02T11:29:28.373","updateDate":"2016-03-02T11:29:28.373"},{"rank":null,"id":450,"code":"Q375","type":"question","description":"problem ill fitting dentures","direction":"negative","underlyingIssue":"experiencing problems with ill fitting dentures","additionalInfo":"","preferredWording":"Have you had problems with an ill fitting denture?","recommendedWording":null,"questionnaires":[25],"categories":[],"createDate":"2016-03-02T11:29:56.923","updateDate":"2016-06-03T14:47:52.87"},{"rank":null,"id":451,"code":"Q376","type":"question","description":"abdominal pain cramps","direction":"negative","underlyingIssue":"having abdominal pains or cramps","additionalInfo":"","preferredWording":"Have you had abdominal pains or cramps?","recommendedWording":null,"questionnaires":[45,26],"categories":[],"createDate":"2016-03-02T11:44:14.533","updateDate":"2016-06-10T15:12:10.693"},{"rank":null,"id":452,"code":"Q377","type":"question","description":"worry changes weight","direction":"negative","underlyingIssue":"worrying about changes in one\'s weight","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about changes in your weight?</p>","preferredWording":"Have you been concerned about changes in your weight?","recommendedWording":null,"questionnaires":[26],"categories":[],"createDate":"2016-03-02T11:52:07.28","updateDate":"2016-06-28T15:01:01.173"},{"rank":null,"id":453,"code":"Q378","type":"question","description":"sweat excessively","direction":"negative","underlyingIssue":"sweating excessively","additionalInfo":"","preferredWording":"Have you sweated excessively?","recommendedWording":"Have you sweated excessively?","questionnaires":[26],"categories":[],"createDate":"2016-03-02T12:34:49.63","updateDate":"2016-06-24T11:35:07.353"},{"rank":null,"id":454,"code":"Q379","type":"question","description":"swelling certain body parts","direction":"negative","underlyingIssue":"having swelling in certain body parts","additionalInfo":"","preferredWording":"Have you experienced any swelling in certain parts of your body (e.g. ankles, legs or around your eyes)?\\n","recommendedWording":"Have you experienced any swelling in certain parts of your body (e.g. ankles, legs or around your eyes)?","questionnaires":[26],"categories":[],"createDate":"2016-03-02T12:40:36.183","updateDate":"2016-06-10T15:21:13.293"},{"rank":null,"id":455,"code":"Q380","type":"question","description":"problem eyes","direction":"negative","underlyingIssue":"experiencing problems with one\'s eyes","additionalInfo":"","preferredWording":"Have you had problems with your eyes \\t(e.g. burning, watery, irritated or dry)?\\n","recommendedWording":null,"questionnaires":[26],"categories":[],"createDate":"2016-03-02T12:41:59.583","updateDate":"2016-06-10T15:22:35.383"},{"rank":null,"id":456,"code":"Q381","type":"question","description":"muscle cramps","direction":"negative","underlyingIssue":"having muscle cramps","additionalInfo":"","preferredWording":"Have you had muscle cramps?","recommendedWording":null,"questionnaires":[26],"categories":[],"createDate":"2016-03-02T12:44:18.973","updateDate":"2016-06-10T15:23:11.873"},{"rank":null,"id":457,"code":"Q382","type":"question","description":"mood changes","direction":"negative","underlyingIssue":"having mood changes","additionalInfo":"","preferredWording":"Have you had mood changes?","recommendedWording":null,"questionnaires":[26,31,41],"categories":[],"createDate":"2016-03-02T12:46:44.28","updateDate":"2016-08-17T14:49:15.193"},{"rank":null,"id":458,"code":"Q383","type":"question","description":"problem carry usual activities tired","direction":"negative","underlyingIssue":"experiencing problems carrying on with usual activities because of getting tired easily","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems carrying on with you usual activities because of getting tired easily?</p>","preferredWording":"Have you had any difficulties carrying on with your usual activities because of getting tired easily?\\n","recommendedWording":null,"questionnaires":[26],"categories":[],"createDate":"2016-03-02T12:50:42.173","updateDate":"2016-06-10T15:57:27.817"},{"rank":null,"id":460,"code":"Q384","type":"question","description":"pain eat","direction":"negative","underlyingIssue":"experiencing pain when eating","additionalInfo":null,"preferredWording":"Have you had pain when you eat?","recommendedWording":null,"questionnaires":[27,29],"categories":[],"createDate":"2016-03-02T13:06:22.7","updateDate":"2016-03-02T13:06:22.7"},{"rank":null,"id":461,"code":"Q385","type":"question","description":"problem swallow saliva","direction":"negative","underlyingIssue":"experiencing problems swallowing saliva","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems swallowing your saliva?</p>","preferredWording":"Have you had trouble with swallowing your saliva?","recommendedWording":null,"questionnaires":[27,29],"categories":[],"createDate":"2016-03-02T13:11:01.95","updateDate":"2016-06-10T15:58:58.657"},{"rank":null,"id":462,"code":"Q386","type":"question","description":"need social support therapy disease","direction":"negative","underlyingIssue":"needing social support to undergo therapy to cope with the disease?","additionalInfo":"","preferredWording":"Have you needed social support (e.g. family, friends, or relatives) to undergo therapy or to cope with the disease?\\n","recommendedWording":null,"questionnaires":[26],"categories":[],"createDate":"2016-03-02T13:11:47.99","updateDate":"2016-06-10T16:08:51.773"},{"rank":null,"id":463,"code":"Q387","type":"question","description":"problem talking","direction":"negative","underlyingIssue":"experiencing problems talking","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems talking?</p>","preferredWording":"Have you had trouble with talking?","recommendedWording":null,"questionnaires":[27,29],"categories":[],"createDate":"2016-03-02T13:12:16.727","updateDate":"2016-06-10T16:09:29.887"},{"rank":null,"id":464,"code":"Q388","type":"question","description":"satisfied received care","direction":"positive","underlyingIssue":"being satisfied with received care","additionalInfo":"","preferredWording":"Have you felt satisfied with the care you have received?","recommendedWording":null,"questionnaires":[26],"categories":[],"createDate":"2016-03-02T13:13:37.35","updateDate":"2016-06-10T16:34:08.377"},{"rank":null,"id":465,"code":"Q389","type":"question","description":"satisfied received information","direction":"positive","underlyingIssue":"being satisfied with received information","additionalInfo":"","preferredWording":"Have you felt satisfied with the information you have received (e.g. about the disease and its treatment)?\\n","recommendedWording":null,"questionnaires":[26],"categories":[],"createDate":"2016-03-02T13:15:49.22","updateDate":"2016-06-10T16:34:30.823"},{"rank":null,"id":466,"code":"Q390","type":"question","description":"satisfied quality social life","direction":"positive","underlyingIssue":"being satisfied with quality of social life","additionalInfo":"","preferredWording":"Have you felt satisfied with the quality of your social life\\t(including family and/ or friends)?\\n","recommendedWording":null,"questionnaires":[26],"categories":[],"createDate":"2016-03-02T13:17:24.183","updateDate":"2016-06-10T16:35:27.953"},{"rank":null,"id":467,"code":"IN18","type":"instructions","description":"communication with professionals","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"We are interested in the communication you have had with the professional(s) who treat you.","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T13:20:54.667","updateDate":"2016-03-02T13:20:54.667"},{"rank":null,"id":468,"code":"IN19","type":"instructions","description":"categories professionals","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Please indicate among the following categories of professional(s) the one that is evaluated:","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T13:21:50.78","updateDate":"2017-03-10T17:00:46.07"},{"rank":null,"id":470,"code":"IN20","type":"instructions","description":"communication these professionals","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please think about your communication with these professionals as you answer the questions.","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T13:37:58.11","updateDate":"2016-03-02T13:37:58.11"},{"rank":null,"id":471,"code":"IN21","type":"instructions","description":"periods of time","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please indicate among the following periods the one you are evaluating.","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T13:39:24.54","updateDate":"2016-03-02T13:39:24.54"},{"rank":null,"id":473,"code":"IN22","type":"instructions","description":"experiences these periods","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please think about your experiences during these periods as you answer the questions.","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T13:42:27.8","updateDate":"2016-03-02T13:42:27.8"},{"rank":null,"id":474,"code":"Q391","type":"question","description":"eat solid food","direction":"positive","underlyingIssue":"being able to eat solid food","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been able to eat solid food?</p>","preferredWording":"Could you eat solid food?","recommendedWording":null,"questionnaires":[29],"categories":[],"createDate":"2016-03-02T13:46:02.057","updateDate":"2016-06-28T15:29:04.193"},{"rank":null,"id":475,"code":"Q392","type":"question","description":"opportunities talk professionals","direction":"positive","underlyingIssue":"feeling that one has had enough opportunities to talk with HCPs","additionalInfo":"","preferredWording":"Have you had enough opportunities to talk with your professional(s)?","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T13:46:41.95","updateDate":"2016-06-10T16:36:46.223"},{"rank":null,"id":476,"code":"Q393","type":"question","description":"eat liquidised soft food","direction":"positive","underlyingIssue":"being able to eat liquidised or soft food","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been able to eat liquidised or soft food?</p>","preferredWording":"Could you eat liquidised or soft food?","recommendedWording":null,"questionnaires":[29],"categories":[],"createDate":"2016-03-02T13:46:59.547","updateDate":"2016-06-28T15:29:27.277"},{"rank":null,"id":477,"code":"Q394","type":"question","description":"drink liquids","direction":"positive","underlyingIssue":"being able to drink liquids","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been able to drink liquids?</p>","preferredWording":"Could you drink liquids?","recommendedWording":null,"questionnaires":[29],"categories":[],"createDate":"2016-03-02T13:47:49.157","updateDate":"2016-06-28T15:29:46.46"},{"rank":null,"id":478,"code":"Q395","type":"question","description":"free ask questions","direction":"positive","underlyingIssue":"feeling free to ask questions","additionalInfo":"","preferredWording":"Have you felt free to ask questions?","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T13:47:57.627","updateDate":"2016-06-10T16:37:54.973"},{"rank":null,"id":479,"code":"Q396","type":"question","description":"opportunity express emotions","direction":"positive","underlyingIssue":"having opportunity to express emotions and worries","additionalInfo":"","preferredWording":"Have you had the opportunity to express your emotions?","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T13:53:46.27","updateDate":"2016-06-10T16:38:55.97"},{"rank":null,"id":480,"code":"Q397","type":"question","description":"problem coughing","direction":"negative","underlyingIssue":"experiencing problems with coughing","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems coughing?</p>","preferredWording":"Have you had problems with coughing?","recommendedWording":null,"questionnaires":[29,43],"categories":[],"createDate":"2016-03-02T13:54:29.67","updateDate":"2016-06-10T16:39:23.177"},{"rank":null,"id":481,"code":"Q398","type":"question","description":"pain chest","direction":"negative","underlyingIssue":"experiencing chest pain","additionalInfo":"","preferredWording":"Have you had pain in your chest?","recommendedWording":null,"questionnaires":[29,35,37,48],"categories":[],"createDate":"2016-03-02T13:55:54.52","updateDate":"2016-06-10T16:39:45.143"},{"rank":null,"id":482,"code":"Q399","type":"question","description":"pain stomach","direction":"negative","underlyingIssue":"experiencing stomach pain","additionalInfo":"","preferredWording":"Have you had pain in your stomach?","recommendedWording":null,"questionnaires":[29],"categories":[],"createDate":"2016-03-02T13:56:29.013","updateDate":"2016-06-14T12:58:13.45"},{"rank":null,"id":483,"code":"Q400","type":"question","description":"patient HCP understanding disease","direction":"positive","underlyingIssue":"sharing the understanding of the disease and treatment with the HCPs","additionalInfo":"","preferredWording":"Have you felt that you and your professional(s) had a shared understanding of your disease and treatment?\\n","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T13:57:38.22","updateDate":"2016-06-14T13:02:40.437"},{"rank":null,"id":484,"code":"Q401","type":"question","description":"patient HCP mutual trust ","direction":"positive","underlyingIssue":"having mutual trust with HCPs","additionalInfo":"","preferredWording":"Has there been mutual trust between you and your professional(s)?","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T13:58:49.153","updateDate":"2016-06-14T13:17:36.53"},{"rank":null,"id":485,"code":"Q402","type":"question","description":"fevers","direction":"negative","underlyingIssue":"having fevers","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had a fever?</p>","preferredWording":"Have you had fevers?","recommendedWording":null,"questionnaires":[30,44],"categories":[],"createDate":"2016-03-02T14:05:43.553","updateDate":"2017-02-16T14:18:25.567"},{"rank":null,"id":486,"code":"Q403","type":"question","description":"patient HCP time talk","direction":"positive","underlyingIssue":"getting enough time from the HCPs to talk","additionalInfo":"","preferredWording":"Have your professional(s) spent enough time talking with you?","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T14:06:47.843","updateDate":"2016-06-14T14:30:08.12"},{"rank":null,"id":487,"code":"Q404","type":"question","description":"patient HCP approach equal","direction":"positive","underlyingIssue":"being approached by HCPs as an equal","additionalInfo":"","preferredWording":"Have your professional(s) approached you as an equal?","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T14:10:07.78","updateDate":"2016-06-14T14:32:17.43"},{"rank":null,"id":488,"code":"Q405","type":"question","description":"HCP sincere","direction":"positive","underlyingIssue":"being treated by HCPs with sincerity","additionalInfo":"","preferredWording":"Have your professional(s) shown sincerity?","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T14:13:32.633","updateDate":"2016-06-14T14:34:58.417"},{"rank":null,"id":489,"code":"Q406","type":"question","description":"problem arrange bladder treatment","direction":"negative","underlyingIssue":"experiencing problems arranging repeated bladder treatment appointments in the daily life","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems arranging your life around the repeated bladder treatment appointments (cystoscopies or instillations)?</p><p><br /></p>","preferredWording":"Did you have trouble arranging your life around the repeated bladder treatment appointments (cystoscopies or instillations)?","recommendedWording":null,"questionnaires":[30,1000297],"categories":[],"createDate":"2016-03-02T14:19:42.88","updateDate":"2016-06-14T14:39:07.73"},{"rank":null,"id":490,"code":"Q407","type":"question","description":"worry repeated bladder treatment","direction":"negative","underlyingIssue":"worrying about having repeated bladder treatments","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you worried about having repeated bladder treatments (cystoscopies or instillations)?</p>","preferredWording":"Did you worry about having repeated bladder treatments (cystoscopies or instillations)?","recommendedWording":null,"questionnaires":[30],"categories":[],"createDate":"2016-03-02T14:20:54.69","updateDate":"2016-06-14T14:39:16.22"},{"rank":null,"id":491,"code":"Q408","type":"question","description":"patient HCP easy talk openly","direction":"positive","underlyingIssue":"HCPs making it easy to talk openly about any issues that are of concern","additionalInfo":"","preferredWording":"Have your professional(s) made it easy for you to talk openly about issues that concern you?\\n","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T14:23:31.57","updateDate":"2016-06-14T14:41:17.353"},{"rank":null,"id":492,"code":"Q409","type":"question","description":"patient HCP respect","direction":"positive","underlyingIssue":"being treated by the HCPs with respect","additionalInfo":"","preferredWording":"Have your professional(s) treated you with respect?","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T14:25:19.573","updateDate":"2016-06-14T14:41:54.743"},{"rank":null,"id":493,"code":"Q410","type":"question","description":"problem HCP seriously","direction":"positive","underlyingIssue":"HCPs taking problems seriously","additionalInfo":"","preferredWording":"Have your professional(s) taken your problems seriously?","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T14:29:00.26","updateDate":"2016-06-14T14:42:34.447"},{"rank":null,"id":494,"code":"Q411","type":"question","description":"patient HCP language","direction":"positive","underlyingIssue":"HCPs using a language that is easy to understand","additionalInfo":"","preferredWording":"Have your professional(s) used language that you understand (avoided medical jargon, used clear terms)?\\n","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T14:37:27.263","updateDate":"2016-06-14T14:43:38.72"},{"rank":null,"id":495,"code":"Q412","type":"question","description":"patient HCP answer openly","direction":"positive","underlyingIssue":"HCPs answering questions openly","additionalInfo":"","preferredWording":"Have your professional(s) answered your questions openly?","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T14:38:34.66","updateDate":"2016-06-14T14:52:05.233"},{"rank":null,"id":496,"code":"RS4","type":"responseScale","description":"4-point Likert scale + N/A","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"N/A, Not at all, A little, Quite a bit, Very much","recommendedWording":null,"questionnaires":[28,42,1000142,1000232],"categories":[],"createDate":"2016-03-02T14:40:28.043","updateDate":"2016-03-02T14:40:56.983"},{"rank":null,"id":497,"code":"Q413","type":"question","description":"dry cough","direction":"negative","underlyingIssue":"having a dry cough","additionalInfo":null,"preferredWording":"Have you had a dry cough?","recommendedWording":null,"questionnaires":[31,48],"categories":[],"createDate":"2016-03-02T14:41:38.37","updateDate":"2016-03-02T14:41:38.37"},{"rank":null,"id":498,"code":"Q414","type":"question","description":"patient HCP look conversation","direction":"positive","underlyingIssue":"HCPs making eye contact during the conversation","additionalInfo":"","preferredWording":"Have your professional(s) looked at you during conversation?","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T14:46:45.063","updateDate":"2016-06-14T14:56:38.84"},{"rank":null,"id":499,"code":"Q415","type":"question","description":"HCP calm voice","direction":"positive","underlyingIssue":"being spoken to by the HCPs with a calm voice","additionalInfo":"","preferredWording":"Have your professional(s) used a calm voice?","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T14:48:04.987","updateDate":"2016-06-14T14:57:25.987"},{"rank":null,"id":500,"code":"Q416","type":"question","description":"patient HCP understand situation","direction":"positive","underlyingIssue":"HCPs trying to understand the situation","additionalInfo":"","preferredWording":"Have your professional(s) tried to understand your current situation?\\n","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T14:53:47.667","updateDate":"2016-06-14T15:00:21.993"},{"rank":null,"id":501,"code":"Q417","type":"question","description":"lack confidence body","direction":"negative","underlyingIssue":"lacking confidence in one\'s body","additionalInfo":"","preferredWording":"Have you felt a lack of confidence in your body?","recommendedWording":null,"questionnaires":[31,33,41],"categories":[],"createDate":"2016-03-02T14:54:31.707","updateDate":"2016-06-14T15:00:56.283"},{"rank":null,"id":502,"code":"Q418","type":"question","description":"dissatisfied body function","direction":"negative","underlyingIssue":"feeling dissatisfied with how the body functions","additionalInfo":"","preferredWording":"Have you been dissatisfied with how your body functions?","recommendedWording":null,"questionnaires":[31,33,41],"categories":[],"createDate":"2016-03-02T14:58:46.247","updateDate":"2016-06-14T15:01:26.813"},{"rank":null,"id":503,"code":"Q419","type":"question","description":"patient HCP listen emotions","direction":"positive","underlyingIssue":"being listened to by the HCPs when expressing emotions","additionalInfo":"","preferredWording":"Have your professional(s) listened to you when you expressed your emotions?\\n","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T15:01:53.83","updateDate":"2016-06-14T15:08:03.63"},{"rank":null,"id":504,"code":"Q420","type":"question","description":"problem accept limitations","direction":"negative","underlyingIssue":"experiencing problems accepting limitations due to the disease","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems accepting limitations due to the disease?</p>","preferredWording":"Have you had difficulty accepting limitations due to the disease?","recommendedWording":null,"questionnaires":[31,33,41],"categories":[],"createDate":"2016-03-02T15:02:18.12","updateDate":"2016-06-28T15:16:26.98"},{"rank":null,"id":505,"code":"Q421","type":"question","description":"HCP help manage emotions","direction":"positive","underlyingIssue":"receiving help from the HCPs to manage emotions","additionalInfo":"","preferredWording":"Have your professional(s) helped you to manage your emotions: for example sadness, anger, fear, anxiety and others?\\n","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T15:03:32.707","updateDate":"2016-06-14T15:10:07.667"},{"rank":null,"id":506,"code":"Q422","type":"question","description":"worry chronically ill","direction":"negative","underlyingIssue":"worrying about becoming chronically ill","additionalInfo":null,"preferredWording":"Have you worried about becoming chronically ill?","recommendedWording":null,"questionnaires":[31,41],"categories":[],"createDate":"2016-03-02T15:04:51.66","updateDate":"2016-03-02T15:04:51.66"},{"rank":null,"id":507,"code":"Q423","type":"question","description":"HCP account preferences information","direction":"positive","underlyingIssue":"HCPs taking into account the preferences on how the information should be provided","additionalInfo":"","preferredWording":"Have your professional(s) taken into account how you prefer to receive information?\\n","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T15:06:26.31","updateDate":"2016-06-14T15:17:27.243"},{"rank":null,"id":508,"code":"Q424","type":"question","description":"patient HCP check information","direction":"positive","underlyingIssue":"HCPs checking what is already known about the illness before providing new information","additionalInfo":"","preferredWording":"Have your professional(s) checked what you already knew about your illness before giving you any new information?\\n","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T15:09:06.62","updateDate":"2016-06-14T15:20:51.22"},{"rank":null,"id":509,"code":"Q425","type":"question","description":"HCP check understand information","direction":"positive","underlyingIssue":"HCPs checking the understanding of the provided information","additionalInfo":"","preferredWording":"Have your professional(s) checked your understanding of information you have been given?","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T15:11:16.887","updateDate":"2016-06-14T15:25:05.477"},{"rank":null,"id":510,"code":"Q426","type":"question","description":"worry damage heart blood vessels","direction":"negative","underlyingIssue":"worrying about damage to the heart and blood vessels","additionalInfo":null,"preferredWording":"Have you worried about damage to your heart and blood vessels?","recommendedWording":null,"questionnaires":[31,41],"categories":[],"createDate":"2016-03-02T15:13:18.57","updateDate":"2016-03-02T15:13:18.57"},{"rank":null,"id":511,"code":"Q427","type":"question","description":"HCP explain again","direction":"positive","underlyingIssue":"HCPs explaining the same again differently if information was not understood","additionalInfo":"","preferredWording":"If you did not understand the information provided,  did your professional(s) explain it again in a different way?","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T15:14:30.6","updateDate":"2016-06-14T15:28:17.19"},{"rank":null,"id":512,"code":"Q428","type":"question","description":"HCP answer difficult questions","direction":"positive","underlyingIssue":"HCPs answering difficult questions sufficiently","additionalInfo":"","preferredWording":"Have your professional(s) answered difficult questions (for example concerns about your future) in a way you felt was sufficient for you?","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T15:16:34.047","updateDate":"2016-06-14T15:30:45.77"},{"rank":null,"id":513,"code":"Q429","type":"question","description":"HCP explain treatment aims","direction":"positive","underlyingIssue":"HCPs explaining aims of the treatment sufficiently","additionalInfo":"","preferredWording":"Have your professional(s) explained to you the aims of the treatment (for example to control symptoms) in a way you felt was sufficient for you?","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T15:19:03.983","updateDate":"2016-06-14T15:32:19.687"},{"rank":null,"id":514,"code":"Q430","type":"question","description":"HCP privacy","direction":"positive","underlyingIssue":"feeling that enough privacy is ensured for conversations with HCPs","additionalInfo":"","preferredWording":"Has there been enough privacy to have confidential conversations with your professional(s)?","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T15:20:48.773","updateDate":"2016-06-14T15:33:32.04"},{"rank":null,"id":515,"code":"Q431","type":"question","description":"satisfied HCP communication","direction":"positive","underlyingIssue":"feeling satisfied with communication with HCPs","additionalInfo":"","preferredWording":"Have you been satisfied with your communication with your professional(s)?\\n","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T15:22:09.6","updateDate":"2016-06-14T15:34:17.173"},{"rank":null,"id":516,"code":"Q432","type":"question","description":"pain abdomen","direction":"negative","underlyingIssue":"having abdominal pain","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had pain in your abdomen?</p>","preferredWording":"Did you have abdominal pain?","recommendedWording":null,"questionnaires":[19,32,44],"categories":[],"createDate":"2016-03-02T15:34:48.583","updateDate":"2016-06-28T13:00:48.407"},{"rank":null,"id":517,"code":"Q433","type":"question","description":"pain buttock anal area rectum","direction":"negative","underlyingIssue":"having pain in buttocks/anal area/rectum","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had pain in your buttocks/anal area/rectum?</p>","preferredWording":"Did you have pain in your buttocks/anal area/rectum?","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-02T15:35:43.857","updateDate":"2016-06-14T15:36:23.507"},{"rank":null,"id":518,"code":"Q434","type":"question","description":"restless agitated","direction":"negative","underlyingIssue":"feeling restless or agitated","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt restless or agitated?</p>","preferredWording":"Have you felt restless or agitated?","recommendedWording":null,"questionnaires":[33,35,41],"categories":[],"createDate":"2016-03-02T15:36:06.323","updateDate":"2016-06-14T15:36:51.633"},{"rank":null,"id":519,"code":"Q435","type":"question","description":"stool mucus","direction":"negative","underlyingIssue":"having mucus in the stools","additionalInfo":"","preferredWording":"Have you had mucus in your stools?","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-02T15:36:50.207","updateDate":"2016-06-14T15:37:16.283"},{"rank":null,"id":521,"code":"Q436","type":"question","description":"worry weight","direction":"negative","underlyingIssue":"worrying about weight","additionalInfo":"","preferredWording":"Have you worried about your weight?","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-02T15:40:16.26","updateDate":"2016-06-14T15:38:25.97"},{"rank":null,"id":522,"code":"CS24","type":"condition","description":"if stoma bag","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer these questions ONLY IF YOU HAVE A STOMA BAG, if not please continue below:","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-02T15:45:40.237","updateDate":"2016-03-02T15:45:40.237"},{"rank":null,"id":523,"code":"CS25","type":"condition","description":"if no stoma bag","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer these questions ONLY IF YOU DO NOT HAVE A STOMA BAG:","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-02T15:46:30.877","updateDate":"2016-03-02T15:46:30.877"},{"rank":null,"id":524,"code":"Q437","type":"question","description":"stoma bag","direction":"none","underlyingIssue":"having a stoma bag","additionalInfo":"","preferredWording":"Do you have a stoma bag (colostomy/ileostomy)?","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-02T15:48:25.557","updateDate":"2016-06-14T15:38:45.487"},{"rank":null,"id":525,"code":"IN23","type":"instructions","description":"Yes/ No","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"(please circle the correct answer)","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-02T15:48:45.277","updateDate":"2016-03-02T15:48:57.243"},{"rank":null,"id":526,"code":"Q438","type":"question","description":"stoma unintentional gas flatulence","direction":"negative","underlyingIssue":"having unintentional release of gas/flatulence from stoma bag","additionalInfo":"","preferredWording":"Have you had unintentional release of gas/flatulence from your stoma bag?  \\n","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-02T15:52:03.09","updateDate":"2016-06-14T15:39:28.217"},{"rank":null,"id":527,"code":"Q439","type":"question","description":"stoma leak stools","direction":"negative","underlyingIssue":"having leakage of stools from the stoma bag","additionalInfo":"","preferredWording":"Have you had leakage of stools from your stoma bag?","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-02T15:53:09.223","updateDate":"2016-06-14T15:47:14.14"},{"rank":null,"id":528,"code":"Q440","type":"question","description":"stoma sore skin","direction":"negative","underlyingIssue":"having sore skin around stoma","additionalInfo":"","preferredWording":"Have you had sore skin around your stoma?","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-02T15:55:43.433","updateDate":"2016-06-14T15:47:03.19"},{"rank":null,"id":529,"code":"Q441","type":"question","description":"stoma frequent change day","direction":"negative","underlyingIssue":"having to frequently change bags during the day","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have frequent bag changes occurred during the day?</p>","preferredWording":"Did frequent bag changes occur during the day?","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-02T15:56:40.533","updateDate":"2016-06-14T15:48:54.357"},{"rank":null,"id":530,"code":"Q442","type":"question","description":"stoma frequent bag night","direction":"negative","underlyingIssue":"having to frequently change stoma bags during the night","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have frequent bag changes occurred during the night?</p>","preferredWording":"Did frequent bag changes occur during the night?","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-02T15:57:16.243","updateDate":"2016-06-28T13:01:40.433"},{"rank":null,"id":531,"code":"Q443","type":"question","description":"embarrassed stoma","direction":"negative","underlyingIssue":"feeling embarrassed because of the stoma","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt embarrassed because of your stoma?</p>","preferredWording":"Did you feel embarrassed because of your stoma?","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-02T15:58:02.793","updateDate":"2016-06-16T11:22:06.71"},{"rank":null,"id":532,"code":"Q444","type":"question","description":"problem care stoma","direction":"negative","underlyingIssue":"experiencing problems caring for the stoma","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems caring for your stoma?</p>","preferredWording":"Did you have problems caring for your stoma?","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-02T15:58:52.95","updateDate":"2016-06-03T14:39:25"},{"rank":null,"id":533,"code":"Q445","type":"question","description":"unintentional release gas anus","direction":"negative","underlyingIssue":"having unintentional release of gas/flatulence from the back passage/anus","additionalInfo":"","preferredWording":"Have you had unintentional release of gas/flatulence from your back passage?","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-02T16:00:24.743","updateDate":"2016-06-16T11:23:59.813"},{"rank":null,"id":534,"code":"Q446","type":"question","description":"leakage stools back passage","direction":"negative","underlyingIssue":"having leakage of stools from back passage/anus","additionalInfo":"","preferredWording":"Have you had leakage of stools from your back passage?","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-02T16:01:35.727","updateDate":"2016-06-15T10:20:01.997"},{"rank":null,"id":535,"code":"Q447","type":"question","description":"sore skin anal area","direction":"negative","underlyingIssue":"having sore skin around the anal area","additionalInfo":"","preferredWording":"Have you had sore skin around your anal area?","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-03T11:52:15.213","updateDate":"2016-06-15T10:26:18.873"},{"rank":null,"id":536,"code":"Q448","type":"question","description":"bowel movement frequent day","direction":"negative","underlyingIssue":"having frequent bowel movements during the day","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had frequent bowel movements during the day?</p>","preferredWording":"Did frequent bowel movements occur during the day?","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-03T12:01:52.28","updateDate":"2016-06-15T10:59:20.84"},{"rank":null,"id":537,"code":"Q449","type":"question","description":"bowel movement frequent night","direction":"negative","underlyingIssue":"having frequent bowel movements during the night","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had frequent bowel movements during the night?</p>","preferredWording":"Did frequent bowel movements occur during the night?","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-03T12:02:18.147","updateDate":"2016-06-15T10:59:52.307"},{"rank":null,"id":538,"code":"Q450","type":"question","description":"embarrassed bowel movement","direction":"negative","underlyingIssue":"being embarrassed because of bowel movement","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt embarrassed because of your bowel movement?</p>","preferredWording":"Did you feel embarrassed because of your bowel movement?\\t","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-03T12:04:37.477","updateDate":"2016-06-15T11:00:57.237"},{"rank":null,"id":539,"code":"Q451","type":"question","description":"pain discomfort intercourse","direction":"negative","underlyingIssue":"having pain/discomfort during intercourse","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had pain or discomfort during intercourse?</p>","preferredWording":"Did you have pain or discomfort during intercourse?","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-03T12:07:47.257","updateDate":"2016-06-15T11:16:07.807"},{"rank":null,"id":540,"code":"Q452","type":"question","description":"cramps abdomen","direction":"negative","underlyingIssue":"having cramps in abdomen","additionalInfo":"","preferredWording":"Have you had cramps in your abdomen?","recommendedWording":"Have you had cramps in your abdomen?","questionnaires":[34,38,1000258,1000282],"categories":[],"createDate":"2016-03-03T12:40:37.427","updateDate":"2017-03-10T12:00:17.593"},{"rank":null,"id":541,"code":"Q453","type":"question","description":"problem control bowels","direction":"negative","underlyingIssue":"experiencing problems controlling bowels","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems controlling your bowels?</p>","preferredWording":"Have you had difficulty in controlling your bowels?","recommendedWording":null,"questionnaires":[34,1000282],"categories":[],"createDate":"2016-03-03T12:43:56.317","updateDate":"2016-06-03T14:40:08.22"},{"rank":null,"id":543,"code":"Q454","type":"question","description":"leak urine","direction":"negative","underlyingIssue":"having leaking of urine","additionalInfo":"","preferredWording":"Have you had leaking of urine?","recommendedWording":null,"questionnaires":[1,13,30,32,34,38,1000232,1000233,1000240,1000243,1000282],"categories":[],"createDate":"2016-03-03T12:48:03.337","updateDate":"2016-06-15T11:36:48.437"},{"rank":null,"id":544,"code":"Q455","type":"question","description":"problem empty bladder","direction":"negative","underlyingIssue":"experiencing problems emptying the bladder","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems emptying your bladder?</p>","preferredWording":"Have you had difficulty emptying your bladder?","recommendedWording":null,"questionnaires":[34,1000282],"categories":[],"createDate":"2016-03-03T12:51:07.66","updateDate":"2016-06-15T11:38:39.463"},{"rank":null,"id":545,"code":"Q456","type":"question","description":"swelling legs","direction":"negative","underlyingIssue":"having swelling in one or both legs","additionalInfo":"<h3>Additional Info</h3><p>nvcncvncvnbvnvnbvn</p>","preferredWording":"Have you had swelling in one or both legs?","recommendedWording":"Have you had swelling in one or both legs?","questionnaires":[29,34,38,1000174,1000282,1000300,1000301],"categories":[],"createDate":"2016-03-03T12:53:58.673","updateDate":"2017-03-28T13:43:59.86"},{"rank":null,"id":546,"code":"Q457","type":"question","description":"pain hip","direction":"negative","underlyingIssue":"having pain in the hip","additionalInfo":"","preferredWording":"Have you had pain in your hip?\\t","recommendedWording":null,"questionnaires":[35],"categories":[],"createDate":"2016-03-03T12:55:23.883","updateDate":"2016-06-15T11:39:25.017"},{"rank":null,"id":547,"code":"Q458","type":"question","description":"pain lower back","direction":"negative","underlyingIssue":"having pain in the lower back","additionalInfo":"","preferredWording":"Have you had pain in your lower back?","recommendedWording":null,"questionnaires":[34,1000282],"categories":[],"createDate":"2016-03-03T12:58:01.527","updateDate":"2016-06-15T11:40:35.517"},{"rank":null,"id":548,"code":"Q459","type":"question","description":"pain increase activity","direction":"negative","underlyingIssue":"having pain that increases with activity","additionalInfo":"","preferredWording":"If you had pain did it increase with activity?","recommendedWording":null,"questionnaires":[35],"categories":[],"createDate":"2016-03-03T12:58:47.313","updateDate":"2016-06-15T11:43:05.843"},{"rank":null,"id":549,"code":"Q460","type":"question","description":"thirsty","direction":"negative","underlyingIssue":"feeling thirsty","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt thirsty?</p>","preferredWording":"Did you feel thirsty?","recommendedWording":null,"questionnaires":[35,44],"categories":[],"createDate":"2016-03-03T13:00:05.257","updateDate":"2016-06-28T14:26:13.56"},{"rank":null,"id":550,"code":"Q461","type":"question","description":"burning sore eyes","direction":"negative","underlyingIssue":"having burning or sore eyes","additionalInfo":"","preferredWording":"Have you had burning or sore eyes?","recommendedWording":null,"questionnaires":[35,48],"categories":[],"createDate":"2016-03-03T13:04:21.4","updateDate":"2016-06-15T11:50:02.983"},{"rank":null,"id":551,"code":"Q462","type":"question","description":"worried dying","direction":"negative","underlyingIssue":"worrying about dying","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about dying?</p>","preferredWording":"Have you been worried about dying?","recommendedWording":null,"questionnaires":[35],"categories":[],"createDate":"2016-03-03T13:05:41.247","updateDate":"2016-06-28T15:10:34.973"},{"rank":null,"id":552,"code":"Q463","type":"question","description":"worried lose weight","direction":"negative","underlyingIssue":"worrying about losing weight","additionalInfo":"","preferredWording":"Have you worried about losing weight?","recommendedWording":null,"questionnaires":[36],"categories":[],"createDate":"2016-03-03T13:14:19.683","updateDate":"2016-06-15T11:50:36.79"},{"rank":null,"id":553,"code":"Q464","type":"question","description":"tingling numb hands feet","direction":"negative","underlyingIssue":"having tingling or numbness in hands or feet","additionalInfo":"","preferredWording":"Have you had tingling or numbness in your hands or feet?","recommendedWording":null,"questionnaires":[34,38,43,1000282],"categories":[],"createDate":"2016-03-03T13:14:35.987","updateDate":"2016-06-15T13:01:26.367"},{"rank":null,"id":554,"code":"Q465","type":"question","description":"sore mouth tongue","direction":"negative","underlyingIssue":"having sore mouth or tongue","additionalInfo":null,"preferredWording":"Have you had a sore mouth or tongue?","recommendedWording":null,"questionnaires":[36,37,48],"categories":[],"createDate":"2016-03-03T13:17:07.86","updateDate":"2016-03-10T13:30:55.757"},{"rank":null,"id":555,"code":"Q466","type":"question","description":"irritated sore vagina vulva","direction":"negative","underlyingIssue":"having irritation or soreness in the vagina or vulva","additionalInfo":"","preferredWording":"Have you had irritation or soreness in your vagina or vulva?","recommendedWording":null,"questionnaires":[34,1000282],"categories":[],"createDate":"2016-03-03T13:19:02.633","updateDate":"2016-06-15T13:04:12.217"},{"rank":null,"id":556,"code":"Q467","type":"question","description":"problem talk feelings family friends","direction":"negative","underlyingIssue":"experiencing problems talking about feelings with family or friends","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems talking about your feelings with your family or friends?</p>","preferredWording":"Have you had trouble talking about your feelings to your family or friends?","recommendedWording":null,"questionnaires":[36],"categories":[],"createDate":"2016-03-03T13:23:08.233","updateDate":"2016-06-28T15:07:51.963"},{"rank":null,"id":557,"code":"Q468","type":"question","description":"vaginal discharge","direction":"negative","underlyingIssue":"having discharge from the vagina","additionalInfo":"","preferredWording":"Have you had discharge from your vagina?","recommendedWording":null,"questionnaires":[34,1000282],"categories":[],"createDate":"2016-03-03T13:23:54.94","updateDate":"2016-06-15T13:14:50.29"},{"rank":null,"id":558,"code":"Q469","type":"question","description":"disease treatment sex life","direction":"negative","underlyingIssue":"disease or treatment affecting sex life","additionalInfo":null,"preferredWording":"Has the disease or treatment had any effect on your sex life?","recommendedWording":null,"questionnaires":[36,42,44],"categories":[],"createDate":"2016-03-03T13:24:58.187","updateDate":"2016-03-03T13:24:58.187"},{"rank":null,"id":559,"code":"Q470","type":"question","description":"abnormal bleed vagina","direction":"negative","underlyingIssue":"having abnormal bleeding from the vagina","additionalInfo":"","preferredWording":"Have you had abnormal bleeding from your vagina?","recommendedWording":null,"questionnaires":[34,1000282],"categories":[],"createDate":"2016-03-03T13:28:13.507","updateDate":"2016-06-15T13:24:08.493"},{"rank":null,"id":560,"code":"Q471","type":"question","description":"hot flush sweats","direction":"negative","underlyingIssue":"having hot flushes or sweats","additionalInfo":"","preferredWording":"Have you had hot flushes and/or sweats?","recommendedWording":null,"questionnaires":[34,1000282],"categories":[],"createDate":"2016-03-03T13:30:08.84","updateDate":"2016-06-15T13:25:33.873"},{"rank":null,"id":561,"code":"Q472","type":"question","description":"cough blood","direction":"negative","underlyingIssue":"coughing up blood","additionalInfo":"","preferredWording":"Have you coughed up blood?","recommendedWording":null,"questionnaires":[37,48],"categories":[],"createDate":"2016-03-03T13:33:32.74","updateDate":"2016-06-15T13:46:00.9"},{"rank":null,"id":562,"code":"Q473","type":"question","description":"short breath rest","direction":"negative","underlyingIssue":"being short of breath when resting","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been short of breath when resting?</p>","preferredWording":"Have you been short of breath when you rested?","recommendedWording":null,"questionnaires":[37,48],"categories":[],"createDate":"2016-03-03T13:35:12.303","updateDate":"2016-06-15T13:50:13.287"},{"rank":null,"id":563,"code":"Q474","type":"question","description":"vagina dry sex","direction":"negative","underlyingIssue":"having a dry vagina during sexual activity","additionalInfo":"","preferredWording":"Has your vagina felt dry during sexual activity?","recommendedWording":null,"questionnaires":[34,38,1000282],"categories":[],"createDate":"2016-03-03T13:35:50.603","updateDate":"2016-06-15T13:47:32.133"},{"rank":null,"id":564,"code":"Q475","type":"question","description":"short breath walk","direction":"negative","underlyingIssue":"being short of breath when walking","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been short of breath when walking?</p>","preferredWording":"Have you been short of breath when you walked?","recommendedWording":null,"questionnaires":[37,48],"categories":[],"createDate":"2016-03-03T13:35:50.947","updateDate":"2016-06-15T13:49:59.527"},{"rank":null,"id":565,"code":"Q476","type":"question","description":"short breath stairs","direction":"negative","underlyingIssue":"being short of breath when climbing stairs","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been short of breath when climbing stairs?</p>","preferredWording":"Have you been short of breath when you climbed stairs?","recommendedWording":null,"questionnaires":[37,48],"categories":[],"createDate":"2016-03-03T13:36:35.203","updateDate":"2016-06-15T13:50:44.283"},{"rank":null,"id":566,"code":"Q477","type":"question","description":"pain other parts body","direction":"negative","underlyingIssue":"having pain in other parts of the body","additionalInfo":"","preferredWording":"Have you had pain in other parts of your body?","recommendedWording":null,"questionnaires":[37,48],"categories":[],"createDate":"2016-03-03T13:39:10.353","updateDate":"2016-06-15T13:51:05.923"},{"rank":null,"id":567,"code":"Q478","type":"question","description":"vagina short ","direction":"negative","underlyingIssue":"feeling that vagina is short ","additionalInfo":"","preferredWording":"Has your vagina felt short?","recommendedWording":null,"questionnaires":[34,1000282],"categories":[],"createDate":"2016-03-03T13:39:25.69","updateDate":"2016-06-15T13:51:42.257"},{"rank":null,"id":568,"code":"CS26","type":"condition","description":"if yes where","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"If yes, where","recommendedWording":null,"questionnaires":[37],"categories":[],"createDate":"2016-03-03T13:39:29.417","updateDate":"2016-03-03T13:39:29.417"},{"rank":null,"id":569,"code":"Q479","type":"question","description":"vagina tight","direction":"negative","underlyingIssue":"feeling that vagina is tight","additionalInfo":"","preferredWording":"Has your vagina felt tight?","recommendedWording":null,"questionnaires":[34,1000282],"categories":[],"createDate":"2016-03-03T13:39:54.097","updateDate":"2016-06-15T13:54:34.343"},{"rank":null,"id":570,"code":"CS27","type":"condition","description":"if yes help","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"If yes, how much did it help?","recommendedWording":null,"questionnaires":[37],"categories":[],"createDate":"2016-03-03T13:40:16.453","updateDate":"2016-03-03T13:40:16.453"},{"rank":null,"id":571,"code":"Q480","type":"question","description":"pain intercourse sexual activity","direction":"negative","underlyingIssue":"having pain during sexual intercourse or sexual activity","additionalInfo":"","preferredWording":"Have you had pain during sexual intercourse or other sexual activity?","recommendedWording":null,"questionnaires":[1000282,34,38],"categories":[],"createDate":"2016-03-03T13:40:34.533","updateDate":"2016-06-15T13:55:15.81"},{"rank":null,"id":572,"code":"TS6","type":"timeScale","description":"current disease treatment information","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"During your current disease or treatment, how much information have you received on:","recommendedWording":null,"questionnaires":[39,1000177],"categories":[],"createDate":"2016-03-03T13:52:34.487","updateDate":"2016-03-03T13:52:34.487"},{"rank":null,"id":573,"code":"Q481","type":"question","description":"diagnosis","direction":"positive","underlyingIssue":"receiving information about the diagnosis of the disease","additionalInfo":"","preferredWording":"The diagnosis of your disease?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T13:54:03.643","updateDate":"2016-06-15T13:59:57.773"},{"rank":null,"id":574,"code":"Q482","type":"question","description":"extent disease","direction":"positive","underlyingIssue":"receiving information about the extent of the disease","additionalInfo":"","preferredWording":"The extent (spread) of your disease?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T13:54:53.377","updateDate":"2016-06-15T14:00:06.09"},{"rank":null,"id":575,"code":"Q483","type":"question","description":"possible causes","direction":"positive","underlyingIssue":"receiving information about the possible causes of the disease","additionalInfo":"","preferredWording":"The possible causes of your disease?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T13:55:45.5","updateDate":"2016-06-15T14:00:15.153"},{"rank":null,"id":576,"code":"Q484","type":"question","description":"disease control","direction":"positive","underlyingIssue":"receiving information whether the disease is under control","additionalInfo":"","preferredWording":"Whether the disease is under control?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T13:57:15.373","updateDate":"2016-06-15T14:00:44.637"},{"rank":null,"id":577,"code":"Q485","type":"question","description":"purpose tests","direction":"positive","underlyingIssue":"receiving information about the purpose of medical tests","additionalInfo":"","preferredWording":"The purpose of any medical tests you have had or may undergo?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T13:58:38.417","updateDate":"2016-06-15T14:09:32.06"},{"rank":null,"id":578,"code":"Q486","type":"question","description":"procedures tests","direction":"positive","underlyingIssue":"receiving information about the procedures of the medical tests","additionalInfo":"","preferredWording":"The procedures of the medical tests?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:00:33.47","updateDate":"2016-06-15T14:09:55.647"},{"rank":null,"id":579,"code":"Q487","type":"question","description":"heavy legs","direction":"negative","underlyingIssue":"having heaviness in one or both legs","additionalInfo":"","preferredWording":"Have you felt heaviness in one or both legs?","recommendedWording":null,"questionnaires":[38],"categories":[],"createDate":"2016-03-03T14:01:01.1","updateDate":"2016-06-15T14:10:39.36"},{"rank":null,"id":580,"code":"Q488","type":"question","description":"results medical tests","direction":"positive","underlyingIssue":"receiving information about the results of the medical tests","additionalInfo":"","preferredWording":"The results of the medical tests you have already received?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:02:51.77","updateDate":"2016-06-15T14:10:59.407"},{"rank":null,"id":581,"code":"Q489","type":"question","description":"pain lower back pelvis","direction":"negative","underlyingIssue":"having pain in the lower back and/or pelvis","additionalInfo":"","preferredWording":"Have you had pain in your lower back and / or pelvis?","recommendedWording":null,"questionnaires":[38],"categories":[],"createDate":"2016-03-03T14:03:27.98","updateDate":"2016-06-15T14:11:28.767"},{"rank":null,"id":582,"code":"Q490","type":"question","description":"medical treatment","direction":"positive","underlyingIssue":"receiving information about the modality of the medical treatment","additionalInfo":"","preferredWording":"The medical treatment (chemotherapy, radiotherapy, surgery or other treatment modality)?","recommendedWording":null,"questionnaires":[39,1000144],"categories":[],"createDate":"2016-03-03T14:05:33.533","updateDate":"2016-06-15T14:12:22.277"},{"rank":null,"id":583,"code":"Q491","type":"question","description":"benefit treatment","direction":"positive","underlyingIssue":"receiving information about the expected benefit of the treatment","additionalInfo":"","preferredWording":"The expected benefit of the treatment?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:07:42.817","updateDate":"2016-06-15T14:12:35.91"},{"rank":null,"id":584,"code":"Q492","type":"question","description":"hurry toilet stools urge","direction":"negative","underlyingIssue":"having to hurry to get to the toilet when feeling the urge to move bowels","additionalInfo":"","preferredWording":"When you felt the urge to move your bowels, did you have to hurry to get to the toilet?","recommendedWording":null,"questionnaires":[38],"categories":[],"createDate":"2016-03-03T14:07:58.493","updateDate":"2016-06-15T14:14:22.01"},{"rank":null,"id":585,"code":"Q493","type":"question","description":"side effects","direction":"positive","underlyingIssue":"receiving information about possible side effects","additionalInfo":"","preferredWording":"The possible side-effects of your treatment?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:08:56.717","updateDate":"2016-06-15T14:23:54.61"},{"rank":null,"id":586,"code":"Q494","type":"question","description":"leak stools","direction":"negative","underlyingIssue":"having leakage of stools","additionalInfo":"","preferredWording":"Have you had any leakage of stools?","recommendedWording":null,"questionnaires":[38],"categories":[],"createDate":"2016-03-03T14:10:06.917","updateDate":"2016-06-15T14:25:16.107"},{"rank":null,"id":587,"code":"Q495","type":"question","description":"expected effects symptoms","direction":"positive","underlyingIssue":"receiving information on the expected effects of the treatment on disease symptoms","additionalInfo":"","preferredWording":"The expected effects of the treatment on disease symptoms?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:11:35.7","updateDate":"2016-06-15T14:25:57.81"},{"rank":null,"id":588,"code":"Q496","type":"question","description":"effects treatment social family life","direction":"positive","underlyingIssue":"receiving information about the effects of the treatment on social and family life","additionalInfo":"","preferredWording":"The effects of the treatment on social and family life?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:13:05.06","updateDate":"2016-06-15T14:26:27.87"},{"rank":null,"id":589,"code":"Q497","type":"question","description":"effects treatment sexual activity","direction":"positive","underlyingIssue":"receiving information about the effects of the treatment on sexual activity","additionalInfo":"","preferredWording":"The effects of the treatment on sexual activity?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:16:05.093","updateDate":"2016-06-15T14:27:01.787"},{"rank":null,"id":590,"code":"Q498","type":"question","description":"help outside hospital","direction":"positive","underlyingIssue":"receiving information about additional help outside the hospital","additionalInfo":"","preferredWording":"Additional help outside the hospital (e.g. help with daily activities, self help groups, district nurses)?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:21:29.77","updateDate":"2016-06-15T14:27:17.777"},{"rank":null,"id":591,"code":"Q499","type":"question","description":"vagina short tight","direction":"negative","underlyingIssue":"feeling that the vagina is short and/or tight","additionalInfo":"","preferredWording":"Has your vagina felt short and / or tight?","recommendedWording":null,"questionnaires":[38],"categories":[],"createDate":"2016-03-03T14:22:05.357","updateDate":"2016-06-15T14:29:23.797"},{"rank":null,"id":592,"code":"Q500","type":"question","description":"rehabilitation","direction":"positive","underlyingIssue":"receiving information about rehabilitation services","additionalInfo":"","preferredWording":"Rehabilitation services (e. g. physiotherapy, occupational therapy)?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:22:17.68","updateDate":"2016-06-15T14:29:37.573"},{"rank":null,"id":593,"code":"Q501","type":"question","description":"aspects managing home","direction":"positive","underlyingIssue":"receiving information about aspects of managing illness at home","additionalInfo":"","preferredWording":"Aspects of managing your illness at home?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:24:52.767","updateDate":"2016-06-15T14:30:06.357"},{"rank":null,"id":594,"code":"Q502","type":"question","description":"psychological support","direction":"positive","underlyingIssue":"receiving information about possible professional psychological support","additionalInfo":"","preferredWording":"Possible professional psychological support?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:27:47.01","updateDate":"2016-06-15T14:30:29.007"},{"rank":null,"id":595,"code":"Q503","type":"question","description":"places care","direction":"positive","underlyingIssue":"receiving information about different places of care","additionalInfo":"","preferredWording":"Different places of care (hospitals/outpatient services/home)?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:29:04.077","updateDate":"2016-06-15T14:31:07.807"},{"rank":null,"id":597,"code":"Q504","type":"question","description":"feeling exhausted","direction":"negative","underlyingIssue":"feeling exhausted","additionalInfo":"","preferredWording":"Have you felt exhausted?","recommendedWording":null,"questionnaires":[40],"categories":[],"createDate":"2016-03-03T14:34:18.6","updateDate":"2016-06-15T14:32:04.747"},{"rank":null,"id":598,"code":"Q505","type":"question","description":"sleepy daytime","direction":"negative","underlyingIssue":"feeling sleepy during the day","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt sleepy during the day?</p>","preferredWording":"Did you feel sleepy during the day?","recommendedWording":null,"questionnaires":[40],"categories":[],"createDate":"2016-03-03T14:36:47.803","updateDate":"2016-06-28T14:16:44.02"},{"rank":null,"id":599,"code":"Q506","type":"question","description":"help get well","direction":"positive","underlyingIssue":"receiving information about things one can do to help themselves get well","additionalInfo":"","preferredWording":"Things that you can do to help yourself get well (rest, contact with others..)?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:37:54.013","updateDate":"2016-06-15T14:34:21.843"},{"rank":null,"id":600,"code":"Q507","type":"question","description":"written information","direction":"positive","underlyingIssue":"receiving written information","additionalInfo":"","preferredWording":"Have you received written information?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:38:33.017","updateDate":"2016-06-15T14:37:42.653"},{"rank":null,"id":601,"code":"Q508","type":"question","description":"information cd tape video","direction":"positive","underlyingIssue":"receiving information on CD/tape/video","additionalInfo":"","preferredWording":"Have you received information on CD or tape / video?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:39:36.213","updateDate":"2016-06-15T14:38:02.327"},{"rank":null,"id":602,"code":"Q509","type":"question","description":"satisfied amount information","direction":"positive","underlyingIssue":"being satisfied with the amount of information received","additionalInfo":"","preferredWording":"Were you satisfied with the amount of information you received?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:40:28.007","updateDate":"2016-06-15T14:38:48.987"},{"rank":null,"id":603,"code":"Q510","type":"question","description":"wish more information","direction":"negative","underlyingIssue":"wishing to receive more information","additionalInfo":"","preferredWording":"Do you wish to receive more information?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:41:09.177","updateDate":"2016-06-15T14:42:56.163"},{"rank":null,"id":604,"code":"CS28","type":"condition","description":"specify topics","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"If yes, please specify on which topics?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:41:25.853","updateDate":"2016-03-03T14:41:25.853"},{"rank":null,"id":605,"code":"Q511","type":"question","description":"wish less information","direction":"negative","underlyingIssue":"wishing to have received less information","additionalInfo":"","preferredWording":"Do you wish that you had received less information?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:44:05.277","updateDate":"2016-06-15T14:43:26.21"},{"rank":null,"id":606,"code":"Q512","type":"question","description":"information helpful","direction":"positive","underlyingIssue":"information being helpful","additionalInfo":"","preferredWording":"Overall has the information you have received been helpful?","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-03-03T14:46:15.213","updateDate":"2016-06-15T14:43:45.507"},{"rank":null,"id":607,"code":"Q513","type":"question","description":"problem get things started","direction":"negative","underlyingIssue":"experiencing problems getting things started","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems getting things started?</p>","preferredWording":"Did you have trouble getting things started?","recommendedWording":null,"questionnaires":[40],"categories":[],"createDate":"2016-03-03T14:55:21.657","updateDate":"2016-06-24T10:47:36.857"},{"rank":null,"id":608,"code":"Q514","type":"question","description":"vulnerable veins","direction":"negative","underlyingIssue":"having vulnerable veins","additionalInfo":"","preferredWording":"Have you had vulnerable veins (for example when having blood taken or receiving treatment)?","recommendedWording":null,"questionnaires":[41],"categories":[],"createDate":"2016-03-03T14:55:51.813","updateDate":"2016-06-15T14:47:30.247"},{"rank":null,"id":609,"code":"Q515","type":"question","description":"feeling discouraged","direction":"negative","underlyingIssue":"feeling discouraged","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt discouraged?</p>","preferredWording":"Did you feel discouraged?","recommendedWording":null,"questionnaires":[40],"categories":[],"createDate":"2016-03-03T14:57:07.117","updateDate":"2016-06-15T14:48:10.327"},{"rank":null,"id":610,"code":"Q516","type":"question","description":"itching skin","direction":"negative","underlyingIssue":"having itching of the skin","additionalInfo":null,"preferredWording":"Have you had itching of your skin?","recommendedWording":null,"questionnaires":[41],"categories":[],"createDate":"2016-03-03T15:01:42.357","updateDate":"2016-03-03T15:01:42.357"},{"rank":null,"id":611,"code":"Q517","type":"question","description":"feeling helpless","direction":"negative","underlyingIssue":"feeling helpless","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt helpless?</p>","preferredWording":"Did you feel helpless?","recommendedWording":null,"questionnaires":[40],"categories":[],"createDate":"2016-03-03T15:03:59.567","updateDate":"2016-06-28T14:17:04.16"},{"rank":null,"id":612,"code":"Q518","type":"question","description":"problem think clearly","direction":"negative","underlyingIssue":"experiencing problems thinking clearly","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems thinking clearly?</p>","preferredWording":"Did you have trouble thinking clearly?","recommendedWording":null,"questionnaires":[40],"categories":[],"createDate":"2016-03-03T15:05:14.87","updateDate":"2016-06-15T14:49:04.943"},{"rank":null,"id":613,"code":"Q519","type":"question","description":"lack self confidence","direction":"negative","underlyingIssue":"lacking self confidence","additionalInfo":null,"preferredWording":"Have you lacked self confidence?","recommendedWording":null,"questionnaires":[41],"categories":[],"createDate":"2016-03-03T15:05:27.38","updateDate":"2016-03-03T15:05:27.38"},{"rank":null,"id":614,"code":"Q520","type":"question","description":"feel confused","direction":"negative","underlyingIssue":"feeling confused","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt confused?</p>","preferredWording":"Did you feel confused?","recommendedWording":null,"questionnaires":[40],"categories":[],"createDate":"2016-03-03T15:06:06.897","updateDate":"2016-06-28T14:17:22.833"},{"rank":null,"id":615,"code":"Q521","type":"question","description":"problem finish things","direction":"negative","underlyingIssue":"experiencing problems finishing things","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems finishing things you started?</p>","preferredWording":"Have you found it difficult to finish things you started?","recommendedWording":null,"questionnaires":[44,45],"categories":[],"createDate":"2016-03-03T15:06:41.89","updateDate":"2016-06-28T14:35:39.263"},{"rank":null,"id":616,"code":"Q522","type":"question","description":"tired interference daily activities","direction":"negative","underlyingIssue":"tiredness interfering with daily activities","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has tiredness interfered with your daily activities?</p>","preferredWording":"Did tiredness interfere with your daily activities?","recommendedWording":null,"questionnaires":[40],"categories":[],"createDate":"2016-03-03T15:08:25.803","updateDate":"2016-06-15T14:59:46.84"},{"rank":null,"id":617,"code":"Q523","type":"question","description":"tired not understood close people","direction":"negative","underlyingIssue":"feeling that tiredness was not understood by the close ones","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt that your tiredness is (was) not understood by the people who are close to you?</p>","preferredWording":"Did you feel that your tiredness is (was) not understood by the people who are close to you?","recommendedWording":null,"questionnaires":[40],"categories":[],"createDate":"2016-03-03T15:10:50.813","updateDate":"2016-06-15T15:01:50.91"},{"rank":null,"id":618,"code":"Q524","type":"question","description":"frustrated","direction":"negative","underlyingIssue":"feeling frustrated","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt frustrated?</p>","preferredWording":"Did you feel frustrated?","recommendedWording":null,"questionnaires":[40],"categories":[],"createDate":"2016-03-03T15:11:39.597","updateDate":"2016-06-15T15:03:10.223"},{"rank":null,"id":619,"code":"Q525","type":"question","description":"look flushed red","direction":"negative","underlyingIssue":"noticing or being told by others that one looks flushed/red","additionalInfo":"","preferredWording":"Have you noticed or been told by others that you looked flushed/red?","recommendedWording":null,"questionnaires":[42],"categories":[],"createDate":"2016-03-03T15:22:30.873","updateDate":"2016-06-15T15:04:32.08"},{"rank":null,"id":620,"code":"Q526","type":"question","description":"abdominal discomfort","direction":"negative","underlyingIssue":"having abdominal discomfort","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had abdominal discomfort?</p>","preferredWording":"Did you have abdominal discomfort?","recommendedWording":null,"questionnaires":[42],"categories":[],"createDate":"2016-03-03T15:23:39.063","updateDate":"2016-06-15T15:05:25.183"},{"rank":null,"id":621,"code":"Q527","type":"question","description":"side effects treatment","direction":"negative","underlyingIssue":"having side-effects from treatment","additionalInfo":"","preferredWording":"Have you had side-effects from your treatment?","recommendedWording":null,"questionnaires":[42],"categories":[],"createDate":"2016-03-03T15:26:05.007","updateDate":"2016-06-15T15:06:53.89"},{"rank":null,"id":622,"code":"CS29","type":"condition","description":"not on treatment","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"(If you are not on treatment please circle N/A)","recommendedWording":null,"questionnaires":[42],"categories":[],"createDate":"2016-03-03T15:26:48.847","updateDate":"2016-03-03T15:26:48.847"},{"rank":null,"id":623,"code":"CS30","type":"condition","description":"not having injections","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"(If not having injections please circle N/A)","recommendedWording":null,"questionnaires":[42],"categories":[],"createDate":"2016-03-03T15:27:05.273","updateDate":"2016-03-03T15:27:05.273"},{"rank":null,"id":624,"code":"CS31","type":"condition","description":"not having tests","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"(If you have not had tests please circle N/A)","recommendedWording":null,"questionnaires":[42],"categories":[],"createDate":"2016-03-03T15:27:25.023","updateDate":"2016-03-03T15:27:25.023"},{"rank":null,"id":625,"code":"CS32","type":"condition","description":"not applicable","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"(If not applicable please circle N/A)","recommendedWording":null,"questionnaires":[42],"categories":[],"createDate":"2016-03-03T15:27:49.08","updateDate":"2016-03-03T15:27:49.08"},{"rank":null,"id":626,"code":"Q528","type":"question","description":"problem repeated injections","direction":"negative","underlyingIssue":"experiencing problems from repeated injections","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems from repeated injections?</p>","preferredWording":"Have you had a problem from repeated injections?","recommendedWording":null,"questionnaires":[42],"categories":[],"createDate":"2016-03-03T15:41:02.23","updateDate":"2016-06-28T15:11:40.9"},{"rank":null,"id":627,"code":"Q529","type":"question","description":"distress disease treatment close people","direction":"negative","underlyingIssue":"disease/treatment being distressing for the close ones","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has your disease or treatment been distressing to those close to you?</p>","preferredWording":"How distressing, do you think, your illness or treatment has been to those close to you? \\n","recommendedWording":null,"questionnaires":[42,45],"categories":[],"createDate":"2016-03-03T15:45:10.78","updateDate":"2016-06-28T14:38:24.487"},{"rank":null,"id":628,"code":"Q530","type":"question","description":"aches pain muscles bones","direction":"negative","underlyingIssue":"having aches or pains in muscles or bones","additionalInfo":"","preferredWording":"Have you had aches or pains in your muscles or bones?","recommendedWording":null,"questionnaires":[42],"categories":[],"createDate":"2016-03-03T15:48:10.777","updateDate":"2016-06-15T15:11:06.913"},{"rank":null,"id":629,"code":"Q531","type":"question","description":"limited travel","direction":"negative","underlyingIssue":"being limited in ability to travel","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been limited in your ability to travel?</p>","preferredWording":"Did you have any limitations in your ability to travel?","recommendedWording":null,"questionnaires":[42],"categories":[],"createDate":"2016-03-03T15:49:17.017","updateDate":"2016-06-15T15:45:59.313"},{"rank":null,"id":630,"code":"Q532","type":"question","description":"problem adequate information","direction":"negative","underlyingIssue":"experiencing problems receiving adequate information about disease or treatment","additionalInfo":"","preferredWording":"Have you had problems receiving adequate information about your disease and treatment? \\n","recommendedWording":null,"questionnaires":[42],"categories":[],"createDate":"2016-03-03T15:51:02.18","updateDate":"2016-06-15T15:46:47.863"},{"rank":null,"id":631,"code":"Q533","type":"question","description":"problem teeth loss","direction":"negative","underlyingIssue":"experiencing problems due to teeth loss","additionalInfo":"","preferredWording":"Have you had problems because of losing some teeth?","recommendedWording":null,"questionnaires":[43],"categories":[],"createDate":"2016-03-04T08:26:08.563","updateDate":"2016-06-15T15:47:34.15"},{"rank":null,"id":632,"code":"Q534","type":"question","description":"problem hoarse","direction":"negative","underlyingIssue":"experiencing problems with hoarseness","additionalInfo":"","preferredWording":"Have you had problems with hoarseness?","recommendedWording":null,"questionnaires":[43],"categories":[],"createDate":"2016-03-04T08:29:22.37","updateDate":"2016-06-15T15:49:21.777"},{"rank":null,"id":633,"code":"Q535","type":"question","description":"problem talk noisy environment","direction":"negative","underlyingIssue":"experiencing problems talking in a noisy environment","additionalInfo":"","preferredWording":"Have you had problems talking in a noisy environment?","recommendedWording":null,"questionnaires":[43],"categories":[],"createDate":"2016-03-04T08:36:27.783","updateDate":"2016-06-15T15:58:24.52"},{"rank":null,"id":634,"code":"Q536","type":"question","description":"pain shoulder","direction":"negative","underlyingIssue":"having pain in the shoulder","additionalInfo":"","preferredWording":"Have you had pain in your shoulder?","recommendedWording":null,"questionnaires":[43,44],"categories":[],"createDate":"2016-03-04T08:43:07.83","updateDate":"2016-06-15T15:58:51.803"},{"rank":null,"id":635,"code":"Q537","type":"question","description":"neck swelling ","direction":"negative","underlyingIssue":"having swelling in the neck","additionalInfo":"","preferredWording":"Have you had swelling in your neck?","recommendedWording":null,"questionnaires":[43],"categories":[],"createDate":"2016-03-04T08:47:47.25","updateDate":"2016-06-15T15:59:11.15"},{"rank":null,"id":636,"code":"Q538","type":"question","description":"rash","direction":"negative","underlyingIssue":"having a rash","additionalInfo":"","preferredWording":"Have you had a rash?","recommendedWording":null,"questionnaires":[43],"categories":[],"createDate":"2016-03-04T08:59:50.34","updateDate":"2016-06-15T15:59:30.04"},{"rank":null,"id":637,"code":"Q539","type":"question","description":"skin colour changes","direction":"negative","underlyingIssue":"skin colour changing","additionalInfo":"","preferredWording":"Has your skin changed colour?","recommendedWording":null,"questionnaires":[43],"categories":[],"createDate":"2016-03-04T09:04:59.777","updateDate":"2016-06-16T11:52:30.36"},{"rank":null,"id":638,"code":"Q540","type":"question","description":"problem wound heal","direction":"negative","underlyingIssue":"experiencing problems with wounds healing","additionalInfo":"","preferredWording":"Have you had problems with wounds healing?","recommendedWording":null,"questionnaires":[43],"categories":[],"createDate":"2016-03-04T09:14:31.057","updateDate":"2016-06-16T11:53:34.37"},{"rank":null,"id":639,"code":"Q541","type":"question","description":"problem chew","direction":"negative","underlyingIssue":"experiencing problems chewing","additionalInfo":"","preferredWording":"Have you had problems chewing?","recommendedWording":null,"questionnaires":[43],"categories":[],"createDate":"2016-03-04T09:17:45.11","updateDate":"2016-06-16T11:54:32.34"},{"rank":null,"id":640,"code":"Q542","type":"question","description":"problem speak clearly","direction":"negative","underlyingIssue":"experiencing problems speaking clearly","additionalInfo":"","preferredWording":"Have you had problems speaking clearly?","recommendedWording":null,"questionnaires":[43],"categories":[],"createDate":"2016-03-04T09:27:49.447","updateDate":"2016-06-16T11:59:53.947"},{"rank":null,"id":641,"code":"Q543","type":"question","description":"muscle loss arms legs","direction":"negative","underlyingIssue":"losing muscles from arms or legs","additionalInfo":"","preferredWording":"Have you lost muscle from your arms or legs?","recommendedWording":null,"questionnaires":[44],"categories":[],"createDate":"2016-03-04T09:44:01.753","updateDate":"2016-06-16T12:00:33.087"},{"rank":null,"id":642,"code":"Q544","type":"question","description":"abdomen swelling","direction":"negative","underlyingIssue":"having abdominal swelling","additionalInfo":"","preferredWording":"Have you had abdominal swelling?","recommendedWording":null,"questionnaires":[44],"categories":[],"createDate":"2016-03-04T09:50:10.163","updateDate":"2016-06-16T12:01:46.707"},{"rank":null,"id":643,"code":"Q545","type":"question","description":"worry appearance abdomen","direction":"negative","underlyingIssue":"worrying about the appearance of the abdomen","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you worried about the appearance of your abdomen?</p>","preferredWording":"Have you been concerned by the appearance of your abdomen?","recommendedWording":null,"questionnaires":[44],"categories":[],"createDate":"2016-03-04T10:07:35.577","updateDate":"2016-06-16T12:03:14.38"},{"rank":null,"id":644,"code":"Q546","type":"question","description":"chills","direction":"negative","underlyingIssue":"having chills","additionalInfo":"","preferredWording":"Have you had chills?","recommendedWording":null,"questionnaires":[44],"categories":[],"createDate":"2016-03-04T10:13:11.707","updateDate":"2016-06-16T12:04:08.49"},{"rank":null,"id":645,"code":"Q547","type":"question","description":"worry enough nourishment","direction":"negative","underlyingIssue":"worrying about getting enough nourishment","additionalInfo":"","preferredWording":"Have you worried about getting enough nourishment?","recommendedWording":null,"questionnaires":[44],"categories":[],"createDate":"2016-03-04T10:15:45.293","updateDate":"2016-06-16T12:04:49.153"},{"rank":null,"id":646,"code":"Q548","type":"question","description":"need sleep day","direction":"negative","underlyingIssue":"needing to sleep during day","additionalInfo":"","preferredWording":"Have you needed to sleep during the day?","recommendedWording":null,"questionnaires":[44],"categories":[],"createDate":"2016-03-04T10:19:34.293","updateDate":"2016-06-16T12:05:10.687"},{"rank":null,"id":647,"code":"Q549","type":"question","description":"upset treatment affect hair","direction":"negative","underlyingIssue":"being upset by how treatment affected hair","additionalInfo":"","preferredWording":"Have you been upset by how the treatment has affected your hair?","recommendedWording":null,"questionnaires":[45],"categories":[],"createDate":"2016-03-04T10:57:38.723","updateDate":"2016-06-16T12:08:58.12"},{"rank":null,"id":648,"code":"CS33","type":"condition","description":"if in hospital for treatment","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please, complete the following questions if you are currently still in hospital for your treatment. If not, please go to question 48 on next page.","recommendedWording":null,"questionnaires":[45],"categories":[],"createDate":"2016-03-04T11:04:36.63","updateDate":"2016-03-04T11:04:36.63"},{"rank":null,"id":649,"code":"CS34","type":"condition","description":"if question does not apply","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please mark the box, if the next question does not apply to you","recommendedWording":null,"questionnaires":[45],"categories":[],"createDate":"2016-03-04T11:05:20.377","updateDate":"2016-03-04T11:05:20.377"},{"rank":null,"id":650,"code":"CS35","type":"condition","description":"if completed hospital treatment and at home","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please, complete the following questions only if you have completed your hospital treatment and are currently at home.","recommendedWording":null,"questionnaires":[45],"categories":[],"createDate":"2016-03-04T11:06:10.047","updateDate":"2016-03-04T11:06:10.047"},{"rank":null,"id":651,"code":"Q550","type":"question","description":"fevers chills","direction":"negative","underlyingIssue":"having fevers or chills","additionalInfo":"","preferredWording":"Have you had fevers or chills?","recommendedWording":null,"questionnaires":[45],"categories":[],"createDate":"2016-03-04T11:06:53.247","updateDate":"2016-06-16T12:09:24.62"},{"rank":null,"id":652,"code":"Q551","type":"question","description":"problem cope hospital","direction":"negative","underlyingIssue":"experiencing problems coping with the hospital stay","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems coping with the hospital stay?</p>","preferredWording":"Have you had trouble coping with the hospital stay?","recommendedWording":null,"questionnaires":[45],"categories":[],"createDate":"2016-03-04T11:11:39.033","updateDate":"2016-06-16T12:11:09.993"},{"rank":null,"id":653,"code":"Q552","type":"question","description":"problem isolation hospital","direction":"negative","underlyingIssue":"experiencing problems with the isolation in hospital","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems with the isolation in hospital?</p>","preferredWording":"Has the isolation in hospital troubled you?","recommendedWording":null,"questionnaires":[45],"categories":[],"createDate":"2016-03-04T11:17:46.21","updateDate":"2016-06-16T12:12:12.57"},{"rank":null,"id":654,"code":"Q553","type":"question","description":"worry blood recover","direction":"negative","underlyingIssue":"worrying that blood may not recover","additionalInfo":"","preferredWording":"Have you worried that the blood (i.e. blood counts) may not recover?","recommendedWording":null,"questionnaires":[45],"categories":[],"createDate":"2016-03-04T11:20:21.717","updateDate":"2016-06-16T12:13:32.16"},{"rank":null,"id":655,"code":"Q554","type":"question","description":"satisfied prepare treatment","direction":"positive","underlyingIssue":"feeling satisfied with preparation of treatment","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been satisfied with the preparation for your treatment?</p>","preferredWording":"How satisfied were you with the preparation for your treatment?","recommendedWording":null,"questionnaires":[45],"categories":[],"createDate":"2016-03-04T11:25:05.693","updateDate":"2016-06-16T12:15:11.35"},{"rank":null,"id":656,"code":"Q555","type":"question","description":"need keep fears concerns family friends","direction":"negative","underlyingIssue":"feeling the need to keep fears or concerns from family or friends","additionalInfo":"","preferredWording":"Have you felt a need to keep your fears/ concerns from family or friends?","recommendedWording":null,"questionnaires":[45],"categories":[],"createDate":"2016-03-04T11:31:24.147","updateDate":"2016-06-16T12:38:29.763"},{"rank":null,"id":657,"code":"Q556","type":"question","description":"experience distinguish important things life","direction":"negative","underlyingIssue":"experience helping to distinguish between important and non-important things in life","additionalInfo":"","preferredWording":"Has your experience helped you to distinguish between important and non-important things in life?","recommendedWording":null,"questionnaires":[45],"categories":[],"createDate":"2016-03-04T11:35:10.013","updateDate":"2016-06-16T12:43:31.12"},{"rank":null,"id":658,"code":"Q557","type":"question","description":"drug intake interference daily life","direction":"negative","underlyingIssue":"having to take drugs regularly interfering with the daily life","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has having to take drugs regularly interfered with your daily life?</p>","preferredWording":"Did having to take your drugs regularly interfere with your daily life?","recommendedWording":null,"questionnaires":[45],"categories":[],"createDate":"2016-03-04T11:50:09.293","updateDate":"2016-06-16T12:46:06.86"},{"rank":null,"id":659,"code":"Q558","type":"question","description":"watch closely new symptoms","direction":"negative","underlyingIssue":"watching oneself closely for new symptoms","additionalInfo":"","preferredWording":"Have you been watching yourself closely for any new symptoms?","recommendedWording":null,"questionnaires":[45],"categories":[],"createDate":"2016-03-04T11:52:01.993","updateDate":"2016-06-16T12:47:10.26"},{"rank":null,"id":660,"code":"IN24","type":"instructions","description":"things experience care hospital stay","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"We are interested in some things about you and your experience of the care received during your hospital stay.","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T12:25:37.513","updateDate":"2016-03-04T12:25:37.513"},{"rank":null,"id":661,"code":"RS5","type":"responseScale","description":"5-point satisfaction scale","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Poor, Fair, Good, Very good, Excellent","recommendedWording":null,"questionnaires":[47,1000177],"categories":[],"createDate":"2016-03-04T12:27:13.783","updateDate":"2016-03-04T14:26:25.327"},{"rank":null,"id":662,"code":"CS36","type":"condition","description":"hospital stay, doctor","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"During your hospital stay, how would you rate doctors, in terms of:","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T12:28:08.527","updateDate":"2016-03-04T12:28:08.527"},{"rank":null,"id":663,"code":"CS37","type":"condition","description":"hospital stay, nurses","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"During your hospital stay, how would you rate nurses, in terms of:","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T12:28:39.18","updateDate":"2016-03-04T12:28:39.18"},{"rank":null,"id":664,"code":"CS38","type":"condition","description":"hospital stay, services & care organisation","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"During your hospital stay, how would you rate services & care organisation, in terms of:","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T12:29:15.72","updateDate":"2016-03-04T12:29:15.72"},{"rank":null,"id":665,"code":"CS39","type":"condition","description":"In general","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"In general,","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T12:30:00.68","updateDate":"2016-03-04T12:30:00.68"},{"rank":null,"id":666,"code":"Q559","type":"question","description":"knowledge experience illness","direction":"positive","underlyingIssue":"feeling satisfied with doctors\' knowledge and experience of the illness","additionalInfo":"","preferredWording":"Their knowledge and experience of your illness?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T12:37:12.63","updateDate":"2016-06-16T12:49:59.447"},{"rank":null,"id":667,"code":"Q560","type":"question","description":"treatment follow-up","direction":"positive","underlyingIssue":"feeling satisfied with the treatment and the medical follow-up provided by doctors","additionalInfo":"","preferredWording":"The treatment and medical follow-up they provided?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T12:38:24.937","updateDate":"2016-06-16T12:51:00.227"},{"rank":null,"id":668,"code":"Q561","type":"question","description":"attention physical problems","direction":"positive","underlyingIssue":"feeling satisfied with doctors\' attention to physical problems","additionalInfo":"","preferredWording":"The attention they paid to your physical problems?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T12:39:25.157","updateDate":"2016-06-16T12:51:29.417"},{"rank":null,"id":669,"code":"Q562","type":"question","description":"willingness listen concerns","direction":"positive","underlyingIssue":"feeling satisfied with doctors\' willingness to listen to concerns","additionalInfo":"","preferredWording":"Their willingness to listen to all of your concerns?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T12:40:58.277","updateDate":"2016-06-16T12:52:37.87"},{"rank":null,"id":670,"code":"Q563","type":"question","description":"interest personally","direction":"positive","underlyingIssue":"feeling satisfied with doctors\'/nurses\' personal interest in the patient","additionalInfo":"","preferredWording":"The interest they showed in you personally?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:00:11.597","updateDate":"2016-06-16T12:53:39.697"},{"rank":null,"id":671,"code":"Q564","type":"question","description":"comfort support","direction":"positive","underlyingIssue":"feeling satisfied with the comfort and support provided by doctors/nurses","additionalInfo":"","preferredWording":"The comfort and support they gave you?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:01:13.75","updateDate":"2016-06-16T13:32:03.327"},{"rank":null,"id":672,"code":"Q565","type":"question","description":"information illness","direction":"positive","underlyingIssue":"feeling satisfied with information about illness received from doctors","additionalInfo":"","preferredWording":"The information they gave you about your illness?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:08:04.153","updateDate":"2016-06-16T13:33:34.247"},{"rank":null,"id":673,"code":"Q566","type":"question","description":"information medical test","direction":"positive","underlyingIssue":"feeling satisfied with information about medical tests provided by doctors/nurses","additionalInfo":"","preferredWording":"The information they gave you about your medical tests?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:09:11.317","updateDate":"2016-06-16T13:36:39.83"},{"rank":null,"id":674,"code":"Q567","type":"question","description":"information treatment","direction":"positive","underlyingIssue":"feeling satisfied with information about treatment provided by doctors/nurses","additionalInfo":"","preferredWording":"The information they gave you about your treatment?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:10:32.313","updateDate":"2016-06-16T13:37:16.68"},{"rank":null,"id":675,"code":"Q568","type":"question","description":"frequency visits consultations","direction":"positive","underlyingIssue":"feeling satisfied with frequency of doctors\' visits and consultations","additionalInfo":"","preferredWording":"The frequency of their visits/consultations?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:11:46.027","updateDate":"2016-06-16T13:37:56.257"},{"rank":null,"id":676,"code":"Q569","type":"question","description":"time visits consultations","direction":"positive","underlyingIssue":"feeling satisfied with time devoted by doctors to the patient during visits and consultations","additionalInfo":"","preferredWording":"The time they devoted to you during visits/consultations?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:18:21.987","updateDate":"2016-06-16T13:46:37.207"},{"rank":null,"id":677,"code":"Q570","type":"question","description":"physical examinations","direction":"negative","underlyingIssue":"feeling satisfied with how physical examinations were carried out by nurses","additionalInfo":"","preferredWording":"The way they carried out your physical examination (took your temperature, felt your pulse,…)?\\n","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:20:08.52","updateDate":"2016-06-16T13:47:49.123"},{"rank":null,"id":678,"code":"Q571","type":"question","description":"handle care","direction":"positive","underlyingIssue":"feeling satisfied with how nurses handled care","additionalInfo":"","preferredWording":"The way they handled your care (gave your medicines, performed injections,…)?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:24:34.31","updateDate":"2016-06-16T13:48:52.46"},{"rank":null,"id":679,"code":"Q572","type":"question","description":"attention physical comfort","direction":"positive","underlyingIssue":"feeling satisfied with nurses\' attention to physical comfort","additionalInfo":"","preferredWording":"The attention they paid to your physical comfort?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:25:33.717","updateDate":"2016-06-16T13:49:29.06"},{"rank":null,"id":680,"code":"Q573","type":"question","description":"human qualities","direction":"positive","underlyingIssue":"feeling satisfied with nurses\' human qualities","additionalInfo":"","preferredWording":"Their human qualities (politeness, respect, sensitivity, kindness, patience,…)?\\n","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:35:04.59","updateDate":"2016-06-16T13:50:10.34"},{"rank":null,"id":681,"code":"Q574","type":"question","description":"information care","direction":"positive","underlyingIssue":"feeling satisfied with information about care provided by nurses","additionalInfo":"","preferredWording":"The information they gave you about your care?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:37:46.133","updateDate":"2016-06-16T13:50:39.823"},{"rank":null,"id":682,"code":"Q575","type":"question","description":"prompt buzzer calls","direction":"positive","underlyingIssue":"feeling satisfied with nurses\' promptness in answering buzzer calls","additionalInfo":"","preferredWording":"Their promptness in answering your buzzer calls?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:39:59.563","updateDate":"2016-06-16T13:51:39.997"},{"rank":null,"id":683,"code":"Q576","type":"question","description":"time devoted","direction":"positive","underlyingIssue":"feeling satisfied with time devoted by nurses","additionalInfo":"","preferredWording":"The time they devoted to you?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:41:05.773","updateDate":"2016-06-16T13:52:19.107"},{"rank":null,"id":684,"code":"Q577","type":"question","description":"exchange information caregivers","direction":"positive","underlyingIssue":"feeling satisfied with exchange of information between caregivers","additionalInfo":"","preferredWording":"The exchange of information between caregivers?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:45:45.243","updateDate":"2016-06-16T13:52:46.967"},{"rank":null,"id":685,"code":"Q578","type":"question","description":"kind helpful technical reception laboratory","direction":"positive","underlyingIssue":"feeling satisfied with kindness/helpfulness of other hospital personnel","additionalInfo":"","preferredWording":"The kindness and helpfulness of the technical, reception, laboratory personnel?\\n","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:47:00.877","updateDate":"2016-06-16T13:53:35.407"},{"rank":null,"id":686,"code":"Q579","type":"question","description":"information admission hospital","direction":"positive","underlyingIssue":"feeling satisfied with information provided on admission to hospital","additionalInfo":"","preferredWording":"The information provided on your admission to the hospital?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:49:40.33","updateDate":"2016-06-16T13:54:47.263"},{"rank":null,"id":687,"code":"Q580","type":"question","description":"information discharge hospital","direction":"positive","underlyingIssue":"feeling satisfied with information provided on discharge from hospital","additionalInfo":"","preferredWording":"The information provided on your discharge from the hospital?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:55:36.567","updateDate":"2016-06-16T13:55:55.22"},{"rank":null,"id":688,"code":"Q581","type":"question","description":"waiting time results tests","direction":"negative","underlyingIssue":"feeling satisfied with waiting time for results of tests","additionalInfo":"","preferredWording":"The waiting time for obtaining results of medical tests?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:57:15.257","updateDate":"2016-06-16T14:01:26.683"},{"rank":null,"id":689,"code":"Q582","type":"question","description":"speed medical tests treatments","direction":"positive","underlyingIssue":"feeling satisfied with speed of implementing tests or treatments","additionalInfo":"","preferredWording":"The speed of implementing medical tests and/or treatments?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:58:28.953","updateDate":"2016-06-16T14:02:01.333"},{"rank":null,"id":690,"code":"Q583","type":"question","description":"ease access","direction":"positive","underlyingIssue":"feeling satisfied with ease of access","additionalInfo":"","preferredWording":"The ease of access (parking, means of transport,…)?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T13:59:25.803","updateDate":"2016-06-16T14:03:03.233"},{"rank":null,"id":691,"code":"Q584","type":"question","description":"ease find departments","direction":"positive","underlyingIssue":"feeling satisfied with ease of finding way to departments","additionalInfo":"","preferredWording":"The ease of finding one’s way to the different departments?","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T14:01:09.097","updateDate":"2016-06-16T14:03:39.38"},{"rank":null,"id":692,"code":"Q585","type":"question","description":"environment building","direction":"positive","underlyingIssue":"feeling satisfied with environment of the building","additionalInfo":"","preferredWording":"The environment of the building (cleanliness, spaciousness, calmness,…)?\\n","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T14:02:19.907","updateDate":"2016-06-16T14:04:22.703"},{"rank":null,"id":693,"code":"CS40","type":"condition","description":"if surgery for lung cancer","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please answer the following questions only if you had surgery for lung cancer:","recommendedWording":null,"questionnaires":[48],"categories":[],"createDate":"2016-03-04T14:52:11.07","updateDate":"2016-03-04T14:52:11.07"},{"rank":null,"id":697,"code":"Q586","type":"question","description":"allergic reactions","direction":"negative","underlyingIssue":"having allergic reactions","additionalInfo":"","preferredWording":"Have you had allergic reactions?","recommendedWording":null,"questionnaires":[48],"categories":[],"createDate":"2016-03-04T15:12:53.423","updateDate":"2016-06-16T14:06:07.43"},{"rank":null,"id":698,"code":"Q587","type":"question","description":"dizzy","direction":"negative","underlyingIssue":"feeling dizzy/light headed","additionalInfo":"","preferredWording":"Have you been dizzy?","recommendedWording":null,"questionnaires":[48],"categories":[],"createDate":"2016-03-04T15:15:05.56","updateDate":"2016-04-21T14:28:25.673"},{"rank":null,"id":699,"code":"Q588","type":"question","description":"split nails","direction":"negative","underlyingIssue":"having splitting fingernails or toenails","additionalInfo":"","preferredWording":"Have you had splitting fingernails or toenails?","recommendedWording":null,"questionnaires":[48],"categories":[],"createDate":"2016-03-04T15:17:32.72","updateDate":"2016-06-16T14:07:51.343"},{"rank":null,"id":700,"code":"Q589","type":"question","description":"afraid tumor progression","direction":"negative","underlyingIssue":"being afraid to tumor progression","additionalInfo":"","preferredWording":"Have you been afraid of tumor progression?","recommendedWording":null,"questionnaires":[48],"categories":[],"createDate":"2016-03-04T15:19:54.407","updateDate":"2016-06-16T14:08:53.56"},{"rank":null,"id":701,"code":"Q590","type":"question","description":"thin lifeless hair","direction":"negative","underlyingIssue":"having thin or lifeless hair","additionalInfo":"","preferredWording":"Have you had thin or lifeless hair as a result of your disease or treatment?","recommendedWording":null,"questionnaires":[48],"categories":[],"createDate":"2016-03-04T15:20:48.633","updateDate":"2016-06-16T14:09:14.887"},{"rank":null,"id":702,"code":"Q591","type":"question","description":"decrease physical capabilities","direction":"negative","underlyingIssue":"experiencing a decrease in physical capabilities","additionalInfo":"","preferredWording":"Have you experienced a decrease in your physical capabilities?\\n","recommendedWording":null,"questionnaires":[48],"categories":[],"createDate":"2016-03-04T15:21:58.463","updateDate":"2016-06-16T14:09:50.547"},{"rank":null,"id":703,"code":"Q592","type":"question","description":"pain area surgery","direction":"negative","underlyingIssue":"having pain in the area of surgery","additionalInfo":"","preferredWording":"Have you had pain in the area of surgery?","recommendedWording":null,"questionnaires":[48],"categories":[],"createDate":"2016-03-04T15:24:35.42","updateDate":"2016-06-16T14:10:16.773"},{"rank":null,"id":704,"code":"Q593","type":"question","description":"area wound oversensitive","direction":"negative","underlyingIssue":"the area of the wound being oversensitive","additionalInfo":"","preferredWording":"Has the area of your wound been oversensitive?","recommendedWording":null,"questionnaires":[48],"categories":[],"createDate":"2016-03-04T15:26:22.707","updateDate":"2016-06-16T14:11:25.167"},{"rank":null,"id":705,"code":"Q594","type":"question","description":"restricted performance surgery","direction":"negative","underlyingIssue":"being restricted in performance due to extent of surgery","additionalInfo":"","preferredWording":"Have you been restricted in your performance due to the extent of surgery? \\n","recommendedWording":null,"questionnaires":[48],"categories":[],"createDate":"2016-03-04T15:27:53.313","updateDate":"2016-06-16T14:12:01.983"},{"rank":null,"id":706,"code":"Q595","type":"question","description":"problem use arm shoulder operation","direction":"negative","underlyingIssue":"experiencing problems using arm or shoulder on the side of the operation","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems using your arm or shoulder on the side of the chest operation?</p>","preferredWording":"Have you had any difficulty using your arm or shoulder on the side of the chest operation?","recommendedWording":null,"questionnaires":[48],"categories":[],"createDate":"2016-03-04T15:29:11.707","updateDate":"2016-06-28T15:09:37.58"},{"rank":null,"id":707,"code":"Q596","type":"question","description":"scar pain daily activities","direction":"negative","underlyingIssue":"scar pain interfering with daily activities","additionalInfo":"","preferredWording":"Has your scar pain interfered with your daily activities?","recommendedWording":null,"questionnaires":[48],"categories":[],"createDate":"2016-03-04T15:30:15.403","updateDate":"2016-06-16T14:13:03.213"},{"rank":null,"id":708,"code":"RS6","type":"responseScale","description":"0-7 point scale","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Don\'t know/ Can\'t answer, Very poor, Excellent","recommendedWording":null,"questionnaires":[49,1000177,1000240],"categories":[],"createDate":"2016-03-07T09:42:10.433","updateDate":"2016-03-07T09:42:10.433"},{"rank":null,"id":709,"code":"IN25","type":"instructions","description":"more generally","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"This page focuses on your thoughts and feelings MORE GENERALLY.","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T09:42:56.75","updateDate":"2016-03-07T09:42:56.75"},{"rank":null,"id":710,"code":"CS41","type":"condition","description":"If \\"not at all\\"","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"If you answered BOTH items 22 AND 23 “Not at all” (option 1), please go to ITEM 27.\\nOtherwise, please continue.","recommendedWording":null,"questionnaires":[49,1000297],"categories":[],"createDate":"2016-03-07T09:43:37.78","updateDate":"2016-03-07T09:43:37.78"},{"rank":null,"id":711,"code":"IN26","type":"instructions","description":"Thank you","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Thank you for completing this measure.","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T09:44:00.917","updateDate":"2016-03-07T09:44:00.917"},{"rank":null,"id":712,"code":"CS42","type":"condition","description":"If further comments","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"If you would like to make any further comments, please write them below.","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T09:44:20.683","updateDate":"2016-03-07T09:44:20.683"},{"rank":null,"id":713,"code":"Q597","type":"question","description":"able deal with problems","direction":"positive","underlyingIssue":"feeling able to deal with problems","additionalInfo":"","preferredWording":"I have felt able to deal with problems","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T09:51:24.99","updateDate":"2016-06-16T14:13:22.06"},{"rank":null,"id":714,"code":"Q598","type":"question","description":"peace myself","direction":"positive","underlyingIssue":"feeling at peace with oneself","additionalInfo":"","preferredWording":"I have felt at peace with myself","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T09:53:04.94","updateDate":"2016-06-16T14:15:16.397"},{"rank":null,"id":715,"code":"Q599","type":"question","description":"find things enjoy","direction":"positive","underlyingIssue":"finding things one enjoys doing","additionalInfo":"","preferredWording":"I have been able to find things I enjoy doing","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T09:54:17.36","updateDate":"2016-06-16T14:14:29.453"},{"rank":null,"id":716,"code":"Q600","type":"question","description":"forgive things done","direction":"positive","underlyingIssue":"feeling able to forge oneself for the things done","additionalInfo":"","preferredWording":"I have felt able to forgive myself for things I have done","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T09:55:46.47","updateDate":"2016-06-16T14:15:00.407"},{"rank":null,"id":717,"code":"Q601","type":"question","description":"troubled","direction":"negative","underlyingIssue":"feeling troubled","additionalInfo":"","preferredWording":"I have felt troubled","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T09:57:10.417","updateDate":"2016-06-16T14:15:47.19"},{"rank":null,"id":718,"code":"Q602","type":"question","description":"lonely","direction":"negative","underlyingIssue":"feeling lonely","additionalInfo":"","preferredWording":"I have felt lonely","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T09:58:17.56","updateDate":"2016-06-16T14:16:13.307"},{"rank":null,"id":719,"code":"Q603","type":"question","description":"share thoughts life people close","direction":"positive","underlyingIssue":"feeling able to share thoughts about life with close people","additionalInfo":"","preferredWording":"I have felt able to share thoughts about life with people who are close to me","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T10:25:46.03","updateDate":"2016-06-16T14:16:44.633"},{"rank":null,"id":720,"code":"Q604","type":"question","description":"love close people","direction":"positive","underlyingIssue":"feeling loved by close people","additionalInfo":"","preferredWording":"I have felt loved by those who are important to me","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T10:27:54.72","updateDate":"2016-06-16T14:16:56.443"},{"rank":null,"id":721,"code":"Q605","type":"question","description":"someone talk feelings","direction":"positive","underlyingIssue":"feeling that there are people to talk about feelings","additionalInfo":"","preferredWording":"I have felt that I have someone to talk to about my feelings","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T10:32:47.823","updateDate":"2016-06-16T14:17:28.563"},{"rank":null,"id":722,"code":"Q606","type":"question","description":"trust others ","direction":"positive","underlyingIssue":"feeling able to trust others","additionalInfo":"","preferredWording":"I have felt able to trust others","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T10:47:47.62","updateDate":"2016-06-16T14:17:59.763"},{"rank":null,"id":723,"code":"Q607","type":"question","description":"forgive others ","direction":"positive","underlyingIssue":"feeling able to forgive others for things they have done","additionalInfo":"","preferredWording":"I have felt able to forgive others for things they have done","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T10:50:43.313","updateDate":"2016-06-16T14:18:21.37"},{"rank":null,"id":724,"code":"Q608","type":"question","description":"valuedperson","direction":"positive","underlyingIssue":"feeling valued as a person","additionalInfo":"","preferredWording":"I have felt that I am valued as a person","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T10:52:15.09","updateDate":"2016-06-16T14:18:43.913"},{"rank":null,"id":725,"code":"Q609","type":"question","description":"life fulfil","direction":"positive","underlyingIssue":"feeling that life is fulfilling","additionalInfo":"","preferredWording":"I have felt that my life is fulfilling","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T11:02:54.42","updateDate":"2016-06-16T14:19:08.11"},{"rank":null,"id":726,"code":"Q610","type":"question","description":"life worthwhile","direction":"positive","underlyingIssue":"feeling that life is worthwhile","additionalInfo":"","preferredWording":"I have felt that my life is worthwhile","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T11:03:51.72","updateDate":"2016-06-16T14:19:54.6"},{"rank":null,"id":727,"code":"Q611","type":"question","description":"plan future","direction":"positive","underlyingIssue":"feeling able to plan for future","additionalInfo":"","preferredWording":"I have felt able to plan for the future","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T11:04:45.853","updateDate":"2016-06-16T14:20:24.023"},{"rank":null,"id":728,"code":"Q612","type":"question","description":"worries concerns future","direction":"negative","underlyingIssue":"having worries or concerns about future","additionalInfo":"","preferredWording":"I have had worries and/or concerns about the future","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T11:05:56.01","updateDate":"2016-06-16T14:20:49.497"},{"rank":null,"id":729,"code":"Q613","type":"question","description":"wonder anything done","direction":"negative","underlyingIssue":"wondering if anything can be done","additionalInfo":"","preferredWording":"I have wondered whether anything can be done for me","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T11:07:36.01","updateDate":"2016-06-16T14:21:21.823"},{"rank":null,"id":730,"code":"Q614","type":"question","description":"felt unfair ill","direction":"negative","underlyingIssue":"feeling that being ill is unfair","additionalInfo":"","preferredWording":"I have felt that it is unfair that I am ill","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T11:09:17.273","updateDate":"2016-06-16T14:21:47.953"},{"rank":null,"id":731,"code":"Q615","type":"question","description":"time quietness prayer meditation","direction":"positive","underlyingIssue":"having time for quietness, prayer or meditation","additionalInfo":"","preferredWording":"I have had time for quietness, prayer or meditation","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T11:10:03.297","updateDate":"2016-06-16T14:22:18.17"},{"rank":null,"id":732,"code":"Q616","type":"question","description":"important others pray for me","direction":"positive","underlyingIssue":"feeling that it is important that others pray for the patient","additionalInfo":"","preferredWording":"I have felt that it is important that other people pray for me","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T11:13:02.25","updateDate":"2016-06-16T14:24:53.927"},{"rank":null,"id":733,"code":"Q617","type":"question","description":"believe god","direction":"positive","underlyingIssue":"believing in God or someone greater than oneself","additionalInfo":"","preferredWording":"I believe in God or in someone or something greater than myself","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T11:13:53.28","updateDate":"2016-06-16T14:25:40.807"},{"rank":null,"id":734,"code":"Q618","type":"question","description":"always believed god","direction":"positive","underlyingIssue":"having always believed in God or someone greater than oneself","additionalInfo":"","preferredWording":"I have always believed in God or in someone or something greater than myself","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T11:14:33.873","updateDate":"2016-06-16T14:25:31.943"},{"rank":null,"id":735,"code":"Q619","type":"question","description":"beliefs changed less well","direction":"negative","underlyingIssue":"one\'s beliefs having changed since feeling less well","additionalInfo":"","preferredWording":"My beliefs have changed since I have felt less well","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T11:15:59.957","updateDate":"2016-06-16T14:26:05.33"},{"rank":null,"id":736,"code":"Q620","type":"question","description":"beliefs changed last weeks","direction":"negative","underlyingIssue":"one\'s beliefs having changed in last weeks","additionalInfo":"","preferredWording":"My beliefs have changed in the last few weeks","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T11:17:25.51","updateDate":"2016-06-16T14:27:04.003"},{"rank":null,"id":737,"code":"Q621","type":"question","description":"connected god","direction":"positive","underlyingIssue":"feeling connected to God or someone greater than oneself","additionalInfo":"","preferredWording":"I feel connected to God or to someone or something greater than myself \\n","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T11:19:00.423","updateDate":"2016-06-16T14:28:23.363"},{"rank":null,"id":738,"code":"Q622","type":"question","description":"feel will live words, deeds, influence others","direction":"positive","underlyingIssue":"feeling that one will live on through words, deeds or influence on others","additionalInfo":"","preferredWording":"I feel that I will live on through my words, deeds and/or influence on other people  \\n","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T11:21:06.15","updateDate":"2016-06-16T14:28:14.813"},{"rank":null,"id":739,"code":"Q623","type":"question","description":"feelings life changed less well","direction":"none","underlyingIssue":"feelings about life having changed since feeling less well","additionalInfo":"","preferredWording":"My feelings about life have changed since I have felt less well","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T11:22:03.437","updateDate":"2016-06-16T14:28:50.82"},{"rank":null,"id":740,"code":"Q624","type":"question","description":" feelings life changed last weeks","direction":"none","underlyingIssue":" feelings about life having changed in last weeks","additionalInfo":"","preferredWording":"My feelings about life have changed in the last few weeks","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T11:23:13","updateDate":"2016-06-16T14:29:24.033"},{"rank":null,"id":741,"code":"Q625","type":"question","description":"life after death","direction":"positive","underlyingIssue":"believing in life after death","additionalInfo":"","preferredWording":"I believe in life after death","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T11:23:35.883","updateDate":"2016-06-16T14:29:44.69"},{"rank":null,"id":742,"code":"Q626","type":"question","description":"spiritual wellbeing","direction":"positive","underlyingIssue":"having spiritual wellbeing","additionalInfo":"","preferredWording":"I have spiritual wellbeing","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T11:24:08.117","updateDate":"2016-06-16T14:30:01.38"},{"rank":null,"id":743,"code":"Q627","type":"question","description":"global spiritual wellbeing","direction":"positive","underlyingIssue":"global spiritual wellbeing","additionalInfo":"","preferredWording":"How would you rate your overall spiritual wellbeing?","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T11:24:58.787","updateDate":"2016-06-16T14:30:24.097"},{"rank":null,"id":744,"code":"IN27","type":"instructions","description":"circle one number","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please circle ONE number below.","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-06-16T14:31:16.183","updateDate":"2016-06-16T14:31:16.183"},{"rank":null,"id":745,"code":"IN28","type":"instructions","description":"interested information aspects","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"We are interested in the information you have received about aspects of your disease and its treatment, in order to improve your health care.","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-06-16T15:19:30.09","updateDate":"2016-06-16T15:19:30.09"},{"rank":null,"id":746,"code":"TS7","type":"timeScale","description":"past week satisfied ","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"During the past week, how satisfied have you been with:","recommendedWording":null,"questionnaires":[18,1000177],"categories":[],"createDate":"2016-07-08T10:33:51.8","updateDate":"2016-07-08T10:33:51.8"},{"rank":null,"id":747,"code":"IN29","type":"instructions","description":"only one period","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please choose only one period of time.","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-08-12T11:28:06.023","updateDate":"2016-08-12T11:28:06.023"},{"rank":null,"id":748,"code":"RS7","type":"responseScale","description":"category HCPs","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Doctor(s), Nurse(s), Psychologist(s), Radiotherapy technician(s), Other (please specify: _____________)","recommendedWording":null,"questionnaires":[28,1000177,1000243],"categories":[],"createDate":"2016-08-12T11:40:29.123","updateDate":"2016-08-12T11:40:29.123"},{"rank":null,"id":749,"code":"RS8","type":"responseScale","description":"communication time","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"During the period of diagnosis, treatment, follow up","recommendedWording":null,"questionnaires":[1000250,28,1000177],"categories":[],"createDate":"2016-08-12T11:42:04.473","updateDate":"2016-08-12T11:42:04.473"},{"rank":null,"id":750,"code":"TS8","type":"timeScale","description":"generally","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"More generally:","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-09-14T14:13:20.237","updateDate":"2016-09-14T14:13:20.237"},{"rank":null,"id":751,"code":"Q628","type":"question","description":"PF problems lift cup glass mouth","direction":"negative","underlyingIssue":"experiencing problems lifting a full cup or glass to the mouth","additionalInfo":"","preferredWording":"Do you have any trouble lifting a full cup or glass to your mouth?","recommendedWording":null,"questionnaires":[50],"categories":[],"createDate":"2016-12-15T15:30:23.783","updateDate":"2016-12-15T15:33:55.563"},{"rank":null,"id":752,"code":"Q629","type":"question","description":"PF problems walk 100 m","direction":"negative","underlyingIssue":"experiencing problems walking 100 metres","additionalInfo":"","preferredWording":"Do you have any trouble walking 100 m?","recommendedWording":null,"questionnaires":[50],"categories":[],"createDate":"2016-12-15T15:33:39.167","updateDate":"2017-04-03T14:12:06.263"},{"rank":null,"id":753,"code":"Q630","type":"question","description":"PF need help footcare","direction":"negative","underlyingIssue":"needing help caring for one\'s feet","additionalInfo":null,"preferredWording":"Do you need help caring for your feet (e.g. cutting your toenails)?","recommendedWording":null,"questionnaires":[50],"categories":[],"createDate":"2016-12-15T15:37:23.983","updateDate":"2016-12-15T15:37:23.983"},{"rank":null,"id":754,"code":"Q631","type":"question","description":"PF problems walk up stairs","direction":"negative","underlyingIssue":"experiencing problems walking up a flight of stairs","additionalInfo":null,"preferredWording":"Do you have any trouble walking up a flight of stairs?","recommendedWording":null,"questionnaires":[50],"categories":[],"createDate":"2016-12-15T15:38:08.37","updateDate":"2016-12-15T15:38:08.37"},{"rank":null,"id":1000967,"code":"TS9","type":"timeScale","description":"test scale","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"test wording","recommendedWording":null,"questionnaires":[1000083],"categories":[],"createDate":"2017-03-03T10:07:52.833","updateDate":"2017-03-03T10:07:52.833"},{"rank":null,"id":1000968,"code":"Q632","type":"question","description":"lolipop","direction":"negative","underlyingIssue":"stress","additionalInfo":"","preferredWording":"it should be loss","recommendedWording":null,"questionnaires":[15],"categories":[],"createDate":"2017-03-03T10:10:46.187","updateDate":"2017-03-16T14:10:32.197"},{"rank":null,"id":1000969,"code":"Q633","type":"question","description":"lolipopopopo","direction":"negative","underlyingIssue":"stress","additionalInfo":null,"preferredWording":"don\'t worry","recommendedWording":null,"questionnaires":[44],"categories":[],"createDate":"2017-03-03T10:28:54.187","updateDate":"2017-03-03T10:28:54.187"},{"rank":null,"id":1000970,"code":"Q634","type":"question","description":"ok","direction":"negative","underlyingIssue":"ok","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[],"createDate":"2017-03-03T10:34:11.947","updateDate":"2017-03-03T10:34:11.947"},{"rank":null,"id":1000971,"code":"Q635","type":"question","description":"jkù","direction":"negative","underlyingIssue":"hnjk","additionalInfo":null,"preferredWording":"dfg","recommendedWording":null,"questionnaires":[44],"categories":[],"createDate":"2017-03-03T14:14:29.38","updateDate":"2017-03-03T14:14:29.38"},{"rank":null,"id":1000972,"code":"Q636","type":"question","description":"carry bags","direction":"negative","underlyingIssue":"stress","additionalInfo":null,"preferredWording":"tyuio","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2017-03-06T10:30:50.73","updateDate":"2017-03-06T10:30:50.73"},{"rank":null,"id":1000973,"code":"Q637","type":"question","description":"test q","direction":"negative","underlyingIssue":"stress","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[],"createDate":"2017-03-08T11:36:49.213","updateDate":"2017-03-08T11:36:49.213"},{"rank":null,"id":1000974,"code":"CS43","type":"condition","description":"test c","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[],"createDate":"2017-03-08T11:37:02.657","updateDate":"2017-03-08T11:37:02.657"},{"rank":null,"id":1000975,"code":"Q638","type":"question","description":"testq","direction":"negative","underlyingIssue":"testq","additionalInfo":null,"preferredWording":"testq","recommendedWording":null,"questionnaires":[5,1000177,1000231,1000236],"categories":[],"createDate":"2017-03-08T11:38:24.94","updateDate":"2017-03-08T11:38:24.94"},{"rank":null,"id":1000976,"code":"CS44","type":"condition","description":"testc","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[],"createDate":"2017-03-08T11:38:38.09","updateDate":"2017-03-08T11:38:38.09"},{"rank":null,"id":1000977,"code":"Q639","type":"question","description":"testqq","direction":"negative","underlyingIssue":"testqq","additionalInfo":"","preferredWording":"testqq","recommendedWording":null,"questionnaires":[1000231],"categories":[],"createDate":"2017-03-09T10:45:43.927","updateDate":"2017-03-31T16:55:14.697"},{"rank":null,"id":1000979,"code":"Q640","type":"question","description":"Test Keyword Autocompletion","direction":"negative","underlyingIssue":"stress","additionalInfo":"<h3>any other information worth mentioning...</h3>","preferredWording":"Test Keyword Autocompletion Wording","recommendedWording":null,"questionnaires":[13],"categories":[],"createDate":"2017-03-09T15:34:14.613","updateDate":"2017-03-09T16:21:55.633"},{"rank":null,"id":1000980,"code":"Q641","type":"question","description":"Test Code for Item","direction":"negative","underlyingIssue":"stress","additionalInfo":"Additonal Test Info","preferredWording":"Test Code for Item Wording","recommendedWording":null,"questionnaires":[13,1000124],"categories":[],"createDate":"2017-03-09T15:48:17.557","updateDate":"2017-03-10T15:52:59.383"},{"rank":null,"id":1000981,"code":"IN30","type":"instructions","description":"hello","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"fdsqdqdq","recommendedWording":null,"questionnaires":[5],"categories":[],"createDate":"2017-03-10T10:10:26.873","updateDate":"2017-03-10T10:28:04.953"},{"rank":null,"id":1000982,"code":"IN31","type":"instructions","description":"blabla","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[],"createDate":"2017-03-10T14:01:05.49","updateDate":"2017-03-10T14:01:26.74"},{"rank":null,"id":1000983,"code":"SS1","type":"symptomScale","description":"Systemic therapy side effects 31-34, 36-38","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Systemic therapy side effects","recommendedWording":null,"questionnaires":[5],"categories":[],"createDate":"2017-03-14T16:02:47.76","updateDate":"2017-03-14T16:02:47.76"},{"rank":null,"id":1000984,"code":"SS2","type":"symptomScale","description":"sympt","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"sympts","recommendedWording":null,"questionnaires":[5],"categories":[],"createDate":"2017-03-14T16:13:45.423","updateDate":"2017-03-14T16:13:45.423"},{"rank":null,"id":1000985,"code":"SS3","type":"symptomScale","description":"Test Symptom Scale","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Test Wording Symptom Scale","recommendedWording":null,"questionnaires":[13],"categories":[],"createDate":"2017-03-14T16:40:34.207","updateDate":"2017-03-14T16:40:34.207"},{"rank":null,"id":1000986,"code":"Q642","type":"question","description":"ICDcode","direction":"none","underlyingIssue":"stress","additionalInfo":"","preferredWording":"lolipop recommended","recommendedWording":"lolipop recommended","questionnaires":[1000124],"categories":[],"createDate":"2017-03-16T12:06:13.967","updateDate":"2017-03-17T17:53:53.597"},{"rank":null,"id":1000987,"code":"IN32","type":"instructions","description":"instr","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[],"createDate":"2017-03-16T12:12:25.117","updateDate":"2017-03-16T12:12:25.117"},{"rank":null,"id":1000988,"code":"SS4","type":"symptomScale","description":"clem","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"test","recommendedWording":null,"questionnaires":[20],"categories":[],"createDate":"2017-03-16T14:20:57.907","updateDate":"2017-03-16T14:20:57.907"},{"rank":null,"id":1000989,"code":"Q643","type":"question","description":"Test Recommended","direction":"positive","underlyingIssue":"stress, sex","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[],"createDate":"2017-03-17T17:30:06.373","updateDate":"2017-03-17T17:30:06.373"},{"rank":null,"id":1000990,"code":"Q644","type":"question","description":"test reco","direction":"none","underlyingIssue":"test reco","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[],"createDate":"2017-03-17T17:39:56.977","updateDate":"2017-03-17T17:39:56.977"},{"rank":null,"id":1000991,"code":"Q645","type":"question","description":"test 2 reco","direction":"negative","underlyingIssue":"stress","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[],"createDate":"2017-03-17T17:42:30.203","updateDate":"2017-03-17T17:42:30.203"},{"rank":null,"id":1000992,"code":"Q646","type":"question","description":"Alexis","direction":"positive","underlyingIssue":"stress","additionalInfo":"","preferredWording":"alexis recommended wording","recommendedWording":"alexis recommended wording 2","questionnaires":[15,18],"categories":[],"createDate":"2017-03-17T18:18:11.59","updateDate":"2017-03-17T18:22:07.023"},{"rank":null,"id":1000993,"code":"IN33","type":"instructions","description":"carry test","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[],"createDate":"2017-03-31T09:21:39.593","updateDate":"2017-03-31T09:21:39.593"},{"rank":null,"id":1000994,"code":"Q647","type":"question","description":"WHere","direction":"negative","underlyingIssue":"stress","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[],"createDate":"2017-03-31T09:23:30.187","updateDate":"2017-03-31T09:23:30.187"},{"rank":null,"id":1000995,"code":"Q648","type":"question","description":"azerty","direction":"negative","underlyingIssue":"azerty","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[],"createDate":"2017-04-21T13:35:11.47","updateDate":"2017-04-21T13:35:11.47"},{"rank":null,"id":1000996,"code":"Q649","type":"question","description":"test bug 379","direction":"positive","underlyingIssue":"rd","additionalInfo":null,"preferredWording":"test","recommendedWording":null,"questionnaires":[13],"categories":[],"createDate":"2017-04-24T15:24:55.31","updateDate":"2017-04-24T15:24:55.31"},{"rank":null,"id":1000997,"code":"CS45","type":"condition","description":"test bug","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[],"createDate":"2017-04-24T15:26:13.433","updateDate":"2017-04-24T15:26:13.433"},{"rank":null,"id":1000998,"code":"CS46","type":"condition","description":"Condition","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[],"createDate":"2017-04-24T15:31:14.693","updateDate":"2017-04-24T15:31:14.693"},{"rank":null,"id":1000999,"code":"CS47","type":"condition","description":"kjzehfkjzhfklz","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[],"createDate":"2017-04-24T15:32:30.51","updateDate":"2017-04-24T15:32:30.51"},{"rank":null,"id":1001001,"code":"Q650","type":"question","description":"zaeaze","direction":"negative","underlyingIssue":"azeaze","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[],"createDate":"2017-04-25T14:42:20.567","updateDate":"2017-04-25T14:42:20.567"},{"rank":null,"id":1001002,"code":"Q651","type":"question","description":"demo sprint 8 not translated item","direction":"negative","underlyingIssue":"stress","additionalInfo":null,"preferredWording":"demo sprint 8 not translated item","recommendedWording":null,"questionnaires":[1,1000240,1000243],"categories":[],"createDate":"2017-05-02T13:24:53.54","updateDate":"2017-05-02T13:24:53.54"},{"rank":null,"id":1001005,"code":"Q652","type":"question","description":"demo item code question","direction":"negative","underlyingIssue":"stress","additionalInfo":null,"preferredWording":"demo item code question","recommendedWording":null,"questionnaires":[5],"categories":[],"createDate":"2017-05-02T14:10:07.303","updateDate":"2017-05-02T14:10:07.303"},{"rank":null,"id":1001006,"code":"TS10","type":"timeScale","description":"demo item code timescale","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"demo item code timescale","recommendedWording":null,"questionnaires":[5,1000177],"categories":[],"createDate":"2017-05-02T14:10:30.903","updateDate":"2017-05-02T14:10:30.903"},{"rank":null,"id":1001007,"code":"IN34","type":"instructions","description":"New item Julien","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"New item Julien","recommendedWording":null,"questionnaires":[1000267,1000268],"categories":[],"createDate":"2018-09-28T16:51:16.68","updateDate":"2018-09-28T16:51:16.68"},{"rank":null,"id":1001008,"code":"Q653","type":"question","description":"New question Julien","direction":"positive","underlyingIssue":"No issue","additionalInfo":null,"preferredWording":"New question Julien","recommendedWording":null,"questionnaires":[1000267,1000271,1000272],"categories":[],"createDate":"2018-09-28T16:52:06.953","updateDate":"2018-09-28T16:52:06.953"},{"rank":null,"id":1001009,"code":"SS5","type":"symptomScale","description":"Test DS","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Test DS","recommendedWording":null,"questionnaires":[1000177,1000274],"categories":[],"createDate":"2018-10-02T16:38:01.96","updateDate":"2018-10-02T16:38:01.96"},{"rank":null,"id":1001010,"code":"Q654","type":"question","description":"Question_Kwa","direction":"positive","underlyingIssue":"test","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[],"createDate":"2019-04-19T15:57:48.457","updateDate":"2019-04-19T15:57:48.457"},{"rank":null,"id":1001011,"code":"Q655","type":"question","description":"Test translation","direction":"none","underlyingIssue":"test translation","additionalInfo":null,"preferredWording":"Test translation ?","recommendedWording":null,"questionnaires":[1000244],"categories":[],"createDate":"2019-04-29T14:48:02.977","updateDate":"2019-04-29T14:48:02.977"}]');
;// CONCATENATED MODULE: ./src/mocks/items/search/index.ts



/* harmony default export */ function search() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.get(resolvePath('/items/search'), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json(items_namespaceObject));
        }), 
    ];
};

// EXTERNAL MODULE: ./src/consts/paths/api/languages/index.ts
var languages = __webpack_require__(94890);
;// CONCATENATED MODULE: ./src/mocks/languages/get/languages.json
var languages_namespaceObject = JSON.parse('[{"code":"lang460","name":"Adb","id":460,"createDate":"2017-05-02T13:03:17.487","updateDate":"2017-05-02T13:03:17.487"},{"code":"af","name":"Afrikaans","id":1,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"af_NA","name":"Afrikaans (Namibia)","id":2,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"af_ZA","name":"Afrikaans (South Africa)","id":3,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ak","name":"Akan","id":4,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ak_GH","name":"Akan (Ghana)","id":5,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"sq","name":"Albanian","id":6,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"sq_AL","name":"Albanian (Albania)","id":7,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"am","name":"Amharic","id":8,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"am_ET","name":"Amharic (Ethiopia)","id":9,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ar","name":"Arabic","id":10,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ar_DZ","name":"Arabic (Algeria)","id":11,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ar_BH","name":"Arabic (Bahrain)","id":12,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ar_EG","name":"Arabic (Egypt)","id":13,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ar_IQ","name":"Arabic (Iraq)","id":14,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lang457","name":"Arabic (Israel)","id":457,"createDate":"2016-07-19T14:39:19.467","updateDate":"2016-07-19T14:39:19.467"},{"code":"ar_JO","name":"Arabic (Jordan)","id":15,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ar_KW","name":"Arabic (Kuwait)","id":16,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ar_LB","name":"Arabic (Lebanon)","id":17,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ar_LY","name":"Arabic (Libya)","id":18,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ar_MA","name":"Arabic (Morocco)","id":19,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ar_OM","name":"Arabic (Oman)","id":20,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ar_QA","name":"Arabic (Qatar)","id":21,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ar_SA","name":"Arabic (Saudi Arabia)","id":22,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ar_SD","name":"Arabic (Sudan)","id":23,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ar_SY","name":"Arabic (Syria)","id":24,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ar_TN","name":"Arabic (Tunisia)","id":25,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ar_AE","name":"Arabic (United Arab Emirates)","id":26,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ar_YE","name":"Arabic (Yemen)","id":27,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"hy","name":"Armenian","id":28,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"hy_AM","name":"Armenian (Armenia)","id":29,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"as","name":"Assamese","id":30,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"as_IN","name":"Assamese (India)","id":31,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"asa","name":"Asu","id":32,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"asa_TZ","name":"Asu (Tanzania)","id":33,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"az","name":"Azerbaijani","id":34,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"az_Cyrl","name":"Azerbaijani (Cyrillic)","id":35,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"az_Cyrl_AZ","name":"Azerbaijani (Cyrillic, Azerbaijan)","id":36,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"az_Latn","name":"Azerbaijani (Latin)","id":37,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"az_Latn_AZ","name":"Azerbaijani (Latin, Azerbaijan)","id":38,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"bm","name":"Bambara","id":39,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"bm_ML","name":"Bambara (Mali)","id":40,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"eu","name":"Basque","id":41,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"eu_ES","name":"Basque (Spain)","id":42,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"be","name":"Belarusian","id":43,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"be_BY","name":"Belarusian (Belarus)","id":44,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"bem","name":"Bemba","id":45,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"bem_ZM","name":"Bemba (Zambia)","id":46,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"bez","name":"Bena","id":47,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"bez_TZ","name":"Bena (Tanzania)","id":48,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"bn","name":"Bengali","id":49,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"bn_BD","name":"Bengali (Bangladesh)","id":50,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"bn_IN","name":"Bengali (India)","id":51,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lang459","name":"Blazer","id":459,"createDate":"2017-04-27T15:28:17.947","updateDate":"2017-04-27T15:28:17.947"},{"code":"bs","name":"Bosnian","id":52,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"bs_BA","name":"Bosnian (Bosnia and Herzegovina)","id":53,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"bg","name":"Bulgarian","id":54,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"bg_BG","name":"Bulgarian (Bulgaria)","id":55,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"my","name":"Burmese","id":56,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"my_MM","name":"Burmese (Myanmar [Burma])","id":57,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ca","name":"Catalan","id":58,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ca_ES","name":"Catalan (Spain)","id":59,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lang435","name":"Cebuano","id":435,"createDate":"2016-04-11T14:36:00.16","updateDate":"2016-04-11T14:36:00.16"},{"code":"tzm","name":"Central Morocco Tamazight","id":60,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"tzm_Latn","name":"Central Morocco Tamazight (Latin)","id":61,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"tzm_Latn_MA","name":"Central Morocco Tamazight (Latin, Morocco)","id":62,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"chr","name":"Cherokee","id":63,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"chr_US","name":"Cherokee (United States)","id":64,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"cgg","name":"Chiga","id":65,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"cgg_UG","name":"Chiga (Uganda)","id":66,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"zh","name":"Chinese","id":67,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"zh_Hans","name":"Chinese (Simplified Han)","id":68,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"zh_Hans_CN","name":"Chinese (Simplified Han, China)","id":69,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"zh_Hans_HK","name":"Chinese (Simplified Han, Hong Kong SAR China)","id":70,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"zh_Hans_MO","name":"Chinese (Simplified Han, Macau SAR China)","id":71,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"zh_Hans_SG","name":"Chinese (Simplified Han, Singapore)","id":72,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"zh_Hant","name":"Chinese (Traditional Han)","id":73,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"zh_Hant_HK","name":"Chinese (Traditional Han, Hong Kong SAR China)","id":74,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"zh_Hant_MO","name":"Chinese (Traditional Han, Macau SAR China)","id":75,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"zh_Hant_TW","name":"Chinese (Traditional Han, Taiwan)","id":76,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lang436","name":"Chinese Cantonese (Hong Kong)","id":436,"createDate":"2016-04-11T14:37:05.34","updateDate":"2016-04-11T14:37:05.34"},{"code":"lang437","name":"Chinese Mandarin (China)","id":437,"createDate":"2016-04-12T10:55:40.223","updateDate":"2016-04-12T10:55:40.223"},{"code":"lang438","name":"Chinese Mandarin (Malaysia)","id":438,"createDate":"2016-04-12T11:11:29.34","updateDate":"2016-04-12T11:11:29.34"},{"code":"lang439","name":"Chinese Mandarin (Singapore)","id":439,"createDate":"2016-04-12T11:24:39.517","updateDate":"2016-04-12T11:24:39.517"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)","id":440,"createDate":"2016-04-12T11:25:04.79","updateDate":"2016-04-12T11:25:04.79"},{"code":"kw","name":"Cornish","id":77,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"kw_GB","name":"Cornish (United Kingdom)","id":78,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"hr","name":"Croatian","id":79,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"hr_HR","name":"Croatian (Croatia)","id":80,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"cs","name":"Czech","id":81,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"cs_CZ","name":"Czech (Czech Republic)","id":82,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"da","name":"Danish","id":83,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"da_DK","name":"Danish (Denmark)","id":84,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"nl","name":"Dutch","id":85,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"nl_BE","name":"Dutch (Belgium)","id":86,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"nl_NL","name":"Dutch (Netherlands)","id":87,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ebu","name":"Embu","id":88,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ebu_KE","name":"Embu (Kenya)","id":89,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en","name":"English","id":90,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_AS","name":"English (American Samoa)","id":91,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_AU","name":"English (Australia)","id":92,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_BE","name":"English (Belgium)","id":93,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_BZ","name":"English (Belize)","id":94,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_BW","name":"English (Botswana)","id":95,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_CA","name":"English (Canada)","id":96,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_GU","name":"English (Guam)","id":97,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_HK","name":"English (Hong Kong SAR China)","id":98,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_IN","name":"English (India)","id":99,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_IE","name":"English (Ireland)","id":100,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_JM","name":"English (Jamaica)","id":101,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_MT","name":"English (Malta)","id":102,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_MH","name":"English (Marshall Islands)","id":103,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_MU","name":"English (Mauritius)","id":104,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_NA","name":"English (Namibia)","id":105,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_NZ","name":"English (New Zealand)","id":106,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_MP","name":"English (Northern Mariana Islands)","id":107,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_PK","name":"English (Pakistan)","id":108,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_PH","name":"English (Philippines)","id":109,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_SG","name":"English (Singapore)","id":110,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_ZA","name":"English (South Africa)","id":111,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_TT","name":"English (Trinidad and Tobago)","id":112,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_UM","name":"English (U.S. Minor Outlying Islands)","id":113,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_VI","name":"English (U.S. Virgin Islands)","id":114,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_GB","name":"English (United Kingdom)","id":115,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_US","name":"English (United States)","id":116,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"en_ZW","name":"English (Zimbabwe)","id":117,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"eo","name":"Esperanto","id":118,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"et","name":"Estonian","id":119,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"et_EE","name":"Estonian (Estonia)","id":120,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ee","name":"Ewe","id":121,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ee_GH","name":"Ewe (Ghana)","id":122,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ee_TG","name":"Ewe (Togo)","id":123,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fo","name":"Faroese","id":124,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fo_FO","name":"Faroese (Faroe Islands)","id":125,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fil","name":"Filipino","id":126,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fil_PH","name":"Filipino (Philippines)","id":127,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fi","name":"Finnish","id":128,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fi_FI","name":"Finnish (Finland)","id":129,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr","name":"French","id":130,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_BE","name":"French (Belgium)","id":131,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_BJ","name":"French (Benin)","id":132,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_BF","name":"French (Burkina Faso)","id":133,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_BI","name":"French (Burundi)","id":134,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_CM","name":"French (Cameroon)","id":135,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_CA","name":"French (Canada)","id":136,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_CF","name":"French (Central African Republic)","id":137,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_TD","name":"French (Chad)","id":138,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_KM","name":"French (Comoros)","id":139,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_CG","name":"French (Congo - Brazzaville)","id":140,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_CD","name":"French (Congo - Kinshasa)","id":141,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_CI","name":"French (Côte d’Ivoire)","id":142,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_DJ","name":"French (Djibouti)","id":143,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_GQ","name":"French (Equatorial Guinea)","id":144,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lang441","name":"French (Europe)","id":441,"createDate":"2016-04-12T11:26:11.343","updateDate":"2016-04-12T11:26:11.343"},{"code":"fr_FR","name":"French (France)","id":145,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_GA","name":"French (Gabon)","id":146,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_GP","name":"French (Guadeloupe)","id":147,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_GN","name":"French (Guinea)","id":148,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_LU","name":"French (Luxembourg)","id":149,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_MG","name":"French (Madagascar)","id":150,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_ML","name":"French (Mali)","id":151,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_MQ","name":"French (Martinique)","id":152,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_MC","name":"French (Monaco)","id":153,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_NE","name":"French (Niger)","id":154,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_RE","name":"French (Réunion)","id":155,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_RW","name":"French (Rwanda)","id":156,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_BL","name":"French (Saint Barthélemy)","id":157,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_MF","name":"French (Saint Martin)","id":158,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_SN","name":"French (Senegal)","id":159,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_CH","name":"French (Switzerland)","id":160,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fr_TG","name":"French (Togo)","id":161,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ff","name":"Fulah","id":162,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ff_SN","name":"Fulah (Senegal)","id":163,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"gl","name":"Galician","id":164,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"gl_ES","name":"Galician (Spain)","id":165,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lg","name":"Ganda","id":166,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lg_UG","name":"Ganda (Uganda)","id":167,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ka","name":"Georgian","id":168,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ka_GE","name":"Georgian (Georgia)","id":169,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"de","name":"German","id":170,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"de_AT","name":"German (Austria)","id":171,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"de_BE","name":"German (Belgium)","id":172,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"de_DE","name":"German (Germany)","id":173,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"de_LI","name":"German (Liechtenstein)","id":174,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"de_LU","name":"German (Luxembourg)","id":175,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"de_CH","name":"German (Switzerland)","id":176,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"el","name":"Greek","id":177,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"el_CY","name":"Greek (Cyprus)","id":178,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"el_GR","name":"Greek (Greece)","id":179,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lang442","name":"Greenlandic","id":442,"createDate":"2016-04-12T11:27:14.12","updateDate":"2016-04-12T11:27:14.12"},{"code":"gu","name":"Gujarati","id":180,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"gu_IN","name":"Gujarati (India)","id":181,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"guz","name":"Gusii","id":182,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"guz_KE","name":"Gusii (Kenya)","id":183,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ha","name":"Hausa","id":184,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ha_Latn","name":"Hausa (Latin)","id":185,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ha_Latn_GH","name":"Hausa (Latin, Ghana)","id":186,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ha_Latn_NE","name":"Hausa (Latin, Niger)","id":187,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ha_Latn_NG","name":"Hausa (Latin, Nigeria)","id":188,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"haw","name":"Hawaiian","id":189,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"haw_US","name":"Hawaiian (United States)","id":190,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"he","name":"Hebrew","id":191,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"he_IL","name":"Hebrew (Israel)","id":192,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"hi","name":"Hindi","id":193,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"hi_IN","name":"Hindi (India)","id":194,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"hu","name":"Hungarian","id":195,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"hu_HU","name":"Hungarian (Hungary)","id":196,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"is","name":"Icelandic","id":197,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"is_IS","name":"Icelandic (Iceland)","id":198,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ig","name":"Igbo","id":199,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ig_NG","name":"Igbo (Nigeria)","id":200,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lang443","name":"Iloko","id":443,"createDate":"2016-04-12T11:28:10.877","updateDate":"2016-04-12T11:28:10.877"},{"code":"id","name":"Indonesian","id":201,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"id_ID","name":"Indonesian (Indonesia)","id":202,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ga","name":"Irish","id":203,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ga_IE","name":"Irish (Ireland)","id":204,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"it","name":"Italian","id":205,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"it_IT","name":"Italian (Italy)","id":206,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"it_CH","name":"Italian (Switzerland)","id":207,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ja","name":"Japanese","id":208,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ja_JP","name":"Japanese (Japan)","id":209,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lang464","name":"Jonas Language","id":464,"createDate":"2021-06-04T11:16:40.9","updateDate":"2021-06-04T11:16:40.9"},{"code":"lang461","name":"Jth","id":461,"createDate":"2018-03-30T16:24:24.083","updateDate":"2018-03-30T16:24:24.083"},{"code":"kea","name":"Kabuverdianu","id":210,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"kea_CV","name":"Kabuverdianu (Cape Verde)","id":211,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"kab","name":"Kabyle","id":212,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"kab_DZ","name":"Kabyle (Algeria)","id":213,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"kl","name":"Kalaallisut","id":214,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"kl_GL","name":"Kalaallisut (Greenland)","id":215,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"kln","name":"Kalenjin","id":216,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"kln_KE","name":"Kalenjin (Kenya)","id":217,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"kam","name":"Kamba","id":218,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"kam_KE","name":"Kamba (Kenya)","id":219,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"kn","name":"Kannada","id":220,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"kn_IN","name":"Kannada (India)","id":221,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"kk","name":"Kazakh","id":222,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"kk_Cyrl","name":"Kazakh (Cyrillic)","id":223,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"kk_Cyrl_KZ","name":"Kazakh (Cyrillic, Kazakhstan)","id":224,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"km","name":"Khmer","id":225,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"km_KH","name":"Khmer (Cambodia)","id":226,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ki","name":"Kikuyu","id":227,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ki_KE","name":"Kikuyu (Kenya)","id":228,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"rw","name":"Kinyarwanda","id":229,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"rw_RW","name":"Kinyarwanda (Rwanda)","id":230,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lang453","name":"Kiswahili","id":453,"createDate":"2016-04-12T11:51:28.557","updateDate":"2016-04-12T11:51:28.557"},{"code":"kok","name":"Konkani","id":231,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"kok_IN","name":"Konkani (India)","id":232,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ko","name":"Korean","id":233,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ko_KR","name":"Korean (South Korea)","id":234,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"khq","name":"Koyra Chiini","id":235,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"khq_ML","name":"Koyra Chiini (Mali)","id":236,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ses","name":"Koyraboro Senni","id":237,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ses_ML","name":"Koyraboro Senni (Mali)","id":238,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lag","name":"Langi","id":239,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lag_TZ","name":"Langi (Tanzania)","id":240,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lv","name":"Latvian","id":241,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lv_LV","name":"Latvian (Latvia)","id":242,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lt","name":"Lithuanian","id":243,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lt_LT","name":"Lithuanian (Lithuania)","id":244,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"luo","name":"Luo","id":245,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"luo_KE","name":"Luo (Kenya)","id":246,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"luy","name":"Luyia","id":247,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"luy_KE","name":"Luyia (Kenya)","id":248,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"mk","name":"Macedonian","id":249,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"mk_MK","name":"Macedonian (Macedonia)","id":250,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"jmc","name":"Machame","id":251,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"jmc_TZ","name":"Machame (Tanzania)","id":252,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"kde","name":"Makonde","id":253,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"kde_TZ","name":"Makonde (Tanzania)","id":254,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"mg","name":"Malagasy","id":255,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"mg_MG","name":"Malagasy (Madagascar)","id":256,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ms","name":"Malay","id":257,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ms_BN","name":"Malay (Brunei)","id":258,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ms_MY","name":"Malay (Malaysia)","id":259,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lang454","name":"Malay (Singapore)","id":454,"createDate":"2016-04-14T09:04:12.263","updateDate":"2016-04-14T09:04:12.263"},{"code":"ml","name":"Malayalam","id":260,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ml_IN","name":"Malayalam (India)","id":261,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"mt","name":"Maltese","id":262,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"mt_MT","name":"Maltese (Malta)","id":263,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"gv","name":"Manx","id":264,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"gv_GB","name":"Manx (United Kingdom)","id":265,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"mr","name":"Marathi","id":266,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"mr_IN","name":"Marathi (India)","id":267,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"mas","name":"Masai","id":268,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"mas_KE","name":"Masai (Kenya)","id":269,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"mas_TZ","name":"Masai (Tanzania)","id":270,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lang463","name":"Mca","id":463,"createDate":"2021-05-28T16:40:59.82","updateDate":"2021-05-28T16:40:59.82"},{"code":"mer","name":"Meru","id":271,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"mer_KE","name":"Meru (Kenya)","id":272,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"mfe","name":"Morisyen","id":273,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"mfe_MU","name":"Morisyen (Mauritius)","id":274,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"naq","name":"Nama","id":275,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"naq_NA","name":"Nama (Namibia)","id":276,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ne","name":"Nepali","id":277,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ne_IN","name":"Nepali (India)","id":278,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ne_NP","name":"Nepali (Nepal)","id":279,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"nd","name":"North Ndebele","id":280,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"nd_ZW","name":"North Ndebele (Zimbabwe)","id":281,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lang452","name":"Norwegian","id":452,"createDate":"2016-04-12T11:50:09.49","updateDate":"2016-04-12T11:50:09.49"},{"code":"nb","name":"Norwegian Bokmål","id":282,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"nb_NO","name":"Norwegian Bokmål (Norway)","id":283,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"nn","name":"Norwegian Nynorsk","id":284,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"nn_NO","name":"Norwegian Nynorsk (Norway)","id":285,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"nyn","name":"Nyankole","id":286,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"nyn_UG","name":"Nyankole (Uganda)","id":287,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"or","name":"Oriya","id":288,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"or_IN","name":"Oriya (India)","id":289,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"om","name":"Oromo","id":290,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"om_ET","name":"Oromo (Ethiopia)","id":291,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"om_KE","name":"Oromo (Kenya)","id":292,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"lang455","name":"Pangasinan","id":455,"createDate":"2016-06-23T08:56:26.557","updateDate":"2016-06-23T08:56:26.557"},{"code":"ps","name":"Pashto","id":293,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"ps_AF","name":"Pashto (Afghanistan)","id":294,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fa","name":"Persian","id":295,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fa_AF","name":"Persian (Afghanistan)","id":296,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"fa_IR","name":"Persian (Iran)","id":297,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"pl","name":"Polish","id":298,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"pl_PL","name":"Polish (Poland)","id":299,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"pt","name":"Portuguese","id":300,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"pt_BR","name":"Portuguese (Brazil)","id":301,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"pt_GW","name":"Portuguese (Guinea-Bissau)","id":302,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"pt_MZ","name":"Portuguese (Mozambique)","id":303,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"},{"code":"pt_PT","name":"Portuguese (Portugal)","id":304,"createDate":"2016-02-25T09:09:26.88","updateDate":"2016-02-25T09:09:26.88"}]');
;// CONCATENATED MODULE: ./src/mocks/languages/get/index.ts




/* harmony default export */ function languages_get() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.get(resolvePath(languages/* languagesPath */.C), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json(languages_namespaceObject));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/questionnaires/addLanguage/index.ts




/* harmony default export */ function addLanguage() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.post(resolvePath("".concat(questionnairesPath/* default */.ZP, "/*").concat(languages/* languagesPath */.C)), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({}));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/questionnaires/deleteLanguage/index.ts



/* harmony default export */ function deleteLanguage() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest["delete"](resolvePath("".concat(questionnairesPath/* default */.ZP, "/*/languages/*")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({}));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/questionnaires/addToVerifiedLanguages/index.ts



/* harmony default export */ function addToVerifiedLanguages() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.post(resolvePath("".concat(questionnairesPath/* default */.ZP, "/*/languages")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({}));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/questionnaires/getWithTranslation/questionnaire.json
var getWithTranslation_questionnaire_namespaceObject = JSON.parse('{"id":13,"name":"Bladder","code":"BLM","type":"module","state":null,"phase":3,"gender":"nonSpecific","chemical":null,"description":"<h3 style=\\"font-family: Titillium, sans-serif; color: rgb(0, 0, 0);\\">QLQ-BLM30 Bladder module</h3><p>The QLQ-BLM30 Bladder module is a questionnaire to assess patient-reported outcomes in muscle-invasive bladder cancer. This module is to be used with the EORTC QLQ-C30 core questionnaire.<br></p><p>The BLM30 module has completed phase III.</p>","additionalInfo":"<h4><u>Scale structure</u></h4><p><b>Please note: This is a hypothesised scale structure. It has not undergone factor analysis</b><br /></p><ul><li>Urinary symptom 31-37</li><li>Urostomy problem 38-43</li><li>Single catheter use problem 44</li><li>Future perspective 45-47</li><li>Abdominal bloating and flatulence 48-49</li><li>Body image 50-52</li><li>Sexual functioning 53-60</li></ul>","contact":"dagmara.kulis@eortc.be","isCustom":false,"author":null,"questionsStartPosition":31,"questionnaireItems":[{"translations":[{"id":5538,"questionnaireItem":296,"questionnaire":0,"item":0,"language":"sv","wording":"Under veckan som gått:","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:30:21.44","updateDate":"2016-06-29T11:30:21.44"}],"item":{"code":"TS1","codePrefix":"TS","type":"timeScale","description":"past week","direction":null,"underlyingIssue":"","additionalInfo":"","recommendedWordings":[],"categories":null,"id":2,"createDate":"2016-02-02T11:56:24.837","updateDate":"2017-03-10T17:10:10.763"},"questionnaire":13,"position":1,"wording":"During the past week:","comment":null,"relatedQuestions":[320,310,321,322,323,325,326,331,339,340,341,342,343,344,345,347,348,350,351,352,832],"id":296,"createDate":"2016-02-29T12:52:53.277","updateDate":"2022-03-01T13:53:32.067"},{"translations":[{"id":5541,"questionnaireItem":295,"questionnaire":0,"item":0,"language":"sv","wording":"Inte alls, Lite, En hel del, Mycket","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:30:55.513","updateDate":"2016-06-29T11:30:55.513"}],"item":{"code":"RS1","codePrefix":"RS","type":"responseScale","description":"4-point Likert scale","direction":null,"underlyingIssue":"","additionalInfo":"","recommendedWordings":[],"categories":null,"id":3,"createDate":"2016-02-02T11:57:02.403","updateDate":"2017-03-10T17:10:42.057"},"questionnaire":13,"position":1,"wording":"Not at all, A little, Quite a bit, Very much","comment":null,"relatedQuestions":[325,322,320,323,326,321,340,341,343,344,345,347,350,351,353,354],"id":295,"createDate":"2016-02-29T12:51:53.683","updateDate":"2022-03-25T14:20:51.57"},{"translations":[],"item":{"code":"Q2","codePrefix":"Q","type":"question","description":"frequent urination day","direction":"negative","underlyingIssue":"havint to urinate frequently during the day","additionalInfo":"<p><u>Recommended wording: </u></p><p>Have you had to urinate frequently during the day?</p>","recommendedWordings":[{"item":4,"language":"en","wording":"Did you urinate frequently during the day?","id":1,"createDate":"2017-04-05T20:17:21.403","updateDate":"2017-04-05T20:17:21.403"}],"categories":null,"id":4,"createDate":"2016-02-10T11:25:09.97","updateDate":"2017-04-03T16:48:25.917"},"questionnaire":13,"position":1,"wording":"Have you had to urinate frequently during the day?","comment":null,"id":9152,"createDate":"2022-03-25T15:08:33.973","updateDate":"2022-03-25T15:08:51.683"},{"translations":[],"item":{"code":"Q4","codePrefix":"Q","type":"question","description":"PF carry bags","direction":"negative","underlyingIssue":"experiencing problems carrying heavy items","additionalInfo":null,"recommendedWordings":[{"item":7,"language":"fr_CA","wording":"Avez-vous des difficultés à faire certains efforts physiques pénibles comme porter un sac à provisions chargé ou une valise ?","id":38,"createDate":"2017-04-27T19:05:20.493","updateDate":"2017-04-27T19:05:20.493"}],"categories":null,"id":7,"createDate":"2016-02-10T11:39:32.283","updateDate":"2016-04-04T15:04:07.07"},"questionnaire":13,"position":37,"wording":"Do you have any trouble doing strenuous activities, like carrying a heavy shopping bag or a suitcase?","comment":null,"id":9089,"createDate":"2022-03-04T17:08:17.85","updateDate":"2022-03-04T17:08:17.85"},{"translations":[{"id":5539,"questionnaireItem":308,"questionnaire":0,"item":0,"language":"sv","wording":"Fortsätt på nästa sida","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:30:30.38","updateDate":"2016-06-29T11:30:30.38"}],"item":{"code":"IN4","codePrefix":"IN","type":"instructions","description":"next page","direction":null,"underlyingIssue":"","additionalInfo":"<h4>Recommended wording:</h4><p>Please continue to the next page</p>","recommendedWordings":[],"categories":null,"id":15,"createDate":"2016-02-10T15:21:39.32","updateDate":"2017-02-09T16:21:44.803"},"questionnaire":13,"position":3,"wording":"Please go on to the next page","comment":null,"relatedQuestions":[],"id":308,"createDate":"2016-02-29T13:07:06.693","updateDate":"2022-03-25T14:21:05.593"},{"translations":[],"item":{"code":"Q12","codePrefix":"Q","type":"question","description":"PA pain","direction":"negative","underlyingIssue":"experiencing pain","additionalInfo":"","recommendedWordings":[],"categories":null,"id":23,"createDate":"2016-02-17T15:31:21.943","updateDate":"2016-06-02T14:12:12.98"},"questionnaire":13,"position":34,"wording":"Have you had pain?","comment":null,"id":7688,"createDate":"2017-04-24T15:31:55.363","updateDate":"2017-04-24T15:31:55.363"},{"translations":[],"item":{"code":"Q32","codePrefix":"Q","type":"question","description":"global health status","direction":"positive","underlyingIssue":"global health status","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":43,"createDate":"2016-02-17T15:59:57.47","updateDate":"2016-04-04T15:45:28.08"},"questionnaire":13,"position":38,"wording":"How would you rate your overall health during the past week?","comment":null,"id":9156,"createDate":"2022-03-28T09:20:17.783","updateDate":"2022-03-28T09:20:17.783"},{"translations":[],"item":{"code":"Q32","codePrefix":"Q","type":"question","description":"global health status","direction":"positive","underlyingIssue":"global health status","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":43,"createDate":"2016-02-17T15:59:57.47","updateDate":"2016-04-04T15:45:28.08"},"questionnaire":13,"position":39,"wording":"How would you rate your overall health during the past week?","comment":null,"id":9157,"createDate":"2022-03-28T09:48:40.367","updateDate":"2022-03-28T09:48:40.367"},{"translations":[],"item":{"code":"Q32","codePrefix":"Q","type":"question","description":"global health status","direction":"positive","underlyingIssue":"global health status","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":43,"createDate":"2016-02-17T15:59:57.47","updateDate":"2016-04-04T15:45:28.08"},"questionnaire":13,"position":40,"wording":"How would you rate your overall health during the past week?","comment":null,"id":9158,"createDate":"2022-03-28T09:52:29.27","updateDate":"2022-03-28T09:52:29.27"},{"translations":[{"id":5564,"questionnaireItem":343,"questionnaire":0,"item":0,"language":"sv","wording":"Har du känt oro för din framtida hälsa?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q41","codePrefix":"Q","type":"question","description":"worry health in future","direction":"negative","underlyingIssue":"worrying about health in the future","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you worried about your health in the future?</p>","recommendedWordings":[{"item":53,"language":"en","wording":"Were you worried about your health in the future?","id":22,"createDate":"2016-02-18T11:46:37.84","updateDate":"2017-04-07T12:51:49.61"},{"item":53,"language":"ko","wording":"chin chan choun","id":24,"createDate":"2016-02-18T11:46:37.84","updateDate":"2017-04-07T12:43:52.95"}],"categories":null,"id":53,"createDate":"2016-02-18T11:46:37.807","updateDate":"2016-06-02T15:16:24.48"},"questionnaire":13,"position":14,"wording":"Were you worried about your health in the future?","comment":null,"id":343,"createDate":"2016-02-29T14:09:07.933","updateDate":"2016-05-17T11:04:37.37"},{"translations":[{"id":5579,"questionnaireItem":832,"questionnaire":0,"item":0,"language":"sv","wording":"Måste du skynda dig till toaletten när du kände att du behövde urinera?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q48","codePrefix":"Q","type":"question","description":"hurry to toilet","direction":"negative","underlyingIssue":"having to hurry to get to the toilet when feeling the urge to pass urine","additionalInfo":"","recommendedWordings":[],"categories":null,"id":60,"createDate":"2016-02-18T13:13:22.243","updateDate":"2016-06-24T11:27:14.913"},"questionnaire":13,"position":29,"wording":"When you felt the urge to pass urine, did you have to hurry to get to the toilet?\\n","comment":null,"id":832,"createDate":"2016-03-02T14:01:00.89","updateDate":"2016-03-02T14:01:12.933"},{"translations":[{"id":5553,"questionnaireItem":320,"questionnaire":0,"item":0,"language":"sv","wording":"Har du haft svårt att få tillräckligt med sömn för att du måste stiga upp ofta om natten och urinera?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q49","codePrefix":"Q","type":"question","description":"enough sleep urinate","direction":"negative","underlyingIssue":"experiencing problems with getting enough sleep because of having to get up frequently at night to urinate","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems getting enough sleep, because you needed to get up frequently at night to urinate?</p>","recommendedWordings":[],"categories":null,"id":61,"createDate":"2016-02-18T13:15:36.77","updateDate":"2016-06-28T11:28:55.257"},"questionnaire":13,"position":5,"wording":"Was it difficult for you to get enough sleep, because you needed to get up frequently at night to urinate?","comment":null,"id":320,"createDate":"2016-02-29T13:19:03.557","updateDate":"2022-03-09T12:31:17.193"},{"translations":[{"id":5554,"questionnaireItem":321,"questionnaire":0,"item":0,"language":"sv","wording":"Har det varit besvärligt att gå hemifrån, för att du måste vara i närheten av en toalett hela tiden?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q50","codePrefix":"Q","type":"question","description":"go out close to toilet","direction":"negative","underlyingIssue":"having problems getting out of the house because of having to be close to the toilet","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems going out of the house, because you needed to be close to a toilet?</p>","recommendedWordings":[],"categories":null,"id":62,"createDate":"2016-02-18T13:17:11.963","updateDate":"2016-06-28T11:38:20.46"},"questionnaire":13,"position":9,"wording":"Have you had difficulty going out of the house, because you needed to be close to a toilet?","comment":null,"id":321,"createDate":"2016-02-29T13:19:41.263","updateDate":"2022-03-14T15:29:23.807"},{"translations":[{"id":5567,"questionnaireItem":347,"questionnaire":0,"item":0,"language":"sv","wording":"Har du känt dig uppsvälld i buken?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q57","codePrefix":"Q","type":"question","description":"bloated feeling abdomen","direction":"negative","underlyingIssue":"having a bloated feeling in the abdomen","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had a bloated feeling in your abdomen?</p>","recommendedWordings":[],"categories":null,"id":71,"createDate":"2016-02-18T14:21:19.85","updateDate":"2016-06-03T13:27:26.473"},"questionnaire":13,"position":17,"wording":"Have you had a bloated feeling in your abdomen?","comment":null,"id":347,"createDate":"2016-02-29T14:25:26.717","updateDate":"2016-05-17T11:05:03.407"},{"translations":[{"id":5572,"questionnaireItem":353,"questionnaire":0,"item":0,"language":"sv","wording":"Har du varit intresserad av sex?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q73","codePrefix":"Q","type":"question","description":"interest in sex","direction":"positive","underlyingIssue":"being interested in sex","additionalInfo":"<p><u>Recommended wording: </u></p><p>Have you been interested in sex?</p>","recommendedWordings":[{"item":88,"language":"en","wording":"sdqfsqdfsdf","id":36,"createDate":"2017-04-21T12:19:18.913","updateDate":"2017-04-21T12:19:18.913"}],"categories":null,"id":88,"createDate":"2016-02-19T14:52:37.923","updateDate":"2017-03-16T19:27:29.457"},"questionnaire":13,"position":22,"wording":"To what extent were you interested in sex?","comment":null,"id":353,"createDate":"2016-02-29T14:55:01.58","updateDate":"2016-05-17T11:05:41.397"},{"translations":[],"item":{"code":"Q73","codePrefix":"Q","type":"question","description":"interest in sex","direction":"positive","underlyingIssue":"being interested in sex","additionalInfo":"<p><u>Recommended wording: </u></p><p>Have you been interested in sex?</p>","recommendedWordings":[{"item":88,"language":"en","wording":"sdqfsqdfsdf","id":36,"createDate":"2017-04-21T12:19:18.913","updateDate":"2017-04-21T12:19:18.913"}],"categories":null,"id":88,"createDate":"2016-02-19T14:52:37.923","updateDate":"2017-03-16T19:27:29.457"},"questionnaire":13,"position":35,"wording":"interest in sex","comment":null,"id":8957,"createDate":"2018-04-23T14:58:22.293","updateDate":"2018-04-23T14:58:22.293"},{"translations":[{"id":5573,"questionnaireItem":354,"questionnaire":0,"item":0,"language":"sv","wording":"Har du varit sexuellt aktiv (med eller utan samlag)?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q75","codePrefix":"Q","type":"question","description":"sexually active","direction":"positive","underlyingIssue":"being sexually active","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been sexually active (with or without intercourse)?</p>","recommendedWordings":[],"categories":null,"id":90,"createDate":"2016-02-19T14:54:21.903","updateDate":"2016-06-28T15:28:23.093"},"questionnaire":13,"position":23,"wording":"To what extent were you sexually active? (with or without intercourse)","comment":null,"id":354,"createDate":"2016-02-29T14:55:15.95","updateDate":"2016-02-29T14:55:15.95"},{"translations":[{"id":5574,"questionnaireItem":355,"questionnaire":0,"item":0,"language":"sv","wording":"Har du haft svårt att få eller bibehålla en erektion?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q78","codePrefix":"Q","type":"question","description":"problem erection","direction":"negative","underlyingIssue":"experiencing problems achieving or maintaining an erection","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems getting or maintaining an erection?</p>","recommendedWordings":[],"categories":null,"id":94,"createDate":"2016-02-19T15:13:33.663","updateDate":"2016-06-03T15:26:34.96"},"questionnaire":13,"position":24,"wording":"Did you have difficulty getting or maintaining an erection?","comment":null,"id":355,"createDate":"2016-02-29T14:55:36.73","updateDate":"2016-05-17T11:05:48.417"},{"translations":[{"id":5575,"questionnaireItem":357,"questionnaire":0,"item":0,"language":"sv","wording":"Har du haft problem med utlösning (t.ex. ”torr” utlösning, dvs orgasm utan sädesuttömning)?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q79","codePrefix":"Q","type":"question","description":"problem ejaculation","direction":"negative","underlyingIssue":"experiencing problems with ejaculation","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with ejaculation (e.g., dry ejaculation)?</p>","recommendedWordings":[],"categories":null,"id":95,"createDate":"2016-02-19T15:14:39.98","updateDate":"2016-06-03T15:27:31.247"},"questionnaire":13,"position":25,"wording":"Did you have ejaculation problems (e.g. dry ejaculation)?","comment":null,"id":357,"createDate":"2016-02-29T14:57:59.13","updateDate":"2016-05-17T11:05:53.157"},{"translations":[{"id":5576,"questionnaireItem":358,"questionnaire":0,"item":0,"language":"sv","wording":"Har du känt dig besvärad i sexuellt intima situationer?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q80","codePrefix":"Q","type":"question","description":"uncomfortable sexually intimate","direction":"negative","underlyingIssue":"feeling uncomfortable about being sexually intimate","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":96,"createDate":"2016-02-19T15:15:52.93","updateDate":"2016-04-05T12:56:58.12"},"questionnaire":13,"position":26,"wording":"Have you felt uncomfortable about being sexually intimate?","comment":null,"id":358,"createDate":"2016-02-29T14:59:19.163","updateDate":"2016-05-17T11:05:56.747"},{"translations":[{"id":5552,"questionnaireItem":310,"questionnaire":0,"item":0,"language":"sv","wording":"Har du behövt urinera ofta under natten?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q81","codePrefix":"Q","type":"question","description":"frequent urination night","direction":"negative","underlyingIssue":"having to urinate frequently at night","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had to urinate frequently during the night?</p>","recommendedWordings":[{"item":104,"language":"en","wording":"blabla","id":26,"createDate":"2017-04-07T13:47:37.253","updateDate":"2017-04-07T13:47:37.253"},{"item":104,"language":"lang441","wording":"blabla fr","id":47,"createDate":"2019-09-05T13:42:18.497","updateDate":"2019-09-05T13:42:59.797"}],"categories":null,"id":104,"createDate":"2016-02-25T09:53:52.523","updateDate":"2016-06-28T12:59:34.023"},"questionnaire":13,"position":2,"wording":"Have you had to urinate frequently at night?","comment":null,"id":310,"createDate":"2016-02-29T13:07:42.713","updateDate":"2022-03-25T15:09:07.593"},{"translations":[{"id":5577,"questionnaireItem":359,"questionnaire":0,"item":0,"language":"sv","wording":"Har du kunnat njuta av sex?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q85","codePrefix":"Q","type":"question","description":"sexual activity enjoyable","direction":"positive","underlyingIssue":"finding sexual activity enjoyable","additionalInfo":"<p><u>Recommended wording:</u></p><p>Has sexual activity been enjoyable for you?</p>","recommendedWordings":[],"categories":null,"id":108,"createDate":"2016-02-25T11:09:58.413","updateDate":"2016-06-03T15:32:27.373"},"questionnaire":13,"position":27,"wording":"To what extent was sex enjoyable for you?","comment":null,"id":359,"createDate":"2016-02-29T14:59:46.883","updateDate":"2016-02-29T14:59:46.883"},{"translations":[{"id":5548,"questionnaireItem":298,"questionnaire":0,"item":0,"language":"sv","wording":"Patienter berättar ibland att de har följande symptom.","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:31:49.88","updateDate":"2016-06-29T11:31:49.88"}],"item":{"code":"IN13","codePrefix":"IN","type":"instructions","description":"patients report","direction":null,"underlyingIssue":"","additionalInfo":"<h4>Recommended wording:</h4><p>Patients sometimes report that they have the following symptoms or problems.</p>","recommendedWordings":[{"item":119,"language":"en","wording":"Patients sometimes report that they have the following symptoms or problems.","id":56,"createDate":"2022-03-25T14:39:54.82","updateDate":"2022-03-25T14:39:54.82"}],"categories":null,"id":119,"createDate":"2016-02-25T11:26:11.347","updateDate":"2017-02-09T16:27:47.297"},"questionnaire":13,"position":1,"wording":"Patients sometimes report that they have the following symptoms or problems.","comment":null,"relatedQuestions":[],"id":298,"createDate":"2016-02-29T12:53:31.093","updateDate":"2022-03-02T10:00:28.22"},{"translations":[{"id":5550,"questionnaireItem":300,"questionnaire":0,"item":0,"language":"sv","wording":"Svara genom att ringa in den siffra som bäst passar in på dig.","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:32:02.173","updateDate":"2016-06-29T11:32:02.173"}],"item":{"code":"IN15","codePrefix":"IN","type":"instructions","description":"answer circling","direction":null,"underlyingIssue":"","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":121,"createDate":"2016-02-25T11:27:05.34","updateDate":"2016-02-25T11:27:05.34"},"questionnaire":13,"position":2,"wording":"Please answer by circling the number that best applies to you.","comment":null,"relatedQuestions":[],"id":300,"createDate":"2016-02-29T12:53:55.29","updateDate":"2016-02-29T12:53:55.29"},{"translations":[{"id":5542,"questionnaireItem":356,"questionnaire":0,"item":0,"language":"sv","wording":"Endast för män:","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:31:07.213","updateDate":"2016-06-29T11:31:07.213"}],"item":{"code":"CS1","codePrefix":"CS","type":"condition","description":"men only","direction":null,"underlyingIssue":"","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":141,"createDate":"2016-02-25T12:43:56.207","updateDate":"2016-02-25T12:43:56.207"},"questionnaire":13,"position":5,"wording":"For men only:","comment":null,"relatedQuestions":[355,357],"id":356,"createDate":"2016-02-29T14:55:58.57","updateDate":"2017-04-27T10:48:11.227"},{"translations":[{"id":5544,"questionnaireItem":304,"questionnaire":0,"item":0,"language":"sv","wording":"Besvara de följande 4 frågorna endast om du varit sexuellt aktiv de senaste 4 veckorna:","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:31:19.163","updateDate":"2016-06-29T11:31:24.793"}],"item":{"code":"CS3","codePrefix":"CS","type":"condition","description":"sexually active 4 weeks","direction":null,"underlyingIssue":"","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":143,"createDate":"2016-02-25T12:45:23.6","updateDate":"2016-02-25T12:45:23.6"},"questionnaire":13,"position":1,"wording":"Please answer the following 4 questions only if you have been sexually active during the past 4 weeks","comment":null,"relatedQuestions":[358,359,360],"id":304,"createDate":"2016-02-29T12:56:50.517","updateDate":"2022-03-28T13:18:41.057"},{"translations":[{"id":5543,"questionnaireItem":361,"questionnaire":0,"item":0,"language":"sv","wording":"Endast för kvinnor:","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:31:12.983","updateDate":"2016-06-29T11:31:12.983"}],"item":{"code":"CS4","codePrefix":"CS","type":"condition","description":"women only","direction":null,"underlyingIssue":"","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":146,"createDate":"2016-02-25T12:48:18.827","updateDate":"2016-02-25T12:48:18.827"},"questionnaire":13,"position":6,"wording":"For women only:","comment":null,"relatedQuestions":[360],"id":361,"createDate":"2016-02-29T15:00:47.803","updateDate":"2017-04-27T10:47:04.037"},{"translations":[{"id":5578,"questionnaireItem":360,"questionnaire":0,"item":0,"language":"sv","wording":"Har din slida känts torr eller har du haft andra problem under samlaget?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q109","codePrefix":"Q","type":"question","description":"dry vagina","direction":"negative","underlyingIssue":"having a dry vagina during sexual activity","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had a dry vagina during sexual activity?</p>","recommendedWordings":[],"categories":null,"id":147,"createDate":"2016-02-25T12:49:03.053","updateDate":"2016-06-28T11:49:23.197"},"questionnaire":13,"position":28,"wording":"Did you have a dry vagina or other problems during intercourse?\\n","comment":null,"id":360,"createDate":"2016-02-29T15:00:17.337","updateDate":"2016-02-29T15:00:29.287"},{"translations":[{"id":5569,"questionnaireItem":350,"questionnaire":0,"item":0,"language":"sv","wording":"Har du känt dig fysiskt mindre attraktiv som en följd av din sjukdom eller behandlingen?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q129","codePrefix":"Q","type":"question","description":"physically less attractive","direction":"negative","underlyingIssue":"feeling physically less attractive as a result of the disease or treatment","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt less physically attractive as a results of your disease or treatment?</p>","recommendedWordings":[],"categories":null,"id":169,"createDate":"2016-02-25T14:45:44.48","updateDate":"2017-03-31T16:57:43.893"},"questionnaire":13,"position":19,"wording":"Have you felt physically less attractive as a result of your illness or treatment?","comment":null,"id":350,"createDate":"2016-02-29T14:49:03.14","updateDate":"2016-05-17T11:05:21.583"},{"translations":[{"id":5570,"questionnaireItem":351,"questionnaire":0,"item":0,"language":"sv","wording":"Har du känt missnöje med din kropp?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q131","codePrefix":"Q","type":"question","description":"dissatisfied body","direction":"negative","underlyingIssue":"feeling dissatisfied with one\'s body","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt dissatisfied with your body as a result of your disease or treatment?</p>","recommendedWordings":[],"categories":null,"id":171,"createDate":"2016-02-25T14:48:00.75","updateDate":"2016-06-28T15:02:11.843"},"questionnaire":13,"position":20,"wording":"Have you been dissatisfied with your body?","comment":null,"id":351,"createDate":"2016-02-29T14:49:15.123","updateDate":"2016-05-17T11:05:25.577"},{"translations":[{"id":5547,"questionnaireItem":305,"questionnaire":0,"item":0,"language":"sv","wording":"BESVARA FRÅGORNA 31 - 37 ENDAST OM DU INTE HAR EN UROSTOMI","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:31:45.073","updateDate":"2016-06-29T11:31:45.073"}],"item":{"code":"CS9","codePrefix":"CS","type":"condition","description":"if no urostomy","direction":null,"underlyingIssue":"","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":225,"createDate":"2016-02-29T12:59:21.06","updateDate":"2016-02-29T12:59:47.253"},"questionnaire":13,"position":2,"wording":"PLEASE ANSWER QUESTIONS 31 - 37 ONLY IF YOU DO NOT HAVE A UROSTOMyy","comment":null,"relatedQuestions":[310,321,320,322,323,832],"id":305,"createDate":"2016-02-29T12:59:21.093","updateDate":"2022-03-22T13:51:22.137"},{"translations":[{"id":5546,"questionnaireItem":306,"questionnaire":0,"item":0,"language":"sv","wording":"VÄNLIGEN BESVARA FRÅGORNA 38 - 43 ENDAST OM DU HAR EN UROSTOMI","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:31:40.13","updateDate":"2016-06-29T11:31:40.13"}],"item":{"code":"CS10","codePrefix":"CS","type":"condition","description":"if urostomy","direction":null,"underlyingIssue":"","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":226,"createDate":"2016-02-29T13:04:51.073","updateDate":"2016-02-29T13:04:51.073"},"questionnaire":13,"position":3,"wording":"PLEASE ANSWER QUESTIONS 38 - 43 ONLY IF YOU HAVE A UROSTOMY","comment":null,"relatedQuestions":[325,339,326,331,340,341],"id":306,"createDate":"2016-02-29T13:04:51.093","updateDate":"2022-03-18T12:56:14.31"},{"translations":[{"id":5545,"questionnaireItem":307,"questionnaire":0,"item":0,"language":"sv","wording":"BESVARA FRÅGA 44 ENDAST OM DU HAR ANVÄNT EN KATETER UNDER VECKAN SOM GÅTT.","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:31:36.103","updateDate":"2016-06-29T11:31:36.103"}],"item":{"code":"CS11","codePrefix":"CS","type":"condition","description":"if catheter, during the past week","direction":null,"underlyingIssue":"","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":227,"createDate":"2016-02-29T13:05:39.733","updateDate":"2016-02-29T13:05:39.733"},"questionnaire":13,"position":4,"wording":"PLEASE ANSWER QUESTION 44 ONLY IF YOU HAVE USED A CATHETER DURING THE PAST WEEK","comment":null,"relatedQuestions":[310,320,321,340,342,352],"id":307,"createDate":"2016-02-29T13:05:39.767","updateDate":"2022-03-18T12:56:36.753"},{"translations":[{"id":5556,"questionnaireItem":323,"questionnaire":0,"item":0,"language":"sv","wording":"Har du känt smärta eller sveda i samband med urinering?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q176","codePrefix":"Q","type":"question","description":"pain burning feeling urinate","direction":"negative","underlyingIssue":"having pain/burning feeling when urinating","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had pain or a burning feeling when urinating?</p>","recommendedWordings":[],"categories":null,"id":233,"createDate":"2016-02-29T13:27:04.957","updateDate":"2016-06-24T11:25:17.737"},"questionnaire":13,"position":6,"wording":"Have you had pain or a burning feeling when urinating?","comment":null,"id":323,"createDate":"2016-02-29T13:27:05.007","updateDate":"2022-03-23T15:13:27.487"},{"translations":[{"id":5557,"questionnaireItem":325,"questionnaire":0,"item":0,"language":"sv","wording":"Har du haft urinläckage?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q178","codePrefix":"Q","type":"question","description":"urine bag leak","direction":"negative","underlyingIssue":"urostomy bag leaking","additionalInfo":"","recommendedWordings":[],"categories":null,"id":235,"createDate":"2016-02-29T13:32:56.5","updateDate":"2016-06-07T09:38:58.763"},"questionnaire":13,"position":3,"wording":"Has urine leaked from your urostomy bag??","comment":null,"id":325,"createDate":"2016-02-29T13:32:56.517","updateDate":"2022-03-22T13:51:47.61"},{"translations":[{"id":5558,"questionnaireItem":326,"questionnaire":0,"item":0,"language":"sv","wording":"Har du haft problem att sköta din urostomi?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q179","codePrefix":"Q","type":"question","description":"problem care urostomy","direction":"negative","underlyingIssue":"experiencing problems caring for the urostomy","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems with caring for your urostomy?</p>","recommendedWordings":[],"categories":null,"id":236,"createDate":"2016-02-29T13:34:00.01","updateDate":"2016-06-28T11:38:53.75"},"questionnaire":13,"position":8,"wording":"Did you have problems with caring for your urostomy?","comment":null,"id":326,"createDate":"2016-02-29T13:34:00.043","updateDate":"2016-05-17T11:03:45.56"},{"translations":[{"id":5559,"questionnaireItem":331,"questionnaire":0,"item":0,"language":"sv","wording":"Har huden runt urostomin varit irriterad?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q181","codePrefix":"Q","type":"question","description":"skin irritarion urostomy","direction":"negative","underlyingIssue":"having irritated skin around the urostomy","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has your skin been irritated around the urostomy?</p>","recommendedWordings":[],"categories":null,"id":238,"createDate":"2016-02-29T13:36:49.683","updateDate":"2016-06-28T11:39:36.513"},"questionnaire":13,"position":10,"wording":"Was your skin around the urostomy irritated?","comment":null,"id":331,"createDate":"2016-02-29T13:36:49.717","updateDate":"2016-05-17T11:03:53.783"},{"translations":[{"id":5560,"questionnaireItem":339,"questionnaire":0,"item":0,"language":"sv","wording":"Har du känt dig generad på grund av din urostomi?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q184","codePrefix":"Q","type":"question","description":"embarrassed urostomy","direction":"negative","underlyingIssue":"being embarrassed because of the urostomy","additionalInfo":"","recommendedWordings":[],"categories":null,"id":241,"createDate":"2016-02-29T13:53:55.313","updateDate":"2016-06-07T09:47:21.983"},"questionnaire":13,"position":7,"wording":"Have you felt embarrassed because of your urostomy?","comment":null,"id":339,"createDate":"2016-02-29T13:53:55.347","updateDate":"2022-03-14T15:29:24.883"},{"translations":[{"id":5561,"questionnaireItem":340,"questionnaire":0,"item":0,"language":"sv","wording":"Har du varit beroende av andra vid skötseln av din urostomi?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q185","codePrefix":"Q","type":"question","description":"dependent others urostomy care ","direction":"negative","underlyingIssue":"depending on others for urostomy care ","additionalInfo":"","recommendedWordings":[],"categories":null,"id":242,"createDate":"2016-02-29T13:56:41.443","updateDate":"2016-06-07T09:47:46.12"},"questionnaire":13,"position":11,"wording":"Have you been dependent on others for caring  for your urostomy?","comment":null,"id":340,"createDate":"2016-02-29T13:56:41.477","updateDate":"2016-05-17T11:04:16.53"},{"translations":[{"id":5562,"questionnaireItem":341,"questionnaire":0,"item":0,"language":"sv","wording":"Har du ofta varit tvungen att byta urostomipåsen?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q186","codePrefix":"Q","type":"question","description":"urostomy bag changes","direction":"negative","underlyingIssue":"having to frequently change the urostomy bag","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had to frequently change the urostomy bag?</p>","recommendedWordings":[],"categories":null,"id":243,"createDate":"2016-02-29T13:58:05.547","updateDate":"2016-06-07T09:51:28.89"},"questionnaire":13,"position":12,"wording":"Did you frequently have to change the urostomy bag?","comment":null,"id":341,"createDate":"2016-02-29T13:58:05.58","updateDate":"2016-05-17T11:04:21.63"},{"translations":[{"id":5563,"questionnaireItem":342,"questionnaire":0,"item":0,"language":"sv","wording":"Har du haft problem med att själv föra in katetern? (för att tömma ut urinen förs en kateter in i blåsan)","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q187","codePrefix":"Q","type":"question","description":"problem self-catheterization","direction":"negative","underlyingIssue":"experiencing problems with self-catheterization","additionalInfo":"","recommendedWordings":[],"categories":null,"id":244,"createDate":"2016-02-29T14:08:26.763","updateDate":"2016-06-03T13:50:22.313"},"questionnaire":13,"position":13,"wording":"Have you had problems with self-catheterization? (inserting a tube in the bladder to pass urine)","comment":null,"id":342,"createDate":"2016-02-29T14:08:26.797","updateDate":"2016-05-17T11:04:26.95"},{"translations":[{"id":5565,"questionnaireItem":344,"questionnaire":0,"item":0,"language":"sv","wording":"Har du oroat dig för resultaten av undersökningarna och testerna?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q188","codePrefix":"Q","type":"question","description":"worry results","direction":"negative","underlyingIssue":"worrying about results of examinations and tests","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about the results of examinations and tests?</p>","recommendedWordings":[],"categories":null,"id":245,"createDate":"2016-02-29T14:12:13.267","updateDate":"2016-06-28T14:35:55.75"},"questionnaire":13,"position":15,"wording":"Did you worry about the results of examinations and tests?","comment":null,"id":344,"createDate":"2016-02-29T14:12:13.287","updateDate":"2016-05-17T11:04:46.903"},{"translations":[{"id":5566,"questionnaireItem":345,"questionnaire":0,"item":0,"language":"sv","wording":"Har du oroat dig för eventuella framtida behandlingar?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q189","codePrefix":"Q","type":"question","description":"worry future treatments","direction":"negative","underlyingIssue":"worrying about possible future treatments","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about possible future treatments?</p>","recommendedWordings":[],"categories":null,"id":246,"createDate":"2016-02-29T14:15:34.67","updateDate":"2016-06-07T09:55:42.347"},"questionnaire":13,"position":16,"wording":"Did you worry about possible future treatments?","comment":null,"id":345,"createDate":"2016-02-29T14:15:34.72","updateDate":"2016-05-17T11:04:53.783"},{"translations":[{"id":5568,"questionnaireItem":348,"questionnaire":0,"item":0,"language":"sv","wording":"Har du haft väderspänningar eller gasbildning?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q190","codePrefix":"Q","type":"question","description":"flatulence","direction":"negative","underlyingIssue":"having flatulence/gas","additionalInfo":"","recommendedWordings":[],"categories":null,"id":247,"createDate":"2016-02-29T14:38:38.54","updateDate":"2016-06-07T09:56:12.987"},"questionnaire":13,"position":18,"wording":"Have you had flatulence or gas?","comment":null,"id":348,"createDate":"2016-02-29T14:38:38.57","updateDate":"2016-05-17T11:05:15.497"},{"translations":[{"id":5571,"questionnaireItem":352,"questionnaire":0,"item":0,"language":"sv","wording":"Har du känt dig mindre kvinnlig/manlig som en följd\\tav din sjukdom eller behandlingen?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q191","codePrefix":"Q","type":"question","description":"less feminine/masculine ","direction":"negative","underlyingIssue":"feeling less feminine/masculine","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt less masculine/feminine as a result of your disease or treatment?</p>","recommendedWordings":[],"categories":null,"id":248,"createDate":"2016-02-29T14:54:06.867","updateDate":"2017-02-16T12:18:13.02"},"questionnaire":13,"position":21,"wording":"Have you felt less feminine/masculine as a result of your illness or treatment?","comment":null,"id":352,"createDate":"2016-02-29T14:54:06.9","updateDate":"2016-05-17T11:05:31.427"},{"translations":[{"id":5580,"questionnaireItem":865,"questionnaire":0,"item":0,"language":"sv","wording":"Har du oroat dig för att du skulle kunna smitta din partner genom sexuell kontakt pga. den behandling av urinblåsetumören som du får?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q192","codePrefix":"Q","type":"question","description":"worry contaminate bladder treatment","direction":"negative","underlyingIssue":"worrying about possible contamination of the partner during sexual contact with the bladder treatment","additionalInfo":"","recommendedWordings":[],"categories":null,"id":249,"createDate":"2016-02-29T15:04:22.763","updateDate":"2016-06-07T10:06:07.217"},"questionnaire":13,"position":30,"wording":"Have you worried that you may contaminate your partner during sexual contact with the \\tbladder treatment you have been receiving?","comment":null,"id":865,"createDate":"2016-03-02T14:26:14.053","updateDate":"2016-05-17T11:06:01.457"},{"translations":[],"item":{"code":"Q230","codePrefix":"Q","type":"question","description":"pain discomfort anus","direction":"none","underlyingIssue":"experiencing pain/discomfort around the anus","additionalInfo":"","recommendedWordings":[],"categories":null,"id":288,"createDate":"2016-03-01T10:32:28.247","updateDate":"2022-03-29T10:40:50.96"},"questionnaire":13,"position":36,"wording":"Have you had pain /discomfort around your anal opening (back passsssssage)?","comment":null,"id":9016,"createDate":"2021-04-08T12:59:01.397","updateDate":"2021-04-08T12:59:01.397"},{"translations":[{"id":5555,"questionnaireItem":322,"questionnaire":0,"item":0,"language":"sv","wording":"Har du haft urinläckage?","comment":null,"gender":"nonSpecific","createDate":"2016-06-29T11:36:04.227","updateDate":"2016-06-29T11:36:04.227"}],"item":{"code":"Q454","codePrefix":"Q","type":"question","description":"leak urine","direction":"negative","underlyingIssue":"having leaking of urine","additionalInfo":"","recommendedWordings":[],"categories":null,"id":543,"createDate":"2016-03-03T12:48:03.337","updateDate":"2016-06-15T11:36:48.437"},"questionnaire":13,"position":4,"wording":"Have you had any unintentional release (leakage) of urine?","comment":null,"id":322,"createDate":"2016-02-29T13:19:52.51","updateDate":"2022-03-22T13:51:38.61"},{"translations":[],"item":{"code":"Q640","codePrefix":"Q","type":"question","description":"Test Keyword Autocompletion","direction":"negative","underlyingIssue":"stress","additionalInfo":"<h3>any other information worth mentioning...</h3>","recommendedWordings":[],"categories":null,"id":1000979,"createDate":"2017-03-09T15:34:14.613","updateDate":"2017-03-09T16:21:55.633"},"questionnaire":13,"position":31,"wording":"Test Keyword Autocompletion Wording","comment":null,"id":7463,"createDate":"2017-03-09T15:34:14.59","updateDate":"2017-03-14T17:01:11.273"},{"translations":[],"item":{"code":"Q641","codePrefix":"Q","type":"question","description":"Test Code for Item","direction":"negative","underlyingIssue":"stress","additionalInfo":"Additonal Test Info","recommendedWordings":[],"categories":null,"id":1000980,"createDate":"2017-03-09T15:48:17.557","updateDate":"2017-03-10T15:52:59.383"},"questionnaire":13,"position":32,"wording":"Test Code for Item Wording","comment":null,"id":7464,"createDate":"2017-03-09T15:48:17.573","updateDate":"2017-03-14T17:01:07.233"},{"translations":[],"item":{"code":"SS3","codePrefix":"SS","type":"symptomScale","description":"Test Symptom Scale","direction":null,"underlyingIssue":"","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":1000985,"createDate":"2017-03-14T16:40:34.207","updateDate":"2017-03-14T16:40:34.207"},"questionnaire":13,"position":1,"wording":"Test Wording Symptom Scale","comment":null,"relatedQuestions":[320,321,322,323,325,326,331,339],"id":7469,"createDate":"2017-03-14T16:40:34.123","updateDate":"2022-03-02T10:00:41.713"},{"translations":[],"item":{"code":"Q649","codePrefix":"Q","type":"question","description":"test bug 379","direction":"positive","underlyingIssue":"rd","additionalInfo":null,"recommendedWordings":[],"categories":null,"id":1000996,"createDate":"2017-04-24T15:24:55.31","updateDate":"2017-04-24T15:24:55.31"},"questionnaire":13,"position":33,"wording":"test","comment":null,"id":7684,"createDate":"2017-04-24T15:24:55.373","updateDate":"2017-04-24T15:24:55.373"}],"languages":[{"code":"en","name":"English"},{"code":"sv","name":"Swedish"}]}');
;// CONCATENATED MODULE: ./src/mocks/questionnaires/getWithTranslation/index.ts




/* harmony default export */ function getWithTranslation() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.get(resolvePath("".concat(questionnairesPath/* default */.ZP, "/*/details/sv")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json(getWithTranslation_questionnaire_namespaceObject));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/questionnaires/bulkAddTranslations/index.ts



/* harmony default export */ function bulkAddTranslations() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.post(resolvePath("".concat(questionnairesPath/* default */.ZP, "/*/translations/bulk-update")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({}));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/questionnaires/updateQuestionnaire/index.ts



/* harmony default export */ function updateQuestionnaire() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 0 : _delay;
    return [
        rest.put(resolvePath("".concat(questionnairesPath/* default */.ZP, "/*")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({
                name: 'asking for publish',
                code: null,
                type: 'module',
                state: 'published',
                phase: null,
                gender: 'nonSpecific',
                chemical: '',
                description: '',
                additionalInfo: null,
                contact: null,
                isCustom: true,
                author: 37,
                questionsStartPosition: null,
                questionnaireItems: [
                    {
                        questionnaire: 1000177,
                        item: 25,
                        position: 1,
                        wording: 'Have you had trouble sleeping?',
                        comment: null,
                        relatedQuestions: [],
                        id: 8960,
                        createDate: '2018-09-28T12:00:32.84',
                        updateDate: '2018-09-28T12:00:32.84'
                    },
                    {
                        questionnaire: 1000177,
                        item: 1000975,
                        position: 2,
                        wording: 'testq',
                        comment: null,
                        relatedQuestions: [],
                        id: 8962,
                        createDate: '2018-09-28T12:06:37.88',
                        updateDate: '2018-09-28T12:06:37.88'
                    },
                    {
                        questionnaire: 1000177,
                        item: 1001009,
                        position: 1,
                        wording: 'Test DS',
                        comment: null,
                        relatedQuestions: [],
                        id: 8968,
                        createDate: '2018-10-02T16:38:02.217',
                        updateDate: '2018-10-02T16:38:02.217'
                    }, 
                ],
                languages: [
                    {
                        code: 'af',
                        name: 'Afrikaans'
                    },
                    {
                        code: 'en',
                        name: 'English'
                    },
                    {
                        code: 'eo',
                        name: 'Esperanto'
                    },
                    {
                        code: 'lang441',
                        name: 'French (Europe)'
                    }, 
                ],
                id: 1000177,
                createDate: '2017-04-21T18:45:53.697',
                updateDate: '2022-02-21T15:05:23.493'
            }));
        }), 
    ];
};

// EXTERNAL MODULE: ./src/consts/paths/api/authors/index.ts
var authors = __webpack_require__(74781);
;// CONCATENATED MODULE: ./src/mocks/questionnaires/authors/authors.json
var authors_namespaceObject = JSON.parse('[{"id":77,"email":"alexis.debontridder+3@gmail.com","name":"Alexis Debontriddder (Com)"},{"id":1,"email":"adb@emakina.com","name":"Alexis Debontridder"},{"id":75,"email":"alexis.debontridder+1@gmail.com","name":"Alexis Debontridder (Academic)"},{"id":52,"email":"alexis.debontridder@gmail.com","name":"Alexis Debontridder (Content)"},{"id":76,"email":"alexis.debontridder+2@gmail.com","name":"Alexis Debontridder (Dev)"},{"id":60,"email":"alexis.debontridder+10@gmail.com","name":"Alexis Debontridder (Request)"},{"id":20,"email":"big.brother@world.com","name":"Big Brother"},{"id":72,"email":"bbr@emakina.com","name":"Bo Bracquez"},{"id":27,"email":"csi@emakina.com","name":"Cédric Simon"},{"id":62,"email":"cle@emakina.com","name":"Christophe Leemans"},{"id":67,"email":"cle1@emakina.com","name":"CLE - Content Manager"},{"id":36,"email":"clb@emakina.com","name":"Clémence Braun"},{"id":3,"email":"dagmara.kulis@eortc.be","name":"Dagmara Kulis"},{"id":56,"email":"dks@emakina.com","name":"Derrick Sanya"},{"id":57,"email":"gco@emakina.com","name":"Gilles Coomans"},{"id":70,"email":"hpe@emakina.com","name":"Hugues Peeters"},{"id":55,"email":"jth@emakina.com","name":"Julien Theys"},{"id":63,"email":"kwa@emakina.com","name":"Kéren"},{"id":65,"email":"kwa@emakina2.com","name":"Kéren Kwa"},{"id":64,"email":"kwa@emakina1.com","name":"Kéren Request Manager"},{"id":2,"email":"mca@emakina.com","name":"Mathieu Callewaert"},{"id":54,"email":"nol@emakina.com","name":"Noé Lebrun"},{"id":61,"email":"pru@emakina.com","name":"Pierre Rusin"},{"id":11,"email":"rwa@emakina.com","name":"Richardinov Popovskaïa W."},{"id":68,"email":"slecomte@emakina.com","name":"Serge Lecomte"},{"id":58,"email":"saj@emakina.com","name":"Simon Ajzenman"},{"id":59,"email":"tha@emakina.com","name":"Tina Hargot "},{"id":69,"email":"yno@emakina.com","name":"Yasmina"},{"id":37,"email":"ykh@emakina.com","name":"Younes Kh\'Leeh"},{"id":73,"email":"zoc@emakina.com","name":"Zoran Obradovic (admin)"},{"id":74,"email":"z.obradovic@emakina.rs","name":"Zoran Test"}]');
;// CONCATENATED MODULE: ./src/mocks/questionnaires/authors/index.ts




/* harmony default export */ function questionnaires_authors() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.get(resolvePath(authors/* default */.Z), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json(authors_namespaceObject));
        }), 
    ];
};

// EXTERNAL MODULE: ./src/consts/paths/api/items/recommendedWording/index.ts
var recommendedWording = __webpack_require__(12580);
;// CONCATENATED MODULE: ./src/mocks/items/setRecommendedWording/index.ts




/* harmony default export */ function setRecommendedWording() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 0 : _delay;
    return [
        rest.post(resolvePath("".concat(getItems/* default */.Z, "/*").concat(recommendedWording/* default */.Z)), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({
                item: 15,
                language: 'en',
                wording: 'Please go on to the next page',
                id: 60,
                createDate: '2022-04-29T06:50:26.8088909+00:00',
                updateDate: '2022-04-29T06:50:26.8088909+00:00'
            }));
        }), 
    ];
};

// EXTERNAL MODULE: ./src/consts/paths/api/questionnaires/bulkAddQuestionnaireItemsPath.ts
var bulkAddQuestionnaireItemsPath = __webpack_require__(85944);
;// CONCATENATED MODULE: ./src/mocks/questionnaires/bulkAddQuestionnaireItems/index.ts



/* harmony default export */ function bulkAddQuestionnaireItems() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.post(resolvePath("".concat(bulkAddQuestionnaireItemsPath/* default */.Z)), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({}));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/questionnaires/editTranslation/index.ts



/* harmony default export */ function editTranslation() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.post(resolvePath("".concat(questionnaireItemsPath/* default */.Z, "/*/translations")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({
                name: 'sadsad',
                code: null,
                type: 'itemlist',
                state: 'draft',
                phase: null,
                gender: 'female',
                chemical: 'asdsad',
                description: 'asdsad',
                additionalInfo: null,
                contact: null,
                isCustom: true,
                author: 73,
                questionsStartPosition: 1,
                languages: [
                    {
                        code: 'en',
                        name: 'English'
                    }
                ],
                id: 1000288,
                createDate: '2022-02-09T12:36:19.7441355+00:00',
                updateDate: '2022-02-09T12:36:19.7441355+00:00'
            }));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/items/delete/index.ts



/* harmony default export */ function items_delete() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest["delete"](resolvePath("".concat(getItems/* default */.Z, "/*")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({}));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/items/updateRecommendedWording/index.ts




/* harmony default export */ function updateRecommendedWording() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 500 : _delay;
    return [
        rest.put(resolvePath("".concat(getItems/* default */.Z, "/*").concat(recommendedWording/* default */.Z, "/*")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json({}));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/usage/usage.json
var usage_namespaceObject = JSON.parse('{"numberOfQuestionnaires":15,"numberOfQuestionItems":300}');
// EXTERNAL MODULE: ./src/consts/paths/api/usage/index.ts
var usage = __webpack_require__(91070);
;// CONCATENATED MODULE: ./src/mocks/usage/index.ts




/* harmony default export */ function mocks_usage() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 2500 : _delay;
    return [
        rest.get(resolvePath(usage/* default */.Z), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json(usage_namespaceObject));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/search/generalSearch.json
var generalSearch_namespaceObject = JSON.parse('[{"type":"questionnaire","object":{"rank":160,"id":58,"name":"CAT Appetite","code":"CAT AP","type":"cat","state":null,"phase":4,"gender":"nonSpecific","chemical":null,"description":"","additionalInfo":"","contact":"itemlibrary@eortc.org","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":7,"languages":[{"code":"ar_JO","name":"Arabic (Jordan)"},{"code":"da","name":"Danish"},{"code":"de","name":"German"},{"code":"en","name":"English"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"fr_CA","name":"French (Canada)"},{"code":"hu","name":"Hungarian"},{"code":"it","name":"Italian"},{"code":"ja","name":"Japanese"},{"code":"lang440","name":"Chinese Mandarin (Taiwan)"},{"code":"lang441","name":"French (Europe)"},{"code":"nl","name":"Dutch"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"ru","name":"Russian"},{"code":"sv","name":"Swedish"},{"code":"tr","name":"Turkish"}],"createDate":"2017-03-08T14:55:50.68","updateDate":"2018-12-14T11:56:10.083"},"rank":160},{"type":"questionnaire","object":{"rank":160,"id":89,"name":"Anal","code":"ANL","type":"module","state":"draft","phase":3,"gender":"nonSpecific","chemical":null,"description":"function(){ return e.getContents.apply(e, arguments); }","additionalInfo":"<p><br></p>","contact":"itemlibrary@eortc.org","isCustom":false,"author":null,"questionsStartPosition":31,"numQuestions":29,"languages":[{"code":"da","name":"Danish"},{"code":"de","name":"German"},{"code":"el","name":"Greek"},{"code":"en","name":"English"},{"code":"es_ES","name":"Spanish (Spain)"},{"code":"es_US","name":"Spanish (United States)"},{"code":"it","name":"Italian"},{"code":"lang441","name":"French (Europe)"},{"code":"lang452","name":"Norwegian"},{"code":"nl","name":"Dutch"},{"code":"pl","name":"Polish"},{"code":"pt_BR","name":"Portuguese (Brazil)"},{"code":"pt_PT","name":"Portuguese (Portugal)"},{"code":"sv","name":"Swedish"},{"code":"tr","name":"Turkish"}],"createDate":"2017-08-30T12:00:14.647","updateDate":"2022-04-27T09:53:36.367"},"rank":160},{"type":"questionnaire","object":{"rank":160,"id":652,"name":"ADBC - Official #1- Test 20/5","code":"ADB3","type":"catshort","state":null,"phase":5,"gender":"male","chemical":null,"description":"","additionalInfo":"","contact":"alexis.debontridder@gmail.com","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":8,"languages":[{"code":"en","name":"English"}],"createDate":"2022-03-24T15:18:45.947","updateDate":"2022-07-07T13:52:17.62"},"rank":160},{"type":"questionnaire","object":{"rank":160,"id":703,"name":"ADBCE Module","code":"ADBCE","type":"module","state":"draft","phase":5,"gender":"nonSpecific","chemical":null,"description":"<p><br></p>","additionalInfo":"<p><br></p>","contact":"alexis.debontridder@gmail.com","isCustom":false,"author":null,"questionsStartPosition":1,"numQuestions":0,"languages":[{"code":"en","name":"English"}],"createDate":"2022-06-01T10:43:08.02","updateDate":"2022-06-29T15:26:22.57"},"rank":160},{"type":"item","object":{"rank":100,"id":17,"code":"Q8","type":"question","description":"PF13 need stay bed chair ","direction":"negative","underlyingIssue":"needing stay in bed or chair during the day","additionalInfo":"","preferredWording":"Do you need to stay in bed or a chair during the day?","recommendedWording":null,"questionnaires":[4,46,50,111,130,143,639,648,674,675,676,607,611,617,627,634,635,549,552,561,564,589,605,502,525,538,543,545,546,436,444,450,457,483,487,415,416,423,427,428,431,343,356,359,381,405,407,309,317,332,334,335,340,278,290,295,299,305,307,206,216,217,234,238,253,144,145,146,182,192,200],"categories":[101],"createDate":"2016-02-10T15:25:53.66","updateDate":"2020-03-05T10:27:49.133"},"rank":100},{"type":"item","object":{"rank":100,"id":18,"code":"Q9","type":"question","description":"PF05 help with daily living","direction":"negative","underlyingIssue":"needing help with basic daily activities","additionalInfo":"","preferredWording":"Do you need help with eating, dressing, washing yourself or using the toilet?","recommendedWording":null,"questionnaires":[4,46,50,111,130,143,676,634,635,639,648,674,675,589,605,607,611,617,627,545,546,549,552,561,564,487,502,507,525,538,543,431,436,444,450,457,483,413,415,416,423,427,428,343,356,359,381,405,407,309,317,332,334,335,340,278,290,295,299,305,307,206,216,217,234,238,253,144,145,146,182,192,200],"categories":[101,2],"createDate":"2016-02-10T15:30:12.49","updateDate":"2020-03-05T10:28:33.063"},"rank":100},{"type":"item","object":{"rank":100,"id":21,"code":"Q10","type":"question","description":"RF10 limit hobbies leisure","direction":"negative","underlyingIssue":"being limited in pursuing hobbies or leisure activities","additionalInfo":"","preferredWording":"Were you limited in pursuing your hobbies or other leisure time activities?","recommendedWording":null,"questionnaires":[4,52,111,130,143,144,634,635,648,674,675,676,589,605,607,611,617,627,546,549,552,561,564,565,483,499,525,538,543,545,427,428,429,436,444,457,381,405,407,415,416,423,332,334,335,340,343,359,290,295,299,305,307,317,146,192,200,216,217,253],"categories":[],"createDate":"2016-02-10T15:53:15.727","updateDate":"2017-02-20T15:16:00.983"},"rank":100},{"type":"item","object":{"rank":100,"id":22,"code":"Q11","type":"question","description":"DY06 short of breath","direction":"negative","underlyingIssue":"being short of breath","additionalInfo":"","preferredWording":"Were you short of breath?","recommendedWording":"Have you been short of breath?","questionnaires":[4,46,60,111,130,143,674,675,676,701,635,643,645,646,648,605,607,611,614,627,634,546,549,552,560,564,589,506,517,525,538,543,545,461,483,485,487,493,500,429,436,438,444,450,457,413,415,416,423,425,428,343,345,347,356,381,392,305,307,332,334,335,340,212,216,240,290,295,299,144,146,162,182,183,206],"categories":[32],"createDate":"2016-02-17T15:30:47.37","updateDate":"2020-02-18T15:49:47.37"},"rank":100},{"type":"item","object":{"rank":100,"id":23,"code":"Q12","type":"question","description":"PA16 pain","direction":"negative","underlyingIssue":"experiencing pain","additionalInfo":"","preferredWording":"Have you had pain?","recommendedWording":null,"questionnaires":[4,18,46,56,111,130,648,674,675,676,605,611,627,630,634,635,545,546,549,552,564,589,506,507,509,510,525,538,457,461,483,487,493,500,428,429,436,438,444,450,406,413,415,416,423,425,356,364,375,381,392,405,332,334,335,340,343,347,233,290,295,299,305,307,143,144,146,182,187,216],"categories":[98],"createDate":"2016-02-17T15:31:21.943","updateDate":"2020-03-06T14:28:08.673"},"rank":100},{"type":"item","object":{"rank":100,"id":24,"code":"Q13","type":"question","description":"FA27 need rest","direction":"negative","underlyingIssue":"needing to rest","additionalInfo":"","preferredWording":"Did you need to rest?","recommendedWording":null,"questionnaires":[4,55,94,102,111,130,674,675,676,611,614,627,634,635,648,549,552,564,589,605,607,510,525,538,543,545,546,483,487,493,502,506,509,429,436,438,444,450,457,405,415,416,423,425,428,335,340,343,345,375,381,295,299,305,307,332,334,217,235,237,238,246,290,143,144,146,187,206,216],"categories":[50],"createDate":"2016-02-17T15:32:17.387","updateDate":"2020-02-27T12:43:45.293"},"rank":100},{"type":"item","object":{"rank":100,"id":25,"code":"Q14","type":"question","description":"SL05 problem sleeping","direction":"negative","underlyingIssue":"experiencing problems sleeping","additionalInfo":"","preferredWording":"Have you had trouble sleeping?","recommendedWording":null,"questionnaires":[4,46,59,111,674,675,676,635,639,643,645,646,589,605,607,611,627,634,538,545,546,549,552,564,483,487,493,517,525,429,436,444,450,457,413,414,415,416,423,335,340,343,356,375,381,299,305,307,332,334,235,240,290,295,182,216,129,130,143,144,146],"categories":[136],"createDate":"2016-02-17T15:41:48.197","updateDate":"2020-03-05T11:53:48.74"},"rank":100},{"type":"item","object":{"rank":100,"id":26,"code":"Q15","type":"question","description":"FA22 weak","direction":"negative","underlyingIssue":"feeling weak","additionalInfo":"","preferredWording":"Have you felt weak?","recommendedWording":null,"questionnaires":[4,675,676,634,635,639,648,674,605,607,611,614,617,627,564,589,538,545,546,549,552,506,509,510,525,483,487,493,502,429,436,438,444,450,457,416,423,425,428,356,375,381,392,415,332,334,335,340,343,290,295,299,305,307,238,240,246,186,206,216,217,235,237,146,182,111,130,143,144,46,55,94,102],"categories":[50,70],"createDate":"2016-02-17T15:43:45.95","updateDate":"2020-02-27T12:44:24.433"},"rank":100},{"type":"item","object":{"rank":100,"id":27,"code":"Q16","type":"question","description":"AP04 appetite loss","direction":"negative","underlyingIssue":"experiencing appetite loss","additionalInfo":"","preferredWording":"Have you lacked appetite?","recommendedWording":null,"questionnaires":[4,46,58,94,102,111,643,645,646,674,675,676,614,627,634,635,639,561,564,589,605,607,611,525,538,545,546,549,552,497,500,506,507,509,510,444,457,461,483,487,493,415,416,423,429,436,438,375,381,392,404,405,410,334,335,340,343,347,356,290,295,299,305,307,332,235,237,238,240,249,279,144,146,182,206,212,216,123,124,127,128,130,143],"categories":[35],"createDate":"2016-02-17T15:47:58.603","updateDate":"2020-02-18T14:33:28.423"},"rank":100},{"type":"item","object":{"rank":100,"id":28,"code":"Q17","type":"question","description":"NV01 nausea","direction":"negative","underlyingIssue":"feeling nauseated","additionalInfo":"","preferredWording":"Have you felt nauseated?","recommendedWording":null,"questionnaires":[4,46,57,111,130,143,675,676,635,639,643,645,646,674,607,611,614,627,630,634,552,560,561,564,589,605,509,510,525,538,545,549,483,487,493,497,500,506,436,438,444,450,457,461,405,410,415,416,423,429,345,356,375,381,391,404,307,332,334,335,340,343,240,249,290,295,299,305,144,146,156,182,212,216],"categories":[87],"createDate":"2016-02-17T15:48:32.033","updateDate":"2020-02-27T14:33:02.763"},"rank":100},{"type":"item","object":{"rank":100,"id":30,"code":"Q19","type":"question","description":"CO09 constipation","direction":"negative","underlyingIssue":"experiencing constipation","additionalInfo":"","preferredWording":"Have you been constipated?","recommendedWording":null,"questionnaires":[4,46,674,675,676,634,635,639,643,645,646,605,607,611,614,627,630,545,549,552,564,589,507,525,538,483,487,497,500,444,450,457,461,410,415,416,423,429,436,340,356,375,381,391,332,334,335,290,295,299,305,307,216,240,249,146,166,170,182,197,61,111,130,143,144],"categories":[10],"createDate":"2016-02-17T15:49:14.91","updateDate":"2020-02-18T15:22:53.127"},"rank":100},{"type":"item","object":{"rank":100,"id":31,"code":"Q20","type":"question","description":"DI12 diarrhea","direction":"negative","underlyingIssue":"experiencing diarrhea","additionalInfo":"","preferredWording":"Have you had diarrhea?","recommendedWording":null,"questionnaires":[4,62,111,130,143,144,643,645,646,674,675,676,611,614,627,630,634,635,552,560,564,589,605,607,510,525,538,545,546,549,483,487,496,497,507,509,416,423,429,436,444,457,340,375,381,404,410,415,299,305,307,332,334,335,235,237,240,249,290,295,146,162,166,170,197,216],"categories":[11],"createDate":"2016-02-17T15:49:53.79","updateDate":"2020-02-18T15:32:08.46"},"rank":100},{"type":"item","object":{"rank":100,"id":32,"code":"Q21","type":"question","description":"FA17 tired","direction":"negative","underlyingIssue":"feeling tired","additionalInfo":"","preferredWording":"Were you tired?","recommendedWording":null,"questionnaires":[4,46,55,94,648,650,674,675,676,607,611,614,627,634,635,549,552,560,564,589,605,509,510,525,538,545,546,483,487,493,502,506,507,436,438,444,450,457,461,415,416,423,425,428,429,392,405,410,413,414,345,347,356,375,381,332,334,335,340,343,246,290,295,299,305,307,216,217,235,237,238,240,144,146,182,206,208,102,111,130,143],"categories":[50],"createDate":"2016-02-17T15:50:18.033","updateDate":"2020-02-27T12:45:08.207"},"rank":100},{"type":"item","object":{"rank":100,"id":33,"code":"Q22","type":"question","description":"PA14 pain interfere daily activities","direction":"negative","underlyingIssue":"experiencing pain that interferes with daily activities","additionalInfo":"","preferredWording":"Did pain interfere with your daily activities?","recommendedWording":null,"questionnaires":[4,46,56,111,123,124,676,634,635,639,648,674,675,589,605,611,617,627,630,538,545,546,549,552,564,461,483,487,509,510,525,428,429,436,444,450,457,381,405,415,416,423,425,335,336,340,343,356,375,295,299,305,307,332,334,147,182,216,233,241,290,127,128,130,143,144,146],"categories":[],"createDate":"2016-02-17T15:51:06.623","updateDate":"2017-09-28T09:43:51.58"},"rank":100},{"type":"item","object":{"rank":100,"id":34,"code":"Q23","type":"question","description":"CF11 problems concentrate","direction":"negative","underlyingIssue":"experiencing problems concentrating on things","additionalInfo":"","preferredWording":"Have you had difficulty in concentrating on things, like reading a newspaper or watching television?","recommendedWording":null,"questionnaires":[4,53,111,130,143,144,646,674,675,676,627,634,635,642,643,645,552,564,589,605,611,617,507,525,538,544,545,549,436,450,457,461,483,487,405,413,415,416,423,429,334,335,340,343,375,381,295,299,305,307,317,332,146,208,216,217,240,290],"categories":[18],"createDate":"2016-02-17T15:51:57.463","updateDate":"2020-02-18T14:40:07.223"},"rank":100},{"type":"item","object":{"rank":100,"id":36,"code":"Q25","type":"question","description":"EF19 worry","direction":"negative","underlyingIssue":"worrying","additionalInfo":"","preferredWording":"Did you worry?","recommendedWording":null,"questionnaires":[4,51,111,129,130,143,674,675,676,605,611,617,627,634,635,538,545,549,552,564,589,457,483,507,509,510,525,423,427,429,431,436,444,375,381,405,413,415,416,332,334,335,340,343,365,290,295,299,305,307,317,144,146,216,217,224,276],"categories":[41],"createDate":"2016-02-17T15:57:25.7","updateDate":"2020-02-27T11:59:29.283"},"rank":100},{"type":"item","object":{"rank":100,"id":37,"code":"Q26","type":"question","description":"EF17 irritable","direction":"negative","underlyingIssue":"feeling irritable","additionalInfo":"","preferredWording":"Did you feel irritable?","recommendedWording":null,"questionnaires":[4,51,111,130,143,144,676,617,627,634,635,674,675,549,552,564,589,605,611,483,509,510,525,538,545,427,429,431,436,444,457,381,405,413,415,416,423,332,334,335,340,343,375,290,295,299,305,307,317,146,216,217,224,240,276],"categories":[40],"createDate":"2016-02-17T15:57:47.793","updateDate":"2020-02-27T12:00:11.373"},"rank":100},{"type":"item","object":{"rank":100,"id":40,"code":"Q29","type":"question","description":"SF10 PC/MT interference family life","direction":"negative","underlyingIssue":"feeling that physical condition or treatment interfere with family life","additionalInfo":"","preferredWording":"Has your physical condition or medical treatment interfered with your family life?","recommendedWording":null,"questionnaires":[4,54,111,130,143,144,627,634,635,674,675,676,564,589,605,607,611,617,510,525,538,545,549,552,436,450,457,483,499,509,405,415,416,423,427,429,334,335,340,343,375,381,295,299,305,307,317,332,146,206,216,217,273,290],"categories":[49],"createDate":"2016-02-17T15:59:01.503","updateDate":"2020-03-05T15:02:59.66"},"rank":100},{"type":"item","object":{"rank":100,"id":41,"code":"Q30","type":"question","description":"SF11 PC/MT interference social activities","direction":"negative","underlyingIssue":"feeling that physical condition or treatment interfere with social activities","additionalInfo":"","preferredWording":"Has your physical condition or medical treatment interfered with your social activities?","recommendedWording":null,"questionnaires":[4,54,111,130,143,144,634,635,674,675,676,564,589,605,611,617,627,510,525,538,545,549,552,450,457,483,492,499,509,415,416,423,427,429,436,335,340,343,375,381,405,299,305,307,317,332,334,146,206,216,217,290,295],"categories":[],"createDate":"2016-02-17T15:59:23.643","updateDate":"2017-02-21T14:38:17.24"},"rank":100},{"type":"item","object":{"rank":100,"id":42,"code":"Q31","type":"question","description":"FI01 financial difficulties","direction":"negative","underlyingIssue":"physical condition or treatment causing financial difficulties","additionalInfo":"","preferredWording":"Has your physical condition or medical treatment caused you financial difficulties?","recommendedWording":null,"questionnaires":[4,63,111,130,143,144,674,675,676,589,605,611,627,634,635,525,538,545,549,552,564,423,429,436,450,457,483,335,340,343,381,415,416,299,305,307,311,332,334,146,216,272,273,290,295],"categories":[51],"createDate":"2016-02-17T15:59:43.397","updateDate":"2020-02-27T14:28:17.89"},"rank":100},{"type":"item","object":{"rank":100,"id":43,"code":"Q32","type":"question","description":"global health status","direction":"positive","underlyingIssue":"global health status","additionalInfo":"","preferredWording":"How would you rate your overall health during the past week?","recommendedWording":null,"questionnaires":[4,111,123,124,127,128,675,676,688,690,715,627,634,635,640,648,674,564,568,589,605,607,611,538,545,546,549,552,561,483,499,500,509,510,525,428,429,436,450,457,461,407,415,416,423,425,427,343,347,359,375,381,405,317,327,332,334,335,340,276,290,295,299,305,307,194,200,206,216,217,261,130,143,144,146,157,192],"categories":[65],"createDate":"2016-02-17T15:59:57.47","updateDate":"2020-03-09T12:12:04.847"},"rank":100},{"type":"item","object":{"rank":100,"id":44,"code":"Q33","type":"question","description":"global quality of life","direction":"positive","underlyingIssue":"global quality of life","additionalInfo":"","preferredWording":"How would you rate your overall quality of life during the past sadda ","recommendedWording":null,"questionnaires":[4,46,111,130,716,719,720,639,648,674,675,676,715,607,611,617,627,634,635,552,561,564,568,589,605,510,525,538,545,546,549,450,457,483,495,499,509,423,425,427,428,429,436,381,405,407,415,416,343,345,347,356,359,375,317,327,332,334,335,340,290,295,299,305,307,216,217,238,261,276,182,192,194,197,200,206,143,144,146,157],"categories":[73],"createDate":"2016-02-17T16:00:16.16","updateDate":"2020-03-09T12:24:04.303"},"rank":100},{"type":"item","object":{"rank":100,"id":46,"code":"Q34","type":"question","description":"problems steps or stairs","direction":"negative","underlyingIssue":"experiencing problems climbing steps or stairs","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with steps or stairs?</p>","preferredWording":"Have you had difficulty with steps or stairs?","recommendedWording":null,"questionnaires":[2,111,301,331,381],"categories":[103],"createDate":"2016-02-18T11:32:53.94","updateDate":"2020-03-09T12:29:30.89"},"rank":100},{"type":"item","object":{"rank":100,"id":47,"code":"Q35","type":"question","description":"problems joints","direction":"negative","underlyingIssue":"experiencing problems with joints","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems with your joints (e.g. stiffness, pain)?</p>","preferredWording":"Have you had problems with your joints?","recommendedWording":"Have you had problems with your joints?","questionnaires":[2,111,132,134,408,445,140,212,301,331,381],"categories":[],"createDate":"2016-02-18T11:34:08.337","updateDate":"2016-09-08T10:15:59.73"},"rank":100},{"type":"item","object":{"rank":100,"id":49,"code":"Q37","type":"question","description":"help with chores","direction":"negative","underlyingIssue":"needing help with household chores","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you needed help with household chores such as cleaning or shopping?</p>","preferredWording":"Did you need help with household chores such as cleaning or shopping?","recommendedWording":null,"questionnaires":[2,111,301,331,381,488],"categories":[3],"createDate":"2016-02-18T11:38:01.16","updateDate":"2020-03-09T14:55:58.717"},"rank":100},{"type":"item","object":{"rank":100,"id":50,"code":"Q38","type":"question","description":"able to talk with family about illness","direction":"positive","underlyingIssue":"feeling able to talk with one\'s family about the illness","additionalInfo":"","preferredWording":"Have you felt able to talk to your family about your illness?","recommendedWording":null,"questionnaires":[2,111,301,311,331,381],"categories":[49,21],"createDate":"2016-02-18T11:43:32.47","updateDate":"2020-03-09T15:10:30.257"},"rank":100},{"type":"item","object":{"rank":100,"id":51,"code":"Q39","type":"question","description":"worry family coping","direction":"negative","underlyingIssue":"worrying about one\'s family coping with the illness and treatment","additionalInfo":"","preferredWording":"Have you worried about your family coping with your illness and treatment?","recommendedWording":null,"questionnaires":[2,111,273,301,331,381,413],"categories":[49,30],"createDate":"2016-02-18T11:44:53.063","updateDate":"2020-03-09T16:01:56.28"},"rank":100},{"type":"item","object":{"rank":100,"id":52,"code":"Q40","type":"question","description":"worry future important people","direction":"negative","underlyingIssue":"worrying about the future of the important people","additionalInfo":"","preferredWording":"Have you worried about the future of people who are important to you?","recommendedWording":"Have you worried about the future of people who are important to you?","questionnaires":[2,49,111,182,381,220,223,230,269,301,331],"categories":[53],"createDate":"2016-02-18T11:45:47.09","updateDate":"2020-03-09T16:09:24.31"},"rank":100},{"type":"item","object":{"rank":100,"id":53,"code":"Q41","type":"question","description":"worry health in future","direction":"negative","underlyingIssue":"worrying about health in the future","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you worried about your health in the future?</p>","preferredWording":"Were you worried about your health in the future?","recommendedWording":"Have you worried about your health in the future?","questionnaires":[2,5,10,12,13,14,671,688,689,690,702,721,633,634,638,645,646,647,576,577,622,623,624,632,545,548,553,563,567,575,486,492,517,519,526,533,470,472,475,482,484,485,417,433,435,449,450,456,367,371,381,394,408,416,301,306,311,321,328,331,258,280,287,291,292,300,231,232,239,247,255,181,199,209,212,228,230,67,111,131,139,140,36,41,42,43,45,48,27,30,31,32,33,35,17,19,21,23,24,26],"categories":[53],"createDate":"2016-02-18T11:46:37.807","updateDate":"2020-03-09T16:18:45.63"},"rank":100},{"type":"item","object":{"rank":100,"id":54,"code":"Q42","type":"question","description":"uncertain about future","direction":"negative","underlyingIssue":"feeling uncertain about one\'s future","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt uncertain about the future?</p>","preferredWording":"Did you feel uncertain about the future?","recommendedWording":null,"questionnaires":[2,11,15,78,111,699,716,732,734,371,381,534,690,698,184,252,301,311,331],"categories":[53],"createDate":"2016-02-18T11:47:16.217","updateDate":"2020-03-09T16:36:05.137"},"rank":100},{"type":"item","object":{"rank":100,"id":55,"code":"Q43","type":"question","description":"worry end of life","direction":"negative","underlyingIssue":"worrying about what might happen towards the end of one\'s life","additionalInfo":"","preferredWording":"Did you feel unsteady on your feet?","recommendedWording":"Have you worried about what might happen towards the end of your life?","questionnaires":[2,111,301,331,371,381,688,690],"categories":[53],"createDate":"2016-02-18T11:48:10.833","updateDate":"2020-03-09T16:49:44.027"},"rank":100},{"type":"item","object":{"rank":100,"id":56,"code":"Q44","type":"question","description":"positive outlook","direction":"positive","underlyingIssue":"having a positive outlook on life","additionalInfo":"","preferredWording":"Have you had a positive outlook on life in the last week?","recommendedWording":null,"questionnaires":[2,111,495,301,331,371,381],"categories":[39,53],"createDate":"2016-02-18T11:50:08.163","updateDate":"2020-03-10T11:49:01.933"},"rank":100},{"type":"item","object":{"rank":100,"id":57,"code":"Q45","type":"question","description":"motivated continue hobbies","direction":"positive","underlyingIssue":"feeling motivated to continue with normal hobbies and activities","additionalInfo":"","preferredWording":"Have you felt motivated to continue with your normal hobbies and activities?","recommendedWording":"Have you felt motivated to continue with your normal hobbies and activities?","questionnaires":[2,111,331,371,381,240,301],"categories":[112],"createDate":"2016-02-18T11:51:08.117","updateDate":"2020-03-10T11:59:32.143"},"rank":100},{"type":"item","object":{"rank":100,"id":58,"code":"Q46","type":"question","description":"burden disease patient","direction":"negative","underlyingIssue":"disease being a burden to the patient","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has your disease been a burden to you?</p>","preferredWording":"How much has your disease been a burden to you?","recommendedWording":null,"questionnaires":[2,19,111,301,321,331,371,381,526,716],"categories":[30],"createDate":"2016-02-18T11:51:46.23","updateDate":"2020-03-10T12:07:16.29"},"rank":100},{"type":"item","object":{"rank":100,"id":59,"code":"Q47","type":"question","description":"burden treatment patient","direction":"negative","underlyingIssue":"treatment being a burden to the patient","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has your treatment been a burden to you?</p>","preferredWording":"How much has your treatment been a burden to you?","recommendedWording":null,"questionnaires":[2,19,26,111,301,331,371,381,499,526],"categories":[30],"createDate":"2016-02-18T11:52:22.983","updateDate":"2020-03-10T12:13:18.32"},"rank":100},{"type":"item","object":{"rank":100,"id":60,"code":"Q48","type":"question","description":"hurry to toilet","direction":"negative","underlyingIssue":"having to hurry to get to the toilet when feeling the urge to pass urine","additionalInfo":"","preferredWording":"When you felt the urge to pass urine, did you have to hurry to get to the toilet?\\n","recommendedWording":"When you felt the urge to pass urine, did you have to hurry to get to the toilet?","questionnaires":[1,13,30,38,67,702,596,603,638,647,688,689,517,541,542,554,563,583,390,410,433,458,482,485,287,291,302,308,381,175,236,284,111,114,131,139,174],"categories":[147],"createDate":"2016-02-18T13:13:22.243","updateDate":"2020-03-10T12:46:43.62"},"rank":100},{"type":"item","object":{"rank":100,"id":1,"code":"Q1","type":"question","description":"less masculine","direction":"negative","underlyingIssue":"feeling less like a man","additionalInfo":"","preferredWording":"Have you been feeling less feminine/masculine as a result of your disease or treatment?","recommendedWording":"Have you felt less masculine as a result of your disease or treatment?","questionnaires":[1,8,11,15,111,140,732,734,482,488,652,699,182,208,308,381,449,460],"categories":[4],"createDate":"2016-02-02T11:40:49.9","updateDate":"2020-03-05T15:28:33.64"},"rank":100},{"type":"item","object":{"rank":100,"id":4,"code":"Q2","type":"question","description":"frequent urination day","direction":"negative","underlyingIssue":"having to urinate frequently during the day","additionalInfo":"<p><u>Recommended wording: </u></p><p>Have you had to urinate frequently during the day?</p>","preferredWording":"Did you urinate frequently during the day?","recommendedWording":"Have you had to urinate frequently during the day?","questionnaires":[1,13,30,32,39,67,699,702,721,603,638,647,652,688,689,433,472,475,482,486,583,236,258,287,291,308,381,111,131,139,166,170,181],"categories":[144],"createDate":"2016-02-10T11:25:09.97","updateDate":"2020-10-23T09:56:10.077"},"rank":100},{"type":"item","object":{"rank":100,"id":6,"code":"Q3","type":"question","description":"weight loss problem","direction":"negative","underlyingIssue":"having a problem with losing too much weight","additionalInfo":"","preferredWording":"Has weight loss been a problem for you?","recommendedWording":"Has weight loss been a problem for you?","questionnaires":[1,42,48,111,199,209,488,548,718,308,328,381,449,456,484],"categories":[72],"createDate":"2016-02-10T11:31:26.9","updateDate":"2020-03-09T11:48:56.09"},"rank":100},{"type":"item","object":{"rank":100,"id":7,"code":"Q4","type":"question","description":"PF15 problems carry bags","direction":"negative","underlyingIssue":"experiencing problems carrying heavy items","additionalInfo":"","preferredWording":"Do you have any trouble doing strenuous activities, like carrying a heavy shopping bag or a suitcase?","recommendedWording":null,"questionnaires":[4,50,111,130,143,144,634,635,648,674,675,676,564,589,605,607,611,627,543,545,546,549,552,561,488,491,492,502,525,538,436,444,450,457,483,487,415,416,423,427,428,431,343,346,359,381,405,407,317,332,334,335,340,342,290,295,299,305,307,309,217,234,238,253,273,278,145,146,192,200,206,216],"categories":[105],"createDate":"2016-02-10T11:39:32.283","updateDate":"2020-03-04T15:41:43.787"},"rank":100},{"type":"item","object":{"rank":100,"id":8,"code":"Q5","type":"question","description":"PF24 problems long walk","direction":"negative","underlyingIssue":"experiencing problems taking a long walk","additionalInfo":"","preferredWording":"Do you have any trouble taking a long walk?","recommendedWording":null,"questionnaires":[4,50,111,130,143,144,674,675,676,607,611,627,634,635,648,549,552,561,564,589,605,502,525,538,543,545,546,444,450,457,483,487,491,416,423,427,428,431,436,345,359,381,405,407,415,317,332,334,335,340,343,295,298,299,305,307,309,217,234,238,253,278,290,145,146,192,200,206,216],"categories":[111],"createDate":"2016-02-10T12:23:09.207","updateDate":"2020-03-04T15:42:50.51"},"rank":100},{"type":"item","object":{"rank":100,"id":9,"code":"Q6","type":"question","description":"PF19 problems short walk","direction":"negative","underlyingIssue":"experiencing problems taking a short walk","additionalInfo":"","preferredWording":"Do you have any trouble taking a short walk outside of the house?","recommendedWording":null,"questionnaires":[4,46,50,111,130,143,676,634,635,639,648,674,675,605,607,611,617,627,628,546,549,552,561,564,589,487,502,525,538,543,545,431,436,444,450,457,483,407,415,416,423,427,428,343,345,356,359,381,405,309,317,332,334,335,340,278,290,295,299,305,307,206,216,217,234,238,253,144,145,146,182,192,200],"categories":[111],"createDate":"2016-02-10T12:29:26.073","updateDate":"2020-03-04T15:43:23.597"},"rank":100},{"type":"item","object":{"rank":100,"id":10,"code":"Q7","type":"question","description":"RF08 limit work daily activities","direction":"negative","underlyingIssue":"being limited in working or doing daily activities","additionalInfo":"","preferredWording":"Were you limited in doing either your work or other daily activities?","recommendedWording":null,"questionnaires":[4,52,94,102,111,130,674,675,676,607,611,627,634,635,648,552,561,564,565,589,605,525,538,543,545,546,549,436,444,457,483,499,507,415,416,423,427,428,429,343,359,381,405,407,410,307,317,332,334,335,340,217,253,290,295,299,305,143,144,146,192,200,216],"categories":[1,123],"createDate":"2016-02-10T12:59:07.657","updateDate":"2020-03-05T11:53:21.363"},"rank":100},{"type":"item","object":{"rank":100,"id":66,"code":"Q52","type":"question","description":"problem incontinence aid","direction":"negative","underlyingIssue":"having problems wearing an incontinence aid","additionalInfo":"","preferredWording":"Has wearing an incontinence aid been a problem for you?","recommendedWording":null,"questionnaires":[1,111,308,381],"categories":[145,82],"createDate":"2016-02-18T13:24:56.33","updateDate":"2020-03-10T13:43:11.663"},"rank":100},{"type":"item","object":{"rank":100,"id":67,"code":"Q53","type":"question","description":"urinary problems daily activities","direction":"negative","underlyingIssue":"urinary problems limiting daily activities","additionalInfo":"","preferredWording":"Have your daily activities been limited by your urinary problems?","recommendedWording":null,"questionnaires":[1,111,308,381],"categories":[142,1],"createDate":"2016-02-18T13:26:44.863","updateDate":"2020-03-10T14:05:07.337"},"rank":100},{"type":"item","object":{"rank":100,"id":68,"code":"Q54","type":"question","description":"bowel problems daily activities","direction":"negative","underlyingIssue":"bowel problems limiting daily activities","additionalInfo":"","preferredWording":"Have your daily activities been limited by your bowel problems?","recommendedWording":null,"questionnaires":[1,111,263,498,501,267,308,381,489,490],"categories":[8,1],"createDate":"2016-02-18T13:27:54.583","updateDate":"2020-03-10T14:16:54.687"},"rank":100},{"type":"item","object":{"rank":100,"id":71,"code":"Q56","type":"question","description":"bloated feeling abdomen","direction":"negative","underlyingIssue":"having a bloated feeling in the abdomen","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had a bloated feeling in your abdomen?</p>","preferredWording":"Did you have a bloated feeling in your abdomen?","recommendedWording":"Have you had a bloated feeling in your abdomen?","questionnaires":[1,10,12,13,16,17,671,688,689,702,721,577,638,643,645,646,647,526,548,554,567,575,576,482,485,486,504,506,517,424,433,458,472,475,480,381,390,395,410,416,417,287,291,302,305,308,333,249,251,255,258,263,280,181,182,236,238,240,247,111,131,139,146,166,170,19,30,32,38,42,67],"categories":[57],"createDate":"2016-02-18T14:21:19.85","updateDate":"2020-03-10T14:46:06.223"},"rank":100},{"type":"item","object":{"rank":100,"id":72,"code":"Q57","type":"question","description":"mouth pain","direction":"negative","underlyingIssue":"having pain in the mouth","additionalInfo":"","preferredWording":"Have you had pain in your mouth?","recommendedWording":"Have you had pain in your mouth?","questionnaires":[9,43,111,153,186,394,430,441,508,533,206,231,232,279,381],"categories":[89,100],"createDate":"2016-02-19T13:12:29.993","updateDate":"2020-03-10T15:19:26.487"},"rank":100},{"type":"item","object":{"rank":100,"id":73,"code":"Q58","type":"question","description":"jaw pain","direction":"negative","underlyingIssue":"having pain in the jaw","additionalInfo":"","preferredWording":"Do you have jaw pain?","recommendedWording":"Have you had pain in your jaw?","questionnaires":[9,40,43,111,533,394,430,206,231,232,279,381],"categories":[89,100],"createDate":"2016-02-19T13:18:57.607","updateDate":"2020-03-10T15:27:50.587"},"rank":100},{"type":"item","object":{"rank":100,"id":74,"code":"Q59","type":"question","description":"sore mouth","direction":"negative","underlyingIssue":"having a sore mouth","additionalInfo":"","preferredWording":"Have you had soreness in your mouth?","recommendedWording":"Have you had soreness in your mouth?","questionnaires":[9,25,43,45,481,508,533,408,430,433,440,441,451,287,291,381,394,153,206,231,232,279,111,118,140],"categories":[89,100],"createDate":"2016-02-19T13:25:26.273","updateDate":"2020-03-10T15:42:09.07"},"rank":100},{"type":"item","object":{"rank":100,"id":75,"code":"Q60","type":"question","description":"throat pain","direction":"negative","underlyingIssue":"having pain in the throat","additionalInfo":null,"preferredWording":"Have you had pain in your throat?","recommendedWording":"Have you had pain in your throat?","questionnaires":[9,43,111,602,533,546,579,430,508,511,513,381,394,206,231,232,240,269,279],"categories":[],"createDate":"2016-02-19T13:30:20.6","updateDate":"2016-04-05T12:24:47.153"},"rank":100},{"type":"item","object":{"rank":100,"id":76,"code":"Q61","type":"question","description":"problem drinking liquids","direction":"negative","underlyingIssue":"experiencing problems drinking liquids","additionalInfo":"","preferredWording":"Have you had problems drinking liquids?","recommendedWording":"Have you had problems drinking liquids?","questionnaires":[12,20,27,111,733,580,589,641,182,249,251,381],"categories":[92,33],"createDate":"2016-02-19T13:34:04.86","updateDate":"2020-03-10T15:56:59.813"},"rank":100},{"type":"item","object":{"rank":100,"id":77,"code":"Q62","type":"question","description":"problem eating pureed food","direction":"negative","underlyingIssue":"experiencing problems eating pureed food","additionalInfo":"","preferredWording":"Have you had problems eating liquidised or soft foods?","recommendedWording":"Have you had problems eating liquidised or soft foods?","questionnaires":[12,27,111,182,251,381,580,641],"categories":[92,33],"createDate":"2016-02-19T13:44:41.08","updateDate":"2020-03-10T16:02:46.46"},"rank":100},{"type":"item","object":{"rank":100,"id":79,"code":"Q64","type":"question","description":"problem eating solid food","direction":"negative","underlyingIssue":"experiencing problems eating solid food","additionalInfo":"","preferredWording":"Have you had problems eating solid foods?","recommendedWording":"Have you had problems eating solid foods?","questionnaires":[12,25,27,111,182,251,381],"categories":[92,33],"createDate":"2016-02-19T13:55:54.107","updateDate":"2020-03-10T16:06:48.543"},"rank":100},{"type":"item","object":{"rank":100,"id":81,"code":"Q66","type":"question","description":"choked when swallowing","direction":"negative","underlyingIssue":"choked when swallowing","additionalInfo":"","preferredWording":"Have you choked when swallowing?","recommendedWording":null,"questionnaires":[9,27,29,43,111,206,430,503,508,517,533,231,232,269,279,381,394],"categories":[89],"createDate":"2016-02-19T13:59:55.543","updateDate":"2020-03-10T16:08:14.327"},"rank":100},{"type":"item","object":{"rank":100,"id":82,"code":"Q67","type":"question","description":"problem teeth","direction":"negative","underlyingIssue":"experiencing problems with teeth","additionalInfo":"","preferredWording":"Have you had problems with your teeth?","recommendedWording":"Have you had problems with your teeth?","questionnaires":[9,25,43,111,231,232,533,279,381,394,482,485,517],"categories":[89],"createDate":"2016-02-19T14:23:06.74","updateDate":"2020-03-10T16:08:40.97"},"rank":100},{"type":"item","object":{"rank":100,"id":83,"code":"Q68","type":"question","description":"swelling legs ankles","direction":"negative","underlyingIssue":"having swelling in legs or ankles","additionalInfo":"","preferredWording":"Have you had swelling in your legs or ankles?","recommendedWording":"Have you had swelling in your legs or ankles?","questionnaires":[1,89,111,117,181,187,482,485,500,583,603,308,381,395,449,458,461],"categories":[38],"createDate":"2016-02-19T14:24:10.39","updateDate":"2020-03-10T16:09:10.457"},"rank":100},{"type":"item","object":{"rank":100,"id":85,"code":"Q69","type":"question","description":"problem open mouth","direction":"negative","underlyingIssue":"experiencing problems opening the mouth wide","additionalInfo":"","preferredWording":"Have you had problems opening your mouth wide?","recommendedWording":"Have you had problems opening your mouth wide?","questionnaires":[9,43,111,231,430,533,232,279,381,394],"categories":[89],"createDate":"2016-02-19T14:31:26.57","updateDate":"2020-03-10T16:09:33.247"},"rank":100},{"type":"item","object":{"rank":100,"id":87,"code":"Q71","type":"question","description":"problem weight gain","direction":"negative","underlyingIssue":"experiencing problems with weight gain","additionalInfo":"","preferredWording":"Has weight gain been a problem for you?","recommendedWording":null,"questionnaires":[1,42,111,408,449,140,308,381],"categories":[71],"createDate":"2016-02-19T14:33:39.673","updateDate":"2020-03-10T16:10:35.053"},"rank":100},{"type":"item","object":{"rank":100,"id":88,"code":"Q72","type":"question","description":"interest in sex","direction":"positive","underlyingIssue":"being interested in sex","additionalInfo":"<p><u>Recommended wording: </u></p><p>Have you been interested in sex?</p>","preferredWording":"To what extent were you interested in sex?","recommendedWording":"Have you been interested in sex?","questionnaires":[1,5,11,13,19,647,688,689,702,721,553,554,563,583,603,638,449,472,475,482,486,526,367,381,408,433,435,300,302,306,308,322,342,228,239,258,287,291,292,117,131,139,140,181,30,32,38,67,89,111],"categories":[133],"createDate":"2016-02-19T14:52:37.923","updateDate":"2020-03-10T16:11:00.577"},"rank":100},{"type":"item","object":{"rank":100,"id":89,"code":"Q73","type":"question","description":"sticky saliva","direction":"negative","underlyingIssue":"having sticky saliva","additionalInfo":"","preferredWording":"Have you had sticky saliva?","recommendedWording":"Have you had sticky saliva?","questionnaires":[9,25,43,111,533,381,394,528,531,532,206,231,232,279],"categories":[89],"createDate":"2016-02-19T14:53:50.577","updateDate":"2020-03-10T16:11:17.113"},"rank":100},{"type":"item","object":{"rank":100,"id":90,"code":"Q74","type":"question","description":"sexually active","direction":"positive","underlyingIssue":"being sexually active","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been sexually active (with or without intercourse)?</p>","preferredWording":"To what extent were you sexually active? (with or without intercourse)","recommendedWording":"Have you been sexually active?","questionnaires":[1,5,8,11,13,689,702,590,596,603,638,647,688,547,553,554,555,563,583,460,482,526,541,542,381,408,433,435,449,292,300,302,306,308,367,182,228,239,284,287,291,131,139,140,159,181,67,89,111,114,117,19,30,34,38],"categories":[133],"createDate":"2016-02-19T14:54:21.903","updateDate":"2020-03-10T16:11:49.543"},"rank":100},{"type":"item","object":{"rank":100,"id":92,"code":"Q75","type":"question","description":"problem smell","direction":"negative","underlyingIssue":"experiencing problems with the sense of smell","additionalInfo":"","preferredWording":"Have you had problems with your sense of smell?","recommendedWording":"Have you had problems with your sense of smell?","questionnaires":[9,43,508,533,602,279,381,394,231,232,260,111,206],"categories":[],"createDate":"2016-02-19T14:58:05.35","updateDate":"2016-06-03T15:24:56.473"},"rank":100},{"type":"item","object":{"rank":100,"id":93,"code":"Q76","type":"question","description":"problem taste","direction":"negative","underlyingIssue":"experiencing problems with the sense of taste","additionalInfo":"","preferredWording":"Have you had problems with your sense of taste?","recommendedWording":"Have you had problems with your sense of taste?","questionnaires":[9,10,27,31,32,33,602,622,623,624,721,532,533,545,575,576,577,475,486,497,508,528,531,381,394,433,451,458,472,231,232,258,279,287,291,36,41,43,44,111,206],"categories":[],"createDate":"2016-02-19T15:07:07.55","updateDate":"2016-06-03T15:25:20.233"},"rank":100},{"type":"item","object":{"rank":100,"id":94,"code":"Q77","type":"question","description":"problem erection","direction":"negative","underlyingIssue":"experiencing problems achieving or maintaining an erection","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems getting or maintaining an erection?</p>","preferredWording":"Did you have difficulty getting or maintaining an erection?","recommendedWording":"Have you had problems getting or maintaining an erection?","questionnaires":[1,11,13,22,30,32,721,647,688,689,702,482,486,571,583,603,638,433,449,458,472,475,258,287,308,342,380,381,131,139,181,193,67,89,111,117],"categories":[133,114],"createDate":"2016-02-19T15:13:33.663","updateDate":"2020-03-11T10:04:32.81"},"rank":100},{"type":"item","object":{"rank":100,"id":95,"code":"Q78","type":"question","description":"problem ejaculation","direction":"negative","underlyingIssue":"experiencing problems with ejaculation","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with ejaculation (e.g., dry ejaculation)?</p>","preferredWording":"Did you have ejaculation problems (e.g. dry ejaculation)?","recommendedWording":"Have you had ejaculation problems (e.g. dry ejaculation)?","questionnaires":[1,11,13,30,67,111,638,647,688,689,702,433,449,482,541,542,596,131,139,181,287,308,381],"categories":[133,115],"createDate":"2016-02-19T15:14:39.98","updateDate":"2020-03-11T10:06:41.633"},"rank":100},{"type":"item","object":{"rank":100,"id":96,"code":"Q79","type":"question","description":"uncomfortable sexually intimate","direction":"negative","underlyingIssue":"feeling uncomfortable about being sexually intimate","additionalInfo":"","preferredWording":"Have you felt uncomfortable about being sexually intimate?","recommendedWording":"Have you felt uncomfortable about being sexually intimate?","questionnaires":[1,13,30,67,111,131,647,688,689,702,449,482,541,542,596,638,139,181,287,308,381,433],"categories":[133],"createDate":"2016-02-19T15:15:52.93","updateDate":"2020-03-11T10:07:13.707"},"rank":100},{"type":"item","object":{"rank":100,"id":105,"code":"Q81","type":"question","description":"importance active sex life","direction":"none","underlyingIssue":"importance of having an active sex life","additionalInfo":"","preferredWording":"How important to you is an active sex life?","recommendedWording":null,"questionnaires":[8,111,182,381,460,482],"categories":[133],"createDate":"2016-02-25T10:41:23.86","updateDate":"2020-03-11T10:09:34.637"},"rank":100},{"type":"item","object":{"rank":100,"id":106,"code":"Q82","type":"question","description":"decreased libido","direction":"negative","underlyingIssue":"having decreased level of sexual desire","additionalInfo":"","preferredWording":"Have you had decreased libido?","recommendedWording":"Have you had decreased libido?","questionnaires":[8,111,182,381,460,482],"categories":[133],"createDate":"2016-02-25T10:43:40.303","updateDate":"2020-03-11T10:10:27.96"},"rank":100},{"type":"item","object":{"rank":100,"id":107,"code":"Q83","type":"question","description":"satisfaction sexual desire","direction":"positive","underlyingIssue":"being satisfied with the level of sexual desire","additionalInfo":"","preferredWording":"Have you been satisfied with your level of sexual desire?","recommendedWording":"Have you been satisfied with your level of sexual desire?","questionnaires":[8,111,182,381,460,482],"categories":[133],"createDate":"2016-02-25T10:51:49.4","updateDate":"2020-03-11T10:10:51.61"},"rank":100},{"type":"item","object":{"rank":100,"id":108,"code":"Q84","type":"question","description":"sexual activity enjoyable","direction":"positive","underlyingIssue":"finding sexual activity enjoyable","additionalInfo":"<p><u>Recommended wording:</u></p><p>Has sexual activity been enjoyable for you?</p>","preferredWording":"To what extent was sex enjoyable for you?","recommendedWording":"Has sexual activity been enjoyable for you?","questionnaires":[1,5,8,11,13,19,647,688,689,702,554,555,563,596,638,482,526,541,542,547,553,408,433,435,449,460,306,308,367,381,284,287,291,292,300,302,181,182,228,239,111,114,131,139,140,30,34,38,67],"categories":[133],"createDate":"2016-02-25T11:09:58.413","updateDate":"2020-03-11T10:11:12.857"},"rank":100},{"type":"item","object":{"rank":100,"id":109,"code":"Q85","type":"question","description":"satisfaction reach orgasm","direction":"positive","underlyingIssue":"being satisfied with the ability to reach an orgasm","additionalInfo":"","preferredWording":"Have you been satisfied with your ability to reach an orgasm?","recommendedWording":"Have you been satisfied with your ability to reach an orgasm?","questionnaires":[8,111,182,381,460,482],"categories":[133],"createDate":"2016-02-25T11:15:48.68","updateDate":"2020-03-11T10:11:48.907"},"rank":100},{"type":"item","object":{"rank":100,"id":110,"code":"Q86","type":"question","description":"worry incontinent","direction":"negative","underlyingIssue":"worrying about being incontinent during foreplay or intercourse","additionalInfo":"","preferredWording":"Have you been worried about being incontinent (urine/stool)?","recommendedWording":"Have you been worried about being incontinent (urine/stool)?","questionnaires":[8,111,261,312,381,460,482],"categories":[145,12],"createDate":"2016-02-25T11:17:10.38","updateDate":"2020-03-11T10:17:00.173"},"rank":100},{"type":"item","object":{"rank":100,"id":62,"code":"Q50","type":"question","description":"go out close to toilet","direction":"negative","underlyingIssue":"having problems getting out of the house because of having to be close to the toilet","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems going out of the house, because you needed to be close to a toilet?</p>","preferredWording":"Have you had difficulty going out of the house, because you needed to be close to a toilet?\\n","recommendedWording":"Have you had problems going out of the house because you needed to be close to a toilet?","questionnaires":[1,13,16,30,67,596,638,647,688,689,702,489,490,498,501,541,542,308,381,170,181,263,267,89,111,117,131,139],"categories":[30],"createDate":"2016-02-18T13:17:11.963","updateDate":"2020-03-10T13:10:34.593"},"rank":100},{"type":"item","object":{"rank":100,"id":122,"code":"Q87","type":"question","description":"fatigue sex life","direction":"negative","underlyingIssue":"fatigue/lack of energy affecting sex life","additionalInfo":"","preferredWording":"Has fatigue or a lack of energy affected your sex life?","recommendedWording":null,"questionnaires":[8,111,182,381,460,482,650],"categories":[133,50],"createDate":"2016-02-25T11:39:27.71","updateDate":"2020-03-11T10:23:44.603"},"rank":100},{"type":"item","object":{"rank":100,"id":123,"code":"Q88","type":"question","description":"treatment sex life","direction":"negative","underlyingIssue":"treatment affecting sex life","additionalInfo":"","preferredWording":"Has the treatment affected your sexual activity?","recommendedWording":null,"questionnaires":[8,111,182,311,381,413,460,482,545],"categories":[133,31],"createDate":"2016-02-25T11:40:18.753","updateDate":"2020-03-11T10:31:16.223"},"rank":100},{"type":"item","object":{"rank":100,"id":124,"code":"Q89","type":"question","description":"pain sexual activity","direction":"negative","underlyingIssue":"feeling pain during or after sexual activity","additionalInfo":"","preferredWording":"Have you had pain during sexual intercourse or other sexual activity?","recommendedWording":null,"questionnaires":[8,111,114,182,284,381,460,482,590,596],"categories":[],"createDate":"2016-02-25T11:47:02.92","updateDate":"2017-09-29T10:37:24.693"},"rank":100},{"type":"item","object":{"rank":100,"id":126,"code":"Q91","type":"question","description":"hoarseness","direction":"negative","underlyingIssue":"been hoarse","additionalInfo":"","preferredWording":"Have you been hoarse?","recommendedWording":"Have you been hoarse?","questionnaires":[9,111,485,517,381,430,482,187,206,240],"categories":[139,94],"createDate":"2016-02-25T11:54:51.64","updateDate":"2020-03-11T10:53:06.157"},"rank":100},{"type":"item","object":{"rank":100,"id":127,"code":"Q92","type":"question","description":"worry pain sexual activity","direction":"negative","underlyingIssue":"worrying that sex will be painful","additionalInfo":"","preferredWording":"Have you worried that sex would be painful?","recommendedWording":"Have you worried that sex would be painful?","questionnaires":[8,34,111,114,182,284,381,460,482,547,555,590],"categories":[],"createDate":"2016-02-25T12:03:24.133","updateDate":"2017-09-29T10:49:11.697"},"rank":100},{"type":"item","object":{"rank":100,"id":128,"code":"Q93","type":"question","description":"communication HCP sexual issues","direction":"none","underlyingIssue":"having communication with health care professionals about sexual issues","additionalInfo":"","preferredWording":"Have you had communication with health professionals about sexual issues?","recommendedWording":null,"questionnaires":[8,111,182,381,460,482,545],"categories":[133,21],"createDate":"2016-02-25T12:06:38.22","updateDate":"2020-03-11T10:58:34.13"},"rank":100},{"type":"item","object":{"rank":100,"id":129,"code":"Q94","type":"question","description":"felt ill","direction":"negative","underlyingIssue":"feeling ill","additionalInfo":"","preferredWording":"Have you felt ill?","recommendedWording":"Have you felt ill?","questionnaires":[9,35,111,632,633,634,381],"categories":[68],"createDate":"2016-02-25T12:06:50.657","updateDate":"2020-03-11T10:58:54.8"},"rank":100},{"type":"item","object":{"rank":100,"id":130,"code":"Q95","type":"question","description":"problem appearance","direction":"negative","underlyingIssue":"experiencing problems with appearance","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with your appearance?</p>","preferredWording":"Have you had problems with your appearance?","recommendedWording":"Have you had problems with your appearance?","questionnaires":[9,21,43,111,231,232,279,381,394,508,533],"categories":[4],"createDate":"2016-02-25T12:19:55.007","updateDate":"2020-03-11T10:59:20.557"},"rank":100},{"type":"item","object":{"rank":100,"id":131,"code":"Q96","type":"question","description":"problem eating","direction":"negative","underlyingIssue":"experiencing problems eating","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems eating?</p>","preferredWording":"Have you had trouble with eating?","recommendedWording":"Have you had problems eating?","questionnaires":[9,10,27,29,36,42,575,576,577,394,430,438,439,533,574,43,111,231,232,279,381],"categories":[33],"createDate":"2016-02-25T12:22:16.317","updateDate":"2020-03-11T11:00:16.14"},"rank":100},{"type":"item","object":{"rank":100,"id":132,"code":"Q97","type":"question","description":"problem eating with family","direction":"negative","underlyingIssue":"experiencing problems eating in front of family","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems eating in front of your family?</p>","preferredWording":"Have you had problems eating in front of your family?","recommendedWording":"Have you had problems eating in front of your family?","questionnaires":[9,43,111,394,430,533,580,231,232,279,381],"categories":[33,49],"createDate":"2016-02-25T12:30:24.647","updateDate":"2020-03-11T11:00:42.113"},"rank":100},{"type":"item","object":{"rank":100,"id":133,"code":"Q98","type":"question","description":"communication sexual issues partner","direction":"positive","underlyingIssue":"being satisfied with the communication about sexual issues with the partner","additionalInfo":"","preferredWording":"Have you been satisfied with the communication about sexual issues between yourself and your partner?","recommendedWording":null,"questionnaires":[8,111,182,545,311,381,460,482],"categories":[133,21],"createDate":"2016-02-25T12:32:26.143","updateDate":"2020-03-11T11:01:17.243"},"rank":100},{"type":"item","object":{"rank":100,"id":134,"code":"Q99","type":"question","description":"worry pain sexual contact","direction":"negative","underlyingIssue":"worrying that partner may cause pain during sexual contact","additionalInfo":"","preferredWording":"Have you been worried that your partner may cause you pain during sexual contact?","recommendedWording":null,"questionnaires":[8,111,381,460,482],"categories":[],"createDate":"2016-02-25T12:33:25.833","updateDate":"2017-09-29T11:05:58.593"},"rank":100},{"type":"item","object":{"rank":100,"id":135,"code":"Q100","type":"question","description":"satisfied level intimacy","direction":"positive","underlyingIssue":"being satisfied with level of affection or intimacy","additionalInfo":"","preferredWording":"Have you been satisfied with your level of intimacy?","recommendedWording":null,"questionnaires":[8,111,182,311,482,507,545,639,381,413,460],"categories":[133],"createDate":"2016-02-25T12:36:32.26","updateDate":"2020-03-05T15:30:01.53"},"rank":100},{"type":"item","object":{"rank":100,"id":137,"code":"Q102","type":"question","description":"insecure satisfy partner","direction":"negative","underlyingIssue":"feeling insecure about the ability to satisfy the partner","additionalInfo":"","preferredWording":"Have you felt insecure regarding your ability to satisfy your partner?","recommendedWording":null,"questionnaires":[8,111,182,381,460,482],"categories":[133],"createDate":"2016-02-25T12:38:28.907","updateDate":"2020-03-05T15:31:21.807"},"rank":100},{"type":"item","object":{"rank":100,"id":138,"code":"Q103","type":"question","description":"problem enjoying meals","direction":"negative","underlyingIssue":"experiencing problems enjoying meals","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems enjoying your meals?</p>","preferredWording":"Have you had problems enjoying your meals?","recommendedWording":"Have you had problems enjoying your meals?","questionnaires":[9,12,27,29,43,394,430,533,580,111,182,231,232,381],"categories":[33],"createDate":"2016-02-25T12:41:11.697","updateDate":"2020-03-05T15:31:49.233"},"rank":100},{"type":"item","object":{"rank":100,"id":139,"code":"Q104","type":"question","description":"satisfied sex life","direction":"positive","underlyingIssue":"being satisfied with the sex life","additionalInfo":"","preferredWording":"Have you been satisfied with your sex life?","recommendedWording":"Have you been satisfied with your sex life?","questionnaires":[8,111,182,381,413,460,482,507],"categories":[133],"createDate":"2016-02-25T12:41:13.367","updateDate":"2020-03-05T15:39:16.343"},"rank":100},{"type":"item","object":{"rank":100,"id":140,"code":"Q105","type":"question","description":"extent sexual enjoyment","direction":"positive","underlyingIssue":"feeling sexual enjoyment","additionalInfo":"","preferredWording":"To what extent did you feel sexual enjoyment?","recommendedWording":null,"questionnaires":[8,111,482,182,381,460],"categories":[133],"createDate":"2016-02-25T12:42:06.737","updateDate":"2020-03-05T15:40:05.89"},"rank":100},{"type":"item","object":{"rank":100,"id":144,"code":"Q106","type":"question","description":"problem talking to others","direction":"negative","underlyingIssue":"experiencing problems talking to other people","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems talking to other people?</p>","preferredWording":"Have you had problems talking to other people?","recommendedWording":"Have you had problems talking to other people?","questionnaires":[9,43,111,206,231,232,533,245,279,381,394,430,508],"categories":[139,21],"createDate":"2016-02-25T12:45:30.777","updateDate":"2020-03-05T15:40:39.443"},"rank":100},{"type":"item","object":{"rank":100,"id":145,"code":"Q107","type":"question","description":"confident about erection","direction":"positive","underlyingIssue":"being confident about obtaining an erection and maintaining it","additionalInfo":"","preferredWording":"Were you confident about obtaining and maintaining an erection when you had sex?","recommendedWording":null,"questionnaires":[8,111,182,381,460,482],"categories":[133,114],"createDate":"2016-02-25T12:47:38.233","updateDate":"2020-03-05T15:41:24.263"},"rank":100},{"type":"item","object":{"rank":100,"id":148,"code":"Q109","type":"question","description":"less feminine","direction":"negative","underlyingIssue":"feeling less feminine","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt less feminine as a result of your disease or treatment?</p>","preferredWording":"Have you felt less feminine as a result of your disease or treatment?","recommendedWording":"Have you felt less feminine as a result of your disease or treatment?","questionnaires":[5,8,34,38,111,547,553,554,555,563,408,435,460,482,545,306,367,381,284,292,300,302,114,140,182,228,239],"categories":[4],"createDate":"2016-02-25T12:49:56.283","updateDate":"2020-03-05T15:41:50.05"},"rank":100},{"type":"item","object":{"rank":100,"id":153,"code":"Q114","type":"question","description":"food drink taste different","direction":"negative","underlyingIssue":"food and drink tasting different than usual","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have food and drink tasted different from usual?</p>","preferredWording":"Have food and drink tasted different from usual?","recommendedWording":"Have food and drink tasted different from usual?","questionnaires":[5,12,17,19,20,25,554,567,589,671,733,526,528,531,532,548,553,408,410,416,417,435,449,300,302,306,367,381,247,249,255,280,292,140,181,182,228,239,240,29,38,45,111],"categories":[],"createDate":"2016-02-25T13:13:34.8","updateDate":"2016-06-06T12:38:17.98"},"rank":100},{"type":"item","object":{"rank":100,"id":154,"code":"Q115","type":"question","description":"eyes painful irritated watery","direction":"negative","underlyingIssue":"eyes feeling painful, irritated or watery","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have your eyes been painful, irritated or watery?</p>","preferredWording":"Were your eyes painful, irritated or watery?","recommendedWording":"Have your eyes been painful, irritated or watery?","questionnaires":[5,111,140,228,239,292,449,553,300,306,367,381,408,435],"categories":[148],"createDate":"2016-02-25T13:14:40.307","updateDate":"2020-03-05T15:48:19.833"},"rank":100},{"type":"item","object":{"rank":100,"id":155,"code":"Q116","type":"question","description":"lost hair","direction":"negative","underlyingIssue":"losing hair","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you lost any hair?</p>","preferredWording":"Have you lost hair as a result of your treatment?","recommendedWording":"Have you lost any hair?","questionnaires":[5,11,12,19,26,32,634,721,486,526,553,554,632,633,435,449,456,472,475,484,367,381,408,433,291,292,300,302,306,328,239,240,258,269,287,140,181,199,209,228,35,37,38,48,111],"categories":[25],"createDate":"2016-02-25T13:15:21.21","updateDate":"2020-03-05T15:49:06.96"},"rank":100},{"type":"item","object":{"rank":100,"id":157,"code":"Q118","type":"question","description":"less interest sex","direction":"negative","underlyingIssue":"having less interest in sex","additionalInfo":"","preferredWording":"Have you felt less interest in sex?","recommendedWording":"Have you felt less interest in sex?","questionnaires":[9,17,43,45,111,671,533,548,567,416,417,458,280,371,381,394,231,232,247,255],"categories":[133],"createDate":"2016-02-25T13:37:35.967","updateDate":"2020-03-05T15:56:19.75"},"rank":100},{"type":"item","object":{"rank":100,"id":158,"code":"Q119","type":"question","description":"less sexual enjoyment","direction":"negative","underlyingIssue":"experiencing less sexual enjoyment","additionalInfo":"","preferredWording":"Have you felt less sexual enjoyment?","recommendedWording":"Have you felt less sexual enjoyment?","questionnaires":[9,17,43,45,111,533,548,567,671,371,381,394,416,417,231,232,247,255,280],"categories":[133],"createDate":"2016-02-25T13:39:03.237","updateDate":"2020-03-05T15:56:49.407"},"rank":100},{"type":"item","object":{"rank":100,"id":159,"code":"Q120","type":"question","description":"painkillers","direction":"negative","underlyingIssue":"using painkillers","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you used any painkillers?</p>","preferredWording":"Did you take any medicine for pain?","recommendedWording":null,"questionnaires":[9,37,111,129,154,562,206,217,229,381],"categories":[],"createDate":"2016-02-25T13:42:38.743","updateDate":"2016-06-06T13:17:54.42"},"rank":100},{"type":"item","object":{"rank":100,"id":160,"code":"Q121","type":"question","description":"nutritional supplements ","direction":"none","underlyingIssue":"using nutritional supplements (excluding vitamins)","additionalInfo":"","preferredWording":"Have you taken any nutritional supplements (excluding vitamins)?","recommendedWording":null,"questionnaires":[9,111,381],"categories":[33],"createDate":"2016-02-25T13:59:04.297","updateDate":"2020-03-05T15:58:26.047"},"rank":100},{"type":"item","object":{"rank":100,"id":161,"code":"Q122","type":"question","description":"feeding tube","direction":"none","underlyingIssue":"using a feeding tube","additionalInfo":"","preferredWording":"Have you used a feeding tube?","recommendedWording":"Have you used a feeding tube?","questionnaires":[9,111,381,430],"categories":[33,81],"createDate":"2016-02-25T14:01:22.347","updateDate":"2020-03-05T15:59:47.603"},"rank":100},{"type":"item","object":{"rank":100,"id":163,"code":"Q124","type":"question","description":"weight gain","direction":"none","underlyingIssue":"gaining weight ","additionalInfo":"","preferredWording":"Have you gained weight?","recommendedWording":"Have you gained weight?","questionnaires":[9,111,140,240,249,305,527,643,381,408,485,497,503,517],"categories":[71],"createDate":"2016-02-25T14:04:48.07","updateDate":"2020-03-05T16:00:46.387"},"rank":100},{"type":"item","object":{"rank":100,"id":166,"code":"Q125","type":"question","description":"upset loss hair","direction":"negative","underlyingIssue":"being upset by hair loss","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been upset by the loss of your hair?</p>","preferredWording":"Did hair loss bother you?","recommendedWording":null,"questionnaires":[5,12,15,19,27,35,634,698,699,732,734,526,534,553,632,633,306,367,381,408,435,449,184,228,239,252,292,300,78,111,140,181],"categories":[25,39],"createDate":"2016-02-25T14:41:43.81","updateDate":"2020-03-05T16:01:32.873"},"rank":100},{"type":"item","object":{"rank":100,"id":167,"code":"Q126","type":"question","description":"feel ill unwell","direction":"negative","underlyingIssue":"feeling ill or unwell","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt ill or unwell?</p>","preferredWording":"Have you felt ill or unwell?","recommendedWording":"Have you felt ill or unwell?","questionnaires":[5,23,24,30,31,111,545,553,623,408,435,449,450,461,500,240,292,300,306,367,381,131,139,140,228,236,239],"categories":[68],"createDate":"2016-02-25T14:43:17.63","updateDate":"2020-03-05T16:02:11.513"},"rank":100},{"type":"item","object":{"rank":100,"id":168,"code":"Q127","type":"question","description":"headaches","direction":"negative","underlyingIssue":"having headaches","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had headaches?</p>","preferredWording":"Did you have headaches?","recommendedWording":"Have you had headaches?","questionnaires":[5,15,21,26,111,615,698,699,732,734,515,527,534,553,560,602,466,474,477,481,512,514,367,381,408,435,449,458,240,252,292,300,306,355,184,193,215,218,228,239,132,134,140,153,163,181],"categories":[99],"createDate":"2016-02-25T14:44:17.443","updateDate":"2020-03-05T16:03:18.703"},"rank":100},{"type":"item","object":{"rank":100,"id":169,"code":"Q128","type":"question","description":"physically less attractive","direction":"negative","underlyingIssue":"feeling physically less attractive as a result of the disease or treatment","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt less physically attractive as a results of your disease or treatment?</p>","preferredWording":"Have you felt physically less attractive as a result of your disease or treatment?","recommendedWording":"Have you felt physically less attractive as a result of your disease or treatment?","questionnaires":[5,12,13,17,19,27,689,702,721,634,638,647,652,671,688,555,563,567,590,632,633,526,533,547,548,553,554,433,435,472,475,486,492,367,381,394,408,416,417,287,291,292,300,302,306,255,258,269,273,280,284,181,228,231,232,239,247,67,111,114,131,140,32,34,35,38,43,45],"categories":[4],"createDate":"2016-02-25T14:45:44.48","updateDate":"2020-03-05T16:04:36.36"},"rank":100},{"type":"item","object":{"rank":100,"id":170,"code":"Q129","type":"question","description":"problems look naked","direction":"negative","underlyingIssue":"experiencing problems looking at oneself naked","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems looking at yourself naked?</p>","preferredWording":"Did you find it difficult to look at yourself naked?","recommendedWording":"Have you had problems looking at yourself naked?","questionnaires":[5,111,140,228,239,292,553,300,306,367,381,408,435],"categories":[4],"createDate":"2016-02-25T14:47:00.423","updateDate":"2020-03-05T16:05:03.363"},"rank":100},{"type":"item","object":{"rank":100,"id":171,"code":"Q130","type":"question","description":"dissatisfied body","direction":"negative","underlyingIssue":"feeling dissatisfied with one\'s body","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt dissatisfied with your body as a result of your disease or treatment?</p>","preferredWording":"Have you been dissatisfied with your body?","recommendedWording":"Have you been dissatisfied with your body?","questionnaires":[5,13,17,19,26,32,721,638,647,671,688,689,702,547,548,553,555,563,567,435,472,475,486,526,533,394,408,409,416,417,433,300,306,367,381,258,280,284,287,291,292,231,232,239,247,255,114,131,140,181,228,34,43,67,111],"categories":[4],"createDate":"2016-02-25T14:48:00.75","updateDate":"2020-04-28T14:34:44.343"},"rank":100},{"type":"item","object":{"rank":100,"id":174,"code":"Q131","type":"question","description":"pain arm shoulder","direction":"negative","underlyingIssue":"having pain in an arm or shoulder","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had pain in your arm or shoulder?</p>","preferredWording":"Have you had pain in your arm or shoulder?","recommendedWording":"Have you had pain in your arm or shoulder?","questionnaires":[5,35,37,634,449,456,484,553,632,633,306,328,367,381,408,435,228,239,281,292,300,199,205,209,217,226,227,48,111,129,140,154],"categories":[100],"createDate":"2016-02-25T15:24:43.723","updateDate":"2020-03-06T09:23:29.243"},"rank":100},{"type":"item","object":{"rank":100,"id":175,"code":"Q132","type":"question","description":"swollen arm hand","direction":"negative","underlyingIssue":"having a swollen arm or hand","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had a swollen arm or hand?</p>","preferredWording":"Did you have a swollen arm or hand?","recommendedWording":"Have you had a swollen arm or hand?","questionnaires":[5,111,140,205,226,227,517,553,381,408,435,449,482,485,228,239,292,300,306,367],"categories":[38],"createDate":"2016-02-25T15:38:42.43","updateDate":"2020-03-06T09:24:02.987"},"rank":100},{"type":"item","object":{"rank":100,"id":180,"code":"Q137","type":"question","description":"skin problems area affected breast","direction":"negative","underlyingIssue":"having skin problems on or in the area of the affected breast","additionalInfo":"","preferredWording":"Have you had skin problems on or in the area of your affected breast (e.g., itchy, dry, flaky)?","recommendedWording":"Have you had skin problems on or in the area of your affected breast (e.g., itchy, dry, flaky)?","questionnaires":[111,140,226,227,228,239,435,449,553,292,300,306,367,381,408],"categories":[14,24],"createDate":"2016-02-25T15:43:46.89","updateDate":"2020-03-06T09:33:52.527"},"rank":100},{"type":"item","object":{"rank":100,"id":181,"code":"Q138","type":"question","description":"full up too quickly ","direction":"negative","underlyingIssue":"feeling full up too quickly after beginning to eat","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt full up too quickly after beginning to eat?</p>","preferredWording":"Have you felt full up too quickly after beginning to eat?","recommendedWording":"Have you felt full up too quickly after beginning to eat?","questionnaires":[10,12,19,20,27,29,733,577,589,439,480,526,575,576,333,381,438,123,182,238,249,251,36,44,111],"categories":[36],"createDate":"2016-02-26T09:10:17.28","updateDate":"2020-03-06T09:34:30.387"},"rank":100},{"type":"item","object":{"rank":100,"id":182,"code":"Q139","type":"question","description":"problem sense taste smell","direction":"negative","underlyingIssue":"experiencing problems with the sense of taste or smell","additionalInfo":"","preferredWording":"Have you had problems with your sense of taste or smell?","recommendedWording":"Have you had problems with your sense of taste or smell?","questionnaires":[11,111,381,531,532],"categories":[],"createDate":"2016-02-29T09:41:28.797","updateDate":"2016-06-06T14:32:02.263"},"rank":100},{"type":"item","object":{"rank":100,"id":184,"code":"Q140","type":"question","description":"acid reflux","direction":"negative","underlyingIssue":"experiencing acid reflux","additionalInfo":"","preferredWording":"Have you had acid reflux?","recommendedWording":null,"questionnaires":[11,111,381,458],"categories":[59],"createDate":"2016-02-29T10:38:26.83","updateDate":"2020-03-06T09:36:01.1"},"rank":100},{"type":"item","object":{"rank":100,"id":185,"code":"Q141","type":"question","description":"tingling numbness fingers toes","direction":"negative","underlyingIssue":"experiencing tingling or numbness in fingers or toes","additionalInfo":"","preferredWording":"Have you had tingling or numbness in your fingers or toes?","recommendedWording":null,"questionnaires":[11,111,166,186,187,239,643,645,646,269,381,391,413,481,507],"categories":[130],"createDate":"2016-02-29T10:39:27.47","updateDate":"2020-03-06T09:36:34.75"},"rank":100},{"type":"item","object":{"rank":100,"id":189,"code":"Q145","type":"question","description":"satisfied medical care","direction":"positive","underlyingIssue":"being satisfied with the received medical care","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been satisfied with the medical care you received?</p>","preferredWording":"How would you rate the care received in this hospital?","recommendedWording":null,"questionnaires":[11,47,90,111,167,276,618,719,381,462,582,598,599,612,327,361,365,376,379],"categories":[124],"createDate":"2016-02-29T11:01:50.947","updateDate":"2020-03-06T09:40:13.227"},"rank":100},{"type":"item","object":{"rank":100,"id":190,"code":"Q146","type":"question","description":"satisfied information disease treatment","direction":"positive","underlyingIssue":"being satisfied with the received information about disease and treatment","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been satisfied with the information you received about your disease and treatment?</p>","preferredWording":"Has the information given about your physical condition and treatment been adequate?","recommendedWording":null,"questionnaires":[11,17,111,247,255,280,671,311,381,416,417,548,567],"categories":[125],"createDate":"2016-02-29T11:02:42.177","updateDate":"2020-03-06T09:40:43.493"},"rank":100},{"type":"item","object":{"rank":100,"id":192,"code":"Q147","type":"question","description":"problem job education","direction":"negative","underlyingIssue":"experiencing problems with job or education because of having cancer or undergoing treatment","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems with your job or your education as a result of your disease or treatment?</p>","preferredWording":"Have you had any problems with your job or your education because of your disease or treatment?","recommendedWording":null,"questionnaires":[11,111,134,269,381],"categories":[123],"createDate":"2016-02-29T11:04:59.01","updateDate":"2020-03-06T09:42:38.323"},"rank":100},{"type":"item","object":{"rank":100,"id":193,"code":"Q148","type":"question","description":"physically limited disease treatment","direction":"negative","underlyingIssue":"being physically limited as a result of disease or treatment","additionalInfo":"","preferredWording":"Have you been physically limited as a result of your disease or treatment?","recommendedWording":null,"questionnaires":[11,111,381],"categories":[101],"createDate":"2016-02-29T11:06:28.65","updateDate":"2020-03-06T09:43:25.437"},"rank":100},{"type":"item","object":{"rank":100,"id":195,"code":"Q149","type":"question","description":"limited types of food","direction":"negative","underlyingIssue":"being limited in types of food as result of the disease or treatment","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you been limited in the types of food you can eat because of your disease or treatment?</p>","preferredWording":"Were you restricted in the types of food you can eat as a result of your disease or treatment?","recommendedWording":null,"questionnaires":[10,17,111,247,255,280,567,575,576,577,580,671,381,399,416,417,492,548],"categories":[37],"createDate":"2016-02-29T11:28:52.86","updateDate":"2020-03-06T09:44:35.543"},"rank":100},{"type":"item","object":{"rank":100,"id":196,"code":"Q150","type":"question","description":"jaundice ","direction":"negative","underlyingIssue":"having yellow skin or eyes (jaundice )","additionalInfo":"","preferredWording":"Have your skin or eyes been yellow (jaundiced)?","recommendedWording":"Have your skin or eyes been yellow (jaundiced)?","questionnaires":[10,36,111,381,438,439,480,575,576,577],"categories":[26],"createDate":"2016-02-29T11:37:32.783","updateDate":"2020-03-06T09:45:11.5"},"rank":100},{"type":"item","object":{"rank":100,"id":198,"code":"Q152","type":"question","description":"worry disruption family life","direction":"negative","underlyingIssue":"worrying about disruption of family life","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about disruption of your family life?</p>","preferredWording":"Were you concerned about disruption of family life?","recommendedWording":null,"questionnaires":[11,15,42,45,111,181,699,732,734,184,252,311,381,534,698],"categories":[49],"createDate":"2016-02-29T11:48:31.533","updateDate":"2020-03-06T09:46:52.167"},"rank":100},{"type":"item","object":{"rank":100,"id":199,"code":"Q153","type":"question","description":"worry jaundice","direction":"negative","underlyingIssue":"worrying about having jaundiced skin or eyes","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been worried about your skin or eyes being yellow (jaundiced)?</p>","preferredWording":"Have you been worried about your skin being yellow?","recommendedWording":null,"questionnaires":[10,44,111,381,575,576,577],"categories":[26],"createDate":"2016-02-29T11:49:08.117","updateDate":"2020-03-06T09:47:17.063"},"rank":100},{"type":"item","object":{"rank":100,"id":200,"code":"Q154","type":"question","description":"less active","direction":"negative","underlyingIssue":"being less active than one wants to be","additionalInfo":"","preferredWording":"Have you been less active than you would like to be?","recommendedWording":null,"questionnaires":[10,36,44,111,381,480,575,576,577,643],"categories":[101],"createDate":"2016-02-29T11:51:41.22","updateDate":"2020-03-06T09:48:01.663"},"rank":100},{"type":"item","object":{"rank":100,"id":201,"code":"Q155","type":"question","description":"worry fertility","direction":"negative","underlyingIssue":"worrying about the ability to have children","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about your ability to have children?</p>","preferredWording":"Have you been concerned about your ability to have children?","recommendedWording":"Have you worried about your ability to have children?","questionnaires":[11,31,41,45,111,492,545,622,623,311,381],"categories":[116],"createDate":"2016-02-29T11:54:14.28","updateDate":"2020-03-06T09:48:45.953"},"rank":100},{"type":"item","object":{"rank":100,"id":202,"code":"Q156","type":"question","description":"talk disease partner","direction":"positive","underlyingIssue":"feeling able to talk about disease with the partner/closest person","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been able to talk about your disease with your partner or the person who is closest to you?</p>","preferredWording":"Can you talk about your disease with your partner or the person who is closest to you?","recommendedWording":null,"questionnaires":[11,111,208,311,381],"categories":[21],"createDate":"2016-02-29T11:55:28.147","updateDate":"2020-03-06T09:53:51.213"},"rank":100},{"type":"item","object":{"rank":100,"id":203,"code":"Q157","type":"question","description":"talk sexuality partner","direction":"positive","underlyingIssue":"feeling able to talk about sexuality with the partner/closest person","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been able to talk about sexuality with your partner or the person who is closest to you?</p>","preferredWording":"Can you talk about sexuality with your partner or the person who is closest to you?","recommendedWording":null,"questionnaires":[11,111,208,311,381],"categories":[21],"createDate":"2016-02-29T11:57:48.74","updateDate":"2020-03-06T09:54:35.627"},"rank":100},{"type":"item","object":{"rank":100,"id":177,"code":"Q134","type":"question","description":"pain area affected breast","direction":"negative","underlyingIssue":"having pain in the area of the affected breast","additionalInfo":"","preferredWording":"Have you had any pain in the area of your affected breast?","recommendedWording":null,"questionnaires":[5,111,140,226,553,367,381,408,435,449,227,228,239,292,300,306],"categories":[14,100],"createDate":"2016-02-25T15:40:59.34","updateDate":"2020-03-06T09:27:37.72"},"rank":100},{"type":"item","object":{"rank":100,"id":178,"code":"Q135","type":"question","description":"swollen area affected breast","direction":"negative","underlyingIssue":"having swelling in the area of the affected breast","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has the area of your affected breast been swollen?</p>","preferredWording":"Was the area of your affected breast swollen?","recommendedWording":null,"questionnaires":[5,111,140,435,449,553,300,306,367,381,408,226,227,228,239,285,292],"categories":[14,38],"createDate":"2016-02-25T15:41:40.383","updateDate":"2020-03-06T09:28:41.29"},"rank":100},{"type":"item","object":{"rank":100,"id":205,"code":"Q158","type":"question","description":"FA06 slowed down","direction":"negative","underlyingIssue":"feeling slowed down","additionalInfo":"","preferredWording":"Have you felt slowed down?","recommendedWording":"Have you felt slowed down?","questionnaires":[10,23,36,40,55,575,576,577,650,279,381,480,545,67,125,153,163,246],"categories":[50],"createDate":"2016-02-29T11:58:51.58","updateDate":"2020-02-27T14:25:55.73"},"rank":100},{"type":"item","object":{"rank":100,"id":206,"code":"Q159","type":"question","description":"FA19 lack energy","direction":"negative","underlyingIssue":"lacking energy","additionalInfo":"","preferredWording":"Have you lacked energy?","recommendedWording":"Have you lacked energy?","questionnaires":[10,24,31,33,36,40,643,645,646,650,577,617,622,623,624,625,504,506,507,545,575,576,421,424,450,461,480,493,358,381,387,395,401,413,127,128,134,153,240,246,41,55,77,123,124,125],"categories":[50],"createDate":"2016-02-29T11:59:58.43","updateDate":"2020-02-27T14:27:43.523"},"rank":100},{"type":"item","object":{"rank":100,"id":207,"code":"Q160","type":"question","description":"satisfied sexual relationship","direction":"positive","underlyingIssue":"being satisfied with the sexual relationship with the partner","additionalInfo":"","preferredWording":"Has the sexual relationship with your partner been satisfying?","recommendedWording":null,"questionnaires":[11,111,381],"categories":[133],"createDate":"2016-02-29T12:00:31.69","updateDate":"2020-03-06T09:55:05.267"},"rank":100},{"type":"item","object":{"rank":100,"id":209,"code":"Q161","type":"question","description":"satisfied testicular implant","direction":"positive","underlyingIssue":"being satisfied with the testicular implant","additionalInfo":"","preferredWording":"Are you satisfied with your testicular implant?","recommendedWording":null,"questionnaires":[11,111,381],"categories":[113,84],"createDate":"2016-02-29T12:01:25.777","updateDate":"2020-03-06T09:55:54.533"},"rank":100},{"type":"item","object":{"rank":100,"id":210,"code":"Q162","type":"question","description":"pain night","direction":"negative","underlyingIssue":"experiencing pain at night","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had pain during the night?</p>","preferredWording":"Did you have pain during the night?","recommendedWording":"Have you had pain during the night?","questionnaires":[10,17,111,567,575,576,577,671,416,417,548,566,247,255,280,381],"categories":[],"createDate":"2016-02-29T12:01:54.31","updateDate":"2016-06-28T12:43:50.357"},"rank":100},{"type":"item","object":{"rank":100,"id":212,"code":"Q163","type":"question","description":"pain back","direction":"negative","underlyingIssue":"having pain in one\'s back","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had pain in your back?</p>","preferredWording":"Have you had back pain?","recommendedWording":"Have you had pain in your back?","questionnaires":[10,17,35,36,103,111,577,615,632,633,634,671,515,548,566,567,575,576,416,417,438,439,480,514,118,240,247,255,280,381],"categories":[100],"createDate":"2016-02-29T12:07:37.24","updateDate":"2020-03-06T09:57:08.383"},"rank":100},{"type":"item","object":{"rank":100,"id":216,"code":"Q164","type":"question","description":"stress","direction":"negative","underlyingIssue":"feeling stressed","additionalInfo":"","preferredWording":"Have you felt stressed?","recommendedWording":"Have you felt stressed?","questionnaires":[10,36,111,576,577,261,273,381,575],"categories":[48],"createDate":"2016-02-29T12:28:13.527","updateDate":"2020-03-06T09:57:40.16"},"rank":100},{"type":"item","object":{"rank":100,"id":217,"code":"Q165","type":"question","description":"enjoying yourself","direction":"negative","underlyingIssue":"feeling less able to enjoy oneself","additionalInfo":"","preferredWording":"Have you felt less able to enjoy yourself?","recommendedWording":"Have you felt less able to enjoy yourself?","questionnaires":[10,36,111,381,577,575,576],"categories":[39],"createDate":"2016-02-29T12:31:06.163","updateDate":"2020-03-06T09:58:02.967"},"rank":100},{"type":"item","object":{"rank":100,"id":218,"code":"Q166","type":"question","description":"discomfort eating","direction":"negative","underlyingIssue":"experiencing discomfort when eating","additionalInfo":"","preferredWording":"Have you had discomfort when eating?","recommendedWording":"Have you had discomfort when eating?","questionnaires":[12,27,111,381,569,146,182,251],"categories":[33,89],"createDate":"2016-02-29T12:35:04.557","updateDate":"2020-03-06T10:00:58.56"},"rank":100},{"type":"item","object":{"rank":100,"id":219,"code":"Q167","type":"question","description":"worry family future","direction":"negative","underlyingIssue":"worrying about the family in the future","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you been worried about your family in the future?</p>","preferredWording":"Were you worried about your family in the future?","recommendedWording":"Have you worried about your family in the future?","questionnaires":[10,36,111,311,381,575,576,577],"categories":[53,49],"createDate":"2016-02-29T12:35:30.08","updateDate":"2020-03-06T10:01:34.847"},"rank":100},{"type":"item","object":{"rank":100,"id":220,"code":"Q168","type":"question","description":"problem side effects ","direction":"negative","underlyingIssue":"experiencing problems with side effects ","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with side effects from your treatment?</p>","preferredWording":"To what extent have you been troubled with side-effects from your treatment?","recommendedWording":null,"questionnaires":[10,15,17,111,143,732,734,548,567,575,576,577,671,409,416,417,447,481,492,280,359,360,378,381,407,144,207,217,247,255,277],"categories":[31],"createDate":"2016-02-29T12:36:35.477","updateDate":"2020-03-06T10:02:09.913"},"rank":100},{"type":"item","object":{"rank":100,"id":221,"code":"Q169","type":"question","description":"problem drainage tubes/bags","direction":"negative","underlyingIssue":"experiencing problems with drainage tubes/bags","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with drainage tubes/bags?</p>","preferredWording":"Have you had difficulties with drainage tubes/ bags?","recommendedWording":null,"questionnaires":[10,111,381,575,576,577],"categories":[80],"createDate":"2016-02-29T12:40:28.83","updateDate":"2020-03-06T10:02:34.237"},"rank":100},{"type":"item","object":{"rank":100,"id":228,"code":"Q170","type":"question","description":"discomfort stomach area","direction":"negative","underlyingIssue":"experiencing discomfort in the stomach area","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had discomfort in your stomach area?</p>","preferredWording":"Have you had abdominal discomfort?","recommendedWording":"Have you had discomfort in your stomach area?","questionnaires":[12,17,23,27,36,567,615,671,461,514,515,548,566,381,416,417,450,458,182,247,251,255,280,94,102,111,123,146],"categories":[58],"createDate":"2016-02-29T13:13:47.813","updateDate":"2020-03-06T10:03:21.877"},"rank":100},{"type":"item","object":{"rank":100,"id":229,"code":"Q171","type":"question","description":"problem acid bile mouth","direction":"negative","underlyingIssue":"experiencing problems with acid or bile coming into the mouth","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with acid or bile coming into your mouth?</p>","preferredWording":"Have you had problems with acid or bile coming into your mouth?","recommendedWording":"Have you had problems with acid or bile coming into your mouth?","questionnaires":[12,27,29,111,182,251,381,432],"categories":[59,89],"createDate":"2016-02-29T13:15:54.63","updateDate":"2020-03-06T10:04:13.763"},"rank":100},{"type":"item","object":{"rank":100,"id":230,"code":"Q172","type":"question","description":"acid indigestion heartburn","direction":"negative","underlyingIssue":"experiencing acid indigestion or heartburn","additionalInfo":"","preferredWording":"Have you had acid indigestion or heartburn?","recommendedWording":"Have you had acid indigestion or heartburn?","questionnaires":[12,19,20,26,27,29,733,381,526,589,632,633,634,238,240,249,251,260,333,35,42,111,166,170,182],"categories":[59],"createDate":"2016-02-29T13:16:32.57","updateDate":"2020-03-06T10:04:49.863"},"rank":100},{"type":"item","object":{"rank":100,"id":233,"code":"Q174","type":"question","description":"pain burning feeling urinate","direction":"negative","underlyingIssue":"having pain/burning feeling when urinating","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had pain or a burning feeling when urinating?</p>","preferredWording":"Have you had pain or a burning feeling when urinating?","recommendedWording":"Have you had pain or a burning feeling when passing urine?","questionnaires":[13,30,34,38,67,111,647,688,689,702,517,547,554,555,563,638,302,381,404,410,482,485,114,131,139,181,236,284],"categories":[143,100],"createDate":"2016-02-29T13:27:04.957","updateDate":"2020-03-06T10:05:43.183"},"rank":100},{"type":"item","object":{"rank":100,"id":234,"code":"Q175","type":"question","description":"long time finish meal","direction":"negative","underlyingIssue":"taking long time to finish one\'s meal","additionalInfo":"","preferredWording":"Has it taken you a long time to complete your meals?","recommendedWording":null,"questionnaires":[12,27,381,182,111],"categories":[33],"createDate":"2016-02-29T13:32:49.667","updateDate":"2020-03-06T10:06:30.763"},"rank":100},{"type":"item","object":{"rank":100,"id":235,"code":"Q176","type":"question","description":"urine bag leak","direction":"negative","underlyingIssue":"urostomy bag leaking","additionalInfo":"","preferredWording":"Has urine leaked from your urostomy bag?","recommendedWording":null,"questionnaires":[13,67,111,131,314,381,702,520,523,638,647,688,689],"categories":[145,85],"createDate":"2016-02-29T13:32:56.5","updateDate":"2020-03-06T10:07:14.753"},"rank":100},{"type":"item","object":{"rank":100,"id":236,"code":"Q177","type":"question","description":"problem care urostomy","direction":"negative","underlyingIssue":"experiencing problems caring for the urostomy","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems with caring for your urostomy?</p>","preferredWording":"Did you have problems with caring for your urostomy?","recommendedWording":null,"questionnaires":[13,67,111,131,638,647,688,689,702,314,381,520,523],"categories":[142,85],"createDate":"2016-02-29T13:34:00.01","updateDate":"2020-03-06T10:08:30.507"},"rank":100},{"type":"item","object":{"rank":100,"id":237,"code":"Q178","type":"question","description":"think illness","direction":"negative","underlyingIssue":"thinking about the illness","additionalInfo":"","preferredWording":"Have you been thinking about your illness?","recommendedWording":"Have you been thinking about your disease?","questionnaires":[12,27,35,111,182,321,381,632,633,634],"categories":[39],"createDate":"2016-02-29T13:36:10.103","updateDate":"2020-03-06T10:09:13.55"},"rank":100},{"type":"item","object":{"rank":100,"id":238,"code":"Q179","type":"question","description":"skin irritarion urostomy","direction":"negative","underlyingIssue":"having irritated skin around the urostomy","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has your skin been irritated around the urostomy?</p>","preferredWording":"Was your skin around the urostomy irritated?","recommendedWording":null,"questionnaires":[13,67,111,131,314,381,690,702,520,523,638,647,688,689],"categories":[142,85],"createDate":"2016-02-29T13:36:49.683","updateDate":"2020-03-06T10:10:15.653"},"rank":100},{"type":"item","object":{"rank":100,"id":239,"code":"Q180","type":"question","description":"worry weight too low","direction":"negative","underlyingIssue":"worrying about the weight being too low","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you worried that your weight is too low?</p>","preferredWording":"Have you worried about your weight being too low?","recommendedWording":"Have you worried that your weight is too low?","questionnaires":[12,17,27,43,44,45,567,671,394,416,417,533,548,232,247,249,255,280,381,111,231],"categories":[72],"createDate":"2016-02-29T13:36:57.64","updateDate":"2020-03-06T10:10:41.58"},"rank":100},{"type":"item","object":{"rank":100,"id":240,"code":"Q181","type":"question","description":"worry weight loss","direction":"negative","underlyingIssue":"worrying about losing weight","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about your weight loss?</p>","preferredWording":"Have you worried about your weight loss?","recommendedWording":"Have you worried about your weight loss?","questionnaires":[10,20,111,577,589,733,381,575,576,239],"categories":[72],"createDate":"2016-02-29T13:44:58.433","updateDate":"2020-03-06T10:11:10.19"},"rank":100},{"type":"item","object":{"rank":100,"id":241,"code":"Q182","type":"question","description":"embarrassed urostomy","direction":"negative","underlyingIssue":"being embarrassed because of the urostomy","additionalInfo":"","preferredWording":"Have you felt embarrassed because of your urostomy?","recommendedWording":null,"questionnaires":[13,67,111,131,314,381,702,520,523,638,647,688,689],"categories":[85,44],"createDate":"2016-02-29T13:53:55.313","updateDate":"2020-03-06T10:12:01.03"},"rank":100},{"type":"item","object":{"rank":100,"id":242,"code":"Q183","type":"question","description":"dependent others urostomy care ","direction":"negative","underlyingIssue":"depending on others for urostomy care ","additionalInfo":"","preferredWording":"Have you been dependent on others for caring for your urostomy?","recommendedWording":null,"questionnaires":[13,67,111,131,314,381,688,689,702,520,523,638,647],"categories":[85,30],"createDate":"2016-02-29T13:56:41.443","updateDate":"2020-03-06T10:12:58.36"},"rank":100},{"type":"item","object":{"rank":100,"id":243,"code":"Q184","type":"question","description":"urostomy bag changes","direction":"negative","underlyingIssue":"having to frequently change the urostomy bag","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had to frequently change the urostomy bag?</p>","preferredWording":"Did you frequently have to change the urostomy bag?","recommendedWording":null,"questionnaires":[13,67,111,131,314,381,702,520,523,638,647,688,689],"categories":[142,85],"createDate":"2016-02-29T13:58:05.547","updateDate":"2020-03-06T10:14:23.66"},"rank":100},{"type":"item","object":{"rank":100,"id":244,"code":"Q185","type":"question","description":"problem self-catheterization","direction":"negative","underlyingIssue":"experiencing problems with self-catheterization","additionalInfo":"","preferredWording":"Have you had problems with self-catheterization? (inserting a tube in the bladder to pass urine)","recommendedWording":null,"questionnaires":[13,67,111,131,314,381,638,647,688,689,702],"categories":[142,85],"createDate":"2016-02-29T14:08:26.763","updateDate":"2020-03-06T10:14:55.127"},"rank":100},{"type":"item","object":{"rank":100,"id":245,"code":"Q186","type":"question","description":"worry results","direction":"negative","underlyingIssue":"worrying about results of examinations and tests","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about the results of examinations and tests?</p>","preferredWording":"Did you worry about the results of examinations and tests?","recommendedWording":"Have you worried about the results of examinations and tests?","questionnaires":[13,30,42,43,45,67,647,688,689,702,321,381,394,413,533,638,111,131,139,181,231,232],"categories":[53,41],"createDate":"2016-02-29T14:12:13.267","updateDate":"2020-03-06T10:17:05.917"},"rank":100},{"type":"item","object":{"rank":100,"id":246,"code":"Q187","type":"question","description":"worry future treatments","direction":"negative","underlyingIssue":"worrying about possible future treatments","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about possible future treatments?</p>","preferredWording":"Did you worry about possible future treatments?","recommendedWording":null,"questionnaires":[13,30,67,111,131,139,638,647,688,689,702,181,228,230,261,321,381],"categories":[53,41],"createDate":"2016-02-29T14:15:34.67","updateDate":"2020-03-06T10:17:35.573"},"rank":100},{"type":"item","object":{"rank":100,"id":248,"code":"Q189","type":"question","description":"less feminine/masculine ","direction":"negative","underlyingIssue":"feeling less feminine/masculine","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt less masculine/feminine as a result of your disease or treatment?</p>","preferredWording":"Have you been feeling less feminine/masculine as a result of your disease or treatment?","recommendedWording":"Have you felt less feminine/masculine as a result of your disease or treatment?","questionnaires":[13,32,67,111,131,181,689,702,721,472,475,486,638,647,688,258,287,291,311,381,433],"categories":[4],"createDate":"2016-02-29T14:54:06.867","updateDate":"2020-03-06T10:19:12.807"},"rank":100},{"type":"item","object":{"rank":100,"id":249,"code":"Q190","type":"question","description":"worry contaminate bladder treatment","direction":"negative","underlyingIssue":"worrying about possible contamination of the partner during sexual contact with the bladder treatment","additionalInfo":"","preferredWording":"Have you worried that you may contaminate your partner during sexual contact with the bladder treatment you have been receiving?","recommendedWording":null,"questionnaires":[13,30,67,111,131,702,139,381,638,647,688,689],"categories":[133,142],"createDate":"2016-02-29T15:04:22.763","updateDate":"2020-03-06T10:19:40.997"},"rank":100},{"type":"item","object":{"rank":100,"id":250,"code":"Q191","type":"question","description":"pain in back","direction":"negative","underlyingIssue":"having pain in the back","additionalInfo":"","preferredWording":"in your back?","recommendedWording":null,"questionnaires":[14,111,154,381,469,470],"categories":[100],"createDate":"2016-02-29T15:21:38.457","updateDate":"2020-03-06T12:03:21.543"},"rank":100},{"type":"item","object":{"rank":100,"id":251,"code":"Q192","type":"question","description":"pain in legs/hips","direction":"negative","underlyingIssue":"having pain in the legs/hips","additionalInfo":"","preferredWording":"in your leg(s) or hip(s)?","recommendedWording":null,"questionnaires":[14,111,154,381,470],"categories":[100],"createDate":"2016-02-29T15:22:54.26","updateDate":"2020-03-06T12:07:09.537"},"rank":100},{"type":"item","object":{"rank":100,"id":252,"code":"Q193","type":"question","description":"pain in arms/shoulders","direction":"negative","underlyingIssue":"having pain in the arms/shoulders","additionalInfo":"","preferredWording":"in your arm(s) or shoulder(s)?","recommendedWording":null,"questionnaires":[14,111,154,381],"categories":[100],"createDate":"2016-02-29T15:24:23.51","updateDate":"2020-03-06T12:07:33.39"},"rank":100},{"type":"item","object":{"rank":100,"id":253,"code":"Q194","type":"question","description":"pain in chest/ribs","direction":"negative","underlyingIssue":"having pain in the chest/ribs","additionalInfo":"","preferredWording":"in your chest or rib(s)?","recommendedWording":null,"questionnaires":[14,111,154,381],"categories":[100],"createDate":"2016-02-29T15:25:10.407","updateDate":"2020-03-06T12:08:20.767"},"rank":100},{"type":"item","object":{"rank":100,"id":254,"code":"Q195","type":"question","description":"pain in buttocks","direction":"negative","underlyingIssue":"having pain in the buttocks","additionalInfo":"","preferredWording":"in your buttock(s)?","recommendedWording":null,"questionnaires":[14,111,154,381,470],"categories":[100],"createDate":"2016-02-29T15:26:05.477","updateDate":"2020-03-06T12:09:42.76"},"rank":100},{"type":"item","object":{"rank":100,"id":301,"code":"Q241","type":"question","description":"problem coordination","direction":"negative","underlyingIssue":"experiencing problems with coordination","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems with your coordination?</p>","preferredWording":"Did you have trouble with your coordination?","recommendedWording":null,"questionnaires":[15,111,184,252,381,477,699,732,734,481,514,515,534,615,698],"categories":[104],"createDate":"2016-03-01T11:29:00.813","updateDate":"2020-03-09T10:33:49.467"},"rank":100},{"type":"item","object":{"rank":100,"id":302,"code":"Q242","type":"question","description":"medication diarrhoea","direction":"none","underlyingIssue":"need to take medication to control diarrhoea","additionalInfo":"","preferredWording":"Have you needed to take medication to control diarrhoea?","recommendedWording":null,"questionnaires":[16,111,263,381],"categories":[11],"createDate":"2016-03-01T11:29:16.697","updateDate":"2020-03-09T10:34:34.49"},"rank":100},{"type":"item","object":{"rank":100,"id":304,"code":"Q243","type":"question","description":"highest number bowel movement","direction":"none","underlyingIssue":"highest number of bowel movements in 24 h","additionalInfo":"","preferredWording":"What was the highest number of times you had to open your bowels in any 24 hour period?","recommendedWording":null,"questionnaires":[16,111,489,490,498,501,263,267,381],"categories":[11],"createDate":"2016-03-01T11:30:18.91","updateDate":"2020-03-09T10:36:44.36"},"rank":100},{"type":"item","object":{"rank":100,"id":306,"code":"Q244","type":"question","description":"assistance manage bowel problem","direction":"none","underlyingIssue":"wishing more assistance to manage one\'s bowel problem","additionalInfo":"","preferredWording":"Would you like more assistance to manage your bowel problem?","recommendedWording":null,"questionnaires":[16,111,263,381],"categories":[8,30],"createDate":"2016-03-01T11:32:07.6","updateDate":"2020-03-09T10:37:21.753"},"rank":100},{"type":"item","object":{"rank":100,"id":310,"code":"Q247","type":"question","description":"problem controlling bladder","direction":"negative","underlyingIssue":"experiencing problems controlling one\'s bladder","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems controlling your bladder?</p>","preferredWording":"Did you have trouble controlling your bladder?","recommendedWording":null,"questionnaires":[15,111,184,690,698,699,732,734,252,381,534,688],"categories":[145],"createDate":"2016-03-01T11:39:30.313","updateDate":"2020-03-09T10:41:35.563"},"rank":100},{"type":"item","object":{"rank":100,"id":311,"code":"Q248","type":"question","description":"numb tingling arm shoulder","direction":"negative","underlyingIssue":"having numbness/tingling in the arm/shoulder","additionalInfo":"","preferredWording":"Have you had numbness or tingling in your arm or shoulder?","recommendedWording":"Have you had numbness or tingling in your arm or shoulder?","questionnaires":[18,111,381],"categories":[130],"createDate":"2016-03-01T11:52:04.807","updateDate":"2020-03-09T10:42:08.34"},"rank":100},{"type":"item","object":{"rank":100,"id":312,"code":"Q249","type":"question","description":"uncomfortable position","direction":"negative","underlyingIssue":"finding some positions uncomfortable","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you found it uncomfortable in certain position (e.g. lying down)?</p>","preferredWording":"Did you find it uncomfortable in certain positions (e.g. lying down)?","recommendedWording":"Have you been uncomfortable in certain positions (e.g. lying down)?","questionnaires":[17,89,111,117,181,247,566,567,583,603,671,255,280,381,416,417,548],"categories":[101],"createDate":"2016-03-01T12:10:30.437","updateDate":"2020-03-09T10:42:44.343"},"rank":100},{"type":"item","object":{"rank":100,"id":313,"code":"Q250","type":"question","description":"limited amounts of food","direction":"negative","underlyingIssue":"being limited in the amounts of food as a result of disease or treatment","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been limited in the amount of food you could eat as a result of your disease or treatment?</p>","preferredWording":"Were you restricted in the amounts of food you could eat as a result of your disease or treatment?","recommendedWording":null,"questionnaires":[17,111,247,255,280,381,399,416,417,548,567,671],"categories":[37],"createDate":"2016-03-01T12:12:10.5","updateDate":"2020-03-09T10:58:38.753"},"rank":100},{"type":"item","object":{"rank":100,"id":314,"code":"Q251","type":"question","description":"indigestion","direction":"negative","underlyingIssue":"experiencing indigestion","additionalInfo":"","preferredWording":"Have you had indigestion?","recommendedWording":null,"questionnaires":[17,111,247,255,280,381,416,417,548,567,643,671],"categories":[57],"createDate":"2016-03-01T12:13:51.263","updateDate":"2020-03-09T10:59:05.053"},"rank":100},{"type":"item","object":{"rank":100,"id":315,"code":"Q252","type":"question","description":"FA15 weak arms legs","direction":"negative","underlyingIssue":"feeling weak in arms and legs","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt weak in your arms and legs?</p>","preferredWording":"Did you feel weak in your arms and legs?","recommendedWording":"Have you felt weak in your arms and legs?","questionnaires":[17,19,55,125,153,163,567,671,416,417,526,545,548,560,246,247,255,280,345,381],"categories":[50,70],"createDate":"2016-03-01T12:15:26.44","updateDate":"2020-02-27T14:27:21.81"},"rank":100},{"type":"item","object":{"rank":100,"id":316,"code":"Q253","type":"question","description":"yellow skin","direction":"negative","underlyingIssue":"skin being yellow (jaundiced)","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has your skin been yellow?</p>","preferredWording":"To what extent was your skin yellow?","recommendedWording":null,"questionnaires":[17,111,247,255,280,381,416,417,548,566,567,671],"categories":[26],"createDate":"2016-03-01T12:16:38.423","updateDate":"2020-03-09T10:59:28.97"},"rank":100},{"type":"item","object":{"rank":100,"id":317,"code":"Q254","type":"question","description":"frequent bowel movements","direction":"negative","underlyingIssue":"having frequent bowel movements","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had frequent bowel movements?</p>","preferredWording":"Did you have frequent bowel movements?","recommendedWording":"Have you had frequent bowel movements?","questionnaires":[17,89,111,117,671,416,417,548,567,247,255,280,381],"categories":[8],"createDate":"2016-03-01T12:17:43.85","updateDate":"2020-03-09T11:04:08.023"},"rank":100},{"type":"item","object":{"rank":100,"id":319,"code":"Q256","type":"question","description":"limited planning activites","direction":"negative","underlyingIssue":"being limited in planning activities in advance","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you been limited in planning activities in advance (e.g. meeting friends)?</p>","preferredWording":"Were you limited in planning activities in advance (e.g. meeting friends)?","recommendedWording":"Have you had problems planning activities in advance (e.g. meeting friends)?","questionnaires":[17,23,89,111,117,181,450,492,548,567,671,247,255,280,381,416,417],"categories":[],"createDate":"2016-03-01T12:21:29.78","updateDate":"2017-10-03T10:59:18.42"},"rank":100},{"type":"item","object":{"rank":100,"id":320,"code":"Q257","type":"question","description":"adequate support HCP","direction":"positive","underlyingIssue":"receiving enough support from the medical staff","additionalInfo":"","preferredWording":"Have you received adequate support from your health care professionals?","recommendedWording":null,"questionnaires":[17,111,247,255,280,381,416,417,548,567,671],"categories":[126],"createDate":"2016-03-01T12:22:30.56","updateDate":"2020-03-09T11:10:57.257"},"rank":100},{"type":"item","object":{"rank":100,"id":321,"code":"Q258","type":"question","description":"problem fullness arm","direction":"negative","underlyingIssue":"experiencing a problem with fullness under the arm","additionalInfo":"","preferredWording":"Have you had difficulty going out of the house, because you needed to be close to a toilet?","recommendedWording":null,"questionnaires":[18,111,381,690],"categories":[14,38],"createDate":"2016-03-01T12:22:38.563","updateDate":"2020-03-09T11:12:16.457"},"rank":100},{"type":"item","object":{"rank":100,"id":323,"code":"Q260","type":"question","description":"feel less sexually attractive","direction":"negative","underlyingIssue":"feeling less sexually attractive","additionalInfo":"","preferredWording":"Have you been feeling less sexually attractive as a result of your disease or treatment?","recommendedWording":"Have you been feeling less sexually attractive as a result of your disease or treatment?","questionnaires":[18,111,381],"categories":[4,133],"createDate":"2016-03-01T12:26:21.09","updateDate":"2020-03-09T11:13:42.29"},"rank":100},{"type":"item","object":{"rank":100,"id":324,"code":"Q261","type":"question","description":"uncomfortable intimate situations","direction":"negative","underlyingIssue":"feeling uncomfortable in intimate situations","additionalInfo":"","preferredWording":"Have you felt uncomfortable in intimate situations?","recommendedWording":null,"questionnaires":[18,111,228,381],"categories":[133],"createDate":"2016-03-01T12:28:19.403","updateDate":"2020-03-09T11:14:31.46"},"rank":100},{"type":"item","object":{"rank":100,"id":325,"code":"Q262","type":"question","description":"breast role sexuality","direction":"negative","underlyingIssue":"the role the breast in sexuality being affected by the disease/treatment","additionalInfo":"","preferredWording":"Has the role of your breast in your sexuality been affected by your disease or treatment?","recommendedWording":null,"questionnaires":[18,111,381],"categories":[14,133],"createDate":"2016-03-01T12:30:47.5","updateDate":"2020-03-09T11:15:09.51"},"rank":100},{"type":"item","object":{"rank":100,"id":326,"code":"Q263","type":"question","description":"problem loss sensations breast","direction":"negative","underlyingIssue":"experiencing problems with the loss of pleasurable sensations of the breast","additionalInfo":"","preferredWording":"Has any loss of pleasurable sensations of your breast been a problem to you?","recommendedWording":null,"questionnaires":[18,111,381,406],"categories":[14,133],"createDate":"2016-03-01T12:37:16.27","updateDate":"2020-03-09T11:16:11.44"},"rank":100},{"type":"item","object":{"rank":100,"id":327,"code":"Q264","type":"question","description":"satisfied size breast","direction":"positive","underlyingIssue":"being satisfied with the size of the breast","additionalInfo":"","preferredWording":"The size of your affected breast?","recommendedWording":null,"questionnaires":[18,111,119,381],"categories":[15,4],"createDate":"2016-03-01T12:39:37.813","updateDate":"2020-03-09T11:16:42.86"},"rank":100},{"type":"item","object":{"rank":100,"id":328,"code":"Q265","type":"question","description":"satisfied shape breast","direction":"positive","underlyingIssue":"being satisfied with the shape of the breast","additionalInfo":"","preferredWording":"The shape of your affected breast?","recommendedWording":null,"questionnaires":[18,381,111],"categories":[15,4],"createDate":"2016-03-01T12:40:20.7","updateDate":"2020-03-09T11:17:32.263"},"rank":100},{"type":"item","object":{"rank":100,"id":329,"code":"Q266","type":"question","description":"satisfied skin appearance breast","direction":"positive","underlyingIssue":"being satisfied with the skin appearance of the breast","additionalInfo":"","preferredWording":"Have you been satisfied with the appearance of the skin of your affected breast (thoracic area)?","recommendedWording":null,"questionnaires":[18,111,119,140,381,408],"categories":[15,4],"createDate":"2016-03-01T12:47:32.943","updateDate":"2020-03-09T11:18:00.547"},"rank":100},{"type":"item","object":{"rank":100,"id":330,"code":"Q267","type":"question","description":"satisfied symmetry breasts","direction":"positive","underlyingIssue":"being satisfied with the symmetry of the breasts","additionalInfo":"","preferredWording":"The symmetry of your breasts?","recommendedWording":null,"questionnaires":[18,111,119,381],"categories":[15,4],"createDate":"2016-03-01T12:48:25.22","updateDate":"2020-03-09T11:20:43.613"},"rank":100},{"type":"item","object":{"rank":100,"id":331,"code":"Q268","type":"question","description":"satisfied cleavage","direction":"positive","underlyingIssue":"being satisfied with the cleavage","additionalInfo":"","preferredWording":"Your cleavage?","recommendedWording":null,"questionnaires":[18,111,381],"categories":[15,4],"createDate":"2016-03-01T12:50:32.35","updateDate":"2020-03-09T11:22:04.283"},"rank":100},{"type":"item","object":{"rank":100,"id":332,"code":"Q269","type":"question","description":"satisfied softness breast","direction":"positive","underlyingIssue":"being satisfied with the softness of the breast","additionalInfo":"","preferredWording":"The softness of your affected breast?","recommendedWording":null,"questionnaires":[18,111,381,406,119],"categories":[15,22],"createDate":"2016-03-01T12:51:20.243","updateDate":"2020-03-09T11:22:52.003"},"rank":100},{"type":"item","object":{"rank":100,"id":333,"code":"Q270","type":"question","description":"satisfied appearance nipple","direction":"positive","underlyingIssue":"being satisfied with the appearance of the nipple","additionalInfo":"","preferredWording":"The appearance of your affected nipple?","recommendedWording":null,"questionnaires":[18,111,119,381],"categories":[15,4],"createDate":"2016-03-01T12:53:22.82","updateDate":"2020-03-09T11:23:54.667"},"rank":100},{"type":"item","object":{"rank":100,"id":280,"code":"Q220","type":"question","description":"blurred visionn","direction":"negative","underlyingIssue":"having blurred vision","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had blurred vision?</p>","preferredWording":"Was your vision blurred?","recommendedWording":null,"questionnaires":[15,22,78,111,153,621,649,698,699,732,734,515,517,534,556,571,615,458,477,481,482,485,514,163,184,215,240,252,381],"categories":[148],"createDate":"2016-03-01T09:43:00.34","updateDate":"2022-07-04T07:21:06.01"},"rank":100},{"type":"item","object":{"rank":100,"id":281,"code":"Q221","type":"question","description":"problems reading vision","direction":"negative","underlyingIssue":"experiencing problems with reading because of vision","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with reading because of your vision?</p>","preferredWording":"Did you have difficulty reading because of your vision?","recommendedWording":null,"questionnaires":[15,21,111,184,215,252,698,699,732,734,381,477,514,515,534,615],"categories":[148],"createDate":"2016-03-01T09:45:02.76","updateDate":"2020-03-09T10:08:38.343"},"rank":100},{"type":"item","object":{"rank":100,"id":284,"code":"Q224","type":"question","description":"problem finding words","direction":"negative","underlyingIssue":"experiencing problems finding the right words to express oneself","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems finding the right words to express yourself?</p>","preferredWording":"Have you had trouble finding the right words to express yourself?","recommendedWording":null,"questionnaires":[15,111,698,699,732,734,477,481,514,515,534,615,184,252,381],"categories":[],"createDate":"2016-03-01T10:19:25.703","updateDate":"2016-06-07T12:35:36.537"},"rank":100},{"type":"item","object":{"rank":100,"id":285,"code":"Q225","type":"question","description":"problem speaking","direction":"negative","underlyingIssue":"experiencing problems speaking","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems speaking?</p>","preferredWording":"Did you have difficulty speaking?","recommendedWording":"Have you had problems speaking?","questionnaires":[15,48,111,184,199,209,699,732,734,484,514,515,534,615,698,252,328,381,456,477,481],"categories":[],"createDate":"2016-03-01T10:23:16.843","updateDate":"2016-06-03T13:48:20.083"},"rank":100},{"type":"item","object":{"rank":100,"id":286,"code":"Q226","type":"question","description":"abdominal cramp","direction":"negative","underlyingIssue":"experiencing abdominal pain/cramping unrelated to bowel movement","additionalInfo":"","preferredWording":"Have you had abdominal pain or cramping not related to a bowel movement?","recommendedWording":null,"questionnaires":[16,94,102,111,127,381],"categories":[58,100],"createDate":"2016-03-01T10:29:58.557","updateDate":"2020-03-09T10:12:03.14"},"rank":100},{"type":"item","object":{"rank":100,"id":287,"code":"Q227","type":"question","description":"pain cramp rectum","direction":"negative","underlyingIssue":"experiencing pain/cramping in the rectum","additionalInfo":"","preferredWording":"Have you had pain or cramping in your rectum (deep inside the back passage)?","recommendedWording":null,"questionnaires":[16,111,263,381],"categories":[8,100],"createDate":"2016-03-01T10:30:43.283","updateDate":"2020-03-09T10:12:44.743"},"rank":100},{"type":"item","object":{"rank":100,"id":288,"code":"Q228","type":"question","description":"pain discomfort anus","direction":"negative","underlyingIssue":"experiencing pain/discomfort around the anus","additionalInfo":"","preferredWording":"Have you had pain /discomfort around your anal opening (back passage)?","recommendedWording":null,"questionnaires":[16,89,111,117,263,381,390,404],"categories":[8,100],"createDate":"2016-03-01T10:32:28.247","updateDate":"2020-03-09T10:13:25.93"},"rank":100},{"type":"item","object":{"rank":100,"id":291,"code":"Q231","type":"question","description":"unable wait bowel movement","direction":"negative","underlyingIssue":"being unable to wait for 15 minutes before bowel movement","additionalInfo":"","preferredWording":"Have you been unable to wait 15 minutes to open your bowels?","recommendedWording":null,"questionnaires":[16,111,312,381],"categories":[11],"createDate":"2016-03-01T10:34:59.26","updateDate":"2020-03-09T10:15:16.393"},"rank":100},{"type":"item","object":{"rank":100,"id":293,"code":"Q233","type":"question","description":"passing water open bowels","direction":"negative","underlyingIssue":"passing water causing bowel movement","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has passing water caused your bowel to act immediately?</p>","preferredWording":"Does passing water cause your bowels to act immediately?","recommendedWording":null,"questionnaires":[16,111,381],"categories":[11],"createDate":"2016-03-01T10:41:49.01","updateDate":"2020-03-09T10:17:33.343"},"rank":100},{"type":"item","object":{"rank":100,"id":294,"code":"Q234","type":"question","description":"wear incontinence aid","direction":"negative","underlyingIssue":"having to wear incontinence aid because of the bowel problems","additionalInfo":"","preferredWording":"Have you had to wear a pad because of your bowel problems?","recommendedWording":null,"questionnaires":[111,263,267,312,381,489,490,498,501],"categories":[8,82],"createDate":"2016-03-01T10:42:38.417","updateDate":"2020-03-09T10:18:10.707"},"rank":100},{"type":"item","object":{"rank":100,"id":295,"code":"Q235","type":"question","description":"restricted types food bowel problems","direction":"negative","underlyingIssue":"having to restrict the types of food one can eat because of bowel problems","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has your treatment restricted you in the types of food you could eat due to your bowel problems?</p>","preferredWording":"Did your treatment restrict the types of food you can eat due to your bowel problems?","recommendedWording":null,"questionnaires":[16,111,263,381],"categories":[8,37],"createDate":"2016-03-01T11:07:40.973","updateDate":"2020-03-09T10:24:54.81"},"rank":100},{"type":"item","object":{"rank":100,"id":296,"code":"Q236","type":"question","description":"worry bowel problem","direction":"negative","underlyingIssue":"worrying about one\'s bowel problem","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about your bowel problem?</p>","preferredWording":"Did you worry about your bowel problem?","recommendedWording":null,"questionnaires":[16,111,381],"categories":[8,41],"createDate":"2016-03-01T11:08:18.477","updateDate":"2020-03-09T10:25:53.153"},"rank":100},{"type":"item","object":{"rank":100,"id":297,"code":"Q237","type":"question","description":"embarrassed bowel problem","direction":"negative","underlyingIssue":"feeling embarrassed by one\'s bowel problem","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt embarrassed by your bowel problem?</p>","preferredWording":"Did you feel embarrassed by your bowel problem?","recommendedWording":null,"questionnaires":[16,111,263,267,381,490],"categories":[8,44],"createDate":"2016-03-01T11:09:11.563","updateDate":"2020-03-09T10:26:26.193"},"rank":100},{"type":"item","object":{"rank":100,"id":298,"code":"Q238","type":"question","description":"problem communicate thoughts","direction":"negative","underlyingIssue":"experiencing problems communicating one\'s thoughts","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems communicating your thoughts?</p>","preferredWording":"Did you have trouble communicating your thoughts?","recommendedWording":null,"questionnaires":[15,111,184,252,381,477,699,732,734,481,514,515,534,615,698],"categories":[139,21],"createDate":"2016-03-01T11:26:03.967","updateDate":"2020-03-09T10:27:01.183"},"rank":100},{"type":"item","object":{"rank":100,"id":258,"code":"Q198","type":"question","description":"pain not relieved by medication","direction":"negative","underlyingIssue":"having pain that cannot be relieved by pain medications","additionalInfo":"","preferredWording":"Have you had pain not relieved by pain medications?","recommendedWording":null,"questionnaires":[14,111,154,181,381,470],"categories":[],"createDate":"2016-02-29T15:37:55.07","updateDate":"2017-10-02T11:45:15.593"},"rank":100},{"type":"item","object":{"rank":100,"id":262,"code":"Q202","type":"question","description":"pain walking","direction":"negative","underlyingIssue":"having pain while walking","additionalInfo":"","preferredWording":"Have you had pain while walking?","recommendedWording":null,"questionnaires":[14,111,181,336,381,470],"categories":[],"createDate":"2016-02-29T15:45:02.947","updateDate":"2016-06-28T10:48:01.347"},"rank":100},{"type":"item","object":{"rank":100,"id":263,"code":"Q203","type":"question","description":"pain bending climbing stairs","direction":"negative","underlyingIssue":"having pain with bending or climbing stairs","additionalInfo":"","preferredWording":"Have you had pain with activities such as bending or climbing stairs?","recommendedWording":null,"questionnaires":[14,94,102,111,181,381,470],"categories":[],"createDate":"2016-02-29T15:45:52.807","updateDate":"2018-03-21T10:00:08.453"},"rank":100},{"type":"item","object":{"rank":100,"id":264,"code":"Q204","type":"question","description":"pain with strenuous activity","direction":"negative","underlyingIssue":"having pain with strenuous activity","additionalInfo":"","preferredWording":"Have you had pain with strenuous activity (e.g. exercise, lifting)?","recommendedWording":null,"questionnaires":[14,111,181,381,470],"categories":[],"createDate":"2016-02-29T15:46:44.867","updateDate":"2016-06-07T10:32:29.327"},"rank":100},{"type":"item","object":{"rank":100,"id":265,"code":"Q205","type":"question","description":"pain interfere sleeping","direction":"negative","underlyingIssue":"pain interfering with sleeping at night","additionalInfo":"","preferredWording":"Has pain interfered with your sleeping at night?","recommendedWording":null,"questionnaires":[14,111,181,381,470],"categories":[],"createDate":"2016-02-29T15:52:18.36","updateDate":"2016-06-07T10:35:11.667"},"rank":100},{"type":"item","object":{"rank":100,"id":266,"code":"Q206","type":"question","description":"modify daily activities","direction":"negative","underlyingIssue":"having to modify one\'s daily activities due to the illness","additionalInfo":"","preferredWording":"Have you had to modify your daily activities because of your illness?","recommendedWording":null,"questionnaires":[14,111,181,212,381,470],"categories":[1],"createDate":"2016-02-29T16:00:49.827","updateDate":"2020-03-09T09:53:22.42"},"rank":100},{"type":"item","object":{"rank":100,"id":268,"code":"Q208","type":"question","description":"worry mobility loss","direction":"negative","underlyingIssue":"worrying about loss of mobility due to the illness","additionalInfo":"","preferredWording":"Have you worried about loss of mobility because of your illness?","recommendedWording":null,"questionnaires":[14,111,181,381,470],"categories":[106,53],"createDate":"2016-03-01T08:18:46.213","updateDate":"2020-03-09T09:55:12.027"},"rank":100},{"type":"item","object":{"rank":100,"id":269,"code":"Q209","type":"question","description":"worry become dependent","direction":"negative","underlyingIssue":"worrying about becoming dependent on others","additionalInfo":"","preferredWording":"Have you worried about becoming dependent on others?","recommendedWording":"Have you worried about becoming dependent on others?","questionnaires":[14,24,31,33,41,111,623,624,181,212,381,470,545,622],"categories":[30,53],"createDate":"2016-03-01T08:26:08.477","updateDate":"2020-03-09T09:56:51.553"},"rank":100},{"type":"item","object":{"rank":100,"id":271,"code":"Q211","type":"question","description":"feel positive health","direction":"positive","underlyingIssue":"feeling positive about one\'s health","additionalInfo":"","preferredWording":"Have you felt positive about your health?","recommendedWording":null,"questionnaires":[14,111,181,381,470],"categories":[53,39],"createDate":"2016-03-01T08:33:40.847","updateDate":"2020-03-09T09:59:29.223"},"rank":100},{"type":"item","object":{"rank":100,"id":335,"code":"Q272","type":"question","description":"satisfied scars appearance breast","direction":"positive","underlyingIssue":"being satisfied with the scars appearance on the breast","additionalInfo":"","preferredWording":"How satisfied have you been with the appearance of any scars on your affected breast?","recommendedWording":null,"questionnaires":[18,111,381],"categories":[15,4],"createDate":"2016-03-01T12:58:08.763","updateDate":"2020-03-09T11:25:51.403"},"rank":100},{"type":"item","object":{"rank":100,"id":336,"code":"Q273","type":"question","description":"problems clothes tight","direction":"negative","underlyingIssue":"experiencing problems with clothes feeling too tight","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems with your clothes feeling too tight?</p>","preferredWording":"Did you have problems with your clothes feeling too tight?","recommendedWording":null,"questionnaires":[19,111,123,333,381,526],"categories":[57,38],"createDate":"2016-03-01T13:02:19.993","updateDate":"2020-03-09T11:26:21.713"},"rank":100},{"type":"item","object":{"rank":100,"id":337,"code":"Q274","type":"question","description":"satisfied breast reconstruction result ","direction":"positive","underlyingIssue":"being satisfied with the breast reconstruction result ","additionalInfo":"","preferredWording":"Overall, how satisfied have you been with the result of your breast reconstruction?","recommendedWording":null,"questionnaires":[18,111,381],"categories":[15,4],"createDate":"2016-03-01T13:05:24.61","updateDate":"2020-03-09T11:26:54.1"},"rank":100},{"type":"item","object":{"rank":100,"id":338,"code":"Q275","type":"question","description":"coming to terms breast reconstruction","direction":"positive","underlyingIssue":"coming to terms with the disease or treatment thanks to breast reconstruction","additionalInfo":"","preferredWording":"Has the reconstruction of your breast helped you come to terms with your disease or treatment?","recommendedWording":null,"questionnaires":[18,111,381],"categories":[15,30],"createDate":"2016-03-01T13:08:44.72","updateDate":"2020-03-09T11:27:30.04"},"rank":100},{"type":"item","object":{"rank":100,"id":339,"code":"Q276","type":"question","description":"tightness breast","direction":"negative","underlyingIssue":"having tightness in the breast","additionalInfo":"","preferredWording":"Have you had tightness?","recommendedWording":null,"questionnaires":[18,111,381,406],"categories":[15],"createDate":"2016-03-01T13:14:52.83","updateDate":"2020-03-09T11:27:53.877"},"rank":100},{"type":"item","object":{"rank":100,"id":340,"code":"Q277","type":"question","description":"numb breast","direction":"negative","underlyingIssue":"having numbness in the breast","additionalInfo":"","preferredWording":"Have you had any numbness?","recommendedWording":null,"questionnaires":[18,111,260,381,406],"categories":[15,131],"createDate":"2016-03-01T13:15:14.173","updateDate":"2020-03-09T11:28:22.363"},"rank":100},{"type":"item","object":{"rank":100,"id":341,"code":"Q278","type":"question","description":"satisfied scars appearance","direction":"positive","underlyingIssue":"being satisfied with the appearance of the scars","additionalInfo":"","preferredWording":"Have you been satisfied with the appearance of the scars?","recommendedWording":null,"questionnaires":[18,111,381],"categories":[15,4],"createDate":"2016-03-01T13:16:30.07","updateDate":"2020-03-09T11:28:57.293"},"rank":100},{"type":"item","object":{"rank":100,"id":342,"code":"Q279","type":"question","description":"problem loss of nipple","direction":"negative","underlyingIssue":"experiencing problems with the loss of the nipple","additionalInfo":"","preferredWording":"Has the loss of your nipple been a problem to you?","recommendedWording":null,"questionnaires":[18,111,381],"categories":[15,4],"createDate":"2016-03-01T13:17:40.15","updateDate":"2020-03-09T11:29:40.27"},"rank":100},{"type":"item","object":{"rank":100,"id":343,"code":"Q280","type":"question","description":"coming to terms nipple preservation/reconstruction","direction":"positive","underlyingIssue":"coming to terms with the disease/treatment thanks to the nipple preservation/reconstruction","additionalInfo":"","preferredWording":"Has the preservation or reconstruction of your nipple helped you come to terms with the disease or treatment?","recommendedWording":null,"questionnaires":[18,111,381,406],"categories":[15],"createDate":"2016-03-01T13:20:16.473","updateDate":"2020-03-09T11:30:19.893"},"rank":100},{"type":"item","object":{"rank":100,"id":344,"code":"IN17","type":"instructions","description":"affected breast","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"The term ‘affected’ refers to the breast, which has been, or is about to be, reconstructed.","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:24:57.263","updateDate":"2016-03-01T13:24:57.263"},"rank":100},{"type":"item","object":{"rank":100,"id":352,"code":"Q281","type":"question","description":"unpleasant food texture","direction":"negative","underlyingIssue":"finding the food texture unpleasany","additionalInfo":"","preferredWording":"Have you found the texture of food unpleasant?","recommendedWording":null,"questionnaires":[20,111,249,381,589,733],"categories":[33],"createDate":"2016-03-01T13:59:48.547","updateDate":"2020-03-09T11:30:41.033"},"rank":100},{"type":"item","object":{"rank":100,"id":353,"code":"Q282","type":"question","description":"change bowel habit","direction":"negative","underlyingIssue":"experiencing changes in bowel habit as a result of disease or treatment","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has your bowel habit changed as a result of your disease or treatment?</p>","preferredWording":"Did you experience any change in bowel habit as a result of your disease or treatment?","recommendedWording":null,"questionnaires":[19,111,123,124,333,381,526],"categories":[8],"createDate":"2016-03-01T14:00:42.26","updateDate":"2020-03-09T11:31:22.84"},"rank":100},{"type":"item","object":{"rank":100,"id":354,"code":"Q283","type":"question","description":"smell food put off","direction":"negative","underlyingIssue":"being put off eating by the smell of the food","additionalInfo":"","preferredWording":"Have you been put off eating by the smell of food?","recommendedWording":null,"questionnaires":[20,111,249,381,589,733],"categories":[],"createDate":"2016-03-01T14:04:02.773","updateDate":"2017-10-03T14:55:04.763"},"rank":100},{"type":"item","object":{"rank":100,"id":355,"code":"Q284","type":"question","description":"too much put off","direction":"negative","underlyingIssue":"being put off eating by having too much on the plate","additionalInfo":"","preferredWording":"Have you been put off eating by having too much food on your plate?","recommendedWording":null,"questionnaires":[20,111,249,381,589,733],"categories":[35],"createDate":"2016-03-01T14:06:54.35","updateDate":"2020-03-09T11:38:17.503"},"rank":100},{"type":"item","object":{"rank":100,"id":356,"code":"Q285","type":"question","description":"tingling hands feet","direction":"negative","underlyingIssue":"feeling tingling in hands or feet","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had tingling in your hands or feet?</p>","preferredWording":"Did you have tingling hands or feet?","recommendedWording":"Have you had tingling hands or feet?","questionnaires":[19,31,35,36,37,48,634,456,484,526,623,632,633,111,194,199,209,328,381],"categories":[130],"createDate":"2016-03-01T14:08:02.65","updateDate":"2020-03-09T11:39:39.513"},"rank":100},{"type":"item","object":{"rank":100,"id":358,"code":"Q287","type":"question","description":"worry not eat enough","direction":"negative","underlyingIssue":"worrying about not eating enough","additionalInfo":"","preferredWording":"Have you worried that you do not eat enough?","recommendedWording":null,"questionnaires":[20,111,249,381,589,733],"categories":[33],"createDate":"2016-03-01T14:12:00.34","updateDate":"2020-03-09T11:41:05.953"},"rank":100},{"type":"item","object":{"rank":100,"id":359,"code":"Q288","type":"question","description":"worry weight loss continues","direction":"negative","underlyingIssue":"worrying about what might happen if the weight loss continues","additionalInfo":"","preferredWording":"Have you worried about what will happen if you continue to lose weight?","recommendedWording":null,"questionnaires":[20,111,381,589,733],"categories":[53,72],"createDate":"2016-03-01T14:16:28.06","updateDate":"2020-03-09T11:42:38.443"},"rank":100},{"type":"item","object":{"rank":100,"id":360,"code":"Q289","type":"question","description":"aches pains muscles joints","direction":"negative","underlyingIssue":"having pains/aches in muscles or joints","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had aches or pains in your muscles or joints?</p>","preferredWording":"Have you had aches or pains in your muscles or joints?","recommendedWording":"Have you had aches or pains in your muscles or joints?","questionnaires":[19,24,26,31,33,38,622,623,624,485,517,526,545,554,563,302,378,381,409,414,482,41,111,166,170,254,256],"categories":[],"createDate":"2016-03-01T14:23:39.107","updateDate":"2016-06-07T15:36:28.073"},"rank":100},{"type":"item","object":{"rank":100,"id":361,"code":"Q290","type":"question","description":"unable to eat","direction":"negative","underlyingIssue":"being unable to eat despite wanting to","additionalInfo":"","preferredWording":"Have you been unable to eat despite wanting to?","recommendedWording":null,"questionnaires":[20,111,249,381,580,589,733],"categories":[33],"createDate":"2016-03-01T14:23:59.497","updateDate":"2020-03-09T11:43:23.683"},"rank":100},{"type":"item","object":{"rank":100,"id":362,"code":"Q291","type":"question","description":"problem swallowing","direction":"negative","underlyingIssue":"experiencing problems swallowing","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems swallowing?</p>","preferredWording":"Have you had problems swallowing?","recommendedWording":"Have you had problems swallowing?","questionnaires":[20,37,45,48,733,589,528,531,532,484,485,456,482,381,318,326,328,251,199,209,249,193,111],"categories":[92],"createDate":"2016-03-01T14:25:11.757","updateDate":"2020-03-09T11:43:43.373"},"rank":100},{"type":"item","object":{"rank":100,"id":363,"code":"Q292","type":"question","description":"pressure others eat more","direction":"negative","underlyingIssue":"feeling pressured by other people to eat more","additionalInfo":"","preferredWording":"Have you felt pressured by other people to eat more?","recommendedWording":null,"questionnaires":[20,111,249,381,589,733],"categories":[35],"createDate":"2016-03-01T14:26:49.887","updateDate":"2020-03-09T11:44:15.243"},"rank":100},{"type":"item","object":{"rank":100,"id":364,"code":"Q293","type":"question","description":"urinate frequently","direction":"negative","underlyingIssue":"urinating frequently","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had to urinate frequently?</p>","preferredWording":"Did you pass water/urine frequently?","recommendedWording":"Have you passed urine frequently?","questionnaires":[19,26,34,38,45,555,482,485,517,526,547,554,302,381,404,410,444,111,114,238,284],"categories":[144],"createDate":"2016-03-01T14:27:00.4","updateDate":"2020-03-09T11:44:40.17"},"rank":100},{"type":"item","object":{"rank":100,"id":365,"code":"Q294","type":"question","description":"worry burden other people","direction":"negative","underlyingIssue":"worrying about being a burden to other people","additionalInfo":"","preferredWording":"Have you worried that you are a burden to other people?","recommendedWording":null,"questionnaires":[20,111,249,269,381,589,733],"categories":[30],"createDate":"2016-03-01T14:28:07.873","updateDate":"2020-03-09T11:45:16.973"},"rank":100},{"type":"item","object":{"rank":100,"id":366,"code":"Q295","type":"question","description":"night sweats","direction":"negative","underlyingIssue":"experiencing excessive sweating at night","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had night sweats?</p>","preferredWording":"Did you have night sweats?","recommendedWording":"Have you had night sweats?","questionnaires":[19,23,24,42,111,254,545,558,562,602,487,493,500,504,506,526,450,461,466,474,482,485,256,381,387,395,421,424],"categories":[69],"createDate":"2016-03-01T14:29:14.707","updateDate":"2020-03-09T11:45:35.253"},"rank":100},{"type":"item","object":{"rank":100,"id":367,"code":"Q296","type":"question","description":"worry appearance","direction":"negative","underlyingIssue":"worrying about the appearance","additionalInfo":"","preferredWording":"Have you worried about your appearance?","recommendedWording":null,"questionnaires":[20,111,381,589,733],"categories":[4],"createDate":"2016-03-01T14:35:03.02","updateDate":"2020-03-09T11:45:57.97"},"rank":100},{"type":"item","object":{"rank":100,"id":368,"code":"Q297","type":"question","description":"feel weight loss control","direction":"negative","underlyingIssue":"feeling out of control about the weight loss","additionalInfo":"","preferredWording":"Have you felt your weight loss was out of control?","recommendedWording":"Have you felt your weight loss was out of control??","questionnaires":[20,111,381,589,733],"categories":[72],"createDate":"2016-03-01T14:36:03.193","updateDate":"2020-03-09T11:47:25.78"},"rank":100},{"type":"item","object":{"rank":100,"id":369,"code":"Q298","type":"question","description":"worry change daily life","direction":"negative","underlyingIssue":"worrying about changes in one\'s daily life","additionalInfo":"","preferredWording":"Have you worried about changes in your daily life?","recommendedWording":null,"questionnaires":[20,111,249,381,589,733],"categories":[1],"createDate":"2016-03-01T14:39:17.077","updateDate":"2020-03-09T11:47:54.423"},"rank":100},{"type":"item","object":{"rank":100,"id":370,"code":"Q299","type":"question","description":"worry become more dependent","direction":"negative","underlyingIssue":"worrying about becoming more dependent on others","additionalInfo":"","preferredWording":"Have you worried about becoming more dependent on others?\\n","recommendedWording":null,"questionnaires":[20,111,249,381,399,589,690,733],"categories":[30,53],"createDate":"2016-03-01T14:40:05.127","updateDate":"2020-03-09T11:48:34.063"},"rank":100},{"type":"item","object":{"rank":100,"id":371,"code":"Q300","type":"question","description":"problem usual activities weight loss","direction":"negative","underlyingIssue":"experiencing problems doing usual activities due to the weight loss","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems doing your usual activities because of your weight?<br /></p>","preferredWording":"Have you had difficulty doing your usual activities because of your weight loss?\\n","recommendedWording":null,"questionnaires":[20,111,381,562,589,733],"categories":[1,72],"createDate":"2016-03-01T14:42:18.933","updateDate":"2020-03-09T11:49:38.663"},"rank":100},{"type":"item","object":{"rank":100,"id":372,"code":"Q301","type":"question","description":"FA29 tired eat","direction":"negative","underlyingIssue":"being too tired to eat","additionalInfo":"","preferredWording":"Have you been too tired to eat?","recommendedWording":null,"questionnaires":[20,55,111,246,249,381,589,650,733],"categories":[50,33],"createDate":"2016-03-01T14:43:04.44","updateDate":"2020-02-27T12:46:43.63"},"rank":100},{"type":"item","object":{"rank":100,"id":374,"code":"Q303","type":"question","description":"AP02 force eat","direction":"negative","underlyingIssue":"forcing yourself to eat","additionalInfo":"","preferredWording":"Have you forced yourself to eat?","recommendedWording":null,"questionnaires":[20,58,111,249,279,381,589,733],"categories":[35],"createDate":"2016-03-01T14:45:19.57","updateDate":"2020-02-18T14:35:25.673"},"rank":100},{"type":"item","object":{"rank":100,"id":375,"code":"Q304","type":"question","description":"adequate information weight loss","direction":"positive","underlyingIssue":"receiving adequate information about weight loss","additionalInfo":"","preferredWording":"Has the information you have been given about your weight loss been adequate?\\n","recommendedWording":null,"questionnaires":[20,111,381,589,733],"categories":[125,72],"createDate":"2016-03-01T14:52:12.177","updateDate":"2020-03-09T12:03:27.943"},"rank":100},{"type":"item","object":{"rank":100,"id":376,"code":"Q305","type":"question","description":"grittiness treated eye","direction":"negative","underlyingIssue":"feeling of grittiness or a foreign body in the treated eye","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had the sensation of grittiness or the feeling of a foreign body in the treated eye?</p>","preferredWording":"Did you have the sensation of grittiness or the feeling of a foreign body in the treated eye?","recommendedWording":null,"questionnaires":[21,111,381],"categories":[148],"createDate":"2016-03-01T14:53:42.207","updateDate":"2020-03-09T12:03:45.367"},"rank":100},{"type":"item","object":{"rank":100,"id":377,"code":"Q306","type":"question","description":"pain soreness discomfort treated eye","direction":"negative","underlyingIssue":"feeling pain, soreness or discomfort in or around the treated eye","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt pain, soreness or discomfort in or around the treated eye?</p>","preferredWording":"Did you feel any pain, soreness or discomfort in or around the treated eye?","recommendedWording":null,"questionnaires":[21,111,381],"categories":[148,100],"createDate":"2016-03-01T14:54:39.93","updateDate":"2020-03-09T12:04:20.78"},"rank":100},{"type":"item","object":{"rank":100,"id":378,"code":"Q307","type":"question","description":"itching treated eye","direction":"negative","underlyingIssue":"feeling itchiness in the treated eye","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had itching in the treated eye?</p>","preferredWording":"Did you have any itching in your treated eye?","recommendedWording":null,"questionnaires":[21,111,381],"categories":[148],"createDate":"2016-03-01T14:55:57.527","updateDate":"2020-03-09T12:04:41.357"},"rank":100},{"type":"item","object":{"rank":100,"id":379,"code":"Q308","type":"question","description":"problem watering treated eye","direction":"negative","underlyingIssue":"experiencing problems with watering in the treated eye","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with watering in the treated eye?</p>","preferredWording":"Did watering in the treated eye trouble you?","recommendedWording":null,"questionnaires":[21,111,381],"categories":[148],"createDate":"2016-03-01T14:57:11.287","updateDate":"2020-03-09T12:05:02.93"},"rank":100},{"type":"item","object":{"rank":100,"id":380,"code":"Q309","type":"question","description":"tingling fingers hands","direction":"negative","underlyingIssue":"experiencing tingling in fingers or hands","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had tingling in your fingers or hands?</p>","preferredWording":"Did you have tingling fingers or hands?","recommendedWording":null,"questionnaires":[22,111,381,485,517,545,571],"categories":[130],"createDate":"2016-03-01T14:58:28.23","updateDate":"2020-03-09T12:05:27.407"},"rank":100},{"type":"item","object":{"rank":100,"id":381,"code":"Q310","type":"question","description":"problem discharge treated eye","direction":"negative","underlyingIssue":"experiencing problems with discharge from the treated eye","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with discharge from your treated eye?</p>","preferredWording":"Were you troubled by any discharge from your treated eye?","recommendedWording":null,"questionnaires":[21,111,381],"categories":[148],"createDate":"2016-03-01T14:58:52.177","updateDate":"2020-03-09T12:05:52.243"},"rank":100},{"type":"item","object":{"rank":100,"id":382,"code":"Q311","type":"question","description":"dryness treated eye","direction":"negative","underlyingIssue":"having dryness in the treated eye","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had dryness in your treated eye?</p>","preferredWording":"Did you suffer from dryness in your treated eye?","recommendedWording":null,"questionnaires":[21,111,381],"categories":[148],"createDate":"2016-03-01T14:59:31.317","updateDate":"2020-03-09T12:08:08.85"},"rank":100},{"type":"item","object":{"rank":100,"id":383,"code":"Q312","type":"question","description":"tingling toes feet","direction":"negative","underlyingIssue":"experiencing tingling in toes or feet","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had tingling in your toes or feet?</p>","preferredWording":"Did you have tingling toes or feet?","recommendedWording":null,"questionnaires":[22,111,229,381,485,517,545,571],"categories":[130],"createDate":"2016-03-01T15:00:08.213","updateDate":"2020-03-09T12:08:35.323"},"rank":100},{"type":"item","object":{"rank":100,"id":384,"code":"Q313","type":"question","description":"problem defects side vision","direction":"negative","underlyingIssue":"experiencing problems with defects in the side vision","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with any defects in your side vision?</p>","preferredWording":"Were you troubled by any defects in your side vision?","recommendedWording":null,"questionnaires":[21,381,556,111],"categories":[148],"createDate":"2016-03-01T15:00:09.6","updateDate":"2020-03-09T12:08:56.43"},"rank":100},{"type":"item","object":{"rank":100,"id":273,"code":"Q213","type":"question","description":"setbacks condition","direction":"negative","underlyingIssue":"feeling setbacks in one\'s condition","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt you had setbacks in your physical condition?</p>","preferredWording":"Did you feel you had setbacks in your condition??","recommendedWording":null,"questionnaires":[15,31,111,181,716,732,734,461,534,545,623,698,699,184,252,381,450],"categories":[62],"createDate":"2016-03-01T08:56:41.187","updateDate":"2020-03-09T10:01:31.48"},"rank":100},{"type":"item","object":{"rank":100,"id":274,"code":"Q214","type":"question","description":"gurgling noise abdomen","direction":"negative","underlyingIssue":"experiencing excessive gurgling noises from the abdomen","additionalInfo":"","preferredWording":"Have you had excessive gurgling noise from your abdomen?","recommendedWording":null,"questionnaires":[16,111,381],"categories":[57],"createDate":"2016-03-01T09:04:53.84","updateDate":"2020-03-09T10:03:33.423"},"rank":100},{"type":"item","object":{"rank":100,"id":276,"code":"Q216","type":"question","description":"release liquid stools","direction":"negative","underlyingIssue":"unintentionally releasing/leaking liquid stoold","additionalInfo":"","preferredWording":"Have you had any unintentional release (leakage) of liquid stools?","recommendedWording":null,"questionnaires":[16,111,263,312,381,507],"categories":[12],"createDate":"2016-03-01T09:11:41.81","updateDate":"2020-03-09T10:04:43.297"},"rank":100},{"type":"item","object":{"rank":100,"id":386,"code":"Q315","type":"question","description":"numb fingers/hands","direction":"negative","underlyingIssue":"experiencing numbness in fingers or hands","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had numbness in your fingers or hands?</p>","preferredWording":"Did you have numbness in your fingers or hands?","recommendedWording":null,"questionnaires":[22,111,381,545,571],"categories":[130],"createDate":"2016-03-01T15:01:10.88","updateDate":"2020-03-09T12:10:00.143"},"rank":100},{"type":"item","object":{"rank":100,"id":391,"code":"Q320","type":"question","description":"worry tumor other areas","direction":"negative","underlyingIssue":"worrying about possible recurrence in other areas of the body","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you worried about a tumor recurring in other parts of the body?</p>","preferredWording":"Were you worried about a tumour recurring in other areas of the body?","recommendedWording":null,"questionnaires":[21,42,111,261,321,381],"categories":[55],"createDate":"2016-03-01T15:07:00.91","updateDate":"2020-03-09T12:12:59.59"},"rank":100},{"type":"item","object":{"rank":100,"id":392,"code":"Q321","type":"question","description":"cramps hands","direction":"negative","underlyingIssue":"having cramps in hands","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had cramps in your hands?</p>","preferredWording":"Did you have cramps in your hands?","recommendedWording":null,"questionnaires":[22,111,381,571,621],"categories":[100,7],"createDate":"2016-03-01T15:07:15.543","updateDate":"2020-03-09T12:13:45.89"},"rank":100},{"type":"item","object":{"rank":100,"id":404,"code":"Q331","type":"question","description":"problem steps pavements","direction":"negative","underlyingIssue":"experiencing problems with steps or pavements","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems with steps or pavements?</p>","preferredWording":"Did you have any difficulty with steps or pavements?","recommendedWording":null,"questionnaires":[21,111,381],"categories":[106,148],"createDate":"2016-03-01T15:23:33.67","updateDate":"2020-03-09T12:25:12.493"},"rank":100},{"type":"item","object":{"rank":100,"id":405,"code":"Q332","type":"question","description":"problem open weak hands","direction":"negative","underlyingIssue":"experiencing problems opening a jar/bottle due to weakness in hands","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems with opening a jar or bottle because of weakness in your hands?</p>","preferredWording":"Did you have difficulty opening a jar or bottle because of weakness in your hands?","recommendedWording":null,"questionnaires":[22,111,282,381,571,621],"categories":[52,6],"createDate":"2016-03-01T15:23:52.453","updateDate":"2020-03-09T12:25:38.887"},"rank":100},{"type":"item","object":{"rank":100,"id":407,"code":"Q334","type":"question","description":"problem walking downstairs uneven ground","direction":"negative","underlyingIssue":"experiencing problems walking down the stairs or on uneven ground","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems walking down the stairs or on uneven ground?</p>","preferredWording":"Did you have any difficulty walking downstairs or on uneven ground?","recommendedWording":null,"questionnaires":[21,111,381],"categories":[106,148],"createDate":"2016-03-01T15:26:48.087","updateDate":"2020-03-09T12:26:41.1"},"rank":100},{"type":"item","object":{"rank":100,"id":408,"code":"Q335","type":"question","description":"problem stairs chair weak legs","direction":"negative","underlyingIssue":"experiencing problems climbing stairs/getting up out of a chair due to weakness in legs","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems climbing stairs or getting up out of a chair because of weakness in your legs?</p>","preferredWording":"Did you have difficulty climbing stairs or getting up out of a chair because of weakness in your legs?","recommendedWording":null,"questionnaires":[22,111,125,282,381,545,571,621],"categories":[103,6],"createDate":"2016-03-01T15:27:32.44","updateDate":"2020-03-09T12:27:20.943"},"rank":100},{"type":"item","object":{"rank":100,"id":409,"code":"Q336","type":"question","description":"dizzy stan up sitting lying position","direction":"negative","underlyingIssue":"feeling dizzy when standing up from a sitting or lying position","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been dizzy when standing up from a sitting or lying position?</p>","preferredWording":"Were you dizzy when standing up from a sitting or lying position?","recommendedWording":null,"questionnaires":[22,111,381,571,621],"categories":[129,110],"createDate":"2016-03-01T15:28:50.567","updateDate":"2020-03-09T12:27:51.487"},"rank":100},{"type":"item","object":{"rank":100,"id":411,"code":"Q338","type":"question","description":"problem use pedals","direction":"negative","underlyingIssue":"experiencing problems using the pedals","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems using the pedals?</p>","preferredWording":"Did you have difficulty using the pedals?","recommendedWording":"Did you have difficulty using the pedals?","questionnaires":[22,111,381,571,621],"categories":[130,6],"createDate":"2016-03-01T15:30:21.86","updateDate":"2020-03-09T12:28:43.077"},"rank":100},{"type":"item","object":{"rank":100,"id":412,"code":"Q339","type":"question","description":"activities limited vision","direction":"negative","underlyingIssue":"vision limiting one\'s activities","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have your activities been limited because of your vision?</p>","preferredWording":"Were your activities limited in any way because of your vision?","recommendedWording":null,"questionnaires":[21,111,381],"categories":[148,1],"createDate":"2016-03-01T15:30:34.137","updateDate":"2020-03-09T12:29:09.19"},"rank":100},{"type":"item","object":{"rank":100,"id":396,"code":"Q323","type":"question","description":"worry lose eye","direction":"negative","underlyingIssue":"worrying about losing the eye","additionalInfo":"","preferredWording":"Were you worried about losing the eye?","recommendedWording":null,"questionnaires":[21,111,381],"categories":[148,54],"createDate":"2016-03-01T15:10:44.577","updateDate":"2020-03-09T12:14:58.74"},"rank":100},{"type":"item","object":{"rank":100,"id":397,"code":"Q324","type":"question","description":"problem standing walking feeling ground","direction":"negative","underlyingIssue":"experiencing problems standing or walking because of difficulty feeling the ground under the feet","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems standing or walking because of difficulty feeling the ground under your feet?</p>","preferredWording":"Did you have problems standing or walking because of difficulty feeling the ground under your feet?","recommendedWording":null,"questionnaires":[22,111,282,381,545,571,630],"categories":[130,106],"createDate":"2016-03-01T15:12:09.663","updateDate":"2020-03-09T12:15:40.783"},"rank":100},{"type":"item","object":{"rank":100,"id":398,"code":"Q325","type":"question","description":"dissatisfied cosmetic surgery","direction":"negative","underlyingIssue":"being dissatisfied with the cosmetic result of the surgery","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been dissatisfied with the cosmetic result of the surgery?</p>","preferredWording":"Were you dissatisfied with the cosmetic result of the surgery?","recommendedWording":null,"questionnaires":[21,111,381],"categories":[4,141],"createDate":"2016-03-01T15:13:48.803","updateDate":"2020-03-09T12:17:03.963"},"rank":100},{"type":"item","object":{"rank":100,"id":399,"code":"Q326","type":"question","description":"problem distinguish hot cold water","direction":"negative","underlyingIssue":"experiencing problems distinguishing between hot and cold water","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems distinguishing between hot and cold water?</p>","preferredWording":"Did you have difficulty distinguishing between hot and cold water?","recommendedWording":null,"questionnaires":[22,111,381,545,571],"categories":[130],"createDate":"2016-03-01T15:14:07.417","updateDate":"2020-03-09T12:18:10.917"},"rank":100},{"type":"item","object":{"rank":100,"id":400,"code":"Q327","type":"question","description":"problem pouring","direction":"negative","underlyingIssue":"experiencing problems pouring liquids","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems pouring (e.g., tea or coffee)?</p>","preferredWording":"Did you have difficulty pouring (e.g., tea or coffee)?","recommendedWording":null,"questionnaires":[21,111,381],"categories":[52,148],"createDate":"2016-03-01T15:15:33.83","updateDate":"2020-03-09T12:18:39.137"},"rank":100},{"type":"item","object":{"rank":100,"id":401,"code":"Q328","type":"question","description":"problem walk crowd","direction":"negative","underlyingIssue":"experiencing problems walking in crowded areas","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems walking in crowded areas?</p>","preferredWording":"Did you have difficulty seeing to walk in crowded areas?","recommendedWording":"Did you have difficulty seeing to walk in crowded areas?","questionnaires":[21,111,381],"categories":[148],"createDate":"2016-03-01T15:18:44.64","updateDate":"2020-03-09T12:22:59.363"},"rank":100},{"type":"item","object":{"rank":100,"id":414,"code":"Q340","type":"question","description":"distorted treated eye","direction":"negative","underlyingIssue":"things appearing distorted out of the treated eye","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have things appeared distorted out of the treated eye?</p>","preferredWording":"Did things appear distorted out of your treated eye?","recommendedWording":null,"questionnaires":[21,111,381],"categories":[148],"createDate":"2016-03-01T15:32:17.133","updateDate":"2020-03-09T12:36:45.04"},"rank":100},{"type":"item","object":{"rank":100,"id":415,"code":"Q341","type":"question","description":"Flash balls light treated eye","direction":"negative","underlyingIssue":"seeing flashes/balls of light with the treated eye","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you seen flashes or balls of light with the treated eye??</p>","preferredWording":"Did you see flashes or balls of light with your treated eye?","recommendedWording":"Did you see flashes or balls of light with your treated eye?","questionnaires":[21,111,381,716],"categories":[152],"createDate":"2016-03-01T15:32:59.507","updateDate":"2022-06-29T08:59:23.58"},"rank":100},{"type":"item","object":{"rank":100,"id":416,"code":"Q342","type":"question","description":"floaters treated eye","direction":"negative","underlyingIssue":"seeing floaters with the treated eye","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you seen floaters with the treated eye?</p>","preferredWording":"Did you see floaters with your treated eye?","recommendedWording":"Did you see floaters with your treated eye?","questionnaires":[21,111,381],"categories":[152],"createDate":"2016-03-01T15:33:31.283","updateDate":"2020-03-09T12:37:50.793"},"rank":100},{"type":"item","object":{"rank":100,"id":417,"code":"Q343","type":"question","description":"bright light uncomfortable","direction":"negative","underlyingIssue":"treated eye feeling uncomfortable in bright light","additionalInfo":"<p><u>Recommended wording:</u></p><p>Has you eye felt uncomfortable in bright light?</p>","preferredWording":"Have your eyes felt uncomfortable in bright light?","recommendedWording":"Have your eyes felt uncomfortable in bright light?","questionnaires":[21,111,240,381,556],"categories":[148],"createDate":"2016-03-01T15:34:16.493","updateDate":"2020-03-09T12:39:06.093"},"rank":100},{"type":"item","object":{"rank":100,"id":418,"code":"Q344","type":"question","description":"vision interfere treated eye","direction":"negative","underlyingIssue":"vision of the treated eye interfering with the other eye","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has the vision of the treated eye interfered with the other eye?</p>","preferredWording":"Did the vision of the treated eye interfere with the other eye?","recommendedWording":null,"questionnaires":[21,111,381],"categories":[148],"createDate":"2016-03-01T15:35:04.683","updateDate":"2020-03-09T12:39:29.057"},"rank":100},{"type":"item","object":{"rank":100,"id":419,"code":"Q345","type":"question","description":"worry tumor recur treated eye","direction":"negative","underlyingIssue":"worrying about tumour recurring in the treated eye","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about tumor recurring in the treated eye?</p>","preferredWording":"Were you worried about the tumour recurring in the treated eye?","recommendedWording":null,"questionnaires":[21,111,381],"categories":[148,55],"createDate":"2016-03-01T15:36:36.43","updateDate":"2020-03-09T13:27:40.843"},"rank":100},{"type":"item","object":{"rank":100,"id":420,"code":"Q346","type":"question","description":"problem driving daylight","direction":"negative","underlyingIssue":"experiencing problems driving in daylight because of the vision impairment","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems driving in daylight because of your vision?</p>","preferredWording":"Did you have difficulty driving in daylight because of your vision?","recommendedWording":null,"questionnaires":[21,111,381],"categories":[148,1],"createDate":"2016-03-01T15:37:22.687","updateDate":"2020-03-09T13:28:05.04"},"rank":100},{"type":"item","object":{"rank":100,"id":421,"code":"Q347","type":"question","description":"problem driving dark ","direction":"negative","underlyingIssue":"experiencing problems driving in the dark because of the vision impairment","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems driving in the dark because of your vision?</p>","preferredWording":"Did you have difficulty driving in the dark because of your vision?","recommendedWording":null,"questionnaires":[21,111,381],"categories":[148,1],"createDate":"2016-03-01T15:38:00.143","updateDate":"2020-03-09T14:15:36.41"},"rank":100},{"type":"item","object":{"rank":100,"id":428,"code":"Q354","type":"question","description":"worry get infection ","direction":"negative","underlyingIssue":"worrying about getting an infection","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about getting an infection?</p>","preferredWording":"Have you worried about picking up an infection?","recommendedWording":null,"questionnaires":[23,26,31,33,41,111,381,545,622,623,624],"categories":[67],"createDate":"2016-03-01T15:58:45.26","updateDate":"2020-03-09T14:27:02.717"},"rank":100},{"type":"item","object":{"rank":100,"id":429,"code":"Q355","type":"question","description":" muscle weakness","direction":"negative","underlyingIssue":"having muscle weakness","additionalInfo":"","preferredWording":"Have you had muscle weakness?","recommendedWording":null,"questionnaires":[24,31,33,41,623,624,381,545,622,111],"categories":[6],"createDate":"2016-03-02T10:19:42.077","updateDate":"2020-05-15T15:03:46.79"},"rank":100},{"type":"item","object":{"rank":100,"id":430,"code":"Q356","type":"question","description":"aches pain bones","direction":"negative","underlyingIssue":"having aches or pain in the bones","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had aches or pain in your bones?</p>","preferredWording":"Have you had bone aches or pain?","recommendedWording":"Have you had aches or pains in your bones?","questionnaires":[24,31,35,41,634,609,610,622,623,632,633,487,545,602,445,466,474,481,482,485,378,381,408,226,227,240,45,111,140,212],"categories":[],"createDate":"2016-03-02T10:21:00.423","updateDate":"2017-10-04T10:26:33.97"},"rank":100},{"type":"item","object":{"rank":100,"id":431,"code":"Q357","type":"question","description":" short breath exertion","direction":"negative","underlyingIssue":"having shortness of breath on exertion","additionalInfo":"","preferredWording":"Have you had shortness of breath on exertion?","recommendedWording":null,"questionnaires":[24,31,33,41,103,624,381,545,622,623,111,125,183,187],"categories":[32,101],"createDate":"2016-03-02T10:26:29.097","updateDate":"2020-03-09T14:29:03.21"},"rank":100},{"type":"item","object":{"rank":100,"id":433,"code":"Q359","type":"question","description":"sudden tiredness","direction":"negative","underlyingIssue":"having sudden tiredness","additionalInfo":"","preferredWording":"Have you had sudden attacks of tiredness?","recommendedWording":"Have you had sudden attacks of tiredness?","questionnaires":[24,31,33,41,111,269,579,622,623,624,650,464,493,504,506,545,546,381,387,395,421,424,450],"categories":[50],"createDate":"2016-03-02T10:33:42.62","updateDate":"2020-03-09T14:29:53.443"},"rank":100},{"type":"item","object":{"rank":100,"id":438,"code":"Q364","type":"question","description":"worry recurrence disease","direction":"negative","underlyingIssue":"worrying about recurrence of the disease","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about recurrence of your disease?</p>","preferredWording":"Have you worried about recurrence of your disease?","recommendedWording":"Have you worried about recurrence of your disease?","questionnaires":[11,24,31,33,41,111,517,545,622,623,624,269,381,450,461,482,485],"categories":[55],"createDate":"2016-03-02T10:49:57.177","updateDate":"2020-03-09T14:48:28.093"},"rank":100},{"type":"item","object":{"rank":100,"id":441,"code":"Q366","type":"question","description":"worry another type cancer","direction":"negative","underlyingIssue":"worrying about getting another type of cancer","additionalInfo":"","preferredWording":"Have you worried about getting another type of cancer?","recommendedWording":null,"questionnaires":[24,31,33,41,111,485,517,545,622,623,624,321,381,482],"categories":[55],"createDate":"2016-03-02T11:05:23.35","updateDate":"2020-03-09T14:49:29.027"},"rank":100},{"type":"item","object":{"rank":100,"id":442,"code":"Q367","type":"question","description":"information dental mouth problems","direction":"none","underlyingIssue":"receiving information about possible dental or mouth problems","additionalInfo":"","preferredWording":"Have you received any information about possible dental or mouth problems?","recommendedWording":null,"questionnaires":[25,111,381,492],"categories":[89,125],"createDate":"2016-03-02T11:11:17.517","updateDate":"2020-03-09T14:50:48.23"},"rank":100},{"type":"item","object":{"rank":100,"id":443,"code":"Q368","type":"question","description":"worry treatment future health problem","direction":"negative","underlyingIssue":"worrying about the treatment causing future health problems","additionalInfo":"","preferredWording":"Have you worried about your treatment causing future health problems?","recommendedWording":null,"questionnaires":[24,31,33,41,111,622,623,624,311,381,482,485,517,545],"categories":[53],"createDate":"2016-03-02T11:20:04.567","updateDate":"2020-03-09T14:54:30.933"},"rank":100},{"type":"item","object":{"rank":100,"id":445,"code":"Q370","type":"question","description":"worry continue work education","direction":"negative","underlyingIssue":"worrying about not being able to continue working or education","additionalInfo":"","preferredWording":"Have you worried about not being able to continue working or your education?","recommendedWording":null,"questionnaires":[24,31,33,41,111,545,622,623,624,134,381,413],"categories":[123,53],"createDate":"2016-03-02T11:23:40.34","updateDate":"2020-03-09T14:56:46.06"},"rank":100},{"type":"item","object":{"rank":100,"id":424,"code":"Q350","type":"question","description":"lethargic","direction":"negative","underlyingIssue":"feeling lethargic","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt lethargic?</p>","preferredWording":"Did you feel lethargic?","recommendedWording":null,"questionnaires":[23,111,153,381,450,461,500],"categories":[50],"createDate":"2016-03-01T15:53:23.2","updateDate":"2020-03-09T14:25:03.36"},"rank":100},{"type":"item","object":{"rank":100,"id":447,"code":"Q371","type":"question","description":"satisfied amount information dental mouth problems","direction":"positive","underlyingIssue":"being satisfied with the amount of information about possible dental or mouth problems","additionalInfo":"","preferredWording":"Have you been satisfied with the amount of information you received about possible dental or mouth problems?","recommendedWording":null,"questionnaires":[25,111,381,492],"categories":[89,125],"createDate":"2016-03-02T11:28:39.497","updateDate":"2020-03-09T14:58:16.447"},"rank":100},{"type":"item","object":{"rank":100,"id":448,"code":"Q372","type":"question","description":"dentures","direction":"none","underlyingIssue":"wearing dentures","additionalInfo":"","preferredWording":"Have you worn dentures?","recommendedWording":null,"questionnaires":[25,111,381],"categories":[89,79],"createDate":"2016-03-02T11:29:12.757","updateDate":"2020-03-09T14:58:38.57"},"rank":100},{"type":"item","object":{"rank":100,"id":450,"code":"Q373","type":"question","description":"problem ill fitting dentures","direction":"negative","underlyingIssue":"experiencing problems with ill fitting dentures","additionalInfo":"","preferredWording":"Have you had problems with an ill fitting denture?","recommendedWording":null,"questionnaires":[25,111,381],"categories":[89,79],"createDate":"2016-03-02T11:29:56.923","updateDate":"2020-03-09T14:59:01.877"},"rank":100},{"type":"item","object":{"rank":100,"id":451,"code":"Q374","type":"question","description":"abdominal pain cramps","direction":"negative","underlyingIssue":"having abdominal pains or cramps","additionalInfo":"","preferredWording":"Have you had abdominal pains or cramps?","recommendedWording":null,"questionnaires":[26,45,111,197,240,249,501,643,263,267,381,489,490,498],"categories":[],"createDate":"2016-03-02T11:44:14.533","updateDate":"2016-06-10T15:12:10.693"},"rank":100},{"type":"item","object":{"rank":100,"id":452,"code":"Q375","type":"question","description":"worry changes weight","direction":"negative","underlyingIssue":"worrying about changes in one\'s weight","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about changes in your weight?</p>","preferredWording":"Have you been concerned about changes in your weight?","recommendedWording":null,"questionnaires":[26,111,381,492],"categories":[62],"createDate":"2016-03-02T11:52:07.28","updateDate":"2020-03-09T14:59:53.34"},"rank":100},{"type":"item","object":{"rank":100,"id":453,"code":"Q376","type":"question","description":"sweat excessively","direction":"negative","underlyingIssue":"sweating excessively","additionalInfo":"","preferredWording":"Have you sweated excessively?","recommendedWording":"Have you sweated excessively?","questionnaires":[26,111,140,240,381,408],"categories":[69],"createDate":"2016-03-02T12:34:49.63","updateDate":"2020-03-09T15:01:50.027"},"rank":100},{"type":"item","object":{"rank":100,"id":454,"code":"Q377","type":"question","description":"swelling certain body parts","direction":"negative","underlyingIssue":"having swelling in certain body parts","additionalInfo":"","preferredWording":"Have you experienced any swelling in certain parts of your body (e.g. ankles, legs or around your eyes)?","recommendedWording":null,"questionnaires":[26,111,381,409,451,482,485,517],"categories":[38],"createDate":"2016-03-02T12:40:36.183","updateDate":"2020-03-09T15:04:13.563"},"rank":100},{"type":"item","object":{"rank":100,"id":455,"code":"Q378","type":"question","description":"problem eyes","direction":"negative","underlyingIssue":"experiencing problems with one\'s eyes","additionalInfo":"","preferredWording":"Have you had problems with your eyes (e.g. burning, watery, irritated or dry)?","recommendedWording":null,"questionnaires":[26,111,163,381],"categories":[148],"createDate":"2016-03-02T12:41:59.583","updateDate":"2020-03-09T15:08:11.323"},"rank":100},{"type":"item","object":{"rank":100,"id":456,"code":"Q379","type":"question","description":"muscle cramps","direction":"negative","underlyingIssue":"having muscle cramps","additionalInfo":"","preferredWording":"Have you had muscle cramps?","recommendedWording":null,"questionnaires":[26,111,163,602,466,474,269,381],"categories":[7],"createDate":"2016-03-02T12:44:18.973","updateDate":"2020-03-09T15:09:57.217"},"rank":100},{"type":"item","object":{"rank":100,"id":458,"code":"Q381","type":"question","description":"problem carry usual activities tired","direction":"negative","underlyingIssue":"experiencing problems carrying on with usual activities because of getting tired easily","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems carrying on with you usual activities because of getting tired easily?</p>","preferredWording":"Have you had numbness or tingling in your arm or shoulder?aa","recommendedWording":"Have you had numbness or tingling in your arm or shoulder?aa","questionnaires":[26,111,381,650,688,689,690,702],"categories":[50,1],"createDate":"2016-03-02T12:50:42.173","updateDate":"2020-03-09T15:12:52.747"},"rank":100},{"type":"item","object":{"rank":100,"id":461,"code":"Q383","type":"question","description":"problem swallow saliva","direction":"negative","underlyingIssue":"experiencing problems swallowing saliva","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems swallowing your saliva?</p>","preferredWording":"Have you had trouble with swallowing your saliva?","recommendedWording":"Have you had problems swallowing your saliva?","questionnaires":[27,29,111,381],"categories":[92],"createDate":"2016-03-02T13:11:01.95","updateDate":"2020-03-09T15:19:00.267"},"rank":100},{"type":"item","object":{"rank":100,"id":462,"code":"Q384","type":"question","description":"need social support therapy disease","direction":"negative","underlyingIssue":"needing social support to undergo therapy to cope with the disease?","additionalInfo":"","preferredWording":"Have you needed social support (e.g. family, friends, or relatives) to undergo therapy or to cope with the disease?","recommendedWording":null,"questionnaires":[26,111,311,321,381,499],"categories":[30,49],"createDate":"2016-03-02T13:11:47.99","updateDate":"2020-03-10T15:25:02.683"},"rank":100},{"type":"item","object":{"rank":100,"id":464,"code":"Q386","type":"question","description":"satisfied received care","direction":"positive","underlyingIssue":"being satisfied with received care","additionalInfo":"","preferredWording":"Have you felt satisfied with the care you have received?","recommendedWording":null,"questionnaires":[26,111,381,478,499],"categories":[126],"createDate":"2016-03-02T13:13:37.35","updateDate":"2020-03-09T15:43:29.227"},"rank":100},{"type":"item","object":{"rank":100,"id":465,"code":"Q387","type":"question","description":"satisfied received information","direction":"positive","underlyingIssue":"being satisfied with received information","additionalInfo":"","preferredWording":"Have you felt satisfied with the information you have received (e.g. about the disease and its treatment)?","recommendedWording":null,"questionnaires":[26,111,311,321,381,478,499],"categories":[125],"createDate":"2016-03-02T13:15:49.22","updateDate":"2020-03-09T15:55:34.89"},"rank":100},{"type":"item","object":{"rank":100,"id":474,"code":"Q389","type":"question","description":"eat solid food","direction":"positive","underlyingIssue":"being able to eat solid food","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been able to eat solid food?</p>","preferredWording":"Could you eat solid food?","recommendedWording":null,"questionnaires":[29,111,381,580,641],"categories":[33],"createDate":"2016-03-02T13:46:02.057","updateDate":"2020-03-09T16:04:06.85"},"rank":100},{"type":"item","object":{"rank":100,"id":475,"code":"Q390","type":"question","description":"opportunities talk professionals","direction":"positive","underlyingIssue":"feeling that one has had enough opportunities to talk with HCPs","additionalInfo":"","preferredWording":"Have you had enough opportunities to talk with your professional(s)?","recommendedWording":null,"questionnaires":[28,111,169,172,327,363,381],"categories":[125],"createDate":"2016-03-02T13:46:41.95","updateDate":"2020-03-09T16:02:21.987"},"rank":100},{"type":"item","object":{"rank":100,"id":476,"code":"Q391","type":"question","description":"eat liquidised soft food","direction":"positive","underlyingIssue":"being able to eat liquidised or soft food","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been able to eat liquidised or soft food?</p>","preferredWording":"Could you eat liquidised or soft food?","recommendedWording":null,"questionnaires":[29,111,381,580],"categories":[33],"createDate":"2016-03-02T13:46:59.547","updateDate":"2020-03-09T16:04:33.183"},"rank":100},{"type":"item","object":{"rank":100,"id":477,"code":"Q392","type":"question","description":"drink liquids","direction":"positive","underlyingIssue":"being able to drink liquids","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been able to drink liquids?</p>","preferredWording":"Could you drink liquids?","recommendedWording":null,"questionnaires":[29,111,381,580],"categories":[33],"createDate":"2016-03-02T13:47:49.157","updateDate":"2020-03-09T16:04:49.143"},"rank":100},{"type":"item","object":{"rank":100,"id":478,"code":"Q393","type":"question","description":"free ask questions","direction":"positive","underlyingIssue":"feeling free to ask questions","additionalInfo":"","preferredWording":"Have you felt free to ask questions?","recommendedWording":null,"questionnaires":[28,111,169,172,327,363,381],"categories":[125],"createDate":"2016-03-02T13:47:57.627","updateDate":"2020-03-09T16:05:44.46"},"rank":100},{"type":"item","object":{"rank":100,"id":479,"code":"Q394","type":"question","description":"opportunity express emotions","direction":"positive","underlyingIssue":"having opportunity to express emotions and worries","additionalInfo":"","preferredWording":"Have you had the opportunity to express your emotions?","recommendedWording":null,"questionnaires":[28,111,169,172,363,381],"categories":[21,39],"createDate":"2016-03-02T13:53:46.27","updateDate":"2020-03-09T16:06:51.947"},"rank":100},{"type":"item","object":{"rank":100,"id":482,"code":"Q397","type":"question","description":"pain stomach","direction":"negative","underlyingIssue":"experiencing stomach pain","additionalInfo":"","preferredWording":"Have you had pain in your stomach?","recommendedWording":null,"questionnaires":[29,111,381],"categories":[],"createDate":"2016-03-02T13:56:29.013","updateDate":"2016-06-14T12:58:13.45"},"rank":100},{"type":"item","object":{"rank":100,"id":483,"code":"Q398","type":"question","description":"patient HCP understanding disease","direction":"positive","underlyingIssue":"sharing the understanding of the disease and treatment with the HCPs","additionalInfo":"","preferredWording":"Have you felt that you and your professional(s) had a shared understanding of your disease and treatment?","recommendedWording":null,"questionnaires":[28,111,169,172,327,363,381],"categories":[126],"createDate":"2016-03-02T13:57:38.22","updateDate":"2020-03-09T16:08:33.83"},"rank":100},{"type":"item","object":{"rank":100,"id":484,"code":"Q399","type":"question","description":"patient HCP mutual trust ","direction":"positive","underlyingIssue":"having mutual trust with HCPs","additionalInfo":"","preferredWording":"Has there been mutual trust between you and your professional(s)?","recommendedWording":null,"questionnaires":[28,111,169,172,363,381],"categories":[126],"createDate":"2016-03-02T13:58:49.153","updateDate":"2020-03-09T16:08:57.683"},"rank":100},{"type":"item","object":{"rank":100,"id":486,"code":"Q401","type":"question","description":"patient HCP time talk","direction":"positive","underlyingIssue":"getting enough time from the HCPs to talk","additionalInfo":"","preferredWording":"Have your professional(s) spent enough time talking with you?","recommendedWording":null,"questionnaires":[28,111,169,172,327,363,381],"categories":[125],"createDate":"2016-03-02T14:06:47.843","updateDate":"2020-03-09T16:10:50.69"},"rank":100},{"type":"item","object":{"rank":100,"id":487,"code":"Q402","type":"question","description":"patient HCP approach equal","direction":"positive","underlyingIssue":"being approached by HCPs as an equal","additionalInfo":"","preferredWording":"Have your professional(s) approached you as an equal?","recommendedWording":null,"questionnaires":[28,111,169,172,363,381],"categories":[126],"createDate":"2016-03-02T14:10:07.78","updateDate":"2020-03-09T16:11:13.37"},"rank":100},{"type":"item","object":{"rank":100,"id":488,"code":"Q403","type":"question","description":"HCP sincere","direction":"positive","underlyingIssue":"being treated by HCPs with sincerity","additionalInfo":"","preferredWording":"Have your professional(s) shown sincerity?","recommendedWording":null,"questionnaires":[28,111,169,172,363,381],"categories":[126],"createDate":"2016-03-02T14:13:32.633","updateDate":"2020-03-09T16:11:40.64"},"rank":100},{"type":"item","object":{"rank":100,"id":489,"code":"Q404","type":"question","description":"problem arrange bladder treatment","direction":"negative","underlyingIssue":"experiencing problems arranging repeated bladder treatment appointments in the daily life","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems arranging your life around the repeated bladder treatment appointments (cystoscopies or instillations)?</p><p><br /></p>","preferredWording":"Did you have trouble arranging your life around the repeated bladder treatment appointments (cystoscopies or instillations)?","recommendedWording":null,"questionnaires":[30,111,131,139,381],"categories":[],"createDate":"2016-03-02T14:19:42.88","updateDate":"2017-10-04T13:39:11.307"},"rank":100},{"type":"item","object":{"rank":100,"id":490,"code":"Q405","type":"question","description":"worry repeated bladder treatment","direction":"negative","underlyingIssue":"worrying about having repeated bladder treatments","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you worried about having repeated bladder treatments (cystoscopies or instillations)?</p>","preferredWording":"The shape of your affected breast?","recommendedWording":null,"questionnaires":[30,111,131,139,381,690],"categories":[142],"createDate":"2016-03-02T14:20:54.69","updateDate":"2020-03-09T16:14:40.337"},"rank":100},{"type":"item","object":{"rank":100,"id":491,"code":"Q406","type":"question","description":"patient HCP easy talk openly","direction":"positive","underlyingIssue":"HCPs making it easy to talk openly about any issues that are of concern","additionalInfo":"","preferredWording":"Have your professional(s) made it easy for you to talk openly about issues that concern you?","recommendedWording":null,"questionnaires":[28,111,169,172,363,381],"categories":[126],"createDate":"2016-03-02T14:23:31.57","updateDate":"2020-03-09T16:15:09.913"},"rank":100},{"type":"item","object":{"rank":100,"id":492,"code":"Q407","type":"question","description":"patient HCP respect","direction":"positive","underlyingIssue":"being treated by the HCPs with respect","additionalInfo":"","preferredWording":"Have your professional(s) treated you with respect?","recommendedWording":null,"questionnaires":[28,111,169,172,363,381],"categories":[126],"createDate":"2016-03-02T14:25:19.573","updateDate":"2020-03-09T16:16:38.88"},"rank":100},{"type":"item","object":{"rank":100,"id":493,"code":"Q408","type":"question","description":"problem HCP seriously","direction":"positive","underlyingIssue":"HCPs taking problems seriously","additionalInfo":"","preferredWording":"Have your professional(s) taken your problems seriously?","recommendedWording":null,"questionnaires":[28,111,169,172,363,381],"categories":[126],"createDate":"2016-03-02T14:29:00.26","updateDate":"2020-03-09T16:17:04.153"},"rank":100},{"type":"item","object":{"rank":100,"id":494,"code":"Q409","type":"question","description":"patient HCP language","direction":"positive","underlyingIssue":"HCPs using a language that is easy to understand","additionalInfo":"","preferredWording":"Have your professional(s) used language that you understand (avoided medical jargon, used clear terms)?","recommendedWording":null,"questionnaires":[28,111,169,172,327,363,381],"categories":[125],"createDate":"2016-03-02T14:37:27.263","updateDate":"2020-03-09T16:17:28.91"},"rank":100},{"type":"item","object":{"rank":100,"id":495,"code":"Q410","type":"question","description":"patient HCP answer openly","direction":"positive","underlyingIssue":"HCPs answering questions openly","additionalInfo":"","preferredWording":"Have your professional(s) answered your questions openly?","recommendedWording":null,"questionnaires":[28,111,169,172,363,381],"categories":[125],"createDate":"2016-03-02T14:38:34.66","updateDate":"2020-03-09T16:19:59.917"},"rank":100},{"type":"item","object":{"rank":100,"id":527,"code":"Q437","type":"question","description":"stoma leak stools","direction":"negative","underlyingIssue":"having leakage of stools from the stoma bag","additionalInfo":"","preferredWording":"Have you had leakage of stools from your stoma bag?","recommendedWording":null,"questionnaires":[32,89,111,117,258,287,475,486,519,583,603,721,291,313,381,413,433,472],"categories":[8,83],"createDate":"2016-03-02T15:53:09.223","updateDate":"2020-03-10T11:45:43.86"},"rank":100},{"type":"item","object":{"rank":100,"id":528,"code":"Q438","type":"question","description":"stoma sore skin","direction":"negative","underlyingIssue":"having sore skin around stoma","additionalInfo":"","preferredWording":"Have you had sore skin around your stoma?","recommendedWording":null,"questionnaires":[32,89,111,117,603,721,433,472,475,486,519,583,258,287,291,313,381,413],"categories":[83,28],"createDate":"2016-03-02T15:55:43.433","updateDate":"2020-03-10T11:47:05.31"},"rank":100},{"type":"item","object":{"rank":100,"id":529,"code":"Q439","type":"question","description":"stoma frequent change day","direction":"negative","underlyingIssue":"having to frequently change bags during the day","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have frequent bag changes occurred during the day?</p>","preferredWording":"Did frequent bag changes occur during the day?","recommendedWording":null,"questionnaires":[32,111,249,258,287,291,519,721,313,381,433,472,475,486],"categories":[8,83],"createDate":"2016-03-02T15:56:40.533","updateDate":"2020-03-10T11:47:42.483"},"rank":100},{"type":"item","object":{"rank":100,"id":531,"code":"Q441","type":"question","description":"embarrassed stoma","direction":"negative","underlyingIssue":"feeling embarrassed because of the stoma","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you felt embarrassed because of your stoma?</p>","preferredWording":"Did you feel embarrassed because of your stoma?","recommendedWording":null,"questionnaires":[32,111,249,258,287,291,519,721,313,381,433,472,475,486],"categories":[83,44],"createDate":"2016-03-02T15:58:02.793","updateDate":"2020-03-10T11:51:05.69"},"rank":100},{"type":"item","object":{"rank":100,"id":532,"code":"Q442","type":"question","description":"problem care stoma","direction":"negative","underlyingIssue":"experiencing problems caring for the stoma","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems caring for your stoma?</p>","preferredWording":"Did you have problems caring for your stoma?","recommendedWording":null,"questionnaires":[32,111,258,287,291,313,507,519,721,381,413,433,472,475,486],"categories":[83],"createDate":"2016-03-02T15:58:52.95","updateDate":"2020-03-10T11:51:33.533"},"rank":100},{"type":"item","object":{"rank":100,"id":533,"code":"Q443","type":"question","description":"unintentional release gas anus","direction":"negative","underlyingIssue":"having unintentional release of gas/flatulence from the back passage/anus","additionalInfo":"","preferredWording":"Have you had unintentional release of gas/flatulence from your back passage?","recommendedWording":null,"questionnaires":[32,111,258,263,287,291,721,381,433,472,475,486,519],"categories":[],"createDate":"2016-03-02T16:00:24.743","updateDate":"2017-10-05T16:09:04.62"},"rank":100},{"type":"item","object":{"rank":100,"id":534,"code":"Q444","type":"question","description":"leakage stools back passage","direction":"negative","underlyingIssue":"having leakage of stools from back passage/anus","additionalInfo":"","preferredWording":"Have you had leakage of stools from your back passage?","recommendedWording":null,"questionnaires":[32,111,166,258,263,501,507,519,721,472,475,486,489,490,498,267,287,291,312,381,433],"categories":[12],"createDate":"2016-03-02T16:01:35.727","updateDate":"2020-03-10T11:53:07.633"},"rank":100},{"type":"item","object":{"rank":100,"id":535,"code":"Q445","type":"question","description":"sore skin anal area","direction":"negative","underlyingIssue":"having sore skin around the anal area","additionalInfo":"","preferredWording":"Have you had sore skin around your anal area?","recommendedWording":null,"questionnaires":[32,111,258,263,287,291,721,381,433,472,475,486,519],"categories":[8,28],"createDate":"2016-03-03T11:52:15.213","updateDate":"2020-03-10T11:54:34.933"},"rank":100},{"type":"item","object":{"rank":100,"id":538,"code":"Q448","type":"question","description":"embarrassed bowel movement","direction":"negative","underlyingIssue":"being embarrassed because of bowel movement","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt embarrassed because of your bowel movement?</p>","preferredWording":"Did you feel embarrassed because of your bowel movement?","recommendedWording":null,"questionnaires":[32,111,258,263,287,489,490,498,501,519,721,291,381,433,472,475,486],"categories":[8,44],"createDate":"2016-03-03T12:04:37.477","updateDate":"2020-03-10T11:56:50.947"},"rank":100},{"type":"item","object":{"rank":100,"id":539,"code":"Q449","type":"question","description":"pain discomfort intercourse","direction":"negative","underlyingIssue":"having pain/discomfort during intercourse","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had pain or discomfort during intercourse?</p>","preferredWording":"Did you have pain or discomfort during intercourse?","recommendedWording":"Have you had pain during intercourse?","questionnaires":[32,89,111,117,181,472,475,486,583,603,721,258,291,322,342,381,433],"categories":[],"createDate":"2016-03-03T12:07:47.257","updateDate":"2017-10-05T16:20:31.873"},"rank":100},{"type":"item","object":{"rank":100,"id":540,"code":"Q450","type":"question","description":"cramps abdomen","direction":"negative","underlyingIssue":"having cramps in abdomen","additionalInfo":"","preferredWording":"Have you had cramps in your abdomen?","recommendedWording":null,"questionnaires":[34,38,111,166,170,302,517,547,554,555,381,404,410,444,482,485],"categories":[58],"createDate":"2016-03-03T12:40:37.427","updateDate":"2020-03-10T12:00:02.047"},"rank":100},{"type":"item","object":{"rank":100,"id":541,"code":"Q451","type":"question","description":"problem control bowels","direction":"negative","underlyingIssue":"experiencing problems controlling bowels","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems controlling your bowels?</p>","preferredWording":"Have you had difficulty in controlling your bowels?","recommendedWording":null,"questionnaires":[34,111,312,381,390,404,410,444,547,555,563],"categories":[12],"createDate":"2016-03-03T12:43:56.317","updateDate":"2020-03-10T12:00:21.61"},"rank":100},{"type":"item","object":{"rank":100,"id":543,"code":"Q452","type":"question","description":"leak urine","direction":"negative","underlyingIssue":"having leaking of urine","additionalInfo":"","preferredWording":"Have you had any unintentional release (leakage) of urine?","recommendedWording":null,"questionnaires":[1,13,30,32,34,38,689,702,721,563,583,603,638,647,688,485,486,517,547,554,555,410,433,444,472,475,482,291,302,308,381,390,404,170,216,236,258,284,287,67,111,114,131,139,166],"categories":[145],"createDate":"2016-03-03T12:48:03.337","updateDate":"2020-03-10T12:00:48.24"},"rank":100},{"type":"item","object":{"rank":100,"id":544,"code":"Q453","type":"question","description":"problem empty bladder","direction":"negative","underlyingIssue":"experiencing problems emptying the bladder","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems emptying your bladder?</p>","preferredWording":"Have you had difficulty emptying your bladder?","recommendedWording":null,"questionnaires":[34,111,341,381,390,404,444,547,555,563,583,603],"categories":[146],"createDate":"2016-03-03T12:51:07.66","updateDate":"2020-03-10T12:01:08.113"},"rank":100},{"type":"item","object":{"rank":100,"id":545,"code":"Q454","type":"question","description":"swelling legs","direction":"negative","underlyingIssue":"having swelling in one or both legs","additionalInfo":"","preferredWording":"Have you had swelling in one or both legs?","recommendedWording":null,"questionnaires":[34,38,111,114,124,127,563,517,521,522,547,554,555,410,433,444,463,482,485,162,260,284,302,381,404],"categories":[38],"createDate":"2016-03-03T12:53:58.673","updateDate":"2020-03-10T12:02:50.793"},"rank":100},{"type":"item","object":{"rank":100,"id":547,"code":"Q456","type":"question","description":"pain lower back","direction":"negative","underlyingIssue":"having pain in the lower back","additionalInfo":"","preferredWording":"Have you had pain in your lower back?","recommendedWording":null,"questionnaires":[34,94,102,547,555,563,111,235,381,404,444],"categories":[100],"createDate":"2016-03-03T12:58:01.527","updateDate":"2020-03-10T12:05:04.97"},"rank":100},{"type":"item","object":{"rank":100,"id":548,"code":"Q457","type":"question","description":"pain increase activity","direction":"negative","underlyingIssue":"having pain that increases with activity","additionalInfo":"","preferredWording":"If you had pain did it increase with activity?","recommendedWording":null,"questionnaires":[35,111,381,632,633,634],"categories":[],"createDate":"2016-03-03T12:58:47.313","updateDate":"2016-06-15T11:43:05.843"},"rank":100},{"type":"item","object":{"rank":100,"id":550,"code":"Q459","type":"question","description":"burning sore eyes","direction":"negative","underlyingIssue":"having burning or sore eyes","additionalInfo":"","preferredWording":"Have you had burning or sore eyes?","recommendedWording":null,"questionnaires":[35,48,111,632,633,634,456,484,381,328,199,209],"categories":[148],"createDate":"2016-03-03T13:04:21.4","updateDate":"2020-03-10T12:06:49.753"},"rank":100},{"type":"item","object":{"rank":100,"id":551,"code":"Q460","type":"question","description":"worried dying","direction":"negative","underlyingIssue":"worrying about dying","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you worried about dying?</p>","preferredWording":"Have you been worried about dying?","recommendedWording":null,"questionnaires":[35,111,261,321,381,632,633,634],"categories":[53],"createDate":"2016-03-03T13:05:41.247","updateDate":"2020-03-10T12:07:51.17"},"rank":100},{"type":"item","object":{"rank":100,"id":552,"code":"Q461","type":"question","description":"worried lose weight","direction":"negative","underlyingIssue":"worrying about losing weight","additionalInfo":"","preferredWording":"Have you worried about losing weight?","recommendedWording":null,"questionnaires":[36,381,111],"categories":[72],"createDate":"2016-03-03T13:14:19.683","updateDate":"2020-03-10T12:08:17.427"},"rank":100},{"type":"item","object":{"rank":100,"id":553,"code":"Q462","type":"question","description":"tingling numb hands feet","direction":"negative","underlyingIssue":"having tingling or numbness in hands or feet","additionalInfo":"","preferredWording":"Have you had tingling or numbness in your hands or feet?","recommendedWording":"Have you had tingling or numbness in your hands or feet?","questionnaires":[34,38,43,111,166,170,533,547,554,555,381,394,410,444,482,485,231,232,240,279,302,377],"categories":[130],"createDate":"2016-03-03T13:14:35.987","updateDate":"2020-03-10T12:08:44.087"},"rank":100},{"type":"item","object":{"rank":100,"id":507,"code":"Q421","type":"question","description":"HCP account preferences information","direction":"positive","underlyingIssue":"HCPs taking into account the preferences on how the information should be provided","additionalInfo":"","preferredWording":"Have your professional(s) taken into account how you prefer to receive information?","recommendedWording":null,"questionnaires":[28,111,169,172,363,381],"categories":[125],"createDate":"2016-03-02T15:06:26.31","updateDate":"2020-03-09T16:37:12.543"},"rank":100},{"type":"item","object":{"rank":100,"id":508,"code":"Q422","type":"question","description":"patient HCP check information","direction":"positive","underlyingIssue":"HCPs checking what is already known about the illness before providing new information","additionalInfo":"","preferredWording":"Have your professional(s) checked what you already knew about your illness before giving you any new information?","recommendedWording":null,"questionnaires":[28,111,169,172,363,381],"categories":[125],"createDate":"2016-03-02T15:09:06.62","updateDate":"2020-03-09T16:37:35.007"},"rank":100},{"type":"item","object":{"rank":100,"id":509,"code":"Q423","type":"question","description":"HCP check understand information","direction":"positive","underlyingIssue":"HCPs checking the understanding of the provided information","additionalInfo":"","preferredWording":"Have your professional(s) checked your understanding of information you have been given?","recommendedWording":null,"questionnaires":[28,111,169,172,363,381],"categories":[125],"createDate":"2016-03-02T15:11:16.887","updateDate":"2020-03-09T16:39:31.883"},"rank":100},{"type":"item","object":{"rank":100,"id":510,"code":"Q424","type":"question","description":"worry damage heart blood vessels","direction":"negative","underlyingIssue":"worrying about damage to the heart and blood vessels","additionalInfo":"","preferredWording":"Have you worried about damage to your heart and blood vessels?","recommendedWording":null,"questionnaires":[31,41,111,381,545,622,623],"categories":[16],"createDate":"2016-03-02T15:13:18.57","updateDate":"2020-03-09T16:39:51.243"},"rank":100},{"type":"item","object":{"rank":100,"id":511,"code":"Q425","type":"question","description":"HCP explain again","direction":"positive","underlyingIssue":"HCPs explaining the same again differently if information was not understood","additionalInfo":"","preferredWording":"If you did not understand the information provided, did your professional(s) explain it again in a different way?","recommendedWording":null,"questionnaires":[28,111,169,172,363,381],"categories":[125],"createDate":"2016-03-02T15:14:30.6","updateDate":"2020-03-09T16:41:17.933"},"rank":100},{"type":"item","object":{"rank":100,"id":512,"code":"Q426","type":"question","description":"HCP answer difficult questions","direction":"positive","underlyingIssue":"HCPs answering difficult questions sufficiently","additionalInfo":"","preferredWording":"Have your professional(s) answered difficult questions (for example concerns about your future) in a way you felt was sufficient for you?","recommendedWording":null,"questionnaires":[28,111,169,172,311,363,381],"categories":[125],"createDate":"2016-03-02T15:16:34.047","updateDate":"2020-03-09T16:42:53.187"},"rank":100},{"type":"item","object":{"rank":100,"id":513,"code":"Q427","type":"question","description":"HCP explain treatment aims","direction":"positive","underlyingIssue":"HCPs explaining aims of the treatment sufficiently","additionalInfo":"","preferredWording":"Have your professional(s) explained to you the aims of the treatment (for example to control symptoms) in a way you felt was sufficient for you?","recommendedWording":null,"questionnaires":[28,111,169,172,363,381,497],"categories":[125],"createDate":"2016-03-02T15:19:03.983","updateDate":"2020-03-09T16:43:15.853"},"rank":100},{"type":"item","object":{"rank":100,"id":514,"code":"Q428","type":"question","description":"HCP privacy","direction":"positive","underlyingIssue":"feeling that enough privacy is ensured for conversations with HCPs","additionalInfo":"","preferredWording":"Has there been enough privacy to have confidential conversations with your professional(s)?","recommendedWording":null,"questionnaires":[28,111,169,172,363,381],"categories":[125],"createDate":"2016-03-02T15:20:48.773","updateDate":"2020-03-09T16:43:42.123"},"rank":100},{"type":"item","object":{"rank":100,"id":515,"code":"Q429","type":"question","description":"satisfied HCP communication","direction":"positive","underlyingIssue":"feeling satisfied with communication with HCPs","additionalInfo":"","preferredWording":"Have you been satisfied with your communication with your professional(s)?","recommendedWording":null,"questionnaires":[28,111,169,172,208,311,363,381],"categories":[125],"createDate":"2016-03-02T15:22:09.6","updateDate":"2020-03-09T16:44:06.647"},"rank":100},{"type":"item","object":{"rank":100,"id":516,"code":"Q430","type":"question","description":"pain abdomen","direction":"negative","underlyingIssue":"having abdominal pain","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had pain in your abdomen?</p>","preferredWording":"Did you have abdominal pain?","recommendedWording":"Have you had pain in your stomach area?","questionnaires":[10,11,12,19,27,645,646,721,560,575,576,577,605,643,475,480,486,519,526,405,433,438,439,472,287,291,333,364,381,186,193,237,238,251,258,123,132,134,146,182,32,36,44,111],"categories":[58,100],"createDate":"2016-03-02T15:34:48.583","updateDate":"2020-03-09T16:50:10.033"},"rank":100},{"type":"item","object":{"rank":100,"id":517,"code":"Q431","type":"question","description":"pain buttock anal area rectum","direction":"negative","underlyingIssue":"having pain in buttocks/anal area/rectum","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had pain in your buttocks/anal area/rectum?</p>","preferredWording":"Did you have pain in your buttocks/anal area/rectum?","recommendedWording":null,"questionnaires":[32,111,197,237,258,498,501,605,721,433,472,475,486,489,490,263,267,268,287,291,381],"categories":[8,100],"createDate":"2016-03-02T15:35:43.857","updateDate":"2020-03-10T11:38:05.05"},"rank":100},{"type":"item","object":{"rank":100,"id":518,"code":"Q432","type":"question","description":"restless agitated","direction":"negative","underlyingIssue":"feeling restless or agitated","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt restless or agitated?</p>","preferredWording":"Did you feel restless or agitated?","recommendedWording":"Have you felt restless or agitated?","questionnaires":[33,35,41,111,622,624,632,633,634,269,381,545,546,579],"categories":[39],"createDate":"2016-03-02T15:36:06.323","updateDate":"2020-03-10T11:38:39.993"},"rank":100},{"type":"item","object":{"rank":100,"id":521,"code":"Q434","type":"question","description":"worry weight","direction":"negative","underlyingIssue":"worrying about weight","additionalInfo":"","preferredWording":"Have you worried about your weight?","recommendedWording":null,"questionnaires":[32,111,258,287,291,381,433,472,475,486,519,721],"categories":[62],"createDate":"2016-03-02T15:40:16.26","updateDate":"2020-03-10T11:41:58.41"},"rank":100},{"type":"item","object":{"rank":100,"id":562,"code":"Q471","type":"question","description":"short breath rest","direction":"negative","underlyingIssue":"being short of breath when resting","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been short of breath when resting?</p>","preferredWording":"Have you been short of breath when you rested?","recommendedWording":"Have you been short of breath when you rested?","questionnaires":[37,48,103,111,129,183,381,456,484,193,199,209,217,281,328],"categories":[32],"createDate":"2016-03-03T13:35:12.303","updateDate":"2020-03-10T12:14:07.863"},"rank":100},{"type":"item","object":{"rank":100,"id":563,"code":"Q472","type":"question","description":"vagina dry sex","direction":"negative","underlyingIssue":"having a dry vagina during sexual activity","additionalInfo":"","preferredWording":"Did you have a dry vagina or other problems during intercourse?\\n","recommendedWording":"Have you experienced a dry vagina during sexual activity?","questionnaires":[8,13,19,30,34,38,689,702,563,583,596,638,647,688,482,526,542,547,554,555,291,302,381,408,433,460,139,140,181,182,284,67,89,111,114,117,131],"categories":[133,119],"createDate":"2016-03-03T13:35:50.603","updateDate":"2020-03-10T12:14:44.697"},"rank":100},{"type":"item","object":{"rank":100,"id":564,"code":"Q473","type":"question","description":"short breath walk","direction":"negative","underlyingIssue":"being short of breath when walking","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been short of breath when walking?</p>","preferredWording":"Have you been short of breath when you walked?","recommendedWording":"Have you been short of breath when you walked?","questionnaires":[37,48,111,129,183,193,484,199,209,217,281,381,456],"categories":[32,111],"createDate":"2016-03-03T13:35:50.947","updateDate":"2020-03-10T12:16:20.013"},"rank":100},{"type":"item","object":{"rank":100,"id":565,"code":"Q474","type":"question","description":"short breath stairs","direction":"negative","underlyingIssue":"being short of breath when climbing stairs","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been short of breath when climbing stairs?</p>","preferredWording":"Have you been short of breath when you climbed stairs?","recommendedWording":"Have you been short of breath when you climbed stairs?","questionnaires":[37,48,111,129,183,193,456,484,199,209,217,281,328,381],"categories":[32,103],"createDate":"2016-03-03T13:36:35.203","updateDate":"2020-03-10T12:16:51.51"},"rank":100},{"type":"item","object":{"rank":100,"id":567,"code":"Q476","type":"question","description":"vagina short ","direction":"negative","underlyingIssue":"feeling that vagina is short ","additionalInfo":"","preferredWording":"Has your vagina felt short?","recommendedWording":null,"questionnaires":[34,111,291,381,563,596,433,542,547,555],"categories":[120],"createDate":"2016-03-03T13:39:25.69","updateDate":"2020-03-10T12:19:12.983"},"rank":100},{"type":"item","object":{"rank":100,"id":569,"code":"Q477","type":"question","description":"vagina tight","direction":"negative","underlyingIssue":"feeling that vagina is tight","additionalInfo":"","preferredWording":"Has your vagina felt tight?","recommendedWording":null,"questionnaires":[34,111,291,381,433,542,547,555,563,596],"categories":[120],"createDate":"2016-03-03T13:39:54.097","updateDate":"2020-03-10T12:19:35.98"},"rank":100},{"type":"item","object":{"rank":100,"id":498,"code":"Q412","type":"question","description":"patient HCP look conversation","direction":"positive","underlyingIssue":"HCPs making eye contact during the conversation","additionalInfo":"","preferredWording":"Have your professional(s) looked at you during conversation?","recommendedWording":null,"questionnaires":[28,111,169,172,363,381],"categories":[126],"createDate":"2016-03-02T14:46:45.063","updateDate":"2020-03-09T16:20:55.78"},"rank":100},{"type":"item","object":{"rank":100,"id":499,"code":"Q413","type":"question","description":"HCP calm voice","direction":"positive","underlyingIssue":"being spoken to by the HCPs with a calm voice","additionalInfo":"","preferredWording":"Have your professional(s) used a calm voice?","recommendedWording":null,"questionnaires":[28,111,169,172,363,381],"categories":[126],"createDate":"2016-03-02T14:48:04.987","updateDate":"2020-03-09T16:21:17.98"},"rank":100},{"type":"item","object":{"rank":100,"id":500,"code":"Q414","type":"question","description":"patient HCP understand situation","direction":"positive","underlyingIssue":"HCPs trying to understand the situation","additionalInfo":"","preferredWording":"Have your professional(s) tried to understand your current situation?","recommendedWording":null,"questionnaires":[28,111,169,172,363,381],"categories":[126],"createDate":"2016-03-02T14:53:47.667","updateDate":"2020-03-09T16:21:40.913"},"rank":100},{"type":"item","object":{"rank":100,"id":501,"code":"Q415","type":"question","description":"lack confidence body","direction":"negative","underlyingIssue":"lacking confidence in one\'s body","additionalInfo":"","preferredWording":"Have you felt a lack of confidence in your body?","recommendedWording":null,"questionnaires":[31,33,41,111,381,545,622,623,624],"categories":[4],"createDate":"2016-03-02T14:54:31.707","updateDate":"2020-03-09T16:32:02.65"},"rank":100},{"type":"item","object":{"rank":100,"id":503,"code":"Q417","type":"question","description":"patient HCP listen emotions","direction":"positive","underlyingIssue":"being listened to by the HCPs when expressing emotions","additionalInfo":"","preferredWording":"Have your professional(s) listened to you when you expressed your emotions?","recommendedWording":null,"questionnaires":[28,111,169,172,363,381],"categories":[125,39],"createDate":"2016-03-02T15:01:53.83","updateDate":"2020-03-09T16:32:47.39"},"rank":100},{"type":"item","object":{"rank":100,"id":504,"code":"Q418","type":"question","description":"problem accept limitations","direction":"negative","underlyingIssue":"experiencing problems accepting limitations due to the disease","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems accepting limitations due to the disease?</p>","preferredWording":"Have you had difficulty accepting limitations due to the disease?","recommendedWording":null,"questionnaires":[31,33,41,111,311,381,545,622,623,624],"categories":[30],"createDate":"2016-03-02T15:02:18.12","updateDate":"2020-03-09T16:35:11.113"},"rank":100},{"type":"item","object":{"rank":100,"id":505,"code":"Q419","type":"question","description":"HCP help manage emotions","direction":"positive","underlyingIssue":"receiving help from the HCPs to manage emotions","additionalInfo":"","preferredWording":"Have your professional(s) helped you to manage your emotions: for example sadness, anger, fear, anxiety and others?","recommendedWording":null,"questionnaires":[28,111,169,172,363,381],"categories":[126,39],"createDate":"2016-03-02T15:03:32.707","updateDate":"2020-03-09T16:35:41.66"},"rank":100},{"type":"item","object":{"rank":100,"id":556,"code":"Q465","type":"question","description":"problem talk feelings family friends","direction":"negative","underlyingIssue":"experiencing problems talking about feelings with family or friends","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems talking about your feelings with your family or friends?</p>","preferredWording":"Have you had trouble talking about your feelings to your family or friends?","recommendedWording":null,"questionnaires":[36,111,311,381],"categories":[39,21],"createDate":"2016-03-03T13:23:08.233","updateDate":"2020-03-10T12:10:24.613"},"rank":100},{"type":"item","object":{"rank":100,"id":557,"code":"Q466","type":"question","description":"vaginal discharge","direction":"negative","underlyingIssue":"having discharge from the vagina","additionalInfo":"","preferredWording":"Have you had discharge from your vagina?","recommendedWording":null,"questionnaires":[34,111,124,127,381,444,547,555,563],"categories":[117],"createDate":"2016-03-03T13:23:54.94","updateDate":"2020-03-10T12:10:49.12"},"rank":100},{"type":"item","object":{"rank":100,"id":558,"code":"Q467","type":"question","description":"disease treatment sex life","direction":"negative","underlyingIssue":"disease or treatment affecting sex life","additionalInfo":"","preferredWording":"Has the disease or treatment affected your sex life (for the worse)?","recommendedWording":"Has the disease or treatment affected your sex life (for the worse)?","questionnaires":[36,42,44,89,111,583,603,381,117,181],"categories":[133,30],"createDate":"2016-03-03T13:24:58.187","updateDate":"2020-03-10T12:11:56.683"},"rank":100},{"type":"item","object":{"rank":100,"id":573,"code":"Q479","type":"question","description":"diagnosis","direction":"positive","underlyingIssue":"receiving information about the diagnosis of the disease","additionalInfo":"","preferredWording":"The diagnosis of your disease?","recommendedWording":null,"questionnaires":[39,381,165,111],"categories":[125],"createDate":"2016-03-03T13:54:03.643","updateDate":"2020-03-10T12:21:37.94"},"rank":100},{"type":"item","object":{"rank":100,"id":574,"code":"Q480","type":"question","description":"extent disease","direction":"positive","underlyingIssue":"receiving information about the extent of the disease","additionalInfo":"","preferredWording":"The extent (spread) of your disease?","recommendedWording":null,"questionnaires":[39,381,111,165],"categories":[125],"createDate":"2016-03-03T13:54:53.377","updateDate":"2020-03-10T12:49:48.107"},"rank":100},{"type":"item","object":{"rank":100,"id":575,"code":"Q481","type":"question","description":"possible causes","direction":"positive","underlyingIssue":"receiving information about the possible causes of the disease","additionalInfo":"","preferredWording":"The possible causes of your disease?","recommendedWording":null,"questionnaires":[39,111,165,381],"categories":[125],"createDate":"2016-03-03T13:55:45.5","updateDate":"2020-03-10T12:50:18.917"},"rank":100},{"type":"item","object":{"rank":100,"id":576,"code":"Q482","type":"question","description":"disease control","direction":"positive","underlyingIssue":"receiving information whether the disease is under control","additionalInfo":"","preferredWording":"Whether the disease is under control?","recommendedWording":null,"questionnaires":[39,111,165,208,381],"categories":[125],"createDate":"2016-03-03T13:57:15.373","updateDate":"2020-03-10T12:53:17.163"},"rank":100},{"type":"item","object":{"rank":100,"id":577,"code":"Q483","type":"question","description":"purpose tests","direction":"positive","underlyingIssue":"receiving information about the purpose of medical tests","additionalInfo":"","preferredWording":"The purpose of any medical tests you have had or may undergo?","recommendedWording":null,"questionnaires":[39,111,165,381,492],"categories":[125],"createDate":"2016-03-03T13:58:38.417","updateDate":"2020-03-10T12:53:35.32"},"rank":100},{"type":"item","object":{"rank":100,"id":578,"code":"Q484","type":"question","description":"procedures tests","direction":"positive","underlyingIssue":"receiving information about the procedures of the medical tests","additionalInfo":"","preferredWording":"The procedures of the medical tests?","recommendedWording":null,"questionnaires":[39,111,165,208,381],"categories":[125],"createDate":"2016-03-03T14:00:33.47","updateDate":"2020-03-10T12:54:32.433"},"rank":100},{"type":"item","object":{"rank":100,"id":579,"code":"Q485","type":"question","description":"heavy legs","direction":"negative","underlyingIssue":"having heaviness in one or both legs","additionalInfo":"","preferredWording":"Have you felt heaviness in one or both legs?","recommendedWording":null,"questionnaires":[38,111,114,162,174,175,554,563,284,302,381,463,521,522],"categories":[38],"createDate":"2016-03-03T14:01:01.1","updateDate":"2020-03-10T12:55:08.437"},"rank":100},{"type":"item","object":{"rank":100,"id":580,"code":"Q486","type":"question","description":"results medical tests","direction":"positive","underlyingIssue":"receiving information about the results of the medical tests","additionalInfo":"","preferredWording":"The results of the medical tests you have already received?","recommendedWording":null,"questionnaires":[39,111,165,208,381],"categories":[125],"createDate":"2016-03-03T14:02:51.77","updateDate":"2020-03-10T12:56:46.373"},"rank":100},{"type":"item","object":{"rank":100,"id":582,"code":"Q488","type":"question","description":"medical treatment","direction":"positive","underlyingIssue":"receiving information about the modality of the medical treatment","additionalInfo":"","preferredWording":"The medical treatment (chemotherapy, radiotherapy, surgery or other treatment modality)?","recommendedWording":null,"questionnaires":[39,111,165,311,381,492],"categories":[125],"createDate":"2016-03-03T14:05:33.533","updateDate":"2020-03-10T12:57:47.587"},"rank":100},{"type":"item","object":{"rank":100,"id":583,"code":"Q489","type":"question","description":"benefit treatment","direction":"positive","underlyingIssue":"receiving information about the expected benefit of the treatment","additionalInfo":"","preferredWording":"The expected benefit of the treatment?","recommendedWording":null,"questionnaires":[39,111,165,208,381,492],"categories":[125],"createDate":"2016-03-03T14:07:42.817","updateDate":"2020-03-10T12:58:10.957"},"rank":100},{"type":"item","object":{"rank":100,"id":585,"code":"Q491","type":"question","description":"side effects","direction":"positive","underlyingIssue":"receiving information about possible side effects","additionalInfo":"","preferredWording":"The possible side-effects of your treatment?","recommendedWording":null,"questionnaires":[39,111,381,311,208,165,168],"categories":[125],"createDate":"2016-03-03T14:08:56.717","updateDate":"2020-03-10T13:00:24.993"},"rank":100},{"type":"item","object":{"rank":100,"id":586,"code":"Q492","type":"question","description":"leak stools","direction":"negative","underlyingIssue":"having leakage of stools","additionalInfo":"","preferredWording":"Have you had any leakage of stools?","recommendedWording":null,"questionnaires":[1,38,111,114,166,170,482,485,517,554,284,302,308,312,381,410],"categories":[12],"createDate":"2016-03-03T14:10:06.917","updateDate":"2020-03-10T13:00:59.11"},"rank":100},{"type":"item","object":{"rank":100,"id":587,"code":"Q493","type":"question","description":"expected effects symptoms","direction":"positive","underlyingIssue":"receiving information on the expected effects of the treatment on disease symptoms","additionalInfo":"","preferredWording":"The expected effects of the treatment on disease symptoms?","recommendedWording":null,"questionnaires":[39,111,381,165,168],"categories":[125],"createDate":"2016-03-03T14:11:35.7","updateDate":"2020-03-10T13:02:45.72"},"rank":100},{"type":"item","object":{"rank":100,"id":588,"code":"Q494","type":"question","description":"effects treatment social family life","direction":"positive","underlyingIssue":"receiving information about the effects of the treatment on social and family life","additionalInfo":"","preferredWording":"The effects of the treatment on social and family life?","recommendedWording":null,"questionnaires":[39,111,165,168,208,381],"categories":[125,49],"createDate":"2016-03-03T14:13:05.06","updateDate":"2020-03-10T13:03:14.61"},"rank":100},{"type":"item","object":{"rank":100,"id":589,"code":"Q495","type":"question","description":"effects treatment sexual activity","direction":"positive","underlyingIssue":"receiving information about the effects of the treatment on sexual activity","additionalInfo":"","preferredWording":"The effects of the treatment on sexual activity?","recommendedWording":null,"questionnaires":[39,111,165,168,208,381],"categories":[125,133],"createDate":"2016-03-03T14:16:05.093","updateDate":"2020-03-10T13:03:55.843"},"rank":100},{"type":"item","object":{"rank":100,"id":590,"code":"Q496","type":"question","description":"help outside hospital","direction":"positive","underlyingIssue":"receiving information about additional help outside the hospital","additionalInfo":"","preferredWording":"Additional help outside the hospital (e.g. help with daily activities, self help groups, district nurses)?","recommendedWording":null,"questionnaires":[39,111,165,168,208,325,381],"categories":[125],"createDate":"2016-03-03T14:21:29.77","updateDate":"2020-03-10T13:07:09.173"},"rank":100},{"type":"item","object":{"rank":100,"id":591,"code":"Q497","type":"question","description":"vagina short tight","direction":"negative","underlyingIssue":"feeling that the vagina is short and/or tight","additionalInfo":"","preferredWording":"Has your vagina felt short and / or tight?","recommendedWording":null,"questionnaires":[38,111,302,381,554],"categories":[120],"createDate":"2016-03-03T14:22:05.357","updateDate":"2020-03-10T13:08:43.023"},"rank":100},{"type":"item","object":{"rank":100,"id":592,"code":"Q498","type":"question","description":"rehabilitation","direction":"positive","underlyingIssue":"receiving information about rehabilitation services","additionalInfo":"","preferredWording":"Rehabilitation services (e. g. physiotherapy, occupational therapy)?","recommendedWording":null,"questionnaires":[39,111,165,327,381],"categories":[125],"createDate":"2016-03-03T14:22:17.68","updateDate":"2020-03-10T13:09:20.837"},"rank":100},{"type":"item","object":{"rank":100,"id":593,"code":"Q499","type":"question","description":"aspects managing home","direction":"positive","underlyingIssue":"receiving information about aspects of managing illness at home","additionalInfo":"","preferredWording":"Aspects of managing your illness at home?","recommendedWording":null,"questionnaires":[39,111,165,168,208,381,492],"categories":[125],"createDate":"2016-03-03T14:24:52.767","updateDate":"2020-03-10T13:10:04.937"},"rank":100},{"type":"item","object":{"rank":100,"id":594,"code":"Q500","type":"question","description":"psychological support","direction":"positive","underlyingIssue":"receiving information about possible professional psychological support","additionalInfo":"","preferredWording":"Possible professional psychological support?","recommendedWording":null,"questionnaires":[39,111,165,168,208,311,381],"categories":[125],"createDate":"2016-03-03T14:27:47.01","updateDate":"2020-03-10T13:11:33.733"},"rank":100},{"type":"item","object":{"rank":100,"id":595,"code":"Q501","type":"question","description":"places care","direction":"positive","underlyingIssue":"receiving information about different places of care","additionalInfo":"","preferredWording":"Different places of care (hospitals/outpatient services/home)?","recommendedWording":null,"questionnaires":[39,111,165,168,381],"categories":[125],"createDate":"2016-03-03T14:29:04.077","updateDate":"2020-03-10T13:12:00.08"},"rank":100},{"type":"item","object":{"rank":100,"id":597,"code":"Q502","type":"question","description":"FA16 exhausted","direction":"negative","underlyingIssue":"feeling exhausted","additionalInfo":"","preferredWording":"Have you felt exhausted?","recommendedWording":null,"questionnaires":[40,55,111,246,625,643,381,404],"categories":[50],"createDate":"2016-03-03T14:34:18.6","updateDate":"2020-02-27T12:47:08.857"},"rank":100},{"type":"item","object":{"rank":100,"id":598,"code":"Q503","type":"question","description":"sleepy daytime","direction":"negative","underlyingIssue":"feeling sleepy during the day","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt sleepy during the day?</p>","preferredWording":"Did you feel sleepy during the day?","recommendedWording":null,"questionnaires":[40,111,545,381],"categories":[50,135],"createDate":"2016-03-03T14:36:47.803","updateDate":"2020-03-10T13:12:45.71"},"rank":100},{"type":"item","object":{"rank":100,"id":599,"code":"Q504","type":"question","description":"help get well","direction":"positive","underlyingIssue":"receiving information about things one can do to help themselves get well","additionalInfo":"","preferredWording":"Things that you can do to help yourself get well (rest, contact with others..)?","recommendedWording":null,"questionnaires":[39,111,165,168,381],"categories":[125],"createDate":"2016-03-03T14:37:54.013","updateDate":"2020-03-10T13:14:05.257"},"rank":100},{"type":"item","object":{"rank":100,"id":600,"code":"Q505","type":"question","description":"written information","direction":"positive","underlyingIssue":"receiving written information","additionalInfo":"","preferredWording":"Have you received written information?","recommendedWording":null,"questionnaires":[39,111,165,168,311,381,492],"categories":[125],"createDate":"2016-03-03T14:38:33.017","updateDate":"2020-03-10T13:14:37.33"},"rank":100},{"type":"item","object":{"rank":100,"id":601,"code":"Q506","type":"question","description":"information cd tape video","direction":"positive","underlyingIssue":"receiving information on CD/tape/video","additionalInfo":"","preferredWording":"Have you received information on CD or tape / video?","recommendedWording":null,"questionnaires":[39,111,165,381],"categories":[125],"createDate":"2016-03-03T14:39:36.213","updateDate":"2020-03-10T13:15:05.487"},"rank":100},{"type":"item","object":{"rank":100,"id":602,"code":"Q507","type":"question","description":"satisfied amount information","direction":"positive","underlyingIssue":"being satisfied with the amount of information received","additionalInfo":"","preferredWording":"Were you satisfied with the amount of information you received?","recommendedWording":null,"questionnaires":[39,111,492,165,168,311,327,381],"categories":[125],"createDate":"2016-03-03T14:40:28.007","updateDate":"2020-03-10T13:15:42.663"},"rank":100},{"type":"item","object":{"rank":100,"id":603,"code":"Q508","type":"question","description":"wish more information","direction":"negative","underlyingIssue":"wishing to receive more information","additionalInfo":"","preferredWording":"Do you wish to receive more information?","recommendedWording":null,"questionnaires":[39,111,165,492,311,381],"categories":[125],"createDate":"2016-03-03T14:41:09.177","updateDate":"2020-03-10T13:16:04.487"},"rank":100},{"type":"item","object":{"rank":100,"id":605,"code":"Q509","type":"question","description":"wish less information","direction":"negative","underlyingIssue":"wishing to have received less information","additionalInfo":"","preferredWording":"Do you wish that you had received less information?","recommendedWording":null,"questionnaires":[39,111,165,208,381],"categories":[125],"createDate":"2016-03-03T14:44:05.277","updateDate":"2020-03-10T13:16:25.983"},"rank":100},{"type":"item","object":{"rank":100,"id":606,"code":"Q510","type":"question","description":"information helpful","direction":"positive","underlyingIssue":"information being helpful","additionalInfo":"","preferredWording":"Overall has the information you have received been helpful?","recommendedWording":null,"questionnaires":[311,381,165,168,111,39],"categories":[125],"createDate":"2016-03-03T14:46:15.213","updateDate":"2020-03-10T13:22:29.167"},"rank":100},{"type":"item","object":{"rank":100,"id":607,"code":"Q511","type":"question","description":"problem get things started","direction":"negative","underlyingIssue":"experiencing problems getting things started","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems getting things started?</p>","preferredWording":"Did you have trouble getting things started?","recommendedWording":null,"questionnaires":[40,77,111,381,625],"categories":[50],"createDate":"2016-03-03T14:55:21.657","updateDate":"2020-03-10T13:25:23.263"},"rank":100},{"type":"item","object":{"rank":100,"id":608,"code":"Q512","type":"question","description":"vulnerable veins","direction":"negative","underlyingIssue":"having vulnerable veins","additionalInfo":"","preferredWording":"Have you had vulnerable veins (for example when having blood taken or receiving treatment)?","recommendedWording":null,"questionnaires":[41,111,381,545,622],"categories":[16,22],"createDate":"2016-03-03T14:55:51.813","updateDate":"2020-03-10T13:26:05.84"},"rank":100},{"type":"item","object":{"rank":100,"id":609,"code":"Q513","type":"question","description":"feeling discouraged","direction":"negative","underlyingIssue":"feeling discouraged","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt discouraged?</p>","preferredWording":"Did you feel discouraged?","recommendedWording":null,"questionnaires":[40,111,381,625],"categories":[39],"createDate":"2016-03-03T14:57:07.117","updateDate":"2020-03-10T13:26:32.983"},"rank":100},{"type":"item","object":{"rank":100,"id":613,"code":"Q517","type":"question","description":"lack self confidence","direction":"negative","underlyingIssue":"lacking self confidence","additionalInfo":"","preferredWording":"Have you lacked self confidence?","recommendedWording":null,"questionnaires":[41,111,381,399,545,622],"categories":[39,4],"createDate":"2016-03-03T15:05:27.38","updateDate":"2020-03-10T13:37:36.047"},"rank":100},{"type":"item","object":{"rank":100,"id":615,"code":"Q519","type":"question","description":"problem finish things","direction":"negative","underlyingIssue":"experiencing problems finishing things","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems finishing things you started?</p>","preferredWording":"Have you found it difficult to finish things you started?","recommendedWording":null,"questionnaires":[44,45,544,381,111],"categories":[17],"createDate":"2016-03-03T15:06:41.89","updateDate":"2020-03-10T13:42:49.417"},"rank":100},{"type":"item","object":{"rank":100,"id":616,"code":"Q520","type":"question","description":"tired interference daily activities","direction":"negative","underlyingIssue":"tiredness interfering with daily activities","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has tiredness interfered with your daily activities?</p>","preferredWording":"Did tiredness interfere with your daily activities?","recommendedWording":null,"questionnaires":[40,77,111,650,652,545,404,381,401,123,124,127,128],"categories":[50,1],"createDate":"2016-03-03T15:08:25.803","updateDate":"2020-03-10T13:43:38.62"},"rank":100},{"type":"item","object":{"rank":100,"id":617,"code":"Q521","type":"question","description":"tired not understood close people","direction":"negative","underlyingIssue":"feeling that tiredness was not understood by the close ones","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you felt that your tiredness is (was) not understood by the people who are close to you?</p>","preferredWording":"Did you feel that your tiredness is (was) not understood by the people who are close to you?","recommendedWording":null,"questionnaires":[40,111,381,413,625],"categories":[50],"createDate":"2016-03-03T15:10:50.813","updateDate":"2020-03-10T13:44:50.77"},"rank":100},{"type":"item","object":{"rank":100,"id":620,"code":"Q524","type":"question","description":"abdominal discomfort","direction":"negative","underlyingIssue":"having abdominal discomfort","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had abdominal discomfort?</p>","preferredWording":"Did you have abdominal discomfort?","recommendedWording":null,"questionnaires":[42,111,381,570],"categories":[58],"createDate":"2016-03-03T15:23:39.063","updateDate":"2020-03-10T13:46:46.943"},"rank":100},{"type":"item","object":{"rank":100,"id":621,"code":"Q525","type":"question","description":"side effects treatment","direction":"negative","underlyingIssue":"having side-effects from treatment","additionalInfo":"","preferredWording":"Have you had side effects from your treatment?","recommendedWording":null,"questionnaires":[42,111,381,527],"categories":[31],"createDate":"2016-03-03T15:26:05.007","updateDate":"2020-03-10T13:47:10.623"},"rank":100},{"type":"item","object":{"rank":100,"id":626,"code":"Q526","type":"question","description":"problem repeated injections","direction":"negative","underlyingIssue":"experiencing problems from repeated injections","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems from repeated injections?</p>","preferredWording":"Have you had a problem from repeated injections?","recommendedWording":null,"questionnaires":[42,111,381],"categories":[22,16],"createDate":"2016-03-03T15:41:02.23","updateDate":"2020-03-10T13:47:41.03"},"rank":100},{"type":"item","object":{"rank":100,"id":627,"code":"Q527","type":"question","description":"distress disease treatment close people","direction":"negative","underlyingIssue":"disease/treatment being distressing for the close ones","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has your disease or treatment been distressing to those close to you?</p>","preferredWording":"How distressing, do you think, your illness or treatment has been to those close to you?","recommendedWording":null,"questionnaires":[42,45,111,381],"categories":[49,30],"createDate":"2016-03-03T15:45:10.78","updateDate":"2020-03-10T13:48:13.557"},"rank":100},{"type":"item","object":{"rank":100,"id":628,"code":"Q528","type":"question","description":"aches pain muscles bones","direction":"negative","underlyingIssue":"having aches or pains in muscles or bones","additionalInfo":"","preferredWording":"Have you had aches or pains in your muscles or bones?","recommendedWording":null,"questionnaires":[42,111,381,132,134,163],"categories":[],"createDate":"2016-03-03T15:48:10.777","updateDate":"2016-06-15T15:11:06.913"},"rank":100},{"type":"item","object":{"rank":100,"id":629,"code":"Q529","type":"question","description":"limited travel","direction":"negative","underlyingIssue":"being limited in ability to travel","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been limited in your ability to travel?</p>","preferredWording":"Did you have any limitations in your ability to travel?","recommendedWording":null,"questionnaires":[42,111,381],"categories":[101,3],"createDate":"2016-03-03T15:49:17.017","updateDate":"2020-03-10T13:50:15.25"},"rank":100},{"type":"item","object":{"rank":100,"id":630,"code":"Q530","type":"question","description":"problem adequate information","direction":"negative","underlyingIssue":"experiencing problems receiving adequate information about disease or treatment","additionalInfo":"","preferredWording":"Have you had problems receiving adequate information about your disease and treatment?","recommendedWording":null,"questionnaires":[42,111,311,381],"categories":[125],"createDate":"2016-03-03T15:51:02.18","updateDate":"2020-03-10T14:07:25.553"},"rank":100},{"type":"item","object":{"rank":100,"id":631,"code":"Q531","type":"question","description":"problem teeth loss","direction":"negative","underlyingIssue":"experiencing problems due to teeth loss","additionalInfo":"","preferredWording":"Have you had problems because of losing some teeth?","recommendedWording":null,"questionnaires":[43,111,231,232,279,381,394,533],"categories":[89],"createDate":"2016-03-04T08:26:08.563","updateDate":"2020-03-10T14:08:07.86"},"rank":100},{"type":"item","object":{"rank":100,"id":632,"code":"Q532","type":"question","description":"problem hoarse","direction":"negative","underlyingIssue":"experiencing problems with hoarseness","additionalInfo":"","preferredWording":"Have you had problems with hoarseness?","recommendedWording":null,"questionnaires":[43,111,231,232,269,279,579,381,394,511,513,533,546],"categories":[139,94],"createDate":"2016-03-04T08:29:22.37","updateDate":"2020-03-10T14:09:09.917"},"rank":100},{"type":"item","object":{"rank":100,"id":635,"code":"Q535","type":"question","description":"neck swelling ","direction":"negative","underlyingIssue":"having swelling in the neck","additionalInfo":"","preferredWording":"Have you had swelling in your neck?","recommendedWording":null,"questionnaires":[43,111,231,232,279,381,394,395,482,485,517,533],"categories":[38],"createDate":"2016-03-04T08:47:47.25","updateDate":"2020-03-10T14:12:41.22"},"rank":100},{"type":"item","object":{"rank":100,"id":636,"code":"Q536","type":"question","description":"rash","direction":"negative","underlyingIssue":"having a rash","additionalInfo":"","preferredWording":"Have you had a rash?","recommendedWording":"Have you had a rash?","questionnaires":[43,103,111,481,496,533,560,368,377,378,381,394,232,240,277,279,362,228,229,230,231,132,134,143,144,146,153],"categories":[24],"createDate":"2016-03-04T08:59:50.34","updateDate":"2020-03-10T14:13:57.41"},"rank":100},{"type":"item","object":{"rank":100,"id":637,"code":"Q537","type":"question","description":"skin colour changes","direction":"negative","underlyingIssue":"skin colour changing","additionalInfo":"","preferredWording":"Has your skin changed colour?","recommendedWording":"Has your skin changed colour?","questionnaires":[43,111,132,134,381,394,533,231,232,240,279],"categories":[22],"createDate":"2016-03-04T09:04:59.777","updateDate":"2020-03-10T14:14:18.437"},"rank":100},{"type":"item","object":{"rank":100,"id":638,"code":"Q538","type":"question","description":"problem wound heal","direction":"negative","underlyingIssue":"experiencing problems with wounds healing","additionalInfo":"","preferredWording":"Have you had problems with wounds healing?","recommendedWording":null,"questionnaires":[43,111,231,232,533,583,603,279,381,394],"categories":[22],"createDate":"2016-03-04T09:14:31.057","updateDate":"2020-03-10T14:14:37.063"},"rank":100},{"type":"item","object":{"rank":100,"id":639,"code":"Q539","type":"question","description":"problem chew","direction":"negative","underlyingIssue":"experiencing problems chewing","additionalInfo":"","preferredWording":"Have you had problems chewing?","recommendedWording":null,"questionnaires":[43,111,231,232,279,381,394,528,531,532,533],"categories":[33,89],"createDate":"2016-03-04T09:17:45.11","updateDate":"2020-03-10T14:16:08.527"},"rank":100},{"type":"item","object":{"rank":100,"id":640,"code":"Q540","type":"question","description":"problem speak clearly","direction":"negative","underlyingIssue":"experiencing problems speaking clearly","additionalInfo":"","preferredWording":"Have you had problems speaking clearly?","recommendedWording":null,"questionnaires":[43,111,231,232,279,381,394,533],"categories":[139],"createDate":"2016-03-04T09:27:49.447","updateDate":"2020-03-10T14:19:54.367"},"rank":100},{"type":"item","object":{"rank":100,"id":666,"code":"Q557","type":"question","description":"knowledge experience illness","direction":"positive","underlyingIssue":"feeling satisfied with doctors\' knowledge and experience of the illness","additionalInfo":"","preferredWording":"Their knowledge and experience of your illness?","recommendedWording":null,"questionnaires":[381,168,47,111],"categories":[126],"createDate":"2016-03-04T12:37:12.63","updateDate":"2020-03-10T14:42:37.043"},"rank":100},{"type":"item","object":{"rank":100,"id":667,"code":"Q558","type":"question","description":"treatment follow-up","direction":"positive","underlyingIssue":"feeling satisfied with the treatment and the medical follow-up provided by doctors","additionalInfo":"","preferredWording":"The treatment and medical follow-up they provided?","recommendedWording":null,"questionnaires":[47,111,381,492],"categories":[126],"createDate":"2016-03-04T12:38:24.937","updateDate":"2020-03-10T14:43:39.163"},"rank":100},{"type":"item","object":{"rank":100,"id":668,"code":"Q559","type":"question","description":"attention physical problems","direction":"positive","underlyingIssue":"feeling satisfied with doctors\' attention to physical problems","additionalInfo":"","preferredWording":"The attention they paid to your physical problems?","recommendedWording":null,"questionnaires":[47,111,168,381],"categories":[126],"createDate":"2016-03-04T12:39:25.157","updateDate":"2020-03-10T14:44:04.747"},"rank":100},{"type":"item","object":{"rank":100,"id":669,"code":"Q560","type":"question","description":"willingness listen concerns","direction":"positive","underlyingIssue":"feeling satisfied with doctors\' willingness to listen to concerns","additionalInfo":"","preferredWording":"Their willingness to listen to all of your concerns?","recommendedWording":null,"questionnaires":[47,111,376,381],"categories":[126],"createDate":"2016-03-04T12:40:58.277","updateDate":"2020-03-10T15:00:26.703"},"rank":100},{"type":"item","object":{"rank":100,"id":670,"code":"Q561","type":"question","description":"interest personally","direction":"positive","underlyingIssue":"feeling satisfied with doctors\'/nurses\' personal interest in the patient","additionalInfo":"","preferredWording":"The interest they showed in you personally?","recommendedWording":null,"questionnaires":[47,111,276,376,381],"categories":[126],"createDate":"2016-03-04T13:00:11.597","updateDate":"2020-03-10T15:01:47.2"},"rank":100},{"type":"item","object":{"rank":100,"id":671,"code":"Q562","type":"question","description":"comfort support","direction":"positive","underlyingIssue":"feeling satisfied with the comfort and support provided by doctors/nurses","additionalInfo":"","preferredWording":"The comfort and support they gave you?","recommendedWording":null,"questionnaires":[47,90,111,167,612,618,597,598,599,379,381,462,582,276,361,365,376],"categories":[126],"createDate":"2016-03-04T13:01:13.75","updateDate":"2020-03-10T15:15:31.567"},"rank":100},{"type":"item","object":{"rank":100,"id":672,"code":"Q563","type":"question","description":"information illness","direction":"positive","underlyingIssue":"feeling satisfied with information about illness received from doctors","additionalInfo":"","preferredWording":"The information they gave you about your illness?","recommendedWording":null,"questionnaires":[47,90,111,167,330,361,598,599,612,618,365,379,381,462,582,597],"categories":[125],"createDate":"2016-03-04T13:08:04.153","updateDate":"2020-03-10T15:15:59.147"},"rank":100},{"type":"item","object":{"rank":100,"id":673,"code":"Q564","type":"question","description":"information medical test","direction":"positive","underlyingIssue":"feeling satisfied with information about medical tests provided by doctors/nurses","additionalInfo":"","preferredWording":"The information they gave you about your medical tests?","recommendedWording":null,"questionnaires":[47,111,276,329,381],"categories":[125],"createDate":"2016-03-04T13:09:11.317","updateDate":"2020-03-10T15:16:24.403"},"rank":100},{"type":"item","object":{"rank":100,"id":674,"code":"Q565","type":"question","description":"information treatment","direction":"positive","underlyingIssue":"feeling satisfied with information about treatment provided by doctors/nurses","additionalInfo":"","preferredWording":"The information they gave you about your treatment?","recommendedWording":null,"questionnaires":[47,111,276,381],"categories":[125],"createDate":"2016-03-04T13:10:32.313","updateDate":"2020-03-10T15:16:49.66"},"rank":100},{"type":"item","object":{"rank":100,"id":675,"code":"Q566","type":"question","description":"frequency visits consultations","direction":"positive","underlyingIssue":"feeling satisfied with frequency of doctors\' visits and consultations","additionalInfo":"","preferredWording":"The frequency of their visits/consultations?","recommendedWording":null,"questionnaires":[47,90,111,167,330,361,599,612,618,379,381,462,582,597,598],"categories":[126],"createDate":"2016-03-04T13:11:46.027","updateDate":"2020-03-10T15:17:13.293"},"rank":100},{"type":"item","object":{"rank":100,"id":676,"code":"Q567","type":"question","description":"time visits consultations","direction":"positive","underlyingIssue":"feeling satisfied with time devoted by doctors to the patient during visits and consultations","additionalInfo":"","preferredWording":"The time they devoted to you during visits/consultations?","recommendedWording":null,"questionnaires":[47,111,381],"categories":[126],"createDate":"2016-03-04T13:18:21.987","updateDate":"2020-03-10T15:17:56.023"},"rank":100},{"type":"item","object":{"rank":100,"id":677,"code":"Q568","type":"question","description":"physical examinations","direction":"negative","underlyingIssue":"feeling satisfied with how physical examinations were carried out by nurses","additionalInfo":"","preferredWording":"The way they carried out your physical examination (took your temperature, felt your pulse,…)?","recommendedWording":null,"questionnaires":[381,111,47],"categories":[126],"createDate":"2016-03-04T13:20:08.52","updateDate":"2020-03-10T15:18:37.503"},"rank":100},{"type":"item","object":{"rank":100,"id":678,"code":"Q569","type":"question","description":"handle care","direction":"positive","underlyingIssue":"feeling satisfied with how nurses handled care","additionalInfo":"","preferredWording":"The way they handled your care (gave your medicines, performed injections,…)?","recommendedWording":null,"questionnaires":[47,111,381],"categories":[126],"createDate":"2016-03-04T13:24:34.31","updateDate":"2020-03-10T15:19:00.093"},"rank":100},{"type":"item","object":{"rank":100,"id":679,"code":"Q570","type":"question","description":"attention physical comfort","direction":"positive","underlyingIssue":"feeling satisfied with nurses\' attention to physical comfort","additionalInfo":"","preferredWording":"The attention they paid to your physical comfort?","recommendedWording":null,"questionnaires":[612,618,582,597,598,599,462,361,379,381,167,47,90,111],"categories":[126],"createDate":"2016-03-04T13:25:33.717","updateDate":"2020-03-10T15:19:46.003"},"rank":100},{"type":"item","object":{"rank":100,"id":680,"code":"Q571","type":"question","description":"human qualities","direction":"positive","underlyingIssue":"feeling satisfied with nurses\' human qualities","additionalInfo":"","preferredWording":"Their human qualities (politeness, respect, sensitivity, kindness, patience,…)?","recommendedWording":null,"questionnaires":[47,111,276,376,381],"categories":[126],"createDate":"2016-03-04T13:35:04.59","updateDate":"2020-03-10T15:20:32.477"},"rank":100},{"type":"item","object":{"rank":100,"id":681,"code":"Q572","type":"question","description":"information care","direction":"positive","underlyingIssue":"feeling satisfied with information about care provided by nurses","additionalInfo":"","preferredWording":"The information they gave you about your care?","recommendedWording":null,"questionnaires":[47,111,276,381],"categories":[125],"createDate":"2016-03-04T13:37:46.133","updateDate":"2020-03-10T15:21:16.357"},"rank":100},{"type":"item","object":{"rank":100,"id":682,"code":"Q573","type":"question","description":"prompt buzzer calls","direction":"positive","underlyingIssue":"feeling satisfied with nurses\' promptness in answering buzzer calls","additionalInfo":"","preferredWording":"Their promptness in answering your buzzer calls?","recommendedWording":null,"questionnaires":[47,111,381],"categories":[126],"createDate":"2016-03-04T13:39:59.563","updateDate":"2020-03-10T15:22:26.357"},"rank":100},{"type":"item","object":{"rank":100,"id":683,"code":"Q574","type":"question","description":"time devoted","direction":"positive","underlyingIssue":"feeling satisfied with time devoted by nurses","additionalInfo":"","preferredWording":"The time they devoted to you?","recommendedWording":null,"questionnaires":[47,90,111,167,599,612,618,462,582,597,598,276,361,365,379,381],"categories":[126],"createDate":"2016-03-04T13:41:05.773","updateDate":"2020-03-10T15:22:52.44"},"rank":100},{"type":"item","object":{"rank":100,"id":684,"code":"Q575","type":"question","description":"exchange information caregivers","direction":"positive","underlyingIssue":"feeling satisfied with exchange of information between caregivers","additionalInfo":"","preferredWording":"The exchange of information between the different caregivers (doctors, nurses, physiotherapists, psychologists, etc.)?","recommendedWording":null,"questionnaires":[47,90,111,167,612,618,381,462,582,598,599,276,325,330,361,379],"categories":[125],"createDate":"2016-03-04T13:45:45.243","updateDate":"2020-03-10T15:23:26.277"},"rank":100},{"type":"item","object":{"rank":100,"id":685,"code":"Q576","type":"question","description":"kind helpful technical reception laboratory","direction":"positive","underlyingIssue":"feeling satisfied with kindness/helpfulness of other hospital personnel","additionalInfo":"","preferredWording":"The kindness and helpfulness of the technical, reception, laboratory personnel, etc.?","recommendedWording":null,"questionnaires":[47,90,111,167,361,376,618,379,381,462,582,598,612],"categories":[126],"createDate":"2016-03-04T13:47:00.877","updateDate":"2020-03-10T15:23:48.6"},"rank":100},{"type":"item","object":{"rank":100,"id":686,"code":"Q577","type":"question","description":"information admission hospital","direction":"positive","underlyingIssue":"feeling satisfied with information provided on admission to hospital","additionalInfo":"","preferredWording":"The information provided on your admission to the hospital?","recommendedWording":null,"questionnaires":[47,111,376,381],"categories":[125],"createDate":"2016-03-04T13:49:40.33","updateDate":"2020-03-10T15:26:10.963"},"rank":100},{"type":"item","object":{"rank":100,"id":687,"code":"Q578","type":"question","description":"information discharge hospital","direction":"positive","underlyingIssue":"feeling satisfied with information provided on discharge from hospital","additionalInfo":"","preferredWording":"The information provided on your discharge from the hospital?","recommendedWording":null,"questionnaires":[47,111,376,381],"categories":[125],"createDate":"2016-03-04T13:55:36.567","updateDate":"2020-03-10T15:26:35.627"},"rank":100},{"type":"item","object":{"rank":100,"id":688,"code":"Q579","type":"question","description":"waiting time results tests","direction":"negative","underlyingIssue":"feeling satisfied with waiting time for results of tests","additionalInfo":"","preferredWording":"The waiting time for obtaining results of medical tests?","recommendedWording":null,"questionnaires":[47,90,111,167,276,330,612,618,376,379,381,462,582,598],"categories":[124],"createDate":"2016-03-04T13:57:15.257","updateDate":"2020-03-10T15:27:23.3"},"rank":100},{"type":"item","object":{"rank":100,"id":689,"code":"Q580","type":"question","description":"speed medical tests treatments","direction":"positive","underlyingIssue":"feeling satisfied with speed of implementing tests or treatments","additionalInfo":"","preferredWording":"The speed of implementing medical tests and/or treatments?","recommendedWording":null,"questionnaires":[47,311,376,381,276,111],"categories":[124],"createDate":"2016-03-04T13:58:28.953","updateDate":"2020-03-10T15:28:19.65"},"rank":100},{"type":"item","object":{"rank":100,"id":690,"code":"Q581","type":"question","description":"ease access","direction":"positive","underlyingIssue":"feeling satisfied with ease of access","additionalInfo":"","preferredWording":"The ease of access (parking, means of transport, etc.)?","recommendedWording":null,"questionnaires":[47,90,111,612,618,582,598,599,462,330,361,379,381,167],"categories":[124],"createDate":"2016-03-04T13:59:25.803","updateDate":"2020-03-10T15:28:42.347"},"rank":100},{"type":"item","object":{"rank":100,"id":691,"code":"Q582","type":"question","description":"ease find departments","direction":"positive","underlyingIssue":"feeling satisfied with ease of finding way to departments","additionalInfo":"","preferredWording":"The ease of finding your way to the different departments in the hospital?","recommendedWording":null,"questionnaires":[47,90,111,167,379,381,462,582,598,599,612,618],"categories":[124],"createDate":"2016-03-04T14:01:09.097","updateDate":"2020-03-10T15:29:08.96"},"rank":100},{"type":"item","object":{"rank":100,"id":692,"code":"Q583","type":"question","description":"environment building","direction":"positive","underlyingIssue":"feeling satisfied with environment of the building","additionalInfo":"","preferredWording":"The environment of the building (cleanliness, spaciousness, calmness, etc.)?","recommendedWording":null,"questionnaires":[47,90,111,167,379,381,462,582,598,612,618],"categories":[124],"createDate":"2016-03-04T14:02:19.907","updateDate":"2020-03-10T15:29:43.547"},"rank":100},{"type":"item","object":{"rank":100,"id":642,"code":"Q542","type":"question","description":"abdomen swelling","direction":"negative","underlyingIssue":"having abdominal swelling","additionalInfo":"","preferredWording":"Have you had abdominal swelling?","recommendedWording":null,"questionnaires":[44,111,235,381],"categories":[57,38],"createDate":"2016-03-04T09:50:10.163","updateDate":"2020-03-10T14:21:58.17"},"rank":100},{"type":"item","object":{"rank":100,"id":643,"code":"Q543","type":"question","description":"worry appearance abdomen","direction":"negative","underlyingIssue":"worrying about the appearance of the abdomen","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you worried about the appearance of your abdomen?</p>","preferredWording":"Have you been concerned by the appearance of your abdomen?","recommendedWording":null,"questionnaires":[44,111,381],"categories":[57,4],"createDate":"2016-03-04T10:07:35.577","updateDate":"2020-03-10T14:22:44.003"},"rank":100},{"type":"item","object":{"rank":100,"id":645,"code":"Q545","type":"question","description":"worry enough nourishment","direction":"negative","underlyingIssue":"worrying about getting enough nourishment","additionalInfo":"","preferredWording":"Have you worried about getting enough nourishment?","recommendedWording":null,"questionnaires":[44,111,381,580],"categories":[33,72],"createDate":"2016-03-04T10:15:45.293","updateDate":"2020-03-10T14:23:49.21"},"rank":100},{"type":"item","object":{"rank":100,"id":646,"code":"Q546","type":"question","description":"need sleep day","direction":"negative","underlyingIssue":"needing to sleep during day","additionalInfo":"","preferredWording":"Have you needed to sleep during the day?","recommendedWording":null,"questionnaires":[44,111,381],"categories":[135],"createDate":"2016-03-04T10:19:34.293","updateDate":"2020-03-10T14:25:43.7"},"rank":100},{"type":"item","object":{"rank":100,"id":647,"code":"Q547","type":"question","description":"upset treatment affect hair","direction":"negative","underlyingIssue":"being upset by how treatment affected hair","additionalInfo":"","preferredWording":"Have you been upset by how the treatment has affected your hair?","recommendedWording":null,"questionnaires":[45,111,381],"categories":[25,39],"createDate":"2016-03-04T10:57:38.723","updateDate":"2020-03-10T14:26:15.46"},"rank":100},{"type":"item","object":{"rank":100,"id":652,"code":"Q549","type":"question","description":"problem cope hospital","direction":"negative","underlyingIssue":"experiencing problems coping with the hospital stay","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems coping with the hospital stay?</p>","preferredWording":"Have you had trouble coping with the hospital stay?","recommendedWording":null,"questionnaires":[45,111,381],"categories":[30],"createDate":"2016-03-04T11:11:39.033","updateDate":"2020-03-10T14:28:06.563"},"rank":100},{"type":"item","object":{"rank":100,"id":653,"code":"Q550","type":"question","description":"problem isolation hospital","direction":"negative","underlyingIssue":"experiencing problems with the isolation in hospital","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems with the isolation in hospital?</p>","preferredWording":"Has the isolation in hospital troubled you?","recommendedWording":null,"questionnaires":[45,111,381],"categories":[39],"createDate":"2016-03-04T11:17:46.21","updateDate":"2020-03-10T14:29:27.2"},"rank":100},{"type":"item","object":{"rank":100,"id":654,"code":"Q551","type":"question","description":"worry blood recover","direction":"negative","underlyingIssue":"worrying that blood may not recover","additionalInfo":"","preferredWording":"Have you worried that the blood (i.e. blood counts) may not recover?","recommendedWording":null,"questionnaires":[45,111,381],"categories":[53,16],"createDate":"2016-03-04T11:20:21.717","updateDate":"2020-03-10T14:30:47.103"},"rank":100},{"type":"item","object":{"rank":100,"id":655,"code":"Q552","type":"question","description":"satisfied prepare treatment","direction":"positive","underlyingIssue":"feeling satisfied with preparation of treatment","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you been satisfied with the preparation for your treatment?</p>","preferredWording":"How satisfied were you with the preparation for your treatment?","recommendedWording":null,"questionnaires":[45,111,381],"categories":[126],"createDate":"2016-03-04T11:25:05.693","updateDate":"2020-03-10T14:32:52.37"},"rank":100},{"type":"item","object":{"rank":100,"id":656,"code":"Q553","type":"question","description":"need keep fears concerns family friends","direction":"negative","underlyingIssue":"feeling the need to keep fears or concerns from family or friends","additionalInfo":"","preferredWording":"Have you felt a need to keep your fears/ concerns from family or friends?","recommendedWording":null,"questionnaires":[45,381,111],"categories":[41,49],"createDate":"2016-03-04T11:31:24.147","updateDate":"2020-03-10T14:33:24.227"},"rank":100},{"type":"item","object":{"rank":100,"id":657,"code":"Q554","type":"question","description":"experience distinguish important things life","direction":"negative","underlyingIssue":"experience helping to distinguish between important and non-important things in life","additionalInfo":"","preferredWording":"Has your experience helped you to distinguish between important and non-important things in life?","recommendedWording":null,"questionnaires":[45,111,381],"categories":[140],"createDate":"2016-03-04T11:35:10.013","updateDate":"2020-03-10T14:34:34.193"},"rank":100},{"type":"item","object":{"rank":100,"id":658,"code":"Q555","type":"question","description":"drug intake interference daily life","direction":"negative","underlyingIssue":"having to take drugs regularly interfering with the daily life","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has having to take drugs regularly interfered with your daily life?</p>","preferredWording":"Did having to take your drugs regularly interfere with your daily life?","recommendedWording":null,"questionnaires":[45,111,381,492],"categories":[1,30],"createDate":"2016-03-04T11:50:09.293","updateDate":"2020-03-10T14:36:55.387"},"rank":100},{"type":"item","object":{"rank":100,"id":659,"code":"Q556","type":"question","description":"watch closely new symptoms","direction":"negative","underlyingIssue":"watching oneself closely for new symptoms","additionalInfo":"","preferredWording":"Have you been watching yourself closely for any new symptoms?","recommendedWording":null,"questionnaires":[45,381,321,111],"categories":[30,54],"createDate":"2016-03-04T11:52:01.993","updateDate":"2020-03-10T14:39:25.1"},"rank":100},{"type":"item","object":{"rank":100,"id":697,"code":"Q584","type":"question","description":"allergic reactions","direction":"negative","underlyingIssue":"having allergic reactions","additionalInfo":"","preferredWording":"Have you had allergic reactions?","recommendedWording":null,"questionnaires":[48,111,199,209,328,381,456,484],"categories":[63],"createDate":"2016-03-04T15:12:53.423","updateDate":"2020-03-10T15:30:08.223"},"rank":100},{"type":"item","object":{"rank":100,"id":699,"code":"Q586","type":"question","description":"split nails","direction":"negative","underlyingIssue":"having splitting fingernails or toenails","additionalInfo":"","preferredWording":"Have you had splitting fingernails or toenails?","recommendedWording":null,"questionnaires":[48,111,199,209,328,381,456,484],"categories":[29],"createDate":"2016-03-04T15:17:32.72","updateDate":"2020-03-10T15:30:53.747"},"rank":100},{"type":"item","object":{"rank":100,"id":700,"code":"Q587","type":"question","description":"afraid tumor progression","direction":"negative","underlyingIssue":"being afraid to tumor progression","additionalInfo":"","preferredWording":"Have you been afraid of tumor progression?","recommendedWording":null,"questionnaires":[48,111,199,209,321,328,381,456,484],"categories":[54],"createDate":"2016-03-04T15:19:54.407","updateDate":"2020-03-10T15:40:46.56"},"rank":100},{"type":"item","object":{"rank":100,"id":701,"code":"Q588","type":"question","description":"thin lifeless hair","direction":"negative","underlyingIssue":"having thin or lifeless hair","additionalInfo":"","preferredWording":"Have you had thin or lifeless hair as a result of your disease or treatment?","recommendedWording":null,"questionnaires":[48,111,199,209,456,484,269,328,381],"categories":[25],"createDate":"2016-03-04T15:20:48.633","updateDate":"2020-03-10T15:41:09.57"},"rank":100},{"type":"item","object":{"rank":100,"id":702,"code":"Q589","type":"question","description":"decrease physical capabilities","direction":"negative","underlyingIssue":"experiencing a decrease in physical capabilities","additionalInfo":"","preferredWording":"Have you experienced a decrease in your physical capabilities?","recommendedWording":null,"questionnaires":[48,111,129,199,209,328,381,456,484],"categories":[101],"createDate":"2016-03-04T15:21:58.463","updateDate":"2020-03-10T15:41:37.183"},"rank":100},{"type":"item","object":{"rank":100,"id":703,"code":"Q590","type":"question","description":"pain area surgery","direction":"negative","underlyingIssue":"having pain in the area of surgery","additionalInfo":"","preferredWording":"Have you had pain in the area of surgery?","recommendedWording":null,"questionnaires":[48,111,199,209,381,484,583,603],"categories":[100],"createDate":"2016-03-04T15:24:35.42","updateDate":"2020-03-10T15:42:56.773"},"rank":100},{"type":"item","object":{"rank":100,"id":704,"code":"Q591","type":"question","description":"area wound oversensitive","direction":"negative","underlyingIssue":"the area of the wound being oversensitive","additionalInfo":"","preferredWording":"Has the area of your wound been oversensitive?","recommendedWording":null,"questionnaires":[48,111,129,199,209,381,484,583,603],"categories":[22,141],"createDate":"2016-03-04T15:26:22.707","updateDate":"2020-03-10T15:43:26.943"},"rank":100},{"type":"item","object":{"rank":100,"id":705,"code":"Q592","type":"question","description":"restricted performance surgery","direction":"negative","underlyingIssue":"being restricted in performance due to extent of surgery","additionalInfo":"","preferredWording":"Have you been restricted in your performance due to the extent of surgery?","recommendedWording":null,"questionnaires":[48,111,199,209,381,484],"categories":[101,141],"createDate":"2016-03-04T15:27:53.313","updateDate":"2020-03-10T15:44:26.647"},"rank":100},{"type":"item","object":{"rank":100,"id":706,"code":"Q593","type":"question","description":"problem use arm shoulder operation","direction":"negative","underlyingIssue":"experiencing problems using arm or shoulder on the side of the operation","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems using your arm or shoulder on the side of the chest operation?</p>","preferredWording":"Have you had any difficulty using your arm or shoulder on the side of the chest operation?","recommendedWording":null,"questionnaires":[48,111,129,199,209,381,484],"categories":[101,141],"createDate":"2016-03-04T15:29:11.707","updateDate":"2020-03-10T15:45:13.697"},"rank":100},{"type":"item","object":{"rank":100,"id":707,"code":"Q594","type":"question","description":"scar pain daily activities","direction":"negative","underlyingIssue":"scar pain interfering with daily activities","additionalInfo":"","preferredWording":"Has your scar pain interfered with your daily activities?","recommendedWording":null,"questionnaires":[48,111,129,199,583,603,609,610,209,381,445,484],"categories":[1,141],"createDate":"2016-03-04T15:30:15.403","updateDate":"2020-03-10T15:45:40.06"},"rank":100},{"type":"item","object":{"rank":100,"id":713,"code":"Q595","type":"question","description":"able deal with problems","direction":"positive","underlyingIssue":"feeling able to deal with problems","additionalInfo":"","preferredWording":"I have felt able to deal with problems","recommendedWording":null,"questionnaires":[49,111,182,311,321,381,220,222,223],"categories":[30,140],"createDate":"2016-03-07T09:51:24.99","updateDate":"2020-03-10T15:46:30.79"},"rank":100},{"type":"item","object":{"rank":100,"id":714,"code":"Q596","type":"question","description":"peace myself","direction":"positive","underlyingIssue":"feeling at peace with oneself","additionalInfo":"","preferredWording":"I have felt at peace with myself","recommendedWording":null,"questionnaires":[49,111,182,220,223,381],"categories":[140],"createDate":"2016-03-07T09:53:04.94","updateDate":"2020-03-10T15:46:53.037"},"rank":100},{"type":"item","object":{"rank":100,"id":715,"code":"Q597","type":"question","description":"find things enjoy","direction":"positive","underlyingIssue":"finding things one enjoys doing","additionalInfo":"","preferredWording":"I have been able to find things I enjoy doing","recommendedWording":null,"questionnaires":[49,111,182,220,223,381],"categories":[30],"createDate":"2016-03-07T09:54:17.36","updateDate":"2020-03-10T15:47:55.983"},"rank":100},{"type":"item","object":{"rank":100,"id":716,"code":"Q598","type":"question","description":"forgive things done","direction":"positive","underlyingIssue":"feeling able to forge oneself for the things done","additionalInfo":"","preferredWording":"I have felt able to forgive myself for things I have done","recommendedWording":null,"questionnaires":[49,111,182,220,223,381],"categories":[39,140],"createDate":"2016-03-07T09:55:46.47","updateDate":"2020-03-10T15:49:02.97"},"rank":100},{"type":"item","object":{"rank":100,"id":717,"code":"Q599","type":"question","description":"troubled","direction":"negative","underlyingIssue":"feeling troubled","additionalInfo":"","preferredWording":"I have felt troubled","recommendedWording":null,"questionnaires":[49,111,182,220,223,381],"categories":[39],"createDate":"2016-03-07T09:57:10.417","updateDate":"2020-03-10T15:49:26.12"},"rank":100},{"type":"item","object":{"rank":100,"id":718,"code":"Q600","type":"question","description":"lonely","direction":"negative","underlyingIssue":"feeling lonely","additionalInfo":"","preferredWording":"I have felt lonely","recommendedWording":null,"questionnaires":[49,111,182,220,223,357,381,639],"categories":[39],"createDate":"2016-03-07T09:58:17.56","updateDate":"2020-03-10T15:50:19.597"},"rank":100},{"type":"item","object":{"rank":100,"id":719,"code":"Q601","type":"question","description":"share thoughts life people close","direction":"positive","underlyingIssue":"feeling able to share thoughts about life with close people","additionalInfo":"","preferredWording":"I have felt able to share thoughts about life with people who are close to me","recommendedWording":null,"questionnaires":[49,111,311,381,182,220,223],"categories":[49,140],"createDate":"2016-03-07T10:25:46.03","updateDate":"2020-03-10T15:51:05.96"},"rank":100},{"type":"item","object":{"rank":100,"id":720,"code":"Q602","type":"question","description":"love close people","direction":"positive","underlyingIssue":"feeling loved by close people","additionalInfo":"","preferredWording":"I have felt loved by those who are important to me","recommendedWording":null,"questionnaires":[49,111,182,220,223,381],"categories":[39,49],"createDate":"2016-03-07T10:27:54.72","updateDate":"2020-03-10T15:51:46.083"},"rank":100},{"type":"item","object":{"rank":100,"id":721,"code":"Q603","type":"question","description":"someone talk feelings","direction":"positive","underlyingIssue":"feeling that there are people to talk about feelings","additionalInfo":"","preferredWording":"I have felt that I have someone to talk to about my feelings","recommendedWording":null,"questionnaires":[49,111,182,220,223,381],"categories":[39,21],"createDate":"2016-03-07T10:32:47.823","updateDate":"2020-03-10T15:52:21.62"},"rank":100},{"type":"item","object":{"rank":100,"id":524,"code":"Q435","type":"question","description":"stoma bag","direction":"none","underlyingIssue":"having a stoma bag","additionalInfo":"","preferredWording":"Do you have a stoma bag (colostomy/ileostomy)?","recommendedWording":null,"questionnaires":[32,111,114,433,472,475,486,699,721,249,258,284,313,381],"categories":[8,83],"createDate":"2016-03-02T15:48:25.557","updateDate":"2020-03-10T11:43:22.523"},"rank":100},{"type":"item","object":{"rank":100,"id":349,"code":"CS16","type":"condition","description":"area where the skin/muscle was taken from","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please answer the following regarding the area where the skin/muscle was taken from:","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:33:05.103","updateDate":"2016-03-01T13:33:05.103"},"rank":100},{"type":"item","object":{"rank":100,"id":725,"code":"Q607","type":"question","description":"life fulfil","direction":"positive","underlyingIssue":"feeling that life is fulfilling","additionalInfo":"","preferredWording":"I have felt that my life is fulfilling","recommendedWording":null,"questionnaires":[49,111,182,220,223,321,381],"categories":[39,140],"createDate":"2016-03-07T11:02:54.42","updateDate":"2020-03-10T15:54:51.16"},"rank":100},{"type":"item","object":{"rank":100,"id":726,"code":"Q608","type":"question","description":"life worthwhile","direction":"positive","underlyingIssue":"feeling that life is worthwhile","additionalInfo":"","preferredWording":"I have felt that my life is worthwhile","recommendedWording":null,"questionnaires":[49,111,182,220,223,381],"categories":[39,140],"createDate":"2016-03-07T11:03:51.72","updateDate":"2020-03-10T15:55:15.683"},"rank":100},{"type":"item","object":{"rank":100,"id":728,"code":"Q610","type":"question","description":"worries concerns future","direction":"negative","underlyingIssue":"having worries or concerns about future","additionalInfo":"","preferredWording":"I have had worries and/or concerns about the future","recommendedWording":null,"questionnaires":[49,111,381,311,182,220,223],"categories":[53,41],"createDate":"2016-03-07T11:05:56.01","updateDate":"2020-03-10T15:57:37.613"},"rank":100},{"type":"item","object":{"rank":100,"id":729,"code":"Q611","type":"question","description":"wonder anything done","direction":"negative","underlyingIssue":"wondering if anything can be done","additionalInfo":"","preferredWording":"I have wondered whether anything can be done for me","recommendedWording":null,"questionnaires":[49,111,182,220,223,381],"categories":[53,30],"createDate":"2016-03-07T11:07:36.01","updateDate":"2020-03-10T15:58:28.577"},"rank":100},{"type":"item","object":{"rank":100,"id":730,"code":"Q612","type":"question","description":"felt unfair ill","direction":"negative","underlyingIssue":"feeling that being ill is unfair","additionalInfo":"","preferredWording":"I have felt that it is unfair that I am ill","recommendedWording":null,"questionnaires":[49,111,182,220,223,381],"categories":[30,140],"createDate":"2016-03-07T11:09:17.273","updateDate":"2020-03-10T15:58:59.823"},"rank":100},{"type":"item","object":{"rank":100,"id":731,"code":"Q613","type":"question","description":"time quietness prayer meditation","direction":"positive","underlyingIssue":"having time for quietness, prayer or meditation","additionalInfo":"","preferredWording":"I have had time for quietness, prayer or meditation","recommendedWording":null,"questionnaires":[49,111,182,220,223,381],"categories":[140],"createDate":"2016-03-07T11:10:03.297","updateDate":"2020-03-10T15:59:24.02"},"rank":100},{"type":"item","object":{"rank":100,"id":732,"code":"Q614","type":"question","description":"important others pray for me","direction":"positive","underlyingIssue":"feeling that it is important that others pray for the patient","additionalInfo":"","preferredWording":"I have felt that it is important that other people pray for me","recommendedWording":null,"questionnaires":[49,111,182,220,223,381],"categories":[140],"createDate":"2016-03-07T11:13:02.25","updateDate":"2020-03-10T15:59:45.953"},"rank":100},{"type":"item","object":{"rank":100,"id":733,"code":"Q615","type":"question","description":"believe god","direction":"positive","underlyingIssue":"believing in God or someone greater than oneself","additionalInfo":"","preferredWording":"I believe in God or in someone or something greater than myself","recommendedWording":null,"questionnaires":[49,111,220,223,381],"categories":[140],"createDate":"2016-03-07T11:13:53.28","updateDate":"2020-03-10T16:00:25.28"},"rank":100},{"type":"item","object":{"rank":100,"id":734,"code":"Q616","type":"question","description":"always believed god","direction":"positive","underlyingIssue":"having always believed in God or someone greater than oneself","additionalInfo":"","preferredWording":"I have always believed in God or in someone or something greater than myself","recommendedWording":null,"questionnaires":[381,49,111,220,223],"categories":[140],"createDate":"2016-03-07T11:14:33.873","updateDate":"2020-03-10T16:00:59.663"},"rank":100},{"type":"item","object":{"rank":100,"id":735,"code":"Q617","type":"question","description":"beliefs changed less well","direction":"negative","underlyingIssue":"one\'s beliefs having changed since feeling less well","additionalInfo":"","preferredWording":"My beliefs have changed since I have felt less well","recommendedWording":null,"questionnaires":[49,111,220,223,381],"categories":[140],"createDate":"2016-03-07T11:15:59.957","updateDate":"2020-03-10T16:01:29.24"},"rank":100},{"type":"item","object":{"rank":100,"id":736,"code":"Q618","type":"question","description":"beliefs changed last weeks","direction":"negative","underlyingIssue":"one\'s beliefs having changed in last weeks","additionalInfo":"","preferredWording":"My beliefs have changed in the last few weeks","recommendedWording":null,"questionnaires":[49,111,220,223,381],"categories":[140],"createDate":"2016-03-07T11:17:25.51","updateDate":"2020-03-10T16:01:55.98"},"rank":100},{"type":"item","object":{"rank":100,"id":737,"code":"Q619","type":"question","description":"connected god","direction":"positive","underlyingIssue":"feeling connected to God or someone greater than oneself","additionalInfo":"","preferredWording":"I feel connected to God or to someone or something greater than myself","recommendedWording":null,"questionnaires":[49,111,220,223,381],"categories":[140],"createDate":"2016-03-07T11:19:00.423","updateDate":"2020-03-10T16:02:18.833"},"rank":100},{"type":"item","object":{"rank":100,"id":738,"code":"Q620","type":"question","description":"feel will live words, deeds, influence others","direction":"positive","underlyingIssue":"feeling that one will live on through words, deeds or influence on others","additionalInfo":"","preferredWording":"I feel that I will live on through my words, deeds and/or influence on other people","recommendedWording":null,"questionnaires":[49,381,220,223,111],"categories":[140],"createDate":"2016-03-07T11:21:06.15","updateDate":"2020-03-10T16:03:05.463"},"rank":100},{"type":"item","object":{"rank":100,"id":739,"code":"Q621","type":"question","description":"feelings life changed less well","direction":"none","underlyingIssue":"feelings about life having changed since feeling less well","additionalInfo":"","preferredWording":"My feelings about life have changed since I have felt less well","recommendedWording":null,"questionnaires":[49,111,182,220,223,381],"categories":[30,140],"createDate":"2016-03-07T11:22:03.437","updateDate":"2020-03-10T16:03:44.76"},"rank":100},{"type":"item","object":{"rank":100,"id":740,"code":"Q622","type":"question","description":" feelings life changed last weeks","direction":"none","underlyingIssue":" feelings about life having changed in last weeks","additionalInfo":"","preferredWording":"My feelings about life have changed in the last few weeks","recommendedWording":null,"questionnaires":[49,111,182,220,223,381],"categories":[30,140],"createDate":"2016-03-07T11:23:13","updateDate":"2020-03-10T16:04:38.843"},"rank":100},{"type":"item","object":{"rank":100,"id":741,"code":"Q623","type":"question","description":"life after death","direction":"positive","underlyingIssue":"believing in life after death","additionalInfo":"","preferredWording":"I believe in life after death","recommendedWording":null,"questionnaires":[49,111,220,223,381],"categories":[140],"createDate":"2016-03-07T11:23:35.883","updateDate":"2020-03-10T16:04:58.483"},"rank":100},{"type":"item","object":{"rank":100,"id":742,"code":"Q624","type":"question","description":"spiritual wellbeing","direction":"positive","underlyingIssue":"having spiritual wellbeing","additionalInfo":"","preferredWording":"I have spiritual wellbeing","recommendedWording":null,"questionnaires":[49,111,220,223,381],"categories":[140],"createDate":"2016-03-07T11:24:08.117","updateDate":"2020-03-10T16:05:24.647"},"rank":100},{"type":"item","object":{"rank":100,"id":743,"code":"Q625","type":"question","description":"global spiritual wellbeing","direction":"positive","underlyingIssue":"global spiritual wellbeing","additionalInfo":"","preferredWording":"How would you rate your overall spiritual wellbeing?","recommendedWording":null,"questionnaires":[49,111,182,220,223,381],"categories":[140],"createDate":"2016-03-07T11:24:58.787","updateDate":"2020-03-10T16:05:55.003"},"rank":100},{"type":"item","object":{"rank":100,"id":751,"code":"Q626","type":"question","description":"PF01 problems lift cup glass mouth","direction":"negative","underlyingIssue":"experiencing problems lifting a full cup or glass to the mouth","additionalInfo":"","preferredWording":"Do you have any trouble lifting a full cup or glass to your mouth?","recommendedWording":null,"questionnaires":[50,111,345,381],"categories":[105],"createDate":"2016-12-15T15:30:23.783","updateDate":"2020-03-04T15:44:01.1"},"rank":100},{"type":"item","object":{"rank":100,"id":752,"code":"Q627","type":"question","description":"PF02 problems walk 100 m","direction":"negative","underlyingIssue":"experiencing problems walking 100 metres","additionalInfo":"","preferredWording":"Do you have any trouble walking 100 m?","recommendedWording":null,"questionnaires":[50,111,345,381],"categories":[111],"createDate":"2016-12-15T15:33:39.167","updateDate":"2020-03-04T15:44:34.72"},"rank":100},{"type":"item","object":{"rank":100,"id":753,"code":"Q628","type":"question","description":"PF03 need help footcare","direction":"negative","underlyingIssue":"needing help caring for one\'s feet","additionalInfo":"","preferredWording":"Do you need help caring for your feet (e.g. cutting your toenails)?","recommendedWording":null,"questionnaires":[50,111,345,381],"categories":[101,2],"createDate":"2016-12-15T15:37:23.983","updateDate":"2020-03-04T15:47:24.993"},"rank":100},{"type":"item","object":{"rank":100,"id":754,"code":"Q629","type":"question","description":"PF04 problems walk up stairs","direction":"negative","underlyingIssue":"experiencing problems walking up a flight of stairs","additionalInfo":"","preferredWording":"Do you have any trouble walking up a flight of stairs?","recommendedWording":null,"questionnaires":[50,111,345,381,543],"categories":[103],"createDate":"2016-12-15T15:38:08.37","updateDate":"2020-03-04T15:48:52.197"},"rank":100},{"type":"item","object":{"rank":100,"id":755,"code":"Q630","type":"question","description":"PF06 help grooming","direction":"negative","underlyingIssue":"needing help with grooming/personal hygiene","additionalInfo":"","preferredWording":"Do you need help with grooming (e.g. cleaning nails, brushing teeth, combing your hair)?","recommendedWording":null,"questionnaires":[50,111,381],"categories":[101,2],"createDate":"2017-02-20T13:33:39.717","updateDate":"2020-03-04T15:49:39.637"},"rank":100},{"type":"item","object":{"rank":100,"id":756,"code":"Q631","type":"question","description":"PF07 problems walk 30 min","direction":"negative","underlyingIssue":"experiencing problems walking for 30 minutes","additionalInfo":"","preferredWording":"Do you have any trouble walking for 30 min.?","recommendedWording":null,"questionnaires":[50,111,345,381],"categories":[111],"createDate":"2017-02-20T13:36:07.66","updateDate":"2020-03-04T15:51:48.447"},"rank":100},{"type":"item","object":{"rank":100,"id":757,"code":"Q632","type":"question","description":"PF08 problems lift 10 kg","direction":"negative","underlyingIssue":"experiencing problems lifting an item weighing around 10 kilograms","additionalInfo":"","preferredWording":"Do you have any trouble lifting a box weighing about 10 kg?","recommendedWording":null,"questionnaires":[50,111,345,381],"categories":[105],"createDate":"2017-02-20T13:37:03.667","updateDate":"2020-03-04T15:52:23.437"},"rank":100},{"type":"item","object":{"rank":100,"id":758,"code":"Q633","type":"question","description":"PF09 problems hike 3 km uneven","direction":"negative","underlyingIssue":"experiencing problems hiking 3 kilometres on uneven surfaces","additionalInfo":"","preferredWording":"Do you have any trouble hiking 3 km on uneven surfaces?","recommendedWording":null,"questionnaires":[50,111,381],"categories":[111],"createDate":"2017-02-20T13:37:57.07","updateDate":"2020-03-04T15:52:55.603"},"rank":100},{"type":"item","object":{"rank":100,"id":759,"code":"Q634","type":"question","description":"PF10","direction":"negative","underlyingIssue":"needing dressing","additionalInfo":"","preferredWording":"Do you need help dressing?","recommendedWording":null,"questionnaires":[50,111,381],"categories":[101,2],"createDate":"2017-02-20T13:38:30.393","updateDate":"2020-03-04T15:53:39.94"},"rank":100},{"type":"item","object":{"rank":100,"id":760,"code":"Q635","type":"question","description":"PF11 problems walking outdoors flat","direction":"negative","underlyingIssue":"experiencing problems walking outdoors on flat ground","additionalInfo":"","preferredWording":"Do you have any trouble walking outdoors on flat ground?","recommendedWording":null,"questionnaires":[50,103,111,345,381],"categories":[111],"createDate":"2017-02-20T13:39:09.193","updateDate":"2020-03-04T15:54:58.61"},"rank":100},{"type":"item","object":{"rank":100,"id":761,"code":"Q636","type":"question","description":"PF12 problems steps","direction":"negative","underlyingIssue":"experiencing problems walking a few steps","additionalInfo":"","preferredWording":"Do you have any trouble walking a few steps?","recommendedWording":null,"questionnaires":[50,111,345,381],"categories":[111],"createDate":"2017-02-20T13:39:47.04","updateDate":"2020-03-04T15:55:32.463"},"rank":100},{"type":"item","object":{"rank":100,"id":762,"code":"Q637","type":"question","description":"PF14 need help put on shirt","direction":"negative","underlyingIssue":"needing help putting on a shirt/blouse","additionalInfo":"","preferredWording":"Do you need help putting on a shirt?","recommendedWording":null,"questionnaires":[50,111,345,381],"categories":[101,2],"createDate":"2017-02-20T13:41:21.037","updateDate":"2020-03-04T15:57:37.403"},"rank":100},{"type":"item","object":{"rank":100,"id":763,"code":"Q638","type":"question","description":"PF16 problems reach object above head","direction":"negative","underlyingIssue":"experiencing problems reaching and getting down an object of around 2 kilograms from above the head","additionalInfo":"","preferredWording":"Do you have any trouble reaching and getting down an object weighing about 2 kg (such as a bag of flour) from just above your head?","recommendedWording":null,"questionnaires":[50,111,345,381],"categories":[107],"createDate":"2017-02-20T13:43:30.867","updateDate":"2020-03-04T16:00:16.773"},"rank":100},{"type":"item","object":{"rank":100,"id":764,"code":"Q639","type":"question","description":"PF17 problems bend pick","direction":"negative","underlyingIssue":"experiencing problems bending over to pick up a light object from the floor","additionalInfo":"","preferredWording":"Do you have any trouble bending over to pick up a light object from the floor?","recommendedWording":null,"questionnaires":[50,111,381],"categories":[102],"createDate":"2017-02-20T13:44:25.453","updateDate":"2020-03-04T16:01:16.987"},"rank":100},{"type":"item","object":{"rank":100,"id":769,"code":"Q644","type":"question","description":"PF23 problems walk carry back","direction":"negative","underlyingIssue":"experiencing problems taking a long walk carrying a heavy load on one\'s back","additionalInfo":"","preferredWording":"Do you have any trouble taking a long walk carrying a heavy pack on your back (e.g. a filled rucksack)?","recommendedWording":null,"questionnaires":[50,564,381,345,111],"categories":[111],"createDate":"2017-02-20T13:51:18.923","updateDate":"2020-03-05T10:18:10.983"},"rank":100},{"type":"item","object":{"rank":100,"id":770,"code":"Q645","type":"question","description":"PF25 problems carry 5 kg","direction":"negative","underlyingIssue":"experiencing problems carrying an object weighing around 5 kilograms","additionalInfo":"","preferredWording":"Do you have any trouble carrying something weighing about 5 kg?","recommendedWording":null,"questionnaires":[50,111,381],"categories":[105],"createDate":"2017-02-20T13:53:09.003","updateDate":"2020-03-05T10:18:38.61"},"rank":100},{"type":"item","object":{"rank":100,"id":771,"code":"Q646","type":"question","description":"PF26","direction":"negative","underlyingIssue":"needing help to walk outside","additionalInfo":"","preferredWording":"Do you need help to walk about outside (e.g. a walking stick or someone to support you)?","recommendedWording":null,"questionnaires":[50,111,345,381],"categories":[111],"createDate":"2017-02-20T13:53:59.27","updateDate":"2020-03-05T10:19:09.997"},"rank":100},{"type":"item","object":{"rank":100,"id":772,"code":"Q647","type":"question","description":"PF27 need help undress","direction":"negative","underlyingIssue":"needing help undressing","additionalInfo":"","preferredWording":"Do you need help undressing?","recommendedWording":null,"questionnaires":[50,111,381],"categories":[101,2],"createDate":"2017-02-20T13:54:38.15","updateDate":"2020-03-05T10:19:43.82"},"rank":100},{"type":"item","object":{"rank":100,"id":773,"code":"Q648","type":"question","description":"PF28 problems carry both hands upstairs","direction":"negative","underlyingIssue":"experiencing problems carrying an object in both hands up the stairs","additionalInfo":"","preferredWording":"Do you have any trouble carrying something in both hands (e.g. shopping bags) while climbing a flight of stairs?","recommendedWording":null,"questionnaires":[50,111,345,381],"categories":[105],"createDate":"2017-02-20T13:56:08.79","updateDate":"2020-03-05T10:20:17.843"},"rank":100},{"type":"item","object":{"rank":100,"id":774,"code":"Q649","type":"question","description":"PF28 need help eat","direction":"negative","underlyingIssue":"needing help eating","additionalInfo":"","preferredWording":"Do you need help eating?","recommendedWording":null,"questionnaires":[50,111,249,381],"categories":[101,2],"createDate":"2017-02-20T13:56:44.187","updateDate":"2020-03-05T10:21:03.863"},"rank":100},{"type":"item","object":{"rank":100,"id":775,"code":"Q650","type":"question","description":"PF30 problems lift pot","direction":"negative","underlyingIssue":"experiencing problems lifting a full teapot/coffeepot","additionalInfo":"","preferredWording":"Do you have any trouble lifting a full teapot/coffeepot?","recommendedWording":null,"questionnaires":[50,345,381,111],"categories":[105],"createDate":"2017-02-20T13:59:35.423","updateDate":"2020-03-05T10:22:06.56"},"rank":100},{"type":"item","object":{"rank":100,"id":776,"code":"Q651","type":"question","description":"PF31 problems run short","direction":"negative","underlyingIssue":"experiencing problems running a short distance","additionalInfo":"","preferredWording":"Do you have any trouble running a short distance, such as to catch the bus?","recommendedWording":null,"questionnaires":[50,111,345,381,543],"categories":[108],"createDate":"2017-02-20T14:00:16.237","updateDate":"2020-03-05T10:27:28.06"},"rank":100},{"type":"item","object":{"rank":100,"id":778,"code":"Q653","type":"question","description":"EF03 panic","direction":"negative","underlyingIssue":"feeling panic","additionalInfo":"","preferredWording":"Have you felt panic?","recommendedWording":null,"questionnaires":[51,111,224,276,345,365,381],"categories":[41],"createDate":"2017-02-20T14:10:42.3","updateDate":"2020-02-27T12:02:36.717"},"rank":100},{"type":"item","object":{"rank":100,"id":779,"code":"Q654","type":"question","description":"EF04 lose interest","direction":"negative","underlyingIssue":"losing interest in recreational or social activities","additionalInfo":"","preferredWording":"Have you lost interest in things, such as recreational or social activities (independently of your actual ability to do them)?","recommendedWording":null,"questionnaires":[51,111,224,345,381],"categories":[],"createDate":"2017-02-20T14:13:37.467","updateDate":"2017-02-20T14:13:54.38"},"rank":100},{"type":"item","object":{"rank":100,"id":780,"code":"Q655","type":"question","description":"EF05 vulnerable","direction":"negative","underlyingIssue":"feeling vulnerable","additionalInfo":"","preferredWording":"Have you felt vulnerable?","recommendedWording":null,"questionnaires":[51,111,224,381],"categories":[39],"createDate":"2017-02-20T14:14:31.553","updateDate":"2020-02-27T12:04:49.613"},"rank":100},{"type":"item","object":{"rank":100,"id":781,"code":"Q656","type":"question","description":"EF06 frustrated","direction":"negative","underlyingIssue":"feeling frustrated","additionalInfo":"","preferredWording":"Did you feel frustrated?","recommendedWording":null,"questionnaires":[40,51,625,381,495,111,224],"categories":[40],"createDate":"2017-02-20T14:15:02.757","updateDate":"2020-02-27T12:05:23.09"},"rank":100},{"type":"item","object":{"rank":100,"id":783,"code":"Q658","type":"question","description":"EF08 discouraged","direction":"negative","underlyingIssue":"feeling discouraged","additionalInfo":"","preferredWording":"Have you felt discouraged?","recommendedWording":null,"questionnaires":[51,111,224,345,365,381,495],"categories":[39],"createDate":"2017-02-20T14:17:04.21","updateDate":"2020-02-27T12:07:44.397"},"rank":100},{"type":"item","object":{"rank":100,"id":784,"code":"Q659","type":"question","description":"EF09 outbursts","direction":"negative","underlyingIssue":"experiencing emotional outbursts","additionalInfo":"","preferredWording":"Have you had emotional outbursts?","recommendedWording":null,"questionnaires":[51,111,224,381],"categories":[47],"createDate":"2017-02-20T14:34:40.843","updateDate":"2020-02-27T12:08:23.49"},"rank":100},{"type":"item","object":{"rank":100,"id":786,"code":"Q661","type":"question","description":"EF11 afraid","direction":"negative","underlyingIssue":"feeling afraid","additionalInfo":"","preferredWording":"Have you felt afraid?","recommendedWording":null,"questionnaires":[51,111,224,276,345,365,381,451],"categories":[45],"createDate":"2017-02-20T14:37:27.117","updateDate":"2020-02-27T12:26:17.02"},"rank":100},{"type":"item","object":{"rank":100,"id":788,"code":"Q663","type":"question","description":"EF13 problems relax","direction":"negative","underlyingIssue":"experiencing problems relaxing","additionalInfo":"","preferredWording":"Have you had difficulty relaxing?","recommendedWording":null,"questionnaires":[51,111,345,381,224],"categories":[48],"createDate":"2017-02-20T14:39:02.033","updateDate":"2020-02-27T12:30:48.023"},"rank":100},{"type":"item","object":{"rank":100,"id":789,"code":"Q664","type":"question","description":"EF14 lose interest appearance","direction":"negative","underlyingIssue":"losing interest in one\'s appearance","additionalInfo":"","preferredWording":"Have you lost interest in your appearance?","recommendedWording":null,"questionnaires":[51,111,224,381],"categories":[4,42],"createDate":"2017-02-20T14:40:15.437","updateDate":"2020-02-27T12:31:51.063"},"rank":100},{"type":"item","object":{"rank":100,"id":792,"code":"Q667","type":"question","description":"EF20 desperate","direction":"negative","underlyingIssue":"feeling desperate","additionalInfo":"","preferredWording":"Have you felt desperate?","recommendedWording":null,"questionnaires":[51,111,224,381],"categories":[39],"createDate":"2017-02-20T14:44:40.777","updateDate":"2020-02-27T12:40:15.737"},"rank":100},{"type":"item","object":{"rank":100,"id":793,"code":"Q668","type":"question","description":"EF21 fear lost control","direction":"negative","underlyingIssue":"feeling afraid of losing control","additionalInfo":"","preferredWording":"Have you been afraid of losing control?","recommendedWording":null,"questionnaires":[51,111,224,381,345,365],"categories":[39],"createDate":"2017-02-20T14:45:25.72","updateDate":"2020-02-27T12:40:53.507"},"rank":100},{"type":"item","object":{"rank":100,"id":797,"code":"Q672","type":"question","description":"RF01 limit household tasks","direction":"negative","underlyingIssue":"being limited in completing one\'s household tasks","additionalInfo":"","preferredWording":"Have you been limited in completing your household tasks?","recommendedWording":null,"questionnaires":[52,111,381,399,565],"categories":[122,3],"createDate":"2017-02-20T14:57:47.1","updateDate":"2020-03-05T10:32:02.68"},"rank":100},{"type":"item","object":{"rank":100,"id":798,"code":"Q673","type":"question","description":"RF02 limit light housework","direction":"negative","underlyingIssue":"being limited in doing light housework","additionalInfo":"","preferredWording":"Have you been limited in doing light housework (e.g. dusting or making the bed)?","recommendedWording":null,"questionnaires":[52,111,381,413,565],"categories":[122,3],"createDate":"2017-02-20T15:07:33.193","updateDate":"2020-03-05T10:32:59.857"},"rank":100},{"type":"item","object":{"rank":100,"id":799,"code":"Q674","type":"question","description":"RF03 limit demanding activity","direction":"negative","underlyingIssue":"being limited in doing physically demanding recreational activities","additionalInfo":"","preferredWording":"Have you been limited in doing physically demanding recreational activities (e.g., swimming or cycling)?","recommendedWording":null,"questionnaires":[52,111,381,413,565],"categories":[],"createDate":"2017-02-20T15:08:52.283","updateDate":"2017-02-20T15:11:08.803"},"rank":100},{"type":"item","object":{"rank":100,"id":800,"code":"Q675","type":"question","description":"RF04 need help work daily activity","direction":"negative","underlyingIssue":"needing help in doing one\'s work or daily activities","additionalInfo":"","preferredWording":"Have you needed assistance in doing your work or daily activities?","recommendedWording":null,"questionnaires":[52,111,381,413,565],"categories":[123,1],"createDate":"2017-02-20T15:10:04.95","updateDate":"2020-03-05T10:35:29.57"},"rank":100},{"type":"item","object":{"rank":100,"id":801,"code":"Q676","type":"question","description":"RF05 limit light activity","direction":"negative","underlyingIssue":"being limited in doing light recreational activities","additionalInfo":"","preferredWording":"Have you been limited in doing light recreational activities (e.g., watching TV, playing cards, or reading)?","recommendedWording":null,"questionnaires":[52,111,381,413,565],"categories":[],"createDate":"2017-02-20T15:10:57.647","updateDate":"2017-10-09T13:46:09.293"},"rank":100},{"type":"item","object":{"rank":100,"id":802,"code":"Q677","type":"question","description":"RF06 limit repairs maintenance","direction":"negative","underlyingIssue":"being limited in doing minor household repairs and maintenance","additionalInfo":"","preferredWording":"Have you been limited in doing minor household repairs and maintenance (e.g., changing a light bulb or hanging up a picture)?","recommendedWording":null,"questionnaires":[52,111,381,565],"categories":[122,3],"createDate":"2017-02-20T15:13:07.3","updateDate":"2020-03-05T11:32:41.647"},"rank":100},{"type":"item","object":{"rank":100,"id":803,"code":"Q678","type":"question","description":"RF07 limit finances","direction":"negative","underlyingIssue":"being limited in taking care of personal or household financial affairs","additionalInfo":"","preferredWording":"Have you been limited in taking care of personal or household financial affairs (e.g. paying bills)?","recommendedWording":null,"questionnaires":[52,111,565,381],"categories":[122,3],"createDate":"2017-02-20T15:14:03.227","updateDate":"2020-03-05T11:33:14.673"},"rank":100},{"type":"item","object":{"rank":100,"id":804,"code":"Q679","type":"question","description":"RF09 limit heavy household","direction":"negative","underlyingIssue":"being limited in doing heavy housework","additionalInfo":"","preferredWording":"Have you been limited in doing heavy housework (e.g., washing floors or vacuuming)?","recommendedWording":null,"questionnaires":[52,111,125,565,413,381],"categories":[122,3],"createDate":"2017-02-20T15:15:25.96","updateDate":"2020-03-05T11:33:53.25"},"rank":100},{"type":"item","object":{"rank":100,"id":805,"code":"Q680","type":"question","description":"CF01 problems two tasks simultaneous","direction":"negative","underlyingIssue":"experiencing problems performing two tasks simultaneously","additionalInfo":"","preferredWording":"Have you had difficulty performing two tasks simultaneously, e.g. having a conversation while cooking?","recommendedWording":null,"questionnaires":[53,111,381,529,530,544],"categories":[20],"createDate":"2017-02-20T15:23:32.657","updateDate":"2020-02-18T14:41:15.643"},"rank":100},{"type":"item","object":{"rank":100,"id":806,"code":"Q681","type":"question","description":"CF02 distracted thoughts","direction":"negative","underlyingIssue":"being distracted by thoughts when one should be concentrating on something else","additionalInfo":"","preferredWording":"Have you been distracted by thoughts when you should have been concentrating on something else?","recommendedWording":null,"questionnaires":[53,111,381,544],"categories":[18],"createDate":"2017-02-20T15:25:18.257","updateDate":"2020-02-18T14:41:57.123"},"rank":100},{"type":"item","object":{"rank":100,"id":889,"code":"Q763","type":"question","description":"NV03 nausea interfere daily activities","direction":"negative","underlyingIssue":"nausea or vomiting interfering with work or daily activities","additionalInfo":"","preferredWording":"Has nausea or vomiting interfered with your work or other daily activities?","recommendedWording":null,"questionnaires":[57,111,156,247,273,336,381,497],"categories":[86,123],"createDate":"2017-03-07T15:24:07.27","updateDate":"2020-02-27T14:35:48.047"},"rank":100},{"type":"item","object":{"rank":100,"id":890,"code":"Q764","type":"question","description":"NV04 severe nausea","direction":"negative","underlyingIssue":"having severe nausea or vomiting","additionalInfo":"","preferredWording":"Have you had severe nausea or vomiting?","recommendedWording":null,"questionnaires":[57,111,156,381,392],"categories":[86],"createDate":"2017-03-07T15:42:23.513","updateDate":"2020-02-27T14:37:15.203"},"rank":100},{"type":"item","object":{"rank":100,"id":891,"code":"Q765","type":"question","description":"NV05 nausea interfere enjoy life","direction":"negative","underlyingIssue":"nausea or vomiting interfering with the ability to enjoy life","additionalInfo":"","preferredWording":"Has nausea or vomiting interfered with your ability to enjoy life?","recommendedWording":null,"questionnaires":[57,111,156,381],"categories":[86,39],"createDate":"2017-03-07T15:44:05.87","updateDate":"2020-02-27T14:38:04.483"},"rank":100},{"type":"item","object":{"rank":100,"id":892,"code":"Q766","type":"question","description":"NV06 nausea eat less","direction":"negative","underlyingIssue":"eating less because of nausea or vomiting","additionalInfo":"","preferredWording":"Have you eaten less because of nausea or vomiting?","recommendedWording":null,"questionnaires":[57,111,156,187,381,497],"categories":[86,33],"createDate":"2017-03-07T15:44:57.98","updateDate":"2020-02-27T14:41:20.387"},"rank":100},{"type":"item","object":{"rank":100,"id":893,"code":"Q767","type":"question","description":"NV07 problem nausea","direction":"negative","underlyingIssue":"nausea or vomiting being a problem","additionalInfo":"","preferredWording":"Has nausea or vomiting been a problem for you?","recommendedWording":null,"questionnaires":[57,111,134,156,377,381,413],"categories":[86],"createDate":"2017-03-07T15:45:53.41","updateDate":"2020-02-27T14:41:57.72"},"rank":100},{"type":"item","object":{"rank":100,"id":894,"code":"Q768","type":"question","description":"NV08 nausea interfere physical activity","direction":"negative","underlyingIssue":"nausea or vomiting interfering with physical activities","additionalInfo":"","preferredWording":"Has nausea or vomiting interfered with your physical activities like taking a walk?","recommendedWording":null,"questionnaires":[57,111,156,381],"categories":[86,111],"createDate":"2017-03-07T15:48:17.717","updateDate":"2020-02-27T14:43:00.383"},"rank":100},{"type":"item","object":{"rank":100,"id":895,"code":"Q769","type":"question","description":"NV09 nausea unbearable","direction":"negative","underlyingIssue":"having nausea or vomiting that was almost unbearable","additionalInfo":"","preferredWording":"Have you had such severe nausea or vomiting that it was almost unbearable?","recommendedWording":null,"questionnaires":[57,111,156,381],"categories":[86],"createDate":"2017-03-07T15:49:21.32","updateDate":"2020-02-27T14:43:38.527"},"rank":100},{"type":"item","object":{"rank":100,"id":896,"code":"Q770","type":"question","description":"NV10 nausea interfere family life","direction":"negative","underlyingIssue":"nausea or vomiting interfering with family life","additionalInfo":"","preferredWording":"Has nausea or vomiting interfered with your family life?","recommendedWording":null,"questionnaires":[57,111,156,381],"categories":[86,49],"createDate":"2017-03-07T15:50:33.49","updateDate":"2020-02-27T14:44:24.843"},"rank":100},{"type":"item","object":{"rank":100,"id":897,"code":"Q771","type":"question","description":"NV11 nausea distress","direction":"negative","underlyingIssue":"being distressed by nausea or vomiting","additionalInfo":"","preferredWording":"Have you been distressed by nausea or vomiting?","recommendedWording":null,"questionnaires":[57,111,156,381,643],"categories":[86,43],"createDate":"2017-03-07T15:51:17.843","updateDate":"2020-02-27T14:46:49.36"},"rank":100},{"type":"item","object":{"rank":100,"id":899,"code":"Q773","type":"question","description":"NV13 nausea interfere leisure","direction":"negative","underlyingIssue":"nausea or vomiting interfering with hobbies or leisure activities","additionalInfo":"","preferredWording":"Has nausea or vomiting interfered with your hobbies or other leisure time activities?","recommendedWording":null,"questionnaires":[57,111,381],"categories":[86,112],"createDate":"2017-03-07T15:53:52.433","updateDate":"2020-02-27T14:49:29.853"},"rank":100},{"type":"item","object":{"rank":100,"id":900,"code":"Q774","type":"question","description":"NV14 nausea interfere appetite","direction":"negative","underlyingIssue":"nausea or vomiting interfering with appetite","additionalInfo":"","preferredWording":"Has nausea or vomiting interfered with your appetite?","recommendedWording":null,"questionnaires":[57,111,156,381],"categories":[86,33],"createDate":"2017-03-07T15:54:35.493","updateDate":"2020-02-27T14:50:19.43"},"rank":100},{"type":"item","object":{"rank":100,"id":901,"code":"Q775","type":"question","description":"NV15 nausea day night","direction":"negative","underlyingIssue":"having nausea or vomiting all the time","additionalInfo":"","preferredWording":"Have you had nausea or vomited day and night?","recommendedWording":null,"questionnaires":[57,111,156,381],"categories":[86],"createDate":"2017-03-07T15:55:52.047","updateDate":"2020-02-27T14:51:57.117"},"rank":100},{"type":"item","object":{"rank":100,"id":902,"code":"Q776","type":"question","description":"NV16 nausea unable eat","direction":"negative","underlyingIssue":"being unable to eat because of nausea or vomiting","additionalInfo":"","preferredWording":"Have you been unable to eat because of nausea or vomiting?","recommendedWording":null,"questionnaires":[57,111,156,249,381],"categories":[86,33],"createDate":"2017-03-07T15:57:32.813","updateDate":"2020-02-27T14:52:37.863"},"rank":100},{"type":"item","object":{"rank":100,"id":903,"code":"Q777","type":"question","description":"NV17 nausea interfere social","direction":"negative","underlyingIssue":"nausea or vomiting interfering with social activities","additionalInfo":"","preferredWording":"Has nausea or vomiting interfered with your social activities?","recommendedWording":null,"questionnaires":[57,111,156,381],"categories":[],"createDate":"2017-03-08T14:52:52.827","updateDate":"2017-03-08T14:54:28.057"},"rank":100},{"type":"item","object":{"rank":100,"id":904,"code":"Q778","type":"question","description":"NV18 nausea less fluid","direction":"negative","underlyingIssue":"drinking less fluid because of nausea or vomiting","additionalInfo":"","preferredWording":"Have you been drinking less fluid because of nausea or vomiting?","recommendedWording":null,"questionnaires":[57,381,111,156],"categories":[86,33],"createDate":"2017-03-08T14:53:41.893","updateDate":"2020-02-27T14:55:12.6"},"rank":100},{"type":"item","object":{"rank":100,"id":905,"code":"Q779","type":"question","description":"NV19 nausea unable eat stomach","direction":"negative","underlyingIssue":"being unable to eat or keep anything in the stomach because of nausea or vomiting","additionalInfo":"","preferredWording":"Have you felt so nauseous or vomited so much that you were unable to eat or keep anything in your stomach?","recommendedWording":null,"questionnaires":[57,381,111,156],"categories":[86,33],"createDate":"2017-03-08T14:55:25.077","updateDate":"2020-02-27T14:56:00.603"},"rank":100},{"type":"item","object":{"rank":100,"id":906,"code":"Q780","type":"question","description":"AP01 severe lack appetite","direction":"negative","underlyingIssue":"having severe lack of appetite","additionalInfo":"","preferredWording":"Have you had severe lack of appetite?","recommendedWording":null,"questionnaires":[58,111,279,381,605,643],"categories":[35],"createDate":"2017-03-08T14:56:49.62","updateDate":"2020-02-18T14:36:09.93"},"rank":100},{"type":"item","object":{"rank":100,"id":907,"code":"Q781","type":"question","description":"AP03 encouragement eat","direction":"negative","underlyingIssue":"needing encouragement from others to eat","additionalInfo":"","preferredWording":"Have you needed encouragement from others to eat?","recommendedWording":null,"questionnaires":[58,111,249,279,381],"categories":[35],"createDate":"2017-03-08T14:58:03.723","updateDate":"2020-02-18T14:36:56.573"},"rank":100},{"type":"item","object":{"rank":100,"id":908,"code":"Q782","type":"question","description":"AP05 problem enjoy food","direction":"negative","underlyingIssue":"experiencing problems enjoying food","additionalInfo":"","preferredWording":"Have you had trouble enjoying your food?","recommendedWording":null,"questionnaires":[58,111,249,279,381],"categories":[35],"createDate":"2017-03-08T15:00:33.537","updateDate":"2020-02-18T14:37:22.58"},"rank":100},{"type":"item","object":{"rank":100,"id":909,"code":"Q783","type":"question","description":"AP06 lack interest eat","direction":"negative","underlyingIssue":"lacking interest in eating","additionalInfo":"","preferredWording":"Have you lacked interest in eating?","recommendedWording":null,"questionnaires":[58,111,249,279,377,381,580],"categories":[35],"createDate":"2017-03-08T15:01:13.85","updateDate":"2020-02-18T14:39:13.76"},"rank":100},{"type":"item","object":{"rank":100,"id":910,"code":"Q784","type":"question","description":"AP07 food repulsive","direction":"negative","underlyingIssue":"finding food repulsive","additionalInfo":"","preferredWording":"Have you found food repulsive?","recommendedWording":null,"questionnaires":[58,111,279,381],"categories":[35],"createDate":"2017-03-08T15:01:58.063","updateDate":"2020-02-18T14:39:39.827"},"rank":100},{"type":"item","object":{"rank":100,"id":912,"code":"Q786","type":"question","description":"SL02 wake up night","direction":"negative","underlyingIssue":"waking up during the night","additionalInfo":"","preferredWording":"Have you woken up during the night?","recommendedWording":null,"questionnaires":[59,111,381,517],"categories":[136],"createDate":"2017-03-08T15:08:54.03","updateDate":"2020-03-05T14:56:59.05"},"rank":100},{"type":"item","object":{"rank":100,"id":913,"code":"Q787","type":"question","description":"SL03 wake up early","direction":"negative","underlyingIssue":"waking up too early","additionalInfo":"","preferredWording":"Have you woken up too early?","recommendedWording":null,"questionnaires":[59,111,381,517],"categories":[136],"createDate":"2017-03-08T15:09:55.45","updateDate":"2020-03-05T14:58:54.053"},"rank":100},{"type":"item","object":{"rank":100,"id":914,"code":"Q788","type":"question","description":"SL04 problem stay asleep","direction":"negative","underlyingIssue":"experiencing problems staying asleep","additionalInfo":"","preferredWording":"Have you had trouble staying asleep?","recommendedWording":null,"questionnaires":[59,111,377,381,517],"categories":[136],"createDate":"2017-03-08T15:10:39.85","updateDate":"2020-03-05T14:59:29.513"},"rank":100},{"type":"item","object":{"rank":100,"id":915,"code":"Q789","type":"question","description":"SL06 problem good night sleep","direction":"negative","underlyingIssue":"experiencing problems getting a good night\'s sleep","additionalInfo":"","preferredWording":"Have you had trouble getting a good night\'s sleep?","recommendedWording":null,"questionnaires":[59,111,381,517],"categories":[136],"createDate":"2017-03-08T15:12:00.943","updateDate":"2020-03-05T15:00:17.793"},"rank":100},{"type":"item","object":{"rank":100,"id":916,"code":"Q790","type":"question","description":"SL07 wake up long period night","direction":"negative","underlyingIssue":"waking up for long periods during the night","additionalInfo":"","preferredWording":"Have you woken up for long periods during the night?","recommendedWording":null,"questionnaires":[59,111,381,517,643],"categories":[136],"createDate":"2017-03-08T15:19:58.427","updateDate":"2020-03-05T15:00:52.333"},"rank":100},{"type":"item","object":{"rank":100,"id":918,"code":"Q792","type":"question","description":"DY01 short breath wash","direction":"negative","underlyingIssue":"being short of breath when washing","additionalInfo":"","preferredWording":"Were you short of breath when washing?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32,2],"createDate":"2017-03-08T15:22:10.893","updateDate":"2020-02-18T15:51:27.303"},"rank":100},{"type":"item","object":{"rank":100,"id":919,"code":"Q793","type":"question","description":"DY02 short breath rest","direction":"negative","underlyingIssue":"being short of breath when resting","additionalInfo":"","preferredWording":"Were you short of breath when resting?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32],"createDate":"2017-03-08T15:22:58.727","updateDate":"2020-02-18T15:52:09.847"},"rank":100},{"type":"item","object":{"rank":100,"id":920,"code":"Q794","type":"question","description":"DY03 problem breath sweat","direction":"negative","underlyingIssue":"problems with breathing causing sweating","additionalInfo":"","preferredWording":"Has difficulty with breathing caused you to sweat?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32,69],"createDate":"2017-03-08T16:02:15.21","updateDate":"2020-02-18T15:53:22.26"},"rank":100},{"type":"item","object":{"rank":100,"id":921,"code":"Q795","type":"question","description":"DY04 gasp air","direction":"negative","underlyingIssue":"feeling like one is gasping for air","additionalInfo":"","preferredWording":"Did you feel you were gasping for air?","recommendedWording":null,"questionnaires":[60,111,183,377,381,701],"categories":[32],"createDate":"2017-03-08T16:06:19.24","updateDate":"2020-02-18T15:53:45.037"},"rank":100},{"type":"item","object":{"rank":100,"id":922,"code":"Q796","type":"question","description":"DY05 feel stop breathe","direction":"negative","underlyingIssue":"feeling like one might stop breathing","additionalInfo":"","preferredWording":"Did you feel you might stop breathing?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32],"createDate":"2017-03-08T16:09:52.3","updateDate":"2020-02-18T15:54:16.02"},"rank":100},{"type":"item","object":{"rank":100,"id":924,"code":"Q798","type":"question","description":"DY08 not enough air","direction":"negative","underlyingIssue":"feeling like one cannot get enough air","additionalInfo":"","preferredWording":"Did you feel you could not get enough air?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32],"createDate":"2017-03-28T11:33:58.1","updateDate":"2020-02-18T15:55:37.623"},"rank":100},{"type":"item","object":{"rank":100,"id":926,"code":"Q800","type":"question","description":"DY10 short breath bend","direction":"negative","underlyingIssue":"being short of breath when bending over","additionalInfo":"","preferredWording":"Were you short of breath when you bent over?","recommendedWording":null,"questionnaires":[60,111,381,701,183],"categories":[32,102],"createDate":"2017-03-28T11:35:26.913","updateDate":"2020-02-18T15:56:25.25"},"rank":100},{"type":"item","object":{"rank":100,"id":927,"code":"Q801","type":"question","description":"DY11 short breath minimal effort","direction":"negative","underlyingIssue":"being short of breath on minimal effort","additionalInfo":"","preferredWording":"Did you become short of breath on minimal effort?","recommendedWording":null,"questionnaires":[643,701,381,183,60,111],"categories":[32],"createDate":"2017-03-28T11:36:09.313","updateDate":"2020-02-27T11:32:49.3"},"rank":100},{"type":"item","object":{"rank":100,"id":928,"code":"Q802","type":"question","description":"DY12 suffocate","direction":"negative","underlyingIssue":"feeling like one is suffocating","additionalInfo":"","preferredWording":"Did you feel you were suffocating?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32],"createDate":"2017-03-28T11:36:48.097","updateDate":"2020-02-27T11:33:39.127"},"rank":100},{"type":"item","object":{"rank":100,"id":929,"code":"Q803","type":"question","description":"DY13 short breath moderate activity","direction":"negative","underlyingIssue":"being short of breath when doing moderate activities","additionalInfo":"","preferredWording":"Were you short of breath when doing moderate activities like walking up two flights of stairs or carrying a light load on level ground?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32,111],"createDate":"2017-03-28T11:37:53.213","updateDate":"2020-02-27T11:34:12.277"},"rank":100},{"type":"item","object":{"rank":100,"id":930,"code":"Q804","type":"question","description":"DY14 severe short breath","direction":"negative","underlyingIssue":"having severe shortness of breah","additionalInfo":"","preferredWording":"Did you have severe shortness of breath?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32],"createDate":"2017-03-28T13:20:05.693","updateDate":"2020-02-27T11:35:34.8"},"rank":100},{"type":"item","object":{"rank":100,"id":931,"code":"Q805","type":"question","description":"DY15 rapid breathing","direction":"negative","underlyingIssue":"breathing rapidly","additionalInfo":"","preferredWording":"Was your breathing rapid?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32],"createDate":"2017-03-28T13:20:42.57","updateDate":"2020-02-27T11:37:51.003"},"rank":100},{"type":"item","object":{"rank":100,"id":932,"code":"Q806","type":"question","description":"DY16 short breath dress","direction":"negative","underlyingIssue":"being short of breath when getting dressed","additionalInfo":"","preferredWording":"Were you short of breath when getting dressed?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32,2],"createDate":"2017-03-28T13:21:20.42","updateDate":"2020-02-27T11:38:37.897"},"rank":100},{"type":"item","object":{"rank":100,"id":933,"code":"Q807","type":"question","description":"DY17 short breath walk 100 m","direction":"negative","underlyingIssue":"being short of breath when walking more than 100 m (100 yds)","additionalInfo":"","preferredWording":"Were you short of breath when walking more than 100 m (100 yds)?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32,111],"createDate":"2017-03-28T13:27:19.51","updateDate":"2020-02-27T11:40:25.583"},"rank":100},{"type":"item","object":{"rank":100,"id":934,"code":"Q808","type":"question","description":"DY18 short breath talk","direction":"negative","underlyingIssue":"being short of breath when talking","additionalInfo":"","preferredWording":"Were you short of breath when talking?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32,139],"createDate":"2017-03-28T13:28:06.5","updateDate":"2020-02-27T11:41:23.787"},"rank":100},{"type":"item","object":{"rank":100,"id":935,"code":"Q809","type":"question","description":"DY19 stop breath walk","direction":"negative","underlyingIssue":"having to stop for breath when walking","additionalInfo":"","preferredWording":"Did you have to stop for breath when walking?","recommendedWording":null,"questionnaires":[60,111,125,183,381,701],"categories":[32,111],"createDate":"2017-03-28T13:29:02.803","updateDate":"2020-02-27T11:41:56.267"},"rank":100},{"type":"item","object":{"rank":100,"id":936,"code":"Q810","type":"question","description":"DY20 very severe short breath","direction":"negative","underlyingIssue":"having very severe shortness of breath","additionalInfo":"","preferredWording":"Did you have very severe shortness of breath?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32],"createDate":"2017-03-28T13:29:42.88","updateDate":"2020-02-27T11:42:36.623"},"rank":100},{"type":"item","object":{"rank":100,"id":937,"code":"Q811","type":"question","description":"DY21 short breath walk","direction":"negative","underlyingIssue":"being short of breath when walking","additionalInfo":"","preferredWording":"Were you short of breath when walking?","recommendedWording":null,"questionnaires":[60,103,111,183,381,701],"categories":[32,111],"createDate":"2017-03-28T13:30:26.61","updateDate":"2020-02-27T11:44:01.253"},"rank":100},{"type":"item","object":{"rank":100,"id":938,"code":"Q812","type":"question","description":"DY22 problems breathe in","direction":"negative","underlyingIssue":"experiencing problems breathing in","additionalInfo":"","preferredWording":"Did you have trouble breathing in?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32],"createDate":"2017-03-28T13:31:09.09","updateDate":"2020-02-27T11:44:38.007"},"rank":100},{"type":"item","object":{"rank":100,"id":939,"code":"Q813","type":"question","description":"DY23 short breath walk level ground","direction":"negative","underlyingIssue":"being short of breath when walking on level ground at one\'s own pace","additionalInfo":"","preferredWording":"Were you short of breath when walking on level ground at your own pace?","recommendedWording":null,"questionnaires":[60,701,111,183,381],"categories":[32,111],"createDate":"2017-03-28T13:36:01.24","updateDate":"2020-02-27T11:45:43.967"},"rank":100},{"type":"item","object":{"rank":100,"id":940,"code":"Q814","type":"question","description":"DY24 problems breathe out","direction":"negative","underlyingIssue":"experiencing problems breathing out","additionalInfo":"","preferredWording":"Did you have trouble breathing out?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32],"createDate":"2017-03-28T13:41:17.587","updateDate":"2020-02-27T11:46:44.227"},"rank":100},{"type":"item","object":{"rank":100,"id":941,"code":"Q815","type":"question","description":"DY25 short breath walk up flight stairs","direction":"negative","underlyingIssue":"being short of breath when walking up one flight of stairs","additionalInfo":"","preferredWording":"Were you short of breath when walking up one flight of stairs?","recommendedWording":null,"questionnaires":[60,103,111,183,381,701],"categories":[32,103],"createDate":"2017-03-28T13:42:27.43","updateDate":"2020-02-27T11:47:25.693"},"rank":100},{"type":"item","object":{"rank":100,"id":942,"code":"Q816","type":"question","description":"DY26 short breath stand up chair","direction":"negative","underlyingIssue":"being short of breath when standing up from a chair","additionalInfo":"","preferredWording":"Were you short of breath when standing up from a chair?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32,110],"createDate":"2017-03-28T13:44:28.397","updateDate":"2020-02-27T11:49:05.75"},"rank":100},{"type":"item","object":{"rank":100,"id":943,"code":"Q817","type":"question","description":"DY27 short breath walk less 100 m","direction":"negative","underlyingIssue":"being short of breath when walking less than 100 m (100 yds)","additionalInfo":"","preferredWording":"Were you short of breath when walking less than 100 m (100 yds)?","recommendedWording":null,"questionnaires":[60,701,111,183,381],"categories":[32,111],"createDate":"2017-03-28T13:46:45.977","updateDate":"2020-02-27T11:49:39.807"},"rank":100},{"type":"item","object":{"rank":100,"id":944,"code":"Q818","type":"question","description":"DY28 cannot breathe","direction":"negative","underlyingIssue":"feeling like one cannot breathe","additionalInfo":"","preferredWording":"Did you feel you could not breathe?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32,74],"createDate":"2017-03-28T13:47:31.827","updateDate":"2020-02-27T11:53:44.133"},"rank":100},{"type":"item","object":{"rank":100,"id":945,"code":"Q819","type":"question","description":"DY29 short breath lie down","direction":"negative","underlyingIssue":"being short of breath when lying down","additionalInfo":"","preferredWording":"Were you short of breath when lying down?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32],"createDate":"2017-03-28T13:48:48.61","updateDate":"2020-02-27T11:54:45.677"},"rank":100},{"type":"item","object":{"rank":100,"id":946,"code":"Q820","type":"question","description":"DY30 short breath go up few steps","direction":"negative","underlyingIssue":"being short of breath when going up a few steps","additionalInfo":"","preferredWording":"Were you short of breath when going up a few steps?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32,103],"createDate":"2017-03-28T13:49:50.95","updateDate":"2020-02-27T11:55:54.953"},"rank":100},{"type":"item","object":{"rank":100,"id":947,"code":"Q821","type":"question","description":"DY31 short breath walk around home","direction":"negative","underlyingIssue":"being short of breath when walking around at home","additionalInfo":"","preferredWording":"Were you short of breath when walking around at home?","recommendedWording":null,"questionnaires":[60,111,183,381,461,701],"categories":[32,111],"createDate":"2017-03-28T13:50:26.32","updateDate":"2020-02-27T11:56:45.903"},"rank":100},{"type":"item","object":{"rank":100,"id":948,"code":"Q822","type":"question","description":"DY32 out breath","direction":"negative","underlyingIssue":"feeling out of breath","additionalInfo":"","preferredWording":"Did you feel out of breath?","recommendedWording":null,"questionnaires":[60,111,183,381,701],"categories":[32],"createDate":"2017-03-28T13:50:59.843","updateDate":"2020-02-27T11:57:49.567"},"rank":100},{"type":"item","object":{"rank":100,"id":949,"code":"Q823","type":"question","description":"CO01 need BM cannot","direction":"negative","underlyingIssue":"feeling the need to have bowel movement but not being able to","additionalInfo":"","preferredWording":"Have you felt the need to have bowel movements but could not?","recommendedWording":null,"questionnaires":[61,111,377,381],"categories":[10],"createDate":"2017-03-28T13:52:38.157","updateDate":"2020-02-18T15:24:41.817"},"rank":100},{"type":"item","object":{"rank":100,"id":950,"code":"Q824","type":"question","description":"CO02 hard stools","direction":"negative","underlyingIssue":"having hard stools","additionalInfo":"","preferredWording":"Have you had hard stools?","recommendedWording":null,"questionnaires":[61,111,381,643],"categories":[10],"createDate":"2017-03-28T13:53:13.85","updateDate":"2020-02-18T15:25:07.9"},"rank":100},{"type":"item","object":{"rank":100,"id":951,"code":"Q825","type":"question","description":"CO03 too hard stools","direction":"negative","underlyingIssue":"having stools too hard to pass","additionalInfo":"","preferredWording":"Have you had stools that were too hard to pass?","recommendedWording":null,"questionnaires":[61,111,381],"categories":[10],"createDate":"2017-03-28T13:55:40.277","updateDate":"2020-02-18T15:25:43.857"},"rank":100},{"type":"item","object":{"rank":100,"id":953,"code":"Q827","type":"question","description":"CO05 strain 10 min BM","direction":"negative","underlyingIssue":"having to strain for more than 10 minutes to have a bowel movement","additionalInfo":"","preferredWording":"Have you had to strain for more than 10 min. to have a bowel movement?","recommendedWording":null,"questionnaires":[61,111,381],"categories":[10],"createDate":"2017-03-28T13:57:55.737","updateDate":"2020-02-18T15:28:15.02"},"rank":100},{"type":"item","object":{"rank":100,"id":954,"code":"Q828","type":"question","description":"CO06 press pass stool","direction":"negative","underlyingIssue":"having to use pressure on the abdomen/buttocks to help pass a stool","additionalInfo":"","preferredWording":"Have you had to use pressure on the abdomen or the buttocks to help pass a stool?","recommendedWording":null,"questionnaires":[61,111,381],"categories":[10],"createDate":"2017-03-28T14:01:35.877","updateDate":"2020-02-18T15:29:04.597"},"rank":100},{"type":"item","object":{"rank":100,"id":955,"code":"Q829","type":"question","description":"CO07 not finish BM","direction":"negative","underlyingIssue":"having a sensation of not finishing after a bowel movement","additionalInfo":"","preferredWording":"After bowel movements, have you had a sensation as though you did not \\"finish\\"?","recommendedWording":null,"questionnaires":[61,111,381],"categories":[10],"createDate":"2017-03-28T14:02:27.95","updateDate":"2020-02-18T15:30:01.913"},"rank":100},{"type":"item","object":{"rank":100,"id":956,"code":"Q830","type":"question","description":"CO08 finger pass stool","direction":"negative","underlyingIssue":"having to use a finger to help pass a stool","additionalInfo":"","preferredWording":"Have you had to use a finger to help pass a stool?","recommendedWording":null,"questionnaires":[61,111,381],"categories":[10],"createDate":"2017-03-28T14:03:13.097","updateDate":"2020-02-18T15:30:34.813"},"rank":100},{"type":"item","object":{"rank":100,"id":957,"code":"Q831","type":"question","description":"CO10 unwell","direction":"negative","underlyingIssue":"feeling unwell and thinking it was due to constipation","additionalInfo":"","preferredWording":"Have you felt unwell and thought that it was due to constipation?","recommendedWording":null,"questionnaires":[61,111,381,643],"categories":[10,68],"createDate":"2017-03-28T14:04:49.79","updateDate":"2020-02-18T15:31:21.643"},"rank":100},{"type":"item","object":{"rank":100,"id":958,"code":"Q832","type":"question","description":"DI01 wear pad","direction":"negative","underlyingIssue":"having to wear a pad or similar because of diarrhea","additionalInfo":"","preferredWording":"Have you had to wear a pad or the like because of diarrhoea?","recommendedWording":null,"questionnaires":[62,111,263,381],"categories":[11,82],"createDate":"2017-03-28T14:08:04.517","updateDate":"2020-02-18T15:37:33.39"},"rank":100},{"type":"item","object":{"rank":100,"id":959,"code":"Q833","type":"question","description":"DI02 3 BM liquid stools","direction":"negative","underlyingIssue":"experiencing more than three bowel movements with liquid stools on a single day","additionalInfo":"","preferredWording":"Have you experienced having more than three bowel movements with liquid stools on a single day?","recommendedWording":null,"questionnaires":[62,111,263,381],"categories":[11],"createDate":"2017-03-28T14:09:22.83","updateDate":"2020-02-18T15:38:13.827"},"rank":100},{"type":"item","object":{"rank":100,"id":960,"code":"Q834","type":"question","description":"DI03 severe toilet several times","direction":"negative","underlyingIssue":"experiencing diarrhea so severe that one has to go to the toilet several times within a few hours","additionalInfo":"","preferredWording":"Have you experienced diarrhoea so severe that you had to go to the toilet several times within a few hours?","recommendedWording":null,"questionnaires":[62,111,381,263],"categories":[11],"createDate":"2017-03-28T14:12:11.173","updateDate":"2020-02-18T15:39:00.22"},"rank":100},{"type":"item","object":{"rank":100,"id":961,"code":"Q835","type":"question","description":"DI04 leakage liquid stools","direction":"negative","underlyingIssue":"having accidental leakage of liquid stools","additionalInfo":"","preferredWording":"Have you had accidental leakage of liquid stool?","recommendedWording":null,"questionnaires":[62,111,263,312,381],"categories":[11],"createDate":"2017-03-28T14:13:26.727","updateDate":"2020-02-18T15:39:32.7"},"rank":100},{"type":"item","object":{"rank":100,"id":962,"code":"Q836","type":"question","description":"DI05 sever DI reach toilet","direction":"negative","underlyingIssue":"having diarrhea so sever than reaching toilet in time was difficult","additionalInfo":"","preferredWording":"Have you had diarrhoea so severe that you had difficulty in reaching a toilet in time?","recommendedWording":null,"questionnaires":[62,111,263,312,381],"categories":[11],"createDate":"2017-03-28T14:14:37.04","updateDate":"2020-02-18T15:40:34.977"},"rank":100},{"type":"item","object":{"rank":100,"id":964,"code":"Q838","type":"question","description":"DI07 distress DI","direction":"negative","underlyingIssue":"being distressed due to diarrhea","additionalInfo":"","preferredWording":"Have you been distressed due to diarrhoea?","recommendedWording":null,"questionnaires":[62,111,381],"categories":[11,43],"createDate":"2017-03-28T14:16:53.247","updateDate":"2020-02-18T15:42:42.6"},"rank":100},{"type":"item","object":{"rank":100,"id":965,"code":"Q839","type":"question","description":"DI08 liquid watery stools","direction":"negative","underlyingIssue":"having liquid or watery stools","additionalInfo":"","preferredWording":"Have you had liquid or watery stools?","recommendedWording":null,"questionnaires":[62,111,132,134,212,377,381,391],"categories":[11],"createDate":"2017-03-28T14:17:23.153","updateDate":"2020-02-18T15:43:18.917"},"rank":100},{"type":"item","object":{"rank":100,"id":966,"code":"Q840","type":"question","description":"DI09 discomfort DI","direction":"negative","underlyingIssue":"having abdominal discomfort due to diarrhea","additionalInfo":"","preferredWording":"Have you had abdominal discomfort due to diarrhoea?","recommendedWording":null,"questionnaires":[62,111,381],"categories":[11,58],"createDate":"2017-03-28T14:20:15.913","updateDate":"2020-02-18T15:44:04.14"},"rank":100},{"type":"item","object":{"rank":100,"id":967,"code":"Q841","type":"question","description":"DI10 worry far toilet DI","direction":"negative","underlyingIssue":"worrying about being far from the toilet because of diarrhea","additionalInfo":"","preferredWording":"Have you worried about being far from the toilet because of diarrhoea?","recommendedWording":null,"questionnaires":[62,111,263,312,381],"categories":[11],"createDate":"2017-03-28T14:21:25.82","updateDate":"2020-02-18T15:45:04.56"},"rank":100},{"type":"item","object":{"rank":100,"id":847,"code":"Q722","type":"question","description":"SF13 PC/MT argue family","direction":"negative","underlyingIssue":"physical condition or medical treatment causing arguments with family or friends","additionalInfo":null,"preferredWording":"Has your physical condition or medical treatment caused you to argue with your family or friends?","recommendedWording":null,"questionnaires":[54,111,381],"categories":[],"createDate":"2017-02-21T14:39:20.937","updateDate":"2017-02-21T14:39:20.937"},"rank":100},{"type":"item","object":{"rank":100,"id":848,"code":"Q723","type":"question","description":"FA01 tired eyes open day","direction":"negative","underlyingIssue":"being so tired that keeping one\'s eyes open during daytime is difficult","additionalInfo":"","preferredWording":"Have you been so tired it was difficult keeping your eyes open during daytime?","recommendedWording":null,"questionnaires":[55,111,246,279,381],"categories":[50,135],"createDate":"2017-02-21T14:44:59.333","updateDate":"2020-02-27T12:49:31.83"},"rank":100},{"type":"item","object":{"rank":100,"id":849,"code":"Q724","type":"question","description":"FA02 muscles tired activity","direction":"negative","underlyingIssue":"muscles feeling tired after physical activity","additionalInfo":null,"preferredWording":"Have your muscles felt very tired after physical activity like taking a long walk?","recommendedWording":null,"questionnaires":[55,111,246,279,345,381],"categories":[],"createDate":"2017-02-21T14:51:06.597","updateDate":"2017-02-21T14:51:06.597"},"rank":100},{"type":"item","object":{"rank":100,"id":850,"code":"Q725","type":"question","description":"FA03 wake up exhausted","direction":"negative","underlyingIssue":"waking up with a feeling of exhaustion","additionalInfo":"","preferredWording":"Have you woken up with a feeling of exhaustion?","recommendedWording":null,"questionnaires":[381,246,279,55,111],"categories":[],"createDate":"2017-02-21T15:00:46.747","updateDate":"2019-08-22T15:34:32.033"},"rank":100},{"type":"item","object":{"rank":100,"id":851,"code":"Q726","type":"question","description":"FA04 weak things","direction":"negative","underlyingIssue":"starting things without difficulty but becoming weak as they progress","additionalInfo":"","preferredWording":"Have you started things without difficulty but got weak as you went on?","recommendedWording":null,"questionnaires":[55,111,246,279,381],"categories":[50,101],"createDate":"2017-02-21T15:01:50.337","updateDate":"2020-02-27T12:55:07.2"},"rank":100},{"type":"item","object":{"rank":100,"id":853,"code":"Q727","type":"question","description":"FA05 lack energy things","direction":"negative","underlyingIssue":"lacking the energy to do things","additionalInfo":"","preferredWording":"Have you lacked the energy to do things?","recommendedWording":null,"questionnaires":[55,111,212,246,279,345,381,643],"categories":[50],"createDate":"2017-02-21T15:06:42.15","updateDate":"2020-02-27T12:57:10.503"},"rank":100},{"type":"item","object":{"rank":100,"id":854,"code":"Q728","type":"question","description":"FA07 tired usual","direction":"negative","underlyingIssue":"being too tired to do usual activities","additionalInfo":"","preferredWording":"Have you been too tired to do your usual activities?","recommendedWording":null,"questionnaires":[55,111,212,246,279,345,381,391,643],"categories":[],"createDate":"2017-02-21T15:08:21.293","updateDate":"2019-08-22T15:32:45.813"},"rank":100},{"type":"item","object":{"rank":100,"id":855,"code":"Q729","type":"question","description":"FA08 drained","direction":"negative","underlyingIssue":"feeling drained","additionalInfo":"","preferredWording":"Have you felt drained?","recommendedWording":null,"questionnaires":[55,111,246,279,345,381],"categories":[50],"createDate":"2017-02-21T15:08:51.653","updateDate":"2020-02-27T13:00:00.543"},"rank":100},{"type":"item","object":{"rank":100,"id":856,"code":"Q730","type":"question","description":"FA09 exhausted move body","direction":"negative","underlyingIssue":"feeling so exhausted that moving one\'s body seems impossible","additionalInfo":"","preferredWording":"Have you been so exhausted it felt almost impossible to move your body?","recommendedWording":null,"questionnaires":[55,111,246,381],"categories":[50],"createDate":"2017-02-21T15:09:40.547","updateDate":"2020-02-27T13:00:40.167"},"rank":100},{"type":"item","object":{"rank":100,"id":857,"code":"Q731","type":"question","description":"FA10 problems start tired","direction":"negative","underlyingIssue":"experiencing problems starting things because of being tired","additionalInfo":"","preferredWording":"Have you had trouble starting things because you were tired?","recommendedWording":null,"questionnaires":[55,111,246,381],"categories":[50],"createDate":"2017-02-21T15:10:16.367","updateDate":"2020-02-27T13:01:13.58"},"rank":100},{"type":"item","object":{"rank":100,"id":858,"code":"Q732","type":"question","description":"FA11 tired simple","direction":"negative","underlyingIssue":"being too tired to do even simple things","additionalInfo":"","preferredWording":"Have you been too tired to do even simple things?","recommendedWording":null,"questionnaires":[55,111,381,643,246,345],"categories":[50],"createDate":"2017-02-21T15:10:49.97","updateDate":"2020-02-27T13:01:54.593"},"rank":100},{"type":"item","object":{"rank":100,"id":859,"code":"Q733","type":"question","description":"FA12 shopping exhausting","direction":"negative","underlyingIssue":"finding shopping and doing errands exhausting","additionalInfo":"","preferredWording":"Have you found shopping and doing errands exhausting?","recommendedWording":null,"questionnaires":[55,111,125,246,381],"categories":[50,3],"createDate":"2017-02-21T15:20:22.353","updateDate":"2020-02-27T13:02:27.183"},"rank":100},{"type":"item","object":{"rank":100,"id":860,"code":"Q734","type":"question","description":"FA13 physically exhausted","direction":"negative","underlyingIssue":"feeling physically exhausted","additionalInfo":"","preferredWording":"Have you felt physically exhausted?","recommendedWording":null,"questionnaires":[55,111,246,269,381,546,579,643],"categories":[50],"createDate":"2017-02-21T15:21:00.387","updateDate":"2020-02-27T13:03:38.35"},"rank":100},{"type":"item","object":{"rank":100,"id":861,"code":"Q735","type":"question","description":"FA14 leisure exhausting","direction":"negative","underlyingIssue":"finding leisure and recreational activities exhausting","additionalInfo":"","preferredWording":"Have you found leisure and recreational activities exhausting?","recommendedWording":null,"questionnaires":[55,111,246,345,381],"categories":[50,112],"createDate":"2017-02-21T15:22:40.933","updateDate":"2020-02-27T13:04:58.033"},"rank":100},{"type":"item","object":{"rank":100,"id":862,"code":"Q736","type":"question","description":"FA18 sleep long day","direction":"negative","underlyingIssue":"needing to sleep for long period during daytime","additionalInfo":"","preferredWording":"Have you had to sleep for long periods during daytime?","recommendedWording":null,"questionnaires":[55,111,246,381],"categories":[135,50],"createDate":"2017-02-21T15:25:42.14","updateDate":"2020-02-27T13:07:03.02"},"rank":100},{"type":"item","object":{"rank":100,"id":863,"code":"Q737","type":"question","description":"FA20 easily tired","direction":"negative","underlyingIssue":"becoming easily tired","additionalInfo":"","preferredWording":"Have you become easily tired?","recommendedWording":"Have you become easily tired?","questionnaires":[55,111,125,246,345,381,464],"categories":[50],"createDate":"2017-02-21T15:26:35.167","updateDate":"2020-02-27T13:07:47.653"},"rank":100},{"type":"item","object":{"rank":100,"id":864,"code":"Q738","type":"question","description":"FA21 problems sit tired","direction":"negative","underlyingIssue":"experiencing problems sitting up because of being tired","additionalInfo":"","preferredWording":"Have you had trouble sitting up because you were tired?","recommendedWording":null,"questionnaires":[55,111,246,381],"categories":[50,109],"createDate":"2017-02-21T15:27:07.443","updateDate":"2020-02-27T13:08:34.11"},"rank":100},{"type":"item","object":{"rank":100,"id":865,"code":"Q739","type":"question","description":"FA23 worn out","direction":"negative","underlyingIssue":"feeling worn out","additionalInfo":"","preferredWording":"Have you felt worn out?","recommendedWording":null,"questionnaires":[55,111,246,381],"categories":[50],"createDate":"2017-02-21T15:27:59.6","updateDate":"2020-02-27T13:09:07.213"},"rank":100},{"type":"item","object":{"rank":100,"id":866,"code":"Q740","type":"question","description":"FA24 long lack energy","direction":"negative","underlyingIssue":"feeling an overwhelming and prolonged lack of energy","additionalInfo":"","preferredWording":"Have you had a feeling of overwhelming and prolonged lack of energy?","recommendedWording":null,"questionnaires":[55,111,246,381,643],"categories":[50],"createDate":"2017-02-21T15:33:37.217","updateDate":"2020-02-27T13:09:40.783"},"rank":100},{"type":"item","object":{"rank":100,"id":867,"code":"Q741","type":"question","description":"FA25 problems finish tired","direction":"negative","underlyingIssue":"experiencing problems finishing things because of being tired","additionalInfo":"","preferredWording":"Have you had trouble finishing things because you were tired?","recommendedWording":null,"questionnaires":[55,111,246,345,381],"categories":[50],"createDate":"2017-02-21T15:36:08.92","updateDate":"2020-02-27T13:11:51.48"},"rank":100},{"type":"item","object":{"rank":100,"id":868,"code":"Q742","type":"question","description":"FA26 tired stairs","direction":"negative","underlyingIssue":"becoming tired from walking up the stairs","additionalInfo":"","preferredWording":"Have you become tired from walking up stairs?","recommendedWording":null,"questionnaires":[345,381,246,111,55],"categories":[50,103],"createDate":"2017-02-21T15:36:42.29","updateDate":"2020-02-27T14:04:25.313"},"rank":100},{"type":"item","object":{"rank":100,"id":869,"code":"Q743","type":"question","description":"FA28 need long rest","direction":"negative","underlyingIssue":"needing frequent or long periods of rest","additionalInfo":"","preferredWording":"Have you required frequent or long periods of rest?","recommendedWording":null,"questionnaires":[55,246,381,111],"categories":[50],"createDate":"2017-02-21T15:37:56.787","updateDate":"2020-02-27T14:05:16.433"},"rank":100},{"type":"item","object":{"rank":100,"id":870,"code":"Q744","type":"question","description":"FA30 tired duties","direction":"negative","underlyingIssue":"becoming tired from carrying out one\'s duties and responsibilities","additionalInfo":null,"preferredWording":"Have you become tired from carrying out your duties and responsibilities?","recommendedWording":null,"questionnaires":[55,111,246,381],"categories":[],"createDate":"2017-02-21T15:39:12.997","updateDate":"2017-02-21T15:39:12.997"},"rank":100},{"type":"item","object":{"rank":100,"id":871,"code":"Q745","type":"question","description":"FA31 extreme need rest","direction":"negative","underlyingIssue":"feeling an extreme need to rest","additionalInfo":"","preferredWording":"Have you had an extreme need for rest?","recommendedWording":null,"questionnaires":[55,111,246,345,381,605],"categories":[50],"createDate":"2017-02-21T15:40:43.34","updateDate":"2020-02-27T14:22:42.617"},"rank":100},{"type":"item","object":{"rank":100,"id":872,"code":"Q746","type":"question","description":"FA32 exhausted dress","direction":"negative","underlyingIssue":"becoming exhausted from dressing","additionalInfo":"","preferredWording":"Have you become exhausted from dressing?","recommendedWording":null,"questionnaires":[55,111,246,345,381],"categories":[50,2],"createDate":"2017-02-21T15:42:15.06","updateDate":"2020-02-27T14:23:22.24"},"rank":100},{"type":"item","object":{"rank":100,"id":873,"code":"Q747","type":"question","description":"FA33 tired long activity","direction":"negative","underlyingIssue":"feeling tired for a long time after physical activity","additionalInfo":"","preferredWording":"Have you felt tired for a long time after physical activity like taking a long walk?","recommendedWording":null,"questionnaires":[55,111,381,497,246,345],"categories":[50,111],"createDate":"2017-02-21T15:42:54.78","updateDate":"2020-02-27T14:24:15.997"},"rank":100},{"type":"item","object":{"rank":100,"id":874,"code":"Q748","type":"question","description":"FA34 exhausted shower","direction":"negative","underlyingIssue":"becoming exhausted from taking a shower","additionalInfo":"","preferredWording":"Have you become exhausted from taking a shower?","recommendedWording":null,"questionnaires":[55,111,246,345,381],"categories":[50,2],"createDate":"2017-02-21T15:43:23.203","updateDate":"2020-02-27T14:24:48.837"},"rank":100},{"type":"item","object":{"rank":100,"id":815,"code":"Q690","type":"question","description":"CF12 distracted read","direction":"negative","underlyingIssue":"experiencing problems reading and having to read the same lines again because of distraction","additionalInfo":"","preferredWording":"Have you been reading something and had to read the same lines again because you were distracted?","recommendedWording":null,"questionnaires":[53,111,381,544],"categories":[18],"createDate":"2017-02-20T15:36:16.647","updateDate":"2020-02-18T14:49:00.353"},"rank":100},{"type":"item","object":{"rank":100,"id":816,"code":"Q691","type":"question","description":"CF14 problems concentrate interested","direction":"negative","underlyingIssue":"experiencing problems maintaining concentration even in something really interesting","additionalInfo":"","preferredWording":"Have you had difficulty maintaining concentration even when something really interested you?","recommendedWording":null,"questionnaires":[53,111,377,381,450,544],"categories":[18],"createDate":"2017-02-20T15:37:59.783","updateDate":"2020-02-18T14:49:23.283"},"rank":100},{"type":"item","object":{"rank":100,"id":818,"code":"Q693","type":"question","description":"CF16 problems attention long period","direction":"negative","underlyingIssue":"experiencing problems paying attention to a task or a conversation for a longer period of time","additionalInfo":null,"preferredWording":"Have you had difficulty paying attention to a task or a conversation for a longer period of time?","recommendedWording":null,"questionnaires":[53,111,381,450,461,544],"categories":[],"createDate":"2017-02-20T15:39:43.937","updateDate":"2017-02-20T15:39:43.937"},"rank":100},{"type":"item","object":{"rank":100,"id":819,"code":"Q694","type":"question","description":"CF17 problems recognise","direction":"negative","underlyingIssue":"experiencing problems recognising close ones and people seen regularly","additionalInfo":"","preferredWording":"Have you had difficulty recognising relatives, friends, or other people you see regularly?","recommendedWording":null,"questionnaires":[53,111,381,544],"categories":[19,151],"createDate":"2017-02-20T15:40:44.42","updateDate":"2020-02-18T14:53:13.883"},"rank":100},{"type":"item","object":{"rank":100,"id":821,"code":"Q696","type":"question","description":"CF19 problems attention long","direction":"negative","underlyingIssue":"experiencing problems paying attention long enough","additionalInfo":null,"preferredWording":"Have you had difficulty paying attention for as long as you wanted or needed to?","recommendedWording":null,"questionnaires":[53,111,381,529,530,544],"categories":[],"createDate":"2017-02-20T15:42:35.67","updateDate":"2017-02-20T15:42:35.67"},"rank":100},{"type":"item","object":{"rank":100,"id":766,"code":"Q641","type":"question","description":"PF20 problems carry bag upstairs","direction":"negative","underlyingIssue":"experiencing problems carrying heavy item up the stairs","additionalInfo":"","preferredWording":"Do you have any trouble carrying a heavy bag upstairs?","recommendedWording":null,"questionnaires":[50,111,381,543],"categories":[105],"createDate":"2017-02-20T13:46:44.677","updateDate":"2020-03-04T16:02:38.14"},"rank":100},{"type":"item","object":{"rank":100,"id":767,"code":"Q642","type":"question","description":"PF21 need help wash face hands","direction":"negative","underlyingIssue":"needing help washing one\'s face and hands","additionalInfo":"","preferredWording":"Do you need help washing your face and hands?","recommendedWording":null,"questionnaires":[50,111,381],"categories":[101,2],"createDate":"2017-02-20T13:47:38.437","updateDate":"2020-03-05T10:16:55.09"},"rank":100},{"type":"item","object":{"rank":100,"id":824,"code":"Q699","type":"question","description":"CF22 distracted task finish","direction":"negative","underlyingIssue":"becoming distracted from a task before finishing it","additionalInfo":"","preferredWording":"Have you become distracted from a task before finishing it?","recommendedWording":null,"questionnaires":[53,111,381,544],"categories":[18],"createDate":"2017-02-20T15:46:15.067","updateDate":"2020-02-18T15:01:33.863"},"rank":100},{"type":"item","object":{"rank":100,"id":827,"code":"Q702","type":"question","description":"CF25 problems remember message","direction":"negative","underlyingIssue":"experiencing problems remembering to pass on a message or remind someone of something","additionalInfo":"","preferredWording":"Have you had difficulty remembering to pass on a message or remind someone of something?","recommendedWording":null,"questionnaires":[53,111,381,544],"categories":[19],"createDate":"2017-02-21T09:33:58.91","updateDate":"2020-02-18T15:06:48.827"},"rank":100},{"type":"item","object":{"rank":100,"id":828,"code":"Q703","type":"question","description":"CF26 problems focus important","direction":"negative","underlyingIssue":"experiencing problems maintaining concentration even when doing something important","additionalInfo":"","preferredWording":"Have you had difficulty maintaining concentration even when doing something important?","recommendedWording":null,"questionnaires":[53,111,381,544],"categories":[18],"createDate":"2017-02-21T09:45:00.56","updateDate":"2020-02-18T15:07:26.72"},"rank":100},{"type":"item","object":{"rank":100,"id":835,"code":"Q710","type":"question","description":"CF33 forget routine","direction":"negative","underlyingIssue":"forgetting to do routine tasks","additionalInfo":"","preferredWording":"Have you forgotten to do routine things such as turning off the light or locking the door?","recommendedWording":null,"questionnaires":[53,111,381,544],"categories":[19],"createDate":"2017-02-21T11:54:57.297","updateDate":"2020-02-18T15:21:33.847"},"rank":100},{"type":"item","object":{"rank":100,"id":836,"code":"Q711","type":"question","description":"CF34 problems focus task","direction":"negative","underlyingIssue":"experiencing problems staying focused on a task or an activity","additionalInfo":"","preferredWording":"Have you had difficulty staying focused on a task or an activity?","recommendedWording":null,"questionnaires":[53,111,381,392,544],"categories":[18],"createDate":"2017-02-21T11:55:39.217","updateDate":"2020-02-18T15:22:05.92"},"rank":100},{"type":"item","object":{"rank":100,"id":841,"code":"Q716","type":"question","description":"SF05 PC/MT interest social","direction":"negative","underlyingIssue":"losing interest in social activities with other people as a result of the physical condition or medical treatment","additionalInfo":null,"preferredWording":"As a result of your physical condition or medical treatment, have you felt you were no longer interested in social activities with other people?","recommendedWording":null,"questionnaires":[54,111,381],"categories":[],"createDate":"2017-02-21T13:48:22.05","updateDate":"2017-02-21T13:48:22.05"},"rank":100},{"type":"item","object":{"rank":100,"id":839,"code":"Q714","type":"question","description":"SF03 PC/MT alone","direction":"negative","underlyingIssue":"preferring to spend time alone as a result of the physical condition or medical treatment","additionalInfo":null,"preferredWording":"As a result of your physical condition or medical treatment, have you preferred to spend time alone?","recommendedWording":null,"questionnaires":[54,111,381],"categories":[],"createDate":"2017-02-21T13:45:10.533","updateDate":"2017-02-21T13:45:10.533"},"rank":100},{"type":"item","object":{"rank":100,"id":844,"code":"Q719","type":"question","description":"SF08 PC/MT isolated","direction":"negative","underlyingIssue":"feeling isolated from one\'s family or friends as a result of the physical condition or medical treatment","additionalInfo":"","preferredWording":"As a result of your physical condition or medical treatment, have you felt isolated from your family or friends?","recommendedWording":null,"questionnaires":[54,111,381],"categories":[],"createDate":"2017-02-21T14:34:03.27","updateDate":"2017-02-21T14:35:44.507"},"rank":100},{"type":"item","object":{"rank":100,"id":876,"code":"Q750","type":"question","description":"PA02 problems pain jobs house","direction":"negative","underlyingIssue":"experiencing problems doing the usual jobs around the house because of pain","additionalInfo":"","preferredWording":"Has pain made it difficult for you to do the jobs that you usually do around the house?","recommendedWording":null,"questionnaires":[56,111,233,381],"categories":[],"createDate":"2017-03-07T14:28:11.797","updateDate":"2017-10-11T10:07:24.97"},"rank":100},{"type":"item","object":{"rank":100,"id":969,"code":"Q843","type":"question","description":"DI13 limit social DI","direction":"negative","underlyingIssue":"having to limit one\'s social activities due to diarrhea","additionalInfo":null,"preferredWording":"Have you had to limit your social activities because of diarrhoea?","recommendedWording":null,"questionnaires":[62,111,263,381],"categories":[],"createDate":"2017-03-28T14:27:56.533","updateDate":"2017-03-28T14:27:56.533"},"rank":100},{"type":"item","object":{"rank":100,"id":970,"code":"Q844","type":"question","description":"FI02 extra expenses difficult pay","direction":"negative","underlyingIssue":"having extra expenses that were difficult to pay as a result of physical condition or medical treatment","additionalInfo":"","preferredWording":"As a result of your physical condition or medical treatment, have you had extra expenses you had difficulties paying?","recommendedWording":null,"questionnaires":[63,111,272,381],"categories":[51],"createDate":"2017-03-28T14:37:36.17","updateDate":"2020-02-27T14:29:08.39"},"rank":100},{"type":"item","object":{"rank":100,"id":971,"code":"Q845","type":"question","description":"FI03 extra expenses","direction":"negative","underlyingIssue":"having extra expenses as a result of physical condition or medical treatment","additionalInfo":"","preferredWording":"As a result of your physical condition or medical treatment, have you had any extra expenses (e.g., for medication, transport, aids)?","recommendedWording":null,"questionnaires":[63,111,272,311,381],"categories":[51],"createDate":"2017-03-28T14:46:46.633","updateDate":"2020-02-27T14:29:38.123"},"rank":100},{"type":"item","object":{"rank":100,"id":972,"code":"Q846","type":"question","description":"FI04 lack money basic","direction":"negative","underlyingIssue":"lacking money to buy basic things as a result of physical condition or medical treatment","additionalInfo":"","preferredWording":"As a result of your physical condition or medical treatment, have you lacked money to buy basic things like food or clothes?","recommendedWording":null,"questionnaires":[63,273,381,111,272],"categories":[51],"createDate":"2017-03-28T14:47:42.92","updateDate":"2020-02-27T14:30:03.503"},"rank":100},{"type":"item","object":{"rank":100,"id":973,"code":"Q847","type":"question","description":"FI05 debt","direction":"negative","underlyingIssue":"being in debt as a result of physical condition or medical treatment","additionalInfo":"","preferredWording":"As a result of your physical condition or medical treatment, have you found yourself in debt?","recommendedWording":null,"questionnaires":[63,111,272,381],"categories":[51],"createDate":"2017-03-28T14:48:30.347","updateDate":"2020-02-27T14:30:34.343"},"rank":100},{"type":"item","object":{"rank":100,"id":974,"code":"Q848","type":"question","description":"FI06 change life finances","direction":"negative","underlyingIssue":"changing one\'s lifestyle because of financial difficulties as a result of physical condition or medical treatment","additionalInfo":"","preferredWording":"Has your physical condition or medical treatment caused you financial difficulties leading to changes in your lifestyle?","recommendedWording":null,"questionnaires":[63,111,272,311,381],"categories":[51],"createDate":"2017-03-28T14:49:55.9","updateDate":"2020-02-27T14:31:05.64"},"rank":100},{"type":"item","object":{"rank":100,"id":975,"code":"Q849","type":"question","description":"FI07 less money","direction":"negative","underlyingIssue":"having less money to spend on oneself as a result of physical condition or medical treatment","additionalInfo":"","preferredWording":"As a result of your physical condition or medical treatment, have you had less money to spend on yourself (e.g., for buying yourself something that you would like to have but don’t necessarily need)?","recommendedWording":null,"questionnaires":[63,111,272,381],"categories":[51],"createDate":"2017-03-28T14:50:55.72","updateDate":"2020-02-27T14:31:36.307"},"rank":100},{"type":"item","object":{"rank":100,"id":976,"code":"Q850","type":"question","description":"FI08 problems pay regular expenses","direction":"negative","underlyingIssue":"experiencing problems paying regular expenses as a result of physical condition or medical treatment","additionalInfo":"","preferredWording":"As a result of your physical condition or medical treatment, have you had difficulties paying any of your regular expenses (e.g. rent, insurance, phone)?","recommendedWording":null,"questionnaires":[63,111,272,381],"categories":[51],"createDate":"2017-03-28T14:52:12.643","updateDate":"2020-02-27T14:32:08.303"},"rank":100},{"type":"item","object":{"rank":100,"id":977,"code":"Q851","type":"question","description":"FI09 borrow sell","direction":"negative","underlyingIssue":"having to borrow money or sell personal belongings as a result of physical condition or medical treatment","additionalInfo":"","preferredWording":"As a result of your physical condition or medical treatment, have you had to borrow money or sell personal belongings?","recommendedWording":null,"questionnaires":[63,111,272,381],"categories":[51],"createDate":"2017-03-28T14:53:06.407","updateDate":"2020-02-27T14:32:33.933"},"rank":100},{"type":"item","object":{"rank":100,"id":984,"code":"SS7","type":"symptomScale","description":"arm","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Arm symptoms - scale","recommendedWording":null,"questionnaires":[5],"categories":[],"createDate":"2017-05-03T15:20:16.95","updateDate":"2018-01-05T16:22:59.01"},"rank":100},{"type":"item","object":{"rank":100,"id":1109,"code":"Q860","type":"question","description":"aware care treatment","direction":"positive","underlyingIssue":"HCPs being aware of the care and treatment patient received previously","additionalInfo":"","preferredWording":"Their awareness of the care and treatment you received previously?","recommendedWording":null,"questionnaires":[90,111,167,361,379,381,618,462,582,597,598,599,612],"categories":[126],"createDate":"2017-08-31T12:03:08.517","updateDate":"2020-03-11T10:18:17.41"},"rank":100},{"type":"item","object":{"rank":100,"id":1110,"code":"Q861","type":"question","description":"attention physical symptoms","direction":"positive","underlyingIssue":"HCPs paying attention to physical symptoms","additionalInfo":"","preferredWording":"The attention they gave to your physical symptoms?","recommendedWording":null,"questionnaires":[597,598,599,612,618,582,462,379,381,90,111,167],"categories":[126],"createDate":"2017-08-31T12:04:40.297","updateDate":"2020-03-11T10:18:40.967"},"rank":100},{"type":"item","object":{"rank":100,"id":1111,"code":"Q862","type":"question","description":"thorough treating physical symptoms","direction":"positive","underlyingIssue":"HCPs treating physical symptoms thoroughly","additionalInfo":"","preferredWording":"Their thoroughness in treating your physical symptoms?","recommendedWording":null,"questionnaires":[90,111,167,598,599,612,618,379,381,462,582,597],"categories":[126],"createDate":"2017-08-31T12:05:37.097","updateDate":"2020-03-11T10:19:05.863"},"rank":100},{"type":"item","object":{"rank":100,"id":1112,"code":"Q863","type":"question","description":"information tests treatment","direction":"positive","underlyingIssue":"HCPs giving information about medical tests and treatment","additionalInfo":"","preferredWording":"The information they gave you about your medical tests and treatment?","recommendedWording":null,"questionnaires":[90,111,167,329,330,361,598,599,612,618,365,379,381,462,582,597],"categories":[125],"createDate":"2017-08-31T12:16:39.463","updateDate":"2020-03-11T10:19:34.427"},"rank":100},{"type":"item","object":{"rank":100,"id":1113,"code":"Q864","type":"question","description":"attention opinion choice","direction":"positive","underlyingIssue":"HCPs paying attention to patient\'s opinion about the choice of treatment","additionalInfo":"","preferredWording":"The attention they gave to your opinion about the choice of your treatment (in case of possible choices)?","recommendedWording":null,"questionnaires":[90,111,167,379,381,612,618,462,582,597,598,599],"categories":[126],"createDate":"2017-08-31T12:17:54.58","updateDate":"2020-03-11T10:20:39.12"},"rank":100},{"type":"item","object":{"rank":100,"id":1114,"code":"Q865","type":"question","description":"interest person","direction":"positive","underlyingIssue":"HCPs showing interest in patient as a person","additionalInfo":"","preferredWording":"The interest they showed in you as a person?","recommendedWording":null,"questionnaires":[599,612,618,597,598,582,462,361,379,381,167,90,111],"categories":[126],"createDate":"2017-08-31T12:18:47.403","updateDate":"2020-03-11T10:21:07.183"},"rank":100},{"type":"item","object":{"rank":100,"id":1118,"code":"Q866","type":"question","description":"information care treatment","direction":"positive","underlyingIssue":"HCPs providing information about care and treatment","additionalInfo":"","preferredWording":"The information they gave you about your care and treatment?","recommendedWording":null,"questionnaires":[90,111,167,261,330,361,597,598,599,612,618,365,379,381,462,513,582],"categories":[125],"createDate":"2017-08-31T12:27:41.297","updateDate":"2020-03-11T10:21:40.817"},"rank":100},{"type":"item","object":{"rank":100,"id":1119,"code":"Q867","type":"question","description":"advice manage symptoms","direction":"positive","underlyingIssue":"HCPs providing advice on managing physical symptoms","additionalInfo":"","preferredWording":"The advice they gave you on managing your physical symptoms?","recommendedWording":null,"questionnaires":[90,111,582,598,599,612,618,381,462,167,330,379],"categories":[126],"createDate":"2017-08-31T12:29:25.883","updateDate":"2020-03-11T10:22:22.017"},"rank":100},{"type":"item","object":{"rank":100,"id":1120,"code":"Q868","type":"question","description":"prompt answer requests","direction":"positive","underlyingIssue":"HCPs answering requests promptly","additionalInfo":"","preferredWording":"Their promptness in answering your specific requests?","recommendedWording":null,"questionnaires":[90,111,167,361,379,618,381,462,582,598,599,612],"categories":[126],"createDate":"2017-08-31T12:30:38.363","updateDate":"2020-03-11T10:22:41.657"},"rank":100},{"type":"item","object":{"rank":100,"id":1122,"code":"Q869","type":"question","description":"ease recognise roles HCPs","direction":"positive","underlyingIssue":"being able to recognise roles and responsibilities of HCPs easily","additionalInfo":"","preferredWording":"The ease of recognizing the roles and responsibilities of the different caregivers (doctors, nurses, physiotherapists, psychologists, etc.) involved in your care?","recommendedWording":null,"questionnaires":[90,111,167,325,330,361,612,618,379,381,462,582,598,599],"categories":[124],"createDate":"2017-08-31T12:33:22.577","updateDate":"2020-03-11T10:23:08.193"},"rank":100},{"type":"item","object":{"rank":100,"id":1123,"code":"Q870","type":"question","description":"HCPs work team","direction":"positive","underlyingIssue":"HCPs involved in patient\'s care working as a team","additionalInfo":"","preferredWording":"The way doctors, nurses and other caregivers involved in your care seem to work together as a team?","recommendedWording":null,"questionnaires":[90,111,167,276,325,582,598,599,612,618,330,361,365,379,381,462],"categories":[126],"createDate":"2017-08-31T12:38:02.463","updateDate":"2020-03-11T10:24:05.757"},"rank":100},{"type":"item","object":{"rank":100,"id":1124,"code":"Q871","type":"question","description":"information care services community","direction":"positive","underlyingIssue":"exchanging information with other care services in the community","additionalInfo":"","preferredWording":"The exchange of information with other care services in the community (general practitioner, home care, nursing house, social services, etc.)?","recommendedWording":null,"questionnaires":[90,111,167,325,598,599,612,618,361,379,381,462,582],"categories":[125],"createDate":"2017-08-31T12:39:26.877","updateDate":"2020-03-11T10:24:47.097"},"rank":100},{"type":"item","object":{"rank":100,"id":1125,"code":"Q872","type":"question","description":"information schedule test","direction":"positive","underlyingIssue":"providing information on the scheduling of medical tests, treatment or care","additionalInfo":"","preferredWording":"The information provided on the scheduling of medical tests, treatment or care?","recommendedWording":null,"questionnaires":[90,462,582,598,599,612,618,365,379,381,111,167,311,329,361],"categories":[125],"createDate":"2017-08-31T12:41:03.897","updateDate":"2020-03-11T10:25:11.543"},"rank":100},{"type":"item","object":{"rank":100,"id":1126,"code":"Q873","type":"question","description":"information support service","direction":"positive","underlyingIssue":"providing information on other supportive services","additionalInfo":"","preferredWording":"The information provided on the overall supportive services available (social, psychological, physiotherapy, dietitian services, support group, etc.)?","recommendedWording":null,"questionnaires":[612,618,582,598,599,462,330,361,379,381,325,90,111,167],"categories":[125],"createDate":"2017-08-31T12:42:34.957","updateDate":"2020-03-11T10:25:38.11"},"rank":100},{"type":"item","object":{"rank":100,"id":1127,"code":"Q874","type":"question","description":"information improve prevent","direction":"positive","underlyingIssue":"HCPs providing information on ways to improve health or prevent illness","additionalInfo":"","preferredWording":"The information provided by doctors, nurses and other caregivers on things you could do to improve your health or prevent illness?","recommendedWording":null,"questionnaires":[90,111,167,330,598,599,612,618,379,381,462,492,582],"categories":[125],"createDate":"2017-08-31T12:44:03.32","updateDate":"2020-03-11T10:25:59.7"},"rank":100},{"type":"item","object":{"rank":100,"id":1128,"code":"Q875","type":"question","description":"wait time test treatment","direction":"positive","underlyingIssue":"feeling satisfied with waiting time for undergoing medical tests/treatments","additionalInfo":"","preferredWording":"The waiting time for undergoing medical tests and/or treatments?","recommendedWording":null,"questionnaires":[90,111,167,330,361,365,618,379,381,462,582,598,612],"categories":[124],"createDate":"2017-08-31T12:46:45.407","updateDate":"2020-03-11T10:26:40.68"},"rank":100},{"type":"item","object":{"rank":100,"id":1129,"code":"Q876","type":"question","description":"privacy examine treat","direction":"positive","underlyingIssue":"feeling satisfied with the privacy given when being examined or treated","additionalInfo":"","preferredWording":"The privacy given when you were examined or treated?","recommendedWording":null,"questionnaires":[90,111,167,379,381,462,582,598,612],"categories":[124],"createDate":"2017-08-31T12:48:26.11","updateDate":"2020-03-11T10:27:14.44"},"rank":100},{"type":"item","object":{"rank":100,"id":1130,"code":"Q877","type":"question","description":"family involved care","direction":"positive","underlyingIssue":"feeling satisfied with the opportunity for the family/close ones to be involved in care","additionalInfo":"","preferredWording":"The opportunity for your family or those close to you to be involved in your care (talking to doctors, receiving disease and care information, etc.)?","recommendedWording":null,"questionnaires":[90,111,167,311,321,379,618,381,462,582,598,599,612],"categories":[124,49],"createDate":"2017-08-31T12:50:08.247","updateDate":"2020-03-11T10:27:50.413"},"rank":100},{"type":"item","object":{"rank":100,"id":1134,"code":"Q878","type":"question","description":"see same HCPs outpatient","direction":"positive","underlyingIssue":"feeling satisfied with the opportunity to see the same HCPs when coming to the outpatient clinic","additionalInfo":"","preferredWording":"The opportunity to see the same caregivers when you come to the outpatient clinic?","recommendedWording":null,"questionnaires":[91,111,361,381,598,599,618],"categories":[124],"createDate":"2017-08-31T13:20:00.883","updateDate":"2020-03-11T10:28:10.77"},"rank":100},{"type":"item","object":{"rank":100,"id":1135,"code":"Q879","type":"question","description":"arrange appointment","direction":"positive","underlyingIssue":"feeling satisfied with the ease of arranging medical appointments at convenient times","additionalInfo":"","preferredWording":"The ease of arranging medical appointments at convenient times?","recommendedWording":null,"questionnaires":[91,111,618,381,598,599,327,361],"categories":[124],"createDate":"2017-08-31T13:21:05.72","updateDate":"2020-03-11T10:30:43.777"},"rank":100},{"type":"item","object":{"rank":100,"id":1136,"code":"Q880","type":"question","description":"waiting time obtain appointment","direction":"positive","underlyingIssue":"feeling satisfied with the waiting time before obtaining a medical appointment","additionalInfo":"","preferredWording":"The waiting time before obtaining a medical appointment?","recommendedWording":null,"questionnaires":[91,111,381,598,618],"categories":[124],"createDate":"2017-08-31T13:22:00.85","updateDate":"2020-03-11T10:31:53.26"},"rank":100},{"type":"item","object":{"rank":100,"id":1137,"code":"Q881","type":"question","description":"communicate hospital home","direction":"positive","underlyingIssue":"feeling satisfied with the ease of communicating with the hospital services from home","additionalInfo":"","preferredWording":"The ease of communicating with the hospital services from home?","recommendedWording":null,"questionnaires":[91,111,168,381,598,599,618],"categories":[125],"createDate":"2017-08-31T13:23:09.837","updateDate":"2020-03-11T10:32:35.05"},"rank":100},{"type":"item","object":{"rank":100,"id":1138,"code":"Q882","type":"question","description":"information should do after hospital","direction":"positive","underlyingIssue":"feeling satisfied with the information provided on what to do/not do after leaving the hospital appointment","additionalInfo":"","preferredWording":"The information provided about what you should/should not do after you leave your hospital appointment?","recommendedWording":null,"questionnaires":[91,111,361,381,598,599],"categories":[125],"createDate":"2017-08-31T13:25:42.923","updateDate":"2020-03-11T10:33:09.153"},"rank":100},{"type":"item","object":{"rank":100,"id":1139,"code":"Q883","type":"question","description":"information contact hospital","direction":"positive","underlyingIssue":"feeling satisfied with the information on who to contact in case of worries after leaving the hospital appointment","additionalInfo":"","preferredWording":"The information on who to contact if you are worried after you leave your hospital appointment?","recommendedWording":null,"questionnaires":[91,598,599,618,361,381,111,168,327],"categories":[125],"createDate":"2017-08-31T13:27:12.5","updateDate":"2020-03-11T10:33:47.14"},"rank":100},{"type":"item","object":{"rank":100,"id":1140,"code":"Q884","type":"question","description":"provision follow up after treatment","direction":"positive","underlyingIssue":"feeling satisfied with the provision of follow-up after treatment","additionalInfo":"","preferredWording":"The provision of follow-up by the different caregivers (doctors, nurses, physiotherapists, psychologists, etc.) after treatment?","recommendedWording":null,"questionnaires":[91,111,327,361,381,598,599,618],"categories":[126],"createDate":"2017-08-31T13:29:08.867","updateDate":"2020-03-11T10:34:08.9"},"rank":100},{"type":"item","object":{"rank":100,"id":1141,"code":"Q885","type":"question","description":"problem swallowing liquid","direction":"negative","underlyingIssue":"experiencing problems swallowing liquids","additionalInfo":"","preferredWording":"Have you had problems swallowing liquids?","recommendedWording":"Have you had problems swallowing liquids?","questionnaires":[9,43,111,187,580,430,497,503,508,517,533,231,232,279,381,394],"categories":[92,33],"createDate":"2017-09-21T13:21:48.777","updateDate":"2020-03-11T10:34:39.15"},"rank":100},{"type":"item","object":{"rank":100,"id":1142,"code":"Q886","type":"question","description":"problem swallow solid food","direction":"negative","underlyingIssue":"experiencing problems swallowing solid foods","additionalInfo":"","preferredWording":"Have you had problems swallowing solid foods?","recommendedWording":"Have you had problems swallowing solid foods?","questionnaires":[9,43,111,546,579,580,511,517,528,531,532,533,394,430,497,503,508,231,232,269,279,381],"categories":[92,33],"createDate":"2017-09-21T13:23:31.507","updateDate":"2020-03-11T10:35:06.09"},"rank":100},{"type":"item","object":{"rank":100,"id":1143,"code":"Q887","type":"question","description":"problem pureed food","direction":"negative","underlyingIssue":"experiencing problems swallowing pureed food","additionalInfo":"","preferredWording":"Have you had problems swallowing pureed food?","recommendedWording":"Have you had problems swallowing pureed food?","questionnaires":[9,43,111,231,580,394,430,503,508,517,533,232,279,381],"categories":[92,33],"createDate":"2017-09-21T13:24:28.76","updateDate":"2020-03-11T10:35:30.677"},"rank":100},{"type":"item","object":{"rank":100,"id":1144,"code":"Q888","type":"question","description":"pain genital area","direction":"negative","underlyingIssue":"experiencing pain in the genital area","additionalInfo":null,"preferredWording":"Have you had pain in your genital area?","recommendedWording":null,"questionnaires":[111,114,128,284,381,590],"categories":[],"createDate":"2017-10-03T16:25:05.827","updateDate":"2017-10-03T16:25:05.827"},"rank":100},{"type":"item","object":{"rank":100,"id":1145,"code":"Q889","type":"question","description":"itchy irritated skin genital area","direction":"negative","underlyingIssue":"having itchy or irritated skin in the genital area","additionalInfo":"","preferredWording":"Have you had itchy or irritated skin in your genital area?","recommendedWording":null,"questionnaires":[111,114,590,284,381],"categories":[113,24],"createDate":"2017-10-03T16:26:02.55","updateDate":"2020-03-11T10:36:32.297"},"rank":100},{"type":"item","object":{"rank":100,"id":1146,"code":"Q890","type":"question","description":"sore skin genital area","direction":"negative","underlyingIssue":"having sore skin in the genital area","additionalInfo":"","preferredWording":"Have you had sore skin in your genital area?","recommendedWording":null,"questionnaires":[381,284,111,114],"categories":[113,28],"createDate":"2017-10-03T16:26:52.457","updateDate":"2020-03-11T10:37:37.69"},"rank":100},{"type":"item","object":{"rank":100,"id":1147,"code":"Q891","type":"question","description":"tear split skin genital area","direction":"negative","underlyingIssue":"having tearing or splitting of the skin in the genital area","additionalInfo":"","preferredWording":"Have you had tearing or splitting of the skin in your genital area?","recommendedWording":null,"questionnaires":[111,114,284,381,590],"categories":[113,22],"createDate":"2017-10-03T16:27:40.447","updateDate":"2020-03-11T10:38:10.343"},"rank":100},{"type":"item","object":{"rank":100,"id":1148,"code":"Q892","type":"question","description":"narrow tight vaginal entrance","direction":"negative","underlyingIssue":"having narrowing and/or tightness of the vaginal entrance","additionalInfo":"","preferredWording":"Have you had narrowing/tightness of your vaginal entrance?","recommendedWording":null,"questionnaires":[111,114,284,381],"categories":[120],"createDate":"2017-10-03T16:28:41.833","updateDate":"2020-03-11T10:39:10.73"},"rank":100},{"type":"item","object":{"rank":100,"id":1149,"code":"Q893","type":"question","description":"problem scar genital area","direction":"negative","underlyingIssue":"experiencing problems because of scarring in the genital area","additionalInfo":"","preferredWording":"Has scarring in your genital area caused you problems?","recommendedWording":null,"questionnaires":[381,284,111,114],"categories":[113],"createDate":"2017-10-03T16:29:26.607","updateDate":"2020-03-11T10:40:04.08"},"rank":100},{"type":"item","object":{"rank":100,"id":1150,"code":"Q894","type":"question","description":"problem sit genital area","direction":"negative","underlyingIssue":"experiencing problems sitting because of the genital area issues","additionalInfo":"","preferredWording":"Have you had difficulties sitting due to problems in your genital area?","recommendedWording":null,"questionnaires":[111,114,284,381,590],"categories":[113,109],"createDate":"2017-10-03T16:30:19.213","updateDate":"2020-03-11T10:40:34.983"},"rank":100},{"type":"item","object":{"rank":100,"id":1151,"code":"Q895","type":"question","description":"discharge vagina genital area","direction":"negative","underlyingIssue":"having unpleasant discharge from the vagina or genital area","additionalInfo":"","preferredWording":"Have you had unpleasant discharge from your vagina or genital area?","recommendedWording":null,"questionnaires":[111,114,128,284,381,590],"categories":[117],"createDate":"2017-10-03T16:31:06.797","updateDate":"2020-03-11T10:40:59.307"},"rank":100},{"type":"item","object":{"rank":100,"id":1152,"code":"Q896","type":"question","description":"swelling genital area","direction":"negative","underlyingIssue":"having swelling in the genital area","additionalInfo":"","preferredWording":"Have you had swelling in the genital area?","recommendedWording":null,"questionnaires":[111,114,128,284,381,463,521,522],"categories":[113,38],"createDate":"2017-10-05T13:05:25.123","updateDate":"2020-03-11T10:41:34.093"},"rank":100},{"type":"item","object":{"rank":100,"id":1153,"code":"Q897","type":"question","description":"tight skin genital area","direction":"negative","underlyingIssue":"experiencing skin tightness in the genital area","additionalInfo":"","preferredWording":"Has the skin felt tight in your genital area?","recommendedWording":null,"questionnaires":[111,114,284,381,463,521,522],"categories":[113,22],"createDate":"2017-10-05T13:11:59.6","updateDate":"2020-03-11T10:42:07.93"},"rank":100},{"type":"item","object":{"rank":100,"id":1154,"code":"Q898","type":"question","description":"swelling groin","direction":"negative","underlyingIssue":"having swelling in the groin","additionalInfo":"","preferredWording":"Have you had swelling in your groin?","recommendedWording":null,"questionnaires":[111,114,128,284,381,463,521,522],"categories":[38,113],"createDate":"2017-10-05T13:12:32.813","updateDate":"2020-03-11T10:42:40.363"},"rank":100},{"type":"item","object":{"rank":100,"id":1157,"code":"Q901","type":"question","description":"tight skin legs","direction":"negative","underlyingIssue":"experiencing skin tightness in one or both legs","additionalInfo":"","preferredWording":"Has the skin felt tight in your leg(s)?","recommendedWording":null,"questionnaires":[521,522,463,284,381,111,114],"categories":[22],"createDate":"2017-10-05T13:15:32.127","updateDate":"2020-03-11T10:47:23.377"},"rank":100},{"type":"item","object":{"rank":100,"id":1159,"code":"Q903","type":"question","description":"urine catheter stoma bag","direction":"none","underlyingIssue":"presence of a urine catheter or a urine stoma bag","additionalInfo":"","preferredWording":"Do you have a urine catheter or a urine stoma bag (artificial bladder)?","recommendedWording":null,"questionnaires":[111,114,284,381],"categories":[142,85],"createDate":"2017-10-05T13:21:24.39","updateDate":"2020-03-11T10:48:13.267"},"rank":100},{"type":"item","object":{"rank":100,"id":1160,"code":"Q904","type":"question","description":"narrow tight vagina sex","direction":"negative","underlyingIssue":"having a feeling that the vagina is narrow/tight during sexual intercourse/sexual activity","additionalInfo":"","preferredWording":"Has your vagina felt narrow and/or tight during sexual intercourse or other sexual activity?","recommendedWording":null,"questionnaires":[111,114,284,381],"categories":[120,133],"createDate":"2017-10-05T13:27:32.407","updateDate":"2020-03-11T10:50:13.543"},"rank":100},{"type":"item","object":{"rank":100,"id":1161,"code":"IN35","type":"instructions","description":"genital area relate","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Some of these relate to the genital area.","recommendedWording":null,"questionnaires":[114,521],"categories":[],"createDate":"2017-10-05T14:34:01.17","updateDate":"2017-10-05T14:34:01.17"},"rank":100},{"type":"item","object":{"rank":100,"id":1162,"code":"IN36","type":"instructions","description":"surgery genital area symptoms problems","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Whether or not you have had surgery in your genital area, please indicate the extent to which you have experienced these symptoms or problems.","recommendedWording":null,"questionnaires":[521,114],"categories":[],"createDate":"2017-10-05T14:34:37.907","updateDate":"2017-10-05T14:34:37.907"},"rank":100},{"type":"item","object":{"rank":100,"id":881,"code":"Q755","type":"question","description":"PA07 pain concentrate work","direction":"negative","underlyingIssue":"pain limiting the ability to concentrate on work or other daily activities","additionalInfo":"","preferredWording":"Has pain limited your ability to concentrate on work or other daily activities?","recommendedWording":null,"questionnaires":[56,111,233,381],"categories":[],"createDate":"2017-03-07T14:35:49.73","updateDate":"2017-10-11T10:21:21.547"},"rank":100},{"type":"item","object":{"rank":100,"id":883,"code":"Q757","type":"question","description":"PA09 pain interfere leisure","direction":"negative","underlyingIssue":"pain interfering with leisure activities","additionalInfo":null,"preferredWording":"Has pain interfered with your leisure activities (e.g. sports and hobbies)?","recommendedWording":null,"questionnaires":[56,111,233,381],"categories":[],"createDate":"2017-03-07T14:39:46.91","updateDate":"2017-03-07T14:39:46.91"},"rank":100},{"type":"item","object":{"rank":100,"id":996,"code":"SS19","type":"symptomScale","description":"hair loss alopecia","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Alopecia - symptom single","recommendedWording":null,"questionnaires":[15,32,37,38],"categories":[],"createDate":"2017-05-03T16:03:17.71","updateDate":"2018-01-09T15:31:58.467"},"rank":100},{"type":"item","object":{"rank":100,"id":1021,"code":"SS43","type":"symptomScale","description":"abdominal pain","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Abdominal pain - single item","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2017-05-05T10:18:58.73","updateDate":"2018-01-09T15:50:18.903"},"rank":100},{"type":"item","object":{"rank":100,"id":1034,"code":"SS56","type":"symptomScale","description":"sexual activity","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Sexual Activity - functional scale","recommendedWording":null,"questionnaires":[1,34,38],"categories":[],"createDate":"2017-05-05T10:49:56.45","updateDate":"2018-01-09T16:05:32.863"},"rank":100},{"type":"item","object":{"rank":100,"id":1089,"code":"SS111","type":"symptomScale","description":"AP","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Appetite loss - single item","recommendedWording":null,"questionnaires":[4,46],"categories":[],"createDate":"2017-05-05T16:30:10.313","updateDate":"2017-05-05T16:30:10.313"},"rank":100},{"type":"item","object":{"rank":100,"id":1093,"code":"Q852","type":"question","description":"leak stools mucus anus","direction":"negative","underlyingIssue":"having leakage of stools or mucus from the anal opening","additionalInfo":"","preferredWording":"Have you had leakage of stools or mucus from your anal opening (back passage)?","recommendedWording":null,"questionnaires":[89,111,117,197,312,381,404,699],"categories":[12],"createDate":"2017-08-30T12:11:11.847","updateDate":"2020-03-11T10:12:14.163"},"rank":100},{"type":"item","object":{"rank":100,"id":1050,"code":"SS72","type":"symptomScale","description":"INFOMEDT","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Information about Medical Tests - information scale","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2017-05-05T15:32:54.863","updateDate":"2017-05-05T15:32:54.863"},"rank":100},{"type":"item","object":{"rank":100,"id":1051,"code":"SS73","type":"symptomScale","description":"INFOTREAT","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Information about Treatments - information scale","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2017-05-05T15:34:42.243","updateDate":"2017-05-05T15:34:42.243"},"rank":100},{"type":"item","object":{"rank":100,"id":1052,"code":"SS74","type":"symptomScale","description":"INFOTHSE","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Information about Other Services - information scale","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2017-05-05T15:35:14.177","updateDate":"2017-05-05T15:35:14.177"},"rank":100},{"type":"item","object":{"rank":100,"id":1053,"code":"SS75","type":"symptomScale","description":"INFODIFP","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Information about Different Places of Care - information single","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2017-05-05T15:36:19","updateDate":"2017-05-05T15:36:19"},"rank":100},{"type":"item","object":{"rank":100,"id":1054,"code":"SS76","type":"symptomScale","description":"INFOHELP","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Information about Things You Can Do to Help Yourself - information single","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2017-05-05T15:36:59.497","updateDate":"2017-05-05T15:36:59.497"},"rank":100},{"type":"item","object":{"rank":100,"id":1068,"code":"SS90","type":"symptomScale","description":"pain arm shoulder","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Pain in Arm or Shoulder - symptom single","recommendedWording":null,"questionnaires":[37],"categories":[],"createDate":"2017-05-05T15:48:49.49","updateDate":"2018-01-09T16:20:40.24"},"rank":100},{"type":"item","object":{"rank":100,"id":1077,"code":"SS99","type":"symptomScale","description":"incontinence aid","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Incontinence Aid - symptom single","recommendedWording":null,"questionnaires":[1],"categories":[],"createDate":"2017-05-05T16:13:52.023","updateDate":"2018-01-16T11:38:28.783"},"rank":100},{"type":"item","object":{"rank":100,"id":1097,"code":"Q856","type":"question","description":"frequent urination","direction":"negative","underlyingIssue":"having to urinate frequently","additionalInfo":"","preferredWording":"Have you had to urinate frequently?","recommendedWording":null,"questionnaires":[89,111,117,181,240,381,458],"categories":[144],"createDate":"2017-08-30T16:03:52.99","updateDate":"2020-03-11T10:15:09.243"},"rank":100},{"type":"item","object":{"rank":100,"id":1098,"code":"Q857","type":"question","description":"clean oneself","direction":"negative","underlyingIssue":"having to clean oneself more often","additionalInfo":"","preferredWording":"Have you had to clean yourself more often?","recommendedWording":null,"questionnaires":[89,111,117,381],"categories":[2],"createDate":"2017-08-30T16:05:49.603","updateDate":"2020-03-11T10:15:29.99"},"rank":100},{"type":"item","object":{"rank":100,"id":1100,"code":"Q858","type":"question","description":"vagina narrow tight","direction":"negative","underlyingIssue":"experiencing narrow or tight vagina","additionalInfo":"","preferredWording":"Has your vagina felt narrow/tight?","recommendedWording":null,"questionnaires":[89,111,117,381,583,603,181],"categories":[120],"createDate":"2017-08-30T16:18:51.923","updateDate":"2020-03-11T10:15:52.907"},"rank":100},{"type":"item","object":{"rank":100,"id":1014,"code":"SS36","type":"symptomScale","description":"anxiety","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Anxiety - single item","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2017-05-05T10:12:40.93","updateDate":"2018-01-09T15:44:43.63"},"rank":100},{"type":"item","object":{"rank":100,"id":1046,"code":"SS68","type":"symptomScale","description":"abdominal swelling","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Abdominal swelling - single item","recommendedWording":null,"questionnaires":[44],"categories":[],"createDate":"2017-05-05T15:28:08.08","updateDate":"2018-01-09T16:11:01.473"},"rank":100},{"type":"item","object":{"rank":100,"id":1169,"code":"SS120","type":"symptomScale","description":"reflux","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Reflux - symptom scale","recommendedWording":null,"questionnaires":[29],"categories":[],"createDate":"2017-11-03T11:14:27.63","updateDate":"2018-01-16T15:04:14.52"},"rank":100},{"type":"item","object":{"rank":100,"id":1172,"code":"SS123","type":"symptomScale","description":"worry recurrence","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Worry about recurrent disease - symptom scale","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2017-11-03T11:34:08.247","updateDate":"2018-01-16T15:05:02.93"},"rank":100},{"type":"item","object":{"rank":100,"id":1173,"code":"SS124","type":"symptomScale","description":"appearance","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Problems with appearance - symptom scale","recommendedWording":null,"questionnaires":[21],"categories":[],"createDate":"2017-11-03T11:36:02.24","updateDate":"2018-01-16T15:05:18.25"},"rank":100},{"type":"item","object":{"rank":100,"id":1177,"code":"SS128","type":"symptomScale","description":"disease-related worries","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Disease-related worries - scale","recommendedWording":null,"questionnaires":[42],"categories":[],"createDate":"2017-11-03T13:00:21.19","updateDate":"2018-01-16T15:06:11.917"},"rank":100},{"type":"item","object":{"rank":100,"id":1217,"code":"Q905","type":"question","description":"reddening mouth","direction":"negative","underlyingIssue":"having reddening in the mouth","additionalInfo":"","preferredWording":"Have you had any redness in your mouth?","recommendedWording":null,"questionnaires":[111,140,527,381,408,440],"categories":[89],"createDate":"2018-01-18T16:20:28.25","updateDate":"2020-03-11T10:50:57.097"},"rank":100},{"type":"item","object":{"rank":100,"id":1219,"code":"Q907","type":"question","description":"reddening hands feet","direction":"negative","underlyingIssue":"having reddening on hands or feet","additionalInfo":"","preferredWording":"Have you had any redness on your hands or feet?","recommendedWording":null,"questionnaires":[111,140,381,408,440,441],"categories":[22],"createDate":"2018-01-18T16:22:27.813","updateDate":"2020-03-11T10:51:47.843"},"rank":100},{"type":"item","object":{"rank":100,"id":1220,"code":"Q908","type":"question","description":"tingling fingers toes","direction":"negative","underlyingIssue":"having tingling in fingers or toes","additionalInfo":"","preferredWording":"Have you had tingling in your fingers or toes?","recommendedWording":null,"questionnaires":[111,140,226,227,381,408,440],"categories":[130],"createDate":"2018-01-18T16:23:58.843","updateDate":"2020-03-11T10:52:15.363"},"rank":100},{"type":"item","object":{"rank":100,"id":1224,"code":"Q912","type":"question","description":"dry vagina","direction":"negative","underlyingIssue":"having a dry vagina","additionalInfo":"","preferredWording":"Have you had a dry vagina?","recommendedWording":null,"questionnaires":[111,140,381,408],"categories":[119],"createDate":"2018-01-18T16:28:55.91","updateDate":"2020-03-11T10:54:44.747"},"rank":100},{"type":"item","object":{"rank":100,"id":1225,"code":"Q913","type":"question","description":"discomfort vagina","direction":"negative","underlyingIssue":"having discomfort in the vagina","additionalInfo":"","preferredWording":"Have you had discomfort in your vagina?","recommendedWording":null,"questionnaires":[111,140,381,408],"categories":[118],"createDate":"2018-01-18T16:29:46.377","updateDate":"2020-03-11T10:55:20.52"},"rank":100},{"type":"item","object":{"rank":100,"id":1226,"code":"Q914","type":"question","description":"pain vagina sex","direction":"negative","underlyingIssue":"having pain in the vagina during sexual activity","additionalInfo":"","preferredWording":"Have you had pain in your vagina during sexual activity?","recommendedWording":null,"questionnaires":[111,140,381,408],"categories":[118,133],"createDate":"2018-01-18T16:30:49.277","updateDate":"2020-03-11T10:56:14.4"},"rank":100},{"type":"item","object":{"rank":100,"id":1227,"code":"Q915","type":"question","description":"satisfied cosmetic result surgery","direction":"positive","underlyingIssue":"being satisfied with the cosmetic result of the surgery","additionalInfo":"","preferredWording":"Have you been satisfied with the cosmetic result of the surgery?","recommendedWording":null,"questionnaires":[111,140,381,408],"categories":[141,4],"createDate":"2018-01-18T16:32:45.627","updateDate":"2020-03-11T10:56:56.24"},"rank":100},{"type":"item","object":{"rank":100,"id":1228,"code":"Q916","type":"question","description":"swelling body","direction":"negative","underlyingIssue":"having swelling in any part of the body","additionalInfo":"","preferredWording":"Have you had swelling in any part of your body (e.g., ankles, legs, arms, hands or fingers)?","recommendedWording":null,"questionnaires":[240,381,445,639],"categories":[38],"createDate":"2018-09-21T15:40:53.79","updateDate":"2020-03-11T12:56:59.45"},"rank":100},{"type":"item","object":{"rank":100,"id":1229,"code":"Q917","type":"question","description":"swelling face eyes","direction":"negative","underlyingIssue":"having swelling of the face or around the eyes","additionalInfo":"","preferredWording":"Have you had any swelling of the face or around the eyes?","recommendedWording":null,"questionnaires":[240,381],"categories":[38],"createDate":"2018-09-21T15:42:10.917","updateDate":"2020-03-11T12:57:24.347"},"rank":100},{"type":"item","object":{"rank":100,"id":1230,"code":"Q918","type":"question","description":"watery eyes","direction":"negative","underlyingIssue":"having watery eyes","additionalInfo":"","preferredWording":"Have your eyes been watery?","recommendedWording":null,"questionnaires":[381,240],"categories":[148],"createDate":"2018-09-21T15:52:35.573","updateDate":"2020-03-11T12:57:46.093"},"rank":100},{"type":"item","object":{"rank":100,"id":1231,"code":"Q919","type":"question","description":"dry eyes","direction":"negative","underlyingIssue":"having dry eyes","additionalInfo":"","preferredWording":"Have your eyes been dry?","recommendedWording":null,"questionnaires":[532,556,381,528,531,240],"categories":[148],"createDate":"2018-09-26T14:20:28.92","updateDate":"2020-03-11T12:58:14.983"},"rank":100},{"type":"item","object":{"rank":100,"id":1232,"code":"Q920","type":"question","description":"red eyes","direction":"negative","underlyingIssue":"having red (bloodshot) eyes","additionalInfo":"","preferredWording":"Have your eyes been red (bloodshot)?","recommendedWording":null,"questionnaires":[240,381],"categories":[148],"createDate":"2018-09-26T14:21:42.927","updateDate":"2020-03-11T12:58:35.73"},"rank":100},{"type":"item","object":{"rank":100,"id":1233,"code":"Q921","type":"question","description":"itchy eyes","direction":"negative","underlyingIssue":"having itchy eyes","additionalInfo":"","preferredWording":"Have your eyes been itchy?","recommendedWording":null,"questionnaires":[240,381],"categories":[148],"createDate":"2018-09-26T14:23:37.307","updateDate":"2020-03-11T12:59:00.88"},"rank":100},{"type":"item","object":{"rank":100,"id":1234,"code":"Q922","type":"question","description":"burning eyes","direction":"negative","underlyingIssue":"having burning eyes","additionalInfo":"","preferredWording":"Have you had burning eyes?","recommendedWording":null,"questionnaires":[240,381],"categories":[148],"createDate":"2018-09-26T14:42:51.76","updateDate":"2020-03-11T12:59:20.83"},"rank":100},{"type":"item","object":{"rank":100,"id":1236,"code":"Q924","type":"question","description":"change bowel movements","direction":"negative","underlyingIssue":"experiencing change in bowel movements","additionalInfo":"","preferredWording":"Have you had any change in your bowel movements?","recommendedWording":null,"questionnaires":[240,381],"categories":[8],"createDate":"2018-09-26T14:49:40.607","updateDate":"2020-03-11T13:00:28.317"},"rank":100},{"type":"item","object":{"rank":100,"id":1237,"code":"Q925","type":"question","description":"restricted types food","direction":"negative","underlyingIssue":"being restricted in the types of food one can eat","additionalInfo":"","preferredWording":"Have you been restricted in the types of food you can eat?","recommendedWording":null,"questionnaires":[240,381,580],"categories":[33],"createDate":"2018-09-26T15:03:39.313","updateDate":"2020-03-11T13:00:48.817"},"rank":100},{"type":"item","object":{"rank":100,"id":1238,"code":"Q926","type":"question","description":"broken nails","direction":"negative","underlyingIssue":"having nails that break easily","additionalInfo":"","preferredWording":"Have your nails broken easily?","recommendedWording":null,"questionnaires":[240,381],"categories":[22],"createDate":"2018-09-26T15:04:49.47","updateDate":"2020-03-11T13:01:16.8"},"rank":100},{"type":"item","object":{"rank":100,"id":1239,"code":"Q927","type":"question","description":"hair colour change","direction":"negative","underlyingIssue":"hair colour changed","additionalInfo":"","preferredWording":"Has the colour of your hair changed?","recommendedWording":null,"questionnaires":[240,381],"categories":[22],"createDate":"2018-09-26T15:08:43.523","updateDate":"2020-03-11T13:01:40.123"},"rank":100},{"type":"item","object":{"rank":100,"id":1240,"code":"Q928","type":"question","description":"hair texture change","direction":"negative","underlyingIssue":"the texture of the hair changed","additionalInfo":"","preferredWording":"Has the texture of your hair changed (thinner, thicker, curlier or straighter)?","recommendedWording":null,"questionnaires":[240,381],"categories":[22],"createDate":"2018-09-26T15:10:23.553","updateDate":"2020-03-11T13:02:01.37"},"rank":100},{"type":"item","object":{"rank":100,"id":1243,"code":"Q931","type":"question","description":"aches pains cramps muscles","direction":"negative","underlyingIssue":"having muscle aches, pains or cramps ","additionalInfo":null,"preferredWording":"Have you had muscle aches, pains or cramps?","recommendedWording":null,"questionnaires":[240,485,381,482],"categories":[],"createDate":"2018-09-26T15:42:22.957","updateDate":"2018-09-26T15:42:22.957"},"rank":100},{"type":"item","object":{"rank":100,"id":1244,"code":"Q932","type":"question","description":"palpitations","direction":"negative","underlyingIssue":"experiencing palpitations","additionalInfo":"","preferredWording":"Have you had palpitations (faster or irregular heartbeat)?","recommendedWording":null,"questionnaires":[240,381,458],"categories":[16],"createDate":"2018-09-26T16:06:02.723","updateDate":"2020-03-11T13:05:02.05"},"rank":100},{"type":"item","object":{"rank":100,"id":1245,"code":"Q933","type":"question","description":"nose bleed","direction":"negative","underlyingIssue":"having nose bleeds","additionalInfo":"","preferredWording":"Have you had nose bleeds?","recommendedWording":null,"questionnaires":[240,381,557],"categories":[62],"createDate":"2018-09-26T16:09:31.287","updateDate":"2020-03-11T13:05:27.79"},"rank":100},{"type":"item","object":{"rank":100,"id":1247,"code":"Q935","type":"question","description":"faint","direction":"negative","underlyingIssue":"having fainted","additionalInfo":"","preferredWording":"Have you fainted?","recommendedWording":null,"questionnaires":[240,381],"categories":[62],"createDate":"2018-09-26T16:13:48.533","updateDate":"2020-03-11T13:06:39.877"},"rank":100},{"type":"item","object":{"rank":100,"id":1251,"code":"Q939","type":"question","description":"skin sensitive sun","direction":"negative","underlyingIssue":"experiencing increased sensitivity of the skin to the sun","additionalInfo":"","preferredWording":"Has your skin been more sensitive to the sun?","recommendedWording":null,"questionnaires":[240,381],"categories":[22],"createDate":"2018-10-03T11:50:15.607","updateDate":"2020-03-11T13:08:12.34"},"rank":100},{"type":"item","object":{"rank":100,"id":1257,"code":"Q942","type":"question","description":"mentally exhausted","direction":"negative","underlyingIssue":"feeling mentally exhausted","additionalInfo":"","preferredWording":"Have you felt mentally exhausted?","recommendedWording":null,"questionnaires":[269,650,381,419,546,579],"categories":[50],"createDate":"2018-12-13T14:27:41.64","updateDate":"2020-03-11T11:02:14.463"},"rank":100},{"type":"item","object":{"rank":100,"id":1258,"code":"Q943","type":"question","description":"discomfort neck","direction":"negative","underlyingIssue":"having discomfort in the neck","additionalInfo":"","preferredWording":"Have you had any discomfort in your neck?","recommendedWording":null,"questionnaires":[269,381,419,511,513,546,579],"categories":[100],"createDate":"2018-12-13T14:30:00.357","updateDate":"2020-03-11T11:02:49.847"},"rank":100},{"type":"item","object":{"rank":100,"id":1259,"code":"Q944","type":"question","description":"voice sound result disease treatment","direction":"negative","underlyingIssue":"having voice that sounds different as a result of the disease or treatment","additionalInfo":"","preferredWording":"Has your voice sounded different as a result of your disease or treatment?","recommendedWording":null,"questionnaires":[269,381,419,511,513,546,579],"categories":[139,94],"createDate":"2018-12-13T14:34:32.597","updateDate":"2020-03-11T11:03:14.62"},"rank":100},{"type":"item","object":{"rank":100,"id":1260,"code":"Q945","type":"question","description":"tired voice","direction":"negative","underlyingIssue":"having a tired voice","additionalInfo":"","preferredWording":"Have you had a tired voice?","recommendedWording":null,"questionnaires":[269,381,419,546,579],"categories":[139,94],"createDate":"2018-12-13T14:35:01.257","updateDate":"2020-03-11T11:03:33.323"},"rank":100},{"type":"item","object":{"rank":100,"id":1262,"code":"Q947","type":"question","description":"rapid heartbeat","direction":"negative","underlyingIssue":"having a rapid heartbeat","additionalInfo":"","preferredWording":"Have you had a rapid heartbeat?","recommendedWording":null,"questionnaires":[269,381,419,451,546,579],"categories":[16],"createDate":"2018-12-13T14:38:54.353","updateDate":"2020-03-11T11:04:30.107"},"rank":100},{"type":"item","object":{"rank":100,"id":1263,"code":"Q948","type":"question","description":"knot throat","direction":"negative","underlyingIssue":"feeling as if there is a knot in the throat","additionalInfo":"","preferredWording":"Have you felt as though there was a knot in your throat?","recommendedWording":null,"questionnaires":[269,381,419,511,513,546,579],"categories":[89],"createDate":"2018-12-13T14:40:35.363","updateDate":"2020-03-11T11:04:51.073"},"rank":100},{"type":"item","object":{"rank":100,"id":1264,"code":"Q949","type":"question","description":"worry hormone tablets body scan","direction":"negative","underlyingIssue":"worrying about having to come off the thyroid hormone replacement tables in order to prepare for a radioiodine body scan or radiodiodine treatment","additionalInfo":"","preferredWording":"Have you worried about having to come off your thyroid hormone replacement tablets to prepare for a radioiodine body scan or radioiodine treatment?","recommendedWording":null,"questionnaires":[269,381,419],"categories":[53,30],"createDate":"2018-12-13T14:43:33.143","updateDate":"2020-03-11T11:05:20.59"},"rank":100},{"type":"item","object":{"rank":100,"id":1265,"code":"Q950","type":"question","description":"worry drugs life","direction":"negative","underlyingIssue":"worrying about having to stay on medication for the rest of one\'s life","additionalInfo":"","preferredWording":"Have you worried about having to take drugs for the rest of your life?","recommendedWording":null,"questionnaires":[269,381,419],"categories":[53,30],"createDate":"2018-12-13T15:31:25.177","updateDate":"2020-03-11T11:05:47.263"},"rank":100},{"type":"item","object":{"rank":100,"id":1266,"code":"Q951","type":"question","description":"tingling numbness mouth","direction":"negative","underlyingIssue":"having tingling or numbness around the mouth","additionalInfo":"","preferredWording":"Have you had tingling or numbness around your mouth?","recommendedWording":null,"questionnaires":[269,381,419],"categories":[130,89],"createDate":"2018-12-13T15:36:46.17","updateDate":"2020-03-11T11:06:17.42"},"rank":100},{"type":"item","object":{"rank":100,"id":1267,"code":"Q952","type":"question","description":"upsetting close distressed result disease treatment","direction":"negative","underlyingIssue":"finding it upsetting to see the close ones distressed as a result of the disease or treatment","additionalInfo":"","preferredWording":"Have you found it upsetting to see those close to you distressed as a result of your disease or treatment?","recommendedWording":null,"questionnaires":[381,419,269],"categories":[43,49],"createDate":"2018-12-13T15:38:35.057","updateDate":"2020-03-11T11:06:50.29"},"rank":100},{"type":"item","object":{"rank":100,"id":1268,"code":"Q953","type":"question","description":"worry close cope","direction":"negative","underlyingIssue":"worrying how the close ones will cope with the disease or treatment","additionalInfo":"","preferredWording":"Have you worried how those close to you will cope with your illness and treatment?","recommendedWording":null,"questionnaires":[269,381,419],"categories":[30,49],"createDate":"2018-12-13T15:40:48.987","updateDate":"2020-03-11T11:07:32.927"},"rank":100},{"type":"item","object":{"rank":100,"id":1269,"code":"Q954","type":"question","description":"support doctors","direction":"positive","underlyingIssue":"feeling supported by the doctors","additionalInfo":"","preferredWording":"Have you felt supported by your doctors?","recommendedWording":null,"questionnaires":[269,381,399,419],"categories":[126],"createDate":"2018-12-13T15:42:49.637","updateDate":"2020-03-11T11:08:01.717"},"rank":100},{"type":"item","object":{"rank":100,"id":1270,"code":"Q955","type":"question","description":"support HCPs","direction":"positive","underlyingIssue":"feeling supported by other HCPs","additionalInfo":"","preferredWording":"Have you felt supported by other health care professionals (e.g. nurse)?","recommendedWording":null,"questionnaires":[269,381,399,419],"categories":[126],"createDate":"2018-12-13T15:43:39.667","updateDate":"2020-03-11T11:08:28.217"},"rank":100},{"type":"item","object":{"rank":100,"id":1271,"code":"Q956","type":"question","description":"support family friends","direction":"positive","underlyingIssue":"feeling supported by family members or friends","additionalInfo":"","preferredWording":"Have you felt supported by your family members or friends?","recommendedWording":null,"questionnaires":[269,381,419],"categories":[49,39],"createDate":"2018-12-13T15:44:39.447","updateDate":"2020-03-11T11:08:59.57"},"rank":100},{"type":"item","object":{"rank":100,"id":1287,"code":"SS183","type":"symptomScale","description":"sexuality","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Sexuality - scale","recommendedWording":null,"questionnaires":[43],"categories":[],"createDate":"2019-12-13T15:47:14.677","updateDate":"2019-12-13T15:47:14.677"},"rank":100},{"type":"item","object":{"rank":100,"id":1296,"code":"Q957","type":"question","description":"Carry bags","direction":"negative","underlyingIssue":"test","additionalInfo":null,"preferredWording":"how it should be","recommendedWording":null,"questionnaires":[53],"categories":[58],"createDate":"2022-04-05T13:40:22.6","updateDate":"2022-04-05T13:40:22.6"},"rank":100},{"type":"item","object":{"rank":100,"id":1297,"code":"Q958","type":"question","description":"Let\'s test","direction":"negative","underlyingIssue":"stress","additionalInfo":null,"preferredWording":"How it is going?","recommendedWording":null,"questionnaires":[53],"categories":[58],"createDate":"2022-04-05T13:48:13.827","updateDate":"2022-04-05T13:48:13.827"},"rank":100},{"type":"item","object":{"rank":100,"id":1298,"code":"IN39","type":"instructions","description":"dddd","direction":"negative","underlyingIssue":"stress","additionalInfo":null,"preferredWording":"dddddd","recommendedWording":null,"questionnaires":[675],"categories":[97],"createDate":"2022-05-18T08:32:40.417","updateDate":"2022-05-18T08:32:40.417"},"rank":100},{"type":"item","object":{"rank":100,"id":1299,"code":"IN40","type":"instructions","description":"Carry","direction":"negative","underlyingIssue":"","additionalInfo":null,"preferredWording":"How it should be","recommendedWording":null,"questionnaires":[40],"categories":[97,137],"createDate":"2022-05-18T08:55:09.84","updateDate":"2022-05-18T08:55:09.84"},"rank":100},{"type":"item","object":{"rank":100,"id":1300,"code":"Q959","type":"question","description":"What?","direction":"negative","underlyingIssue":"underlying issue","additionalInfo":null,"preferredWording":"How it is going?","recommendedWording":null,"questionnaires":[40],"categories":[76],"createDate":"2022-05-18T08:57:13.36","updateDate":"2022-05-18T08:57:13.36"},"rank":100},{"type":"item","object":{"rank":100,"id":1301,"code":"Q960","type":"question","description":"Adb Q1","direction":"positive","underlyingIssue":"Adb-Q1-Underlying-Issue stress and anxiety","additionalInfo":null,"preferredWording":"Adb Q1 english wording 1","recommendedWording":null,"questionnaires":[652],"categories":[58],"createDate":"2022-05-20T14:33:37.403","updateDate":"2022-05-20T14:33:37.403"},"rank":100},{"type":"item","object":{"rank":100,"id":1302,"code":"Q961","type":"question","description":"Test","direction":"negative","underlyingIssue":"stress","additionalInfo":null,"preferredWording":"hhh","recommendedWording":null,"questionnaires":[688],"categories":[76],"createDate":"2022-05-25T09:24:08.41","updateDate":"2022-05-25T09:24:08.41"},"rank":100},{"type":"item","object":{"rank":100,"id":1303,"code":"Q962","type":"question","description":"asdsadas","direction":"negative","underlyingIssue":"stress","additionalInfo":null,"preferredWording":"asdsadad","recommendedWording":null,"questionnaires":[14],"categories":[58],"createDate":"2022-05-25T09:42:53.097","updateDate":"2022-05-25T09:42:53.097"},"rank":100},{"type":"item","object":{"rank":100,"id":1304,"code":"Q963","type":"question","description":"asdasd","direction":"negative","underlyingIssue":"streas","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[48,137],"createDate":"2022-05-31T08:32:22.973","updateDate":"2022-05-31T08:32:22.973"},"rank":100},{"type":"item","object":{"rank":100,"id":1305,"code":"Q964","type":"question","description":"Short name test","direction":"negative","underlyingIssue":"stress","additionalInfo":null,"preferredWording":"sadad","recommendedWording":null,"questionnaires":[15,732,734],"categories":[134],"createDate":"2022-06-21T10:55:59.5","updateDate":"2022-06-21T10:55:59.5"},"rank":100},{"type":"item","object":{"rank":100,"id":1307,"code":"Q966","type":"question","description":"Testsee","direction":"negative","underlyingIssue":"stress","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[35],"createDate":"2022-06-22T12:01:27.1","updateDate":"2022-06-22T12:01:27.1"},"rank":100},{"type":"item","object":{"rank":100,"id":1309,"code":"Q968","type":"question","description":"testttt","direction":"negative","underlyingIssue":"stress","additionalInfo":null,"preferredWording":"how","recommendedWording":null,"questionnaires":[690],"categories":[75],"createDate":"2022-06-22T14:30:54.42","updateDate":"2022-06-22T14:30:54.42"},"rank":100},{"type":"item","object":{"rank":100,"id":1311,"code":"Q969","type":"question","description":"wefwefwef","direction":"negative","underlyingIssue":"stress","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[76,96],"createDate":"2022-06-23T09:16:54.103","updateDate":"2022-06-23T09:16:54.103"},"rank":100},{"type":"item","object":{"rank":100,"id":1312,"code":"Q970","type":"question","description":"Test test","direction":"negative","underlyingIssue":"stress","additionalInfo":null,"preferredWording":"how","recommendedWording":null,"questionnaires":[15,732,734],"categories":[57],"createDate":"2022-06-23T11:01:36.463","updateDate":"2022-06-23T11:01:36.463"},"rank":100},{"type":"item","object":{"rank":100,"id":1313,"code":"Q971","type":"question","description":"asfsefsef","direction":"negative","underlyingIssue":"wgewegwegweg","additionalInfo":null,"preferredWording":null,"recommendedWording":null,"questionnaires":[],"categories":[58],"createDate":"2022-06-28T11:17:12.85","updateDate":"2022-06-28T11:17:12.85"},"rank":100},{"type":"item","object":{"rank":100,"id":1315,"code":"Q973","type":"question","description":"Adb Q1 Copy 1","direction":"positive","underlyingIssue":"Adb-Q1-Underlying-Issue stress and anxiety","additionalInfo":null,"preferredWording":"Adb Q1 english wording 1","recommendedWording":null,"questionnaires":[89],"categories":[49],"createDate":"2022-06-28T13:55:08.157","updateDate":"2022-06-28T13:55:08.157"},"rank":100},{"type":"item","object":{"rank":100,"id":1214,"code":"SS165","type":"symptomScale","description":"urine urgency leakage","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Urine urgency and leakage - scale","recommendedWording":null,"questionnaires":[114],"categories":[],"createDate":"2018-01-16T16:17:17.413","updateDate":"2018-01-16T16:17:17.413"},"rank":100},{"type":"item","object":{"rank":100,"id":1319,"code":"Q974","type":"question","description":"Adb Q1 Copy 2","direction":"negative","underlyingIssue":"stress","additionalInfo":null,"preferredWording":"Adb Q1 Copy 2 Wording","recommendedWording":null,"questionnaires":[89],"categories":[58],"createDate":"2022-06-28T16:25:23.56","updateDate":"2022-06-28T16:25:23.56"},"rank":100},{"type":"item","object":{"rank":100,"id":1321,"code":"Q975","type":"question","description":"Test test test","direction":"negative","underlyingIssue":"New item test","additionalInfo":null,"preferredWording":"lwiuefluwhefliuwhef","recommendedWording":null,"questionnaires":[488],"categories":[135],"createDate":"2022-06-30T11:46:58.56","updateDate":"2022-06-30T11:46:58.56"},"rank":100},{"type":"item","object":{"rank":100,"id":1324,"code":"Q977","type":"question","description":"will replace item 1323","direction":"negative","underlyingIssue":"stress","additionalInfo":null,"preferredWording":"will replace item 1323","recommendedWording":null,"questionnaires":[652],"categories":[59],"createDate":"2022-07-06T09:59:38.19","updateDate":"2022-07-06T09:59:38.19"},"rank":100},{"type":"item","object":{"rank":100,"id":1325,"code":"Q978","type":"question","description":"test item delete","direction":"negative","underlyingIssue":"stress","additionalInfo":null,"preferredWording":"test item delete","recommendedWording":null,"questionnaires":[652],"categories":[59],"createDate":"2022-07-06T10:14:55.06","updateDate":"2022-07-06T10:14:55.06"},"rank":100},{"type":"item","object":{"rank":96,"id":1274,"code":"SS170","type":"symptomScale","description":"abdominal bloating and flatulence","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Abdominal bloating and flatulence - scale","recommendedWording":null,"questionnaires":[13],"categories":[],"createDate":"2019-12-13T12:35:46.623","updateDate":"2019-12-13T12:35:46.623"},"rank":96},{"type":"item","object":{"rank":96,"id":395,"code":"CS20","type":"condition","description":"if you are a man","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please answer the following question only if you are a man","recommendedWording":null,"questionnaires":[22,193],"categories":[],"createDate":"2016-03-01T15:09:35.95","updateDate":"2016-03-01T15:09:35.95"},"rank":96},{"type":"item","object":{"rank":96,"id":650,"code":"CS35","type":"condition","description":"if completed hospital treatment and at home","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please, complete the following questions only if you have completed your hospital treatment and are currently at home.","recommendedWording":null,"questionnaires":[45],"categories":[],"createDate":"2016-03-04T11:06:10.047","updateDate":"2016-03-04T11:06:10.047"},"rank":96},{"type":"item","object":{"rank":96,"id":710,"code":"CS41","type":"condition","description":"If \\"not at all\\"","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"If you answered BOTH items 22 AND 23 “Not at all” (option 1), please go to ITEM 27.\\nOtherwise, please continue.","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T09:43:37.78","updateDate":"2016-03-07T09:43:37.78"},"rank":96},{"type":"item","object":{"rank":96,"id":179,"code":"Q136","type":"question","description":"oversensitive area affected breast","direction":"negative","underlyingIssue":"the area of the affected breast being oversensitive","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Has the area of your affected breast been oversensitive?</p>","preferredWording":"Was the area of your affected breast oversensitive?","recommendedWording":null,"questionnaires":[5,111,140,226,227,228,408,435,449,553,239,292,300,306,367,381],"categories":[],"createDate":"2016-02-25T15:42:45.907","updateDate":"2016-06-06T13:53:55.747"},"rank":96},{"type":"item","object":{"rank":96,"id":118,"code":"IN12","type":"instructions","description":"answer all questions circling","direction":null,"underlyingIssue":"","additionalInfo":"<h4>Recommended wording:</h4><p>Please answer all of the questions yourself by circling the number that best applies to you.</p>","preferredWording":"Please answer all of the questions yourself by circling the number that best applies to you.","recommendedWording":null,"questionnaires":[4,24,28,39,46,47,596,599,517,523,530,561,456,457,498,499,407,425,427,428,429,431,253,305,317,192,194,200,217,234,90,91],"categories":[],"createDate":"2016-02-25T11:24:28.24","updateDate":"2017-02-09T16:26:19.903"},"rank":96},{"type":"item","object":{"rank":80,"id":496,"code":"RS4","type":"responseScale","description":"4-point Likert scale + N/A","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"N/A, Not at all, A little, Quite a bit, Very much","recommendedWording":null,"questionnaires":[28,42,131,169,172,363,527],"categories":[],"createDate":"2016-03-02T14:40:28.043","updateDate":"2016-03-02T14:40:56.983"},"rank":80},{"type":"item","object":{"rank":64,"id":3,"code":"RS1","type":"responseScale","description":"4-point Likert scale","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Not at all, A little, Quite a bit, Very much.","recommendedWording":"Not at all, A little, Quite a bit, Very much","questionnaires":[1,2,4,5,8,9,734,699,702,716,721,732,733,674,675,676,688,690,698,645,646,647,648,652,671,635,638,639,641,642,643,628,630,631,632,633,634,621,622,623,624,625,627,611,613,614,615,617,602,603,605,608,609,583,589,590,596,571,574,575,576,577,579,561,563,564,566,567,569,554,555,556,557,558,560,547,548,549,552,553,541,542,543,544,545,546,528,530,532,533,534,538,521,522,523,525,526,527,510,513,514,515,517,520,504,506,508,509,497,498,499,500,502,503,487,489,491,492,493,495,481,482,483,484,485,486,472,474,475,477,480,461,463,464,466,469,470,450,451,456,457,458,460,435,436,438,440,444,449,428,429,430,431,432,433,418,421,423,424,425,427,410,413,414,415,416,417,401,404,405,406,407,409,380,387,390,391,394,395,364,367,368,371,375,377,357,358,359,360,362,363,343,345,346,347,350,356,333,334,335,340,341,342,325,326,327,328,331,332,311,312,317,318,321,322,303,305,306,307,308,309,295,298,299,300,301,302,282,284,287,290,291,292,276,277,279,280,281,258,259,260,263,269,272,249,251,252,253,254,255,237,238,239,240,241,247,230,231,232,234,235,236,218,220,222,223,228,229,208,209,212,215,216,217,198,199,200,205,206,207,182,184,187,192,193,194,169,170,172,174,175,181,154,162,163,165,166,168,140,143,144,145,146,153,129,130,131,132,134,139,118,119,123,124,125,128,78,89,94,102,103,114,60,61,62,63,67,77,54,55,56,57,58,59,48,49,50,51,52,53,41,42,43,44,45,46,35,36,37,38,39,40,29,30,31,32,33,34,23,24,25,26,27,28,16,17,19,20,21,22,10,11,12,13,14,15],"categories":[],"createDate":"2016-02-02T11:57:02.403","updateDate":"2016-02-02T11:57:02.403"},"rank":64},{"type":"item","object":{"rank":48,"id":121,"code":"IN15","type":"instructions","description":"answer circling","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please answer by circling the number that best applies to you.","recommendedWording":"Please answer by circling the number that best applies to you.","questionnaires":[1,2,9,10,11,12,609,615,513,515,528,542,563,579,463,481,493,504,506,424,430,432,433,451,458,368,390,391,409,418,421,281,282,322,326,347,360,240,254,259,260,269,277,218,235,236,237,238,239,125,131,140,193,217,43,44,45,48,89,35,36,37,40,41,42,29,30,31,32,33,34,21,22,23,25,26,27,13,14,16,17,18,20],"categories":[],"createDate":"2016-02-25T11:27:05.34","updateDate":"2016-02-25T11:27:05.34"},"rank":48},{"type":"item","object":{"rank":48,"id":176,"code":"Q133","type":"question","description":"problem move arm","direction":"negative","underlyingIssue":"experiencing problems raising an arm or moving it sideways","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had problems raising your arm or moving it sideways?</p>","preferredWording":"Was it difficult to raise your arm or to move it sideways?","recommendedWording":"Have you had problems raising your arm or moving it sideways?","questionnaires":[5,43,111,140,205,226,394,408,435,449,533,553,279,292,300,306,367,381,227,228,231,232,239,269],"categories":[106],"createDate":"2016-02-25T15:39:51.01","updateDate":"2020-03-06T09:26:15.26"},"rank":48},{"type":"item","object":{"rank":48,"id":204,"code":"CS7","type":"condition","description":"next sexual activity","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Next questions only in the case of sexual activity:","recommendedWording":null,"questionnaires":[11],"categories":[],"createDate":"2016-02-29T11:58:39.113","updateDate":"2016-02-29T11:58:39.113"},"rank":48},{"type":"item","object":{"rank":48,"id":173,"code":"CS6","type":"condition","description":"only if sexually active","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer the following two questions only if you were sexually active:","recommendedWording":null,"questionnaires":[5,19],"categories":[],"createDate":"2016-02-25T15:13:09.363","updateDate":"2016-02-25T15:13:09.363"},"rank":48},{"type":"item","object":{"rank":48,"id":142,"code":"CS2","type":"condition","description":"incontinence aid","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer this question only if you wear an incontinence aid:","recommendedWording":null,"questionnaires":[1],"categories":[],"createDate":"2016-02-25T12:44:48.7","updateDate":"2016-02-25T12:44:48.7"},"rank":48},{"type":"item","object":{"rank":48,"id":143,"code":"CS3","type":"condition","description":"sexually active 4 weeks","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer these questions only if you have been sexually active during the past 4 weeks:","recommendedWording":"Answer these questions only if you have been sexually active during the past 4 weeks:","questionnaires":[1,13,30,34,38,596,699,433,449,542,563,114,131,140],"categories":[],"createDate":"2016-02-25T12:45:23.6","updateDate":"2016-02-25T12:45:23.6"},"rank":48},{"type":"item","object":{"rank":48,"id":64,"code":"Q51","type":"question","description":"pain at urination","direction":"negative","underlyingIssue":"having pain when urinating","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had pain when urinating?</p>","preferredWording":"Did you have pain when you urinated?","recommendedWording":null,"questionnaires":[1,32,77,111,475,486,721,364,381,433,472,258,287,291,308,237],"categories":[],"createDate":"2016-02-18T13:19:23.663","updateDate":"2016-06-28T13:00:27.737"},"rank":48},{"type":"item","object":{"rank":48,"id":113,"code":"IN7","type":"instructions","description":"respond all circling","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please respond to all of the statements yourself by circling the number that best applies to you.","recommendedWording":null,"questionnaires":[8,49],"categories":[],"createDate":"2016-02-25T11:22:11.94","updateDate":"2016-02-25T11:22:11.94"},"rank":48},{"type":"item","object":{"rank":48,"id":485,"code":"Q400","type":"question","description":"fevers","direction":"negative","underlyingIssue":"having fevers","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had a fever?</p>","preferredWording":"Have you been feeling less sexually attractive as a result of your disease or treatment?\\n","recommendedWording":"Have you had a fever?","questionnaires":[30,44,111,131,562,602,689,702,391,405,487,500,527,560,139,186,259,273,381],"categories":[64],"createDate":"2016-03-02T14:05:43.553","updateDate":"2020-08-06T09:44:22.113"},"rank":48},{"type":"item","object":{"rank":48,"id":427,"code":"Q353","type":"question","description":"need antibiotics courses","direction":"negative","underlyingIssue":"needing repeated courses of antibiotics","additionalInfo":"","preferredWording":"Have you needed repeated courses of antibiotics?","recommendedWording":null,"questionnaires":[23,111,381,450,461],"categories":[67],"createDate":"2016-03-01T15:58:06.367","updateDate":"2020-03-09T14:26:17.943"},"rank":48},{"type":"item","object":{"rank":48,"id":413,"code":"CS21","type":"condition","description":"if applicable","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"If applicable:","recommendedWording":null,"questionnaires":[21,24,31,33,41],"categories":[],"createDate":"2016-03-01T15:31:24.14","updateDate":"2016-03-01T15:31:24.14"},"rank":48},{"type":"item","object":{"rank":48,"id":394,"code":"CS19","type":"condition","description":"if you drive a car","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please answer the following question only if you drive a car","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2016-03-01T15:09:01.847","updateDate":"2016-03-01T15:09:01.847"},"rank":48},{"type":"item","object":{"rank":48,"id":117,"code":"IN11","type":"instructions","description":"interested you and your health","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"We are interested in some things about you and your health.","recommendedWording":null,"questionnaires":[4,46,192,194,200,217,499,517,523,530,561,427,428,429,431,456,457,234,253,305,317,407,425],"categories":[],"createDate":"2016-02-25T11:23:44.403","updateDate":"2016-02-25T11:23:44.403"},"rank":48},{"type":"item","object":{"rank":48,"id":641,"code":"Q541","type":"question","description":"muscle loss arms legs","direction":"negative","underlyingIssue":"losing muscles from arms or legs","additionalInfo":"","preferredWording":"Have you lost muscle from your arms or legs?","recommendedWording":null,"questionnaires":[44,111,381,545],"categories":[],"createDate":"2016-03-04T09:44:01.753","updateDate":"2017-10-06T15:58:24.66"},"rank":48},{"type":"item","object":{"rank":48,"id":559,"code":"Q468","type":"question","description":"abnormal bleed vagina","direction":"negative","underlyingIssue":"having abnormal bleeding from the vagina","additionalInfo":"","preferredWording":"Have you had abnormal bleeding from your vagina?","recommendedWording":null,"questionnaires":[34,94,111,124,127,381,563,444,482,485,517,547,555],"categories":[113],"createDate":"2016-03-03T13:28:13.507","updateDate":"2020-03-10T12:12:36.527"},"rank":48},{"type":"item","object":{"rank":48,"id":571,"code":"Q478","type":"question","description":"pain intercourse sexual activity","direction":"negative","underlyingIssue":"having pain during sexual intercourse or sexual activity","additionalInfo":"","preferredWording":"Have you had pain during sexual intercourse or other sexual activity?","recommendedWording":null,"questionnaires":[34,38,111,542,547,554,555,563,302,381],"categories":[],"createDate":"2016-03-03T13:40:34.533","updateDate":"2016-06-15T13:55:15.81"},"rank":48},{"type":"item","object":{"rank":48,"id":649,"code":"CS34","type":"condition","description":"if question does not apply","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please mark the box, if the next question does not apply to you","recommendedWording":null,"questionnaires":[45],"categories":[],"createDate":"2016-03-04T11:05:20.377","updateDate":"2016-03-04T11:05:20.377"},"rank":48},{"type":"item","object":{"rank":48,"id":724,"code":"Q606","type":"question","description":"valuedperson","direction":"positive","underlyingIssue":"feeling valued as a person","additionalInfo":"","preferredWording":"I have felt that I am valued as a person","recommendedWording":null,"questionnaires":[49,381,182,220,223,111],"categories":[],"createDate":"2016-03-07T10:52:15.09","updateDate":"2016-06-16T14:18:43.913"},"rank":48},{"type":"item","object":{"rank":48,"id":350,"code":"CS17","type":"condition","description":"If loss of nipple without nipple reconstruction","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer this question ONLY IF you have LOST your nipple and NOT had a nipple reconstruction.","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:34:38.837","updateDate":"2016-03-01T13:34:38.837"},"rank":48},{"type":"item","object":{"rank":48,"id":470,"code":"IN20","type":"instructions","description":"communication these professionals","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please think about your communication with these professionals as you answer the questions.","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T13:37:58.11","updateDate":"2016-03-02T13:37:58.11"},"rank":48},{"type":"item","object":{"rank":48,"id":473,"code":"IN22","type":"instructions","description":"experiences these periods","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please think about your experiences during these periods as you answer the questions.","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T13:42:27.8","updateDate":"2016-03-02T13:42:27.8"},"rank":48},{"type":"item","object":{"rank":48,"id":625,"code":"CS32","type":"condition","description":"not applicable","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"(If not applicable please circle N/A)","recommendedWording":null,"questionnaires":[42],"categories":[],"createDate":"2016-03-03T15:27:49.08","updateDate":"2016-03-03T15:27:49.08"},"rank":48},{"type":"item","object":{"rank":48,"id":745,"code":"IN28","type":"instructions","description":"interested information aspects","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"We are interested in the information you have received about aspects of your disease and its treatment, in order to improve your health care.","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2016-06-16T15:19:30.09","updateDate":"2016-06-16T15:19:30.09"},"rank":48},{"type":"item","object":{"rank":48,"id":989,"code":"SS12","type":"symptomScale","description":"psychosocial aspects","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Psychosocial aspects - scale","recommendedWording":null,"questionnaires":[14],"categories":[],"createDate":"2017-05-03T15:51:31.723","updateDate":"2018-01-09T15:28:38.983"},"rank":48},{"type":"item","object":{"rank":48,"id":840,"code":"Q715","type":"question","description":"SF04 PC/MT able see family","direction":"negative","underlyingIssue":"being less able to see one\'s family or friends as a result of the physical condition or medical treatment","additionalInfo":null,"preferredWording":"As a result of your physical condition or medical treatment have you been less able to see your family or friends?","recommendedWording":null,"questionnaires":[54,111,381],"categories":[],"createDate":"2017-02-21T13:46:59.63","updateDate":"2017-02-21T13:46:59.63"},"rank":48},{"type":"item","object":{"rank":48,"id":825,"code":"Q700","type":"question","description":"CF23 problems remember already done","direction":"negative","underlyingIssue":"experiencing problems remembering whether one has already done something","additionalInfo":"","preferredWording":"Have you had difficulty remembering whether you had already done something?","recommendedWording":null,"questionnaires":[53,111,381,544],"categories":[19],"createDate":"2017-02-20T15:47:26.033","updateDate":"2020-02-18T15:02:20.727"},"rank":48},{"type":"item","object":{"rank":48,"id":875,"code":"Q749","type":"question","description":"PA01 problm fall asleep pain","direction":"negative","underlyingIssue":"experiencing problems falling asleep because of pain","additionalInfo":null,"preferredWording":"Have you had any trouble falling asleep because of pain?","recommendedWording":null,"questionnaires":[56,111,233,381],"categories":[],"createDate":"2017-03-07T14:27:02.653","updateDate":"2017-03-07T14:27:02.653"},"rank":48},{"type":"item","object":{"rank":48,"id":1183,"code":"SS134","type":"symptomScale","description":"autonomy","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Autonomic - scale","recommendedWording":null,"questionnaires":[22],"categories":[],"createDate":"2018-01-05T16:04:46.233","updateDate":"2018-01-05T16:04:46.233"},"rank":48},{"type":"item","object":{"rank":48,"id":1189,"code":"SS140","type":"symptomScale","description":"importance sexual activity","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Importance of sexual activity - single item","recommendedWording":null,"questionnaires":[8],"categories":[],"createDate":"2018-01-05T16:11:53.61","updateDate":"2018-01-05T16:11:53.61"},"rank":48},{"type":"item","object":{"rank":48,"id":1316,"code":"CS50","type":"condition","description":"ADB TS-28062022-2","direction":"negative","underlyingIssue":"","additionalInfo":null,"preferredWording":"ADB C-28062022-2 Wording","recommendedWording":null,"questionnaires":[89],"categories":[],"createDate":"2022-06-28T14:34:31.397","updateDate":"2022-06-28T14:34:31.397"},"rank":48},{"type":"item","object":{"rank":48,"id":1317,"code":"TS9","type":"timeScale","description":"ADB TS-28062022-2","direction":"negative","underlyingIssue":"","additionalInfo":null,"preferredWording":"ADB TS-28062022-2 Wording","recommendedWording":null,"questionnaires":[89],"categories":[],"createDate":"2022-06-28T14:37:48.257","updateDate":"2022-06-28T14:37:48.257"},"rank":48},{"type":"item","object":{"rank":48,"id":1272,"code":"SS168","type":"symptomScale","description":"urinary symptoms and problems","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Urinary symptoms and problems - scale","recommendedWording":null,"questionnaires":[13],"categories":[],"createDate":"2019-12-13T12:28:06.117","updateDate":"2019-12-13T12:28:06.117"},"rank":48},{"type":"item","object":{"rank":48,"id":1103,"code":"RS9","type":"responseScale","description":"5-point satisfaction N/A","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Poor, Fair, good, Very good, Excellent, N/A","recommendedWording":null,"questionnaires":[90,167,325,329,330,361,599,612,618,365,379,462,582,597,598],"categories":[],"createDate":"2017-08-31T10:54:44.37","updateDate":"2017-08-31T10:54:44.37"},"rank":48},{"type":"item","object":{"rank":48,"id":1099,"code":"IN30","type":"instructions","description":"sexual activities dilator","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"These questions apply to sexual activities or the use of a vaginal dilator:","recommendedWording":null,"questionnaires":[89,603],"categories":[],"createDate":"2017-08-30T16:17:01.69","updateDate":"2017-08-30T16:17:01.69"},"rank":48},{"type":"item","object":{"rank":32,"id":888,"code":"Q762","type":"question","description":"PA15 problem walk pain","direction":"negative","underlyingIssue":"experiencing problems taking a walk because of pain","additionalInfo":"","preferredWording":"Have you had any trouble taking a walk because of pain?","recommendedWording":null,"questionnaires":[56,111,233,381],"categories":[],"createDate":"2017-03-07T14:58:28.193","updateDate":"2017-10-11T10:54:10.077"},"rank":32},{"type":"item","object":{"rank":32,"id":1104,"code":"IN32","type":"instructions","description":"indicate hospital service clinic","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please indicate the hospital service or clinic you are assessing (select only one of them):","recommendedWording":null,"questionnaires":[599,90],"categories":[],"createDate":"2017-08-31T10:59:52.433","updateDate":"2017-08-31T10:59:52.433"},"rank":32},{"type":"item","object":{"rank":32,"id":1254,"code":"IN37","type":"instructions","description":"patients report symptoms result treatment","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Patients sometimes report that they have the following symptoms as a result of their treatment.","recommendedWording":null,"questionnaires":[240],"categories":[],"createDate":"2018-10-03T11:58:03.423","updateDate":"2018-10-03T11:58:03.423"},"rank":32},{"type":"item","object":{"rank":32,"id":1131,"code":"IN33","type":"instructions","description":"outpatient care","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please answer the following questions only if you are currently receiving outpatient care.","recommendedWording":null,"questionnaires":[91,599,612],"categories":[],"createDate":"2017-08-31T13:14:50.217","updateDate":"2017-08-31T13:14:50.217"},"rank":32},{"type":"item","object":{"rank":32,"id":833,"code":"Q708","type":"question","description":"CF31 problems remember text","direction":"negative","underlyingIssue":"experiencing problems remembering the content of a text one was reading","additionalInfo":"","preferredWording":"Have you had difficulty remembering what a text you were reading was about?","recommendedWording":null,"questionnaires":[53,111,381,544],"categories":[19],"createDate":"2017-02-21T11:46:58.91","updateDate":"2020-02-18T15:11:52.87"},"rank":32},{"type":"item","object":{"rank":32,"id":471,"code":"IN21","type":"instructions","description":"periods of time","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please indicate among the following periods the one you are evaluating.","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T13:39:24.54","updateDate":"2016-03-02T13:39:24.54"},"rank":32},{"type":"item","object":{"rank":32,"id":522,"code":"CS24","type":"condition","description":"if stoma bag","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer these questions ONLY IF YOU HAVE A STOMA BAG, if not please continue below:","recommendedWording":null,"questionnaires":[32,89,249,343,433,519],"categories":[],"createDate":"2016-03-02T15:45:40.237","updateDate":"2016-03-02T15:45:40.237"},"rank":32},{"type":"item","object":{"rank":32,"id":523,"code":"CS25","type":"condition","description":"if no stoma bag","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please answer these questions ONLY IF YOU DO NOT HAVE A BOWEL STOMA BAG:","recommendedWording":null,"questionnaires":[32,89,114,343,433,519],"categories":[],"createDate":"2016-03-02T15:46:30.877","updateDate":"2016-03-02T15:46:30.877"},"rank":32},{"type":"item","object":{"rank":32,"id":622,"code":"CS29","type":"condition","description":"not on treatment","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"(If you are not on treatment please circle N/A)","recommendedWording":null,"questionnaires":[42],"categories":[],"createDate":"2016-03-03T15:26:48.847","updateDate":"2016-03-03T15:26:48.847"},"rank":32},{"type":"item","object":{"rank":32,"id":165,"code":"CS5","type":"condition","description":"if hair loss","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer this question only if you have lost any hair:","recommendedWording":null,"questionnaires":[5,12,19,27,35,140,228,449],"categories":[],"createDate":"2016-02-25T14:40:37.583","updateDate":"2016-02-25T14:40:37.583"},"rank":32},{"type":"item","object":{"rank":32,"id":402,"code":"Q329","type":"question","description":"problem hold pen","direction":"negative","underlyingIssue":"experiencing problems holding a pen, making writing difficult","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems holding a pen, which made writing difficult?</p>","preferredWording":"Did you have a problem holding a pen, which made writing difficult?","recommendedWording":"Did you have a problem holding a pen, which made writing difficult??","questionnaires":[22,111,621,571,381],"categories":[52],"createDate":"2016-03-01T15:21:15.857","updateDate":"2020-03-09T12:23:32.247"},"rank":32},{"type":"item","object":{"rank":32,"id":480,"code":"Q395","type":"question","description":"problem coughing","direction":"negative","underlyingIssue":"experiencing problems with coughing","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems coughing?</p>","preferredWording":"Have you had a problem with fullness under your arm??","recommendedWording":"Have you had problems with coughing?","questionnaires":[29,43,690,702,527,533,688,689,381,394,212,231,232,111,132,134],"categories":[77],"createDate":"2016-03-02T13:54:29.67","updateDate":"2020-03-09T16:07:15.503"},"rank":32},{"type":"item","object":{"rank":32,"id":114,"code":"IN8","type":"instructions","description":"no right wrong","direction":null,"underlyingIssue":"","additionalInfo":"<h4>Recommended wording:</h4><p>There are no right or wrong answers.</p>","preferredWording":"There are no right or wrong answers.","recommendedWording":"There are no right or wrong answers.","questionnaires":[4,8,28,39,46,47,599,499,517,523,530,561,427,428,429,431,456,305,317,407,425,192,194,200,217,234,253,49,90,91],"categories":[],"createDate":"2016-02-25T11:22:28.07","updateDate":"2017-02-09T16:22:48.237"},"rank":32},{"type":"item","object":{"rank":32,"id":116,"code":"IN10","type":"instructions","description":"try to respond","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please try to respond to as many questions as possible.","recommendedWording":null,"questionnaires":[8],"categories":[],"createDate":"2016-02-25T11:22:57.337","updateDate":"2016-02-25T11:22:57.337"},"rank":32},{"type":"item","object":{"rank":32,"id":208,"code":"CS8","type":"condition","description":"testicular implant","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer this question only if you have a testicular implant:","recommendedWording":null,"questionnaires":[11],"categories":[],"createDate":"2016-02-29T12:00:49.177","updateDate":"2016-02-29T12:00:49.177"},"rank":32},{"type":"item","object":{"rank":32,"id":225,"code":"CS9","type":"condition","description":"if no urostomy","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"PLEASE ANSWER QUESTIONS 31 - 37 ONLY IF YOU DO NOT HAVE A UROSTOMY","recommendedWording":null,"questionnaires":[13,131,342,343],"categories":[],"createDate":"2016-02-29T12:59:21.06","updateDate":"2016-02-29T12:59:47.253"},"rank":32},{"type":"item","object":{"rank":32,"id":226,"code":"CS10","type":"condition","description":"if urostomy","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"PLEASE ANSWER QUESTIONS 38 - 43 ONLY IF YOU HAVE A UROSTOMY","recommendedWording":null,"questionnaires":[13,131,342,343,523],"categories":[],"createDate":"2016-02-29T13:04:51.073","updateDate":"2016-02-29T13:04:51.073"},"rank":32},{"type":"item","object":{"rank":32,"id":227,"code":"CS11","type":"condition","description":"if catheter, during the past week","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"PLEASE ANSWER QUESTION 44 ONLY IF YOU HAVE USED A CATHETER DURING THE PAST WEEK","recommendedWording":null,"questionnaires":[13,131],"categories":[],"createDate":"2016-02-29T13:05:39.733","updateDate":"2016-02-29T13:05:39.733"},"rank":32},{"type":"item","object":{"rank":24,"id":660,"code":"IN24","type":"instructions","description":"things experience care hospital stay","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"We are interested in some things about you and your experience of the care received during your hospital stay.","recommendedWording":null,"questionnaires":[47],"categories":[],"createDate":"2016-03-04T12:25:37.513","updateDate":"2016-03-04T12:25:37.513"},"rank":24},{"type":"item","object":{"rank":24,"id":842,"code":"Q717","type":"question","description":"SF06 PC/MY common family","direction":"negative","underlyingIssue":"feeling one has no longer a lot in common with family or friends as a result of the physical condition or medical treatment","additionalInfo":"","preferredWording":"As a result of your physical condition or medical treatment, have you felt you no longer had a lot in common with your family or friends?","recommendedWording":null,"questionnaires":[54,111,381],"categories":[],"createDate":"2017-02-21T14:32:30.647","updateDate":"2017-02-21T14:35:28.797"},"rank":24},{"type":"item","object":{"rank":24,"id":1163,"code":"CS48","type":"condition","description":"no urine catheter urine stoma bag","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please answer these questions ONLY IF YOU DO NOT HAVE A URINE CATHETER OR A URINE STOMA BAG:","recommendedWording":null,"questionnaires":[114],"categories":[],"createDate":"2017-10-05T14:37:38.907","updateDate":"2017-10-05T14:37:38.907"},"rank":24},{"type":"item","object":{"rank":16,"id":1255,"code":"IN38","type":"instructions","description":"indicate extent past week result treatment","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please indicate the extent to which you have experienced these symptoms during the past week as a result of your treatment.","recommendedWording":null,"questionnaires":[240],"categories":[],"createDate":"2018-10-03T11:58:53.373","updateDate":"2018-10-03T11:58:53.373"},"rank":16},{"type":"item","object":{"rank":16,"id":1256,"code":"CS49","type":"condition","description":"skin problem","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Have you had any of the following skin problems:","recommendedWording":null,"questionnaires":[240],"categories":[],"createDate":"2018-10-03T12:00:27.053","updateDate":"2018-10-03T12:00:27.053"},"rank":16},{"type":"item","object":{"rank":16,"id":1283,"code":"SS179","type":"symptomScale","description":"dry mouth sticky saliva","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Dry mouth and sticky saliva - scale","recommendedWording":null,"questionnaires":[43],"categories":[],"createDate":"2019-12-13T15:42:35.837","updateDate":"2019-12-13T15:42:35.837"},"rank":16},{"type":"item","object":{"rank":16,"id":1184,"code":"SS135","type":"symptomScale","description":"disease treatment effect","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Disease and treatment effect - scale","recommendedWording":null,"questionnaires":[23],"categories":[],"createDate":"2018-01-05T16:06:16.857","updateDate":"2018-01-05T16:06:16.857"},"rank":16},{"type":"item","object":{"rank":16,"id":1215,"code":"SS166","type":"symptomScale","description":"bowel urgency leakage","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Bowel urgency and leakage - scale","recommendedWording":null,"questionnaires":[114],"categories":[],"createDate":"2018-01-16T16:18:04.03","updateDate":"2018-01-16T16:18:04.03"},"rank":16},{"type":"item","object":{"rank":16,"id":1180,"code":"SS131","type":"symptomScale","description":"muscle bone pain","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Muscle and/or bone pain - single item","recommendedWording":null,"questionnaires":[42],"categories":[],"createDate":"2017-11-03T13:38:15.403","updateDate":"2018-01-16T15:06:40.387"},"rank":16},{"type":"item","object":{"rank":16,"id":1049,"code":"SS71","type":"symptomScale","description":"INFODIS","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Information about the Disease - information scale","recommendedWording":null,"questionnaires":[39],"categories":[],"createDate":"2017-05-05T15:32:16.02","updateDate":"2017-05-05T15:32:16.02"},"rank":16},{"type":"item","object":{"rank":16,"id":1017,"code":"SS39","type":"symptomScale","description":"blood mucus stool","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Blood and mucus in stool - scale","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2017-05-05T10:16:25.36","updateDate":"2018-01-09T15:45:27.343"},"rank":16},{"type":"item","object":{"rank":16,"id":1222,"code":"Q910","type":"question","description":"pain joints","direction":"negative","underlyingIssue":"having pain in joints","additionalInfo":"","preferredWording":"Have you had aches or pains in your joints?","recommendedWording":"Have you had pain in your joints?","questionnaires":[111,381,408,451,482,485,140,240,269,357],"categories":[],"createDate":"2018-01-18T16:26:47.483","updateDate":"2018-02-06T10:20:13.18"},"rank":16},{"type":"item","object":{"rank":16,"id":1223,"code":"Q911","type":"question","description":"pain muscles","direction":"negative","underlyingIssue":"having aches or pains in muscles","additionalInfo":null,"preferredWording":"Have you had aches or pains in your muscles?","recommendedWording":null,"questionnaires":[111,140,212,381,408,451],"categories":[],"createDate":"2018-01-18T16:28:00.387","updateDate":"2018-01-18T16:28:00.387"},"rank":16},{"type":"item","object":{"rank":16,"id":1037,"code":"SS59","type":"symptomScale","description":"pain back pelvis","direction":null,"underlyingIssue":"","additionalInfo":"","preferredWording":"Pain in Back and Pelvis - symptom single","recommendedWording":null,"questionnaires":[38],"categories":[],"createDate":"2017-05-05T10:54:31.94","updateDate":"2018-01-09T16:06:30.07"},"rank":16},{"type":"item","object":{"rank":16,"id":1002,"code":"SS25","type":"symptomScale","description":"WH","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Worries/Fears Health and Functioning - symptom scale","recommendedWording":null,"questionnaires":[24,31,33,41],"categories":[],"createDate":"2017-05-03T16:09:42.777","updateDate":"2017-05-03T16:09:42.777"},"rank":16},{"type":"item","object":{"rank":16,"id":1005,"code":"SS28","type":"symptomScale","description":"SA","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Satisfaction with Care and Information - functional single","recommendedWording":null,"questionnaires":[26],"categories":[],"createDate":"2017-05-03T16:13:49","updateDate":"2017-05-03T16:13:49"},"rank":16},{"type":"item","object":{"rank":16,"id":884,"code":"Q758","type":"question","description":"PA10 pain interfere social","direction":"negative","underlyingIssue":"pain interfering with social activities","additionalInfo":null,"preferredWording":"Has pain interfered with your social activities?","recommendedWording":null,"questionnaires":[56,111,233,381],"categories":[],"createDate":"2017-03-07T14:41:58.457","updateDate":"2017-03-07T14:41:58.457"},"rank":16},{"type":"item","object":{"rank":16,"id":882,"code":"Q756","type":"question","description":"PA08 problem sleep pain","direction":"negative","underlyingIssue":"experiencing problems sleeping because of pain","additionalInfo":null,"preferredWording":"Have you had any trouble sleeping because of pain?","recommendedWording":null,"questionnaires":[56,111,233,381],"categories":[],"createDate":"2017-03-07T14:38:30.187","updateDate":"2017-03-07T14:38:30.187"},"rank":16},{"type":"item","object":{"rank":16,"id":1085,"code":"SS107","type":"symptomScale","description":"NV","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Nausea and Vomiting - single item","recommendedWording":null,"questionnaires":[4,46],"categories":[],"createDate":"2017-05-05T16:26:12.593","updateDate":"2017-05-05T16:26:12.593"},"rank":16},{"type":"item","object":{"rank":16,"id":1095,"code":"Q854","type":"question","description":"sore treated","direction":"negative","underlyingIssue":"experiencing soreness in the treated areas","additionalInfo":"","preferredWording":"Have you had soreness in the areas that have been treated?","recommendedWording":null,"questionnaires":[89,111,117,381,583],"categories":[],"createDate":"2017-08-30T16:00:55.91","updateDate":"2017-10-11T16:06:08.81"},"rank":16},{"type":"item","object":{"rank":16,"id":1096,"code":"Q855","type":"question","description":"itchy irritated skin treated","direction":"negative","underlyingIssue":"experiencing itchy or irritated skin in the treated areas","additionalInfo":"","preferredWording":"Have you had itchy or irritated skin in the areas that have been treated?","recommendedWording":null,"questionnaires":[603,583,381,391,89,111,117],"categories":[24],"createDate":"2017-08-30T16:02:45.767","updateDate":"2020-03-11T10:13:51.523"},"rank":16},{"type":"item","object":{"rank":16,"id":1253,"code":"Q941","type":"question","description":"infections","direction":"negative","underlyingIssue":"having infections","additionalInfo":"","preferredWording":"Have you had any infections?","recommendedWording":null,"questionnaires":[381,240],"categories":[67],"createDate":"2018-10-03T11:55:32.21","updateDate":"2020-03-11T13:08:58.03"},"rank":16},{"type":"item","object":{"rank":16,"id":843,"code":"Q718","type":"question","description":"SF07 PC/MT less time family","direction":"negative","underlyingIssue":"spending less time with one\'s family or friends as a result of the physical condition or medical treatment","additionalInfo":"","preferredWording":"As a result of your physical condition or medical treatment, have you spent less time with your family or friends?","recommendedWording":null,"questionnaires":[54,111,381,499],"categories":[],"createDate":"2017-02-21T14:33:19.307","updateDate":"2017-02-21T14:35:36.94"},"rank":16},{"type":"item","object":{"rank":16,"id":838,"code":"Q713","type":"question","description":"SF02 PC/MT say family","direction":"negative","underlyingIssue":"feeling one does not know what to say to one\'s family or friends as a result of the physical condition or medical treatment","additionalInfo":null,"preferredWording":"As a result of your physical condition or medical treatment, have you felt you did not know what to say to your family or friends?","recommendedWording":null,"questionnaires":[54,111,311,381],"categories":[],"createDate":"2017-02-21T13:44:04.357","updateDate":"2017-02-21T13:44:04.357"},"rank":16},{"type":"item","object":{"rank":16,"id":845,"code":"Q720","type":"question","description":"SF09 PC/MT problems contact","direction":"negative","underlyingIssue":"experiencing problems making contact with people as a result of the physical condition or medical treatment","additionalInfo":"","preferredWording":"As a result of your physical condition or medical treatment, have you found it hard to make contact with people?","recommendedWording":null,"questionnaires":[54,111,381],"categories":[],"createDate":"2017-02-21T14:34:57.06","updateDate":"2017-02-21T14:35:50.903"},"rank":16},{"type":"item","object":{"rank":16,"id":878,"code":"Q752","type":"question","description":"PA04 problem stand minutes","direction":"negative","underlyingIssue":"experiencing problems standing for more than a few minutes because of pain","additionalInfo":null,"preferredWording":"Has pain made it difficult for you to stand for more than a few minutes?","recommendedWording":null,"questionnaires":[56,111,233,381],"categories":[],"createDate":"2017-03-07T14:29:24.48","updateDate":"2017-03-07T14:29:24.48"},"rank":16},{"type":"item","object":{"rank":16,"id":834,"code":"Q709","type":"question","description":"CF32 problems remember did","direction":"negative","underlyingIssue":"experiencing problems remembering what one did a few days earlier","additionalInfo":"","preferredWording":"Have you had difficulty remembering what you did a few days earlier?","recommendedWording":null,"questionnaires":[53,111,381,544],"categories":[19],"createDate":"2017-02-21T11:48:48.227","updateDate":"2020-02-18T15:20:23.193"},"rank":16},{"type":"item","object":{"rank":16,"id":768,"code":"Q643","type":"question","description":"PF22 problems run 100 m","direction":"negative","underlyingIssue":"experiencing problems running 100 metres","additionalInfo":"","preferredWording":"Do you have any trouble running 100 m?","recommendedWording":null,"questionnaires":[50,111,345,381],"categories":[108],"createDate":"2017-02-20T13:48:13.96","updateDate":"2020-03-05T10:17:28.817"},"rank":16},{"type":"item","object":{"rank":16,"id":822,"code":"Q697","type":"question","description":"CF20 problems remember new information","direction":"negative","underlyingIssue":"experiencing problems remembering new information","additionalInfo":"","preferredWording":"Have you had difficulty remembering new information, like a person\'s name or simple instructions?","recommendedWording":null,"questionnaires":[53,111,381,529,530,544],"categories":[19],"createDate":"2017-02-20T15:43:25.75","updateDate":"2020-02-18T14:57:38.99"},"rank":16},{"type":"item","object":{"rank":16,"id":968,"code":"Q842","type":"question","description":"DI11 limit work DI","direction":"negative","underlyingIssue":"having to limit work or daily activities due to diarrhea","additionalInfo":"","preferredWording":"Have you had to limit your work or daily activities because of diarrhoea?","recommendedWording":null,"questionnaires":[62,111,263,381,643],"categories":[],"createDate":"2017-03-28T14:26:02.027","updateDate":"2017-10-11T15:43:39.693"},"rank":16},{"type":"item","object":{"rank":16,"id":708,"code":"RS6","type":"responseScale","description":"0-7 point scale","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Don\'t know/ Can\'t answer, Very poor, Excellent","recommendedWording":null,"questionnaires":[49,182,220,223],"categories":[],"createDate":"2016-03-07T09:42:10.433","updateDate":"2016-03-07T09:42:10.433"},"rank":16},{"type":"item","object":{"rank":16,"id":709,"code":"IN25","type":"instructions","description":"more generally","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"This page focuses on your thoughts and feelings MORE GENERALLY.","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T09:42:56.75","updateDate":"2016-03-07T09:42:56.75"},"rank":16},{"type":"item","object":{"rank":16,"id":351,"code":"CS18","type":"condition","description":"If nipple preserving or reconstructing surgery","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer this question ONLY IF you HAVE had nipple preserving or reconstructing surgery.","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:35:51.74","updateDate":"2016-03-01T13:35:51.74"},"rank":16},{"type":"item","object":{"rank":16,"id":712,"code":"CS42","type":"condition","description":"If further comments","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"If you would like to make any further comments, please write them below.","recommendedWording":null,"questionnaires":[49],"categories":[],"createDate":"2016-03-07T09:44:20.683","updateDate":"2016-03-07T09:44:20.683"},"rank":16},{"type":"item","object":{"rank":16,"id":525,"code":"IN23","type":"instructions","description":"Yes/ No","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"(please circle the correct answer)","recommendedWording":null,"questionnaires":[32],"categories":[],"createDate":"2016-03-02T15:48:45.277","updateDate":"2016-03-02T15:48:57.243"},"rank":16},{"type":"item","object":{"rank":16,"id":727,"code":"Q609","type":"question","description":"plan future","direction":"positive","underlyingIssue":"feeling able to plan for future","additionalInfo":"","preferredWording":"I have felt able to plan for the future","recommendedWording":null,"questionnaires":[49,111,311,381,182,220,223],"categories":[53],"createDate":"2016-03-07T11:04:45.853","updateDate":"2020-03-10T15:55:46.29"},"rank":16},{"type":"item","object":{"rank":16,"id":722,"code":"Q604","type":"question","description":"trust others ","direction":"positive","underlyingIssue":"feeling able to trust others","additionalInfo":"","preferredWording":"I have felt able to trust others","recommendedWording":null,"questionnaires":[49,111,220,223,381],"categories":[],"createDate":"2016-03-07T10:47:47.62","updateDate":"2016-06-16T14:17:59.763"},"rank":16},{"type":"item","object":{"rank":16,"id":723,"code":"Q605","type":"question","description":"forgive others ","direction":"positive","underlyingIssue":"feeling able to forgive others for things they have done","additionalInfo":"","preferredWording":"I have felt able to forgive others for things they have done","recommendedWording":null,"questionnaires":[49,111,182,220,223,381],"categories":[],"createDate":"2016-03-07T10:50:43.313","updateDate":"2016-06-16T14:18:21.37"},"rank":16},{"type":"item","object":{"rank":16,"id":765,"code":"Q640","type":"question","description":"PF18 problems run fast","direction":"negative","underlyingIssue":"experiencing problems running fast","additionalInfo":"","preferredWording":"Do you have any trouble running fast?","recommendedWording":null,"questionnaires":[50,111,381,543],"categories":[108],"createDate":"2017-02-20T13:45:13.957","updateDate":"2020-03-04T16:01:41.153"},"rank":16},{"type":"item","object":{"rank":16,"id":808,"code":"Q683","type":"question","description":"CF04 problems remember told","direction":"negative","underlyingIssue":"experiencing problems remembering what one was told a few minutes earlier","additionalInfo":"","preferredWording":"Have you had difficulty remembering what somebody told you a few minutes earlier?","recommendedWording":null,"questionnaires":[53,111,381,544],"categories":[19],"createDate":"2017-02-20T15:27:30.21","updateDate":"2020-02-18T14:43:16.963"},"rank":16},{"type":"item","object":{"rank":16,"id":811,"code":"Q686","type":"question","description":"CF07 walk forget","direction":"negative","underlyingIssue":"experiencing problems remembering the reason why one went somewhere","additionalInfo":"","preferredWording":"Have you walked into a room but forgotten what you went for?","recommendedWording":null,"questionnaires":[53,111,381,544],"categories":[19],"createDate":"2017-02-20T15:30:54.707","updateDate":"2020-02-18T14:45:00.063"},"rank":16},{"type":"item","object":{"rank":16,"id":497,"code":"Q411","type":"question","description":"dry cough","direction":"negative","underlyingIssue":"having a dry cough","additionalInfo":"","preferredWording":"Have you had a dry cough?","recommendedWording":null,"questionnaires":[31,48,111,199,209,328,381,456,484,545,623],"categories":[77],"createDate":"2016-03-02T14:41:38.37","updateDate":"2020-03-09T16:20:21.04"},"rank":16},{"type":"item","object":{"rank":16,"id":449,"code":"CS23","type":"condition","description":"only if used dentures","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer question 43 only if you used dentures:","recommendedWording":null,"questionnaires":[25],"categories":[],"createDate":"2016-03-02T11:29:28.373","updateDate":"2016-03-02T11:29:28.373"},"rank":16},{"type":"item","object":{"rank":16,"id":446,"code":"CS22","type":"condition","description":"only if received information","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer question 45 only if you have received information:","recommendedWording":null,"questionnaires":[25,492],"categories":[],"createDate":"2016-03-02T11:27:50.4","updateDate":"2016-03-02T11:27:50.4"},"rank":16},{"type":"item","object":{"rank":16,"id":444,"code":"Q369","type":"question","description":"problem work/study","direction":"negative","underlyingIssue":"experiencing problems at work or place of study due to the disease","additionalInfo":"","preferredWording":"Have you had problems at your work or place of study due to the disease?","recommendedWording":null,"questionnaires":[24,31,33,41,111,624,381,413,507,545,622,623],"categories":[123],"createDate":"2016-03-02T11:21:57.703","updateDate":"2020-03-09T14:55:21.9"},"rank":16},{"type":"item","object":{"rank":16,"id":466,"code":"Q388","type":"question","description":"satisfied quality social life","direction":"positive","underlyingIssue":"being satisfied with quality of social life","additionalInfo":"","preferredWording":"Have you felt satisfied with the quality of your social life (including family and/ or friends)?","recommendedWording":null,"questionnaires":[26,111,381,478,495,499],"categories":[],"createDate":"2016-03-02T13:17:24.183","updateDate":"2017-10-04T13:06:51.17"},"rank":16},{"type":"item","object":{"rank":16,"id":467,"code":"IN18","type":"instructions","description":"communication with professionals","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"We are interested in the communication you have had with the professional(s) who treat you.","recommendedWording":null,"questionnaires":[28],"categories":[],"createDate":"2016-03-02T13:20:54.667","updateDate":"2016-03-02T13:20:54.667"},"rank":16},{"type":"item","object":{"rank":16,"id":468,"code":"IN19","type":"instructions","description":"categories professionals","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please indicate the professional(s) you evaluate:","recommendedWording":null,"questionnaires":[28,90,599,208],"categories":[],"createDate":"2016-03-02T13:21:50.78","updateDate":"2016-03-02T13:21:50.78"},"rank":16},{"type":"item","object":{"rank":16,"id":457,"code":"Q380","type":"question","description":"mood changes","direction":"negative","underlyingIssue":"having mood changes","additionalInfo":"","preferredWording":"Have you had mood changes?","recommendedWording":null,"questionnaires":[26,31,41,111,140,381,408,545,622,623],"categories":[47],"createDate":"2016-03-02T12:46:44.28","updateDate":"2020-03-09T15:11:46.807"},"rank":16},{"type":"item","object":{"rank":16,"id":423,"code":"Q349","type":"question","description":"temperature go up down","direction":"negative","underlyingIssue":"temperature going up and down","additionalInfo":"","preferredWording":"Has your temperature been going up and down?","recommendedWording":null,"questionnaires":[23,111,254,256,381,450,461],"categories":[64],"createDate":"2016-03-01T15:40:45.12","updateDate":"2020-08-06T09:44:51.35"},"rank":16},{"type":"item","object":{"rank":16,"id":439,"code":"Q365","type":"question","description":"mouth sensitive food drink","direction":"negative","underlyingIssue":"mouth being sensitive to food and drink","additionalInfo":"","preferredWording":"Has your mouth been sensitive to food and drink?","recommendedWording":null,"questionnaires":[25,111,381],"categories":[],"createDate":"2016-03-02T11:03:35.973","updateDate":"2016-06-10T15:01:42.99"},"rank":16},{"type":"item","object":{"rank":16,"id":277,"code":"Q217","type":"question","description":"get up bowel movement","direction":"negative","underlyingIssue":"having to get up at night to open bowels","additionalInfo":"","preferredWording":"Have you needed to get up at night to open your bowels?","recommendedWording":null,"questionnaires":[16,111,263,381],"categories":[],"createDate":"2016-03-01T09:17:03.48","updateDate":"2016-06-07T12:29:11.313"},"rank":16},{"type":"item","object":{"rank":16,"id":275,"code":"Q215","type":"question","description":"release wind mucous","direction":"negative","underlyingIssue":"unintentionally releasing/leaking wind or mucous","additionalInfo":"","preferredWording":"Have you had any unintentional release (leakage) of wind or mucous?","recommendedWording":null,"questionnaires":[16,111,263,381,458],"categories":[],"createDate":"2016-03-01T09:08:03.45","updateDate":"2017-10-02T13:27:39.33"},"rank":16},{"type":"item","object":{"rank":16,"id":385,"code":"Q314","type":"question","description":"problem double vision straight","direction":"negative","underlyingIssue":"experiencing problems with double vision when looking straight ahead","additionalInfo":"<p><u>Recommended wording</u>:</p><p>Have you had problems with double vision when looking straight ahead?</p>","preferredWording":"Were you troubled by double vision when looking straight ahead?","recommendedWording":null,"questionnaires":[21,111,381],"categories":[150],"createDate":"2016-03-01T15:00:58.15","updateDate":"2020-03-09T12:09:17.243"},"rank":16},{"type":"item","object":{"rank":16,"id":345,"code":"TS4","type":"timeScale","description":"past week satisfaction","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Did you worry about possible future treatments?","recommendedWording":null,"questionnaires":[18,119,406,688],"categories":[],"createDate":"2016-03-01T13:26:19.26","updateDate":"2016-03-01T13:26:54.027"},"rank":16},{"type":"item","object":{"rank":16,"id":346,"code":"CS13","type":"condition","description":"if nipple preserved","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer these two questions ONLY IF your nipple has been PRESERVED.","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:29:30.24","updateDate":"2016-03-01T13:29:30.24"},"rank":16},{"type":"item","object":{"rank":16,"id":347,"code":"CS14","type":"condition","description":"breast reconstruction overall","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer these questions in relation to your breast reconstruction overall.","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:30:05.95","updateDate":"2016-03-01T13:30:05.95"},"rank":16},{"type":"item","object":{"rank":16,"id":348,"code":"CS15","type":"condition","description":"if flap procedure","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Answer these questions ONLY IF YOU HAVE HAD A FLAP PROCEDURE (skin/muscle is taken from your back, tummy or buttock to reconstruct your breast).\\n\\n","recommendedWording":null,"questionnaires":[18],"categories":[],"createDate":"2016-03-01T13:31:46.753","updateDate":"2016-03-01T13:31:46.753"},"rank":16},{"type":"item","object":{"rank":16,"id":272,"code":"Q212","type":"question","description":"problem pass wind gas flatulence","direction":"negative","underlyingIssue":"experiencing problems with passing wind/gas/flatulence","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems passing wind/gas/flatulence?</p>","preferredWording":"Were you bothered by gas (flatulence)?","recommendedWording":"Have you had problems with gas (flatulence)?","questionnaires":[16,17,19,38,42,671,554,563,567,548,517,526,482,485,416,417,381,333,302,247,255,280,166,170,181,111,117,89],"categories":[],"createDate":"2016-03-01T08:53:34.837","updateDate":"2017-10-02T13:20:40.547"},"rank":16},{"type":"item","object":{"rank":16,"id":623,"code":"CS30","type":"condition","description":"not having injections","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"(If not having injections please circle N/A)","recommendedWording":null,"questionnaires":[42],"categories":[],"createDate":"2016-03-03T15:27:05.273","updateDate":"2016-03-03T15:27:05.273"},"rank":16},{"type":"item","object":{"rank":16,"id":624,"code":"CS31","type":"condition","description":"not having tests","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"(If you have not had tests please circle N/A)","recommendedWording":null,"questionnaires":[42],"categories":[],"createDate":"2016-03-03T15:27:25.023","updateDate":"2016-03-03T15:27:25.023"},"rank":16},{"type":"item","object":{"rank":16,"id":560,"code":"Q469","type":"question","description":"hot flush sweats","direction":"negative","underlyingIssue":"having hot flushes or sweats","additionalInfo":"","preferredWording":"Have you had hot flushes and/or sweats?","recommendedWording":null,"questionnaires":[34,111,381,414,444,458,482,485,517,547,555,563],"categories":[66],"createDate":"2016-03-03T13:30:08.84","updateDate":"2020-03-10T12:12:56.963"},"rank":16},{"type":"item","object":{"rank":16,"id":581,"code":"Q487","type":"question","description":"pain lower back pelvis","direction":"negative","underlyingIssue":"having pain in the lower back and/or pelvis","additionalInfo":"","preferredWording":"Have you had pain in your lower back and / or pelvis?","recommendedWording":null,"questionnaires":[38,111,123,124,127,174,175,302,381,554],"categories":[],"createDate":"2016-03-03T14:03:27.98","updateDate":"2017-10-06T12:32:27.877"},"rank":16},{"type":"item","object":{"rank":16,"id":506,"code":"Q420","type":"question","description":"worry chronically ill","direction":"negative","underlyingIssue":"worrying about becoming chronically ill","additionalInfo":"","preferredWording":"Have you worried about becoming chronically ill?","recommendedWording":null,"questionnaires":[31,41,111,381,545,622,623],"categories":[53],"createDate":"2016-03-02T15:04:51.66","updateDate":"2020-03-09T16:36:44.793"},"rank":16},{"type":"item","object":{"rank":16,"id":633,"code":"Q533","type":"question","description":"problem talk noisy environment","direction":"negative","underlyingIssue":"experiencing problems talking in a noisy environment","additionalInfo":"","preferredWording":"Have you had problems talking in a noisy environment?","recommendedWording":null,"questionnaires":[43,111,231,232,533,279,381,394],"categories":[139],"createDate":"2016-03-04T08:36:27.783","updateDate":"2020-03-10T14:10:06.95"},"rank":16},{"type":"item","object":{"rank":16,"id":693,"code":"CS40","type":"condition","description":"if surgery for lung cancer","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please answer the following questions only if you had surgery for lung cancer:","recommendedWording":null,"questionnaires":[48],"categories":[],"createDate":"2016-03-04T14:52:11.07","updateDate":"2016-03-04T14:52:11.07"},"rank":16},{"type":"item","object":{"rank":16,"id":554,"code":"Q463","type":"question","description":"sore mouth tongue","direction":"negative","underlyingIssue":"having sore mouth or tongue","additionalInfo":null,"preferredWording":"Have you had a sore mouth or tongue?","recommendedWording":null,"questionnaires":[36,456,484,527,328,381,111,199,209,37,48],"categories":[],"createDate":"2016-03-03T13:17:07.86","updateDate":"2016-03-10T13:30:55.757"},"rank":16},{"type":"item","object":{"rank":16,"id":334,"code":"Q271","type":"question","description":"satisfied sensation nipple","direction":"positive","underlyingIssue":"being satisfied with the sensation of the nipple","additionalInfo":"","preferredWording":"The sensation in your affected nipple?","recommendedWording":null,"questionnaires":[18,111,381,406],"categories":[],"createDate":"2016-03-01T12:54:09.073","updateDate":"2017-10-03T14:21:22.223"},"rank":16},{"type":"item","object":{"rank":16,"id":112,"code":"IN6","type":"instructions","description":"changes sexual health","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Patients sometimes report changes in their sexual health after treatment.","recommendedWording":null,"questionnaires":[8],"categories":[],"createDate":"2016-02-25T11:21:48.163","updateDate":"2016-02-25T11:21:48.163"},"rank":16},{"type":"item","object":{"rank":16,"id":104,"code":"Q80","type":"question","description":"frequent urination night","direction":"negative","underlyingIssue":"having to urinate frequently at night","additionalInfo":"<p><u>Recommended wording:</u><br /></p><p>Have you had to urinate frequently during the night?</p>","preferredWording":"Did you urinate frequently during the night?","recommendedWording":"Have you had to urinate frequently at night?","questionnaires":[1,13,30,32,67,111,721,603,638,647,688,689,702,433,472,475,482,486,583,258,287,291,308,381,390,131,139,166,170,181,236],"categories":[],"createDate":"2016-02-25T09:53:52.523","updateDate":"2016-06-28T12:59:34.023"},"rank":16},{"type":"item","object":{"rank":16,"id":164,"code":"RS3","type":"responseScale","description":"binary","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Yes, No","recommendedWording":null,"questionnaires":[9,16,25,32,652,699,721,508,530,563,590,433,472,475,486,492,503,284,287,303,312,430,217,229,249,258,262,263,119,129,154,165,208,216,37,39,114,118],"categories":[],"createDate":"2016-02-25T14:10:16.883","updateDate":"2016-02-25T14:10:16.883"},"rank":16},{"type":"item","object":{"rank":16,"id":5,"code":"TS2","type":"timeScale","description":"last 4 weeks","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"During the past week:","recommendedWording":"During the past 4 weeks:","questionnaires":[1,2,4,721,732,733,734,702,716,688,689,690,698,699,650,671,674,675,676,645,646,647,648,649,635,638,639,642,643,627,628,631,632,633,634,622,623,624,625,613,614,615,617,621,603,605,608,609,611,589,590,596,602,571,574,575,576,577,579,561,563,564,566,567,554,555,557,558,560,548,549,552,553,545,546,547,541,542,543,530,532,533,534,538,526,527,528,517,520,521,522,523,525,508,509,510,513,514,515,499,500,502,503,504,506,489,492,493,495,497,498,484,485,486,487,480,481,482,483,472,474,475,477,461,463,464,466,470,450,451,456,457,458,460,440,444,445,449,433,435,436,438,427,428,429,430,431,432,417,418,421,423,424,425,408,409,410,414,415,416,401,404,405,406,407,380,387,390,391,394,395,364,367,368,371,375,356,357,358,359,360,362,342,343,345,347,350,334,335,337,340,341,322,326,328,331,332,333,308,309,312,317,318,321,303,305,306,307,299,300,301,302,291,292,295,298,282,284,287,290,272,276,277,279,280,281,258,259,260,262,263,269,251,252,253,254,255,239,240,247,249,231,232,235,236,237,238,226,227,228,229,230,216,217,218,220,222,223,206,207,208,209,212,215,184,192,193,199,200,205,181,182,162,163,166,170,174,175,140,143,144,146,153,154,131,132,134,139,124,125,128,129,130,114,117,119,123,77,78,89,94,102,60,61,62,63,67,54,55,56,57,58,59,46,48,49,51,52,53,42,43,44,45,40,41,35,36,37,38,32,33,34,27,29,30,31,23,24,25,26,18,19,20,21,22,15,16,17,12,13,14,5,8,9,10,11],"categories":[],"createDate":"2016-02-10T11:28:03.23","updateDate":"2016-03-04T14:26:11.287"},"rank":16},{"type":"item","object":{"rank":16,"id":86,"code":"Q70","type":"question","description":"dry mouth","direction":"negative","underlyingIssue":"having a dry mouth","additionalInfo":"<p><br /></p>","preferredWording":"Have you had a dry mouth?","recommendedWording":"Have you had a dry mouth?","questionnaires":[5,9,12,17,20,23,633,634,671,721,733,553,567,589,623,624,632,528,531,532,533,545,548,485,486,497,508,517,527,433,435,449,472,475,482,367,381,394,408,416,417,280,287,291,292,300,306,247,249,255,258,269,279,229,230,231,232,239,240,111,140,182,206,212,228,32,33,35,36,43,45,24,25,26,27,29,31],"categories":[91],"createDate":"2016-02-19T14:33:24.743","updateDate":"2020-03-10T16:10:10.233"},"rank":16},{"type":"item","object":{"rank":16,"id":16,"code":"IN5","type":"instructions","description":"last questions C30","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"For the following questions please circle the number between 1 and 7 that \\nbest applies to you","recommendedWording":"For the following questions please circle the number between 1 and 7 that \\nbest applies to you","questionnaires":[4,15,46,192,194,425,427,428,561,200,217,238,276,317,347],"categories":[],"createDate":"2016-02-10T15:22:43.847","updateDate":"2016-02-18T09:11:36.977"},"rank":16},{"type":"item","object":{"rank":8,"id":61,"code":"Q49","type":"question","description":"enough sleep urinate","direction":"negative","underlyingIssue":"experiencing problems with getting enough sleep because of having to get up frequently at night to urinate","additionalInfo":"<p><u>Recommended wording:</u></p><p>Have you had problems getting enough sleep, because you needed to get up frequently at night to urinate?</p>","preferredWording":"Was it difficult for you to get enough sleep, because you needed to get up frequently at night to urinate?\\n","recommendedWording":null,"questionnaires":[1,13,30,67,77,111,647,688,689,702,131,139,236,308,381,638],"categories":[],"createDate":"2016-02-18T13:15:36.77","updateDate":"2016-06-28T11:28:55.257"},"rank":8},{"type":"item","object":{"rank":8,"id":255,"code":"TS3","type":"timeScale","description":"pain during the past week","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"During the past week have you had pain in any of the following parts of your body?","recommendedWording":null,"questionnaires":[14,154,194,337,469,470],"categories":[],"createDate":"2016-02-29T15:27:58.143","updateDate":"2016-02-29T15:27:58.143"},"rank":8},{"type":"item","object":{"rank":8,"id":300,"code":"Q240","type":"question","description":"unhappy rest life bowel habit","direction":"negative","underlyingIssue":"feeling unhappy with the current bowel habit staying so for the rest of life","additionalInfo":"","preferredWording":"How unhappy would you feel if you lived the rest of your life with your bowel habit as it is now?","recommendedWording":null,"questionnaires":[16,111,263,381],"categories":[8,53],"createDate":"2016-03-01T11:27:38.177","updateDate":"2020-03-09T10:33:27.66"},"rank":8},{"type":"item","object":{"rank":8,"id":1102,"code":"IN31","type":"instructions","description":"recent experience care","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"We are interested in your MOST RECENT experience of the care received in this hospital service or clinic.","recommendedWording":null,"questionnaires":[90],"categories":[],"createDate":"2017-08-31T10:47:45.107","updateDate":"2017-08-31T10:47:45.107"},"rank":8},{"type":"item","object":{"rank":8,"id":1132,"code":"IN34","type":"instructions","description":"recent experience care outpatient","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"We are interested in your MOST RECENT experience of the care received in the outpatient setting in this hospital or clinic.","recommendedWording":null,"questionnaires":[91],"categories":[],"createDate":"2017-08-31T13:15:53.21","updateDate":"2017-08-31T13:15:53.21"},"rank":8},{"type":"item","object":{"rank":8,"id":1133,"code":"CS47","type":"condition","description":"outpatient rate service care organisation","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"In the outpatient setting in this hospital, how would you rate services and care organisation, in terms of:","recommendedWording":null,"questionnaires":[91,599],"categories":[],"createDate":"2017-08-31T13:17:39.887","updateDate":"2017-08-31T13:17:39.887"},"rank":8},{"type":"item","object":{"rank":5,"id":648,"code":"CS33","type":"condition","description":"if in hospital for treatment","direction":null,"underlyingIssue":"","additionalInfo":null,"preferredWording":"Please, complete the following questions if you are currently still in hospital for your treatment. If not, please go to question 48 on next page.","recommendedWording":null,"questionnaires":[45],"categories":[],"createDate":"2016-03-04T11:04:36.63","updateDate":"2016-03-04T11:04:36.63"},"rank":5}]');
;// CONCATENATED MODULE: ./src/mocks/search/generalSearch.ts



/* harmony default export */ function generalSearch() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1000 : _delay;
    return [
        rest.get(resolvePath('/search*'), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json(generalSearch_namespaceObject));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/search/keywords.json
var keywords_namespaceObject = JSON.parse('["abdomen","abdominal cramping","abdominal discomfort","abdominal distension","abdominal pain","abdominal symptoms","ability","ability to drink","ability to eat","abnormal","absorption","accept","acceptance","access","access to hospital","accident","accidental leakage","accidents","ache","aches","acid indigestion","acidity","acitivities of daily living","active","activities","activities of daily life","activities of daily living","Adb-Q","Adb-Q1-Keyword-1","additional","adequacy","advice","affected","afraid","allergy","alone","alopecia","altered bowel habit","amount of food","anal","anal area","anal pain","analgesic","analgesics","anger","angst","annoyed","anorexia","anorgasmia","anosmia","anti-diarrheal","anus","anxiety","anxious","aphasia","appearance","appetite","appetite loss","appointments","arbba","area","argue","argument","arm","arm strength","arms","arousal","arthralgia","arthritis","artificial bladder","artificial nutrition","ascites","ask questions","asthenia","ataxia","attention","attention span","attractive","attractiveness","audio","availability","avoidance of social situations","catching a bus","changing a light bulb","concern about weight loss","contract an infection","daily activities","daily activity","driving a car","excess of air","falling asleep","food aversion","genital area","hanging up a picture","incontinence aid","information about care","information about different places of care","information about medical tests","information about other services","information about self-help","information about the disease","information about treatment","information about treatments","irritarion around stoma","lack of appetite","leisure activities","less active","less like a woman","life appreciation","light activity","like a man","loss of appetite","lowered appetite","muscle ache","not getting enough air","pain at night","pain in the arms","pain with activity","pain with physical activity","panic attack","passing a message on","physical activity","physical appearance","physically active","physically demanding activity","pins and needles","problems with appearance","reading a newspaper","recreational activities","recreational activity","severe lack of appetite","sexual activity","side-effects influencing sexual activity","small appetite","social activities","stand up from a chair","stomach ache","stomach area","strenuous activities","talking about sex","taste alteration","treatment aims","ups and downs","use a finger to pass a stool","usual activities","walk around at home","worries about disease","worries about others","worry about recurrence","worrying about future"]');
// EXTERNAL MODULE: ./src/consts/itemDetails.ts
var itemDetails = __webpack_require__(40332);
;// CONCATENATED MODULE: ./src/mocks/search/keywordSearch.ts





/* harmony default export */ function keywordSearch() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1000 : _delay;
    return [
        rest.get(resolvePath("".concat(getItems/* default */.Z, "/").concat(itemDetails/* KEYWORDS */.Pb, "/search*")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json(keywords_namespaceObject));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/search/icdCodes.json
var icdCodes_namespaceObject = JSON.parse('["ADB10.33","ADB25.1","Adb-Q1-ICD-1","ic","icd","ICD20.15"]');
;// CONCATENATED MODULE: ./src/mocks/search/icdCodeSearch.ts





/* harmony default export */ function icdCodeSearch() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1000 : _delay;
    return [
        rest.get(resolvePath("".concat(getItems/* default */.Z, "/").concat(itemDetails/* ICDCODES */.gJ, "/search*")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json(icdCodes_namespaceObject));
        }), 
    ];
};

// EXTERNAL MODULE: ./src/consts/paths/api/requests/requestsPath.ts
var requestsPath = __webpack_require__(21987);
;// CONCATENATED MODULE: ./src/mocks/requests/getRequests/requests.json
var requests_namespaceObject = JSON.parse('[{"id":52562,"requestDate":"2021-10-07T15:06:00","title":"Mr","name":"Alexis - Azure Debontridder","institution":"Emakina.BE","emailAddress":"cle@emakina.com","requestType":"Commercial","questionnaires":[{"Id":"1287","phase":"4","name":"Vulva","description":"Vulva Cancer (VU34)","languageId":"10","languageCode":"English"},{"Id":"1291","phase":"4","name":"Vulva","description":"Vulva Cancer (VU34)","languageId":"26","languageCode":"Polish"}],"optin":false,"status":"Approved"},{"id":52546,"requestDate":"2018-10-05T15:50:00","title":null,"name":"ddsqd qsdsqd","institution":"sqdsqdqs","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"1160","phase":"4","name":"Oral Health","description":"Oral Health Module (OH15)","languageId":"10","languageCode":"English"},{"Id":"247","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"10","languageCode":"English"}],"optin":true,"status":"Approved"},{"id":52545,"requestDate":"2018-10-05T15:32:00","title":null,"name":"a db","institution":"emk","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"859","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"12","languageCode":"French"}],"optin":false,"status":"Pending"},{"id":52544,"requestDate":"2018-10-01T16:05:00","title":null,"name":"a db","institution":"Emakina","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"1159","phase":"4","name":"Oral Health","description":"Oral Health Module (OH15)","languageId":"12","languageCode":"French"}],"optin":false,"status":"Refused"},{"id":52543,"requestDate":"2018-05-03T09:10:00","title":"Mr","name":"Alexis - Dev Debontridder","institution":"Emakina.BE","emailAddress":"jth@emakina.com","requestType":"Commercial","questionnaires":[{"Id":"1287","phase":"4","name":"Vulva","description":"Vulva Cancer (VU34)","languageId":"10","languageCode":"English"},{"Id":"1291","phase":"4","name":"Vulva","description":"Vulva Cancer (VU34)","languageId":"26","languageCode":"Polish"}],"optin":false,"status":"Approved"},{"id":52540,"requestDate":"2018-04-27T17:19:00","title":"Mr","name":"Alexis Debontridder","institution":"Emakina.BE","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"1287","phase":"4","name":"Vulva","description":"Vulva Cancer (VU34)","languageId":"10","languageCode":"English"},{"Id":"1291","phase":"4","name":"Vulva","description":"Vulva Cancer (VU34)","languageId":"26","languageCode":"Polish"}],"optin":false,"status":"Approved"},{"id":52539,"requestDate":"2018-04-27T17:18:00","title":"Mr","name":"Alexis Debontridder","institution":"Emakina.BE","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"1287","phase":"4","name":"Vulva","description":"Vulva Cancer (VU34)","languageId":"10","languageCode":"English"},{"Id":"1291","phase":"4","name":"Vulva","description":"Vulva Cancer (VU34)","languageId":"26","languageCode":"Polish"}],"optin":false,"status":"Approved"},{"id":52528,"requestDate":"2018-03-16T10:56:00","title":null,"name":"CSI Emakina","institution":"Test","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"1077","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"40","languageCode":"French (Canadian)"},{"Id":"179","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"12","languageCode":"French"},{"Id":"180","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"13","languageCode":"German"},{"Id":"181","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"14","languageCode":"Greek"},{"Id":"236","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"12","languageCode":"French"},{"Id":"237","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"13","languageCode":"German"},{"Id":"261","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"15","languageCode":"Hebrew"},{"Id":"434","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"71","languageCode":"Estonian"},{"Id":"726","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"12","languageCode":"French"},{"Id":"727","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"13","languageCode":"German"},{"Id":"781","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"40","languageCode":"French (Canadian)"},{"Id":"829","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"71","languageCode":"Estonian"},{"Id":"1215","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"15","languageCode":"Hebrew"}],"optin":false,"status":"Approved"},{"id":52522,"requestDate":"2018-03-09T10:22:00","title":null,"name":"karim EMK","institution":"My university","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"143","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"8","languageCode":"Dutch"},{"Id":"150","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"16","languageCode":"Hungarian"},{"Id":"200","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"1","languageCode":"Arabic"},{"Id":"206","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"8","languageCode":"Dutch"},{"Id":"219","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"26","languageCode":"Polish"}],"optin":false,"status":"Approved"},{"id":52521,"requestDate":"2018-03-09T10:19:00","title":null,"name":"CSI CSI","institution":"Test","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"}],"optin":false,"status":"Approved"},{"id":52520,"requestDate":"2018-03-09T10:18:00","title":null,"name":"[FirstName] 52520 Surname 52520","institution":"[Institution] 52520","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"1058","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"118","languageCode":"Amharic"}],"optin":false,"status":"Approved"},{"id":52519,"requestDate":"2018-03-09T10:09:00","title":null,"name":"Test CSI","institution":"Test","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"1058","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"118","languageCode":"Amharic"},{"Id":"1151","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"1","languageCode":"Arabic"},{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"138","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"2","languageCode":"Bulgarian"},{"Id":"139","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"4","languageCode":"Chinese (Taiwanese)"}],"optin":false,"status":"Approved"},{"id":52518,"requestDate":"2018-03-09T09:48:00","title":null,"name":"[FirstName] 52518 Surname 52518","institution":"[Institution] 52518","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"138","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"2","languageCode":"Bulgarian"},{"Id":"139","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"4","languageCode":"Chinese (Taiwanese)"}],"optin":false,"status":"Approved"},{"id":52517,"requestDate":"2018-03-09T09:47:00","title":null,"name":"[FirstName] 52517 Surname 52517","institution":"[Institution] 52517","emailAddress":"adb@emakina.com","requestType":"Academic","questionnaires":[{"Id":"138","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"2","languageCode":"Bulgarian"},{"Id":"139","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"4","languageCode":"Chinese (Taiwanese)"}],"optin":false,"status":"Approved"},{"id":52516,"requestDate":"2018-03-09T09:35:00","title":null,"name":"[FirstName] 52516 Surname 52516","institution":"[Institution] 52516","emailAddress":"jth@emakina.com","requestType":"Commercial","questionnaires":[{"Id":"138","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"2","languageCode":"Bulgarian"},{"Id":"139","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"4","languageCode":"Chinese (Taiwanese)"}],"optin":false,"status":"Approved"},{"id":52515,"requestDate":"2018-03-09T09:24:00","title":null,"name":"[FirstName] 52515 Surname 52515","institution":"[Institution] 52515","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"138","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"2","languageCode":"Bulgarian"},{"Id":"139","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"140","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"5","languageCode":"Croatian"}],"optin":false,"status":"Approved"},{"id":52514,"requestDate":"2018-03-08T16:54:00","title":null,"name":"[FirstName] 52514 Surname 52514","institution":"[Institution] 52514","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"138","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"2","languageCode":"Bulgarian"}],"optin":false,"status":"Approved"},{"id":52513,"requestDate":"2018-03-08T16:19:00","title":null,"name":"[FirstName] 52513 Surname 52513","institution":"[Institution] 52513","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"138","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"2","languageCode":"Bulgarian"},{"Id":"139","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"4","languageCode":"Chinese (Taiwanese)"}],"optin":false,"status":"Approved"},{"id":52512,"requestDate":"2018-03-08T15:14:00","title":null,"name":"[FirstName] 52512 Surname 52512","institution":"[Institution] 52512","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"1073","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"57","languageCode":"Arabic (Israël)"},{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"200","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"1","languageCode":"Arabic"},{"Id":"233","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"8","languageCode":"Dutch"},{"Id":"234","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"10","languageCode":"English"},{"Id":"334","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"57","languageCode":"Arabic (Israël)"}],"optin":false,"status":"Approved"},{"id":52510,"requestDate":"2018-03-08T15:12:00","title":null,"name":"[FirstName] 52510 Surname 52510","institution":"[Institution] 52510","emailAddress":"jth@emakina.com","requestType":"Commercial","questionnaires":[{"Id":"925","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"56","languageCode":"Arabic (Egypt)"},{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"173","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"6","languageCode":"Czech"},{"Id":"174","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"7","languageCode":"Danish"}],"optin":false,"status":"Approved"},{"id":52509,"requestDate":"2018-03-08T15:10:00","title":null,"name":"[FirstName] 52509 Surname 52509","institution":"[Institution] 52509","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"925","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"56","languageCode":"Arabic (Egypt)"},{"Id":"1058","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"118","languageCode":"Amharic"},{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"200","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"1","languageCode":"Arabic"},{"Id":"334","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"57","languageCode":"Arabic (Israël)"}],"optin":false,"status":"Approved"},{"id":52507,"requestDate":"2018-03-06T11:29:00","title":null,"name":"karim EMK","institution":"commerc","emailAddress":"jth@emakina.com","requestType":"Commercial","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"146","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"12","languageCode":"French"},{"Id":"200","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"1","languageCode":"Arabic"},{"Id":"202","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"3","languageCode":"Chinese"},{"Id":"209","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"12","languageCode":"French"},{"Id":"226","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"34","languageCode":"Spanish"},{"Id":"308","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"68","languageCode":"Spanish (US)"},{"Id":"429","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"3","languageCode":"Chinese"}],"optin":false,"status":"Approved"},{"id":52506,"requestDate":"2018-03-06T11:24:00","title":null,"name":"karim EMK","institution":"acad","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"200","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"1","languageCode":"Arabic"}],"optin":false,"status":"Approved"},{"id":52503,"requestDate":"2018-03-06T11:23:00","title":null,"name":"karim EMK","institution":"comm","emailAddress":"jth@emakina.com","requestType":"Commercial","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"200","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"1","languageCode":"Arabic"}],"optin":false,"status":"Approved"},{"id":52504,"requestDate":"2018-03-06T11:23:00","title":null,"name":"karim EMK","institution":"comm","emailAddress":"jth@emakina.com","requestType":"Commercial","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"200","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"1","languageCode":"Arabic"}],"optin":false,"status":"Approved"},{"id":52496,"requestDate":"2018-03-06T11:00:00","title":null,"name":"karim EMK","institution":"comm","emailAddress":"jth@emakina.com","requestType":"Commercial","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"}],"optin":false,"status":"Approved"},{"id":52497,"requestDate":"2018-03-06T11:00:00","title":null,"name":"karim EMK","institution":"comm","emailAddress":"jth@emakina.com","requestType":"Commercial","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"}],"optin":false,"status":"Approved"},{"id":52493,"requestDate":"2018-03-06T10:54:00","title":null,"name":"[FirstName] 52493 Surname 52493","institution":"[Institution] 52493","emailAddress":"jth@emakina.com","requestType":"Commercial","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"}],"optin":false,"status":"Approved"},{"id":52489,"requestDate":"2018-03-06T10:49:00","title":null,"name":"karim EMK","institution":"comm","emailAddress":"jth@emakina.com","requestType":"Commercial","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"200","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"1","languageCode":"Arabic"},{"Id":"202","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"3","languageCode":"Chinese"}],"optin":false,"status":"Approved"},{"id":52490,"requestDate":"2018-03-06T10:49:00","title":null,"name":"karim EMK","institution":"comm","emailAddress":"jth@emakina.com","requestType":"Commercial","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"200","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"1","languageCode":"Arabic"},{"Id":"202","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"3","languageCode":"Chinese"}],"optin":false,"status":"Approved"},{"id":52491,"requestDate":"2018-03-06T10:49:00","title":null,"name":"karim EMK","institution":"comm","emailAddress":"jth@emakina.com","requestType":"Commercial","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"200","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"1","languageCode":"Arabic"},{"Id":"202","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"3","languageCode":"Chinese"}],"optin":false,"status":"Approved"},{"id":52488,"requestDate":"2018-03-06T10:42:00","title":null,"name":"karim EMK","institution":"comm","emailAddress":"jth@emakina.com","requestType":"Commercial","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"}],"optin":false,"status":"Approved"},{"id":52485,"requestDate":"2018-03-06T10:07:00","title":null,"name":"karim EMK","institution":"acad","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"200","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"1","languageCode":"Arabic"},{"Id":"202","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"3","languageCode":"Chinese"}],"optin":false,"status":"Approved"},{"id":52484,"requestDate":"2018-03-05T17:49:00","title":null,"name":"karim EMK","institution":"acad","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"200","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"1","languageCode":"Arabic"},{"Id":"202","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"3","languageCode":"Chinese"}],"optin":false,"status":"Approved"},{"id":52482,"requestDate":"2018-03-05T17:42:00","title":null,"name":"karim EMK","institution":"commercial","emailAddress":"jth@emakina.com","requestType":"Commercial","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"200","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"1","languageCode":"Arabic"},{"Id":"219","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"26","languageCode":"Polish"},{"Id":"220","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"27","languageCode":"Portuguese"}],"optin":false,"status":"Approved"},{"id":52481,"requestDate":"2018-03-05T17:36:00","title":null,"name":"karim EMK","institution":"université","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"200","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"1","languageCode":"Arabic"},{"Id":"222","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"30","languageCode":"Russian"}],"optin":false,"status":"Approved"},{"id":52480,"requestDate":"2018-03-05T17:33:00","title":null,"name":"karim EMK","institution":"unif","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"200","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"1","languageCode":"Arabic"},{"Id":"202","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"3","languageCode":"Chinese"}],"optin":false,"status":"Approved"},{"id":52479,"requestDate":"2018-03-05T17:26:00","title":null,"name":"karim EMK","institution":"unif","emailAddress":"jth@emakina.com","requestType":"Academic","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"200","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"1","languageCode":"Arabic"},{"Id":"202","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"3","languageCode":"Chinese"}],"optin":false,"status":"Approved"},{"id":52472,"requestDate":"2018-01-08T09:56:00","title":"Ms","name":"[FirstName] 52472 Surname 52472","institution":"[Institution] 52472","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"61","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"8","languageCode":"Dutch"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"},{"Id":"748","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"8","languageCode":"Dutch"}],"optin":false,"status":"Approved"},{"id":52471,"requestDate":"2018-01-08T09:10:00","title":"Ms","name":"[FirstName] 52471 Surname 52471","institution":"[Institution] 52471","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52470,"requestDate":"2018-01-08T08:19:00","title":"Ms","name":"[FirstName] 52470 Surname 52470","institution":"[Institution] 52470","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"152","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"18","languageCode":"Indian (Hindi)"},{"Id":"311","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"65","languageCode":"Indian (Telegu)"}],"optin":false,"status":"Approved"},{"id":52468,"requestDate":"2018-01-07T21:55:00","title":"Dr.","name":"[FirstName] 52468 Surname 52468","institution":"[Institution] 52468","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1019","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"48","languageCode":"Spanish (Chilean)"},{"Id":"103","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"48","languageCode":"Spanish (Chilean)"},{"Id":"607","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"48","languageCode":"Spanish (Chilean)"},{"Id":"694","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"48","languageCode":"Spanish (Chilean)"}],"optin":false,"status":"Approved"},{"id":52467,"requestDate":"2018-01-07T17:26:00","title":"dr","name":"[FirstName] 52467 Surname 52467","institution":"[Institution] 52467","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"636","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"76","languageCode":"Urdu"}],"optin":false,"status":"Approved"},{"id":52466,"requestDate":"2018-01-07T12:36:00","title":"Mrs","name":"[FirstName] 52466 Surname 52466","institution":"[Institution] 52466","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"53","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"3","languageCode":"Chinese"}],"optin":false,"status":"Approved"},{"id":52465,"requestDate":"2018-01-07T10:33:00","title":"MS","name":"[FirstName] 52465 Surname 52465","institution":"[Institution] 52465","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"566","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"95","languageCode":"Malay (Malaysia)"}],"optin":false,"status":"Approved"},{"id":52463,"requestDate":"2018-01-07T09:17:00","title":"Ms.","name":"[FirstName] 52463 Surname 52463","institution":"[Institution] 52463","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"931","phase":"1","name":"ELD14","description":"ELD14","languageId":"10","languageCode":"English"},{"Id":"1160","phase":"4","name":"Oral Health","description":"Oral Health Module (OH15)","languageId":"10","languageCode":"English"},{"Id":"1183","phase":"2","name":"Cholangio","description":"Cholangiocarcinoma - gall bladder cancers (BIL21)","languageId":"10","languageCode":"English"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"122","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"},{"Id":"234","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"10","languageCode":"English"},{"Id":"247","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"10","languageCode":"English"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"},{"Id":"430","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"10","languageCode":"English"},{"Id":"458","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"10","languageCode":"English"},{"Id":"539","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"},{"Id":"647","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"10","languageCode":"English"},{"Id":"725","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"10","languageCode":"English"},{"Id":"735","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"10","languageCode":"English"},{"Id":"772","phase":"1","name":"Bone Metastases","description":"desc","languageId":"10","languageCode":"English"},{"Id":"806","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"10","languageCode":"English"},{"Id":"871","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"10","languageCode":"English"},{"Id":"1192","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"10","languageCode":"English"},{"Id":"1232","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52462,"requestDate":"2018-01-07T07:53:00","title":"Mr","name":"[FirstName] 52462 Surname 52462","institution":"[Institution] 52462","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"857","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"1","languageCode":"Arabic"}],"optin":false,"status":"Approved"},{"id":52461,"requestDate":"2018-01-06T15:09:00","title":"Dr","name":"[FirstName] 52461 Surname 52461","institution":"[Institution] 52461","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52460,"requestDate":"2018-01-06T13:31:00","title":"Mr.","name":"[FirstName] 52460 Surname 52460","institution":"[Institution] 52460","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"80","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"22","languageCode":"Japanese"}],"optin":false,"status":"Approved"},{"id":52459,"requestDate":"2018-01-06T12:46:00","title":"Dr.","name":"[FirstName] 52459 Surname 52459","institution":"[Institution] 52459","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"87","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"27","languageCode":"Portuguese"}],"optin":false,"status":"Approved"},{"id":52458,"requestDate":"2018-01-06T12:10:00","title":"Ms","name":"[FirstName] 52458 Surname 52458","institution":"[Institution] 52458","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"51","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"61","languageCode":"Burmese (Myanmar)"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"1192","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52457,"requestDate":"2018-01-06T11:40:00","title":"Ms","name":"[FirstName] 52457 Surname 52457","institution":"[Institution] 52457","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"51","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"61","languageCode":"Burmese (Myanmar)"}],"optin":false,"status":"Approved"},{"id":52456,"requestDate":"2018-01-06T11:08:00","title":"dr.","name":"[FirstName] 52456 Surname 52456","institution":"[Institution] 52456","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1039","phase":"4","name":"IN-PATSAT32","description":"IN-PATSAT32","languageId":"28","languageCode":"Portuguese (Brazilian)"}],"optin":false,"status":"Approved"},{"id":52455,"requestDate":"2018-01-06T11:00:00","title":"dr.","name":"[FirstName] 52455 Surname 52455","institution":"[Institution] 52455","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"510","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"28","languageCode":"Portuguese (Brazilian)"}],"optin":false,"status":"Approved"},{"id":52454,"requestDate":"2018-01-06T08:43:00","title":"Mrs","name":"[FirstName] 52454 Surname 52454","institution":"[Institution] 52454","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"929","phase":"1","name":"ELD14","description":"ELD14","languageId":"4","languageCode":"Chinese (Taiwanese)"}],"optin":false,"status":"Approved"},{"id":52453,"requestDate":"2018-01-06T08:11:00","title":"Miss","name":"[FirstName] 52453 Surname 52453","institution":"[Institution] 52453","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"53","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"3","languageCode":"Chinese"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"247","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"10","languageCode":"English"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"629","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"3","languageCode":"Chinese"},{"Id":"726","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"12","languageCode":"French"},{"Id":"915","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"3","languageCode":"Chinese"},{"Id":"1236","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"3","languageCode":"Chinese"}],"optin":false,"status":"Approved"},{"id":52452,"requestDate":"2018-01-06T08:09:00","title":"Dr","name":"[FirstName] 52452 Surname 52452","institution":"[Institution] 52452","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"85","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"20","languageCode":"Persian"},{"Id":"159","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"20","languageCode":"Persian"}],"optin":false,"status":"Approved"},{"id":52451,"requestDate":"2018-01-06T07:39:00","title":"Dr","name":"[FirstName] 52451 Surname 52451","institution":"[Institution] 52451","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"939","phase":"1","name":"Bone Metastases","description":"desc","languageId":"20","languageCode":"Persian"},{"Id":"85","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"20","languageCode":"Persian"},{"Id":"159","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"20","languageCode":"Persian"},{"Id":"298","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"20","languageCode":"Persian"},{"Id":"673","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"20","languageCode":"Persian"},{"Id":"746","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"20","languageCode":"Persian"},{"Id":"760","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"20","languageCode":"Persian"},{"Id":"846","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"20","languageCode":"Persian"},{"Id":"1279","phase":"4","name":"Spiritual Wellbeing","description":"Spiritual Wellbeing (SWB32)","languageId":"20","languageCode":"Persian"}],"optin":false,"status":"Approved"},{"id":52450,"requestDate":"2018-01-06T05:57:00","title":"Ms","name":"[FirstName] 52450 Surname 52450","institution":"[Institution] 52450","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"566","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"95","languageCode":"Malay (Malaysia)"},{"Id":"639","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"88","languageCode":"Chinese (Malaysia)"},{"Id":"641","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"98","languageCode":"Tamil (Malaysia)"}],"optin":false,"status":"Approved"},{"id":52449,"requestDate":"2018-01-06T01:48:00","title":"Mr.","name":"[FirstName] 52449 Surname 52449","institution":"[Institution] 52449","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"106","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"51","languageCode":"Spanish (Guatemalian)"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52448,"requestDate":"2018-01-05T23:47:00","title":"Ms","name":"[FirstName] 52448 Surname 52448","institution":"[Institution] 52448","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"294","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"73","languageCode":"Latvian"}],"optin":false,"status":"Approved"},{"id":52447,"requestDate":"2018-01-05T18:29:00","title":"Dr","name":"[FirstName] 52447 Surname 52447","institution":"[Institution] 52447","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52445,"requestDate":"2018-01-05T17:07:00","title":"Mr","name":"[FirstName] 52445 Surname 52445","institution":"[Institution] 52445","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"274","phase":"4","name":"IN-PATSAT32","description":"IN-PATSAT32","languageId":"12","languageCode":"French"}],"optin":false,"status":"Approved"},{"id":52446,"requestDate":"2018-01-05T17:07:00","title":"Mr","name":"[FirstName] 52446 Surname 52446","institution":"[Institution] 52446","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"274","phase":"4","name":"IN-PATSAT32","description":"IN-PATSAT32","languageId":"12","languageCode":"French"}],"optin":false,"status":"Approved"},{"id":52444,"requestDate":"2018-01-05T16:48:00","title":"Mr","name":"[FirstName] 52444 Surname 52444","institution":"[Institution] 52444","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"179","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"12","languageCode":"French"},{"Id":"209","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"12","languageCode":"French"},{"Id":"859","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"12","languageCode":"French"}],"optin":false,"status":"Approved"},{"id":52442,"requestDate":"2018-01-05T16:05:00","title":"Ms","name":"[FirstName] 52442 Surname 52442","institution":"[Institution] 52442","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"859","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"12","languageCode":"French"}],"optin":false,"status":"Approved"},{"id":52441,"requestDate":"2018-01-05T15:55:00","title":"Ms.","name":"[FirstName] 52441 Surname 52441","institution":"[Institution] 52441","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1192","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"10","languageCode":"English"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"},{"Id":"647","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"10","languageCode":"English"},{"Id":"696","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"6","languageCode":"Czech"},{"Id":"1232","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52440,"requestDate":"2018-01-05T15:46:00","title":"Mr.","name":"[FirstName] 52440 Surname 52440","institution":"[Institution] 52440","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52439,"requestDate":"2018-01-05T13:13:00","title":"Dr","name":"[FirstName] 52439 Surname 52439","institution":"[Institution] 52439","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1040","phase":"1","name":"ELD14","description":"ELD14","languageId":"28","languageCode":"Portuguese (Brazilian)"},{"Id":"88","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"28","languageCode":"Portuguese (Brazilian)"},{"Id":"221","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"28","languageCode":"Portuguese (Brazilian)"},{"Id":"1199","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"28","languageCode":"Portuguese (Brazilian)"}],"optin":false,"status":"Approved"},{"id":52438,"requestDate":"2018-01-05T11:33:00","title":"Mw","name":"[FirstName] 52438 Surname 52438","institution":"[Institution] 52438","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"143","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"8","languageCode":"Dutch"}],"optin":false,"status":"Approved"},{"id":52437,"requestDate":"2018-01-05T06:40:00","title":"Ms.","name":"[FirstName] 52437 Surname 52437","institution":"[Institution] 52437","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"122","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"},{"Id":"234","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"10","languageCode":"English"},{"Id":"247","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"10","languageCode":"English"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"},{"Id":"430","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52436,"requestDate":"2018-01-04T21:32:00","title":"Ms","name":"[FirstName] 52436 Surname 52436","institution":"[Institution] 52436","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"275","phase":"4","name":"IN-PATSAT32","description":"IN-PATSAT32","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52435,"requestDate":"2018-01-04T20:43:00","title":"Dr","name":"[FirstName] 52435 Surname 52435","institution":"[Institution] 52435","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"33","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"34","languageCode":"Spanish"},{"Id":"34","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"34","languageCode":"Spanish"},{"Id":"35","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"34","languageCode":"Spanish"}],"optin":false,"status":"Approved"},{"id":52432,"requestDate":"2018-01-04T17:41:00","title":"Miss","name":"[FirstName] 52432 Surname 52432","institution":"[Institution] 52432","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"},{"Id":"458","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52431,"requestDate":"2018-01-04T15:42:00","title":"Mr","name":"[FirstName] 52431 Surname 52431","institution":"[Institution] 52431","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52430,"requestDate":"2018-01-04T15:29:00","title":"A/Prof","name":"[FirstName] 52430 Surname 52430","institution":"[Institution] 52430","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1192","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"10","languageCode":"English"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52429,"requestDate":"2018-01-04T14:24:00","title":"Dr.","name":"[FirstName] 52429 Surname 52429","institution":"[Institution] 52429","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"},{"Id":"147","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"13","languageCode":"German"},{"Id":"541","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"13","languageCode":"German"},{"Id":"1194","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"13","languageCode":"German"},{"Id":"1274","phase":"4","name":"Spiritual Wellbeing","description":"Spiritual Wellbeing (SWB32)","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52428,"requestDate":"2018-01-04T14:13:00","title":"Dr.","name":"[FirstName] 52428 Surname 52428","institution":"[Institution] 52428","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"6","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52427,"requestDate":"2018-01-04T13:11:00","title":"Dr","name":"[FirstName] 52427 Surname 52427","institution":"[Institution] 52427","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1087","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"3","languageCode":"Chinese"},{"Id":"53","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"3","languageCode":"Chinese"}],"optin":false,"status":"Approved"},{"id":52426,"requestDate":"2018-01-04T12:41:00","title":"Mr","name":"[FirstName] 52426 Surname 52426","institution":"[Institution] 52426","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"30","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"48","languageCode":"Spanish (Chilean)"}],"optin":false,"status":"Approved"},{"id":52425,"requestDate":"2018-01-04T12:12:00","title":"Ms","name":"[FirstName] 52425 Surname 52425","institution":"[Institution] 52425","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52424,"requestDate":"2018-01-04T09:13:00","title":"dr","name":"[FirstName] 52424 Surname 52424","institution":"[Institution] 52424","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"931","phase":"1","name":"ELD14","description":"ELD14","languageId":"10","languageCode":"English"},{"Id":"966","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"33","languageCode":"Slovenian"},{"Id":"1192","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"10","languageCode":"English"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"95","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"33","languageCode":"Slovenian"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"167","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"33","languageCode":"Slovenian"},{"Id":"191","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"33","languageCode":"Slovenian"},{"Id":"225","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"33","languageCode":"Slovenian"},{"Id":"586","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"33","languageCode":"Slovenian"},{"Id":"735","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"10","languageCode":"English"},{"Id":"1223","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"33","languageCode":"Slovenian"},{"Id":"1232","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"10","languageCode":"English"},{"Id":"1271","phase":"4","name":"Spiritual Wellbeing","description":"Spiritual Wellbeing (SWB32)","languageId":"5","languageCode":"Croatian"},{"Id":"1276","phase":"4","name":"Spiritual Wellbeing","description":"Spiritual Wellbeing (SWB32)","languageId":"21","languageCode":"Italian"}],"optin":false,"status":"Approved"},{"id":52423,"requestDate":"2018-01-04T08:50:00","title":"Dr","name":"[FirstName] 52423 Surname 52423","institution":"[Institution] 52423","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"695","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"21","languageCode":"Italian"}],"optin":false,"status":"Approved"},{"id":52422,"requestDate":"2018-01-04T06:51:00","title":"ms","name":"[FirstName] 52422 Surname 52422","institution":"[Institution] 52422","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"75","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"18","languageCode":"Indian (Hindi)"}],"optin":false,"status":"Approved"},{"id":52421,"requestDate":"2018-01-04T03:29:00","title":"Mr","name":"[FirstName] 52421 Surname 52421","institution":"[Institution] 52421","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1120","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"22","languageCode":"Japanese"},{"Id":"80","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"22","languageCode":"Japanese"}],"optin":false,"status":"Approved"},{"id":52420,"requestDate":"2018-01-04T03:17:00","title":"mr","name":"[FirstName] 52420 Surname 52420","institution":"[Institution] 52420","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"671","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"93","languageCode":"Indonesian"}],"optin":false,"status":"Approved"},{"id":52419,"requestDate":"2018-01-03T19:50:00","title":"Mr. ","name":"[FirstName] 52419 Surname 52419","institution":"[Institution] 52419","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"931","phase":"1","name":"ELD14","description":"ELD14","languageId":"10","languageCode":"English"},{"Id":"1160","phase":"4","name":"Oral Health","description":"Oral Health Module (OH15)","languageId":"10","languageCode":"English"},{"Id":"1183","phase":"2","name":"Cholangio","description":"Cholangiocarcinoma - gall bladder cancers (BIL21)","languageId":"10","languageCode":"English"},{"Id":"1192","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"10","languageCode":"English"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"122","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"},{"Id":"234","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"10","languageCode":"English"},{"Id":"247","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"10","languageCode":"English"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"},{"Id":"430","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"10","languageCode":"English"},{"Id":"458","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"10","languageCode":"English"},{"Id":"539","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"},{"Id":"647","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"10","languageCode":"English"},{"Id":"725","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"10","languageCode":"English"},{"Id":"735","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"10","languageCode":"English"},{"Id":"772","phase":"1","name":"Bone Metastases","description":"desc","languageId":"10","languageCode":"English"},{"Id":"806","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"10","languageCode":"English"},{"Id":"871","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"10","languageCode":"English"},{"Id":"1232","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52418,"requestDate":"2018-01-03T16:40:00","title":"Ms","name":"[FirstName] 52418 Surname 52418","institution":"[Institution] 52418","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52417,"requestDate":"2018-01-03T16:38:00","title":"Ms","name":"[FirstName] 52417 Surname 52417","institution":"[Institution] 52417","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"56","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"1244","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"129","languageCode":"Armenian"}],"optin":false,"status":"Approved"},{"id":52416,"requestDate":"2018-01-03T14:32:00","title":"Mr","name":"[FirstName] 52416 Surname 52416","institution":"[Institution] 52416","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"70","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"14","languageCode":"Greek"},{"Id":"211","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"14","languageCode":"Greek"}],"optin":false,"status":"Approved"},{"id":52415,"requestDate":"2018-01-03T13:58:00","title":"Miss","name":"[FirstName] 52415 Surname 52415","institution":"[Institution] 52415","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52414,"requestDate":"2018-01-03T13:06:00","title":"Dr","name":"[FirstName] 52414 Surname 52414","institution":"[Institution] 52414","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"931","phase":"1","name":"ELD14","description":"ELD14","languageId":"10","languageCode":"English"},{"Id":"1160","phase":"4","name":"Oral Health","description":"Oral Health Module (OH15)","languageId":"10","languageCode":"English"},{"Id":"1183","phase":"2","name":"Cholangio","description":"Cholangiocarcinoma - gall bladder cancers (BIL21)","languageId":"10","languageCode":"English"},{"Id":"1192","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"10","languageCode":"English"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"122","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"},{"Id":"234","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"10","languageCode":"English"},{"Id":"247","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"10","languageCode":"English"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"},{"Id":"430","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"10","languageCode":"English"},{"Id":"458","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"10","languageCode":"English"},{"Id":"539","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"},{"Id":"647","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"10","languageCode":"English"},{"Id":"725","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"10","languageCode":"English"},{"Id":"735","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"10","languageCode":"English"},{"Id":"772","phase":"1","name":"Bone Metastases","description":"desc","languageId":"10","languageCode":"English"},{"Id":"806","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"10","languageCode":"English"},{"Id":"871","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"10","languageCode":"English"},{"Id":"1232","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52413,"requestDate":"2018-01-03T12:55:00","title":"Dr","name":"[FirstName] 52413 Surname 52413","institution":"[Institution] 52413","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"7","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"15","languageCode":"Hebrew"}],"optin":false,"status":"Approved"},{"id":52412,"requestDate":"2018-01-03T12:52:00","title":"Dr","name":"[FirstName] 52412 Surname 52412","institution":"[Institution] 52412","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1016","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"15","languageCode":"Hebrew"},{"Id":"1071","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"15","languageCode":"Hebrew"},{"Id":"1156","phase":"4","name":"Oral Health","description":"Oral Health Module (OH15)","languageId":"15","languageCode":"Hebrew"},{"Id":"71","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"15","languageCode":"Hebrew"},{"Id":"149","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"15","languageCode":"Hebrew"},{"Id":"212","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"15","languageCode":"Hebrew"},{"Id":"261","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"15","languageCode":"Hebrew"},{"Id":"375","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"15","languageCode":"Hebrew"},{"Id":"464","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"15","languageCode":"Hebrew"},{"Id":"606","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"15","languageCode":"Hebrew"},{"Id":"654","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"15","languageCode":"Hebrew"},{"Id":"876","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"15","languageCode":"Hebrew"},{"Id":"923","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"15","languageCode":"Hebrew"},{"Id":"1215","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"15","languageCode":"Hebrew"}],"optin":false,"status":"Approved"},{"id":52411,"requestDate":"2018-01-03T11:35:00","title":"Mrs.","name":"[FirstName] 52411 Surname 52411","institution":"[Institution] 52411","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52410,"requestDate":"2018-01-03T11:02:00","title":"Ms","name":"[FirstName] 52410 Surname 52410","institution":"[Institution] 52410","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"56","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"203","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"4","languageCode":"Chinese (Taiwanese)"}],"optin":false,"status":"Approved"},{"id":52409,"requestDate":"2018-01-03T08:40:00","title":"Dr","name":"[FirstName] 52409 Surname 52409","institution":"[Institution] 52409","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"330","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"111","languageCode":"Urdu (Pakistan)"}],"optin":false,"status":"Approved"},{"id":52408,"requestDate":"2018-01-03T08:00:00","title":"Prof D","name":"[FirstName] 52408 Surname 52408","institution":"[Institution] 52408","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"6","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52407,"requestDate":"2018-01-02T20:57:00","title":"Dr.","name":"[FirstName] 52407 Surname 52407","institution":"[Institution] 52407","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"},{"Id":"871","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52406,"requestDate":"2018-01-02T18:04:00","title":"Dr.","name":"[FirstName] 52406 Surname 52406","institution":"[Institution] 52406","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"931","phase":"1","name":"ELD14","description":"ELD14","languageId":"10","languageCode":"English"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52405,"requestDate":"2018-01-02T15:31:00","title":"Ms","name":"[FirstName] 52405 Surname 52405","institution":"[Institution] 52405","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"930","phase":"1","name":"ELD14","description":"ELD14","languageId":"8","languageCode":"Dutch"},{"Id":"1191","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"8","languageCode":"Dutch"},{"Id":"61","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"8","languageCode":"Dutch"},{"Id":"206","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"8","languageCode":"Dutch"},{"Id":"734","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"8","languageCode":"Dutch"},{"Id":"748","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"8","languageCode":"Dutch"}],"optin":false,"status":"Approved"},{"id":52404,"requestDate":"2018-01-02T14:57:00","title":"Ms","name":"[FirstName] 52404 Surname 52404","institution":"[Institution] 52404","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"901","phase":"4","name":"IN-PATSAT32","description":"IN-PATSAT32","languageId":"1","languageCode":"Arabic"}],"optin":false,"status":"Approved"},{"id":52403,"requestDate":"2018-01-02T14:55:00","title":"Ms","name":"[FirstName] 52403 Surname 52403","institution":"[Institution] 52403","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1151","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"1","languageCode":"Arabic"},{"Id":"535","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"91","languageCode":"Arabic 1.1"},{"Id":"536","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"92","languageCode":"Arabic 1.2"}],"optin":false,"status":"Approved"},{"id":52402,"requestDate":"2018-01-02T14:49:00","title":"Ms","name":"[FirstName] 52402 Surname 52402","institution":"[Institution] 52402","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"857","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"1","languageCode":"Arabic"}],"optin":false,"status":"Approved"},{"id":52401,"requestDate":"2018-01-02T14:42:00","title":"Dr","name":"[FirstName] 52401 Surname 52401","institution":"[Institution] 52401","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"979","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"93","languageCode":"Indonesian"},{"Id":"1092","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"93","languageCode":"Indonesian"},{"Id":"544","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"93","languageCode":"Indonesian"},{"Id":"671","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"93","languageCode":"Indonesian"}],"optin":false,"status":"Approved"},{"id":52400,"requestDate":"2018-01-02T14:35:00","title":"Dr","name":"[FirstName] 52400 Surname 52400","institution":"[Institution] 52400","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"},{"Id":"1194","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52399,"requestDate":"2018-01-02T13:31:00","title":"dr","name":"[FirstName] 52399 Surname 52399","institution":"[Institution] 52399","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"183","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"21","languageCode":"Italian"}],"optin":false,"status":"Approved"},{"id":52398,"requestDate":"2018-01-02T09:33:00","title":"Mr","name":"[FirstName] 52398 Surname 52398","institution":"[Institution] 52398","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1098","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"62","languageCode":"Chinese (Traditional HK)"}],"optin":false,"status":"Approved"},{"id":52397,"requestDate":"2018-01-02T02:23:00","title":"Ms","name":"[FirstName] 52397 Surname 52397","institution":"[Institution] 52397","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52395,"requestDate":"2018-01-02T00:11:00","title":"Ms","name":"[FirstName] 52395 Surname 52395","institution":"[Institution] 52395","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52392,"requestDate":"2018-01-01T16:14:00","title":"Dr","name":"[FirstName] 52392 Surname 52392","institution":"[Institution] 52392","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52393,"requestDate":"2018-01-01T16:14:00","title":"Dr","name":"[FirstName] 52393 Surname 52393","institution":"[Institution] 52393","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52394,"requestDate":"2018-01-01T16:14:00","title":"Dr","name":"[FirstName] 52394 Surname 52394","institution":"[Institution] 52394","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52391,"requestDate":"2018-01-01T14:52:00","title":"Dr","name":"[FirstName] 52391 Surname 52391","institution":"[Institution] 52391","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"300","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"75","languageCode":"Indian (Malayalam)"},{"Id":"342","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"75","languageCode":"Indian (Malayalam)"},{"Id":"364","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"75","languageCode":"Indian (Malayalam)"},{"Id":"449","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"75","languageCode":"Indian (Malayalam)"},{"Id":"458","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"10","languageCode":"English"},{"Id":"786","phase":"1","name":"Bone Metastases","description":"desc","languageId":"75","languageCode":"Indian (Malayalam)"}],"optin":false,"status":"Approved"},{"id":52389,"requestDate":"2018-01-01T08:17:00","title":"Dr","name":"[FirstName] 52389 Surname 52389","institution":"[Institution] 52389","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"},{"Id":"340","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"18","languageCode":"Indian (Hindi)"},{"Id":"341","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"74","languageCode":"Kannada"},{"Id":"345","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"64","languageCode":"Tamil"},{"Id":"346","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"65","languageCode":"Indian (Telegu)"}],"optin":false,"status":"Approved"},{"id":52388,"requestDate":"2018-01-01T06:29:00","title":"Dr ","name":"[FirstName] 52388 Surname 52388","institution":"[Institution] 52388","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"508","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"75","languageCode":"Indian (Malayalam)"}],"optin":false,"status":"Approved"},{"id":52387,"requestDate":"2018-01-01T06:18:00","title":"Dr","name":"[FirstName] 52387 Surname 52387","institution":"[Institution] 52387","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"273","phase":"4","name":"IN-PATSAT32","description":"IN-PATSAT32","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52386,"requestDate":"2017-12-31T21:09:00","title":"DR","name":"[FirstName] 52386 Surname 52386","institution":"[Institution] 52386","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1212","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"69","languageCode":"Spanish (Peru)"}],"optin":false,"status":"Approved"},{"id":52385,"requestDate":"2017-12-31T18:52:00","title":"dr","name":"[FirstName] 52385 Surname 52385","institution":"[Institution] 52385","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52384,"requestDate":"2017-12-31T18:45:00","title":"Dr","name":"[FirstName] 52384 Surname 52384","institution":"[Institution] 52384","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"598","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52383,"requestDate":"2017-12-31T16:34:00","title":"Dr","name":"[FirstName] 52383 Surname 52383","institution":"[Institution] 52383","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52382,"requestDate":"2017-12-31T15:53:00","title":"DR","name":"[FirstName] 52382 Surname 52382","institution":"[Institution] 52382","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1186","phase":"2","name":"Cholangio","description":"Cholangiocarcinoma - gall bladder cancers (BIL21)","languageId":"22","languageCode":"Japanese"},{"Id":"80","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"22","languageCode":"Japanese"},{"Id":"798","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"22","languageCode":"Japanese"},{"Id":"811","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"22","languageCode":"Japanese"}],"optin":false,"status":"Approved"},{"id":52381,"requestDate":"2017-12-31T15:11:00","title":"Mr","name":"[FirstName] 52381 Surname 52381","institution":"[Institution] 52381","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"154","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"21","languageCode":"Italian"}],"optin":false,"status":"Approved"},{"id":52380,"requestDate":"2017-12-31T04:47:00","title":"Dr.","name":"[FirstName] 52380 Surname 52380","institution":"[Institution] 52380","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1101","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"59","languageCode":"Malay (Singapore)"},{"Id":"566","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"95","languageCode":"Malay (Malaysia)"}],"optin":false,"status":"Approved"},{"id":52379,"requestDate":"2017-12-30T16:25:00","title":"Dr.","name":"[FirstName] 52379 Surname 52379","institution":"[Institution] 52379","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"},{"Id":"874","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52378,"requestDate":"2017-12-30T01:15:00","title":"Dr","name":"[FirstName] 52378 Surname 52378","institution":"[Institution] 52378","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"674","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"57","languageCode":"Arabic (Israël)"},{"Id":"675","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"101","languageCode":"Arabic (Lebanon)"}],"optin":false,"status":"Approved"},{"id":52377,"requestDate":"2017-12-30T01:06:00","title":"Dr","name":"[FirstName] 52377 Surname 52377","institution":"[Institution] 52377","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"676","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"56","languageCode":"Arabic (Egypt)"},{"Id":"857","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"1","languageCode":"Arabic"}],"optin":false,"status":"Approved"},{"id":52376,"requestDate":"2017-12-29T20:42:00","title":"Ms","name":"[FirstName] 52376 Surname 52376","institution":"[Institution] 52376","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"56","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"4","languageCode":"Chinese (Taiwanese)"}],"optin":false,"status":"Approved"},{"id":52375,"requestDate":"2017-12-29T18:18:00","title":"Dr.","name":"[FirstName] 52375 Surname 52375","institution":"[Institution] 52375","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52374,"requestDate":"2017-12-29T16:13:00","title":"Ms","name":"[FirstName] 52374 Surname 52374","institution":"[Institution] 52374","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52373,"requestDate":"2017-12-29T13:50:00","title":"dr","name":"[FirstName] 52373 Surname 52373","institution":"[Institution] 52373","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"219","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"26","languageCode":"Polish"},{"Id":"1198","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"26","languageCode":"Polish"}],"optin":false,"status":"Approved"},{"id":52372,"requestDate":"2017-12-29T13:32:00","title":"Ms.","name":"[FirstName] 52372 Surname 52372","institution":"[Institution] 52372","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"171","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"38","languageCode":"Turkish"},{"Id":"1232","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52371,"requestDate":"2017-12-29T13:13:00","title":"Dr","name":"[FirstName] 52371 Surname 52371","institution":"[Institution] 52371","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"183","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"21","languageCode":"Italian"},{"Id":"860","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"21","languageCode":"Italian"}],"optin":false,"status":"Approved"},{"id":52366,"requestDate":"2017-12-29T10:48:00","title":"Ms","name":"[FirstName] 52366 Surname 52366","institution":"[Institution] 52366","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"110","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"64","languageCode":"Tamil"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"293","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"64","languageCode":"Tamil"}],"optin":false,"status":"Approved"},{"id":52365,"requestDate":"2017-12-29T09:58:00","title":"MR.","name":"[FirstName] 52365 Surname 52365","institution":"[Institution] 52365","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"566","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"95","languageCode":"Malay (Malaysia)"},{"Id":"834","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"95","languageCode":"Malay (Malaysia)"}],"optin":false,"status":"Approved"},{"id":52363,"requestDate":"2017-12-29T05:08:00","title":"Ms.","name":"[FirstName] 52363 Surname 52363","institution":"[Institution] 52363","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"931","phase":"1","name":"ELD14","description":"ELD14","languageId":"10","languageCode":"English"},{"Id":"1160","phase":"4","name":"Oral Health","description":"Oral Health Module (OH15)","languageId":"10","languageCode":"English"},{"Id":"1183","phase":"2","name":"Cholangio","description":"Cholangiocarcinoma - gall bladder cancers (BIL21)","languageId":"10","languageCode":"English"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"122","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"},{"Id":"234","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"10","languageCode":"English"},{"Id":"247","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"10","languageCode":"English"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"},{"Id":"430","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"10","languageCode":"English"},{"Id":"458","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"10","languageCode":"English"},{"Id":"539","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"},{"Id":"647","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"10","languageCode":"English"},{"Id":"725","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"10","languageCode":"English"},{"Id":"735","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"10","languageCode":"English"},{"Id":"772","phase":"1","name":"Bone Metastases","description":"desc","languageId":"10","languageCode":"English"},{"Id":"806","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"10","languageCode":"English"},{"Id":"871","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"10","languageCode":"English"},{"Id":"1192","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"10","languageCode":"English"},{"Id":"1232","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52364,"requestDate":"2017-12-29T05:08:00","title":"Ms.","name":"[FirstName] 52364 Surname 52364","institution":"[Institution] 52364","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"931","phase":"1","name":"ELD14","description":"ELD14","languageId":"10","languageCode":"English"},{"Id":"1160","phase":"4","name":"Oral Health","description":"Oral Health Module (OH15)","languageId":"10","languageCode":"English"},{"Id":"1183","phase":"2","name":"Cholangio","description":"Cholangiocarcinoma - gall bladder cancers (BIL21)","languageId":"10","languageCode":"English"},{"Id":"1192","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"10","languageCode":"English"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"122","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"},{"Id":"234","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"10","languageCode":"English"},{"Id":"247","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"10","languageCode":"English"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"},{"Id":"430","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"10","languageCode":"English"},{"Id":"458","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"10","languageCode":"English"},{"Id":"539","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"},{"Id":"647","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"10","languageCode":"English"},{"Id":"725","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"10","languageCode":"English"},{"Id":"735","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"10","languageCode":"English"},{"Id":"772","phase":"1","name":"Bone Metastases","description":"desc","languageId":"10","languageCode":"English"},{"Id":"806","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"10","languageCode":"English"},{"Id":"871","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"10","languageCode":"English"},{"Id":"1232","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52362,"requestDate":"2017-12-29T04:59:00","title":"Phs","name":"[FirstName] 52362 Surname 52362","institution":"[Institution] 52362","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"103","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"48","languageCode":"Spanish (Chilean)"},{"Id":"747","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"48","languageCode":"Spanish (Chilean)"}],"optin":false,"status":"Approved"},{"id":52361,"requestDate":"2017-12-28T23:29:00","title":"Ms","name":"[FirstName] 52361 Surname 52361","institution":"[Institution] 52361","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"386","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"9","languageCode":"Dutch (Afrikaans)"}],"optin":false,"status":"Approved"},{"id":52360,"requestDate":"2017-12-28T22:45:00","title":"dr","name":"[FirstName] 52360 Surname 52360","institution":"[Institution] 52360","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"279","phase":"4","name":"IN-PATSAT32","description":"IN-PATSAT32","languageId":"26","languageCode":"Polish"}],"optin":false,"status":"Approved"},{"id":52358,"requestDate":"2017-12-28T20:24:00","title":"Dr.","name":"[FirstName] 52358 Surname 52358","institution":"[Institution] 52358","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"193","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"34","languageCode":"Spanish"},{"Id":"194","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"34","languageCode":"Spanish"},{"Id":"313","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"34","languageCode":"Spanish"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"725","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"10","languageCode":"English"},{"Id":"756","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"34","languageCode":"Spanish"},{"Id":"863","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"34","languageCode":"Spanish"}],"optin":false,"status":"Approved"},{"id":52359,"requestDate":"2017-12-28T20:24:00","title":"Dr.","name":"[FirstName] 52359 Surname 52359","institution":"[Institution] 52359","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"193","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"34","languageCode":"Spanish"},{"Id":"194","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"34","languageCode":"Spanish"},{"Id":"313","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"34","languageCode":"Spanish"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"725","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"10","languageCode":"English"},{"Id":"756","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"34","languageCode":"Spanish"},{"Id":"863","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"34","languageCode":"Spanish"}],"optin":false,"status":"Approved"},{"id":52357,"requestDate":"2017-12-28T20:21:00","title":"Dr","name":"[FirstName] 52357 Surname 52357","institution":"[Institution] 52357","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"647","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"10","languageCode":"English"},{"Id":"668","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"34","languageCode":"Spanish"},{"Id":"863","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"34","languageCode":"Spanish"}],"optin":false,"status":"Approved"},{"id":52355,"requestDate":"2017-12-28T17:59:00","title":"Dr. ","name":"[FirstName] 52355 Surname 52355","institution":"[Institution] 52355","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"6","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52354,"requestDate":"2017-12-28T17:52:00","title":"Dr ","name":"[FirstName] 52354 Surname 52354","institution":"[Institution] 52354","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"},{"Id":"640","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"74","languageCode":"Kannada"}],"optin":false,"status":"Approved"},{"id":52353,"requestDate":"2017-12-28T17:35:00","title":"Dr. ","name":"[FirstName] 52353 Surname 52353","institution":"[Institution] 52353","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"},{"Id":"124","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"13","languageCode":"German"},{"Id":"147","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"13","languageCode":"German"},{"Id":"180","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"13","languageCode":"German"},{"Id":"210","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"13","languageCode":"German"},{"Id":"237","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"13","languageCode":"German"},{"Id":"250","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"13","languageCode":"German"},{"Id":"321","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"13","languageCode":"German"},{"Id":"373","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52352,"requestDate":"2017-12-28T15:11:00","title":"Dr","name":"[FirstName] 52352 Surname 52352","institution":"[Institution] 52352","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52351,"requestDate":"2017-12-28T15:07:00","title":"Dr","name":"[FirstName] 52351 Surname 52351","institution":"[Institution] 52351","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52350,"requestDate":"2017-12-28T14:44:00","title":"","name":"[FirstName] 52350 Surname 52350","institution":"[Institution] 52350","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"168","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"34","languageCode":"Spanish"},{"Id":"863","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"34","languageCode":"Spanish"}],"optin":false,"status":"Approved"},{"id":52349,"requestDate":"2017-12-28T14:34:00","title":"","name":"[FirstName] 52349 Surname 52349","institution":"[Institution] 52349","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52348,"requestDate":"2017-12-28T03:53:00","title":"Dr.","name":"[FirstName] 52348 Surname 52348","institution":"[Institution] 52348","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52347,"requestDate":"2017-12-27T21:08:00","title":"Dr","name":"[FirstName] 52347 Surname 52347","institution":"[Institution] 52347","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"478","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"34","languageCode":"Spanish"},{"Id":"863","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"34","languageCode":"Spanish"}],"optin":false,"status":"Approved"},{"id":52346,"requestDate":"2017-12-27T19:12:00","title":"Ms","name":"[FirstName] 52346 Surname 52346","institution":"[Institution] 52346","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"75","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"18","languageCode":"Indian (Hindi)"},{"Id":"76","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"19","languageCode":"Indian (Marathi)"}],"optin":false,"status":"Approved"},{"id":52345,"requestDate":"2017-12-27T18:59:00","title":"Ms","name":"[FirstName] 52345 Surname 52345","institution":"[Institution] 52345","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"209","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"12","languageCode":"French"},{"Id":"859","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"12","languageCode":"French"}],"optin":false,"status":"Approved"},{"id":52344,"requestDate":"2017-12-27T18:18:00","title":"MS","name":"[FirstName] 52344 Surname 52344","institution":"[Institution] 52344","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52343,"requestDate":"2017-12-27T18:17:00","title":"MS","name":"[FirstName] 52343 Surname 52343","institution":"[Institution] 52343","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52341,"requestDate":"2017-12-27T17:44:00","title":"Ms","name":"[FirstName] 52341 Surname 52341","institution":"[Institution] 52341","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52342,"requestDate":"2017-12-27T17:44:00","title":"Ms","name":"[FirstName] 52342 Surname 52342","institution":"[Institution] 52342","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52340,"requestDate":"2017-12-27T16:50:00","title":"mr","name":"[FirstName] 52340 Surname 52340","institution":"[Institution] 52340","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"716","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"26","languageCode":"Polish"}],"optin":false,"status":"Approved"},{"id":52337,"requestDate":"2017-12-27T16:39:00","title":"Ms","name":"[FirstName] 52337 Surname 52337","institution":"[Institution] 52337","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"113","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"38","languageCode":"Turkish"},{"Id":"384","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"38","languageCode":"Turkish"}],"optin":false,"status":"Approved"},{"id":52336,"requestDate":"2017-12-27T16:38:00","title":"Mr","name":"[FirstName] 52336 Surname 52336","institution":"[Institution] 52336","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"970","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"30","languageCode":"Russian"},{"Id":"1100","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"11","languageCode":"Finnish"},{"Id":"53","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"3","languageCode":"Chinese"},{"Id":"56","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"64","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"11","languageCode":"Finnish"},{"Id":"80","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"22","languageCode":"Japanese"},{"Id":"88","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"28","languageCode":"Portuguese (Brazilian)"},{"Id":"91","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"30","languageCode":"Russian"},{"Id":"593","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"793","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"28","languageCode":"Portuguese (Brazilian)"},{"Id":"798","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"22","languageCode":"Japanese"},{"Id":"861","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"26","languageCode":"Polish"}],"optin":false,"status":"Approved"},{"id":52335,"requestDate":"2017-12-27T13:53:00","title":"Dr.","name":"[FirstName] 52335 Surname 52335","institution":"[Institution] 52335","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"58","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"6","languageCode":"Czech"}],"optin":false,"status":"Approved"},{"id":52334,"requestDate":"2017-12-27T12:27:00","title":"Sr","name":"[FirstName] 52334 Surname 52334","institution":"[Institution] 52334","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"35","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"34","languageCode":"Spanish"}],"optin":false,"status":"Approved"},{"id":52333,"requestDate":"2017-12-27T10:06:00","title":"mr","name":"[FirstName] 52333 Surname 52333","institution":"[Institution] 52333","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"75","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"18","languageCode":"Indian (Hindi)"}],"optin":false,"status":"Approved"},{"id":52332,"requestDate":"2017-12-27T10:00:00","title":"","name":"[FirstName] 52332 Surname 52332","institution":"[Institution] 52332","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1207","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"77","languageCode":"Bengali"}],"optin":false,"status":"Approved"},{"id":52331,"requestDate":"2017-12-27T09:58:00","title":"","name":"[FirstName] 52331 Surname 52331","institution":"[Institution] 52331","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"725","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52328,"requestDate":"2017-12-27T07:36:00","title":"Dr","name":"[FirstName] 52328 Surname 52328","institution":"[Institution] 52328","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"75","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"18","languageCode":"Indian (Hindi)"}],"optin":false,"status":"Approved"},{"id":52327,"requestDate":"2017-12-27T06:20:00","title":"Ms","name":"[FirstName] 52327 Surname 52327","institution":"[Institution] 52327","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52326,"requestDate":"2017-12-26T21:08:00","title":"Dr","name":"[FirstName] 52326 Surname 52326","institution":"[Institution] 52326","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"273","phase":"4","name":"IN-PATSAT32","description":"IN-PATSAT32","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52325,"requestDate":"2017-12-26T20:35:00","title":"Dr. ","name":"[FirstName] 52325 Surname 52325","institution":"[Institution] 52325","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"53","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"3","languageCode":"Chinese"}],"optin":false,"status":"Approved"},{"id":52324,"requestDate":"2017-12-26T20:27:00","title":"Dr","name":"[FirstName] 52324 Surname 52324","institution":"[Institution] 52324","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"931","phase":"1","name":"ELD14","description":"ELD14","languageId":"10","languageCode":"English"},{"Id":"1160","phase":"4","name":"Oral Health","description":"Oral Health Module (OH15)","languageId":"10","languageCode":"English"},{"Id":"1183","phase":"2","name":"Cholangio","description":"Cholangiocarcinoma - gall bladder cancers (BIL21)","languageId":"10","languageCode":"English"},{"Id":"1189","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"1","languageCode":"Arabic"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"122","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"10","languageCode":"English"},{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"200","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"1","languageCode":"Arabic"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"},{"Id":"234","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"10","languageCode":"English"},{"Id":"247","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"10","languageCode":"English"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"},{"Id":"430","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"10","languageCode":"English"},{"Id":"458","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"10","languageCode":"English"},{"Id":"539","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"},{"Id":"605","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"91","languageCode":"Arabic 1.1"},{"Id":"642","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"1","languageCode":"Arabic"},{"Id":"647","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"10","languageCode":"English"},{"Id":"725","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"10","languageCode":"English"},{"Id":"735","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"10","languageCode":"English"},{"Id":"769","phase":"1","name":"Bone Metastases","description":"desc","languageId":"1","languageCode":"Arabic"},{"Id":"772","phase":"1","name":"Bone Metastases","description":"desc","languageId":"10","languageCode":"English"},{"Id":"806","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"10","languageCode":"English"},{"Id":"857","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"1","languageCode":"Arabic"},{"Id":"871","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"10","languageCode":"English"},{"Id":"897","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"1","languageCode":"Arabic"},{"Id":"925","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"56","languageCode":"Arabic (Egypt)"},{"Id":"1192","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"10","languageCode":"English"},{"Id":"1232","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52322,"requestDate":"2017-12-26T18:25:00","title":"Ms.","name":"[FirstName] 52322 Surname 52322","institution":"[Institution] 52322","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"857","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"1","languageCode":"Arabic"}],"optin":false,"status":"Approved"},{"id":52323,"requestDate":"2017-12-26T18:25:00","title":"Ms.","name":"[FirstName] 52323 Surname 52323","institution":"[Institution] 52323","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"857","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"1","languageCode":"Arabic"}],"optin":false,"status":"Approved"},{"id":52321,"requestDate":"2017-12-26T17:02:00","title":"Dr.","name":"[FirstName] 52321 Surname 52321","institution":"[Institution] 52321","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"929","phase":"1","name":"ELD14","description":"ELD14","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"1190","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"56","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"453","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"799","phase":"1","name":"Bone Metastases","description":"desc","languageId":"4","languageCode":"Chinese (Taiwanese)"}],"optin":false,"status":"Approved"},{"id":52320,"requestDate":"2017-12-26T10:08:00","title":"Mr","name":"[FirstName] 52320 Surname 52320","institution":"[Institution] 52320","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"122","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"},{"Id":"234","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"10","languageCode":"English"},{"Id":"430","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"10","languageCode":"English"},{"Id":"539","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52319,"requestDate":"2017-12-26T09:48:00","title":"Mr","name":"[FirstName] 52319 Surname 52319","institution":"[Institution] 52319","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"53","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"3","languageCode":"Chinese"},{"Id":"202","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"3","languageCode":"Chinese"},{"Id":"354","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"3","languageCode":"Chinese"},{"Id":"429","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"3","languageCode":"Chinese"}],"optin":false,"status":"Approved"},{"id":52318,"requestDate":"2017-12-26T09:46:00","title":"mr","name":"[FirstName] 52318 Surname 52318","institution":"[Institution] 52318","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"53","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"3","languageCode":"Chinese"},{"Id":"354","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"3","languageCode":"Chinese"}],"optin":false,"status":"Approved"},{"id":52317,"requestDate":"2017-12-26T06:47:00","title":"Dr","name":"[FirstName] 52317 Surname 52317","institution":"[Institution] 52317","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"182","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"18","languageCode":"Indian (Hindi)"}],"optin":false,"status":"Approved"},{"id":52316,"requestDate":"2017-12-26T04:06:00","title":"Miss","name":"[FirstName] 52316 Surname 52316","institution":"[Institution] 52316","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"566","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"95","languageCode":"Malay (Malaysia)"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52314,"requestDate":"2017-12-26T02:23:00","title":"Assist","name":"[FirstName] 52314 Surname 52314","institution":"[Institution] 52314","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"56","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"720","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"4","languageCode":"Chinese (Taiwanese)"}],"optin":false,"status":"Approved"},{"id":52315,"requestDate":"2017-12-26T02:23:00","title":"Assist","name":"[FirstName] 52315 Surname 52315","institution":"[Institution] 52315","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"56","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"720","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"4","languageCode":"Chinese (Taiwanese)"}],"optin":false,"status":"Approved"},{"id":52313,"requestDate":"2017-12-25T19:58:00","title":"Mr","name":"[FirstName] 52313 Surname 52313","institution":"[Institution] 52313","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"80","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"22","languageCode":"Japanese"}],"optin":false,"status":"Approved"},{"id":52312,"requestDate":"2017-12-25T19:56:00","title":"Mr","name":"[FirstName] 52312 Surname 52312","institution":"[Institution] 52312","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"80","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"22","languageCode":"Japanese"}],"optin":false,"status":"Approved"},{"id":52311,"requestDate":"2017-12-25T18:49:00","title":"Mr","name":"[FirstName] 52311 Surname 52311","institution":"[Institution] 52311","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"929","phase":"1","name":"ELD14","description":"ELD14","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"931","phase":"1","name":"ELD14","description":"ELD14","languageId":"10","languageCode":"English"},{"Id":"1098","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"62","languageCode":"Chinese (Traditional HK)"},{"Id":"1190","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"53","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"3","languageCode":"Chinese"},{"Id":"56","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"407","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"62","languageCode":"Chinese (Traditional HK)"},{"Id":"539","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"10","languageCode":"English"},{"Id":"593","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"},{"Id":"1192","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52310,"requestDate":"2017-12-25T17:35:00","title":"Prof.","name":"[FirstName] 52310 Surname 52310","institution":"[Institution] 52310","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"939","phase":"1","name":"Bone Metastases","description":"desc","languageId":"20","languageCode":"Persian"},{"Id":"85","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"20","languageCode":"Persian"},{"Id":"808","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"13","languageCode":"German"},{"Id":"874","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52309,"requestDate":"2017-12-25T13:01:00","title":"Mr","name":"[FirstName] 52309 Surname 52309","institution":"[Institution] 52309","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52308,"requestDate":"2017-12-25T07:16:00","title":"Mr.","name":"[FirstName] 52308 Surname 52308","institution":"[Institution] 52308","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"71","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"15","languageCode":"Hebrew"},{"Id":"91","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"30","languageCode":"Russian"},{"Id":"190","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"30","languageCode":"Russian"},{"Id":"261","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"15","languageCode":"Hebrew"},{"Id":"334","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"57","languageCode":"Arabic (Israël)"},{"Id":"857","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"1","languageCode":"Arabic"}],"optin":false,"status":"Approved"},{"id":52307,"requestDate":"2017-12-25T07:01:00","title":"Dr","name":"[FirstName] 52307 Surname 52307","institution":"[Institution] 52307","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"75","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"18","languageCode":"Indian (Hindi)"},{"Id":"539","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52306,"requestDate":"2017-12-25T01:54:00","title":"Dr.","name":"[FirstName] 52306 Surname 52306","institution":"[Institution] 52306","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"53","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"3","languageCode":"Chinese"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"483","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"3","languageCode":"Chinese"}],"optin":false,"status":"Approved"},{"id":52305,"requestDate":"2017-12-24T16:40:00","title":"Dr","name":"[FirstName] 52305 Surname 52305","institution":"[Institution] 52305","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"71","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"15","languageCode":"Hebrew"},{"Id":"149","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"15","languageCode":"Hebrew"},{"Id":"1232","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52304,"requestDate":"2017-12-24T15:05:00","title":"Dr.","name":"[FirstName] 52304 Surname 52304","institution":"[Institution] 52304","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"862","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"29","languageCode":"Romanian"}],"optin":false,"status":"Approved"},{"id":52303,"requestDate":"2017-12-24T12:45:00","title":"ms","name":"[FirstName] 52303 Surname 52303","institution":"[Institution] 52303","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"71","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"15","languageCode":"Hebrew"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"149","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"15","languageCode":"Hebrew"},{"Id":"1232","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52301,"requestDate":"2017-12-23T20:44:00","title":"Dr.","name":"[FirstName] 52301 Surname 52301","institution":"[Institution] 52301","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"861","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"26","languageCode":"Polish"},{"Id":"1198","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"26","languageCode":"Polish"}],"optin":false,"status":"Approved"},{"id":52300,"requestDate":"2017-12-23T20:43:00","title":"Dr.","name":"[FirstName] 52300 Surname 52300","institution":"[Institution] 52300","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"861","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"26","languageCode":"Polish"},{"Id":"1198","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"26","languageCode":"Polish"}],"optin":false,"status":"Approved"},{"id":52299,"requestDate":"2017-12-22T20:20:00","title":"Dr","name":"[FirstName] 52299 Surname 52299","institution":"[Institution] 52299","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52297,"requestDate":"2017-12-22T13:19:00","title":"Ms","name":"[FirstName] 52297 Surname 52297","institution":"[Institution] 52297","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"470","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"26","languageCode":"Polish"},{"Id":"861","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"26","languageCode":"Polish"}],"optin":false,"status":"Approved"},{"id":52296,"requestDate":"2017-12-22T09:30:00","title":"Dr","name":"[FirstName] 52296 Surname 52296","institution":"[Institution] 52296","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"108","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"37","languageCode":"Swedish"},{"Id":"169","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"37","languageCode":"Swedish"}],"optin":false,"status":"Approved"},{"id":52295,"requestDate":"2017-12-22T08:36:00","title":"Ms","name":"[FirstName] 52295 Surname 52295","institution":"[Institution] 52295","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"3","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"8","languageCode":"Dutch"},{"Id":"4","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"5","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"12","languageCode":"French"}],"optin":false,"status":"Approved"},{"id":52294,"requestDate":"2017-12-22T03:39:00","title":"Dr.","name":"[FirstName] 52294 Surname 52294","institution":"[Institution] 52294","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1104","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"45","languageCode":"Thai"},{"Id":"247","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"10","languageCode":"English"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"},{"Id":"725","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52293,"requestDate":"2017-12-22T03:26:00","title":"Dr","name":"[FirstName] 52293 Surname 52293","institution":"[Institution] 52293","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"946","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"55","languageCode":"Chinese (Singapore mandarin)"},{"Id":"971","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"55","languageCode":"Chinese (Singapore mandarin)"},{"Id":"55","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"55","languageCode":"Chinese (Singapore mandarin)"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"458","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"10","languageCode":"English"},{"Id":"725","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52292,"requestDate":"2017-12-22T00:59:00","title":"Ms","name":"[FirstName] 52292 Surname 52292","institution":"[Institution] 52292","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"122","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"10","languageCode":"English"},{"Id":"234","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"10","languageCode":"English"},{"Id":"430","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52291,"requestDate":"2017-12-21T22:14:00","title":"Dr","name":"[FirstName] 52291 Surname 52291","institution":"[Institution] 52291","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"122","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"},{"Id":"234","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"10","languageCode":"English"},{"Id":"247","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"10","languageCode":"English"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52290,"requestDate":"2017-12-21T20:22:00","title":"Dr","name":"[FirstName] 52290 Surname 52290","institution":"[Institution] 52290","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1189","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"1","languageCode":"Arabic"},{"Id":"1190","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"1192","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"10","languageCode":"English"},{"Id":"1193","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"12","languageCode":"French"},{"Id":"1201","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"34","languageCode":"Spanish"}],"optin":false,"status":"Approved"},{"id":52289,"requestDate":"2017-12-21T19:55:00","title":"","name":"[FirstName] 52289 Surname 52289","institution":"[Institution] 52289","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52288,"requestDate":"2017-12-21T19:50:00","title":"Ms","name":"[FirstName] 52288 Surname 52288","institution":"[Institution] 52288","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"861","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"26","languageCode":"Polish"}],"optin":false,"status":"Approved"},{"id":52287,"requestDate":"2017-12-21T19:30:00","title":"Ms","name":"[FirstName] 52287 Surname 52287","institution":"[Institution] 52287","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"778","phase":"1","name":"Bone Metastases","description":"desc","languageId":"28","languageCode":"Portuguese (Brazilian)"}],"optin":false,"status":"Approved"},{"id":52286,"requestDate":"2017-12-21T18:53:00","title":"Dr.","name":"[FirstName] 52286 Surname 52286","institution":"[Institution] 52286","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"931","phase":"1","name":"ELD14","description":"ELD14","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"247","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"10","languageCode":"English"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"458","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"},{"Id":"725","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52285,"requestDate":"2017-12-21T17:06:00","title":"Dr","name":"[FirstName] 52285 Surname 52285","institution":"[Institution] 52285","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52283,"requestDate":"2017-12-21T14:16:00","title":"Mr","name":"[FirstName] 52283 Surname 52283","institution":"[Institution] 52283","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"142","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"7","languageCode":"Danish"},{"Id":"858","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"7","languageCode":"Danish"}],"optin":false,"status":"Approved"},{"id":52282,"requestDate":"2017-12-21T14:09:00","title":"Mr","name":"[FirstName] 52282 Surname 52282","institution":"[Institution] 52282","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"272","phase":"4","name":"IN-PATSAT32","description":"IN-PATSAT32","languageId":"8","languageCode":"Dutch"},{"Id":"273","phase":"4","name":"IN-PATSAT32","description":"IN-PATSAT32","languageId":"10","languageCode":"English"},{"Id":"274","phase":"4","name":"IN-PATSAT32","description":"IN-PATSAT32","languageId":"12","languageCode":"French"},{"Id":"275","phase":"4","name":"IN-PATSAT32","description":"IN-PATSAT32","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52280,"requestDate":"2017-12-21T11:32:00","title":"Ms","name":"[FirstName] 52280 Surname 52280","institution":"[Institution] 52280","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1266","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"28","languageCode":"Portuguese (Brazilian)"}],"optin":false,"status":"Approved"},{"id":52281,"requestDate":"2017-12-21T11:32:00","title":"Ms","name":"[FirstName] 52281 Surname 52281","institution":"[Institution] 52281","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1266","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"28","languageCode":"Portuguese (Brazilian)"}],"optin":false,"status":"Approved"},{"id":52279,"requestDate":"2017-12-21T09:05:00","title":"Ms","name":"[FirstName] 52279 Surname 52279","institution":"[Institution] 52279","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"931","phase":"1","name":"ELD14","description":"ELD14","languageId":"10","languageCode":"English"},{"Id":"1005","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"75","languageCode":"Indian (Malayalam)"},{"Id":"1006","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"75","languageCode":"Indian (Malayalam)"},{"Id":"1160","phase":"4","name":"Oral Health","description":"Oral Health Module (OH15)","languageId":"10","languageCode":"English"},{"Id":"1183","phase":"2","name":"Cholangio","description":"Cholangiocarcinoma - gall bladder cancers (BIL21)","languageId":"10","languageCode":"English"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"122","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"},{"Id":"234","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"10","languageCode":"English"},{"Id":"247","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"10","languageCode":"English"},{"Id":"300","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"75","languageCode":"Indian (Malayalam)"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"342","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"75","languageCode":"Indian (Malayalam)"},{"Id":"364","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"75","languageCode":"Indian (Malayalam)"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"},{"Id":"430","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"10","languageCode":"English"},{"Id":"449","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"75","languageCode":"Indian (Malayalam)"},{"Id":"458","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"10","languageCode":"English"},{"Id":"539","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"10","languageCode":"English"},{"Id":"552","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"75","languageCode":"Indian (Malayalam)"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"},{"Id":"647","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"10","languageCode":"English"},{"Id":"725","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"10","languageCode":"English"},{"Id":"735","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"10","languageCode":"English"},{"Id":"753","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"75","languageCode":"Indian (Malayalam)"},{"Id":"767","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"75","languageCode":"Indian (Malayalam)"},{"Id":"772","phase":"1","name":"Bone Metastases","description":"desc","languageId":"10","languageCode":"English"},{"Id":"786","phase":"1","name":"Bone Metastases","description":"desc","languageId":"75","languageCode":"Indian (Malayalam)"},{"Id":"806","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"10","languageCode":"English"},{"Id":"871","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"10","languageCode":"English"},{"Id":"1192","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"10","languageCode":"English"},{"Id":"1232","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"10","languageCode":"English"},{"Id":"1262","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"75","languageCode":"Indian (Malayalam)"}],"optin":false,"status":"Approved"},{"id":52278,"requestDate":"2017-12-21T07:33:00","title":"Dr","name":"[FirstName] 52278 Surname 52278","institution":"[Institution] 52278","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52277,"requestDate":"2017-12-21T05:09:00","title":"Ms","name":"[FirstName] 52277 Surname 52277","institution":"[Institution] 52277","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"4","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52276,"requestDate":"2017-12-21T03:26:00","title":"Dr","name":"[FirstName] 52276 Surname 52276","institution":"[Institution] 52276","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"931","phase":"1","name":"ELD14","description":"ELD14","languageId":"10","languageCode":"English"},{"Id":"961","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"77","languageCode":"Bengali"},{"Id":"1091","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"77","languageCode":"Bengali"},{"Id":"1160","phase":"4","name":"Oral Health","description":"Oral Health Module (OH15)","languageId":"10","languageCode":"English"},{"Id":"1179","phase":"2","name":"Cholangio","description":"Cholangiocarcinoma - gall bladder cancers (BIL21)","languageId":"77","languageCode":"Bengali"},{"Id":"1183","phase":"2","name":"Cholangio","description":"Cholangiocarcinoma - gall bladder cancers (BIL21)","languageId":"10","languageCode":"English"},{"Id":"1192","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"10","languageCode":"English"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"122","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"},{"Id":"234","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"10","languageCode":"English"},{"Id":"247","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"10","languageCode":"English"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"336","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"77","languageCode":"Bengali"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"},{"Id":"401","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"77","languageCode":"Bengali"},{"Id":"427","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"77","languageCode":"Bengali"},{"Id":"430","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"10","languageCode":"English"},{"Id":"458","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"10","languageCode":"English"},{"Id":"539","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"10","languageCode":"English"},{"Id":"547","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"77","languageCode":"Bengali"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"},{"Id":"647","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"10","languageCode":"English"},{"Id":"725","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"10","languageCode":"English"},{"Id":"735","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"10","languageCode":"English"},{"Id":"757","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"77","languageCode":"Bengali"},{"Id":"772","phase":"1","name":"Bone Metastases","description":"desc","languageId":"10","languageCode":"English"},{"Id":"806","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"10","languageCode":"English"},{"Id":"837","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"77","languageCode":"Bengali"},{"Id":"871","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"10","languageCode":"English"},{"Id":"1203","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"77","languageCode":"Bengali"},{"Id":"1207","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"77","languageCode":"Bengali"},{"Id":"1232","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"10","languageCode":"English"},{"Id":"1259","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"77","languageCode":"Bengali"}],"optin":false,"status":"Approved"},{"id":52275,"requestDate":"2017-12-21T03:16:00","title":"Dr","name":"[FirstName] 52275 Surname 52275","institution":"[Institution] 52275","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"961","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"77","languageCode":"Bengali"},{"Id":"1091","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"77","languageCode":"Bengali"},{"Id":"336","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"77","languageCode":"Bengali"},{"Id":"401","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"77","languageCode":"Bengali"},{"Id":"427","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"77","languageCode":"Bengali"},{"Id":"547","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"77","languageCode":"Bengali"},{"Id":"757","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"77","languageCode":"Bengali"},{"Id":"1203","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"77","languageCode":"Bengali"},{"Id":"1207","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"77","languageCode":"Bengali"},{"Id":"1259","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"77","languageCode":"Bengali"}],"optin":false,"status":"Approved"},{"id":52274,"requestDate":"2017-12-20T22:00:00","title":"Dr","name":"[FirstName] 52274 Surname 52274","institution":"[Institution] 52274","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"976","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"49","languageCode":"Spanish (Colombian)"},{"Id":"1012","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"49","languageCode":"Spanish (Colombian)"},{"Id":"104","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"49","languageCode":"Spanish (Colombian)"},{"Id":"332","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"49","languageCode":"Spanish (Colombian)"},{"Id":"491","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"49","languageCode":"Spanish (Colombian)"},{"Id":"611","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"49","languageCode":"Spanish (Colombian)"},{"Id":"763","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"49","languageCode":"Spanish (Colombian)"},{"Id":"1246","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"49","languageCode":"Spanish (Colombian)"}],"optin":false,"status":"Approved"},{"id":52273,"requestDate":"2017-12-20T21:16:00","title":"Mr. ","name":"[FirstName] 52273 Surname 52273","institution":"[Institution] 52273","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"647","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"10","languageCode":"English"},{"Id":"668","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"34","languageCode":"Spanish"},{"Id":"863","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"34","languageCode":"Spanish"}],"optin":false,"status":"Approved"},{"id":52272,"requestDate":"2017-12-20T21:10:00","title":"Mr.","name":"[FirstName] 52272 Surname 52272","institution":"[Institution] 52272","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52271,"requestDate":"2017-12-20T20:44:00","title":"Dr.","name":"[FirstName] 52271 Surname 52271","institution":"[Institution] 52271","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"394","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"68","languageCode":"Spanish (US)"}],"optin":false,"status":"Approved"},{"id":52270,"requestDate":"2017-12-20T20:37:00","title":"Mr","name":"[FirstName] 52270 Surname 52270","institution":"[Institution] 52270","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52269,"requestDate":"2017-12-20T20:34:00","title":"dra","name":"[FirstName] 52269 Surname 52269","institution":"[Institution] 52269","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"107","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"52","languageCode":"Spanish (Mexican)"},{"Id":"745","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"52","languageCode":"Spanish (Mexican)"}],"optin":false,"status":"Approved"},{"id":52267,"requestDate":"2017-12-20T19:37:00","title":"Dr","name":"[FirstName] 52267 Surname 52267","institution":"[Institution] 52267","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1024","phase":"1","name":"ELD14","description":"ELD14","languageId":"7","languageCode":"Danish"},{"Id":"854","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"7","languageCode":"Danish"},{"Id":"858","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"7","languageCode":"Danish"}],"optin":false,"status":"Approved"},{"id":52265,"requestDate":"2017-12-20T17:43:00","title":"Dr","name":"[FirstName] 52265 Surname 52265","institution":"[Institution] 52265","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"336","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"77","languageCode":"Bengali"},{"Id":"427","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"77","languageCode":"Bengali"}],"optin":false,"status":"Approved"},{"id":52264,"requestDate":"2017-12-20T17:20:00","title":"Dr-","name":"[FirstName] 52264 Surname 52264","institution":"[Institution] 52264","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"107","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"52","languageCode":"Spanish (Mexican)"},{"Id":"764","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"52","languageCode":"Spanish (Mexican)"}],"optin":false,"status":"Approved"},{"id":52263,"requestDate":"2017-12-20T17:15:00","title":"dr","name":"[FirstName] 52263 Surname 52263","institution":"[Institution] 52263","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52262,"requestDate":"2017-12-20T12:48:00","title":"Mr","name":"[FirstName] 52262 Surname 52262","institution":"[Institution] 52262","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"458","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52261,"requestDate":"2017-12-20T11:12:00","title":"Dr.","name":"[FirstName] 52261 Surname 52261","institution":"[Institution] 52261","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52260,"requestDate":"2017-12-20T10:47:00","title":"Dr.","name":"[FirstName] 52260 Surname 52260","institution":"[Institution] 52260","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"122","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52259,"requestDate":"2017-12-20T10:13:00","title":"ms","name":"[FirstName] 52259 Surname 52259","institution":"[Institution] 52259","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"93","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"43","languageCode":"Sinhala"},{"Id":"537","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"43","languageCode":"Sinhala"},{"Id":"830","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"105","languageCode":"Tamil (Sri Lanka)"}],"optin":false,"status":"Approved"},{"id":52258,"requestDate":"2017-12-20T09:49:00","title":"Dr","name":"[FirstName] 52258 Surname 52258","institution":"[Institution] 52258","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"640","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"74","languageCode":"Kannada"},{"Id":"698","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"74","languageCode":"Kannada"}],"optin":false,"status":"Approved"},{"id":52256,"requestDate":"2017-12-20T08:38:00","title":"Dr.","name":"[FirstName] 52256 Surname 52256","institution":"[Institution] 52256","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"704","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"29","languageCode":"Romanian"}],"optin":false,"status":"Approved"},{"id":52255,"requestDate":"2017-12-20T05:50:00","title":"Dr","name":"[FirstName] 52255 Surname 52255","institution":"[Institution] 52255","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"75","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"18","languageCode":"Indian (Hindi)"},{"Id":"111","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"65","languageCode":"Indian (Telegu)"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"744","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"18","languageCode":"Indian (Hindi)"}],"optin":false,"status":"Approved"},{"id":52254,"requestDate":"2017-12-20T05:08:00","title":"Dr.","name":"[FirstName] 52254 Surname 52254","institution":"[Institution] 52254","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"109","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"63","languageCode":"Tagalog (Philipinnes)"}],"optin":false,"status":"Approved"},{"id":52253,"requestDate":"2017-12-20T01:35:00","title":"Mr.","name":"[FirstName] 52253 Surname 52253","institution":"[Institution] 52253","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"993","phase":"1","name":"Bone Metastases","description":"desc","languageId":"3","languageCode":"Chinese"},{"Id":"53","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"3","languageCode":"Chinese"},{"Id":"202","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"3","languageCode":"Chinese"},{"Id":"802","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"3","languageCode":"Chinese"}],"optin":false,"status":"Approved"},{"id":52252,"requestDate":"2017-12-20T01:32:00","title":"Mr","name":"[FirstName] 52252 Surname 52252","institution":"[Institution] 52252","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"56","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"4","languageCode":"Chinese (Taiwanese)"}],"optin":false,"status":"Approved"},{"id":52251,"requestDate":"2017-12-19T18:37:00","title":"Ms","name":"[FirstName] 52251 Surname 52251","institution":"[Institution] 52251","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52250,"requestDate":"2017-12-19T16:51:00","title":"Mr","name":"[FirstName] 52250 Surname 52250","institution":"[Institution] 52250","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"936","phase":"1","name":"ELD14","description":"ELD14","languageId":"34","languageCode":"Spanish"},{"Id":"133","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"34","languageCode":"Spanish"},{"Id":"168","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"34","languageCode":"Spanish"},{"Id":"193","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"34","languageCode":"Spanish"},{"Id":"194","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"34","languageCode":"Spanish"},{"Id":"226","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"34","languageCode":"Spanish"},{"Id":"241","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"34","languageCode":"Spanish"},{"Id":"256","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"34","languageCode":"Spanish"},{"Id":"313","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"34","languageCode":"Spanish"},{"Id":"382","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"34","languageCode":"Spanish"},{"Id":"478","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"34","languageCode":"Spanish"},{"Id":"518","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"34","languageCode":"Spanish"},{"Id":"668","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"34","languageCode":"Spanish"},{"Id":"672","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"34","languageCode":"Spanish"},{"Id":"741","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"34","languageCode":"Spanish"},{"Id":"756","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"34","languageCode":"Spanish"},{"Id":"780","phase":"1","name":"Bone Metastases","description":"desc","languageId":"34","languageCode":"Spanish"},{"Id":"819","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"34","languageCode":"Spanish"},{"Id":"863","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"34","languageCode":"Spanish"},{"Id":"890","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"34","languageCode":"Spanish"},{"Id":"1201","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"34","languageCode":"Spanish"},{"Id":"1282","phase":"4","name":"Spiritual Wellbeing","description":"Spiritual Wellbeing (SWB32)","languageId":"34","languageCode":"Spanish"}],"optin":false,"status":"Approved"},{"id":52247,"requestDate":"2017-12-19T13:29:00","title":"Mr.","name":"[FirstName] 52247 Surname 52247","institution":"[Institution] 52247","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"197","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"38","languageCode":"Turkish"}],"optin":false,"status":"Approved"},{"id":52246,"requestDate":"2017-12-19T13:28:00","title":"Srta","name":"[FirstName] 52246 Surname 52246","institution":"[Institution] 52246","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"162","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"28","languageCode":"Portuguese (Brazilian)"},{"Id":"221","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"28","languageCode":"Portuguese (Brazilian)"},{"Id":"403","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"28","languageCode":"Portuguese (Brazilian)"},{"Id":"471","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"28","languageCode":"Portuguese (Brazilian)"},{"Id":"793","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"28","languageCode":"Portuguese (Brazilian)"}],"optin":false,"status":"Approved"},{"id":52245,"requestDate":"2017-12-19T12:18:00","title":"Ms","name":"[FirstName] 52245 Surname 52245","institution":"[Institution] 52245","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"61","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"8","languageCode":"Dutch"},{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"},{"Id":"859","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"12","languageCode":"French"}],"optin":false,"status":"Approved"},{"id":52244,"requestDate":"2017-12-19T12:10:00","title":"Dr.","name":"[FirstName] 52244 Surname 52244","institution":"[Institution] 52244","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52243,"requestDate":"2017-12-19T11:41:00","title":"Mr","name":"[FirstName] 52243 Surname 52243","institution":"[Institution] 52243","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"300","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"75","languageCode":"Indian (Malayalam)"},{"Id":"364","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"75","languageCode":"Indian (Malayalam)"}],"optin":false,"status":"Approved"},{"id":52242,"requestDate":"2017-12-19T11:35:00","title":"Mr","name":"[FirstName] 52242 Surname 52242","institution":"[Institution] 52242","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"299","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"74","languageCode":"Kannada"},{"Id":"640","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"74","languageCode":"Kannada"}],"optin":false,"status":"Approved"},{"id":52241,"requestDate":"2017-12-19T10:28:00","title":"Dr","name":"[FirstName] 52241 Surname 52241","institution":"[Institution] 52241","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"61","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"8","languageCode":"Dutch"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"},{"Id":"695","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"21","languageCode":"Italian"},{"Id":"748","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"8","languageCode":"Dutch"},{"Id":"860","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"21","languageCode":"Italian"}],"optin":false,"status":"Approved"},{"id":52240,"requestDate":"2017-12-19T10:27:00","title":"ms","name":"[FirstName] 52240 Surname 52240","institution":"[Institution] 52240","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"935","phase":"1","name":"ELD14","description":"ELD14","languageId":"21","languageCode":"Italian"},{"Id":"183","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"21","languageCode":"Italian"},{"Id":"289","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"21","languageCode":"Italian"},{"Id":"320","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"21","languageCode":"Italian"},{"Id":"657","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"21","languageCode":"Italian"},{"Id":"860","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"21","languageCode":"Italian"},{"Id":"1195","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"21","languageCode":"Italian"}],"optin":false,"status":"Approved"},{"id":52239,"requestDate":"2017-12-19T10:15:00","title":"Dr","name":"[FirstName] 52239 Surname 52239","institution":"[Institution] 52239","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"75","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"18","languageCode":"Indian (Hindi)"},{"Id":"266","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"70","languageCode":"Indian (Punjabi)"}],"optin":false,"status":"Approved"},{"id":52235,"requestDate":"2017-12-19T07:44:00","title":"Ms.","name":"[FirstName] 52235 Surname 52235","institution":"[Institution] 52235","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"566","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"95","languageCode":"Malay (Malaysia)"}],"optin":false,"status":"Approved"},{"id":52236,"requestDate":"2017-12-19T07:44:00","title":"Ms.","name":"[FirstName] 52236 Surname 52236","institution":"[Institution] 52236","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"566","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"95","languageCode":"Malay (Malaysia)"}],"optin":false,"status":"Approved"},{"id":52237,"requestDate":"2017-12-19T07:44:00","title":"Ms.","name":"[FirstName] 52237 Surname 52237","institution":"[Institution] 52237","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"566","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"95","languageCode":"Malay (Malaysia)"}],"optin":false,"status":"Approved"},{"id":52238,"requestDate":"2017-12-19T07:44:00","title":"Ms.","name":"[FirstName] 52238 Surname 52238","institution":"[Institution] 52238","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"566","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"95","languageCode":"Malay (Malaysia)"}],"optin":false,"status":"Approved"},{"id":52234,"requestDate":"2017-12-19T04:16:00","title":"Dr.","name":"[FirstName] 52234 Surname 52234","institution":"[Institution] 52234","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"931","phase":"1","name":"ELD14","description":"ELD14","languageId":"10","languageCode":"English"},{"Id":"1090","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"63","languageCode":"Tagalog (Philipinnes)"},{"Id":"1132","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"63","languageCode":"Tagalog (Philipinnes)"},{"Id":"1160","phase":"4","name":"Oral Health","description":"Oral Health Module (OH15)","languageId":"10","languageCode":"English"},{"Id":"1183","phase":"2","name":"Cholangio","description":"Cholangiocarcinoma - gall bladder cancers (BIL21)","languageId":"10","languageCode":"English"},{"Id":"1192","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"10","languageCode":"English"},{"Id":"53","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"3","languageCode":"Chinese"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"122","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"202","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"3","languageCode":"Chinese"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"},{"Id":"234","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"10","languageCode":"English"},{"Id":"247","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"10","languageCode":"English"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"354","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"3","languageCode":"Chinese"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"},{"Id":"429","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"3","languageCode":"Chinese"},{"Id":"430","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"10","languageCode":"English"},{"Id":"458","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"10","languageCode":"English"},{"Id":"483","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"3","languageCode":"Chinese"},{"Id":"488","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"3","languageCode":"Chinese"},{"Id":"539","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"},{"Id":"629","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"3","languageCode":"Chinese"},{"Id":"647","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"10","languageCode":"English"},{"Id":"678","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"3","languageCode":"Chinese"},{"Id":"725","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"10","languageCode":"English"},{"Id":"735","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"10","languageCode":"English"},{"Id":"772","phase":"1","name":"Bone Metastases","description":"desc","languageId":"10","languageCode":"English"},{"Id":"806","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"10","languageCode":"English"},{"Id":"871","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"10","languageCode":"English"},{"Id":"915","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"3","languageCode":"Chinese"},{"Id":"1232","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52232,"requestDate":"2017-12-19T01:39:00","title":"Mrs","name":"[FirstName] 52232 Surname 52232","institution":"[Institution] 52232","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1243","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"129","languageCode":"Armenian"},{"Id":"1244","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"129","languageCode":"Armenian"}],"optin":false,"status":"Approved"},{"id":52233,"requestDate":"2017-12-19T01:39:00","title":"Mrs","name":"[FirstName] 52233 Surname 52233","institution":"[Institution] 52233","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1243","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"129","languageCode":"Armenian"},{"Id":"1244","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"129","languageCode":"Armenian"}],"optin":false,"status":"Approved"},{"id":52231,"requestDate":"2017-12-18T22:03:00","title":"DR","name":"[FirstName] 52231 Surname 52231","institution":"[Institution] 52231","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"4","phase":"4","name":"CoreC15","description":"QLQ-C15-PAL Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52230,"requestDate":"2017-12-18T20:18:00","title":"Ms","name":"[FirstName] 52230 Surname 52230","institution":"[Institution] 52230","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1164","phase":"4","name":"Oral Health","description":"Oral Health Module (OH15)","languageId":"26","languageCode":"Polish"},{"Id":"1172","phase":"1","name":"ELD14","description":"ELD14","languageId":"26","languageCode":"Polish"},{"Id":"160","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"26","languageCode":"Polish"},{"Id":"188","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"26","languageCode":"Polish"},{"Id":"219","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"26","languageCode":"Polish"},{"Id":"239","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"26","languageCode":"Polish"},{"Id":"253","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"26","languageCode":"Polish"},{"Id":"317","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"26","languageCode":"Polish"},{"Id":"378","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"26","languageCode":"Polish"},{"Id":"410","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"26","languageCode":"Polish"},{"Id":"470","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"26","languageCode":"Polish"},{"Id":"542","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"26","languageCode":"Polish"},{"Id":"662","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"26","languageCode":"Polish"},{"Id":"716","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"26","languageCode":"Polish"},{"Id":"759","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"26","languageCode":"Polish"},{"Id":"789","phase":"1","name":"Bone Metastases","description":"desc","languageId":"26","languageCode":"Polish"},{"Id":"794","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"26","languageCode":"Polish"},{"Id":"797","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"26","languageCode":"Polish"},{"Id":"814","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"26","languageCode":"Polish"},{"Id":"861","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"26","languageCode":"Polish"},{"Id":"883","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"26","languageCode":"Polish"},{"Id":"1198","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"26","languageCode":"Polish"}],"optin":false,"status":"Approved"},{"id":52229,"requestDate":"2017-12-18T18:04:00","title":"Ms","name":"[FirstName] 52229 Surname 52229","institution":"[Institution] 52229","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"156","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"42","languageCode":"Korean"}],"optin":false,"status":"Approved"},{"id":52228,"requestDate":"2017-12-18T16:58:00","title":"Dr. ","name":"[FirstName] 52228 Surname 52228","institution":"[Institution] 52228","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52226,"requestDate":"2017-12-18T15:43:00","title":"nurse ","name":"[FirstName] 52226 Surname 52226","institution":"[Institution] 52226","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"146","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"12","languageCode":"French"}],"optin":false,"status":"Approved"},{"id":52227,"requestDate":"2017-12-18T15:43:00","title":"Mr","name":"[FirstName] 52227 Surname 52227","institution":"[Institution] 52227","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"80","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"22","languageCode":"Japanese"},{"Id":"127","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"22","languageCode":"Japanese"}],"optin":false,"status":"Approved"},{"id":52225,"requestDate":"2017-12-18T15:13:00","title":"Nurse","name":"[FirstName] 52225 Surname 52225","institution":"[Institution] 52225","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"857","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"1","languageCode":"Arabic"}],"optin":false,"status":"Approved"},{"id":52224,"requestDate":"2017-12-18T14:51:00","title":"Dr.","name":"[FirstName] 52224 Surname 52224","institution":"[Institution] 52224","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1028","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"63","languageCode":"Tagalog (Philipinnes)"},{"Id":"109","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"63","languageCode":"Tagalog (Philipinnes)"},{"Id":"428","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"63","languageCode":"Tagalog (Philipinnes)"},{"Id":"520","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"63","languageCode":"Tagalog (Philipinnes)"},{"Id":"824","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"63","languageCode":"Tagalog (Philipinnes)"},{"Id":"917","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"63","languageCode":"Tagalog (Philipinnes)"},{"Id":"1219","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"63","languageCode":"Tagalog (Philipinnes)"}],"optin":false,"status":"Approved"},{"id":52223,"requestDate":"2017-12-18T13:31:00","title":"Dr","name":"[FirstName] 52223 Surname 52223","institution":"[Institution] 52223","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1233","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"21","languageCode":"Italian"}],"optin":false,"status":"Approved"},{"id":52221,"requestDate":"2017-12-18T11:45:00","title":"Dr","name":"[FirstName] 52221 Surname 52221","institution":"[Institution] 52221","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"219","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"26","languageCode":"Polish"},{"Id":"861","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"26","languageCode":"Polish"}],"optin":false,"status":"Approved"},{"id":52220,"requestDate":"2017-12-18T10:12:00","title":"Ms.","name":"[FirstName] 52220 Surname 52220","institution":"[Institution] 52220","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"53","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"3","languageCode":"Chinese"},{"Id":"56","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"4","languageCode":"Chinese (Taiwanese)"}],"optin":false,"status":"Approved"},{"id":52219,"requestDate":"2017-12-18T10:07:00","title":"Dr","name":"[FirstName] 52219 Surname 52219","institution":"[Institution] 52219","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"154","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"21","languageCode":"Italian"},{"Id":"860","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"21","languageCode":"Italian"}],"optin":false,"status":"Approved"},{"id":52218,"requestDate":"2017-12-18T02:01:00","title":"Dr. ","name":"[FirstName] 52218 Surname 52218","institution":"[Institution] 52218","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"647","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"10","languageCode":"English"},{"Id":"668","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"34","languageCode":"Spanish"},{"Id":"863","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"34","languageCode":"Spanish"}],"optin":false,"status":"Approved"},{"id":52217,"requestDate":"2017-12-18T01:22:00","title":"M","name":"[FirstName] 52217 Surname 52217","institution":"[Institution] 52217","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"209","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"12","languageCode":"French"}],"optin":false,"status":"Approved"},{"id":52216,"requestDate":"2017-12-18T00:30:00","title":"PD Dr.","name":"[FirstName] 52216 Surname 52216","institution":"[Institution] 52216","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"933","phase":"1","name":"ELD14","description":"ELD14","languageId":"13","languageCode":"German"},{"Id":"1158","phase":"4","name":"Oral Health","description":"Oral Health Module (OH15)","languageId":"13","languageCode":"German"},{"Id":"1184","phase":"2","name":"Cholangio","description":"Cholangiocarcinoma - gall bladder cancers (BIL21)","languageId":"13","languageCode":"German"},{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"},{"Id":"124","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"13","languageCode":"German"},{"Id":"147","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"13","languageCode":"German"},{"Id":"180","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"13","languageCode":"German"},{"Id":"210","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"13","languageCode":"German"},{"Id":"237","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"13","languageCode":"German"},{"Id":"250","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"13","languageCode":"German"},{"Id":"321","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"13","languageCode":"German"},{"Id":"373","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"13","languageCode":"German"},{"Id":"462","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"13","languageCode":"German"},{"Id":"541","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"13","languageCode":"German"},{"Id":"598","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"13","languageCode":"German"},{"Id":"625","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"13","languageCode":"German"},{"Id":"651","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"13","languageCode":"German"},{"Id":"727","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"13","languageCode":"German"},{"Id":"737","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"13","languageCode":"German"},{"Id":"792","phase":"1","name":"Bone Metastases","description":"desc","languageId":"13","languageCode":"German"},{"Id":"808","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"13","languageCode":"German"},{"Id":"874","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"13","languageCode":"German"},{"Id":"1194","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"13","languageCode":"German"},{"Id":"1256","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"13","languageCode":"German"},{"Id":"1274","phase":"4","name":"Spiritual Wellbeing","description":"Spiritual Wellbeing (SWB32)","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52214,"requestDate":"2017-12-18T00:27:00","title":"","name":"[FirstName] 52214 Surname 52214","institution":"[Institution] 52214","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52215,"requestDate":"2017-12-18T00:27:00","title":"","name":"[FirstName] 52215 Surname 52215","institution":"[Institution] 52215","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52213,"requestDate":"2017-12-17T23:34:00","title":"Dr","name":"[FirstName] 52213 Surname 52213","institution":"[Institution] 52213","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"168","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"34","languageCode":"Spanish"},{"Id":"863","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"34","languageCode":"Spanish"}],"optin":false,"status":"Approved"},{"id":52212,"requestDate":"2017-12-17T21:50:00","title":"Ms","name":"[FirstName] 52212 Surname 52212","institution":"[Institution] 52212","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"87","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"27","languageCode":"Portuguese"}],"optin":false,"status":"Approved"},{"id":52211,"requestDate":"2017-12-17T21:33:00","title":"Dr","name":"[FirstName] 52211 Surname 52211","institution":"[Institution] 52211","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"45","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"2","languageCode":"Bulgarian"},{"Id":"451","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"2","languageCode":"Bulgarian"}],"optin":false,"status":"Approved"},{"id":52210,"requestDate":"2017-12-17T19:09:00","title":"Dr","name":"[FirstName] 52210 Surname 52210","institution":"[Institution] 52210","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"72","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"16","languageCode":"Hungarian"}],"optin":false,"status":"Approved"},{"id":52209,"requestDate":"2017-12-17T19:02:00","title":"Mrs","name":"[FirstName] 52209 Surname 52209","institution":"[Institution] 52209","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"935","phase":"1","name":"ELD14","description":"ELD14","languageId":"21","languageCode":"Italian"},{"Id":"154","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"21","languageCode":"Italian"},{"Id":"251","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"21","languageCode":"Italian"},{"Id":"657","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"21","languageCode":"Italian"},{"Id":"738","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"21","languageCode":"Italian"},{"Id":"776","phase":"1","name":"Bone Metastases","description":"desc","languageId":"21","languageCode":"Italian"},{"Id":"860","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"21","languageCode":"Italian"},{"Id":"1195","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"21","languageCode":"Italian"},{"Id":"1233","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"21","languageCode":"Italian"}],"optin":false,"status":"Approved"},{"id":52208,"requestDate":"2017-12-17T14:49:00","title":"ms","name":"[FirstName] 52208 Surname 52208","institution":"[Institution] 52208","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"168","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"34","languageCode":"Spanish"}],"optin":false,"status":"Approved"},{"id":52204,"requestDate":"2017-12-17T13:49:00","title":"mrs","name":"[FirstName] 52204 Surname 52204","institution":"[Institution] 52204","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"939","phase":"1","name":"Bone Metastases","description":"desc","languageId":"20","languageCode":"Persian"},{"Id":"85","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"20","languageCode":"Persian"},{"Id":"159","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"20","languageCode":"Persian"},{"Id":"298","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"20","languageCode":"Persian"},{"Id":"673","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"20","languageCode":"Persian"},{"Id":"746","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"20","languageCode":"Persian"},{"Id":"760","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"20","languageCode":"Persian"},{"Id":"846","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"20","languageCode":"Persian"},{"Id":"1279","phase":"4","name":"Spiritual Wellbeing","description":"Spiritual Wellbeing (SWB32)","languageId":"20","languageCode":"Persian"}],"optin":false,"status":"Approved"},{"id":52203,"requestDate":"2017-12-17T00:50:00","title":"Dr","name":"[FirstName] 52203 Surname 52203","institution":"[Institution] 52203","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"273","phase":"4","name":"IN-PATSAT32","description":"IN-PATSAT32","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52202,"requestDate":"2017-12-16T21:25:00","title":"Dr","name":"[FirstName] 52202 Surname 52202","institution":"[Institution] 52202","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"70","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"14","languageCode":"Greek"},{"Id":"148","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"14","languageCode":"Greek"}],"optin":false,"status":"Approved"},{"id":52201,"requestDate":"2017-12-16T20:48:00","title":"Ms","name":"[FirstName] 52201 Surname 52201","institution":"[Institution] 52201","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"103","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"48","languageCode":"Spanish (Chilean)"},{"Id":"168","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"34","languageCode":"Spanish"},{"Id":"607","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"48","languageCode":"Spanish (Chilean)"},{"Id":"863","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"34","languageCode":"Spanish"}],"optin":false,"status":"Approved"},{"id":52199,"requestDate":"2017-12-16T17:47:00","title":"Dr","name":"[FirstName] 52199 Surname 52199","institution":"[Institution] 52199","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"931","phase":"1","name":"ELD14","description":"ELD14","languageId":"10","languageCode":"English"},{"Id":"959","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"3","languageCode":"Chinese"},{"Id":"983","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"3","languageCode":"Chinese"},{"Id":"993","phase":"1","name":"Bone Metastases","description":"desc","languageId":"3","languageCode":"Chinese"},{"Id":"1020","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"3","languageCode":"Chinese"},{"Id":"1087","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"3","languageCode":"Chinese"},{"Id":"1160","phase":"4","name":"Oral Health","description":"Oral Health Module (OH15)","languageId":"10","languageCode":"English"},{"Id":"1180","phase":"2","name":"Cholangio","description":"Cholangiocarcinoma - gall bladder cancers (BIL21)","languageId":"3","languageCode":"Chinese"},{"Id":"1183","phase":"2","name":"Cholangio","description":"Cholangiocarcinoma - gall bladder cancers (BIL21)","languageId":"10","languageCode":"English"},{"Id":"1192","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"10","languageCode":"English"},{"Id":"53","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"3","languageCode":"Chinese"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"122","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"202","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"3","languageCode":"Chinese"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"},{"Id":"234","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"10","languageCode":"English"},{"Id":"247","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"10","languageCode":"English"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"354","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"3","languageCode":"Chinese"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"},{"Id":"429","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"3","languageCode":"Chinese"},{"Id":"430","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"10","languageCode":"English"},{"Id":"458","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"10","languageCode":"English"},{"Id":"483","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"3","languageCode":"Chinese"},{"Id":"488","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"3","languageCode":"Chinese"},{"Id":"539","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"},{"Id":"629","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"3","languageCode":"Chinese"},{"Id":"647","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"10","languageCode":"English"},{"Id":"678","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"3","languageCode":"Chinese"},{"Id":"725","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"10","languageCode":"English"},{"Id":"735","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"10","languageCode":"English"},{"Id":"772","phase":"1","name":"Bone Metastases","description":"desc","languageId":"10","languageCode":"English"},{"Id":"802","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"3","languageCode":"Chinese"},{"Id":"806","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"10","languageCode":"English"},{"Id":"871","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"10","languageCode":"English"},{"Id":"915","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"3","languageCode":"Chinese"},{"Id":"1232","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"10","languageCode":"English"},{"Id":"1236","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"3","languageCode":"Chinese"},{"Id":"1270","phase":"4","name":"Oral Health","description":"Oral Health Module (OH15)","languageId":"3","languageCode":"Chinese"}],"optin":false,"status":"Approved"},{"id":52198,"requestDate":"2017-12-16T16:01:00","title":"Dr","name":"[FirstName] 52198 Surname 52198","institution":"[Institution] 52198","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52196,"requestDate":"2017-12-16T12:07:00","title":"Dr.","name":"[FirstName] 52196 Surname 52196","institution":"[Institution] 52196","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"925","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"56","languageCode":"Arabic (Egypt)"},{"Id":"1059","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"101","languageCode":"Arabic (Lebanon)"},{"Id":"1189","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"1","languageCode":"Arabic"},{"Id":"136","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"1","languageCode":"Arabic"},{"Id":"857","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"1","languageCode":"Arabic"}],"optin":false,"status":"Approved"},{"id":52195,"requestDate":"2017-12-16T10:51:00","title":"Mr","name":"[FirstName] 52195 Surname 52195","institution":"[Institution] 52195","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52193,"requestDate":"2017-12-16T00:35:00","title":"Dr","name":"[FirstName] 52193 Surname 52193","institution":"[Institution] 52193","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52192,"requestDate":"2017-12-15T22:40:00","title":"Dr. ","name":"[FirstName] 52192 Surname 52192","institution":"[Institution] 52192","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52191,"requestDate":"2017-12-15T14:28:00","title":"Dr.","name":"[FirstName] 52191 Surname 52191","institution":"[Institution] 52191","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"458","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52190,"requestDate":"2017-12-15T13:16:00","title":"Dr","name":"[FirstName] 52190 Surname 52190","institution":"[Institution] 52190","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"863","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"34","languageCode":"Spanish"}],"optin":false,"status":"Approved"},{"id":52189,"requestDate":"2017-12-15T08:37:00","title":"DR ","name":"[FirstName] 52189 Surname 52189","institution":"[Institution] 52189","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"75","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"18","languageCode":"Indian (Hindi)"}],"optin":false,"status":"Approved"},{"id":52188,"requestDate":"2017-12-15T05:52:00","title":"MPH","name":"[FirstName] 52188 Surname 52188","institution":"[Institution] 52188","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"81","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"42","languageCode":"Korean"},{"Id":"128","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"42","languageCode":"Korean"},{"Id":"156","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"42","languageCode":"Korean"},{"Id":"216","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"42","languageCode":"Korean"},{"Id":"319","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"42","languageCode":"Korean"},{"Id":"404","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"42","languageCode":"Korean"},{"Id":"421","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"42","languageCode":"Korean"},{"Id":"482","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"42","languageCode":"Korean"},{"Id":"574","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"42","languageCode":"Korean"}],"optin":false,"status":"Approved"},{"id":52187,"requestDate":"2017-12-15T04:08:00","title":"Ms","name":"[FirstName] 52187 Surname 52187","institution":"[Institution] 52187","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"172","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52186,"requestDate":"2017-12-14T22:53:00","title":"Mr.","name":"[FirstName] 52186 Surname 52186","institution":"[Institution] 52186","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"284","phase":"4","name":"IN-PATSAT32","description":"IN-PATSAT32","languageId":"38","languageCode":"Turkish"}],"optin":false,"status":"Approved"},{"id":52185,"requestDate":"2017-12-14T22:00:00","title":"Dr.","name":"[FirstName] 52185 Surname 52185","institution":"[Institution] 52185","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"91","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"30","languageCode":"Russian"},{"Id":"240","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"30","languageCode":"Russian"}],"optin":false,"status":"Approved"},{"id":52184,"requestDate":"2017-12-14T19:55:00","title":"Ms","name":"[FirstName] 52184 Surname 52184","institution":"[Institution] 52184","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"936","phase":"1","name":"ELD14","description":"ELD14","languageId":"34","languageCode":"Spanish"},{"Id":"133","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"34","languageCode":"Spanish"},{"Id":"168","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"34","languageCode":"Spanish"},{"Id":"193","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"34","languageCode":"Spanish"},{"Id":"194","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"34","languageCode":"Spanish"},{"Id":"226","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"34","languageCode":"Spanish"},{"Id":"241","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"34","languageCode":"Spanish"},{"Id":"256","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"34","languageCode":"Spanish"},{"Id":"313","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"34","languageCode":"Spanish"},{"Id":"382","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"34","languageCode":"Spanish"},{"Id":"478","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"34","languageCode":"Spanish"},{"Id":"518","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"34","languageCode":"Spanish"},{"Id":"668","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"34","languageCode":"Spanish"},{"Id":"672","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"34","languageCode":"Spanish"},{"Id":"741","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"34","languageCode":"Spanish"},{"Id":"756","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"34","languageCode":"Spanish"},{"Id":"780","phase":"1","name":"Bone Metastases","description":"desc","languageId":"34","languageCode":"Spanish"},{"Id":"819","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"34","languageCode":"Spanish"},{"Id":"863","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"34","languageCode":"Spanish"},{"Id":"890","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"34","languageCode":"Spanish"},{"Id":"1201","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"34","languageCode":"Spanish"},{"Id":"1282","phase":"4","name":"Spiritual Wellbeing","description":"Spiritual Wellbeing (SWB32)","languageId":"34","languageCode":"Spanish"}],"optin":false,"status":"Approved"},{"id":52183,"requestDate":"2017-12-14T18:47:00","title":"Ms","name":"[FirstName] 52183 Surname 52183","institution":"[Institution] 52183","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"273","phase":"4","name":"IN-PATSAT32","description":"IN-PATSAT32","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52182,"requestDate":"2017-12-14T18:40:00","title":"Ms","name":"[FirstName] 52182 Surname 52182","institution":"[Institution] 52182","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"91","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"30","languageCode":"Russian"},{"Id":"132","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"30","languageCode":"Russian"},{"Id":"164","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"30","languageCode":"Russian"},{"Id":"190","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"30","languageCode":"Russian"},{"Id":"222","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"30","languageCode":"Russian"},{"Id":"240","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"30","languageCode":"Russian"},{"Id":"255","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"30","languageCode":"Russian"}],"optin":false,"status":"Approved"},{"id":52181,"requestDate":"2017-12-14T17:36:00","title":"Dr.","name":"[FirstName] 52181 Surname 52181","institution":"[Institution] 52181","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"},{"Id":"147","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"13","languageCode":"German"},{"Id":"598","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"13","languageCode":"German"},{"Id":"737","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"13","languageCode":"German"},{"Id":"1194","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52180,"requestDate":"2017-12-14T16:05:00","title":"Dr","name":"[FirstName] 52180 Surname 52180","institution":"[Institution] 52180","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"85","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"20","languageCode":"Persian"},{"Id":"846","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"20","languageCode":"Persian"}],"optin":false,"status":"Approved"},{"id":52179,"requestDate":"2017-12-14T14:58:00","title":"miss","name":"[FirstName] 52179 Surname 52179","institution":"[Institution] 52179","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52178,"requestDate":"2017-12-14T14:22:00","title":"Dr","name":"[FirstName] 52178 Surname 52178","institution":"[Institution] 52178","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"147","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52177,"requestDate":"2017-12-14T13:03:00","title":"Dr","name":"[FirstName] 52177 Surname 52177","institution":"[Institution] 52177","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"931","phase":"1","name":"ELD14","description":"ELD14","languageId":"10","languageCode":"English"},{"Id":"1192","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"10","languageCode":"English"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"},{"Id":"735","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52176,"requestDate":"2017-12-14T11:46:00","title":"Dr.","name":"[FirstName] 52176 Surname 52176","institution":"[Institution] 52176","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"},{"Id":"180","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52175,"requestDate":"2017-12-14T11:29:00","title":"Mrs.","name":"[FirstName] 52175 Surname 52175","institution":"[Institution] 52175","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"73","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"41","languageCode":"Icelandic"}],"optin":false,"status":"Approved"},{"id":52174,"requestDate":"2017-12-14T11:00:00","title":"Ms","name":"[FirstName] 52174 Surname 52174","institution":"[Institution] 52174","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"662","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"26","languageCode":"Polish"},{"Id":"861","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"26","languageCode":"Polish"}],"optin":false,"status":"Approved"},{"id":52173,"requestDate":"2017-12-14T09:11:00","title":"Dr","name":"[FirstName] 52173 Surname 52173","institution":"[Institution] 52173","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"108","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"37","languageCode":"Swedish"}],"optin":false,"status":"Approved"},{"id":52172,"requestDate":"2017-12-13T20:46:00","title":"PhD","name":"[FirstName] 52172 Surname 52172","institution":"[Institution] 52172","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"958","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"52","languageCode":"Spanish (Mexican)"},{"Id":"107","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"52","languageCode":"Spanish (Mexican)"}],"optin":false,"status":"Approved"},{"id":52171,"requestDate":"2017-12-13T20:35:00","title":"ms ","name":"[FirstName] 52171 Surname 52171","institution":"[Institution] 52171","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52169,"requestDate":"2017-12-13T17:46:00","title":"Dr","name":"[FirstName] 52169 Surname 52169","institution":"[Institution] 52169","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52170,"requestDate":"2017-12-13T17:46:00","title":"Dr","name":"[FirstName] 52170 Surname 52170","institution":"[Institution] 52170","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52168,"requestDate":"2017-12-13T16:16:00","title":"","name":"[FirstName] 52168 Surname 52168","institution":"[Institution] 52168","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52167,"requestDate":"2017-12-13T16:15:00","title":"Dr","name":"[FirstName] 52167 Surname 52167","institution":"[Institution] 52167","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"695","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"21","languageCode":"Italian"},{"Id":"860","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"21","languageCode":"Italian"}],"optin":false,"status":"Approved"},{"id":52166,"requestDate":"2017-12-13T16:10:00","title":"Dr","name":"[FirstName] 52166 Surname 52166","institution":"[Institution] 52166","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"566","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"95","languageCode":"Malay (Malaysia)"},{"Id":"647","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52165,"requestDate":"2017-12-13T14:28:00","title":"Dr. ","name":"[FirstName] 52165 Surname 52165","institution":"[Institution] 52165","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"859","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"12","languageCode":"French"}],"optin":false,"status":"Approved"},{"id":52164,"requestDate":"2017-12-13T14:22:00","title":"Dr.","name":"[FirstName] 52164 Surname 52164","institution":"[Institution] 52164","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"},{"Id":"727","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52161,"requestDate":"2017-12-13T12:06:00","title":"Mr","name":"[FirstName] 52161 Surname 52161","institution":"[Institution] 52161","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"407","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"62","languageCode":"Chinese (Traditional HK)"}],"optin":false,"status":"Approved"},{"id":52160,"requestDate":"2017-12-13T11:30:00","title":"Dr","name":"[FirstName] 52160 Surname 52160","institution":"[Institution] 52160","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"933","phase":"1","name":"ELD14","description":"ELD14","languageId":"13","languageCode":"German"},{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52159,"requestDate":"2017-12-13T11:00:00","title":"MR","name":"[FirstName] 52159 Surname 52159","institution":"[Institution] 52159","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"71","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"15","languageCode":"Hebrew"}],"optin":false,"status":"Approved"},{"id":52158,"requestDate":"2017-12-13T10:45:00","title":"Mrs","name":"[FirstName] 52158 Surname 52158","institution":"[Institution] 52158","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"234","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"},{"Id":"647","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52157,"requestDate":"2017-12-13T10:39:00","title":"Mrs","name":"[FirstName] 52157 Surname 52157","institution":"[Institution] 52157","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"273","phase":"4","name":"IN-PATSAT32","description":"IN-PATSAT32","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52156,"requestDate":"2017-12-13T09:33:00","title":"Dr","name":"[FirstName] 52156 Surname 52156","institution":"[Institution] 52156","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"931","phase":"1","name":"ELD14","description":"ELD14","languageId":"10","languageCode":"English"},{"Id":"938","phase":"1","name":"ELD14","description":"ELD14","languageId":"38","languageCode":"Turkish"},{"Id":"943","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"38","languageCode":"Turkish"},{"Id":"978","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"38","languageCode":"Turkish"},{"Id":"1070","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"38","languageCode":"Turkish"},{"Id":"1160","phase":"4","name":"Oral Health","description":"Oral Health Module (OH15)","languageId":"10","languageCode":"English"},{"Id":"1183","phase":"2","name":"Cholangio","description":"Cholangiocarcinoma - gall bladder cancers (BIL21)","languageId":"10","languageCode":"English"},{"Id":"1192","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"10","languageCode":"English"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"113","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"38","languageCode":"Turkish"},{"Id":"122","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"10","languageCode":"English"},{"Id":"135","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"38","languageCode":"Turkish"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"171","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"38","languageCode":"Turkish"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"197","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"38","languageCode":"Turkish"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"},{"Id":"229","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"38","languageCode":"Turkish"},{"Id":"234","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"10","languageCode":"English"},{"Id":"247","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"10","languageCode":"English"},{"Id":"312","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"38","languageCode":"Turkish"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"},{"Id":"384","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"38","languageCode":"Turkish"},{"Id":"430","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"10","languageCode":"English"},{"Id":"458","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"10","languageCode":"English"},{"Id":"480","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"38","languageCode":"Turkish"},{"Id":"539","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"},{"Id":"647","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"10","languageCode":"English"},{"Id":"725","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"10","languageCode":"English"},{"Id":"735","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"10","languageCode":"English"},{"Id":"772","phase":"1","name":"Bone Metastases","description":"desc","languageId":"10","languageCode":"English"},{"Id":"806","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"10","languageCode":"English"},{"Id":"822","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"38","languageCode":"Turkish"},{"Id":"871","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"10","languageCode":"English"},{"Id":"894","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"38","languageCode":"Turkish"},{"Id":"921","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"38","languageCode":"Turkish"},{"Id":"1232","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52155,"requestDate":"2017-12-13T09:02:00","title":"Dr","name":"[FirstName] 52155 Surname 52155","institution":"[Institution] 52155","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"108","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"37","languageCode":"Swedish"},{"Id":"195","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"37","languageCode":"Swedish"}],"optin":false,"status":"Approved"},{"id":52154,"requestDate":"2017-12-13T09:01:00","title":"Dr.","name":"[FirstName] 52154 Surname 52154","institution":"[Institution] 52154","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"81","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"42","languageCode":"Korean"},{"Id":"156","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"42","languageCode":"Korean"}],"optin":false,"status":"Approved"},{"id":52153,"requestDate":"2017-12-13T08:43:00","title":"Ms.","name":"[FirstName] 52153 Surname 52153","institution":"[Institution] 52153","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1191","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"8","languageCode":"Dutch"}],"optin":false,"status":"Approved"},{"id":52152,"requestDate":"2017-12-13T08:20:00","title":"Dr","name":"[FirstName] 52152 Surname 52152","institution":"[Institution] 52152","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"122","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"},{"Id":"234","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"10","languageCode":"English"},{"Id":"247","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"10","languageCode":"English"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"370","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52151,"requestDate":"2017-12-13T08:07:00","title":"Dr","name":"[FirstName] 52151 Surname 52151","institution":"[Institution] 52151","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"75","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"18","languageCode":"Indian (Hindi)"},{"Id":"110","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"64","languageCode":"Tamil"},{"Id":"111","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"65","languageCode":"Indian (Telegu)"},{"Id":"640","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"74","languageCode":"Kannada"}],"optin":false,"status":"Approved"},{"id":52150,"requestDate":"2017-12-13T08:06:00","title":"Dr","name":"[FirstName] 52150 Surname 52150","institution":"[Institution] 52150","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"364","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"75","languageCode":"Indian (Malayalam)"}],"optin":false,"status":"Approved"},{"id":52149,"requestDate":"2017-12-13T07:59:00","title":"Dr","name":"[FirstName] 52149 Surname 52149","institution":"[Institution] 52149","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"182","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"18","languageCode":"Indian (Hindi)"},{"Id":"299","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"74","languageCode":"Kannada"},{"Id":"358","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"64","languageCode":"Tamil"},{"Id":"362","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"65","languageCode":"Indian (Telegu)"}],"optin":false,"status":"Approved"},{"id":52148,"requestDate":"2017-12-13T07:47:00","title":"Dr","name":"[FirstName] 52148 Surname 52148","institution":"[Institution] 52148","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"806","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"10","languageCode":"English"},{"Id":"1262","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"75","languageCode":"Indian (Malayalam)"}],"optin":false,"status":"Approved"},{"id":52147,"requestDate":"2017-12-13T07:43:00","title":"Dr","name":"[FirstName] 52147 Surname 52147","institution":"[Institution] 52147","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"806","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"10","languageCode":"English"},{"Id":"1262","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"75","languageCode":"Indian (Malayalam)"}],"optin":false,"status":"Approved"},{"id":52146,"requestDate":"2017-12-13T06:36:00","title":"Dr.ma","name":"[FirstName] 52146 Surname 52146","institution":"[Institution] 52146","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"182","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"18","languageCode":"Indian (Hindi)"},{"Id":"186","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"19","languageCode":"Indian (Marathi)"}],"optin":false,"status":"Approved"},{"id":52145,"requestDate":"2017-12-13T03:26:00","title":"Mr","name":"[FirstName] 52145 Surname 52145","institution":"[Institution] 52145","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"122","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52144,"requestDate":"2017-12-13T01:57:00","title":"Ms","name":"[FirstName] 52144 Surname 52144","institution":"[Institution] 52144","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"1190","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"56","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"139","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"172","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"4","languageCode":"Chinese (Taiwanese)"},{"Id":"593","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"4","languageCode":"Chinese (Taiwanese)"}],"optin":false,"status":"Approved"},{"id":52143,"requestDate":"2017-12-13T00:13:00","title":"Dr.","name":"[FirstName] 52143 Surname 52143","institution":"[Institution] 52143","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"647","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52142,"requestDate":"2017-12-12T23:24:00","title":"Mr","name":"[FirstName] 52142 Surname 52142","institution":"[Institution] 52142","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"826","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"52","languageCode":"Spanish (Mexican)"}],"optin":false,"status":"Approved"},{"id":52141,"requestDate":"2017-12-12T22:53:00","title":"Miss","name":"[FirstName] 52141 Surname 52141","institution":"[Institution] 52141","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52137,"requestDate":"2017-12-12T22:09:00","title":"Dr","name":"[FirstName] 52137 Surname 52137","institution":"[Institution] 52137","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52138,"requestDate":"2017-12-12T22:09:00","title":"Dr","name":"[FirstName] 52138 Surname 52138","institution":"[Institution] 52138","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52139,"requestDate":"2017-12-12T22:09:00","title":"Dr","name":"[FirstName] 52139 Surname 52139","institution":"[Institution] 52139","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52140,"requestDate":"2017-12-12T22:09:00","title":"Dr","name":"[FirstName] 52140 Surname 52140","institution":"[Institution] 52140","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52136,"requestDate":"2017-12-12T22:08:00","title":"Dr","name":"[FirstName] 52136 Surname 52136","institution":"[Institution] 52136","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52135,"requestDate":"2017-12-12T17:49:00","title":"Dr","name":"[FirstName] 52135 Surname 52135","institution":"[Institution] 52135","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"933","phase":"1","name":"ELD14","description":"ELD14","languageId":"13","languageCode":"German"},{"Id":"1158","phase":"4","name":"Oral Health","description":"Oral Health Module (OH15)","languageId":"13","languageCode":"German"},{"Id":"1184","phase":"2","name":"Cholangio","description":"Cholangiocarcinoma - gall bladder cancers (BIL21)","languageId":"13","languageCode":"German"},{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"},{"Id":"124","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"13","languageCode":"German"},{"Id":"147","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"13","languageCode":"German"},{"Id":"180","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"13","languageCode":"German"},{"Id":"210","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"13","languageCode":"German"},{"Id":"237","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"13","languageCode":"German"},{"Id":"250","phase":"4","name":"Ovarian","description":"Ovarian Module (OV28)","languageId":"13","languageCode":"German"},{"Id":"321","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"13","languageCode":"German"},{"Id":"373","phase":"3","name":"Myeloma","description":"Myeloma Module (MY20)","languageId":"13","languageCode":"German"},{"Id":"462","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"13","languageCode":"German"},{"Id":"541","phase":"3","name":"Colorectal Liver Metastases","description":"Colorectal Liver Metastases Module (LMC21)","languageId":"13","languageCode":"German"},{"Id":"598","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"13","languageCode":"German"},{"Id":"625","phase":"4","name":"Oesophago–Gastric","description":"Oesophago–Gastric Module (OG25)","languageId":"13","languageCode":"German"},{"Id":"651","phase":"3","name":"Brain","description":"Brain Module (BN20)","languageId":"13","languageCode":"German"},{"Id":"727","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"13","languageCode":"German"},{"Id":"737","phase":"4","name":"Information","description":"Information Module (INFO25)","languageId":"13","languageCode":"German"},{"Id":"792","phase":"1","name":"Bone Metastases","description":"desc","languageId":"13","languageCode":"German"},{"Id":"808","phase":"3","name":"Hepatocellular Carcinoma","description":"Hepatocellular Carcinoma Module (HCC18)","languageId":"13","languageCode":"German"},{"Id":"874","phase":"1","name":"GI.NET21","description":"GI.NET21","languageId":"13","languageCode":"German"},{"Id":"1194","phase":"3","name":"Fatigue","description":"Fatigue Module (FA12)","languageId":"13","languageCode":"German"},{"Id":"1256","phase":"4","name":"Breast Reconstruction module","description":"Breast Reconstruction module (BRECON23)","languageId":"13","languageCode":"German"},{"Id":"1274","phase":"4","name":"Spiritual Wellbeing","description":"Spiritual Wellbeing (SWB32)","languageId":"13","languageCode":"German"}],"optin":false,"status":"Approved"},{"id":52134,"requestDate":"2017-12-12T16:26:00","title":"Ms","name":"[FirstName] 52134 Surname 52134","institution":"[Institution] 52134","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"70","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"14","languageCode":"Greek"},{"Id":"148","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"14","languageCode":"Greek"}],"optin":false,"status":"Approved"},{"id":52133,"requestDate":"2017-12-12T16:17:00","title":"Mrs","name":"[FirstName] 52133 Surname 52133","institution":"[Institution] 52133","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"122","phase":"4","name":"Gastric","description":"Gastric Module (STO22)","languageId":"10","languageCode":"English"},{"Id":"144","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"10","languageCode":"English"},{"Id":"177","phase":"4","name":"Head &amp; Neck","description":"Head and Neck Module (H&amp;N35)","languageId":"10","languageCode":"English"},{"Id":"207","phase":"4","name":"Lung","description":"Lung Module (LC13)","languageId":"10","languageCode":"English"},{"Id":"234","phase":"4","name":"Oesophageal","description":"Oesophageal Module (OES18)","languageId":"10","languageCode":"English"},{"Id":"323","phase":"3","name":"Cervix","description":"Cervix Module (CX24)","languageId":"10","languageCode":"English"},{"Id":"458","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"10","languageCode":"English"},{"Id":"596","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"10","languageCode":"English"},{"Id":"725","phase":"4","name":"Endometrial","description":"Endometrial Module (EN24)","languageId":"10","languageCode":"English"}],"optin":false,"status":"Approved"},{"id":52132,"requestDate":"2017-12-12T16:12:00","title":"","name":"[FirstName] 52132 Surname 52132","institution":"[Institution] 52132","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"88","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"28","languageCode":"Portuguese (Brazilian)"},{"Id":"162","phase":"2","name":"Breast","description":"Breast Module (BR23)","languageId":"28","languageCode":"Portuguese (Brazilian)"}],"optin":false,"status":"Approved"},{"id":52130,"requestDate":"2017-12-12T15:34:00","title":"","name":"[FirstName] 52130 Surname 52130","institution":"[Institution] 52130","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"61","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"8","languageCode":"Dutch"}],"optin":false,"status":"Approved"},{"id":52129,"requestDate":"2017-12-12T12:08:00","title":"Dr.","name":"[FirstName] 52129 Surname 52129","institution":"[Institution] 52129","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"57","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"5","languageCode":"Croatian"}],"optin":false,"status":"Approved"},{"id":52128,"requestDate":"2017-12-12T11:52:00","title":"Ms","name":"[FirstName] 52128 Surname 52128","institution":"[Institution] 52128","emailAddress":"jth@emakina.com","requestType":"Unknown","questionnaires":[{"Id":"61","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"8","languageCode":"Dutch"},{"Id":"63","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"10","languageCode":"English"},{"Id":"69","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"13","languageCode":"German"},{"Id":"80","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"22","languageCode":"Japanese"},{"Id":"81","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"42","languageCode":"Korean"},{"Id":"858","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"7","languageCode":"Danish"},{"Id":"859","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"12","languageCode":"French"},{"Id":"860","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"21","languageCode":"Italian"}],"optin":false,"status":"Approved"}]');
;// CONCATENATED MODULE: ./src/mocks/requests/getRequests/index.ts




/* harmony default export */ function getRequests() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.get(resolvePath(requestsPath/* getRequestsPath */._k), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json(requests_namespaceObject));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/requests/getRequest/request.json
var request_namespaceObject = JSON.parse('{"phone":"[Phone] 52127","protocol":"CR 29","isScoringManualRequired":true,"id":52127,"requestDate":"2017-12-12T11:50:00","title":"Ms","name":"[FirstName] 52127 Surname 52127","institution":"[Institution] 52127","emailAddress":"jth@emakina.com","requestType":"Unknown","country":"Germany","questionnaires":[{"Id":"103","phase":"3","name":"CoreC30","description":"QLQ-C30 Core Questionnaire","languageId":"48","languageCode":"Spanish (Chilean)"},{"Id":"694","phase":"2","name":"Prostate","description":"Prostate Module (PR25)","languageId":"48","languageCode":"Spanish (Chilean)"},{"Id":"1258","phase":"4","name":"Colorectal","description":"Colorectal Module (CR29)","languageId":"48","languageCode":"Spanish (Chilean)"}],"optin":false}');
;// CONCATENATED MODULE: ./src/mocks/requests/getRequest/index.ts




/* harmony default export */ function getRequest() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 500 : _delay;
    return [
        rest.get(resolvePath("".concat(requestsPath/* getRequestsPath */._k, "/*")), function(req, res, ctx) {
            return res(ctx.delay(delay), ctx.status(200), ctx.json(request_namespaceObject));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/requests/performRequestAction/index.ts



/* harmony default export */ function performRequestAction() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _delay = ref.delay, delay = _delay === void 0 ? 1500 : _delay;
    return [
        rest.post(resolvePath(requestsPath/* requestActionPath */.PM), function(req, res, ctx) {
            var _body = req.body, action = _body.action, requestIds = _body.requestIds;
            if (!(requestIds === null || requestIds === void 0 ? void 0 : requestIds.length) || !action) {
                return res(ctx.status(400));
            }
            return res(ctx.delay(delay), ctx.status(200));
        }), 
    ];
};

;// CONCATENATED MODULE: ./src/mocks/handlers.ts
/**
 * a list of handlers (endpoints) to emulate (mock) a actual implementation
 */ 













































function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var handlers_delay = 200;
var restHandlers = [
    keywordSearch,
    icdCodeSearch,
    generalSearch,
    happyPath,
    forgotPassword_happyPath,
    requestAccess_happyPath,
    getUsers_happyPath,
    current_user_happyPath,
    addUser_happyPath,
    requestAccess_happyPath,
    editUser_happyPath,
    deleteUser,
    editAccount,
    changePassword,
    questionnaires_getSummaries,
    categories,
    createCustomQuestionnaire,
    getItem,
    get,
    getWithTranslation,
    publish,
    questionnaires_delete,
    updateQuestionnaireItem,
    deleteQuestionnaireItem,
    editQuestionnaireItem,
    timeScales,
    responseScales,
    addQuestionnaireItem,
    downloadCsv,
    languages_get,
    addLanguage,
    updateQuestionnaire,
    questionnaires_authors,
    search,
    setRecommendedWording,
    bulkAddQuestionnaireItems,
    updateItem,
    deleteLanguage,
    bulkAddTranslations,
    editTranslation,
    addToVerifiedLanguages,
    items_delete,
    updateRecommendedWording,
    mocks_usage,
    getRequests,
    getRequest,
    performRequestAction, 
];
/* harmony default export */ var handlers = (restHandlers.reduce(function(prev, curr) {
    return _toConsumableArray(prev).concat(_toConsumableArray(curr({
        delay: handlers_delay
    })));
}, []));

;// CONCATENATED MODULE: ./src/mocks/browser.ts
// eslint-disable-next-line import/no-extraneous-dependencies


function browser_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function browser_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return browser_arrayLikeToArray(arr);
}
function browser_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function browser_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function browser_toConsumableArray(arr) {
    return browser_arrayWithoutHoles(arr) || browser_iterableToArray(arr) || browser_unsupportedIterableToArray(arr) || browser_nonIterableSpread();
}
function browser_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return browser_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return browser_arrayLikeToArray(o, minLen);
}
// eslint-disable-next-line import/prefer-default-export
var worker = setupWorker.apply(void 0, browser_toConsumableArray(handlers));


/***/ }),

/***/ 34153:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable */ // @ts-ignore
if (false) { var server; } else {
    var worker = (__webpack_require__(65599)/* .worker */ .K);
    void worker.start();
}


/***/ }),

/***/ 52669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./src/layout/Header/HeaderBase/index.tsx + 13 modules
var HeaderBase = __webpack_require__(53787);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Nav.js + 3 modules
var Nav = __webpack_require__(50163);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(46863);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./src/hooks/useCurrentUser/index.tsx
var useCurrentUser = __webpack_require__(36271);
// EXTERNAL MODULE: ./src/hooks/useCurrentUserPermissions/index.tsx + 1 modules
var useCurrentUserPermissions = __webpack_require__(42010);
// EXTERNAL MODULE: ./src/layout/Header/LoggedInHeader/LoggedInHeader.module.scss
var LoggedInHeader_module = __webpack_require__(62742);
var LoggedInHeader_module_default = /*#__PURE__*/__webpack_require__.n(LoggedInHeader_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_n6febsnk4nq7zxsovmf65ymnxm/node_modules/next/link.js
var next_link = __webpack_require__(70462);
;// CONCATENATED MODULE: ./src/elements/NavLink/index.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function NavLink(_param) {
    var href = _param.href, children = _param.children, props = _objectWithoutProperties(_param, [
        "href",
        "children"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, _objectSpread({}, props, {
            children: children
        }))
    }));
}
/* harmony default export */ var elements_NavLink = (NavLink);

// EXTERNAL MODULE: ./src/hooks/useUserSession/index.ts + 2 modules
var useUserSession = __webpack_require__(39955);
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(19803);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(97902);
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/querySelectorAll.js
var querySelectorAll = __webpack_require__(83465);
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/addEventListener.js
var addEventListener = __webpack_require__(22853);
// EXTERNAL MODULE: ./node_modules/.pnpm/uncontrollable@7.2.1_react@17.0.2/node_modules/uncontrollable/lib/esm/index.js + 4 modules
var esm = __webpack_require__(22084);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/usePrevious.js
var usePrevious = __webpack_require__(35981);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useForceUpdate.js
var useForceUpdate = __webpack_require__(89357);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useEventListener.js
var useEventListener = __webpack_require__(88908);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useEventCallback.js
var useEventCallback = __webpack_require__(61255);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/DropdownContext.js

const DropdownContext = /*#__PURE__*/react.createContext(null);
/* harmony default export */ var esm_DropdownContext = (DropdownContext);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useCallbackRef.js
var useCallbackRef = __webpack_require__(14786);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/usePopper.js + 3 modules
var usePopper = __webpack_require__(39279);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/useClickOutside.js
var useClickOutside = __webpack_require__(41071);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/mergeOptionsWithPopperConfig.js
var mergeOptionsWithPopperConfig = __webpack_require__(96027);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/DropdownMenu.js
const _excluded = ["children"];

function DropdownMenu_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }











const noop = () => {};
/**
 * @memberOf Dropdown
 * @param {object}  options
 * @param {boolean} options.flip Automatically adjust the menu `drop` position based on viewport edge detection
 * @param {[number, number]} options.offset Define an offset distance between the Menu and the Toggle
 * @param {boolean} options.show Display the menu manually, ignored in the context of a `Dropdown`
 * @param {boolean} options.usePopper opt in/out of using PopperJS to position menus. When disabled you must position it yourself.
 * @param {string}  options.rootCloseEvent The pointer event to listen for when determining "clicks outside" the menu for triggering a close.
 * @param {object}  options.popperConfig Options passed to the [`usePopper`](/api/usePopper) hook.
 */


function useDropdownMenu(options = {}) {
  const context = (0,react.useContext)(esm_DropdownContext);
  const [arrowElement, attachArrowRef] = (0,useCallbackRef/* default */.Z)();
  const hasShownRef = (0,react.useRef)(false);
  const {
    flip,
    offset,
    rootCloseEvent,
    fixed = false,
    placement: placementOverride,
    popperConfig = {},
    enableEventListeners = true,
    usePopper: shouldUsePopper = !!context
  } = options;
  const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;

  if (show && !hasShownRef.current) {
    hasShownRef.current = true;
  }

  const handleClose = e => {
    context == null ? void 0 : context.toggle(false, e);
  };

  const {
    placement,
    setMenu,
    menuElement,
    toggleElement
  } = context || {};
  const popper = (0,usePopper/* default */.Z)(toggleElement, menuElement, (0,mergeOptionsWithPopperConfig/* default */.ZP)({
    placement: placementOverride || placement || 'bottom-start',
    enabled: shouldUsePopper,
    enableEvents: enableEventListeners == null ? show : enableEventListeners,
    offset,
    flip,
    fixed,
    arrowElement,
    popperConfig
  }));
  const menuProps = Object.assign({
    ref: setMenu || noop,
    'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
  }, popper.attributes.popper, {
    style: popper.styles.popper
  });
  const metadata = {
    show,
    placement,
    hasShown: hasShownRef.current,
    toggle: context == null ? void 0 : context.toggle,
    popper: shouldUsePopper ? popper : null,
    arrowProps: shouldUsePopper ? Object.assign({
      ref: attachArrowRef
    }, popper.attributes.arrow, {
      style: popper.styles.arrow
    }) : {}
  };
  (0,useClickOutside/* default */.Z)(menuElement, handleClose, {
    clickTrigger: rootCloseEvent,
    disabled: !show
  });
  return [menuProps, metadata];
}
const defaultProps = {
  usePopper: true
};

/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */
function DropdownMenu(_ref) {
  let {
    children
  } = _ref,
      options = DropdownMenu_objectWithoutPropertiesLoose(_ref, _excluded);

  const [props, meta] = useDropdownMenu(options);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: children(props, meta)
  });
}

DropdownMenu.displayName = 'DropdownMenu';
DropdownMenu.defaultProps = defaultProps;
/** @component */

/* harmony default export */ var esm_DropdownMenu = (DropdownMenu);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@react-aria+ssr@3.1.2_react@17.0.2/node_modules/@react-aria/ssr/dist/module.js


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $9d939cbc98267846$exports = {};

$parcel$export($9d939cbc98267846$exports, "SSRProvider", () => $9d939cbc98267846$export$9f8ac96af4b1b2ae);
$parcel$export($9d939cbc98267846$exports, "useSSRSafeId", () => $9d939cbc98267846$export$619500959fc48b26);
$parcel$export($9d939cbc98267846$exports, "useIsSSR", () => $9d939cbc98267846$export$535bd6ca7f90a273);

// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $9d939cbc98267846$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $9d939cbc98267846$var$SSRContext = /*#__PURE__*/ react.createContext($9d939cbc98267846$var$defaultContext);
function $9d939cbc98267846$export$9f8ac96af4b1b2ae(props) {
    let cur = (0,react.useContext)($9d939cbc98267846$var$SSRContext);
    let value = (0,react.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $9d939cbc98267846$var$defaultContext ? '' : `${cur.prefix}-${++cur.current}`,
            current: 0
        })
    , [
        cur
    ]);
    return(/*#__PURE__*/ react.createElement($9d939cbc98267846$var$SSRContext.Provider, {
        value: value
    }, props.children));
}
let $9d939cbc98267846$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
function $9d939cbc98267846$export$619500959fc48b26(defaultId) {
    let ctx = (0,react.useContext)($9d939cbc98267846$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $9d939cbc98267846$var$defaultContext && !$9d939cbc98267846$var$canUseDOM) console.warn('When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.');
    return (0,react.useMemo)(()=>defaultId || `react-aria${ctx.prefix}-${++ctx.current}`
    , [
        defaultId
    ]);
}
function $9d939cbc98267846$export$535bd6ca7f90a273() {
    let cur = (0,react.useContext)($9d939cbc98267846$var$SSRContext);
    let isInSSRContext = cur !== $9d939cbc98267846$var$defaultContext;
    let [isSSR, setIsSSR] = (0,react.useState)(isInSSRContext);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof window !== 'undefined' && isInSSRContext) // This if statement technically breaks the rules of hooks, but is safe
    // because the condition never changes after mounting.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0,react.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return isSSR;
}





//# sourceMappingURL=module.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/DropdownToggle.js






const isRoleMenu = el => {
  var _el$getAttribute;

  return ((_el$getAttribute = el.getAttribute('role')) == null ? void 0 : _el$getAttribute.toLowerCase()) === 'menu';
};

const DropdownToggle_noop = () => {};
/**
 * Wires up Dropdown toggle functionality, returning a set a props to attach
 * to the element that functions as the dropdown toggle (generally a button).
 *
 * @memberOf Dropdown
 */


function useDropdownToggle() {
  const id = $9d939cbc98267846$export$619500959fc48b26();
  const {
    show = false,
    toggle = DropdownToggle_noop,
    setToggle,
    menuElement
  } = (0,react.useContext)(esm_DropdownContext) || {};
  const handleClick = (0,react.useCallback)(e => {
    toggle(!show, e);
  }, [show, toggle]);
  const props = {
    id,
    ref: setToggle || DropdownToggle_noop,
    onClick: handleClick,
    'aria-expanded': !!show
  }; // This is maybe better down in an effect, but
  // the component is going to update anyway when the menu element
  // is set so might return new props.

  if (menuElement && isRoleMenu(menuElement)) {
    props['aria-haspopup'] = true;
  }

  return [props, {
    show,
    toggle
  }];
}

/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */
function DropdownToggle({
  children
}) {
  const [props, meta] = useDropdownToggle();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: children(props, meta)
  });
}

DropdownToggle.displayName = 'DropdownToggle';
/** @component */

/* harmony default export */ var esm_DropdownToggle = (DropdownToggle);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/SelectableContext.js
var SelectableContext = __webpack_require__(77519);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/NavContext.js
var NavContext = __webpack_require__(84418);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/Button.js
var esm_Button = __webpack_require__(46028);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/DataKey.js
var DataKey = __webpack_require__(46040);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/DropdownItem.js
const DropdownItem_excluded = ["eventKey", "disabled", "onClick", "active", "as"];

function DropdownItem_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }










/**
 * Create a dropdown item. Returns a set of props for the dropdown item component
 * including an `onClick` handler that prevents selection when the item is disabled
 */
function useDropdownItem({
  key,
  href,
  active,
  disabled,
  onClick
}) {
  const onSelectCtx = (0,react.useContext)(SelectableContext/* default */.Z);
  const navContext = (0,react.useContext)(NavContext/* default */.Z);
  const {
    activeKey
  } = navContext || {};
  const eventKey = (0,SelectableContext/* makeEventKey */.h)(key, href);
  const isActive = active == null && key != null ? (0,SelectableContext/* makeEventKey */.h)(activeKey) === eventKey : active;
  const handleClick = (0,useEventCallback/* default */.Z)(event => {
    if (disabled) return;
    onClick == null ? void 0 : onClick(event);

    if (onSelectCtx && !event.isPropagationStopped()) {
      onSelectCtx(eventKey, event);
    }
  });
  return [{
    onClick: handleClick,
    'aria-disabled': disabled || undefined,
    'aria-selected': isActive,
    [(0,DataKey/* dataAttr */.PB)('dropdown-item')]: ''
  }, {
    isActive
  }];
}
const DropdownItem = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    eventKey,
    disabled,
    onClick,
    active,
    as: Component = esm_Button/* default */.ZP
  } = _ref,
      props = DropdownItem_objectWithoutPropertiesLoose(_ref, DropdownItem_excluded);

  const [dropdownItemProps] = useDropdownItem({
    key: eventKey,
    href: props.href,
    disabled,
    onClick,
    active
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, Object.assign({}, props, {
    ref: ref
  }, dropdownItemProps));
});
DropdownItem.displayName = 'DropdownItem';
/* harmony default export */ var esm_DropdownItem = (DropdownItem);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/useWindow.js
var useWindow = __webpack_require__(30215);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/Dropdown.js


















function useRefWithUpdate() {
  const forceUpdate = (0,useForceUpdate/* default */.Z)();
  const ref = (0,react.useRef)(null);
  const attachRef = (0,react.useCallback)(element => {
    ref.current = element; // ensure that a menu set triggers an update for consumers

    forceUpdate();
  }, [forceUpdate]);
  return [ref, attachRef];
}
/**
 * @displayName Dropdown
 * @public
 */


function Dropdown({
  defaultShow,
  show: rawShow,
  onSelect,
  onToggle: rawOnToggle,
  itemSelector = `* [${(0,DataKey/* dataAttr */.PB)('dropdown-item')}]`,
  focusFirstItemOnShow,
  placement = 'bottom-start',
  children
}) {
  const window = (0,useWindow/* default */.Z)();
  const [show, onToggle] = (0,esm/* useUncontrolledProp */.$c)(rawShow, defaultShow, rawOnToggle); // We use normal refs instead of useCallbackRef in order to populate the
  // the value as quickly as possible, otherwise the effect to focus the element
  // may run before the state value is set

  const [menuRef, setMenu] = useRefWithUpdate();
  const menuElement = menuRef.current;
  const [toggleRef, setToggle] = useRefWithUpdate();
  const toggleElement = toggleRef.current;
  const lastShow = (0,usePrevious/* default */.Z)(show);
  const lastSourceEvent = (0,react.useRef)(null);
  const focusInDropdown = (0,react.useRef)(false);
  const onSelectCtx = (0,react.useContext)(SelectableContext/* default */.Z);
  const toggle = (0,react.useCallback)((nextShow, event, source = event == null ? void 0 : event.type) => {
    onToggle(nextShow, {
      originalEvent: event,
      source
    });
  }, [onToggle]);
  const handleSelect = (0,useEventCallback/* default */.Z)((key, event) => {
    onSelect == null ? void 0 : onSelect(key, event);
    toggle(false, event, 'select');

    if (!event.isPropagationStopped()) {
      onSelectCtx == null ? void 0 : onSelectCtx(key, event);
    }
  });
  const context = (0,react.useMemo)(() => ({
    toggle,
    placement,
    show,
    menuElement,
    toggleElement,
    setMenu,
    setToggle
  }), [toggle, placement, show, menuElement, toggleElement, setMenu, setToggle]);

  if (menuElement && lastShow && !show) {
    focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
  }

  const focusToggle = (0,useEventCallback/* default */.Z)(() => {
    if (toggleElement && toggleElement.focus) {
      toggleElement.focus();
    }
  });
  const maybeFocusFirst = (0,useEventCallback/* default */.Z)(() => {
    const type = lastSourceEvent.current;
    let focusType = focusFirstItemOnShow;

    if (focusType == null) {
      focusType = menuRef.current && isRoleMenu(menuRef.current) ? 'keyboard' : false;
    }

    if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) {
      return;
    }

    const first = (0,querySelectorAll/* default */.Z)(menuRef.current, itemSelector)[0];
    if (first && first.focus) first.focus();
  });
  (0,react.useEffect)(() => {
    if (show) maybeFocusFirst();else if (focusInDropdown.current) {
      focusInDropdown.current = false;
      focusToggle();
    } // only `show` should be changing
  }, [show, focusInDropdown, focusToggle, maybeFocusFirst]);
  (0,react.useEffect)(() => {
    lastSourceEvent.current = null;
  });

  const getNextFocusedChild = (current, offset) => {
    if (!menuRef.current) return null;
    const items = (0,querySelectorAll/* default */.Z)(menuRef.current, itemSelector);
    let index = items.indexOf(current) + offset;
    index = Math.max(0, Math.min(index, items.length));
    return items[index];
  };

  (0,useEventListener/* default */.Z)((0,react.useCallback)(() => window.document, [window]), 'keydown', event => {
    var _menuRef$current, _toggleRef$current;

    const {
      key
    } = event;
    const target = event.target;
    const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
    const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target); // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
    // in inscrutability

    const isInput = /input|textarea/i.test(target.tagName);

    if (isInput && (key === ' ' || key !== 'Escape' && fromMenu || key === 'Escape' && target.type === 'search')) {
      return;
    }

    if (!fromMenu && !fromToggle) {
      return;
    }

    if (key === 'Tab' && (!menuRef.current || !show)) {
      return;
    }

    lastSourceEvent.current = event.type;
    const meta = {
      originalEvent: event,
      source: event.type
    };

    switch (key) {
      case 'ArrowUp':
        {
          const next = getNextFocusedChild(target, -1);
          if (next && next.focus) next.focus();
          event.preventDefault();
          return;
        }

      case 'ArrowDown':
        event.preventDefault();

        if (!show) {
          onToggle(true, meta);
        } else {
          const next = getNextFocusedChild(target, 1);
          if (next && next.focus) next.focus();
        }

        return;

      case 'Tab':
        // on keydown the target is the element being tabbed FROM, we need that
        // to know if this event is relevant to this dropdown (e.g. in this menu).
        // On `keyup` the target is the element being tagged TO which we use to check
        // if focus has left the menu
        (0,addEventListener/* default */.ZP)(target.ownerDocument, 'keyup', e => {
          var _menuRef$current2;

          if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) {
            onToggle(false, meta);
          }
        }, {
          once: true
        });
        break;

      case 'Escape':
        if (key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
        }

        onToggle(false, meta);
        break;

      default:
    }
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SelectableContext/* default.Provider */.Z.Provider, {
    value: handleSelect,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_DropdownContext.Provider, {
      value: context,
      children: children
    })
  });
}

Dropdown.displayName = 'Dropdown';
Dropdown.Menu = esm_DropdownMenu;
Dropdown.Toggle = esm_DropdownToggle;
Dropdown.Item = esm_DropdownItem;
/* harmony default export */ var esm_Dropdown = (Dropdown);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/DropdownContext.js

const DropdownContext_DropdownContext = /*#__PURE__*/react.createContext({});
DropdownContext_DropdownContext.displayName = 'DropdownContext';
/* harmony default export */ var react_bootstrap_esm_DropdownContext = (DropdownContext_DropdownContext);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/Anchor.js + 8 modules
var Anchor = __webpack_require__(50456);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/DropdownItem.js






const DropdownItem_DropdownItem = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  eventKey,
  disabled = false,
  onClick,
  active,
  as: Component = Anchor/* default */.Z,
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'dropdown-item');
  const [dropdownItemProps, meta] = useDropdownItem({
    key: eventKey,
    href: props.href,
    disabled,
    onClick,
    active
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, { ...props,
    ...dropdownItemProps,
    ref: ref,
    className: classnames_default()(className, prefix, meta.isActive && 'active', disabled && 'disabled')
  });
});
DropdownItem_DropdownItem.displayName = 'DropdownItem';
/* harmony default export */ var react_bootstrap_esm_DropdownItem = (DropdownItem_DropdownItem);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useIsomorphicEffect.js
var useIsomorphicEffect = __webpack_require__(46644);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useMergedRefs.js
var useMergedRefs = __webpack_require__(39400);
// EXTERNAL MODULE: ./node_modules/.pnpm/warning@4.0.3/node_modules/warning/warning.js
var warning = __webpack_require__(91190);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/InputGroupContext.js

const context = /*#__PURE__*/react.createContext(null);
context.displayName = 'InputGroupContext';
/* harmony default export */ var InputGroupContext = (context);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/NavbarContext.js
var NavbarContext = __webpack_require__(46674);
// EXTERNAL MODULE: ./node_modules/.pnpm/invariant@2.2.4/node_modules/invariant/browser.js
var browser = __webpack_require__(53670);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/useWrappedRefWithWarning.js



function useWrappedRefWithWarning(ref, componentName) {
  // @ts-ignore
  if (true) return ref; // eslint-disable-next-line react-hooks/rules-of-hooks

  const warningRef = (0,react.useCallback)(refValue => {
    !(refValue == null || !refValue.isReactComponent) ?  false ? 0 : browser_default()(false) : void 0;
  }, [componentName]); // eslint-disable-next-line react-hooks/rules-of-hooks

  return (0,useMergedRefs/* default */.Z)(warningRef, ref);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/DropdownMenu.js














const DropdownMenu_defaultProps = {
  flip: true
};
function getDropdownMenuPlacement(alignEnd, dropDirection, isRTL) {
  const topStart = isRTL ? 'top-end' : 'top-start';
  const topEnd = isRTL ? 'top-start' : 'top-end';
  const bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
  const bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
  const leftStart = isRTL ? 'right-start' : 'left-start';
  const leftEnd = isRTL ? 'right-end' : 'left-end';
  const rightStart = isRTL ? 'left-start' : 'right-start';
  const rightEnd = isRTL ? 'left-end' : 'right-end';
  let placement = alignEnd ? bottomEnd : bottomStart;
  if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;
  return placement;
}
const DropdownMenu_DropdownMenu = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  align,
  rootCloseEvent,
  flip,
  show: showProps,
  renderOnMount,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  popperConfig,
  variant,
  ...props
}, ref) => {
  let alignEnd = false;
  const isNavbar = (0,react.useContext)(NavbarContext/* default */.Z);
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'dropdown-menu');
  const {
    align: contextAlign,
    drop,
    isRTL
  } = (0,react.useContext)(react_bootstrap_esm_DropdownContext);
  align = align || contextAlign;
  const isInputGroup = (0,react.useContext)(InputGroupContext);
  const alignClasses = [];

  if (align) {
    if (typeof align === 'object') {
      const keys = Object.keys(align);
       false ? 0 : void 0;

      if (keys.length) {
        const brkPoint = keys[0];
        const direction = align[brkPoint]; // .dropdown-menu-end is required for responsively aligning
        // left in addition to align left classes.

        alignEnd = direction === 'start';
        alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
      }
    } else if (align === 'end') {
      alignEnd = true;
    }
  }

  const placement = getDropdownMenuPlacement(alignEnd, drop, isRTL);
  const [menuProps, {
    hasShown,
    popper,
    show,
    toggle
  }] = useDropdownMenu({
    flip,
    rootCloseEvent,
    show: showProps,
    usePopper: !isNavbar && alignClasses.length === 0,
    offset: [0, 2],
    popperConfig,
    placement
  });
  menuProps.ref = (0,useMergedRefs/* default */.Z)(useWrappedRefWithWarning(ref, 'DropdownMenu'), menuProps.ref);
  (0,useIsomorphicEffect/* default */.Z)(() => {
    // Popper's initial position for the menu is incorrect when
    // renderOnMount=true. Need to call update() to correct it.
    if (show) popper == null ? void 0 : popper.update();
  }, [show]);
  if (!hasShown && !renderOnMount && !isInputGroup) return null; // For custom components provide additional, non-DOM, props;

  if (typeof Component !== 'string') {
    menuProps.show = show;

    menuProps.close = () => toggle == null ? void 0 : toggle(false);

    menuProps.align = align;
  }

  let style = props.style;

  if (popper != null && popper.placement) {
    // we don't need the default popper style,
    // menus are display: none when not shown.
    style = { ...props.style,
      ...menuProps.style
    };
    props['x-placement'] = popper.placement;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, { ...props,
    ...menuProps,
    style: style // Bootstrap css requires this data attrib to style responsive menus.
    ,
    ...((alignClasses.length || isNavbar) && {
      'data-bs-popper': 'static'
    }),
    className: classnames_default()(className, prefix, show && 'show', alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
  });
});
DropdownMenu_DropdownMenu.displayName = 'DropdownMenu';
DropdownMenu_DropdownMenu.defaultProps = DropdownMenu_defaultProps;
/* harmony default export */ var react_bootstrap_esm_DropdownMenu = (DropdownMenu_DropdownMenu);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/DropdownToggle.js











const DropdownToggle_DropdownToggle = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  split,
  className,
  childBsPrefix,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = Button/* default */.Z,
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'dropdown-toggle');
  const dropdownContext = (0,react.useContext)(esm_DropdownContext);
  const isInputGroup = (0,react.useContext)(InputGroupContext);

  if (childBsPrefix !== undefined) {
    props.bsPrefix = childBsPrefix;
  }

  const [toggleProps] = useDropdownToggle();
  toggleProps.ref = (0,useMergedRefs/* default */.Z)(toggleProps.ref, useWrappedRefWithWarning(ref, 'DropdownToggle')); // This intentionally forwards size and variant (if set) to the
  // underlying component, to allow it to render size and style variants.

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    className: classnames_default()(className, prefix, split && `${prefix}-split`, !!isInputGroup && (dropdownContext == null ? void 0 : dropdownContext.show) && 'show'),
    ...toggleProps,
    ...props
  });
});
DropdownToggle_DropdownToggle.displayName = 'DropdownToggle';
/* harmony default export */ var react_bootstrap_esm_DropdownToggle = (DropdownToggle_DropdownToggle);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(91385);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Dropdown.js















const DropdownHeader = (0,createWithBsPrefix/* default */.Z)('dropdown-header', {
  defaultProps: {
    role: 'heading'
  }
});
const DropdownDivider = (0,createWithBsPrefix/* default */.Z)('dropdown-divider', {
  Component: 'hr',
  defaultProps: {
    role: 'separator'
  }
});
const DropdownItemText = (0,createWithBsPrefix/* default */.Z)('dropdown-item-text', {
  Component: 'span'
});
const Dropdown_defaultProps = {
  navbar: false,
  align: 'start',
  autoClose: true
};
const Dropdown_Dropdown = /*#__PURE__*/react.forwardRef((pProps, ref) => {
  const {
    bsPrefix,
    drop,
    show,
    className,
    align,
    onSelect,
    onToggle,
    focusFirstItemOnShow,
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    navbar: _4,
    autoClose,
    ...props
  } = (0,esm/* useUncontrolled */.Ch)(pProps, {
    show: 'onToggle'
  });
  const isInputGroup = (0,react.useContext)(InputGroupContext);
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'dropdown');
  const isRTL = (0,ThemeProvider/* useIsRTL */.SC)();

  const isClosingPermitted = source => {
    // autoClose=false only permits close on button click
    if (autoClose === false) return source === 'click'; // autoClose=inside doesn't permit close on rootClose

    if (autoClose === 'inside') return source !== 'rootClose'; // autoClose=outside doesn't permit close on select

    if (autoClose === 'outside') return source !== 'select';
    return true;
  };

  const handleToggle = (0,useEventCallback/* default */.Z)((nextShow, meta) => {
    if (meta.originalEvent.currentTarget === document && (meta.source !== 'keydown' || meta.originalEvent.key === 'Escape')) meta.source = 'rootClose';
    if (isClosingPermitted(meta.source)) onToggle == null ? void 0 : onToggle(nextShow, meta);
  });
  const alignEnd = align === 'end';
  const placement = getDropdownMenuPlacement(alignEnd, drop, isRTL);
  const contextValue = (0,react.useMemo)(() => ({
    align,
    drop,
    isRTL
  }), [align, drop, isRTL]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react_bootstrap_esm_DropdownContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Dropdown, {
      placement: placement,
      show: show,
      onSelect: onSelect,
      onToggle: handleToggle,
      focusFirstItemOnShow: focusFirstItemOnShow,
      itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
      children: isInputGroup ? props.children : /*#__PURE__*/(0,jsx_runtime.jsx)(Component, { ...props,
        ref: ref,
        className: classnames_default()(className, show && 'show', (!drop || drop === 'down') && prefix, drop === 'up' && 'dropup', drop === 'end' && 'dropend', drop === 'start' && 'dropstart')
      })
    })
  });
});
Dropdown_Dropdown.displayName = 'Dropdown';
Dropdown_Dropdown.defaultProps = Dropdown_defaultProps;
/* harmony default export */ var react_bootstrap_esm_Dropdown = (Object.assign(Dropdown_Dropdown, {
  Toggle: react_bootstrap_esm_DropdownToggle,
  Menu: react_bootstrap_esm_DropdownMenu,
  Item: react_bootstrap_esm_DropdownItem,
  ItemText: DropdownItemText,
  Divider: DropdownDivider,
  Header: DropdownHeader
}));
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/NavLink.js
var esm_NavLink = __webpack_require__(92292);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/NavDropdown.js







const NavDropdown = /*#__PURE__*/react.forwardRef(({
  id,
  title,
  children,
  bsPrefix,
  className,
  rootCloseEvent,
  menuRole,
  disabled,
  active,
  renderMenuOnMount,
  menuVariant,
  ...props
}, ref) => {
  /* NavItem has no additional logic, it's purely presentational. Can set nav item class here to support "as" */
  const navItemPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(undefined, 'nav-item');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react_bootstrap_esm_Dropdown, {
    ref: ref,
    ...props,
    className: classnames_default()(className, navItemPrefix),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_bootstrap_esm_Dropdown.Toggle, {
      id: id,
      eventKey: null,
      active: active,
      disabled: disabled,
      childBsPrefix: bsPrefix,
      as: esm_NavLink/* default */.Z,
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_bootstrap_esm_Dropdown.Menu, {
      role: menuRole,
      renderOnMount: renderMenuOnMount,
      rootCloseEvent: rootCloseEvent,
      variant: menuVariant,
      children: children
    })]
  });
});
NavDropdown.displayName = 'NavDropdown';
/* harmony default export */ var esm_NavDropdown = (Object.assign(NavDropdown, {
  Item: react_bootstrap_esm_Dropdown.Item,
  ItemText: react_bootstrap_esm_Dropdown.ItemText,
  Divider: react_bootstrap_esm_Dropdown.Divider,
  Header: react_bootstrap_esm_Dropdown.Header
}));
// EXTERNAL MODULE: ./src/hooks/useModal.ts
var useModal = __webpack_require__(5330);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_n6febsnk4nq7zxsovmf65ymnxm/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(95601);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/components/_modal/FormModal/index.tsx
var FormModal = __webpack_require__(72552);
// EXTERNAL MODULE: ./src/components/_form/Field/index.tsx
var Field = __webpack_require__(50509);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Form.js + 15 modules
var Form = __webpack_require__(28268);
// EXTERNAL MODULE: ./src/components/_form/Select/CountrySelect/index.tsx
var CountrySelect = __webpack_require__(27824);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(55423);
// EXTERNAL MODULE: ./src/functions/validation/getIsRequiredText.ts
var getIsRequiredText = __webpack_require__(42590);
;// CONCATENATED MODULE: ./src/layout/AppMenu/EditAccount/schema.ts


var editUserFormModalSchema = es/* object */.Ry().shape({
    name: es/* string */.Z_().required((0,getIsRequiredText/* default */.Z)('Name')),
    country: es/* string */.Z_().required((0,getIsRequiredText/* default */.Z)('Country')).min(2),
    organisation: es/* string */.Z_().required((0,getIsRequiredText/* default */.Z)('Organisation'))
});

// EXTERNAL MODULE: ./src/hooks/useAlerts/index.ts + 1 modules
var useAlerts = __webpack_require__(96308);
;// CONCATENATED MODULE: ./src/layout/AppMenu/EditAccount/index.tsx


/* eslint-disable @typescript-eslint/no-unsafe-assignment,react/jsx-props-no-spreading */ 






function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function EditAccount_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function EditAccount_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            EditAccount_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var EditAccountFormModal = function(param1) {
    var toggle = param1.toggle, isShowing = param1.isShowing, targetUser = param1.targetUser;
    var updateCurrentUser = (0,useCurrentUser/* default */.Z)().updateCurrentUser;
    var addSuccessAlert = (0,useAlerts/* default */.Z)().addSuccessAlert;
    var onSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(data) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return updateCurrentUser(data);
                    case 2:
                        addSuccessAlert('User updated!');
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal/* default */.Z, {
        title: "Edit account",
        toggle: toggle,
        isShowing: isShowing,
        validationSchema: editUserFormModalSchema,
        submitButtonText: "Save",
        initialValues: targetUser,
        onSubmit: onSubmit,
        onComplete: function() {
            return toggle();
        },
        customSize: true,
        children: function(param) {
            var register = param.register, control = param.control, errors = param.formState.errors;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "name",
                        id: "name",
                        feedback: errors.name,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, EditAccount_objectSpread({
                            isInvalid: !!errors.name,
                            placeholder: ""
                        }, register('name')))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "email",
                        id: "email",
                        feedback: errors.email,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "m-0 mt-2",
                            children: targetUser.email
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "country",
                        id: "country",
                        feedback: errors.country,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CountrySelect/* default */.Z, {
                            control: control,
                            name: "country",
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "organisation",
                        id: "organisation",
                        feedback: errors.organisation,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, EditAccount_objectSpread({
                            placeholder: ""
                        }, register('organisation'), {
                            isInvalid: !!errors.organisation
                        }))
                    })
                ]
            });
        }
    }));
};
/* harmony default export */ var EditAccount = (EditAccountFormModal);

// EXTERNAL MODULE: ./src/components/_form/schema-presets.ts
var schema_presets = __webpack_require__(31500);
;// CONCATENATED MODULE: ./src/layout/AppMenu/ChangePassword/schema.ts


var updatePasswordFormModalSchema = es/* object */.Ry().shape({
    challenge: es/* string */.Z_(),
    currentPassword: schema_presets/* passwordSchema */.Js,
    newPassword: schema_presets/* passwordSchema */.Js,
    confirmPassword: es/* string */.Z_().oneOf([
        es/* ref */.iH('newPassword')
    ], 'Passwords must match')
});
var updatePasswordFormModalDefaultValues = {
    challenge: 'password',
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
};

// EXTERNAL MODULE: ./src/components/_modal/MessageBox/index.tsx
var MessageBox = __webpack_require__(29089);
;// CONCATENATED MODULE: ./src/layout/AppMenu/ChangePassword/index.tsx


/* eslint-disable @typescript-eslint/no-unsafe-assignment,react/jsx-props-no-spreading */ 





function ChangePassword_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ChangePassword_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ChangePassword_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ChangePassword_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ChangePassword_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ChangePassword_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ChangePassword_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ChangePasswordFormModal = function(param1) {
    var toggle = param1.toggle, isShowing = param1.isShowing;
    var ref = (0,useCurrentUser/* default */.Z)(), updatePassword = ref.updatePassword, isPasswordUpdated = ref.isPasswordUpdated, resetSuccess = ref.resetSuccess;
    var onSubmit = function() {
        var _ref = ChangePassword_asyncToGenerator(runtime_default().mark(function _callee(data) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return updatePassword(data);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var onComplete = function() {
        resetSuccess();
    };
    return isPasswordUpdated ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageBox/* default */.Z, {
        title: "Password changed!",
        onComplete: onComplete,
        isShowing: isShowing,
        toggle: toggle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "You can now use your new password to log in."
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal/* default */.Z, {
        title: "Change password",
        toggle: toggle,
        isShowing: isShowing,
        validationSchema: updatePasswordFormModalSchema,
        submitButtonText: "Save",
        initialValues: updatePasswordFormModalDefaultValues,
        onSubmit: onSubmit,
        onComplete: function() {},
        customSize: true,
        children: function(param) {
            var register = param.register, errors = param.formState.errors;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "current password",
                        id: "currentPassword",
                        feedback: errors.currentPassword,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, ChangePassword_objectSpread({
                            autoComplete: "off",
                            type: "password"
                        }, register('currentPassword'), {
                            placeholder: "",
                            isInvalid: !!errors.currentPassword
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "new password",
                        id: "newPassword",
                        feedback: errors.newPassword,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, ChangePassword_objectSpread({
                            type: "password"
                        }, register('newPassword'), {
                            placeholder: "",
                            isInvalid: !!errors.newPassword
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "confirm password",
                        id: "confirmPassword",
                        feedback: errors.confirmPassword,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, ChangePassword_objectSpread({
                            type: "password"
                        }, register('confirmPassword'), {
                            isInvalid: !!errors.confirmPassword
                        }))
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var ChangePassword = (ChangePasswordFormModal);

;// CONCATENATED MODULE: ./src/layout/Header/LoggedInHeader/Dropdown/index.tsx






function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var LoggedInHeader_Dropdown_Dropdown = function(param) {
    var onLogoutClick = param.onLogoutClick, user = param.user;
    var ref = _slicedToArray((0,useModal/* default */.Z)(), 2), isEditAccountShowing = ref[0], toggleEditAccount = ref[1];
    var ref1 = _slicedToArray((0,useModal/* default */.Z)(), 2), isChangePasswordShowing = ref1[0], toggleChangePassword = ref1[1];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_NavDropdown, {
                title: user.name,
                align: "end",
                className: (LoggedInHeader_module_default()).dropdown,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_NavDropdown.Item, {
                        onClick: toggleEditAccount,
                        children: "Edit account"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_NavDropdown.Item, {
                        onClick: toggleChangePassword,
                        children: "Change password"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_NavDropdown.Item, {
                        href: "/myCustom/",
                        children: "My questionnaire page"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_NavDropdown.Item, {
                        onClick: onLogoutClick,
                        children: "Log out"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EditAccount, {
                isShowing: isEditAccountShowing,
                toggle: toggleEditAccount,
                targetUser: user
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePassword, {
                isShowing: isChangePasswordShowing,
                toggle: toggleChangePassword
            })
        ]
    }));
};
/* harmony default export */ var LoggedInHeader_Dropdown = (LoggedInHeader_Dropdown_Dropdown);

// EXTERNAL MODULE: ./src/components/_questionnaires/CustomQuestionnaireFormModal/CreateCustomQuestionnaireFormModal/index.tsx
var CreateCustomQuestionnaireFormModal = __webpack_require__(95560);
;// CONCATENATED MODULE: ./src/layout/Header/LoggedInHeader/index.tsx












function LoggedInHeader_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function LoggedInHeader_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function LoggedInHeader_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function LoggedInHeader_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function LoggedInHeader_slicedToArray(arr, i) {
    return LoggedInHeader_arrayWithHoles(arr) || LoggedInHeader_iterableToArrayLimit(arr, i) || LoggedInHeader_unsupportedIterableToArray(arr, i) || LoggedInHeader_nonIterableRest();
}
function LoggedInHeader_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return LoggedInHeader_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return LoggedInHeader_arrayLikeToArray(o, minLen);
}
var LoggedInHeader = function() {
    var logOut = (0,useUserSession/* default */.Z)().logOut;
    var onLogoutClick = (0,react.useCallback)(function() {
        logOut();
    }, [
        logOut
    ]);
    var currentUser = (0,useCurrentUser/* default */.Z)().currentUser;
    var ref = LoggedInHeader_slicedToArray((0,useModal/* default */.Z)(), 2), isShowingCreateQuestionnaire = ref[0], toggleCreateQuestionnaire = ref[1];
    var ref1 = (0,useCurrentUserPermissions/* default */.ZP)(), users = ref1.users, requests = ref1.requests, customQuestionnaires = ref1.customQuestionnaires;
    var canAccessUsers = users === null || users === void 0 ? void 0 : users.canAccess;
    var canAccessRequests = requests === null || requests === void 0 ? void 0 : requests.canAccess;
    var canCreateCustomQuestionnaire = customQuestionnaires === null || customQuestionnaires === void 0 ? void 0 : customQuestionnaires.canCreate;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderBase/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* default */.Z, {
                    className: (LoggedInHeader_module_default()).authOptionsWrapper,
                    children: [
                        canAccessUsers && /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_NavLink, {
                            href: "/users",
                            children: "Users"
                        }),
                        canAccessRequests && /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_NavLink, {
                            href: "/requests",
                            children: "Requests"
                        }),
                        canCreateCustomQuestionnaire && /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Item */.Z.Item, {
                            className: (LoggedInHeader_module_default()).createQuestBtn,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                onClick: toggleCreateQuestionnaire,
                                children: "Create a new questionnaire"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LoggedInHeader_Dropdown, {
                            onLogoutClick: onLogoutClick,
                            user: currentUser
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateCustomQuestionnaireFormModal/* default */.Z, {
                    isShowing: isShowingCreateQuestionnaire,
                    toggle: toggleCreateQuestionnaire
                })
            ]
        })
    }));
};
/* harmony default export */ var Header_LoggedInHeader = (LoggedInHeader);

// EXTERNAL MODULE: ./src/elements/TooltipWrapper/TooltipWrapper.tsx + 11 modules
var TooltipWrapper = __webpack_require__(53046);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(28440);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(44858);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(42359);
// EXTERNAL MODULE: ./src/layout/Footer/Base/index.tsx
var Base = __webpack_require__(59116);
// EXTERNAL MODULE: ./src/layout/Footer/LoggedInFooter/loggedInFooter.module.scss
var loggedInFooter_module = __webpack_require__(8111);
var loggedInFooter_module_default = /*#__PURE__*/__webpack_require__.n(loggedInFooter_module);
;// CONCATENATED MODULE: ./src/layout/Footer/LoggedInFooter/index.tsx





var LoggedInFooter = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Base/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            className: (loggedInFooter_module_default()).textWrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                        sm: 5,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "How to obtain the questionnaires"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "The EORTC has two policies for the use of the QLQ-C30 and associated ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " modules."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    "Commercial users",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipWrapper/* default */.Z, {
                                        placement: "top",
                                        tooltipId: "footerTooltip1",
                                        text: "If an organization, institution or company is being provided with or providing funds, sponsorship or a grant for their research, and should any of these gain financially or use the measures for commercial purposes, then a fee is chargeable.",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (loggedInFooter_module_default()).iconTooltip
                                        })
                                    }),
                                    "- Royalty fee: please contact",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "mailto:qol.contracts@eortc.org ",
                                        children: "qol.contracts@eortc.org "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    "What is classed as 'academic' research",
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipWrapper/* default */.Z, {
                                        placement: "top",
                                        tooltipId: "footerTooltip2",
                                        text: "The only time a fee is not chargeable is if the study is purely for academic use and there is no financial gain by any party.",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (loggedInFooter_module_default()).iconTooltip
                                        })
                                    }),
                                    "- for educational institutions, hospitals, etc - No fee: questionnaires can be downloaded from the EORTC website"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                        sm: {
                            span: 5,
                            offset: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "Can't find what you're looking for?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    "Please suggest some issues that are not yet captured in questions.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipWrapper/* default */.Z, {
                                        placement: "top",
                                        tooltipId: "footerTooltip3",
                                        text: "Something missing from our Library? If you would like to assess a symptom/problem/side effect that is not featured in any of the items here, you can send us your suggestion, including a justification for your idea, and we will add your request to the research pool for consideration.",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (loggedInFooter_module_default()).iconTooltip
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Contact us at ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "mailto:itemlibrary@eortc.org",
                                        children: "itemlibrary@eortc.org"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var Footer_LoggedInFooter = (LoggedInFooter);

// EXTERNAL MODULE: ./src/layout/Layout/LoggedInLayout/loggedInLayout.module.scss
var loggedInLayout_module = __webpack_require__(49083);
var loggedInLayout_module_default = /*#__PURE__*/__webpack_require__.n(loggedInLayout_module);
// EXTERNAL MODULE: ./src/components/_errors/ErrorBoundary/index.tsx + 32 modules
var ErrorBoundary = __webpack_require__(70359);
;// CONCATENATED MODULE: ./src/layout/Layout/LoggedInLayout/index.tsx





var LoggedInLayout = function(param) {
    var children = param.children;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_LoggedInHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (loggedInLayout_module_default()).wrapper,
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_LoggedInFooter, {})
        ]
    });
};
/* harmony default export */ var Layout_LoggedInLayout = (LoggedInLayout);

// EXTERNAL MODULE: ./src/layout/Layout/LoggedOutLayout/index.tsx + 1 modules
var LoggedOutLayout = __webpack_require__(20298);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Alert.js
var Alert = __webpack_require__(44925);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Badge.js




const Badge_defaultProps = {
  bg: 'primary',
  pill: false
};
const Badge = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  bg,
  pill,
  text,
  className,
  as: Component = 'span',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'badge');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
  });
});
Badge.displayName = 'Badge';
Badge.defaultProps = Badge_defaultProps;
/* harmony default export */ var esm_Badge = (Badge);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/CloseButton.js
var CloseButton = __webpack_require__(53866);
// EXTERNAL MODULE: ./src/layout/Alerts/Alert/alertbottom.module.scss
var alertbottom_module = __webpack_require__(49111);
var alertbottom_module_default = /*#__PURE__*/__webpack_require__.n(alertbottom_module);
;// CONCATENATED MODULE: ./src/hooks/useTimeout/index.ts

var useTimeout = function(callback, delay) {
    var savedCallback = (0,react.useRef)(callback);
    // Remember the latest callback if it changes.
    (0,react.useLayoutEffect)(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the timeout.
    (0,react.useEffect)(function() {
        // Don't schedule if no delay is specified.
        // Note: 0 is a valid value for delay.
        if (!delay && delay !== 0) {
            return;
        }
        var id = setTimeout(function() {
            return savedCallback.current();
        }, delay);
        return function() {
            return clearTimeout(id);
        };
    }, [
        delay
    ]);
};
/* harmony default export */ var hooks_useTimeout = (useTimeout);

;// CONCATENATED MODULE: ./src/layout/Alerts/Alert/index.tsx






var Alert_Alert = function(param) {
    var alert = param.alert, offSet = param.offSet;
    var heightOffSet = 65;
    var ref = (0,react.useState)(offSet * heightOffSet), bottomOffSet = ref[0], setBottomOffSet = ref[1];
    var message = alert.message, type = alert.type, count = alert.count;
    var removeAlert = (0,useAlerts/* default */.Z)().removeAlert;
    var onClose = (0,react.useCallback)(function() {
        setBottomOffSet(-80);
        // We need timeout since transitions duration is 0.5s
        var timeoutID = setTimeout(function() {
            return removeAlert(alert);
        }, 500);
        return function() {
            return clearTimeout(timeoutID);
        };
    }, [
        alert,
        removeAlert
    ]);
    hooks_useTimeout(onClose, alert.isAutomaticallyDismissed ? 2000 : null);
    (0,react.useEffect)(function() {
        setBottomOffSet(offSet * heightOffSet);
    }, [
        offSet
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
        variant: type,
        onClick: function() {
            return 1;
        },
        className: (alertbottom_module_default()).container,
        style: {
            bottom: "".concat(bottomOffSet, "px")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (alertbottom_module_default()).contentWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        message,
                        count > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Badge, {
                            bg: type,
                            className: "ms-4",
                            children: count
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                    className: (alertbottom_module_default()).close,
                    onClick: onClose
                })
            ]
        })
    }));
};
/* harmony default export */ var Alerts_Alert = (Alert_Alert);

;// CONCATENATED MODULE: ./src/layout/Alerts/index.tsx



function Alerts() {
    var alerts = (0,useAlerts/* default */.Z)().alerts;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: alerts.map(function(alert, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Alerts_Alert, {
                alert: alert,
                offSet: index
            }, alert.id);
        })
    }));
}
/* harmony default export */ var layout_Alerts = (Alerts);

;// CONCATENATED MODULE: ./src/layout/Layout/index.tsx






var Layout = function(param) {
    var children = param.children;
    var isAuthenticated = (0,useUserSession/* default */.Z)().isAuthenticated;
    var ref = (0,useCurrentUserPermissions/* default */.ZP)(), currentUser = ref.currentUser, arePermissionsLoaded = ref.arePermissionsLoaded;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isAuthenticated && currentUser && arePermissionsLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_LoggedInLayout, {
                children: children
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoggedOutLayout/* default */.Z, {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_Alerts, {})
        ]
    }));
};
/* harmony default export */ var layout_Layout = (Layout);

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_n6febsnk4nq7zxsovmf65ymnxm/node_modules/next/router.js
var next_router = __webpack_require__(63359);
;// CONCATENATED MODULE: ./src/elements/AppLoading/index.tsx

var Loading = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        children: "Loading..."
    });
};
/* harmony default export */ var AppLoading = (Loading);

;// CONCATENATED MODULE: ./src/components/_auth/AuthLoading/index.tsx

/* harmony default export */ var AuthLoading = (AppLoading);

// EXTERNAL MODULE: ./src/components/_errors/403/403.module.scss
var _403_module = __webpack_require__(52810);
var _403_module_default = /*#__PURE__*/__webpack_require__.n(_403_module);
;// CONCATENATED MODULE: ./src/components/_errors/403/index.tsx





function Error403() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_LoggedInLayout, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (_403_module_default()).title,
                        children: "Not allowed!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (_403_module_default()).subTitle,
                        children: "Oops, it seems that you are not supposed to be here..."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (_403_module_default()).link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "/",
                            children: "Back home"
                        })
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/_auth/RouteGuard/index.tsx







function RouteGuard(param) {
    var children = param.children;
    var router = (0,next_router.useRouter)();
    var allowedAnonymousPaths = [
        '/',
        '/_error',
        '/reset-password'
    ];
    var isAuthenticated = (0,useUserSession/* default */.Z)().isAuthenticated;
    var ref = (0,useCurrentUserPermissions/* default */.ZP)(), currentUser = ref.currentUser, canAccessPage = ref.canAccessPage, arePermissionsLoaded = ref.arePermissionsLoaded;
    (0,react.useEffect)(function() {
        // cannot access page -> redirect with return url
        if (!isAuthenticated && !allowedAnonymousPaths.includes(router.pathname)) {
            void router.push({
                pathname: '/',
                query: {
                    returnUrl: router.asPath
                }
            });
        }
    // eslint-disable-next-line
    }, [
        router,
        isAuthenticated
    ]);
    if (// not authenticated and will be redirected to home
    (!allowedAnonymousPaths.includes(router.pathname) && !currentUser && router.pathname !== '/') || // authenticated but not ready yet to access or evaluate rights
    (isAuthenticated && (!currentUser || !arePermissionsLoaded))) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(AuthLoading, {}));
    }
    if (// authenticated but cannot access the page
    isAuthenticated && !canAccessPage(router.pathname) && // and not yet on the error page
    router.pathname !== '/_error') {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Error403, {}));
    }
    if (isAuthenticated && router.query.returnUrl) {
        void router.push(router.query.returnUrl.toString());
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(AuthLoading, {}));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(88349);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/devtools/index.js
var devtools = __webpack_require__(27257);
// EXTERNAL MODULE: ./src/styles/main.scss
var main = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/hooks/useUnexpectedError.ts
var useUnexpectedError = __webpack_require__(97808);
;// CONCATENATED MODULE: ./src/pages/_app.tsx
/* provided dependency */ var process = __webpack_require__(14224);









function _app_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _app_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _app_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
if (process.env.NEXT_PUBLIC_API_MOCKING === 'enabled') {
    // eslint-disable-next-line global-require
    __webpack_require__(34153);
}
var unexpectedApiResponseConditions = [
    function(response) {
        return response.status >= 500;
    },
    function(response) {
        var ref;
        return (ref = response.headers['content-type']) === null || ref === void 0 ? void 0 : ref.startsWith('text/html');
    }, 
];
function App(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var setUnexpectedError = (0,useUnexpectedError/* default */.Z)().setUnexpectedError;
    var queryClient = (0,react.useMemo)(function() {
        return new react_query_es.QueryClient({
            defaultOptions: {
                queries: {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    onError: function onError(error) {
                        if (error.response && unexpectedApiResponseConditions.some(function(cond) {
                            return cond(error.response);
                        })) {
                            setUnexpectedError(error);
                        }
                    },
                    refetchOnWindowFocus: false,
                    refetchOnMount: false
                }
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_query_es.QueryClientProvider, {
            client: queryClient,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RouteGuard, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_Layout, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _app_objectSpread({}, pageProps))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(devtools.ReactQueryDevtools, {
                    initialIsOpen: false
                })
            ]
        })
    }));
}
/* harmony default export */ var _app = (App);


/***/ }),

/***/ 52810:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"__403_title__drHg7","subTitle":"__403_subTitle__me8sf","link":"__403_link__nqbVn"};

/***/ }),

/***/ 94493:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"__500_wrapper__msyTt","h1":"__500_h1__HtvlF","p":"__500_p__LX_z_","a":"__500_a__WJVbl"};

/***/ }),

/***/ 23076:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"field_formGroup__eq0y9","label":"field_label__WZ3qN","formInputFieldLabel":"field_formInputFieldLabel__pr4fg","labelText":"field_labelText__sXdUR","input":"field_input__tf4WL"};

/***/ }),

/***/ 59586:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"richTextEditor_wrapper__oo9dV","inputArea":"richTextEditor_inputArea__ZUaB5"};

/***/ }),

/***/ 62001:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hideEmpty":"sharedSelect_hideEmpty__ZPEut"};

/***/ }),

/***/ 17124:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"selectContainer":"typeahead_selectContainer__xgAwT","selectContainerWithApiCall":"typeahead_selectContainerWithApiCall___JXTF"};

/***/ }),

/***/ 1993:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fieldError":"typeaheadWithApiCall_fieldError__R6yeK","helpInfoText":"typeaheadWithApiCall_helpInfoText__dNe8a"};

/***/ }),

/***/ 20974:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customSize":"formModal_customSize___Tn2Z"};

/***/ }),

/***/ 55133:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"modal_button__gax68","leftButton":"modal_leftButton__Elv6d","modalDefault":"modal_modalDefault__MFMp9"};

/***/ }),

/***/ 10680:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"modalHeader_header__c8J9F","headerReduced":"modalHeader_headerReduced__mQTWm","modalTitle":"modalHeader_modalTitle__I6FmW","button":"modalHeader_button__djcV1","leftButton":"modalHeader_leftButton__TpeNL"};

/***/ }),

/***/ 49758:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"infoTextWrapper":"createQuestionnaire_infoTextWrapper__MOdxl","helpInfoText":"createQuestionnaire_helpInfoText__HsP9j"};

/***/ }),

/***/ 50050:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customButton":"button_customButton__mLcVy"};

/***/ }),

/***/ 80570:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loader":"buttonWithLoader_loader__9nip6","load3":"buttonWithLoader_load3__A3U3a"};

/***/ }),

/***/ 96485:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"alert":"login-info_alert__Dldao","alertIcon":"login-info_alertIcon__PbPGl"};

/***/ }),

/***/ 49111:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"alertbottom_container__Z5III","contentWrapper":"alertbottom_contentWrapper__7jCuR","close":"alertbottom_close__YzNsR"};

/***/ }),

/***/ 73534:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__KALIa","navbar":"footer_navbar__a3bW2","navitem":"footer_navitem__BDOE2"};

/***/ }),

/***/ 8111:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"loggedInFooter_textWrapper__qSzND","iconTooltip":"loggedInFooter_iconTooltip__4dIFD"};

/***/ }),

/***/ 99283:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"example":"HeaderBase_example___cBCv","logoWrapper":"HeaderBase_logoWrapper__HASYS","title":"HeaderBase_title__y8Q6W","authOptionsWrapper":"HeaderBase_authOptionsWrapper__OmiDE","createQuestBtn":"HeaderBase_createQuestBtn__dicSP"};

/***/ }),

/***/ 62742:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"authOptionsWrapper":"LoggedInHeader_authOptionsWrapper__afQsA","createQuestBtn":"LoggedInHeader_createQuestBtn__BSMAd","dropdown":"LoggedInHeader_dropdown__yE708"};

/***/ }),

/***/ 49083:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"loggedInLayout_wrapper__uOd_l"};

/***/ }),

/***/ 2853:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 99534:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 70462:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(93305)


/***/ }),

/***/ 63359:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(29463)


/***/ }),

/***/ 16444:
/***/ (function(module, exports) {

"use strict";


// ref: https://github.com/tc39/proposal-global
var getGlobal = function () {
	// the only reliable means to get the global object is
	// `Function('return this')()`
	// However, this causes CSP violations in Chrome apps.
	if (typeof self !== 'undefined') { return self; }
	if (typeof window !== 'undefined') { return window; }
	if (typeof global !== 'undefined') { return global; }
	throw new Error('unable to locate global object');
}

var global = getGlobal();

module.exports = exports = global.fetch;

// Needed for TypeScript and Webpack.
if (global.fetch) {
	exports["default"] = global.fetch.bind(global);
}

exports.Headers = global.Headers;
exports.Request = global.Request;
exports.Response = global.Response;

/***/ }),

/***/ 14224:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 14970:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = all;

var _createChainableTypeChecker = __webpack_require__(44520);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),

/***/ 44520:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),

/***/ 74049:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(36257);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 40507:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(74049)();
}


/***/ }),

/***/ 36257:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 36584:
/***/ (function(module) {

"use strict";
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */


function Cache(maxSize) {
  this._maxSize = maxSize
  this.clear()
}
Cache.prototype.clear = function () {
  this._size = 0
  this._values = Object.create(null)
}
Cache.prototype.get = function (key) {
  return this._values[key]
}
Cache.prototype.set = function (key, value) {
  this._size >= this._maxSize && this.clear()
  if (!(key in this._values)) this._size++

  return (this._values[key] = value)
}

var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512

var pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE)

var config

module.exports = {
  Cache: Cache,

  split: split,

  normalizePath: normalizePath,

  setter: function (path) {
    var parts = normalizePath(path)

    return (
      setCache.get(path) ||
      setCache.set(path, function setter(obj, value) {
        var index = 0
        var len = parts.length
        var data = obj

        while (index < len - 1) {
          var part = parts[index]
          if (
            part === '__proto__' ||
            part === 'constructor' ||
            part === 'prototype'
          ) {
            return obj
          }

          data = data[parts[index++]]
        }
        data[parts[index]] = value
      })
    )
  },

  getter: function (path, safe) {
    var parts = normalizePath(path)
    return (
      getCache.get(path) ||
      getCache.set(path, function getter(data) {
        var index = 0,
          len = parts.length
        while (index < len) {
          if (data != null || !safe) data = data[parts[index++]]
          else return
        }
        return data
      })
    )
  },

  join: function (segments) {
    return segments.reduce(function (path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },

  forEach: function (path, cb, thisArg) {
    forEach(Array.isArray(path) ? path : split(path), cb, thisArg)
  },
}

function normalizePath(path) {
  return (
    pathCache.get(path) ||
    pathCache.set(
      path,
      split(path).map(function (part) {
        return part.replace(CLEAN_QUOTES_REGEX, '$2')
      })
    )
  )
}

function split(path) {
  return path.match(SPLIT_REGEX) || ['']
}

function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket

  for (idx = 0; idx < len; idx++) {
    part = parts[idx]

    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"'
      }

      isBracket = isQuoted(part)
      isArray = !isBracket && /^\d+$/.test(part)

      iter.call(thisArg, part, isBracket, isArray, idx, parts)
    }
  }
}

function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}

function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}

function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}

function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}


/***/ }),

/***/ 3078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "oP": function() { return /* reexport */ Highlighter_Highlighter; },
  "pY": function() { return /* reexport */ Typeahead_Typeahead; }
});

// UNUSED EXPORTS: AsyncTypeahead, ClearButton, Hint, Input, Loader, Menu, MenuItem, Token, TypeaheadInputMulti, TypeaheadInputSingle, TypeaheadMenu, useAsync, useHint, useItem, useToken, withAsync, withItem, withToken

// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(15517);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(69690);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(92685);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = (0,objectWithoutPropertiesLoose/* default */.Z)(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash.debounce@4.0.8/node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(86763);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useForceUpdate.js
var useForceUpdate = __webpack_require__(89357);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/usePrevious.js
var usePrevious = __webpack_require__(35981);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/constants.js
var DEFAULT_LABELKEY = 'label';
var SIZES = ['lg', 'sm'];
// EXTERNAL MODULE: ./node_modules/.pnpm/invariant@2.2.4/node_modules/invariant/browser.js
var browser = __webpack_require__(53670);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/getStringLabelKey.js

function getStringLabelKey(labelKey) {
  return typeof labelKey === 'string' ? labelKey : DEFAULT_LABELKEY;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/hasOwnProperty.js
/**
 * Check if an object has the given property in a type-safe way.
 */
function hasOwnProperty_hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/nodash.js
var idCounter = 0; // eslint-disable-next-line @typescript-eslint/ban-types

function isFunction(value) {
  return typeof value === 'function';
}
function isString(value) {
  return typeof value === 'string';
} // eslint-disable-next-line @typescript-eslint/no-empty-function

function noop() {}
function pick(obj, keys) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var result = {};
  keys.forEach(function (key) {
    result[key] = obj[key];
  });
  return result;
}
function uniqueId(prefix) {
  idCounter += 1;
  return (prefix == null ? '' : String(prefix)) + idCounter;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/getOptionLabel.js





/**
 * Retrieves the display string from an option. Options can be the string
 * themselves, or an object with a defined display string. Anything else throws
 * an error.
 */
function getOptionLabel(option, labelKey) {
  // Handle internally created options first.
  if (!isString(option) && (hasOwnProperty_hasOwnProperty(option, 'paginationOption') || hasOwnProperty_hasOwnProperty(option, 'customOption'))) {
    return option[getStringLabelKey(labelKey)];
  }

  var optionLabel;

  if (isFunction(labelKey)) {
    optionLabel = labelKey(option);
  } else if (isString(option)) {
    optionLabel = option;
  } else {
    // `option` is an object and `labelKey` is a string.
    optionLabel = option[labelKey];
  }

  !isString(optionLabel) ?  false ? 0 : browser_default()(false) : void 0;
  return optionLabel;
}

/* harmony default export */ var utils_getOptionLabel = (getOptionLabel);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/addCustomOption.js



function addCustomOption(results, props) {
  var allowNew = props.allowNew,
      labelKey = props.labelKey,
      text = props.text;

  if (!allowNew || !text.trim()) {
    return false;
  } // If the consumer has provided a callback, use that to determine whether or
  // not to add the custom option.


  if (isFunction(allowNew)) {
    return allowNew(results, props);
  } // By default, don't add the custom option if there is an exact text match
  // with an existing option.


  return !results.some(function (o) {
    return utils_getOptionLabel(o, labelKey) === text;
  });
}

/* harmony default export */ var utils_addCustomOption = (addCustomOption);
// EXTERNAL MODULE: ./node_modules/.pnpm/fast-deep-equal@3.1.3/node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(3341);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/getOptionProperty.js

function getOptionProperty(option, key) {
  if (isString(option)) {
    return undefined;
  }

  return option[key];
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/stripDiacritics.js
/**
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Taken from: http://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript/18391901#18391901
 */
// prettier-ignore
var map = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\xD0"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'OE',
  letters: "\x8C\u0152"
}, {
  base: 'oe',
  letters: "\x9C\u0153"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}].reduce(function (acc, _ref) {
  var base = _ref.base,
      letters = _ref.letters;
  letters.split('').forEach(function (letter) {
    acc[letter] = base;
  });
  return acc;
}, {}); // "what?" version ... http://jsperf.com/diacritics/12

function stripDiacritics(str) {
  return str.normalize('NFD').replace(/[\u0300-\u036F]/g, '') // Remove combining diacritics

  /* eslint-disable-next-line no-control-regex */
  .replace(/[^\u0000-\u007E]/g, function (a) {
    return map[a] || a;
  });
}
// EXTERNAL MODULE: ./node_modules/.pnpm/warning@4.0.3/node_modules/warning/warning.js
var warning = __webpack_require__(91190);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/warn.js
// @flow

var warned = {};
/**
 * Copied from: https://github.com/ReactTraining/react-router/blob/master/modules/routerWarning.js
 */

function warn_warn(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (!falseToWarn && message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  warning_default().apply(void 0, [falseToWarn, "[react-bootstrap-typeahead] ".concat(message)].concat(args));
}
function resetWarned() {
  warned = {};
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/defaultFilterBy.js






function isMatch(input, string, props) {
  var searchStr = input;
  var str = string;

  if (!props.caseSensitive) {
    searchStr = searchStr.toLowerCase();
    str = str.toLowerCase();
  }

  if (props.ignoreDiacritics) {
    searchStr = stripDiacritics(searchStr);
    str = stripDiacritics(str);
  }

  return str.indexOf(searchStr) !== -1;
}
/**
 * Default algorithm for filtering results.
 */


function defaultFilterBy(option, props) {
  var filterBy = props.filterBy,
      labelKey = props.labelKey,
      multiple = props.multiple,
      selected = props.selected,
      text = props.text; // Don't show selected options in the menu for the multi-select case.

  if (multiple && selected.some(function (o) {
    return fast_deep_equal_default()(o, option);
  })) {
    return false;
  }

  if (isFunction(labelKey) && isMatch(text, labelKey(option), props)) {
    return true;
  }

  var fields = filterBy.slice();

  if (isString(labelKey)) {
    // Add the `labelKey` field to the list of fields if it isn't already there.
    if (fields.indexOf(labelKey) === -1) {
      fields.unshift(labelKey);
    }
  }

  if (isString(option)) {
    warn_warn(fields.length <= 1, 'You cannot filter by properties when `option` is a string.');
    return isMatch(text, option, props);
  }

  return fields.some(function (field) {
    var value = getOptionProperty(option, field);

    if (!isString(value)) {
      warn_warn(false, 'Fields passed to `filterBy` should have string values. Value will ' + 'be converted to a string; results may be unexpected.');
      value = String(value);
    }

    return isMatch(text, value, props);
  });
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/isSelectable.js
/**
 * Check if an input type is selectable, based on WHATWG spec.
 *
 * See:
 *  - https://stackoverflow.com/questions/21177489/selectionstart-selectionend-on-input-type-number-no-longer-allowed-in-chrome/24175357
 *  - https://html.spec.whatwg.org/multipage/input.html#do-not-apply
 */
function isSelectable(inputNode) {
  return inputNode.selectionStart != null;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/defaultSelectHint.js

function defaultSelectHint(e, selectHint) {
  var shouldSelectHint = false;

  if (e.key === 'ArrowRight') {
    // For selectable input types ("text", "search"), only select the hint if
    // it's at the end of the input value. For non-selectable types ("email",
    // "number"), always select the hint.
    shouldSelectHint = isSelectable(e.currentTarget) ? e.currentTarget.selectionStart === e.currentTarget.value.length : true;
  }

  if (e.key === 'Tab') {
    // Prevent input from blurring on TAB.
    e.preventDefault();
    shouldSelectHint = true;
  }

  return selectHint ? selectHint(shouldSelectHint, e) : shouldSelectHint;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/getDisplayName.js
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDisplayName_getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/getMatchBounds.js


var CASE_INSENSITIVE = 'i';
var COMBINING_MARKS = /[\u0300-\u036F]/;
// Export for testing.
function escapeStringRegexp(str) {
  !(typeof str === 'string') ?  false ? 0 : browser_default()(false) : void 0; // Escape characters with special meaning either inside or outside character
  // sets. Use a simple backslash escape when it’s always valid, and a \unnnn
  // escape when the simpler form would be disallowed by Unicode patterns’
  // stricter grammar.

  return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
function getMatchBounds(subject, str) {
  var search = new RegExp(escapeStringRegexp(stripDiacritics(str)), CASE_INSENSITIVE);
  var matches = search.exec(stripDiacritics(subject));

  if (!matches) {
    return null;
  }

  var start = matches.index;
  var matchLength = matches[0].length; // Account for combining marks, which changes the indices.

  if (COMBINING_MARKS.test(subject)) {
    // Starting at the beginning of the subject string, check for the number of
    // combining marks and increment the start index whenever one is found.
    for (var ii = 0; ii <= start; ii++) {
      if (COMBINING_MARKS.test(subject[ii])) {
        start += 1;
      }
    } // Similarly, increment the length of the match string if it contains a
    // combining mark.


    for (var _ii = start; _ii <= start + matchLength; _ii++) {
      if (COMBINING_MARKS.test(subject[_ii])) {
        matchLength += 1;
      }
    }
  }

  return {
    end: start + matchLength,
    start: start
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/getHintText.js





function getHintText(_ref) {
  var activeIndex = _ref.activeIndex,
      initialItem = _ref.initialItem,
      isFocused = _ref.isFocused,
      isMenuShown = _ref.isMenuShown,
      labelKey = _ref.labelKey,
      multiple = _ref.multiple,
      selected = _ref.selected,
      text = _ref.text;

  // Don't display a hint under the following conditions:
  if ( // No text entered.
  !text || // The input is not focused.
  !isFocused || // The menu is hidden.
  !isMenuShown || // No item in the menu.
  !initialItem || // The initial item is a custom option.
  !isString(initialItem) && hasOwnProperty_hasOwnProperty(initialItem, 'customOption') || // One of the menu items is active.
  activeIndex > -1 || // There's already a selection in single-select mode.
  !!selected.length && !multiple) {
    return '';
  }

  var initialItemStr = utils_getOptionLabel(initialItem, labelKey);
  var bounds = getMatchBounds(initialItemStr.toLowerCase(), text.toLowerCase());

  if (!(bounds && bounds.start === 0)) {
    return '';
  } // Text matching is case- and accent-insensitive, so to display the hint
  // correctly, splice the input string with the hint string.


  return text + initialItemStr.slice(bounds.end, initialItemStr.length);
}

/* harmony default export */ var utils_getHintText = (getHintText);
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(19803);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/getMenuItemId.js
function getMenuItemId() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var position = arguments.length > 1 ? arguments[1] : undefined;
  return "".concat(id, "-item-").concat(position);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/getInputProps.js


var _excluded = ["activeIndex", "id", "isFocused", "isMenuShown", "multiple", "onClick", "onFocus", "placeholder"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var getInputProps = function getInputProps(_ref) {
  var activeIndex = _ref.activeIndex,
      id = _ref.id,
      isFocused = _ref.isFocused,
      isMenuShown = _ref.isMenuShown,
      multiple = _ref.multiple,
      onClick = _ref.onClick,
      onFocus = _ref.onFocus,
      placeholder = _ref.placeholder,
      rest = _objectWithoutProperties(_ref, _excluded);

  return function () {
    var _cx;

    var inputProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var className = hasOwnProperty_hasOwnProperty(inputProps, 'className') ? inputProps.className : undefined;

    var props = _objectSpread(_objectSpread(_objectSpread({
      // These props can be overridden by values in `inputProps`.
      autoComplete: 'off',
      placeholder: placeholder,
      type: 'text'
    }, inputProps), rest), {}, {
      'aria-activedescendant': activeIndex >= 0 ? getMenuItemId(id, activeIndex) : undefined,
      'aria-autocomplete': 'both',
      'aria-expanded': isMenuShown,
      'aria-haspopup': 'listbox',
      'aria-owns': isMenuShown ? id : undefined,
      className: classnames_default()((_cx = {}, (0,defineProperty/* default */.Z)(_cx, className || '', !multiple), (0,defineProperty/* default */.Z)(_cx, "focus", isFocused), _cx)),
      onClick: onClick,
      onFocus: onFocus,
      // Comboboxes are single-select by definition:
      // https://www.w3.org/TR/wai-aria-practices-1.1/#combobox
      role: 'combobox'
    });

    if (!multiple) {
      return props;
    }

    return _objectSpread(_objectSpread({}, props), {}, {
      'aria-autocomplete': 'list',
      'aria-expanded': undefined,
      inputClassName: className,
      role: undefined
    });
  };
};

/* harmony default export */ var utils_getInputProps = (getInputProps);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/getInputText.js


function getInputText(props) {
  var activeItem = props.activeItem,
      labelKey = props.labelKey,
      multiple = props.multiple,
      selected = props.selected,
      text = props.text;

  if (activeItem) {
    // Display the input value if the pagination item is active.
    return utils_getOptionLabel(activeItem, labelKey);
  }

  if (!multiple && selected.length && selected[0]) {
    return utils_getOptionLabel(selected[0], labelKey);
  }

  return text;
}

/* harmony default export */ var utils_getInputText = (getInputText);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/getIsOnlyResult.js


function getIsOnlyResult(props) {
  var allowNew = props.allowNew,
      highlightOnlyResult = props.highlightOnlyResult,
      results = props.results;

  if (!highlightOnlyResult || allowNew) {
    return false;
  }

  return results.length === 1 && !getOptionProperty(results[0], 'disabled');
}

/* harmony default export */ var utils_getIsOnlyResult = (getIsOnlyResult);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/getTruncatedOptions.js
/**
 * Truncates the result set based on `maxResults` and returns the new set.
 */
function getTruncatedOptions(options, maxResults) {
  if (!maxResults || maxResults >= options.length) {
    return options;
  }

  return options.slice(0, maxResults);
}

/* harmony default export */ var utils_getTruncatedOptions = (getTruncatedOptions);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/getUpdatedActiveIndex.js


function isDisabledOption(index, items) {
  var option = items[index];
  return !!option && !isString(option) && hasOwnProperty_hasOwnProperty(option, 'disabled');
}
function skipDisabledOptions(currentIndex, key, items) {
  var newIndex = currentIndex;

  while (isDisabledOption(newIndex, items)) {
    newIndex += key === 'ArrowUp' ? -1 : 1;
  }

  return newIndex;
}
function getUpdatedActiveIndex(currentIndex, key, items) {
  var newIndex = currentIndex; // Increment or decrement index based on user keystroke.

  newIndex += key === 'ArrowUp' ? -1 : 1; // Skip over any disabled options.

  newIndex = skipDisabledOptions(newIndex, key, items); // If we've reached the end, go back to the beginning or vice-versa.

  if (newIndex === items.length) {
    newIndex = -1;
  } else if (newIndex === -2) {
    newIndex = items.length - 1; // Skip over any disabled options.

    newIndex = skipDisabledOptions(newIndex, key, items);
  }

  return newIndex;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/isShown.js
function isShown(_ref) {
  var open = _ref.open,
      minLength = _ref.minLength,
      showMenu = _ref.showMenu,
      text = _ref.text;

  // If menu visibility is controlled via props, that value takes precedence.
  if (open || open === false) {
    return open;
  }

  if (text.length < minLength) {
    return false;
  }

  return showMenu;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/preventInputBlur.js
/**
 * Prevent the main input from blurring when a menu item or the clear button is
 * clicked. (#226 & #310)
 */
function preventInputBlur(e) {
  e.preventDefault();
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/size.js
function isSizeLarge(size) {
  return size === 'lg';
}
function isSizeSmall(size) {
  return size === 'sm';
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/validateSelectedPropChange.js

function validateSelectedPropChange(prevSelected, selected) {
  var uncontrolledToControlled = !prevSelected && selected;
  var controlledToUncontrolled = prevSelected && !selected;
  var from, to, precedent;

  if (uncontrolledToControlled) {
    from = 'uncontrolled';
    to = 'controlled';
    precedent = 'an';
  } else {
    from = 'controlled';
    to = 'uncontrolled';
    precedent = 'a';
  }

  var message = "You are changing ".concat(precedent, " ").concat(from, " typeahead to be ").concat(to, ". ") + "Input elements should not switch from ".concat(from, " to ").concat(to, " (or vice versa). ") + 'Decide between using a controlled or uncontrolled element for the ' + 'lifetime of the component.';
  warn_warn(!(uncontrolledToControlled || controlledToUncontrolled), message);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/utils/index.js

























;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/propTypes.js




var INPUT_PROPS_BLACKLIST = [{
  alt: 'onBlur',
  prop: 'onBlur'
}, {
  alt: 'onInputChange',
  prop: 'onChange'
}, {
  alt: 'onFocus',
  prop: 'onFocus'
}, {
  alt: 'onKeyDown',
  prop: 'onKeyDown'
}];
var sizeType = prop_types_default().oneOf(SIZES);

/**
 * Allows additional warnings or messaging related to prop validation.
 */
function checkPropType(validator, callback) {
  return function (props, propName, componentName) {
    prop_types_default().checkPropTypes((0,defineProperty/* default */.Z)({}, propName, validator), props, 'prop', componentName);
    isFunction(callback) && callback(props, propName, componentName);
  };
}
function caseSensitiveType(props) {
  var caseSensitive = props.caseSensitive,
      filterBy = props.filterBy;
  warn_warn(!caseSensitive || typeof filterBy !== 'function', 'Your `filterBy` function will override the `caseSensitive` prop.');
}
function deprecated(validator, reason) {
  return function (props, propName, componentName) {
    if (props[propName] != null) {
      warn(false, "The `".concat(propName, "` prop is deprecated. ").concat(reason));
    }

    return PropTypes.checkPropTypes(_defineProperty({}, propName, validator), props, 'prop', componentName);
  };
}
function defaultInputValueType(props) {
  var defaultInputValue = props.defaultInputValue,
      defaultSelected = props.defaultSelected,
      multiple = props.multiple,
      selected = props.selected;
  var name = defaultSelected.length ? 'defaultSelected' : 'selected';
  warn_warn(!(!multiple && defaultInputValue && (defaultSelected.length || selected && selected.length)), "`defaultInputValue` will be overridden by the value from `".concat(name, "`."));
}
function defaultSelectedType(props) {
  var defaultSelected = props.defaultSelected,
      multiple = props.multiple;
  warn_warn(multiple || defaultSelected.length <= 1, 'You are passing multiple options to the `defaultSelected` prop of a ' + 'Typeahead in single-select mode. The selections will be truncated to a ' + 'single selection.');
}
function highlightOnlyResultType(_ref) {
  var allowNew = _ref.allowNew,
      highlightOnlyResult = _ref.highlightOnlyResult;
  warn_warn(!(highlightOnlyResult && allowNew), '`highlightOnlyResult` will not work with `allowNew`.');
}
function ignoreDiacriticsType(props) {
  var filterBy = props.filterBy,
      ignoreDiacritics = props.ignoreDiacritics;
  warn_warn(ignoreDiacritics || typeof filterBy !== 'function', 'Your `filterBy` function will override the `ignoreDiacritics` prop.');
}
function inputPropsType(_ref2) {
  var inputProps = _ref2.inputProps;

  if (!(inputProps && Object.prototype.toString.call(inputProps) === '[object Object]')) {
    return;
  } // Blacklisted properties.


  INPUT_PROPS_BLACKLIST.forEach(function (_ref3) {
    var alt = _ref3.alt,
        prop = _ref3.prop;
    var msg = alt ? " Use the top-level `".concat(alt, "` prop instead.") : null;
    warn_warn(!inputProps[prop], "The `".concat(prop, "` property of `inputProps` will be ignored.").concat(msg));
  });
}
function isRequiredForA11y(props, propName, componentName) {
  warn_warn(props[propName] != null, "The prop `".concat(propName, "` is required to make `").concat(componentName, "` ") + 'accessible for users of assistive technologies such as screen readers.');
}
function labelKeyType(_ref4) {
  var allowNew = _ref4.allowNew,
      labelKey = _ref4.labelKey;
  warn_warn(!(isFunction(labelKey) && allowNew), '`labelKey` must be a string when `allowNew={true}`.');
}
var optionType = prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).string]);
function selectedType(_ref5) {
  var multiple = _ref5.multiple,
      onChange = _ref5.onChange,
      selected = _ref5.selected;
  warn_warn(multiple || !selected || selected.length <= 1, 'You are passing multiple options to the `selected` prop of a Typeahead ' + 'in single-select mode. This may lead to unexpected behaviors or errors.');
  warn_warn(!selected || selected && isFunction(onChange), 'You provided a `selected` prop without an `onChange` handler. If you ' + 'want the typeahead to be uncontrolled, use `defaultSelected`. ' + 'Otherwise, set `onChange`.');
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/behaviors/async.js



var async_excluded = ["allowNew", "delay", "emptyLabel", "isLoading", "minLength", "onInputChange", "onSearch", "options", "promptText", "searchText", "useCache"];

function async_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function async_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { async_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { async_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var propTypes = {
  /**
   * Delay, in milliseconds, before performing search.
   */
  delay: (prop_types_default()).number,

  /**
   * Whether or not a request is currently pending. Necessary for the
   * container to know when new results are available.
   */
  isLoading: (prop_types_default()).bool.isRequired,

  /**
   * Number of input characters that must be entered before showing results.
   */
  minLength: (prop_types_default()).number,

  /**
   * Callback to perform when the search is executed.
   */
  onSearch: (prop_types_default()).func.isRequired,

  /**
   * Options to be passed to the typeahead. Will typically be the query
   * results, but can also be initial default options.
   */
  options: prop_types_default().arrayOf(optionType),

  /**
   * Message displayed in the menu when there is no user input.
   */
  promptText: (prop_types_default()).node,

  /**
   * Message displayed in the menu while the request is pending.
   */
  searchText: (prop_types_default()).node,

  /**
   * Whether or not the component should cache query results.
   */
  useCache: (prop_types_default()).bool
};

/**
 * Logic that encapsulates common behavior and functionality around
 * asynchronous searches, including:
 *
 *  - Debouncing user input
 *  - Optional query caching
 *  - Search prompt and empty results behaviors
 */
function useAsync(props) {
  var allowNew = props.allowNew,
      _props$delay = props.delay,
      delay = _props$delay === void 0 ? 200 : _props$delay,
      emptyLabel = props.emptyLabel,
      isLoading = props.isLoading,
      _props$minLength = props.minLength,
      minLength = _props$minLength === void 0 ? 2 : _props$minLength,
      onInputChange = props.onInputChange,
      onSearch = props.onSearch,
      _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      _props$promptText = props.promptText,
      promptText = _props$promptText === void 0 ? 'Type to search...' : _props$promptText,
      _props$searchText = props.searchText,
      searchText = _props$searchText === void 0 ? 'Searching...' : _props$searchText,
      _props$useCache = props.useCache,
      useCache = _props$useCache === void 0 ? true : _props$useCache,
      otherProps = _objectWithoutProperties(props, async_excluded);

  var cacheRef = (0,react.useRef)({});
  var handleSearchDebouncedRef = (0,react.useRef)(null);
  var queryRef = (0,react.useRef)(props.defaultInputValue || '');
  var forceUpdate = (0,useForceUpdate/* default */.Z)();
  var prevProps = (0,usePrevious/* default */.Z)(props);
  var handleSearch = (0,react.useCallback)(function (query) {
    queryRef.current = query;

    if (!query || minLength && query.length < minLength) {
      return;
    } // Use cached results, if applicable.


    if (useCache && cacheRef.current[query]) {
      // Re-render the component with the cached results.
      forceUpdate();
      return;
    } // Perform the search.


    onSearch(query);
  }, [forceUpdate, minLength, onSearch, useCache]); // Set the debounced search function.

  (0,react.useEffect)(function () {
    handleSearchDebouncedRef.current = lodash_debounce_default()(handleSearch, delay);
    return function () {
      handleSearchDebouncedRef.current && handleSearchDebouncedRef.current.cancel();
    };
  }, [delay, handleSearch]);
  (0,react.useEffect)(function () {
    // Ensure that we've gone from a loading to a completed state. Otherwise
    // an empty response could get cached if the component updates during the
    // request (eg: if the parent re-renders for some reason).
    if (!isLoading && prevProps && prevProps.isLoading && useCache) {
      cacheRef.current[queryRef.current] = options;
    }
  });

  var getEmptyLabel = function getEmptyLabel() {
    if (!queryRef.current.length) {
      return promptText;
    }

    if (isLoading) {
      return searchText;
    }

    return emptyLabel;
  };

  var handleInputChange = (0,react.useCallback)(function (query, e) {
    onInputChange && onInputChange(query, e);
    handleSearchDebouncedRef.current && handleSearchDebouncedRef.current(query);
  }, [onInputChange]);
  var cachedQuery = cacheRef.current[queryRef.current];
  return async_objectSpread(async_objectSpread({}, otherProps), {}, {
    // Disable custom selections during a search if `allowNew` isn't a function.
    allowNew: isFunction(allowNew) ? allowNew : allowNew && !isLoading,
    emptyLabel: getEmptyLabel(),
    isLoading: isLoading,
    minLength: minLength,
    onInputChange: handleInputChange,
    options: useCache && cachedQuery ? cachedQuery : options
  });
}
function withAsync(Component) {
  var AsyncTypeahead = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
    return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, useAsync(props), {
      ref: ref
    }));
  });
  AsyncTypeahead.displayName = "withAsync(".concat(getDisplayName_getDisplayName(Component), ")"); // @ts-ignore

  AsyncTypeahead.propTypes = propTypes;
  return AsyncTypeahead;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(7688);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,setPrototypeOf/* default */.Z)(subClass, superClass);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/contains.js
var contains = __webpack_require__(26712);
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/listen.js
var listen = __webpack_require__(17692);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+hooks@0.3.27_react@17.0.2/node_modules/@restart/hooks/esm/useCommittedRef.js

/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded befor being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */

function useCommittedRef(value) {
  var ref = (0,react.useRef)(value);
  (0,react.useEffect)(function () {
    ref.current = value;
  }, [value]);
  return ref;
}

/* harmony default export */ var esm_useCommittedRef = (useCommittedRef);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+hooks@0.3.27_react@17.0.2/node_modules/@restart/hooks/esm/useEventCallback.js


function useEventCallback(fn) {
  var ref = esm_useCommittedRef(fn);
  return (0,react.useCallback)(function () {
    return ref.current && ref.current.apply(ref, arguments);
  }, [ref]);
}
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/ownerDocument.js
var ownerDocument = __webpack_require__(78342);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@17.0.2_react@17.0.2/node_modules/react-dom/index.js
var react_dom = __webpack_require__(87995);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-overlays@5.1.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-overlays/esm/safeFindDOMNode.js

function safeFindDOMNode(componentOrElement) {
  if (componentOrElement && 'setState' in componentOrElement) {
    return react_dom.findDOMNode(componentOrElement);
  }

  return componentOrElement != null ? componentOrElement : null;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-overlays@5.1.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-overlays/esm/ownerDocument.js


/* harmony default export */ var esm_ownerDocument = (function (componentOrElement) {
  return (0,ownerDocument/* default */.Z)(safeFindDOMNode(componentOrElement));
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-overlays@5.1.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-overlays/esm/useRootClose.js






var escapeKeyCode = 27;

var useRootClose_noop = function noop() {};

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var getRefTarget = function getRefTarget(ref) {
  return ref && ('current' in ref ? ref.current : ref);
};

/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */
function useRootClose(ref, onRootClose, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      disabled = _ref.disabled,
      _ref$clickTrigger = _ref.clickTrigger,
      clickTrigger = _ref$clickTrigger === void 0 ? 'click' : _ref$clickTrigger;

  var preventMouseRootCloseRef = (0,react.useRef)(false);
  var onClose = onRootClose || useRootClose_noop;
  var handleMouseCapture = (0,react.useCallback)(function (e) {
    var currentTarget = getRefTarget(ref);
    warning_default()(!!currentTarget, 'RootClose captured a close event but does not have a ref to compare it to. ' + 'useRootClose(), should be passed a ref that resolves to a DOM node');
    preventMouseRootCloseRef.current = !currentTarget || isModifiedEvent(e) || !isLeftClickEvent(e) || !!(0,contains/* default */.Z)(currentTarget, e.target);
  }, [ref]);
  var handleMouse = useEventCallback(function (e) {
    if (!preventMouseRootCloseRef.current) {
      onClose(e);
    }
  });
  var handleKeyUp = useEventCallback(function (e) {
    if (e.keyCode === escapeKeyCode) {
      onClose(e);
    }
  });
  (0,react.useEffect)(function () {
    if (disabled || ref == null) return undefined; // Store the current event to avoid triggering handlers immediately
    // https://github.com/facebook/react/issues/20074

    var currentEvent = window.event;
    var doc = esm_ownerDocument(getRefTarget(ref)); // Use capture for this listener so it fires before React's listener, to
    // avoid false positives in the contains() check below if the target DOM
    // element is removed in the React mouse callback.

    var removeMouseCaptureListener = (0,listen/* default */.Z)(doc, clickTrigger, handleMouseCapture, true);
    var removeMouseListener = (0,listen/* default */.Z)(doc, clickTrigger, function (e) {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }

      handleMouse(e);
    });
    var removeKeyupListener = (0,listen/* default */.Z)(doc, 'keyup', function (e) {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }

      handleKeyUp(e);
    });
    var mobileSafariHackListeners = [];

    if ('ontouchstart' in doc.documentElement) {
      mobileSafariHackListeners = [].slice.call(doc.body.children).map(function (el) {
        return (0,listen/* default */.Z)(el, 'mousemove', useRootClose_noop);
      });
    }

    return function () {
      removeMouseCaptureListener();
      removeMouseListener();
      removeKeyupListener();
      mobileSafariHackListeners.forEach(function (remove) {
        return remove();
      });
    };
  }, [ref, disabled, clickTrigger, handleMouseCapture, handleMouse, handleKeyUp]);
}

/* harmony default export */ var esm_useRootClose = (useRootClose);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/core/Context.js


var defaultContext = {
  activeIndex: -1,
  hintText: '',
  id: '',
  initialItem: null,
  inputNode: null,
  isOnlyResult: false,
  onActiveItemChange: noop,
  onAdd: noop,
  onInitialItemChange: noop,
  onMenuItemClick: noop,
  setItem: noop
};
var TypeaheadContext = /*#__PURE__*/(0,react.createContext)(defaultContext);
var useTypeaheadContext = function useTypeaheadContext() {
  return (0,react.useContext)(TypeaheadContext);
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/core/TypeaheadManager.js


function TypeaheadManager_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TypeaheadManager_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TypeaheadManager_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TypeaheadManager_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var inputPropKeys = ['activeIndex', 'disabled', 'id', 'inputRef', 'isFocused', 'isMenuShown', 'multiple', 'onBlur', 'onChange', 'onClick', 'onFocus', 'onKeyDown', 'placeholder'];
var propKeys = ['activeIndex', 'hideMenu', 'isMenuShown', 'labelKey', 'onClear', 'onHide', 'onRemove', 'results', 'selected', 'text', 'toggleMenu'];
var contextKeys = ['activeIndex', 'id', 'initialItem', 'inputNode', 'onActiveItemChange', 'onAdd', 'onInitialItemChange', 'onMenuItemClick', 'setItem'];

var TypeaheadManager = function TypeaheadManager(props) {
  var allowNew = props.allowNew,
      children = props.children,
      initialItem = props.initialItem,
      isMenuShown = props.isMenuShown,
      onAdd = props.onAdd,
      onInitialItemChange = props.onInitialItemChange,
      onKeyDown = props.onKeyDown,
      onMenuToggle = props.onMenuToggle,
      results = props.results,
      selectHint = props.selectHint;
  var prevProps = (0,usePrevious/* default */.Z)(props);
  var hintText = utils_getHintText(props);
  (0,react.useEffect)(function () {
    // Clear the initial item when there are no results.
    if (!(allowNew || results.length)) {
      onInitialItemChange();
    }
  });
  (0,react.useEffect)(function () {
    if (prevProps && prevProps.isMenuShown !== isMenuShown) {
      onMenuToggle(isMenuShown);
    }
  });

  var handleKeyDown = function handleKeyDown(e) {
    onKeyDown(e);

    if (!initialItem) {
      return;
    }

    var addOnlyResult = e.key === 'Enter' && utils_getIsOnlyResult(props);
    var shouldSelectHint = hintText && defaultSelectHint(e, selectHint);

    if (addOnlyResult || shouldSelectHint) {
      onAdd(initialItem);
    }
  };

  var childProps = TypeaheadManager_objectSpread(TypeaheadManager_objectSpread({}, pick(props, propKeys)), {}, {
    getInputProps: utils_getInputProps(TypeaheadManager_objectSpread(TypeaheadManager_objectSpread({}, pick(props, inputPropKeys)), {}, {
      onKeyDown: handleKeyDown,
      value: utils_getInputText(props)
    }))
  });

  var contextValue = TypeaheadManager_objectSpread(TypeaheadManager_objectSpread({}, pick(props, contextKeys)), {}, {
    hintText: hintText,
    isOnlyResult: utils_getIsOnlyResult(props)
  });

  return /*#__PURE__*/react.createElement(TypeaheadContext.Provider, {
    value: contextValue
  }, isFunction(children) ? children(childProps) : children);
};

/* harmony default export */ var core_TypeaheadManager = (TypeaheadManager);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/core/Typeahead.js









var Typeahead_excluded = ["onChange"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Typeahead_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Typeahead_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Typeahead_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Typeahead_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var Typeahead_propTypes = {
  /**
   * Allows the creation of new selections on the fly. Note that any new items
   * will be added to the list of selections, but not the list of original
   * options unless handled as such by `Typeahead`'s parent.
   *
   * If a function is specified, it will be used to determine whether a custom
   * option should be included. The return value should be true or false.
   */
  allowNew: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).func]),

  /**
   * Autofocus the input when the component initially mounts.
   */
  autoFocus: (prop_types_default()).bool,

  /**
   * Whether or not filtering should be case-sensitive.
   */
  caseSensitive: checkPropType((prop_types_default()).bool, caseSensitiveType),

  /**
   * The initial value displayed in the text input.
   */
  defaultInputValue: checkPropType((prop_types_default()).string, defaultInputValueType),

  /**
   * Whether or not the menu is displayed upon initial render.
   */
  defaultOpen: (prop_types_default()).bool,

  /**
   * Specify any pre-selected options. Use only if you want the component to
   * be uncontrolled.
   */
  defaultSelected: checkPropType(prop_types_default().arrayOf(optionType), defaultSelectedType),

  /**
   * Either an array of fields in `option` to search, or a custom filtering
   * callback.
   */
  filterBy: prop_types_default().oneOfType([prop_types_default().arrayOf((prop_types_default()).string.isRequired), (prop_types_default()).func]),

  /**
   * Highlights the menu item if there is only one result and allows selecting
   * that item by hitting enter. Does not work with `allowNew`.
   */
  highlightOnlyResult: checkPropType((prop_types_default()).bool, highlightOnlyResultType),

  /**
   * An html id attribute, required for assistive technologies such as screen
   * readers.
   */
  id: checkPropType(prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]), isRequiredForA11y),

  /**
   * Whether the filter should ignore accents and other diacritical marks.
   */
  ignoreDiacritics: checkPropType((prop_types_default()).bool, ignoreDiacriticsType),

  /**
   * Specify the option key to use for display or a function returning the
   * display string. By default, the selector will use the `label` key.
   */
  labelKey: checkPropType(prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).func]), labelKeyType),

  /**
   * Maximum number of results to display by default. Mostly done for
   * performance reasons so as not to render too many DOM nodes in the case of
   * large data sets.
   */
  maxResults: (prop_types_default()).number,

  /**
   * Number of input characters that must be entered before showing results.
   */
  minLength: (prop_types_default()).number,

  /**
   * Whether or not multiple selections are allowed.
   */
  multiple: (prop_types_default()).bool,

  /**
   * Invoked when the input is blurred. Receives an event.
   */
  onBlur: (prop_types_default()).func,

  /**
   * Invoked whenever items are added or removed. Receives an array of the
   * selected options.
   */
  onChange: (prop_types_default()).func,

  /**
   * Invoked when the input is focused. Receives an event.
   */
  onFocus: (prop_types_default()).func,

  /**
   * Invoked when the input value changes. Receives the string value of the
   * input.
   */
  onInputChange: (prop_types_default()).func,

  /**
   * Invoked when a key is pressed. Receives an event.
   */
  onKeyDown: (prop_types_default()).func,

  /**
   * Invoked when menu visibility changes.
   */
  onMenuToggle: (prop_types_default()).func,

  /**
   * Invoked when the pagination menu item is clicked. Receives an event.
   */
  onPaginate: (prop_types_default()).func,

  /**
   * Whether or not the menu should be displayed. `undefined` allows the
   * component to control visibility, while `true` and `false` show and hide
   * the menu, respectively.
   */
  open: (prop_types_default()).bool,

  /**
   * Full set of options, including pre-selected options. Must either be an
   * array of objects (recommended) or strings.
   */
  options: prop_types_default().arrayOf(optionType).isRequired,

  /**
   * Give user the ability to display additional results if the number of
   * results exceeds `maxResults`.
   */
  paginate: (prop_types_default()).bool,

  /**
   * The selected option(s) displayed in the input. Use this prop if you want
   * to control the component via its parent.
   */
  selected: checkPropType(prop_types_default().arrayOf(optionType), selectedType)
};
var defaultProps = {
  allowNew: false,
  autoFocus: false,
  caseSensitive: false,
  defaultInputValue: '',
  defaultOpen: false,
  defaultSelected: [],
  filterBy: [],
  highlightOnlyResult: false,
  ignoreDiacritics: true,
  labelKey: DEFAULT_LABELKEY,
  maxResults: 100,
  minLength: 0,
  multiple: false,
  onBlur: noop,
  onFocus: noop,
  onInputChange: noop,
  onKeyDown: noop,
  onMenuToggle: noop,
  onPaginate: noop,
  paginate: true
};
function getInitialState(props) {
  var defaultInputValue = props.defaultInputValue,
      defaultOpen = props.defaultOpen,
      defaultSelected = props.defaultSelected,
      maxResults = props.maxResults,
      multiple = props.multiple;
  var selected = props.selected ? props.selected.slice() : defaultSelected.slice();
  var text = defaultInputValue;

  if (!multiple && selected.length) {
    // Set the text if an initial selection is passed in.
    text = utils_getOptionLabel(selected[0], props.labelKey);

    if (selected.length > 1) {
      // Limit to 1 selection in single-select mode.
      selected = selected.slice(0, 1);
    }
  }

  return {
    activeIndex: -1,
    activeItem: undefined,
    initialItem: undefined,
    isFocused: false,
    selected: selected,
    showMenu: defaultOpen,
    shownResults: maxResults,
    text: text
  };
}
function clearTypeahead(state, props) {
  return Typeahead_objectSpread(Typeahead_objectSpread({}, getInitialState(props)), {}, {
    isFocused: state.isFocused,
    selected: [],
    text: ''
  });
}
function clickOrFocusInput(state) {
  return Typeahead_objectSpread(Typeahead_objectSpread({}, state), {}, {
    isFocused: true,
    showMenu: true
  });
}
function hideMenu(state, props) {
  var _getInitialState = getInitialState(props),
      activeIndex = _getInitialState.activeIndex,
      activeItem = _getInitialState.activeItem,
      initialItem = _getInitialState.initialItem,
      shownResults = _getInitialState.shownResults;

  return Typeahead_objectSpread(Typeahead_objectSpread({}, state), {}, {
    activeIndex: activeIndex,
    activeItem: activeItem,
    initialItem: initialItem,
    showMenu: false,
    shownResults: shownResults
  });
}
function toggleMenu(state, props) {
  return state.showMenu ? hideMenu(state, props) : Typeahead_objectSpread(Typeahead_objectSpread({}, state), {}, {
    showMenu: true
  });
}
/**
 * Manually trigger the input's change event.
 * https://stackoverflow.com/questions/23892547/what-is-the-best-way-to-trigger-onchange-event-in-react-js/46012210#46012210
 */

function triggerInputChange(input, value) {
  var inputValue = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
  inputValue && inputValue.set && inputValue.set.call(input, value);
  var e = new Event('input', {
    bubbles: true
  });
  input.dispatchEvent(e);
}

var Typeahead = /*#__PURE__*/function (_React$Component) {
  _inherits(Typeahead, _React$Component);

  var _super = _createSuper(Typeahead);

  function Typeahead() {
    var _this;

    _classCallCheck(this, Typeahead);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "state", getInitialState(_this.props));

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "inputNode", null);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "isMenuShown", false);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "items", []);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "blur", function () {
      _this.inputNode && _this.inputNode.blur();

      _this.hideMenu();
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "clear", function () {
      _this.setState(clearTypeahead);
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "focus", function () {
      _this.inputNode && _this.inputNode.focus();
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "getInput", function () {
      return _this.inputNode;
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "inputRef", function (inputNode) {
      _this.inputNode = inputNode;
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "setItem", function (item, position) {
      _this.items[position] = item;
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "hideMenu", function () {
      _this.setState(hideMenu);
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "toggleMenu", function () {
      _this.setState(toggleMenu);
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_handleActiveIndexChange", function (activeIndex) {
      _this.setState(function (state) {
        return {
          activeIndex: activeIndex,
          activeItem: activeIndex >= 0 ? state.activeItem : undefined
        };
      });
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_handleActiveItemChange", function (activeItem) {
      // Don't update the active item if it hasn't changed.
      if (!fast_deep_equal_default()(activeItem, _this.state.activeItem)) {
        _this.setState({
          activeItem: activeItem
        });
      }
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_handleBlur", function (e) {
      e.persist();

      _this.setState({
        isFocused: false
      }, function () {
        return _this.props.onBlur(e);
      });
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_handleChange", function (selected) {
      _this.props.onChange && _this.props.onChange(selected);
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_handleClear", function () {
      _this.inputNode && triggerInputChange(_this.inputNode, '');

      _this.setState(clearTypeahead, function () {
        // Change handler is automatically triggered for single selections but
        // not multi-selections.
        if (_this.props.multiple) {
          _this._handleChange([]);
        }
      });
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_handleClick", function (e) {
      var _this$props$inputProp;

      e.persist();
      var onClick = (_this$props$inputProp = _this.props.inputProps) === null || _this$props$inputProp === void 0 ? void 0 : _this$props$inputProp.onClick;

      _this.setState(clickOrFocusInput, function () {
        return isFunction(onClick) && onClick(e);
      });
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_handleFocus", function (e) {
      e.persist();

      _this.setState(clickOrFocusInput, function () {
        return _this.props.onFocus(e);
      });
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_handleInitialItemChange", function (initialItem) {
      // Don't update the initial item if it hasn't changed.
      if (!fast_deep_equal_default()(initialItem, _this.state.initialItem)) {
        _this.setState({
          initialItem: initialItem
        });
      }
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_handleInputChange", function (e) {
      e.persist();
      var text = e.currentTarget.value;
      var _this$props = _this.props,
          multiple = _this$props.multiple,
          onInputChange = _this$props.onInputChange; // Clear selections when the input value changes in single-select mode.

      var shouldClearSelections = _this.state.selected.length && !multiple;

      _this.setState(function (state, props) {
        var _getInitialState2 = getInitialState(props),
            activeIndex = _getInitialState2.activeIndex,
            activeItem = _getInitialState2.activeItem,
            shownResults = _getInitialState2.shownResults;

        return {
          activeIndex: activeIndex,
          activeItem: activeItem,
          selected: shouldClearSelections ? [] : state.selected,
          showMenu: true,
          shownResults: shownResults,
          text: text
        };
      }, function () {
        onInputChange(text, e);
        shouldClearSelections && _this._handleChange([]);
      });
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_handleKeyDown", function (e) {
      var activeItem = _this.state.activeItem; // Skip most actions when the menu is hidden.

      if (!_this.isMenuShown) {
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
          _this.setState({
            showMenu: true
          });
        }

        _this.props.onKeyDown(e);

        return;
      }

      switch (e.key) {
        case 'ArrowUp':
        case 'ArrowDown':
          // Prevent input cursor from going to the beginning when pressing up.
          e.preventDefault();

          _this._handleActiveIndexChange(getUpdatedActiveIndex(_this.state.activeIndex, e.key, _this.items));

          break;

        case 'Enter':
          // Prevent form submission while menu is open.
          e.preventDefault();
          activeItem && _this._handleMenuItemSelect(activeItem, e);
          break;

        case 'Escape':
        case 'Tab':
          // ESC simply hides the menu. TAB will blur the input and move focus to
          // the next item; hide the menu so it doesn't gain focus.
          _this.hideMenu();

          break;

        default:
          break;
      }

      _this.props.onKeyDown(e);
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_handleMenuItemSelect", function (option, e) {
      if (getOptionProperty(option, 'paginationOption')) {
        _this._handlePaginate(e);
      } else {
        _this._handleSelectionAdd(option);
      }
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_handlePaginate", function (e) {
      e.persist();

      _this.setState(function (state, props) {
        return {
          shownResults: state.shownResults + props.maxResults
        };
      }, function () {
        return _this.props.onPaginate(e, _this.state.shownResults);
      });
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_handleSelectionAdd", function (option) {
      var _this$props2 = _this.props,
          multiple = _this$props2.multiple,
          labelKey = _this$props2.labelKey;
      var selected;
      var selection = option;
      var text; // Add a unique id to the custom selection. Avoid doing this in `render` so
      // the id doesn't increment every time.

      if (!isString(selection) && selection.customOption) {
        selection = Typeahead_objectSpread(Typeahead_objectSpread({}, selection), {}, {
          id: uniqueId('new-id-')
        });
      }

      if (multiple) {
        // If multiple selections are allowed, add the new selection to the
        // existing selections.
        selected = _this.state.selected.concat(selection);
        text = '';
      } else {
        // If only a single selection is allowed, replace the existing selection
        // with the new one.
        selected = [selection];
        text = utils_getOptionLabel(selection, labelKey);
      }

      _this.setState(function (state, props) {
        return Typeahead_objectSpread(Typeahead_objectSpread({}, hideMenu(state, props)), {}, {
          initialItem: selection,
          selected: selected,
          text: text
        });
      }, function () {
        return _this._handleChange(selected);
      });
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_handleSelectionRemove", function (selection) {
      var selected = _this.state.selected.filter(function (option) {
        return !fast_deep_equal_default()(option, selection);
      }); // Make sure the input stays focused after the item is removed.


      _this.focus();

      _this.setState(function (state, props) {
        return Typeahead_objectSpread(Typeahead_objectSpread({}, hideMenu(state, props)), {}, {
          selected: selected
        });
      }, function () {
        return _this._handleChange(selected);
      });
    });

    return _this;
  }

  _createClass(Typeahead, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.autoFocus && this.focus();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props3 = this.props,
          labelKey = _this$props3.labelKey,
          multiple = _this$props3.multiple,
          selected = _this$props3.selected;
      validateSelectedPropChange(selected, prevProps.selected); // Sync selections in state with those in props.

      if (selected && !fast_deep_equal_default()(selected, prevState.selected)) {
        this.setState({
          selected: selected
        });

        if (!multiple) {
          this.setState({
            text: selected.length ? utils_getOptionLabel(selected[0], labelKey) : ''
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          onChange = _this$props4.onChange,
          props = _objectWithoutProperties(_this$props4, Typeahead_excluded);

      var mergedPropsAndState = Typeahead_objectSpread(Typeahead_objectSpread({}, props), this.state);

      var filterBy = mergedPropsAndState.filterBy,
          labelKey = mergedPropsAndState.labelKey,
          options = mergedPropsAndState.options,
          paginate = mergedPropsAndState.paginate,
          shownResults = mergedPropsAndState.shownResults,
          text = mergedPropsAndState.text;
      this.isMenuShown = isShown(mergedPropsAndState);
      this.items = []; // Reset items on re-render.

      var results = [];

      if (this.isMenuShown) {
        var cb = isFunction(filterBy) ? filterBy : defaultFilterBy;
        results = options.filter(function (option) {
          return cb(option, mergedPropsAndState);
        }); // This must come before results are truncated.

        var shouldPaginate = paginate && results.length > shownResults; // Truncate results if necessary.

        results = utils_getTruncatedOptions(results, shownResults); // Add the custom option if necessary.

        if (utils_addCustomOption(results, mergedPropsAndState)) {
          results.push((0,defineProperty/* default */.Z)({
            customOption: true
          }, getStringLabelKey(labelKey), text));
        } // Add the pagination item if necessary.


        if (shouldPaginate) {
          var _results$push2;

          results.push((_results$push2 = {}, (0,defineProperty/* default */.Z)(_results$push2, getStringLabelKey(labelKey), ''), (0,defineProperty/* default */.Z)(_results$push2, "paginationOption", true), _results$push2));
        }
      }

      return /*#__PURE__*/react.createElement(core_TypeaheadManager, (0,esm_extends/* default */.Z)({}, mergedPropsAndState, {
        hideMenu: this.hideMenu,
        inputNode: this.inputNode,
        inputRef: this.inputRef,
        isMenuShown: this.isMenuShown,
        onActiveItemChange: this._handleActiveItemChange,
        onAdd: this._handleSelectionAdd,
        onBlur: this._handleBlur,
        onChange: this._handleInputChange,
        onClear: this._handleClear,
        onClick: this._handleClick,
        onFocus: this._handleFocus,
        onHide: this.hideMenu,
        onInitialItemChange: this._handleInitialItemChange,
        onKeyDown: this._handleKeyDown,
        onMenuItemClick: this._handleMenuItemSelect,
        onRemove: this._handleSelectionRemove,
        results: results,
        setItem: this.setItem,
        toggleMenu: this.toggleMenu
      }));
    }
  }]);

  return Typeahead;
}(react.Component);

(0,defineProperty/* default */.Z)(Typeahead, "propTypes", Typeahead_propTypes);

(0,defineProperty/* default */.Z)(Typeahead, "defaultProps", defaultProps);

/* harmony default export */ var core_Typeahead = (Typeahead);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/ClearButton/ClearButton.js


var ClearButton_excluded = ["className", "label", "onClick", "onKeyDown", "size"];





var ClearButton_propTypes = {
  label: (prop_types_default()).string,
  onClick: (prop_types_default()).func,
  onKeyDown: (prop_types_default()).func,
  size: sizeType
};
var ClearButton_defaultProps = {
  label: 'Clear'
};

/**
 * ClearButton
 *
 * http://getbootstrap.com/css/#helper-classes-close
 */
var ClearButton = function ClearButton(_ref) {
  var className = _ref.className,
      label = _ref.label,
      _onClick = _ref.onClick,
      _onKeyDown = _ref.onKeyDown,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ClearButton_excluded);

  return /*#__PURE__*/react.createElement("button", (0,esm_extends/* default */.Z)({}, props, {
    "aria-label": label,
    className: classnames_default()('close', 'btn-close', 'rbt-close', {
      'rbt-close-lg': isSizeLarge(size),
      'rbt-close-sm': isSizeSmall(size)
    }, className),
    onClick: function onClick(e) {
      e.stopPropagation();
      _onClick && _onClick(e);
    },
    onKeyDown: function onKeyDown(e) {
      // Prevent browser from navigating back.
      if (e.key === 'Backspace') {
        e.preventDefault();
      }

      _onKeyDown && _onKeyDown(e);
    },
    type: "button"
  }), /*#__PURE__*/react.createElement("span", {
    "aria-hidden": "true",
    className: "rbt-close-content"
  }, "\xD7"), /*#__PURE__*/react.createElement("span", {
    className: "sr-only visually-hidden"
  }, label));
};

ClearButton.propTypes = ClearButton_propTypes;
ClearButton.defaultProps = ClearButton_defaultProps;
/* harmony default export */ var ClearButton_ClearButton = (ClearButton);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/ClearButton/index.js


;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/Loader/Loader.js


var Loader_propTypes = {
  label: (prop_types_default()).string
};
var Loader_defaultProps = {
  label: 'Loading...'
};

var Loader = function Loader(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/react.createElement("div", {
    className: "rbt-loader spinner-border spinner-border-sm",
    role: "status"
  }, /*#__PURE__*/react.createElement("span", {
    className: "sr-only visually-hidden"
  }, label));
};

Loader.propTypes = Loader_propTypes;
Loader.defaultProps = Loader_defaultProps;
/* harmony default export */ var Loader_Loader = (Loader);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/Loader/index.js


// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/createPopper.js + 6 modules
var createPopper = __webpack_require__(32829);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/modifiers/eventListeners.js
var eventListeners = __webpack_require__(78425);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/modifiers/popperOffsets.js
var popperOffsets = __webpack_require__(93809);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/modifiers/computeStyles.js
var computeStyles = __webpack_require__(83148);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
var getNodeName = __webpack_require__(30741);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
var instanceOf = __webpack_require__(8792);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!(0,instanceOf/* isHTMLElement */.Re)(element) || !(0,getNodeName/* default */.Z)(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!(0,instanceOf/* isHTMLElement */.Re)(element) || !(0,getNodeName/* default */.Z)(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect,
  requires: ['computeStyles']
});
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/modifiers/offset.js
var offset = __webpack_require__(87883);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/modifiers/flip.js + 3 modules
var flip = __webpack_require__(89858);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/modifiers/preventOverflow.js + 1 modules
var preventOverflow = __webpack_require__(7382);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/modifiers/arrow.js
var arrow = __webpack_require__(40002);
// EXTERNAL MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/modifiers/hide.js
var hide = __webpack_require__(5445);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@popperjs+core@2.11.4/node_modules/@popperjs/core/lib/popper.js










var defaultModifiers = [eventListeners/* default */.Z, popperOffsets/* default */.Z, computeStyles/* default */.Z, modifiers_applyStyles, offset/* default */.Z, flip/* default */.Z, preventOverflow/* default */.Z, arrow/* default */.Z, hide/* default */.Z];
var popper_createPopper = /*#__PURE__*/(0,createPopper/* popperGenerator */.kZ)({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


// EXTERNAL MODULE: ./node_modules/.pnpm/react-fast-compare@3.2.0/node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__(61970);
var react_fast_compare_default = /*#__PURE__*/__webpack_require__.n(react_fast_compare);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-popper@2.2.5_f2o5qdn5jx3hkjcnqvzjhvgfwa/node_modules/react-popper/lib/esm/utils.js


/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-popper@2.2.5_f2o5qdn5jx3hkjcnqvzjhvgfwa/node_modules/react-popper/lib/esm/usePopper.js




var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = react.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };

  var _React$useState = react.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = react.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        setState({
          styles: fromEntries(elements.map(function (element) {
            return [element, state.styles[element] || {}];
          })),
          attributes: fromEntries(elements.map(function (element) {
            return [element, state.attributes[element]];
          }))
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = react.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (react_fast_compare_default()(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = react.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper = options.createPopper || popper_createPopper;
    var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/Overlay/Overlay.js



var Overlay_excluded = ["referenceElement"];

function Overlay_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Overlay_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Overlay_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Overlay_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var alignValues = ['justify', 'left', 'right'];
// `Element` is not defined during server-side rendering, so shim it here.

/* istanbul ignore next */
var SafeElement = typeof Element === 'undefined' ? noop : Element;
var Overlay_propTypes = {
  /**
   * Specify menu alignment. The default value is `justify`, which makes the
   * menu as wide as the input and truncates long values. Specifying `left`
   * or `right` will align the menu to that side and the width will be
   * determined by the length of menu item values.
   */
  align: prop_types_default().oneOf(alignValues),
  children: (prop_types_default()).func.isRequired,

  /**
   * Specify whether the menu should appear above the input.
   */
  dropup: (prop_types_default()).bool,

  /**
   * Whether or not to automatically adjust the position of the menu when it
   * reaches the viewport boundaries.
   */
  flip: (prop_types_default()).bool,
  isMenuShown: (prop_types_default()).bool,
  positionFixed: (prop_types_default()).bool,
  // @ts-ignore
  referenceElement: prop_types_default().instanceOf(SafeElement)
};
var Overlay_defaultProps = {
  align: 'justify',
  dropup: false,
  flip: false,
  isMenuShown: false,
  positionFixed: false
};
var setPopperWidth = {
  enabled: true,
  fn: function fn(data) {
    // eslint-disable-next-line no-param-reassign
    data.state.styles.popper.width = "".concat(data.state.rects.reference.width, "px");
  },
  name: 'setPopperWidth',
  phase: 'write'
};
function getModifiers(props) {
  var modifiers = [{
    enabled: !!props.flip,
    name: 'flip'
  }];

  if (props.align !== 'right' && props.align !== 'left') {
    modifiers.push(setPopperWidth);
  }

  return modifiers;
}
function getPlacement(props) {
  var x = props.align === 'right' ? 'end' : 'start';
  var y = props.dropup ? 'top' : 'bottom';
  return "".concat(y, "-").concat(x);
}

var Overlay = function Overlay(_ref) {
  var referenceElement = _ref.referenceElement,
      props = _objectWithoutProperties(_ref, Overlay_excluded);

  var _useState = (0,react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      popperElement = _useState2[0],
      attachRef = _useState2[1];

  var _usePopper = usePopper(referenceElement, popperElement, {
    modifiers: getModifiers(props),
    placement: getPlacement(props),
    strategy: props.positionFixed ? 'fixed' : 'absolute'
  }),
      attributes = _usePopper.attributes,
      styles = _usePopper.styles,
      forceUpdate = _usePopper.forceUpdate;

  if (!props.isMenuShown) {
    return null;
  }

  return props.children(Overlay_objectSpread(Overlay_objectSpread({}, attributes.popper), {}, {
    innerRef: attachRef,
    inputHeight: (referenceElement === null || referenceElement === void 0 ? void 0 : referenceElement.offsetHeight) || 0,
    scheduleUpdate: forceUpdate,
    style: styles.popper
  }));
};

Overlay.propTypes = Overlay_propTypes;
Overlay.defaultProps = Overlay_defaultProps;
/* harmony default export */ var Overlay_Overlay = (Overlay);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/Overlay/index.js


;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/behaviors/token.js




var token_excluded = ["onBlur", "onClick", "onFocus", "onRemove", "option"];

function token_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function token_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { token_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { token_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var token_propTypes = {
  onBlur: (prop_types_default()).func,
  onClick: (prop_types_default()).func,
  onFocus: (prop_types_default()).func,
  onRemove: (prop_types_default()).func,
  option: optionType.isRequired
};
function useToken(_ref) {
  var onBlur = _ref.onBlur,
      onClick = _ref.onClick,
      onFocus = _ref.onFocus,
      onRemove = _ref.onRemove,
      option = _ref.option,
      props = _objectWithoutProperties(_ref, token_excluded);

  var _useState = (0,react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      rootElement = _useState4[0],
      attachRef = _useState4[1];

  var handleBlur = function handleBlur(e) {
    setActive(false);
    onBlur && onBlur(e);
  };

  var handleClick = function handleClick(e) {
    setActive(true);
    onClick && onClick(e);
  };

  var handleFocus = function handleFocus(e) {
    setActive(true);
    onFocus && onFocus(e);
  };

  var handleRemove = function handleRemove() {
    onRemove && onRemove(option);
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Backspace' && active) {
      // Prevent browser from going back.
      e.preventDefault();
      handleRemove();
    }
  };

  esm_useRootClose(rootElement, handleBlur, token_objectSpread(token_objectSpread({}, props), {}, {
    disabled: !active
  }));
  return {
    active: active,
    onBlur: handleBlur,
    onClick: handleClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onRemove: isFunction(onRemove) ? handleRemove : undefined,
    ref: attachRef
  };
}
/* istanbul ignore next */

function withToken(Component) {
  var displayName = "withToken(".concat(getDisplayName(Component), ")");

  var WrappedToken = function WrappedToken(props) {
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, useToken(props)));
  };

  WrappedToken.displayName = displayName;
  WrappedToken.propTypes = token_propTypes;
  return WrappedToken;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/Token/Token.js



var Token_excluded = ["active", "children", "className", "onRemove", "tabIndex"],
    _excluded2 = ["children", "option", "readOnly"],
    _excluded3 = ["ref"];

function Token_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Token_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Token_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Token_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var InteractiveToken = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      onRemove = _ref.onRemove,
      tabIndex = _ref.tabIndex,
      props = _objectWithoutProperties(_ref, Token_excluded);

  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
    className: classnames_default()('rbt-token', 'rbt-token-removeable', {
      'rbt-token-active': !!active
    }, className),
    ref: ref,
    tabIndex: tabIndex || 0
  }), children, /*#__PURE__*/react.createElement(ClearButton_ClearButton, {
    className: "rbt-token-remove-button",
    label: "Remove",
    onClick: onRemove,
    tabIndex: -1
  }));
});

var StaticToken = function StaticToken(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      disabled = _ref2.disabled,
      href = _ref2.href;
  var classnames = classnames_default()('rbt-token', {
    'rbt-token-disabled': disabled
  }, className);

  if (href && !disabled) {
    return /*#__PURE__*/react.createElement("a", {
      className: classnames,
      href: href
    }, children);
  }

  return /*#__PURE__*/react.createElement("div", {
    className: classnames
  }, children);
};

/**
 * Individual token component, generally displayed within the
 * `TypeaheadInputMulti` component, but can also be rendered on its own.
 */
var Token = function Token(_ref3) {
  var children = _ref3.children,
      option = _ref3.option,
      readOnly = _ref3.readOnly,
      props = _objectWithoutProperties(_ref3, _excluded2);

  var _useToken = useToken(Token_objectSpread(Token_objectSpread({}, props), {}, {
    option: option
  })),
      ref = _useToken.ref,
      tokenProps = _objectWithoutProperties(_useToken, _excluded3);

  var child = /*#__PURE__*/react.createElement("div", {
    className: "rbt-token-label"
  }, children);
  return !props.disabled && !readOnly && isFunction(tokenProps.onRemove) ? /*#__PURE__*/react.createElement(InteractiveToken, (0,esm_extends/* default */.Z)({}, props, tokenProps, {
    ref: ref
  }), child) : /*#__PURE__*/react.createElement(StaticToken, props, child);
};

/* harmony default export */ var Token_Token = (Token);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/Hint/Hint.js

 // IE doesn't seem to get the composite computed value (eg: 'padding',
// 'borderStyle', etc.), so generate these from the individual values.

function interpolateStyle(styles, attr) {
  var subattr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  // Title-case the sub-attribute.
  if (subattr) {
    /* eslint-disable-next-line no-param-reassign */
    subattr = subattr.replace(subattr[0], subattr[0].toUpperCase());
  }

  return ['Top', 'Right', 'Bottom', 'Left'].map(function (dir) {
    return styles["".concat(attr).concat(dir).concat(subattr)];
  }).join(' ');
}

function copyStyles(inputNode, hintNode) {
  var inputStyle = window.getComputedStyle(inputNode);
  /* eslint-disable no-param-reassign */

  hintNode.style.borderStyle = interpolateStyle(inputStyle, 'border', 'style');
  hintNode.style.borderWidth = interpolateStyle(inputStyle, 'border', 'width');
  hintNode.style.fontSize = inputStyle.fontSize;
  hintNode.style.height = inputStyle.height;
  hintNode.style.lineHeight = inputStyle.lineHeight;
  hintNode.style.margin = interpolateStyle(inputStyle, 'margin');
  hintNode.style.padding = interpolateStyle(inputStyle, 'padding');
  /* eslint-enable no-param-reassign */
}

var useHint = function useHint() {
  var _useTypeaheadContext = useTypeaheadContext(),
      hintText = _useTypeaheadContext.hintText,
      inputNode = _useTypeaheadContext.inputNode;

  var hintRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    if (inputNode && hintRef.current) {
      copyStyles(inputNode, hintRef.current);
    }
  });
  return {
    hintRef: hintRef,
    hintText: hintText
  };
};

var Hint = function Hint(_ref) {
  var children = _ref.children,
      className = _ref.className;

  var _useHint = useHint(),
      hintRef = _useHint.hintRef,
      hintText = _useHint.hintText;

  return /*#__PURE__*/react.createElement("div", {
    className: className,
    style: {
      display: 'flex',
      flex: 1,
      height: '100%',
      position: 'relative'
    }
  }, children, /*#__PURE__*/react.createElement("input", {
    "aria-hidden": true,
    className: "rbt-input-hint",
    ref: hintRef,
    readOnly: true,
    style: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      boxShadow: 'none',
      color: 'rgba(0, 0, 0, 0.54)',
      left: 0,
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      width: '100%'
    },
    tabIndex: -1,
    value: hintText
  }));
};

/* harmony default export */ var Hint_Hint = (Hint);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/Hint/index.js


;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/Input/Input.js



var Input = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/react.createElement("input", (0,esm_extends/* default */.Z)({}, props, {
    className: classnames_default()('rbt-input-main', props.className),
    ref: ref
  }));
});
/* harmony default export */ var Input_Input = (Input);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/Input/index.js


;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/behaviors/classNames.js


var classNames_excluded = ["className", "isInvalid", "isValid", "size"];

/* eslint-disable @typescript-eslint/no-explicit-any */




function withClassNames(Component) {
  var WrappedComponent = function WrappedComponent(_ref) {
    var className = _ref.className,
        isInvalid = _ref.isInvalid,
        isValid = _ref.isValid,
        size = _ref.size,
        props = _objectWithoutProperties(_ref, classNames_excluded);

    return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, {
      className: classnames_default()('form-control', 'rbt-input', {
        'form-control-lg': isSizeLarge(size),
        'form-control-sm': isSizeSmall(size),
        'is-invalid': isInvalid,
        'is-valid': isValid
      }, className)
    }));
  };

  WrappedComponent.displayName = "withClassNames(".concat(getDisplayName_getDisplayName(Component), ")");
  return WrappedComponent;
}

/* harmony default export */ var classNames = (withClassNames);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/TypeaheadInputMulti/TypeaheadInputMulti.js









var TypeaheadInputMulti_excluded = ["children", "className", "inputClassName", "inputRef", "placeholder", "referenceElementRef", "selected"];

function TypeaheadInputMulti_createSuper(Derived) { var hasNativeReflectConstruct = TypeaheadInputMulti_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function TypeaheadInputMulti_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */







var TypeaheadInputMulti = /*#__PURE__*/function (_React$Component) {
  _inherits(TypeaheadInputMulti, _React$Component);

  var _super = TypeaheadInputMulti_createSuper(TypeaheadInputMulti);

  function TypeaheadInputMulti() {
    var _this;

    _classCallCheck(this, TypeaheadInputMulti);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "wrapperRef", /*#__PURE__*/react.createRef());

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_input", null);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "getInputRef", function (input) {
      _this._input = input;

      _this.props.inputRef(input);
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_handleContainerClickOrFocus", function (e) {
      // Don't focus the input if it's disabled.
      if (_this.props.disabled) {
        e.currentTarget.blur();
        return;
      }

      var inputNode = _this._input;

      if (!inputNode || // Ignore if the clicked element is a child of the container, ie: a token
      // or the input itself.
      e.currentTarget.contains(e.target) && e.currentTarget !== e.target) {
        return;
      }

      if (isSelectable(inputNode)) {
        // Move cursor to the end if the user clicks outside the actual input.
        inputNode.selectionStart = inputNode.value.length;
      }

      inputNode.focus();
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_handleKeyDown", function (e) {
      var _this$props = _this.props,
          onKeyDown = _this$props.onKeyDown,
          selected = _this$props.selected,
          value = _this$props.value;

      if (e.key === 'Backspace' && selected.length && !value) {
        // Prevent browser from going back.
        e.preventDefault(); // If the input is selected and there is no text, focus the last
        // token when the user hits backspace.

        if (_this.wrapperRef.current) {
          var children = _this.wrapperRef.current.children;
          var lastToken = children[children.length - 2];
          lastToken && lastToken.focus();
        }
      }

      onKeyDown && onKeyDown(e);
    });

    return _this;
  }

  _createClass(TypeaheadInputMulti, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          inputClassName = _this$props2.inputClassName,
          inputRef = _this$props2.inputRef,
          placeholder = _this$props2.placeholder,
          referenceElementRef = _this$props2.referenceElementRef,
          selected = _this$props2.selected,
          props = _objectWithoutProperties(_this$props2, TypeaheadInputMulti_excluded);

      return /*#__PURE__*/react.createElement("div", {
        className: classnames_default()('rbt-input-multi', className),
        onClick: this._handleContainerClickOrFocus,
        onFocus: this._handleContainerClickOrFocus,
        ref: referenceElementRef,
        tabIndex: -1
      }, /*#__PURE__*/react.createElement("div", {
        className: "rbt-input-wrapper",
        ref: this.wrapperRef
      }, children, /*#__PURE__*/react.createElement(Hint_Hint, null, /*#__PURE__*/react.createElement(Input_Input, (0,esm_extends/* default */.Z)({}, props, {
        className: inputClassName,
        onKeyDown: this._handleKeyDown,
        placeholder: selected.length ? '' : placeholder,
        ref: this.getInputRef,
        style: {
          backgroundColor: 'transparent',
          border: 0,
          boxShadow: 'none',
          cursor: 'inherit',
          outline: 'none',
          padding: 0,
          width: '100%',
          zIndex: 1
        }
      })))));
    }
  }]);

  return TypeaheadInputMulti;
}(react.Component);

/* harmony default export */ var TypeaheadInputMulti_TypeaheadInputMulti = (classNames(TypeaheadInputMulti));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/TypeaheadInputMulti/index.js


;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/TypeaheadInputSingle/TypeaheadInputSingle.js


var TypeaheadInputSingle_excluded = ["inputRef", "referenceElementRef"];





var TypeaheadInputSingle = function TypeaheadInputSingle(_ref) {
  var inputRef = _ref.inputRef,
      referenceElementRef = _ref.referenceElementRef,
      props = _objectWithoutProperties(_ref, TypeaheadInputSingle_excluded);

  return /*#__PURE__*/react.createElement(Hint_Hint, null, /*#__PURE__*/react.createElement(Input_Input, (0,esm_extends/* default */.Z)({}, props, {
    ref: function ref(node) {
      inputRef(node);
      referenceElementRef(node);
    }
  })));
};

/* harmony default export */ var TypeaheadInputSingle_TypeaheadInputSingle = (classNames(TypeaheadInputSingle));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/TypeaheadInputSingle/index.js


;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/Highlighter/Highlighter.js



var Highlighter_propTypes = {
  children: (prop_types_default()).string.isRequired,
  highlightClassName: (prop_types_default()).string,
  search: (prop_types_default()).string.isRequired
};
var Highlighter_defaultProps = {
  highlightClassName: 'rbt-highlight-text'
};

/**
 * Stripped-down version of https://github.com/helior/react-highlighter
 *
 * Results are already filtered by the time the component is used internally so
 * we can safely ignore case and diacritical marks for the purposes of matching.
 */
var Highlighter = function Highlighter(_ref) {
  var children = _ref.children,
      highlightClassName = _ref.highlightClassName,
      search = _ref.search;

  if (!search || !children) {
    return /*#__PURE__*/react.createElement(react.Fragment, null, children);
  }

  var matchCount = 0;
  var remaining = children;
  var highlighterChildren = [];

  while (remaining) {
    var bounds = getMatchBounds(remaining, search); // No match anywhere in the remaining string, stop.

    if (!bounds) {
      highlighterChildren.push(remaining);
      break;
    } // Capture the string that leads up to a match.


    var nonMatch = remaining.slice(0, bounds.start);

    if (nonMatch) {
      highlighterChildren.push(nonMatch);
    } // Capture the matching string.


    var match = remaining.slice(bounds.start, bounds.end);
    highlighterChildren.push( /*#__PURE__*/react.createElement("mark", {
      className: highlightClassName,
      key: matchCount
    }, match));
    matchCount += 1; // And if there's anything left over, continue the loop.

    remaining = remaining.slice(bounds.end);
  }

  return /*#__PURE__*/react.createElement(react.Fragment, null, highlighterChildren);
};

Highlighter.propTypes = Highlighter_propTypes;
Highlighter.defaultProps = Highlighter_defaultProps;
/* harmony default export */ var Highlighter_Highlighter = (Highlighter);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/Highlighter/index.js


;// CONCATENATED MODULE: ./node_modules/.pnpm/compute-scroll-into-view@1.0.17/node_modules/compute-scroll-into-view/dist/index.module.js
function t(t){return"object"==typeof t&&null!=t&&1===t.nodeType}function e(t,e){return(!e||"hidden"!==t)&&"visible"!==t&&"clip"!==t}function n(t,n){if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){var r=getComputedStyle(t,null);return e(r.overflowY,n)||e(r.overflowX,n)||function(t){var e=function(t){if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}}(t);return!!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)}(t)}return!1}function r(t,e,n,r,i,o,l,d){return o<t&&l>e||o>t&&l<e?0:o<=t&&d<=n||l>=e&&d>=n?o-t-r:l>e&&d<n||o<t&&d>n?l-e+i:0}/* harmony default export */ function index_module(e,i){var o=window,l=i.scrollMode,d=i.block,u=i.inline,h=i.boundary,a=i.skipOverflowHiddenElements,c="function"==typeof h?h:function(t){return t!==h};if(!t(e))throw new TypeError("Invalid target");for(var f=document.scrollingElement||document.documentElement,s=[],p=e;t(p)&&c(p);){if((p=p.parentElement)===f){s.push(p);break}null!=p&&p===document.body&&n(p)&&!n(document.documentElement)||null!=p&&n(p,a)&&s.push(p)}for(var m=o.visualViewport?o.visualViewport.width:innerWidth,g=o.visualViewport?o.visualViewport.height:innerHeight,w=window.scrollX||pageXOffset,v=window.scrollY||pageYOffset,W=e.getBoundingClientRect(),b=W.height,H=W.width,y=W.top,E=W.right,M=W.bottom,V=W.left,x="start"===d||"nearest"===d?y:"end"===d?M:y+b/2,I="center"===u?V+H/2:"end"===u?E:V,C=[],T=0;T<s.length;T++){var k=s[T],B=k.getBoundingClientRect(),D=B.height,O=B.width,R=B.top,X=B.right,Y=B.bottom,L=B.left;if("if-needed"===l&&y>=0&&V>=0&&M<=g&&E<=m&&y>=R&&M<=Y&&V>=L&&E<=X)return C;var S=getComputedStyle(k),j=parseInt(S.borderLeftWidth,10),q=parseInt(S.borderTopWidth,10),z=parseInt(S.borderRightWidth,10),A=parseInt(S.borderBottomWidth,10),F=0,G=0,J="offsetWidth"in k?k.offsetWidth-k.clientWidth-j-z:0,K="offsetHeight"in k?k.offsetHeight-k.clientHeight-q-A:0;if(f===k)F="start"===d?x:"end"===d?x-g:"nearest"===d?r(v,v+g,g,q,A,v+x,v+x+b,b):x-g/2,G="start"===u?I:"center"===u?I-m/2:"end"===u?I-m:r(w,w+m,m,j,z,w+I,w+I+H,H),F=Math.max(0,F+v),G=Math.max(0,G+w);else{F="start"===d?x-R-q:"end"===d?x-Y+A+K:"nearest"===d?r(R,Y,D,q,A+K,x,x+b,b):x-(R+D/2)+K/2,G="start"===u?I-L-j:"center"===u?I-(L+O/2)+J/2:"end"===u?I-X+z+J:r(L,X,O,j,z+J,I,I+H,H);var N=k.scrollLeft,P=k.scrollTop;x+=P-(F=Math.max(0,Math.min(P+F,k.scrollHeight-D+K))),I+=N-(G=Math.max(0,Math.min(N+G,k.scrollWidth-O+J)))}C.push({el:k,top:F,left:G})}return C}
//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/scroll-into-view-if-needed@2.2.29/node_modules/scroll-into-view-if-needed/es/index.js


function isOptionsObject(options) {
  return options === Object(options) && Object.keys(options).length !== 0;
}

function defaultBehavior(actions, behavior) {
  if (behavior === void 0) {
    behavior = 'auto';
  }

  var canSmoothScroll = ('scrollBehavior' in document.body.style);
  actions.forEach(function (_ref) {
    var el = _ref.el,
        top = _ref.top,
        left = _ref.left;

    if (el.scroll && canSmoothScroll) {
      el.scroll({
        top: top,
        left: left,
        behavior: behavior
      });
    } else {
      el.scrollTop = top;
      el.scrollLeft = left;
    }
  });
}

function getOptions(options) {
  if (options === false) {
    return {
      block: 'end',
      inline: 'nearest'
    };
  }

  if (isOptionsObject(options)) {
    return options;
  }

  return {
    block: 'start',
    inline: 'nearest'
  };
}

function scrollIntoView(target, options) {
  var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);

  if (isOptionsObject(options) && typeof options.behavior === 'function') {
    return options.behavior(isTargetAttached ? index_module(target, options) : []);
  }

  if (!isTargetAttached) {
    return;
  }

  var computeOptions = getOptions(options);
  return defaultBehavior(index_module(target, computeOptions), computeOptions.behavior);
}

/* harmony default export */ var es = (scrollIntoView);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/behaviors/item.js



var item_excluded = ["label", "onClick", "option", "position"];

function item_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function item_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { item_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { item_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var item_propTypes = {
  option: optionType.isRequired,
  position: (prop_types_default()).number
};
function useItem(_ref) {
  var label = _ref.label,
      onClick = _ref.onClick,
      option = _ref.option,
      position = _ref.position,
      props = _objectWithoutProperties(_ref, item_excluded);

  var _useTypeaheadContext = useTypeaheadContext(),
      activeIndex = _useTypeaheadContext.activeIndex,
      id = _useTypeaheadContext.id,
      isOnlyResult = _useTypeaheadContext.isOnlyResult,
      onActiveItemChange = _useTypeaheadContext.onActiveItemChange,
      onInitialItemChange = _useTypeaheadContext.onInitialItemChange,
      onMenuItemClick = _useTypeaheadContext.onMenuItemClick,
      setItem = _useTypeaheadContext.setItem;

  var itemRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    if (position === 0) {
      onInitialItemChange(option);
    }
  });
  (0,react.useEffect)(function () {
    if (position === activeIndex) {
      onActiveItemChange(option); // Automatically scroll the menu as the user keys through it.

      var node = itemRef.current;
      node && es(node, {
        block: 'nearest',
        boundary: node.parentNode,
        inline: 'nearest',
        scrollMode: 'if-needed'
      });
    }
  });
  var handleClick = (0,react.useCallback)(function (e) {
    onMenuItemClick(option, e);
    onClick && onClick(e);
  }, [onClick, onMenuItemClick, option]);
  var active = isOnlyResult || activeIndex === position; // Update the item's position in the item stack.

  setItem(option, position);
  return item_objectSpread(item_objectSpread({}, props), {}, {
    active: active,
    'aria-label': label,
    'aria-selected': active,
    id: getMenuItemId(id, position),
    onClick: handleClick,
    onMouseDown: preventInputBlur,
    ref: itemRef,
    role: 'option'
  });
}
/* istanbul ignore next */

function withItem(Component) {
  var WrappedMenuItem = function WrappedMenuItem(props) {
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, useItem(props)));
  };

  WrappedMenuItem.displayName = "withItem(".concat(getDisplayName(Component), ")");
  WrappedMenuItem.propTypes = item_propTypes;
  return WrappedMenuItem;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/MenuItem/MenuItem.js


var MenuItem_excluded = ["active", "children", "className", "disabled", "onClick"];



var BaseMenuItem = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      _onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, MenuItem_excluded);

  return /*#__PURE__*/react.createElement("a", (0,esm_extends/* default */.Z)({}, props, {
    className: classnames_default()('dropdown-item', {
      active: active,
      disabled: disabled
    }, className),
    href: props.href || '#',
    onClick: function onClick(e) {
      e.preventDefault();
      !disabled && _onClick && _onClick(e);
    },
    ref: ref
  }), children);
});
function MenuItem(props) {
  return /*#__PURE__*/react.createElement(BaseMenuItem, useItem(props));
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/MenuItem/index.js


;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/Menu/Menu.js



var Menu_excluded = ["children", "className", "emptyLabel", "innerRef", "inputHeight", "maxHeight", "scheduleUpdate", "style", "text"];

function Menu_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Menu_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Menu_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Menu_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var MenuDivider = function MenuDivider() {
  return /*#__PURE__*/react.createElement("div", {
    className: "dropdown-divider",
    role: "separator"
  });
};

var MenuHeader = function MenuHeader(props) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
    react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
      className: "dropdown-header",
      role: "heading"
    }))
  );
};

var Menu_propTypes = {
  'aria-label': (prop_types_default()).string,

  /**
   * Message to display in the menu if there are no valid results.
   */
  emptyLabel: (prop_types_default()).node,

  /**
   * Needed for accessibility.
   */
  id: checkPropType(prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]), isRequiredForA11y),

  /**
   * Maximum height of the dropdown menu.
   */
  maxHeight: (prop_types_default()).string
};
var Menu_defaultProps = {
  'aria-label': 'menu-options'
};

/**
 * Menu component that handles empty state when passed a set of results.
 */
var Menu = function Menu(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$emptyLabel = _ref.emptyLabel,
      emptyLabel = _ref$emptyLabel === void 0 ? 'No matches found.' : _ref$emptyLabel,
      innerRef = _ref.innerRef,
      inputHeight = _ref.inputHeight,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? '300px' : _ref$maxHeight,
      scheduleUpdate = _ref.scheduleUpdate,
      style = _ref.style,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? '' : _ref$text,
      props = _objectWithoutProperties(_ref, Menu_excluded);

  var isInitialMount = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    scheduleUpdate && scheduleUpdate();
  }, [inputHeight, scheduleUpdate]);
  var contents = react.Children.count(children) === 0 ? /*#__PURE__*/react.createElement(BaseMenuItem, {
    disabled: true,
    role: "option"
  }, emptyLabel) : children;
  return (
    /*#__PURE__*/

    /* eslint-disable jsx-a11y/interactive-supports-focus */
    react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
      className: classnames_default()('rbt-menu', 'dropdown-menu', 'show', className),
      key: // Force a re-render if the text changes to ensure that menu
      // positioning updates correctly.
      text,
      onMouseDown: // Prevent input from blurring when clicking on the menu scrollbar.
      preventInputBlur,
      ref: innerRef,
      role: "listbox",
      style: Menu_objectSpread(Menu_objectSpread({}, style), {}, {
        display: 'block',
        maxHeight: maxHeight,
        overflow: 'auto'
      })
    }), contents)
    /* eslint-enable jsx-a11y/interactive-supports-focus */

  );
};

Menu.propTypes = Menu_propTypes;
Menu.defaultProps = Menu_defaultProps;
Menu.Divider = MenuDivider;
Menu.Header = MenuHeader;
/* harmony default export */ var Menu_Menu = (Menu);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/Menu/index.js


;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/TypeaheadMenu/TypeaheadMenu.js


var TypeaheadMenu_excluded = ["labelKey", "newSelectionPrefix", "options", "paginationText", "renderMenuItemChildren"];






var TypeaheadMenu_propTypes = {
  /**
   * Provides the ability to specify a prefix before the user-entered text to
   * indicate that the selection will be new. No-op unless `allowNew={true}`.
   */
  newSelectionPrefix: (prop_types_default()).node,

  /**
   * Prompt displayed when large data sets are paginated.
   */
  paginationText: (prop_types_default()).node,

  /**
   * Provides a hook for customized rendering of menu item contents.
   */
  renderMenuItemChildren: (prop_types_default()).func
};
var TypeaheadMenu_defaultProps = {
  newSelectionPrefix: 'New selection: ',
  paginationText: 'Display additional results...',
  renderMenuItemChildren: function renderMenuItemChildren(option, props) {
    return /*#__PURE__*/react.createElement(Highlighter_Highlighter, {
      search: props.text
    }, utils_getOptionLabel(option, props.labelKey));
  }
};

var TypeaheadMenu = function TypeaheadMenu(props) {
  var labelKey = props.labelKey,
      newSelectionPrefix = props.newSelectionPrefix,
      options = props.options,
      paginationText = props.paginationText,
      renderMenuItemChildren = props.renderMenuItemChildren,
      menuProps = _objectWithoutProperties(props, TypeaheadMenu_excluded);

  var renderMenuItem = function renderMenuItem(option, position) {
    var label = utils_getOptionLabel(option, labelKey);
    var menuItemProps = {
      disabled: !!getOptionProperty(option, 'disabled'),
      label: label,
      option: option,
      position: position
    };

    if (getOptionProperty(option, 'customOption')) {
      return /*#__PURE__*/react.createElement(MenuItem, (0,esm_extends/* default */.Z)({}, menuItemProps, {
        className: "rbt-menu-custom-option",
        key: position,
        label: label
      }), newSelectionPrefix, /*#__PURE__*/react.createElement(Highlighter_Highlighter, {
        search: menuProps.text
      }, label));
    }

    if (getOptionProperty(option, 'paginationOption')) {
      return /*#__PURE__*/react.createElement(react.Fragment, {
        key: "pagination-option-divider"
      }, /*#__PURE__*/react.createElement(Menu_Menu.Divider, null), /*#__PURE__*/react.createElement(MenuItem, (0,esm_extends/* default */.Z)({}, menuItemProps, {
        className: "rbt-menu-pagination-option",
        label: // TODO: Fix how (aria-)labels are passed to `MenuItem`.
        // `paginationText` can be a ReactNode.
        isString(paginationText) ? paginationText : ''
      }), paginationText));
    }

    return /*#__PURE__*/react.createElement(MenuItem, (0,esm_extends/* default */.Z)({}, menuItemProps, {
      key: position
    }), renderMenuItemChildren(option, props, position));
  };

  return /*#__PURE__*/react.createElement(Menu_Menu, menuProps, options.map(renderMenuItem));
};

TypeaheadMenu.propTypes = TypeaheadMenu_propTypes;
TypeaheadMenu.defaultProps = TypeaheadMenu_defaultProps;
/* harmony default export */ var TypeaheadMenu_TypeaheadMenu = (TypeaheadMenu);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/TypeaheadMenu/index.js


;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/Typeahead/Typeahead.js










var Typeahead_Typeahead_excluded = ["children", "onRootClose"];

function Typeahead_Typeahead_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Typeahead_Typeahead_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Typeahead_Typeahead_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Typeahead_Typeahead_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Typeahead_createSuper(Derived) { var hasNativeReflectConstruct = Typeahead_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function Typeahead_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }















var Typeahead_Typeahead_propTypes = {
  /**
   * Displays a button to clear the input when there are selections.
   */
  clearButton: (prop_types_default()).bool,

  /**
   * Props to be applied directly to the input. `onBlur`, `onChange`,
   * `onFocus`, and `onKeyDown` are ignored.
   */
  inputProps: checkPropType((prop_types_default()).object, inputPropsType),

  /**
   * Bootstrap 4 only. Adds the `is-invalid` classname to the `form-control`.
   */
  isInvalid: (prop_types_default()).bool,

  /**
   * Indicate whether an asynchronous data fetch is happening.
   */
  isLoading: (prop_types_default()).bool,

  /**
   * Bootstrap 4 only. Adds the `is-valid` classname to the `form-control`.
   */
  isValid: (prop_types_default()).bool,

  /**
   * Callback for custom input rendering.
   */
  renderInput: (prop_types_default()).func,

  /**
   * Callback for custom menu rendering.
   */
  renderMenu: (prop_types_default()).func,

  /**
   * Callback for custom menu rendering.
   */
  renderToken: (prop_types_default()).func,

  /**
   * Specifies the size of the input.
   */
  size: sizeType
};
var Typeahead_defaultProps = {
  isLoading: false
};

var defaultRenderMenu = function defaultRenderMenu(results, menuProps, props) {
  return /*#__PURE__*/react.createElement(TypeaheadMenu_TypeaheadMenu, (0,esm_extends/* default */.Z)({}, menuProps, {
    labelKey: props.labelKey,
    options: results,
    text: props.text
  }));
};

var defaultRenderToken = function defaultRenderToken(option, props, idx) {
  return /*#__PURE__*/react.createElement(Token_Token, {
    disabled: props.disabled,
    key: idx,
    onRemove: props.onRemove,
    option: option,
    tabIndex: props.tabIndex
  }, utils_getOptionLabel(option, props.labelKey));
};

var overlayPropKeys = ['align', 'dropup', 'flip', 'positionFixed'];

function getOverlayProps(props) {
  return pick(props, overlayPropKeys);
}

var RootClose = function RootClose(_ref) {
  var children = _ref.children,
      onRootClose = _ref.onRootClose,
      props = _objectWithoutProperties(_ref, Typeahead_Typeahead_excluded);

  var _useState = (0,react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      rootElement = _useState2[0],
      attachRef = _useState2[1];

  esm_useRootClose(rootElement, onRootClose, props);
  return children(attachRef);
};

var TypeaheadComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(TypeaheadComponent, _React$Component);

  var _super = Typeahead_createSuper(TypeaheadComponent);

  function TypeaheadComponent() {
    var _this;

    _classCallCheck(this, TypeaheadComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_referenceElement", null);

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "referenceElementRef", function (referenceElement) {
      _this._referenceElement = referenceElement;
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_renderInput", function (inputProps, props) {
      var _this$props = _this.props,
          isInvalid = _this$props.isInvalid,
          isValid = _this$props.isValid,
          multiple = _this$props.multiple,
          renderInput = _this$props.renderInput,
          renderToken = _this$props.renderToken,
          size = _this$props.size;

      if (isFunction(renderInput)) {
        return renderInput(inputProps, props);
      }

      var commonProps = Typeahead_Typeahead_objectSpread(Typeahead_Typeahead_objectSpread({}, inputProps), {}, {
        isInvalid: isInvalid,
        isValid: isValid,
        size: size
      });

      if (!multiple) {
        return /*#__PURE__*/react.createElement(TypeaheadInputSingle_TypeaheadInputSingle, commonProps);
      }

      var labelKey = props.labelKey,
          onRemove = props.onRemove,
          selected = props.selected;
      return /*#__PURE__*/react.createElement(TypeaheadInputMulti_TypeaheadInputMulti, (0,esm_extends/* default */.Z)({}, commonProps, {
        selected: selected
      }), selected.map(function (option, idx) {
        return (renderToken || defaultRenderToken)(option, Typeahead_Typeahead_objectSpread(Typeahead_Typeahead_objectSpread({}, commonProps), {}, {
          labelKey: labelKey,
          onRemove: onRemove
        }), idx);
      }));
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_renderMenu", function (results, menuProps, props) {
      var _this$props2 = _this.props,
          emptyLabel = _this$props2.emptyLabel,
          id = _this$props2.id,
          maxHeight = _this$props2.maxHeight,
          newSelectionPrefix = _this$props2.newSelectionPrefix,
          paginationText = _this$props2.paginationText,
          renderMenu = _this$props2.renderMenu,
          renderMenuItemChildren = _this$props2.renderMenuItemChildren;
      return (renderMenu || defaultRenderMenu)(results, Typeahead_Typeahead_objectSpread(Typeahead_Typeahead_objectSpread({}, menuProps), {}, {
        emptyLabel: emptyLabel,
        id: id,
        maxHeight: maxHeight,
        newSelectionPrefix: newSelectionPrefix,
        paginationText: paginationText,
        renderMenuItemChildren: renderMenuItemChildren
      }), props);
    });

    (0,defineProperty/* default */.Z)(_assertThisInitialized(_this), "_renderAux", function (_ref2) {
      var onClear = _ref2.onClear,
          selected = _ref2.selected;
      var _this$props3 = _this.props,
          clearButton = _this$props3.clearButton,
          disabled = _this$props3.disabled,
          isLoading = _this$props3.isLoading,
          size = _this$props3.size;
      var content;

      if (isLoading) {
        content = /*#__PURE__*/react.createElement(Loader_Loader, null);
      } else if (clearButton && !disabled && selected.length) {
        content = /*#__PURE__*/react.createElement(ClearButton_ClearButton, {
          onClick: onClear,
          onMouseDown: preventInputBlur,
          size: size
        });
      }

      return content ? /*#__PURE__*/react.createElement("div", {
        className: classnames_default()('rbt-aux', {
          'rbt-aux-lg': isSizeLarge(size)
        })
      }, content) : null;
    });

    return _this;
  }

  _createClass(TypeaheadComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          children = _this$props4.children,
          className = _this$props4.className,
          instanceRef = _this$props4.instanceRef,
          open = _this$props4.open,
          options = _this$props4.options,
          style = _this$props4.style;
      return /*#__PURE__*/react.createElement(core_Typeahead, (0,esm_extends/* default */.Z)({}, this.props, {
        options: options,
        ref: instanceRef
      }), function (props) {
        var hideMenu = props.hideMenu,
            isMenuShown = props.isMenuShown,
            results = props.results;

        var auxContent = _this2._renderAux(props);

        return /*#__PURE__*/react.createElement(RootClose, {
          disabled: open || !isMenuShown,
          onRootClose: hideMenu
        }, function (ref) {
          return /*#__PURE__*/react.createElement("div", {
            className: classnames_default()('rbt', {
              'has-aux': !!auxContent
            }, className),
            ref: ref,
            style: Typeahead_Typeahead_objectSpread(Typeahead_Typeahead_objectSpread({}, style), {}, {
              outline: 'none',
              position: 'relative'
            }),
            tabIndex: -1
          }, _this2._renderInput(Typeahead_Typeahead_objectSpread(Typeahead_Typeahead_objectSpread({}, props.getInputProps(_this2.props.inputProps)), {}, {
            referenceElementRef: _this2.referenceElementRef
          }), props), /*#__PURE__*/react.createElement(Overlay_Overlay, (0,esm_extends/* default */.Z)({}, getOverlayProps(_this2.props), {
            isMenuShown: isMenuShown,
            referenceElement: _this2._referenceElement
          }), function (menuProps) {
            return _this2._renderMenu(results, menuProps, props);
          }), auxContent, isFunction(children) ? children(props) : children);
        });
      });
    }
  }]);

  return TypeaheadComponent;
}(react.Component);

(0,defineProperty/* default */.Z)(TypeaheadComponent, "propTypes", Typeahead_Typeahead_propTypes);

(0,defineProperty/* default */.Z)(TypeaheadComponent, "defaultProps", Typeahead_defaultProps);

/* harmony default export */ var Typeahead_Typeahead = (/*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/react.createElement(TypeaheadComponent, (0,esm_extends/* default */.Z)({}, props, {
    instanceRef: ref
  }));
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/Typeahead/index.js


;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/AsyncTypeahead/AsyncTypeahead.js

 // @ts-ignore

/* harmony default export */ var AsyncTypeahead = (withAsync(Typeahead_Typeahead));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/AsyncTypeahead/index.js


;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/components/Token/index.js


;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap-typeahead@6.0.0-alpha.9_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap-typeahead/es/index.js
// Components












 // HOCs + Hooks





/***/ }),

/***/ 76557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61255);
/* harmony import */ var _CloseButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53866);
/* harmony import */ var _ModalContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1445);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4637);







const defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};
const AbstractModalHeader = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({
  closeLabel,
  closeVariant,
  closeButton,
  onHide,
  children,
  ...props
}, ref) => {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_ModalContext__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
  const handleClick = (0,_restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(() => {
    context == null ? void 0 : context.onHide();
    onHide == null ? void 0 : onHide();
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    ref: ref,
    ...props,
    children: [children, closeButton && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_CloseButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      "aria-label": closeLabel,
      variant: closeVariant,
      onClick: handleClick
    })]
  });
});
AbstractModalHeader.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (AbstractModalHeader);

/***/ }),

/***/ 44925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19803);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var uncontrollable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22084);
/* harmony import */ var _restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61255);
/* harmony import */ var _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50456);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97902);
/* harmony import */ var _Fade__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94542);
/* harmony import */ var _CloseButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53866);
/* harmony import */ var _divWithClassName__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57024);
/* harmony import */ var _createWithBsPrefix__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91385);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4637);












const DivStyledAsH4 = (0,_divWithClassName__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)('h4');
DivStyledAsH4.displayName = 'DivStyledAsH4';
const AlertHeading = (0,_createWithBsPrefix__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)('alert-heading', {
  Component: DivStyledAsH4
});
const AlertLink = (0,_createWithBsPrefix__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)('alert-link', {
  Component: _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z
});
const defaultProps = {
  variant: 'primary',
  show: true,
  transition: _Fade__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
  closeLabel: 'Close alert'
};
const Alert = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((uncontrolledProps, ref) => {
  const {
    bsPrefix,
    show,
    closeLabel,
    closeVariant,
    className,
    children,
    variant,
    onClose,
    dismissible,
    transition,
    ...props
  } = (0,uncontrollable__WEBPACK_IMPORTED_MODULE_2__/* .useUncontrolled */ .Ch)(uncontrolledProps, {
    show: 'onClose'
  });
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_9__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'alert');
  const handleClose = (0,_restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(e => {
    if (onClose) {
      onClose(false, e);
    }
  });
  const Transition = transition === true ? _Fade__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z : transition;

  const alert = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    role: "alert",
    ...(!Transition ? props : undefined),
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
    children: [dismissible && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_CloseButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      onClick: handleClose,
      "aria-label": closeLabel,
      variant: closeVariant
    }), children]
  });

  if (!Transition) return show ? alert : null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Transition, {
    unmountOnExit: true,
    ...props,
    ref: undefined,
    in: show,
    children: alert
  });
});
Alert.displayName = 'Alert';
Alert.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Object.assign(Alert, {
  Link: AlertLink,
  Heading: AlertHeading
}));

/***/ }),

/***/ 25047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_BootstrapModalManager; },
  "t": function() { return /* binding */ getSharedManager; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/hasClass.js
var hasClass = __webpack_require__(99523);
;// CONCATENATED MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0,hasClass/* default */.Z)(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/css.js + 5 modules
var css = __webpack_require__(20968);
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/querySelectorAll.js
var querySelectorAll = __webpack_require__(83465);
;// CONCATENATED MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/removeClass.js
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/ModalManager.js + 1 modules
var ModalManager = __webpack_require__(20317);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/BootstrapModalManager.js





const Selector = {
  FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
  STICKY_CONTENT: '.sticky-top',
  NAVBAR_TOGGLER: '.navbar-toggler'
};

class BootstrapModalManager extends ModalManager/* default */.Z {
  adjustAndStore(prop, element, adjust) {
    const actual = element.style[prop]; // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
    // @ts-ignore

    element.dataset[prop] = actual;
    (0,css/* default */.Z)(element, {
      [prop]: `${parseFloat((0,css/* default */.Z)(element, prop)) + adjust}px`
    });
  }

  restore(prop, element) {
    const value = element.dataset[prop];

    if (value !== undefined) {
      delete element.dataset[prop];
      (0,css/* default */.Z)(element, {
        [prop]: value
      });
    }
  }

  setContainerStyle(containerState) {
    super.setContainerStyle(containerState);
    const container = this.getElement();
    addClass(container, 'modal-open');
    if (!containerState.scrollBarWidth) return;
    const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
    const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
    (0,querySelectorAll/* default */.Z)(container, Selector.FIXED_CONTENT).forEach(el => this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
    (0,querySelectorAll/* default */.Z)(container, Selector.STICKY_CONTENT).forEach(el => this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
    (0,querySelectorAll/* default */.Z)(container, Selector.NAVBAR_TOGGLER).forEach(el => this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
  }

  removeContainerStyle(containerState) {
    super.removeContainerStyle(containerState);
    const container = this.getElement();
    removeClass(container, 'modal-open');
    const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
    const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
    (0,querySelectorAll/* default */.Z)(container, Selector.FIXED_CONTENT).forEach(el => this.restore(paddingProp, el));
    (0,querySelectorAll/* default */.Z)(container, Selector.STICKY_CONTENT).forEach(el => this.restore(marginProp, el));
    (0,querySelectorAll/* default */.Z)(container, Selector.NAVBAR_TOGGLER).forEach(el => this.restore(marginProp, el));
  }

}

let sharedManager;
function getSharedManager(options) {
  if (!sharedManager) sharedManager = new BootstrapModalManager(options);
  return sharedManager;
}
/* harmony default export */ var esm_BootstrapModalManager = (BootstrapModalManager);

/***/ }),

/***/ 46863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19803);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _restart_ui_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46028);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97902);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4637);





const defaultProps = {
  variant: 'primary',
  active: false,
  disabled: false
};
const Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  as,
  bsPrefix,
  variant,
  size,
  active,
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'btn');
  const [buttonProps, {
    tagName
  }] = (0,_restart_ui_Button__WEBPACK_IMPORTED_MODULE_4__/* .useButtonProps */ .FT)({
    tagName: as,
    ...props
  });
  const Component = tagName;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, { ...buttonProps,
    ...props,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && props.disabled && 'disabled')
  });
});
Button.displayName = 'Button';
Button.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Button);

/***/ }),

/***/ 53866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40507);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19803);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4637);




const propTypes = {
  'aria-label': (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  onClick: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),

  /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */
  variant: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOf(['white'])
};
const defaultProps = {
  'aria-label': 'Close'
};
const CloseButton = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({
  className,
  variant,
  ...props
}, ref) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
  ref: ref,
  type: "button",
  className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('btn-close', variant && `btn-close-${variant}`, className),
  ...props
}));
CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = propTypes;
CloseButton.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (CloseButton);

/***/ }),

/***/ 42359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useCol */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19803);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97902);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4637);




function useCol({
  as,
  bsPrefix,
  className,
  ...props
}) {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'col');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const spans = [];
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let span;
    let offset;
    let order;

    if (typeof propValue === 'object' && propValue != null) {
      ({
        span,
        offset,
        order
      } = propValue);
    } else {
      span = propValue;
    }

    const infix = brkPoint !== 'xs' ? `-${brkPoint}` : '';
    if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
    if (order != null) classes.push(`order${infix}-${order}`);
    if (offset != null) classes.push(`offset${infix}-${offset}`);
  });
  return [{ ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, ...spans, ...classes)
  }, {
    as,
    bsPrefix,
    spans
  }];
}
const Col = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref) => {
  const [{
    className,
    ...colProps
  }, {
    as: Component = 'div',
    bsPrefix,
    spans
  }] = useCol(props);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, { ...colProps,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, !spans.length && bsPrefix)
  });
});
Col.displayName = 'Col';
/* harmony default export */ __webpack_exports__["Z"] = (Col);

/***/ }),

/***/ 28440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19803);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97902);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4637);




const defaultProps = {
  fluid: false
};
const Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  fluid,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
Container.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Container);

/***/ }),

/***/ 94542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19803);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72983);
/* harmony import */ var _transitionEndListener__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72605);
/* harmony import */ var _triggerBrowserReflow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81194);
/* harmony import */ var _TransitionWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52309);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4637);








const defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
const fadeStyles = {
  [react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_3__/* .ENTERING */ .d0]: 'show',
  [react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_3__/* .ENTERED */ .cn]: 'show'
};
const Fade = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  className,
  children,
  transitionClasses = {},
  ...props
}, ref) => {
  const handleEnter = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((node, isAppearing) => {
    (0,_triggerBrowserReflow__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(node);
    props.onEnter == null ? void 0 : props.onEnter(node, isAppearing);
  }, [props]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_TransitionWrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    ref: ref,
    addEndListener: _transitionEndListener__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
    ...props,
    onEnter: handleEnter,
    childRef: children.ref,
    children: (status, innerProps) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(children, { ...innerProps,
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()('fade', className, children.props.className, fadeStyles[status], transitionClasses[status])
    })
  });
});
Fade.defaultProps = defaultProps;
Fade.displayName = 'Fade';
/* harmony default export */ __webpack_exports__["Z"] = (Fade);

/***/ }),

/***/ 28268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Form; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(19803);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Feedback.js




const propTypes = {
  /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */
  type: (prop_types_default()).string,

  /** Display feedback as a tooltip. */
  tooltip: (prop_types_default()).bool,
  as: (prop_types_default()).elementType
};
const Feedback = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  as: Component = 'div',
  className,
  type = 'valid',
  tooltip = false,
  ...props
}, ref) => /*#__PURE__*/(0,jsx_runtime.jsx)(Component, { ...props,
  ref: ref,
  className: classnames_default()(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
}));
Feedback.displayName = 'Feedback';
Feedback.propTypes = propTypes;
/* harmony default export */ var esm_Feedback = (Feedback);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/FormContext.js
 // TODO

const FormContext = /*#__PURE__*/react.createContext({});
/* harmony default export */ var esm_FormContext = (FormContext);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(97902);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/FormCheckInput.js






const FormCheckInput = /*#__PURE__*/react.forwardRef(({
  id,
  bsPrefix,
  className,
  type = 'checkbox',
  isValid = false,
  isInvalid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'input',
  ...props
}, ref) => {
  const {
    controlId
  } = (0,react.useContext)(esm_FormContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-check-input');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, { ...props,
    ref: ref,
    type: type,
    id: id || controlId,
    className: classnames_default()(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
  });
});
FormCheckInput.displayName = 'FormCheckInput';
/* harmony default export */ var esm_FormCheckInput = (FormCheckInput);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/FormCheckLabel.js






const FormCheckLabel = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  htmlFor,
  ...props
}, ref) => {
  const {
    controlId
  } = (0,react.useContext)(esm_FormContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-check-label');
  return /*#__PURE__*/(0,jsx_runtime.jsx)("label", { ...props,
    ref: ref,
    htmlFor: htmlFor || controlId,
    className: classnames_default()(className, bsPrefix)
  });
});
FormCheckLabel.displayName = 'FormCheckLabel';
/* harmony default export */ var esm_FormCheckLabel = (FormCheckLabel);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/ElementChildren.js

/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */

function map(children, func) {
  let index = 0;
  return React.Children.map(children, child => /*#__PURE__*/React.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */


function forEach(children, func) {
  let index = 0;
  React.Children.forEach(children, child => {
    if ( /*#__PURE__*/React.isValidElement(child)) func(child, index++);
  });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */


function hasChildOfType(children, type) {
  return react.Children.toArray(children).some(child => /*#__PURE__*/react.isValidElement(child) && child.type === type);
}


;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/FormCheck.js












const FormCheck = /*#__PURE__*/react.forwardRef(({
  id,
  bsPrefix,
  bsSwitchPrefix,
  inline = false,
  disabled = false,
  isValid = false,
  isInvalid = false,
  feedbackTooltip = false,
  feedback,
  feedbackType,
  className,
  style,
  title = '',
  type = 'checkbox',
  label,
  children,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as = 'input',
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-check');
  bsSwitchPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsSwitchPrefix, 'form-switch');
  const {
    controlId
  } = (0,react.useContext)(esm_FormContext);
  const innerFormContext = (0,react.useMemo)(() => ({
    controlId: id || controlId
  }), [controlId, id]);
  const hasLabel = !children && label != null && label !== false || hasChildOfType(children, esm_FormCheckLabel);

  const input = /*#__PURE__*/(0,jsx_runtime.jsx)(esm_FormCheckInput, { ...props,
    type: type === 'switch' ? 'checkbox' : type,
    ref: ref,
    isValid: isValid,
    isInvalid: isInvalid,
    disabled: disabled,
    as: as
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_FormContext.Provider, {
    value: innerFormContext,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: style,
      className: classnames_default()(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, type === 'switch' && bsSwitchPrefix),
      children: children || /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [input, hasLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(esm_FormCheckLabel, {
          title: title,
          children: label
        }), feedback && /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Feedback, {
          type: feedbackType,
          tooltip: feedbackTooltip,
          children: feedback
        })]
      })
    })
  });
});
FormCheck.displayName = 'FormCheck';
/* harmony default export */ var esm_FormCheck = (Object.assign(FormCheck, {
  Input: esm_FormCheckInput,
  Label: esm_FormCheckLabel
}));
// EXTERNAL MODULE: ./node_modules/.pnpm/warning@4.0.3/node_modules/warning/warning.js
var warning = __webpack_require__(91190);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/FormControl.js








const FormControl = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  type,
  size,
  htmlSize,
  id,
  className,
  isValid = false,
  isInvalid = false,
  plaintext,
  readOnly,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'input',
  ...props
}, ref) => {
  const {
    controlId
  } = (0,react.useContext)(esm_FormContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-control');
  let classes;

  if (plaintext) {
    classes = {
      [`${bsPrefix}-plaintext`]: true
    };
  } else {
    classes = {
      [bsPrefix]: true,
      [`${bsPrefix}-${size}`]: size
    };
  }

   false ? 0 : void 0;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, { ...props,
    type: type,
    size: htmlSize,
    ref: ref,
    readOnly: readOnly,
    id: id || controlId,
    className: classnames_default()(className, classes, isValid && `is-valid`, isInvalid && `is-invalid`, type === 'color' && `${bsPrefix}-color`)
  });
});
FormControl.displayName = 'FormControl';
/* harmony default export */ var esm_FormControl = (Object.assign(FormControl, {
  Feedback: esm_Feedback
}));
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(91385);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/FormFloating.js

/* harmony default export */ var FormFloating = ((0,createWithBsPrefix/* default */.Z)('form-floating'));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/FormGroup.js




const FormGroup = /*#__PURE__*/react.forwardRef(({
  controlId,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const context = (0,react.useMemo)(() => ({
    controlId
  }), [controlId]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_FormContext.Provider, {
    value: context,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, { ...props,
      ref: ref
    })
  });
});
FormGroup.displayName = 'FormGroup';
/* harmony default export */ var esm_FormGroup = (FormGroup);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(42359);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/FormLabel.js








const defaultProps = {
  column: false,
  visuallyHidden: false
};
const FormLabel = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'label',
  bsPrefix,
  column,
  visuallyHidden,
  className,
  htmlFor,
  ...props
}, ref) => {
  const {
    controlId
  } = (0,react.useContext)(esm_FormContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-label');
  let columnClass = 'col-form-label';
  if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
  const classes = classnames_default()(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
   false ? 0 : void 0;
  htmlFor = htmlFor || controlId;
  if (column) return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
    ref: ref,
    as: "label",
    className: classes,
    htmlFor: htmlFor,
    ...props
  });
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    (0,jsx_runtime.jsx)(Component, {
      ref: ref,
      className: classes,
      htmlFor: htmlFor,
      ...props
    })
  );
});
FormLabel.displayName = 'FormLabel';
FormLabel.defaultProps = defaultProps;
/* harmony default export */ var esm_FormLabel = (FormLabel);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/FormRange.js






const FormRange = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  id,
  ...props
}, ref) => {
  const {
    controlId
  } = (0,react.useContext)(esm_FormContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-range');
  return /*#__PURE__*/(0,jsx_runtime.jsx)("input", { ...props,
    type: "range",
    ref: ref,
    className: classnames_default()(className, bsPrefix),
    id: id || controlId
  });
});
FormRange.displayName = 'FormRange';
/* harmony default export */ var esm_FormRange = (FormRange);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/FormSelect.js






const FormSelect = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  size,
  htmlSize,
  className,
  isValid = false,
  isInvalid = false,
  id,
  ...props
}, ref) => {
  const {
    controlId
  } = (0,react.useContext)(esm_FormContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-select');
  return /*#__PURE__*/(0,jsx_runtime.jsx)("select", { ...props,
    size: htmlSize,
    ref: ref,
    className: classnames_default()(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
    id: id || controlId
  });
});
FormSelect.displayName = 'FormSelect';
/* harmony default export */ var esm_FormSelect = (FormSelect);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/FormText.js




const FormText = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  as: Component = 'small',
  muted,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-text');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, { ...props,
    ref: ref,
    className: classnames_default()(className, bsPrefix, muted && 'text-muted')
  });
});
FormText.displayName = 'FormText';
/* harmony default export */ var esm_FormText = (FormText);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Switch.js



const Switch = /*#__PURE__*/react.forwardRef((props, ref) => /*#__PURE__*/(0,jsx_runtime.jsx)(esm_FormCheck, { ...props,
  ref: ref,
  type: "switch"
}));
Switch.displayName = 'Switch';
/* harmony default export */ var esm_Switch = (Object.assign(Switch, {
  Input: esm_FormCheck.Input,
  Label: esm_FormCheck.Label
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/FloatingLabel.js






const FloatingLabel = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  children,
  controlId,
  label,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'form-floating');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(esm_FormGroup, {
    ref: ref,
    className: classnames_default()(className, bsPrefix),
    controlId: controlId,
    ...props,
    children: [children, /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      htmlFor: controlId,
      children: label
    })]
  });
});
FloatingLabel.displayName = 'FloatingLabel';
/* harmony default export */ var esm_FloatingLabel = (FloatingLabel);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Form.js














const Form_propTypes = {
  /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */
  _ref: (prop_types_default()).any,

  /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */
  validated: (prop_types_default()).bool,
  as: (prop_types_default()).elementType
};
const Form = /*#__PURE__*/react.forwardRef(({
  className,
  validated,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'form',
  ...props
}, ref) => /*#__PURE__*/(0,jsx_runtime.jsx)(Component, { ...props,
  ref: ref,
  className: classnames_default()(className, validated && 'was-validated')
}));
Form.displayName = 'Form';
Form.propTypes = Form_propTypes;
/* harmony default export */ var esm_Form = (Object.assign(Form, {
  Group: esm_FormGroup,
  Control: esm_FormControl,
  Floating: FormFloating,
  Check: esm_FormCheck,
  Switch: esm_Switch,
  Label: esm_FormLabel,
  Text: esm_FormText,
  Range: esm_FormRange,
  Select: esm_FormSelect,
  FloatingLabel: esm_FloatingLabel
}));

/***/ }),

/***/ 84745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Modal; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(19803);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/addEventListener.js
var addEventListener = __webpack_require__(22853);
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/canUseDOM.js
var canUseDOM = __webpack_require__(62762);
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/ownerDocument.js
var ownerDocument = __webpack_require__(78342);
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/removeEventListener.js
var removeEventListener = __webpack_require__(97877);
;// CONCATENATED MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/scrollbarSize.js

var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (canUseDOM/* default */.Z) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useCallbackRef.js
var useCallbackRef = __webpack_require__(14786);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useEventCallback.js
var useEventCallback = __webpack_require__(61255);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useMergedRefs.js
var useMergedRefs = __webpack_require__(39400);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useWillUnmount.js + 1 modules
var useWillUnmount = __webpack_require__(87528);
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/transitionEnd.js + 1 modules
var transitionEnd = __webpack_require__(4498);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/Modal.js + 1 modules
var Modal = __webpack_require__(42902);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/BootstrapModalManager.js + 2 modules
var BootstrapModalManager = __webpack_require__(25047);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Fade.js
var Fade = __webpack_require__(94542);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(91385);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/ModalBody.js

/* harmony default export */ var ModalBody = ((0,createWithBsPrefix/* default */.Z)('modal-body'));
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/ModalContext.js
var ModalContext = __webpack_require__(1445);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(97902);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/ModalDialog.js




const ModalDialog = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  contentClassName,
  centered,
  size,
  fullscreen,
  children,
  scrollable,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'modal');
  const dialogClass = `${bsPrefix}-dialog`;
  const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", { ...props,
    ref: ref,
    className: classnames_default()(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(`${bsPrefix}-content`, contentClassName),
      children: children
    })
  });
});
ModalDialog.displayName = 'ModalDialog';
/* harmony default export */ var esm_ModalDialog = (ModalDialog);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/ModalFooter.js

/* harmony default export */ var ModalFooter = ((0,createWithBsPrefix/* default */.Z)('modal-footer'));
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/AbstractModalHeader.js
var AbstractModalHeader = __webpack_require__(76557);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/ModalHeader.js





const defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};
const ModalHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'modal-header');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AbstractModalHeader/* default */.Z, {
    ref: ref,
    ...props,
    className: classnames_default()(className, bsPrefix)
  });
});
ModalHeader.displayName = 'ModalHeader';
ModalHeader.defaultProps = defaultProps;
/* harmony default export */ var esm_ModalHeader = (ModalHeader);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/divWithClassName.js
var divWithClassName = __webpack_require__(57024);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/ModalTitle.js


const DivStyledAsH4 = (0,divWithClassName/* default */.Z)('h4');
/* harmony default export */ var ModalTitle = ((0,createWithBsPrefix/* default */.Z)('modal-title', {
  Component: DivStyledAsH4
}));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Modal.js
























const Modal_defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  animation: true,
  dialogAs: esm_ModalDialog
};
/* eslint-disable no-use-before-define, react/no-multi-comp */

function DialogTransition(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Fade/* default */.Z, { ...props,
    timeout: null
  });
}

function BackdropTransition(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Fade/* default */.Z, { ...props,
    timeout: null
  });
}
/* eslint-enable no-use-before-define */


const Modal_Modal = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  style,
  dialogClassName,
  contentClassName,
  children,
  dialogAs: Dialog,
  'aria-labelledby': ariaLabelledby,

  /* BaseModal props */
  show,
  animation,
  backdrop,
  keyboard,
  onEscapeKeyDown,
  onShow,
  onHide,
  container,
  autoFocus,
  enforceFocus,
  restoreFocus,
  restoreFocusOptions,
  onEntered,
  onExit,
  onExiting,
  onEnter,
  onEntering,
  onExited,
  backdropClassName,
  manager: propsManager,
  ...props
}, ref) => {
  const [modalStyle, setStyle] = (0,react.useState)({});
  const [animateStaticModal, setAnimateStaticModal] = (0,react.useState)(false);
  const waitingForMouseUpRef = (0,react.useRef)(false);
  const ignoreBackdropClickRef = (0,react.useRef)(false);
  const removeStaticModalAnimationRef = (0,react.useRef)(null);
  const [modal, setModalRef] = (0,useCallbackRef/* default */.Z)();
  const mergedRef = (0,useMergedRefs/* default */.Z)(ref, setModalRef);
  const handleHide = (0,useEventCallback/* default */.Z)(onHide);
  const isRTL = (0,ThemeProvider/* useIsRTL */.SC)();
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'modal');
  const modalContext = (0,react.useMemo)(() => ({
    onHide: handleHide
  }), [handleHide]);

  function getModalManager() {
    if (propsManager) return propsManager;
    return (0,BootstrapModalManager/* getSharedManager */.t)({
      isRTL
    });
  }

  function updateDialogStyle(node) {
    if (!canUseDOM/* default */.Z) return;
    const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
    const modalIsOverflowing = node.scrollHeight > (0,ownerDocument/* default */.Z)(node).documentElement.clientHeight;
    setStyle({
      paddingRight: containerIsOverflowing && !modalIsOverflowing ? scrollbarSize() : undefined,
      paddingLeft: !containerIsOverflowing && modalIsOverflowing ? scrollbarSize() : undefined
    });
  }

  const handleWindowResize = (0,useEventCallback/* default */.Z)(() => {
    if (modal) {
      updateDialogStyle(modal.dialog);
    }
  });
  (0,useWillUnmount/* default */.Z)(() => {
    (0,removeEventListener/* default */.Z)(window, 'resize', handleWindowResize);
    removeStaticModalAnimationRef.current == null ? void 0 : removeStaticModalAnimationRef.current();
  }); // We prevent the modal from closing during a drag by detecting where the
  // the click originates from. If it starts in the modal and then ends outside
  // don't close.

  const handleDialogMouseDown = () => {
    waitingForMouseUpRef.current = true;
  };

  const handleMouseUp = e => {
    if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) {
      ignoreBackdropClickRef.current = true;
    }

    waitingForMouseUpRef.current = false;
  };

  const handleStaticModalAnimation = () => {
    setAnimateStaticModal(true);
    removeStaticModalAnimationRef.current = (0,transitionEnd/* default */.Z)(modal.dialog, () => {
      setAnimateStaticModal(false);
    });
  };

  const handleStaticBackdropClick = e => {
    if (e.target !== e.currentTarget) {
      return;
    }

    handleStaticModalAnimation();
  };

  const handleClick = e => {
    if (backdrop === 'static') {
      handleStaticBackdropClick(e);
      return;
    }

    if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
      ignoreBackdropClickRef.current = false;
      return;
    }

    onHide == null ? void 0 : onHide();
  };

  const handleEscapeKeyDown = e => {
    if (!keyboard && backdrop === 'static') {
      // Call preventDefault to stop modal from closing in restart ui,
      // then play our animation.
      e.preventDefault();
      handleStaticModalAnimation();
    } else if (keyboard && onEscapeKeyDown) {
      onEscapeKeyDown(e);
    }
  };

  const handleEnter = (node, isAppearing) => {
    if (node) {
      node.style.display = 'block';
      updateDialogStyle(node);
    }

    onEnter == null ? void 0 : onEnter(node, isAppearing);
  };

  const handleExit = node => {
    removeStaticModalAnimationRef.current == null ? void 0 : removeStaticModalAnimationRef.current();
    onExit == null ? void 0 : onExit(node);
  };

  const handleEntering = (node, isAppearing) => {
    onEntering == null ? void 0 : onEntering(node, isAppearing); // FIXME: This should work even when animation is disabled.

    (0,addEventListener/* default */.ZP)(window, 'resize', handleWindowResize);
  };

  const handleExited = node => {
    if (node) node.style.display = ''; // RHL removes it sometimes

    onExited == null ? void 0 : onExited(node); // FIXME: This should work even when animation is disabled.

    (0,removeEventListener/* default */.Z)(window, 'resize', handleWindowResize);
  };

  const renderBackdrop = (0,react.useCallback)(backdropProps => /*#__PURE__*/(0,jsx_runtime.jsx)("div", { ...backdropProps,
    className: classnames_default()(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
  }), [animation, backdropClassName, bsPrefix]);
  const baseModalStyle = { ...style,
    ...modalStyle
  }; // Sets `display` always block when `animation` is false

  if (!animation) {
    baseModalStyle.display = 'block';
  }

  const renderDialog = dialogProps => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    role: "dialog",
    ...dialogProps,
    style: baseModalStyle,
    className: classnames_default()(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`),
    onClick: backdrop ? handleClick : undefined,
    onMouseUp: handleMouseUp,
    "aria-labelledby": ariaLabelledby,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dialog, { ...props,
      onMouseDown: handleDialogMouseDown,
      className: dialogClassName,
      contentClassName: contentClassName,
      children: children
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ModalContext/* default.Provider */.Z.Provider, {
    value: modalContext,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      show: show,
      ref: mergedRef,
      backdrop: backdrop,
      container: container,
      keyboard: true // Always set true - see handleEscapeKeyDown
      ,
      autoFocus: autoFocus,
      enforceFocus: enforceFocus,
      restoreFocus: restoreFocus,
      restoreFocusOptions: restoreFocusOptions,
      onEscapeKeyDown: handleEscapeKeyDown,
      onShow: onShow,
      onHide: onHide,
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: onEntered,
      onExit: handleExit,
      onExiting: onExiting,
      onExited: handleExited,
      manager: getModalManager(),
      transition: animation ? DialogTransition : undefined,
      backdropTransition: animation ? BackdropTransition : undefined,
      renderBackdrop: renderBackdrop,
      renderDialog: renderDialog
    })
  });
});
Modal_Modal.displayName = 'Modal';
Modal_Modal.defaultProps = Modal_defaultProps;
/* harmony default export */ var esm_Modal = (Object.assign(Modal_Modal, {
  Body: ModalBody,
  Header: esm_ModalHeader,
  Title: ModalTitle,
  Footer: ModalFooter,
  Dialog: esm_ModalDialog,
  TRANSITION_DURATION: 300,
  BACKDROP_TRANSITION_DURATION: 150
}));

/***/ }),

/***/ 1445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);

const ModalContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onHide() {}

});
/* harmony default export */ __webpack_exports__["Z"] = (ModalContext);

/***/ }),

/***/ 50163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ react_bootstrap_esm_Nav; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(19803);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types-extra@1.1.1_react@17.0.2/node_modules/prop-types-extra/lib/all.js
var lib_all = __webpack_require__(14970);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/uncontrollable@7.2.1_react@17.0.2/node_modules/uncontrollable/lib/esm/index.js + 4 modules
var esm = __webpack_require__(22084);
// EXTERNAL MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/querySelectorAll.js
var querySelectorAll = __webpack_require__(83465);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useForceUpdate.js
var useForceUpdate = __webpack_require__(89357);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+hooks@0.4.5_react@17.0.2/node_modules/@restart/hooks/esm/useMergedRefs.js
var useMergedRefs = __webpack_require__(39400);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/NavContext.js
var NavContext = __webpack_require__(84418);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/SelectableContext.js
var SelectableContext = __webpack_require__(77519);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/TabContext.js
var TabContext = __webpack_require__(70330);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/DataKey.js
var DataKey = __webpack_require__(46040);
// EXTERNAL MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/NavItem.js
var NavItem = __webpack_require__(27680);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@restart+ui@1.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/@restart/ui/esm/Nav.js
const _excluded = ["as", "onSelect", "activeKey", "role", "onKeyDown"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }













// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

const EVENT_KEY_ATTR = (0,DataKey/* dataAttr */.PB)('event-key');
const Nav = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    onSelect,
    activeKey,
    role,
    onKeyDown
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
  // and don't want to reset the set in the effect
  const forceUpdate = (0,useForceUpdate/* default */.Z)();
  const needsRefocusRef = (0,react.useRef)(false);
  const parentOnSelect = (0,react.useContext)(SelectableContext/* default */.Z);
  const tabContext = (0,react.useContext)(TabContext/* default */.Z);
  let getControlledId, getControllerId;

  if (tabContext) {
    role = role || 'tablist';
    activeKey = tabContext.activeKey; // TODO: do we need to duplicate these?

    getControlledId = tabContext.getControlledId;
    getControllerId = tabContext.getControllerId;
  }

  const listNode = (0,react.useRef)(null);

  const getNextActiveTab = offset => {
    const currentListNode = listNode.current;
    if (!currentListNode) return null;
    const items = (0,querySelectorAll/* default */.Z)(currentListNode, `[${EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
    const activeChild = currentListNode.querySelector('[aria-selected=true]');
    if (!activeChild || activeChild !== document.activeElement) return null;
    const index = items.indexOf(activeChild);
    if (index === -1) return null;
    let nextIndex = index + offset;
    if (nextIndex >= items.length) nextIndex = 0;
    if (nextIndex < 0) nextIndex = items.length - 1;
    return items[nextIndex];
  };

  const handleSelect = (key, event) => {
    if (key == null) return;
    onSelect == null ? void 0 : onSelect(key, event);
    parentOnSelect == null ? void 0 : parentOnSelect(key, event);
  };

  const handleKeyDown = event => {
    onKeyDown == null ? void 0 : onKeyDown(event);

    if (!tabContext) {
      return;
    }

    let nextActiveChild;

    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        nextActiveChild = getNextActiveTab(-1);
        break;

      case 'ArrowRight':
      case 'ArrowDown':
        nextActiveChild = getNextActiveTab(1);
        break;

      default:
        return;
    }

    if (!nextActiveChild) return;
    event.preventDefault();
    handleSelect(nextActiveChild.dataset[(0,DataKey/* dataProp */.$F)('EventKey')] || null, event);
    needsRefocusRef.current = true;
    forceUpdate();
  };

  (0,react.useEffect)(() => {
    if (listNode.current && needsRefocusRef.current) {
      const activeChild = listNode.current.querySelector(`[${EVENT_KEY_ATTR}][aria-selected=true]`);
      activeChild == null ? void 0 : activeChild.focus();
    }

    needsRefocusRef.current = false;
  });
  const mergedRef = (0,useMergedRefs/* default */.Z)(ref, listNode);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SelectableContext/* default.Provider */.Z.Provider, {
    value: handleSelect,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavContext/* default.Provider */.Z.Provider, {
      value: {
        role,
        // used by NavLink to determine it's role
        activeKey: (0,SelectableContext/* makeEventKey */.h)(activeKey),
        getControlledId: getControlledId || noop,
        getControllerId: getControllerId || noop
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, Object.assign({}, props, {
        onKeyDown: handleKeyDown,
        ref: mergedRef,
        role: role
      }))
    })
  });
});
Nav.displayName = 'Nav';
/* harmony default export */ var esm_Nav = (Object.assign(Nav, {
  Item: NavItem/* default */.Z
}));
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(97902);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/NavbarContext.js
var NavbarContext = __webpack_require__(46674);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/CardHeaderContext.js

const context = /*#__PURE__*/react.createContext(null);
context.displayName = 'CardHeaderContext';
/* harmony default export */ var CardHeaderContext = (context);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(91385);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/NavItem.js

/* harmony default export */ var esm_NavItem = ((0,createWithBsPrefix/* default */.Z)('nav-item'));
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/NavLink.js
var NavLink = __webpack_require__(92292);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Nav.js












const defaultProps = {
  justify: false,
  fill: false
};
const Nav_Nav = /*#__PURE__*/react.forwardRef((uncontrolledProps, ref) => {
  const {
    as = 'div',
    bsPrefix: initialBsPrefix,
    variant,
    fill,
    justify,
    navbar,
    navbarScroll,
    className,
    activeKey,
    ...props
  } = (0,esm/* useUncontrolled */.Ch)(uncontrolledProps, {
    activeKey: 'onSelect'
  });
  const bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(initialBsPrefix, 'nav');
  let navbarBsPrefix;
  let cardHeaderBsPrefix;
  let isNavbar = false;
  const navbarContext = (0,react.useContext)(NavbarContext/* default */.Z);
  const cardHeaderContext = (0,react.useContext)(CardHeaderContext);

  if (navbarContext) {
    navbarBsPrefix = navbarContext.bsPrefix;
    isNavbar = navbar == null ? true : navbar;
  } else if (cardHeaderContext) {
    ({
      cardHeaderBsPrefix
    } = cardHeaderContext);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Nav, {
    as: as,
    ref: ref,
    activeKey: activeKey,
    className: classnames_default()(className, {
      [bsPrefix]: !isNavbar,
      [`${navbarBsPrefix}-nav`]: isNavbar,
      [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
      [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
      [`${bsPrefix}-${variant}`]: !!variant,
      [`${bsPrefix}-fill`]: fill,
      [`${bsPrefix}-justified`]: justify
    }),
    ...props
  });
});
Nav_Nav.displayName = 'Nav';
Nav_Nav.defaultProps = defaultProps;
/* harmony default export */ var react_bootstrap_esm_Nav = (Object.assign(Nav_Nav, {
  Item: esm_NavItem,
  Link: NavLink/* default */.Z
}));

/***/ }),

/***/ 92292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19803);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50456);
/* harmony import */ var _restart_ui_NavItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27680);
/* harmony import */ var _restart_ui_SelectableContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77519);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97902);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4637);







const defaultProps = {
  disabled: false
};
const NavLink = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  as: Component = _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
  active,
  eventKey,
  ...props
}, ref) => {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_4__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'nav-link');
  const [navItemProps, meta] = (0,_restart_ui_NavItem__WEBPACK_IMPORTED_MODULE_5__/* .useNavItem */ .v)({
    key: (0,_restart_ui_SelectableContext__WEBPACK_IMPORTED_MODULE_6__/* .makeEventKey */ .h)(eventKey, props.href),
    active,
    ...props
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, { ...props,
    ...navItemProps,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, bsPrefix, props.disabled && 'disabled', meta.isActive && 'active')
  });
});
NavLink.displayName = 'NavLink';
NavLink.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (NavLink);

/***/ }),

/***/ 46674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
 // TODO: check

const context = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
context.displayName = 'NavbarContext';
/* harmony default export */ __webpack_exports__["Z"] = (context);

/***/ }),

/***/ 44858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19803);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97902);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4637);




const Row = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const decoratedBsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'row');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const sizePrefix = `${decoratedBsPrefix}-cols`;
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let cols;

    if (propValue != null && typeof propValue === 'object') {
      ({
        cols
      } = propValue);
    } else {
      cols = propValue;
    }

    const infix = brkPoint !== 'xs' ? `-${brkPoint}` : '';
    if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, decoratedBsPrefix, ...classes)
  });
});
Row.displayName = 'Row';
/* harmony default export */ __webpack_exports__["Z"] = (Row);

/***/ }),

/***/ 97902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vE": function() { return /* binding */ useBootstrapPrefix; },
/* harmony export */   "pi": function() { return /* binding */ useBootstrapBreakpoints; },
/* harmony export */   "SC": function() { return /* binding */ useIsRTL; }
/* harmony export */ });
/* unused harmony exports DEFAULT_BREAKPOINTS, createBootstrapComponent, ThemeConsumer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4637);



const DEFAULT_BREAKPOINTS = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
const ThemeContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  prefixes: {},
  breakpoints: DEFAULT_BREAKPOINTS
});
const {
  Consumer,
  Provider
} = ThemeContext;

function ThemeProvider({
  prefixes = {},
  breakpoints = DEFAULT_BREAKPOINTS,
  dir,
  children
}) {
  const contextValue = useMemo(() => ({
    prefixes: { ...prefixes
    },
    breakpoints,
    dir
  }), [prefixes, breakpoints, dir]);
  return /*#__PURE__*/_jsx(Provider, {
    value: contextValue,
    children: children
  });
}

function useBootstrapPrefix(prefix, defaultPrefix) {
  const {
    prefixes
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext);
  return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function useBootstrapBreakpoints() {
  const {
    breakpoints
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext);
  return breakpoints;
}
function useIsRTL() {
  const {
    dir
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext);
  return dir === 'rtl';
}

function createBootstrapComponent(Component, opts) {
  if (typeof opts === 'string') opts = {
    prefix: opts
  };
  const isClassy = Component.prototype && Component.prototype.isReactComponent; // If it's a functional component make sure we don't break it with a ref

  const {
    prefix,
    forwardRefAs = isClassy ? 'ref' : 'innerRef'
  } = opts;
  const Wrapped = /*#__PURE__*/React.forwardRef(({ ...props
  }, ref) => {
    props[forwardRefAs] = ref;
    const bsPrefix = useBootstrapPrefix(props.bsPrefix, prefix);
    return /*#__PURE__*/_jsx(Component, { ...props,
      bsPrefix: bsPrefix
    });
  });
  Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
  return Wrapped;
}


/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ThemeProvider)));

/***/ }),

/***/ 52309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72983);
/* harmony import */ var _restart_hooks_useMergedRefs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39400);
/* harmony import */ var _safeFindDOMNode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92201);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4637);





// Normalizes Transition callbacks when nodeRef is used.
const TransitionWrapper = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({
  onEnter,
  onEntering,
  onEntered,
  onExit,
  onExiting,
  onExited,
  addEndListener,
  children,
  childRef,
  ...props
}, ref) => {
  const nodeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const mergedRef = (0,_restart_hooks_useMergedRefs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(nodeRef, childRef);

  const attachRef = r => {
    mergedRef((0,_safeFindDOMNode__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(r));
  };

  const normalize = callback => param => {
    if (callback && nodeRef.current) {
      callback(nodeRef.current, param);
    }
  };
  /* eslint-disable react-hooks/exhaustive-deps */


  const handleEnter = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(normalize(onEnter), [onEnter]);
  const handleEntering = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(normalize(onEntering), [onEntering]);
  const handleEntered = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(normalize(onEntered), [onEntered]);
  const handleExit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(normalize(onExit), [onExit]);
  const handleExiting = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(normalize(onExiting), [onExiting]);
  const handleExited = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(normalize(onExited), [onExited]);
  const handleAddEndListener = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(normalize(addEndListener), [addEndListener]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
    ref: ref,
    ...props,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    nodeRef: nodeRef,
    children: typeof children === 'function' ? (status, innerProps) => children(status, { ...innerProps,
      ref: attachRef
    }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
      ref: attachRef
    })
  });
});
/* harmony default export */ __webpack_exports__["Z"] = (TransitionWrapper);

/***/ }),

/***/ 91385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createWithBsPrefix; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(19803);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/.pnpm/dom-helpers@5.2.1/node_modules/dom-helpers/esm/camelize.js
var rHyphen = /-(.)/g;
function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(97902);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/createWithBsPrefix.js






const pascalCase = str => str[0].toUpperCase() + camelize(str).slice(1);

// TODO: emstricten & fix the typing here! `createWithBsPrefix<TElementType>...`
function createWithBsPrefix(prefix, {
  displayName = pascalCase(prefix),
  Component,
  defaultProps
} = {}) {
  const BsComponent = /*#__PURE__*/react.forwardRef(({
    className,
    bsPrefix,
    as: Tag = Component || 'div',
    ...props
  }, ref) => {
    const resolvedPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, prefix);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Tag, {
      ref: ref,
      className: classnames_default()(className, resolvedPrefix),
      ...props
    });
  });
  BsComponent.defaultProps = defaultProps;
  BsComponent.displayName = displayName;
  return BsComponent;
}

/***/ }),

/***/ 57024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19803);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4637);



/* harmony default export */ __webpack_exports__["Z"] = (className => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((p, ref) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", { ...p,
  ref: ref,
  className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(p.className, className)
})));

/***/ }),

/***/ 92201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ safeFindDOMNode; }
/* harmony export */ });
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87995);

function safeFindDOMNode(componentOrElement) {
  if (componentOrElement && 'setState' in componentOrElement) {
    return react_dom__WEBPACK_IMPORTED_MODULE_0__.findDOMNode(componentOrElement);
  }

  return componentOrElement != null ? componentOrElement : null;
}

/***/ }),

/***/ 72605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ transitionEndListener; }
/* harmony export */ });
/* harmony import */ var dom_helpers_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20968);
/* harmony import */ var dom_helpers_transitionEnd__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4498);



function parseDuration(node, property) {
  const str = (0,dom_helpers_css__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(node, property) || '';
  const mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

function transitionEndListener(element, handler) {
  const duration = parseDuration(element, 'transitionDuration');
  const delay = parseDuration(element, 'transitionDelay');
  const remove = (0,dom_helpers_transitionEnd__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(element, e => {
    if (e.target === element) {
      remove();
      handler(e);
    }
  }, duration + delay);
}

/***/ }),

/***/ 81194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ triggerBrowserReflow; }
/* harmony export */ });
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function triggerBrowserReflow(node) {
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  node.offsetHeight;
}

/***/ }),

/***/ 16629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DY": function() { return /* binding */ ReactContentLoaderBulletList; },
/* harmony export */   "EK": function() { return /* binding */ ReactContentLoaderCode; },
/* harmony export */   "s1": function() { return /* binding */ ReactContentLoaderFacebook; },
/* harmony export */   "mr": function() { return /* binding */ ReactContentLoaderInstagram; },
/* harmony export */   "aV": function() { return /* binding */ ReactContentLoaderListStyle; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var uid = (function () {
    return Math.random()
        .toString(36)
        .substring(6);
});

var SVG = function (_a) {
    var animate = _a.animate, animateBegin = _a.animateBegin, backgroundColor = _a.backgroundColor, backgroundOpacity = _a.backgroundOpacity, baseUrl = _a.baseUrl, children = _a.children, foregroundColor = _a.foregroundColor, foregroundOpacity = _a.foregroundOpacity, gradientRatio = _a.gradientRatio, gradientDirection = _a.gradientDirection, uniqueKey = _a.uniqueKey, interval = _a.interval, rtl = _a.rtl, speed = _a.speed, style = _a.style, title = _a.title, beforeMask = _a.beforeMask, props = __rest(_a, ["animate", "animateBegin", "backgroundColor", "backgroundOpacity", "baseUrl", "children", "foregroundColor", "foregroundOpacity", "gradientRatio", "gradientDirection", "uniqueKey", "interval", "rtl", "speed", "style", "title", "beforeMask"]);
    var fixedId = uniqueKey || uid();
    var idClip = fixedId + "-diff";
    var idGradient = fixedId + "-animated-diff";
    var idAria = fixedId + "-aria";
    var rtlStyle = rtl ? { transform: 'scaleX(-1)' } : null;
    var keyTimes = "0; " + interval + "; 1";
    var dur = speed + "s";
    var gradientTransform = gradientDirection === 'top-bottom' ? 'rotate(90)' : undefined;
    return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", __assign({ "aria-labelledby": idAria, role: "img", style: __assign(__assign({}, style), rtlStyle) }, props),
        title ? (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("title", { id: idAria }, title) : null,
        beforeMask && (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(beforeMask) ? beforeMask : null,
        (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { role: "presentation", x: "0", y: "0", width: "100%", height: "100%", clipPath: "url(" + baseUrl + "#" + idClip + ")", style: { fill: "url(" + baseUrl + "#" + idGradient + ")" } }),
        (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("defs", null,
            (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("clipPath", { id: idClip }, children),
            (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("linearGradient", { id: idGradient, gradientTransform: gradientTransform },
                (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("stop", { offset: "0%", stopColor: backgroundColor, stopOpacity: backgroundOpacity }, animate && ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("animate", { attributeName: "offset", values: -gradientRatio + "; " + -gradientRatio + "; 1", keyTimes: keyTimes, dur: dur, repeatCount: "indefinite", begin: animateBegin }))),
                (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("stop", { offset: "50%", stopColor: foregroundColor, stopOpacity: foregroundOpacity }, animate && ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("animate", { attributeName: "offset", values: -gradientRatio / 2 + "; " + -gradientRatio / 2 + "; " + (1 +
                        gradientRatio / 2), keyTimes: keyTimes, dur: dur, repeatCount: "indefinite", begin: animateBegin }))),
                (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("stop", { offset: "100%", stopColor: backgroundColor, stopOpacity: backgroundOpacity }, animate && ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("animate", { attributeName: "offset", values: "0; 0; " + (1 + gradientRatio), keyTimes: keyTimes, dur: dur, repeatCount: "indefinite", begin: animateBegin })))))));
};
SVG.defaultProps = {
    animate: true,
    backgroundColor: '#f5f6f7',
    backgroundOpacity: 1,
    baseUrl: '',
    foregroundColor: '#eee',
    foregroundOpacity: 1,
    gradientRatio: 2,
    gradientDirection: 'left-right',
    id: null,
    interval: 0.25,
    rtl: false,
    speed: 1.2,
    style: {},
    title: 'Loading...',
    beforeMask: null,
};

var ContentLoader = function (props) {
    return props.children ? (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(SVG, __assign({}, props)) : (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ReactContentLoaderFacebook, __assign({}, props));
};

var ReactContentLoaderFacebook = function (props) { return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ContentLoader, __assign({ viewBox: "0 0 476 124" }, props),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "48", y: "8", width: "88", height: "6", rx: "3" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "48", y: "26", width: "52", height: "6", rx: "3" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "0", y: "56", width: "410", height: "6", rx: "3" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "0", y: "72", width: "380", height: "6", rx: "3" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "0", y: "88", width: "178", height: "6", rx: "3" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", { cx: "20", cy: "20", r: "20" }))); };

var ReactContentLoaderInstagram = function (props) { return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ContentLoader, __assign({ viewBox: "0 0 400 460" }, props),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", { cx: "31", cy: "31", r: "15" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "58", y: "18", rx: "2", ry: "2", width: "140", height: "10" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "58", y: "34", rx: "2", ry: "2", width: "140", height: "10" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "0", y: "60", rx: "2", ry: "2", width: "400", height: "400" }))); };

var ReactContentLoaderCode = function (props) { return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ContentLoader, __assign({ viewBox: "0 0 340 84" }, props),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "0", y: "0", width: "67", height: "11", rx: "3" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "76", y: "0", width: "140", height: "11", rx: "3" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "127", y: "48", width: "53", height: "11", rx: "3" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "187", y: "48", width: "72", height: "11", rx: "3" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "18", y: "48", width: "100", height: "11", rx: "3" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "0", y: "71", width: "37", height: "11", rx: "3" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "18", y: "23", width: "140", height: "11", rx: "3" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "166", y: "23", width: "173", height: "11", rx: "3" }))); };

var ReactContentLoaderListStyle = function (props) { return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ContentLoader, __assign({ viewBox: "0 0 400 110" }, props),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "0", y: "0", rx: "3", ry: "3", width: "250", height: "10" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "20", y: "20", rx: "3", ry: "3", width: "220", height: "10" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "20", y: "40", rx: "3", ry: "3", width: "170", height: "10" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "0", y: "60", rx: "3", ry: "3", width: "250", height: "10" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "20", y: "80", rx: "3", ry: "3", width: "200", height: "10" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "20", y: "100", rx: "3", ry: "3", width: "80", height: "10" }))); };

var ReactContentLoaderBulletList = function (props) { return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ContentLoader, __assign({ viewBox: "0 0 245 125" }, props),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", { cx: "10", cy: "20", r: "8" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "25", y: "15", rx: "5", ry: "5", width: "220", height: "10" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", { cx: "10", cy: "50", r: "8" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "25", y: "45", rx: "5", ry: "5", width: "220", height: "10" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", { cx: "10", cy: "80", r: "8" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "25", y: "75", rx: "5", ry: "5", width: "220", height: "10" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", { cx: "10", cy: "110", r: "8" }),
    (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", { x: "25", y: "105", rx: "5", ry: "5", width: "220", height: "10" }))); };

/* harmony default export */ __webpack_exports__["ZP"] = (ContentLoader);

//# sourceMappingURL=react-content-loader.es.js.map


/***/ }),

/***/ 61970:
/***/ (function(module) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 60198:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 56237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(60198);
} else {}


/***/ }),

/***/ 27257:
/***/ (function(module) {

if (true) {
  module.exports = {
    ReactQueryDevtools: function () {
      return null
    },
    ReactQueryDevtoolsPanel: function () {
      return null
    },
  }
} else {}


/***/ }),

/***/ 56485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ focusManager; }
/* harmony export */ });
/* unused harmony export FocusManager */
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54660);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81283);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32643);



var FocusManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(FocusManager, _Subscribable);

  function FocusManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onFocus) {
      var _window;

      if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onFocus();
        }; // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }
    };

    return _this;
  }

  var _proto = FocusManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (focused) {
      if (typeof focused === 'boolean') {
        _this2.setFocused(focused);
      } else {
        _this2.onFocus();
      }
    });
  };

  _proto.setFocused = function setFocused(focused) {
    this.focused = focused;

    if (focused) {
      this.onFocus();
    }
  };

  _proto.onFocus = function onFocus() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isFocused = function isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  };

  return FocusManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);
var focusManager = new FocusManager();

/***/ }),

/***/ 67708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _queryClient__WEBPACK_IMPORTED_MODULE_0__.S; }
/* harmony export */ });
/* harmony import */ var _queryClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95351);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94285);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useMutation")) __webpack_require__.d(__webpack_exports__, { "useMutation": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useMutation; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useQueryClient")) __webpack_require__.d(__webpack_exports__, { "useQueryClient": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useQueryClient; } });














 // Types



/***/ }),

/***/ 20359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getLogger; },
/* harmony export */   "E": function() { return /* binding */ setLogger; }
/* harmony export */ });
// TYPES
// FUNCTIONS
var logger = console;
function getLogger() {
  return logger;
}
function setLogger(newLogger) {
  logger = newLogger;
}

/***/ }),

/***/ 14901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ Mutation; },
/* harmony export */   "R": function() { return /* binding */ getDefaultState; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15517);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20359);
/* harmony import */ var _notifyManager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92394);
/* harmony import */ var _retryer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97622);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32643);




 // TYPES

// CLASS
var Mutation = /*#__PURE__*/function () {
  function Mutation(config) {
    this.options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, config.defaultOptions, config.options);
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.meta = config.meta;
  }

  var _proto = Mutation.prototype;

  _proto.setState = function setState(state) {
    this.dispatch({
      type: 'setState',
      state: state
    });
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    this.observers = this.observers.filter(function (x) {
      return x !== observer;
    });
  };

  _proto.cancel = function cancel() {
    if (this.retryer) {
      this.retryer.cancel();
      return this.retryer.promise.then(_utils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT).catch(_utils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT);
    }

    return Promise.resolve();
  };

  _proto.continue = function _continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }

    return this.execute();
  };

  _proto.execute = function execute() {
    var _this = this;

    var data;
    var restored = this.state.status === 'loading';
    var promise = Promise.resolve();

    if (!restored) {
      this.dispatch({
        type: 'loading',
        variables: this.options.variables
      });
      promise = promise.then(function () {
        // Notify cache callback
        _this.mutationCache.config.onMutate == null ? void 0 : _this.mutationCache.config.onMutate(_this.state.variables, _this);
      }).then(function () {
        return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
      }).then(function (context) {
        if (context !== _this.state.context) {
          _this.dispatch({
            type: 'loading',
            context: context,
            variables: _this.state.variables
          });
        }
      });
    }

    return promise.then(function () {
      return _this.executeMutation();
    }).then(function (result) {
      data = result; // Notify cache callback

      _this.mutationCache.config.onSuccess == null ? void 0 : _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
    }).then(function () {
      return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
    }).then(function () {
      return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
    }).then(function () {
      _this.dispatch({
        type: 'success',
        data: data
      });

      return data;
    }).catch(function (error) {
      // Notify cache callback
      _this.mutationCache.config.onError == null ? void 0 : _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error

      (0,_logger__WEBPACK_IMPORTED_MODULE_2__/* .getLogger */ .j)().error(error);
      return Promise.resolve().then(function () {
        return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
      }).then(function () {
        return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
      }).then(function () {
        _this.dispatch({
          type: 'error',
          error: error
        });

        throw error;
      });
    });
  };

  _proto.executeMutation = function executeMutation() {
    var _this2 = this,
        _this$options$retry;

    this.retryer = new _retryer__WEBPACK_IMPORTED_MODULE_3__/* .Retryer */ .m4({
      fn: function fn() {
        if (!_this2.options.mutationFn) {
          return Promise.reject('No mutationFn found');
        }

        return _this2.options.mutationFn(_this2.state.variables);
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay
    });
    return this.retryer.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = reducer(this.state, action);
    _notifyManager__WEBPACK_IMPORTED_MODULE_4__/* .notifyManager.batch */ .V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onMutationUpdate(action);
      });

      _this3.mutationCache.notify(_this3);
    });
  };

  return Mutation;
}();
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}

function reducer(state, action) {
  switch (action.type) {
    case 'failed':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        failureCount: state.failureCount + 1
      });

    case 'pause':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        isPaused: true
      });

    case 'continue':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        isPaused: false
      });

    case 'loading':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        context: action.context,
        data: undefined,
        error: null,
        isPaused: false,
        status: 'loading',
        variables: action.variables
      });

    case 'success':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        data: action.data,
        error: null,
        status: 'success',
        isPaused: false
      });

    case 'error':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        data: undefined,
        error: action.error,
        failureCount: state.failureCount + 1,
        isPaused: false,
        status: 'error'
      });

    case 'setState':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, action.state);

    default:
      return state;
  }
}

/***/ }),

/***/ 92394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ notifyManager; }
/* harmony export */ });
/* unused harmony export NotifyManager */
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32643);
 // TYPES

// CLASS
var NotifyManager = /*#__PURE__*/function () {
  function NotifyManager() {
    this.queue = [];
    this.transactions = 0;

    this.notifyFn = function (callback) {
      callback();
    };

    this.batchNotifyFn = function (callback) {
      callback();
    };
  }

  var _proto = NotifyManager.prototype;

  _proto.batch = function batch(callback) {
    var result;
    this.transactions++;

    try {
      result = callback();
    } finally {
      this.transactions--;

      if (!this.transactions) {
        this.flush();
      }
    }

    return result;
  };

  _proto.schedule = function schedule(callback) {
    var _this = this;

    if (this.transactions) {
      this.queue.push(callback);
    } else {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this.notifyFn(callback);
      });
    }
  }
  /**
   * All calls to the wrapped function will be batched.
   */
  ;

  _proto.batchCalls = function batchCalls(callback) {
    var _this2 = this;

    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this2.schedule(function () {
        callback.apply(void 0, args);
      });
    };
  };

  _proto.flush = function flush() {
    var _this3 = this;

    var queue = this.queue;
    this.queue = [];

    if (queue.length) {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this3.batchNotifyFn(function () {
          queue.forEach(function (callback) {
            _this3.notifyFn(callback);
          });
        });
      });
    }
  }
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */
  ;

  _proto.setNotifyFunction = function setNotifyFunction(fn) {
    this.notifyFn = fn;
  }
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */
  ;

  _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
    this.batchNotifyFn = fn;
  };

  return NotifyManager;
}(); // SINGLETON

var notifyManager = new NotifyManager();

/***/ }),

/***/ 90423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ onlineManager; }
/* harmony export */ });
/* unused harmony export OnlineManager */
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54660);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81283);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32643);



var OnlineManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OnlineManager, _Subscribable);

  function OnlineManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onOnline) {
      var _window;

      if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onOnline();
        }; // Listen to online


        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      }
    };

    return _this;
  }

  var _proto = OnlineManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (online) {
      if (typeof online === 'boolean') {
        _this2.setOnline(online);
      } else {
        _this2.onOnline();
      }
    });
  };

  _proto.setOnline = function setOnline(online) {
    this.online = online;

    if (online) {
      this.onOnline();
    }
  };

  _proto.onOnline = function onOnline() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isOnline = function isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  };

  return OnlineManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);
var onlineManager = new OnlineManager();

/***/ }),

/***/ 95351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ QueryClient; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(15517);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(32643);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(54660);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(92394);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(20359);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(97622);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/query.js




 // TYPES

// CLASS
var Query = /*#__PURE__*/function () {
  function Query(config) {
    this.abortSignalConsumed = false;
    this.hadObservers = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || this.getDefaultState(this.options);
    this.state = this.initialState;
    this.meta = config.meta;
    this.scheduleGc();
  }

  var _proto = Query.prototype;

  _proto.setOptions = function setOptions(options) {
    var _this$options$cacheTi;

    this.options = (0,esm_extends/* default */.Z)({}, this.defaultOptions, options);
    this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set

    this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 5 * 60 * 1000);
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.scheduleGc = function scheduleGc() {
    var _this = this;

    this.clearGcTimeout();

    if ((0,utils/* isValidTimeout */.PN)(this.cacheTime)) {
      this.gcTimeout = setTimeout(function () {
        _this.optionalRemove();
      }, this.cacheTime);
    }
  };

  _proto.clearGcTimeout = function clearGcTimeout() {
    clearTimeout(this.gcTimeout);
    this.gcTimeout = undefined;
  };

  _proto.optionalRemove = function optionalRemove() {
    if (!this.observers.length) {
      if (this.state.isFetching) {
        if (this.hadObservers) {
          this.scheduleGc();
        }
      } else {
        this.cache.remove(this);
      }
    }
  };

  _proto.setData = function setData(updater, options) {
    var _this$options$isDataE, _this$options;

    var prevData = this.state.data; // Get the new data

    var data = (0,utils/* functionalUpdate */.SE)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`

    if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) {
      data = prevData;
    } else if (this.options.structuralSharing !== false) {
      // Structurally share data between prev and new data if needed
      data = (0,utils/* replaceEqualDeep */.Q$)(prevData, data);
    } // Set data and mark it as cached


    this.dispatch({
      data: data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt
    });
    return data;
  };

  _proto.setState = function setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state: state,
      setStateOptions: setStateOptions
    });
  };

  _proto.cancel = function cancel(options) {
    var _this$retryer;

    var promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT) : Promise.resolve();
  };

  _proto.destroy = function destroy() {
    this.clearGcTimeout();
    this.cancel({
      silent: true
    });
  };

  _proto.reset = function reset() {
    this.destroy();
    this.setState(this.initialState);
  };

  _proto.isActive = function isActive() {
    return this.observers.some(function (observer) {
      return observer.options.enabled !== false;
    });
  };

  _proto.isFetching = function isFetching() {
    return this.state.isFetching;
  };

  _proto.isStale = function isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
      return observer.getCurrentResult().isStale;
    });
  };

  _proto.isStaleByTime = function isStaleByTime(staleTime) {
    if (staleTime === void 0) {
      staleTime = 0;
    }

    return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0,utils/* timeUntilStale */.Kp)(this.state.dataUpdatedAt, staleTime);
  };

  _proto.onFocus = function onFocus() {
    var _this$retryer2;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnWindowFocus();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  };

  _proto.onOnline = function onOnline() {
    var _this$retryer3;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnReconnect();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
      this.hadObservers = true; // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer: observer
      });
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(function (x) {
        return x !== observer;
      });

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.retryer.isTransportCancelable || this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        if (this.cacheTime) {
          this.scheduleGc();
        } else {
          this.cache.remove(this);
        }
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer: observer
      });
    }
  };

  _proto.getObserversCount = function getObserversCount() {
    return this.observers.length;
  };

  _proto.invalidate = function invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  };

  _proto.fetch = function fetch(options, fetchOptions) {
    var _this2 = this,
        _this$options$behavio,
        _context$fetchOptions,
        _abortController$abor;

    if (this.state.isFetching) {
      if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      var observer = this.observers.find(function (x) {
        return x.options.queryFn;
      });

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    var queryKey = (0,utils/* ensureQueryKeyArray */.mc)(this.queryKey);
    var abortController = (0,utils/* getAbortController */.G9)(); // Create query function context

    var queryFnContext = {
      queryKey: queryKey,
      pageParam: undefined,
      meta: this.meta
    };
    Object.defineProperty(queryFnContext, 'signal', {
      enumerable: true,
      get: function get() {
        if (abortController) {
          _this2.abortSignalConsumed = true;
          return abortController.signal;
        }

        return undefined;
      }
    }); // Create fetch function

    var fetchFn = function fetchFn() {
      if (!_this2.options.queryFn) {
        return Promise.reject('Missing queryFn');
      }

      _this2.abortSignalConsumed = false;
      return _this2.options.queryFn(queryFnContext);
    }; // Trigger behavior hook


    var context = {
      fetchOptions: fetchOptions,
      options: this.options,
      queryKey: queryKey,
      state: this.state,
      fetchFn: fetchFn,
      meta: this.meta
    };

    if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
      var _this$options$behavio2;

      (_this$options$behavio2 = this.options.behavior) == null ? void 0 : _this$options$behavio2.onFetch(context);
    } // Store state in case the current fetch needs to be reverted


    this.revertState = this.state; // Set to fetching state if not already in it

    if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    } // Try to fetch the data


    this.retryer = new retryer/* Retryer */.m4({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
      onSuccess: function onSuccess(data) {
        _this2.setData(data); // Notify cache callback


        _this2.cache.config.onSuccess == null ? void 0 : _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0

        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onError: function onError(error) {
        // Optimistically update state if needed
        if (!((0,retryer/* isCancelledError */.DV)(error) && error.silent)) {
          _this2.dispatch({
            type: 'error',
            error: error
          });
        }

        if (!(0,retryer/* isCancelledError */.DV)(error)) {
          // Notify cache callback
          _this2.cache.config.onError == null ? void 0 : _this2.cache.config.onError(error, _this2); // Log error

          (0,logger/* getLogger */.j)().error(error);
        } // Remove query after fetching if cache time is 0


        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay
    });
    this.promise = this.retryer.promise;
    return this.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = this.reducer(this.state, action);
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onQueryUpdate(action);
      });

      _this3.cache.notify({
        query: _this3,
        type: 'queryUpdated',
        action: action
      });
    });
  };

  _proto.getDefaultState = function getDefaultState(options) {
    var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    var hasInitialData = typeof options.initialData !== 'undefined';
    var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    var hasData = typeof data !== 'undefined';
    return {
      data: data,
      dataUpdateCount: 0,
      dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
      error: null,
      errorUpdateCount: 0,
      errorUpdatedAt: 0,
      fetchFailureCount: 0,
      fetchMeta: null,
      isFetching: false,
      isInvalidated: false,
      isPaused: false,
      status: hasData ? 'success' : 'idle'
    };
  };

  _proto.reducer = function reducer(state, action) {
    var _action$meta, _action$dataUpdatedAt;

    switch (action.type) {
      case 'failed':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: state.fetchFailureCount + 1
        });

      case 'pause':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: true
        });

      case 'continue':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: false
        });

      case 'fetch':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: 0,
          fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
          isFetching: true,
          isPaused: false
        }, !state.dataUpdatedAt && {
          error: null,
          status: 'loading'
        });

      case 'success':
        return (0,esm_extends/* default */.Z)({}, state, {
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
          error: null,
          fetchFailureCount: 0,
          isFetching: false,
          isInvalidated: false,
          isPaused: false,
          status: 'success'
        });

      case 'error':
        var error = action.error;

        if ((0,retryer/* isCancelledError */.DV)(error) && error.revert && this.revertState) {
          return (0,esm_extends/* default */.Z)({}, this.revertState);
        }

        return (0,esm_extends/* default */.Z)({}, state, {
          error: error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          isFetching: false,
          isPaused: false,
          status: 'error'
        });

      case 'invalidate':
        return (0,esm_extends/* default */.Z)({}, state, {
          isInvalidated: true
        });

      case 'setState':
        return (0,esm_extends/* default */.Z)({}, state, action.state);

      default:
        return state;
    }
  };

  return Query;
}();
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(81283);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/queryCache.js





// CLASS
var QueryCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryCache, _Subscribable);

  function QueryCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.queries = [];
    _this.queriesMap = {};
    return _this;
  }

  var _proto = QueryCache.prototype;

  _proto.build = function build(client, options, state) {
    var _options$queryHash;

    var queryKey = options.queryKey;
    var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0,utils/* hashQueryKeyByOptions */.Rm)(queryKey, options);
    var query = this.get(queryHash);

    if (!query) {
      query = new Query({
        cache: this,
        queryKey: queryKey,
        queryHash: queryHash,
        options: client.defaultQueryOptions(options),
        state: state,
        defaultOptions: client.getQueryDefaults(queryKey),
        meta: options.meta
      });
      this.add(query);
    }

    return query;
  };

  _proto.add = function add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'queryAdded',
        query: query
      });
    }
  };

  _proto.remove = function remove(query) {
    var queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(function (x) {
        return x !== query;
      });

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'queryRemoved',
        query: query
      });
    }
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.queries.forEach(function (query) {
        _this2.remove(query);
      });
    });
  };

  _proto.get = function get(queryHash) {
    return this.queriesMap[queryHash];
  };

  _proto.getAll = function getAll() {
    return this.queries;
  };

  _proto.find = function find(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    });
  };

  _proto.findAll = function findAll(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    return Object.keys(filters).length > 0 ? this.queries.filter(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    }) : this.queries;
  };

  _proto.notify = function notify(event) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(event);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    var _this4 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this4.queries.forEach(function (query) {
        query.onFocus();
      });
    });
  };

  _proto.onOnline = function onOnline() {
    var _this5 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queries.forEach(function (query) {
        query.onOnline();
      });
    });
  };

  return QueryCache;
}(subscribable/* Subscribable */.l);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/mutation.js
var core_mutation = __webpack_require__(14901);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/mutationCache.js




 // TYPES

// CLASS
var MutationCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(MutationCache, _Subscribable);

  function MutationCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }

  var _proto = MutationCache.prototype;

  _proto.build = function build(client, options, state) {
    var mutation = new core_mutation/* Mutation */.m({
      mutationCache: this,
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state: state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
      meta: options.meta
    });
    this.add(mutation);
    return mutation;
  };

  _proto.add = function add(mutation) {
    this.mutations.push(mutation);
    this.notify(mutation);
  };

  _proto.remove = function remove(mutation) {
    this.mutations = this.mutations.filter(function (x) {
      return x !== mutation;
    });
    mutation.cancel();
    this.notify(mutation);
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.mutations.forEach(function (mutation) {
        _this2.remove(mutation);
      });
    });
  };

  _proto.getAll = function getAll() {
    return this.mutations;
  };

  _proto.find = function find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.findAll = function findAll(filters) {
    return this.mutations.filter(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.notify = function notify(mutation) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(mutation);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    this.resumePausedMutations();
  };

  _proto.onOnline = function onOnline() {
    this.resumePausedMutations();
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    var pausedMutations = this.mutations.filter(function (x) {
      return x.state.isPaused;
    });
    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return pausedMutations.reduce(function (promise, mutation) {
        return promise.then(function () {
          return mutation.continue().catch(utils/* noop */.ZT);
        });
      }, Promise.resolve());
    });
  };

  return MutationCache;
}(subscribable/* Subscribable */.l);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(56485);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/onlineManager.js
var onlineManager = __webpack_require__(90423);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/infiniteQueryBehavior.js


function infiniteQueryBehavior() {
  return {
    onFetch: function onFetch(context) {
      context.fetchFn = function () {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        var abortController = (0,utils/* getAbortController */.G9)();
        var abortSignal = abortController == null ? void 0 : abortController.signal;
        var newPageParams = oldPageParams;
        var cancelled = false; // Get query function

        var queryFn = context.options.queryFn || function () {
          return Promise.reject('Missing queryFn');
        };

        var buildNewPages = function buildNewPages(pages, param, page, previous) {
          newPageParams = previous ? [param].concat(newPageParams) : [].concat(newPageParams, [param]);
          return previous ? [page].concat(pages) : [].concat(pages, [page]);
        }; // Create function to fetch a page


        var fetchPage = function fetchPage(pages, manual, param, previous) {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          var queryFnContext = {
            queryKey: context.queryKey,
            signal: abortSignal,
            pageParam: param,
            meta: context.meta
          };
          var queryFnResult = queryFn(queryFnContext);
          var promise = Promise.resolve(queryFnResult).then(function (page) {
            return buildNewPages(pages, param, page, previous);
          });

          if ((0,retryer/* isCancelable */.LE)(queryFnResult)) {
            var promiseAsAny = promise;
            promiseAsAny.cancel = queryFnResult.cancel;
          }

          return promise;
        };

        var promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
            var manual = typeof pageParam !== 'undefined';
            var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
            promise = fetchPage(oldPages, manual, param);
          } // Fetch previous page?
          else if (isFetchingPreviousPage) {
              var _manual = typeof pageParam !== 'undefined';

              var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);

              promise = fetchPage(oldPages, _manual, _param, true);
            } // Refetch pages
            else {
                (function () {
                  newPageParams = [];
                  var manual = typeof context.options.getNextPageParam === 'undefined';
                  var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

                  promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

                  var _loop = function _loop(i) {
                    promise = promise.then(function (pages) {
                      var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

                      if (shouldFetchNextPage) {
                        var _param2 = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);

                        return fetchPage(pages, manual, _param2);
                      }

                      return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                  };

                  for (var i = 1; i < oldPages.length; i++) {
                    _loop(i);
                  }
                })();
              }

        var finalPromise = promise.then(function (pages) {
          return {
            pages: pages,
            pageParams: newPageParams
          };
        });
        var finalPromiseAsAny = finalPromise;

        finalPromiseAsAny.cancel = function () {
          cancelled = true;
          abortController == null ? void 0 : abortController.abort();

          if ((0,retryer/* isCancelable */.LE)(promise)) {
            promise.cancel();
          }
        };

        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */

function hasNextPage(options, pages) {
  if (options.getNextPageParam && Array.isArray(pages)) {
    var nextPageParam = getNextPageParam(options, pages);
    return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
  }
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */

function hasPreviousPage(options, pages) {
  if (options.getPreviousPageParam && Array.isArray(pages)) {
    var previousPageParam = getPreviousPageParam(options, pages);
    return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
  }
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/queryClient.js








// CLASS
var QueryClient = /*#__PURE__*/function () {
  function QueryClient(config) {
    if (config === void 0) {
      config = {};
    }

    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
  }

  var _proto = QueryClient.prototype;

  _proto.mount = function mount() {
    var _this = this;

    this.unsubscribeFocus = focusManager/* focusManager.subscribe */.j.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onFocus();

        _this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager/* onlineManager.subscribe */.N.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onOnline();

        _this.queryCache.onOnline();
      }
    });
  };

  _proto.unmount = function unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
  };

  _proto.isFetching = function isFetching(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    filters.fetching = true;
    return this.queryCache.findAll(filters).length;
  };

  _proto.isMutating = function isMutating(filters) {
    return this.mutationCache.findAll((0,esm_extends/* default */.Z)({}, filters, {
      fetching: true
    })).length;
  };

  _proto.getQueryData = function getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  };

  _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref) {
      var queryKey = _ref.queryKey,
          state = _ref.state;
      var data = state.data;
      return [queryKey, data];
    });
  };

  _proto.setQueryData = function setQueryData(queryKey, updater, options) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(queryKey);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(updater, options);
  };

  _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
    var _this2 = this;

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref2) {
        var queryKey = _ref2.queryKey;
        return [queryKey, _this2.setQueryData(queryKey, updater, options)];
      });
    });
  };

  _proto.getQueryState = function getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  };

  _proto.removeQueries = function removeQueries(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    var queryCache = this.queryCache;
    notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        queryCache.remove(query);
      });
    });
  };

  _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
    var _this3 = this;

    var _parseFilterArgs3 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs3[0],
        options = _parseFilterArgs3[1];

    var queryCache = this.queryCache;

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      active: true
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        query.reset();
      });
      return _this3.refetchQueries(refetchFilters, options);
    });
  };

  _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
    var _this4 = this;

    var _parseFilterArgs4 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs4[0],
        _parseFilterArgs4$ = _parseFilterArgs4[1],
        cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this4.queryCache.findAll(filters).map(function (query) {
        return query.cancel(cancelOptions);
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
    var _ref3,
        _filters$refetchActiv,
        _filters$refetchInact,
        _this5 = this;

    var _parseFilterArgs5 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs5[0],
        options = _parseFilterArgs5[1];

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      // if filters.refetchActive is not provided and filters.active is explicitly false,
      // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
      active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
      inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queryCache.findAll(filters).forEach(function (query) {
        query.invalidate();
      });

      return _this5.refetchQueries(refetchFilters, options);
    });
  };

  _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
    var _this6 = this;

    var _parseFilterArgs6 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs6[0],
        options = _parseFilterArgs6[1];

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this6.queryCache.findAll(filters).map(function (query) {
        return query.fetch(undefined, (0,esm_extends/* default */.Z)({}, options, {
          meta: {
            refetchPage: filters == null ? void 0 : filters.refetchPage
          }
        }));
      });
    });
    var promise = Promise.all(promises).then(utils/* noop */.ZT);

    if (!(options == null ? void 0 : options.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  };

  _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    var query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  };

  _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    parsedOptions.behavior = infiniteQueryBehavior();
    return this.fetchQuery(parsedOptions);
  };

  _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.cancelMutations = function cancelMutations() {
    var _this7 = this;

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this7.mutationCache.getAll().map(function (mutation) {
        return mutation.cancel();
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    return this.getMutationCache().resumePausedMutations();
  };

  _proto.executeMutation = function executeMutation(options) {
    return this.mutationCache.build(this, options).execute();
  };

  _proto.getQueryCache = function getQueryCache() {
    return this.queryCache;
  };

  _proto.getMutationCache = function getMutationCache() {
    return this.mutationCache;
  };

  _proto.getDefaultOptions = function getDefaultOptions() {
    return this.defaultOptions;
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
    var result = this.queryDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(queryKey) === (0,utils/* hashQueryKey */.yF)(x.queryKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey: queryKey,
        defaultOptions: options
      });
    }
  };

  _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
    var _this$queryDefaults$f;

    return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(queryKey, x.queryKey);
    })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
  };

  _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
    var result = this.mutationDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(mutationKey) === (0,utils/* hashQueryKey */.yF)(x.mutationKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey: mutationKey,
        defaultOptions: options
      });
    }
  };

  _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
    var _this$mutationDefault;

    return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(mutationKey, x.mutationKey);
    })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
  };

  _proto.defaultQueryOptions = function defaultQueryOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    var defaultedOptions = (0,esm_extends/* default */.Z)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
      _defaulted: true
    });

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = (0,utils/* hashQueryKeyByOptions */.Rm)(defaultedOptions.queryKey, defaultedOptions);
    }

    return defaultedOptions;
  };

  _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
    return this.defaultQueryOptions(options);
  };

  _proto.defaultMutationOptions = function defaultMutationOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    return (0,esm_extends/* default */.Z)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
      _defaulted: true
    });
  };

  _proto.clear = function clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  };

  return QueryClient;
}();

/***/ }),

/***/ 97622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LE": function() { return /* binding */ isCancelable; },
/* harmony export */   "DV": function() { return /* binding */ isCancelledError; },
/* harmony export */   "m4": function() { return /* binding */ Retryer; }
/* harmony export */ });
/* unused harmony export CancelledError */
/* harmony import */ var _focusManager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56485);
/* harmony import */ var _onlineManager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90423);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32643);




function defaultRetryDelay(failureCount) {
  return Math.min(1000 * Math.pow(2, failureCount), 30000);
}

function isCancelable(value) {
  return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var CancelledError = function CancelledError(options) {
  this.revert = options == null ? void 0 : options.revert;
  this.silent = options == null ? void 0 : options.silent;
};
function isCancelledError(value) {
  return value instanceof CancelledError;
} // CLASS

var Retryer = function Retryer(config) {
  var _this = this;

  var cancelRetry = false;
  var cancelFn;
  var continueFn;
  var promiseResolve;
  var promiseReject;
  this.abort = config.abort;

  this.cancel = function (cancelOptions) {
    return cancelFn == null ? void 0 : cancelFn(cancelOptions);
  };

  this.cancelRetry = function () {
    cancelRetry = true;
  };

  this.continueRetry = function () {
    cancelRetry = false;
  };

  this.continue = function () {
    return continueFn == null ? void 0 : continueFn();
  };

  this.failureCount = 0;
  this.isPaused = false;
  this.isResolved = false;
  this.isTransportCancelable = false;
  this.promise = new Promise(function (outerResolve, outerReject) {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  var resolve = function resolve(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  var reject = function reject(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  var pause = function pause() {
    return new Promise(function (continueResolve) {
      continueFn = continueResolve;
      _this.isPaused = true;
      config.onPause == null ? void 0 : config.onPause();
    }).then(function () {
      continueFn = undefined;
      _this.isPaused = false;
      config.onContinue == null ? void 0 : config.onContinue();
    });
  }; // Create loop function


  var run = function run() {
    // Do nothing if already resolved
    if (_this.isResolved) {
      return;
    }

    var promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    } // Create callback to cancel this fetch


    cancelFn = function cancelFn(cancelOptions) {
      if (!_this.isResolved) {
        reject(new CancelledError(cancelOptions));
        _this.abort == null ? void 0 : _this.abort(); // Cancel transport if supported

        if (isCancelable(promiseOrValue)) {
          try {
            promiseOrValue.cancel();
          } catch (_unused) {}
        }
      }
    }; // Check if the transport layer support cancellation


    _this.isTransportCancelable = isCancelable(promiseOrValue);
    Promise.resolve(promiseOrValue).then(resolve).catch(function (error) {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (_this.isResolved) {
        return;
      } // Do we need to retry the request?


      var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
      var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);

      if (cancelRetry || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      _this.failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(_this.failureCount, error); // Delay

      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .sleep */ .Gh)(delay) // Pause if the document is not visible or when the device is offline
      .then(function () {
        if (!_focusManager__WEBPACK_IMPORTED_MODULE_1__/* .focusManager.isFocused */ .j.isFocused() || !_onlineManager__WEBPACK_IMPORTED_MODULE_2__/* .onlineManager.isOnline */ .N.isOnline()) {
          return pause();
        }
      }).then(function () {
        if (cancelRetry) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  run();
};

/***/ }),

/***/ 81283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Subscribable; }
/* harmony export */ });
var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    this.listeners = [];
  }

  var _proto = Subscribable.prototype;

  _proto.subscribe = function subscribe(listener) {
    var _this = this;

    var callback = listener || function () {
      return undefined;
    };

    this.listeners.push(callback);
    this.onSubscribe();
    return function () {
      _this.listeners = _this.listeners.filter(function (x) {
        return x !== callback;
      });

      _this.onUnsubscribe();
    };
  };

  _proto.hasListeners = function hasListeners() {
    return this.listeners.length > 0;
  };

  _proto.onSubscribe = function onSubscribe() {// Do nothing
  };

  _proto.onUnsubscribe = function onUnsubscribe() {// Do nothing
  };

  return Subscribable;
}();

/***/ }),

/***/ 94285:
/***/ (function() {



/***/ }),

/***/ 32643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "SE": function() { return /* binding */ functionalUpdate; },
/* harmony export */   "PN": function() { return /* binding */ isValidTimeout; },
/* harmony export */   "mc": function() { return /* binding */ ensureQueryKeyArray; },
/* harmony export */   "Kp": function() { return /* binding */ timeUntilStale; },
/* harmony export */   "_v": function() { return /* binding */ parseQueryArgs; },
/* harmony export */   "lV": function() { return /* binding */ parseMutationArgs; },
/* harmony export */   "I6": function() { return /* binding */ parseFilterArgs; },
/* harmony export */   "_x": function() { return /* binding */ matchQuery; },
/* harmony export */   "X7": function() { return /* binding */ matchMutation; },
/* harmony export */   "Rm": function() { return /* binding */ hashQueryKeyByOptions; },
/* harmony export */   "yF": function() { return /* binding */ hashQueryKey; },
/* harmony export */   "to": function() { return /* binding */ partialMatchKey; },
/* harmony export */   "Q$": function() { return /* binding */ replaceEqualDeep; },
/* harmony export */   "VS": function() { return /* binding */ shallowEqualObjects; },
/* harmony export */   "Gh": function() { return /* binding */ sleep; },
/* harmony export */   "A4": function() { return /* binding */ scheduleMicrotask; },
/* harmony export */   "G9": function() { return /* binding */ getAbortController; }
/* harmony export */ });
/* unused harmony exports difference, replaceAt, parseMutationFilterArgs, mapQueryStatusFilter, stableValueHash, partialDeepEqual, isPlainObject, isQueryKey, isError */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15517);

// TYPES
// UTILS
var isServer = typeof window === 'undefined';
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function ensureQueryKeyArray(value) {
  return Array.isArray(value) ? value : [value];
}
function difference(array1, array2) {
  return array1.filter(function (x) {
    return array2.indexOf(x) === -1;
  });
}
function replaceAt(array, index, value) {
  var copy = array.slice(0);
  copy[index] = value;
  return copy;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg3, {
      queryKey: arg1,
      queryFn: arg2
    });
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  });
}
function parseMutationArgs(arg1, arg2, arg3) {
  if (isQueryKey(arg1)) {
    if (typeof arg2 === 'function') {
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg3, {
        mutationKey: arg1,
        mutationFn: arg2
      });
    }

    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
      mutationKey: arg1
    });
  }

  if (typeof arg1 === 'function') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
      mutationFn: arg1
    });
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg1);
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  }), arg3] : [arg1 || {}, arg2];
}
function parseMutationFilterArgs(arg1, arg2) {
  return isQueryKey(arg1) ? _extends({}, arg2, {
    mutationKey: arg1
  }) : arg1;
}
function mapQueryStatusFilter(active, inactive) {
  if (active === true && inactive === true || active == null && inactive == null) {
    return 'all';
  } else if (active === false && inactive === false) {
    return 'none';
  } else {
    // At this point, active|inactive can only be true|false or false|true
    // so, when only one value is provided, the missing one has to be the negated value
    var isActive = active != null ? active : !inactive;
    return isActive ? 'active' : 'inactive';
  }
}
function matchQuery(filters, query) {
  var active = filters.active,
      exact = filters.exact,
      fetching = filters.fetching,
      inactive = filters.inactive,
      predicate = filters.predicate,
      queryKey = filters.queryKey,
      stale = filters.stale;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  var queryStatusFilter = mapQueryStatusFilter(active, inactive);

  if (queryStatusFilter === 'none') {
    return false;
  } else if (queryStatusFilter !== 'all') {
    var isActive = query.isActive();

    if (queryStatusFilter === 'active' && !isActive) {
      return false;
    }

    if (queryStatusFilter === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetching === 'boolean' && query.isFetching() !== fetching) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  var exact = filters.exact,
      fetching = filters.fetching,
      predicate = filters.predicate,
      mutationKey = filters.mutationKey;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 */

function hashQueryKey(queryKey) {
  var asArray = ensureQueryKeyArray(queryKey);
  return stableValueHash(asArray);
}
/**
 * Hashes the value into a stable hash.
 */

function stableValueHash(value) {
  return JSON.stringify(value, function (_, val) {
    return isPlainObject(val) ? Object.keys(val).sort().reduce(function (result, key) {
      result[key] = val[key];
      return result;
    }, {}) : val;
  });
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(function (key) {
      return !partialDeepEqual(a[key], b[key]);
    });
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  var array = Array.isArray(a) && Array.isArray(b);

  if (array || isPlainObject(a) && isPlainObject(b)) {
    var aSize = array ? a.length : Object.keys(a).length;
    var bItems = array ? b : Object.keys(b);
    var bSize = bItems.length;
    var copy = array ? [] : {};
    var equalItems = 0;

    for (var i = 0; i < bSize; i++) {
      var key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (var key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  var ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  var prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return typeof value === 'string' || Array.isArray(value);
}
function isError(value) {
  return value instanceof Error;
}
function sleep(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  Promise.resolve().then(callback).catch(function (error) {
    return setTimeout(function () {
      throw error;
    });
  });
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }
}

/***/ }),

/***/ 88349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _core__WEBPACK_IMPORTED_MODULE_0__.QueryClient; },
/* harmony export */   "QueryClientProvider": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider; },
/* harmony export */   "useMutation": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useMutation; },
/* harmony export */   "useQuery": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useQuery; },
/* harmony export */   "useQueryClient": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useQueryClient; }
/* harmony export */ });
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67708);
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useMutation")) __webpack_require__.d(__webpack_exports__, { "useMutation": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useMutation; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useQueryClient")) __webpack_require__.d(__webpack_exports__, { "useQueryClient": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useQueryClient; } });
/* harmony import */ var _react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98250);



/***/ }),

/***/ 98250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "QueryClientProvider": function() { return /* reexport */ QueryClientProvider; },
  "useMutation": function() { return /* reexport */ useMutation; },
  "useQuery": function() { return /* reexport */ useQuery; },
  "useQueryClient": function() { return /* reexport */ useQueryClient; }
});

// UNUSED EXPORTS: Hydrate, QueryErrorResetBoundary, useHydrate, useInfiniteQuery, useIsFetching, useIsMutating, useQueries, useQueryErrorResetBoundary

// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(92394);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@17.0.2_react@17.0.2/node_modules/react-dom/index.js
var react_dom = __webpack_require__(87995);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/react/reactBatchedUpdates.js

var unstable_batchedUpdates = react_dom.unstable_batchedUpdates;
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/react/setBatchUpdatesFn.js


notifyManager/* notifyManager.setBatchNotifyFunction */.V.setBatchNotifyFunction(unstable_batchedUpdates);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(20359);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/react/logger.js
var logger_logger = console;
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/react/setLogger.js


(0,logger/* setLogger */.E)(logger_logger);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/react/QueryClientProvider.js

var defaultContext = /*#__PURE__*/react.createContext(undefined);
var QueryClientSharingContext = /*#__PURE__*/react.createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(contextSharing) {
  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }

    return window.ReactQueryClientContext;
  }

  return defaultContext;
}

var useQueryClient = function useQueryClient() {
  var queryClient = react.useContext(getQueryClientContext(react.useContext(QueryClientSharingContext)));

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};
var QueryClientProvider = function QueryClientProvider(_ref) {
  var client = _ref.client,
      _ref$contextSharing = _ref.contextSharing,
      contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing,
      children = _ref.children;
  react.useEffect(function () {
    client.mount();
    return function () {
      client.unmount();
    };
  }, [client]);
  var Context = getQueryClientContext(contextSharing);
  return /*#__PURE__*/react.createElement(QueryClientSharingContext.Provider, {
    value: contextSharing
  }, /*#__PURE__*/react.createElement(Context.Provider, {
    value: client
  }, children));
};
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(15517);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(32643);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(54660);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/mutation.js
var mutation = __webpack_require__(14901);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(81283);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/mutationObserver.js





// CLASS
var MutationObserver = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(MutationObserver, _Subscribable);

  function MutationObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;

    _this.setOptions(options);

    _this.bindMethods();

    _this.updateResult();

    return _this;
  }

  var _proto = MutationObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  };

  _proto.setOptions = function setOptions(options) {
    this.options = this.client.defaultMutationOptions(options);
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      var _this$currentMutation;

      (_this$currentMutation = this.currentMutation) == null ? void 0 : _this$currentMutation.removeObserver(this);
    }
  };

  _proto.onMutationUpdate = function onMutationUpdate(action) {
    this.updateResult(); // Determine which callbacks to trigger

    var notifyOptions = {
      listeners: true
    };

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error') {
      notifyOptions.onError = true;
    }

    this.notify(notifyOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.reset = function reset() {
    this.currentMutation = undefined;
    this.updateResult();
    this.notify({
      listeners: true
    });
  };

  _proto.mutate = function mutate(variables, options) {
    this.mutateOptions = options;

    if (this.currentMutation) {
      this.currentMutation.removeObserver(this);
    }

    this.currentMutation = this.client.getMutationCache().build(this.client, (0,esm_extends/* default */.Z)({}, this.options, {
      variables: typeof variables !== 'undefined' ? variables : this.options.variables
    }));
    this.currentMutation.addObserver(this);
    return this.currentMutation.execute();
  };

  _proto.updateResult = function updateResult() {
    var state = this.currentMutation ? this.currentMutation.state : (0,mutation/* getDefaultState */.R)();

    var result = (0,esm_extends/* default */.Z)({}, state, {
      isLoading: state.status === 'loading',
      isSuccess: state.status === 'success',
      isError: state.status === 'error',
      isIdle: state.status === 'idle',
      mutate: this.mutate,
      reset: this.reset
    });

    this.currentResult = result;
  };

  _proto.notify = function notify(options) {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      // First trigger the mutate callbacks
      if (_this2.mutateOptions) {
        if (options.onSuccess) {
          _this2.mutateOptions.onSuccess == null ? void 0 : _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
        } else if (options.onError) {
          _this2.mutateOptions.onError == null ? void 0 : _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
        }
      } // Then trigger the listeners


      if (options.listeners) {
        _this2.listeners.forEach(function (listener) {
          listener(_this2.currentResult);
        });
      }
    });
  };

  return MutationObserver;
}(subscribable/* Subscribable */.l);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/react/utils.js
function shouldThrowError(suspense, _useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary.apply(void 0, params);
  } // Allow useErrorBoundary to override suspense's throwing behavior


  if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors

  return !!suspense;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/react/useMutation.js






 // HOOK

function useMutation(arg1, arg2, arg3) {
  var mountedRef = react.useRef(false);

  var _React$useState = react.useState(0),
      forceUpdate = _React$useState[1];

  var options = (0,utils/* parseMutationArgs */.lV)(arg1, arg2, arg3);
  var queryClient = useQueryClient();
  var obsRef = react.useRef();

  if (!obsRef.current) {
    obsRef.current = new MutationObserver(queryClient, options);
  } else {
    obsRef.current.setOptions(options);
  }

  var currentResult = obsRef.current.getCurrentResult();
  react.useEffect(function () {
    mountedRef.current = true;
    var unsubscribe = obsRef.current.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    }));
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, []);
  var mutate = react.useCallback(function (variables, mutateOptions) {
    obsRef.current.mutate(variables, mutateOptions).catch(utils/* noop */.ZT);
  }, []);

  if (currentResult.error && shouldThrowError(undefined, obsRef.current.options.useErrorBoundary, [currentResult.error])) {
    throw currentResult.error;
  }

  return (0,esm_extends/* default */.Z)({}, currentResult, {
    mutate: mutate,
    mutateAsync: currentResult.mutate
  });
}
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(56485);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(97622);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/core/queryObserver.js








var QueryObserver = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryObserver, _Subscribable);

  function QueryObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.options = options;
    _this.trackedProps = [];
    _this.previousSelectError = null;

    _this.bindMethods();

    _this.setOptions(options);

    return _this;
  }

  var _proto = QueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  };

  _proto.onSubscribe = function onSubscribe() {
    if (this.listeners.length === 1) {
      this.currentQuery.addObserver(this);

      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }

      this.updateTimers();
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  };

  _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
    return _shouldFetchOnReconnect(this.currentQuery, this.options);
  };

  _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
    return _shouldFetchOnWindowFocus(this.currentQuery, this.options);
  };

  _proto.destroy = function destroy() {
    this.listeners = [];
    this.clearTimers();
    this.currentQuery.removeObserver(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    var prevOptions = this.options;
    var prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryObserverOptions(options);

    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one


    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }

    this.updateQuery();
    var mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result


    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }

    var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return this.createResult(query, defaultedOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.trackResult = function trackResult(result, defaultedOptions) {
    var _this2 = this;

    var trackedResult = {};

    var trackProp = function trackProp(key) {
      if (!_this2.trackedProps.includes(key)) {
        _this2.trackedProps.push(key);
      }
    };

    Object.keys(result).forEach(function (key) {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: function get() {
          trackProp(key);
          return result[key];
        }
      });
    });

    if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) {
      trackProp('error');
    }

    return trackedResult;
  };

  _proto.getNextResult = function getNextResult(options) {
    var _this3 = this;

    return new Promise(function (resolve, reject) {
      var unsubscribe = _this3.subscribe(function (result) {
        if (!result.isFetching) {
          unsubscribe();

          if (result.isError && (options == null ? void 0 : options.throwOnError)) {
            reject(result.error);
          } else {
            resolve(result);
          }
        }
      });
    });
  };

  _proto.getCurrentQuery = function getCurrentQuery() {
    return this.currentQuery;
  };

  _proto.remove = function remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  };

  _proto.refetch = function refetch(options) {
    return this.fetch((0,esm_extends/* default */.Z)({}, options, {
      meta: {
        refetchPage: options == null ? void 0 : options.refetchPage
      }
    }));
  };

  _proto.fetchOptimistic = function fetchOptimistic(options) {
    var _this4 = this;

    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return query.fetch().then(function () {
      return _this4.createResult(query, defaultedOptions);
    });
  };

  _proto.fetch = function fetch(fetchOptions) {
    var _this5 = this;

    return this.executeFetch(fetchOptions).then(function () {
      _this5.updateResult();

      return _this5.currentResult;
    });
  };

  _proto.executeFetch = function executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    var promise = this.currentQuery.fetch(this.options, fetchOptions);

    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  };

  _proto.updateStaleTimeout = function updateStaleTimeout() {
    var _this6 = this;

    this.clearStaleTimeout();

    if (utils/* isServer */.sk || this.currentResult.isStale || !(0,utils/* isValidTimeout */.PN)(this.options.staleTime)) {
      return;
    }

    var time = (0,utils/* timeUntilStale */.Kp)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    var timeout = time + 1;
    this.staleTimeoutId = setTimeout(function () {
      if (!_this6.currentResult.isStale) {
        _this6.updateResult();
      }
    }, timeout);
  };

  _proto.computeRefetchInterval = function computeRefetchInterval() {
    var _this$options$refetch;

    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  };

  _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
    var _this7 = this;

    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;

    if (utils/* isServer */.sk || this.options.enabled === false || !(0,utils/* isValidTimeout */.PN)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }

    this.refetchIntervalId = setInterval(function () {
      if (_this7.options.refetchIntervalInBackground || focusManager/* focusManager.isFocused */.j.isFocused()) {
        _this7.executeFetch();
      }
    }, this.currentRefetchInterval);
  };

  _proto.updateTimers = function updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  };

  _proto.clearTimers = function clearTimers() {
    this.clearStaleTimeout();
    this.clearRefetchInterval();
  };

  _proto.clearStaleTimeout = function clearStaleTimeout() {
    clearTimeout(this.staleTimeoutId);
    this.staleTimeoutId = undefined;
  };

  _proto.clearRefetchInterval = function clearRefetchInterval() {
    clearInterval(this.refetchIntervalId);
    this.refetchIntervalId = undefined;
  };

  _proto.createResult = function createResult(query, options) {
    var prevQuery = this.currentQuery;
    var prevOptions = this.options;
    var prevResult = this.currentResult;
    var prevResultState = this.currentResultState;
    var prevResultOptions = this.currentResultOptions;
    var queryChange = query !== prevQuery;
    var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    var state = query.state;
    var dataUpdatedAt = state.dataUpdatedAt,
        error = state.error,
        errorUpdatedAt = state.errorUpdatedAt,
        isFetching = state.isFetching,
        status = state.status;
    var isPreviousData = false;
    var isPlaceholderData = false;
    var data; // Optimistically set result in fetching state if needed

    if (options.optimisticResults) {
      var mounted = this.hasListeners();
      var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);

      if (fetchOnMount || fetchOptionally) {
        isFetching = true;

        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }
    } // Keep previous data if needed


    if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
        var _this$previousSelect;

        // Memoize select result
        if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === ((_this$previousSelect = this.previousSelect) == null ? void 0 : _this$previousSelect.fn) && !this.previousSelectError) {
          data = this.previousSelect.result;
        } else {
          try {
            data = options.select(state.data);

            if (options.structuralSharing !== false) {
              data = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, data);
            }

            this.previousSelect = {
              fn: options.select,
              result: data
            };
            this.previousSelectError = null;
          } catch (selectError) {
            (0,logger/* getLogger */.j)().error(selectError);
            error = selectError;
            this.previousSelectError = selectError;
            errorUpdatedAt = Date.now();
            status = 'error';
          }
        }
      } // Use query data
      else {
          data = state.data;
        } // Show placeholder data if needed


    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
      var placeholderData; // Memoize placeholder data

      if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;

        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);

            if (options.structuralSharing !== false) {
              placeholderData = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, placeholderData);
            }

            this.previousSelectError = null;
          } catch (selectError) {
            (0,logger/* getLogger */.j)().error(selectError);
            error = selectError;
            this.previousSelectError = selectError;
            errorUpdatedAt = Date.now();
            status = 'error';
          }
        }
      }

      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = placeholderData;
        isPlaceholderData = true;
      }
    }

    var result = {
      status: status,
      isLoading: status === 'loading',
      isSuccess: status === 'success',
      isError: status === 'error',
      isIdle: status === 'idle',
      data: data,
      dataUpdatedAt: dataUpdatedAt,
      error: error,
      errorUpdatedAt: errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching: isFetching,
      isRefetching: isFetching && status !== 'loading',
      isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
      isPlaceholderData: isPlaceholderData,
      isPreviousData: isPreviousData,
      isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  };

  _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
    if (!prevResult) {
      return true;
    }

    var _this$options = this.options,
        notifyOnChangeProps = _this$options.notifyOnChangeProps,
        notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;

    if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) {
      return true;
    }

    if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) {
      return true;
    }

    var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
    return Object.keys(result).some(function (key) {
      var typedKey = key;
      var changed = result[typedKey] !== prevResult[typedKey];
      var isIncluded = includedProps == null ? void 0 : includedProps.some(function (x) {
        return x === key;
      });
      var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function (x) {
        return x === key;
      });
      return changed && !isExcluded && (!includedProps || isIncluded);
    });
  };

  _proto.updateResult = function updateResult(notifyOptions) {
    var prevResult = this.currentResult;
    this.currentResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify if something has changed

    if ((0,utils/* shallowEqualObjects */.VS)(this.currentResult, prevResult)) {
      return;
    } // Determine which callbacks to trigger


    var defaultNotifyOptions = {
      cache: true
    };

    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) {
      defaultNotifyOptions.listeners = true;
    }

    this.notify((0,esm_extends/* default */.Z)({}, defaultNotifyOptions, notifyOptions));
  };

  _proto.updateQuery = function updateQuery() {
    var query = this.client.getQueryCache().build(this.client, this.options);

    if (query === this.currentQuery) {
      return;
    }

    var prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;

    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  };

  _proto.onQueryUpdate = function onQueryUpdate(action) {
    var notifyOptions = {};

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error' && !(0,retryer/* isCancelledError */.DV)(action.error)) {
      notifyOptions.onError = true;
    }

    this.updateResult(notifyOptions);

    if (this.hasListeners()) {
      this.updateTimers();
    }
  };

  _proto.notify = function notify(notifyOptions) {
    var _this8 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        _this8.options.onSuccess == null ? void 0 : _this8.options.onSuccess(_this8.currentResult.data);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(_this8.currentResult.data, null);
      } else if (notifyOptions.onError) {
        _this8.options.onError == null ? void 0 : _this8.options.onError(_this8.currentResult.error);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(undefined, _this8.currentResult.error);
      } // Then trigger the listeners


      if (notifyOptions.listeners) {
        _this8.listeners.forEach(function (listener) {
          listener(_this8.currentResult);
        });
      } // Then the cache listeners


      if (notifyOptions.cache) {
        _this8.client.getQueryCache().notify({
          query: _this8.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  };

  return QueryObserver;
}(subscribable/* Subscribable */.l);

function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}

function shouldRefetchOnMount(query, options) {
  return options.enabled !== false && query.state.dataUpdatedAt > 0 && (options.refetchOnMount === 'always' || options.refetchOnMount !== false && isStale(query, options));
}

function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || shouldRefetchOnMount(query, options);
}

function _shouldFetchOnReconnect(query, options) {
  return options.enabled !== false && (options.refetchOnReconnect === 'always' || options.refetchOnReconnect !== false && isStale(query, options));
}

function _shouldFetchOnWindowFocus(query, options) {
  return options.enabled !== false && (options.refetchOnWindowFocus === 'always' || options.refetchOnWindowFocus !== false && isStale(query, options));
}

function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}

function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/react/QueryErrorResetBoundary.js
 // CONTEXT

function createValue() {
  var _isReset = false;
  return {
    clearReset: function clearReset() {
      _isReset = false;
    },
    reset: function reset() {
      _isReset = true;
    },
    isReset: function isReset() {
      return _isReset;
    }
  };
}

var QueryErrorResetBoundaryContext = /*#__PURE__*/react.createContext(createValue()); // HOOK

var useQueryErrorResetBoundary = function useQueryErrorResetBoundary() {
  return react.useContext(QueryErrorResetBoundaryContext);
}; // COMPONENT

var QueryErrorResetBoundary = function QueryErrorResetBoundary(_ref) {
  var children = _ref.children;
  var value = React.useMemo(function () {
    return createValue();
  }, []);
  return /*#__PURE__*/React.createElement(QueryErrorResetBoundaryContext.Provider, {
    value: value
  }, typeof children === 'function' ? children(value) : children);
};
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/react/useBaseQuery.js





function useBaseQuery(options, Observer) {
  var mountedRef = react.useRef(false);

  var _React$useState = react.useState(0),
      forceUpdate = _React$useState[1];

  var queryClient = useQueryClient();
  var errorResetBoundary = useQueryErrorResetBoundary();
  var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions.optimisticResults = true; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSettled);
  }

  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    } // Set cache time to 1 if the option has been set to 0
    // when using suspense to prevent infinite loop of fetches


    if (defaultedOptions.cacheTime === 0) {
      defaultedOptions.cacheTime = 1;
    }
  }

  if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      defaultedOptions.retryOnMount = false;
    }
  }

  var _React$useState2 = react.useState(function () {
    return new Observer(queryClient, defaultedOptions);
  }),
      observer = _React$useState2[0];

  var result = observer.getOptimisticResult(defaultedOptions);
  react.useEffect(function () {
    mountedRef.current = true;
    errorResetBoundary.clearReset();
    var unsubscribe = observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    })); // Update result to make sure we did not miss any query updates
    // between creating the observer and subscribing to it.

    observer.updateResult();
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [errorResetBoundary, observer]);
  react.useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (defaultedOptions.suspense && result.isLoading) {
    throw observer.fetchOptimistic(defaultedOptions).then(function (_ref) {
      var data = _ref.data;
      defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
    }).catch(function (error) {
      errorResetBoundary.clearReset();
      defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
    });
  } // Handle error boundary


  if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && shouldThrowError(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [result.error, observer.getCurrentQuery()])) {
    throw result.error;
  } // Handle result property usage tracking


  if (defaultedOptions.notifyOnChangeProps === 'tracked') {
    result = observer.trackResult(result, defaultedOptions);
  }

  return result;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/react/useQuery.js


 // HOOK

function useQuery(arg1, arg2, arg3) {
  var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(parsedOptions, QueryObserver);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-query@3.34.16_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-query/es/react/index.js
// Side effects










 // Types



/***/ }),

/***/ 72983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cn": function() { return /* binding */ ENTERED; },
  "d0": function() { return /* binding */ ENTERING; },
  "Wj": function() { return /* binding */ EXITED; },
  "Ix": function() { return /* binding */ EXITING; },
  "ZP": function() { return /* binding */ esm_Transition; }
});

// UNUSED EXPORTS: UNMOUNTED

// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(92685);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(54660);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@17.0.2_react@17.0.2/node_modules/react-dom/index.js
var react_dom = __webpack_require__(87995);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-transition-group@4.4.2_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-transition-group@4.4.2_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-transition-group/esm/TransitionGroupContext.js

/* harmony default export */ var TransitionGroupContext = (react.createContext(null));
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-transition-group@4.4.2_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-transition-group/esm/Transition.js








var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);

/***/ }),

/***/ 43409:
/***/ (function(module) {


/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

module.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges)
}

module.exports.array = toposort

function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor
    // Better data structures make algorithm much faster.
    , outgoingEdges = makeOutgoingEdges(edges)
    , nodesHash = makeNodesHash(nodes)

  // check for unknown nodes
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
    }
  })

  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set())
  }

  return sorted

  function visit(node, i, predecessors) {
    if(predecessors.has(node)) {
      var nodeRep
      try {
        nodeRep = ", node was:" + JSON.stringify(node)
      } catch(e) {
        nodeRep = ""
      }
      throw new Error('Cyclic dependency' + nodeRep)
    }

    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
    }

    if (visited[i]) return;
    visited[i] = true

    var outgoing = outgoingEdges.get(node) || new Set()
    outgoing = Array.from(outgoing)

    if (i = outgoing.length) {
      predecessors.add(node)
      do {
        var child = outgoing[--i]
        visit(child, nodesHash.get(child), predecessors)
      } while (i)
      predecessors.delete(node)
    }

    sorted[--cursor] = node
  }
}

function uniqueNodes(arr){
  var res = new Set()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    res.add(edge[0])
    res.add(edge[1])
  }
  return Array.from(res)
}

function makeOutgoingEdges(arr){
  var edges = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    if (!edges.has(edge[0])) edges.set(edge[0], new Set())
    if (!edges.has(edge[1])) edges.set(edge[1], new Set())
    edges.get(edge[0]).add(edge[1])
  }
  return edges
}

function makeNodesHash(arr){
  var res = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i)
  }
  return res
}


/***/ }),

/***/ 65949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "pi": function() { return /* binding */ __assign; },
/* harmony export */   "_T": function() { return /* binding */ __rest; },
/* harmony export */   "XA": function() { return /* binding */ __values; },
/* harmony export */   "CR": function() { return /* binding */ __read; },
/* harmony export */   "fl": function() { return /* binding */ __spread; }
/* harmony export */ });
/* unused harmony exports __decorate, __param, __metadata, __awaiter, __generator, __createBinding, __exportStar, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),

/***/ 22084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ch": function() { return /* reexport */ useUncontrolled; },
  "$c": function() { return /* reexport */ useUncontrolledProp; }
});

// UNUSED EXPORTS: uncontrollable

// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(15517);
// EXTERNAL MODULE: ./node_modules/.pnpm/@babel+runtime@7.17.7/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(92685);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/invariant@2.2.4/node_modules/invariant/browser.js
var browser = __webpack_require__(53670);
;// CONCATENATED MODULE: ./node_modules/.pnpm/uncontrollable@7.2.1_react@17.0.2/node_modules/uncontrollable/lib/esm/utils.js


var noop = function noop() {};

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, displayName) {
  var propTypes = {};
  Object.keys(controlledValues).forEach(function (prop) {
    // add default propTypes for folks that use runtime checks
    propTypes[defaultKey(prop)] = noop;

    if (false) { var handler; }
  });
  return propTypes;
}
function isProp(props, prop) {
  return props[prop] !== undefined;
}
function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

function canAcceptRef(component) {
  return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/uncontrollable@7.2.1_react@17.0.2/node_modules/uncontrollable/lib/esm/hook.js



function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }




function useUncontrolledProp(propValue, defaultValue, handler) {
  var wasPropRef = (0,react.useRef)(propValue !== undefined);

  var _useState = (0,react.useState)(defaultValue),
      stateValue = _useState[0],
      setState = _useState[1];

  var isProp = propValue !== undefined;
  var wasProp = wasPropRef.current;
  wasPropRef.current = isProp;
  /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */

  if (!isProp && wasProp && stateValue !== defaultValue) {
    setState(defaultValue);
  }

  return [isProp ? propValue : stateValue, (0,react.useCallback)(function (value) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (handler) handler.apply(void 0, [value].concat(args));
    setState(value);
  }, [handler])];
}


function useUncontrolled(props, config) {
  return Object.keys(config).reduce(function (result, fieldName) {
    var _extends2;

    var _ref = result,
        defaultValue = _ref[defaultKey(fieldName)],
        propsValue = _ref[fieldName],
        rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, [defaultKey(fieldName), fieldName].map(_toPropertyKey));

    var handlerName = config[fieldName];

    var _useUncontrolledProp = useUncontrolledProp(propsValue, defaultValue, props[handlerName]),
        value = _useUncontrolledProp[0],
        handler = _useUncontrolledProp[1];

    return (0,esm_extends/* default */.Z)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
  }, props);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-lifecycles-compat@3.0.4/node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function react_lifecycles_compat_es_polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}



;// CONCATENATED MODULE: ./node_modules/.pnpm/uncontrollable@7.2.1_react@17.0.2/node_modules/uncontrollable/lib/esm/uncontrollable.js



var _jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";




function uncontrollable(Component, controlledValues, methods) {
  if (methods === void 0) {
    methods = [];
  }

  var displayName = Component.displayName || Component.name || 'Component';
  var canAcceptRef = Utils.canAcceptRef(Component);
  var controlledProps = Object.keys(controlledValues);
  var PROPS_TO_OMIT = controlledProps.map(Utils.defaultKey);
  !(canAcceptRef || !methods.length) ?  false ? 0 : invariant(false) : void 0;

  var UncontrolledComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(UncontrolledComponent, _React$Component);

    function UncontrolledComponent() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.handlers = Object.create(null);
      controlledProps.forEach(function (propName) {
        var handlerName = controlledValues[propName];

        var handleChange = function handleChange(value) {
          if (_this.props[handlerName]) {
            var _this$props;

            _this._notifying = true;

            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (_this$props = _this.props)[handlerName].apply(_this$props, [value].concat(args));

            _this._notifying = false;
          }

          if (!_this.unmounted) _this.setState(function (_ref) {
            var _extends2;

            var values = _ref.values;
            return {
              values: _extends(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
            };
          });
        };

        _this.handlers[handlerName] = handleChange;
      });
      if (methods.length) _this.attachRef = function (ref) {
        _this.inner = ref;
      };
      var values = Object.create(null);
      controlledProps.forEach(function (key) {
        values[key] = _this.props[Utils.defaultKey(key)];
      });
      _this.state = {
        values: values,
        prevProps: {}
      };
      return _this;
    }

    var _proto = UncontrolledComponent.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate() {
      //let setState trigger the update
      return !this._notifying;
    };

    UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
      var values = _ref2.values,
          prevProps = _ref2.prevProps;
      var nextState = {
        values: _extends(Object.create(null), values),
        prevProps: {}
      };
      controlledProps.forEach(function (key) {
        /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */
        nextState.prevProps[key] = props[key];

        if (!Utils.isProp(props, key) && Utils.isProp(prevProps, key)) {
          nextState.values[key] = props[Utils.defaultKey(key)];
        }
      });
      return nextState;
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.unmounted = true;
    };

    _proto.render = function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          innerRef = _this$props2.innerRef,
          props = _objectWithoutPropertiesLoose(_this$props2, ["innerRef"]);

      PROPS_TO_OMIT.forEach(function (prop) {
        delete props[prop];
      });
      var newProps = {};
      controlledProps.forEach(function (propName) {
        var propValue = _this2.props[propName];
        newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
      });
      return React.createElement(Component, _extends({}, props, newProps, this.handlers, {
        ref: innerRef || this.attachRef
      }));
    };

    return UncontrolledComponent;
  }(React.Component);

  polyfill(UncontrolledComponent);
  UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
  UncontrolledComponent.propTypes = _extends({
    innerRef: function innerRef() {}
  }, Utils.uncontrolledPropTypes(controlledValues, displayName));
  methods.forEach(function (method) {
    UncontrolledComponent.prototype[method] = function $proxiedMethod() {
      var _this$inner;

      return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
    };
  });
  var WrappedComponent = UncontrolledComponent;

  if (React.forwardRef) {
    WrappedComponent = React.forwardRef(function (props, ref) {
      return React.createElement(UncontrolledComponent, _extends({}, props, {
        innerRef: ref,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 128
        },
        __self: this
      }));
    });
    WrappedComponent.propTypes = UncontrolledComponent.propTypes;
  }

  WrappedComponent.ControlledComponent = Component;
  /**
   * useful when wrapping a Component and you want to control
   * everything
   */

  WrappedComponent.deferControlTo = function (newComponent, additions, nextMethods) {
    if (additions === void 0) {
      additions = {};
    }

    return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
  };

  return WrappedComponent;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/uncontrollable@7.2.1_react@17.0.2/node_modules/uncontrollable/lib/esm/index.js



/***/ }),

/***/ 91190:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 55423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IX": function() { return /* reexport */ array_create; },
  "Xg": function() { return /* reexport */ boolean_create; },
  "O7": function() { return /* reexport */ boolean_create; },
  "nK": function() { return /* reexport */ mixed_create; },
  "Rx": function() { return /* reexport */ number_create; },
  "Ry": function() { return /* reexport */ object_create; },
  "iH": function() { return /* reexport */ create; },
  "i_": function() { return /* reexport */ setLocale; },
  "Z_": function() { return /* reexport */ string_create; }
});

// UNUSED EXPORTS: ArraySchema, BaseSchema, BooleanSchema, DateSchema, MixedSchema, NumberSchema, ObjectSchema, StringSchema, ValidationError, addMethod, date, isSchema, lazy, reach

;// CONCATENATED MODULE: ./node_modules/.pnpm/nanoclone@0.2.1/node_modules/nanoclone/src/index.js
// ES6 Map
var map
try {
  map = Map
} catch (_) { }
var set

// ES6 Set
try {
  set = Set
} catch (_) { }

function baseClone (src, circulars, clones) {
  // Null/undefined/functions/etc
  if (!src || typeof src !== 'object' || typeof src === 'function') {
    return src
  }

  // DOM Node
  if (src.nodeType && 'cloneNode' in src) {
    return src.cloneNode(true)
  }

  // Date
  if (src instanceof Date) {
    return new Date(src.getTime())
  }

  // RegExp
  if (src instanceof RegExp) {
    return new RegExp(src)
  }

  // Arrays
  if (Array.isArray(src)) {
    return src.map(clone)
  }

  // ES6 Maps
  if (map && src instanceof map) {
    return new Map(Array.from(src.entries()))
  }

  // ES6 Sets
  if (set && src instanceof set) {
    return new Set(Array.from(src.values()))
  }

  // Object
  if (src instanceof Object) {
    circulars.push(src)
    var obj = Object.create(src)
    clones.push(obj)
    for (var key in src) {
      var idx = circulars.findIndex(function (i) {
        return i === src[key]
      })
      obj[key] = idx > -1 ? clones[idx] : baseClone(src[key], circulars, clones)
    }
    return obj
  }

  // ???
  return src
}

function clone (src) {
  return baseClone(src, [], [])
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/util/printValue.js
const printValue_toString = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false) return '' + val;
  const typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  const tag = printValue_toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    let result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/locale.js

let mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    let isCast = originalValue != null && originalValue !== value;
    let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${printValue(value, true)}\`` + (isCast ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : '.');

    if (value === null) {
      msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
    }

    return msg;
  },
  defined: '${path} must be defined'
};
let string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
let number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
let date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
let locale_boolean = {
  isValue: '${path} field must be ${value}'
};
let object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must have ${length} items'
};
/* harmony default export */ var locale = (Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean: locale_boolean
}));
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/has.js
var has = __webpack_require__(56611);
var has_default = /*#__PURE__*/__webpack_require__.n(has);
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/util/isSchema.js
const isSchema_isSchema = obj => obj && obj.__isYupSchema__;

/* harmony default export */ var util_isSchema = (isSchema_isSchema);
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/Condition.js



class Condition {
  constructor(refs, options) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;

    if (typeof options === 'function') {
      this.fn = options;
      return;
    }

    if (!has_default()(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
    if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    let {
      is,
      then,
      otherwise
    } = options;
    let check = typeof is === 'function' ? is : (...values) => values.every(value => value === is);

    this.fn = function (...args) {
      let options = args.pop();
      let schema = args.pop();
      let branch = check(...args) ? then : otherwise;
      if (!branch) return undefined;
      if (typeof branch === 'function') return branch(schema);
      return schema.concat(branch.resolve(options));
    };
  }

  resolve(base, options) {
    let values = this.refs.map(ref => ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn.apply(base, values.concat(base, options));
    if (schema === undefined || schema === base) return base;
    if (!util_isSchema(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  }

}

/* harmony default export */ var es_Condition = (Condition);
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/util/toArray.js
function toArray(value) {
  return value == null ? [] : [].concat(value);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/ValidationError.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



let strReg = /\$\{\s*(\w+)\s*\}/g;
class ValidationError extends Error {
  static formatError(message, params) {
    const path = params.label || params.path || 'this';
    if (path !== params.path) params = _extends({}, params, {
      path
    });
    if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === 'function') return message(params);
    return message;
  }

  static isError(err) {
    return err && err.name === 'ValidationError';
  }

  constructor(errorOrErrors, value, field, type) {
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.errors = void 0;
    this.params = void 0;
    this.inner = void 0;
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach(err => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        this.inner = this.inner.concat(err.inner.length ? err.inner : err);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
  }

}
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/util/runTests.js


const once = cb => {
  let fired = false;
  return (...args) => {
    if (fired) return;
    fired = true;
    cb(...args);
  };
};

function runTests(options, cb) {
  let {
    endEarly,
    tests,
    args,
    value,
    errors,
    sort,
    path
  } = options;
  let callback = once(cb);
  let count = tests.length;
  const nestedErrors = [];
  errors = errors ? errors : [];
  if (!count) return errors.length ? callback(new ValidationError(errors, value, path)) : callback(null, value);

  for (let i = 0; i < tests.length; i++) {
    const test = tests[i];
    test(args, function finishTestRun(err) {
      if (err) {
        // always return early for non validation errors
        if (!ValidationError.isError(err)) {
          return callback(err, value);
        }

        if (endEarly) {
          err.value = value;
          return callback(err, value);
        }

        nestedErrors.push(err);
      }

      if (--count <= 0) {
        if (nestedErrors.length) {
          if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

          if (errors.length) nestedErrors.push(...errors);
          errors = nestedErrors;
        }

        if (errors.length) {
          callback(new ValidationError(errors, value, path), value);
          return;
        }

        callback(null, value);
      }
    });
  }
}
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/mapValues.js
var mapValues = __webpack_require__(65632);
var mapValues_default = /*#__PURE__*/__webpack_require__.n(mapValues);
// EXTERNAL MODULE: ./node_modules/.pnpm/property-expr@2.0.5/node_modules/property-expr/index.js
var property_expr = __webpack_require__(36584);
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/Reference.js

const prefixes = {
  context: '$',
  value: '.'
};
function create(key, options) {
  return new Reference(key, options);
}
class Reference {
  constructor(key, options = {}) {
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && (0,property_expr.getter)(this.path, true);
    this.map = options.map;
  }

  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */


  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }

  resolve() {
    return this;
  }

  describe() {
    return {
      type: 'ref',
      key: this.key
    };
  }

  toString() {
    return `Ref(${this.key})`;
  }

  static isRef(value) {
    return value && value.__isYupRef;
  }

} // @ts-ignore

Reference.prototype.__isYupRef = true;
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/util/createValidation.js
function createValidation_extends() { createValidation_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return createValidation_extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function createValidation(config) {
  function validate(_ref, cb) {
    let {
      value,
      path = '',
      label,
      options,
      originalValue,
      sync
    } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, ["value", "path", "label", "options", "originalValue", "sync"]);

    const {
      name,
      test,
      params,
      message
    } = config;
    let {
      parent,
      context
    } = options;

    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }

    function createError(overrides = {}) {
      const nextParams = mapValues_default()(createValidation_extends({
        value,
        originalValue,
        label,
        path: overrides.path || path
      }, params, overrides.params), resolve);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
      error.params = nextParams;
      return error;
    }

    let ctx = createValidation_extends({
      path,
      parent,
      type: name,
      createError,
      resolve,
      options,
      originalValue
    }, rest);

    if (!sync) {
      try {
        Promise.resolve(test.call(ctx, value, ctx)).then(validOrError => {
          if (ValidationError.isError(validOrError)) cb(validOrError);else if (!validOrError) cb(createError());else cb(null, validOrError);
        }).catch(cb);
      } catch (err) {
        cb(err);
      }

      return;
    }

    let result;

    try {
      var _ref2;

      result = test.call(ctx, value, ctx);

      if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') {
        throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
      }
    } catch (err) {
      cb(err);
      return;
    }

    if (ValidationError.isError(result)) cb(result);else if (!result) cb(createError());else cb(null, result);
  }

  validate.OPTIONS = config;
  return validate;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/util/reach.js


let trim = part => part.substr(0, part.length - 1).substr(1);

function getIn(schema, path, value, context = value) {
  let parent, lastPart, lastPartDebug; // root path: ''

  if (!path) return {
    parent,
    parentPath: path,
    schema
  };
  (0,property_expr.forEach)(path, (_part, isBracket, isArray) => {
    let part = isBracket ? trim(_part) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });

    if (schema.innerType) {
      let idx = isArray ? parseInt(part, 10) : 0;

      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
      }

      parent = value;
      value = value && value[idx];
      schema = schema.innerType;
    } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal


    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }

    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}

const reach = (obj, path, value, context) => getIn(obj, path, value, context).schema;

/* harmony default export */ var util_reach = ((/* unused pure expression or super */ null && (reach)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/util/ReferenceSet.js

class ReferenceSet {
  constructor() {
    this.list = void 0;
    this.refs = void 0;
    this.list = new Set();
    this.refs = new Map();
  }

  get size() {
    return this.list.size + this.refs.size;
  }

  describe() {
    const description = [];

    for (const item of this.list) description.push(item);

    for (const [, ref] of this.refs) description.push(ref.describe());

    return description;
  }

  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }

  resolveAll(resolve) {
    return this.toArray().reduce((acc, e) => acc.concat(Reference.isRef(e) ? resolve(e) : e), []);
  }

  add(value) {
    Reference.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  }

  delete(value) {
    Reference.isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
  }

  clone() {
    const next = new ReferenceSet();
    next.list = new Set(this.list);
    next.refs = new Map(this.refs);
    return next;
  }

  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.list.forEach(value => next.add(value));
    newItems.refs.forEach(value => next.add(value));
    removeItems.list.forEach(value => next.delete(value));
    removeItems.refs.forEach(value => next.delete(value));
    return next;
  }

}
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/schema.js
function schema_extends() { schema_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return schema_extends.apply(this, arguments); }

// @ts-ignore










 // const UNSET = 'unset' as const;

class BaseSchema {
  constructor(options) {
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this._typeError = void 0;
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = (options == null ? void 0 : options.type) || 'mixed';
    this.spec = schema_extends({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      nullable: false,
      presence: 'optional'
    }, options == null ? void 0 : options.spec);
  } // TODO: remove


  get _type() {
    return this.type;
  }

  _typeCheck(_value) {
    return true;
  }

  clone(spec) {
    if (this._mutate) {
      if (spec) Object.assign(this.spec, spec);
      return this;
    } // if the nested value is a schema we can skip cloning, since
    // they are already immutable


    const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly

    next.type = this.type;
    next._typeError = this._typeError;
    next._whitelistError = this._whitelistError;
    next._blacklistError = this._blacklistError;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.exclusiveTests = schema_extends({}, this.exclusiveTests); // @ts-expect-error this is readonly

    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone(schema_extends({}, this.spec, spec));
    return next;
  }

  label(label) {
    let next = this.clone();
    next.spec.label = label;
    return next;
  }

  meta(...args) {
    if (args.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  } // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }


  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }

  concat(schema) {
    if (!schema || schema === this) return this;
    if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();

    const mergedSpec = schema_extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
    //   mergedSpec.nullable = base.spec.nullable;
    // if (combined.spec.presence === UNSET)
    //   mergedSpec.presence = base.spec.presence;


    combined.spec = mergedSpec;
    combined._typeError || (combined._typeError = base._typeError);
    combined._whitelistError || (combined._whitelistError = base._whitelistError);
    combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)

    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests

    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
    // the deduping logic is consistent

    combined.withMutation(next => {
      schema.tests.forEach(fn => {
        next.test(fn.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }

  isType(v) {
    if (this.spec.nullable && v === null) return true;
    return this._typeCheck(v);
  }

  resolve(options) {
    let schema = this;

    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((schema, condition) => condition.resolve(schema, options), schema);
      schema = schema.resolve(options);
    }

    return schema;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */


  cast(value, options = {}) {
    let resolvedSchema = this.resolve(schema_extends({
      value
    }, options));

    let result = resolvedSchema._cast(value, options);

    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
    }

    return result;
  }

  _cast(rawValue, _options) {
    let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn) => fn.call(this, value, rawValue, this), rawValue);

    if (value === undefined) {
      value = this.getDefault();
    }

    return value;
  }

  _validate(_value, options = {}, cb) {
    let {
      sync,
      path,
      from = [],
      originalValue = _value,
      strict = this.spec.strict,
      abortEarly = this.spec.abortEarly
    } = options;
    let value = _value;

    if (!strict) {
      // this._validating = true;
      value = this._cast(value, schema_extends({
        assert: false
      }, options)); // this._validating = false;
    } // value is cast, we can check if it meets type requirements


    let args = {
      value,
      path,
      options,
      originalValue,
      schema: this,
      label: this.spec.label,
      sync,
      from
    };
    let initialTests = [];
    if (this._typeError) initialTests.push(this._typeError);
    let finalTests = [];
    if (this._whitelistError) finalTests.push(this._whitelistError);
    if (this._blacklistError) finalTests.push(this._blacklistError);
    runTests({
      args,
      value,
      path,
      sync,
      tests: initialTests,
      endEarly: abortEarly
    }, err => {
      if (err) return void cb(err, value);
      runTests({
        tests: this.tests.concat(finalTests),
        args,
        path,
        sync,
        value,
        endEarly: abortEarly
      }, cb);
    });
  }

  validate(value, options, maybeCb) {
    let schema = this.resolve(schema_extends({}, options, {
      value
    })); // callback case is for nested validations

    return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject) => schema._validate(value, options, (err, value) => {
      if (err) reject(err);else resolve(value);
    }));
  }

  validateSync(value, options) {
    let schema = this.resolve(schema_extends({}, options, {
      value
    }));
    let result;

    schema._validate(value, schema_extends({}, options, {
      sync: true
    }), (err, value) => {
      if (err) throw err;
      result = value;
    });

    return result;
  }

  isValid(value, options) {
    return this.validate(value, options).then(() => true, err => {
      if (ValidationError.isError(err)) return false;
      throw err;
    });
  }

  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err)) return false;
      throw err;
    }
  }

  _getDefault() {
    let defaultValue = this.spec.default;

    if (defaultValue == null) {
      return defaultValue;
    }

    return typeof defaultValue === 'function' ? defaultValue.call(this) : clone(defaultValue);
  }

  getDefault(options) {
    let schema = this.resolve(options || {});
    return schema._getDefault();
  }

  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }

    let next = this.clone({
      default: def
    });
    return next;
  }

  strict(isStrict = true) {
    let next = this.clone();
    next.spec.strict = isStrict;
    return next;
  }

  _isPresent(value) {
    return value != null;
  }

  defined(message = mixed.defined) {
    return this.test({
      message,
      name: 'defined',
      exclusive: true,

      test(value) {
        return value !== undefined;
      }

    });
  }

  required(message = mixed.required) {
    return this.clone({
      presence: 'required'
    }).withMutation(s => s.test({
      message,
      name: 'required',
      exclusive: true,

      test(value) {
        return this.schema._isPresent(value);
      }

    }));
  }

  notRequired() {
    let next = this.clone({
      presence: 'optional'
    });
    next.tests = next.tests.filter(test => test.OPTIONS.name !== 'required');
    return next;
  }

  nullable(isNullable = true) {
    let next = this.clone({
      nullable: isNullable !== false
    });
    return next;
  }

  transform(fn) {
    let next = this.clone();
    next.transforms.push(fn);
    return next;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */


  test(...args) {
    let opts;

    if (args.length === 1) {
      if (typeof args[0] === 'function') {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }

    if (opts.message === undefined) opts.message = mixed["default"];
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;

    if (opts.exclusive) {
      if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }

    if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(fn => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }

      return true;
    });
    next.tests.push(validate);
    return next;
  }

  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== 'string') {
      options = keys;
      keys = '.';
    }

    let next = this.clone();
    let deps = toArray(keys).map(key => new Reference(key));
    deps.forEach(dep => {
      // @ts-ignore
      if (dep.isSibling) next.deps.push(dep.key);
    });
    next.conditions.push(new es_Condition(deps, options));
    return next;
  }

  typeError(message) {
    let next = this.clone();
    next._typeError = createValidation({
      message,
      name: 'typeError',

      test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }

    });
    return next;
  }

  oneOf(enums, message = mixed.oneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._whitelist.add(val);

      next._blacklist.delete(val);
    });
    next._whitelistError = createValidation({
      message,
      name: 'oneOf',

      test(value) {
        if (value === undefined) return true;
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: valids.toArray().join(', '),
            resolved
          }
        });
      }

    });
    return next;
  }

  notOneOf(enums, message = mixed.notOneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._blacklist.add(val);

      next._whitelist.delete(val);
    });
    next._blacklistError = createValidation({
      message,
      name: 'notOneOf',

      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value)) return this.createError({
          params: {
            values: invalids.toArray().join(', '),
            resolved
          }
        });
        return true;
      }

    });
    return next;
  }

  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }

  describe() {
    const next = this.clone();
    const {
      label,
      meta
    } = next.spec;
    const description = {
      meta,
      label,
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map(fn => ({
        name: fn.OPTIONS.name,
        params: fn.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex(c => c.name === n.name) === idx)
    };
    return description;
  }

} // eslint-disable-next-line @typescript-eslint/no-unused-vars

// @ts-expect-error
BaseSchema.prototype.__isYupSchema__ = true;

for (const method of ['validate', 'validateSync']) BaseSchema.prototype[`${method}At`] = function (path, value, options = {}) {
  const {
    parent,
    parentPath,
    schema
  } = getIn(this, path, value, options.context);
  return schema[method](parent && parent[parentPath], schema_extends({}, options, {
    parent,
    path
  }));
};

for (const alias of ['equals', 'is']) BaseSchema.prototype[alias] = BaseSchema.prototype.oneOf;

for (const alias of ['not', 'nope']) BaseSchema.prototype[alias] = BaseSchema.prototype.notOneOf;

BaseSchema.prototype.optional = BaseSchema.prototype.notRequired;
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/mixed.js

const Mixed = BaseSchema;
/* harmony default export */ var es_mixed = ((/* unused pure expression or super */ null && (Mixed)));
function mixed_create() {
  return new Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class

mixed_create.prototype = Mixed.prototype;
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/util/isAbsent.js
const isAbsent = value => value == null;

/* harmony default export */ var util_isAbsent = (isAbsent);
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/boolean.js



function boolean_create() {
  return new BooleanSchema();
}
class BooleanSchema extends BaseSchema {
  constructor() {
    super({
      type: 'boolean'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (!this.isType(value)) {
          if (/^(true|1)$/i.test(String(value))) return true;
          if (/^(false|0)$/i.test(String(value))) return false;
        }

        return value;
      });
    });
  }

  _typeCheck(v) {
    if (v instanceof Boolean) v = v.valueOf();
    return typeof v === 'boolean';
  }

  isTrue(message = locale_boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'true'
      },

      test(value) {
        return util_isAbsent(value) || value === true;
      }

    });
  }

  isFalse(message = locale_boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'false'
      },

      test(value) {
        return util_isAbsent(value) || value === false;
      }

    });
  }

}
boolean_create.prototype = BooleanSchema.prototype;
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/string.js


 // eslint-disable-next-line

let rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

let rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line

let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

let isTrimmed = value => util_isAbsent(value) || value === value.trim();

let objStringTag = {}.toString();
function string_create() {
  return new StringSchema();
}
class StringSchema extends BaseSchema {
  constructor() {
    super({
      type: 'string'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        if (Array.isArray(value)) return value;
        const strValue = value != null && value.toString ? value.toString() : value;
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
  }

  _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();
    return typeof value === 'string';
  }

  _isPresent(value) {
    return super._isPresent(value) && !!value.length;
  }

  length(length, message = string.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },

      test(value) {
        return util_isAbsent(value) || value.length === this.resolve(length);
      }

    });
  }

  min(min, message = string.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return util_isAbsent(value) || value.length >= this.resolve(min);
      }

    });
  }

  max(max, message = string.max) {
    return this.test({
      name: 'max',
      exclusive: true,
      message,
      params: {
        max
      },

      test(value) {
        return util_isAbsent(value) || value.length <= this.resolve(max);
      }

    });
  }

  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name;

    if (options) {
      if (typeof options === 'object') {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options);
      } else {
        message = options;
      }
    }

    return this.test({
      name: name || 'matches',
      message: message || string.matches,
      params: {
        regex
      },
      test: value => util_isAbsent(value) || value === '' && excludeEmptyString || value.search(regex) !== -1
    });
  }

  email(message = string.email) {
    return this.matches(rEmail, {
      name: 'email',
      message,
      excludeEmptyString: true
    });
  }

  url(message = string.url) {
    return this.matches(rUrl, {
      name: 'url',
      message,
      excludeEmptyString: true
    });
  }

  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: 'uuid',
      message,
      excludeEmptyString: false
    });
  } //-- transforms --


  ensure() {
    return this.default('').transform(val => val === null ? '' : val);
  }

  trim(message = string.trim) {
    return this.transform(val => val != null ? val.trim() : val).test({
      message,
      name: 'trim',
      test: isTrimmed
    });
  }

  lowercase(message = string.lowercase) {
    return this.transform(value => !util_isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => util_isAbsent(value) || value === value.toLowerCase()
    });
  }

  uppercase(message = string.uppercase) {
    return this.transform(value => !util_isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => util_isAbsent(value) || value === value.toUpperCase()
    });
  }

}
string_create.prototype = StringSchema.prototype; //
// String Interfaces
//
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/number.js




let number_isNaN = value => value != +value;

function number_create() {
  return new NumberSchema();
}
class NumberSchema extends BaseSchema {
  constructor() {
    super({
      type: 'number'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        let parsed = value;

        if (typeof parsed === 'string') {
          parsed = parsed.replace(/\s/g, '');
          if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings

          parsed = +parsed;
        }

        if (this.isType(parsed)) return parsed;
        return parseFloat(parsed);
      });
    });
  }

  _typeCheck(value) {
    if (value instanceof Number) value = value.valueOf();
    return typeof value === 'number' && !number_isNaN(value);
  }

  min(min, message = number.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return util_isAbsent(value) || value >= this.resolve(min);
      }

    });
  }

  max(max, message = number.max) {
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },

      test(value) {
        return util_isAbsent(value) || value <= this.resolve(max);
      }

    });
  }

  lessThan(less, message = number.lessThan) {
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        less
      },

      test(value) {
        return util_isAbsent(value) || value < this.resolve(less);
      }

    });
  }

  moreThan(more, message = number.moreThan) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        more
      },

      test(value) {
        return util_isAbsent(value) || value > this.resolve(more);
      }

    });
  }

  positive(msg = number.positive) {
    return this.moreThan(0, msg);
  }

  negative(msg = number.negative) {
    return this.lessThan(0, msg);
  }

  integer(message = number.integer) {
    return this.test({
      name: 'integer',
      message,
      test: val => util_isAbsent(val) || Number.isInteger(val)
    });
  }

  truncate() {
    return this.transform(value => !util_isAbsent(value) ? value | 0 : value);
  }

  round(method) {
    var _method;

    let avail = ['ceil', 'floor', 'round', 'trunc'];
    method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round'; // this exists for symemtry with the new Math.trunc

    if (method === 'trunc') return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
    return this.transform(value => !util_isAbsent(value) ? Math[method](value) : value);
  }

}
number_create.prototype = NumberSchema.prototype; //
// Number Interfaces
//
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/util/isodate.js
/* eslint-disable */

/**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */
//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
      minutesOffset = 0,
      timestamp,
      struct;

  if (struct = isoReg.exec(date)) {
    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
    for (var i = 0, k; k = numericKeys[i]; ++i) struct[k] = +struct[k] || 0; // allow undefined days and months


    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds

    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time

    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
      if (struct[8] !== 'Z' && struct[9] !== undefined) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
      }

      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else timestamp = Date.parse ? Date.parse(date) : NaN;

  return timestamp;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/date.js
// @ts-ignore





let invalidDate = new Date('');

let isDate = obj => Object.prototype.toString.call(obj) === '[object Date]';

function date_create() {
  return new DateSchema();
}
class DateSchema extends BaseSchema {
  constructor() {
    super({
      type: 'date'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        value = parseIsoDate(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.

        return !isNaN(value) ? new Date(value) : invalidDate;
      });
    });
  }

  _typeCheck(v) {
    return isDate(v) && !isNaN(v.getTime());
  }

  prepareParam(ref, name) {
    let param;

    if (!Reference.isRef(ref)) {
      let cast = this.cast(ref);
      if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
      param = cast;
    } else {
      param = ref;
    }

    return param;
  }

  min(min, message = date.min) {
    let limit = this.prepareParam(min, 'min');
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return util_isAbsent(value) || value >= this.resolve(limit);
      }

    });
  }

  max(max, message = date.max) {
    let limit = this.prepareParam(max, 'max');
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },

      test(value) {
        return util_isAbsent(value) || value <= this.resolve(limit);
      }

    });
  }

}
DateSchema.INVALID_DATE = invalidDate;
date_create.prototype = DateSchema.prototype;
date_create.INVALID_DATE = invalidDate;
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/snakeCase.js
var snakeCase = __webpack_require__(69113);
var snakeCase_default = /*#__PURE__*/__webpack_require__.n(snakeCase);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/camelCase.js
var camelCase = __webpack_require__(47638);
var camelCase_default = /*#__PURE__*/__webpack_require__.n(camelCase);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/mapKeys.js
var mapKeys = __webpack_require__(48347);
var mapKeys_default = /*#__PURE__*/__webpack_require__.n(mapKeys);
// EXTERNAL MODULE: ./node_modules/.pnpm/toposort@2.0.2/node_modules/toposort/index.js
var toposort = __webpack_require__(43409);
var toposort_default = /*#__PURE__*/__webpack_require__.n(toposort);
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/util/sortFields.js
 // @ts-expect-error





function sortFields(fields, excludedEdges = []) {
  let edges = [];
  let nodes = new Set();
  let excludes = new Set(excludedEdges.map(([a, b]) => `${a}-${b}`));

  function addNode(depPath, key) {
    let node = (0,property_expr.split)(depPath)[0];
    nodes.add(node);
    if (!excludes.has(`${key}-${node}`)) edges.push([key, node]);
  }

  for (const key in fields) if (has_default()(fields, key)) {
    let value = fields[key];
    nodes.add(key);
    if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (util_isSchema(value) && 'deps' in value) value.deps.forEach(path => addNode(path, key));
  }

  return toposort_default().array(Array.from(nodes), edges).reverse();
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/util/sortByKeyOrder.js
function findIndex(arr, err) {
  let idx = Infinity;
  arr.some((key, ii) => {
    var _err$path;

    if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
      idx = ii;
      return true;
    }
  });
  return idx;
}

function sortByKeyOrder(keys) {
  return (a, b) => {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/object.js
function object_extends() { object_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return object_extends.apply(this, arguments); }














let isObject = obj => Object.prototype.toString.call(obj) === '[object Object]';

function unknown(ctx, value) {
  let known = Object.keys(ctx.fields);
  return Object.keys(value).filter(key => known.indexOf(key) === -1);
}

const defaultSort = sortByKeyOrder([]);
class ObjectSchema extends BaseSchema {
  constructor(spec) {
    super({
      type: 'object'
    });
    this.fields = Object.create(null);
    this._sortErrors = defaultSort;
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(() => {
      this.transform(function coerce(value) {
        if (typeof value === 'string') {
          try {
            value = JSON.parse(value);
          } catch (err) {
            value = null;
          }
        }

        if (this.isType(value)) return value;
        return null;
      });

      if (spec) {
        this.shape(spec);
      }
    });
  }

  _typeCheck(value) {
    return isObject(value) || typeof value === 'function';
  }

  _cast(_value, options = {}) {
    var _options$stripUnknown;

    let value = super._cast(_value, options); //should ignore nulls here


    if (value === undefined) return this.getDefault();
    if (!this._typeCheck(value)) return value;
    let fields = this.fields;
    let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;

    let props = this._nodes.concat(Object.keys(value).filter(v => this._nodes.indexOf(v) === -1));

    let intermediateValue = {}; // is filled during the transform below

    let innerOptions = object_extends({}, options, {
      parent: intermediateValue,
      __validating: options.__validating || false
    });

    let isChanged = false;

    for (const prop of props) {
      let field = fields[prop];
      let exists = has_default()(value, prop);

      if (field) {
        let fieldValue;
        let inputValue = value[prop]; // safe to mutate since this is fired in sequence

        innerOptions.path = (options.path ? `${options.path}.` : '') + prop; // innerOptions.value = value[prop];

        field = field.resolve({
          value: inputValue,
          context: options.context,
          parent: intermediateValue
        });
        let fieldSpec = 'spec' in field ? field.spec : undefined;
        let strict = fieldSpec == null ? void 0 : fieldSpec.strict;

        if (fieldSpec == null ? void 0 : fieldSpec.strip) {
          isChanged = isChanged || prop in value;
          continue;
        }

        fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
        field.cast(value[prop], innerOptions) : value[prop];

        if (fieldValue !== undefined) {
          intermediateValue[prop] = fieldValue;
        }
      } else if (exists && !strip) {
        intermediateValue[prop] = value[prop];
      }

      if (intermediateValue[prop] !== value[prop]) {
        isChanged = true;
      }
    }

    return isChanged ? intermediateValue : value;
  }

  _validate(_value, opts = {}, callback) {
    let errors = [];
    let {
      sync,
      from = [],
      originalValue = _value,
      abortEarly = this.spec.abortEarly,
      recursive = this.spec.recursive
    } = opts;
    from = [{
      schema: this,
      value: originalValue
    }, ...from]; // this flag is needed for handling `strict` correctly in the context of
    // validation vs just casting. e.g strict() on a field is only used when validating

    opts.__validating = true;
    opts.originalValue = originalValue;
    opts.from = from;

    super._validate(_value, opts, (err, value) => {
      if (err) {
        if (!ValidationError.isError(err) || abortEarly) {
          return void callback(err, value);
        }

        errors.push(err);
      }

      if (!recursive || !isObject(value)) {
        callback(errors[0] || null, value);
        return;
      }

      originalValue = originalValue || value;

      let tests = this._nodes.map(key => (_, cb) => {
        let path = key.indexOf('.') === -1 ? (opts.path ? `${opts.path}.` : '') + key : `${opts.path || ''}["${key}"]`;
        let field = this.fields[key];

        if (field && 'validate' in field) {
          field.validate(value[key], object_extends({}, opts, {
            // @ts-ignore
            path,
            from,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: true,
            parent: value,
            originalValue: originalValue[key]
          }), cb);
          return;
        }

        cb(null);
      });

      runTests({
        sync,
        tests,
        value,
        errors,
        endEarly: abortEarly,
        sort: this._sortErrors,
        path: opts.path
      }, callback);
    });
  }

  clone(spec) {
    const next = super.clone(spec);
    next.fields = object_extends({}, this.fields);
    next._nodes = this._nodes;
    next._excludedEdges = this._excludedEdges;
    next._sortErrors = this._sortErrors;
    return next;
  }

  concat(schema) {
    let next = super.concat(schema);
    let nextFields = next.fields;

    for (let [field, schemaOrRef] of Object.entries(this.fields)) {
      const target = nextFields[field];

      if (target === undefined) {
        nextFields[field] = schemaOrRef;
      } else if (target instanceof BaseSchema && schemaOrRef instanceof BaseSchema) {
        nextFields[field] = schemaOrRef.concat(target);
      }
    }

    return next.withMutation(() => next.shape(nextFields, this._excludedEdges));
  }

  getDefaultFromShape() {
    let dft = {};

    this._nodes.forEach(key => {
      const field = this.fields[key];
      dft[key] = 'default' in field ? field.getDefault() : undefined;
    });

    return dft;
  }

  _getDefault() {
    if ('default' in this.spec) {
      return super._getDefault();
    } // if there is no default set invent one


    if (!this._nodes.length) {
      return undefined;
    }

    return this.getDefaultFromShape();
  }

  shape(additions, excludes = []) {
    let next = this.clone();
    let fields = Object.assign(next.fields, additions);
    next.fields = fields;
    next._sortErrors = sortByKeyOrder(Object.keys(fields));

    if (excludes.length) {
      // this is a convenience for when users only supply a single pair
      if (!Array.isArray(excludes[0])) excludes = [excludes];
      next._excludedEdges = [...next._excludedEdges, ...excludes];
    }

    next._nodes = sortFields(fields, next._excludedEdges);
    return next;
  }

  pick(keys) {
    const picked = {};

    for (const key of keys) {
      if (this.fields[key]) picked[key] = this.fields[key];
    }

    return this.clone().withMutation(next => {
      next.fields = {};
      return next.shape(picked);
    });
  }

  omit(keys) {
    const next = this.clone();
    const fields = next.fields;
    next.fields = {};

    for (const key of keys) {
      delete fields[key];
    }

    return next.withMutation(() => next.shape(fields));
  }

  from(from, to, alias) {
    let fromGetter = (0,property_expr.getter)(from, true);
    return this.transform(obj => {
      if (obj == null) return obj;
      let newObj = obj;

      if (has_default()(obj, from)) {
        newObj = object_extends({}, obj);
        if (!alias) delete newObj[from];
        newObj[to] = fromGetter(obj);
      }

      return newObj;
    });
  }

  noUnknown(noAllow = true, message = object.noUnknown) {
    if (typeof noAllow === 'string') {
      message = noAllow;
      noAllow = true;
    }

    let next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,

      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(', ')
          }
        });
      }

    });
    next.spec.noUnknown = noAllow;
    return next;
  }

  unknown(allow = true, message = object.noUnknown) {
    return this.noUnknown(!allow, message);
  }

  transformKeys(fn) {
    return this.transform(obj => obj && mapKeys_default()(obj, (_, key) => fn(key)));
  }

  camelCase() {
    return this.transformKeys((camelCase_default()));
  }

  snakeCase() {
    return this.transformKeys((snakeCase_default()));
  }

  constantCase() {
    return this.transformKeys(key => snakeCase_default()(key).toUpperCase());
  }

  describe() {
    let base = super.describe();
    base.fields = mapValues_default()(this.fields, value => value.describe());
    return base;
  }

}
function object_create(spec) {
  return new ObjectSchema(spec);
}
object_create.prototype = ObjectSchema.prototype;
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/array.js
function array_extends() { array_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return array_extends.apply(this, arguments); }








function array_create(type) {
  return new ArraySchema(type);
}
class ArraySchema extends BaseSchema {
  constructor(type) {
    super({
      type: 'array'
    }); // `undefined` specifically means uninitialized, as opposed to
    // "no subtype"

    this.innerType = void 0;
    this.innerType = type;
    this.withMutation(() => {
      this.transform(function (values) {
        if (typeof values === 'string') try {
          values = JSON.parse(values);
        } catch (err) {
          values = null;
        }
        return this.isType(values) ? values : null;
      });
    });
  }

  _typeCheck(v) {
    return Array.isArray(v);
  }

  get _subType() {
    return this.innerType;
  }

  _cast(_value, _opts) {
    const value = super._cast(_value, _opts); //should ignore nulls here


    if (!this._typeCheck(value) || !this.innerType) return value;
    let isChanged = false;
    const castArray = value.map((v, idx) => {
      const castElement = this.innerType.cast(v, array_extends({}, _opts, {
        path: `${_opts.path || ''}[${idx}]`
      }));

      if (castElement !== v) {
        isChanged = true;
      }

      return castElement;
    });
    return isChanged ? castArray : value;
  }

  _validate(_value, options = {}, callback) {
    var _options$abortEarly, _options$recursive;

    let errors = [];
    let sync = options.sync;
    let path = options.path;
    let innerType = this.innerType;
    let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
    let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
    let originalValue = options.originalValue != null ? options.originalValue : _value;

    super._validate(_value, options, (err, value) => {
      if (err) {
        if (!ValidationError.isError(err) || endEarly) {
          return void callback(err, value);
        }

        errors.push(err);
      }

      if (!recursive || !innerType || !this._typeCheck(value)) {
        callback(errors[0] || null, value);
        return;
      }

      originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated

      let tests = new Array(value.length);

      for (let idx = 0; idx < value.length; idx++) {
        let item = value[idx];
        let path = `${options.path || ''}[${idx}]`; // object._validate note for isStrict explanation

        let innerOptions = array_extends({}, options, {
          path,
          strict: true,
          parent: value,
          index: idx,
          originalValue: originalValue[idx]
        });

        tests[idx] = (_, cb) => innerType.validate(item, innerOptions, cb);
      }

      runTests({
        sync,
        path,
        value,
        errors,
        endEarly,
        tests
      }, callback);
    });
  }

  clone(spec) {
    const next = super.clone(spec);
    next.innerType = this.innerType;
    return next;
  }

  concat(schema) {
    let next = super.concat(schema);
    next.innerType = this.innerType;
    if (schema.innerType) next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat()
    next.innerType.concat(schema.innerType) : schema.innerType;
    return next;
  }

  of(schema) {
    // FIXME: this should return a new instance of array without the default to be
    let next = this.clone();
    if (!util_isSchema(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + printValue(schema)); // FIXME(ts):

    next.innerType = schema;
    return next;
  }

  length(length, message = array.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },

      test(value) {
        return util_isAbsent(value) || value.length === this.resolve(length);
      }

    });
  }

  min(min, message) {
    message = message || array.min;
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      // FIXME(ts): Array<typeof T>
      test(value) {
        return util_isAbsent(value) || value.length >= this.resolve(min);
      }

    });
  }

  max(max, message) {
    message = message || array.max;
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },

      test(value) {
        return util_isAbsent(value) || value.length <= this.resolve(max);
      }

    });
  }

  ensure() {
    return this.default(() => []).transform((val, original) => {
      // We don't want to return `null` for nullable schema
      if (this._typeCheck(val)) return val;
      return original == null ? [] : [].concat(original);
    });
  }

  compact(rejector) {
    let reject = !rejector ? v => !!v : (v, i, a) => !rejector(v, i, a);
    return this.transform(values => values != null ? values.filter(reject) : values);
  }

  describe() {
    let base = super.describe();
    if (this.innerType) base.innerType = this.innerType.describe();
    return base;
  }

  nullable(isNullable = true) {
    return super.nullable(isNullable);
  }

  defined() {
    return super.defined();
  }

  required(msg) {
    return super.required(msg);
  }

}
array_create.prototype = ArraySchema.prototype; //
// Interfaces
//
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/setLocale.js

function setLocale(custom) {
  Object.keys(custom).forEach(type => {
    // @ts-ignore
    Object.keys(custom[type]).forEach(method => {
      // @ts-ignore
      locale[type][method] = custom[type][method];
    });
  });
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js















function addMethod(schemaType, name, fn) {
  if (!schemaType || !isSchema(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
  if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
  if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
  schemaType.prototype[name] = fn;
}




/***/ }),

/***/ 69690:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 15517:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 54660:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7688);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 92685:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),

/***/ 7688:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 62058:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$6P": function() { return /* reexport */ es_all; },
  "xHg": function() { return /* reexport */ es_flatten; },
  "vMG": function() { return /* reexport */ es_groupBy; },
  "HK3": function() { return /* reexport */ es_indexBy; },
  "zys": function() { return /* reexport */ es_innerJoin; },
  "v_p": function() { return /* reexport */ es_join; },
  "UID": function() { return /* reexport */ es_map; },
  "EQD": function() { return /* reexport */ es_match; },
  "Fp7": function() { return /* reexport */ es_max; },
  "BPw": function() { return /* reexport */ es_mergeDeepRight; },
  "VV$": function() { return /* reexport */ es_min; },
  "zGw": function() { return /* reexport */ pipe; },
  "vgT": function() { return /* reexport */ es_prop; },
  "w6H": function() { return /* reexport */ es_range; },
  "u4g": function() { return /* reexport */ es_reduce; },
  "MRu": function() { return /* reexport */ es_sortBy; },
  "Vl2": function() { return /* reexport */ es_split; },
  "Bul": function() { return /* reexport */ es_test; },
  "Zpf": function() { return /* reexport */ es_toPairs; },
  "jj$": function() { return /* reexport */ es_uniq; },
  "VO0": function() { return /* reexport */ es_values; }
});

// UNUSED EXPORTS: F, T, __, add, addIndex, adjust, allPass, always, and, andThen, any, anyPass, ap, aperture, append, apply, applySpec, applyTo, ascend, assoc, assocPath, binary, bind, both, call, chain, clamp, clone, collectBy, comparator, complement, compose, composeWith, concat, cond, construct, constructN, converge, count, countBy, curry, curryN, dec, defaultTo, descend, difference, differenceWith, dissoc, dissocPath, divide, drop, dropLast, dropLastWhile, dropRepeats, dropRepeatsWith, dropWhile, either, empty, endsWith, eqBy, eqProps, equals, evolve, filter, find, findIndex, findLast, findLastIndex, flip, forEach, forEachObjIndexed, fromPairs, groupWith, gt, gte, has, hasIn, hasPath, head, identical, identity, ifElse, inc, includes, indexOf, init, insert, insertAll, intersection, intersperse, into, invert, invertObj, invoker, is, isEmpty, isNil, juxt, keys, keysIn, last, lastIndexOf, length, lens, lensIndex, lensPath, lensProp, lift, liftN, lt, lte, mapAccum, mapAccumRight, mapObjIndexed, mathMod, maxBy, mean, median, memoizeWith, mergeAll, mergeDeepLeft, mergeDeepWith, mergeDeepWithKey, mergeLeft, mergeRight, mergeWith, mergeWithKey, minBy, modify, modifyPath, modulo, move, multiply, nAry, negate, none, not, nth, nthArg, o, objOf, of, omit, on, once, or, otherwise, over, pair, partial, partialObject, partialRight, partition, path, pathEq, pathOr, pathSatisfies, paths, pick, pickAll, pickBy, pipeWith, pluck, prepend, product, project, promap, propEq, propIs, propOr, propSatisfies, props, reduceBy, reduceRight, reduceWhile, reduced, reject, remove, repeat, replace, reverse, scan, sequence, set, slice, sort, sortWith, splitAt, splitEvery, splitWhen, splitWhenever, startsWith, subtract, sum, symmetricDifference, symmetricDifferenceWith, tail, take, takeLast, takeLastWhile, takeWhile, tap, thunkify, times, toLower, toPairsIn, toString, toUpper, transduce, transpose, traverse, trim, tryCatch, type, unapply, unary, uncurryN, unfold, union, unionWith, uniqBy, uniqWith, unless, unnest, until, unwind, update, useWith, valuesIn, view, when, where, whereAny, whereEq, without, xor, xprod, zip, zipObj, zipWith

;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/__.js
/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @name __
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      const greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 */
/* harmony default export */ var _ = ({
  '@@functional/placeholder': true
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isPlaceholder.js
function _isPlaceholder(a) {
  return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_curry1.js

/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */

function _curry1_curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_curry2.js


/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */

function _curry2_curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;

      case 1:
        return _isPlaceholder(a) ? f2 : _curry1_curry1(function (_b) {
          return fn(a, _b);
        });

      default:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1_curry1(function (_a) {
          return fn(_a, b);
        }) : _isPlaceholder(b) ? _curry1_curry1(function (_b) {
          return fn(a, _b);
        }) : fn(a, b);
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isArray.js
/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */
/* harmony default export */ var internal_isArray = (Array.isArray || function _isArray(val) {
  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isTransformer.js
function _isTransformer_isTransformer(obj) {
  return obj != null && typeof obj['@@transducer/step'] === 'function';
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_dispatchable.js


/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer created by [transducerCreator] to return a new transformer
 * (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} transducerCreator transducer factory if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */

function _dispatchable(methodNames, transducerCreator, fn) {
  return function () {
    if (arguments.length === 0) {
      return fn();
    }

    var obj = arguments[arguments.length - 1];

    if (!internal_isArray(obj)) {
      var idx = 0;

      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === 'function') {
          return obj[methodNames[idx]].apply(obj, Array.prototype.slice.call(arguments, 0, -1));
        }

        idx += 1;
      }

      if (_isTransformer_isTransformer(obj)) {
        var transducer = transducerCreator.apply(null, Array.prototype.slice.call(arguments, 0, -1));
        return transducer(obj);
      }
    }

    return fn.apply(this, arguments);
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_reduced.js
function _reduced_reduced(x) {
  return x && x['@@transducer/reduced'] ? x : {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xfBase.js
/* harmony default export */ var _xfBase = ({
  init: function () {
    return this.xf['@@transducer/init']();
  },
  result: function (result) {
    return this.xf['@@transducer/result'](result);
  }
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xall.js




var XAll =
/*#__PURE__*/
function () {
  function XAll(f, xf) {
    this.xf = xf;
    this.f = f;
    this.all = true;
  }

  XAll.prototype['@@transducer/init'] = _xfBase.init;

  XAll.prototype['@@transducer/result'] = function (result) {
    if (this.all) {
      result = this.xf['@@transducer/step'](result, true);
    }

    return this.xf['@@transducer/result'](result);
  };

  XAll.prototype['@@transducer/step'] = function (result, input) {
    if (!this.f(input)) {
      this.all = false;
      result = _reduced_reduced(this.xf['@@transducer/step'](result, false));
    }

    return result;
  };

  return XAll;
}();

var _xall =
/*#__PURE__*/
_curry2_curry2(function _xall(f, xf) {
  return new XAll(f, xf);
});

/* harmony default export */ var internal_xall = (_xall);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/all.js



/**
 * Returns `true` if all elements of the list match the predicate, `false` if
 * there are any that don't.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
 *         otherwise.
 * @see R.any, R.none, R.transduce
 * @example
 *
 *      const equals3 = R.equals(3);
 *      R.all(equals3)([3, 3, 3, 3]); //=> true
 *      R.all(equals3)([3, 3, 1, 3]); //=> false
 */

var all_all =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable(['all'], internal_xall, function all(fn, list) {
  var idx = 0;

  while (idx < list.length) {
    if (!fn(list[idx])) {
      return false;
    }

    idx += 1;
  }

  return true;
}));

/* harmony default export */ var es_all = (all_all);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_map.js
function _map_map(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result = Array(len);

  while (idx < len) {
    result[idx] = fn(functor[idx]);
    idx += 1;
  }

  return result;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isString.js
function _isString_isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isArrayLike.js



/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 *      _isArrayLike({nodeType: 1, length: 1}) // => false
 */

var _isArrayLike_isArrayLike =
/*#__PURE__*/
_curry1_curry1(function isArrayLike(x) {
  if (internal_isArray(x)) {
    return true;
  }

  if (!x) {
    return false;
  }

  if (typeof x !== 'object') {
    return false;
  }

  if (_isString_isString(x)) {
    return false;
  }

  if (x.length === 0) {
    return true;
  }

  if (x.length > 0) {
    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
  }

  return false;
});

/* harmony default export */ var internal_isArrayLike = (_isArrayLike_isArrayLike);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xwrap.js
var XWrap =
/*#__PURE__*/
function () {
  function XWrap(fn) {
    this.f = fn;
  }

  XWrap.prototype['@@transducer/init'] = function () {
    throw new Error('init not implemented on XWrap');
  };

  XWrap.prototype['@@transducer/result'] = function (acc) {
    return acc;
  };

  XWrap.prototype['@@transducer/step'] = function (acc, x) {
    return this.f(acc, x);
  };

  return XWrap;
}();

function _xwrap_xwrap(fn) {
  return new XWrap(fn);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_arity.js
function _arity_arity(n, fn) {
  /* eslint-disable no-unused-vars */
  switch (n) {
    case 0:
      return function () {
        return fn.apply(this, arguments);
      };

    case 1:
      return function (a0) {
        return fn.apply(this, arguments);
      };

    case 2:
      return function (a0, a1) {
        return fn.apply(this, arguments);
      };

    case 3:
      return function (a0, a1, a2) {
        return fn.apply(this, arguments);
      };

    case 4:
      return function (a0, a1, a2, a3) {
        return fn.apply(this, arguments);
      };

    case 5:
      return function (a0, a1, a2, a3, a4) {
        return fn.apply(this, arguments);
      };

    case 6:
      return function (a0, a1, a2, a3, a4, a5) {
        return fn.apply(this, arguments);
      };

    case 7:
      return function (a0, a1, a2, a3, a4, a5, a6) {
        return fn.apply(this, arguments);
      };

    case 8:
      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn.apply(this, arguments);
      };

    case 9:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn.apply(this, arguments);
      };

    case 10:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn.apply(this, arguments);
      };

    default:
      throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
  }
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/bind.js


/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */

var bind =
/*#__PURE__*/
_curry2_curry2(function bind(fn, thisObj) {
  return _arity_arity(fn.length, function () {
    return fn.apply(thisObj, arguments);
  });
});

/* harmony default export */ var es_bind = (bind);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_reduce.js




function _arrayReduce(xf, acc, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    acc = xf['@@transducer/step'](acc, list[idx]);

    if (acc && acc['@@transducer/reduced']) {
      acc = acc['@@transducer/value'];
      break;
    }

    idx += 1;
  }

  return xf['@@transducer/result'](acc);
}

function _iterableReduce(xf, acc, iter) {
  var step = iter.next();

  while (!step.done) {
    acc = xf['@@transducer/step'](acc, step.value);

    if (acc && acc['@@transducer/reduced']) {
      acc = acc['@@transducer/value'];
      break;
    }

    step = iter.next();
  }

  return xf['@@transducer/result'](acc);
}

function _methodReduce(xf, acc, obj, methodName) {
  return xf['@@transducer/result'](obj[methodName](es_bind(xf['@@transducer/step'], xf), acc));
}

var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
function _reduce_reduce(fn, acc, list) {
  if (typeof fn === 'function') {
    fn = _xwrap_xwrap(fn);
  }

  if (internal_isArrayLike(list)) {
    return _arrayReduce(fn, acc, list);
  }

  if (typeof list['fantasy-land/reduce'] === 'function') {
    return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
  }

  if (list[symIterator] != null) {
    return _iterableReduce(fn, acc, list[symIterator]());
  }

  if (typeof list.next === 'function') {
    return _iterableReduce(fn, acc, list);
  }

  if (typeof list.reduce === 'function') {
    return _methodReduce(fn, acc, list, 'reduce');
  }

  throw new TypeError('reduce: list must be array or iterable');
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xmap.js



var XMap =
/*#__PURE__*/
function () {
  function XMap(f, xf) {
    this.xf = xf;
    this.f = f;
  }

  XMap.prototype['@@transducer/init'] = _xfBase.init;
  XMap.prototype['@@transducer/result'] = _xfBase.result;

  XMap.prototype['@@transducer/step'] = function (result, input) {
    return this.xf['@@transducer/step'](result, this.f(input));
  };

  return XMap;
}();

var _xmap =
/*#__PURE__*/
_curry2_curry2(function _xmap(f, xf) {
  return new XMap(f, xf);
});

/* harmony default export */ var internal_xmap = (_xmap);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_curryN.js


/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */

function _curryN_curryN(length, received, fn) {
  return function () {
    var combined = [];
    var argsIdx = 0;
    var left = length;
    var combinedIdx = 0;

    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result;

      if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
        result = received[combinedIdx];
      } else {
        result = arguments[argsIdx];
        argsIdx += 1;
      }

      combined[combinedIdx] = result;

      if (!_isPlaceholder(result)) {
        left -= 1;
      }

      combinedIdx += 1;
    }

    return left <= 0 ? fn.apply(this, combined) : _arity_arity(left, _curryN_curryN(length, combined, fn));
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/curryN.js




/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */

var curryN_curryN =
/*#__PURE__*/
_curry2_curry2(function curryN(length, fn) {
  if (length === 1) {
    return _curry1_curry1(fn);
  }

  return _arity_arity(length, _curryN_curryN(length, [], fn));
});

/* harmony default export */ var es_curryN = (curryN_curryN);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_has.js
function _has_has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isArguments.js

var _isArguments_toString = Object.prototype.toString;

var _isArguments_isArguments =
/*#__PURE__*/
function () {
  return _isArguments_toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
    return _isArguments_toString.call(x) === '[object Arguments]';
  } : function _isArguments(x) {
    return _has_has('callee', x);
  };
}();

/* harmony default export */ var internal_isArguments = (_isArguments_isArguments);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/keys.js


 // cover IE < 9 keys issues

var hasEnumBug = !
/*#__PURE__*/
{
  toString: null
}.propertyIsEnumerable('toString');
var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString']; // Safari bug

var hasArgsEnumBug =
/*#__PURE__*/
function () {
  'use strict';

  return arguments.propertyIsEnumerable('length');
}();

var contains = function contains(list, item) {
  var idx = 0;

  while (idx < list.length) {
    if (list[idx] === item) {
      return true;
    }

    idx += 1;
  }

  return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values, R.toPairs
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */


var keys_keys = typeof Object.keys === 'function' && !hasArgsEnumBug ?
/*#__PURE__*/
_curry1_curry1(function keys(obj) {
  return Object(obj) !== obj ? [] : Object.keys(obj);
}) :
/*#__PURE__*/
_curry1_curry1(function keys(obj) {
  if (Object(obj) !== obj) {
    return [];
  }

  var prop, nIdx;
  var ks = [];

  var checkArgsLength = hasArgsEnumBug && internal_isArguments(obj);

  for (prop in obj) {
    if (_has_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
      ks[ks.length] = prop;
    }
  }

  if (hasEnumBug) {
    nIdx = nonEnumerableProps.length - 1;

    while (nIdx >= 0) {
      prop = nonEnumerableProps[nIdx];

      if (_has_has(prop, obj) && !contains(ks, prop)) {
        ks[ks.length] = prop;
      }

      nIdx -= 1;
    }
  }

  return ks;
});
/* harmony default export */ var es_keys = (keys_keys);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/map.js







/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex, R.pluck, R.project
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */

var map_map =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable(['fantasy-land/map', 'map'], internal_xmap, function map(fn, functor) {
  switch (Object.prototype.toString.call(functor)) {
    case '[object Function]':
      return es_curryN(functor.length, function () {
        return fn.call(this, functor.apply(this, arguments));
      });

    case '[object Object]':
      return _reduce_reduce(function (acc, key) {
        acc[key] = fn(functor[key]);
        return acc;
      }, {}, es_keys(functor));

    default:
      return _map_map(fn, functor);
  }
}));

/* harmony default export */ var es_map = (map_map);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isInteger.js
/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */
/* harmony default export */ var internal_isInteger = (Number.isInteger || function _isInteger(n) {
  return n << 0 === n;
});
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/nth.js


/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      const list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */

var nth_nth =
/*#__PURE__*/
_curry2_curry2(function nth(offset, list) {
  var idx = offset < 0 ? list.length + offset : offset;
  return _isString_isString(list) ? list.charAt(idx) : list[idx];
});

/* harmony default export */ var es_nth = (nth_nth);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/prop.js



/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx -> {s: a} -> a | Undefined
 * @param {String|Number} p The property name or array index
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path, R.props, R.pluck, R.project, R.nth
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 *      R.prop(0, [100]); //=> 100
 *      R.compose(R.inc, R.prop('x'))({ x: 3 }) //=> 4
 */

var prop_prop =
/*#__PURE__*/
_curry2_curry2(function prop(p, obj) {
  if (obj == null) {
    return;
  }

  return internal_isInteger(p) ? es_nth(p, obj) : obj[p];
});

/* harmony default export */ var es_prop = (prop_prop);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/pluck.js



/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.project, R.prop, R.props
 * @example
 *
 *      var getAges = R.pluck('age');
 *      getAges([{name: 'fred', age: 29}, {name: 'wilma', age: 27}]); //=> [29, 27]
 *
 *      R.pluck(0, [[1, 2], [3, 4]]);               //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */

var pluck_pluck =
/*#__PURE__*/
_curry2_curry2(function pluck(p, list) {
  return es_map(es_prop(p), list);
});

/* harmony default export */ var es_pluck = (pluck_pluck);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_curry3.js



/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */

function _curry3_curry3(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;

      case 1:
        return _isPlaceholder(a) ? f3 : _curry2_curry2(function (_b, _c) {
          return fn(a, _b, _c);
        });

      case 2:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2_curry2(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) ? _curry2_curry2(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _curry1_curry1(function (_c) {
          return fn(a, b, _c);
        });

      default:
        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2_curry2(function (_a, _b) {
          return fn(_a, _b, c);
        }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2_curry2(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2_curry2(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _isPlaceholder(a) ? _curry1_curry1(function (_a) {
          return fn(_a, b, c);
        }) : _isPlaceholder(b) ? _curry1_curry1(function (_b) {
          return fn(a, _b, c);
        }) : _isPlaceholder(c) ? _curry1_curry1(function (_c) {
          return fn(a, b, _c);
        }) : fn(a, b, c);
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/reduce.js


/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */

var reduce_reduce =
/*#__PURE__*/
_curry3_curry3(_reduce_reduce);

/* harmony default export */ var es_reduce = (reduce_reduce);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/allPass.js





/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if every one of the provided predicates is satisfied
 * by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.anyPass
 * @example
 *
 *      const isQueen = R.propEq('rank', 'Q');
 *      const isSpade = R.propEq('suit', '♠︎');
 *      const isQueenOfSpades = R.allPass([isQueen, isSpade]);
 *
 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
 */

var allPass =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry1(function allPass(preds) {
  return curryN(reduce(max, 0, pluck('length', preds)), function () {
    var idx = 0;
    var len = preds.length;

    while (idx < len) {
      if (!preds[idx].apply(this, arguments)) {
        return false;
      }

      idx += 1;
    }

    return true;
  });
})));

/* harmony default export */ var es_allPass = ((/* unused pure expression or super */ null && (allPass)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xany.js




var XAny =
/*#__PURE__*/
function () {
  function XAny(f, xf) {
    this.xf = xf;
    this.f = f;
    this.any = false;
  }

  XAny.prototype['@@transducer/init'] = _xfBase.init;

  XAny.prototype['@@transducer/result'] = function (result) {
    if (!this.any) {
      result = this.xf['@@transducer/step'](result, false);
    }

    return this.xf['@@transducer/result'](result);
  };

  XAny.prototype['@@transducer/step'] = function (result, input) {
    if (this.f(input)) {
      this.any = true;
      result = _reduced_reduced(this.xf['@@transducer/step'](result, true));
    }

    return result;
  };

  return XAny;
}();

var _xany =
/*#__PURE__*/
_curry2_curry2(function _xany(f, xf) {
  return new XAny(f, xf);
});

/* harmony default export */ var internal_xany = (_xany);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/any.js



/**
 * Returns `true` if at least one of the elements of the list match the predicate,
 * `false` otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
 *         otherwise.
 * @see R.all, R.none, R.transduce
 * @example
 *
 *      const lessThan0 = R.flip(R.lt)(0);
 *      const lessThan2 = R.flip(R.lt)(2);
 *      R.any(lessThan0)([1, 2]); //=> false
 *      R.any(lessThan2)([1, 2]); //=> true
 */

var any =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable(['any'], internal_xany, function any(fn, list) {
  var idx = 0;

  while (idx < list.length) {
    if (fn(list[idx])) {
      return true;
    }

    idx += 1;
  }

  return false;
}));

/* harmony default export */ var es_any = ((/* unused pure expression or super */ null && (any)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/anyPass.js





/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if at least one of the provided predicates is
 * satisfied by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.allPass
 * @example
 *
 *      const isClub = R.propEq('suit', '♣');
 *      const isSpade = R.propEq('suit', '♠');
 *      const isBlackCard = R.anyPass([isClub, isSpade]);
 *
 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
 */

var anyPass =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry1(function anyPass(preds) {
  return curryN(reduce(max, 0, pluck('length', preds)), function () {
    var idx = 0;
    var len = preds.length;

    while (idx < len) {
      if (preds[idx].apply(this, arguments)) {
        return true;
      }

      idx += 1;
    }

    return false;
  });
})));

/* harmony default export */ var es_anyPass = ((/* unused pure expression or super */ null && (anyPass)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_concat.js
/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */
function _concat_concat(set1, set2) {
  set1 = set1 || [];
  set2 = set2 || [];
  var idx;
  var len1 = set1.length;
  var len2 = set2.length;
  var result = [];
  idx = 0;

  while (idx < len1) {
    result[result.length] = set1[idx];
    idx += 1;
  }

  idx = 0;

  while (idx < len2) {
    result[result.length] = set2[idx];
    idx += 1;
  }

  return result;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/ap.js




/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the second argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @sig (r -> a -> b) -> (r -> a) -> (r -> b)
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 *
 *      // R.ap can also be used as S combinator
 *      // when only two functions are passed
 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */

var ap_ap =
/*#__PURE__*/
_curry2_curry2(function ap(applyF, applyX) {
  return typeof applyX['fantasy-land/ap'] === 'function' ? applyX['fantasy-land/ap'](applyF) : typeof applyF.ap === 'function' ? applyF.ap(applyX) : typeof applyF === 'function' ? function (x) {
    return applyF(x)(applyX(x));
  } : _reduce_reduce(function (acc, f) {
    return _concat_concat(acc, es_map(f, applyX));
  }, [], applyF);
});

/* harmony default export */ var es_ap = (ap_ap);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_aperture.js
function _aperture(n, list) {
  var idx = 0;
  var limit = list.length - (n - 1);
  var acc = new Array(limit >= 0 ? limit : 0);

  while (idx < limit) {
    acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
    idx += 1;
  }

  return acc;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xaperture.js




var XAperture =
/*#__PURE__*/
function () {
  function XAperture(n, xf) {
    this.xf = xf;
    this.pos = 0;
    this.full = false;
    this.acc = new Array(n);
  }

  XAperture.prototype['@@transducer/init'] = _xfBase.init;

  XAperture.prototype['@@transducer/result'] = function (result) {
    this.acc = null;
    return this.xf['@@transducer/result'](result);
  };

  XAperture.prototype['@@transducer/step'] = function (result, input) {
    this.store(input);
    return this.full ? this.xf['@@transducer/step'](result, this.getCopy()) : result;
  };

  XAperture.prototype.store = function (input) {
    this.acc[this.pos] = input;
    this.pos += 1;

    if (this.pos === this.acc.length) {
      this.pos = 0;
      this.full = true;
    }
  };

  XAperture.prototype.getCopy = function () {
    return _concat_concat(Array.prototype.slice.call(this.acc, this.pos), Array.prototype.slice.call(this.acc, 0, this.pos));
  };

  return XAperture;
}();

var _xaperture =
/*#__PURE__*/
_curry2_curry2(function _xaperture(n, xf) {
  return new XAperture(n, xf);
});

/* harmony default export */ var internal_xaperture = (_xaperture);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/aperture.js




/**
 * Returns a new list, composed of n-tuples of consecutive elements. If `n` is
 * greater than the length of the list, an empty list is returned.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @param {Number} n The size of the tuples to create
 * @param {Array} list The list to split into `n`-length tuples
 * @return {Array} The resulting list of `n`-length tuples
 * @see R.transduce
 * @example
 *
 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
 */

var aperture =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable([], internal_xaperture, _aperture));

/* harmony default export */ var es_aperture = ((/* unused pure expression or super */ null && (aperture)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/values.js


/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys, R.toPairs
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */

var values_values =
/*#__PURE__*/
_curry1_curry1(function values(obj) {
  var props = es_keys(obj);
  var len = props.length;
  var vals = [];
  var idx = 0;

  while (idx < len) {
    vals[idx] = obj[props[idx]];
    idx += 1;
  }

  return vals;
});

/* harmony default export */ var es_values = (values_values);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/applySpec.js








 // Use custom mapValues function to avoid issues with specs that include a "map" key and R.map
// delegating calls to .map

function mapValues(fn, obj) {
  return _isArray(obj) ? obj.map(fn) : keys(obj).reduce(function (acc, key) {
    acc[key] = fn(obj[key]);
    return acc;
  }, {});
}
/**
 * Given a spec object recursively mapping properties to functions, creates a
 * function producing an object of the same structure, by mapping each property
 * to the result of calling its associated function with the supplied arguments.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
 * @param {Object} spec an object recursively mapping properties to functions for
 *        producing the values for these properties.
 * @return {Function} A function that returns an object of the same structure
 * as `spec', with each property set to the value returned by calling its
 * associated function with the supplied arguments.
 * @see R.converge, R.juxt
 * @example
 *
 *      const getMetrics = R.applySpec({
 *        sum: R.add,
 *        nested: { mul: R.multiply }
 *      });
 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
 */


var applySpec =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry1(function applySpec(spec) {
  spec = mapValues(function (v) {
    return typeof v == 'function' ? v : applySpec(v);
  }, spec);
  return curryN(reduce(max, 0, pluck('length', values(spec))), function () {
    var args = arguments;
    return mapValues(function (f) {
      return apply(f, args);
    }, spec);
  });
})));

/* harmony default export */ var es_applySpec = ((/* unused pure expression or super */ null && (applySpec)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_assoc.js


/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @private
 * @param {String|Number} prop The property name to set
 * @param {*} val The new value
 * @param {Object|Array} obj The object to clone
 * @return {Object|Array} A new object equivalent to the original except for the changed property.
 */

function _assoc_assoc(prop, val, obj) {
  if (_isInteger(prop) && _isArray(obj)) {
    var arr = [].concat(obj);
    arr[prop] = val;
    return arr;
  }

  var result = {};

  for (var p in obj) {
    result[p] = obj[p];
  }

  result[prop] = val;
  return result;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/assocPath.js





/**
 * Makes a shallow clone of an object, setting or overriding the nodes required
 * to create the given path, and placing the specific value at the tail end of
 * that path. Note that this copies and flattens prototype properties onto the
 * new object as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> a -> {a} -> {a}
 * @param {Array} path the path to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except along the specified path.
 * @see R.dissocPath
 * @example
 *
 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
 *
 *      // Any missing or non-object keys in path will be overridden
 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
 */

var assocPath_assocPath =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry3(function assocPath(path, val, obj) {
  if (path.length === 0) {
    return val;
  }

  var idx = path[0];

  if (path.length > 1) {
    var nextObj = !isNil(obj) && _has(idx, obj) ? obj[idx] : _isInteger(path[1]) ? [] : {};
    val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
  }

  return _assoc(idx, val, obj);
})));

/* harmony default export */ var es_assocPath = ((/* unused pure expression or super */ null && (assocPath_assocPath)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/assoc.js


/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig Idx -> a -> {k: v} -> {k: v}
 * @param {String|Number} prop The property name to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except for the changed property.
 * @see R.dissoc, R.pick
 * @example
 *
 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
 */

var assoc_assoc =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry3(function assoc(prop, val, obj) {
  return assocPath([prop], val, obj);
})));

/* harmony default export */ var es_assoc = ((/* unused pure expression or super */ null && (assoc_assoc)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/liftN.js





/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      const madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */

var liftN =
/*#__PURE__*/
_curry2_curry2(function liftN(arity, fn) {
  var lifted = es_curryN(arity, fn);
  return es_curryN(arity, function () {
    return _reduce_reduce(es_ap, es_map(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
  });
});

/* harmony default export */ var es_liftN = (liftN);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/lift.js


/**
 * "lifts" a function of arity >= 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      const madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([100, 200], [30, 40], [5, 6, 7]); //=> [135, 136, 137, 145, 146, 147, 235, 236, 237, 245, 246, 247]
 *
 *      const madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([10, 20], [1], [2, 3], [4], [100, 200]); //=> [117, 217, 118, 218, 127, 227, 128, 228]
 */

var lift_lift =
/*#__PURE__*/
_curry1_curry1(function lift(fn) {
  return es_liftN(fn.length, fn);
});

/* harmony default export */ var es_lift = (lift_lift);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/both.js




/**
 * A function which calls the two provided functions and returns the `&&`
 * of the results.
 * It returns the result of the first function if it is false-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * false-y value.
 *
 * In addition to functions, `R.both` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f A predicate
 * @param {Function} g Another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
 * @see R.either, R.and
 * @example
 *
 *      const gt10 = R.gt(R.__, 10)
 *      const lt20 = R.lt(R.__, 20)
 *      const f = R.both(gt10, lt20);
 *      f(15); //=> true
 *      f(30); //=> false
 *
 *      R.both(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(false)
 *      R.both([false, false, 'a'], [11]); //=> [false, false, 11]
 */

var both =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function both(f, g) {
  return _isFunction(f) ? function _both() {
    return f.apply(this, arguments) && g.apply(this, arguments);
  } : lift(and)(f, g);
})));

/* harmony default export */ var es_both = ((/* unused pure expression or super */ null && (both)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_makeFlat.js

/**
 * `_makeFlat` is a helper function that returns a one-level or fully recursive
 * function based on the flag passed in.
 *
 * @private
 */

function _makeFlat(recursive) {
  return function flatt(list) {
    var value, jlen, j;
    var result = [];
    var idx = 0;
    var ilen = list.length;

    while (idx < ilen) {
      if (internal_isArrayLike(list[idx])) {
        value = recursive ? flatt(list[idx]) : list[idx];
        j = 0;
        jlen = value.length;

        while (j < jlen) {
          result[result.length] = value[j];
          j += 1;
        }
      } else {
        result[result.length] = list[idx];
      }

      idx += 1;
    }

    return result;
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_forceReduced.js
function _forceReduced(x) {
  return {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_flatCat.js





var preservingReduced = function (xf) {
  return {
    '@@transducer/init': _xfBase.init,
    '@@transducer/result': function (result) {
      return xf['@@transducer/result'](result);
    },
    '@@transducer/step': function (result, input) {
      var ret = xf['@@transducer/step'](result, input);
      return ret['@@transducer/reduced'] ? _forceReduced(ret) : ret;
    }
  };
};

var _flatCat = function _xcat(xf) {
  var rxf = preservingReduced(xf);
  return {
    '@@transducer/init': _xfBase.init,
    '@@transducer/result': function (result) {
      return rxf['@@transducer/result'](result);
    },
    '@@transducer/step': function (result, input) {
      return !internal_isArrayLike(input) ? _reduce_reduce(rxf, result, [input]) : _reduce_reduce(rxf, result, input);
    }
  };
};

/* harmony default export */ var internal_flatCat = (_flatCat);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xchain.js




var _xchain =
/*#__PURE__*/
_curry2_curry2(function _xchain(f, xf) {
  return es_map(f, internal_flatCat(xf));
});

/* harmony default export */ var internal_xchain = (_xchain);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/chain.js





/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries.
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * If second argument is a function, `chain(f, g)(x)` is equivalent to `f(g(x), x)`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      const duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */

var chain =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable(['fantasy-land/chain', 'chain'], internal_xchain, function chain(fn, monad) {
  if (typeof monad === 'function') {
    return function (x) {
      return fn(monad(x))(x);
    };
  }

  return _makeFlat(false)(es_map(fn, monad));
}));

/* harmony default export */ var es_chain = (chain);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/collectBy.js


/**
 * Splits a list into sub-lists, based on the result of calling a key-returning function on each element,
 * and grouping the results according to values returned.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category List
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx a => (b -> a) -> [b] -> [[b]]
 * @param {Function} fn Function :: a -> Idx
 * @param {Array} list The array to group
 * @return {Array}
 *    An array of arrays where each sub-array contains items for which
 *    the String-returning function has returned the same value.
 * @see R.groupBy, R.partition
 * @example
 *      R.collectBy(R.prop('type'), [
 *        {type: 'breakfast', item: '☕️'},
 *        {type: 'lunch', item: '🌯'},
 *        {type: 'dinner', item: '🍝'},
 *        {type: 'breakfast', item: '🥐'},
 *        {type: 'lunch', item: '🍕'}
 *      ]);
 *
 *      // [ [ {type: 'breakfast', item: '☕️'},
 *      //     {type: 'breakfast', item: '🥐'} ],
 *      //   [ {type: 'lunch', item: '🌯'},
 *      //     {type: 'lunch', item: '🍕'} ],
 *      //   [ {type: 'dinner', item: '🍝'} ] ]
 */

var collectBy =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function collectBy(fn, list) {
  var group = _reduce(function (o, x) {
    var tag = fn(x);

    if (o[tag] === undefined) {
      o[tag] = [];
    }

    o[tag].push(x);
    return o;
  }, {}, list);

  var newList = [];

  for (var tag in group) {
    newList.push(group[tag]);
  }

  return newList;
})));

/* harmony default export */ var es_collectBy = ((/* unused pure expression or super */ null && (collectBy)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/not.js

/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */

var not =
/*#__PURE__*/
_curry1_curry1(function not(a) {
  return !a;
});

/* harmony default export */ var es_not = (not);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/complement.js


/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      const isNotNil = R.complement(R.isNil);
 *      R.isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      R.isNil(7); //=> false
 *      isNotNil(7); //=> true
 */

var complement =
/*#__PURE__*/
es_lift(es_not);
/* harmony default export */ var es_complement = ((/* unused pure expression or super */ null && (complement)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_pipe.js
function _pipe(f, g) {
  return function () {
    return g.call(this, f.apply(this, arguments));
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_checkForMethod.js

/**
 * This checks whether a function has a [methodname] function. If it isn't an
 * array it will execute that function otherwise it will default to the ramda
 * implementation.
 *
 * @private
 * @param {Function} fn ramda implementation
 * @param {String} methodname property to check for a custom implementation
 * @return {Object} Whatever the return value of the method is.
 */

function _checkForMethod_checkForMethod(methodname, fn) {
  return function () {
    var length = arguments.length;

    if (length === 0) {
      return fn();
    }

    var obj = arguments[length - 1];
    return internal_isArray(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/slice.js


/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */

var slice_slice =
/*#__PURE__*/
_curry3_curry3(
/*#__PURE__*/
_checkForMethod_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
  return Array.prototype.slice.call(list, fromIndex, toIndex);
}));

/* harmony default export */ var es_slice = (slice_slice);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/tail.js



/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */

var tail_tail =
/*#__PURE__*/
_curry1_curry1(
/*#__PURE__*/
_checkForMethod_checkForMethod('tail',
/*#__PURE__*/
es_slice(1, Infinity)));

/* harmony default export */ var es_tail = (tail_tail);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/pipe.js




/**
 * Performs left-to-right function composition. The first argument may have
 * any arity; the remaining arguments must be unary.
 *
 * In some libraries this function is named `sequence`.
 *
 * **Note:** The result of pipe is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.compose
 * @example
 *
 *      const f = R.pipe(Math.pow, R.negate, R.inc);
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
 * @symb R.pipe(f, g, h)(a)(b) = h(g(f(a)))(b)
 */

function pipe() {
  if (arguments.length === 0) {
    throw new Error('pipe requires at least one argument');
  }

  return _arity_arity(arguments[0].length, es_reduce(_pipe, arguments[0], es_tail(arguments)));
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/reverse.js


/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */

var reverse_reverse =
/*#__PURE__*/
_curry1_curry1(function reverse(list) {
  return _isString_isString(list) ? list.split('').reverse().join('') : Array.prototype.slice.call(list, 0).reverse();
});

/* harmony default export */ var es_reverse = (reverse_reverse);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/compose.js


/**
 * Performs right-to-left function composition. The last argument may have
 * any arity; the remaining arguments must be unary.
 *
 * **Note:** The result of compose is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.pipe
 * @example
 *
 *      const classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
 *      const yellGreeting = R.compose(R.toUpper, classyGreeting);
 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
 *
 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
 * @symb R.compose(f, g, h)(a)(b) = f(g(h(a)))(b)
 */

function compose() {
  if (arguments.length === 0) {
    throw new Error('compose requires at least one argument');
  }

  return pipe.apply(this, es_reverse(arguments));
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/pipeWith.js






/**
 * Performs left-to-right function composition using transforming function. The first function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of pipeWith is not automatically curried. Transforming function is not used on the
 * first argument.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((* -> *), [((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)]) -> ((a, b, ..., n) -> z)
 * @param {Function} transformer The transforming function
 * @param {Array} functions The functions to pipe
 * @return {Function}
 * @see R.composeWith, R.pipe
 * @example
 *
 *      const pipeWhileNotNil = R.pipeWith((f, res) => R.isNil(res) ? res : f(res));
 *      const f = pipeWhileNotNil([Math.pow, R.negate, R.inc])
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipeWith(f)([g, h, i])(...args) = f(i, f(h, g(...args)))
 */

var pipeWith_pipeWith =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function pipeWith(xf, list) {
  if (list.length <= 0) {
    return identity;
  }

  var headList = head(list);
  var tailList = tail(list);
  return _arity(headList.length, function () {
    return _reduce(function (result, f) {
      return xf.call(this, f, result);
    }, headList.apply(this, arguments), tailList);
  });
})));

/* harmony default export */ var es_pipeWith = ((/* unused pure expression or super */ null && (pipeWith_pipeWith)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/composeWith.js



/**
 * Performs right-to-left function composition using transforming function. The last function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of composeWith is not automatically curried. Transforming function is not used
 * on the last argument.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((* -> *), [(y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)]) -> ((a, b, ..., n) -> z)
 * @param {Function} transformer The transforming function
 * @param {Array} functions The functions to compose
 * @return {Function}
 * @see R.compose, R.pipeWith
 * @example
 *
 *      const composeWhileNotNil = R.composeWith((f, res) => R.isNil(res) ? res : f(res));
 *
 *      composeWhileNotNil([R.inc, R.prop('age')])({age: 1}) //=> 2
 *      composeWhileNotNil([R.inc, R.prop('age')])({}) //=> undefined
 *
 * @symb R.composeWith(f)([g, h, i])(...args) = f(g, f(h, i(...args)))
 */

var composeWith =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function composeWith(xf, list) {
  return pipeWith.apply(this, [xf, reverse(list)]);
})));

/* harmony default export */ var es_composeWith = ((/* unused pure expression or super */ null && (composeWith)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_arrayFromIterator.js
function _arrayFromIterator(iter) {
  var list = [];
  var next;

  while (!(next = iter.next()).done) {
    list.push(next.value);
  }

  return list;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_includesWith.js
function _includesWith(pred, x, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }

    idx += 1;
  }

  return false;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_functionName.js
function _functionName(f) {
  // String(x => x) evaluates to "x => x", so the pattern may not match.
  var match = String(f).match(/^function (\w*)/);
  return match == null ? '' : match[1];
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_objectIs.js
// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function _objectIs(a, b) {
  // SameValue algorithm
  if (a === b) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
  } else {
    // Step 6.a: NaN == NaN
    return a !== a && b !== b;
  }
}

/* harmony default export */ var internal_objectIs = (typeof Object.is === 'function' ? Object.is : _objectIs);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/type.js

/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */

var type =
/*#__PURE__*/
_curry1_curry1(function type(val) {
  return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
});

/* harmony default export */ var es_type = (type);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_equals.js







/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparison of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */

function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
  var a = _arrayFromIterator(aIterator);

  var b = _arrayFromIterator(bIterator);

  function eq(_a, _b) {
    return _equals(_a, _b, stackA.slice(), stackB.slice());
  } // if *a* array contains any element that is not included in *b*


  return !_includesWith(function (b, aItem) {
    return !_includesWith(eq, aItem, b);
  }, b, a);
}

function _equals(a, b, stackA, stackB) {
  if (internal_objectIs(a, b)) {
    return true;
  }

  var typeA = es_type(a);

  if (typeA !== es_type(b)) {
    return false;
  }

  if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
    return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
  }

  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
    return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
  }

  switch (typeA) {
    case 'Arguments':
    case 'Array':
    case 'Object':
      if (typeof a.constructor === 'function' && _functionName(a.constructor) === 'Promise') {
        return a === b;
      }

      break;

    case 'Boolean':
    case 'Number':
    case 'String':
      if (!(typeof a === typeof b && internal_objectIs(a.valueOf(), b.valueOf()))) {
        return false;
      }

      break;

    case 'Date':
      if (!internal_objectIs(a.valueOf(), b.valueOf())) {
        return false;
      }

      break;

    case 'Error':
      return a.name === b.name && a.message === b.message;

    case 'RegExp':
      if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
        return false;
      }

      break;
  }

  var idx = stackA.length - 1;

  while (idx >= 0) {
    if (stackA[idx] === a) {
      return stackB[idx] === b;
    }

    idx -= 1;
  }

  switch (typeA) {
    case 'Map':
      if (a.size !== b.size) {
        return false;
      }

      return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));

    case 'Set':
      if (a.size !== b.size) {
        return false;
      }

      return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));

    case 'Arguments':
    case 'Array':
    case 'Object':
    case 'Boolean':
    case 'Number':
    case 'String':
    case 'Date':
    case 'Error':
    case 'RegExp':
    case 'Int8Array':
    case 'Uint8Array':
    case 'Uint8ClampedArray':
    case 'Int16Array':
    case 'Uint16Array':
    case 'Int32Array':
    case 'Uint32Array':
    case 'Float32Array':
    case 'Float64Array':
    case 'ArrayBuffer':
      break;

    default:
      // Values of other types are only equal if identical.
      return false;
  }

  var keysA = es_keys(a);

  if (keysA.length !== es_keys(b).length) {
    return false;
  }

  var extendedStackA = stackA.concat([a]);
  var extendedStackB = stackB.concat([b]);
  idx = keysA.length - 1;

  while (idx >= 0) {
    var key = keysA[idx];

    if (!(_has_has(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) {
      return false;
    }

    idx -= 1;
  }

  return true;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/equals.js


/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */

var equals_equals =
/*#__PURE__*/
_curry2_curry2(function equals(a, b) {
  return _equals(a, b, [], []);
});

/* harmony default export */ var es_equals = (equals_equals);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_indexOf.js

function _indexOf_indexOf(list, a, idx) {
  var inf, item; // Array.prototype.indexOf doesn't exist below IE9

  if (typeof list.indexOf === 'function') {
    switch (typeof a) {
      case 'number':
        if (a === 0) {
          // manually crawl the list to distinguish between +0 and -0
          inf = 1 / a;

          while (idx < list.length) {
            item = list[idx];

            if (item === 0 && 1 / item === inf) {
              return idx;
            }

            idx += 1;
          }

          return -1;
        } else if (a !== a) {
          // NaN
          while (idx < list.length) {
            item = list[idx];

            if (typeof item === 'number' && item !== item) {
              return idx;
            }

            idx += 1;
          }

          return -1;
        } // non-zero numbers can utilise Set


        return list.indexOf(a, idx);
      // all these types can utilise Set

      case 'string':
      case 'boolean':
      case 'function':
      case 'undefined':
        return list.indexOf(a, idx);

      case 'object':
        if (a === null) {
          // null can utilise Set
          return list.indexOf(a, idx);
        }

    }
  } // anything else not covered above, defer to R.equals


  while (idx < list.length) {
    if (es_equals(list[idx], a)) {
      return idx;
    }

    idx += 1;
  }

  return -1;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_includes.js

function _includes_includes(a, list) {
  return _indexOf_indexOf(list, a, 0) >= 0;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_quote.js
function _quote(s) {
  var escaped = s.replace(/\\/g, '\\\\').replace(/[\b]/g, '\\b') // \b matches word boundary; [\b] matches backspace
  .replace(/\f/g, '\\f').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t').replace(/\v/g, '\\v').replace(/\0/g, '\\0');
  return '"' + escaped.replace(/"/g, '\\"') + '"';
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_toISOString.js
/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */
var pad = function pad(n) {
  return (n < 10 ? '0' : '') + n;
};

var _toISOString = typeof Date.prototype.toISOString === 'function' ? function _toISOString(d) {
  return d.toISOString();
} : function _toISOString(d) {
  return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds()) + '.' + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
};

/* harmony default export */ var internal_toISOString = (_toISOString);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_complement.js
function _complement_complement(f) {
  return function () {
    return !f.apply(this, arguments);
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_filter.js
function _filter_filter(fn, list) {
  var idx = 0;
  var len = list.length;
  var result = [];

  while (idx < len) {
    if (fn(list[idx])) {
      result[result.length] = list[idx];
    }

    idx += 1;
  }

  return result;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isObject.js
function _isObject_isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xfilter.js



var XFilter =
/*#__PURE__*/
function () {
  function XFilter(f, xf) {
    this.xf = xf;
    this.f = f;
  }

  XFilter.prototype['@@transducer/init'] = _xfBase.init;
  XFilter.prototype['@@transducer/result'] = _xfBase.result;

  XFilter.prototype['@@transducer/step'] = function (result, input) {
    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
  };

  return XFilter;
}();

var _xfilter =
/*#__PURE__*/
_curry2_curry2(function _xfilter(f, xf) {
  return new XFilter(f, xf);
});

/* harmony default export */ var internal_xfilter = (_xfilter);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/filter.js







/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */

var filter =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable(['fantasy-land/filter', 'filter'], internal_xfilter, function (pred, filterable) {
  return _isObject_isObject(filterable) ? _reduce_reduce(function (acc, key) {
    if (pred(filterable[key])) {
      acc[key] = filterable[key];
    }

    return acc;
  }, {}, es_keys(filterable)) : // else
  _filter_filter(pred, filterable);
}));

/* harmony default export */ var es_filter = (filter);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/reject.js



/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      const isOdd = (n) => n % 2 !== 0;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */

var reject_reject =
/*#__PURE__*/
_curry2_curry2(function reject(pred, filterable) {
  return es_filter(_complement_complement(pred), filterable);
});

/* harmony default export */ var es_reject = (reject_reject);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_toString.js






function _toString_toString(x, seen) {
  var recur = function recur(y) {
    var xs = seen.concat([x]);
    return _includes_includes(y, xs) ? '<Circular>' : _toString_toString(y, xs);
  }; //  mapPairs :: (Object, [String]) -> [String]


  var mapPairs = function (obj, keys) {
    return _map_map(function (k) {
      return _quote(k) + ': ' + recur(obj[k]);
    }, keys.slice().sort());
  };

  switch (Object.prototype.toString.call(x)) {
    case '[object Arguments]':
      return '(function() { return arguments; }(' + _map_map(recur, x).join(', ') + '))';

    case '[object Array]':
      return '[' + _map_map(recur, x).concat(mapPairs(x, es_reject(function (k) {
        return /^\d+$/.test(k);
      }, es_keys(x)))).join(', ') + ']';

    case '[object Boolean]':
      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();

    case '[object Date]':
      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(internal_toISOString(x))) + ')';

    case '[object Null]':
      return 'null';

    case '[object Number]':
      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);

    case '[object String]':
      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);

    case '[object Undefined]':
      return 'undefined';

    default:
      if (typeof x.toString === 'function') {
        var repr = x.toString();

        if (repr !== '[object Object]') {
          return repr;
        }
      }

      return '{' + mapPairs(x, es_keys(x)).join(', ') + '}';
  }
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/toString.js


/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */

var toString_toString =
/*#__PURE__*/
_curry1_curry1(function toString(val) {
  return _toString_toString(val, []);
});

/* harmony default export */ var es_toString = (toString_toString);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/concat.js





/**
 * Returns the result of concatenating the given lists or strings.
 *
 * Note: `R.concat` expects both arguments to be of the same type,
 * unlike the native `Array.prototype.concat` method. It will throw
 * an error if you `concat` an Array with a non-Array value.
 *
 * Dispatches to the `concat` method of the first argument, if present.
 * Can also concatenate two members of a [fantasy-land
 * compatible semigroup](https://github.com/fantasyland/fantasy-land#semigroup).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @sig String -> String -> String
 * @param {Array|String} firstList The first list
 * @param {Array|String} secondList The second list
 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
 * `secondList`.
 *
 * @example
 *
 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 *      R.concat([], []); //=> []
 */

var concat_concat =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function concat(a, b) {
  if (_isArray(a)) {
    if (_isArray(b)) {
      return a.concat(b);
    }

    throw new TypeError(toString(b) + ' is not an array');
  }

  if (_isString(a)) {
    if (_isString(b)) {
      return a + b;
    }

    throw new TypeError(toString(b) + ' is not a string');
  }

  if (a != null && _isFunction(a['fantasy-land/concat'])) {
    return a['fantasy-land/concat'](b);
  }

  if (a != null && _isFunction(a.concat)) {
    return a.concat(b);
  }

  throw new TypeError(toString(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
})));

/* harmony default export */ var es_concat = ((/* unused pure expression or super */ null && (concat_concat)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/cond.js





/**
 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
 * to `fn` are applied to each of the predicates in turn until one returns a
 * "truthy" value, at which point `fn` returns the result of applying its
 * arguments to the corresponding transformer. If none of the predicates
 * matches, `fn` returns undefined.
 *
 * **Please note**: This is not a direct substitute for a `switch` statement.
 * Remember that both elements of every pair passed to `cond` are *functions*,
 * and `cond` returns a function.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Logic
 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
 * @param {Array} pairs A list of [predicate, transformer]
 * @return {Function}
 * @see R.ifElse, R.unless, R.when
 * @example
 *
 *      const fn = R.cond([
 *        [R.equals(0),   R.always('water freezes at 0°C')],
 *        [R.equals(100), R.always('water boils at 100°C')],
 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
 *      ]);
 *      fn(0); //=> 'water freezes at 0°C'
 *      fn(50); //=> 'nothing special happens at 50°C'
 *      fn(100); //=> 'water boils at 100°C'
 */

var cond =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry1(function cond(pairs) {
  var arity = reduce(max, 0, map(function (pair) {
    return pair[0].length;
  }, pairs));
  return _arity(arity, function () {
    var idx = 0;

    while (idx < pairs.length) {
      if (pairs[idx][0].apply(this, arguments)) {
        return pairs[idx][1].apply(this, arguments);
      }

      idx += 1;
    }
  });
})));

/* harmony default export */ var es_cond = ((/* unused pure expression or super */ null && (cond)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/max.js

/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */

var max_max =
/*#__PURE__*/
_curry2_curry2(function max(a, b) {
  return b > a ? b : a;
});

/* harmony default export */ var es_max = (max_max);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/converge.js






/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. The arity of the new function is the same as the arity of
 * the longest branching function. When invoked, this new function is applied
 * to some arguments, and each branching function is applied to those same
 * arguments. The results of each branching function are passed as arguments
 * to the converging function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      const average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      const strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */

var converge =
/*#__PURE__*/
_curry2_curry2(function converge(after, fns) {
  return es_curryN(es_reduce(es_max, 0, es_pluck('length', fns)), function () {
    var args = arguments;
    var context = this;
    return after.apply(context, _map_map(function (fn) {
      return fn.apply(context, args);
    }, fns));
  });
});

/* harmony default export */ var es_converge = (converge);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/count.js


/**
 * Returns the number of items in a given `list` matching the predicate `f`
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} predicate to match items against
 * @return {Array} list of items to count in
 * @example
 *
 *      const even = x => x % 2 == 0;
 *
 *      R.count(even, [1, 2, 3, 4, 5]); // => 2
 *      R.map(R.count(even), [[1, 1, 1], [2, 3, 4, 5], [6]]); // => [0, 2, 1]
 */

var count =
/*#__PURE__*/
(/* unused pure expression or super */ null && (curry(function (pred, list) {
  return _reduce(function (a, e) {
    return pred(e) ? a + 1 : a;
  }, 0, list);
})));
/* harmony default export */ var es_count = ((/* unused pure expression or super */ null && (count)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_cloneRegExp.js
function _cloneRegExp(pattern) {
  return new RegExp(pattern.source, (pattern.global ? 'g' : '') + (pattern.ignoreCase ? 'i' : '') + (pattern.multiline ? 'm' : '') + (pattern.sticky ? 'y' : '') + (pattern.unicode ? 'u' : ''));
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_clone.js


/**
 * Copies an object.
 *
 * @private
 * @param {*} value The value to be copied
 * @param {Array} refFrom Array containing the source references
 * @param {Array} refTo Array containing the copied source references
 * @param {Boolean} deep Whether or not to perform deep cloning.
 * @return {*} The copied value.
 */

function _clone_clone(value, refFrom, refTo, deep) {
  var copy = function copy(copiedValue) {
    var len = refFrom.length;
    var idx = 0;

    while (idx < len) {
      if (value === refFrom[idx]) {
        return refTo[idx];
      }

      idx += 1;
    }

    refFrom[idx] = value;
    refTo[idx] = copiedValue;

    for (var key in value) {
      if (value.hasOwnProperty(key)) {
        copiedValue[key] = deep ? _clone_clone(value[key], refFrom, refTo, true) : value[key];
      }
    }

    return copiedValue;
  };

  switch (es_type(value)) {
    case 'Object':
      return copy(Object.create(Object.getPrototypeOf(value)));

    case 'Array':
      return copy([]);

    case 'Date':
      return new Date(value.valueOf());

    case 'RegExp':
      return _cloneRegExp(value);

    case 'Int8Array':
    case 'Uint8Array':
    case 'Uint8ClampedArray':
    case 'Int16Array':
    case 'Uint16Array':
    case 'Int32Array':
    case 'Uint32Array':
    case 'Float32Array':
    case 'Float64Array':
    case 'BigInt64Array':
    case 'BigUint64Array':
      return value.slice();

    default:
      return value;
  }
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xreduceBy.js




var XReduceBy =
/*#__PURE__*/
function () {
  function XReduceBy(valueFn, valueAcc, keyFn, xf) {
    this.valueFn = valueFn;
    this.valueAcc = valueAcc;
    this.keyFn = keyFn;
    this.xf = xf;
    this.inputs = {};
  }

  XReduceBy.prototype['@@transducer/init'] = _xfBase.init;

  XReduceBy.prototype['@@transducer/result'] = function (result) {
    var key;

    for (key in this.inputs) {
      if (_has_has(key, this.inputs)) {
        result = this.xf['@@transducer/step'](result, this.inputs[key]);

        if (result['@@transducer/reduced']) {
          result = result['@@transducer/value'];
          break;
        }
      }
    }

    this.inputs = null;
    return this.xf['@@transducer/result'](result);
  };

  XReduceBy.prototype['@@transducer/step'] = function (result, input) {
    var key = this.keyFn(input);
    this.inputs[key] = this.inputs[key] || [key, this.valueAcc];
    this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
    return result;
  };

  return XReduceBy;
}();

var _xreduceBy =
/*#__PURE__*/
_curryN_curryN(4, [], function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
  return new XReduceBy(valueFn, valueAcc, keyFn, xf);
});

/* harmony default export */ var internal_xreduceBy = (_xreduceBy);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/reduceBy.js







/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * The value function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to short circuit the iteration.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce, R.reduced
 * @example
 *
 *      const groupNames = (acc, {name}) => acc.concat(name)
 *      const toGrade = ({score}) =>
 *        score < 65 ? 'F' :
 *        score < 70 ? 'D' :
 *        score < 80 ? 'C' :
 *        score < 90 ? 'B' : 'A'
 *
 *      var students = [
 *        {name: 'Abby', score: 83},
 *        {name: 'Bart', score: 62},
 *        {name: 'Curt', score: 88},
 *        {name: 'Dora', score: 92},
 *      ]
 *
 *      reduceBy(groupNames, [], toGrade, students)
 *      //=> {"A": ["Dora"], "B": ["Abby", "Curt"], "F": ["Bart"]}
 */

var reduceBy_reduceBy =
/*#__PURE__*/
_curryN_curryN(4, [],
/*#__PURE__*/
_dispatchable([], internal_xreduceBy, function reduceBy(valueFn, valueAcc, keyFn, list) {
  return _reduce_reduce(function (acc, elt) {
    var key = keyFn(elt);
    var value = valueFn(_has_has(key, acc) ? acc[key] : _clone_clone(valueAcc, [], [], false), elt);

    if (value && value['@@transducer/reduced']) {
      return _reduced_reduced(acc);
    }

    acc[key] = value;
    return acc;
  }, {}, list);
}));

/* harmony default export */ var es_reduceBy = (reduceBy_reduceBy);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/countBy.js

/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      const numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      const letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */

var countBy =
/*#__PURE__*/
(/* unused pure expression or super */ null && (reduceBy(function (acc, elem) {
  return acc + 1;
}, 0)));
/* harmony default export */ var es_countBy = ((/* unused pure expression or super */ null && (countBy)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_Set.js


var _Set_Set =
/*#__PURE__*/
function () {
  function _Set() {
    /* globals Set */
    this._nativeSet = typeof Set === 'function' ? new Set() : null;
    this._items = {};
  }

  // until we figure out why jsdoc chokes on this
  // @param item The item to add to the Set
  // @returns {boolean} true if the item did not exist prior, otherwise false
  //
  _Set.prototype.add = function (item) {
    return !hasOrAdd(item, true, this);
  }; //
  // @param item The item to check for existence in the Set
  // @returns {boolean} true if the item exists in the Set, otherwise false
  //


  _Set.prototype.has = function (item) {
    return hasOrAdd(item, false, this);
  }; //
  // Combines the logic for checking whether an item is a member of the set and
  // for adding a new item to the set.
  //
  // @param item       The item to check or add to the Set instance.
  // @param shouldAdd  If true, the item will be added to the set if it doesn't
  //                   already exist.
  // @param set        The set instance to check or add to.
  // @return {boolean} true if the item already existed, otherwise false.
  //


  return _Set;
}();

function hasOrAdd(item, shouldAdd, set) {
  var type = typeof item;
  var prevSize, newSize;

  switch (type) {
    case 'string':
    case 'number':
      // distinguish between +0 and -0
      if (item === 0 && 1 / item === -Infinity) {
        if (set._items['-0']) {
          return true;
        } else {
          if (shouldAdd) {
            set._items['-0'] = true;
          }

          return false;
        }
      } // these types can all utilise the native Set


      if (set._nativeSet !== null) {
        if (shouldAdd) {
          prevSize = set._nativeSet.size;

          set._nativeSet.add(item);

          newSize = set._nativeSet.size;
          return newSize === prevSize;
        } else {
          return set._nativeSet.has(item);
        }
      } else {
        if (!(type in set._items)) {
          if (shouldAdd) {
            set._items[type] = {};
            set._items[type][item] = true;
          }

          return false;
        } else if (item in set._items[type]) {
          return true;
        } else {
          if (shouldAdd) {
            set._items[type][item] = true;
          }

          return false;
        }
      }

    case 'boolean':
      // set._items['boolean'] holds a two element array
      // representing [ falseExists, trueExists ]
      if (type in set._items) {
        var bIdx = item ? 1 : 0;

        if (set._items[type][bIdx]) {
          return true;
        } else {
          if (shouldAdd) {
            set._items[type][bIdx] = true;
          }

          return false;
        }
      } else {
        if (shouldAdd) {
          set._items[type] = item ? [false, true] : [true, false];
        }

        return false;
      }

    case 'function':
      // compare functions for reference equality
      if (set._nativeSet !== null) {
        if (shouldAdd) {
          prevSize = set._nativeSet.size;

          set._nativeSet.add(item);

          newSize = set._nativeSet.size;
          return newSize === prevSize;
        } else {
          return set._nativeSet.has(item);
        }
      } else {
        if (!(type in set._items)) {
          if (shouldAdd) {
            set._items[type] = [item];
          }

          return false;
        }

        if (!_includes_includes(item, set._items[type])) {
          if (shouldAdd) {
            set._items[type].push(item);
          }

          return false;
        }

        return true;
      }

    case 'undefined':
      if (set._items[type]) {
        return true;
      } else {
        if (shouldAdd) {
          set._items[type] = true;
        }

        return false;
      }

    case 'object':
      if (item === null) {
        if (!set._items['null']) {
          if (shouldAdd) {
            set._items['null'] = true;
          }

          return false;
        }

        return true;
      }

    /* falls through */

    default:
      // reduce the search size of heterogeneous sets by creating buckets
      // for each type.
      type = Object.prototype.toString.call(item);

      if (!(type in set._items)) {
        if (shouldAdd) {
          set._items[type] = [item];
        }

        return false;
      } // scan through all previously applied items


      if (!_includes_includes(item, set._items[type])) {
        if (shouldAdd) {
          set._items[type].push(item);
        }

        return false;
      }

      return true;
  }
} // A simple Set type that honours R.equals semantics


/* harmony default export */ var internal_Set = (_Set_Set);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/difference.js


/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Objects and Arrays are compared in terms of
 * value equality, not reference equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
 * @example
 *
 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
 */

var difference_difference =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function difference(first, second) {
  var out = [];
  var idx = 0;
  var firstLen = first.length;
  var secondLen = second.length;
  var toFilterOut = new _Set();

  for (var i = 0; i < secondLen; i += 1) {
    toFilterOut.add(second[i]);
  }

  while (idx < firstLen) {
    if (toFilterOut.add(first[idx])) {
      out[out.length] = first[idx];
    }

    idx += 1;
  }

  return out;
})));

/* harmony default export */ var es_difference = ((/* unused pure expression or super */ null && (difference_difference)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_dissoc.js



/**
 * Returns a new object that does not contain a `prop` property.
 *
 * @private
 * @param {String|Number} prop The name of the property to dissociate
 * @param {Object|Array} obj The object to clone
 * @return {Object} A new object equivalent to the original but without the specified property
 */

function _dissoc_dissoc(prop, obj) {
  if (obj == null) {
    return obj;
  }

  if (_isInteger(prop) && _isArray(obj)) {
    return remove(prop, 1, obj);
  }

  var result = {};

  for (var p in obj) {
    result[p] = obj[p];
  }

  delete result[prop];
  return result;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/dissocPath.js





/**
 * Makes a shallow clone of an object. Note that this copies and flattens
 * prototype properties onto the new object as well. All non-primitive
 * properties are copied by reference.
 *
 * @private
 * @param {String|Integer} prop The prop operating
 * @param {Object|Array} obj The object to clone
 * @return {Object|Array} A new object equivalent to the original.
 */

function _shallowCloneObject(prop, obj) {
  if (_isInteger(prop) && _isArray(obj)) {
    return [].concat(obj);
  }

  var result = {};

  for (var p in obj) {
    result[p] = obj[p];
  }

  return result;
}
/**
 * Makes a shallow clone of an object, omitting the property at the given path.
 * Note that this copies and flattens prototype properties onto the new object
 * as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.11.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> {k: v} -> {k: v}
 * @param {Array} path The path to the value to omit
 * @param {Object} obj The object to clone
 * @return {Object} A new object without the property at path
 * @see R.assocPath
 * @example
 *
 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
 */


var dissocPath_dissocPath =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function dissocPath(path, obj) {
  if (obj == null) {
    return obj;
  }

  switch (path.length) {
    case 0:
      return obj;

    case 1:
      return _dissoc(path[0], obj);

    default:
      var head = path[0];
      var tail = Array.prototype.slice.call(path, 1);

      if (obj[head] == null) {
        return _shallowCloneObject(head, obj);
      } else {
        return assoc(head, dissocPath(tail, obj[head]), obj);
      }

  }
})));

/* harmony default export */ var es_dissocPath = ((/* unused pure expression or super */ null && (dissocPath_dissocPath)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/dissoc.js


/**
 * Returns a new object that does not contain a `prop` property.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Object
 * @sig String -> {k: v} -> {k: v}
 * @param {String} prop The name of the property to dissociate
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original but without the specified property
 * @see R.assoc, R.omit
 * @example
 *
 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
 */

var dissoc =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function dissoc(prop, obj) {
  return dissocPath([prop], obj);
})));

/* harmony default export */ var es_dissoc = ((/* unused pure expression or super */ null && (dissoc)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xdrop.js



var XDrop =
/*#__PURE__*/
function () {
  function XDrop(n, xf) {
    this.xf = xf;
    this.n = n;
  }

  XDrop.prototype['@@transducer/init'] = _xfBase.init;
  XDrop.prototype['@@transducer/result'] = _xfBase.result;

  XDrop.prototype['@@transducer/step'] = function (result, input) {
    if (this.n > 0) {
      this.n -= 1;
      return result;
    }

    return this.xf['@@transducer/step'](result, input);
  };

  return XDrop;
}();

var _xdrop =
/*#__PURE__*/
_curry2_curry2(function _xdrop(n, xf) {
  return new XDrop(n, xf);
});

/* harmony default export */ var internal_xdrop = (_xdrop);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/drop.js




/**
 * Returns all but the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `drop` method).
 *
 * Dispatches to the `drop` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*} A copy of list without the first `n` elements
 * @see R.take, R.transduce, R.dropLast, R.dropWhile
 * @example
 *
 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(3, 'ramda');               //=> 'da'
 */

var drop_drop =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable(['drop'], internal_xdrop, function drop(n, xs) {
  return es_slice(Math.max(0, n), Infinity, xs);
}));

/* harmony default export */ var es_drop = ((/* unused pure expression or super */ null && (drop_drop)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xtake.js




var XTake =
/*#__PURE__*/
function () {
  function XTake(n, xf) {
    this.xf = xf;
    this.n = n;
    this.i = 0;
  }

  XTake.prototype['@@transducer/init'] = _xfBase.init;
  XTake.prototype['@@transducer/result'] = _xfBase.result;

  XTake.prototype['@@transducer/step'] = function (result, input) {
    this.i += 1;
    var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
    return this.n >= 0 && this.i >= this.n ? _reduced_reduced(ret) : ret;
  };

  return XTake;
}();

var _xtake =
/*#__PURE__*/
_curry2_curry2(function _xtake(n, xf) {
  return new XTake(n, xf);
});

/* harmony default export */ var internal_xtake = (_xtake);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/take.js




/**
 * Returns the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `take` method).
 *
 * Dispatches to the `take` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*}
 * @see R.drop
 * @example
 *
 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(3, 'ramda');               //=> 'ram'
 *
 *      const personnel = [
 *        'Dave Brubeck',
 *        'Paul Desmond',
 *        'Eugene Wright',
 *        'Joe Morello',
 *        'Gerry Mulligan',
 *        'Bob Bates',
 *        'Joe Dodge',
 *        'Ron Crotty'
 *      ];
 *
 *      const takeFive = R.take(5);
 *      takeFive(personnel);
 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
 * @symb R.take(-1, [a, b]) = [a, b]
 * @symb R.take(0, [a, b]) = []
 * @symb R.take(1, [a, b]) = [a]
 * @symb R.take(2, [a, b]) = [a, b]
 */

var take_take =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable(['take'], internal_xtake, function take(n, xs) {
  return es_slice(0, n < 0 ? Infinity : n, xs);
}));

/* harmony default export */ var es_take = (take_take);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_dropLast.js

function dropLast(n, xs) {
  return es_take(n < xs.length ? xs.length - n : 0, xs);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xdropLast.js



var XDropLast =
/*#__PURE__*/
function () {
  function XDropLast(n, xf) {
    this.xf = xf;
    this.pos = 0;
    this.full = false;
    this.acc = new Array(n);
  }

  XDropLast.prototype['@@transducer/init'] = _xfBase.init;

  XDropLast.prototype['@@transducer/result'] = function (result) {
    this.acc = null;
    return this.xf['@@transducer/result'](result);
  };

  XDropLast.prototype['@@transducer/step'] = function (result, input) {
    if (this.full) {
      result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
    }

    this.store(input);
    return result;
  };

  XDropLast.prototype.store = function (input) {
    this.acc[this.pos] = input;
    this.pos += 1;

    if (this.pos === this.acc.length) {
      this.pos = 0;
      this.full = true;
    }
  };

  return XDropLast;
}();

var _xdropLast =
/*#__PURE__*/
_curry2_curry2(function _xdropLast(n, xf) {
  return new XDropLast(n, xf);
});

/* harmony default export */ var internal_xdropLast = (_xdropLast);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/dropLast.js




/**
 * Returns a list containing all but the last `n` elements of the given `list`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements of `list` to skip.
 * @param {Array} list The list of elements to consider.
 * @return {Array} A copy of the list with only the first `list.length - n` elements
 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
 * @example
 *
 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(3, 'ramda');               //=> 'ra'
 */

var dropLast_dropLast =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable([], internal_xdropLast, dropLast));

/* harmony default export */ var es_dropLast = ((/* unused pure expression or super */ null && (dropLast_dropLast)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_dropLastWhile.js

function dropLastWhile(pred, xs) {
  var idx = xs.length - 1;

  while (idx >= 0 && pred(xs[idx])) {
    idx -= 1;
  }

  return es_slice(0, idx + 1, xs);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xdropLastWhile.js




var XDropLastWhile =
/*#__PURE__*/
function () {
  function XDropLastWhile(fn, xf) {
    this.f = fn;
    this.retained = [];
    this.xf = xf;
  }

  XDropLastWhile.prototype['@@transducer/init'] = _xfBase.init;

  XDropLastWhile.prototype['@@transducer/result'] = function (result) {
    this.retained = null;
    return this.xf['@@transducer/result'](result);
  };

  XDropLastWhile.prototype['@@transducer/step'] = function (result, input) {
    return this.f(input) ? this.retain(result, input) : this.flush(result, input);
  };

  XDropLastWhile.prototype.flush = function (result, input) {
    result = _reduce_reduce(this.xf['@@transducer/step'], result, this.retained);
    this.retained = [];
    return this.xf['@@transducer/step'](result, input);
  };

  XDropLastWhile.prototype.retain = function (result, input) {
    this.retained.push(input);
    return result;
  };

  return XDropLastWhile;
}();

var _xdropLastWhile =
/*#__PURE__*/
_curry2_curry2(function _xdropLastWhile(fn, xf) {
  return new XDropLastWhile(fn, xf);
});

/* harmony default export */ var internal_xdropLastWhile = (_xdropLastWhile);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/dropLastWhile.js




/**
 * Returns a new list excluding all the tailing elements of a given list which
 * satisfy the supplied predicate function. It passes each value from the right
 * to the supplied predicate function, skipping elements until the predicate
 * function returns a `falsy` value. The predicate function is applied to one argument:
 * *(value)*.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} predicate The function to be called on each element
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
 * @example
 *
 *      const lteThree = x => x <= 3;
 *
 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
 *
 *      R.dropLastWhile(x => x !== 'd' , 'Ramda'); //=> 'Ramd'
 */

var dropLastWhile_dropLastWhile =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable([], internal_xdropLastWhile, dropLastWhile));

/* harmony default export */ var es_dropLastWhile = ((/* unused pure expression or super */ null && (dropLastWhile_dropLastWhile)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xdropRepeatsWith.js



var XDropRepeatsWith =
/*#__PURE__*/
function () {
  function XDropRepeatsWith(pred, xf) {
    this.xf = xf;
    this.pred = pred;
    this.lastValue = undefined;
    this.seenFirstValue = false;
  }

  XDropRepeatsWith.prototype['@@transducer/init'] = _xfBase.init;
  XDropRepeatsWith.prototype['@@transducer/result'] = _xfBase.result;

  XDropRepeatsWith.prototype['@@transducer/step'] = function (result, input) {
    var sameAsLast = false;

    if (!this.seenFirstValue) {
      this.seenFirstValue = true;
    } else if (this.pred(this.lastValue, input)) {
      sameAsLast = true;
    }

    this.lastValue = input;
    return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
  };

  return XDropRepeatsWith;
}();

var _xdropRepeatsWith =
/*#__PURE__*/
_curry2_curry2(function _xdropRepeatsWith(pred, xf) {
  return new XDropRepeatsWith(pred, xf);
});

/* harmony default export */ var internal_xdropRepeatsWith = (_xdropRepeatsWith);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/last.js

/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */

var last =
/*#__PURE__*/
es_nth(-1);
/* harmony default export */ var es_last = (last);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/dropRepeatsWith.js




/**
 * Returns a new list without any consecutively repeating elements. Equality is
 * determined by applying the supplied predicate to each pair of consecutive elements. The
 * first element in a series of equal elements will be preserved.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *      const l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
 */

var dropRepeatsWith =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable([], internal_xdropRepeatsWith, function dropRepeatsWith(pred, list) {
  var result = [];
  var idx = 1;
  var len = list.length;

  if (len !== 0) {
    result[0] = list[0];

    while (idx < len) {
      if (!pred(es_last(result), list[idx])) {
        result[result.length] = list[idx];
      }

      idx += 1;
    }
  }

  return result;
}));

/* harmony default export */ var es_dropRepeatsWith = (dropRepeatsWith);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/dropRepeats.js





/**
 * Returns a new list without any consecutively repeating elements.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
 */

var dropRepeats =
/*#__PURE__*/
_curry1_curry1(
/*#__PURE__*/
_dispatchable([],
/*#__PURE__*/
internal_xdropRepeatsWith(es_equals),
/*#__PURE__*/
es_dropRepeatsWith(es_equals)));

/* harmony default export */ var es_dropRepeats = ((/* unused pure expression or super */ null && (dropRepeats)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xdropWhile.js



var XDropWhile =
/*#__PURE__*/
function () {
  function XDropWhile(f, xf) {
    this.xf = xf;
    this.f = f;
  }

  XDropWhile.prototype['@@transducer/init'] = _xfBase.init;
  XDropWhile.prototype['@@transducer/result'] = _xfBase.result;

  XDropWhile.prototype['@@transducer/step'] = function (result, input) {
    if (this.f) {
      if (this.f(input)) {
        return result;
      }

      this.f = null;
    }

    return this.xf['@@transducer/step'](result, input);
  };

  return XDropWhile;
}();

var _xdropWhile =
/*#__PURE__*/
_curry2_curry2(function _xdropWhile(f, xf) {
  return new XDropWhile(f, xf);
});

/* harmony default export */ var internal_xdropWhile = (_xdropWhile);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/dropWhile.js




/**
 * Returns a new list excluding the leading elements of a given list which
 * satisfy the supplied predicate function. It passes each value to the supplied
 * predicate function, skipping elements while the predicate function returns
 * `true`. The predicate function is applied to one argument: *(value)*.
 *
 * Dispatches to the `dropWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.takeWhile, R.transduce, R.addIndex
 * @example
 *
 *      const lteTwo = x => x <= 2;
 *
 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
 *
 *      R.dropWhile(x => x !== 'd' , 'Ramda'); //=> 'da'
 */

var dropWhile =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable(['dropWhile'], internal_xdropWhile, function dropWhile(pred, xs) {
  var idx = 0;
  var len = xs.length;

  while (idx < len && pred(xs[idx])) {
    idx += 1;
  }

  return es_slice(idx, Infinity, xs);
}));

/* harmony default export */ var es_dropWhile = ((/* unused pure expression or super */ null && (dropWhile)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/either.js




/**
 * A function wrapping calls to the two functions in an `||` operation,
 * returning the result of the first function if it is truth-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * truth-y value.
 *
 * In addition to functions, `R.either` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f a predicate
 * @param {Function} g another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
 * @see R.both, R.or
 * @example
 *
 *      const gt10 = x => x > 10;
 *      const even = x => x % 2 === 0;
 *      const f = R.either(gt10, even);
 *      f(101); //=> true
 *      f(8); //=> true
 *
 *      R.either(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(55)
 *      R.either([false, false, 'a'], [11]) // => [11, 11, "a"]
 */

var either =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function either(f, g) {
  return _isFunction(f) ? function _either() {
    return f.apply(this, arguments) || g.apply(this, arguments);
  } : lift(or)(f, g);
})));

/* harmony default export */ var es_either = ((/* unused pure expression or super */ null && (either)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/empty.js






/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`),
 * TypedArray (`Uint8Array []`, `Float32Array []`, etc), and Arguments. Other
 * types are supported if they define `<Type>.empty`,
 * `<Type>.prototype.empty` or implement the
 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));               //=> Nothing()
 *      R.empty([1, 2, 3]);              //=> []
 *      R.empty('unicorns');             //=> ''
 *      R.empty({x: 1, y: 2});           //=> {}
 *      R.empty(Uint8Array.from('123')); //=> Uint8Array []
 */

var empty_empty =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry1(function empty(x) {
  return x != null && typeof x['fantasy-land/empty'] === 'function' ? x['fantasy-land/empty']() : x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function' ? x.constructor['fantasy-land/empty']() : x != null && typeof x.empty === 'function' ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === 'function' ? x.constructor.empty() : _isArray(x) ? [] : _isString(x) ? '' : _isObject(x) ? {} : _isArguments(x) ? function () {
    return arguments;
  }() : _isTypedArray(x) ? x.constructor.from('') : void 0 // else
  ;
})));

/* harmony default export */ var es_empty = ((/* unused pure expression or super */ null && (empty_empty)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/takeLast.js


/**
 * Returns a new list containing the last `n` elements of the given list.
 * If `n > list.length`, returns a list of `list.length` elements.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements to return.
 * @param {Array} xs The collection to consider.
 * @return {Array}
 * @see R.dropLast
 * @example
 *
 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(3, 'ramda');               //=> 'mda'
 */

var takeLast_takeLast =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function takeLast(n, xs) {
  return drop(n >= 0 ? xs.length - n : 0, xs);
})));

/* harmony default export */ var es_takeLast = ((/* unused pure expression or super */ null && (takeLast_takeLast)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/endsWith.js



/**
 * Checks if a list ends with the provided sublist.
 *
 * Similarly, checks if a string ends with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} suffix
 * @param {*} list
 * @return {Boolean}
 * @see R.startsWith
 * @example
 *
 *      R.endsWith('c', 'abc')                //=> true
 *      R.endsWith('b', 'abc')                //=> false
 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
 */

var endsWith =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function (suffix, list) {
  return equals(takeLast(suffix.length, list), suffix);
})));

/* harmony default export */ var es_endsWith = ((/* unused pure expression or super */ null && (endsWith)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/eqBy.js


/**
 * Takes a function and two values in its domain and returns `true` if the
 * values map to the same value in the codomain; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Relation
 * @sig (a -> b) -> a -> a -> Boolean
 * @param {Function} f
 * @param {*} x
 * @param {*} y
 * @return {Boolean}
 * @example
 *
 *      R.eqBy(Math.abs, 5, -5); //=> true
 */

var eqBy =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry3(function eqBy(f, x, y) {
  return equals(f(x), f(y));
})));

/* harmony default export */ var es_eqBy = ((/* unused pure expression or super */ null && (eqBy)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/eqProps.js


/**
 * Reports whether two objects have the same value, in [`R.equals`](#equals)
 * terms, for the specified property. Useful as a curried predicate.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig k -> {k: v} -> {k: v} -> Boolean
 * @param {String} prop The name of the property to compare
 * @param {Object} obj1
 * @param {Object} obj2
 * @return {Boolean}
 *
 * @example
 *
 *      const o1 = { a: 1, b: 2, c: 3, d: 4 };
 *      const o2 = { a: 10, b: 20, c: 3, d: 40 };
 *      R.eqProps('a', o1, o2); //=> false
 *      R.eqProps('c', o1, o2); //=> true
 */

var eqProps =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry3(function eqProps(prop, obj1, obj2) {
  return equals(obj1[prop], obj2[prop]);
})));

/* harmony default export */ var es_eqProps = ((/* unused pure expression or super */ null && (eqProps)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/evolve.js



/**
 * Creates a new object by recursively evolving a shallow copy of `object`,
 * according to the `transformation` functions. All non-primitive properties
 * are copied by reference.
 *
 * A `transformation` function will not be invoked if its corresponding key
 * does not exist in the evolved object.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
 * @param {Object} transformations The object specifying transformation functions to apply
 *        to the object.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const tomato = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
 *      const transformations = {
 *        firstName: R.trim,
 *        lastName: R.trim, // Will not get invoked.
 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
 *      };
 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
 */

var evolve =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function evolve(transformations, object) {
  if (!_isObject(object) && !_isArray(object)) {
    return object;
  }

  var result = object instanceof Array ? [] : {};
  var transformation, key, type;

  for (key in object) {
    transformation = transformations[key];
    type = typeof transformation;
    result[key] = type === 'function' ? transformation(object[key]) : transformation && type === 'object' ? evolve(transformation, object[key]) : object[key];
  }

  return result;
})));

/* harmony default export */ var es_evolve = ((/* unused pure expression or super */ null && (evolve)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xfind.js




var XFind =
/*#__PURE__*/
function () {
  function XFind(f, xf) {
    this.xf = xf;
    this.f = f;
    this.found = false;
  }

  XFind.prototype['@@transducer/init'] = _xfBase.init;

  XFind.prototype['@@transducer/result'] = function (result) {
    if (!this.found) {
      result = this.xf['@@transducer/step'](result, void 0);
    }

    return this.xf['@@transducer/result'](result);
  };

  XFind.prototype['@@transducer/step'] = function (result, input) {
    if (this.f(input)) {
      this.found = true;
      result = _reduced_reduced(this.xf['@@transducer/step'](result, input));
    }

    return result;
  };

  return XFind;
}();

var _xfind =
/*#__PURE__*/
_curry2_curry2(function _xfind(f, xf) {
  return new XFind(f, xf);
});

/* harmony default export */ var internal_xfind = (_xfind);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/find.js



/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */

var find =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable(['find'], internal_xfind, function find(fn, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (fn(list[idx])) {
      return list[idx];
    }

    idx += 1;
  }
}));

/* harmony default export */ var es_find = ((/* unused pure expression or super */ null && (find)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xfindIndex.js




var XFindIndex =
/*#__PURE__*/
function () {
  function XFindIndex(f, xf) {
    this.xf = xf;
    this.f = f;
    this.idx = -1;
    this.found = false;
  }

  XFindIndex.prototype['@@transducer/init'] = _xfBase.init;

  XFindIndex.prototype['@@transducer/result'] = function (result) {
    if (!this.found) {
      result = this.xf['@@transducer/step'](result, -1);
    }

    return this.xf['@@transducer/result'](result);
  };

  XFindIndex.prototype['@@transducer/step'] = function (result, input) {
    this.idx += 1;

    if (this.f(input)) {
      this.found = true;
      result = _reduced_reduced(this.xf['@@transducer/step'](result, this.idx));
    }

    return result;
  };

  return XFindIndex;
}();

var _xfindIndex =
/*#__PURE__*/
_curry2_curry2(function _xfindIndex(f, xf) {
  return new XFindIndex(f, xf);
});

/* harmony default export */ var internal_xfindIndex = (_xfindIndex);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/findIndex.js



/**
 * Returns the index of the first element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce, R.indexOf
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
 */

var findIndex =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable([], internal_xfindIndex, function findIndex(fn, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (fn(list[idx])) {
      return idx;
    }

    idx += 1;
  }

  return -1;
}));

/* harmony default export */ var es_findIndex = ((/* unused pure expression or super */ null && (findIndex)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xfindLast.js



var XFindLast =
/*#__PURE__*/
function () {
  function XFindLast(f, xf) {
    this.xf = xf;
    this.f = f;
  }

  XFindLast.prototype['@@transducer/init'] = _xfBase.init;

  XFindLast.prototype['@@transducer/result'] = function (result) {
    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
  };

  XFindLast.prototype['@@transducer/step'] = function (result, input) {
    if (this.f(input)) {
      this.last = input;
    }

    return result;
  };

  return XFindLast;
}();

var _xfindLast =
/*#__PURE__*/
_curry2_curry2(function _xfindLast(f, xf) {
  return new XFindLast(f, xf);
});

/* harmony default export */ var internal_xfindLast = (_xfindLast);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/findLast.js



/**
 * Returns the last element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
 */

var findLast =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable([], internal_xfindLast, function findLast(fn, list) {
  var idx = list.length - 1;

  while (idx >= 0) {
    if (fn(list[idx])) {
      return list[idx];
    }

    idx -= 1;
  }
}));

/* harmony default export */ var es_findLast = ((/* unused pure expression or super */ null && (findLast)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xfindLastIndex.js



var XFindLastIndex =
/*#__PURE__*/
function () {
  function XFindLastIndex(f, xf) {
    this.xf = xf;
    this.f = f;
    this.idx = -1;
    this.lastIdx = -1;
  }

  XFindLastIndex.prototype['@@transducer/init'] = _xfBase.init;

  XFindLastIndex.prototype['@@transducer/result'] = function (result) {
    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.lastIdx));
  };

  XFindLastIndex.prototype['@@transducer/step'] = function (result, input) {
    this.idx += 1;

    if (this.f(input)) {
      this.lastIdx = this.idx;
    }

    return result;
  };

  return XFindLastIndex;
}();

var _xfindLastIndex =
/*#__PURE__*/
_curry2_curry2(function _xfindLastIndex(f, xf) {
  return new XFindLastIndex(f, xf);
});

/* harmony default export */ var internal_xfindLastIndex = (_xfindLastIndex);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/findLastIndex.js



/**
 * Returns the index of the last element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce, R.lastIndexOf
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
 */

var findLastIndex =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable([], internal_xfindLastIndex, function findLastIndex(fn, list) {
  var idx = list.length - 1;

  while (idx >= 0) {
    if (fn(list[idx])) {
      return idx;
    }

    idx -= 1;
  }

  return -1;
}));

/* harmony default export */ var es_findLastIndex = ((/* unused pure expression or super */ null && (findLastIndex)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/flatten.js


/**
 * Returns a new list by pulling every item out of it (and all its sub-arrays)
 * and putting them in a new array, depth-first.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b]
 * @param {Array} list The array to consider.
 * @return {Array} The flattened list.
 * @see R.unnest
 * @example
 *
 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
 */

var flatten =
/*#__PURE__*/
_curry1_curry1(
/*#__PURE__*/
_makeFlat(true));

/* harmony default export */ var es_flatten = (flatten);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/forEach.js


/**
 * Iterate over an input `list`, calling a provided function `fn` for each
 * element in the list.
 *
 * `fn` receives one argument: *(value)*.
 *
 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.forEach` method. For more
 * details on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
 *
 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
 * the original array. In some libraries this function is named `each`.
 *
 * Dispatches to the `forEach` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> *) -> [a] -> [a]
 * @param {Function} fn The function to invoke. Receives one argument, `value`.
 * @param {Array} list The list to iterate over.
 * @return {Array} The original list.
 * @see R.addIndex
 * @example
 *
 *      const printXPlusFive = x => console.log(x + 5);
 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
 *      // logs 6
 *      // logs 7
 *      // logs 8
 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
 */

var forEach =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(
/*#__PURE__*/
_checkForMethod('forEach', function forEach(fn, list) {
  var len = list.length;
  var idx = 0;

  while (idx < len) {
    fn(list[idx]);
    idx += 1;
  }

  return list;
}))));

/* harmony default export */ var es_forEach = ((/* unused pure expression or super */ null && (forEach)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/forEachObjIndexed.js


/**
 * Iterate over an input `object`, calling a provided function `fn` for each
 * key and value in the object.
 *
 * `fn` receives three argument: *(value, key, obj)*.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Object
 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
 * @param {Object} obj The object to iterate over.
 * @return {Object} The original object.
 * @example
 *
 *      const printKeyConcatValue = (value, key) => console.log(key + ':' + value);
 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
 *      // logs x:1
 *      // logs y:2
 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
 */

var forEachObjIndexed =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function forEachObjIndexed(fn, obj) {
  var keyList = keys(obj);
  var idx = 0;

  while (idx < keyList.length) {
    var key = keyList[idx];
    fn(obj[key], key, obj);
    idx += 1;
  }

  return obj;
})));

/* harmony default export */ var es_forEachObjIndexed = ((/* unused pure expression or super */ null && (forEachObjIndexed)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/groupBy.js



/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a key-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx a => (b -> a) -> [b] -> {a: [b]}
 * @param {Function} fn Function :: a -> Idx
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.reduceBy, R.transduce, R.indexBy
 * @example
 *
 *      const byGrade = R.groupBy(function(student) {
 *        const score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      const students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */

var groupBy =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_checkForMethod_checkForMethod('groupBy',
/*#__PURE__*/
es_reduceBy(function (acc, item) {
  acc.push(item);
  return acc;
}, [])));

/* harmony default export */ var es_groupBy = (groupBy);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/identical.js


/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * Note this is merely a curried version of ES6 `Object.is`.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      const o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */

var identical =
/*#__PURE__*/
_curry2_curry2(internal_objectIs);

/* harmony default export */ var es_identical = ((/* unused pure expression or super */ null && (identical)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/includes.js


/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 * Also works with strings.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.any
 * @example
 *
 *      R.includes(3, [1, 2, 3]); //=> true
 *      R.includes(4, [1, 2, 3]); //=> false
 *      R.includes({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.includes([42], [[42]]); //=> true
 *      R.includes('ba', 'banana'); //=>true
 */

var includes =
/*#__PURE__*/
_curry2_curry2(_includes_includes);

/* harmony default export */ var es_includes = ((/* unused pure expression or super */ null && (includes)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/indexBy.js

/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx a => (b -> a) -> [b] -> {a: b}
 * @param {Function} fn Function :: a -> Idx
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @see R.groupBy
 * @example
 *
 *      const list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */

var indexBy =
/*#__PURE__*/
es_reduceBy(function (acc, elem) {
  return elem;
}, null);
/* harmony default export */ var es_indexBy = (indexBy);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/indexOf.js



/**
 * Returns the position of the first occurrence of an item in an array, or -1
 * if the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.lastIndexOf, R.findIndex
 * @example
 *
 *      R.indexOf(3, [1,2,3,4]); //=> 2
 *      R.indexOf(10, [1,2,3,4]); //=> -1
 */

var indexOf =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function indexOf(target, xs) {
  return typeof xs.indexOf === 'function' && !_isArray(xs) ? xs.indexOf(target) : _indexOf(xs, target, 0);
})));

/* harmony default export */ var es_indexOf = ((/* unused pure expression or super */ null && (indexOf)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/init.js

/**
 * Returns all but the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.last, R.head, R.tail
 * @example
 *
 *      R.init([1, 2, 3]);  //=> [1, 2]
 *      R.init([1, 2]);     //=> [1]
 *      R.init([1]);        //=> []
 *      R.init([]);         //=> []
 *
 *      R.init('abc');  //=> 'ab'
 *      R.init('ab');   //=> 'a'
 *      R.init('a');    //=> ''
 *      R.init('');     //=> ''
 */

var init =
/*#__PURE__*/
(/* unused pure expression or super */ null && (slice(0, -1)));
/* harmony default export */ var es_init = ((/* unused pure expression or super */ null && (init)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/innerJoin.js



/**
 * Takes a predicate `pred`, a list `xs`, and a list `ys`, and returns a list
 * `xs'` comprising each of the elements of `xs` which is equal to one or more
 * elements of `ys` according to `pred`.
 *
 * `pred` must be a binary function expecting an element from each list.
 *
 * `xs`, `ys`, and `xs'` are treated as sets, semantically, so ordering should
 * not be significant, but since `xs'` is ordered the implementation guarantees
 * that its values are in the same order as they appear in `xs`. Duplicates are
 * not removed, so `xs'` may contain duplicates if `xs` contains duplicates.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Relation
 * @sig ((a, b) -> Boolean) -> [a] -> [b] -> [a]
 * @param {Function} pred
 * @param {Array} xs
 * @param {Array} ys
 * @return {Array}
 * @see R.intersection
 * @example
 *
 *      R.innerJoin(
 *        (record, id) => record.id === id,
 *        [{id: 824, name: 'Richie Furay'},
 *         {id: 956, name: 'Dewey Martin'},
 *         {id: 313, name: 'Bruce Palmer'},
 *         {id: 456, name: 'Stephen Stills'},
 *         {id: 177, name: 'Neil Young'}],
 *        [177, 456, 999]
 *      );
 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
 */

var innerJoin =
/*#__PURE__*/
_curry3_curry3(function innerJoin(pred, xs, ys) {
  return _filter_filter(function (x) {
    return _includesWith(pred, x, ys);
  }, xs);
});

/* harmony default export */ var es_innerJoin = (innerJoin);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_identity.js
function _identity(x) {
  return x;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/identity.js


/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      const obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */

var identity_identity =
/*#__PURE__*/
_curry1_curry1(_identity);

/* harmony default export */ var es_identity = (identity_identity);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xuniqBy.js




var XUniqBy =
/*#__PURE__*/
function () {
  function XUniqBy(f, xf) {
    this.xf = xf;
    this.f = f;
    this.set = new internal_Set();
  }

  XUniqBy.prototype['@@transducer/init'] = _xfBase.init;
  XUniqBy.prototype['@@transducer/result'] = _xfBase.result;

  XUniqBy.prototype['@@transducer/step'] = function (result, input) {
    return this.set.add(this.f(input)) ? this.xf['@@transducer/step'](result, input) : result;
  };

  return XUniqBy;
}();

var _xuniqBy =
/*#__PURE__*/
_curry2_curry2(function _xuniqBy(f, xf) {
  return new XUniqBy(f, xf);
});

/* harmony default export */ var internal_xuniqBy = (_xuniqBy);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/uniqBy.js




/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */

var uniqBy =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable([], internal_xuniqBy, function (fn, list) {
  var set = new internal_Set();
  var result = [];
  var idx = 0;
  var appliedItem, item;

  while (idx < list.length) {
    item = list[idx];
    appliedItem = fn(item);

    if (set.add(appliedItem)) {
      result.push(item);
    }

    idx += 1;
  }

  return result;
}));

/* harmony default export */ var es_uniqBy = (uniqBy);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/uniq.js


/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */

var uniq_uniq =
/*#__PURE__*/
es_uniqBy(es_identity);
/* harmony default export */ var es_uniq = (uniq_uniq);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/intersection.js





/**
 * Combines two lists into a set (i.e. no duplicates) composed of those
 * elements common to both lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The list of elements found in both `list1` and `list2`.
 * @see R.innerJoin
 * @example
 *
 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
 */

var intersection =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function intersection(list1, list2) {
  var lookupList, filteredList;

  if (list1.length > list2.length) {
    lookupList = list1;
    filteredList = list2;
  } else {
    lookupList = list2;
    filteredList = list1;
  }

  return uniq(_filter(flip(_includes)(lookupList), filteredList));
})));

/* harmony default export */ var es_intersection = ((/* unused pure expression or super */ null && (intersection)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/intersperse.js


/**
 * Creates a new list with the separator interposed between elements.
 *
 * Dispatches to the `intersperse` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} separator The element to add to the list.
 * @param {Array} list The list to be interposed.
 * @return {Array} The new list.
 * @example
 *
 *      R.intersperse('a', ['b', 'n', 'n', 's']); //=> ['b', 'a', 'n', 'a', 'n', 'a', 's']
 */

var intersperse =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(
/*#__PURE__*/
_checkForMethod('intersperse', function intersperse(separator, list) {
  var out = [];
  var idx = 0;
  var length = list.length;

  while (idx < length) {
    if (idx === length - 1) {
      out.push(list[idx]);
    } else {
      out.push(list[idx], separator);
    }

    idx += 1;
  }

  return out;
}))));

/* harmony default export */ var es_intersperse = ((/* unused pure expression or super */ null && (intersperse)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_objectAssign.js
 // Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign

function _objectAssign_objectAssign(target) {
  if (target == null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  var output = Object(target);
  var idx = 1;
  var length = arguments.length;

  while (idx < length) {
    var source = arguments[idx];

    if (source != null) {
      for (var nextKey in source) {
        if (_has_has(nextKey, source)) {
          output[nextKey] = source[nextKey];
        }
      }
    }

    idx += 1;
  }

  return output;
}

/* harmony default export */ var internal_objectAssign = (typeof Object.assign === 'function' ? Object.assign : _objectAssign_objectAssign);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/objOf.js

/**
 * Creates an object containing a single key:value pair.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @sig String -> a -> {String:a}
 * @param {String} key
 * @param {*} val
 * @return {Object}
 * @see R.pair
 * @example
 *
 *      const matchPhrases = R.compose(
 *        R.objOf('must'),
 *        R.map(R.objOf('match_phrase'))
 *      );
 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
 */

var objOf =
/*#__PURE__*/
_curry2_curry2(function objOf(key, val) {
  var obj = {};
  obj[key] = val;
  return obj;
});

/* harmony default export */ var es_objOf = (objOf);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_stepCat.js





var _stepCatArray = {
  '@@transducer/init': Array,
  '@@transducer/step': function (xs, x) {
    xs.push(x);
    return xs;
  },
  '@@transducer/result': _identity
};
var _stepCatString = {
  '@@transducer/init': String,
  '@@transducer/step': function (a, b) {
    return a + b;
  },
  '@@transducer/result': _identity
};
var _stepCatObject = {
  '@@transducer/init': Object,
  '@@transducer/step': function (result, input) {
    return internal_objectAssign(result, internal_isArrayLike(input) ? es_objOf(input[0], input[1]) : input);
  },
  '@@transducer/result': _identity
};
function _stepCat_stepCat(obj) {
  if (_isTransformer(obj)) {
    return obj;
  }

  if (_isArrayLike(obj)) {
    return _stepCatArray;
  }

  if (typeof obj === 'string') {
    return _stepCatString;
  }

  if (typeof obj === 'object') {
    return _stepCatObject;
  }

  throw new Error('Cannot create transformer for ' + obj);
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/into.js





/**
 * Transforms the items of the list with the transducer and appends the
 * transformed items to the accumulator using an appropriate iterator function
 * based on the accumulator type.
 *
 * The accumulator can be an array, string, object or a transformer. Iterated
 * items will be appended to arrays and concatenated to strings. Objects will
 * be merged directly or 2-item arrays will be merged as key, value pairs.
 *
 * The accumulator can also be a transformer object that provides a 2-arity
 * reducing iterator function, step, 0-arity initial value function, init, and
 * 1-arity result extraction function result. The step function is used as the
 * iterator function in reduce. The result function is used to convert the
 * final accumulator into the return type and in most cases is R.identity. The
 * init function is used to provide the initial accumulator.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the
 * transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig a -> (b -> b) -> [c] -> a
 * @param {*} acc The initial accumulator value.
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.transduce
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *
 *      R.into([], transducer, numbers); //=> [2, 3]
 *
 *      const intoArray = R.into([]);
 *      intoArray(transducer, numbers); //=> [2, 3]
 */

var into =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry3(function into(acc, xf, list) {
  return _isTransformer(acc) ? _reduce(xf(acc), acc['@@transducer/init'](), list) : _reduce(xf(_stepCat(acc)), _clone(acc, [], [], false), list);
})));

/* harmony default export */ var es_into = ((/* unused pure expression or super */ null && (into)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/invert.js



/**
 * Same as [`R.invertObj`](#invertObj), however this accounts for objects with
 * duplicate values by putting the values into an array.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: [ s, ... ]}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object with keys in an array.
 * @see R.invertObj
 * @example
 *
 *      const raceResultsByFirstName = {
 *        first: 'alice',
 *        second: 'jake',
 *        third: 'alice',
 *      };
 *      R.invert(raceResultsByFirstName);
 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
 */

var invert =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry1(function invert(obj) {
  var props = keys(obj);
  var len = props.length;
  var idx = 0;
  var out = {};

  while (idx < len) {
    var key = props[idx];
    var val = obj[key];
    var list = _has(val, out) ? out[val] : out[val] = [];
    list[list.length] = key;
    idx += 1;
  }

  return out;
})));

/* harmony default export */ var es_invert = ((/* unused pure expression or super */ null && (invert)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/invertObj.js


/**
 * Returns a new object with the keys of the given object as values, and the
 * values of the given object, which are coerced to strings, as keys. Note
 * that the last key found is preferred when handling the same value.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: s}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object
 * @see R.invert
 * @example
 *
 *      const raceResults = {
 *        first: 'alice',
 *        second: 'jake'
 *      };
 *      R.invertObj(raceResults);
 *      //=> { 'alice': 'first', 'jake':'second' }
 *
 *      // Alternatively:
 *      const raceResults = ['alice', 'jake'];
 *      R.invertObj(raceResults);
 *      //=> { 'alice': '0', 'jake':'1' }
 */

var invertObj =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry1(function invertObj(obj) {
  var props = keys(obj);
  var len = props.length;
  var idx = 0;
  var out = {};

  while (idx < len) {
    var key = props[idx];
    out[obj[key]] = key;
    idx += 1;
  }

  return out;
})));

/* harmony default export */ var es_invertObj = ((/* unused pure expression or super */ null && (invertObj)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isFunction.js
function _isFunction_isFunction(x) {
  var type = Object.prototype.toString.call(x);
  return type === '[object Function]' || type === '[object AsyncFunction]' || type === '[object GeneratorFunction]' || type === '[object AsyncGeneratorFunction]';
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/invoker.js




/**
 * Turns a named method with a specified arity into a function that can be
 * called directly supplied with arguments and a target object.
 *
 * The returned function is curried and accepts `arity + 1` parameters where
 * the final parameter is the target object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of any of the target object's methods to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *
 *      const sliceFrom = R.invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *      const sliceFrom6 = R.invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 *
 *      const dog = {
 *        speak: async () => 'Woof!'
 *      };
 *      const speak = R.invoker(0, 'speak');
 *      speak(dog).then(console.log) //~> 'Woof!'
 *
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */

var invoker_invoker =
/*#__PURE__*/
_curry2_curry2(function invoker(arity, method) {
  return es_curryN(arity + 1, function () {
    var target = arguments[arity];

    if (target != null && _isFunction_isFunction(target[method])) {
      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
    }

    throw new TypeError(es_toString(target) + ' does not have a method named "' + method + '"');
  });
});

/* harmony default export */ var es_invoker = (invoker_invoker);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/isEmpty.js



/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);           //=> false
 *      R.isEmpty([]);                  //=> true
 *      R.isEmpty('');                  //=> true
 *      R.isEmpty(null);                //=> false
 *      R.isEmpty({});                  //=> true
 *      R.isEmpty({length: 0});         //=> false
 *      R.isEmpty(Uint8Array.from('')); //=> true
 */

var isEmpty =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry1(function isEmpty(x) {
  return x != null && equals(x, empty(x));
})));

/* harmony default export */ var es_isEmpty = ((/* unused pure expression or super */ null && (isEmpty)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/join.js

/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      const spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */

var join =
/*#__PURE__*/
es_invoker(1, 'join');
/* harmony default export */ var es_join = (join);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/juxt.js


/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      const getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */

var juxt =
/*#__PURE__*/
_curry1_curry1(function juxt(fns) {
  return es_converge(function () {
    return Array.prototype.slice.call(arguments, 0);
  }, fns);
});

/* harmony default export */ var es_juxt = (juxt);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/lastIndexOf.js



/**
 * Returns the position of the last occurrence of an item in an array, or -1 if
 * the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.indexOf, R.findLastIndex
 * @example
 *
 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
 */

var lastIndexOf =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function lastIndexOf(target, xs) {
  if (typeof xs.lastIndexOf === 'function' && !_isArray(xs)) {
    return xs.lastIndexOf(target);
  } else {
    var idx = xs.length - 1;

    while (idx >= 0) {
      if (equals(xs[idx], target)) {
        return idx;
      }

      idx -= 1;
    }

    return -1;
  }
})));

/* harmony default export */ var es_lastIndexOf = ((/* unused pure expression or super */ null && (lastIndexOf)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/lens.js


/**
 * Returns a lens for the given getter and setter functions. The getter "gets"
 * the value of the focus; the setter "sets" the value of the focus. The setter
 * should not mutate the data structure.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
 * @param {Function} getter
 * @param {Function} setter
 * @return {Lens}
 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lens(R.prop('x'), R.assoc('x'));
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */

var lens_lens =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function lens(getter, setter) {
  return function (toFunctorFn) {
    return function (target) {
      return map(function (focus) {
        return setter(focus, target);
      }, toFunctorFn(getter(target)));
    };
  };
})));

/* harmony default export */ var es_lens = ((/* unused pure expression or super */ null && (lens_lens)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/lensIndex.js




/**
 * Returns a lens whose focus is the specified index.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Number -> Lens s a
 * @param {Number} n
 * @return {Lens}
 * @see R.view, R.set, R.over, R.nth
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
 */

var lensIndex =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry1(function lensIndex(n) {
  return lens(nth(n), update(n));
})));

/* harmony default export */ var es_lensIndex = ((/* unused pure expression or super */ null && (lensIndex)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/paths.js



/**
 * Retrieves the values at given paths of an object.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Object
 * @typedefn Idx = [String | Int | Symbol]
 * @sig [Idx] -> {a} -> [a | Undefined]
 * @param {Array} pathsArray The array of paths to be fetched.
 * @param {Object} obj The object to retrieve the nested properties from.
 * @return {Array} A list consisting of values at paths specified by "pathsArray".
 * @see R.path
 * @example
 *
 *      R.paths([['a', 'b'], ['p', 0, 'q']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, 3]
 *      R.paths([['a', 'b'], ['p', 'r']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, undefined]
 */

var paths_paths =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function paths(pathsArray, obj) {
  return pathsArray.map(function (paths) {
    var val = obj;
    var idx = 0;
    var p;

    while (idx < paths.length) {
      if (val == null) {
        return;
      }

      p = paths[idx];
      val = _isInteger(p) ? nth(p, val) : val[p];
      idx += 1;
    }

    return val;
  });
})));

/* harmony default export */ var es_paths = ((/* unused pure expression or super */ null && (paths_paths)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/path.js


/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop, R.nth
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 *      R.path(['a', 'b', 0], {a: {b: [1, 2, 3]}}); //=> 1
 *      R.path(['a', 'b', -2], {a: {b: [1, 2, 3]}}); //=> 2
 */

var path_path =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function path(pathAr, obj) {
  return paths([pathAr], obj)[0];
})));

/* harmony default export */ var es_path = ((/* unused pure expression or super */ null && (path_path)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/lensPath.js




/**
 * Returns a lens whose focus is the specified path.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig [Idx] -> Lens s a
 * @param {Array} path The path to use.
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xHeadYLens = R.lensPath(['x', 0, 'y']);
 *
 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> 2
 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
 */

var lensPath =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry1(function lensPath(p) {
  return lens(path(p), assocPath(p));
})));

/* harmony default export */ var es_lensPath = ((/* unused pure expression or super */ null && (lensPath)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/lensProp.js




/**
 * Returns a lens whose focus is the specified property.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig String -> Lens s a
 * @param {String} k
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */

var lensProp =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry1(function lensProp(k) {
  return lens(prop(k), assoc(k));
})));

/* harmony default export */ var es_lensProp = ((/* unused pure expression or super */ null && (lensProp)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/mapObjIndexed.js



/**
 * An Object-specific version of [`map`](#map). The function is applied to three
 * arguments: *(value, key, obj)*. If only the value is significant, use
 * [`map`](#map) instead.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig ((*, String, Object) -> *) -> Object -> Object
 * @param {Function} fn
 * @param {Object} obj
 * @return {Object}
 * @see R.map
 * @example
 *
 *      const xyz = { x: 1, y: 2, z: 3 };
 *      const prependKeyAndDouble = (num, key, obj) => key + (num * 2);
 *
 *      R.mapObjIndexed(prependKeyAndDouble, xyz); //=> { x: 'x2', y: 'y4', z: 'z6' }
 */

var mapObjIndexed =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function mapObjIndexed(fn, obj) {
  return _reduce(function (acc, key) {
    acc[key] = fn(obj[key], key, obj);
    return acc;
  }, {}, keys(obj));
})));

/* harmony default export */ var es_mapObjIndexed = ((/* unused pure expression or super */ null && (mapObjIndexed)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/match.js

/**
 * Tests a regular expression against a String. Note that this function will
 * return an empty array when there are no matches. This differs from
 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
 * which returns `null` when there are no matches.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig RegExp -> String -> [String | Undefined]
 * @param {RegExp} rx A regular expression.
 * @param {String} str The string to match against
 * @return {Array} The list of matches or empty array.
 * @see R.test
 * @example
 *
 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
 *      R.match(/a/, 'b'); //=> []
 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
 */

var match =
/*#__PURE__*/
_curry2_curry2(function match(rx, str) {
  return str.match(rx) || [];
});

/* harmony default export */ var es_match = (match);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/mathMod.js


/**
 * `mathMod` behaves like the modulo operator should mathematically, unlike the
 * `%` operator (and by extension, [`R.modulo`](#modulo)). So while
 * `-17 % 5` is `-2`, `mathMod(-17, 5)` is `3`. `mathMod` requires Integer
 * arguments, and returns NaN when the modulus is zero or negative.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} m The dividend.
 * @param {Number} p the modulus.
 * @return {Number} The result of `b mod a`.
 * @see R.modulo
 * @example
 *
 *      R.mathMod(-17, 5);  //=> 3
 *      R.mathMod(17, 5);   //=> 2
 *      R.mathMod(17, -5);  //=> NaN
 *      R.mathMod(17, 0);   //=> NaN
 *      R.mathMod(17.2, 5); //=> NaN
 *      R.mathMod(17, 5.3); //=> NaN
 *
 *      const clock = R.mathMod(R.__, 12);
 *      clock(15); //=> 3
 *      clock(24); //=> 0
 *
 *      const seventeenMod = R.mathMod(17);
 *      seventeenMod(3);  //=> 2
 *      seventeenMod(4);  //=> 1
 *      seventeenMod(10); //=> 7
 */

var mathMod =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function mathMod(m, p) {
  if (!_isInteger(m)) {
    return NaN;
  }

  if (!_isInteger(p) || p < 1) {
    return NaN;
  }

  return (m % p + p) % p;
})));

/* harmony default export */ var es_mathMod = ((/* unused pure expression or super */ null && (mathMod)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/add.js

/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */

var add =
/*#__PURE__*/
_curry2_curry2(function add(a, b) {
  return Number(a) + Number(b);
});

/* harmony default export */ var es_add = (add);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/sum.js


/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */

var sum_sum =
/*#__PURE__*/
es_reduce(es_add, 0);
/* harmony default export */ var es_sum = ((/* unused pure expression or super */ null && (sum_sum)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/mean.js


/**
 * Returns the mean of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.median
 * @example
 *
 *      R.mean([2, 7, 9]); //=> 6
 *      R.mean([]); //=> NaN
 */

var mean_mean =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry1(function mean(list) {
  return sum(list) / list.length;
})));

/* harmony default export */ var es_mean = ((/* unused pure expression or super */ null && (mean_mean)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/median.js


/**
 * Returns the median of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.mean
 * @example
 *
 *      R.median([2, 9, 7]); //=> 7
 *      R.median([7, 2, 10, 9]); //=> 8
 *      R.median([]); //=> NaN
 */

var median =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry1(function median(list) {
  var len = list.length;

  if (len === 0) {
    return NaN;
  }

  var width = 2 - len % 2;
  var idx = (len - width) / 2;
  return mean(Array.prototype.slice.call(list, 0).sort(function (a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }).slice(idx, idx + width));
})));

/* harmony default export */ var es_median = ((/* unused pure expression or super */ null && (median)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/mergeAll.js


/**
 * Creates one new object with the own properties from a list of objects.
 * If a key exists in more than one object, the value from the last
 * object it exists in will be used.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig [{k: v}] -> {k: v}
 * @param {Array} list An array of objects
 * @return {Object} A merged object.
 * @see R.reduce
 * @example
 *
 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
 */

var mergeAll =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry1(function mergeAll(list) {
  return _objectAssign.apply(null, [{}].concat(list));
})));

/* harmony default export */ var es_mergeAll = ((/* unused pure expression or super */ null && (mergeAll)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/mergeWithKey.js


/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */

var mergeWithKey =
/*#__PURE__*/
_curry3_curry3(function mergeWithKey(fn, l, r) {
  var result = {};
  var k;

  for (k in l) {
    if (_has_has(k, l)) {
      result[k] = _has_has(k, r) ? fn(k, l[k], r[k]) : l[k];
    }
  }

  for (k in r) {
    if (_has_has(k, r) && !_has_has(k, result)) {
      result[k] = r[k];
    }
  }

  return result;
});

/* harmony default export */ var es_mergeWithKey = (mergeWithKey);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/mergeDeepWithKey.js



/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */

var mergeDeepWithKey =
/*#__PURE__*/
_curry3_curry3(function mergeDeepWithKey(fn, lObj, rObj) {
  return es_mergeWithKey(function (k, lVal, rVal) {
    if (_isObject_isObject(lVal) && _isObject_isObject(rVal)) {
      return mergeDeepWithKey(fn, lVal, rVal);
    } else {
      return fn(k, lVal, rVal);
    }
  }, lObj, rObj);
});

/* harmony default export */ var es_mergeDeepWithKey = (mergeDeepWithKey);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/mergeDeepRight.js


/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                       { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
 */

var mergeDeepRight =
/*#__PURE__*/
_curry2_curry2(function mergeDeepRight(lObj, rObj) {
  return es_mergeDeepWithKey(function (k, lVal, rVal) {
    return rVal;
  }, lObj, rObj);
});

/* harmony default export */ var es_mergeDeepRight = (mergeDeepRight);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/mergeLeft.js


/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeRight, R.mergeDeepLeft, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeLeft({ 'age': 40 }, { 'name': 'fred', 'age': 10 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const resetToDefault = R.mergeLeft({x: 0});
 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeLeft(a, b) = {...b, ...a}
 */

var mergeLeft =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function mergeLeft(l, r) {
  return _objectAssign({}, r, l);
})));

/* harmony default export */ var es_mergeLeft = ((/* unused pure expression or super */ null && (mergeLeft)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/mergeRight.js


/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeLeft, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeRight({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const withDefaults = R.mergeRight({x: 0, y: 0});
 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeRight(a, b) = {...a, ...b}
 */

var mergeRight =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function mergeRight(l, r) {
  return _objectAssign({}, l, r);
})));

/* harmony default export */ var es_mergeRight = ((/* unused pure expression or super */ null && (mergeRight)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/min.js

/**
 * Returns the smaller of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.minBy, R.max
 * @example
 *
 *      R.min(789, 123); //=> 123
 *      R.min('a', 'b'); //=> 'a'
 */

var min =
/*#__PURE__*/
_curry2_curry2(function min(a, b) {
  return b < a ? b : a;
});

/* harmony default export */ var es_min = (min);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_modify.js


/**
 * Makes a shallow clone of an object, applying the given fn to the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @private
 * @param {String|Number} prop The property name to set
 * @param {Function} fn The function to apply to the property
 * @param {Object|Array} obj The object to clone
 * @return {Object|Array} A new object equivalent to the original except for the changed property.
 */

function _modify_modify(prop, fn, obj) {
  if (_isInteger(prop) && _isArray(obj)) {
    var arr = [].concat(obj);
    arr[prop] = fn(arr[prop]);
    return arr;
  }

  var result = {};

  for (var p in obj) {
    result[p] = obj[p];
  }

  result[prop] = fn(result[prop]);
  return result;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/modifyPath.js






/**
 * Creates a shallow clone of the passed object by applying an `fn` function
 * to the value at the given path.
 *
 * The function will not be invoked, and the object will not change
 * if its corresponding path does not exist in the object.
 * All non-primitive properties are copied to the new object by reference.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Object
 * @sig [Idx] -> (v -> v) -> {k: v} -> {k: v}
 * @param {Array} path The path to be modified.
 * @param {Function} fn The function to apply to the path.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const person = {name: 'James', address: { zipCode: '90216' }};
 *      R.modifyPath(['address', 'zipCode'], R.reverse, person); //=> {name: 'James', address: { zipCode: '61209' }}
 *
 *      // Can handle arrays too
 *      const person = {name: 'James', addresses: [{ zipCode: '90216' }]};
 *      R.modifyPath(['addresses', 0, 'zipCode'], R.reverse, person); //=> {name: 'James', addresses: [{ zipCode: '61209' }]}
 */

var modifyPath_modifyPath =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry3(function modifyPath(path, fn, object) {
  if (!_isObject(object) && !_isArray(object) || path.length === 0) {
    return object;
  }

  var idx = path[0];

  if (!_has(idx, object)) {
    return object;
  }

  if (path.length === 1) {
    return _modify(idx, fn, object);
  }

  var val = modifyPath(Array.prototype.slice.call(path, 1), fn, object[idx]);

  if (val === object[idx]) {
    return object;
  }

  return _assoc(idx, val, object);
})));

/* harmony default export */ var es_modifyPath = ((/* unused pure expression or super */ null && (modifyPath_modifyPath)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/modify.js


/**
 * Creates a copy of the passed object by applying an `fn` function to the given `prop` property.
 *
 * The function will not be invoked, and the object will not change
 * if its corresponding property does not exist in the object.
 * All non-primitive properties are copied to the new object by reference.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Object
 * @sig Idx -> (v -> v) -> {k: v} -> {k: v}
 * @param {String|Number} prop The property to be modified.
 * @param {Function} fn The function to apply to the property.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const person = {name: 'James', age: 20, pets: ['dog', 'cat']};
 *      R.modify('age', R.add(1), person); //=> {name: 'James', age: 21, pets: ['dog', 'cat']}
 *      R.modify('pets', R.append('turtle'), person); //=> {name: 'James', age: 20, pets: ['dog', 'cat', 'turtle']}
 */

var modify =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry3(function modify(prop, fn, object) {
  return modifyPath([prop], fn, object);
})));

/* harmony default export */ var es_modify = ((/* unused pure expression or super */ null && (modify)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/none.js



/**
 * Returns `true` if no elements of the list match the predicate, `false`
 * otherwise.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
 * @see R.all, R.any
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *      const isOdd = n => n % 2 !== 0;
 *
 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
 *      R.none(isOdd, [1, 3, 5, 7, 8, 11]); //=> false
 */

var none =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function none(fn, input) {
  return all(_complement(fn), input);
})));

/* harmony default export */ var es_none = ((/* unused pure expression or super */ null && (none)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_assertPromise.js


function _assertPromise_assertPromise(name, p) {
  if (p == null || !_isFunction(p.then)) {
    throw new TypeError('`' + name + '` expected a Promise, received ' + _toString(p, []));
  }
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/otherwise.js


/**
 * Returns the result of applying the onFailure function to the value inside
 * a failed promise. This is useful for handling rejected promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig (e -> b) -> (Promise e a) -> (Promise e b)
 * @sig (e -> (Promise f b)) -> (Promise e a) -> (Promise f b)
 * @param {Function} onFailure The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(null, onFailure)`
 * @see R.andThen
 * @example
 *
 *      const failedFetch = id => Promise.reject('bad ID');
 *      const useDefault = () => ({ firstName: 'Bob', lastName: 'Loblaw' });
 *
 *      //recoverFromFailure :: String -> Promise ({ firstName, lastName })
 *      const recoverFromFailure = R.pipe(
 *        failedFetch,
 *        R.otherwise(useDefault),
 *        R.andThen(R.pick(['firstName', 'lastName'])),
 *      );
 *      recoverFromFailure(12345).then(console.log);
 */

var otherwise =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function otherwise(f, p) {
  _assertPromise('otherwise', p);

  return p.then(null, f);
})));

/* harmony default export */ var es_otherwise = ((/* unused pure expression or super */ null && (otherwise)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/partition.js



/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.includes('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.includes('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */

var partition =
/*#__PURE__*/
es_juxt([es_filter, es_reject]);
/* harmony default export */ var es_partition = ((/* unused pure expression or super */ null && (partition)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/pathEq.js



/**
 * Determines whether a nested path on an object has a specific value, in
 * [`R.equals`](#equals) terms. Most likely used to filter a list.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Relation
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> a -> {a} -> Boolean
 * @param {Array} path The path of the nested property to use
 * @param {*} val The value to compare the nested property with
 * @param {Object} obj The object to check the nested property in
 * @return {Boolean} `true` if the value equals the nested object property,
 *         `false` otherwise.
 * @example
 *
 *      const user1 = { address: { zipCode: 90210 } };
 *      const user2 = { address: { zipCode: 55555 } };
 *      const user3 = { name: 'Bob' };
 *      const users = [ user1, user2, user3 ];
 *      const isFamous = R.pathEq(['address', 'zipCode'], 90210);
 *      R.filter(isFamous, users); //=> [ user1 ]
 */

var pathEq =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry3(function pathEq(_path, val, obj) {
  return equals(path(_path, obj), val);
})));

/* harmony default export */ var es_pathEq = ((/* unused pure expression or super */ null && (pathEq)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/pathOr.js



/**
 * If the given, non-null object has a value at the given path, returns the
 * value at that path. Otherwise returns the provided default value.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig a -> [Idx] -> {a} -> a
 * @param {*} d The default value.
 * @param {Array} p The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path` of the supplied object or the default value.
 * @example
 *
 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */

var pathOr =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry3(function pathOr(d, p, obj) {
  return defaultTo(d, path(p, obj));
})));

/* harmony default export */ var es_pathOr = ((/* unused pure expression or super */ null && (pathOr)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/pathSatisfies.js


/**
 * Returns `true` if the specified object property at given path satisfies the
 * given predicate; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Logic
 * @typedefn Idx = String | Int | Symbol
 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
 * @param {Function} pred
 * @param {Array} propPath
 * @param {*} obj
 * @return {Boolean}
 * @see R.propSatisfies, R.path
 * @example
 *
 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
 *      R.pathSatisfies(R.is(Object), [], {x: {y: 2}}); //=> true
 */

var pathSatisfies =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry3(function pathSatisfies(pred, propPath, obj) {
  return pred(path(propPath, obj));
})));

/* harmony default export */ var es_pathSatisfies = ((/* unused pure expression or super */ null && (pathSatisfies)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/multiply.js

/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      const double = R.multiply(2);
 *      const triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */

var multiply =
/*#__PURE__*/
_curry2_curry2(function multiply(a, b) {
  return a * b;
});

/* harmony default export */ var es_multiply = (multiply);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/product.js


/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */

var product =
/*#__PURE__*/
es_reduce(es_multiply, 1);
/* harmony default export */ var es_product = ((/* unused pure expression or super */ null && (product)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/pickAll.js

/**
 * Similar to `pick` except that this one includes a `key: undefined` pair for
 * properties that don't exist.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.pick
 * @example
 *
 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
 */

var pickAll =
/*#__PURE__*/
_curry2_curry2(function pickAll(names, obj) {
  var result = {};
  var idx = 0;
  var len = names.length;

  while (idx < len) {
    var name = names[idx];
    result[name] = obj[name];
    idx += 1;
  }

  return result;
});

/* harmony default export */ var es_pickAll = (pickAll);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/useWith.js


/**
 * Accepts a function `fn` and a list of transformer functions and returns a
 * new curried function. When the new function is invoked, it calls the
 * function `fn` with parameters consisting of the result of calling each
 * supplied handler on successive arguments to the new function.
 *
 * If more arguments are passed to the returned function than transformer
 * functions, those arguments are passed directly to `fn` as additional
 * parameters. If you expect additional arguments that don't need to be
 * transformed, although you can ignore them, it's best to pass an identity
 * function so that the new function reports the correct arity.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} fn The function to wrap.
 * @param {Array} transformers A list of transformer functions
 * @return {Function} The wrapped function.
 * @see R.converge
 * @example
 *
 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
 */

var useWith =
/*#__PURE__*/
_curry2_curry2(function useWith(fn, transformers) {
  return es_curryN(transformers.length, function () {
    var args = [];
    var idx = 0;

    while (idx < transformers.length) {
      args.push(transformers[idx].call(this, arguments[idx]));
      idx += 1;
    }

    return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
  });
});

/* harmony default export */ var es_useWith = (useWith);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/project.js




/**
 * Reasonable analog to SQL `select` statement.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @category Relation
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array} props The property names to project
 * @param {Array} objs The objects to query
 * @return {Array} An array of objects with just the `props` properties.
 * @see R.pluck, R.props, R.prop
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
 *      const kids = [abby, fred];
 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
 */

var project =
/*#__PURE__*/
es_useWith(_map_map, [es_pickAll, es_identity]); // passing `identity` gives correct arity

/* harmony default export */ var es_project = ((/* unused pure expression or super */ null && (project)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_promap.js
function _promap(f, g, profunctor) {
  return function (x) {
    return g(profunctor(f(x)));
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xpromap.js




var XPromap =
/*#__PURE__*/
function () {
  function XPromap(f, g, xf) {
    this.xf = xf;
    this.f = f;
    this.g = g;
  }

  XPromap.prototype['@@transducer/init'] = _xfBase.init;
  XPromap.prototype['@@transducer/result'] = _xfBase.result;

  XPromap.prototype['@@transducer/step'] = function (result, input) {
    return this.xf['@@transducer/step'](result, _promap(this.f, this.g, input));
  };

  return XPromap;
}();

var _xpromap =
/*#__PURE__*/
_curry3_curry3(function _xpromap(f, g, xf) {
  return new XPromap(f, g, xf);
});

/* harmony default export */ var internal_xpromap = (_xpromap);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/promap.js




/**
 * Takes two functions as pre- and post- processors respectively for a third function,
 * i.e. `promap(f, g, h)(x) === g(h(f(x)))`.
 *
 * Dispatches to the `promap` method of the third argument, if present,
 * according to the [FantasyLand Profunctor spec](https://github.com/fantasyland/fantasy-land#profunctor).
 *
 * Acts as a transducer if a transformer is given in profunctor position.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Function
 * @sig (a -> b) -> (c -> d) -> (b -> c) -> (a -> d)
 * @sig Profunctor p => (a -> b) -> (c -> d) -> p b c -> p a d
 * @param {Function} f The preprocessor function, a -> b
 * @param {Function} g The postprocessor function, c -> d
 * @param {Profunctor} profunctor The profunctor instance to be promapped, e.g. b -> c
 * @return {Profunctor} The new profunctor instance, e.g. a -> d
 * @see R.transduce
 * @example
 *
 *      const decodeChar = R.promap(s => s.charCodeAt(), String.fromCharCode, R.add(-8))
 *      const decodeString = R.promap(R.split(''), R.join(''), R.map(decodeChar))
 *      decodeString("ziuli") //=> "ramda"
 *
 * @symb R.promap(f, g, h) = x => g(h(f(x)))
 * @symb R.promap(f, g, profunctor) = profunctor.promap(f, g)
 */

var promap =
/*#__PURE__*/
_curry3_curry3(
/*#__PURE__*/
_dispatchable(['fantasy-land/promap', 'promap'], internal_xpromap, _promap));

/* harmony default export */ var es_promap = ((/* unused pure expression or super */ null && (promap)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/propEq.js



/**
 * Returns `true` if the specified object property is equal, in
 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
 * You can test multiple properties with [`R.whereEq`](#whereEq).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig String -> a -> Object -> Boolean
 * @param {String} name
 * @param {*} val
 * @param {*} obj
 * @return {Boolean}
 * @see R.whereEq, R.propSatisfies, R.equals
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond'};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown'};
 *      const rusty = {name: 'Rusty', age: 10, hair: 'brown'};
 *      const alois = {name: 'Alois', age: 15, disposition: 'surly'};
 *      const kids = [abby, fred, rusty, alois];
 *      const hasBrownHair = R.propEq('hair', 'brown');
 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
 */

var propEq =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry3(function propEq(name, val, obj) {
  return equals(val, prop(name, obj));
})));

/* harmony default export */ var es_propEq = ((/* unused pure expression or super */ null && (propEq)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/propIs.js



/**
 * Returns `true` if the specified object property is of the given type;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Type
 * @sig Type -> String -> Object -> Boolean
 * @param {Function} type
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.is, R.propSatisfies
 * @example
 *
 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
 *      R.propIs(Number, 'x', {});            //=> false
 */

var propIs =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry3(function propIs(type, name, obj) {
  return is(type, prop(name, obj));
})));

/* harmony default export */ var es_propIs = ((/* unused pure expression or super */ null && (propIs)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/propOr.js



/**
 * Return the specified property of the given non-null object if the property
 * is present and it's value is not `null`, `undefined` or `NaN`.
 *
 * Otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Object
 * @sig a -> String -> Object -> a
 * @param {*} val The default value.
 * @param {String} p The name of the property to return.
 * @param {Object} obj The object to query.
 * @return {*} The value of given property of the supplied object or the default value.
 * @example
 *
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const favorite = R.prop('favoriteLibrary');
 *      const favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
 *
 *      favorite(alice);  //=> undefined
 *      favoriteWithDefault(alice);  //=> 'Ramda'
 */

var propOr =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry3(function propOr(val, p, obj) {
  return defaultTo(val, prop(p, obj));
})));

/* harmony default export */ var es_propOr = ((/* unused pure expression or super */ null && (propOr)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/propSatisfies.js


/**
 * Returns `true` if the specified object property satisfies the given
 * predicate; `false` otherwise. You can test multiple properties with
 * [`R.where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Logic
 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
 * @param {Function} pred
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.where, R.propEq, R.propIs
 * @example
 *
 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
 */

var propSatisfies =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry3(function propSatisfies(pred, name, obj) {
  return pred(prop(name, obj));
})));

/* harmony default export */ var es_propSatisfies = ((/* unused pure expression or super */ null && (propSatisfies)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/props.js


/**
 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> [v]
 * @param {Array} ps The property names to fetch
 * @param {Object} obj The object to query
 * @return {Array} The corresponding values or partially applied function.
 * @see R.prop, R.pluck, R.project
 * @example
 *
 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
 *
 *      const fullName = R.compose(R.join(' '), R.props(['first', 'last']));
 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
 */

var props =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function props(ps, obj) {
  return ps.map(function (p) {
    return path([p], obj);
  });
})));

/* harmony default export */ var es_props = ((/* unused pure expression or super */ null && (props)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isNumber.js
function _isNumber(x) {
  return Object.prototype.toString.call(x) === '[object Number]';
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/range.js


/**
 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> Number -> [Number]
 * @param {Number} from The first number in the list.
 * @param {Number} to One more than the last number in the list.
 * @return {Array} The list of numbers in the set `[a, b)`.
 * @example
 *
 *      R.range(1, 5);    //=> [1, 2, 3, 4]
 *      R.range(50, 53);  //=> [50, 51, 52]
 */

var range =
/*#__PURE__*/
_curry2_curry2(function range(from, to) {
  if (!(_isNumber(from) && _isNumber(to))) {
    throw new TypeError('Both arguments to range must be numbers');
  }

  var result = [];
  var n = from;

  while (n < to) {
    result.push(n);
    n += 1;
  }

  return result;
});

/* harmony default export */ var es_range = (range);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/reduceWhile.js



/**
 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
 * through the list, successively calling the iterator function. `reduceWhile`
 * also takes a predicate that is evaluated before each step. If the predicate
 * returns `false`, it "short-circuits" the iteration and returns the current
 * value of the accumulator. `reduceWhile` may alternatively be short-circuited
 * via [`reduced`](#reduced).
 *
 * @func
 * @memberOf R
 * @since v0.22.0
 * @category List
 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} pred The predicate. It is passed the accumulator and the
 *        current element.
 * @param {Function} fn The iterator function. Receives two values, the
 *        accumulator and the current element.
 * @param {*} a The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced
 * @example
 *
 *      const isOdd = (acc, x) => x % 2 !== 0;
 *      const xs = [1, 3, 5, 60, 777, 800];
 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
 *
 *      const ys = [2, 4, 6]
 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
 */

var reduceWhile =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curryN(4, [], function _reduceWhile(pred, fn, a, list) {
  return _reduce(function (acc, x) {
    return pred(acc, x) ? fn(acc, x) : _reduced(acc);
  }, a, list);
})));

/* harmony default export */ var es_reduceWhile = ((/* unused pure expression or super */ null && (reduceWhile)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/sequence.js





/**
 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
 * Applicative of Traversable.
 *
 * Dispatches to the `sequence` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
 * @param {Function} of
 * @param {*} traversable
 * @return {*}
 * @see R.traverse
 * @example
 *
 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
 *
 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
 */

var sequence_sequence =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function sequence(of, traversable) {
  return typeof traversable.sequence === 'function' ? traversable.sequence(of) : reduceRight(function (x, acc) {
    return ap(map(prepend, x), acc);
  }, of([]), traversable);
})));

/* harmony default export */ var es_sequence = ((/* unused pure expression or super */ null && (sequence_sequence)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/sortBy.js

/**
 * Sorts the list according to the supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord b => (a -> b) -> [a] -> [a]
 * @param {Function} fn
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted by the keys generated by `fn`.
 * @example
 *
 *      const sortByFirstItem = R.sortBy(R.prop(0));
 *      const pairs = [[-1, 1], [-2, 2], [-3, 3]];
 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
 *
 *      const sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const bob = {
 *        name: 'Bob',
 *        age: -10
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 314.159
 *      };
 *      const people = [clara, bob, alice];
 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
 */

var sortBy =
/*#__PURE__*/
_curry2_curry2(function sortBy(fn, list) {
  return Array.prototype.slice.call(list, 0).sort(function (a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
  });
});

/* harmony default export */ var es_sortBy = (sortBy);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/split.js

/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `sep`.
 * @see R.join
 * @example
 *
 *      const pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */

var split =
/*#__PURE__*/
es_invoker(1, 'split');
/* harmony default export */ var es_split = (split);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/splitAt.js



/**
 * Splits a given list or string at a given index.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig Number -> [a] -> [[a], [a]]
 * @sig Number -> String -> [String, String]
 * @param {Number} index The index where the array/string is split.
 * @param {Array|String} array The array/string to be split.
 * @return {Array}
 * @example
 *
 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
 */

var splitAt =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function splitAt(index, array) {
  return [slice(0, index, array), slice(index, length(array), array)];
})));

/* harmony default export */ var es_splitAt = ((/* unused pure expression or super */ null && (splitAt)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/splitEvery.js


/**
 * Splits a collection into slices of the specified length.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @sig Number -> String -> [String]
 * @param {Number} n
 * @param {Array} list
 * @return {Array}
 * @example
 *
 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
 */

var splitEvery =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function splitEvery(n, list) {
  if (n <= 0) {
    throw new Error('First argument to splitEvery must be a positive integer');
  }

  var result = [];
  var idx = 0;

  while (idx < list.length) {
    result.push(slice(idx, idx += n, list));
  }

  return result;
})));

/* harmony default export */ var es_splitEvery = ((/* unused pure expression or super */ null && (splitEvery)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/startsWith.js



/**
 * Checks if a list starts with the provided sublist.
 *
 * Similarly, checks if a string starts with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} prefix
 * @param {*} list
 * @return {Boolean}
 * @see R.endsWith
 * @example
 *
 *      R.startsWith('a', 'abc')                //=> true
 *      R.startsWith('b', 'abc')                //=> false
 *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
 *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
 */

var startsWith =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function (prefix, list) {
  return equals(take(prefix.length, list), prefix);
})));

/* harmony default export */ var es_startsWith = ((/* unused pure expression or super */ null && (startsWith)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/symmetricDifference.js



/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
 * @example
 *
 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
 */

var symmetricDifference =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function symmetricDifference(list1, list2) {
  return concat(difference(list1, list2), difference(list2, list1));
})));

/* harmony default export */ var es_symmetricDifference = ((/* unused pure expression or super */ null && (symmetricDifference)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/symmetricDifferenceWith.js



/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both. Duplication is determined according to the value
 * returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifference, R.difference, R.differenceWith
 * @example
 *
 *      const eqA = R.eqBy(R.prop('a'));
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
 *      const l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
 */

var symmetricDifferenceWith =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry3(function symmetricDifferenceWith(pred, list1, list2) {
  return concat(differenceWith(pred, list1, list2), differenceWith(pred, list2, list1));
})));

/* harmony default export */ var es_symmetricDifferenceWith = ((/* unused pure expression or super */ null && (symmetricDifferenceWith)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/takeLastWhile.js


/**
 * Returns a new list containing the last `n` elements of a given list, passing
 * each value to the supplied predicate function, and terminating when the
 * predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropLastWhile, R.addIndex
 * @example
 *
 *      const isNotOne = x => x !== 1;
 *
 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
 *
 *      R.takeLastWhile(x => x !== 'R' , 'Ramda'); //=> 'amda'
 */

var takeLastWhile =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function takeLastWhile(fn, xs) {
  var idx = xs.length - 1;

  while (idx >= 0 && fn(xs[idx])) {
    idx -= 1;
  }

  return slice(idx + 1, Infinity, xs);
})));

/* harmony default export */ var es_takeLastWhile = ((/* unused pure expression or super */ null && (takeLastWhile)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xtakeWhile.js




var XTakeWhile =
/*#__PURE__*/
function () {
  function XTakeWhile(f, xf) {
    this.xf = xf;
    this.f = f;
  }

  XTakeWhile.prototype['@@transducer/init'] = _xfBase.init;
  XTakeWhile.prototype['@@transducer/result'] = _xfBase.result;

  XTakeWhile.prototype['@@transducer/step'] = function (result, input) {
    return this.f(input) ? this.xf['@@transducer/step'](result, input) : _reduced_reduced(result);
  };

  return XTakeWhile;
}();

var _xtakeWhile =
/*#__PURE__*/
_curry2_curry2(function _xtakeWhile(f, xf) {
  return new XTakeWhile(f, xf);
});

/* harmony default export */ var internal_xtakeWhile = (_xtakeWhile);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/takeWhile.js




/**
 * Returns a new list containing the first `n` elements of a given list,
 * passing each value to the supplied predicate function, and terminating when
 * the predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * Dispatches to the `takeWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropWhile, R.transduce, R.addIndex
 * @example
 *
 *      const isNotFour = x => x !== 4;
 *
 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
 *
 *      R.takeWhile(x => x !== 'd' , 'Ramda'); //=> 'Ram'
 */

var takeWhile =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable(['takeWhile'], internal_xtakeWhile, function takeWhile(fn, xs) {
  var idx = 0;
  var len = xs.length;

  while (idx < len && fn(xs[idx])) {
    idx += 1;
  }

  return es_slice(0, idx, xs);
}));

/* harmony default export */ var es_takeWhile = ((/* unused pure expression or super */ null && (takeWhile)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xtap.js



var XTap =
/*#__PURE__*/
function () {
  function XTap(f, xf) {
    this.xf = xf;
    this.f = f;
  }

  XTap.prototype['@@transducer/init'] = _xfBase.init;
  XTap.prototype['@@transducer/result'] = _xfBase.result;

  XTap.prototype['@@transducer/step'] = function (result, input) {
    this.f(input);
    return this.xf['@@transducer/step'](result, input);
  };

  return XTap;
}();

var _xtap =
/*#__PURE__*/
_curry2_curry2(function _xtap(f, xf) {
  return new XTap(f, xf);
});

/* harmony default export */ var internal_xtap = (_xtap);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/tap.js



/**
 * Runs the given function with the supplied object, then returns the object.
 *
 * Acts as a transducer if a transformer is given as second parameter.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a -> *) -> a -> a
 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
 * @param {*} x
 * @return {*} `x`.
 * @example
 *
 *      const sayX = x => console.log('x is ' + x);
 *      R.tap(sayX, 100); //=> 100
 *      // logs 'x is 100'
 * @symb R.tap(f, a) = a
 */

var tap =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable([], internal_xtap, function tap(fn, x) {
  fn(x);
  return x;
}));

/* harmony default export */ var es_tap = ((/* unused pure expression or super */ null && (tap)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_isRegExp.js
function _isRegExp(x) {
  return Object.prototype.toString.call(x) === '[object RegExp]';
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/test.js




/**
 * Determines whether a given string matches a given regular expression.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category String
 * @sig RegExp -> String -> Boolean
 * @param {RegExp} pattern
 * @param {String} str
 * @return {Boolean}
 * @see R.match
 * @example
 *
 *      R.test(/^x/, 'xyz'); //=> true
 *      R.test(/^y/, 'xyz'); //=> false
 */

var test =
/*#__PURE__*/
_curry2_curry2(function test(pattern, str) {
  if (!_isRegExp(pattern)) {
    throw new TypeError('‘test’ requires a value of type RegExp as its first argument; received ' + es_toString(pattern));
  }

  return _cloneRegExp(pattern).test(str);
});

/* harmony default export */ var es_test = (test);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/andThen.js


/**
 * Returns the result of applying the onSuccess function to the value inside
 * a successfully resolved promise. This is useful for working with promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Function
 * @sig (a -> b) -> (Promise e a) -> (Promise e b)
 * @sig (a -> (Promise e b)) -> (Promise e a) -> (Promise e b)
 * @param {Function} onSuccess The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(onSuccess)`
 * @see R.otherwise
 * @example
 *
 *      const makeQuery = email => ({ query: { email }});
 *      const fetchMember = request =>
 *        Promise.resolve({ firstName: 'Bob', lastName: 'Loblaw', id: 42 });
 *
 *      //getMemberName :: String -> Promise ({ firstName, lastName })
 *      const getMemberName = R.pipe(
 *        makeQuery,
 *        fetchMember,
 *        R.andThen(R.pick(['firstName', 'lastName']))
 *      );
 *
 *      getMemberName('bob@gmail.com').then(console.log);
 */

var andThen =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function andThen(f, p) {
  _assertPromise('andThen', p);

  return p.then(f);
})));

/* harmony default export */ var es_andThen = ((/* unused pure expression or super */ null && (andThen)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/toLower.js

/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */

var toLower =
/*#__PURE__*/
(/* unused pure expression or super */ null && (invoker(0, 'toLowerCase')));
/* harmony default export */ var es_toLower = ((/* unused pure expression or super */ null && (toLower)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/toPairs.js


/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs, R.keys, R.values
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */

var toPairs =
/*#__PURE__*/
_curry1_curry1(function toPairs(obj) {
  var pairs = [];

  for (var prop in obj) {
    if (_has_has(prop, obj)) {
      pairs[pairs.length] = [prop, obj[prop]];
    }
  }

  return pairs;
});

/* harmony default export */ var es_toPairs = (toPairs);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/toUpper.js

/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */

var toUpper =
/*#__PURE__*/
(/* unused pure expression or super */ null && (invoker(0, 'toUpperCase')));
/* harmony default export */ var es_toUpper = ((/* unused pure expression or super */ null && (toUpper)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/transduce.js



/**
 * Initializes a transducer using supplied iterator function. Returns a single
 * item by iterating through the list, successively calling the transformed
 * iterator function and passing it an accumulator value and the current value
 * from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It will be
 * wrapped as a transformer to initialize the transducer. A transformer can be
 * passed directly in place of an iterator function. In both cases, iteration
 * may be stopped early with the [`R.reduced`](#reduced) function.
 *
 * A transducer is a function that accepts a transformer and returns a
 * transformer and can be composed directly.
 *
 * A transformer is an object that provides a 2-arity reducing iterator
 * function, step, 0-arity initial value function, init, and 1-arity result
 * extraction function, result. The step function is used as the iterator
 * function in reduce. The result function is used to convert the final
 * accumulator into the return type and in most cases is
 * [`R.identity`](#identity). The init function can be used to provide an
 * initial accumulator, but is ignored by transduce.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array. Wrapped as transformer, if necessary, and used to
 *        initialize the transducer
 * @param {*} acc The initial accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced, R.into
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
 *
 *      const isOdd = (x) => x % 2 !== 0;
 *      const firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
 */

var transduce =
/*#__PURE__*/
(/* unused pure expression or super */ null && (curryN(4, function transduce(xf, fn, acc, list) {
  return _reduce(xf(typeof fn === 'function' ? _xwrap(fn) : fn), acc, list);
})));
/* harmony default export */ var es_transduce = ((/* unused pure expression or super */ null && (transduce)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/traverse.js



/**
 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
 * into an Applicative of Traversable.
 *
 * Dispatches to the `traverse` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
 * @param {Function} of
 * @param {Function} f
 * @param {*} traversable
 * @return {*}
 * @see R.sequence
 * @example
 *
 *      // Returns `Maybe.Nothing` if the given divisor is `0`
 *      const safeDiv = n => d => d === 0 ? Maybe.Nothing() : Maybe.Just(n / d)
 *
 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Maybe.Just([5, 2.5, 2])
 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Maybe.Nothing
 */

var traverse =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry3(function traverse(of, f, traversable) {
  return typeof traversable['fantasy-land/traverse'] === 'function' ? traversable['fantasy-land/traverse'](f, of) : typeof traversable.traverse === 'function' ? traversable.traverse(f, of) : sequence(of, map(f, traversable));
})));

/* harmony default export */ var es_traverse = ((/* unused pure expression or super */ null && (traverse)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/trim.js

var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003' + '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' + '\u2029\uFEFF';
var zeroWidth = '\u200b';
var hasProtoTrim = typeof String.prototype.trim === 'function';
/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */

var trim = !hasProtoTrim ||
/*#__PURE__*/
ws.trim() || !
/*#__PURE__*/
zeroWidth.trim() ?
/*#__PURE__*/
_curry1_curry1(function trim(str) {
  var beginRx = new RegExp('^[' + ws + '][' + ws + ']*');
  var endRx = new RegExp('[' + ws + '][' + ws + ']*$');
  return str.replace(beginRx, '').replace(endRx, '');
}) :
/*#__PURE__*/
_curry1_curry1(function trim(str) {
  return str.trim();
});
/* harmony default export */ var es_trim = ((/* unused pure expression or super */ null && (trim)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/union.js




/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */

var union =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
compose(es_uniq, _concat_concat));

/* harmony default export */ var es_union = ((/* unused pure expression or super */ null && (union)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/internal/_xuniqWith.js




var XUniqWith =
/*#__PURE__*/
function () {
  function XUniqWith(pred, xf) {
    this.xf = xf;
    this.pred = pred;
    this.items = [];
  }

  XUniqWith.prototype['@@transducer/init'] = _xfBase.init;
  XUniqWith.prototype['@@transducer/result'] = _xfBase.result;

  XUniqWith.prototype['@@transducer/step'] = function (result, input) {
    if (_includesWith(this.pred, input, this.items)) {
      return result;
    } else {
      this.items.push(input);
      return this.xf['@@transducer/step'](result, input);
    }
  };

  return XUniqWith;
}();

var _xuniqWith =
/*#__PURE__*/
_curry2_curry2(function _xuniqWith(pred, xf) {
  return new XUniqWith(pred, xf);
});

/* harmony default export */ var internal_xuniqWith = (_xuniqWith);
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/uniqWith.js




/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied predicate to
 * two list elements. Prefers the first item if two items compare equal based
 * on the predicate.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      const strEq = R.eqBy(String);
 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
 */

var uniqWith_uniqWith =
/*#__PURE__*/
_curry2_curry2(
/*#__PURE__*/
_dispatchable([], internal_xuniqWith, function (pred, list) {
  var idx = 0;
  var len = list.length;
  var result = [];
  var item;

  while (idx < len) {
    item = list[idx];

    if (!_includesWith(pred, item, result)) {
      result[result.length] = item;
    }

    idx += 1;
  }

  return result;
}));

/* harmony default export */ var es_uniqWith = ((/* unused pure expression or super */ null && (uniqWith_uniqWith)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/unionWith.js



/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list. Duplication is determined according to the value returned by
 * applying the supplied predicate to two list elements. If an element exists
 * in both lists, the first element from the first list will be used.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [*] -> [*] -> [*]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @see R.union
 * @example
 *
 *      const l1 = [{a: 1}, {a: 2}];
 *      const l2 = [{a: 1}, {a: 4}];
 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
 */

var unionWith =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry3(function unionWith(pred, list1, list2) {
  return uniqWith(pred, _concat(list1, list2));
})));

/* harmony default export */ var es_unionWith = ((/* unused pure expression or super */ null && (unionWith)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/unnest.js


/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */

var unnest =
/*#__PURE__*/
es_chain(_identity);
/* harmony default export */ var es_unnest = ((/* unused pure expression or super */ null && (unnest)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/unwind.js




/**
 *
 * Deconstructs an array field from the input documents to output a document for each element.
 * Each output document is the input document with the value of the array field replaced by the element.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Object
 * @sig String -> {k: [v]} -> [{k: v}]
 * @param {String} key The key to determine which property of the object should be unwind
 * @param {Object} object The object containing list under property named as key which is to unwind
 * @return {List} A new list of object containing the value of input key having list replaced by each element in the object.
 * @example
 *
 * R.unwind('hobbies', {
 *   name: 'alice',
 *   hobbies: ['Golf', 'Hacking'],
 *   colors: ['red', 'green'],
 * });
 * // [
 * //   { name: 'alice', hobbies: 'Golf', colors: ['red', 'green'] },
 * //   { name: 'alice', hobbies: 'Hacking', colors: ['red', 'green'] }
 * // ]
 */

var unwind =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function (key, object) {
  // If key is not in object or key is not as a list in object
  if (!(key in object && _isArray(object[key]))) {
    return [object];
  } // Map over object[key] which is a list and assoc each element with key


  return _map(function (item) {
    return _assoc(key, item, object);
  }, object[key]);
})));

/* harmony default export */ var es_unwind = ((/* unused pure expression or super */ null && (unwind)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/whereEq.js




/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec, false otherwise. An object satisfies the spec if, for each of the
 * spec's own properties, accessing that property of the object gives the same
 * value (in [`R.equals`](#equals) terms) as accessing that property of the
 * spec.
 *
 * `whereEq` is a specialization of [`where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @sig {String: *} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propEq, R.where
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.whereEq({a: 1, b: 2});
 *
 *      pred({a: 1});              //=> false
 *      pred({a: 1, b: 2});        //=> true
 *      pred({a: 1, b: 2, c: 3});  //=> true
 *      pred({a: 1, b: 1});        //=> false
 */

var whereEq =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function whereEq(spec, testObj) {
  return where(map(equals, spec), testObj);
})));

/* harmony default export */ var es_whereEq = ((/* unused pure expression or super */ null && (whereEq)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/without.js




/**
 * Returns a new list without values in the first argument.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @param {Array} list1 The values to be removed from `list2`.
 * @param {Array} list2 The array to remove values from.
 * @return {Array} The new array without values in `list1`.
 * @see R.transduce, R.difference, R.remove
 * @example
 *
 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
 */

var without =
/*#__PURE__*/
(/* unused pure expression or super */ null && (_curry2(function (xs, list) {
  return reject(flip(_includes)(xs), list);
})));

/* harmony default export */ var es_without = ((/* unused pure expression or super */ null && (without)));
;// CONCATENATED MODULE: ./node_modules/.pnpm/ramda@0.28.0/node_modules/ramda/es/index.js






































































































































































































































































/***/ }),

/***/ 90300:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KN": function() { return /* binding */ appendErrors; },
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "t8": function() { return /* binding */ set; },
/* harmony export */   "bc": function() { return /* binding */ useController; },
/* harmony export */   "cI": function() { return /* binding */ useForm; },
/* harmony export */   "qo": function() { return /* binding */ useWatch; }
/* harmony export */ });
/* unused harmony exports Controller, FormProvider, useFieldArray, useFormContext, useFormState */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);


var isCheckBoxInput = (element) => element.type === 'checkbox';

var isDateObject = (value) => value instanceof Date;

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !isDateObject(value);

var getEventValue = (event) => isObject(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/.\d/)) || name;

var isNameInFieldArray = (names, name) => [...names].some((current) => getNodeParentName(name) === current);

var compact = (value) => value.filter(Boolean);

var isUndefined = (val) => val === undefined;

var get = (obj, path, defaultValue) => {
    if (!path || !isObject(obj)) {
        return defaultValue;
    }
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], obj);
    return isUndefined(result) || result === obj
        ? isUndefined(obj[path])
            ? defaultValue
            : obj[path]
        : result;
};

const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

var omit = (source, key) => {
    const copy = Object.assign({}, source);
    delete copy[key];
    return copy;
};

const HookFormContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const useFormContext = () => react__WEBPACK_IMPORTED_MODULE_0__.useContext(HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const FormProvider = (props) => (React.createElement(HookFormContext.Provider, { value: omit(props, 'children') }, props.children));

var getProxyFormState = (formState, _proxyFormState, localProxyFormState, isRoot = true) => {
    const result = {};
    for (const key in formState) {
        Object.defineProperty(result, key, {
            get: () => {
                const _key = key;
                if (_proxyFormState[_key] !== VALIDATION_MODE.all) {
                    _proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
                }
                localProxyFormState && (localProxyFormState[_key] = true);
                return formState[_key];
            },
        });
    }
    return result;
};

var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

var shouldRenderFormState = (formStateData, _proxyFormState, isRoot) => {
    const formState = omit(formStateData, 'name');
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
        Object.keys(formState).find((key) => _proxyFormState[key] ===
            (!isRoot || VALIDATION_MODE.all)));
};

var convertToArrayPayload = (value) => (Array.isArray(value) ? value : [value]);

var shouldSubscribeByName = (name, signalName, exact) => exact && signalName
    ? name === signalName
    : !name ||
        !signalName ||
        name === signalName ||
        convertToArrayPayload(name).some((currentName) => currentName &&
            (currentName.startsWith(signalName) ||
                signalName.startsWith(currentName)));

function useSubscribe(props) {
    const _props = react__WEBPACK_IMPORTED_MODULE_0__.useRef(props);
    _props.current = props;
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const tearDown = (subscription) => {
            if (subscription) {
                subscription.unsubscribe();
            }
        };
        const subscription = !props.disabled &&
            _props.current.subject.subscribe({
                next: _props.current.callback,
            });
        return () => tearDown(subscription);
    }, [props.disabled]);
}

/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name, exact } = props || {};
    const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState(control._formState);
    const _localProxyFormState = react__WEBPACK_IMPORTED_MODULE_0__.useRef({
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    });
    const _name = react__WEBPACK_IMPORTED_MODULE_0__.useRef(name);
    const _mounted = react__WEBPACK_IMPORTED_MODULE_0__.useRef(true);
    _name.current = name;
    const callback = react__WEBPACK_IMPORTED_MODULE_0__.useCallback((value) => _mounted.current &&
        shouldSubscribeByName(_name.current, value.name, exact) &&
        shouldRenderFormState(value, _localProxyFormState.current) &&
        updateFormState(Object.assign(Object.assign({}, control._formState), value)), [control, exact]);
    useSubscribe({
        disabled,
        callback,
        subject: control._subjects.state,
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => () => {
        _mounted.current = false;
    }, []);
    return getProxyFormState(formState, control._proxyFormState, _localProxyFormState.current, false);
}

var isString = (value) => typeof value === 'string';

var generateWatchOutput = (names, _names, formValues, isGlobal) => {
    const isArray = Array.isArray(names);
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names);
    }
    if (isArray) {
        return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName),
            get(formValues, fieldName)));
    }
    isGlobal && (_names.watchAll = true);
    return formValues;
};

var isFunction = (value) => typeof value === 'function';

var objectHasFunction = (data) => {
    for (const key in data) {
        if (isFunction(data[key])) {
            return true;
        }
    }
    return false;
};

/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/api/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */
function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, exact, } = props || {};
    const _name = react__WEBPACK_IMPORTED_MODULE_0__.useRef(name);
    _name.current = name;
    const callback = react__WEBPACK_IMPORTED_MODULE_0__.useCallback((formState) => {
        if (shouldSubscribeByName(_name.current, formState.name, exact)) {
            const fieldValues = generateWatchOutput(_name.current, control._names, formState.values || control._formValues);
            updateValue(isUndefined(_name.current) ||
                (isObject(fieldValues) && !objectHasFunction(fieldValues))
                ? Object.assign({}, fieldValues) : Array.isArray(fieldValues)
                ? [...fieldValues]
                : isUndefined(fieldValues)
                    ? defaultValue
                    : fieldValues);
        }
    }, [control, exact, defaultValue]);
    useSubscribe({
        disabled,
        subject: control._subjects.watch,
        callback,
    });
    const [value, updateValue] = react__WEBPACK_IMPORTED_MODULE_0__.useState(isUndefined(defaultValue)
        ? control._getWatch(name)
        : defaultValue);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        control._removeUnmounted();
    });
    return value;
}

/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */
function useController(props) {
    const methods = useFormContext();
    const { name, control = methods.control, shouldUnregister } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const value = useWatch({
        control,
        name,
        defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
        exact: true,
    });
    const formState = useFormState({
        control,
        name,
    });
    const _registerProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef(control.register(name, Object.assign(Object.assign({}, props.rules), { value })));
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const updateMounted = (name, value) => {
            const field = get(control._fields, name);
            if (field) {
                field._f.mount = value;
            }
        };
        updateMounted(name, true);
        return () => {
            const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
            (isArrayField
                ? _shouldUnregisterField && !control._stateFlags.action
                : _shouldUnregisterField)
                ? control.unregister(name)
                : updateMounted(name, false);
        };
    }, [name, control, isArrayField, shouldUnregister]);
    return {
        field: {
            name,
            value,
            onChange: react__WEBPACK_IMPORTED_MODULE_0__.useCallback((event) => {
                _registerProps.current.onChange({
                    target: {
                        value: getEventValue(event),
                        name: name,
                    },
                    type: EVENTS.CHANGE,
                });
            }, [name]),
            onBlur: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
                _registerProps.current.onBlur({
                    target: {
                        value: get(control._formValues, name),
                        name: name,
                    },
                    type: EVENTS.BLUR,
                });
            }, [name, control]),
            ref: react__WEBPACK_IMPORTED_MODULE_0__.useCallback((elm) => {
                const field = get(control._fields, name);
                if (elm && field && elm.focus) {
                    field._f.ref = {
                        focus: () => elm.focus(),
                        setCustomValidity: (message) => elm.setCustomValidity(message),
                        reportValidity: () => elm.reportValidity(),
                    };
                }
            }, [name, control._fields]),
        },
        formState,
        fieldState: control.getFieldState(name, formState),
    };
}

/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */
const Controller = (props) => props.render(useController(props));

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? Object.assign(Object.assign({}, errors[name]), { types: Object.assign(Object.assign({}, (errors[name] && errors[name].types ? errors[name].types : {})), { [type]: message || true }) }) : {};

var isKey = (value) => /^\w*$/.test(value);

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

function set(object, path, value) {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}

const focusFieldBy = (fields, callback, fieldsNames) => {
    for (const key of fieldsNames || Object.keys(fields)) {
        const field = get(fields, key);
        if (field) {
            const _f = field._f;
            const current = omit(field, '_f');
            if (_f && callback(_f.name)) {
                if (_f.ref.focus && isUndefined(_f.ref.focus())) {
                    break;
                }
                else if (_f.refs) {
                    _f.refs[0].focus();
                    break;
                }
            }
            else if (isObject(current)) {
                focusFieldBy(current, callback);
            }
        }
    }
};

var generateId = () => {
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};

var getFocusFieldName = (name, index, options = {}) => options.shouldFocus || isUndefined(options.shouldFocus)
    ? options.focusName ||
        `${name}.${isUndefined(options.focusIndex) ? index : options.focusIndex}.`
    : '';

var isWatched = (name, _names, isBlurEvent) => !isBlurEvent &&
    (_names.watchAll ||
        _names.watch.has(name) ||
        [..._names.watch].some((watchName) => name.startsWith(watchName) &&
            /^\.\w+/.test(name.slice(watchName.length))));

function append(data, value) {
    return [...data, ...convertToArrayPayload(value)];
}

function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) {
        copy = new Date(data);
    }
    else if (data instanceof Set) {
        copy = new Set(data);
    }
    else if (isArray || isObject(data)) {
        copy = isArray ? [] : {};
        for (const key in data) {
            if (isFunction(data[key])) {
                copy = data;
                break;
            }
            copy[key] = cloneObject(data[key]);
        }
    }
    else {
        return data;
    }
    return copy;
}

var fillEmptyArray = (value) => Array.isArray(value) ? value.map(() => undefined) : undefined;

function insert(data, index, value) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value),
        ...data.slice(index),
    ];
}

var moveArrayAt = (data, from, to) => {
    if (!Array.isArray(data)) {
        return [];
    }
    if (isUndefined(data[to])) {
        data[to] = undefined;
    }
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};

function prepend(data, value) {
    return [...convertToArrayPayload(value), ...convertToArrayPayload(data)];
}

function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [...data];
    for (const index of indexes) {
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index) => isUndefined(index)
    ? []
    : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b) => a - b));

var swapArrayAt = (data, indexA, indexB) => {
    data[indexA] = [data[indexB], (data[indexB] = data[indexA])][0];
};

var updateAt = (fieldValues, index, value) => {
    fieldValues[index] = value;
    return fieldValues;
};

/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFieldArray(props) {
    const methods = useFormContext();
    const { control = methods.control, name, keyName = 'id', shouldUnregister, } = props;
    const [fields, setFields] = React.useState(control._getFieldArray(name));
    const ids = React.useRef(control._getFieldArray(name).map(generateId));
    const _fieldIds = React.useRef(fields);
    const _name = React.useRef(name);
    const _actioned = React.useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    const callback = React.useCallback(({ values, name: fieldArrayName }) => {
        if (fieldArrayName === _name.current || !fieldArrayName) {
            const fieldValues = get(values, _name.current, []);
            setFields(fieldValues);
            ids.current = fieldValues.map(generateId);
        }
    }, []);
    useSubscribe({
        callback,
        subject: control._subjects.array,
    });
    const updateValues = React.useCallback((updatedFieldArrayValues) => {
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [control, name]);
    const append$1 = (value, options) => {
        const appendValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = append(control._getFieldArray(name), appendValue);
        control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = append(ids.current, appendValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, append, {
            argA: fillEmptyArray(value),
        });
    };
    const prepend$1 = (value, options) => {
        const prependValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = prepend(control._getFieldArray(name), prependValue);
        control._names.focus = getFocusFieldName(name, 0, options);
        ids.current = prepend(ids.current, prependValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, prepend, {
            argA: fillEmptyArray(value),
        });
    };
    const remove = (index) => {
        const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
        ids.current = removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
            argA: index,
        });
    };
    const insert$1 = (index, value, options) => {
        const insertValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = getFocusFieldName(name, index, options);
        ids.current = insert(ids.current, index, insertValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, insert, {
            argA: index,
            argB: fillEmptyArray(value),
        });
    };
    const swap = (indexA, indexB) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
            argA: indexA,
            argB: indexB,
        }, false);
    };
    const move = (from, to) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        moveArrayAt(updatedFieldArrayValues, from, to);
        moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
            argA: from,
            argB: to,
        }, false);
    };
    const update = (index, value) => {
        const updateValue = cloneObject(value);
        const updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [...updatedFieldArrayValues].map((item, i) => !item || i === index ? generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, updatedFieldArrayValues, updateAt, {
            argA: index,
            argB: updateValue,
        }, true, false);
    };
    const replace = (value) => {
        const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value));
        ids.current = updatedFieldArrayValues.map(generateId);
        updateValues([...updatedFieldArrayValues]);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, [...updatedFieldArrayValues], (data) => data, {}, true, false);
    };
    React.useEffect(() => {
        control._stateFlags.action = false;
        isWatched(name, control._names) && control._subjects.state.next({});
        if (_actioned.current) {
            control._executeSchema([name]).then((result) => {
                const error = get(result.errors, name);
                if (error && error.type && !get(control._formState.errors, name)) {
                    set(control._formState.errors, name, error);
                    control._subjects.state.next({
                        errors: control._formState.errors,
                    });
                }
            });
        }
        control._subjects.watch.next({
            name,
            values: control._formValues,
        });
        control._names.focus &&
            focusFieldBy(control._fields, (key) => key.startsWith(control._names.focus));
        control._names.focus = '';
        control._proxyFormState.isValid && control._updateValid();
    }, [fields, name, control]);
    React.useEffect(() => {
        !get(control._formValues, name) && control._updateFieldArray(name);
        return () => {
            (control._options.shouldUnregister || shouldUnregister) &&
                control.unregister(name);
        };
    }, [name, control, keyName, shouldUnregister]);
    return {
        swap: React.useCallback(swap, [updateValues, name, control]),
        move: React.useCallback(move, [updateValues, name, control]),
        prepend: React.useCallback(prepend$1, [updateValues, name, control]),
        append: React.useCallback(append$1, [updateValues, name, control]),
        remove: React.useCallback(remove, [updateValues, name, control]),
        insert: React.useCallback(insert$1, [updateValues, name, control]),
        update: React.useCallback(update, [updateValues, name, control]),
        replace: React.useCallback(replace, [updateValues, name, control]),
        fields: React.useMemo(() => fields.map((field, index) => (Object.assign(Object.assign({}, field), { [keyName]: ids.current[index] || generateId() }))), [fields, keyName]),
    };
}

function createSubject() {
    let _observers = [];
    const next = (value) => {
        for (const observer of _observers) {
            observer.next(value);
        }
    };
    const subscribe = (observer) => {
        _observers.push(observer);
        return {
            unsubscribe: () => {
                _observers = _observers.filter((o) => o !== observer);
            },
        };
    };
    const unsubscribe = () => {
        _observers = [];
    };
    return {
        get observers() {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe,
    };
}

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepEqual(object1, object2) {
    if (isPrimitive(object1) || isPrimitive(object2)) {
        return object1 === object2;
    }
    if (isDateObject(object1) && isDateObject(object2)) {
        return object1.getTime() === object2.getTime();
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        if (!keys2.includes(key)) {
            return false;
        }
        if (key !== 'ref') {
            const val2 = object2[key];
            if ((isDateObject(val1) && isDateObject(val2)) ||
                (isObject(val1) && isObject(val2)) ||
                (Array.isArray(val1) && Array.isArray(val2))
                ? !deepEqual(val1, val2)
                : val1 !== val2) {
                return false;
            }
        }
    }
    return true;
}

var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

var isBoolean = (value) => typeof value === 'boolean';

var isFileInput = (element) => element.type === 'file';

var isHTMLElement = (value) => value instanceof HTMLElement;

var isMultipleSelect = (element) => element.type === `select-multiple`;

var isRadioInput = (element) => element.type === 'radio';

var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

var live = (ref) => isHTMLElement(ref) && ref.isConnected;

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function unset(object, path) {
    const updatePath = isKey(path) ? [path] : stringToPath(path);
    const childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
    const key = updatePath[updatePath.length - 1];
    let previousObjRef;
    if (childObject) {
        delete childObject[key];
    }
    for (let k = 0; k < updatePath.slice(0, -1).length; k++) {
        let index = -1;
        let objectRef;
        const currentPaths = updatePath.slice(0, -(k + 1));
        const currentPathsLength = currentPaths.length - 1;
        if (k > 0) {
            previousObjRef = object;
        }
        while (++index < currentPaths.length) {
            const item = currentPaths[index];
            objectRef = objectRef ? objectRef[item] : object[item];
            if (currentPathsLength === index &&
                ((isObject(objectRef) && isEmptyObject(objectRef)) ||
                    (Array.isArray(objectRef) &&
                        !objectRef.filter((data) => !isUndefined(data)).length))) {
                previousObjRef ? delete previousObjRef[item] : delete object[item];
            }
            previousObjRef = objectRef;
        }
    }
    return object;
}

function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                fields[key] = Array.isArray(data[key]) ? [] : {};
                markFieldsDirty(data[key], fields[key]);
            }
            else if (!isNullOrUndefined(data[key])) {
                fields[key] = true;
            }
        }
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                if (isUndefined(formValues) ||
                    isPrimitive(dirtyFieldsFromValues[key])) {
                    dirtyFieldsFromValues[key] = Array.isArray(data[key])
                        ? markFieldsDirty(data[key], [])
                        : Object.assign({}, markFieldsDirty(data[key]));
                }
                else {
                    getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
                }
            }
            else {
                dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
            }
        }
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.checked && !option.disabled)
                .map((option) => option.value);
            return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled
            ? // @ts-expect-error expected to work in the browser
                options[0].attributes && !isUndefined(options[0].attributes.value)
                    ? isUndefined(options[0].value) || options[0].value === ''
                        ? validResult
                        : { value: options[0].value, isValid: true }
                    : validResult
            : defaultResult;
    }
    return defaultResult;
};

var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value)
    ? value
    : valueAsNumber
        ? value === ''
            ? NaN
            : +value
        : valueAsDate && isString(value)
            ? new Date(value)
            : setValueAs
                ? setValueAs(value)
                : value;

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.checked && !option.disabled
        ? {
            isValid: true,
            value: option.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

function getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref) => ref.disabled) : ref.disabled) {
        return;
    }
    if (isFileInput(ref)) {
        return ref.files;
    }
    if (isRadioInput(ref)) {
        return getRadioValue(_f.refs).value;
    }
    if (isMultipleSelect(ref)) {
        return [...ref.selectedOptions].map(({ value }) => value);
    }
    if (isCheckBoxInput(ref)) {
        return getCheckboxValue(_f.refs).value;
    }
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
    const fields = {};
    for (const name of fieldsNames) {
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
        shouldUseNativeValidation,
    };
};

var isRegex = (value) => value instanceof RegExp;

var getRuleValue = (rule) => isUndefined(rule)
    ? undefined
    : isRegex(rule)
        ? rule.source
        : isObject(rule)
            ? isRegex(rule.value)
                ? rule.value.source
                : rule.value
            : rule;

var hasValidation = (options) => options.mount &&
    (options.required ||
        options.min ||
        options.max ||
        options.maxLength ||
        options.minLength ||
        options.pattern ||
        options.validate);

function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) {
        return {
            error,
            name,
        };
    }
    const names = name.split('.');
    while (names.length) {
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) {
            return { name };
        }
        if (foundError && foundError.type) {
            return {
                name: fieldName,
                error: foundError,
            };
        }
        names.pop();
    }
    return {
        name,
    };
}

var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
    if (mode.isOnAll) {
        return false;
    }
    else if (!isSubmitted && mode.isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);

var isMessage = (value) => isString(value) || react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(value);

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) ||
        (Array.isArray(result) && result.every(isMessage)) ||
        (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var validateField = async (field, inputValue, validateAllFieldCriteria, shouldUseNativeValidation) => {
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, } = field._f;
    if (!mount || disabled) {
        return {};
    }
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message) => {
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? '' : message || ' ');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = ((valueAsNumber || isFileInput(ref)) && !ref.value) ||
        inputValue === '' ||
        (Array.isArray(inputValue) && !inputValue.length);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = Object.assign({ type: exceedMax ? maxType : minType, message,
            ref }, appendErrorsCurry(exceedMax ? maxType : minType, message));
    };
    if (required &&
        ((!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue))) ||
            (isBoolean(inputValue) && !inputValue) ||
            (isCheckBox && !getCheckboxValue(refs).isValid) ||
            (isRadio && !getRadioValue(refs).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = Object.assign({ type: INPUT_VALIDATION_RULES.required, message, ref: inputRef }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, message));
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || +inputValue;
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            if (isString(maxOutput.value)) {
                exceedMax = valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value)) {
                exceedMin = valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && isString(inputValue)) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            inputValue.length > maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            inputValue.length < minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = Object.assign({ type: INPUT_VALIDATION_RULES.pattern, message,
                ref }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message));
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = Object.assign(Object.assign({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        }
        else if (isObject(validate)) {
            let validationResult = {};
            for (const key in validate) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateError = getValidateError(await validate[key](inputValue), inputRef, key);
                if (validateError) {
                    validationResult = Object.assign(Object.assign({}, validateError), appendErrorsCurry(key, validateError.message));
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = Object.assign({ ref: inputRef }, validationResult);
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    setCustomValidity(true);
    return error;
};

const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true,
};
function createFormControl(props = {}) {
    let _options = Object.assign(Object.assign({}, defaultOptions), props);
    let _formState = {
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {},
    };
    let _fields = {};
    let _defaultValues = _options.defaultValues || {};
    let _formValues = _options.shouldUnregister
        ? {}
        : cloneObject(_defaultValues);
    let _stateFlags = {
        action: false,
        mount: false,
        watch: false,
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
    };
    let delayErrorCallback;
    let timer = 0;
    let validateFields = {};
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    };
    const _subjects = {
        watch: createSubject(),
        array: createSubject(),
        state: createSubject(),
    };
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback, wait) => (...args) => {
        clearTimeout(timer);
        timer = window.setTimeout(() => callback(...args), wait);
    };
    const _updateValid = async (shouldSkipRender) => {
        let isValid = false;
        if (_proxyFormState.isValid) {
            isValid = _options.resolver
                ? isEmptyObject((await _executeSchema()).errors)
                : await executeBuildInValidation(_fields, true);
            if (!shouldSkipRender && isValid !== _formState.isValid) {
                _formState.isValid = isValid;
                _subjects.state.next({
                    isValid,
                });
            }
        }
        return isValid;
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
        if (args && method) {
            _stateFlags.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (_proxyFormState.errors &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            }
            _subjects.state.next({
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid,
            });
        }
        else {
            set(_formValues, name, values);
        }
    };
    const updateErrors = (name, error) => (set(_formState.errors, name, error),
        _subjects.state.next({
            errors: _formState.errors,
        }));
    const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
        const field = get(_fields, name);
        if (field) {
            const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
            isUndefined(defaultValue) ||
                (ref && ref.defaultChecked) ||
                shouldSkipSetValueAs
                ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f))
                : setFieldValue(name, defaultValue);
            _stateFlags.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
        let isFieldDirty = false;
        const output = {
            name,
        };
        const isPreviousFieldTouched = get(_formState.touchedFields, name);
        if (_proxyFormState.isDirty) {
            const isPreviousFormDirty = _formState.isDirty;
            _formState.isDirty = output.isDirty = _getDirty();
            isFieldDirty = isPreviousFormDirty !== output.isDirty;
        }
        if (_proxyFormState.dirtyFields && (!isBlurEvent || shouldDirty)) {
            const isPreviousFieldDirty = get(_formState.dirtyFields, name);
            const isCurrentFieldPristine = deepEqual(get(_defaultValues, name), fieldValue);
            isCurrentFieldPristine
                ? unset(_formState.dirtyFields, name)
                : set(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            isFieldDirty =
                isFieldDirty ||
                    isPreviousFieldDirty !== get(_formState.dirtyFields, name);
        }
        if (isBlurEvent && !isPreviousFieldTouched) {
            set(_formState.touchedFields, name, isBlurEvent);
            output.touchedFields = _formState.touchedFields;
            isFieldDirty =
                isFieldDirty ||
                    (_proxyFormState.touchedFields &&
                        isPreviousFieldTouched !== isBlurEvent);
        }
        isFieldDirty && shouldRender && _subjects.state.next(output);
        return isFieldDirty ? output : {};
    };
    const shouldRenderByError = async (shouldSkipRender, name, isValid, error, fieldState) => {
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback =
                delayErrorCallback || debounce(updateErrors, props.delayError);
            delayErrorCallback(name, error);
        }
        else {
            clearTimeout(timer);
            error
                ? set(_formState.errors, name, error)
                : unset(_formState.errors, name);
        }
        if (((error ? !deepEqual(previousFieldError, error) : previousFieldError) ||
            !isEmptyObject(fieldState) ||
            shouldUpdateValid) &&
            !shouldSkipRender) {
            const updatedFormState = Object.assign(Object.assign(Object.assign({}, fieldState), (shouldUpdateValid ? { isValid } : {})), { errors: _formState.errors, name });
            _formState = Object.assign(Object.assign({}, _formState), updatedFormState);
            _subjects.state.next(updatedFormState);
        }
        validateFields[name]--;
        if (_proxyFormState.isValidating &&
            !Object.values(validateFields).some((v) => v)) {
            _subjects.state.next({
                isValidating: false,
            });
            validateFields = {};
        }
    };
    const _executeSchema = async (name) => _options.resolver
        ? await _options.resolver(Object.assign({}, _formValues), _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation))
        : {};
    const executeSchemaAndUpdateState = async (names) => {
        const { errors } = await _executeSchema();
        if (names) {
            for (const name of names) {
                const error = get(errors, name);
                error
                    ? set(_formState.errors, name, error)
                    : unset(_formState.errors, name);
            }
        }
        else {
            _formState.errors = errors;
        }
        return errors;
    };
    const executeBuildInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true,
    }) => {
        for (const name in fields) {
            const field = fields[name];
            if (field) {
                const fieldReference = field._f;
                const fieldValue = omit(field, '_f');
                if (fieldReference) {
                    const fieldError = await validateField(field, get(_formValues, fieldReference.name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation);
                    if (fieldError[fieldReference.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) {
                            break;
                        }
                    }
                    if (!shouldOnlyCheckValid) {
                        fieldError[fieldReference.name]
                            ? set(_formState.errors, fieldReference.name, fieldError[fieldReference.name])
                            : unset(_formState.errors, fieldReference.name);
                    }
                }
                fieldValue &&
                    (await executeBuildInValidation(fieldValue, shouldOnlyCheckValid, context));
            }
        }
        return context.valid;
    };
    const _removeUnmounted = () => {
        for (const name of _names.unMount) {
            const field = get(_fields, name);
            field &&
                (field._f.refs
                    ? field._f.refs.every((ref) => !live(ref))
                    : !live(field._f.ref)) &&
                unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data) => (name && data && set(_formValues, name, data),
        !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal) => {
        const fieldValues = Object.assign({}, (_stateFlags.mount
            ? _formValues
            : isUndefined(defaultValue)
                ? _defaultValues
                : isString(names)
                    ? { [names]: defaultValue }
                    : defaultValue));
        return generateWatchOutput(names, _names, fieldValues, isGlobal);
    };
    const _getFieldArray = (name) => compact(get(_stateFlags.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        let fieldValue = value;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled &&
                    set(_formValues, name, getFieldValueAs(value, fieldReference));
                fieldValue =
                    isWeb && isHTMLElement(fieldReference.ref) && isNullOrUndefined(value)
                        ? ''
                        : value;
                if (isMultipleSelect(fieldReference.ref)) {
                    [...fieldReference.ref.options].forEach((selectRef) => (selectRef.selected = fieldValue.includes(selectRef.value)));
                }
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) {
                        fieldReference.refs.length > 1
                            ? fieldReference.refs.forEach((checkboxRef) => (checkboxRef.checked = Array.isArray(fieldValue)
                                ? !!fieldValue.find((data) => data === checkboxRef.value)
                                : fieldValue === checkboxRef.value))
                            : fieldReference.refs[0] &&
                                (fieldReference.refs[0].checked = !!fieldValue);
                    }
                    else {
                        fieldReference.refs.forEach((radioRef) => (radioRef.checked = radioRef.value === fieldValue));
                    }
                }
                else if (isFileInput(fieldReference.ref)) {
                    fieldReference.ref.value = '';
                }
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) {
                        _subjects.watch.next({
                            name,
                        });
                    }
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) &&
            updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value, options) => {
        for (const fieldKey in value) {
            const fieldValue = value[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = get(_fields, fieldName);
            (_names.array.has(name) ||
                !isPrimitive(fieldValue) ||
                (field && !field._f)) &&
                !isDateObject(fieldValue)
                ? setValues(fieldName, fieldValue, options)
                : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: _formValues,
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) &&
                options.shouldDirty) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
                _subjects.state.next({
                    name,
                    dirtyFields: _formState.dirtyFields,
                    isDirty: _getDirty(name, cloneValue),
                });
            }
        }
        else {
            field && !field._f && !isNullOrUndefined(cloneValue)
                ? setValues(name, cloneValue, options)
                : setFieldValue(name, cloneValue, options);
        }
        isWatched(name, _names) && _subjects.state.next({});
        _subjects.watch.next({
            name,
        });
    };
    const onChange = async (event) => {
        const target = event.target;
        let name = target.name;
        const field = get(_fields, name);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type
                ? getFieldValue(field._f)
                : getEventValue(event);
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = (!hasValidation(field._f) &&
                !_options.resolver &&
                !get(_formState.errors, name) &&
                !field._f.deps) ||
                skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
            }
            else if (field._f.onChange) {
                field._f.onChange(event);
            }
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent &&
                _subjects.watch.next({
                    name,
                    type: event.type,
                });
            if (shouldSkipValidation) {
                return (shouldRender &&
                    _subjects.state.next(Object.assign({ name }, (watched ? {} : fieldState))));
            }
            !isBlurEvent && watched && _subjects.state.next({});
            validateFields[name] = validateFields[name] ? +1 : 1;
            _subjects.state.next({
                isValidating: true,
            });
            if (_options.resolver) {
                const { errors } = await _executeSchema([name]);
                const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = isEmptyObject(errors);
            }
            else {
                error = (await validateField(field, get(_formValues, name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                isValid = await _updateValid(true);
            }
            field._f.deps &&
                trigger(field._f.deps);
            shouldRenderByError(false, name, isValid, error, fieldState);
        }
    };
    const trigger = async (name, options = {}) => {
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        _subjects.state.next({
            isValidating: true,
        });
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name
                ? !fieldNames.some((name) => get(errors, name))
                : isValid;
        }
        else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
                const field = get(_fields, fieldName);
                return await executeBuildInValidation(field && field._f ? { [fieldName]: field } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        }
        else {
            validationResult = isValid = await executeBuildInValidation(_fields);
        }
        _subjects.state.next(Object.assign(Object.assign(Object.assign({}, (!isString(name) ||
            (_proxyFormState.isValid && isValid !== _formState.isValid)
            ? {}
            : { name })), (_options.resolver ? { isValid } : {})), { errors: _formState.errors, isValidating: false }));
        options.shouldFocus &&
            !validationResult &&
            focusFieldBy(_fields, (key) => get(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames) => {
        const values = Object.assign(Object.assign({}, _defaultValues), (_stateFlags.mount ? _formValues : {}));
        return isUndefined(fieldNames)
            ? values
            : isString(fieldNames)
                ? get(values, fieldNames)
                : fieldNames.map((name) => get(values, name));
    };
    const getFieldState = (name, formState) => ({
        invalid: !!get((formState || _formState).errors, name),
        isDirty: !!get((formState || _formState).dirtyFields, name),
        isTouched: !!get((formState || _formState).touchedFields, name),
        error: get((formState || _formState).errors, name),
    });
    const clearErrors = (name) => {
        name
            ? convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName))
            : (_formState.errors = {});
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const setError = (name, error, options) => {
        const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
        set(_formState.errors, name, Object.assign(Object.assign({}, error), { ref }));
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false,
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue) => isFunction(name)
        ? _subjects.watch.subscribe({
            next: (info) => name(_getWatch(undefined, defaultValue), info),
        })
        : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {}) => {
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (get(_fields, fieldName)) {
                if (!options.keepValue) {
                    unset(_fields, fieldName);
                    unset(_formValues, fieldName);
                }
                !options.keepError && unset(_formState.errors, fieldName);
                !options.keepDirty && unset(_formState.dirtyFields, fieldName);
                !options.keepTouched && unset(_formState.touchedFields, fieldName);
                !_options.shouldUnregister &&
                    !options.keepDefaultValue &&
                    unset(_defaultValues, fieldName);
            }
        }
        _subjects.watch.next({});
        _subjects.state.next(Object.assign(Object.assign({}, _formState), (!options.keepDirty ? {} : { isDirty: _getDirty() })));
        !options.keepIsValid && _updateValid();
    };
    const register = (name, options = {}) => {
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled);
        set(_fields, name, {
            _f: Object.assign(Object.assign(Object.assign({}, (field && field._f ? field._f : { ref: { name } })), { name, mount: true }), options),
        });
        _names.mount.add(name);
        field
            ? disabledIsDefined &&
                set(_formValues, name, options.disabled
                    ? undefined
                    : get(_formValues, name, getFieldValue(field._f)))
            : updateValidAndValue(name, true, options.value);
        return Object.assign(Object.assign(Object.assign({}, (disabledIsDefined ? { disabled: options.disabled } : {})), (_options.shouldUseNativeValidation
            ? {
                required: !!options.required,
                min: getRuleValue(options.min),
                max: getRuleValue(options.max),
                minLength: getRuleValue(options.minLength),
                maxLength: getRuleValue(options.maxLength),
                pattern: getRuleValue(options.pattern),
            }
            : {})), { name,
            onChange, onBlur: onChange, ref: (ref) => {
                if (ref) {
                    register(name, options);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value)
                        ? ref.querySelectorAll
                            ? ref.querySelectorAll('input,select,textarea')[0] || ref
                            : ref
                        : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox
                        ? refs.find((option) => option === fieldRef)
                        : fieldRef === field._f.ref) {
                        return;
                    }
                    set(_fields, name, {
                        _f: Object.assign(Object.assign({}, field._f), (radioOrCheckbox
                            ? {
                                refs: [...refs.filter(live), fieldRef],
                                ref: { type: fieldRef.type, name },
                            }
                            : { ref: fieldRef })),
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                }
                else {
                    field = get(_fields, name, {});
                    if (field._f) {
                        field._f.mount = false;
                    }
                    (_options.shouldUnregister || options.shouldUnregister) &&
                        !(isNameInFieldArray(_names.array, name) && _stateFlags.action) &&
                        _names.unMount.add(name);
                }
            } });
    };
    const handleSubmit = (onValid, onInvalid) => async (e) => {
        if (e) {
            e.preventDefault && e.preventDefault();
            e.persist && e.persist();
        }
        let hasNoPromiseError = true;
        let fieldValues = cloneObject(_formValues);
        _subjects.state.next({
            isSubmitting: true,
        });
        try {
            if (_options.resolver) {
                const { errors, values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            }
            else {
                await executeBuildInValidation(_fields);
            }
            if (isEmptyObject(_formState.errors) &&
                Object.keys(_formState.errors).every((name) => get(fieldValues, name))) {
                _subjects.state.next({
                    errors: {},
                    isSubmitting: true,
                });
                await onValid(fieldValues, e);
            }
            else {
                if (onInvalid) {
                    await onInvalid(Object.assign({}, _formState.errors), e);
                }
                _options.shouldFocusError &&
                    focusFieldBy(_fields, (key) => get(_formState.errors, key), _names.mount);
            }
        }
        catch (err) {
            hasNoPromiseError = false;
            throw err;
        }
        finally {
            _formState.isSubmitted = true;
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: isEmptyObject(_formState.errors) && hasNoPromiseError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors,
            });
        }
    };
    const resetField = (name, options = {}) => {
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) {
                setValue(name, get(_defaultValues, name));
            }
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) {
                unset(_formState.touchedFields, name);
            }
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue
                    ? _getDirty(name, get(_defaultValues, name))
                    : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next(Object.assign({}, _formState));
        }
    };
    const reset = (formValues, keepStateOptions = {}) => {
        const updatedValues = formValues || _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const values = formValues && !isEmptyObject(formValues)
            ? cloneUpdatedValues
            : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) {
            _defaultValues = updatedValues;
        }
        if (!keepStateOptions.keepValues) {
            if (isWeb && isUndefined(formValues)) {
                for (const name of _names.mount) {
                    const field = get(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs)
                            ? field._f.refs[0]
                            : field._f.ref;
                        try {
                            isHTMLElement(fieldReference) &&
                                fieldReference.closest('form').reset();
                            break;
                        }
                        catch (_a) { }
                    }
                }
            }
            _formValues = props.shouldUnregister
                ? keepStateOptions.keepDefaultValues
                    ? cloneObject(_defaultValues)
                    : {}
                : cloneUpdatedValues;
            _fields = {};
            _subjects.array.next({
                values,
            });
            _subjects.watch.next({
                values,
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: '',
        };
        _stateFlags.mount =
            !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _stateFlags.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount
                ? _formState.submitCount
                : 0,
            isDirty: keepStateOptions.keepDirty
                ? _formState.isDirty
                : keepStateOptions.keepDefaultValues
                    ? !deepEqual(formValues, _defaultValues)
                    : false,
            isSubmitted: keepStateOptions.keepIsSubmitted
                ? _formState.isSubmitted
                : false,
            dirtyFields: keepStateOptions.keepDirty
                ? _formState.dirtyFields
                : (keepStateOptions.keepDefaultValues && formValues
                    ? Object.entries(formValues).reduce((previous, [key, value]) => (Object.assign(Object.assign({}, previous), { [key]: value !== get(_defaultValues, key) })), {})
                    : {}),
            touchedFields: keepStateOptions.keepTouched
                ? _formState.touchedFields
                : {},
            errors: keepStateOptions.keepErrors
                ? _formState.errors
                : {},
            isSubmitting: false,
            isSubmitSuccessful: false,
        });
    };
    const setFocus = (name, options = {}) => {
        const field = get(_fields, name)._f;
        const fieldRef = field.refs ? field.refs[0] : field.ref;
        options.shouldSelect ? fieldRef.select() : fieldRef.focus();
    };
    return {
        control: {
            register,
            unregister,
            getFieldState,
            _executeSchema,
            _getWatch,
            _getDirty,
            _updateValid,
            _removeUnmounted,
            _updateFieldArray,
            _getFieldArray,
            _subjects,
            _proxyFormState,
            get _fields() {
                return _fields;
            },
            get _formValues() {
                return _formValues;
            },
            get _stateFlags() {
                return _stateFlags;
            },
            set _stateFlags(value) {
                _stateFlags = value;
            },
            get _defaultValues() {
                return _defaultValues;
            },
            get _names() {
                return _names;
            },
            set _names(value) {
                _names = value;
            },
            get _formState() {
                return _formState;
            },
            set _formState(value) {
                _formState = value;
            },
            get _options() {
                return _options;
            },
            set _options(value) {
                _options = Object.assign(Object.assign({}, _options), value);
            },
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState,
    };
}

/**
 * Custom hook to mange the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useForm(props = {}) {
    const _formControl = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {},
    });
    if (_formControl.current) {
        _formControl.current.control._options = props;
    }
    else {
        _formControl.current = Object.assign(Object.assign({}, createFormControl(props)), { formState });
    }
    const control = _formControl.current.control;
    const callback = react__WEBPACK_IMPORTED_MODULE_0__.useCallback((value) => {
        if (shouldRenderFormState(value, control._proxyFormState, true)) {
            control._formState = Object.assign(Object.assign({}, control._formState), value);
            updateFormState(Object.assign({}, control._formState));
        }
    }, [control]);
    useSubscribe({
        subject: control._subjects.state,
        callback,
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (!control._stateFlags.mount) {
            control._proxyFormState.isValid && control._updateValid();
            control._stateFlags.mount = true;
        }
        if (control._stateFlags.watch) {
            control._stateFlags.watch = false;
            control._subjects.state.next({});
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = getProxyFormState(formState, control._proxyFormState);
    return _formControl.current;
}


//# sourceMappingURL=index.esm.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ /* webpack/runtime/startup prefetch */
/******/ !function() {
/******/ 	__webpack_require__.O(0, [888], function() {
/******/ 		__webpack_require__.E(463);
/******/ 		__webpack_require__.E(479);
/******/ 	}, 5);
/******/ }();
/******/ 
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(58121), __webpack_exec__(8925), __webpack_exec__(71958), __webpack_exec__(29463); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);